import * as jt from "react";
import Ye, { useRef as gr, useState as Ht, useEffect as l0, useMemo as qi, useCallback as Hn, forwardRef as J9, useContext as fp, useLayoutEffect as Q9, createContext as W3, Component as _F, Fragment as Bv, useDeferredValue as AF, useImperativeHandle as EF } from "react";
import { ErrorBoundary as uo, getFileExtention as SF, getFileSizeDisplay as CF, displayAllowedFileType as kF, getTextRequiredFieldIndicator as e_, fileTypeValidation as TF, validateMultipleFileType as FF, validateMultipleFileSize as DF, memoWithGenerics as dp } from "@reapitform/utils";
import { elFlexAlignSelfCenter as OF, elMy6 as Lv, FlexContainer as Lt, elPy6 as t_, Text2XS as x5, elMy3 as r_, useMediaQuery as hp, TextBase as ts, Modal as RF, TextL as PF, Button as ea, Icon as il, Text2XL as IF, elMb5 as n_, ButtonGroup as pp, elWFull as Ja, elHFull as v1, elPb6 as BF, elPy0 as LF, elPt0 as NF, elFlex1 as bh, elHAuto as MF, PageContainer as UF, elHScreen as zF, elFlexAlignSelfStart as Nv, BodyText as H3, elMt5 as q3, InputWrap as $F, elRowGap3 as VF, elRowGap8 as jF, elRowGap6 as WF, TextSM as jr, elPx6 as HF, TextXL as qF, TextXS as Y3, elColGap3 as YF, Tile as GF, Loader as i_, elFlexShrink0 as ZF, InputGroup as a_, Label as o_, InputError as Pd, elFlexGrow as XF, elMt2 as KF, elMt3 as y5, elRowGap2 as JF, elMt6 as QF, FormSectionDivider as eD, elPy2 as tD, elMt7 as rD, Select as nD, elColGap8 as iD, elColGap2 as s_, TableHeader as Mv, TableHeadersRow as aD, TableCell as G3, TableRowContainer as oD, TableRow as sD, elPy3 as lD, TableCellSplit as uD, Table as cD, PersistantNotification as fD, Pagination as dD, elP8 as hD, elBorderRadius as pD, Drawer as mD, PersistentNotification as gD, Badge as vD } from "@reapit/elements";
import { useNavigate as l_, useParams as mp } from "react-router";
import { usePlatformUpdate as Z3, getUrl as bD, useDebounce as xD, useAttachment as yD, useDragAndDrop as wD, usePlatformGet as _D } from "@reapitform/hooks";
import { createPortal as AD } from "react-dom";
import { useSearchParams as ED, Link as SD } from "react-router-dom";
function CD(t, e) {
  for (var r = 0; r < e.length; r++) {
    const n = e[r];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const i in n)
        if (i !== "default" && !(i in t)) {
          const a = Object.getOwnPropertyDescriptor(n, i);
          a && Object.defineProperty(t, i, a.get ? a : {
            enumerable: !0,
            get: () => n[i]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }));
}
var Wt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function On(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function kD(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), r;
}
var u_ = { exports: {} }, gp = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var TD = Ye, FD = Symbol.for("react.element"), DD = Symbol.for("react.fragment"), OD = Object.prototype.hasOwnProperty, RD = TD.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, PD = { key: !0, ref: !0, __self: !0, __source: !0 };
function c_(t, e, r) {
  var n, i = {}, a = null, o = null;
  r !== void 0 && (a = "" + r), e.key !== void 0 && (a = "" + e.key), e.ref !== void 0 && (o = e.ref);
  for (n in e) OD.call(e, n) && !PD.hasOwnProperty(n) && (i[n] = e[n]);
  if (t && t.defaultProps) for (n in e = t.defaultProps, e) i[n] === void 0 && (i[n] = e[n]);
  return { $$typeof: FD, type: t, key: a, ref: o, props: i, _owner: RD.current };
}
gp.Fragment = DD;
gp.jsx = c_;
gp.jsxs = c_;
u_.exports = gp;
var X = u_.exports, ID = function() {
  const e = Array.prototype.slice.call(arguments).filter(Boolean), r = {}, n = [];
  e.forEach((a) => {
    (a ? a.split(" ") : []).forEach((s) => {
      if (s.startsWith("atm_")) {
        const [, l] = s.split("_");
        r[l] = s;
      } else
        n.push(s);
    });
  });
  const i = [];
  for (const a in r)
    Object.prototype.hasOwnProperty.call(r, a) && i.push(r[a]);
  return i.push(...n), i.join(" ");
}, st = ID;
const Hne = ({
  src: t,
  srcSet: e,
  className: r,
  ...n
}) => /* @__PURE__ */ X.jsx(uo, {
  children: /* @__PURE__ */ X.jsx("img", {
    ...n,
    className: st(r, OF, Lv, "c1n16whr"),
    src: t,
    srcSet: e
  })
}), BD = ({
  src: t
}) => /* @__PURE__ */ X.jsx(uo, {
  children: /* @__PURE__ */ X.jsxs(Lt, {
    className: t_,
    isFlexColumn: !0,
    isFlexJustifyCenter: !0,
    isFlexAlignCenter: !0,
    children: [/* @__PURE__ */ X.jsx("img", {
      className: st(r_, "c1f5pbu0"),
      src: t || "/assets/reapit-copy-right.png",
      alt: "reapit mark copyright"
    }), /* @__PURE__ */ X.jsx(x5, {
      intent: "default",
      children: "© Reapit. All rights reserved."
    })]
  })
}), LD = "ez7mhdr", ND = "e8xzqa9", MD = "e1988jq8", qne = "e1fne3kq", UD = "e1rue5y3", Yne = "eek5nfc", zD = "ery5b1i", Uv = "eelr47z", Gne = "e1x6ql5v", $D = "e7nnrc7", zv = "e1js7psk", VD = "e1yxk2zh", ic = "e8cvq5i", f_ = "eq6op9c", Zne = "ehj0fi9", jD = "elo5z3c", Xne = "enmtyfk", Kne = "e9kvf4c", WD = "ecasyoh", Jne = "e1uflo5q", Qne = "e1o0r473", eie = "eyrvftq", tie = "e1ti7f2i", rie = "e9gkaod";
function HD(t, e, r, n) {
  const i = r / t, a = r, o = e * i, s = n / e, l = n, u = t * s;
  return o <= n ? { scaledWidth: a, scaledHeight: o } : { scaledWidth: u, scaledHeight: l };
}
const d_ = ({
  className: t,
  initialSignature: e,
  disabled: r,
  ...n
}) => {
  const i = gr(null), { isMobile: a } = hp(), [o, s] = Ht(!!e), [l, u] = Ht(null), [d, h] = Ht(!1), [v, b] = Ht(0), [x, A] = Ht(0), T = gr(!1);
  l0(() => (C(), () => {
    u(null), h(!1);
  }), []), l0(() => {
    e && (k(), E(e));
  }, [e]);
  const k = () => {
    if (!i.current) return;
    i.current.getContext("2d")?.clearRect(0, 0, i.current.width, i.current.height);
  }, E = (q) => {
    if (!i.current) return;
    const { naturalWidth: Y, naturalHeight: Z } = q, { width: Q, height: J } = i.current.getBoundingClientRect(), { scaledWidth: se, scaledHeight: ae } = HD(Y, Z, Q, J), te = i.current.getContext("2d"), ne = Q / 2 - se / 2, ce = J / 2 - ae / 2;
    te?.drawImage(q, ne, ce, se, ae);
  }, C = () => {
    if (i.current) {
      const q = i.current.getContext("2d"), { width: Y, height: Z } = i.current.getBoundingClientRect();
      i.current.width = Y, i.current.height = Z, q && (q.strokeStyle = "#000", q.lineJoin = "round", q.lineCap = "round", q.lineWidth = 3, u(q));
    }
  }, D = (q) => {
    if (!i.current) return { offsetX: 0, offsetY: 0 };
    const Y = i.current.getBoundingClientRect(), Z = i.current.width / Y.width, Q = i.current.height / Y.height, J = (q.clientX - Y.left) * Z, se = (q.clientY - Y.top) * Q;
    return { offsetX: J, offsetY: se };
  }, _ = (q, Y) => {
    d && (l && (l.beginPath(), l.moveTo(v, x), l.lineTo(q, Y), l.stroke()), T.current = !0, b(q), A(Y));
  }, I = (q, Y) => {
    d || h(!0), b(q), A(Y);
  }, R = (q) => {
    if (r) return;
    const { offsetX: Y, offsetY: Z } = D(q);
    I(Y, Z);
  }, U = (q) => {
    if (r) return;
    const { offsetX: Y, offsetY: Z } = D(q);
    _(Y, Z);
  }, V = (q) => {
    if (r) return;
    const { offsetX: Y, offsetY: Z } = D(q.touches[0]);
    I(Y, Z);
  }, z = (q) => {
    if (r) return;
    const { offsetX: Y, offsetY: Z } = D(q.touches[0]);
    _(Y, Z);
  }, j = () => {
    r || (h(!1), T.current && s(!0), T.current = !1);
  }, S = () => {
    l && i.current && (l.clearRect(0, 0, i.current.width, i.current.height), u(l), s(!1), n.onChange?.(""));
  }, B = () => {
    if (!(r || !T.current)) {
      if (i.current) {
        const q = i.current.toDataURL?.("image/png");
        n.onChange && n.onChange(q);
      }
      j();
    }
  };
  return /* @__PURE__ */ X.jsx(uo, { children: /* @__PURE__ */ X.jsxs(Lt, { isFlexColumn: !0, isFlexAlignEnd: !0, className: st(t), children: [
    /* @__PURE__ */ X.jsx(
      "canvas",
      {
        role: "img",
        ref: i,
        className: st(LD, a && ND),
        onMouseMove: U,
        onMouseDown: R,
        onTouchMove: z,
        onTouchStart: V,
        onTouchEnd: j,
        onMouseUp: B,
        onTouchEndCapture: B
      }
    ),
    !r && /* @__PURE__ */ X.jsx(
      ts,
      {
        intent: o ? "primary" : "default",
        className: st(MD, zD),
        onClick: S,
        children: "Clear"
      }
    )
  ] }) });
}, qD = "e3mb09g", YD = "e3kz4ix", GD = "e1hc6tw7", ZD = "e1it6ud0", XD = "e1iozjhy", a6 = "e14pkelk", KD = "e1d7xlxw", JD = "e1ssq5o8", vp = ({
  footer: t,
  hasCloseButton: e,
  children: r,
  className: n,
  handlerModalClose: i,
  isModalOpen: a,
  hasFullScreen: o,
  title: s
}) => {
  const { isMobile: l } = hp(), u = o && l ? st(n, qD, Ja, v1) : st(YD, n), d = !l && s ? s : void 0;
  return /* @__PURE__ */ X.jsx(uo, { children: /* @__PURE__ */ X.jsxs(RF, { isOpen: a, className: st(u, JD), onModalClose: i, children: [
    /* @__PURE__ */ X.jsxs(Lt, { isFlexJustifyBetween: !0, isFlexAlignCenter: !0, className: st(GD, BF, a6), children: [
      /* @__PURE__ */ X.jsx(PF, { hasBoldText: !0, children: d }),
      l && e && /* @__PURE__ */ X.jsx(ea, { role: "button", className: st(KD, XD), onClick: i, children: /* @__PURE__ */ X.jsx(il, { icon: "close" }) })
    ] }),
    e && l && /* @__PURE__ */ X.jsx(Lt, { className: st(LF), children: /* @__PURE__ */ X.jsx(IF, { className: n_, children: s }) }),
    /* @__PURE__ */ X.jsx(Lt, { className: st(NF, bh), children: r }),
    t && /* @__PURE__ */ X.jsxs(Lt, { isFlexJustifyEnd: !0, className: st(ZD, a6), children: [
      !l && /* @__PURE__ */ X.jsx(pp, { alignment: "right", children: t }),
      l && t
    ] })
  ] }) });
}, nie = ({
  children: t,
  hasFullPage: e,
  hasGreyBackground: r
}) => {
  const n = e ? st(v1) : MF;
  return /* @__PURE__ */ X.jsx(uo, {
    children: /* @__PURE__ */ X.jsx(UF, {
      hasGreyBackground: r,
      className: st(zF, "c1rw9kmn"),
      children: /* @__PURE__ */ X.jsxs(Lt, {
        isFlexAlignCenter: !0,
        isFlexColumn: !0,
        className: st(n, Ja),
        children: [/* @__PURE__ */ X.jsx(Lt, {
          className: st(n, "chu52ol"),
          children: t
        }), /* @__PURE__ */ X.jsx(BD, {})]
      })
    })
  });
}, QD = ({
  variant: t = "rectangle",
  width: e = "100%",
  height: r = "1rem",
  className: n
}) => /* @__PURE__ */ X.jsx("div", {
  className: st("sbi06ha", t, n),
  style: {
    width: e,
    height: r
  }
});
function h_(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return e[r] === void 0 && (e[r] = t(r)), e[r];
  };
}
var eO = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, ig = /* @__PURE__ */ h_(
  function(t) {
    return eO.test(t) || t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && t.charCodeAt(2) < 91;
  }
  /* Z+1 */
), tO = (t) => t.toUpperCase() === t, rO = (t) => (e) => t.indexOf(e) === -1, p_ = (t, e) => {
  const r = {};
  return Object.keys(t).filter(rO(e)).forEach((n) => {
    r[n] = t[n];
  }), r;
};
function nO(t, e, r) {
  const n = p_(e, r);
  if (!t) {
    const i = typeof ig == "function" ? { default: ig } : ig;
    Object.keys(n).forEach((a) => {
      i.default(a) || delete n[a];
    });
  }
  return n;
}
var iO = (t, e) => {
};
function aO(t) {
  let e = "";
  return (r) => {
    const n = (a, o) => {
      const { as: s = t, class: l = e } = a, u = r.propsAsIs === void 0 ? !(typeof s == "string" && s.indexOf("-") === -1 && !tO(s[0])) : r.propsAsIs, d = nO(u, a, [
        "as",
        "class"
      ]);
      d.ref = o, d.className = r.atomic ? st(r.class, d.className || l) : st(d.className || l, r.class);
      const { vars: h } = r;
      if (h) {
        const v = {};
        for (const A in h) {
          const T = h[A], k = T[0], E = T[1] || "", C = typeof k == "function" ? k(a) : k;
          iO(C, r.name), v[`--${A}`] = `${C}${E}`;
        }
        const b = d.style || {}, x = Object.keys(b);
        x.length > 0 && x.forEach((A) => {
          v[A] = b[A];
        }), d.style = v;
      }
      return t.__wyw_meta && t !== s ? (d.as = s, Ye.createElement(t, d)) : Ye.createElement(s, d);
    }, i = Ye.forwardRef ? Ye.forwardRef(n) : (
      // React.forwardRef won't available on older React versions and in Preact
      // Fallback to a innerRef prop in that case
      (a) => {
        const o = p_(a, ["innerRef"]);
        return n(o, a.innerRef);
      }
    );
    return i.displayName = r.name, i.__wyw_meta = {
      className: r.class || e,
      extends: t
    }, i;
  };
}
var Rn = aO;
const oO = ({
  data: t
}) => /* @__PURE__ */ X.jsx("a", {
  className: "c1itkqo2",
  href: t,
  target: t ? "_blank" : void 0,
  rel: t ? "noreferrer" : void 0,
  children: /* @__PURE__ */ X.jsx(ts, {
    hasMediumText: !0,
    intent: "primary",
    children: "View in maps"
  })
}), sO = (t) => {
  const e = t.phoneNumbers?.map((r) => `TEL;TYPE=${r.type},VOICE:${r.phoneNumber}`).join(`
`);
  return `BEGIN:VCARD
VERSION:3.0
${t.contactName ? `FN:${t.contactName}
` : ""}${t.organisationName ? `ORG:${t.organisationName}
` : ""}${e || ""}`;
}, lO = ({
  data: t
}) => {
  if (!t) return null;
  const e = qi(() => "s1j8gkk0", []), r = qi(() => {
    const i = [];
    return t.workMobile && i.push({
      phoneNumber: t.workMobile,
      type: "CELL"
    }), t.workPhone && i.push({
      phoneNumber: t.workPhone,
      type: "WORK"
    }), i;
  }, [t.workMobile, t.workPhone]), n = (i) => {
    i.preventDefault();
    const a = sO({
      contactName: t.fullName,
      organisationName: t.companyName,
      phoneNumbers: r
    }), o = new Blob([a], {
      type: "text/vcard"
    }), s = URL.createObjectURL(o), l = document.createElement("a");
    l.download = `${t.fullName}.vcf`, l.textContent = t.fullName, l.href = s, l.click();
  };
  return /* @__PURE__ */ X.jsx("a", {
    href: "#",
    role: "button",
    className: st(Nv, $D),
    onClick: n,
    children: /* @__PURE__ */ X.jsx(ts, {
      className: e,
      intent: "default",
      children: "Save to Contacts"
    })
  });
}, uO = () => {
  const t = l_(), { recipientId: e = "mok-id-forms" } = mp(), [r, n] = Z3({
    path: `/api/recipient/${e}/Exit`,
    method: "PATCH",
    headers: {},
    isProtectedRoute: !1
  });
  return {
    isSubmitLoading: n,
    handleSubmitExit: () => async () => {
      await r({}) && t(`/${e}/broken-link`);
    }
  };
}, iie = ({ className: t, handlerModalClose: e, isModalOpen: r }) => {
  const { handleSubmitExit: n, isSubmitLoading: i } = uO();
  return /* @__PURE__ */ X.jsx(uo, { children: /* @__PURE__ */ X.jsx(vp, { className: t, handlerModalClose: e, isModalOpen: r, title: "Exit Agreement", children: /* @__PURE__ */ X.jsxs(Lt, { isFlexColumn: !0, className: st(v1, bh), children: [
    /* @__PURE__ */ X.jsx(H3, { children: "Exiting this Agreement will temporarily disable the link and the Agent will be notified. A new link will be issued shortly." }),
    /* @__PURE__ */ X.jsxs(pp, { alignment: "right", className: st(q3), children: [
      /* @__PURE__ */ X.jsx(ea, { intent: "default", disabled: i, onClick: e, children: "Cancel" }),
      /* @__PURE__ */ X.jsx(ea, { loading: i, disabled: i, intent: "primary", onClick: n(), children: "Exit Agreement" })
    ] })
  ] }) }) });
};
var xh = (t) => t.type === "checkbox", zu = (t) => t instanceof Date, ii = (t) => t == null;
const m_ = (t) => typeof t == "object";
var Ir = (t) => !ii(t) && !Array.isArray(t) && m_(t) && !zu(t), cO = (t) => Ir(t) && t.target ? xh(t.target) ? t.target.checked : t.target.value : t, fO = (t) => t.substring(0, t.search(/\.\d+(\.|$)/)) || t, dO = (t, e) => t.has(fO(e)), hO = (t) => {
  const e = t.constructor && t.constructor.prototype;
  return Ir(e) && e.hasOwnProperty("isPrototypeOf");
}, X3 = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function An(t) {
  let e;
  const r = Array.isArray(t);
  if (t instanceof Date)
    e = new Date(t);
  else if (t instanceof Set)
    e = new Set(t);
  else if (!(X3 && (t instanceof Blob || t instanceof FileList)) && (r || Ir(t)))
    if (e = r ? [] : {}, !r && !hO(t))
      e = t;
    else
      for (const n in t)
        t.hasOwnProperty(n) && (e[n] = An(t[n]));
  else
    return t;
  return e;
}
var yh = (t) => Array.isArray(t) ? t.filter(Boolean) : [], rr = (t) => t === void 0, ut = (t, e, r) => {
  if (!e || !Ir(t))
    return r;
  const n = yh(e.split(/[,[\].]+?/)).reduce((i, a) => ii(i) ? i : i[a], t);
  return rr(n) || n === t ? rr(t[e]) ? r : t[e] : n;
}, Lo = (t) => typeof t == "boolean", K3 = (t) => /^\w*$/.test(t), g_ = (t) => yh(t.replace(/["|']|\]/g, "").split(/\.|\[/)), V0 = (t, e, r) => {
  let n = -1;
  const i = K3(e) ? [e] : g_(e), a = i.length, o = a - 1;
  for (; ++n < a; ) {
    const s = i[n];
    let l = r;
    if (n !== o) {
      const u = t[s];
      l = Ir(u) || Array.isArray(u) ? u : isNaN(+i[n + 1]) ? {} : [];
    }
    if (s === "__proto__")
      return;
    t[s] = l, t = t[s];
  }
  return t;
};
const o6 = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, wa = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, $s = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, pO = Ye.createContext(null), mO = () => Ye.useContext(pO);
var gO = (t, e, r, n = !0) => {
  const i = {
    defaultValues: e._defaultValues
  };
  for (const a in t)
    Object.defineProperty(i, a, {
      get: () => {
        const o = a;
        return e._proxyFormState[o] !== wa.all && (e._proxyFormState[o] = !n || wa.all), t[o];
      }
    });
  return i;
}, ni = (t) => Ir(t) && !Object.keys(t).length, vO = (t, e, r, n) => {
  r(t);
  const { name: i, ...a } = t;
  return ni(a) || Object.keys(a).length >= Object.keys(e).length || Object.keys(a).find((o) => e[o] === wa.all);
}, Yi = (t) => Array.isArray(t) ? t : [t];
function v_(t) {
  const e = Ye.useRef(t);
  e.current = t, Ye.useEffect(() => {
    const r = !t.disabled && e.current.subject && e.current.subject.subscribe({
      next: e.current.next
    });
    return () => {
      r && r.unsubscribe();
    };
  }, [t.disabled]);
}
var Ko = (t) => typeof t == "string", bO = (t, e, r, n, i) => Ko(t) ? (n && e.watch.add(t), ut(r, t, i)) : Array.isArray(t) ? t.map((a) => (n && e.watch.add(a), ut(r, a))) : (n && (e.watchAll = !0), r), b_ = (t, e, r, n, i) => e ? {
  ...r[t],
  types: {
    ...r[t] && r[t].types ? r[t].types : {},
    [n]: i || !0
  }
} : {}, Sl = () => {
  const t = typeof performance > "u" ? Date.now() : performance.now() * 1e3;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (e) => {
    const r = (Math.random() * 16 + t) % 16 | 0;
    return (e == "x" ? r : r & 3 | 8).toString(16);
  });
}, ag = (t, e, r = {}) => r.shouldFocus || rr(r.shouldFocus) ? r.focusName || `${t}.${rr(r.focusIndex) ? e : r.focusIndex}.` : "", Id = (t) => ({
  isOnSubmit: !t || t === wa.onSubmit,
  isOnBlur: t === wa.onBlur,
  isOnChange: t === wa.onChange,
  isOnAll: t === wa.all,
  isOnTouch: t === wa.onTouched
}), $v = (t, e, r) => !r && (e.watchAll || e.watch.has(t) || [...e.watch].some((n) => t.startsWith(n) && /^\.\w+/.test(t.slice(n.length))));
const qf = (t, e, r, n) => {
  for (const i of r || Object.keys(t)) {
    const a = ut(t, i);
    if (a) {
      const { _f: o, ...s } = a;
      if (o) {
        if (o.refs && o.refs[0] && e(o.refs[0], i) && !n)
          return !0;
        if (o.ref && e(o.ref, o.name) && !n)
          return !0;
        if (qf(s, e))
          break;
      } else if (Ir(s) && qf(s, e))
        break;
    }
  }
};
var x_ = (t, e, r) => {
  const n = Yi(ut(t, r));
  return V0(n, "root", e[r]), V0(t, r, n), t;
}, J3 = (t) => t.type === "file", Ks = (t) => typeof t == "function", w5 = (t) => {
  if (!X3)
    return !1;
  const e = t ? t.ownerDocument : 0;
  return t instanceof (e && e.defaultView ? e.defaultView.HTMLElement : HTMLElement);
}, Y2 = (t) => Ko(t), Q3 = (t) => t.type === "radio", _5 = (t) => t instanceof RegExp;
const s6 = {
  value: !1,
  isValid: !1
}, l6 = { value: !0, isValid: !0 };
var y_ = (t) => {
  if (Array.isArray(t)) {
    if (t.length > 1) {
      const e = t.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: e, isValid: !!e.length };
    }
    return t[0].checked && !t[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      t[0].attributes && !rr(t[0].attributes.value) ? rr(t[0].value) || t[0].value === "" ? l6 : { value: t[0].value, isValid: !0 } : l6
    ) : s6;
  }
  return s6;
};
const u6 = {
  isValid: !1,
  value: null
};
var w_ = (t) => Array.isArray(t) ? t.reduce((e, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : e, u6) : u6;
function c6(t, e, r = "validate") {
  if (Y2(t) || Array.isArray(t) && t.every(Y2) || Lo(t) && !t)
    return {
      type: r,
      message: Y2(t) ? t : "",
      ref: e
    };
}
var _f = (t) => Ir(t) && !_5(t) ? t : {
  value: t,
  message: ""
}, Vv = async (t, e, r, n, i) => {
  const { ref: a, refs: o, required: s, maxLength: l, minLength: u, min: d, max: h, pattern: v, validate: b, name: x, valueAsNumber: A, mount: T, disabled: k } = t._f, E = ut(e, x);
  if (!T || k)
    return {};
  const C = o ? o[0] : a, D = (S) => {
    n && C.reportValidity && (C.setCustomValidity(Lo(S) ? "" : S || ""), C.reportValidity());
  }, _ = {}, I = Q3(a), R = xh(a), U = I || R, V = (A || J3(a)) && rr(a.value) && rr(E) || w5(a) && a.value === "" || E === "" || Array.isArray(E) && !E.length, z = b_.bind(null, x, r, _), j = (S, B, q, Y = $s.maxLength, Z = $s.minLength) => {
    const Q = S ? B : q;
    _[x] = {
      type: S ? Y : Z,
      message: Q,
      ref: a,
      ...z(S ? Y : Z, Q)
    };
  };
  if (i ? !Array.isArray(E) || !E.length : s && (!U && (V || ii(E)) || Lo(E) && !E || R && !y_(o).isValid || I && !w_(o).isValid)) {
    const { value: S, message: B } = Y2(s) ? { value: !!s, message: s } : _f(s);
    if (S && (_[x] = {
      type: $s.required,
      message: B,
      ref: C,
      ...z($s.required, B)
    }, !r))
      return D(B), _;
  }
  if (!V && (!ii(d) || !ii(h))) {
    let S, B;
    const q = _f(h), Y = _f(d);
    if (!ii(E) && !isNaN(E)) {
      const Z = a.valueAsNumber || E && +E;
      ii(q.value) || (S = Z > q.value), ii(Y.value) || (B = Z < Y.value);
    } else {
      const Z = a.valueAsDate || new Date(E), Q = (ae) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + ae), J = a.type == "time", se = a.type == "week";
      Ko(q.value) && E && (S = J ? Q(E) > Q(q.value) : se ? E > q.value : Z > new Date(q.value)), Ko(Y.value) && E && (B = J ? Q(E) < Q(Y.value) : se ? E < Y.value : Z < new Date(Y.value));
    }
    if ((S || B) && (j(!!S, q.message, Y.message, $s.max, $s.min), !r))
      return D(_[x].message), _;
  }
  if ((l || u) && !V && (Ko(E) || i && Array.isArray(E))) {
    const S = _f(l), B = _f(u), q = !ii(S.value) && E.length > +S.value, Y = !ii(B.value) && E.length < +B.value;
    if ((q || Y) && (j(q, S.message, B.message), !r))
      return D(_[x].message), _;
  }
  if (v && !V && Ko(E)) {
    const { value: S, message: B } = _f(v);
    if (_5(S) && !E.match(S) && (_[x] = {
      type: $s.pattern,
      message: B,
      ref: a,
      ...z($s.pattern, B)
    }, !r))
      return D(B), _;
  }
  if (b) {
    if (Ks(b)) {
      const S = await b(E, e), B = c6(S, C);
      if (B && (_[x] = {
        ...B,
        ...z($s.validate, B.message)
      }, !r))
        return D(B.message), _;
    } else if (Ir(b)) {
      let S = {};
      for (const B in b) {
        if (!ni(S) && !r)
          break;
        const q = c6(await b[B](E, e), C, B);
        q && (S = {
          ...q,
          ...z(B, q.message)
        }, D(q.message), r && (_[x] = S));
      }
      if (!ni(S) && (_[x] = {
        ref: C,
        ...S
      }, !r))
        return _;
    }
  }
  return D(!0), _;
}, og = (t, e) => [
  ...t,
  ...Yi(e)
], sg = (t) => Array.isArray(t) ? t.map(() => {
}) : void 0;
function lg(t, e, r) {
  return [
    ...t.slice(0, e),
    ...Yi(r),
    ...t.slice(e)
  ];
}
var ug = (t, e, r) => Array.isArray(t) ? (rr(t[r]) && (t[r] = void 0), t.splice(r, 0, t.splice(e, 1)[0]), t) : [], cg = (t, e) => [
  ...Yi(e),
  ...Yi(t)
];
function xO(t, e) {
  let r = 0;
  const n = [...t];
  for (const i of e)
    n.splice(i - r, 1), r++;
  return yh(n).length ? n : [];
}
var fg = (t, e) => rr(e) ? [] : xO(t, Yi(e).sort((r, n) => r - n)), dg = (t, e, r) => {
  [t[e], t[r]] = [t[r], t[e]];
};
function yO(t, e) {
  const r = e.slice(0, -1).length;
  let n = 0;
  for (; n < r; )
    t = rr(t) ? n++ : t[e[n++]];
  return t;
}
function wO(t) {
  for (const e in t)
    if (t.hasOwnProperty(e) && !rr(t[e]))
      return !1;
  return !0;
}
function $r(t, e) {
  const r = Array.isArray(e) ? e : K3(e) ? [e] : g_(e), n = r.length === 1 ? t : yO(t, r), i = r.length - 1, a = r[i];
  return n && delete n[a], i !== 0 && (Ir(n) && ni(n) || Array.isArray(n) && wO(n)) && $r(t, r.slice(0, -1)), t;
}
var f6 = (t, e, r) => (t[e] = r, t);
function _O(t) {
  const e = mO(), { control: r = e.control, name: n, keyName: i = "id", shouldUnregister: a } = t, [o, s] = Ye.useState(r._getFieldArray(n)), l = Ye.useRef(r._getFieldArray(n).map(Sl)), u = Ye.useRef(o), d = Ye.useRef(n), h = Ye.useRef(!1);
  d.current = n, u.current = o, r._names.array.add(n), t.rules && r.register(n, t.rules), v_({
    next: ({ values: _, name: I }) => {
      if (I === d.current || !I) {
        const R = ut(_, d.current);
        Array.isArray(R) && (s(R), l.current = R.map(Sl));
      }
    },
    subject: r._subjects.array
  });
  const v = Ye.useCallback((_) => {
    h.current = !0, r._updateFieldArray(n, _);
  }, [r, n]), b = (_, I) => {
    const R = Yi(An(_)), U = og(r._getFieldArray(n), R);
    r._names.focus = ag(n, U.length - 1, I), l.current = og(l.current, R.map(Sl)), v(U), s(U), r._updateFieldArray(n, U, og, {
      argA: sg(_)
    });
  }, x = (_, I) => {
    const R = Yi(An(_)), U = cg(r._getFieldArray(n), R);
    r._names.focus = ag(n, 0, I), l.current = cg(l.current, R.map(Sl)), v(U), s(U), r._updateFieldArray(n, U, cg, {
      argA: sg(_)
    });
  }, A = (_) => {
    const I = fg(r._getFieldArray(n), _);
    l.current = fg(l.current, _), v(I), s(I), r._updateFieldArray(n, I, fg, {
      argA: _
    });
  }, T = (_, I, R) => {
    const U = Yi(An(I)), V = lg(r._getFieldArray(n), _, U);
    r._names.focus = ag(n, _, R), l.current = lg(l.current, _, U.map(Sl)), v(V), s(V), r._updateFieldArray(n, V, lg, {
      argA: _,
      argB: sg(I)
    });
  }, k = (_, I) => {
    const R = r._getFieldArray(n);
    dg(R, _, I), dg(l.current, _, I), v(R), s(R), r._updateFieldArray(n, R, dg, {
      argA: _,
      argB: I
    }, !1);
  }, E = (_, I) => {
    const R = r._getFieldArray(n);
    ug(R, _, I), ug(l.current, _, I), v(R), s(R), r._updateFieldArray(n, R, ug, {
      argA: _,
      argB: I
    }, !1);
  }, C = (_, I) => {
    const R = An(I), U = f6(r._getFieldArray(n), _, R);
    l.current = [...U].map((V, z) => !V || z === _ ? Sl() : l.current[z]), v(U), s([...U]), r._updateFieldArray(n, U, f6, {
      argA: _,
      argB: R
    }, !0, !1);
  }, D = (_) => {
    const I = Yi(An(_));
    l.current = I.map(Sl), v([...I]), s([...I]), r._updateFieldArray(n, [...I], (R) => R, {}, !0, !1);
  };
  return Ye.useEffect(() => {
    if (r._state.action = !1, $v(n, r._names) && r._subjects.state.next({
      ...r._formState
    }), h.current && (!Id(r._options.mode).isOnSubmit || r._formState.isSubmitted))
      if (r._options.resolver)
        r._executeSchema([n]).then((_) => {
          const I = ut(_.errors, n), R = ut(r._formState.errors, n);
          (R ? !I && R.type || I && (R.type !== I.type || R.message !== I.message) : I && I.type) && (I ? V0(r._formState.errors, n, I) : $r(r._formState.errors, n), r._subjects.state.next({
            errors: r._formState.errors
          }));
        });
      else {
        const _ = ut(r._fields, n);
        _ && _._f && !(Id(r._options.reValidateMode).isOnSubmit && Id(r._options.mode).isOnSubmit) && Vv(_, r._formValues, r._options.criteriaMode === wa.all, r._options.shouldUseNativeValidation, !0).then((I) => !ni(I) && r._subjects.state.next({
          errors: x_(r._formState.errors, I, n)
        }));
      }
    r._subjects.values.next({
      name: n,
      values: { ...r._formValues }
    }), r._names.focus && qf(r._fields, (_, I) => {
      if (r._names.focus && I.startsWith(r._names.focus) && _.focus)
        return _.focus(), 1;
    }), r._names.focus = "", r._updateValid(), h.current = !1;
  }, [o, n, r]), Ye.useEffect(() => (!ut(r._formValues, n) && r._updateFieldArray(n), () => {
    (r._options.shouldUnregister || a) && r.unregister(n);
  }), [n, r, i, a]), {
    swap: Ye.useCallback(k, [v, n, r]),
    move: Ye.useCallback(E, [v, n, r]),
    prepend: Ye.useCallback(x, [v, n, r]),
    append: Ye.useCallback(b, [v, n, r]),
    remove: Ye.useCallback(A, [v, n, r]),
    insert: Ye.useCallback(T, [v, n, r]),
    update: Ye.useCallback(C, [v, n, r]),
    replace: Ye.useCallback(D, [v, n, r]),
    fields: Ye.useMemo(() => o.map((_, I) => ({
      ..._,
      [i]: l.current[I] || Sl()
    })), [o, i])
  };
}
var hg = () => {
  let t = [];
  return {
    get observers() {
      return t;
    },
    next: (i) => {
      for (const a of t)
        a.next && a.next(i);
    },
    subscribe: (i) => (t.push(i), {
      unsubscribe: () => {
        t = t.filter((a) => a !== i);
      }
    }),
    unsubscribe: () => {
      t = [];
    }
  };
}, jv = (t) => ii(t) || !m_(t);
function Vl(t, e) {
  if (jv(t) || jv(e))
    return t === e;
  if (zu(t) && zu(e))
    return t.getTime() === e.getTime();
  const r = Object.keys(t), n = Object.keys(e);
  if (r.length !== n.length)
    return !1;
  for (const i of r) {
    const a = t[i];
    if (!n.includes(i))
      return !1;
    if (i !== "ref") {
      const o = e[i];
      if (zu(a) && zu(o) || Ir(a) && Ir(o) || Array.isArray(a) && Array.isArray(o) ? !Vl(a, o) : a !== o)
        return !1;
    }
  }
  return !0;
}
var __ = (t) => t.type === "select-multiple", AO = (t) => Q3(t) || xh(t), pg = (t) => w5(t) && t.isConnected, A_ = (t) => {
  for (const e in t)
    if (Ks(t[e]))
      return !0;
  return !1;
};
function A5(t, e = {}) {
  const r = Array.isArray(t);
  if (Ir(t) || r)
    for (const n in t)
      Array.isArray(t[n]) || Ir(t[n]) && !A_(t[n]) ? (e[n] = Array.isArray(t[n]) ? [] : {}, A5(t[n], e[n])) : ii(t[n]) || (e[n] = !0);
  return e;
}
function E_(t, e, r) {
  const n = Array.isArray(t);
  if (Ir(t) || n)
    for (const i in t)
      Array.isArray(t[i]) || Ir(t[i]) && !A_(t[i]) ? rr(e) || jv(r[i]) ? r[i] = Array.isArray(t[i]) ? A5(t[i], []) : { ...A5(t[i]) } : E_(t[i], ii(e) ? {} : e[i], r[i]) : r[i] = !Vl(t[i], e[i]);
  return r;
}
var vd = (t, e) => E_(t, e, A5(e)), S_ = (t, { valueAsNumber: e, valueAsDate: r, setValueAs: n }) => rr(t) ? t : e ? t === "" ? NaN : t && +t : r && Ko(t) ? new Date(t) : n ? n(t) : t;
function mg(t) {
  const e = t.ref;
  if (!(t.refs ? t.refs.every((r) => r.disabled) : e.disabled))
    return J3(e) ? e.files : Q3(e) ? w_(t.refs).value : __(e) ? [...e.selectedOptions].map(({ value: r }) => r) : xh(e) ? y_(t.refs).value : S_(rr(e.value) ? t.ref.value : e.value, t);
}
var EO = (t, e, r, n) => {
  const i = {};
  for (const a of t) {
    const o = ut(e, a);
    o && V0(i, a, o._f);
  }
  return {
    criteriaMode: r,
    names: [...t],
    fields: i,
    shouldUseNativeValidation: n
  };
}, bd = (t) => rr(t) ? t : _5(t) ? t.source : Ir(t) ? _5(t.value) ? t.value.source : t.value : t;
const d6 = "AsyncFunction";
var SO = (t) => (!t || !t.validate) && !!(Ks(t.validate) && t.validate.constructor.name === d6 || Ir(t.validate) && Object.values(t.validate).find((e) => e.constructor.name === d6)), CO = (t) => t.mount && (t.required || t.min || t.max || t.maxLength || t.minLength || t.pattern || t.validate);
function h6(t, e, r) {
  const n = ut(t, r);
  if (n || K3(r))
    return {
      error: n,
      name: r
    };
  const i = r.split(".");
  for (; i.length; ) {
    const a = i.join("."), o = ut(e, a), s = ut(t, a);
    if (o && !Array.isArray(o) && r !== a)
      return { name: r };
    if (s && s.type)
      return {
        name: a,
        error: s
      };
    i.pop();
  }
  return {
    name: r
  };
}
var kO = (t, e, r, n, i) => i.isOnAll ? !1 : !r && i.isOnTouch ? !(e || t) : (r ? n.isOnBlur : i.isOnBlur) ? !t : (r ? n.isOnChange : i.isOnChange) ? t : !0, TO = (t, e) => !yh(ut(t, e)).length && $r(t, e);
const FO = {
  mode: wa.onSubmit,
  reValidateMode: wa.onChange,
  shouldFocusError: !0
};
function DO(t = {}) {
  let e = {
    ...FO,
    ...t
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Ks(e.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1
  }, n = {}, i = Ir(e.defaultValues) || Ir(e.values) ? An(e.defaultValues || e.values) || {} : {}, a = e.shouldUnregister ? {} : An(i), o = {
    action: !1,
    mount: !1,
    watch: !1
  }, s = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, l, u = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, h = {
    values: hg(),
    array: hg(),
    state: hg()
  }, v = Id(e.mode), b = Id(e.reValidateMode), x = e.criteriaMode === wa.all, A = (W) => (ee) => {
    clearTimeout(u), u = setTimeout(W, ee);
  }, T = async (W) => {
    if (!t.disabled && (d.isValid || W)) {
      const ee = e.resolver ? ni((await U()).errors) : await z(n, !0);
      ee !== r.isValid && h.state.next({
        isValid: ee
      });
    }
  }, k = (W, ee) => {
    !t.disabled && (d.isValidating || d.validatingFields) && ((W || Array.from(s.mount)).forEach((le) => {
      le && (ee ? V0(r.validatingFields, le, ee) : $r(r.validatingFields, le));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !ni(r.validatingFields)
    }));
  }, E = (W, ee = [], le, me, Ee = !0, ve = !0) => {
    if (me && le && !t.disabled) {
      if (o.action = !0, ve && Array.isArray(ut(n, W))) {
        const Te = le(ut(n, W), me.argA, me.argB);
        Ee && V0(n, W, Te);
      }
      if (ve && Array.isArray(ut(r.errors, W))) {
        const Te = le(ut(r.errors, W), me.argA, me.argB);
        Ee && V0(r.errors, W, Te), TO(r.errors, W);
      }
      if (d.touchedFields && ve && Array.isArray(ut(r.touchedFields, W))) {
        const Te = le(ut(r.touchedFields, W), me.argA, me.argB);
        Ee && V0(r.touchedFields, W, Te);
      }
      d.dirtyFields && (r.dirtyFields = vd(i, a)), h.state.next({
        name: W,
        isDirty: S(W, ee),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      V0(a, W, ee);
  }, C = (W, ee) => {
    V0(r.errors, W, ee), h.state.next({
      errors: r.errors
    });
  }, D = (W) => {
    r.errors = W, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, _ = (W, ee, le, me) => {
    const Ee = ut(n, W);
    if (Ee) {
      const ve = ut(a, W, rr(le) ? ut(i, W) : le);
      rr(ve) || me && me.defaultChecked || ee ? V0(a, W, ee ? ve : mg(Ee._f)) : Y(W, ve), o.mount && T();
    }
  }, I = (W, ee, le, me, Ee) => {
    let ve = !1, Te = !1;
    const Pe = {
      name: W
    };
    if (!t.disabled) {
      const at = !!(ut(n, W) && ut(n, W)._f && ut(n, W)._f.disabled);
      if (!le || me) {
        d.isDirty && (Te = r.isDirty, r.isDirty = Pe.isDirty = S(), ve = Te !== Pe.isDirty);
        const Ue = at || Vl(ut(i, W), ee);
        Te = !!(!at && ut(r.dirtyFields, W)), Ue || at ? $r(r.dirtyFields, W) : V0(r.dirtyFields, W, !0), Pe.dirtyFields = r.dirtyFields, ve = ve || d.dirtyFields && Te !== !Ue;
      }
      if (le) {
        const Ue = ut(r.touchedFields, W);
        Ue || (V0(r.touchedFields, W, le), Pe.touchedFields = r.touchedFields, ve = ve || d.touchedFields && Ue !== le);
      }
      ve && Ee && h.state.next(Pe);
    }
    return ve ? Pe : {};
  }, R = (W, ee, le, me) => {
    const Ee = ut(r.errors, W), ve = d.isValid && Lo(ee) && r.isValid !== ee;
    if (t.delayError && le ? (l = A(() => C(W, le)), l(t.delayError)) : (clearTimeout(u), l = null, le ? V0(r.errors, W, le) : $r(r.errors, W)), (le ? !Vl(Ee, le) : Ee) || !ni(me) || ve) {
      const Te = {
        ...me,
        ...ve && Lo(ee) ? { isValid: ee } : {},
        errors: r.errors,
        name: W
      };
      r = {
        ...r,
        ...Te
      }, h.state.next(Te);
    }
  }, U = async (W) => {
    k(W, !0);
    const ee = await e.resolver(a, e.context, EO(W || s.mount, n, e.criteriaMode, e.shouldUseNativeValidation));
    return k(W), ee;
  }, V = async (W) => {
    const { errors: ee } = await U(W);
    if (W)
      for (const le of W) {
        const me = ut(ee, le);
        me ? V0(r.errors, le, me) : $r(r.errors, le);
      }
    else
      r.errors = ee;
    return ee;
  }, z = async (W, ee, le = {
    valid: !0
  }) => {
    for (const me in W) {
      const Ee = W[me];
      if (Ee) {
        const { _f: ve, ...Te } = Ee;
        if (ve) {
          const Pe = s.array.has(ve.name), at = Ee._f && SO(Ee._f);
          at && d.validatingFields && k([me], !0);
          const Ue = await Vv(Ee, a, x, e.shouldUseNativeValidation && !ee, Pe);
          if (at && d.validatingFields && k([me]), Ue[ve.name] && (le.valid = !1, ee))
            break;
          !ee && (ut(Ue, ve.name) ? Pe ? x_(r.errors, Ue, ve.name) : V0(r.errors, ve.name, Ue[ve.name]) : $r(r.errors, ve.name));
        }
        !ni(Te) && await z(Te, ee, le);
      }
    }
    return le.valid;
  }, j = () => {
    for (const W of s.unMount) {
      const ee = ut(n, W);
      ee && (ee._f.refs ? ee._f.refs.every((le) => !pg(le)) : !pg(ee._f.ref)) && Ne(W);
    }
    s.unMount = /* @__PURE__ */ new Set();
  }, S = (W, ee) => !t.disabled && (W && ee && V0(a, W, ee), !Vl(te(), i)), B = (W, ee, le) => bO(W, s, {
    ...o.mount ? a : rr(ee) ? i : Ko(W) ? { [W]: ee } : ee
  }, le, ee), q = (W) => yh(ut(o.mount ? a : i, W, t.shouldUnregister ? ut(i, W, []) : [])), Y = (W, ee, le = {}) => {
    const me = ut(n, W);
    let Ee = ee;
    if (me) {
      const ve = me._f;
      ve && (!ve.disabled && V0(a, W, S_(ee, ve)), Ee = w5(ve.ref) && ii(ee) ? "" : ee, __(ve.ref) ? [...ve.ref.options].forEach((Te) => Te.selected = Ee.includes(Te.value)) : ve.refs ? xh(ve.ref) ? ve.refs.length > 1 ? ve.refs.forEach((Te) => (!Te.defaultChecked || !Te.disabled) && (Te.checked = Array.isArray(Ee) ? !!Ee.find((Pe) => Pe === Te.value) : Ee === Te.value)) : ve.refs[0] && (ve.refs[0].checked = !!Ee) : ve.refs.forEach((Te) => Te.checked = Te.value === Ee) : J3(ve.ref) ? ve.ref.value = "" : (ve.ref.value = Ee, ve.ref.type || h.values.next({
        name: W,
        values: { ...a }
      })));
    }
    (le.shouldDirty || le.shouldTouch) && I(W, Ee, le.shouldTouch, le.shouldDirty, !0), le.shouldValidate && ae(W);
  }, Z = (W, ee, le) => {
    for (const me in ee) {
      const Ee = ee[me], ve = `${W}.${me}`, Te = ut(n, ve);
      (s.array.has(W) || Ir(Ee) || Te && !Te._f) && !zu(Ee) ? Z(ve, Ee, le) : Y(ve, Ee, le);
    }
  }, Q = (W, ee, le = {}) => {
    const me = ut(n, W), Ee = s.array.has(W), ve = An(ee);
    V0(a, W, ve), Ee ? (h.array.next({
      name: W,
      values: { ...a }
    }), (d.isDirty || d.dirtyFields) && le.shouldDirty && h.state.next({
      name: W,
      dirtyFields: vd(i, a),
      isDirty: S(W, ve)
    })) : me && !me._f && !ii(ve) ? Z(W, ve, le) : Y(W, ve, le), $v(W, s) && h.state.next({ ...r }), h.values.next({
      name: o.mount ? W : void 0,
      values: { ...a }
    });
  }, J = async (W) => {
    o.mount = !0;
    const ee = W.target;
    let le = ee.name, me = !0;
    const Ee = ut(n, le), ve = () => ee.type ? mg(Ee._f) : cO(W), Te = (Pe) => {
      me = Number.isNaN(Pe) || zu(Pe) && isNaN(Pe.getTime()) || Vl(Pe, ut(a, le, Pe));
    };
    if (Ee) {
      let Pe, at;
      const Ue = ve(), rt = W.type === o6.BLUR || W.type === o6.FOCUS_OUT, gt = !CO(Ee._f) && !e.resolver && !ut(r.errors, le) && !Ee._f.deps || kO(rt, ut(r.touchedFields, le), r.isSubmitted, b, v), _t = $v(le, s, rt);
      V0(a, le, Ue), rt ? (Ee._f.onBlur && Ee._f.onBlur(W), l && l(0)) : Ee._f.onChange && Ee._f.onChange(W);
      const Bt = I(le, Ue, rt, !1), At = !ni(Bt) || _t;
      if (!rt && h.values.next({
        name: le,
        type: W.type,
        values: { ...a }
      }), gt)
        return d.isValid && (t.mode === "onBlur" ? rt && T() : T()), At && h.state.next({ name: le, ..._t ? {} : Bt });
      if (!rt && _t && h.state.next({ ...r }), e.resolver) {
        const { errors: Tt } = await U([le]);
        if (Te(Ue), me) {
          const Je = h6(r.errors, n, le), ot = h6(Tt, n, Je.name || le);
          Pe = ot.error, le = ot.name, at = ni(Tt);
        }
      } else
        k([le], !0), Pe = (await Vv(Ee, a, x, e.shouldUseNativeValidation))[le], k([le]), Te(Ue), me && (Pe ? at = !1 : d.isValid && (at = await z(n, !0)));
      me && (Ee._f.deps && ae(Ee._f.deps), R(le, at, Pe, Bt));
    }
  }, se = (W, ee) => {
    if (ut(r.errors, ee) && W.focus)
      return W.focus(), 1;
  }, ae = async (W, ee = {}) => {
    let le, me;
    const Ee = Yi(W);
    if (e.resolver) {
      const ve = await V(rr(W) ? W : Ee);
      le = ni(ve), me = W ? !Ee.some((Te) => ut(ve, Te)) : le;
    } else W ? (me = (await Promise.all(Ee.map(async (ve) => {
      const Te = ut(n, ve);
      return await z(Te && Te._f ? { [ve]: Te } : Te);
    }))).every(Boolean), !(!me && !r.isValid) && T()) : me = le = await z(n);
    return h.state.next({
      ...!Ko(W) || d.isValid && le !== r.isValid ? {} : { name: W },
      ...e.resolver || !W ? { isValid: le } : {},
      errors: r.errors
    }), ee.shouldFocus && !me && qf(n, se, W ? Ee : s.mount), me;
  }, te = (W) => {
    const ee = {
      ...o.mount ? a : i
    };
    return rr(W) ? ee : Ko(W) ? ut(ee, W) : W.map((le) => ut(ee, le));
  }, ne = (W, ee) => ({
    invalid: !!ut((ee || r).errors, W),
    isDirty: !!ut((ee || r).dirtyFields, W),
    error: ut((ee || r).errors, W),
    isValidating: !!ut(r.validatingFields, W),
    isTouched: !!ut((ee || r).touchedFields, W)
  }), ce = (W) => {
    W && Yi(W).forEach((ee) => $r(r.errors, ee)), h.state.next({
      errors: W ? r.errors : {}
    });
  }, pe = (W, ee, le) => {
    const me = (ut(n, W, { _f: {} })._f || {}).ref, Ee = ut(r.errors, W) || {}, { ref: ve, message: Te, type: Pe, ...at } = Ee;
    V0(r.errors, W, {
      ...at,
      ...ee,
      ref: me
    }), h.state.next({
      name: W,
      errors: r.errors,
      isValid: !1
    }), le && le.shouldFocus && me && me.focus && me.focus();
  }, Me = (W, ee) => Ks(W) ? h.values.subscribe({
    next: (le) => W(B(void 0, ee), le)
  }) : B(W, ee, !0), Ne = (W, ee = {}) => {
    for (const le of W ? Yi(W) : s.mount)
      s.mount.delete(le), s.array.delete(le), ee.keepValue || ($r(n, le), $r(a, le)), !ee.keepError && $r(r.errors, le), !ee.keepDirty && $r(r.dirtyFields, le), !ee.keepTouched && $r(r.touchedFields, le), !ee.keepIsValidating && $r(r.validatingFields, le), !e.shouldUnregister && !ee.keepDefaultValue && $r(i, le);
    h.values.next({
      values: { ...a }
    }), h.state.next({
      ...r,
      ...ee.keepDirty ? { isDirty: S() } : {}
    }), !ee.keepIsValid && T();
  }, it = ({ disabled: W, name: ee, field: le, fields: me, value: Ee }) => {
    if (Lo(W) && o.mount || W) {
      const ve = W ? void 0 : rr(Ee) ? mg(le ? le._f : ut(me, ee)._f) : Ee;
      V0(a, ee, ve), I(ee, ve, !1, !1, !0);
    }
  }, fe = (W, ee = {}) => {
    let le = ut(n, W);
    const me = Lo(ee.disabled) || Lo(t.disabled);
    return V0(n, W, {
      ...le || {},
      _f: {
        ...le && le._f ? le._f : { ref: { name: W } },
        name: W,
        mount: !0,
        ...ee
      }
    }), s.mount.add(W), le ? it({
      field: le,
      disabled: Lo(ee.disabled) ? ee.disabled : t.disabled,
      name: W,
      value: ee.value
    }) : _(W, !0, ee.value), {
      ...me ? { disabled: ee.disabled || t.disabled } : {},
      ...e.progressive ? {
        required: !!ee.required,
        min: bd(ee.min),
        max: bd(ee.max),
        minLength: bd(ee.minLength),
        maxLength: bd(ee.maxLength),
        pattern: bd(ee.pattern)
      } : {},
      name: W,
      onChange: J,
      onBlur: J,
      ref: (Ee) => {
        if (Ee) {
          fe(W, ee), le = ut(n, W);
          const ve = rr(Ee.value) && Ee.querySelectorAll && Ee.querySelectorAll("input,select,textarea")[0] || Ee, Te = AO(ve), Pe = le._f.refs || [];
          if (Te ? Pe.find((at) => at === ve) : ve === le._f.ref)
            return;
          V0(n, W, {
            _f: {
              ...le._f,
              ...Te ? {
                refs: [
                  ...Pe.filter(pg),
                  ve,
                  ...Array.isArray(ut(i, W)) ? [{}] : []
                ],
                ref: { type: ve.type, name: W }
              } : { ref: ve }
            }
          }), _(W, !1, void 0, ve);
        } else
          le = ut(n, W, {}), le._f && (le._f.mount = !1), (e.shouldUnregister || ee.shouldUnregister) && !(dO(s.array, W) && o.action) && s.unMount.add(W);
      }
    };
  }, ye = () => e.shouldFocusError && qf(n, se, s.mount), be = (W) => {
    Lo(W) && (h.state.next({ disabled: W }), qf(n, (ee, le) => {
      const me = ut(n, le);
      me && (ee.disabled = me._f.disabled || W, Array.isArray(me._f.refs) && me._f.refs.forEach((Ee) => {
        Ee.disabled = me._f.disabled || W;
      }));
    }, 0, !1));
  }, he = (W, ee) => async (le) => {
    let me;
    le && (le.preventDefault && le.preventDefault(), le.persist && le.persist());
    let Ee = An(a);
    if (h.state.next({
      isSubmitting: !0
    }), e.resolver) {
      const { errors: ve, values: Te } = await U();
      r.errors = ve, Ee = Te;
    } else
      await z(n);
    if ($r(r.errors, "root"), ni(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await W(Ee, le);
      } catch (ve) {
        me = ve;
      }
    } else
      ee && await ee({ ...r.errors }, le), ye(), setTimeout(ye);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: ni(r.errors) && !me,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), me)
      throw me;
  }, Ge = (W, ee = {}) => {
    ut(n, W) && (rr(ee.defaultValue) ? Q(W, An(ut(i, W))) : (Q(W, ee.defaultValue), V0(i, W, An(ee.defaultValue))), ee.keepTouched || $r(r.touchedFields, W), ee.keepDirty || ($r(r.dirtyFields, W), r.isDirty = ee.defaultValue ? S(W, An(ut(i, W))) : S()), ee.keepError || ($r(r.errors, W), d.isValid && T()), h.state.next({ ...r }));
  }, $e = (W, ee = {}) => {
    const le = W ? An(W) : i, me = An(le), Ee = ni(W), ve = Ee ? i : me;
    if (ee.keepDefaultValues || (i = le), !ee.keepValues) {
      if (ee.keepDirtyValues) {
        const Te = /* @__PURE__ */ new Set([
          ...s.mount,
          ...Object.keys(vd(i, a))
        ]);
        for (const Pe of Array.from(Te))
          ut(r.dirtyFields, Pe) ? V0(ve, Pe, ut(a, Pe)) : Q(Pe, ut(ve, Pe));
      } else {
        if (X3 && rr(W))
          for (const Te of s.mount) {
            const Pe = ut(n, Te);
            if (Pe && Pe._f) {
              const at = Array.isArray(Pe._f.refs) ? Pe._f.refs[0] : Pe._f.ref;
              if (w5(at)) {
                const Ue = at.closest("form");
                if (Ue) {
                  Ue.reset();
                  break;
                }
              }
            }
          }
        n = {};
      }
      a = t.shouldUnregister ? ee.keepDefaultValues ? An(i) : {} : An(ve), h.array.next({
        values: { ...ve }
      }), h.values.next({
        values: { ...ve }
      });
    }
    s = {
      mount: ee.keepDirtyValues ? s.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, o.mount = !d.isValid || !!ee.keepIsValid || !!ee.keepDirtyValues, o.watch = !!t.shouldUnregister, h.state.next({
      submitCount: ee.keepSubmitCount ? r.submitCount : 0,
      isDirty: Ee ? !1 : ee.keepDirty ? r.isDirty : !!(ee.keepDefaultValues && !Vl(W, i)),
      isSubmitted: ee.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: Ee ? {} : ee.keepDirtyValues ? ee.keepDefaultValues && a ? vd(i, a) : r.dirtyFields : ee.keepDefaultValues && W ? vd(i, W) : ee.keepDirty ? r.dirtyFields : {},
      touchedFields: ee.keepTouched ? r.touchedFields : {},
      errors: ee.keepErrors ? r.errors : {},
      isSubmitSuccessful: ee.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ve = (W, ee) => $e(Ks(W) ? W(a) : W, ee);
  return {
    control: {
      register: fe,
      unregister: Ne,
      getFieldState: ne,
      handleSubmit: he,
      setError: pe,
      _executeSchema: U,
      _getWatch: B,
      _getDirty: S,
      _updateValid: T,
      _removeUnmounted: j,
      _updateFieldArray: E,
      _updateDisabledField: it,
      _getFieldArray: q,
      _reset: $e,
      _resetDefaultValues: () => Ks(e.defaultValues) && e.defaultValues().then((W) => {
        Ve(W, e.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (W) => {
        r = {
          ...r,
          ...W
        };
      },
      _disableForm: be,
      _subjects: h,
      _proxyFormState: d,
      _setErrors: D,
      get _fields() {
        return n;
      },
      get _formValues() {
        return a;
      },
      get _state() {
        return o;
      },
      set _state(W) {
        o = W;
      },
      get _defaultValues() {
        return i;
      },
      get _names() {
        return s;
      },
      set _names(W) {
        s = W;
      },
      get _formState() {
        return r;
      },
      set _formState(W) {
        r = W;
      },
      get _options() {
        return e;
      },
      set _options(W) {
        e = {
          ...e,
          ...W
        };
      }
    },
    trigger: ae,
    register: fe,
    handleSubmit: he,
    watch: Me,
    setValue: Q,
    getValues: te,
    reset: Ve,
    resetField: Ge,
    clearErrors: ce,
    unregister: Ne,
    setError: pe,
    setFocus: (W, ee = {}) => {
      const le = ut(n, W), me = le && le._f;
      if (me) {
        const Ee = me.refs ? me.refs[0] : me.ref;
        Ee.focus && (Ee.focus(), ee.shouldSelect && Ee.select());
      }
    },
    getFieldState: ne
  };
}
function OO(t = {}) {
  const e = Ye.useRef(), r = Ye.useRef(), [n, i] = Ye.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Ks(t.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1,
    defaultValues: Ks(t.defaultValues) ? void 0 : t.defaultValues
  });
  e.current || (e.current = {
    ...DO(t),
    formState: n
  });
  const a = e.current.control;
  return a._options = t, v_({
    subject: a._subjects.state,
    next: (o) => {
      vO(o, a._proxyFormState, a._updateFormState) && i({ ...a._formState });
    }
  }), Ye.useEffect(() => a._disableForm(t.disabled), [a, t.disabled]), Ye.useEffect(() => {
    if (a._proxyFormState.isDirty) {
      const o = a._getDirty();
      o !== n.isDirty && a._subjects.state.next({
        isDirty: o
      });
    }
  }, [a, n.isDirty]), Ye.useEffect(() => {
    t.values && !Vl(t.values, r.current) ? (a._reset(t.values, a._options.resetOptions), r.current = t.values, i((o) => ({ ...o }))) : a._resetDefaultValues();
  }, [t.values, a]), Ye.useEffect(() => {
    t.errors && a._setErrors(t.errors);
  }, [t.errors, a]), Ye.useEffect(() => {
    a._state.mount || (a._updateValid(), a._state.mount = !0), a._state.watch && (a._state.watch = !1, a._subjects.state.next({ ...a._formState })), a._removeUnmounted();
  }), Ye.useEffect(() => {
    t.shouldUnregister && a._subjects.values.next({
      values: a._getWatch()
    });
  }, [t.shouldUnregister, a]), Ye.useEffect(() => {
    e.current && (e.current.watch = e.current.watch.bind({}));
  }, [n]), e.current.formState = gO(n, a), e.current;
}
const p6 = (t, e, r) => {
  if (t && "reportValidity" in t) {
    const n = ut(r, e);
    t.setCustomValidity(n && n.message || ""), t.reportValidity();
  }
}, C_ = (t, e) => {
  for (const r in e.fields) {
    const n = e.fields[r];
    n && n.ref && "reportValidity" in n.ref ? p6(n.ref, r, t) : n.refs && n.refs.forEach((i) => p6(i, r, t));
  }
}, RO = (t, e) => {
  e.shouldUseNativeValidation && C_(t, e);
  const r = {};
  for (const n in t) {
    const i = ut(e.fields, n), a = Object.assign(t[n] || {}, { ref: i && i.ref });
    if (PO(e.names || Object.keys(t), n)) {
      const o = Object.assign({}, ut(r, n));
      V0(o, "root", a), V0(r, n, o);
    } else V0(r, n, a);
  }
  return r;
}, PO = (t, e) => t.some((r) => r.startsWith(e + "."));
function IO(t, e, r) {
  return e === void 0 && (e = {}), r === void 0 && (r = {}), function(n, i, a) {
    try {
      return Promise.resolve(function(o, s) {
        try {
          var l = (e.context, Promise.resolve(t[r.mode === "sync" ? "validateSync" : "validate"](n, Object.assign({ abortEarly: !1 }, e, { context: i }))).then(function(u) {
            return a.shouldUseNativeValidation && C_({}, a), { values: r.raw ? n : u, errors: {} };
          }));
        } catch (u) {
          return s(u);
        }
        return l && l.then ? l.then(void 0, s) : l;
      }(0, function(o) {
        if (!o.inner) throw o;
        return { values: {}, errors: RO((s = o, l = !a.shouldUseNativeValidation && a.criteriaMode === "all", (s.inner || []).reduce(function(u, d) {
          if (u[d.path] || (u[d.path] = { message: d.message, type: d.type }), l) {
            var h = u[d.path].types, v = h && h[d.type];
            u[d.path] = b_(d.path, l, u, d.type, v ? [].concat(v, d.message) : d.message);
          }
          return u;
        }, {})), a) };
        var s, l;
      }));
    } catch (o) {
      return Promise.reject(o);
    }
  };
}
function Sc(t) {
  this._maxSize = t, this.clear();
}
Sc.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
Sc.prototype.get = function(t) {
  return this._values[t];
};
Sc.prototype.set = function(t, e) {
  return this._size >= this._maxSize && this.clear(), t in this._values || this._size++, this._values[t] = e;
};
var BO = /[^.^\]^[]+|(?=\[\]|\.\.)/g, k_ = /^\d+$/, LO = /^\d/, NO = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, MO = /^\s*(['"]?)(.*?)(\1)\s*$/, eb = 512, m6 = new Sc(eb), g6 = new Sc(eb), v6 = new Sc(eb), ac = {
  Cache: Sc,
  split: Wv,
  normalizePath: gg,
  setter: function(t) {
    var e = gg(t);
    return g6.get(t) || g6.set(t, function(n, i) {
      for (var a = 0, o = e.length, s = n; a < o - 1; ) {
        var l = e[a];
        if (l === "__proto__" || l === "constructor" || l === "prototype")
          return n;
        s = s[e[a++]];
      }
      s[e[a]] = i;
    });
  },
  getter: function(t, e) {
    var r = gg(t);
    return v6.get(t) || v6.set(t, function(i) {
      for (var a = 0, o = r.length; a < o; )
        if (i != null || !e) i = i[r[a++]];
        else return;
      return i;
    });
  },
  join: function(t) {
    return t.reduce(function(e, r) {
      return e + (tb(r) || k_.test(r) ? "[" + r + "]" : (e ? "." : "") + r);
    }, "");
  },
  forEach: function(t, e, r) {
    UO(Array.isArray(t) ? t : Wv(t), e, r);
  }
};
function gg(t) {
  return m6.get(t) || m6.set(
    t,
    Wv(t).map(function(e) {
      return e.replace(MO, "$2");
    })
  );
}
function Wv(t) {
  return t.match(BO) || [""];
}
function UO(t, e, r) {
  var n = t.length, i, a, o, s;
  for (a = 0; a < n; a++)
    i = t[a], i && (VO(i) && (i = '"' + i + '"'), s = tb(i), o = !s && /^\d+$/.test(i), e.call(r, i, s, o, a, t));
}
function tb(t) {
  return typeof t == "string" && t && ["'", '"'].indexOf(t.charAt(0)) !== -1;
}
function zO(t) {
  return t.match(LO) && !t.match(k_);
}
function $O(t) {
  return NO.test(t);
}
function VO(t) {
  return !tb(t) && (zO(t) || $O(t));
}
const jO = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g, bp = (t) => t.match(jO) || [], xp = (t) => t[0].toUpperCase() + t.slice(1), rb = (t, e) => bp(t).join(e).toLowerCase(), T_ = (t) => bp(t).reduce(
  (e, r) => `${e}${e ? r[0].toUpperCase() + r.slice(1).toLowerCase() : r.toLowerCase()}`,
  ""
), WO = (t) => xp(T_(t)), HO = (t) => rb(t, "_"), qO = (t) => rb(t, "-"), YO = (t) => xp(rb(t, " ")), GO = (t) => bp(t).map(xp).join(" ");
var vg = {
  words: bp,
  upperFirst: xp,
  camelCase: T_,
  pascalCase: WO,
  snakeCase: HO,
  kebabCase: qO,
  sentenceCase: YO,
  titleCase: GO
}, nb = { exports: {} };
nb.exports = function(t) {
  return F_(ZO(t), t);
};
nb.exports.array = F_;
function F_(t, e) {
  var r = t.length, n = new Array(r), i = {}, a = r, o = XO(e), s = KO(t);
  for (e.forEach(function(u) {
    if (!s.has(u[0]) || !s.has(u[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); a--; )
    i[a] || l(t[a], a, /* @__PURE__ */ new Set());
  return n;
  function l(u, d, h) {
    if (h.has(u)) {
      var v;
      try {
        v = ", node was:" + JSON.stringify(u);
      } catch {
        v = "";
      }
      throw new Error("Cyclic dependency" + v);
    }
    if (!s.has(u))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(u));
    if (!i[d]) {
      i[d] = !0;
      var b = o.get(u) || /* @__PURE__ */ new Set();
      if (b = Array.from(b), d = b.length) {
        h.add(u);
        do {
          var x = b[--d];
          l(x, s.get(x), h);
        } while (d);
        h.delete(u);
      }
      n[--r] = u;
    }
  }
}
function ZO(t) {
  for (var e = /* @__PURE__ */ new Set(), r = 0, n = t.length; r < n; r++) {
    var i = t[r];
    e.add(i[0]), e.add(i[1]);
  }
  return Array.from(e);
}
function XO(t) {
  for (var e = /* @__PURE__ */ new Map(), r = 0, n = t.length; r < n; r++) {
    var i = t[r];
    e.has(i[0]) || e.set(i[0], /* @__PURE__ */ new Set()), e.has(i[1]) || e.set(i[1], /* @__PURE__ */ new Set()), e.get(i[0]).add(i[1]);
  }
  return e;
}
function KO(t) {
  for (var e = /* @__PURE__ */ new Map(), r = 0, n = t.length; r < n; r++)
    e.set(t[r], r);
  return e;
}
var JO = nb.exports;
const QO = /* @__PURE__ */ On(JO), eR = Object.prototype.toString, tR = Error.prototype.toString, rR = RegExp.prototype.toString, nR = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", iR = /^Symbol\((.*)\)(.*)$/;
function aR(t) {
  return t != +t ? "NaN" : t === 0 && 1 / t < 0 ? "-0" : "" + t;
}
function b6(t, e = !1) {
  if (t == null || t === !0 || t === !1) return "" + t;
  const r = typeof t;
  if (r === "number") return aR(t);
  if (r === "string") return e ? `"${t}"` : t;
  if (r === "function") return "[Function " + (t.name || "anonymous") + "]";
  if (r === "symbol") return nR.call(t).replace(iR, "Symbol($1)");
  const n = eR.call(t).slice(8, -1);
  return n === "Date" ? isNaN(t.getTime()) ? "" + t : t.toISOString(t) : n === "Error" || t instanceof Error ? "[" + tR.call(t) + "]" : n === "RegExp" ? rR.call(t) : null;
}
function Xl(t, e) {
  let r = b6(t, e);
  return r !== null ? r : JSON.stringify(t, function(n, i) {
    let a = b6(this[n], e);
    return a !== null ? a : i;
  }, 2);
}
function D_(t) {
  return t == null ? [] : [].concat(t);
}
let O_, R_, P_, oR = /\$\{\s*(\w+)\s*\}/g;
O_ = Symbol.toStringTag;
class x6 {
  constructor(e, r, n, i) {
    this.name = void 0, this.message = void 0, this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = void 0, this.inner = void 0, this[O_] = "Error", this.name = "ValidationError", this.value = r, this.path = n, this.type = i, this.errors = [], this.inner = [], D_(e).forEach((a) => {
      if (Si.isError(a)) {
        this.errors.push(...a.errors);
        const o = a.inner.length ? a.inner : [a];
        this.inner.push(...o);
      } else
        this.errors.push(a);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
R_ = Symbol.hasInstance;
P_ = Symbol.toStringTag;
class Si extends Error {
  static formatError(e, r) {
    const n = r.label || r.path || "this";
    return n !== r.path && (r = Object.assign({}, r, {
      path: n
    })), typeof e == "string" ? e.replace(oR, (i, a) => Xl(r[a])) : typeof e == "function" ? e(r) : e;
  }
  static isError(e) {
    return e && e.name === "ValidationError";
  }
  constructor(e, r, n, i, a) {
    const o = new x6(e, r, n, i);
    if (a)
      return o;
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = [], this.inner = [], this[P_] = "Error", this.name = o.name, this.message = o.message, this.type = o.type, this.value = o.value, this.path = o.path, this.errors = o.errors, this.inner = o.inner, Error.captureStackTrace && Error.captureStackTrace(this, Si);
  }
  static [R_](e) {
    return x6[Symbol.hasInstance](e) || super[Symbol.hasInstance](e);
  }
}
let No = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: t,
    type: e,
    value: r,
    originalValue: n
  }) => {
    const i = n != null && n !== r ? ` (cast from the value \`${Xl(n, !0)}\`).` : ".";
    return e !== "mixed" ? `${t} must be a \`${e}\` type, but the final value was: \`${Xl(r, !0)}\`` + i : `${t} must match the configured type. The validated value was: \`${Xl(r, !0)}\`` + i;
  }
}, Ei = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  datetime: "${path} must be a valid ISO date-time",
  datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, sR = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, Hv = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, lR = {
  isValue: "${path} field must be ${value}"
}, qv = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, uR = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
}, cR = {
  notType: (t) => {
    const {
      path: e,
      value: r,
      spec: n
    } = t, i = n.types.length;
    if (Array.isArray(r)) {
      if (r.length < i) return `${e} tuple value has too few items, expected a length of ${i} but got ${r.length} for value: \`${Xl(r, !0)}\``;
      if (r.length > i) return `${e} tuple value has too many items, expected a length of ${i} but got ${r.length} for value: \`${Xl(r, !0)}\``;
    }
    return Si.formatError(No.notType, t);
  }
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: No,
  string: Ei,
  number: sR,
  date: Hv,
  object: qv,
  array: uR,
  boolean: lR,
  tuple: cR
});
const ib = (t) => t && t.__isYupSchema__;
class E5 {
  static fromOptions(e, r) {
    if (!r.then && !r.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: n,
      then: i,
      otherwise: a
    } = r, o = typeof n == "function" ? n : (...s) => s.every((l) => l === n);
    return new E5(e, (s, l) => {
      var u;
      let d = o(...s) ? i : a;
      return (u = d?.(l)) != null ? u : l;
    });
  }
  constructor(e, r) {
    this.fn = void 0, this.refs = e, this.refs = e, this.fn = r;
  }
  resolve(e, r) {
    let n = this.refs.map((a) => (
      // TODO: ? operator here?
      a.getValue(r?.value, r?.parent, r?.context)
    )), i = this.fn(n, e, r);
    if (i === void 0 || // @ts-ignore this can be base
    i === e)
      return e;
    if (!ib(i)) throw new TypeError("conditions must return a schema object");
    return i.resolve(r);
  }
}
const v2 = {
  context: "$",
  value: "."
};
class Cc {
  constructor(e, r = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof e != "string") throw new TypeError("ref must be a string, got: " + e);
    if (this.key = e.trim(), e === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === v2.context, this.isValue = this.key[0] === v2.value, this.isSibling = !this.isContext && !this.isValue;
    let n = this.isContext ? v2.context : this.isValue ? v2.value : "";
    this.path = this.key.slice(n.length), this.getter = this.path && ac.getter(this.path, !0), this.map = r.map;
  }
  getValue(e, r, n) {
    let i = this.isContext ? n : this.isValue ? e : r;
    return this.getter && (i = this.getter(i || {})), this.map && (i = this.map(i)), i;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(e, r) {
    return this.getValue(e, r?.parent, r?.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(e) {
    return e && e.__isYupRef;
  }
}
Cc.prototype.__isYupRef = !0;
const $u = (t) => t == null;
function Af(t) {
  function e({
    value: r,
    path: n = "",
    options: i,
    originalValue: a,
    schema: o
  }, s, l) {
    const {
      name: u,
      test: d,
      params: h,
      message: v,
      skipAbsent: b
    } = t;
    let {
      parent: x,
      context: A,
      abortEarly: T = o.spec.abortEarly,
      disableStackTrace: k = o.spec.disableStackTrace
    } = i;
    function E(j) {
      return Cc.isRef(j) ? j.getValue(r, x, A) : j;
    }
    function C(j = {}) {
      const S = Object.assign({
        value: r,
        originalValue: a,
        label: o.spec.label,
        path: j.path || n,
        spec: o.spec,
        disableStackTrace: j.disableStackTrace || k
      }, h, j.params);
      for (const q of Object.keys(S)) S[q] = E(S[q]);
      const B = new Si(Si.formatError(j.message || v, S), r, S.path, j.type || u, S.disableStackTrace);
      return B.params = S, B;
    }
    const D = T ? s : l;
    let _ = {
      path: n,
      parent: x,
      type: u,
      from: i.from,
      createError: C,
      resolve: E,
      options: i,
      originalValue: a,
      schema: o
    };
    const I = (j) => {
      Si.isError(j) ? D(j) : j ? l(null) : D(C());
    }, R = (j) => {
      Si.isError(j) ? D(j) : s(j);
    };
    if (b && $u(r))
      return I(!0);
    let V;
    try {
      var z;
      if (V = d.call(_, r, _), typeof ((z = V) == null ? void 0 : z.then) == "function") {
        if (i.sync)
          throw new Error(`Validation test of type: "${_.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
        return Promise.resolve(V).then(I, R);
      }
    } catch (j) {
      R(j);
      return;
    }
    I(V);
  }
  return e.OPTIONS = t, e;
}
function fR(t, e, r, n = r) {
  let i, a, o;
  return e ? (ac.forEach(e, (s, l, u) => {
    let d = l ? s.slice(1, s.length - 1) : s;
    t = t.resolve({
      context: n,
      parent: i,
      value: r
    });
    let h = t.type === "tuple", v = u ? parseInt(d, 10) : 0;
    if (t.innerType || h) {
      if (h && !u) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${o}" must contain an index to the tuple element, e.g. "${o}[0]"`);
      if (r && v >= r.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${s}, in the path: ${e}. because there is no value at that index. `);
      i = r, r = r && r[v], t = h ? t.spec.types[v] : t.innerType;
    }
    if (!u) {
      if (!t.fields || !t.fields[d]) throw new Error(`The schema does not contain the path: ${e}. (failed at: ${o} which is a type: "${t.type}")`);
      i = r, r = r && r[d], t = t.fields[d];
    }
    a = d, o = l ? "[" + s + "]" : "." + s;
  }), {
    schema: t,
    parent: i,
    parentPath: a
  }) : {
    parent: i,
    parentPath: e,
    schema: t
  };
}
class S5 extends Set {
  describe() {
    const e = [];
    for (const r of this.values())
      e.push(Cc.isRef(r) ? r.describe() : r);
    return e;
  }
  resolveAll(e) {
    let r = [];
    for (const n of this.values())
      r.push(e(n));
    return r;
  }
  clone() {
    return new S5(this.values());
  }
  merge(e, r) {
    const n = this.clone();
    return e.forEach((i) => n.add(i)), r.forEach((i) => n.delete(i)), n;
  }
}
function Uf(t, e = /* @__PURE__ */ new Map()) {
  if (ib(t) || !t || typeof t != "object") return t;
  if (e.has(t)) return e.get(t);
  let r;
  if (t instanceof Date)
    r = new Date(t.getTime()), e.set(t, r);
  else if (t instanceof RegExp)
    r = new RegExp(t), e.set(t, r);
  else if (Array.isArray(t)) {
    r = new Array(t.length), e.set(t, r);
    for (let n = 0; n < t.length; n++) r[n] = Uf(t[n], e);
  } else if (t instanceof Map) {
    r = /* @__PURE__ */ new Map(), e.set(t, r);
    for (const [n, i] of t.entries()) r.set(n, Uf(i, e));
  } else if (t instanceof Set) {
    r = /* @__PURE__ */ new Set(), e.set(t, r);
    for (const n of t) r.add(Uf(n, e));
  } else if (t instanceof Object) {
    r = {}, e.set(t, r);
    for (const [n, i] of Object.entries(t)) r[n] = Uf(i, e);
  } else
    throw Error(`Unable to clone ${t}`);
  return r;
}
class is {
  constructor(e) {
    this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new S5(), this._blacklist = new S5(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(No.notType);
    }), this.type = e.type, this._typeCheck = e.check, this.spec = Object.assign({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      disableStackTrace: !1,
      nullable: !1,
      optional: !0,
      coerce: !0
    }, e?.spec), this.withMutation((r) => {
      r.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(e) {
    if (this._mutate)
      return e && Object.assign(this.spec, e), this;
    const r = Object.create(Object.getPrototypeOf(this));
    return r.type = this.type, r._typeCheck = this._typeCheck, r._whitelist = this._whitelist.clone(), r._blacklist = this._blacklist.clone(), r.internalTests = Object.assign({}, this.internalTests), r.exclusiveTests = Object.assign({}, this.exclusiveTests), r.deps = [...this.deps], r.conditions = [...this.conditions], r.tests = [...this.tests], r.transforms = [...this.transforms], r.spec = Uf(Object.assign({}, this.spec, e)), r;
  }
  label(e) {
    let r = this.clone();
    return r.spec.label = e, r;
  }
  meta(...e) {
    if (e.length === 0) return this.spec.meta;
    let r = this.clone();
    return r.spec.meta = Object.assign(r.spec.meta || {}, e[0]), r;
  }
  withMutation(e) {
    let r = this._mutate;
    this._mutate = !0;
    let n = e(this);
    return this._mutate = r, n;
  }
  concat(e) {
    if (!e || e === this) return this;
    if (e.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${e.type}`);
    let r = this, n = e.clone();
    const i = Object.assign({}, r.spec, n.spec);
    return n.spec = i, n.internalTests = Object.assign({}, r.internalTests, n.internalTests), n._whitelist = r._whitelist.merge(e._whitelist, e._blacklist), n._blacklist = r._blacklist.merge(e._blacklist, e._whitelist), n.tests = r.tests, n.exclusiveTests = r.exclusiveTests, n.withMutation((a) => {
      e.tests.forEach((o) => {
        a.test(o.OPTIONS);
      });
    }), n.transforms = [...r.transforms, ...n.transforms], n;
  }
  isType(e) {
    return e == null ? !!(this.spec.nullable && e === null || this.spec.optional && e === void 0) : this._typeCheck(e);
  }
  resolve(e) {
    let r = this;
    if (r.conditions.length) {
      let n = r.conditions;
      r = r.clone(), r.conditions = [], r = n.reduce((i, a) => a.resolve(i, e), r), r = r.resolve(e);
    }
    return r;
  }
  resolveOptions(e) {
    var r, n, i, a;
    return Object.assign({}, e, {
      from: e.from || [],
      strict: (r = e.strict) != null ? r : this.spec.strict,
      abortEarly: (n = e.abortEarly) != null ? n : this.spec.abortEarly,
      recursive: (i = e.recursive) != null ? i : this.spec.recursive,
      disableStackTrace: (a = e.disableStackTrace) != null ? a : this.spec.disableStackTrace
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(e, r = {}) {
    let n = this.resolve(Object.assign({
      value: e
    }, r)), i = r.assert === "ignore-optionality", a = n._cast(e, r);
    if (r.assert !== !1 && !n.isType(a)) {
      if (i && $u(a))
        return a;
      let o = Xl(e), s = Xl(a);
      throw new TypeError(`The value of ${r.path || "field"} could not be cast to a value that satisfies the schema type: "${n.type}". 

attempted value: ${o} 
` + (s !== o ? `result of cast: ${s}` : ""));
    }
    return a;
  }
  _cast(e, r) {
    let n = e === void 0 ? e : this.transforms.reduce((i, a) => a.call(this, i, e, this), e);
    return n === void 0 && (n = this.getDefault(r)), n;
  }
  _validate(e, r = {}, n, i) {
    let {
      path: a,
      originalValue: o = e,
      strict: s = this.spec.strict
    } = r, l = e;
    s || (l = this._cast(l, Object.assign({
      assert: !1
    }, r)));
    let u = [];
    for (let d of Object.values(this.internalTests))
      d && u.push(d);
    this.runTests({
      path: a,
      value: l,
      originalValue: o,
      options: r,
      tests: u
    }, n, (d) => {
      if (d.length)
        return i(d, l);
      this.runTests({
        path: a,
        value: l,
        originalValue: o,
        options: r,
        tests: this.tests
      }, n, i);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(e, r, n) {
    let i = !1, {
      tests: a,
      value: o,
      originalValue: s,
      path: l,
      options: u
    } = e, d = (A) => {
      i || (i = !0, r(A, o));
    }, h = (A) => {
      i || (i = !0, n(A, o));
    }, v = a.length, b = [];
    if (!v) return h([]);
    let x = {
      value: o,
      originalValue: s,
      path: l,
      options: u,
      schema: this
    };
    for (let A = 0; A < a.length; A++) {
      const T = a[A];
      T(x, d, function(E) {
        E && (Array.isArray(E) ? b.push(...E) : b.push(E)), --v <= 0 && h(b);
      });
    }
  }
  asNestedTest({
    key: e,
    index: r,
    parent: n,
    parentPath: i,
    originalParent: a,
    options: o
  }) {
    const s = e ?? r;
    if (s == null)
      throw TypeError("Must include `key` or `index` for nested validations");
    const l = typeof s == "number";
    let u = n[s];
    const d = Object.assign({}, o, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: !0,
      parent: n,
      value: u,
      originalValue: a[s],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [l ? "index" : "key"]: s,
      path: l || s.includes(".") ? `${i || ""}[${l ? s : `"${s}"`}]` : (i ? `${i}.` : "") + e
    });
    return (h, v, b) => this.resolve(d)._validate(u, d, v, b);
  }
  validate(e, r) {
    var n;
    let i = this.resolve(Object.assign({}, r, {
      value: e
    })), a = (n = r?.disableStackTrace) != null ? n : i.spec.disableStackTrace;
    return new Promise((o, s) => i._validate(e, r, (l, u) => {
      Si.isError(l) && (l.value = u), s(l);
    }, (l, u) => {
      l.length ? s(new Si(l, u, void 0, void 0, a)) : o(u);
    }));
  }
  validateSync(e, r) {
    var n;
    let i = this.resolve(Object.assign({}, r, {
      value: e
    })), a, o = (n = r?.disableStackTrace) != null ? n : i.spec.disableStackTrace;
    return i._validate(e, Object.assign({}, r, {
      sync: !0
    }), (s, l) => {
      throw Si.isError(s) && (s.value = l), s;
    }, (s, l) => {
      if (s.length) throw new Si(s, e, void 0, void 0, o);
      a = l;
    }), a;
  }
  isValid(e, r) {
    return this.validate(e, r).then(() => !0, (n) => {
      if (Si.isError(n)) return !1;
      throw n;
    });
  }
  isValidSync(e, r) {
    try {
      return this.validateSync(e, r), !0;
    } catch (n) {
      if (Si.isError(n)) return !1;
      throw n;
    }
  }
  _getDefault(e) {
    let r = this.spec.default;
    return r == null ? r : typeof r == "function" ? r.call(this, e) : Uf(r);
  }
  getDefault(e) {
    return this.resolve(e || {})._getDefault(e);
  }
  default(e) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: e
    });
  }
  strict(e = !0) {
    return this.clone({
      strict: e
    });
  }
  nullability(e, r) {
    const n = this.clone({
      nullable: e
    });
    return n.internalTests.nullable = Af({
      message: r,
      name: "nullable",
      test(i) {
        return i === null ? this.schema.spec.nullable : !0;
      }
    }), n;
  }
  optionality(e, r) {
    const n = this.clone({
      optional: e
    });
    return n.internalTests.optionality = Af({
      message: r,
      name: "optionality",
      test(i) {
        return i === void 0 ? this.schema.spec.optional : !0;
      }
    }), n;
  }
  optional() {
    return this.optionality(!0);
  }
  defined(e = No.defined) {
    return this.optionality(!1, e);
  }
  nullable() {
    return this.nullability(!0);
  }
  nonNullable(e = No.notNull) {
    return this.nullability(!1, e);
  }
  required(e = No.required) {
    return this.clone().withMutation((r) => r.nonNullable(e).defined(e));
  }
  notRequired() {
    return this.clone().withMutation((e) => e.nullable().optional());
  }
  transform(e) {
    let r = this.clone();
    return r.transforms.push(e), r;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...e) {
    let r;
    if (e.length === 1 ? typeof e[0] == "function" ? r = {
      test: e[0]
    } : r = e[0] : e.length === 2 ? r = {
      name: e[0],
      test: e[1]
    } : r = {
      name: e[0],
      message: e[1],
      test: e[2]
    }, r.message === void 0 && (r.message = No.default), typeof r.test != "function") throw new TypeError("`test` is a required parameters");
    let n = this.clone(), i = Af(r), a = r.exclusive || r.name && n.exclusiveTests[r.name] === !0;
    if (r.exclusive && !r.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return r.name && (n.exclusiveTests[r.name] = !!r.exclusive), n.tests = n.tests.filter((o) => !(o.OPTIONS.name === r.name && (a || o.OPTIONS.test === i.OPTIONS.test))), n.tests.push(i), n;
  }
  when(e, r) {
    !Array.isArray(e) && typeof e != "string" && (r = e, e = ".");
    let n = this.clone(), i = D_(e).map((a) => new Cc(a));
    return i.forEach((a) => {
      a.isSibling && n.deps.push(a.key);
    }), n.conditions.push(typeof r == "function" ? new E5(i, r) : E5.fromOptions(i, r)), n;
  }
  typeError(e) {
    let r = this.clone();
    return r.internalTests.typeError = Af({
      message: e,
      name: "typeError",
      skipAbsent: !0,
      test(n) {
        return this.schema._typeCheck(n) ? !0 : this.createError({
          params: {
            type: this.schema.type
          }
        });
      }
    }), r;
  }
  oneOf(e, r = No.oneOf) {
    let n = this.clone();
    return e.forEach((i) => {
      n._whitelist.add(i), n._blacklist.delete(i);
    }), n.internalTests.whiteList = Af({
      message: r,
      name: "oneOf",
      skipAbsent: !0,
      test(i) {
        let a = this.schema._whitelist, o = a.resolveAll(this.resolve);
        return o.includes(i) ? !0 : this.createError({
          params: {
            values: Array.from(a).join(", "),
            resolved: o
          }
        });
      }
    }), n;
  }
  notOneOf(e, r = No.notOneOf) {
    let n = this.clone();
    return e.forEach((i) => {
      n._blacklist.add(i), n._whitelist.delete(i);
    }), n.internalTests.blacklist = Af({
      message: r,
      name: "notOneOf",
      test(i) {
        let a = this.schema._blacklist, o = a.resolveAll(this.resolve);
        return o.includes(i) ? this.createError({
          params: {
            values: Array.from(a).join(", "),
            resolved: o
          }
        }) : !0;
      }
    }), n;
  }
  strip(e = !0) {
    let r = this.clone();
    return r.spec.strip = e, r;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(e) {
    const r = (e ? this.resolve(e) : this).clone(), {
      label: n,
      meta: i,
      optional: a,
      nullable: o
    } = r.spec;
    return {
      meta: i,
      label: n,
      optional: a,
      nullable: o,
      default: r.getDefault(e),
      type: r.type,
      oneOf: r._whitelist.describe(),
      notOneOf: r._blacklist.describe(),
      tests: r.tests.map((l) => ({
        name: l.OPTIONS.name,
        params: l.OPTIONS.params
      })).filter((l, u, d) => d.findIndex((h) => h.name === l.name) === u)
    };
  }
}
is.prototype.__isYupSchema__ = !0;
for (const t of ["validate", "validateSync"]) is.prototype[`${t}At`] = function(e, r, n = {}) {
  const {
    parent: i,
    parentPath: a,
    schema: o
  } = fR(this, e, r, n.context);
  return o[t](i && i[a], Object.assign({}, n, {
    parent: i,
    path: e
  }));
};
for (const t of ["equals", "is"]) is.prototype[t] = is.prototype.oneOf;
for (const t of ["not", "nope"]) is.prototype[t] = is.prototype.notOneOf;
const dR = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function hR(t) {
  const e = Yv(t);
  if (!e) return Date.parse ? Date.parse(t) : Number.NaN;
  if (e.z === void 0 && e.plusMinus === void 0)
    return new Date(e.year, e.month, e.day, e.hour, e.minute, e.second, e.millisecond).valueOf();
  let r = 0;
  return e.z !== "Z" && e.plusMinus !== void 0 && (r = e.hourOffset * 60 + e.minuteOffset, e.plusMinus === "+" && (r = 0 - r)), Date.UTC(e.year, e.month, e.day, e.hour, e.minute + r, e.second, e.millisecond);
}
function Yv(t) {
  var e, r;
  const n = dR.exec(t);
  return n ? {
    year: Vs(n[1]),
    month: Vs(n[2], 1) - 1,
    day: Vs(n[3], 1),
    hour: Vs(n[4]),
    minute: Vs(n[5]),
    second: Vs(n[6]),
    millisecond: n[7] ? (
      // allow arbitrary sub-second precision beyond milliseconds
      Vs(n[7].substring(0, 3))
    ) : 0,
    precision: (e = (r = n[7]) == null ? void 0 : r.length) != null ? e : void 0,
    z: n[8] || void 0,
    plusMinus: n[9] || void 0,
    hourOffset: Vs(n[10]),
    minuteOffset: Vs(n[11])
  } : null;
}
function Vs(t, e = 0) {
  return Number(t) || e;
}
let pR = (
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
), mR = (
  // eslint-disable-next-line
  /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
), gR = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, vR = "^\\d{4}-\\d{2}-\\d{2}", bR = "\\d{2}:\\d{2}:\\d{2}", xR = "(([+-]\\d{2}(:?\\d{2})?)|Z)", yR = new RegExp(`${vR}T${bR}(\\.\\d+)?${xR}$`), wR = (t) => $u(t) || t === t.trim(), _R = {}.toString();
function Rl() {
  return new I_();
}
class I_ extends is {
  constructor() {
    super({
      type: "string",
      check(e) {
        return e instanceof String && (e = e.valueOf()), typeof e == "string";
      }
    }), this.withMutation(() => {
      this.transform((e, r, n) => {
        if (!n.spec.coerce || n.isType(e) || Array.isArray(e)) return e;
        const i = e != null && e.toString ? e.toString() : e;
        return i === _R ? e : i;
      });
    });
  }
  required(e) {
    return super.required(e).withMutation((r) => r.test({
      message: e || No.required,
      name: "required",
      skipAbsent: !0,
      test: (n) => !!n.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation((e) => (e.tests = e.tests.filter((r) => r.OPTIONS.name !== "required"), e));
  }
  length(e, r = Ei.length) {
    return this.test({
      message: r,
      name: "length",
      exclusive: !0,
      params: {
        length: e
      },
      skipAbsent: !0,
      test(n) {
        return n.length === this.resolve(e);
      }
    });
  }
  min(e, r = Ei.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: e
      },
      skipAbsent: !0,
      test(n) {
        return n.length >= this.resolve(e);
      }
    });
  }
  max(e, r = Ei.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: r,
      params: {
        max: e
      },
      skipAbsent: !0,
      test(n) {
        return n.length <= this.resolve(e);
      }
    });
  }
  matches(e, r) {
    let n = !1, i, a;
    return r && (typeof r == "object" ? {
      excludeEmptyString: n = !1,
      message: i,
      name: a
    } = r : i = r), this.test({
      name: a || "matches",
      message: i || Ei.matches,
      params: {
        regex: e
      },
      skipAbsent: !0,
      test: (o) => o === "" && n || o.search(e) !== -1
    });
  }
  email(e = Ei.email) {
    return this.matches(pR, {
      name: "email",
      message: e,
      excludeEmptyString: !0
    });
  }
  url(e = Ei.url) {
    return this.matches(mR, {
      name: "url",
      message: e,
      excludeEmptyString: !0
    });
  }
  uuid(e = Ei.uuid) {
    return this.matches(gR, {
      name: "uuid",
      message: e,
      excludeEmptyString: !1
    });
  }
  datetime(e) {
    let r = "", n, i;
    return e && (typeof e == "object" ? {
      message: r = "",
      allowOffset: n = !1,
      precision: i = void 0
    } = e : r = e), this.matches(yR, {
      name: "datetime",
      message: r || Ei.datetime,
      excludeEmptyString: !0
    }).test({
      name: "datetime_offset",
      message: r || Ei.datetime_offset,
      params: {
        allowOffset: n
      },
      skipAbsent: !0,
      test: (a) => {
        if (!a || n) return !0;
        const o = Yv(a);
        return o ? !!o.z : !1;
      }
    }).test({
      name: "datetime_precision",
      message: r || Ei.datetime_precision,
      params: {
        precision: i
      },
      skipAbsent: !0,
      test: (a) => {
        if (!a || i == null) return !0;
        const o = Yv(a);
        return o ? o.precision === i : !1;
      }
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((e) => e === null ? "" : e);
  }
  trim(e = Ei.trim) {
    return this.transform((r) => r != null ? r.trim() : r).test({
      message: e,
      name: "trim",
      test: wR
    });
  }
  lowercase(e = Ei.lowercase) {
    return this.transform((r) => $u(r) ? r : r.toLowerCase()).test({
      message: e,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (r) => $u(r) || r === r.toLowerCase()
    });
  }
  uppercase(e = Ei.uppercase) {
    return this.transform((r) => $u(r) ? r : r.toUpperCase()).test({
      message: e,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (r) => $u(r) || r === r.toUpperCase()
    });
  }
}
Rl.prototype = I_.prototype;
let AR = /* @__PURE__ */ new Date(""), ER = (t) => Object.prototype.toString.call(t) === "[object Date]";
class yp extends is {
  constructor() {
    super({
      type: "date",
      check(e) {
        return ER(e) && !isNaN(e.getTime());
      }
    }), this.withMutation(() => {
      this.transform((e, r, n) => !n.spec.coerce || n.isType(e) || e === null ? e : (e = hR(e), isNaN(e) ? yp.INVALID_DATE : new Date(e)));
    });
  }
  prepareParam(e, r) {
    let n;
    if (Cc.isRef(e))
      n = e;
    else {
      let i = this.cast(e);
      if (!this._typeCheck(i)) throw new TypeError(`\`${r}\` must be a Date or a value that can be \`cast()\` to a Date`);
      n = i;
    }
    return n;
  }
  min(e, r = Hv.min) {
    let n = this.prepareParam(e, "min");
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: e
      },
      skipAbsent: !0,
      test(i) {
        return i >= this.resolve(n);
      }
    });
  }
  max(e, r = Hv.max) {
    let n = this.prepareParam(e, "max");
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: e
      },
      skipAbsent: !0,
      test(i) {
        return i <= this.resolve(n);
      }
    });
  }
}
yp.INVALID_DATE = AR;
yp.prototype;
function SR(t, e = []) {
  let r = [], n = /* @__PURE__ */ new Set(), i = new Set(e.map(([o, s]) => `${o}-${s}`));
  function a(o, s) {
    let l = ac.split(o)[0];
    n.add(l), i.has(`${s}-${l}`) || r.push([s, l]);
  }
  for (const o of Object.keys(t)) {
    let s = t[o];
    n.add(o), Cc.isRef(s) && s.isSibling ? a(s.path, o) : ib(s) && "deps" in s && s.deps.forEach((l) => a(l, o));
  }
  return QO.array(Array.from(n), r).reverse();
}
function y6(t, e) {
  let r = 1 / 0;
  return t.some((n, i) => {
    var a;
    if ((a = e.path) != null && a.includes(n))
      return r = i, !0;
  }), r;
}
function B_(t) {
  return (e, r) => y6(t, e) - y6(t, r);
}
const CR = (t, e, r) => {
  if (typeof t != "string")
    return t;
  let n = t;
  try {
    n = JSON.parse(t);
  } catch {
  }
  return r.isType(n) ? n : t;
};
function G2(t) {
  if ("fields" in t) {
    const e = {};
    for (const [r, n] of Object.entries(t.fields))
      e[r] = G2(n);
    return t.setFields(e);
  }
  if (t.type === "array") {
    const e = t.optional();
    return e.innerType && (e.innerType = G2(e.innerType)), e;
  }
  return t.type === "tuple" ? t.optional().clone({
    types: t.spec.types.map(G2)
  }) : "optional" in t ? t.optional() : t;
}
const kR = (t, e) => {
  const r = [...ac.normalizePath(e)];
  if (r.length === 1) return r[0] in t;
  let n = r.pop(), i = ac.getter(ac.join(r), !0)(t);
  return !!(i && n in i);
};
let w6 = (t) => Object.prototype.toString.call(t) === "[object Object]";
function TR(t, e) {
  let r = Object.keys(t.fields);
  return Object.keys(e).filter((n) => r.indexOf(n) === -1);
}
const FR = B_([]);
function L_(t) {
  return new N_(t);
}
class N_ extends is {
  constructor(e) {
    super({
      type: "object",
      check(r) {
        return w6(r) || typeof r == "function";
      }
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = FR, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      e && this.shape(e);
    });
  }
  _cast(e, r = {}) {
    var n;
    let i = super._cast(e, r);
    if (i === void 0) return this.getDefault(r);
    if (!this._typeCheck(i)) return i;
    let a = this.fields, o = (n = r.stripUnknown) != null ? n : this.spec.noUnknown, s = [].concat(this._nodes, Object.keys(i).filter((h) => !this._nodes.includes(h))), l = {}, u = Object.assign({}, r, {
      parent: l,
      __validating: r.__validating || !1
    }), d = !1;
    for (const h of s) {
      let v = a[h], b = h in i;
      if (v) {
        let x, A = i[h];
        u.path = (r.path ? `${r.path}.` : "") + h, v = v.resolve({
          value: A,
          context: r.context,
          parent: l
        });
        let T = v instanceof is ? v.spec : void 0, k = T?.strict;
        if (T != null && T.strip) {
          d = d || h in i;
          continue;
        }
        x = !r.__validating || !k ? (
          // TODO: use _cast, this is double resolving
          v.cast(i[h], u)
        ) : i[h], x !== void 0 && (l[h] = x);
      } else b && !o && (l[h] = i[h]);
      (b !== h in l || l[h] !== i[h]) && (d = !0);
    }
    return d ? l : i;
  }
  _validate(e, r = {}, n, i) {
    let {
      from: a = [],
      originalValue: o = e,
      recursive: s = this.spec.recursive
    } = r;
    r.from = [{
      schema: this,
      value: o
    }, ...a], r.__validating = !0, r.originalValue = o, super._validate(e, r, n, (l, u) => {
      if (!s || !w6(u)) {
        i(l, u);
        return;
      }
      o = o || u;
      let d = [];
      for (let h of this._nodes) {
        let v = this.fields[h];
        !v || Cc.isRef(v) || d.push(v.asNestedTest({
          options: r,
          key: h,
          parent: u,
          parentPath: r.path,
          originalParent: o
        }));
      }
      this.runTests({
        tests: d,
        value: u,
        originalValue: o,
        options: r
      }, n, (h) => {
        i(h.sort(this._sortErrors).concat(l), u);
      });
    });
  }
  clone(e) {
    const r = super.clone(e);
    return r.fields = Object.assign({}, this.fields), r._nodes = this._nodes, r._excludedEdges = this._excludedEdges, r._sortErrors = this._sortErrors, r;
  }
  concat(e) {
    let r = super.concat(e), n = r.fields;
    for (let [i, a] of Object.entries(this.fields)) {
      const o = n[i];
      n[i] = o === void 0 ? a : o;
    }
    return r.withMutation((i) => (
      // XXX: excludes here is wrong
      i.setFields(n, [...this._excludedEdges, ...e._excludedEdges])
    ));
  }
  _getDefault(e) {
    if ("default" in this.spec)
      return super._getDefault(e);
    if (!this._nodes.length)
      return;
    let r = {};
    return this._nodes.forEach((n) => {
      var i;
      const a = this.fields[n];
      let o = e;
      (i = o) != null && i.value && (o = Object.assign({}, o, {
        parent: o.value,
        value: o.value[n]
      })), r[n] = a && "getDefault" in a ? a.getDefault(o) : void 0;
    }), r;
  }
  setFields(e, r) {
    let n = this.clone();
    return n.fields = e, n._nodes = SR(e, r), n._sortErrors = B_(Object.keys(e)), r && (n._excludedEdges = r), n;
  }
  shape(e, r = []) {
    return this.clone().withMutation((n) => {
      let i = n._excludedEdges;
      return r.length && (Array.isArray(r[0]) || (r = [r]), i = [...n._excludedEdges, ...r]), n.setFields(Object.assign(n.fields, e), i);
    });
  }
  partial() {
    const e = {};
    for (const [r, n] of Object.entries(this.fields))
      e[r] = "optional" in n && n.optional instanceof Function ? n.optional() : n;
    return this.setFields(e);
  }
  deepPartial() {
    return G2(this);
  }
  pick(e) {
    const r = {};
    for (const n of e)
      this.fields[n] && (r[n] = this.fields[n]);
    return this.setFields(r, this._excludedEdges.filter(([n, i]) => e.includes(n) && e.includes(i)));
  }
  omit(e) {
    const r = [];
    for (const n of Object.keys(this.fields))
      e.includes(n) || r.push(n);
    return this.pick(r);
  }
  from(e, r, n) {
    let i = ac.getter(e, !0);
    return this.transform((a) => {
      if (!a) return a;
      let o = a;
      return kR(a, e) && (o = Object.assign({}, a), n || delete o[e], o[r] = i(a)), o;
    });
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(CR);
  }
  noUnknown(e = !0, r = qv.noUnknown) {
    typeof e != "boolean" && (r = e, e = !0);
    let n = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: r,
      test(i) {
        if (i == null) return !0;
        const a = TR(this.schema, i);
        return !e || a.length === 0 || this.createError({
          params: {
            unknown: a.join(", ")
          }
        });
      }
    });
    return n.spec.noUnknown = e, n;
  }
  unknown(e = !0, r = qv.noUnknown) {
    return this.noUnknown(!e, r);
  }
  transformKeys(e) {
    return this.transform((r) => {
      if (!r) return r;
      const n = {};
      for (const i of Object.keys(r)) n[e(i)] = r[i];
      return n;
    });
  }
  camelCase() {
    return this.transformKeys(vg.camelCase);
  }
  snakeCase() {
    return this.transformKeys(vg.snakeCase);
  }
  constantCase() {
    return this.transformKeys((e) => vg.snakeCase(e).toUpperCase());
  }
  describe(e) {
    const r = (e ? this.resolve(e) : this).clone(), n = super.describe(e);
    n.fields = {};
    for (const [a, o] of Object.entries(r.fields)) {
      var i;
      let s = e;
      (i = s) != null && i.value && (s = Object.assign({}, s, {
        parent: s.value,
        value: s.value[a]
      })), n.fields[a] = o.describe(s);
    }
    return n;
  }
}
L_.prototype = N_.prototype;
const DR = L_().shape({
  recipientId: Rl().required("Recipient ID is a required field"),
  ipAddress: Rl().required("IP Address is a required field"),
  browser: Rl().required("Browser is a required field"),
  browserUserAgent: Rl().required("Browser User Agent is a required field"),
  dateSignedUTC: Rl().required("Date Signed UTC is a required field"),
  timeZoneSignedIANA: Rl().required("Time Zone is a required field"),
  dataUri: Rl().required("Signature data is required")
}), OR = (t) => {
  const e = window.navigator;
  return {
    recipientId: t,
    ipAddress: "ip",
    browser: e.platform,
    browserUserAgent: e.userAgent,
    dateSignedUTC: (/* @__PURE__ */ new Date()).toISOString(),
    timeZoneSignedIANA: RR(),
    dataUri: ""
  };
}, RR = () => {
  const t = (/* @__PURE__ */ new Date()).getTimezoneOffset(), e = Math.floor(Math.abs(t) / 60), r = Math.abs(t) % 60;
  return `UTC${t > 0 ? "-" : "+"}${String(e).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
}, PR = (t, e, r) => {
  const { recipientId: n = "" } = mp(), i = OO({
    resolver: IO(DR),
    defaultValues: OR(n)
  }), { handleSubmit: a, register: o, trigger: s, setValue: l, formState: u } = i, [d, h] = Z3({
    path: "/api/recipient/Signature",
    method: r ? "POST" : "PUT",
    headers: {},
    isProtectedRoute: !1
  });
  return {
    trigger: s,
    onCanvaschange: (A) => {
      l("dataUri", A), s("dataUri");
    },
    isValid: () => u.isValid,
    register: o,
    isSubmitLoading: h,
    handleSubmitSignature: () => a(async (A) => {
      const T = {
        ...A
      }, k = await d(T);
      if (k) {
        t();
        try {
          await e?.(A.dataUri, k);
        } catch (E) {
          console.error("Error in onSignatureSubmitted:", E);
        }
      }
    }),
    formState: u
  };
}, IR = ({
  handlerModalClose: t,
  isValid: e,
  isSubmitLoading: r,
  handleSubmitSignature: n
}) => {
  const { isMobile: i } = hp();
  return /* @__PURE__ */ X.jsx(uo, { children: /* @__PURE__ */ X.jsxs(X.Fragment, { children: [
    !i && /* @__PURE__ */ X.jsx(ea, { name: "submit-cancel", intent: "neutral", disabled: r, onClick: t, children: "Cancel" }),
    /* @__PURE__ */ X.jsx(
      ea,
      {
        role: "button",
        name: "submit-btn",
        className: i ? Ja : "",
        disabled: !e() || r,
        intent: "primary",
        loading: r,
        onClick: n(),
        children: "Adopt Signature"
      }
    )
  ] }) });
}, BR = ({
  className: t,
  handlerModalClose: e,
  isModalOpen: r,
  initialSignature: n,
  onSignatureSubmitted: i
}) => {
  const { onCanvaschange: a, register: o, isValid: s, handleSubmitSignature: l, isSubmitLoading: u } = PR(
    e,
    i,
    !n
  );
  return /* @__PURE__ */ X.jsx(uo, { children: /* @__PURE__ */ X.jsx(
    vp,
    {
      hasFullScreen: !0,
      hasCloseButton: !0,
      isModalOpen: r,
      className: t,
      handlerModalClose: e,
      title: "Add your signature",
      footer: /* @__PURE__ */ X.jsx(IR, { handlerModalClose: e, handleSubmitSignature: l, isSubmitLoading: u, isValid: s }),
      children: /* @__PURE__ */ X.jsxs(Lt, { hasMaxWidth: !0, isFlexColumn: !0, className: st(v1, bh), children: [
        /* @__PURE__ */ X.jsx(H3, { children: "Draw your signature in the space provided. If you would like to redo the signature, tap ‘Clear’ and try again." }),
        /* @__PURE__ */ X.jsx($F, { className: st(q3), children: /* @__PURE__ */ X.jsx(
          d_,
          {
            initialSignature: n,
            ...o("dataUri"),
            onChange: (d) => a(d)
          }
        ) })
      ] })
    }
  ) });
}, aie = (t) => {
  const e = l_(), { recipientId: r = "mok-id-forms" } = mp(), [n, i] = Z3({
    path: `/api/recipient/${r}/${t ? "ChangeRequest" : "Complete"}`,
    method: "PATCH",
    headers: {},
    isProtectedRoute: !1
  });
  return {
    isSubmitLoading: i,
    handleSubmitAgreement: async () => {
      await n({}) && e(`/${r}/succes/${t ? "changed-request" : "submited"}`);
    }
  };
}, LR = "cn58si", oie = ({
  className: t,
  handlerModalClose: e,
  handleSubmitAgreement: r,
  isModalOpen: n,
  changeRequested: i,
  isLoading: a
}) => {
  const {
    isMobile: o
  } = hp();
  return i?.length ? /* @__PURE__ */ X.jsx(uo, {
    children: /* @__PURE__ */ X.jsx(vp, {
      hasFullScreen: !0,
      hasCloseButton: !0,
      className: t,
      handlerModalClose: e,
      isModalOpen: n,
      title: "Submit change request",
      children: /* @__PURE__ */ X.jsxs(Lt, {
        isFlexColumn: !0,
        className: st(v1, bh, o ? jF : WF),
        children: [/* @__PURE__ */ X.jsxs(Lt, {
          isFlexColumn: !0,
          className: VF,
          children: [/* @__PURE__ */ X.jsx(ts, {
            children: "You have made a change request to:"
          }), /* @__PURE__ */ X.jsx(Lt, {
            isFlexColumn: !0,
            children: i.map((s, l) => /* @__PURE__ */ X.jsx(ts, {
              hasBoldText: !0,
              className: LR,
              children: s
            }, l))
          }), /* @__PURE__ */ X.jsx(ts, {
            children: "Unfortunately you are unable to proceed with the lease signing at this time. We`ll review your request and issue a revised agreement."
          })]
        }), !o && /* @__PURE__ */ X.jsx(pp, {
          alignment: "right",
          children: /* @__PURE__ */ X.jsx(ea, {
            buttonSize: "large",
            loading: a,
            disabled: a,
            intent: "primary",
            onClick: r,
            children: "Submit Request"
          })
        }), o && /* @__PURE__ */ X.jsx(ea, {
          buttonSize: "large",
          loading: a,
          disabled: a,
          intent: "primary",
          onClick: r,
          children: "Submit Request"
        })]
      })
    })
  }) : null;
}, sie = ({
  className: t,
  title: e,
  message: r,
  onCancel: n,
  onClose: i,
  onConfirm: a,
  isOpen: o,
  isLoading: s,
  cancelButtonText: l = "Cancel",
  confirmButtonText: u = "Confirm",
  intent: d = "primary"
}) => /* @__PURE__ */ X.jsx(uo, { children: /* @__PURE__ */ X.jsx(vp, { className: t, handlerModalClose: i, isModalOpen: o, title: e, children: /* @__PURE__ */ X.jsxs(Lt, { isFlexColumn: !0, className: st(v1, bh), children: [
  /* @__PURE__ */ X.jsx(H3, { children: r }),
  /* @__PURE__ */ X.jsxs(pp, { alignment: "right", className: st(q3), children: [
    /* @__PURE__ */ X.jsx(ea, { intent: "default", disabled: s, onClick: n, children: l }),
    /* @__PURE__ */ X.jsx(ea, { loading: s, disabled: s, intent: d, onClick: a, children: u })
  ] })
] }) }) });
var NR = jt.createContext(
  void 0
), MR = (t) => {
  const e = jt.useContext(NR);
  if (t)
    return t;
  if (!e)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return e;
};
const UR = (t) => {
  const [e, r] = Ht(!1), [n, i] = Ht(), [a] = xD((o) => {
    const s = new Image();
    s.crossOrigin = "anonymous", s.src = o, s.onload = () => {
      i(s), r(!1);
    }, s.onerror = () => {
      r(!1);
    };
  }, {
    startImmediatly: !0
  });
  return l0(() => {
    if (t)
      return r(!0), a(t), () => i(void 0);
  }, [t]), {
    image: n,
    isLoading: e
  };
}, zR = ({
  data: t,
  queryClient: e,
  cardId: r,
  index: n
}) => {
  const [i, a] = Ht(t?.dataUri), [o, s] = Ht(!1), {
    recipientId: l,
    stepsId: u
  } = mp(), d = MR(e), h = qi(bD(`/api/recipient/${l}/Card`, {
    step: u,
    cardNum: r
  }), [l, u, r]), v = qi(() => ["step", l, u], [l, u]);
  if (l0(() => {
    t.dataUri && a(t.dataUri);
  }, [t.dataUri]), !t) return null;
  const b = "c86x3ub", {
    image: x,
    isLoading: A
  } = UR(i), T = async (k, E) => {
    k && (a(k), d.setQueryData([h], (C) => {
      const D = [...C.cardDisplayDataBody];
      return D[n].data = E, {
        ...C,
        cardDisplayDataBody: D
      };
    }), d.setQueryData(v, (C) => ({
      ...C,
      continueButtonEnabled: !0
    })));
  };
  return t?.dataUri && !x || A ? /* @__PURE__ */ X.jsx(QD, {
    className: Lv,
    width: "100%",
    height: "120px",
    role: "progressbar"
  }) : /* @__PURE__ */ X.jsxs(X.Fragment, {
    children: [/* @__PURE__ */ X.jsxs(Lt, {
      className: st(b, Lv, x ? "with-data" : ""),
      onClick: () => s(!0),
      children: [/* @__PURE__ */ X.jsx(d_, {
        disabled: !0,
        initialSignature: x
      }), !x && /* @__PURE__ */ X.jsx(jr, {
        className: st("description", HF),
        intent: "primary",
        hasBoldText: !0,
        hasCenteredText: !0,
        children: "Tap here to add your signature"
      })]
    }), /* @__PURE__ */ X.jsx(BR, {
      handlerModalClose: () => s(!1),
      initialSignature: x,
      isModalOpen: o,
      onSignatureSubmitted: T
    })]
  });
}, $R = () => Lt, VR = /* @__PURE__ */ Rn($R())({
  name: "StyledCard",
  class: "s13sja2g",
  propsAsIs: !0
}), lie = ({
  Icon: t,
  title: e,
  ...r
}) => /* @__PURE__ */ X.jsxs(Lt, {
  isFlexAlignCenter: !0,
  className: st(n_, YF),
  ...r,
  children: [t, e && /* @__PURE__ */ X.jsx(ts, {
    intent: "low",
    children: e
  })]
}), uie = ({
  className: t,
  ...e
}) => /* @__PURE__ */ X.jsx(Lt, {
  isFlexColumn: !0,
  className: st("w1i58dto", t),
  ...e
}), cie = (t) => /* @__PURE__ */ X.jsx(Lt, {
  isFlexColumn: !0,
  ...t
}), fie = (t) => /* @__PURE__ */ X.jsx(qF, {
  hasBoldText: !0,
  ...t
}), die = (t) => /* @__PURE__ */ X.jsx(ts, {
  ...t
}), hie = (t) => /* @__PURE__ */ X.jsx(Y3, {
  hasGreyText: !0,
  ...t
}), pie = (t) => /* @__PURE__ */ X.jsx(VR, {
  isFlexColumn: !0,
  ...t
}), mie = ({
  action: t,
  data: e,
  queryClient: r,
  cardId: n,
  index: i
}) => {
  switch (t) {
    case "saveToContacts":
      return /* @__PURE__ */ X.jsx(lO, {
        data: e
      });
    case "viewInMaps":
      return /* @__PURE__ */ X.jsx(oO, {
        data: e
      });
    case "signature":
      return /* @__PURE__ */ X.jsx(zR, {
        index: i,
        data: e,
        queryClient: r,
        cardId: n
      });
    default:
      return null;
  }
}, jR = (t, e, r) => {
  const n = t[e];
  return n ? typeof n == "function" ? n() : Promise.resolve(n) : new Promise((i, a) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      a.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + e + (e.split("/").length !== r ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
}, WR = /* @__PURE__ */ Rn("div")({
  name: "FormIconContainer",
  class: "f1ff97qc",
  propsAsIs: !1
}), gie = ({
  iconName: t
}) => {
  const {
    SvgIcon: e,
    loading: r,
    error: n
  } = HR(t);
  if (r) return /* @__PURE__ */ X.jsx("div", {
    children: "Loading..."
  });
  if (n) return /* @__PURE__ */ X.jsxs("div", {
    children: ["Error: ", n.message]
  });
  if (!e) return t && /* @__PURE__ */ X.jsx(il, {
    icon: t
  });
  const i = e ? /* @__PURE__ */ X.jsx(e, {}) : t && /* @__PURE__ */ X.jsx(il, {
    icon: t
  });
  return /* @__PURE__ */ X.jsx(WR, {
    children: i
  });
};
function HR(t) {
  const [e, r] = Ht(null), [n, i] = Ht(!1), [a, o] = Ht(null);
  return l0(() => {
    (async () => {
      i(!0), o(null), t || (t = "person");
      try {
        const l = await jR(/* @__PURE__ */ Object.assign({
          "../assets/icons/address.svg": () => import("./address-Bi54BJ-U.js"),
          "../assets/icons/bond.svg": () => import("./bond-DY1OUqiv.js"),
          "../assets/icons/bylaws.svg": () => import("./bylaws-CgYriOXE.js"),
          "../assets/icons/calendar.svg": () => import("./calendar-Cs4NOlNc.js"),
          "../assets/icons/electricity.svg": () => import("./electricity-DSzVJ7bl.js"),
          "../assets/icons/gas.svg": () => import("./gas-B5wmFd4V.js"),
          "../assets/icons/glasses-invisible.svg": () => import("./glasses-invisible-2lpKky7t.js"),
          "../assets/icons/inclusion.svg": () => import("./inclusion-MELnzgDq.js"),
          "../assets/icons/lock.svg": () => import("./lock-DSSYGsha.js"),
          "../assets/icons/occupants.svg": () => import("./occupants-Ed-h2905.js"),
          "../assets/icons/otherRepairs.svg": () => import("./otherRepairs-B-O4hKVl.js"),
          "../assets/icons/owners.svg": () => import("./owners-CunhHjoP.js"),
          "../assets/icons/payment.svg": () => import("./payment-DIHmik-3.js"),
          "../assets/icons/pencil-edit-square.svg": () => import("./pencil-edit-square-CeEUCQF6.js"),
          "../assets/icons/person.svg": () => import("./person-BN0jsdl6.js"),
          "../assets/icons/pet.svg": () => import("./pet-CcFtj3vj.js"),
          "../assets/icons/phone.svg": () => import("./phone-C6mpT5v2.js"),
          "../assets/icons/plumbing.svg": () => import("./plumbing-DIGiD9YE.js"),
          "../assets/icons/rent.svg": () => import("./rent-isOGeRH4.js"),
          "../assets/icons/water.svg": () => import("./water-Bk3PKCw1.js")
        }), `../assets/icons/${t}.svg`, 4);
        r(() => l.ReactComponent || l.default);
      } catch {
        r(null);
      } finally {
        i(!1);
      }
    })();
  }, [t]), {
    SvgIcon: e,
    loading: n,
    error: a
  };
}
const qR = "dqyey9s", vie = ({
  htmlString: t
}) => /* @__PURE__ */ X.jsx("div", {
  className: qR,
  dangerouslySetInnerHTML: {
    __html: t
  }
}), YR = () => Lt, GR = /* @__PURE__ */ Rn(YR())({
  name: "FileInformationContainer",
  class: "fwp76zs",
  propsAsIs: !0
}), ZR = () => Lt, XR = /* @__PURE__ */ Rn(ZR())({
  name: "InputFileWrapper",
  class: "i1dmypcs",
  propsAsIs: !0
}), KR = /* @__PURE__ */ Rn("div")({
  name: "FileExtention",
  class: "fp5y5zx",
  propsAsIs: !1
}), JR = "f1clzgo8", QR = ({
  index: t,
  onDeleteFile: e,
  onRetry: r,
  internalStatus: n,
  fileName: i,
  fileSize: a,
  fileId: o
}) => {
  const s = n === "PENDING", l = n === "ERROR";
  return /* @__PURE__ */ X.jsx(GF, {
    paddingSize: "none",
    className: st(l && WD),
    children: /* @__PURE__ */ X.jsxs(GR, {
      isFlexNoWrap: !0,
      isFlexAlignCenter: !0,
      children: [/* @__PURE__ */ X.jsx(KR, {
        children: SF(i)
      }), /* @__PURE__ */ X.jsx(jr, {
        hasBoldText: !0,
        className: st(XF, "cowif1z"),
        children: i
      }), s && /* @__PURE__ */ X.jsx(i_, {}), !s && !l && /* @__PURE__ */ X.jsxs(X.Fragment, {
        children: [/* @__PURE__ */ X.jsx(jr, {
          hasGreyText: !0,
          className: ZF,
          children: CF(a)
        }), /* @__PURE__ */ X.jsx(il, {
          onClick: () => e?.(t, o),
          className: st(zv, ic),
          intent: "secondary",
          icon: "close"
        })]
      }), l && /* @__PURE__ */ X.jsxs(Lt, {
        isFlexAlignCenter: !0,
        isFlexNoWrap: !0,
        isFlexShrink0: !0,
        className: ic,
        children: [/* @__PURE__ */ X.jsx(jr, {
          hasGreyText: !0,
          children: "Retry"
        }), /* @__PURE__ */ X.jsx(il, {
          onClick: () => r?.(t),
          className: zv,
          intent: "secondary",
          icon: "refresh"
        })]
      })]
    })
  });
};
function bie({
  label: t,
  required: e,
  errorMessage: r,
  allowMultiple: n,
  defaultData: i,
  onChange: a,
  disabled: o,
  acceptedFileType: s,
  minimumFileSize: l,
  maximumFileSize: u,
  disableDeleteActualFile: d
}) {
  const h = Ye.useRef(null), [v, b] = Ye.useState(), [x, A] = Ye.useState(), [T, k] = Ye.useState(), [E, C] = Ye.useState(i ? Array.isArray(i) ? i : [i] : []), {
    upload: D,
    archiveFiles: _
  } = yD(), {
    childHandler: I,
    isDragOverZone: R,
    registerMainHandler: U
  } = wD(), V = E.length, z = (te) => {
    a?.(te);
  }, j = async (te, ne) => {
    if (!te.fileId) return;
    let ce;
    try {
      await _(te.fileId);
    } catch {
      ce = "ERROR";
    }
    C((pe) => {
      const Me = [...pe], Ne = Me.splice(ne, 1);
      return ce === "ERROR" && Me.splice(ne, 0, {
        ...Ne[0],
        internalStatus: "ERROR"
      }), z?.(n ? Me : Me[0]), Me;
    });
  }, S = async (te) => {
    let ne, ce;
    try {
      ce = await D(te), ne = "NEW";
    } catch {
      k(te), ne = "ERROR";
    }
    C((pe) => {
      const Me = pe.map((Ne) => Ne.fileName !== te.name ? Ne : {
        ...Ne,
        fileId: ce?.fileId,
        internalStatus: ne
      });
      return z?.(n ? Me : Me[0]), Me;
    });
  }, B = (te) => {
    if (Number.isNaN(te) || te < 0 || te >= V) return;
    const ne = [...E], pe = ne.splice(te, 1)[0];
    !pe.internalStatus && pe.fileId && !d && (j(pe, te), ne.splice(te, 0, {
      ...pe,
      internalStatus: "PENDING"
    })), h.current && (h.current.value = ""), C(ne), z?.(n ? ne : ne[0]);
  }, q = (te) => {
    C((ne) => {
      const ce = [...te].reduce((Me, Ne) => {
        if (ne.find((ye) => ye.fileName === Ne.name)) return Me;
        const fe = {
          fileName: Ne.name,
          fileSize: Ne.size,
          internalStatus: "PENDING"
        };
        return S(Ne), [...Me, fe];
      }, []);
      if (ce.length === 0) return ne;
      const pe = [...ne, ...ce];
      return z?.(n ? pe : ce[0]), [...ne, ...ce];
    });
  }, Y = async (te, ne = E[0]) => {
    const ce = ne && !ne?.internalStatus, pe = {
      fileName: te.name,
      fileSize: te.size,
      internalStatus: "PENDING"
    };
    if (C([pe]), z(pe), ce && ne.fileId)
      try {
        await _(ne.fileId);
      } catch {
        k({
          ...ne,
          file: te
        }), C([{
          ...pe,
          internalStatus: "ERROR"
        }]);
        return;
      }
    S(te);
  }, Z = (te) => {
    b(!1), A(!1);
    const ne = Array.isArray(te) ? te : te.target.files;
    return !ne || !ne.length ? void 0 : FF(ne, s) ? DF(ne, l, u) ? n ? q(ne) : Y(ne[0]) : A(!0) : b(!0);
  }, Q = async (te) => {
    const ne = E[te];
    C((Ne) => Ne.map((it, fe) => fe === te ? {
      ...it,
      internalStatus: "PENDING"
    } : it));
    const ce = T && !(T instanceof File), pe = T instanceof File;
    if (ne.fileId !== void 0) return B(te);
    if (pe) return S(T);
    if (ce) return Y(T.file, T);
  }, J = Ye.useMemo(() => !l && !u ? "" : l ? u ? `File size should be atleast ${l} and can't exceed ${u}` : `File size should be atleast ${l}` : `File size can't exceed ${u}`, [l, u]), se = Ye.useMemo(() => !l && !u ? "" : l ? u ? `**Minimum file size is ${l} and maximum file size is ${u}` : `**Minimum file size is ${l}` : `**Maximum file size is ${u}`, [l, u]), ae = Ye.useMemo(() => s ? `*File type should be ${kF[s]}` : "", [s]);
  return /* @__PURE__ */ X.jsxs(a_, {
    children: [t && /* @__PURE__ */ X.jsx(o_, {
      children: e_(t, e)
    }), /* @__PURE__ */ X.jsxs(Lt, {
      isFlexColumn: !0,
      className: st(JR, !t && KF),
      children: [/* @__PURE__ */ X.jsxs(XR, {
        isFlexColumn: !0,
        isFlexAlignCenter: !0,
        isFlexJustifyCenter: !0,
        className: st(o && "is-disabled", r && "is-error", R && "drag-over"),
        onClick: () => h.current?.click(),
        ...U(Z),
        children: [/* @__PURE__ */ X.jsx("input", {
          ref: h,
          accept: s ? TF[s]?.join(",") : "*",
          onChange: Z,
          type: "file",
          multiple: n,
          ...I
        }), /* @__PURE__ */ X.jsxs(jr, {
          ...I,
          children: [!R && /* @__PURE__ */ X.jsxs(X.Fragment, {
            children: ["Drag and drop or", " ", /* @__PURE__ */ X.jsx("span", {
              className: "action-text",
              ...I,
              children: "browse files"
            })]
          }), R && "Drop here to upload"]
        })]
      }), (ae || se) && /* @__PURE__ */ X.jsxs(Lt, {
        isFlexColumn: !0,
        children: [ae && /* @__PURE__ */ X.jsx(x5, {
          intent: "low",
          className: st(Nv, y5),
          children: ae
        }), se && /* @__PURE__ */ X.jsx(x5, {
          intent: "low",
          className: st(Nv, y5),
          children: se
        })]
      }), !!E.length && /* @__PURE__ */ X.jsx(Lt, {
        isFlexColumn: !0,
        className: st(JF, QF, Uv),
        children: E.map((te, ne) => /* @__PURE__ */ X.jsx(QR, {
          index: ne,
          onRetry: Q,
          onDeleteFile: B,
          ...te
        }, ne))
      })]
    }), v && /* @__PURE__ */ X.jsx(Pd, {
      message: "Please add a valid file type!"
    }), x && /* @__PURE__ */ X.jsx(Pd, {
      message: J
    }), r && /* @__PURE__ */ X.jsx(Pd, {
      message: r
    })]
  });
}
const eP = "f1dttf61", tP = ({
  className: t,
  ...e
}) => /* @__PURE__ */ X.jsx(eD, {
  className: st(eP, t),
  ...e
}), xie = ({
  title: t,
  description: e,
  children: r,
  className: n
}) => /* @__PURE__ */ X.jsxs(Lt, { isFlexWrap: !0, isFlexColumn: !0, children: [
  (t || e) && /* @__PURE__ */ X.jsxs(Lt, { isFlexColumn: !0, className: tD, children: [
    t && /* @__PURE__ */ X.jsx(jr, { hasBoldText: !0, children: t }),
    e && /* @__PURE__ */ X.jsx(jr, { className: st(y5), children: e })
  ] }),
  /* @__PURE__ */ X.jsx(Lt, { isFlexColumn: !0, className: st(Ja, n), isFlexWrap: !0, children: r }),
  /* @__PURE__ */ X.jsx(tP, {})
] });
function pc(t) {
  "@babel/helpers - typeof";
  return pc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, pc(t);
}
function rP(t, e) {
  if (pc(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (pc(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function M_(t) {
  var e = rP(t, "string");
  return pc(e) == "symbol" ? e : e + "";
}
function kd(t, e, r) {
  return (e = M_(e)) in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function _6(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function kt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? _6(Object(r), !0).forEach(function(n) {
      kd(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : _6(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function nP(t) {
  if (Array.isArray(t)) return t;
}
function iP(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, i, a, o, s = [], l = !0, u = !1;
    try {
      if (a = (r = r.call(t)).next, e === 0) {
        if (Object(r) !== r) return;
        l = !1;
      } else for (; !(l = (n = a.call(r)).done) && (s.push(n.value), s.length !== e); l = !0) ;
    } catch (d) {
      u = !0, i = d;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (u) throw i;
      }
    }
    return s;
  }
}
function Gv(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function U_(t, e) {
  if (t) {
    if (typeof t == "string") return Gv(t, e);
    var r = {}.toString.call(t).slice(8, -1);
    return r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set" ? Array.from(t) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Gv(t, e) : void 0;
  }
}
function aP() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nl(t, e) {
  return nP(t) || iP(t, e) || U_(t, e) || aP();
}
function oP(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t) if ({}.hasOwnProperty.call(t, n)) {
    if (e.indexOf(n) !== -1) continue;
    r[n] = t[n];
  }
  return r;
}
function ol(t, e) {
  if (t == null) return {};
  var r, n, i = oP(t, e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    for (n = 0; n < a.length; n++) r = a[n], e.indexOf(r) === -1 && {}.propertyIsEnumerable.call(t, r) && (i[r] = t[r]);
  }
  return i;
}
var sP = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function lP(t) {
  var e = t.defaultInputValue, r = e === void 0 ? "" : e, n = t.defaultMenuIsOpen, i = n === void 0 ? !1 : n, a = t.defaultValue, o = a === void 0 ? null : a, s = t.inputValue, l = t.menuIsOpen, u = t.onChange, d = t.onInputChange, h = t.onMenuClose, v = t.onMenuOpen, b = t.value, x = ol(t, sP), A = Ht(s !== void 0 ? s : r), T = nl(A, 2), k = T[0], E = T[1], C = Ht(l !== void 0 ? l : i), D = nl(C, 2), _ = D[0], I = D[1], R = Ht(b !== void 0 ? b : o), U = nl(R, 2), V = U[0], z = U[1], j = Hn(function(J, se) {
    typeof u == "function" && u(J, se), z(J);
  }, [u]), S = Hn(function(J, se) {
    var ae;
    typeof d == "function" && (ae = d(J, se)), E(ae !== void 0 ? ae : J);
  }, [d]), B = Hn(function() {
    typeof v == "function" && v(), I(!0);
  }, [v]), q = Hn(function() {
    typeof h == "function" && h(), I(!1);
  }, [h]), Y = s !== void 0 ? s : k, Z = l !== void 0 ? l : _, Q = b !== void 0 ? b : V;
  return kt(kt({}, x), {}, {
    inputValue: Y,
    menuIsOpen: Z,
    onChange: j,
    onInputChange: S,
    onMenuClose: q,
    onMenuOpen: B,
    value: Q
  });
}
function Dt() {
  return Dt = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Dt.apply(null, arguments);
}
function uP(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function A6(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, M_(n.key), n);
  }
}
function cP(t, e, r) {
  return e && A6(t.prototype, e), r && A6(t, r), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function Zv(t, e) {
  return Zv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, Zv(t, e);
}
function fP(t, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && Zv(t, e);
}
function C5(t) {
  return C5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, C5(t);
}
function z_() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (z_ = function() {
    return !!t;
  })();
}
function dP(t) {
  if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function hP(t, e) {
  if (e && (pc(e) == "object" || typeof e == "function")) return e;
  if (e !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return dP(t);
}
function pP(t) {
  var e = z_();
  return function() {
    var r, n = C5(t);
    if (e) {
      var i = C5(this).constructor;
      r = Reflect.construct(n, arguments, i);
    } else r = n.apply(this, arguments);
    return hP(this, r);
  };
}
function mP(t) {
  if (Array.isArray(t)) return Gv(t);
}
function gP(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function vP() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ab(t) {
  return mP(t) || gP(t) || U_(t) || vP();
}
var bP = !1;
function xP(t) {
  if (t.sheet)
    return t.sheet;
  for (var e = 0; e < document.styleSheets.length; e++)
    if (document.styleSheets[e].ownerNode === t)
      return document.styleSheets[e];
}
function yP(t) {
  var e = document.createElement("style");
  return e.setAttribute("data-emotion", t.key), t.nonce !== void 0 && e.setAttribute("nonce", t.nonce), e.appendChild(document.createTextNode("")), e.setAttribute("data-s", ""), e;
}
var wP = /* @__PURE__ */ function() {
  function t(r) {
    var n = this;
    this._insertTag = function(i) {
      var a;
      n.tags.length === 0 ? n.insertionPoint ? a = n.insertionPoint.nextSibling : n.prepend ? a = n.container.firstChild : a = n.before : a = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(i, a), n.tags.push(i);
    }, this.isSpeedy = r.speedy === void 0 ? !bP : r.speedy, this.tags = [], this.ctr = 0, this.nonce = r.nonce, this.key = r.key, this.container = r.container, this.prepend = r.prepend, this.insertionPoint = r.insertionPoint, this.before = null;
  }
  var e = t.prototype;
  return e.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, e.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(yP(this));
    var i = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var a = xP(i);
      try {
        a.insertRule(n, a.cssRules.length);
      } catch {
      }
    } else
      i.appendChild(document.createTextNode(n));
    this.ctr++;
  }, e.flush = function() {
    this.tags.forEach(function(n) {
      var i;
      return (i = n.parentNode) == null ? void 0 : i.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, t;
}(), Wn = "-ms-", k5 = "-moz-", F0 = "-webkit-", $_ = "comm", ob = "rule", sb = "decl", _P = "@import", V_ = "@keyframes", AP = "@layer", EP = Math.abs, wp = String.fromCharCode, SP = Object.assign;
function CP(t, e) {
  return Sn(t, 0) ^ 45 ? (((e << 2 ^ Sn(t, 0)) << 2 ^ Sn(t, 1)) << 2 ^ Sn(t, 2)) << 2 ^ Sn(t, 3) : 0;
}
function j_(t) {
  return t.trim();
}
function kP(t, e) {
  return (t = e.exec(t)) ? t[0] : t;
}
function D0(t, e, r) {
  return t.replace(e, r);
}
function Xv(t, e) {
  return t.indexOf(e);
}
function Sn(t, e) {
  return t.charCodeAt(e) | 0;
}
function Gd(t, e, r) {
  return t.slice(e, r);
}
function Uo(t) {
  return t.length;
}
function lb(t) {
  return t.length;
}
function b2(t, e) {
  return e.push(t), t;
}
function TP(t, e) {
  return t.map(e).join("");
}
var _p = 1, i1 = 1, W_ = 0, Ti = 0, Vr = 0, b1 = "";
function Ap(t, e, r, n, i, a, o) {
  return { value: t, root: e, parent: r, type: n, props: i, children: a, line: _p, column: i1, length: o, return: "" };
}
function xd(t, e) {
  return SP(Ap("", null, null, "", null, null, 0), t, { length: -t.length }, e);
}
function FP() {
  return Vr;
}
function DP() {
  return Vr = Ti > 0 ? Sn(b1, --Ti) : 0, i1--, Vr === 10 && (i1 = 1, _p--), Vr;
}
function Ki() {
  return Vr = Ti < W_ ? Sn(b1, Ti++) : 0, i1++, Vr === 10 && (i1 = 1, _p++), Vr;
}
function rs() {
  return Sn(b1, Ti);
}
function Z2() {
  return Ti;
}
function wh(t, e) {
  return Gd(b1, t, e);
}
function Zd(t) {
  switch (t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function H_(t) {
  return _p = i1 = 1, W_ = Uo(b1 = t), Ti = 0, [];
}
function q_(t) {
  return b1 = "", t;
}
function X2(t) {
  return j_(wh(Ti - 1, Kv(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function OP(t) {
  for (; (Vr = rs()) && Vr < 33; )
    Ki();
  return Zd(t) > 2 || Zd(Vr) > 3 ? "" : " ";
}
function RP(t, e) {
  for (; --e && Ki() && !(Vr < 48 || Vr > 102 || Vr > 57 && Vr < 65 || Vr > 70 && Vr < 97); )
    ;
  return wh(t, Z2() + (e < 6 && rs() == 32 && Ki() == 32));
}
function Kv(t) {
  for (; Ki(); )
    switch (Vr) {
      case t:
        return Ti;
      case 34:
      case 39:
        t !== 34 && t !== 39 && Kv(Vr);
        break;
      case 40:
        t === 41 && Kv(t);
        break;
      case 92:
        Ki();
        break;
    }
  return Ti;
}
function PP(t, e) {
  for (; Ki() && t + Vr !== 57; )
    if (t + Vr === 84 && rs() === 47)
      break;
  return "/*" + wh(e, Ti - 1) + "*" + wp(t === 47 ? t : Ki());
}
function IP(t) {
  for (; !Zd(rs()); )
    Ki();
  return wh(t, Ti);
}
function BP(t) {
  return q_(K2("", null, null, null, [""], t = H_(t), 0, [0], t));
}
function K2(t, e, r, n, i, a, o, s, l) {
  for (var u = 0, d = 0, h = o, v = 0, b = 0, x = 0, A = 1, T = 1, k = 1, E = 0, C = "", D = i, _ = a, I = n, R = C; T; )
    switch (x = E, E = Ki()) {
      case 40:
        if (x != 108 && Sn(R, h - 1) == 58) {
          Xv(R += D0(X2(E), "&", "&\f"), "&\f") != -1 && (k = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        R += X2(E);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        R += OP(x);
        break;
      case 92:
        R += RP(Z2() - 1, 7);
        continue;
      case 47:
        switch (rs()) {
          case 42:
          case 47:
            b2(LP(PP(Ki(), Z2()), e, r), l);
            break;
          default:
            R += "/";
        }
        break;
      case 123 * A:
        s[u++] = Uo(R) * k;
      case 125 * A:
      case 59:
      case 0:
        switch (E) {
          case 0:
          case 125:
            T = 0;
          case 59 + d:
            k == -1 && (R = D0(R, /\f/g, "")), b > 0 && Uo(R) - h && b2(b > 32 ? S6(R + ";", n, r, h - 1) : S6(D0(R, " ", "") + ";", n, r, h - 2), l);
            break;
          case 59:
            R += ";";
          default:
            if (b2(I = E6(R, e, r, u, d, i, s, C, D = [], _ = [], h), a), E === 123)
              if (d === 0)
                K2(R, e, I, I, D, a, h, s, _);
              else
                switch (v === 99 && Sn(R, 3) === 110 ? 100 : v) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    K2(t, I, I, n && b2(E6(t, I, I, 0, 0, i, s, C, i, D = [], h), _), i, _, h, s, n ? D : _);
                    break;
                  default:
                    K2(R, I, I, I, [""], _, 0, s, _);
                }
        }
        u = d = b = 0, A = k = 1, C = R = "", h = o;
        break;
      case 58:
        h = 1 + Uo(R), b = x;
      default:
        if (A < 1) {
          if (E == 123)
            --A;
          else if (E == 125 && A++ == 0 && DP() == 125)
            continue;
        }
        switch (R += wp(E), E * A) {
          case 38:
            k = d > 0 ? 1 : (R += "\f", -1);
            break;
          case 44:
            s[u++] = (Uo(R) - 1) * k, k = 1;
            break;
          case 64:
            rs() === 45 && (R += X2(Ki())), v = rs(), d = h = Uo(C = R += IP(Z2())), E++;
            break;
          case 45:
            x === 45 && Uo(R) == 2 && (A = 0);
        }
    }
  return a;
}
function E6(t, e, r, n, i, a, o, s, l, u, d) {
  for (var h = i - 1, v = i === 0 ? a : [""], b = lb(v), x = 0, A = 0, T = 0; x < n; ++x)
    for (var k = 0, E = Gd(t, h + 1, h = EP(A = o[x])), C = t; k < b; ++k)
      (C = j_(A > 0 ? v[k] + " " + E : D0(E, /&\f/g, v[k]))) && (l[T++] = C);
  return Ap(t, e, r, i === 0 ? ob : s, l, u, d);
}
function LP(t, e, r) {
  return Ap(t, e, r, $_, wp(FP()), Gd(t, 2, -2), 0);
}
function S6(t, e, r, n) {
  return Ap(t, e, r, sb, Gd(t, 0, n), Gd(t, n + 1, -1), n);
}
function Yf(t, e) {
  for (var r = "", n = lb(t), i = 0; i < n; i++)
    r += e(t[i], i, t, e) || "";
  return r;
}
function NP(t, e, r, n) {
  switch (t.type) {
    case AP:
      if (t.children.length) break;
    case _P:
    case sb:
      return t.return = t.return || t.value;
    case $_:
      return "";
    case V_:
      return t.return = t.value + "{" + Yf(t.children, n) + "}";
    case ob:
      t.value = t.props.join(",");
  }
  return Uo(r = Yf(t.children, n)) ? t.return = t.value + "{" + r + "}" : "";
}
function MP(t) {
  var e = lb(t);
  return function(r, n, i, a) {
    for (var o = "", s = 0; s < e; s++)
      o += t[s](r, n, i, a) || "";
    return o;
  };
}
function UP(t) {
  return function(e) {
    e.root || (e = e.return) && t(e);
  };
}
var zP = function(e, r, n) {
  for (var i = 0, a = 0; i = a, a = rs(), i === 38 && a === 12 && (r[n] = 1), !Zd(a); )
    Ki();
  return wh(e, Ti);
}, $P = function(e, r) {
  var n = -1, i = 44;
  do
    switch (Zd(i)) {
      case 0:
        i === 38 && rs() === 12 && (r[n] = 1), e[n] += zP(Ti - 1, r, n);
        break;
      case 2:
        e[n] += X2(i);
        break;
      case 4:
        if (i === 44) {
          e[++n] = rs() === 58 ? "&\f" : "", r[n] = e[n].length;
          break;
        }
      default:
        e[n] += wp(i);
    }
  while (i = Ki());
  return e;
}, VP = function(e, r) {
  return q_($P(H_(e), r));
}, C6 = /* @__PURE__ */ new WeakMap(), jP = function(e) {
  if (!(e.type !== "rule" || !e.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  e.length < 1)) {
    for (var r = e.value, n = e.parent, i = e.column === n.column && e.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n) return;
    if (!(e.props.length === 1 && r.charCodeAt(0) !== 58 && !C6.get(n)) && !i) {
      C6.set(e, !0);
      for (var a = [], o = VP(r, a), s = n.props, l = 0, u = 0; l < o.length; l++)
        for (var d = 0; d < s.length; d++, u++)
          e.props[u] = a[l] ? o[l].replace(/&\f/g, s[d]) : s[d] + " " + o[l];
    }
  }
}, WP = function(e) {
  if (e.type === "decl") {
    var r = e.value;
    // charcode for l
    r.charCodeAt(0) === 108 && // charcode for b
    r.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
};
function Y_(t, e) {
  switch (CP(t, e)) {
    case 5103:
      return F0 + "print-" + t + t;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return F0 + t + t;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return F0 + t + k5 + t + Wn + t + t;
    case 6828:
    case 4268:
      return F0 + t + Wn + t + t;
    case 6165:
      return F0 + t + Wn + "flex-" + t + t;
    case 5187:
      return F0 + t + D0(t, /(\w+).+(:[^]+)/, F0 + "box-$1$2" + Wn + "flex-$1$2") + t;
    case 5443:
      return F0 + t + Wn + "flex-item-" + D0(t, /flex-|-self/, "") + t;
    case 4675:
      return F0 + t + Wn + "flex-line-pack" + D0(t, /align-content|flex-|-self/, "") + t;
    case 5548:
      return F0 + t + Wn + D0(t, "shrink", "negative") + t;
    case 5292:
      return F0 + t + Wn + D0(t, "basis", "preferred-size") + t;
    case 6060:
      return F0 + "box-" + D0(t, "-grow", "") + F0 + t + Wn + D0(t, "grow", "positive") + t;
    case 4554:
      return F0 + D0(t, /([^-])(transform)/g, "$1" + F0 + "$2") + t;
    case 6187:
      return D0(D0(D0(t, /(zoom-|grab)/, F0 + "$1"), /(image-set)/, F0 + "$1"), t, "") + t;
    case 5495:
    case 3959:
      return D0(t, /(image-set\([^]*)/, F0 + "$1$`$1");
    case 4968:
      return D0(D0(t, /(.+:)(flex-)?(.*)/, F0 + "box-pack:$3" + Wn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + F0 + t + t;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return D0(t, /(.+)-inline(.+)/, F0 + "$1$2") + t;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Uo(t) - 1 - e > 6) switch (Sn(t, e + 1)) {
        case 109:
          if (Sn(t, e + 4) !== 45) break;
        case 102:
          return D0(t, /(.+:)(.+)-([^]+)/, "$1" + F0 + "$2-$3$1" + k5 + (Sn(t, e + 3) == 108 ? "$3" : "$2-$3")) + t;
        case 115:
          return ~Xv(t, "stretch") ? Y_(D0(t, "stretch", "fill-available"), e) + t : t;
      }
      break;
    case 4949:
      if (Sn(t, e + 1) !== 115) break;
    case 6444:
      switch (Sn(t, Uo(t) - 3 - (~Xv(t, "!important") && 10))) {
        case 107:
          return D0(t, ":", ":" + F0) + t;
        case 101:
          return D0(t, /(.+:)([^;!]+)(;|!.+)?/, "$1" + F0 + (Sn(t, 14) === 45 ? "inline-" : "") + "box$3$1" + F0 + "$2$3$1" + Wn + "$2box$3") + t;
      }
      break;
    case 5936:
      switch (Sn(t, e + 11)) {
        case 114:
          return F0 + t + Wn + D0(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        case 108:
          return F0 + t + Wn + D0(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        case 45:
          return F0 + t + Wn + D0(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
      return F0 + t + Wn + t + t;
  }
  return t;
}
var HP = function(e, r, n, i) {
  if (e.length > -1 && !e.return) switch (e.type) {
    case sb:
      e.return = Y_(e.value, e.length);
      break;
    case V_:
      return Yf([xd(e, {
        value: D0(e.value, "@", "@" + F0)
      })], i);
    case ob:
      if (e.length) return TP(e.props, function(a) {
        switch (kP(a, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return Yf([xd(e, {
              props: [D0(a, /:(read-\w+)/, ":" + k5 + "$1")]
            })], i);
          case "::placeholder":
            return Yf([xd(e, {
              props: [D0(a, /:(plac\w+)/, ":" + F0 + "input-$1")]
            }), xd(e, {
              props: [D0(a, /:(plac\w+)/, ":" + k5 + "$1")]
            }), xd(e, {
              props: [D0(a, /:(plac\w+)/, Wn + "input-$1")]
            })], i);
        }
        return "";
      });
  }
}, qP = [HP], YP = function(e) {
  var r = e.key;
  if (r === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(A) {
      var T = A.getAttribute("data-emotion");
      T.indexOf(" ") !== -1 && (document.head.appendChild(A), A.setAttribute("data-s", ""));
    });
  }
  var i = e.stylisPlugins || qP, a = {}, o, s = [];
  o = e.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + r + ' "]'),
    function(A) {
      for (var T = A.getAttribute("data-emotion").split(" "), k = 1; k < T.length; k++)
        a[T[k]] = !0;
      s.push(A);
    }
  );
  var l, u = [jP, WP];
  {
    var d, h = [NP, UP(function(A) {
      d.insert(A);
    })], v = MP(u.concat(i, h)), b = function(T) {
      return Yf(BP(T), v);
    };
    l = function(T, k, E, C) {
      d = E, b(T ? T + "{" + k.styles + "}" : k.styles), C && (x.inserted[k.name] = !0);
    };
  }
  var x = {
    key: r,
    sheet: new wP({
      key: r,
      container: o,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: a,
    registered: {},
    insert: l
  };
  return x.sheet.hydrate(s), x;
}, G_ = { exports: {} }, H0 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cn = typeof Symbol == "function" && Symbol.for, ub = cn ? Symbol.for("react.element") : 60103, cb = cn ? Symbol.for("react.portal") : 60106, Ep = cn ? Symbol.for("react.fragment") : 60107, Sp = cn ? Symbol.for("react.strict_mode") : 60108, Cp = cn ? Symbol.for("react.profiler") : 60114, kp = cn ? Symbol.for("react.provider") : 60109, Tp = cn ? Symbol.for("react.context") : 60110, fb = cn ? Symbol.for("react.async_mode") : 60111, Fp = cn ? Symbol.for("react.concurrent_mode") : 60111, Dp = cn ? Symbol.for("react.forward_ref") : 60112, Op = cn ? Symbol.for("react.suspense") : 60113, GP = cn ? Symbol.for("react.suspense_list") : 60120, Rp = cn ? Symbol.for("react.memo") : 60115, Pp = cn ? Symbol.for("react.lazy") : 60116, ZP = cn ? Symbol.for("react.block") : 60121, XP = cn ? Symbol.for("react.fundamental") : 60117, KP = cn ? Symbol.for("react.responder") : 60118, JP = cn ? Symbol.for("react.scope") : 60119;
function na(t) {
  if (typeof t == "object" && t !== null) {
    var e = t.$$typeof;
    switch (e) {
      case ub:
        switch (t = t.type, t) {
          case fb:
          case Fp:
          case Ep:
          case Cp:
          case Sp:
          case Op:
            return t;
          default:
            switch (t = t && t.$$typeof, t) {
              case Tp:
              case Dp:
              case Pp:
              case Rp:
              case kp:
                return t;
              default:
                return e;
            }
        }
      case cb:
        return e;
    }
  }
}
function Z_(t) {
  return na(t) === Fp;
}
H0.AsyncMode = fb;
H0.ConcurrentMode = Fp;
H0.ContextConsumer = Tp;
H0.ContextProvider = kp;
H0.Element = ub;
H0.ForwardRef = Dp;
H0.Fragment = Ep;
H0.Lazy = Pp;
H0.Memo = Rp;
H0.Portal = cb;
H0.Profiler = Cp;
H0.StrictMode = Sp;
H0.Suspense = Op;
H0.isAsyncMode = function(t) {
  return Z_(t) || na(t) === fb;
};
H0.isConcurrentMode = Z_;
H0.isContextConsumer = function(t) {
  return na(t) === Tp;
};
H0.isContextProvider = function(t) {
  return na(t) === kp;
};
H0.isElement = function(t) {
  return typeof t == "object" && t !== null && t.$$typeof === ub;
};
H0.isForwardRef = function(t) {
  return na(t) === Dp;
};
H0.isFragment = function(t) {
  return na(t) === Ep;
};
H0.isLazy = function(t) {
  return na(t) === Pp;
};
H0.isMemo = function(t) {
  return na(t) === Rp;
};
H0.isPortal = function(t) {
  return na(t) === cb;
};
H0.isProfiler = function(t) {
  return na(t) === Cp;
};
H0.isStrictMode = function(t) {
  return na(t) === Sp;
};
H0.isSuspense = function(t) {
  return na(t) === Op;
};
H0.isValidElementType = function(t) {
  return typeof t == "string" || typeof t == "function" || t === Ep || t === Fp || t === Cp || t === Sp || t === Op || t === GP || typeof t == "object" && t !== null && (t.$$typeof === Pp || t.$$typeof === Rp || t.$$typeof === kp || t.$$typeof === Tp || t.$$typeof === Dp || t.$$typeof === XP || t.$$typeof === KP || t.$$typeof === JP || t.$$typeof === ZP);
};
H0.typeOf = na;
G_.exports = H0;
var QP = G_.exports, X_ = QP, eI = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, tI = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, K_ = {};
K_[X_.ForwardRef] = eI;
K_[X_.Memo] = tI;
var rI = !0;
function nI(t, e, r) {
  var n = "";
  return r.split(" ").forEach(function(i) {
    t[i] !== void 0 ? e.push(t[i] + ";") : i && (n += i + " ");
  }), n;
}
var J_ = function(e, r, n) {
  var i = e.key + "-" + r.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  rI === !1) && e.registered[i] === void 0 && (e.registered[i] = r.styles);
}, iI = function(e, r, n) {
  J_(e, r, n);
  var i = e.key + "-" + r.name;
  if (e.inserted[r.name] === void 0) {
    var a = r;
    do
      e.insert(r === a ? "." + i : "", a, e.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function aI(t) {
  for (var e = 0, r, n = 0, i = t.length; i >= 4; ++n, i -= 4)
    r = t.charCodeAt(n) & 255 | (t.charCodeAt(++n) & 255) << 8 | (t.charCodeAt(++n) & 255) << 16 | (t.charCodeAt(++n) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, e = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      e ^= (t.charCodeAt(n + 2) & 255) << 16;
    case 2:
      e ^= (t.charCodeAt(n + 1) & 255) << 8;
    case 1:
      e ^= t.charCodeAt(n) & 255, e = /* Math.imul(h, m): */
      (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  }
  return e ^= e >>> 13, e = /* Math.imul(h, m): */
  (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16), ((e ^ e >>> 15) >>> 0).toString(36);
}
var oI = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, sI = !1, lI = /[A-Z]|^ms/g, uI = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Q_ = function(e) {
  return e.charCodeAt(1) === 45;
}, k6 = function(e) {
  return e != null && typeof e != "boolean";
}, bg = /* @__PURE__ */ h_(function(t) {
  return Q_(t) ? t : t.replace(lI, "-$&").toLowerCase();
}), T6 = function(e, r) {
  switch (e) {
    case "animation":
    case "animationName":
      if (typeof r == "string")
        return r.replace(uI, function(n, i, a) {
          return zo = {
            name: i,
            styles: a,
            next: zo
          }, i;
        });
  }
  return oI[e] !== 1 && !Q_(e) && typeof r == "number" && r !== 0 ? r + "px" : r;
}, cI = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Xd(t, e, r) {
  if (r == null)
    return "";
  var n = r;
  if (n.__emotion_styles !== void 0)
    return n;
  switch (typeof r) {
    case "boolean":
      return "";
    case "object": {
      var i = r;
      if (i.anim === 1)
        return zo = {
          name: i.name,
          styles: i.styles,
          next: zo
        }, i.name;
      var a = r;
      if (a.styles !== void 0) {
        var o = a.next;
        if (o !== void 0)
          for (; o !== void 0; )
            zo = {
              name: o.name,
              styles: o.styles,
              next: zo
            }, o = o.next;
        var s = a.styles + ";";
        return s;
      }
      return fI(t, e, r);
    }
    case "function": {
      if (t !== void 0) {
        var l = zo, u = r(t);
        return zo = l, Xd(t, e, u);
      }
      break;
    }
  }
  var d = r;
  return d;
}
function fI(t, e, r) {
  var n = "";
  if (Array.isArray(r))
    for (var i = 0; i < r.length; i++)
      n += Xd(t, e, r[i]) + ";";
  else
    for (var a in r) {
      var o = r[a];
      if (typeof o != "object") {
        var s = o;
        k6(s) && (n += bg(a) + ":" + T6(a, s) + ";");
      } else {
        if (a === "NO_COMPONENT_SELECTOR" && sI)
          throw new Error(cI);
        if (Array.isArray(o) && typeof o[0] == "string" && e == null)
          for (var l = 0; l < o.length; l++)
            k6(o[l]) && (n += bg(a) + ":" + T6(a, o[l]) + ";");
        else {
          var u = Xd(t, e, o);
          switch (a) {
            case "animation":
            case "animationName": {
              n += bg(a) + ":" + u + ";";
              break;
            }
            default:
              n += a + "{" + u + "}";
          }
        }
      }
    }
  return n;
}
var F6 = /label:\s*([^\s;{]+)\s*(;|$)/g, zo;
function eA(t, e, r) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var n = !0, i = "";
  zo = void 0;
  var a = t[0];
  if (a == null || a.raw === void 0)
    n = !1, i += Xd(r, e, a);
  else {
    var o = a;
    i += o[0];
  }
  for (var s = 1; s < t.length; s++)
    if (i += Xd(r, e, t[s]), n) {
      var l = a;
      i += l[s];
    }
  F6.lastIndex = 0;
  for (var u = "", d; (d = F6.exec(i)) !== null; )
    u += "-" + d[1];
  var h = aI(i) + u;
  return {
    name: h,
    styles: i,
    next: zo
  };
}
var dI = function(e) {
  return e();
}, hI = jt.useInsertionEffect ? jt.useInsertionEffect : !1, pI = hI || dI, mI = !1, tA = /* @__PURE__ */ jt.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ YP({
    key: "css"
  }) : null
);
tA.Provider;
var gI = function(e) {
  return /* @__PURE__ */ J9(function(r, n) {
    var i = fp(tA);
    return e(r, i, n);
  });
}, vI = /* @__PURE__ */ jt.createContext({}), db = {}.hasOwnProperty, Jv = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", bI = function(e, r) {
  var n = {};
  for (var i in r)
    db.call(r, i) && (n[i] = r[i]);
  return n[Jv] = e, n;
}, xI = function(e) {
  var r = e.cache, n = e.serialized, i = e.isStringTag;
  return J_(r, n, i), pI(function() {
    return iI(r, n, i);
  }), null;
}, yI = /* @__PURE__ */ gI(function(t, e, r) {
  var n = t.css;
  typeof n == "string" && e.registered[n] !== void 0 && (n = e.registered[n]);
  var i = t[Jv], a = [n], o = "";
  typeof t.className == "string" ? o = nI(e.registered, a, t.className) : t.className != null && (o = t.className + " ");
  var s = eA(a, void 0, jt.useContext(vI));
  o += e.key + "-" + s.name;
  var l = {};
  for (var u in t)
    db.call(t, u) && u !== "css" && u !== Jv && !mI && (l[u] = t[u]);
  return l.className = o, r && (l.ref = r), /* @__PURE__ */ jt.createElement(jt.Fragment, null, /* @__PURE__ */ jt.createElement(xI, {
    cache: e,
    serialized: s,
    isStringTag: typeof i == "string"
  }), /* @__PURE__ */ jt.createElement(i, l));
}), wI = yI, Et = function(e, r) {
  var n = arguments;
  if (r == null || !db.call(r, "css"))
    return jt.createElement.apply(void 0, n);
  var i = n.length, a = new Array(i);
  a[0] = wI, a[1] = bI(e, r);
  for (var o = 2; o < i; o++)
    a[o] = n[o];
  return jt.createElement.apply(null, a);
};
(function(t) {
  var e;
  e || (e = t.JSX || (t.JSX = {}));
})(Et || (Et = {}));
function hb() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return eA(e);
}
function _I() {
  var t = hb.apply(void 0, arguments), e = "animation-" + t.name;
  return {
    name: e,
    styles: "@keyframes " + e + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
function AI(t, e) {
  return e || (e = t.slice(0)), Object.freeze(Object.defineProperties(t, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}
const a1 = Math.min, oc = Math.max, T5 = Math.round, x2 = Math.floor, ns = (t) => ({
  x: t,
  y: t
}), EI = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, SI = {
  start: "end",
  end: "start"
};
function Qv(t, e, r) {
  return oc(t, a1(e, r));
}
function _h(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function mc(t) {
  return t.split("-")[0];
}
function Ah(t) {
  return t.split("-")[1];
}
function rA(t) {
  return t === "x" ? "y" : "x";
}
function pb(t) {
  return t === "y" ? "height" : "width";
}
function sc(t) {
  return ["top", "bottom"].includes(mc(t)) ? "y" : "x";
}
function mb(t) {
  return rA(sc(t));
}
function CI(t, e, r) {
  r === void 0 && (r = !1);
  const n = Ah(t), i = mb(t), a = pb(i);
  let o = i === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return e.reference[a] > e.floating[a] && (o = F5(o)), [o, F5(o)];
}
function kI(t) {
  const e = F5(t);
  return [e3(t), e, e3(e)];
}
function e3(t) {
  return t.replace(/start|end/g, (e) => SI[e]);
}
function TI(t, e, r) {
  const n = ["left", "right"], i = ["right", "left"], a = ["top", "bottom"], o = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return r ? e ? i : n : e ? n : i;
    case "left":
    case "right":
      return e ? a : o;
    default:
      return [];
  }
}
function FI(t, e, r, n) {
  const i = Ah(t);
  let a = TI(mc(t), r === "start", n);
  return i && (a = a.map((o) => o + "-" + i), e && (a = a.concat(a.map(e3)))), a;
}
function F5(t) {
  return t.replace(/left|right|bottom|top/g, (e) => EI[e]);
}
function DI(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function nA(t) {
  return typeof t != "number" ? DI(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function D5(t) {
  const {
    x: e,
    y: r,
    width: n,
    height: i
  } = t;
  return {
    width: n,
    height: i,
    top: r,
    left: e,
    right: e + n,
    bottom: r + i,
    x: e,
    y: r
  };
}
function D6(t, e, r) {
  let {
    reference: n,
    floating: i
  } = t;
  const a = sc(e), o = mb(e), s = pb(o), l = mc(e), u = a === "y", d = n.x + n.width / 2 - i.width / 2, h = n.y + n.height / 2 - i.height / 2, v = n[s] / 2 - i[s] / 2;
  let b;
  switch (l) {
    case "top":
      b = {
        x: d,
        y: n.y - i.height
      };
      break;
    case "bottom":
      b = {
        x: d,
        y: n.y + n.height
      };
      break;
    case "right":
      b = {
        x: n.x + n.width,
        y: h
      };
      break;
    case "left":
      b = {
        x: n.x - i.width,
        y: h
      };
      break;
    default:
      b = {
        x: n.x,
        y: n.y
      };
  }
  switch (Ah(e)) {
    case "start":
      b[o] -= v * (r && u ? -1 : 1);
      break;
    case "end":
      b[o] += v * (r && u ? -1 : 1);
      break;
  }
  return b;
}
const OI = async (t, e, r) => {
  const {
    placement: n = "bottom",
    strategy: i = "absolute",
    middleware: a = [],
    platform: o
  } = r, s = a.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(e));
  let u = await o.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: d,
    y: h
  } = D6(u, n, l), v = n, b = {}, x = 0;
  for (let A = 0; A < s.length; A++) {
    const {
      name: T,
      fn: k
    } = s[A], {
      x: E,
      y: C,
      data: D,
      reset: _
    } = await k({
      x: d,
      y: h,
      initialPlacement: n,
      placement: v,
      strategy: i,
      middlewareData: b,
      rects: u,
      platform: o,
      elements: {
        reference: t,
        floating: e
      }
    });
    d = E ?? d, h = C ?? h, b = {
      ...b,
      [T]: {
        ...b[T],
        ...D
      }
    }, _ && x <= 50 && (x++, typeof _ == "object" && (_.placement && (v = _.placement), _.rects && (u = _.rects === !0 ? await o.getElementRects({
      reference: t,
      floating: e,
      strategy: i
    }) : _.rects), {
      x: d,
      y: h
    } = D6(u, v, l)), A = -1);
  }
  return {
    x: d,
    y: h,
    placement: v,
    strategy: i,
    middlewareData: b
  };
};
async function iA(t, e) {
  var r;
  e === void 0 && (e = {});
  const {
    x: n,
    y: i,
    platform: a,
    rects: o,
    elements: s,
    strategy: l
  } = t, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: h = "floating",
    altBoundary: v = !1,
    padding: b = 0
  } = _h(e, t), x = nA(b), T = s[v ? h === "floating" ? "reference" : "floating" : h], k = D5(await a.getClippingRect({
    element: (r = await (a.isElement == null ? void 0 : a.isElement(T))) == null || r ? T : T.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: l
  })), E = h === "floating" ? {
    x: n,
    y: i,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, C = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), D = await (a.isElement == null ? void 0 : a.isElement(C)) ? await (a.getScale == null ? void 0 : a.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, _ = D5(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: E,
    offsetParent: C,
    strategy: l
  }) : E);
  return {
    top: (k.top - _.top + x.top) / D.y,
    bottom: (_.bottom - k.bottom + x.bottom) / D.y,
    left: (k.left - _.left + x.left) / D.x,
    right: (_.right - k.right + x.right) / D.x
  };
}
const RI = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: r,
      y: n,
      placement: i,
      rects: a,
      platform: o,
      elements: s,
      middlewareData: l
    } = e, {
      element: u,
      padding: d = 0
    } = _h(t, e) || {};
    if (u == null)
      return {};
    const h = nA(d), v = {
      x: r,
      y: n
    }, b = mb(i), x = pb(b), A = await o.getDimensions(u), T = b === "y", k = T ? "top" : "left", E = T ? "bottom" : "right", C = T ? "clientHeight" : "clientWidth", D = a.reference[x] + a.reference[b] - v[b] - a.floating[x], _ = v[b] - a.reference[b], I = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(u));
    let R = I ? I[C] : 0;
    (!R || !await (o.isElement == null ? void 0 : o.isElement(I))) && (R = s.floating[C] || a.floating[x]);
    const U = D / 2 - _ / 2, V = R / 2 - A[x] / 2 - 1, z = a1(h[k], V), j = a1(h[E], V), S = z, B = R - A[x] - j, q = R / 2 - A[x] / 2 + U, Y = Qv(S, q, B), Z = !l.arrow && Ah(i) != null && q !== Y && a.reference[x] / 2 - (q < S ? z : j) - A[x] / 2 < 0, Q = Z ? q < S ? q - S : q - B : 0;
    return {
      [b]: v[b] + Q,
      data: {
        [b]: Y,
        centerOffset: q - Y - Q,
        ...Z && {
          alignmentOffset: Q
        }
      },
      reset: Z
    };
  }
}), PI = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var r, n;
      const {
        placement: i,
        middlewareData: a,
        rects: o,
        initialPlacement: s,
        platform: l,
        elements: u
      } = e, {
        mainAxis: d = !0,
        crossAxis: h = !0,
        fallbackPlacements: v,
        fallbackStrategy: b = "bestFit",
        fallbackAxisSideDirection: x = "none",
        flipAlignment: A = !0,
        ...T
      } = _h(t, e);
      if ((r = a.arrow) != null && r.alignmentOffset)
        return {};
      const k = mc(i), E = sc(s), C = mc(s) === s, D = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), _ = v || (C || !A ? [F5(s)] : kI(s)), I = x !== "none";
      !v && I && _.push(...FI(s, A, x, D));
      const R = [s, ..._], U = await iA(e, T), V = [];
      let z = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (d && V.push(U[k]), h) {
        const Y = CI(i, o, D);
        V.push(U[Y[0]], U[Y[1]]);
      }
      if (z = [...z, {
        placement: i,
        overflows: V
      }], !V.every((Y) => Y <= 0)) {
        var j, S;
        const Y = (((j = a.flip) == null ? void 0 : j.index) || 0) + 1, Z = R[Y];
        if (Z) {
          var B;
          const J = h === "alignment" ? E !== sc(Z) : !1, se = ((B = z[0]) == null ? void 0 : B.overflows[0]) > 0;
          if (!J || se)
            return {
              data: {
                index: Y,
                overflows: z
              },
              reset: {
                placement: Z
              }
            };
        }
        let Q = (S = z.filter((J) => J.overflows[0] <= 0).sort((J, se) => J.overflows[1] - se.overflows[1])[0]) == null ? void 0 : S.placement;
        if (!Q)
          switch (b) {
            case "bestFit": {
              var q;
              const J = (q = z.filter((se) => {
                if (I) {
                  const ae = sc(se.placement);
                  return ae === E || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  ae === "y";
                }
                return !0;
              }).map((se) => [se.placement, se.overflows.filter((ae) => ae > 0).reduce((ae, te) => ae + te, 0)]).sort((se, ae) => se[1] - ae[1])[0]) == null ? void 0 : q[0];
              J && (Q = J);
              break;
            }
            case "initialPlacement":
              Q = s;
              break;
          }
        if (i !== Q)
          return {
            reset: {
              placement: Q
            }
          };
      }
      return {};
    }
  };
};
async function II(t, e) {
  const {
    placement: r,
    platform: n,
    elements: i
  } = t, a = await (n.isRTL == null ? void 0 : n.isRTL(i.floating)), o = mc(r), s = Ah(r), l = sc(r) === "y", u = ["left", "top"].includes(o) ? -1 : 1, d = a && l ? -1 : 1, h = _h(e, t);
  let {
    mainAxis: v,
    crossAxis: b,
    alignmentAxis: x
  } = typeof h == "number" ? {
    mainAxis: h,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: h.mainAxis || 0,
    crossAxis: h.crossAxis || 0,
    alignmentAxis: h.alignmentAxis
  };
  return s && typeof x == "number" && (b = s === "end" ? x * -1 : x), l ? {
    x: b * d,
    y: v * u
  } : {
    x: v * u,
    y: b * d
  };
}
const BI = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var r, n;
      const {
        x: i,
        y: a,
        placement: o,
        middlewareData: s
      } = e, l = await II(e, t);
      return o === ((r = s.offset) == null ? void 0 : r.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: i + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, LI = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: r,
        y: n,
        placement: i
      } = e, {
        mainAxis: a = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (T) => {
            let {
              x: k,
              y: E
            } = T;
            return {
              x: k,
              y: E
            };
          }
        },
        ...l
      } = _h(t, e), u = {
        x: r,
        y: n
      }, d = await iA(e, l), h = sc(mc(i)), v = rA(h);
      let b = u[v], x = u[h];
      if (a) {
        const T = v === "y" ? "top" : "left", k = v === "y" ? "bottom" : "right", E = b + d[T], C = b - d[k];
        b = Qv(E, b, C);
      }
      if (o) {
        const T = h === "y" ? "top" : "left", k = h === "y" ? "bottom" : "right", E = x + d[T], C = x - d[k];
        x = Qv(E, x, C);
      }
      const A = s.fn({
        ...e,
        [v]: b,
        [h]: x
      });
      return {
        ...A,
        data: {
          x: A.x - r,
          y: A.y - n,
          enabled: {
            [v]: a,
            [h]: o
          }
        }
      };
    }
  };
};
function Ip() {
  return typeof window < "u";
}
function x1(t) {
  return aA(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function Ji(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function ds(t) {
  var e;
  return (e = (aA(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function aA(t) {
  return Ip() ? t instanceof Node || t instanceof Ji(t).Node : !1;
}
function no(t) {
  return Ip() ? t instanceof Element || t instanceof Ji(t).Element : !1;
}
function as(t) {
  return Ip() ? t instanceof HTMLElement || t instanceof Ji(t).HTMLElement : !1;
}
function O6(t) {
  return !Ip() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof Ji(t).ShadowRoot;
}
function Eh(t) {
  const {
    overflow: e,
    overflowX: r,
    overflowY: n,
    display: i
  } = io(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + n + r) && !["inline", "contents"].includes(i);
}
function NI(t) {
  return ["table", "td", "th"].includes(x1(t));
}
function Bp(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function gb(t) {
  const e = vb(), r = no(t) ? io(t) : t;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((n) => r[n] ? r[n] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !e && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !e && (r.filter ? r.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
}
function MI(t) {
  let e = iu(t);
  for (; as(e) && !o1(e); ) {
    if (gb(e))
      return e;
    if (Bp(e))
      return null;
    e = iu(e);
  }
  return null;
}
function vb() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function o1(t) {
  return ["html", "body", "#document"].includes(x1(t));
}
function io(t) {
  return Ji(t).getComputedStyle(t);
}
function Lp(t) {
  return no(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function iu(t) {
  if (x1(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    O6(t) && t.host || // Fallback.
    ds(t)
  );
  return O6(e) ? e.host : e;
}
function oA(t) {
  const e = iu(t);
  return o1(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : as(e) && Eh(e) ? e : oA(e);
}
function Kd(t, e, r) {
  var n;
  e === void 0 && (e = []), r === void 0 && (r = !0);
  const i = oA(t), a = i === ((n = t.ownerDocument) == null ? void 0 : n.body), o = Ji(i);
  if (a) {
    const s = t3(o);
    return e.concat(o, o.visualViewport || [], Eh(i) ? i : [], s && r ? Kd(s) : []);
  }
  return e.concat(i, Kd(i, [], r));
}
function t3(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function sA(t) {
  const e = io(t);
  let r = parseFloat(e.width) || 0, n = parseFloat(e.height) || 0;
  const i = as(t), a = i ? t.offsetWidth : r, o = i ? t.offsetHeight : n, s = T5(r) !== a || T5(n) !== o;
  return s && (r = a, n = o), {
    width: r,
    height: n,
    $: s
  };
}
function bb(t) {
  return no(t) ? t : t.contextElement;
}
function Gf(t) {
  const e = bb(t);
  if (!as(e))
    return ns(1);
  const r = e.getBoundingClientRect(), {
    width: n,
    height: i,
    $: a
  } = sA(e);
  let o = (a ? T5(r.width) : r.width) / n, s = (a ? T5(r.height) : r.height) / i;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const UI = /* @__PURE__ */ ns(0);
function lA(t) {
  const e = Ji(t);
  return !vb() || !e.visualViewport ? UI : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function zI(t, e, r) {
  return e === void 0 && (e = !1), !r || e && r !== Ji(t) ? !1 : e;
}
function gc(t, e, r, n) {
  e === void 0 && (e = !1), r === void 0 && (r = !1);
  const i = t.getBoundingClientRect(), a = bb(t);
  let o = ns(1);
  e && (n ? no(n) && (o = Gf(n)) : o = Gf(t));
  const s = zI(a, r, n) ? lA(a) : ns(0);
  let l = (i.left + s.x) / o.x, u = (i.top + s.y) / o.y, d = i.width / o.x, h = i.height / o.y;
  if (a) {
    const v = Ji(a), b = n && no(n) ? Ji(n) : n;
    let x = v, A = t3(x);
    for (; A && n && b !== x; ) {
      const T = Gf(A), k = A.getBoundingClientRect(), E = io(A), C = k.left + (A.clientLeft + parseFloat(E.paddingLeft)) * T.x, D = k.top + (A.clientTop + parseFloat(E.paddingTop)) * T.y;
      l *= T.x, u *= T.y, d *= T.x, h *= T.y, l += C, u += D, x = Ji(A), A = t3(x);
    }
  }
  return D5({
    width: d,
    height: h,
    x: l,
    y: u
  });
}
function xb(t, e) {
  const r = Lp(t).scrollLeft;
  return e ? e.left + r : gc(ds(t)).left + r;
}
function uA(t, e, r) {
  r === void 0 && (r = !1);
  const n = t.getBoundingClientRect(), i = n.left + e.scrollLeft - (r ? 0 : (
    // RTL <body> scrollbar.
    xb(t, n)
  )), a = n.top + e.scrollTop;
  return {
    x: i,
    y: a
  };
}
function $I(t) {
  let {
    elements: e,
    rect: r,
    offsetParent: n,
    strategy: i
  } = t;
  const a = i === "fixed", o = ds(n), s = e ? Bp(e.floating) : !1;
  if (n === o || s && a)
    return r;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = ns(1);
  const d = ns(0), h = as(n);
  if ((h || !h && !a) && ((x1(n) !== "body" || Eh(o)) && (l = Lp(n)), as(n))) {
    const b = gc(n);
    u = Gf(n), d.x = b.x + n.clientLeft, d.y = b.y + n.clientTop;
  }
  const v = o && !h && !a ? uA(o, l, !0) : ns(0);
  return {
    width: r.width * u.x,
    height: r.height * u.y,
    x: r.x * u.x - l.scrollLeft * u.x + d.x + v.x,
    y: r.y * u.y - l.scrollTop * u.y + d.y + v.y
  };
}
function VI(t) {
  return Array.from(t.getClientRects());
}
function jI(t) {
  const e = ds(t), r = Lp(t), n = t.ownerDocument.body, i = oc(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), a = oc(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let o = -r.scrollLeft + xb(t);
  const s = -r.scrollTop;
  return io(n).direction === "rtl" && (o += oc(e.clientWidth, n.clientWidth) - i), {
    width: i,
    height: a,
    x: o,
    y: s
  };
}
function WI(t, e) {
  const r = Ji(t), n = ds(t), i = r.visualViewport;
  let a = n.clientWidth, o = n.clientHeight, s = 0, l = 0;
  if (i) {
    a = i.width, o = i.height;
    const u = vb();
    (!u || u && e === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: s,
    y: l
  };
}
function HI(t, e) {
  const r = gc(t, !0, e === "fixed"), n = r.top + t.clientTop, i = r.left + t.clientLeft, a = as(t) ? Gf(t) : ns(1), o = t.clientWidth * a.x, s = t.clientHeight * a.y, l = i * a.x, u = n * a.y;
  return {
    width: o,
    height: s,
    x: l,
    y: u
  };
}
function R6(t, e, r) {
  let n;
  if (e === "viewport")
    n = WI(t, r);
  else if (e === "document")
    n = jI(ds(t));
  else if (no(e))
    n = HI(e, r);
  else {
    const i = lA(t);
    n = {
      x: e.x - i.x,
      y: e.y - i.y,
      width: e.width,
      height: e.height
    };
  }
  return D5(n);
}
function cA(t, e) {
  const r = iu(t);
  return r === e || !no(r) || o1(r) ? !1 : io(r).position === "fixed" || cA(r, e);
}
function qI(t, e) {
  const r = e.get(t);
  if (r)
    return r;
  let n = Kd(t, [], !1).filter((s) => no(s) && x1(s) !== "body"), i = null;
  const a = io(t).position === "fixed";
  let o = a ? iu(t) : t;
  for (; no(o) && !o1(o); ) {
    const s = io(o), l = gb(o);
    !l && s.position === "fixed" && (i = null), (a ? !l && !i : !l && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || Eh(o) && !l && cA(t, o)) ? n = n.filter((d) => d !== o) : i = s, o = iu(o);
  }
  return e.set(t, n), n;
}
function YI(t) {
  let {
    element: e,
    boundary: r,
    rootBoundary: n,
    strategy: i
  } = t;
  const o = [...r === "clippingAncestors" ? Bp(e) ? [] : qI(e, this._c) : [].concat(r), n], s = o[0], l = o.reduce((u, d) => {
    const h = R6(e, d, i);
    return u.top = oc(h.top, u.top), u.right = a1(h.right, u.right), u.bottom = a1(h.bottom, u.bottom), u.left = oc(h.left, u.left), u;
  }, R6(e, s, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function GI(t) {
  const {
    width: e,
    height: r
  } = sA(t);
  return {
    width: e,
    height: r
  };
}
function ZI(t, e, r) {
  const n = as(e), i = ds(e), a = r === "fixed", o = gc(t, !0, a, e);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = ns(0);
  function u() {
    l.x = xb(i);
  }
  if (n || !n && !a)
    if ((x1(e) !== "body" || Eh(i)) && (s = Lp(e)), n) {
      const b = gc(e, !0, a, e);
      l.x = b.x + e.clientLeft, l.y = b.y + e.clientTop;
    } else i && u();
  a && !n && i && u();
  const d = i && !n && !a ? uA(i, s) : ns(0), h = o.left + s.scrollLeft - l.x - d.x, v = o.top + s.scrollTop - l.y - d.y;
  return {
    x: h,
    y: v,
    width: o.width,
    height: o.height
  };
}
function xg(t) {
  return io(t).position === "static";
}
function P6(t, e) {
  if (!as(t) || io(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let r = t.offsetParent;
  return ds(t) === r && (r = r.ownerDocument.body), r;
}
function fA(t, e) {
  const r = Ji(t);
  if (Bp(t))
    return r;
  if (!as(t)) {
    let i = iu(t);
    for (; i && !o1(i); ) {
      if (no(i) && !xg(i))
        return i;
      i = iu(i);
    }
    return r;
  }
  let n = P6(t, e);
  for (; n && NI(n) && xg(n); )
    n = P6(n, e);
  return n && o1(n) && xg(n) && !gb(n) ? r : n || MI(t) || r;
}
const XI = async function(t) {
  const e = this.getOffsetParent || fA, r = this.getDimensions, n = await r(t.floating);
  return {
    reference: ZI(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function KI(t) {
  return io(t).direction === "rtl";
}
const JI = {
  convertOffsetParentRelativeRectToViewportRelativeRect: $I,
  getDocumentElement: ds,
  getClippingRect: YI,
  getOffsetParent: fA,
  getElementRects: XI,
  getClientRects: VI,
  getDimensions: GI,
  getScale: Gf,
  isElement: no,
  isRTL: KI
};
function dA(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function QI(t, e) {
  let r = null, n;
  const i = ds(t);
  function a() {
    var s;
    clearTimeout(n), (s = r) == null || s.disconnect(), r = null;
  }
  function o(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const u = t.getBoundingClientRect(), {
      left: d,
      top: h,
      width: v,
      height: b
    } = u;
    if (s || e(), !v || !b)
      return;
    const x = x2(h), A = x2(i.clientWidth - (d + v)), T = x2(i.clientHeight - (h + b)), k = x2(d), C = {
      rootMargin: -x + "px " + -A + "px " + -T + "px " + -k + "px",
      threshold: oc(0, a1(1, l)) || 1
    };
    let D = !0;
    function _(I) {
      const R = I[0].intersectionRatio;
      if (R !== l) {
        if (!D)
          return o();
        R ? o(!1, R) : n = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      R === 1 && !dA(u, t.getBoundingClientRect()) && o(), D = !1;
    }
    try {
      r = new IntersectionObserver(_, {
        ...C,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(_, C);
    }
    r.observe(t);
  }
  return o(!0), a;
}
function hA(t, e, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: a = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, u = bb(t), d = i || a ? [...u ? Kd(u) : [], ...Kd(e)] : [];
  d.forEach((k) => {
    i && k.addEventListener("scroll", r, {
      passive: !0
    }), a && k.addEventListener("resize", r);
  });
  const h = u && s ? QI(u, r) : null;
  let v = -1, b = null;
  o && (b = new ResizeObserver((k) => {
    let [E] = k;
    E && E.target === u && b && (b.unobserve(e), cancelAnimationFrame(v), v = requestAnimationFrame(() => {
      var C;
      (C = b) == null || C.observe(e);
    })), r();
  }), u && !l && b.observe(u), b.observe(e));
  let x, A = l ? gc(t) : null;
  l && T();
  function T() {
    const k = gc(t);
    A && !dA(A, k) && r(), A = k, x = requestAnimationFrame(T);
  }
  return r(), () => {
    var k;
    d.forEach((E) => {
      i && E.removeEventListener("scroll", r), a && E.removeEventListener("resize", r);
    }), h?.(), (k = b) == null || k.disconnect(), b = null, l && cancelAnimationFrame(x);
  };
}
const eB = BI, tB = LI, rB = PI, nB = RI, I6 = (t, e, r) => {
  const n = /* @__PURE__ */ new Map(), i = {
    platform: JI,
    ...r
  }, a = {
    ...i.platform,
    _c: n
  };
  return OI(t, e, {
    ...i,
    platform: a
  });
};
var r3 = Q9, iB = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], O5 = function() {
};
function aB(t, e) {
  return e ? e[0] === "-" ? t + e : t + "__" + e : t;
}
function oB(t, e) {
  for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++)
    n[i - 2] = arguments[i];
  var a = [].concat(n);
  if (e && t)
    for (var o in e)
      e.hasOwnProperty(o) && e[o] && a.push("".concat(aB(t, o)));
  return a.filter(function(s) {
    return s;
  }).map(function(s) {
    return String(s).trim();
  }).join(" ");
}
var B6 = function(e) {
  return mB(e) ? e.filter(Boolean) : pc(e) === "object" && e !== null ? [e] : [];
}, pA = function(e) {
  e.className, e.clearValue, e.cx, e.getStyles, e.getClassNames, e.getValue, e.hasValue, e.isMulti, e.isRtl, e.options, e.selectOption, e.selectProps, e.setValue, e.theme;
  var r = ol(e, iB);
  return kt({}, r);
}, Sr = function(e, r, n) {
  var i = e.cx, a = e.getStyles, o = e.getClassNames, s = e.className;
  return {
    css: a(r, e),
    className: i(n ?? {}, o(r, e), s)
  };
};
function Np(t) {
  return [document.documentElement, document.body, window].indexOf(t) > -1;
}
function sB(t) {
  return Np(t) ? window.innerHeight : t.clientHeight;
}
function mA(t) {
  return Np(t) ? window.pageYOffset : t.scrollTop;
}
function R5(t, e) {
  if (Np(t)) {
    window.scrollTo(0, e);
    return;
  }
  t.scrollTop = e;
}
function lB(t) {
  var e = getComputedStyle(t), r = e.position === "absolute", n = /(auto|scroll)/;
  if (e.position === "fixed") return document.documentElement;
  for (var i = t; i = i.parentElement; )
    if (e = getComputedStyle(i), !(r && e.position === "static") && n.test(e.overflow + e.overflowY + e.overflowX))
      return i;
  return document.documentElement;
}
function uB(t, e, r, n) {
  return r * ((t = t / n - 1) * t * t + 1) + e;
}
function y2(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : O5, i = mA(t), a = e - i, o = 10, s = 0;
  function l() {
    s += o;
    var u = uB(s, i, a, r);
    R5(t, u), s < r ? window.requestAnimationFrame(l) : n(t);
  }
  l();
}
function L6(t, e) {
  var r = t.getBoundingClientRect(), n = e.getBoundingClientRect(), i = e.offsetHeight / 3;
  n.bottom + i > r.bottom ? R5(t, Math.min(e.offsetTop + e.clientHeight - t.offsetHeight + i, t.scrollHeight)) : n.top - i < r.top && R5(t, Math.max(e.offsetTop - i, 0));
}
function cB(t) {
  var e = t.getBoundingClientRect();
  return {
    bottom: e.bottom,
    height: e.height,
    left: e.left,
    right: e.right,
    top: e.top,
    width: e.width
  };
}
function N6() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function fB() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var gA = !1, dB = {
  get passive() {
    return gA = !0;
  }
}, w2 = typeof window < "u" ? window : {};
w2.addEventListener && w2.removeEventListener && (w2.addEventListener("p", O5, dB), w2.removeEventListener("p", O5, !1));
var hB = gA;
function pB(t) {
  return t != null;
}
function mB(t) {
  return Array.isArray(t);
}
function _2(t, e, r) {
  return t ? e : r;
}
var gB = function(e) {
  for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
    n[i - 1] = arguments[i];
  var a = Object.entries(e).filter(function(o) {
    var s = nl(o, 1), l = s[0];
    return !n.includes(l);
  });
  return a.reduce(function(o, s) {
    var l = nl(s, 2), u = l[0], d = l[1];
    return o[u] = d, o;
  }, {});
}, vB = ["children", "innerProps"], bB = ["children", "innerProps"];
function xB(t) {
  var e = t.maxHeight, r = t.menuEl, n = t.minHeight, i = t.placement, a = t.shouldScroll, o = t.isFixedPosition, s = t.controlHeight, l = lB(r), u = {
    placement: "bottom",
    maxHeight: e
  };
  if (!r || !r.offsetParent) return u;
  var d = l.getBoundingClientRect(), h = d.height, v = r.getBoundingClientRect(), b = v.bottom, x = v.height, A = v.top, T = r.offsetParent.getBoundingClientRect(), k = T.top, E = o ? window.innerHeight : sB(l), C = mA(l), D = parseInt(getComputedStyle(r).marginBottom, 10), _ = parseInt(getComputedStyle(r).marginTop, 10), I = k - _, R = E - A, U = I + C, V = h - C - A, z = b - E + C + D, j = C + A - _, S = 160;
  switch (i) {
    case "auto":
    case "bottom":
      if (R >= x)
        return {
          placement: "bottom",
          maxHeight: e
        };
      if (V >= x && !o)
        return a && y2(l, z, S), {
          placement: "bottom",
          maxHeight: e
        };
      if (!o && V >= n || o && R >= n) {
        a && y2(l, z, S);
        var B = o ? R - D : V - D;
        return {
          placement: "bottom",
          maxHeight: B
        };
      }
      if (i === "auto" || o) {
        var q = e, Y = o ? I : U;
        return Y >= n && (q = Math.min(Y - D - s, e)), {
          placement: "top",
          maxHeight: q
        };
      }
      if (i === "bottom")
        return a && R5(l, z), {
          placement: "bottom",
          maxHeight: e
        };
      break;
    case "top":
      if (I >= x)
        return {
          placement: "top",
          maxHeight: e
        };
      if (U >= x && !o)
        return a && y2(l, j, S), {
          placement: "top",
          maxHeight: e
        };
      if (!o && U >= n || o && I >= n) {
        var Z = e;
        return (!o && U >= n || o && I >= n) && (Z = o ? I - _ : U - _), a && y2(l, j, S), {
          placement: "top",
          maxHeight: Z
        };
      }
      return {
        placement: "bottom",
        maxHeight: e
      };
    default:
      throw new Error('Invalid placement provided "'.concat(i, '".'));
  }
  return u;
}
function yB(t) {
  var e = {
    bottom: "top",
    top: "bottom"
  };
  return t ? e[t] : "bottom";
}
var vA = function(e) {
  return e === "auto" ? "bottom" : e;
}, wB = function(e, r) {
  var n, i = e.placement, a = e.theme, o = a.borderRadius, s = a.spacing, l = a.colors;
  return kt((n = {
    label: "menu"
  }, kd(n, yB(i), "100%"), kd(n, "position", "absolute"), kd(n, "width", "100%"), kd(n, "zIndex", 1), n), r ? {} : {
    backgroundColor: l.neutral0,
    borderRadius: o,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: s.menuGutter,
    marginTop: s.menuGutter
  });
}, bA = /* @__PURE__ */ W3(null), _B = function(e) {
  var r = e.children, n = e.minMenuHeight, i = e.maxMenuHeight, a = e.menuPlacement, o = e.menuPosition, s = e.menuShouldScrollIntoView, l = e.theme, u = fp(bA) || {}, d = u.setPortalPlacement, h = gr(null), v = Ht(i), b = nl(v, 2), x = b[0], A = b[1], T = Ht(null), k = nl(T, 2), E = k[0], C = k[1], D = l.spacing.controlHeight;
  return r3(function() {
    var _ = h.current;
    if (_) {
      var I = o === "fixed", R = s && !I, U = xB({
        maxHeight: i,
        menuEl: _,
        minHeight: n,
        placement: a,
        shouldScroll: R,
        isFixedPosition: I,
        controlHeight: D
      });
      A(U.maxHeight), C(U.placement), d?.(U.placement);
    }
  }, [i, a, o, s, n, d, D]), r({
    ref: h,
    placerProps: kt(kt({}, e), {}, {
      placement: E || vA(a),
      maxHeight: x
    })
  });
}, AB = function(e) {
  var r = e.children, n = e.innerRef, i = e.innerProps;
  return Et("div", Dt({}, Sr(e, "menu", {
    menu: !0
  }), {
    ref: n
  }, i), r);
}, EB = AB, SB = function(e, r) {
  var n = e.maxHeight, i = e.theme.spacing.baseUnit;
  return kt({
    maxHeight: n,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, r ? {} : {
    paddingBottom: i,
    paddingTop: i
  });
}, CB = function(e) {
  var r = e.children, n = e.innerProps, i = e.innerRef, a = e.isMulti;
  return Et("div", Dt({}, Sr(e, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": a
  }), {
    ref: i
  }, n), r);
}, xA = function(e, r) {
  var n = e.theme, i = n.spacing.baseUnit, a = n.colors;
  return kt({
    textAlign: "center"
  }, r ? {} : {
    color: a.neutral40,
    padding: "".concat(i * 2, "px ").concat(i * 3, "px")
  });
}, kB = xA, TB = xA, FB = function(e) {
  var r = e.children, n = r === void 0 ? "No options" : r, i = e.innerProps, a = ol(e, vB);
  return Et("div", Dt({}, Sr(kt(kt({}, a), {}, {
    children: n,
    innerProps: i
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), i), n);
}, DB = function(e) {
  var r = e.children, n = r === void 0 ? "Loading..." : r, i = e.innerProps, a = ol(e, bB);
  return Et("div", Dt({}, Sr(kt(kt({}, a), {}, {
    children: n,
    innerProps: i
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), i), n);
}, OB = function(e) {
  var r = e.rect, n = e.offset, i = e.position;
  return {
    left: r.left,
    position: i,
    top: n,
    width: r.width,
    zIndex: 1
  };
}, RB = function(e) {
  var r = e.appendTo, n = e.children, i = e.controlElement, a = e.innerProps, o = e.menuPlacement, s = e.menuPosition, l = gr(null), u = gr(null), d = Ht(vA(o)), h = nl(d, 2), v = h[0], b = h[1], x = qi(function() {
    return {
      setPortalPlacement: b
    };
  }, []), A = Ht(null), T = nl(A, 2), k = T[0], E = T[1], C = Hn(function() {
    if (i) {
      var R = cB(i), U = s === "fixed" ? 0 : window.pageYOffset, V = R[v] + U;
      (V !== k?.offset || R.left !== k?.rect.left || R.width !== k?.rect.width) && E({
        offset: V,
        rect: R
      });
    }
  }, [i, s, v, k?.offset, k?.rect.left, k?.rect.width]);
  r3(function() {
    C();
  }, [C]);
  var D = Hn(function() {
    typeof u.current == "function" && (u.current(), u.current = null), i && l.current && (u.current = hA(i, l.current, C, {
      elementResize: "ResizeObserver" in window
    }));
  }, [i, C]);
  r3(function() {
    D();
  }, [D]);
  var _ = Hn(function(R) {
    l.current = R, D();
  }, [D]);
  if (!r && s !== "fixed" || !k) return null;
  var I = Et("div", Dt({
    ref: _
  }, Sr(kt(kt({}, e), {}, {
    offset: k.offset,
    position: s,
    rect: k.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), a), n);
  return Et(bA.Provider, {
    value: x
  }, r ? /* @__PURE__ */ AD(I, r) : I);
}, PB = function(e) {
  var r = e.isDisabled, n = e.isRtl;
  return {
    label: "container",
    direction: n ? "rtl" : void 0,
    pointerEvents: r ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, IB = function(e) {
  var r = e.children, n = e.innerProps, i = e.isDisabled, a = e.isRtl;
  return Et("div", Dt({}, Sr(e, "container", {
    "--is-disabled": i,
    "--is-rtl": a
  }), n), r);
}, BB = function(e, r) {
  var n = e.theme.spacing, i = e.isMulti, a = e.hasValue, o = e.selectProps.controlShouldRenderValue;
  return kt({
    alignItems: "center",
    display: i && a && o ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, r ? {} : {
    padding: "".concat(n.baseUnit / 2, "px ").concat(n.baseUnit * 2, "px")
  });
}, LB = function(e) {
  var r = e.children, n = e.innerProps, i = e.isMulti, a = e.hasValue;
  return Et("div", Dt({}, Sr(e, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": i,
    "value-container--has-value": a
  }), n), r);
}, NB = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, MB = function(e) {
  var r = e.children, n = e.innerProps;
  return Et("div", Dt({}, Sr(e, "indicatorsContainer", {
    indicators: !0
  }), n), r);
}, M6, UB = ["size"], zB = ["innerProps", "isRtl", "size"], $B = {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
}, yA = function(e) {
  var r = e.size, n = ol(e, UB);
  return Et("svg", Dt({
    height: r,
    width: r,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: $B
  }, n));
}, yb = function(e) {
  return Et(yA, Dt({
    size: 20
  }, e), Et("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, wA = function(e) {
  return Et(yA, Dt({
    size: 20
  }, e), Et("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, _A = function(e, r) {
  var n = e.isFocused, i = e.theme, a = i.spacing.baseUnit, o = i.colors;
  return kt({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, r ? {} : {
    color: n ? o.neutral60 : o.neutral20,
    padding: a * 2,
    ":hover": {
      color: n ? o.neutral80 : o.neutral40
    }
  });
}, VB = _A, jB = function(e) {
  var r = e.children, n = e.innerProps;
  return Et("div", Dt({}, Sr(e, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), n), r || Et(wA, null));
}, WB = _A, HB = function(e) {
  var r = e.children, n = e.innerProps;
  return Et("div", Dt({}, Sr(e, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), n), r || Et(yb, null));
}, qB = function(e, r) {
  var n = e.isDisabled, i = e.theme, a = i.spacing.baseUnit, o = i.colors;
  return kt({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, r ? {} : {
    backgroundColor: n ? o.neutral10 : o.neutral20,
    marginBottom: a * 2,
    marginTop: a * 2
  });
}, YB = function(e) {
  var r = e.innerProps;
  return Et("span", Dt({}, r, Sr(e, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, GB = _I(M6 || (M6 = AI([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), ZB = function(e, r) {
  var n = e.isFocused, i = e.size, a = e.theme, o = a.colors, s = a.spacing.baseUnit;
  return kt({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: i,
    lineHeight: 1,
    marginRight: i,
    textAlign: "center",
    verticalAlign: "middle"
  }, r ? {} : {
    color: n ? o.neutral60 : o.neutral20,
    padding: s * 2
  });
}, yg = function(e) {
  var r = e.delay, n = e.offset;
  return Et("span", {
    css: /* @__PURE__ */ hb({
      animation: "".concat(GB, " 1s ease-in-out ").concat(r, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: n ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, "", "")
  });
}, XB = function(e) {
  var r = e.innerProps, n = e.isRtl, i = e.size, a = i === void 0 ? 4 : i, o = ol(e, zB);
  return Et("div", Dt({}, Sr(kt(kt({}, o), {}, {
    innerProps: r,
    isRtl: n,
    size: a
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), r), Et(yg, {
    delay: 0,
    offset: n
  }), Et(yg, {
    delay: 160,
    offset: !0
  }), Et(yg, {
    delay: 320,
    offset: !n
  }));
}, KB = function(e, r) {
  var n = e.isDisabled, i = e.isFocused, a = e.theme, o = a.colors, s = a.borderRadius, l = a.spacing;
  return kt({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: l.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, r ? {} : {
    backgroundColor: n ? o.neutral5 : o.neutral0,
    borderColor: n ? o.neutral10 : i ? o.primary : o.neutral20,
    borderRadius: s,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: i ? "0 0 0 1px ".concat(o.primary) : void 0,
    "&:hover": {
      borderColor: i ? o.primary : o.neutral30
    }
  });
}, JB = function(e) {
  var r = e.children, n = e.isDisabled, i = e.isFocused, a = e.innerRef, o = e.innerProps, s = e.menuIsOpen;
  return Et("div", Dt({
    ref: a
  }, Sr(e, "control", {
    control: !0,
    "control--is-disabled": n,
    "control--is-focused": i,
    "control--menu-is-open": s
  }), o, {
    "aria-disabled": n || void 0
  }), r);
}, QB = JB, eL = ["data"], tL = function(e, r) {
  var n = e.theme.spacing;
  return r ? {} : {
    paddingBottom: n.baseUnit * 2,
    paddingTop: n.baseUnit * 2
  };
}, rL = function(e) {
  var r = e.children, n = e.cx, i = e.getStyles, a = e.getClassNames, o = e.Heading, s = e.headingProps, l = e.innerProps, u = e.label, d = e.theme, h = e.selectProps;
  return Et("div", Dt({}, Sr(e, "group", {
    group: !0
  }), l), Et(o, Dt({}, s, {
    selectProps: h,
    theme: d,
    getStyles: i,
    getClassNames: a,
    cx: n
  }), u), Et("div", null, r));
}, nL = function(e, r) {
  var n = e.theme, i = n.colors, a = n.spacing;
  return kt({
    label: "group",
    cursor: "default",
    display: "block"
  }, r ? {} : {
    color: i.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: a.baseUnit * 3,
    paddingRight: a.baseUnit * 3,
    textTransform: "uppercase"
  });
}, iL = function(e) {
  var r = pA(e);
  r.data;
  var n = ol(r, eL);
  return Et("div", Dt({}, Sr(e, "groupHeading", {
    "group-heading": !0
  }), n));
}, aL = rL, oL = ["innerRef", "isDisabled", "isHidden", "inputClassName"], sL = function(e, r) {
  var n = e.isDisabled, i = e.value, a = e.theme, o = a.spacing, s = a.colors;
  return kt(kt({
    visibility: n ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: i ? "translateZ(0)" : ""
  }, lL), r ? {} : {
    margin: o.baseUnit / 2,
    paddingBottom: o.baseUnit / 2,
    paddingTop: o.baseUnit / 2,
    color: s.neutral80
  });
}, AA = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, lL = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": kt({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, AA)
}, uL = function(e) {
  return kt({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: e ? 0 : 1,
    width: "100%"
  }, AA);
}, cL = function(e) {
  var r = e.cx, n = e.value, i = pA(e), a = i.innerRef, o = i.isDisabled, s = i.isHidden, l = i.inputClassName, u = ol(i, oL);
  return Et("div", Dt({}, Sr(e, "input", {
    "input-container": !0
  }), {
    "data-value": n || ""
  }), Et("input", Dt({
    className: r({
      input: !0
    }, l),
    ref: a,
    style: uL(s),
    disabled: o
  }, u)));
}, fL = cL, dL = function(e, r) {
  var n = e.theme, i = n.spacing, a = n.borderRadius, o = n.colors;
  return kt({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, r ? {} : {
    backgroundColor: o.neutral10,
    borderRadius: a / 2,
    margin: i.baseUnit / 2
  });
}, hL = function(e, r) {
  var n = e.theme, i = n.borderRadius, a = n.colors, o = e.cropWithEllipsis;
  return kt({
    overflow: "hidden",
    textOverflow: o || o === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, r ? {} : {
    borderRadius: i / 2,
    color: a.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, pL = function(e, r) {
  var n = e.theme, i = n.spacing, a = n.borderRadius, o = n.colors, s = e.isFocused;
  return kt({
    alignItems: "center",
    display: "flex"
  }, r ? {} : {
    borderRadius: a / 2,
    backgroundColor: s ? o.dangerLight : void 0,
    paddingLeft: i.baseUnit,
    paddingRight: i.baseUnit,
    ":hover": {
      backgroundColor: o.dangerLight,
      color: o.danger
    }
  });
}, EA = function(e) {
  var r = e.children, n = e.innerProps;
  return Et("div", n, r);
}, mL = EA, gL = EA;
function vL(t) {
  var e = t.children, r = t.innerProps;
  return Et("div", Dt({
    role: "button"
  }, r), e || Et(yb, {
    size: 14
  }));
}
var bL = function(e) {
  var r = e.children, n = e.components, i = e.data, a = e.innerProps, o = e.isDisabled, s = e.removeProps, l = e.selectProps, u = n.Container, d = n.Label, h = n.Remove;
  return Et(u, {
    data: i,
    innerProps: kt(kt({}, Sr(e, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": o
    })), a),
    selectProps: l
  }, Et(d, {
    data: i,
    innerProps: kt({}, Sr(e, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: l
  }, r), Et(h, {
    data: i,
    innerProps: kt(kt({}, Sr(e, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(r || "option")
    }, s),
    selectProps: l
  }));
}, xL = bL, yL = function(e, r) {
  var n = e.isDisabled, i = e.isFocused, a = e.isSelected, o = e.theme, s = o.spacing, l = o.colors;
  return kt({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, r ? {} : {
    backgroundColor: a ? l.primary : i ? l.primary25 : "transparent",
    color: n ? l.neutral20 : a ? l.neutral0 : "inherit",
    padding: "".concat(s.baseUnit * 2, "px ").concat(s.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: n ? void 0 : a ? l.primary : l.primary50
    }
  });
}, wL = function(e) {
  var r = e.children, n = e.isDisabled, i = e.isFocused, a = e.isSelected, o = e.innerRef, s = e.innerProps;
  return Et("div", Dt({}, Sr(e, "option", {
    option: !0,
    "option--is-disabled": n,
    "option--is-focused": i,
    "option--is-selected": a
  }), {
    ref: o,
    "aria-disabled": n
  }, s), r);
}, _L = wL, AL = function(e, r) {
  var n = e.theme, i = n.spacing, a = n.colors;
  return kt({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, r ? {} : {
    color: a.neutral50,
    marginLeft: i.baseUnit / 2,
    marginRight: i.baseUnit / 2
  });
}, EL = function(e) {
  var r = e.children, n = e.innerProps;
  return Et("div", Dt({}, Sr(e, "placeholder", {
    placeholder: !0
  }), n), r);
}, SL = EL, CL = function(e, r) {
  var n = e.isDisabled, i = e.theme, a = i.spacing, o = i.colors;
  return kt({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, r ? {} : {
    color: n ? o.neutral40 : o.neutral80,
    marginLeft: a.baseUnit / 2,
    marginRight: a.baseUnit / 2
  });
}, kL = function(e) {
  var r = e.children, n = e.isDisabled, i = e.innerProps;
  return Et("div", Dt({}, Sr(e, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": n
  }), i), r);
}, TL = kL, FL = {
  ClearIndicator: HB,
  Control: QB,
  DropdownIndicator: jB,
  DownChevron: wA,
  CrossIcon: yb,
  Group: aL,
  GroupHeading: iL,
  IndicatorsContainer: MB,
  IndicatorSeparator: YB,
  Input: fL,
  LoadingIndicator: XB,
  Menu: EB,
  MenuList: CB,
  MenuPortal: RB,
  LoadingMessage: DB,
  NoOptionsMessage: FB,
  MultiValue: xL,
  MultiValueContainer: mL,
  MultiValueLabel: gL,
  MultiValueRemove: vL,
  Option: _L,
  Placeholder: SL,
  SelectContainer: IB,
  SingleValue: TL,
  ValueContainer: LB
}, DL = function(e) {
  return kt(kt({}, FL), e.components);
}, U6 = Number.isNaN || function(e) {
  return typeof e == "number" && e !== e;
};
function OL(t, e) {
  return !!(t === e || U6(t) && U6(e));
}
function RL(t, e) {
  if (t.length !== e.length)
    return !1;
  for (var r = 0; r < t.length; r++)
    if (!OL(t[r], e[r]))
      return !1;
  return !0;
}
function PL(t, e) {
  e === void 0 && (e = RL);
  var r = null;
  function n() {
    for (var i = [], a = 0; a < arguments.length; a++)
      i[a] = arguments[a];
    if (r && r.lastThis === this && e(i, r.lastArgs))
      return r.lastResult;
    var o = t.apply(this, i);
    return r = {
      lastResult: o,
      lastArgs: i,
      lastThis: this
    }, o;
  }
  return n.clear = function() {
    r = null;
  }, n;
}
var IL = {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
}, BL = function(e) {
  return Et("span", Dt({
    css: IL
  }, e));
}, z6 = BL, LL = {
  guidance: function(e) {
    var r = e.isSearchable, n = e.isMulti, i = e.tabSelectsValue, a = e.context, o = e.isInitialFocus;
    switch (a) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(i ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return o ? "".concat(e["aria-label"] || "Select", " is focused ").concat(r ? ",type to refine list" : "", ", press Down to open the menu, ").concat(n ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(e) {
    var r = e.action, n = e.label, i = n === void 0 ? "" : n, a = e.labels, o = e.isDisabled;
    switch (r) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(i, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(a.length > 1 ? "s" : "", " ").concat(a.join(","), ", selected.");
      case "select-option":
        return o ? "option ".concat(i, " is disabled. Select another option.") : "option ".concat(i, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(e) {
    var r = e.context, n = e.focused, i = e.options, a = e.label, o = a === void 0 ? "" : a, s = e.selectValue, l = e.isDisabled, u = e.isSelected, d = e.isAppleDevice, h = function(A, T) {
      return A && A.length ? "".concat(A.indexOf(T) + 1, " of ").concat(A.length) : "";
    };
    if (r === "value" && s)
      return "value ".concat(o, " focused, ").concat(h(s, n), ".");
    if (r === "menu" && d) {
      var v = l ? " disabled" : "", b = "".concat(u ? " selected" : "").concat(v);
      return "".concat(o).concat(b, ", ").concat(h(i, n), ".");
    }
    return "";
  },
  onFilter: function(e) {
    var r = e.inputValue, n = e.resultsMessage;
    return "".concat(n).concat(r ? " for search term " + r : "", ".");
  }
}, NL = function(e) {
  var r = e.ariaSelection, n = e.focusedOption, i = e.focusedValue, a = e.focusableOptions, o = e.isFocused, s = e.selectValue, l = e.selectProps, u = e.id, d = e.isAppleDevice, h = l.ariaLiveMessages, v = l.getOptionLabel, b = l.inputValue, x = l.isMulti, A = l.isOptionDisabled, T = l.isSearchable, k = l.menuIsOpen, E = l.options, C = l.screenReaderStatus, D = l.tabSelectsValue, _ = l.isLoading, I = l["aria-label"], R = l["aria-live"], U = qi(function() {
    return kt(kt({}, LL), h || {});
  }, [h]), V = qi(function() {
    var Y = "";
    if (r && U.onChange) {
      var Z = r.option, Q = r.options, J = r.removedValue, se = r.removedValues, ae = r.value, te = function(fe) {
        return Array.isArray(fe) ? null : fe;
      }, ne = J || Z || te(ae), ce = ne ? v(ne) : "", pe = Q || se || void 0, Me = pe ? pe.map(v) : [], Ne = kt({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: ne && A(ne, s),
        label: ce,
        labels: Me
      }, r);
      Y = U.onChange(Ne);
    }
    return Y;
  }, [r, U, A, s, v]), z = qi(function() {
    var Y = "", Z = n || i, Q = !!(n && s && s.includes(n));
    if (Z && U.onFocus) {
      var J = {
        focused: Z,
        label: v(Z),
        isDisabled: A(Z, s),
        isSelected: Q,
        options: a,
        context: Z === n ? "menu" : "value",
        selectValue: s,
        isAppleDevice: d
      };
      Y = U.onFocus(J);
    }
    return Y;
  }, [n, i, v, A, U, a, s, d]), j = qi(function() {
    var Y = "";
    if (k && E.length && !_ && U.onFilter) {
      var Z = C({
        count: a.length
      });
      Y = U.onFilter({
        inputValue: b,
        resultsMessage: Z
      });
    }
    return Y;
  }, [a, b, k, U, E, C, _]), S = r?.action === "initial-input-focus", B = qi(function() {
    var Y = "";
    if (U.guidance) {
      var Z = i ? "value" : k ? "menu" : "input";
      Y = U.guidance({
        "aria-label": I,
        context: Z,
        isDisabled: n && A(n, s),
        isMulti: x,
        isSearchable: T,
        tabSelectsValue: D,
        isInitialFocus: S
      });
    }
    return Y;
  }, [I, n, i, x, A, T, k, U, s, D, S]), q = Et(Bv, null, Et("span", {
    id: "aria-selection"
  }, V), Et("span", {
    id: "aria-focused"
  }, z), Et("span", {
    id: "aria-results"
  }, j), Et("span", {
    id: "aria-guidance"
  }, B));
  return Et(Bv, null, Et(z6, {
    id: u
  }, S && q), Et(z6, {
    "aria-live": R,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, o && !S && q));
}, ML = NL, n3 = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], UL = new RegExp("[" + n3.map(function(t) {
  return t.letters;
}).join("") + "]", "g"), SA = {};
for (var wg = 0; wg < n3.length; wg++)
  for (var _g = n3[wg], Ag = 0; Ag < _g.letters.length; Ag++)
    SA[_g.letters[Ag]] = _g.base;
var CA = function(e) {
  return e.replace(UL, function(r) {
    return SA[r];
  });
}, zL = PL(CA), $6 = function(e) {
  return e.replace(/^\s+|\s+$/g, "");
}, $L = function(e) {
  return "".concat(e.label, " ").concat(e.value);
}, VL = function(e) {
  return function(r, n) {
    if (r.data.__isNew__) return !0;
    var i = kt({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: $L,
      trim: !0,
      matchFrom: "any"
    }, e), a = i.ignoreCase, o = i.ignoreAccents, s = i.stringify, l = i.trim, u = i.matchFrom, d = l ? $6(n) : n, h = l ? $6(s(r)) : s(r);
    return a && (d = d.toLowerCase(), h = h.toLowerCase()), o && (d = zL(d), h = CA(h)), u === "start" ? h.substr(0, d.length) === d : h.indexOf(d) > -1;
  };
}, jL = ["innerRef"];
function WL(t) {
  var e = t.innerRef, r = ol(t, jL), n = gB(r, "onExited", "in", "enter", "exit", "appear");
  return Et("input", Dt({
    ref: e
  }, n, {
    css: /* @__PURE__ */ hb({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, "", "")
  }));
}
var HL = function(e) {
  e.cancelable && e.preventDefault(), e.stopPropagation();
};
function qL(t) {
  var e = t.isEnabled, r = t.onBottomArrive, n = t.onBottomLeave, i = t.onTopArrive, a = t.onTopLeave, o = gr(!1), s = gr(!1), l = gr(0), u = gr(null), d = Hn(function(T, k) {
    if (u.current !== null) {
      var E = u.current, C = E.scrollTop, D = E.scrollHeight, _ = E.clientHeight, I = u.current, R = k > 0, U = D - _ - C, V = !1;
      U > k && o.current && (n && n(T), o.current = !1), R && s.current && (a && a(T), s.current = !1), R && k > U ? (r && !o.current && r(T), I.scrollTop = D, V = !0, o.current = !0) : !R && -k > C && (i && !s.current && i(T), I.scrollTop = 0, V = !0, s.current = !0), V && HL(T);
    }
  }, [r, n, i, a]), h = Hn(function(T) {
    d(T, T.deltaY);
  }, [d]), v = Hn(function(T) {
    l.current = T.changedTouches[0].clientY;
  }, []), b = Hn(function(T) {
    var k = l.current - T.changedTouches[0].clientY;
    d(T, k);
  }, [d]), x = Hn(function(T) {
    if (T) {
      var k = hB ? {
        passive: !1
      } : !1;
      T.addEventListener("wheel", h, k), T.addEventListener("touchstart", v, k), T.addEventListener("touchmove", b, k);
    }
  }, [b, v, h]), A = Hn(function(T) {
    T && (T.removeEventListener("wheel", h, !1), T.removeEventListener("touchstart", v, !1), T.removeEventListener("touchmove", b, !1));
  }, [b, v, h]);
  return l0(function() {
    if (e) {
      var T = u.current;
      return x(T), function() {
        A(T);
      };
    }
  }, [e, x, A]), function(T) {
    u.current = T;
  };
}
var V6 = ["boxSizing", "height", "overflow", "paddingRight", "position"], j6 = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function W6(t) {
  t.cancelable && t.preventDefault();
}
function H6(t) {
  t.stopPropagation();
}
function q6() {
  var t = this.scrollTop, e = this.scrollHeight, r = t + this.offsetHeight;
  t === 0 ? this.scrollTop = 1 : r === e && (this.scrollTop = t - 1);
}
function Y6() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var G6 = !!(typeof window < "u" && window.document && window.document.createElement), yd = 0, Ef = {
  capture: !1,
  passive: !1
};
function YL(t) {
  var e = t.isEnabled, r = t.accountForScrollbars, n = r === void 0 ? !0 : r, i = gr({}), a = gr(null), o = Hn(function(l) {
    if (G6) {
      var u = document.body, d = u && u.style;
      if (n && V6.forEach(function(x) {
        var A = d && d[x];
        i.current[x] = A;
      }), n && yd < 1) {
        var h = parseInt(i.current.paddingRight, 10) || 0, v = document.body ? document.body.clientWidth : 0, b = window.innerWidth - v + h || 0;
        Object.keys(j6).forEach(function(x) {
          var A = j6[x];
          d && (d[x] = A);
        }), d && (d.paddingRight = "".concat(b, "px"));
      }
      u && Y6() && (u.addEventListener("touchmove", W6, Ef), l && (l.addEventListener("touchstart", q6, Ef), l.addEventListener("touchmove", H6, Ef))), yd += 1;
    }
  }, [n]), s = Hn(function(l) {
    if (G6) {
      var u = document.body, d = u && u.style;
      yd = Math.max(yd - 1, 0), n && yd < 1 && V6.forEach(function(h) {
        var v = i.current[h];
        d && (d[h] = v);
      }), u && Y6() && (u.removeEventListener("touchmove", W6, Ef), l && (l.removeEventListener("touchstart", q6, Ef), l.removeEventListener("touchmove", H6, Ef)));
    }
  }, [n]);
  return l0(function() {
    if (e) {
      var l = a.current;
      return o(l), function() {
        s(l);
      };
    }
  }, [e, o, s]), function(l) {
    a.current = l;
  };
}
var GL = function(e) {
  var r = e.target;
  return r.ownerDocument.activeElement && r.ownerDocument.activeElement.blur();
}, ZL = {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function XL(t) {
  var e = t.children, r = t.lockEnabled, n = t.captureEnabled, i = n === void 0 ? !0 : n, a = t.onBottomArrive, o = t.onBottomLeave, s = t.onTopArrive, l = t.onTopLeave, u = qL({
    isEnabled: i,
    onBottomArrive: a,
    onBottomLeave: o,
    onTopArrive: s,
    onTopLeave: l
  }), d = YL({
    isEnabled: r
  }), h = function(b) {
    u(b), d(b);
  };
  return Et(Bv, null, r && Et("div", {
    onClick: GL,
    css: ZL
  }), e(h));
}
var KL = {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
}, JL = function(e) {
  var r = e.name, n = e.onFocus;
  return Et("input", {
    required: !0,
    name: r,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: n,
    css: KL,
    value: "",
    onChange: function() {
    }
  });
}, QL = JL;
function wb(t) {
  var e;
  return typeof window < "u" && window.navigator != null ? t.test(((e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.platform) || window.navigator.platform) : !1;
}
function eN() {
  return wb(/^iPhone/i);
}
function kA() {
  return wb(/^Mac/i);
}
function tN() {
  return wb(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  kA() && navigator.maxTouchPoints > 1;
}
function rN() {
  return eN() || tN();
}
function nN() {
  return kA() || rN();
}
var iN = function(e) {
  return e.label;
}, aN = function(e) {
  return e.label;
}, oN = function(e) {
  return e.value;
}, sN = function(e) {
  return !!e.isDisabled;
}, lN = {
  clearIndicator: WB,
  container: PB,
  control: KB,
  dropdownIndicator: VB,
  group: tL,
  groupHeading: nL,
  indicatorsContainer: NB,
  indicatorSeparator: qB,
  input: sL,
  loadingIndicator: ZB,
  loadingMessage: TB,
  menu: wB,
  menuList: SB,
  menuPortal: OB,
  multiValue: dL,
  multiValueLabel: hL,
  multiValueRemove: pL,
  noOptionsMessage: kB,
  option: yL,
  placeholder: AL,
  singleValue: CL,
  valueContainer: BB
}, uN = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, cN = 4, TA = 4, fN = 38, dN = TA * 2, hN = {
  baseUnit: TA,
  controlHeight: fN,
  menuGutter: dN
}, Eg = {
  borderRadius: cN,
  colors: uN,
  spacing: hN
}, pN = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: N6(),
  captureMenuScroll: !N6(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: VL(),
  formatGroupLabel: iN,
  getOptionLabel: aN,
  getOptionValue: oN,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: sN,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !fB(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(e) {
    var r = e.count;
    return "".concat(r, " result").concat(r !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function Z6(t, e, r, n) {
  var i = OA(t, e, r), a = RA(t, e, r), o = DA(t, e), s = P5(t, e);
  return {
    type: "option",
    data: e,
    isDisabled: i,
    isSelected: a,
    label: o,
    value: s,
    index: n
  };
}
function J2(t, e) {
  return t.options.map(function(r, n) {
    if ("options" in r) {
      var i = r.options.map(function(o, s) {
        return Z6(t, o, e, s);
      }).filter(function(o) {
        return K6(t, o);
      });
      return i.length > 0 ? {
        type: "group",
        data: r,
        options: i,
        index: n
      } : void 0;
    }
    var a = Z6(t, r, e, n);
    return K6(t, a) ? a : void 0;
  }).filter(pB);
}
function FA(t) {
  return t.reduce(function(e, r) {
    return r.type === "group" ? e.push.apply(e, ab(r.options.map(function(n) {
      return n.data;
    }))) : e.push(r.data), e;
  }, []);
}
function X6(t, e) {
  return t.reduce(function(r, n) {
    return n.type === "group" ? r.push.apply(r, ab(n.options.map(function(i) {
      return {
        data: i.data,
        id: "".concat(e, "-").concat(n.index, "-").concat(i.index)
      };
    }))) : r.push({
      data: n.data,
      id: "".concat(e, "-").concat(n.index)
    }), r;
  }, []);
}
function mN(t, e) {
  return FA(J2(t, e));
}
function K6(t, e) {
  var r = t.inputValue, n = r === void 0 ? "" : r, i = e.data, a = e.isSelected, o = e.label, s = e.value;
  return (!IA(t) || !a) && PA(t, {
    label: o,
    value: s,
    data: i
  }, n);
}
function gN(t, e) {
  var r = t.focusedValue, n = t.selectValue, i = n.indexOf(r);
  if (i > -1) {
    var a = e.indexOf(r);
    if (a > -1)
      return r;
    if (i < e.length)
      return e[i];
  }
  return null;
}
function vN(t, e) {
  var r = t.focusedOption;
  return r && e.indexOf(r) > -1 ? r : e[0];
}
var Sg = function(e, r) {
  var n, i = (n = e.find(function(a) {
    return a.data === r;
  })) === null || n === void 0 ? void 0 : n.id;
  return i || null;
}, DA = function(e, r) {
  return e.getOptionLabel(r);
}, P5 = function(e, r) {
  return e.getOptionValue(r);
};
function OA(t, e, r) {
  return typeof t.isOptionDisabled == "function" ? t.isOptionDisabled(e, r) : !1;
}
function RA(t, e, r) {
  if (r.indexOf(e) > -1) return !0;
  if (typeof t.isOptionSelected == "function")
    return t.isOptionSelected(e, r);
  var n = P5(t, e);
  return r.some(function(i) {
    return P5(t, i) === n;
  });
}
function PA(t, e, r) {
  return t.filterOption ? t.filterOption(e, r) : !0;
}
var IA = function(e) {
  var r = e.hideSelectedOptions, n = e.isMulti;
  return r === void 0 ? n : r;
}, bN = 1, BA = /* @__PURE__ */ function(t) {
  fP(r, t);
  var e = pP(r);
  function r(n) {
    var i;
    if (uP(this, r), i = e.call(this, n), i.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, i.blockOptionHover = !1, i.isComposing = !1, i.commonProps = void 0, i.initialTouchX = 0, i.initialTouchY = 0, i.openAfterFocus = !1, i.scrollToFocusedOptionOnUpdate = !1, i.userIsDragging = void 0, i.isAppleDevice = nN(), i.controlRef = null, i.getControlRef = function(l) {
      i.controlRef = l;
    }, i.focusedOptionRef = null, i.getFocusedOptionRef = function(l) {
      i.focusedOptionRef = l;
    }, i.menuListRef = null, i.getMenuListRef = function(l) {
      i.menuListRef = l;
    }, i.inputRef = null, i.getInputRef = function(l) {
      i.inputRef = l;
    }, i.focus = i.focusInput, i.blur = i.blurInput, i.onChange = function(l, u) {
      var d = i.props, h = d.onChange, v = d.name;
      u.name = v, i.ariaOnChange(l, u), h(l, u);
    }, i.setValue = function(l, u, d) {
      var h = i.props, v = h.closeMenuOnSelect, b = h.isMulti, x = h.inputValue;
      i.onInputChange("", {
        action: "set-value",
        prevInputValue: x
      }), v && (i.setState({
        inputIsHiddenAfterUpdate: !b
      }), i.onMenuClose()), i.setState({
        clearFocusValueOnUpdate: !0
      }), i.onChange(l, {
        action: u,
        option: d
      });
    }, i.selectOption = function(l) {
      var u = i.props, d = u.blurInputOnSelect, h = u.isMulti, v = u.name, b = i.state.selectValue, x = h && i.isOptionSelected(l, b), A = i.isOptionDisabled(l, b);
      if (x) {
        var T = i.getOptionValue(l);
        i.setValue(b.filter(function(k) {
          return i.getOptionValue(k) !== T;
        }), "deselect-option", l);
      } else if (!A)
        h ? i.setValue([].concat(ab(b), [l]), "select-option", l) : i.setValue(l, "select-option");
      else {
        i.ariaOnChange(l, {
          action: "select-option",
          option: l,
          name: v
        });
        return;
      }
      d && i.blurInput();
    }, i.removeValue = function(l) {
      var u = i.props.isMulti, d = i.state.selectValue, h = i.getOptionValue(l), v = d.filter(function(x) {
        return i.getOptionValue(x) !== h;
      }), b = _2(u, v, v[0] || null);
      i.onChange(b, {
        action: "remove-value",
        removedValue: l
      }), i.focusInput();
    }, i.clearValue = function() {
      var l = i.state.selectValue;
      i.onChange(_2(i.props.isMulti, [], null), {
        action: "clear",
        removedValues: l
      });
    }, i.popValue = function() {
      var l = i.props.isMulti, u = i.state.selectValue, d = u[u.length - 1], h = u.slice(0, u.length - 1), v = _2(l, h, h[0] || null);
      d && i.onChange(v, {
        action: "pop-value",
        removedValue: d
      });
    }, i.getFocusedOptionId = function(l) {
      return Sg(i.state.focusableOptionsWithIds, l);
    }, i.getFocusableOptionsWithIds = function() {
      return X6(J2(i.props, i.state.selectValue), i.getElementId("option"));
    }, i.getValue = function() {
      return i.state.selectValue;
    }, i.cx = function() {
      for (var l = arguments.length, u = new Array(l), d = 0; d < l; d++)
        u[d] = arguments[d];
      return oB.apply(void 0, [i.props.classNamePrefix].concat(u));
    }, i.getOptionLabel = function(l) {
      return DA(i.props, l);
    }, i.getOptionValue = function(l) {
      return P5(i.props, l);
    }, i.getStyles = function(l, u) {
      var d = i.props.unstyled, h = lN[l](u, d);
      h.boxSizing = "border-box";
      var v = i.props.styles[l];
      return v ? v(h, u) : h;
    }, i.getClassNames = function(l, u) {
      var d, h;
      return (d = (h = i.props.classNames)[l]) === null || d === void 0 ? void 0 : d.call(h, u);
    }, i.getElementId = function(l) {
      return "".concat(i.state.instancePrefix, "-").concat(l);
    }, i.getComponents = function() {
      return DL(i.props);
    }, i.buildCategorizedOptions = function() {
      return J2(i.props, i.state.selectValue);
    }, i.getCategorizedOptions = function() {
      return i.props.menuIsOpen ? i.buildCategorizedOptions() : [];
    }, i.buildFocusableOptions = function() {
      return FA(i.buildCategorizedOptions());
    }, i.getFocusableOptions = function() {
      return i.props.menuIsOpen ? i.buildFocusableOptions() : [];
    }, i.ariaOnChange = function(l, u) {
      i.setState({
        ariaSelection: kt({
          value: l
        }, u)
      });
    }, i.onMenuMouseDown = function(l) {
      l.button === 0 && (l.stopPropagation(), l.preventDefault(), i.focusInput());
    }, i.onMenuMouseMove = function(l) {
      i.blockOptionHover = !1;
    }, i.onControlMouseDown = function(l) {
      if (!l.defaultPrevented) {
        var u = i.props.openMenuOnClick;
        i.state.isFocused ? i.props.menuIsOpen ? l.target.tagName !== "INPUT" && l.target.tagName !== "TEXTAREA" && i.onMenuClose() : u && i.openMenu("first") : (u && (i.openAfterFocus = !0), i.focusInput()), l.target.tagName !== "INPUT" && l.target.tagName !== "TEXTAREA" && l.preventDefault();
      }
    }, i.onDropdownIndicatorMouseDown = function(l) {
      if (!(l && l.type === "mousedown" && l.button !== 0) && !i.props.isDisabled) {
        var u = i.props, d = u.isMulti, h = u.menuIsOpen;
        i.focusInput(), h ? (i.setState({
          inputIsHiddenAfterUpdate: !d
        }), i.onMenuClose()) : i.openMenu("first"), l.preventDefault();
      }
    }, i.onClearIndicatorMouseDown = function(l) {
      l && l.type === "mousedown" && l.button !== 0 || (i.clearValue(), l.preventDefault(), i.openAfterFocus = !1, l.type === "touchend" ? i.focusInput() : setTimeout(function() {
        return i.focusInput();
      }));
    }, i.onScroll = function(l) {
      typeof i.props.closeMenuOnScroll == "boolean" ? l.target instanceof HTMLElement && Np(l.target) && i.props.onMenuClose() : typeof i.props.closeMenuOnScroll == "function" && i.props.closeMenuOnScroll(l) && i.props.onMenuClose();
    }, i.onCompositionStart = function() {
      i.isComposing = !0;
    }, i.onCompositionEnd = function() {
      i.isComposing = !1;
    }, i.onTouchStart = function(l) {
      var u = l.touches, d = u && u.item(0);
      d && (i.initialTouchX = d.clientX, i.initialTouchY = d.clientY, i.userIsDragging = !1);
    }, i.onTouchMove = function(l) {
      var u = l.touches, d = u && u.item(0);
      if (d) {
        var h = Math.abs(d.clientX - i.initialTouchX), v = Math.abs(d.clientY - i.initialTouchY), b = 5;
        i.userIsDragging = h > b || v > b;
      }
    }, i.onTouchEnd = function(l) {
      i.userIsDragging || (i.controlRef && !i.controlRef.contains(l.target) && i.menuListRef && !i.menuListRef.contains(l.target) && i.blurInput(), i.initialTouchX = 0, i.initialTouchY = 0);
    }, i.onControlTouchEnd = function(l) {
      i.userIsDragging || i.onControlMouseDown(l);
    }, i.onClearIndicatorTouchEnd = function(l) {
      i.userIsDragging || i.onClearIndicatorMouseDown(l);
    }, i.onDropdownIndicatorTouchEnd = function(l) {
      i.userIsDragging || i.onDropdownIndicatorMouseDown(l);
    }, i.handleInputChange = function(l) {
      var u = i.props.inputValue, d = l.currentTarget.value;
      i.setState({
        inputIsHiddenAfterUpdate: !1
      }), i.onInputChange(d, {
        action: "input-change",
        prevInputValue: u
      }), i.props.menuIsOpen || i.onMenuOpen();
    }, i.onInputFocus = function(l) {
      i.props.onFocus && i.props.onFocus(l), i.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (i.openAfterFocus || i.props.openMenuOnFocus) && i.openMenu("first"), i.openAfterFocus = !1;
    }, i.onInputBlur = function(l) {
      var u = i.props.inputValue;
      if (i.menuListRef && i.menuListRef.contains(document.activeElement)) {
        i.inputRef.focus();
        return;
      }
      i.props.onBlur && i.props.onBlur(l), i.onInputChange("", {
        action: "input-blur",
        prevInputValue: u
      }), i.onMenuClose(), i.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, i.onOptionHover = function(l) {
      if (!(i.blockOptionHover || i.state.focusedOption === l)) {
        var u = i.getFocusableOptions(), d = u.indexOf(l);
        i.setState({
          focusedOption: l,
          focusedOptionId: d > -1 ? i.getFocusedOptionId(l) : null
        });
      }
    }, i.shouldHideSelectedOptions = function() {
      return IA(i.props);
    }, i.onValueInputFocus = function(l) {
      l.preventDefault(), l.stopPropagation(), i.focus();
    }, i.onKeyDown = function(l) {
      var u = i.props, d = u.isMulti, h = u.backspaceRemovesValue, v = u.escapeClearsValue, b = u.inputValue, x = u.isClearable, A = u.isDisabled, T = u.menuIsOpen, k = u.onKeyDown, E = u.tabSelectsValue, C = u.openMenuOnFocus, D = i.state, _ = D.focusedOption, I = D.focusedValue, R = D.selectValue;
      if (!A && !(typeof k == "function" && (k(l), l.defaultPrevented))) {
        switch (i.blockOptionHover = !0, l.key) {
          case "ArrowLeft":
            if (!d || b) return;
            i.focusValue("previous");
            break;
          case "ArrowRight":
            if (!d || b) return;
            i.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (b) return;
            if (I)
              i.removeValue(I);
            else {
              if (!h) return;
              d ? i.popValue() : x && i.clearValue();
            }
            break;
          case "Tab":
            if (i.isComposing || l.shiftKey || !T || !E || !_ || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            C && i.isOptionSelected(_, R))
              return;
            i.selectOption(_);
            break;
          case "Enter":
            if (l.keyCode === 229)
              break;
            if (T) {
              if (!_ || i.isComposing) return;
              i.selectOption(_);
              break;
            }
            return;
          case "Escape":
            T ? (i.setState({
              inputIsHiddenAfterUpdate: !1
            }), i.onInputChange("", {
              action: "menu-close",
              prevInputValue: b
            }), i.onMenuClose()) : x && v && i.clearValue();
            break;
          case " ":
            if (b)
              return;
            if (!T) {
              i.openMenu("first");
              break;
            }
            if (!_) return;
            i.selectOption(_);
            break;
          case "ArrowUp":
            T ? i.focusOption("up") : i.openMenu("last");
            break;
          case "ArrowDown":
            T ? i.focusOption("down") : i.openMenu("first");
            break;
          case "PageUp":
            if (!T) return;
            i.focusOption("pageup");
            break;
          case "PageDown":
            if (!T) return;
            i.focusOption("pagedown");
            break;
          case "Home":
            if (!T) return;
            i.focusOption("first");
            break;
          case "End":
            if (!T) return;
            i.focusOption("last");
            break;
          default:
            return;
        }
        l.preventDefault();
      }
    }, i.state.instancePrefix = "react-select-" + (i.props.instanceId || ++bN), i.state.selectValue = B6(n.value), n.menuIsOpen && i.state.selectValue.length) {
      var a = i.getFocusableOptionsWithIds(), o = i.buildFocusableOptions(), s = o.indexOf(i.state.selectValue[0]);
      i.state.focusableOptionsWithIds = a, i.state.focusedOption = o[s], i.state.focusedOptionId = Sg(a, o[s]);
    }
    return i;
  }
  return cP(r, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && L6(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      var a = this.props, o = a.isDisabled, s = a.menuIsOpen, l = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (l && !o && i.isDisabled || // ensure focus is on the Input when the menu opens
      l && s && !i.menuIsOpen) && this.focusInput(), l && o && !i.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !l && !o && i.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (L6(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(i, a) {
      this.props.onInputChange(i, a);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(i) {
      var a = this, o = this.state, s = o.selectValue, l = o.isFocused, u = this.buildFocusableOptions(), d = i === "first" ? 0 : u.length - 1;
      if (!this.props.isMulti) {
        var h = u.indexOf(s[0]);
        h > -1 && (d = h);
      }
      this.scrollToFocusedOptionOnUpdate = !(l && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: u[d],
        focusedOptionId: this.getFocusedOptionId(u[d])
      }, function() {
        return a.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(i) {
      var a = this.state, o = a.selectValue, s = a.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var l = o.indexOf(s);
        s || (l = -1);
        var u = o.length - 1, d = -1;
        if (o.length) {
          switch (i) {
            case "previous":
              l === 0 ? d = 0 : l === -1 ? d = u : d = l - 1;
              break;
            case "next":
              l > -1 && l < u && (d = l + 1);
              break;
          }
          this.setState({
            inputIsHidden: d !== -1,
            focusedValue: o[d]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", a = this.props.pageSize, o = this.state.focusedOption, s = this.getFocusableOptions();
      if (s.length) {
        var l = 0, u = s.indexOf(o);
        o || (u = -1), i === "up" ? l = u > 0 ? u - 1 : s.length - 1 : i === "down" ? l = (u + 1) % s.length : i === "pageup" ? (l = u - a, l < 0 && (l = 0)) : i === "pagedown" ? (l = u + a, l > s.length - 1 && (l = s.length - 1)) : i === "last" && (l = s.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: s[l],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(s[l])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(Eg) : kt(kt({}, Eg), this.props.theme) : Eg;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var i = this.clearValue, a = this.cx, o = this.getStyles, s = this.getClassNames, l = this.getValue, u = this.selectOption, d = this.setValue, h = this.props, v = h.isMulti, b = h.isRtl, x = h.options, A = this.hasValue();
      return {
        clearValue: i,
        cx: a,
        getStyles: o,
        getClassNames: s,
        getValue: l,
        hasValue: A,
        isMulti: v,
        isRtl: b,
        options: x,
        selectOption: u,
        selectProps: h,
        setValue: d,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var i = this.state.selectValue;
      return i.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var i = this.props, a = i.isClearable, o = i.isMulti;
      return a === void 0 ? o : a;
    }
  }, {
    key: "isOptionDisabled",
    value: function(i, a) {
      return OA(this.props, i, a);
    }
  }, {
    key: "isOptionSelected",
    value: function(i, a) {
      return RA(this.props, i, a);
    }
  }, {
    key: "filterOption",
    value: function(i, a) {
      return PA(this.props, i, a);
    }
  }, {
    key: "formatOptionLabel",
    value: function(i, a) {
      if (typeof this.props.formatOptionLabel == "function") {
        var o = this.props.inputValue, s = this.state.selectValue;
        return this.props.formatOptionLabel(i, {
          context: a,
          inputValue: o,
          selectValue: s
        });
      } else
        return this.getOptionLabel(i);
    }
  }, {
    key: "formatGroupLabel",
    value: function(i) {
      return this.props.formatGroupLabel(i);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var i = this.props, a = i.isDisabled, o = i.isSearchable, s = i.inputId, l = i.inputValue, u = i.tabIndex, d = i.form, h = i.menuIsOpen, v = i.required, b = this.getComponents(), x = b.Input, A = this.state, T = A.inputIsHidden, k = A.ariaSelection, E = this.commonProps, C = s || this.getElementId("input"), D = kt(kt(kt({
          "aria-autocomplete": "list",
          "aria-expanded": h,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": v,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, h && {
          "aria-controls": this.getElementId("listbox")
        }), !o && {
          "aria-readonly": !0
        }), this.hasValue() ? k?.action === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return o ? /* @__PURE__ */ jt.createElement(x, Dt({}, E, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: C,
          innerRef: this.getInputRef,
          isDisabled: a,
          isHidden: T,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: u,
          form: d,
          type: "text",
          value: l
        }, D)) : /* @__PURE__ */ jt.createElement(WL, Dt({
          id: C,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: O5,
          onFocus: this.onInputFocus,
          disabled: a,
          tabIndex: u,
          inputMode: "none",
          form: d,
          value: ""
        }, D));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var i = this, a = this.getComponents(), o = a.MultiValue, s = a.MultiValueContainer, l = a.MultiValueLabel, u = a.MultiValueRemove, d = a.SingleValue, h = a.Placeholder, v = this.commonProps, b = this.props, x = b.controlShouldRenderValue, A = b.isDisabled, T = b.isMulti, k = b.inputValue, E = b.placeholder, C = this.state, D = C.selectValue, _ = C.focusedValue, I = C.isFocused;
      if (!this.hasValue() || !x)
        return k ? null : /* @__PURE__ */ jt.createElement(h, Dt({}, v, {
          key: "placeholder",
          isDisabled: A,
          isFocused: I,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), E);
      if (T)
        return D.map(function(U, V) {
          var z = U === _, j = "".concat(i.getOptionLabel(U), "-").concat(i.getOptionValue(U));
          return /* @__PURE__ */ jt.createElement(o, Dt({}, v, {
            components: {
              Container: s,
              Label: l,
              Remove: u
            },
            isFocused: z,
            isDisabled: A,
            key: j,
            index: V,
            removeProps: {
              onClick: function() {
                return i.removeValue(U);
              },
              onTouchEnd: function() {
                return i.removeValue(U);
              },
              onMouseDown: function(B) {
                B.preventDefault();
              }
            },
            data: U
          }), i.formatOptionLabel(U, "value"));
        });
      if (k)
        return null;
      var R = D[0];
      return /* @__PURE__ */ jt.createElement(d, Dt({}, v, {
        data: R,
        isDisabled: A
      }), this.formatOptionLabel(R, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var i = this.getComponents(), a = i.ClearIndicator, o = this.commonProps, s = this.props, l = s.isDisabled, u = s.isLoading, d = this.state.isFocused;
      if (!this.isClearable() || !a || l || !this.hasValue() || u)
        return null;
      var h = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ jt.createElement(a, Dt({}, o, {
        innerProps: h,
        isFocused: d
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var i = this.getComponents(), a = i.LoadingIndicator, o = this.commonProps, s = this.props, l = s.isDisabled, u = s.isLoading, d = this.state.isFocused;
      if (!a || !u) return null;
      var h = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ jt.createElement(a, Dt({}, o, {
        innerProps: h,
        isDisabled: l,
        isFocused: d
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var i = this.getComponents(), a = i.DropdownIndicator, o = i.IndicatorSeparator;
      if (!a || !o) return null;
      var s = this.commonProps, l = this.props.isDisabled, u = this.state.isFocused;
      return /* @__PURE__ */ jt.createElement(o, Dt({}, s, {
        isDisabled: l,
        isFocused: u
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var i = this.getComponents(), a = i.DropdownIndicator;
      if (!a) return null;
      var o = this.commonProps, s = this.props.isDisabled, l = this.state.isFocused, u = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ jt.createElement(a, Dt({}, o, {
        innerProps: u,
        isDisabled: s,
        isFocused: l
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var i = this, a = this.getComponents(), o = a.Group, s = a.GroupHeading, l = a.Menu, u = a.MenuList, d = a.MenuPortal, h = a.LoadingMessage, v = a.NoOptionsMessage, b = a.Option, x = this.commonProps, A = this.state.focusedOption, T = this.props, k = T.captureMenuScroll, E = T.inputValue, C = T.isLoading, D = T.loadingMessage, _ = T.minMenuHeight, I = T.maxMenuHeight, R = T.menuIsOpen, U = T.menuPlacement, V = T.menuPosition, z = T.menuPortalTarget, j = T.menuShouldBlockScroll, S = T.menuShouldScrollIntoView, B = T.noOptionsMessage, q = T.onMenuScrollToTop, Y = T.onMenuScrollToBottom;
      if (!R) return null;
      var Z = function(ce, pe) {
        var Me = ce.type, Ne = ce.data, it = ce.isDisabled, fe = ce.isSelected, ye = ce.label, be = ce.value, he = A === Ne, Ge = it ? void 0 : function() {
          return i.onOptionHover(Ne);
        }, $e = it ? void 0 : function() {
          return i.selectOption(Ne);
        }, Ve = "".concat(i.getElementId("option"), "-").concat(pe), Ze = {
          id: Ve,
          onClick: $e,
          onMouseMove: Ge,
          onMouseOver: Ge,
          tabIndex: -1,
          role: "option",
          "aria-selected": i.isAppleDevice ? void 0 : fe
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ jt.createElement(b, Dt({}, x, {
          innerProps: Ze,
          data: Ne,
          isDisabled: it,
          isSelected: fe,
          key: Ve,
          label: ye,
          type: Me,
          value: be,
          isFocused: he,
          innerRef: he ? i.getFocusedOptionRef : void 0
        }), i.formatOptionLabel(ce.data, "menu"));
      }, Q;
      if (this.hasOptions())
        Q = this.getCategorizedOptions().map(function(ne) {
          if (ne.type === "group") {
            var ce = ne.data, pe = ne.options, Me = ne.index, Ne = "".concat(i.getElementId("group"), "-").concat(Me), it = "".concat(Ne, "-heading");
            return /* @__PURE__ */ jt.createElement(o, Dt({}, x, {
              key: Ne,
              data: ce,
              options: pe,
              Heading: s,
              headingProps: {
                id: it,
                data: ne.data
              },
              label: i.formatGroupLabel(ne.data)
            }), ne.options.map(function(fe) {
              return Z(fe, "".concat(Me, "-").concat(fe.index));
            }));
          } else if (ne.type === "option")
            return Z(ne, "".concat(ne.index));
        });
      else if (C) {
        var J = D({
          inputValue: E
        });
        if (J === null) return null;
        Q = /* @__PURE__ */ jt.createElement(h, x, J);
      } else {
        var se = B({
          inputValue: E
        });
        if (se === null) return null;
        Q = /* @__PURE__ */ jt.createElement(v, x, se);
      }
      var ae = {
        minMenuHeight: _,
        maxMenuHeight: I,
        menuPlacement: U,
        menuPosition: V,
        menuShouldScrollIntoView: S
      }, te = /* @__PURE__ */ jt.createElement(_B, Dt({}, x, ae), function(ne) {
        var ce = ne.ref, pe = ne.placerProps, Me = pe.placement, Ne = pe.maxHeight;
        return /* @__PURE__ */ jt.createElement(l, Dt({}, x, ae, {
          innerRef: ce,
          innerProps: {
            onMouseDown: i.onMenuMouseDown,
            onMouseMove: i.onMenuMouseMove
          },
          isLoading: C,
          placement: Me
        }), /* @__PURE__ */ jt.createElement(XL, {
          captureEnabled: k,
          onTopArrive: q,
          onBottomArrive: Y,
          lockEnabled: j
        }, function(it) {
          return /* @__PURE__ */ jt.createElement(u, Dt({}, x, {
            innerRef: function(ye) {
              i.getMenuListRef(ye), it(ye);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": x.isMulti,
              id: i.getElementId("listbox")
            },
            isLoading: C,
            maxHeight: Ne,
            focusedOption: A
          }), Q);
        }));
      });
      return z || V === "fixed" ? /* @__PURE__ */ jt.createElement(d, Dt({}, x, {
        appendTo: z,
        controlElement: this.controlRef,
        menuPlacement: U,
        menuPosition: V
      }), te) : te;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var i = this, a = this.props, o = a.delimiter, s = a.isDisabled, l = a.isMulti, u = a.name, d = a.required, h = this.state.selectValue;
      if (d && !this.hasValue() && !s)
        return /* @__PURE__ */ jt.createElement(QL, {
          name: u,
          onFocus: this.onValueInputFocus
        });
      if (!(!u || s))
        if (l)
          if (o) {
            var v = h.map(function(A) {
              return i.getOptionValue(A);
            }).join(o);
            return /* @__PURE__ */ jt.createElement("input", {
              name: u,
              type: "hidden",
              value: v
            });
          } else {
            var b = h.length > 0 ? h.map(function(A, T) {
              return /* @__PURE__ */ jt.createElement("input", {
                key: "i-".concat(T),
                name: u,
                type: "hidden",
                value: i.getOptionValue(A)
              });
            }) : /* @__PURE__ */ jt.createElement("input", {
              name: u,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ jt.createElement("div", null, b);
          }
        else {
          var x = h[0] ? this.getOptionValue(h[0]) : "";
          return /* @__PURE__ */ jt.createElement("input", {
            name: u,
            type: "hidden",
            value: x
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var i = this.commonProps, a = this.state, o = a.ariaSelection, s = a.focusedOption, l = a.focusedValue, u = a.isFocused, d = a.selectValue, h = this.getFocusableOptions();
      return /* @__PURE__ */ jt.createElement(ML, Dt({}, i, {
        id: this.getElementId("live-region"),
        ariaSelection: o,
        focusedOption: s,
        focusedValue: l,
        isFocused: u,
        selectValue: d,
        focusableOptions: h,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var i = this.getComponents(), a = i.Control, o = i.IndicatorsContainer, s = i.SelectContainer, l = i.ValueContainer, u = this.props, d = u.className, h = u.id, v = u.isDisabled, b = u.menuIsOpen, x = this.state.isFocused, A = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ jt.createElement(s, Dt({}, A, {
        className: d,
        innerProps: {
          id: h,
          onKeyDown: this.onKeyDown
        },
        isDisabled: v,
        isFocused: x
      }), this.renderLiveRegion(), /* @__PURE__ */ jt.createElement(a, Dt({}, A, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: v,
        isFocused: x,
        menuIsOpen: b
      }), /* @__PURE__ */ jt.createElement(l, Dt({}, A, {
        isDisabled: v
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ jt.createElement(o, Dt({}, A, {
        isDisabled: v
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(i, a) {
      var o = a.prevProps, s = a.clearFocusValueOnUpdate, l = a.inputIsHiddenAfterUpdate, u = a.ariaSelection, d = a.isFocused, h = a.prevWasFocused, v = a.instancePrefix, b = i.options, x = i.value, A = i.menuIsOpen, T = i.inputValue, k = i.isMulti, E = B6(x), C = {};
      if (o && (x !== o.value || b !== o.options || A !== o.menuIsOpen || T !== o.inputValue)) {
        var D = A ? mN(i, E) : [], _ = A ? X6(J2(i, E), "".concat(v, "-option")) : [], I = s ? gN(a, E) : null, R = vN(a, D), U = Sg(_, R);
        C = {
          selectValue: E,
          focusedOption: R,
          focusedOptionId: U,
          focusableOptionsWithIds: _,
          focusedValue: I,
          clearFocusValueOnUpdate: !1
        };
      }
      var V = l != null && i !== o ? {
        inputIsHidden: l,
        inputIsHiddenAfterUpdate: void 0
      } : {}, z = u, j = d && h;
      return d && !j && (z = {
        value: _2(k, E, E[0] || null),
        options: E,
        action: "initial-input-focus"
      }, j = !h), u?.action === "initial-input-focus" && (z = null), kt(kt(kt({}, C), V), {}, {
        prevProps: i,
        ariaSelection: z,
        prevWasFocused: j
      });
    }
  }]), r;
}(_F);
BA.defaultProps = pN;
var xN = /* @__PURE__ */ J9(function(t, e) {
  var r = lP(t);
  return /* @__PURE__ */ jt.createElement(BA, Dt({
    ref: e
  }, r));
}), yN = xN;
const wN = "idjfpfk";
function yie({
  apiPath: t,
  disabled: e,
  placeholder: r,
  getOptionValue: n,
  getOptionLabel: i,
  className: a,
  onChange: o,
  hasError: s,
  value: l,
  ...u
}) {
  const d = gr(!1), [h, v] = Ye.useState(""), b = Ye.useRef(null), [x, A] = _D({
    path: `/${t}${h ? `?search=${h}` : ""}`,
    retry: !1
  }), T = A, k = qi(() => {
    if (typeof l == "object") return l;
    if (typeof l == "string" && n)
      return x?.find((_) => n(_) === l);
  }, [x, l]), E = () => !0;
  function C(_) {
    b.current && clearTimeout(b.current);
    const I = setTimeout(() => {
      v(_);
    }, 350);
    b.current = I;
  }
  function D(_) {
    o?.(_);
  }
  return l0(() => {
    !x || d.current || !k || (o?.(k), d.current = !0);
  }, [x]), /* @__PURE__ */ X.jsx(
    yN,
    {
      isLoading: T,
      options: x ?? void 0,
      onInputChange: C,
      getOptionValue: n,
      getOptionLabel: i,
      filterOption: E,
      placeholder: r,
      onChange: D,
      className: st(wN, a || ""),
      styles: {
        control: (_) => ({
          ..._,
          borderColor: s ? "var(--intent-danger)" : _.borderColor,
          backgroundColor: s ? "var(--color-red-100)" : _.backgroundColor
        })
      },
      menuPlacement: "auto",
      value: k,
      isDisabled: e,
      ...u
    }
  );
}
const _N = /* @__PURE__ */ Rn("div")({
  name: "ButtonMargin",
  class: "bg37lzj",
  propsAsIs: !1
}), J6 = /* @__PURE__ */ Rn("div")({
  name: "LineSpacerDash",
  class: "l12veqdq",
  propsAsIs: !1
}), wie = ({
  formFieldDefaultValue: t,
  formControl: e,
  addButtonText: r = "Add",
  fieldName: n,
  title: i,
  description: a,
  isRequired: o,
  minLength: s = 0,
  RenderArrayFeld: l,
  formFieldTitle: u,
  errorMessage: d
}) => {
  const h = o && !s ? 1 : s, {
    fields: v,
    append: b,
    remove: x
  } = _O({
    name: n,
    control: e,
    rules: {
      required: o,
      minLength: h
    }
  }), A = async () => {
    b(t);
  }, T = (k) => async () => {
    x(k);
  };
  return /* @__PURE__ */ X.jsxs(Lt, {
    isFlexWrap: !0,
    isFlexColumn: !0,
    children: [(i || a) && /* @__PURE__ */ X.jsxs(Lt, {
      isFlexColumn: !0,
      className: Uv,
      children: [i && /* @__PURE__ */ X.jsx(jr, {
        hasBoldText: !0,
        children: i
      }), a && /* @__PURE__ */ X.jsx(jr, {
        className: st(y5),
        children: a
      })]
    }), /* @__PURE__ */ X.jsx(Lt, {
      className: Ja,
      isFlexWrap: !0,
      children: v?.map?.((k, E) => {
        const C = E + 1 > h, D = E === v.length - 1, _ = d && D;
        return /* @__PURE__ */ X.jsxs(Lt, {
          className: Ja,
          isFlexColumn: !0,
          children: [u && /* @__PURE__ */ X.jsxs(Lt, {
            isFlexJustifyBetween: !0,
            className: st(Ja, rD, Uv),
            children: [/* @__PURE__ */ X.jsxs(jr, {
              hasBoldText: !0,
              children: [u, " ", E + 1]
            }), C && /* @__PURE__ */ X.jsx(jr, {
              onClick: T(E),
              intent: "danger",
              className: st(ic),
              children: "Remove"
            })]
          }), /* @__PURE__ */ X.jsx(l, {
            append: b,
            fieldName: `${n}.${E}`,
            index: E,
            remove: x
          }), C && /* @__PURE__ */ X.jsx(Lt, {
            isFlexJustifyEnd: !0,
            children: /* @__PURE__ */ X.jsx(_N, {
              children: /* @__PURE__ */ X.jsx(jr, {
                onClick: T(E),
                intent: "danger",
                className: st(ic),
                children: "Remove"
              })
            })
          }), !u && !_ && /* @__PURE__ */ X.jsx(J6, {})]
        }, k.id);
      })
    }), d && /* @__PURE__ */ X.jsx(Pd, {
      message: d
    }), d && /* @__PURE__ */ X.jsx(J6, {}), /* @__PURE__ */ X.jsx(ts, {
      tag: "span",
      intent: "neutral",
      className: st(ic, "c1vzy2b7"),
      onClick: A,
      children: r
    })]
  });
}, _ie = Ye.forwardRef(({
  label: t,
  errorMessage: e,
  options: r,
  disabled: n,
  placeholder: i = "Select",
  ...a
}, o) => {
  const s = !r?.length, l = s ? !0 : !!n;
  return /* @__PURE__ */ X.jsxs(a_, {
    children: [t && /* @__PURE__ */ X.jsx(o_, {
      children: t
    }), /* @__PURE__ */ X.jsxs(nD, {
      ref: o,
      className: st(e && "c1ohr5ou"),
      disabled: l,
      ...a,
      children: [/* @__PURE__ */ X.jsx("option", {
        value: "",
        children: s ? "No options to select" : i
      }), r?.map((u) => /* @__PURE__ */ X.jsx("option", {
        value: u.value,
        children: u.title
      }, u.value))]
    }), e && /* @__PURE__ */ X.jsx(Pd, {
      message: e
    })]
  });
}), AN = "t1khpbjn", EN = "tzyf6wk", Aie = ({ tabItems: t, paramKey: e = "tab" }) => {
  const [r, n] = Ht(), [i] = ED(), a = i.get(e) || t[0].name, o = (l) => {
    n(l);
  }, s = r === void 0 ? null : t[r].component;
  return /* @__PURE__ */ X.jsxs(Lt, { isFlexColumn: !0, className: Ja, children: [
    /* @__PURE__ */ X.jsx(Lt, { tag: "div", isFlexRow: !0, isFlexWrap: !0, className: st(VD, iD), children: t.map((l, u) => {
      const d = l.name === a;
      return r === void 0 && d && n(u), /* @__PURE__ */ X.jsx(
        SD,
        {
          to: {
            search: `?${e}=${l.name}`
          },
          onClick: () => o(u),
          className: st(AN, d && EN),
          children: /* @__PURE__ */ X.jsx(ts, { intent: d ? "primary" : "default", children: l.title })
        },
        l.name
      );
    }) }),
    /* @__PURE__ */ X.jsx(uo, { children: s })
  ] });
};
function SN(t, e) {
  for (let r = 0; r < t.length; r++) {
    const n = t[r];
    if (!e(n)) return !1;
  }
  return !0;
}
const CN = Ye.memo(function({
  actions: e,
  selectedRows: r
}) {
  if (!r || r?.length === 0 || !e?.length) return;
  const n = AF(e);
  return /* @__PURE__ */ X.jsx(Lt, { className: s_, children: n.map((i, a) => {
    if (i.disabledCombinedAction) return null;
    const o = i.visibleFor ? !SN(r, i.visibleFor) : !1;
    return /* @__PURE__ */ X.jsx(
      ea,
      {
        buttonSize: "small",
        disabled: o,
        onClick: () => i.onClickMultiple?.(r),
        children: i.actionMultipleTitle ?? i.actionTitle
      },
      a
    );
  }) });
}), LA = "a1k4sg1x", kN = (t, e, r) => {
  const n = t.map((i) => i.columnWidth ?? "minmax(var(--component-table-min-column-width), 1fr)").join(" ");
  return {
    "--grid-template-column": `${e ? "3rem " : ""}${n} ${r ? "3rem" : ""} var(--component-table-expandable-trigger-width, 0)`
  };
}, TN = "c1he72vv", _b = "ts1jzjc", FN = "p4uyqds", DN = "tnq1osb", ON = Ye.memo(({
  rowActions: t,
  selectedRows: e,
  tableAction: r,
  dataCount: n,
  dataCountDisplayMessage: i,
  isLoading: a
}) => {
  const o = !!(e && e.length > 0), s = !!(t && t.length > 0), l = o && s, u = qi(() => n ? l ? `${e?.length} of ${n} selected` : `${n} ${n > 1 ? i?.plural : i?.singular}` : "", [n, e?.length, l, i?.singular, i?.plural]);
  return /* @__PURE__ */ X.jsxs(Lt, {
    isFlexAlignCenter: !0,
    isFlexJustifyBetween: !0,
    className: st(UD, "c1hl48sg"),
    children: [/* @__PURE__ */ X.jsx(jr, {
      children: !a && u
    }), /* @__PURE__ */ X.jsxs(Lt, {
      children: [l && /* @__PURE__ */ X.jsx(CN, {
        actions: t,
        selectedRows: e
      }), r && /* @__PURE__ */ X.jsx(ea, {
        intent: "default",
        className: st(zv, DN),
        onClick: r.onClick,
        children: /* @__PURE__ */ X.jsx(jr, {
          intent: "primary",
          hasMediumText: !0,
          children: r.actionTitle
        })
      })]
    })]
  });
}), RN = Ye.memo(({
  headerData: t,
  isSortable: e,
  onSortChanges: r,
  sortDirection: n = "asc"
}) => /* @__PURE__ */ X.jsx(Mv, {
  className: _b,
  children: /* @__PURE__ */ X.jsxs(Lt, {
    isFlexAlignCenter: !0,
    className: st(s_, Ja, e && ic),
    onClick: () => e && r?.(String(t.sortAs ?? t.key)),
    children: [/* @__PURE__ */ X.jsx(x5, {
      hasBoldText: !0,
      className: "c1qjjnho",
      children: t.headerTitle
    }), e && n === "asc" && /* @__PURE__ */ X.jsx(il, {
      width: "1.25rem",
      height: "1.25rem",
      icon: "sortAscend",
      className: "coqv3m9"
    }), e && n === "desc" && /* @__PURE__ */ X.jsx(il, {
      width: "1.25rem",
      height: "1.25rem",
      icon: "sortDescend",
      className: "c1p79y9"
    })]
  })
}, `${t.key}-${t.headerTitle}`)), PN = /* @__PURE__ */ Rn("label")({
  name: "ElCheckbox",
  class: "emjdyxn",
  propsAsIs: !1
}), IN = /* @__PURE__ */ Rn("input")({
  name: "ElCheckboxInput",
  class: "e16x2b1l",
  propsAsIs: !1
}), BN = () => jr, LN = /* @__PURE__ */ Rn(BN())({
  name: "ElCheckboxLabelText",
  class: "ecxiuan",
  propsAsIs: !0
}), NN = () => Y3, MN = /* @__PURE__ */ Rn(NN())({
  name: "ElCheckboxSupplementaryInfo",
  class: "e128ob17",
  propsAsIs: !0
}), UN = /* @__PURE__ */ Rn("svg")({
  name: "ElCheckboxSvgIcon",
  class: "e1dxrykb",
  propsAsIs: !1
}), zN = /* @__PURE__ */ Rn("svg")({
  name: "ElCheckboxSelectedSvgIcon",
  class: "ecka9b5",
  propsAsIs: !1
}), $N = /* @__PURE__ */ Rn("svg")({
  name: "ElCheckboxRemoveAllSvgIcon",
  class: "euwv13g",
  propsAsIs: !1
}), VN = (t) => /* @__PURE__ */ X.jsx(UN, { ...t, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ X.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M20,2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2Zm0,18H4V4H20Z"
  }
) }), jN = (t) => /* @__PURE__ */ X.jsx(zN, { ...t, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ X.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M20,2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM18,9.17l-7.07,7.07a1,1,0,0,1-.71.3,1,1,0,0,1-.7-.3L6,12.71a1,1,0,0,1,0-1.42,1,1,0,0,1,1.41,0l2.83,2.83L16.6,7.76A1,1,0,0,1,18,9.17Z"
  }
) }), WN = (t) => /* @__PURE__ */ X.jsxs($N, { ...t, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: [
  /* @__PURE__ */ X.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M20,2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2Zm0,18H4V4H20Z"
    }
  ),
  /* @__PURE__ */ X.jsx("path", { fill: "currentColor", d: "M8,13h8a1,1,0,0,0,0-2H8a1,1,0,0,0,0,2Z" })
] }), NA = Ye.forwardRef(
  ({ className: t, asRemoveAll: e, label: r, supplementaryInfo: n, required: i, ...a }, o) => /* @__PURE__ */ X.jsxs(PN, { className: t, children: [
    /* @__PURE__ */ X.jsx(IN, { type: "checkbox", ref: o, ...a, "aria-hidden": !0 }),
    /* @__PURE__ */ X.jsx(VN, { "aria-hidden": !0 }),
    !e && /* @__PURE__ */ X.jsx(jN, { "aria-hidden": !0 }),
    e && /* @__PURE__ */ X.jsx(WN, { "aria-hidden": !0 }),
    r && /* @__PURE__ */ X.jsx(LN, { children: e_(r, i) }),
    n && /* @__PURE__ */ X.jsx(MN, { hasGreyText: !0, children: n })
  ] })
), HN = Ye.memo(({
  headers: t,
  hasRowAction: e,
  isSelectable: r,
  onSortChanges: n,
  hasRowSelected: i,
  onClickSelectionHeader: a,
  sortQueryKey: o = {
    sortKey: "sortBy",
    sortValue: "sortByDirection"
  }
}) => {
  const s = new URLSearchParams(window.location.href), l = o?.sortKey ?? "", u = o?.sortValue ?? "", [d, h] = Ye.useState(t.reduce((b, x) => {
    if (!x.sortable) return b;
    const A = (x.sortAs ?? x.key).toString(), k = s.get(l) === A ? s.get(u) : x.sortValue;
    return {
      ...b,
      [A]: k === "Ascending" ? "asc" : "desc"
    };
  }, {}));
  function v(b) {
    const x = d[b] === "asc" ? "desc" : "asc", A = Object.keys(d).reduce((T, k) => k === b ? {
      ...T,
      [k]: x
    } : {
      ...T,
      [k]: "asc"
    }, {});
    h(A), n?.(b, x, A);
  }
  return /* @__PURE__ */ X.jsxs(aD, {
    "data-testid": "table-headers",
    children: [r && /* @__PURE__ */ X.jsx(Mv, {
      className: jD,
      children: /* @__PURE__ */ X.jsx(NA, {
        asRemoveAll: !0,
        checked: i,
        onChange: (b) => a?.(b.target.checked)
      })
    }), t.map((b) => /* @__PURE__ */ X.jsx(RN, {
      headerData: b,
      isSortable: b.sortable,
      onSortChanges: v,
      sortDirection: d[b?.sortAs ?? b.key]
    }, b.headerTitle)), e && /* @__PURE__ */ X.jsx(Mv, {
      className: st(f_, "cnconji")
    })]
  });
});
var MA = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function r() {
      for (var a = "", o = 0; o < arguments.length; o++) {
        var s = arguments[o];
        s && (a = i(a, n(s)));
      }
      return a;
    }
    function n(a) {
      if (typeof a == "string" || typeof a == "number")
        return a;
      if (typeof a != "object")
        return "";
      if (Array.isArray(a))
        return r.apply(null, a);
      if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
        return a.toString();
      var o = "";
      for (var s in a)
        e.call(a, s) && a[s] && (o = i(o, s));
      return o;
    }
    function i(a, o) {
      return o ? a ? a + " " + o : a + o : a;
    }
    t.exports ? (r.default = r, t.exports = r) : window.classNames = r;
  })();
})(MA);
var qN = MA.exports;
const i3 = /* @__PURE__ */ On(qN);
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const YN = "react-tooltip-core-styles", GN = "react-tooltip-base-styles", Q6 = { core: !1, base: !1 };
function ey({ css: t, id: e = GN, type: r = "base", ref: n }) {
  var i, a;
  if (!t || typeof document > "u" || Q6[r] || r === "core" && typeof process < "u" && (!((i = process == null ? void 0 : process.env) === null || i === void 0) && i.REACT_TOOLTIP_DISABLE_CORE_STYLES) || r !== "base" && typeof process < "u" && (!((a = process == null ? void 0 : process.env) === null || a === void 0) && a.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
  r === "core" && (e = YN), n || (n = {});
  const { insertAt: o } = n;
  if (document.getElementById(e)) return;
  const s = document.head || document.getElementsByTagName("head")[0], l = document.createElement("style");
  l.id = e, l.type = "text/css", o === "top" && s.firstChild ? s.insertBefore(l, s.firstChild) : s.appendChild(l), l.styleSheet ? l.styleSheet.cssText = t : l.appendChild(document.createTextNode(t)), Q6[r] = !0;
}
const ty = async ({ elementReference: t = null, tooltipReference: e = null, tooltipArrowReference: r = null, place: n = "top", offset: i = 10, strategy: a = "absolute", middlewares: o = [eB(Number(i)), rB({ fallbackAxisSideDirection: "start" }), tB({ padding: 5 })], border: s }) => {
  if (!t) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: n };
  if (e === null) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: n };
  const l = o;
  return r ? (l.push(nB({ element: r, padding: 5 })), I6(t, e, { placement: n, strategy: a, middleware: l }).then(({ x: u, y: d, placement: h, middlewareData: v }) => {
    var b, x;
    const A = { left: `${u}px`, top: `${d}px`, border: s }, { x: T, y: k } = (b = v.arrow) !== null && b !== void 0 ? b : { x: 0, y: 0 }, E = (x = { top: "bottom", right: "left", bottom: "top", left: "right" }[h.split("-")[0]]) !== null && x !== void 0 ? x : "bottom", C = s && { borderBottom: s, borderRight: s };
    let D = 0;
    if (s) {
      const _ = `${s}`.match(/(\d+)px/);
      D = _?.[1] ? Number(_[1]) : 1;
    }
    return { tooltipStyles: A, tooltipArrowStyles: { left: T != null ? `${T}px` : "", top: k != null ? `${k}px` : "", right: "", bottom: "", ...C, [E]: `-${4 + D}px` }, place: h };
  })) : I6(t, e, { placement: "bottom", strategy: a, middleware: l }).then(({ x: u, y: d, placement: h }) => ({ tooltipStyles: { left: `${u}px`, top: `${d}px` }, tooltipArrowStyles: {}, place: h }));
}, ry = (t, e) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(t, e), ny = (t, e, r) => {
  let n = null;
  const i = function(...a) {
    const o = () => {
      n = null;
    };
    !n && (t.apply(this, a), n = setTimeout(o, e));
  };
  return i.cancel = () => {
    n && (clearTimeout(n), n = null);
  }, i;
}, iy = (t) => t !== null && !Array.isArray(t) && typeof t == "object", a3 = (t, e) => {
  if (t === e) return !0;
  if (Array.isArray(t) && Array.isArray(e)) return t.length === e.length && t.every((i, a) => a3(i, e[a]));
  if (Array.isArray(t) !== Array.isArray(e)) return !1;
  if (!iy(t) || !iy(e)) return t === e;
  const r = Object.keys(t), n = Object.keys(e);
  return r.length === n.length && r.every((i) => a3(t[i], e[i]));
}, ZN = (t) => {
  if (!(t instanceof HTMLElement || t instanceof SVGElement)) return !1;
  const e = getComputedStyle(t);
  return ["overflow", "overflow-x", "overflow-y"].some((r) => {
    const n = e.getPropertyValue(r);
    return n === "auto" || n === "scroll";
  });
}, ay = (t) => {
  if (!t) return null;
  let e = t.parentElement;
  for (; e; ) {
    if (ZN(e)) return e;
    e = e.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, XN = typeof window < "u" ? Q9 : l0, ga = (t) => {
  t.current && (clearTimeout(t.current), t.current = null);
}, KN = "DEFAULT_TOOLTIP_ID", JN = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, QN = W3({ getTooltipData: () => JN });
function UA(t = KN) {
  return fp(QN).getTooltipData(t);
}
var Sf = { tooltip: "core-styles-module_tooltip__3vRRp", fixed: "core-styles-module_fixed__pcSol", arrow: "core-styles-module_arrow__cvMwQ", noArrow: "core-styles-module_noArrow__xock6", clickable: "core-styles-module_clickable__ZuTTB", show: "core-styles-module_show__Nt9eE", closing: "core-styles-module_closing__sGnxF" }, Cg = { tooltip: "styles-module_tooltip__mnnfp", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const eM = ({ forwardRef: t, id: e, className: r, classNameArrow: n, variant: i = "dark", anchorId: a, anchorSelect: o, place: s = "top", offset: l = 10, events: u = ["hover"], openOnClick: d = !1, positionStrategy: h = "absolute", middlewares: v, wrapper: b, delayShow: x = 0, delayHide: A = 0, float: T = !1, hidden: k = !1, noArrow: E = !1, clickable: C = !1, closeOnEsc: D = !1, closeOnScroll: _ = !1, closeOnResize: I = !1, openEvents: R, closeEvents: U, globalCloseEvents: V, imperativeModeOnly: z, style: j, position: S, afterShow: B, afterHide: q, disableTooltip: Y, content: Z, contentWrapperRef: Q, isOpen: J, defaultIsOpen: se = !1, setIsOpen: ae, activeAnchor: te, setActiveAnchor: ne, border: ce, opacity: pe, arrowColor: Me, role: Ne = "tooltip" }) => {
  var it;
  const fe = gr(null), ye = gr(null), be = gr(null), he = gr(null), Ge = gr(null), [$e, Ve] = Ht({ tooltipStyles: {}, tooltipArrowStyles: {}, place: s }), [Ze, wt] = Ht(!1), [et, W] = Ht(!1), [ee, le] = Ht(null), me = gr(!1), Ee = gr(null), { anchorRefs: ve, setActiveAnchor: Te } = UA(e), Pe = gr(!1), [at, Ue] = Ht([]), rt = gr(!1), gt = d || u.includes("click"), _t = gt || R?.click || R?.dblclick || R?.mousedown, Bt = R ? { ...R } : { mouseover: !0, focus: !0, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 };
  !R && gt && Object.assign(Bt, { mouseenter: !1, focus: !1, mouseover: !1, click: !0 });
  const At = U ? { ...U } : { mouseout: !0, blur: !0, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 };
  !U && gt && Object.assign(At, { mouseleave: !1, blur: !1, mouseout: !1 });
  const Tt = V ? { ...V } : { escape: D || !1, scroll: _ || !1, resize: I || !1, clickOutsideAnchor: _t || !1 };
  z && (Object.assign(Bt, { mouseover: !1, focus: !1, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 }), Object.assign(At, { mouseout: !1, blur: !1, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 }), Object.assign(Tt, { escape: !1, scroll: !1, resize: !1, clickOutsideAnchor: !1 })), XN(() => (rt.current = !0, () => {
    rt.current = !1;
  }), []);
  const Je = (qe) => {
    rt.current && (qe && W(!0), setTimeout(() => {
      rt.current && (ae?.(qe), J === void 0 && wt(qe));
    }, 10));
  };
  l0(() => {
    if (J === void 0) return () => null;
    J && W(!0);
    const qe = setTimeout(() => {
      wt(J);
    }, 10);
    return () => {
      clearTimeout(qe);
    };
  }, [J]), l0(() => {
    if (Ze !== me.current) if (ga(Ge), me.current = Ze, Ze) B?.();
    else {
      const qe = ((mt) => {
        const lt = mt.match(/^([\d.]+)(ms|s)$/);
        if (!lt) return 0;
        const [, Vt, t0] = lt;
        return Number(Vt) * (t0 === "ms" ? 1 : 1e3);
      })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
      Ge.current = setTimeout(() => {
        W(!1), le(null), q?.();
      }, qe + 25);
    }
  }, [Ze]);
  const ot = (qe) => {
    Ve((mt) => a3(mt, qe) ? mt : qe);
  }, R0 = (qe = x) => {
    ga(be), et ? Je(!0) : be.current = setTimeout(() => {
      Je(!0);
    }, qe);
  }, b0 = (qe = A) => {
    ga(he), he.current = setTimeout(() => {
      Pe.current || Je(!1);
    }, qe);
  }, ir = (qe) => {
    var mt;
    if (!qe) return;
    const lt = (mt = qe.currentTarget) !== null && mt !== void 0 ? mt : qe.target;
    if (!lt?.isConnected) return ne(null), void Te({ current: null });
    x ? R0() : Je(!0), ne(lt), Te({ current: lt }), ga(he);
  }, a0 = () => {
    C ? b0(A || 100) : A ? b0() : Je(!1), ga(be);
  }, e0 = ({ x: qe, y: mt }) => {
    var lt;
    const Vt = { getBoundingClientRect: () => ({ x: qe, y: mt, width: 0, height: 0, top: mt, left: qe, right: qe, bottom: mt }) };
    ty({ place: (lt = ee?.place) !== null && lt !== void 0 ? lt : s, offset: l, elementReference: Vt, tooltipReference: fe.current, tooltipArrowReference: ye.current, strategy: h, middlewares: v, border: ce }).then((t0) => {
      ot(t0);
    });
  }, kr = (qe) => {
    if (!qe) return;
    const mt = qe, lt = { x: mt.clientX, y: mt.clientY };
    e0(lt), Ee.current = lt;
  }, br = (qe) => {
    var mt;
    if (!Ze) return;
    const lt = qe.target;
    lt.isConnected && (!((mt = fe.current) === null || mt === void 0) && mt.contains(lt) || [document.querySelector(`[id='${a}']`), ...at].some((Vt) => Vt?.contains(lt)) || (Je(!1), ga(be)));
  }, Br = ny(ir, 50), Mt = ny(a0, 50), Rt = (qe) => {
    Mt.cancel(), Br(qe);
  }, tt = () => {
    Br.cancel(), Mt();
  }, yt = Hn(() => {
    var qe, mt;
    const lt = (qe = ee?.position) !== null && qe !== void 0 ? qe : S;
    lt ? e0(lt) : T ? Ee.current && e0(Ee.current) : te?.isConnected && ty({ place: (mt = ee?.place) !== null && mt !== void 0 ? mt : s, offset: l, elementReference: te, tooltipReference: fe.current, tooltipArrowReference: ye.current, strategy: h, middlewares: v, border: ce }).then((Vt) => {
      rt.current && ot(Vt);
    });
  }, [Ze, te, Z, j, s, ee?.place, l, h, S, ee?.position, T]);
  l0(() => {
    var qe, mt;
    const lt = new Set(ve);
    at.forEach((Ut) => {
      Y?.(Ut) || lt.add({ current: Ut });
    });
    const Vt = document.querySelector(`[id='${a}']`);
    Vt && !Y?.(Vt) && lt.add({ current: Vt });
    const t0 = () => {
      Je(!1);
    }, Q0 = ay(te), E0 = ay(fe.current);
    Tt.scroll && (window.addEventListener("scroll", t0), Q0?.addEventListener("scroll", t0), E0?.addEventListener("scroll", t0));
    let S0 = null;
    Tt.resize ? window.addEventListener("resize", t0) : te && fe.current && (S0 = hA(te, fe.current, yt, { ancestorResize: !0, elementResize: !0, layoutShift: !0 }));
    const N0 = (Ut) => {
      Ut.key === "Escape" && Je(!1);
    };
    Tt.escape && window.addEventListener("keydown", N0), Tt.clickOutsideAnchor && window.addEventListener("click", br);
    const Gt = [], M0 = (Ut) => !!(Ut?.target && te?.contains(Ut.target)), gn = (Ut) => {
      Ze && M0(Ut) || ir(Ut);
    }, Pi = (Ut) => {
      Ze && M0(Ut) && a0();
    }, xr = ["mouseover", "mouseout", "mouseenter", "mouseleave", "focus", "blur"], vn = ["click", "dblclick", "mousedown", "mouseup"];
    Object.entries(Bt).forEach(([Ut, U0]) => {
      U0 && (xr.includes(Ut) ? Gt.push({ event: Ut, listener: Rt }) : vn.includes(Ut) && Gt.push({ event: Ut, listener: gn }));
    }), Object.entries(At).forEach(([Ut, U0]) => {
      U0 && (xr.includes(Ut) ? Gt.push({ event: Ut, listener: tt }) : vn.includes(Ut) && Gt.push({ event: Ut, listener: Pi }));
    }), T && Gt.push({ event: "pointermove", listener: kr });
    const Y0 = () => {
      Pe.current = !0;
    }, h0 = () => {
      Pe.current = !1, a0();
    }, Tr = C && (At.mouseout || At.mouseleave);
    return Tr && ((qe = fe.current) === null || qe === void 0 || qe.addEventListener("mouseover", Y0), (mt = fe.current) === null || mt === void 0 || mt.addEventListener("mouseout", h0)), Gt.forEach(({ event: Ut, listener: U0 }) => {
      lt.forEach((ar) => {
        var ct;
        (ct = ar.current) === null || ct === void 0 || ct.addEventListener(Ut, U0);
      });
    }), () => {
      var Ut, U0;
      Tt.scroll && (window.removeEventListener("scroll", t0), Q0?.removeEventListener("scroll", t0), E0?.removeEventListener("scroll", t0)), Tt.resize ? window.removeEventListener("resize", t0) : S0?.(), Tt.clickOutsideAnchor && window.removeEventListener("click", br), Tt.escape && window.removeEventListener("keydown", N0), Tr && ((Ut = fe.current) === null || Ut === void 0 || Ut.removeEventListener("mouseover", Y0), (U0 = fe.current) === null || U0 === void 0 || U0.removeEventListener("mouseout", h0)), Gt.forEach(({ event: ar, listener: ct }) => {
        lt.forEach((Jr) => {
          var P0;
          (P0 = Jr.current) === null || P0 === void 0 || P0.removeEventListener(ar, ct);
        });
      });
    };
  }, [te, yt, et, ve, at, R, U, V, gt, x, A]), l0(() => {
    var qe, mt;
    let lt = (mt = (qe = ee?.anchorSelect) !== null && qe !== void 0 ? qe : o) !== null && mt !== void 0 ? mt : "";
    !lt && e && (lt = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`);
    const Vt = new MutationObserver((t0) => {
      const Q0 = [], E0 = [];
      t0.forEach((S0) => {
        if (S0.type === "attributes" && S0.attributeName === "data-tooltip-id" && (S0.target.getAttribute("data-tooltip-id") === e ? Q0.push(S0.target) : S0.oldValue === e && E0.push(S0.target)), S0.type === "childList") {
          if (te) {
            const N0 = [...S0.removedNodes].filter((Gt) => Gt.nodeType === 1);
            if (lt) try {
              E0.push(...N0.filter((Gt) => Gt.matches(lt))), E0.push(...N0.flatMap((Gt) => [...Gt.querySelectorAll(lt)]));
            } catch {
            }
            N0.some((Gt) => {
              var M0;
              return !!(!((M0 = Gt?.contains) === null || M0 === void 0) && M0.call(Gt, te)) && (W(!1), Je(!1), ne(null), ga(be), ga(he), !0);
            });
          }
          if (lt) try {
            const N0 = [...S0.addedNodes].filter((Gt) => Gt.nodeType === 1);
            Q0.push(...N0.filter((Gt) => Gt.matches(lt))), Q0.push(...N0.flatMap((Gt) => [...Gt.querySelectorAll(lt)]));
          } catch {
          }
        }
      }), (Q0.length || E0.length) && Ue((S0) => [...S0.filter((N0) => !E0.includes(N0)), ...Q0]);
    });
    return Vt.observe(document.body, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["data-tooltip-id"], attributeOldValue: !0 }), () => {
      Vt.disconnect();
    };
  }, [e, o, ee?.anchorSelect, te]), l0(() => {
    yt();
  }, [yt]), l0(() => {
    if (!Q?.current) return () => null;
    const qe = new ResizeObserver(() => {
      setTimeout(() => yt());
    });
    return qe.observe(Q.current), () => {
      qe.disconnect();
    };
  }, [Z, Q?.current]), l0(() => {
    var qe;
    const mt = document.querySelector(`[id='${a}']`), lt = [...at, mt];
    te && lt.includes(te) || ne((qe = at[0]) !== null && qe !== void 0 ? qe : mt);
  }, [a, at, te]), l0(() => (se && Je(!0), () => {
    ga(be), ga(he);
  }), []), l0(() => {
    var qe;
    let mt = (qe = ee?.anchorSelect) !== null && qe !== void 0 ? qe : o;
    if (!mt && e && (mt = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`), mt) try {
      const lt = Array.from(document.querySelectorAll(mt));
      Ue(lt);
    } catch {
      Ue([]);
    }
  }, [e, o, ee?.anchorSelect]), l0(() => {
    be.current && (ga(be), R0(x));
  }, [x]);
  const q0 = (it = ee?.content) !== null && it !== void 0 ? it : Z, L0 = Ze && Object.keys($e.tooltipStyles).length > 0;
  return EF(t, () => ({ open: (qe) => {
    if (qe?.anchorSelect) try {
      document.querySelector(qe.anchorSelect);
    } catch {
      return void console.warn(`[react-tooltip] "${qe.anchorSelect}" is not a valid CSS selector`);
    }
    le(qe ?? null), qe?.delay ? R0(qe.delay) : Je(!0);
  }, close: (qe) => {
    qe?.delay ? b0(qe.delay) : Je(!1);
  }, activeAnchor: te, place: $e.place, isOpen: !!(et && !k && q0 && L0) })), et && !k && q0 ? Ye.createElement(b, { id: e, role: Ne, className: i3("react-tooltip", Sf.tooltip, Cg.tooltip, Cg[i], r, `react-tooltip__place-${$e.place}`, Sf[L0 ? "show" : "closing"], L0 ? "react-tooltip__show" : "react-tooltip__closing", h === "fixed" && Sf.fixed, C && Sf.clickable), onTransitionEnd: (qe) => {
    ga(Ge), Ze || qe.propertyName !== "opacity" || (W(!1), le(null), q?.());
  }, style: { ...j, ...$e.tooltipStyles, opacity: pe !== void 0 && L0 ? pe : void 0 }, ref: fe }, q0, Ye.createElement(b, { className: i3("react-tooltip-arrow", Sf.arrow, Cg.arrow, n, E && Sf.noArrow), style: { ...$e.tooltipArrowStyles, background: Me ? `linear-gradient(to right bottom, transparent 50%, ${Me} 50%)` : void 0 }, ref: ye })) : null;
}, tM = ({ content: t }) => Ye.createElement("span", { dangerouslySetInnerHTML: { __html: t } }), rM = Ye.forwardRef(({ id: t, anchorId: e, anchorSelect: r, content: n, html: i, render: a, className: o, classNameArrow: s, variant: l = "dark", place: u = "top", offset: d = 10, wrapper: h = "div", children: v = null, events: b = ["hover"], openOnClick: x = !1, positionStrategy: A = "absolute", middlewares: T, delayShow: k = 0, delayHide: E = 0, float: C = !1, hidden: D = !1, noArrow: _ = !1, clickable: I = !1, closeOnEsc: R = !1, closeOnScroll: U = !1, closeOnResize: V = !1, openEvents: z, closeEvents: j, globalCloseEvents: S, imperativeModeOnly: B = !1, style: q, position: Y, isOpen: Z, defaultIsOpen: Q = !1, disableStyleInjection: J = !1, border: se, opacity: ae, arrowColor: te, setIsOpen: ne, afterShow: ce, afterHide: pe, disableTooltip: Me, role: Ne = "tooltip" }, it) => {
  const [fe, ye] = Ht(n), [be, he] = Ht(i), [Ge, $e] = Ht(u), [Ve, Ze] = Ht(l), [wt, et] = Ht(d), [W, ee] = Ht(k), [le, me] = Ht(E), [Ee, ve] = Ht(C), [Te, Pe] = Ht(D), [at, Ue] = Ht(h), [rt, gt] = Ht(b), [_t, Bt] = Ht(A), [At, Tt] = Ht(null), [Je, ot] = Ht(null), R0 = gr(J), { anchorRefs: b0, activeAnchor: ir } = UA(t), a0 = (Mt) => Mt?.getAttributeNames().reduce((Rt, tt) => {
    var yt;
    return tt.startsWith("data-tooltip-") && (Rt[tt.replace(/^data-tooltip-/, "")] = (yt = Mt?.getAttribute(tt)) !== null && yt !== void 0 ? yt : null), Rt;
  }, {}), e0 = (Mt) => {
    const Rt = { place: (tt) => {
      var yt;
      $e((yt = tt) !== null && yt !== void 0 ? yt : u);
    }, content: (tt) => {
      ye(tt ?? n);
    }, html: (tt) => {
      he(tt ?? i);
    }, variant: (tt) => {
      var yt;
      Ze((yt = tt) !== null && yt !== void 0 ? yt : l);
    }, offset: (tt) => {
      et(tt === null ? d : Number(tt));
    }, wrapper: (tt) => {
      var yt;
      Ue((yt = tt) !== null && yt !== void 0 ? yt : h);
    }, events: (tt) => {
      const yt = tt?.split(" ");
      gt(yt ?? b);
    }, "position-strategy": (tt) => {
      var yt;
      Bt((yt = tt) !== null && yt !== void 0 ? yt : A);
    }, "delay-show": (tt) => {
      ee(tt === null ? k : Number(tt));
    }, "delay-hide": (tt) => {
      me(tt === null ? E : Number(tt));
    }, float: (tt) => {
      ve(tt === null ? C : tt === "true");
    }, hidden: (tt) => {
      Pe(tt === null ? D : tt === "true");
    }, "class-name": (tt) => {
      Tt(tt);
    } };
    Object.values(Rt).forEach((tt) => tt(null)), Object.entries(Mt).forEach(([tt, yt]) => {
      var q0;
      (q0 = Rt[tt]) === null || q0 === void 0 || q0.call(Rt, yt);
    });
  };
  l0(() => {
    ye(n);
  }, [n]), l0(() => {
    he(i);
  }, [i]), l0(() => {
    $e(u);
  }, [u]), l0(() => {
    Ze(l);
  }, [l]), l0(() => {
    et(d);
  }, [d]), l0(() => {
    ee(k);
  }, [k]), l0(() => {
    me(E);
  }, [E]), l0(() => {
    ve(C);
  }, [C]), l0(() => {
    Pe(D);
  }, [D]), l0(() => {
    Bt(A);
  }, [A]), l0(() => {
    R0.current !== J && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }, [J]), l0(() => {
    typeof window < "u" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: J === "core", disableBase: J } }));
  }, []), l0(() => {
    var Mt;
    const Rt = new Set(b0);
    let tt = r;
    if (!tt && t && (tt = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`), tt) try {
      document.querySelectorAll(tt).forEach((mt) => {
        Rt.add({ current: mt });
      });
    } catch {
      console.warn(`[react-tooltip] "${tt}" is not a valid CSS selector`);
    }
    const yt = document.querySelector(`[id='${e}']`);
    if (yt && Rt.add({ current: yt }), !Rt.size) return () => null;
    const q0 = (Mt = Je ?? yt) !== null && Mt !== void 0 ? Mt : ir.current, L0 = new MutationObserver((mt) => {
      mt.forEach((lt) => {
        var Vt;
        if (!q0 || lt.type !== "attributes" || !(!((Vt = lt.attributeName) === null || Vt === void 0) && Vt.startsWith("data-tooltip-"))) return;
        const t0 = a0(q0);
        e0(t0);
      });
    }), qe = { attributes: !0, childList: !1, subtree: !1 };
    if (q0) {
      const mt = a0(q0);
      e0(mt), L0.observe(q0, qe);
    }
    return () => {
      L0.disconnect();
    };
  }, [b0, ir, Je, e, r]), l0(() => {
    q?.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), se && !ry("border", `${se}`) && console.warn(`[react-tooltip] "${se}" is not a valid \`border\`.`), q?.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), ae && !ry("opacity", `${ae}`) && console.warn(`[react-tooltip] "${ae}" is not a valid \`opacity\`.`);
  }, []);
  let kr = v;
  const br = gr(null);
  if (a) {
    const Mt = a({ content: Je?.getAttribute("data-tooltip-content") || fe || null, activeAnchor: Je });
    kr = Mt ? Ye.createElement("div", { ref: br, className: "react-tooltip-content-wrapper" }, Mt) : null;
  } else fe && (kr = fe);
  be && (kr = Ye.createElement(tM, { content: be }));
  const Br = { forwardRef: it, id: t, anchorId: e, anchorSelect: r, className: i3(o, At), classNameArrow: s, content: kr, contentWrapperRef: br, place: Ge, variant: Ve, offset: wt, wrapper: at, events: rt, openOnClick: x, positionStrategy: _t, middlewares: T, delayShow: W, delayHide: le, float: Ee, hidden: Te, noArrow: _, clickable: I, closeOnEsc: R, closeOnScroll: U, closeOnResize: V, openEvents: z, closeEvents: j, globalCloseEvents: S, imperativeModeOnly: B, style: q, position: Y, isOpen: Z, defaultIsOpen: Q, border: se, opacity: ae, arrowColor: te, setIsOpen: ne, afterShow: ce, afterHide: pe, disableTooltip: Me, activeAnchor: Je, setActiveAnchor: (Mt) => ot(Mt), role: Ne };
  return Ye.createElement(eM, { ...Br });
});
typeof window < "u" && window.addEventListener("react-tooltip-inject-styles", (t) => {
  t.detail.disableCore || ey({ css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}", type: "core" }), t.detail.disableBase || ey({ css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
});
const nM = "t1lgsskr", iM = Ye.forwardRef(({
  children: t,
  tooltipContent: e,
  disableTooltip: r = !1,
  position: n = "top",
  style: i
}, a) => {
  const o = Ye.useId();
  return /* @__PURE__ */ X.jsxs(X.Fragment, {
    children: [/* @__PURE__ */ X.jsx("div", {
      id: o,
      ref: a,
      style: i,
      children: t
    }), e && /* @__PURE__ */ X.jsx(rM, {
      noArrow: !0,
      className: nM,
      anchorSelect: `#${CSS.escape(o)}`,
      content: e,
      hidden: r,
      place: n
    })]
  });
});
async function aM(t, e) {
  return new Promise((r) => {
    const n = t.getBoundingClientRect(), i = n.y + n.height, a = n.x + n.width, o = e.getBoundingClientRect(), s = o.x > a || o.y > i;
    r(s);
  });
}
const oM = Ye.memo(
  ({
    children: t,
    showTooltipWhenTruncated: e,
    disableWordWrap: r,
    className: n,
    ...i
  }) => {
    const [a, o] = Ye.useState(!1), s = Ye.useRef(null), l = Ye.useRef(null), u = () => {
      !s.current || !l.current || !e || aM(s.current, l.current).then(
        (v) => Ye.startTransition(() => o(v))
      );
    };
    Ye.useEffect(() => (u(), window.addEventListener("resize", u), () => window.removeEventListener("resize", u)), [u]);
    const d = a && typeof t == "string", h = typeof t == "string" ? t : "";
    return /* @__PURE__ */ X.jsx(G3, { className: st(_b, n), ...i, children: /* @__PURE__ */ X.jsxs(
      iM,
      {
        tooltipContent: h,
        ref: s,
        disableTooltip: !d,
        style: { whiteSpace: r ? "nowrap" : "normal", overflow: "hidden", textOverflow: "ellipsis" },
        children: [
          t,
          /* @__PURE__ */ X.jsx("span", { ref: l })
        ]
      }
    ) });
  }
), sM = "d1yqr0wu", lM = /* @__PURE__ */ Rn("div")({
  name: "DropdownContainer",
  class: "duhgpp1",
  propsAsIs: !1
}), uM = "d1lq6yfo", cM = /* @__PURE__ */ Rn("div")({
  name: "DropdownTrigger",
  class: "djz3jk0",
  propsAsIs: !1
}), zA = "dvkyuye", fM = "d1d6rxac", dM = () => Lt, hM = /* @__PURE__ */ Rn(dM())({
  name: "DropdownContentItems",
  class: "d16be35y",
  propsAsIs: !0
}), pM = ({
  children: t,
  ...e
}) => /* @__PURE__ */ X.jsx(Lt, {
  isFlexColumn: !0,
  className: zA,
  ...e,
  children: t
}), mM = Ye.memo(
  ({ children: t, className: e, alignment: r = "right", trigger: n }) => {
    const [i, a] = Ye.useState(!1), o = Ye.useRef(null);
    return l0(() => {
      const s = (l) => {
        o.current?.contains(l.target) || a(!1);
      };
      return window.addEventListener("click", s), () => window.removeEventListener("click", s);
    }, []), /* @__PURE__ */ X.jsxs(lM, { ref: o, className: e, children: [
      /* @__PURE__ */ X.jsx(cM, { onClick: () => a((s) => !s), children: /* @__PURE__ */ X.jsxs(jr, { intent: i ? "primary" : "secondary", children: [
        n,
        !n && /* @__PURE__ */ X.jsx(il, { icon: "more", intent: i ? "primary" : "secondary" })
      ] }) }),
      i && /* @__PURE__ */ X.jsx(
        pM,
        {
          onClick: (s) => {
            s.stopPropagation(), a(!1);
          },
          "data-alignment": r,
          children: t
        }
      )
    ] });
  }
), gM = {
  setIsOpen: () => {
  },
  isOpen: !1
}, $A = W3(gM), Ab = () => fp($A), vM = () => {
  const [t, e] = Ye.useState(!1);
  return { isOpen: t, setIsOpen: e };
}, bM = ({
  children: t,
  onClick: e,
  className: r,
  isOpen: n,
  setIsOpen: i,
  ...a
}) => {
  const [o, s] = Ht(!1);
  l0(() => {
    const u = () => {
      if (i) return i(!1);
      s(!1);
    };
    return window.addEventListener("click", u), () => window.removeEventListener("click", u);
  }, []);
  const l = (u) => {
    u.stopPropagation(), e?.(u);
  };
  return /* @__PURE__ */ X.jsx($A.Provider, { value: { isOpen: n ?? o, setIsOpen: i ?? s }, children: /* @__PURE__ */ X.jsx(
    "div",
    {
      onClick: l,
      className: st(sM, (n || o) && "is-open", r),
      ...a,
      children: t
    }
  ) });
}, xM = ({
  children: t,
  className: e,
  onClick: r,
  forceOpen: n,
  ...i
}) => {
  const { isOpen: a, setIsOpen: o } = Ab(), s = (l) => {
    n || o((u) => !u), r?.(l);
  };
  if (!(!a && !n))
    return /* @__PURE__ */ X.jsx(
      Lt,
      {
        isFlexColumn: !0,
        className: st(zA, a && "is-open", e),
        onClick: s,
        ...i,
        children: t
      }
    );
}, yM = ({ children: t, className: e, ...r }) => {
  const { isOpen: n } = Ab();
  return /* @__PURE__ */ X.jsx(ea, { className: st(fM, n && "is-open", e), ...r, children: t });
}, wM = ({ children: t, onClick: e, className: r, disabled: n, ...i }) => {
  const { setIsOpen: a, isOpen: o } = Ab(), s = (l) => {
    n || (a((u) => !u), e?.(l));
  };
  return /* @__PURE__ */ X.jsx("div", { onClick: s, className: st(uM, o && "is-open", r), ...i, children: t });
};
function _M({
  rowAction: t,
  rowData: e
}) {
  return t.visibleFor?.(e) ?? !0 ? /* @__PURE__ */ X.jsx(hM, { onClick: () => t.onClick?.(e), children: /* @__PURE__ */ X.jsx(jr, { children: t.actionTitle }) }) : null;
}
const AM = dp(_M);
function EM({
  rowActions: t,
  className: e,
  rowData: r,
  ...n
}) {
  if (!(!t || !t.length))
    return /* @__PURE__ */ X.jsx(G3, { ...n, className: st(e, LA), id: "table-row-action", children: /* @__PURE__ */ X.jsx(mM, { className: f_, alignment: "right", children: t.map((i, a) => /* @__PURE__ */ X.jsx(AM, { rowAction: i, rowData: r }, `row-action-${r.referenceID}-${a}`)) }) });
}
const SM = dp(EM);
function CM({
  rowData: t,
  onRowSelectionChange: e,
  isSelected: r,
  className: n,
  ...i
}) {
  return /* @__PURE__ */ X.jsx(G3, { className: st(_b, n), ...i, id: "table-row-action", children: /* @__PURE__ */ X.jsx(NA, { checked: r, onChange: (a) => e?.(a.target.checked, t) }) });
}
const kM = dp(CM);
function TM({
  rowKeyIdentifier: t,
  rowData: e,
  isSelectable: r,
  rowActions: n,
  headers: i,
  onRowSelectionChange: a,
  isSelected: o,
  onRowClick: s
}) {
  if (!e) return null;
  const l = !!(n && n.length), u = qi(
    () => !!i.find((h) => h.asNarrowRowTitle),
    [i]
  ), d = (h) => {
    h.target.closest("#table-row-action") || s?.(e);
  };
  return /* @__PURE__ */ X.jsx(oD, { onClick: d, className: st(typeof s == "function" && ic), children: /* @__PURE__ */ X.jsxs(sD, { "data-testid": "table-row-item", className: lD, children: [
    r && /* @__PURE__ */ X.jsx(kM, { isSelected: o, rowData: e, onRowSelectionChange: a }),
    i.map((h, v) => {
      const b = h.getColumnValue?.(e) ?? e[h.key] ?? "-";
      return /* @__PURE__ */ X.jsx(
        oM,
        {
          narrowLabel: h.asNarrowRowTitle ? "" : h.headerTitle,
          narrowOrder: h.asNarrowRowTitle ? 0 : l ? v + 2 : v + 1,
          disableWordWrap: h.disableWordWrap,
          showTooltipWhenTruncated: h.showTooltipWhenTruncated,
          children: b
        },
        `${e[t]}-${h.headerTitle}-${v}`
      );
    }),
    /* @__PURE__ */ X.jsx(
      SM,
      {
        narrowIsFullWidth: u,
        narrowOrder: 1,
        className: LA,
        rowActions: n,
        rowData: e
      }
    )
  ] }) });
}
const FM = dp(TM), DM = "cell-split-data-bold", OM = "cell-split-data-medium-bold", RM = "t1scjwqy", Eie = ({
  isTitleMediumBold: t,
  isTitleBold: e,
  className: r,
  ...n
}) => /* @__PURE__ */ X.jsx(
  uD,
  {
    className: st(
      RM,
      e && DM,
      t && OM,
      r
    ),
    ...n
  }
);
function Sie({
  rows: t,
  headers: e,
  rowKeyIdentifier: r,
  onReorder: n,
  pagination: i,
  isLoading: a = !1,
  loadingMessage: o = "Please wait. Get the table data",
  isError: s = !1,
  errorMessage: l = "Opps. Something went wrong while getting the data!",
  emptyMessage: u = "The data is empty",
  onPageChange: d,
  tableRowAction: h,
  tableDataCountMessage: v,
  tableAction: b,
  isRowSelectable: x,
  onRowClick: A,
  sortQueryKey: T
}) {
  const [k, E] = Ye.useState(), [C, D] = Ye.useState(), _ = Ye.useDeferredValue(t), I = Array.isArray(h) && h.length > 0, R = _?.length ?? 0, U = t?.length !== _?.length, V = Ye.useMemo(() => !(R > 0), [R]), z = V && !a && !s && !U, j = (a || U) && !s, S = s && !a && !U, B = !V && !s && !a && !U, q = B && i?.numberPages, Y = Ye.useMemo(() => kN(e, x, I), []), Z = Ye.useCallback((J, se) => {
    Ye.startTransition(() => {
      if (J) {
        D((ae) => ({ ...ae, [se[r]]: se })), E((ae) => [...ae ?? [], se]);
        return;
      }
      D((ae) => {
        const te = { ...ae };
        return delete te[se[r]], te;
      }), E(
        (ae) => ae?.filter((te) => te[r] !== se[r])
      );
    });
  }, []), Q = (J) => {
    Ye.startTransition(() => {
      if (J) {
        D(
          t?.reduce((se, ae) => ({ ...se, [ae[r]]: ae }), {})
        ), E(t);
        return;
      }
      D(null), E(null);
    });
  };
  return Ye.useEffect(() => {
    Ye.startTransition(() => {
      E(null), D(null);
    });
  }, [i?.currentPage, t?.length, B]), /* @__PURE__ */ X.jsxs(Lt, { isFlexColumn: !0, className: Ja, children: [
    /* @__PURE__ */ X.jsx(
      ON,
      {
        tableAction: b,
        dataCount: i?.dataCount ?? t?.length,
        dataCountDisplayMessage: v,
        rowActions: h,
        selectedRows: k,
        isLoading: j
      }
    ),
    /* @__PURE__ */ X.jsxs(
      cD,
      {
        "data-testid": "table",
        className: st((I || x) && TN, FN),
        style: Y,
        "data-num-columns-excl-action-col": e.length,
        children: [
          /* @__PURE__ */ X.jsx(
            HN,
            {
              headers: e,
              hasRowAction: I,
              isSelectable: x,
              onSortChanges: n,
              hasRowSelected: !!k?.length,
              onClickSelectionHeader: Q,
              sortQueryKey: T
            }
          ),
          (z || S || j) && /* @__PURE__ */ X.jsxs(Lt, { isFlexAlignCenter: !0, isFlexJustifyCenter: !0, className: st(hD, Ja), children: [
            j && /* @__PURE__ */ X.jsx(i_, { label: o }),
            S && /* @__PURE__ */ X.jsx(fD, { intent: "danger", children: l }),
            z && /* @__PURE__ */ X.jsx(jr, { intent: "secondary", children: u })
          ] }),
          B && _?.map((J) => /* @__PURE__ */ X.jsx(
            FM,
            {
              headers: e,
              rowKeyIdentifier: r.toString(),
              rowData: J,
              isSelectable: x,
              onRowSelectionChange: Z,
              rowActions: h,
              isSelected: !!C?.[J[r]],
              onRowClick: A
            },
            J[r]
          )),
          i && q && /* @__PURE__ */ X.jsx(dD, { callback: (J) => d?.(J), ...i, className: t_ })
        ]
      }
    )
  ] });
}
const PM = "t13lnvfc", IM = "b65h1v6", BM = ({
  actionDropdown: t,
  disabled: e
}) => {
  const r = vM();
  if (!(!t || t.length < 1))
    return /* @__PURE__ */ X.jsxs(bM, {
      className: st(IM, e && "is-disabled"),
      ...r,
      children: [/* @__PURE__ */ X.jsx(wM, {
        disabled: e,
        children: /* @__PURE__ */ X.jsx("div", {
          className: PM,
          children: /* @__PURE__ */ X.jsx(il, {
            icon: r.isOpen ? "chevronUp" : "chevronDown"
          })
        })
      }), /* @__PURE__ */ X.jsx(xM, {
        children: t.map((n, i) => /* @__PURE__ */ X.jsx(yM, {
          onClick: (a) => n.onClick?.(a),
          children: n.title
        }, i))
      })]
    });
}, Cie = ({
  actionDropdown: t,
  children: e,
  className: r,
  disabled: n,
  ...i
}) => /* @__PURE__ */ X.jsxs(Lt, {
  isFlexRow: !0,
  isFlexNoWrap: !0,
  className: st(pD),
  children: [/* @__PURE__ */ X.jsx(ea, {
    intent: "primary",
    className: st("c15vfjvt", r),
    disabled: n,
    ...i,
    children: /* @__PURE__ */ X.jsx(jr, {
      hasMediumText: !0,
      className: "cgnbcom",
      children: e
    })
  }), /* @__PURE__ */ X.jsx(BM, {
    actionDropdown: t,
    disabled: n
  })]
}), LM = "d16g5uhk", kie = ({
  className: t,
  children: e,
  ...r
}) => /* @__PURE__ */ X.jsx(mD, {
  className: st(LM, t),
  ...r,
  children: e
}), Bu = "VIEW", kg = "TEXT", NM = "PAGE", MM = "DOCUMENT";
var VA = { exports: {} }, o3 = { exports: {} };
typeof Object.create == "function" ? o3.exports = function(e, r) {
  r && (e.super_ = r, e.prototype = Object.create(r.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : o3.exports = function(e, r) {
  if (r) {
    e.super_ = r;
    var n = function() {
    };
    n.prototype = r.prototype, e.prototype = new n(), e.prototype.constructor = e;
  }
};
var UM = o3.exports, Eb = { exports: {} }, Zf = typeof Reflect == "object" ? Reflect : null, oy = Zf && typeof Zf.apply == "function" ? Zf.apply : function(e, r, n) {
  return Function.prototype.apply.call(e, r, n);
}, Q2;
Zf && typeof Zf.ownKeys == "function" ? Q2 = Zf.ownKeys : Object.getOwnPropertySymbols ? Q2 = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Q2 = function(e) {
  return Object.getOwnPropertyNames(e);
};
function zM(t) {
  console && console.warn && console.warn(t);
}
var jA = Number.isNaN || function(e) {
  return e !== e;
};
function Z0() {
  Z0.init.call(this);
}
Eb.exports = Z0;
Eb.exports.once = WM;
Z0.EventEmitter = Z0;
Z0.prototype._events = void 0;
Z0.prototype._eventsCount = 0;
Z0.prototype._maxListeners = void 0;
var sy = 10;
function Mp(t) {
  if (typeof t != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
}
Object.defineProperty(Z0, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return sy;
  },
  set: function(t) {
    if (typeof t != "number" || t < 0 || jA(t))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
    sy = t;
  }
});
Z0.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
Z0.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || jA(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function WA(t) {
  return t._maxListeners === void 0 ? Z0.defaultMaxListeners : t._maxListeners;
}
Z0.prototype.getMaxListeners = function() {
  return WA(this);
};
Z0.prototype.emit = function(e) {
  for (var r = [], n = 1; n < arguments.length; n++) r.push(arguments[n]);
  var i = e === "error", a = this._events;
  if (a !== void 0)
    i = i && a.error === void 0;
  else if (!i)
    return !1;
  if (i) {
    var o;
    if (r.length > 0 && (o = r[0]), o instanceof Error)
      throw o;
    var s = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
    throw s.context = o, s;
  }
  var l = a[e];
  if (l === void 0)
    return !1;
  if (typeof l == "function")
    oy(l, this, r);
  else
    for (var u = l.length, d = ZA(l, u), n = 0; n < u; ++n)
      oy(d[n], this, r);
  return !0;
};
function HA(t, e, r, n) {
  var i, a, o;
  if (Mp(r), a = t._events, a === void 0 ? (a = t._events = /* @__PURE__ */ Object.create(null), t._eventsCount = 0) : (a.newListener !== void 0 && (t.emit(
    "newListener",
    e,
    r.listener ? r.listener : r
  ), a = t._events), o = a[e]), o === void 0)
    o = a[e] = r, ++t._eventsCount;
  else if (typeof o == "function" ? o = a[e] = n ? [r, o] : [o, r] : n ? o.unshift(r) : o.push(r), i = WA(t), i > 0 && o.length > i && !o.warned) {
    o.warned = !0;
    var s = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    s.name = "MaxListenersExceededWarning", s.emitter = t, s.type = e, s.count = o.length, zM(s);
  }
  return t;
}
Z0.prototype.addListener = function(e, r) {
  return HA(this, e, r, !1);
};
Z0.prototype.on = Z0.prototype.addListener;
Z0.prototype.prependListener = function(e, r) {
  return HA(this, e, r, !0);
};
function $M() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function qA(t, e, r) {
  var n = { fired: !1, wrapFn: void 0, target: t, type: e, listener: r }, i = $M.bind(n);
  return i.listener = r, n.wrapFn = i, i;
}
Z0.prototype.once = function(e, r) {
  return Mp(r), this.on(e, qA(this, e, r)), this;
};
Z0.prototype.prependOnceListener = function(e, r) {
  return Mp(r), this.prependListener(e, qA(this, e, r)), this;
};
Z0.prototype.removeListener = function(e, r) {
  var n, i, a, o, s;
  if (Mp(r), i = this._events, i === void 0)
    return this;
  if (n = i[e], n === void 0)
    return this;
  if (n === r || n.listener === r)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete i[e], i.removeListener && this.emit("removeListener", e, n.listener || r));
  else if (typeof n != "function") {
    for (a = -1, o = n.length - 1; o >= 0; o--)
      if (n[o] === r || n[o].listener === r) {
        s = n[o].listener, a = o;
        break;
      }
    if (a < 0)
      return this;
    a === 0 ? n.shift() : VM(n, a), n.length === 1 && (i[e] = n[0]), i.removeListener !== void 0 && this.emit("removeListener", e, s || r);
  }
  return this;
};
Z0.prototype.off = Z0.prototype.removeListener;
Z0.prototype.removeAllListeners = function(e) {
  var r, n, i;
  if (n = this._events, n === void 0)
    return this;
  if (n.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : n[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete n[e]), this;
  if (arguments.length === 0) {
    var a = Object.keys(n), o;
    for (i = 0; i < a.length; ++i)
      o = a[i], o !== "removeListener" && this.removeAllListeners(o);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (r = n[e], typeof r == "function")
    this.removeListener(e, r);
  else if (r !== void 0)
    for (i = r.length - 1; i >= 0; i--)
      this.removeListener(e, r[i]);
  return this;
};
function YA(t, e, r) {
  var n = t._events;
  if (n === void 0)
    return [];
  var i = n[e];
  return i === void 0 ? [] : typeof i == "function" ? r ? [i.listener || i] : [i] : r ? jM(i) : ZA(i, i.length);
}
Z0.prototype.listeners = function(e) {
  return YA(this, e, !0);
};
Z0.prototype.rawListeners = function(e) {
  return YA(this, e, !1);
};
Z0.listenerCount = function(t, e) {
  return typeof t.listenerCount == "function" ? t.listenerCount(e) : GA.call(t, e);
};
Z0.prototype.listenerCount = GA;
function GA(t) {
  var e = this._events;
  if (e !== void 0) {
    var r = e[t];
    if (typeof r == "function")
      return 1;
    if (r !== void 0)
      return r.length;
  }
  return 0;
}
Z0.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Q2(this._events) : [];
};
function ZA(t, e) {
  for (var r = new Array(e), n = 0; n < e; ++n)
    r[n] = t[n];
  return r;
}
function VM(t, e) {
  for (; e + 1 < t.length; e++)
    t[e] = t[e + 1];
  t.pop();
}
function jM(t) {
  for (var e = new Array(t.length), r = 0; r < e.length; ++r)
    e[r] = t[r].listener || t[r];
  return e;
}
function WM(t, e) {
  return new Promise(function(r, n) {
    function i(o) {
      t.removeListener(e, a), n(o);
    }
    function a() {
      typeof t.removeListener == "function" && t.removeListener("error", i), r([].slice.call(arguments));
    }
    XA(t, e, a, { once: !0 }), e !== "error" && HM(t, i, { once: !0 });
  });
}
function HM(t, e, r) {
  typeof t.on == "function" && XA(t, "error", e, r);
}
function XA(t, e, r, n) {
  if (typeof t.on == "function")
    n.once ? t.once(e, r) : t.on(e, r);
  else if (typeof t.addEventListener == "function")
    t.addEventListener(e, function i(a) {
      n.once && t.removeEventListener(e, i), r(a);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof t);
}
var qM = Eb.exports, YM = UM, KA = qM.EventEmitter;
VA.exports = ta;
VA.exports.default = ta;
function ta(t) {
  if (!(this instanceof ta))
    return new ta(t);
  KA.call(this), t = t || {}, this.concurrency = t.concurrency || 1 / 0, this.timeout = t.timeout || 0, this.autostart = t.autostart || !1, this.results = t.results || null, this.pending = 0, this.session = 0, this.running = !1, this.jobs = [], this.timers = {};
}
YM(ta, KA);
var GM = [
  "pop",
  "shift",
  "indexOf",
  "lastIndexOf"
];
GM.forEach(function(t) {
  ta.prototype[t] = function() {
    return Array.prototype[t].apply(this.jobs, arguments);
  };
});
ta.prototype.slice = function(t, e) {
  return this.jobs = this.jobs.slice(t, e), this;
};
ta.prototype.reverse = function() {
  return this.jobs.reverse(), this;
};
var ZM = [
  "push",
  "unshift",
  "splice"
];
ZM.forEach(function(t) {
  ta.prototype[t] = function() {
    var e = Array.prototype[t].apply(this.jobs, arguments);
    return this.autostart && this.start(), e;
  };
});
Object.defineProperty(ta.prototype, "length", {
  get: function() {
    return this.pending + this.jobs.length;
  }
});
ta.prototype.start = function(t) {
  if (t && KM.call(this, t), this.running = !0, this.pending >= this.concurrency)
    return;
  if (this.jobs.length === 0) {
    this.pending === 0 && s3.call(this);
    return;
  }
  var e = this, r = this.jobs.shift(), n = !0, i = this.session, a = null, o = !1, s = null, l = r.hasOwnProperty("timeout") ? r.timeout : this.timeout;
  function u(h, v) {
    n && e.session === i && (n = !1, e.pending--, a !== null && (delete e.timers[a], clearTimeout(a)), h ? e.emit("error", h, r) : o === !1 && (s !== null && (e.results[s] = Array.prototype.slice.call(arguments, 1)), e.emit("success", v, r)), e.session === i && (e.pending === 0 && e.jobs.length === 0 ? s3.call(e) : e.running && e.start()));
  }
  l && (a = setTimeout(function() {
    o = !0, e.listeners("timeout").length > 0 ? e.emit("timeout", u, r) : u();
  }, l), this.timers[a] = a), this.results && (s = this.results.length, this.results[s] = null), this.pending++, e.emit("start", r);
  var d = r(u);
  d && d.then && typeof d.then == "function" && d.then(function(h) {
    return u(null, h);
  }).catch(function(h) {
    return u(h || !0);
  }), this.running && this.jobs.length > 0 && this.start();
};
ta.prototype.stop = function() {
  this.running = !1;
};
ta.prototype.end = function(t) {
  XM.call(this), this.jobs.length = 0, this.pending = 0, s3.call(this, t);
};
function XM() {
  for (var t in this.timers) {
    var e = this.timers[t];
    delete this.timers[t], clearTimeout(e);
  }
}
function KM(t) {
  var e = this;
  this.on("error", r), this.on("end", n);
  function r(i) {
    e.end(i);
  }
  function n(i) {
    e.removeListener("error", r), e.removeListener("end", n), t(i, this.results);
  }
}
function s3(t) {
  this.session++, this.running = !1, this.emit("end", t);
}
const JM = {
  utf16le: "utf-16le",
  ucs2: "utf-16le",
  utf16be: "utf-16be"
};
class Tn {
  constructor(e) {
    this.buffer = e, this.view = new DataView(e.buffer, e.byteOffset, e.byteLength), this.pos = 0, this.length = this.buffer.length;
  }
  readString(e, r = "ascii") {
    r = JM[r] || r;
    let n = this.readBuffer(e);
    try {
      return new TextDecoder(r).decode(n);
    } catch {
      return n;
    }
  }
  readBuffer(e) {
    return this.buffer.slice(this.pos, this.pos += e);
  }
  readUInt24BE() {
    return (this.readUInt16BE() << 8) + this.readUInt8();
  }
  readUInt24LE() {
    return this.readUInt16LE() + (this.readUInt8() << 16);
  }
  readInt24BE() {
    return (this.readInt16BE() << 8) + this.readUInt8();
  }
  readInt24LE() {
    return this.readUInt16LE() + (this.readInt8() << 16);
  }
}
Tn.TYPES = {
  UInt8: 1,
  UInt16: 2,
  UInt24: 3,
  UInt32: 4,
  Int8: 1,
  Int16: 2,
  Int24: 3,
  Int32: 4,
  Float: 4,
  Double: 8
};
for (let t of Object.getOwnPropertyNames(DataView.prototype))
  if (t.slice(0, 3) === "get") {
    let e = t.slice(3).replace("Ui", "UI");
    e === "Float32" ? e = "Float" : e === "Float64" && (e = "Double");
    let r = Tn.TYPES[e];
    Tn.prototype["read" + e + (r === 1 ? "" : "BE")] = function() {
      const n = this.view[t](this.pos, !1);
      return this.pos += r, n;
    }, r !== 1 && (Tn.prototype["read" + e + "LE"] = function() {
      const n = this.view[t](this.pos, !0);
      return this.pos += r, n;
    });
  }
const QM = new TextEncoder(), ly = new Uint8Array(new Uint16Array([4660]).buffer)[0] == 18;
class I5 {
  constructor(e) {
    this.buffer = e, this.view = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength), this.pos = 0;
  }
  writeBuffer(e) {
    this.buffer.set(e, this.pos), this.pos += e.length;
  }
  writeString(e, r = "ascii") {
    let n;
    switch (r) {
      case "utf16le":
      case "utf16-le":
      case "ucs2":
        n = uy(e, ly);
        break;
      case "utf16be":
      case "utf16-be":
        n = uy(e, !ly);
        break;
      case "utf8":
        n = QM.encode(e);
        break;
      case "ascii":
        n = eU(e);
        break;
      default:
        throw new Error(`Unsupported encoding: ${r}`);
    }
    this.writeBuffer(n);
  }
  writeUInt24BE(e) {
    this.buffer[this.pos++] = e >>> 16 & 255, this.buffer[this.pos++] = e >>> 8 & 255, this.buffer[this.pos++] = e & 255;
  }
  writeUInt24LE(e) {
    this.buffer[this.pos++] = e & 255, this.buffer[this.pos++] = e >>> 8 & 255, this.buffer[this.pos++] = e >>> 16 & 255;
  }
  writeInt24BE(e) {
    e >= 0 ? this.writeUInt24BE(e) : this.writeUInt24BE(e + 16777215 + 1);
  }
  writeInt24LE(e) {
    e >= 0 ? this.writeUInt24LE(e) : this.writeUInt24LE(e + 16777215 + 1);
  }
  fill(e, r) {
    if (r < this.buffer.length)
      this.buffer.fill(e, this.pos, this.pos + r), this.pos += r;
    else {
      const n = new Uint8Array(r);
      n.fill(e), this.writeBuffer(n);
    }
  }
}
function uy(t, e) {
  let r = new Uint16Array(t.length);
  for (let n = 0; n < t.length; n++) {
    let i = t.charCodeAt(n);
    e && (i = i >> 8 | (i & 255) << 8), r[n] = i;
  }
  return new Uint8Array(r.buffer);
}
function eU(t) {
  let e = new Uint8Array(t.length);
  for (let r = 0; r < t.length; r++)
    e[r] = t.charCodeAt(r);
  return e;
}
for (let t of Object.getOwnPropertyNames(DataView.prototype))
  if (t.slice(0, 3) === "set") {
    let e = t.slice(3).replace("Ui", "UI");
    e === "Float32" ? e = "Float" : e === "Float64" && (e = "Double");
    let r = Tn.TYPES[e];
    I5.prototype["write" + e + (r === 1 ? "" : "BE")] = function(n) {
      this.view[t](this.pos, n, !1), this.pos += r;
    }, r !== 1 && (I5.prototype["write" + e + "LE"] = function(n) {
      this.view[t](this.pos, n, !0), this.pos += r;
    });
  }
class sl {
  fromBuffer(e) {
    let r = new Tn(e);
    return this.decode(r);
  }
  toBuffer(e) {
    let r = this.size(e), n = new Uint8Array(r), i = new I5(n);
    return this.encode(i, e), n;
  }
}
class O0 extends sl {
  constructor(e, r = "BE") {
    super(), this.type = e, this.endian = r, this.fn = this.type, this.type[this.type.length - 1] !== "8" && (this.fn += this.endian);
  }
  size() {
    return Tn.TYPES[this.type];
  }
  decode(e) {
    return e[`read${this.fn}`]();
  }
  encode(e, r) {
    return e[`write${this.fn}`](r);
  }
}
const ze = new O0("UInt8"), un = new O0("UInt16", "BE"), F = un, tU = new O0("UInt16", "LE"), rU = new O0("UInt24", "BE"), Kl = rU;
new O0("UInt24", "LE");
const JA = new O0("UInt32", "BE"), ge = JA, nU = new O0("UInt32", "LE"), Zr = new O0("Int8"), iU = new O0("Int16", "BE"), Be = iU;
new O0("Int16", "LE");
new O0("Int24", "BE");
new O0("Int24", "LE");
const aU = new O0("Int32", "BE"), Vu = aU;
new O0("Int32", "LE");
new O0("Float", "BE");
new O0("Float", "LE");
new O0("Double", "BE");
new O0("Double", "LE");
class kc extends O0 {
  constructor(e, r, n = e >> 1) {
    super(`Int${e}`, r), this._point = 1 << n;
  }
  decode(e) {
    return super.decode(e) / this._point;
  }
  encode(e, r) {
    return super.encode(e, r * this._point | 0);
  }
}
const oU = new kc(16, "BE"), sU = oU;
new kc(16, "LE");
const lU = new kc(32, "BE"), Er = lU;
new kc(32, "LE");
function os(t, e, r) {
  let n;
  if (typeof t == "number" ? n = t : typeof t == "function" ? n = t.call(r, r) : r && typeof t == "string" ? n = r[t] : e && t instanceof O0 && (n = t.decode(e)), isNaN(n))
    throw new Error("Not a fixed size");
  return n;
}
class Sb {
  constructor(e = {}) {
    this.enumerable = !0, this.configurable = !0;
    for (let r in e) {
      const n = e[r];
      this[r] = n;
    }
  }
}
class ue extends sl {
  constructor(e, r, n = "count") {
    super(), this.type = e, this.length = r, this.lengthType = n;
  }
  decode(e, r) {
    let n;
    const { pos: i } = e, a = [];
    let o = r;
    if (this.length != null && (n = os(this.length, e, r)), this.length instanceof O0 && (Object.defineProperties(a, {
      parent: { value: r },
      _startOffset: { value: i },
      _currentOffset: { value: 0, writable: !0 },
      _length: { value: n }
    }), o = a), n == null || this.lengthType === "bytes") {
      const s = n != null ? e.pos + n : r?._length ? r._startOffset + r._length : e.length;
      for (; e.pos < s; )
        a.push(this.type.decode(e, o));
    } else
      for (let s = 0, l = n; s < l; s++)
        a.push(this.type.decode(e, o));
    return a;
  }
  size(e, r, n = !0) {
    if (!e)
      return this.type.size(null, r) * os(this.length, null, r);
    let i = 0;
    this.length instanceof O0 && (i += this.length.size(), r = { parent: r, pointerSize: 0 });
    for (let a of e)
      i += this.type.size(a, r);
    return r && n && this.length instanceof O0 && (i += r.pointerSize), i;
  }
  encode(e, r, n) {
    let i = n;
    this.length instanceof O0 && (i = {
      pointers: [],
      startOffset: e.pos,
      parent: n
    }, i.pointerOffset = e.pos + this.size(r, i, !1), this.length.encode(e, r.length));
    for (let a of r)
      this.type.encode(e, a, i);
    if (this.length instanceof O0) {
      let a = 0;
      for (; a < i.pointers.length; ) {
        const o = i.pointers[a++];
        o.type.encode(e, o.val, o.parent);
      }
    }
  }
}
class j0 extends ue {
  decode(e, r) {
    const { pos: n } = e, i = os(this.length, e, r);
    this.length instanceof O0 && (r = {
      parent: r,
      _startOffset: n,
      _currentOffset: 0,
      _length: i
    });
    const a = new Tg(this.type, i, e, r);
    return e.pos += i * this.type.size(null, r), a;
  }
  size(e, r) {
    return e instanceof Tg && (e = e.toArray()), super.size(e, r);
  }
  encode(e, r, n) {
    return r instanceof Tg && (r = r.toArray()), super.encode(e, r, n);
  }
}
class Tg {
  constructor(e, r, n, i) {
    this.type = e, this.length = r, this.stream = n, this.ctx = i, this.base = this.stream.pos, this.items = [];
  }
  get(e) {
    if (!(e < 0 || e >= this.length)) {
      if (this.items[e] == null) {
        const { pos: r } = this.stream;
        this.stream.pos = this.base + this.type.size(null, this.ctx) * e, this.items[e] = this.type.decode(this.stream, this.ctx), this.stream.pos = r;
      }
      return this.items[e];
    }
  }
  toArray() {
    const e = [];
    for (let r = 0, n = this.length; r < n; r++)
      e.push(this.get(r));
    return e;
  }
}
class ao extends sl {
  constructor(e, r = []) {
    super(), this.type = e, this.flags = r;
  }
  decode(e) {
    const r = this.type.decode(e), n = {};
    for (let i = 0; i < this.flags.length; i++) {
      const a = this.flags[i];
      a != null && (n[a] = !!(r & 1 << i));
    }
    return n;
  }
  size() {
    return this.type.size();
  }
  encode(e, r) {
    let n = 0;
    for (let i = 0; i < this.flags.length; i++) {
      const a = this.flags[i];
      a != null && r[a] && (n |= 1 << i);
    }
    return this.type.encode(e, n);
  }
}
class Fn extends sl {
  constructor(e) {
    super(), this.length = e;
  }
  decode(e, r) {
    const n = os(this.length, e, r);
    return e.readBuffer(n);
  }
  size(e, r) {
    if (!e)
      return os(this.length, null, r);
    let n = e.length;
    return this.length instanceof O0 && (n += this.length.size()), n;
  }
  encode(e, r, n) {
    return this.length instanceof O0 && this.length.encode(e, r.length), e.writeBuffer(r);
  }
}
class B5 extends sl {
  constructor(e, r = !0) {
    super(), this.type = e, this.condition = r;
  }
  decode(e, r) {
    let { condition: n } = this;
    if (typeof n == "function" && (n = n.call(r, r)), n)
      return this.type.decode(e, r);
  }
  size(e, r) {
    let { condition: n } = this;
    return typeof n == "function" && (n = n.call(r, r)), n ? this.type.size(e, r) : 0;
  }
  encode(e, r, n) {
    let { condition: i } = this;
    if (typeof i == "function" && (i = i.call(n, n)), i)
      return this.type.encode(e, r, n);
  }
}
class J0 extends sl {
  constructor(e, r = 1) {
    super(), this.type = e, this.count = r;
  }
  decode(e, r) {
    e.pos += this.size(null, r);
  }
  size(e, r) {
    const n = os(this.count, null, r);
    return this.type.size() * n;
  }
  encode(e, r, n) {
    return e.fill(0, this.size(r, n));
  }
}
class A0 extends sl {
  constructor(e, r = "ascii") {
    super(), this.length = e, this.encoding = r;
  }
  decode(e, r) {
    let n, i, { encoding: a } = this;
    typeof a == "function" && (a = a.call(r, r) || "ascii");
    let o = Fg(a);
    if (this.length != null)
      n = os(this.length, e, r);
    else {
      let l;
      for ({ buffer: l, length: n, pos: i } = e; i < n - o + 1 && (l[i] !== 0 || o === 2 && l[i + 1] !== 0); )
        i += o;
      n = i - e.pos;
    }
    const s = e.readString(n, a);
    return this.length == null && e.pos < e.length && (e.pos += o), s;
  }
  size(e, r) {
    if (e == null)
      return os(this.length, null, r);
    let { encoding: n } = this;
    typeof n == "function" && (n = n.call(r?.val, r?.val) || "ascii"), n === "utf16be" && (n = "utf16le");
    let i = cy(e, n);
    return this.length instanceof O0 && (i += this.length.size()), this.length == null && (i += Fg(n)), i;
  }
  encode(e, r, n) {
    let { encoding: i } = this;
    if (typeof i == "function" && (i = i.call(n?.val, n?.val) || "ascii"), this.length instanceof O0 && this.length.encode(e, cy(r, i)), e.writeString(r, i), this.length == null)
      return Fg(i) == 2 ? e.writeUInt16LE(0) : e.writeUInt8(0);
  }
}
function Fg(t) {
  switch (t) {
    case "ascii":
    case "utf8":
      return 1;
    case "utf16le":
    case "utf16-le":
    case "utf-16be":
    case "utf-16le":
    case "utf16be":
    case "utf16-be":
    case "ucs2":
      return 2;
    default:
      return 1;
  }
}
function cy(t, e) {
  switch (e) {
    case "ascii":
      return t.length;
    case "utf8":
      let r = 0;
      for (let n = 0; n < t.length; n++) {
        let i = t.charCodeAt(n);
        if (i >= 55296 && i <= 56319 && n < t.length - 1) {
          let a = t.charCodeAt(++n);
          (a & 64512) === 56320 ? i = ((i & 1023) << 10) + (a & 1023) + 65536 : n--;
        }
        i & 4294967168 ? i & 4294965248 ? i & 4294901760 ? i & 4292870144 || (r += 4) : r += 3 : r += 2 : r++;
      }
      return r;
    case "utf16le":
    case "utf16-le":
    case "utf16be":
    case "utf16-be":
    case "ucs2":
      return t.length * 2;
    default:
      throw new Error("Unknown encoding " + e);
  }
}
class xe extends sl {
  constructor(e = {}) {
    super(), this.fields = e;
  }
  decode(e, r, n = 0) {
    const i = this._setup(e, r, n);
    return this._parseFields(e, i, this.fields), this.process != null && this.process.call(i, e), i;
  }
  _setup(e, r, n) {
    const i = {};
    return Object.defineProperties(i, {
      parent: { value: r },
      _startOffset: { value: e.pos },
      _currentOffset: { value: 0, writable: !0 },
      _length: { value: n }
    }), i;
  }
  _parseFields(e, r, n) {
    for (let a in n) {
      var i;
      const o = n[a];
      typeof o == "function" ? i = o.call(r, r) : i = o.decode(e, r), i !== void 0 && (i instanceof Sb ? Object.defineProperty(r, a, i) : r[a] = i), r._currentOffset = e.pos - r._startOffset;
    }
  }
  size(e, r, n = !0) {
    e == null && (e = {});
    const i = {
      parent: r,
      val: e,
      pointerSize: 0
    };
    this.preEncode != null && this.preEncode.call(e);
    let a = 0;
    for (let o in this.fields) {
      const s = this.fields[o];
      s.size != null && (a += s.size(e[o], i));
    }
    return n && (a += i.pointerSize), a;
  }
  encode(e, r, n) {
    let i;
    this.preEncode != null && this.preEncode.call(r, e);
    const a = {
      pointers: [],
      startOffset: e.pos,
      parent: n,
      val: r,
      pointerSize: 0
    };
    a.pointerOffset = e.pos + this.size(r, a, !1);
    for (let s in this.fields)
      i = this.fields[s], i.encode != null && i.encode(e, r[s], a);
    let o = 0;
    for (; o < a.pointers.length; ) {
      const s = a.pointers[o++];
      s.type.encode(e, s.val, s.parent);
    }
  }
}
const uU = (t, e) => e.reduce((r, n) => r && r[n], t);
class qt extends xe {
  constructor(e, r = {}) {
    super(), this.type = e, this.versions = r, typeof e == "string" && (this.versionPath = e.split("."));
  }
  decode(e, r, n = 0) {
    const i = this._setup(e, r, n);
    typeof this.type == "string" ? i.version = uU(r, this.versionPath) : i.version = this.type.decode(e), this.versions.header && this._parseFields(e, i, this.versions.header);
    const a = this.versions[i.version];
    if (a == null)
      throw new Error(`Unknown version ${i.version}`);
    return a instanceof qt ? a.decode(e, r) : (this._parseFields(e, i, a), this.process != null && this.process.call(i, e), i);
  }
  size(e, r, n = !0) {
    let i, a;
    if (!e)
      throw new Error("Not a fixed size");
    this.preEncode != null && this.preEncode.call(e);
    const o = {
      parent: r,
      val: e,
      pointerSize: 0
    };
    let s = 0;
    if (typeof this.type != "string" && (s += this.type.size(e.version, o)), this.versions.header)
      for (i in this.versions.header)
        a = this.versions.header[i], a.size != null && (s += a.size(e[i], o));
    const l = this.versions[e.version];
    if (l == null)
      throw new Error(`Unknown version ${e.version}`);
    for (i in l)
      a = l[i], a.size != null && (s += a.size(e[i], o));
    return n && (s += o.pointerSize), s;
  }
  encode(e, r, n) {
    let i, a;
    this.preEncode != null && this.preEncode.call(r, e);
    const o = {
      pointers: [],
      startOffset: e.pos,
      parent: n,
      val: r,
      pointerSize: 0
    };
    if (o.pointerOffset = e.pos + this.size(r, o, !1), typeof this.type != "string" && this.type.encode(e, r.version), this.versions.header)
      for (i in this.versions.header)
        a = this.versions.header[i], a.encode != null && a.encode(e, r[i], o);
    const s = this.versions[r.version];
    for (i in s)
      a = s[i], a.encode != null && a.encode(e, r[i], o);
    let l = 0;
    for (; l < o.pointers.length; ) {
      const u = o.pointers[l++];
      u.type.encode(e, u.val, u.parent);
    }
  }
}
class de extends sl {
  constructor(e, r, n = {}) {
    if (super(), this.offsetType = e, this.type = r, this.options = n, this.type === "void" && (this.type = null), this.options.type == null && (this.options.type = "local"), this.options.allowNull == null && (this.options.allowNull = !0), this.options.nullValue == null && (this.options.nullValue = 0), this.options.lazy == null && (this.options.lazy = !1), this.options.relativeTo) {
      if (typeof this.options.relativeTo != "function")
        throw new Error("relativeTo option must be a function");
      this.relativeToGetter = n.relativeTo;
    }
  }
  decode(e, r) {
    const n = this.offsetType.decode(e, r);
    if (n === this.options.nullValue && this.options.allowNull)
      return null;
    let i;
    switch (this.options.type) {
      case "local":
        i = r._startOffset;
        break;
      case "immediate":
        i = e.pos - this.offsetType.size();
        break;
      case "parent":
        i = r.parent._startOffset;
        break;
      default:
        for (var a = r; a.parent; )
          a = a.parent;
        i = a._startOffset || 0;
    }
    this.options.relativeTo && (i += this.relativeToGetter(r));
    const o = n + i;
    if (this.type != null) {
      let s = null;
      const l = () => {
        if (s != null)
          return s;
        const { pos: u } = e;
        return e.pos = o, s = this.type.decode(e, r), e.pos = u, s;
      };
      return this.options.lazy ? new Sb({
        get: l
      }) : l();
    } else
      return o;
  }
  size(e, r) {
    const n = r;
    switch (this.options.type) {
      case "local":
      case "immediate":
        break;
      case "parent":
        r = r.parent;
        break;
      default:
        for (; r.parent; )
          r = r.parent;
    }
    let { type: i } = this;
    if (i == null) {
      if (!(e instanceof l3))
        throw new Error("Must be a VoidPointer");
      ({ type: i } = e), e = e.value;
    }
    if (e && r) {
      let a = i.size(e, n);
      r.pointerSize += a;
    }
    return this.offsetType.size();
  }
  encode(e, r, n) {
    let i;
    const a = n;
    if (r == null) {
      this.offsetType.encode(e, this.options.nullValue);
      return;
    }
    switch (this.options.type) {
      case "local":
        i = n.startOffset;
        break;
      case "immediate":
        i = e.pos + this.offsetType.size(r, a);
        break;
      case "parent":
        n = n.parent, i = n.startOffset;
        break;
      default:
        for (i = 0; n.parent; )
          n = n.parent;
    }
    this.options.relativeTo && (i += this.relativeToGetter(a.val)), this.offsetType.encode(e, n.pointerOffset - i);
    let { type: o } = this;
    if (o == null) {
      if (!(r instanceof l3))
        throw new Error("Must be a VoidPointer");
      ({ type: o } = r), r = r.value;
    }
    return n.pointers.push({
      type: o,
      val: r,
      parent: a
    }), n.pointerOffset += o.size(r, a);
  }
}
class l3 {
  constructor(e, r) {
    this.type = e, this.value = r;
  }
}
function Fi(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Pn(t, e, r, n) {
  var i = arguments.length, a = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, r) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") a = Reflect.decorate(t, e, r, n);
  else for (var s = t.length - 1; s >= 0; s--) (o = t[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(e, r, a) : o(e, r)) || a);
  return i > 3 && a && Object.defineProperty(e, r, a), a;
}
var cU = function t(e, r) {
  if (e === r) return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    if (e.constructor !== r.constructor) return !1;
    var n, i, a;
    if (Array.isArray(e)) {
      if (n = e.length, n != r.length) return !1;
      for (i = n; i-- !== 0; )
        if (!t(e[i], r[i])) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === r.source && e.flags === r.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === r.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === r.toString();
    if (a = Object.keys(e), n = a.length, n !== Object.keys(r).length) return !1;
    for (i = n; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, a[i])) return !1;
    for (i = n; i-- !== 0; ) {
      var o = a[i];
      if (!t(e[o], r[o])) return !1;
    }
    return !0;
  }
  return e !== e && r !== r;
};
const fy = /* @__PURE__ */ On(cU);
var Sh = {};
Sh.byteLength = hU;
Sh.toByteArray = mU;
Sh.fromByteArray = bU;
var Vo = [], va = [], fU = typeof Uint8Array < "u" ? Uint8Array : Array, Dg = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var Cf = 0, dU = Dg.length; Cf < dU; ++Cf)
  Vo[Cf] = Dg[Cf], va[Dg.charCodeAt(Cf)] = Cf;
va[45] = 62;
va[95] = 63;
function QA(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = t.indexOf("=");
  r === -1 && (r = e);
  var n = r === e ? 0 : 4 - r % 4;
  return [r, n];
}
function hU(t) {
  var e = QA(t), r = e[0], n = e[1];
  return (r + n) * 3 / 4 - n;
}
function pU(t, e, r) {
  return (e + r) * 3 / 4 - r;
}
function mU(t) {
  var e, r = QA(t), n = r[0], i = r[1], a = new fU(pU(t, n, i)), o = 0, s = i > 0 ? n - 4 : n, l;
  for (l = 0; l < s; l += 4)
    e = va[t.charCodeAt(l)] << 18 | va[t.charCodeAt(l + 1)] << 12 | va[t.charCodeAt(l + 2)] << 6 | va[t.charCodeAt(l + 3)], a[o++] = e >> 16 & 255, a[o++] = e >> 8 & 255, a[o++] = e & 255;
  return i === 2 && (e = va[t.charCodeAt(l)] << 2 | va[t.charCodeAt(l + 1)] >> 4, a[o++] = e & 255), i === 1 && (e = va[t.charCodeAt(l)] << 10 | va[t.charCodeAt(l + 1)] << 4 | va[t.charCodeAt(l + 2)] >> 2, a[o++] = e >> 8 & 255, a[o++] = e & 255), a;
}
function gU(t) {
  return Vo[t >> 18 & 63] + Vo[t >> 12 & 63] + Vo[t >> 6 & 63] + Vo[t & 63];
}
function vU(t, e, r) {
  for (var n, i = [], a = e; a < r; a += 3)
    n = (t[a] << 16 & 16711680) + (t[a + 1] << 8 & 65280) + (t[a + 2] & 255), i.push(gU(n));
  return i.join("");
}
function bU(t) {
  for (var e, r = t.length, n = r % 3, i = [], a = 16383, o = 0, s = r - n; o < s; o += a)
    i.push(vU(t, o, o + a > s ? s : o + a));
  return n === 1 ? (e = t[r - 1], i.push(
    Vo[e >> 2] + Vo[e << 4 & 63] + "=="
  )) : n === 2 && (e = (t[r - 2] << 8) + t[r - 1], i.push(
    Vo[e >> 10] + Vo[e >> 4 & 63] + Vo[e << 2 & 63] + "="
  )), i.join("");
}
var Cb = 0, eE = -3;
function Jd() {
  this.table = new Uint16Array(16), this.trans = new Uint16Array(288);
}
function xU(t, e) {
  this.source = t, this.sourceIndex = 0, this.tag = 0, this.bitcount = 0, this.dest = e, this.destLen = 0, this.ltree = new Jd(), this.dtree = new Jd();
}
var tE = new Jd(), rE = new Jd(), kb = new Uint8Array(30), Tb = new Uint16Array(30), nE = new Uint8Array(30), iE = new Uint16Array(30), yU = new Uint8Array([
  16,
  17,
  18,
  0,
  8,
  7,
  9,
  6,
  10,
  5,
  11,
  4,
  12,
  3,
  13,
  2,
  14,
  1,
  15
]), dy = new Jd(), Do = new Uint8Array(320);
function aE(t, e, r, n) {
  var i, a;
  for (i = 0; i < r; ++i) t[i] = 0;
  for (i = 0; i < 30 - r; ++i) t[i + r] = i / r | 0;
  for (a = n, i = 0; i < 30; ++i)
    e[i] = a, a += 1 << t[i];
}
function wU(t, e) {
  var r;
  for (r = 0; r < 7; ++r) t.table[r] = 0;
  for (t.table[7] = 24, t.table[8] = 152, t.table[9] = 112, r = 0; r < 24; ++r) t.trans[r] = 256 + r;
  for (r = 0; r < 144; ++r) t.trans[24 + r] = r;
  for (r = 0; r < 8; ++r) t.trans[168 + r] = 280 + r;
  for (r = 0; r < 112; ++r) t.trans[176 + r] = 144 + r;
  for (r = 0; r < 5; ++r) e.table[r] = 0;
  for (e.table[5] = 32, r = 0; r < 32; ++r) e.trans[r] = r;
}
var hy = new Uint16Array(16);
function Og(t, e, r, n) {
  var i, a;
  for (i = 0; i < 16; ++i) t.table[i] = 0;
  for (i = 0; i < n; ++i) t.table[e[r + i]]++;
  for (t.table[0] = 0, a = 0, i = 0; i < 16; ++i)
    hy[i] = a, a += t.table[i];
  for (i = 0; i < n; ++i)
    e[r + i] && (t.trans[hy[e[r + i]]++] = i);
}
function _U(t) {
  t.bitcount-- || (t.tag = t.source[t.sourceIndex++], t.bitcount = 7);
  var e = t.tag & 1;
  return t.tag >>>= 1, e;
}
function Mo(t, e, r) {
  if (!e)
    return r;
  for (; t.bitcount < 24; )
    t.tag |= t.source[t.sourceIndex++] << t.bitcount, t.bitcount += 8;
  var n = t.tag & 65535 >>> 16 - e;
  return t.tag >>>= e, t.bitcount -= e, n + r;
}
function u3(t, e) {
  for (; t.bitcount < 24; )
    t.tag |= t.source[t.sourceIndex++] << t.bitcount, t.bitcount += 8;
  var r = 0, n = 0, i = 0, a = t.tag;
  do
    n = 2 * n + (a & 1), a >>>= 1, ++i, r += e.table[i], n -= e.table[i];
  while (n >= 0);
  return t.tag = a, t.bitcount -= i, e.trans[r + n];
}
function AU(t, e, r) {
  var n, i, a, o, s, l;
  for (n = Mo(t, 5, 257), i = Mo(t, 5, 1), a = Mo(t, 4, 4), o = 0; o < 19; ++o) Do[o] = 0;
  for (o = 0; o < a; ++o) {
    var u = Mo(t, 3, 0);
    Do[yU[o]] = u;
  }
  for (Og(dy, Do, 0, 19), s = 0; s < n + i; ) {
    var d = u3(t, dy);
    switch (d) {
      case 16:
        var h = Do[s - 1];
        for (l = Mo(t, 2, 3); l; --l)
          Do[s++] = h;
        break;
      case 17:
        for (l = Mo(t, 3, 3); l; --l)
          Do[s++] = 0;
        break;
      case 18:
        for (l = Mo(t, 7, 11); l; --l)
          Do[s++] = 0;
        break;
      default:
        Do[s++] = d;
        break;
    }
  }
  Og(e, Do, 0, n), Og(r, Do, n, i);
}
function py(t, e, r) {
  for (; ; ) {
    var n = u3(t, e);
    if (n === 256)
      return Cb;
    if (n < 256)
      t.dest[t.destLen++] = n;
    else {
      var i, a, o, s;
      for (n -= 257, i = Mo(t, kb[n], Tb[n]), a = u3(t, r), o = t.destLen - Mo(t, nE[a], iE[a]), s = o; s < o + i; ++s)
        t.dest[t.destLen++] = t.dest[s];
    }
  }
}
function EU(t) {
  for (var e, r, n; t.bitcount > 8; )
    t.sourceIndex--, t.bitcount -= 8;
  if (e = t.source[t.sourceIndex + 1], e = 256 * e + t.source[t.sourceIndex], r = t.source[t.sourceIndex + 3], r = 256 * r + t.source[t.sourceIndex + 2], e !== (~r & 65535))
    return eE;
  for (t.sourceIndex += 4, n = e; n; --n)
    t.dest[t.destLen++] = t.source[t.sourceIndex++];
  return t.bitcount = 0, Cb;
}
function SU(t, e) {
  var r = new xU(t, e), n, i, a;
  do {
    switch (n = _U(r), i = Mo(r, 2, 0), i) {
      case 0:
        a = EU(r);
        break;
      case 1:
        a = py(r, tE, rE);
        break;
      case 2:
        AU(r, r.ltree, r.dtree), a = py(r, r.ltree, r.dtree);
        break;
      default:
        a = eE;
    }
    if (a !== Cb)
      throw new Error("Data error");
  } while (!n);
  return r.destLen < r.dest.length ? typeof r.dest.slice == "function" ? r.dest.slice(0, r.destLen) : r.dest.subarray(0, r.destLen) : r.dest;
}
wU(tE, rE);
aE(kb, Tb, 4, 3);
aE(nE, iE, 2, 1);
kb[28] = 0;
Tb[28] = 258;
var oE = SU;
const CU = /* @__PURE__ */ On(oE), kU = new Uint8Array(new Uint32Array([305419896]).buffer)[0] === 18, my = (t, e, r) => {
  let n = t[e];
  t[e] = t[r], t[r] = n;
}, TU = (t) => {
  const e = t.length;
  for (let r = 0; r < e; r += 4)
    my(t, r, r + 3), my(t, r + 1, r + 2);
}, FU = (t) => {
  kU && TU(t);
};
var DU = {
  swap32LE: FU
};
const gy = oE, { swap32LE: OU } = DU, Fb = 11, lc = 5, RU = Fb - lc, PU = 65536 >> Fb, IU = 1 << RU, BU = IU - 1, e5 = 2, LU = 1 << lc, Rg = LU - 1, sE = 65536 >> lc, NU = 1024 >> lc, MU = sE + NU, UU = MU, zU = 32, $U = UU + zU, VU = 1 << e5;
class jU {
  constructor(e) {
    const r = typeof e.readUInt32BE == "function" && typeof e.slice == "function";
    if (r || e instanceof Uint8Array) {
      let n;
      if (r)
        this.highStart = e.readUInt32LE(0), this.errorValue = e.readUInt32LE(4), n = e.readUInt32LE(8), e = e.slice(12);
      else {
        const i = new DataView(e.buffer);
        this.highStart = i.getUint32(0, !0), this.errorValue = i.getUint32(4, !0), n = i.getUint32(8, !0), e = e.subarray(12);
      }
      e = gy(e, new Uint8Array(n)), e = gy(e, new Uint8Array(n)), OU(e), this.data = new Uint32Array(e.buffer);
    } else
      ({ data: this.data, highStart: this.highStart, errorValue: this.errorValue } = e);
  }
  get(e) {
    let r;
    return e < 0 || e > 1114111 ? this.errorValue : e < 55296 || e > 56319 && e <= 65535 ? (r = (this.data[e >> lc] << e5) + (e & Rg), this.data[r]) : e <= 65535 ? (r = (this.data[sE + (e - 55296 >> lc)] << e5) + (e & Rg), this.data[r]) : e < this.highStart ? (r = this.data[$U - PU + (e >> Fb)], r = this.data[r + (e >> lc & BU)], r = (r << e5) + (e & Rg), this.data[r]) : this.data[this.data.length - VU];
  }
}
var WU = jU;
const Ch = /* @__PURE__ */ On(WU);
function Tc(t) {
  return t && t.__esModule ? t.default : t;
}
var lu = {};
lu = JSON.parse('{"categories":["Cc","Zs","Po","Sc","Ps","Pe","Sm","Pd","Nd","Lu","Sk","Pc","Ll","So","Lo","Pi","Cf","No","Pf","Lt","Lm","Mn","Me","Mc","Nl","Zl","Zp","Cs","Co"],"combiningClasses":["Not_Reordered","Above","Above_Right","Below","Attached_Above_Right","Attached_Below","Overlay","Iota_Subscript","Double_Below","Double_Above","Below_Right","Above_Left","CCC10","CCC11","CCC12","CCC13","CCC14","CCC15","CCC16","CCC17","CCC18","CCC19","CCC20","CCC21","CCC22","CCC23","CCC24","CCC25","CCC30","CCC31","CCC32","CCC27","CCC28","CCC29","CCC33","CCC34","CCC35","CCC36","Nukta","Virama","CCC84","CCC91","CCC103","CCC107","CCC118","CCC122","CCC129","CCC130","CCC132","Attached_Above","Below_Left","Left","Kana_Voicing","CCC26","Right"],"scripts":["Common","Latin","Bopomofo","Inherited","Greek","Coptic","Cyrillic","Armenian","Hebrew","Arabic","Syriac","Thaana","Nko","Samaritan","Mandaic","Devanagari","Bengali","Gurmukhi","Gujarati","Oriya","Tamil","Telugu","Kannada","Malayalam","Sinhala","Thai","Lao","Tibetan","Myanmar","Georgian","Hangul","Ethiopic","Cherokee","Canadian_Aboriginal","Ogham","Runic","Tagalog","Hanunoo","Buhid","Tagbanwa","Khmer","Mongolian","Limbu","Tai_Le","New_Tai_Lue","Buginese","Tai_Tham","Balinese","Sundanese","Batak","Lepcha","Ol_Chiki","Braille","Glagolitic","Tifinagh","Han","Hiragana","Katakana","Yi","Lisu","Vai","Bamum","Syloti_Nagri","Phags_Pa","Saurashtra","Kayah_Li","Rejang","Javanese","Cham","Tai_Viet","Meetei_Mayek","null","Linear_B","Lycian","Carian","Old_Italic","Gothic","Old_Permic","Ugaritic","Old_Persian","Deseret","Shavian","Osmanya","Osage","Elbasan","Caucasian_Albanian","Linear_A","Cypriot","Imperial_Aramaic","Palmyrene","Nabataean","Hatran","Phoenician","Lydian","Meroitic_Hieroglyphs","Meroitic_Cursive","Kharoshthi","Old_South_Arabian","Old_North_Arabian","Manichaean","Avestan","Inscriptional_Parthian","Inscriptional_Pahlavi","Psalter_Pahlavi","Old_Turkic","Old_Hungarian","Hanifi_Rohingya","Old_Sogdian","Sogdian","Elymaic","Brahmi","Kaithi","Sora_Sompeng","Chakma","Mahajani","Sharada","Khojki","Multani","Khudawadi","Grantha","Newa","Tirhuta","Siddham","Modi","Takri","Ahom","Dogra","Warang_Citi","Nandinagari","Zanabazar_Square","Soyombo","Pau_Cin_Hau","Bhaiksuki","Marchen","Masaram_Gondi","Gunjala_Gondi","Makasar","Cuneiform","Egyptian_Hieroglyphs","Anatolian_Hieroglyphs","Mro","Bassa_Vah","Pahawh_Hmong","Medefaidrin","Miao","Tangut","Nushu","Duployan","SignWriting","Nyiakeng_Puachue_Hmong","Wancho","Mende_Kikakui","Adlam"],"eaw":["N","Na","A","W","H","F"]}');
const Db = new Ch(Sh.toByteArray("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")), HU = Math.log2 || ((t) => Math.log(t) / Math.LN2), Up = (t) => HU(t) + 1 | 0, qU = Up((/* @__PURE__ */ Tc(lu)).categories.length - 1), lE = Up((/* @__PURE__ */ Tc(lu)).combiningClasses.length - 1), Ob = Up((/* @__PURE__ */ Tc(lu)).scripts.length - 1), Rb = Up((/* @__PURE__ */ Tc(lu)).eaw.length - 1), Pb = 10, YU = lE + Ob + Rb + Pb, GU = Ob + Rb + Pb, ZU = Rb + Pb, XU = (1 << qU) - 1, KU = (1 << lE) - 1, JU = (1 << Ob) - 1;
function zp(t) {
  const e = Db.get(t);
  return (/* @__PURE__ */ Tc(lu)).categories[e >> YU & XU];
}
function QU(t) {
  const e = Db.get(t);
  return (/* @__PURE__ */ Tc(lu)).combiningClasses[e >> GU & KU];
}
function uE(t) {
  const e = Db.get(t);
  return (/* @__PURE__ */ Tc(lu)).scripts[e >> ZU & JU];
}
function vy(t) {
  return zp(t) === "Nd";
}
function cE(t) {
  const e = zp(t);
  return e === "Mn" || e === "Me" || e === "Mc";
}
var Pg = 1, Ig = 0;
class ez {
  constructor(e) {
    this.stateTable = e.stateTable, this.accepting = e.accepting, this.tags = e.tags;
  }
  /**
   * Returns an iterable object that yields pattern matches over the input sequence.
   * Matches are of the form [startIndex, endIndex, tags].
   */
  match(e) {
    var r = this;
    return {
      *[Symbol.iterator]() {
        for (var n = Pg, i = null, a = null, o = null, s = 0; s < e.length; s++) {
          var l = e[s];
          o = n, n = r.stateTable[n][l], n === Ig && (i != null && a != null && a >= i && (yield [i, a, r.tags[o]]), n = r.stateTable[Pg][l], i = null), n !== Ig && i == null && (i = s), r.accepting[n] && (a = s), n === Ig && (n = Pg);
        }
        i != null && a != null && a >= i && (yield [i, a, r.tags[n]]);
      }
    };
  }
  /**
   * For each match over the input sequence, action functions matching
   * the tag definitions in the input pattern are called with the startIndex,
   * endIndex, and sub-match sequence.
   */
  apply(e, r) {
    for (var [n, i, a] of this.match(e))
      for (var o of a)
        typeof r[o] == "function" && r[o](n, i, e.slice(n, i + 1));
  }
}
var tz = ez;
const fE = /* @__PURE__ */ On(tz);
var dE = { exports: {} };
(function(t) {
  var e = function() {
    function r(v, b) {
      return b != null && v instanceof b;
    }
    var n;
    try {
      n = Map;
    } catch {
      n = function() {
      };
    }
    var i;
    try {
      i = Set;
    } catch {
      i = function() {
      };
    }
    var a;
    try {
      a = Promise;
    } catch {
      a = function() {
      };
    }
    function o(v, b, x, A, T) {
      typeof b == "object" && (x = b.depth, A = b.prototype, T = b.includeNonEnumerable, b = b.circular);
      var k = [], E = [], C = typeof Buffer < "u";
      typeof b > "u" && (b = !0), typeof x > "u" && (x = 1 / 0);
      function D(_, I) {
        if (_ === null)
          return null;
        if (I === 0)
          return _;
        var R, U;
        if (typeof _ != "object")
          return _;
        if (r(_, n))
          R = new n();
        else if (r(_, i))
          R = new i();
        else if (r(_, a))
          R = new a(function(Q, J) {
            _.then(function(se) {
              Q(D(se, I - 1));
            }, function(se) {
              J(D(se, I - 1));
            });
          });
        else if (o.__isArray(_))
          R = [];
        else if (o.__isRegExp(_))
          R = new RegExp(_.source, h(_)), _.lastIndex && (R.lastIndex = _.lastIndex);
        else if (o.__isDate(_))
          R = new Date(_.getTime());
        else {
          if (C && Buffer.isBuffer(_))
            return Buffer.allocUnsafe ? R = Buffer.allocUnsafe(_.length) : R = new Buffer(_.length), _.copy(R), R;
          r(_, Error) ? R = Object.create(_) : typeof A > "u" ? (U = Object.getPrototypeOf(_), R = Object.create(U)) : (R = Object.create(A), U = A);
        }
        if (b) {
          var V = k.indexOf(_);
          if (V != -1)
            return E[V];
          k.push(_), E.push(R);
        }
        r(_, n) && _.forEach(function(Q, J) {
          var se = D(J, I - 1), ae = D(Q, I - 1);
          R.set(se, ae);
        }), r(_, i) && _.forEach(function(Q) {
          var J = D(Q, I - 1);
          R.add(J);
        });
        for (var z in _) {
          var j;
          U && (j = Object.getOwnPropertyDescriptor(U, z)), !(j && j.set == null) && (R[z] = D(_[z], I - 1));
        }
        if (Object.getOwnPropertySymbols)
          for (var S = Object.getOwnPropertySymbols(_), z = 0; z < S.length; z++) {
            var B = S[z], q = Object.getOwnPropertyDescriptor(_, B);
            q && !q.enumerable && !T || (R[B] = D(_[B], I - 1), q.enumerable || Object.defineProperty(R, B, {
              enumerable: !1
            }));
          }
        if (T)
          for (var Y = Object.getOwnPropertyNames(_), z = 0; z < Y.length; z++) {
            var Z = Y[z], q = Object.getOwnPropertyDescriptor(_, Z);
            q && q.enumerable || (R[Z] = D(_[Z], I - 1), Object.defineProperty(R, Z, {
              enumerable: !1
            }));
          }
        return R;
      }
      return D(v, x);
    }
    o.clonePrototype = function(b) {
      if (b === null)
        return null;
      var x = function() {
      };
      return x.prototype = b, new x();
    };
    function s(v) {
      return Object.prototype.toString.call(v);
    }
    o.__objToStr = s;
    function l(v) {
      return typeof v == "object" && s(v) === "[object Date]";
    }
    o.__isDate = l;
    function u(v) {
      return typeof v == "object" && s(v) === "[object Array]";
    }
    o.__isArray = u;
    function d(v) {
      return typeof v == "object" && s(v) === "[object RegExp]";
    }
    o.__isRegExp = d;
    function h(v) {
      var b = "";
      return v.global && (b += "g"), v.ignoreCase && (b += "i"), v.multiline && (b += "m"), b;
    }
    return o.__getRegExpFlags = h, o;
  }();
  t.exports && (t.exports = e);
})(dE);
var rz = dE.exports;
const Bg = /* @__PURE__ */ On(rz);
var wd = {}, L5 = {};
function hE(t) {
  this.buffer = t, this.pos = 0;
}
hE.prototype.read = function(t, e, r) {
  this.pos + r > this.buffer.length && (r = this.buffer.length - this.pos);
  for (var n = 0; n < r; n++)
    t[e + n] = this.buffer[this.pos + n];
  return this.pos += r, r;
};
L5.BrotliInput = hE;
function pE(t) {
  this.buffer = t, this.pos = 0;
}
pE.prototype.write = function(t, e) {
  if (this.pos + e > this.buffer.length)
    throw new Error("Output buffer is not large enough");
  return this.buffer.set(t.subarray(0, e), this.pos), this.pos += e, e;
};
L5.BrotliOutput = pE;
var ju = 4096, nz = 2 * ju + 32, mE = 2 * ju - 1, iz = new Uint32Array([
  0,
  1,
  3,
  7,
  15,
  31,
  63,
  127,
  255,
  511,
  1023,
  2047,
  4095,
  8191,
  16383,
  32767,
  65535,
  131071,
  262143,
  524287,
  1048575,
  2097151,
  4194303,
  8388607,
  16777215
]);
function Fc(t) {
  this.buf_ = new Uint8Array(nz), this.input_ = t, this.reset();
}
Fc.READ_SIZE = ju;
Fc.IBUF_MASK = mE;
Fc.prototype.reset = function() {
  this.buf_ptr_ = 0, this.val_ = 0, this.pos_ = 0, this.bit_pos_ = 0, this.bit_end_pos_ = 0, this.eos_ = 0, this.readMoreInput();
  for (var t = 0; t < 4; t++)
    this.val_ |= this.buf_[this.pos_] << 8 * t, ++this.pos_;
  return this.bit_end_pos_ > 0;
};
Fc.prototype.readMoreInput = function() {
  if (!(this.bit_end_pos_ > 256))
    if (this.eos_) {
      if (this.bit_pos_ > this.bit_end_pos_)
        throw new Error("Unexpected end of input " + this.bit_pos_ + " " + this.bit_end_pos_);
    } else {
      var t = this.buf_ptr_, e = this.input_.read(this.buf_, t, ju);
      if (e < 0)
        throw new Error("Unexpected end of input");
      if (e < ju) {
        this.eos_ = 1;
        for (var r = 0; r < 32; r++)
          this.buf_[t + e + r] = 0;
      }
      if (t === 0) {
        for (var r = 0; r < 32; r++)
          this.buf_[(ju << 1) + r] = this.buf_[r];
        this.buf_ptr_ = ju;
      } else
        this.buf_ptr_ = 0;
      this.bit_end_pos_ += e << 3;
    }
};
Fc.prototype.fillBitWindow = function() {
  for (; this.bit_pos_ >= 8; )
    this.val_ >>>= 8, this.val_ |= this.buf_[this.pos_ & mE] << 24, ++this.pos_, this.bit_pos_ = this.bit_pos_ - 8 >>> 0, this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
};
Fc.prototype.readBits = function(t) {
  32 - this.bit_pos_ < t && this.fillBitWindow();
  var e = this.val_ >>> this.bit_pos_ & iz[t];
  return this.bit_pos_ += t, e;
};
var az = Fc, Cl = {}, Lg = {}, Ng, by;
function oz() {
  return by || (by = 1, Ng = "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"), Ng;
}
var xy;
function sz() {
  if (xy) return Lg;
  xy = 1;
  var t = Sh;
  return Lg.init = function() {
    var e = vE().BrotliDecompressBuffer, r = t.toByteArray(oz());
    return e(r);
  }, Lg;
}
var yy;
function gE() {
  if (yy) return Cl;
  yy = 1;
  var t = sz();
  return Cl.init = function() {
    Cl.dictionary = t.init();
  }, Cl.offsetsByLength = new Uint32Array([
    0,
    0,
    0,
    0,
    0,
    4096,
    9216,
    21504,
    35840,
    44032,
    53248,
    63488,
    74752,
    87040,
    93696,
    100864,
    104704,
    106752,
    108928,
    113536,
    115968,
    118528,
    119872,
    121280,
    122016
  ]), Cl.sizeBitsByLength = new Uint8Array([
    0,
    0,
    0,
    0,
    10,
    10,
    11,
    11,
    10,
    10,
    10,
    10,
    10,
    9,
    9,
    8,
    7,
    7,
    8,
    7,
    7,
    6,
    6,
    5,
    5
  ]), Cl.minDictionaryWordLength = 4, Cl.maxDictionaryWordLength = 24, Cl;
}
var N5 = {};
function zf(t, e) {
  this.bits = t, this.value = e;
}
N5.HuffmanCode = zf;
var Bf = 15;
function wy(t, e) {
  for (var r = 1 << e - 1; t & r; )
    r >>= 1;
  return (t & r - 1) + r;
}
function _y(t, e, r, n, i) {
  do
    n -= r, t[e + n] = new zf(i.bits, i.value);
  while (n > 0);
}
function lz(t, e, r) {
  for (var n = 1 << e - r; e < Bf && (n -= t[e], !(n <= 0)); )
    ++e, n <<= 1;
  return e - r;
}
N5.BrotliBuildHuffmanTable = function(t, e, r, n, i) {
  var a = e, o, s, l, u, d, h, v, b, x, A, T, k = new Int32Array(Bf + 1), E = new Int32Array(Bf + 1);
  for (T = new Int32Array(i), l = 0; l < i; l++)
    k[n[l]]++;
  for (E[1] = 0, s = 1; s < Bf; s++)
    E[s + 1] = E[s] + k[s];
  for (l = 0; l < i; l++)
    n[l] !== 0 && (T[E[n[l]]++] = l);
  if (b = r, x = 1 << b, A = x, E[Bf] === 1) {
    for (u = 0; u < A; ++u)
      t[e + u] = new zf(0, T[0] & 65535);
    return A;
  }
  for (u = 0, l = 0, s = 1, d = 2; s <= r; ++s, d <<= 1)
    for (; k[s] > 0; --k[s])
      o = new zf(s & 255, T[l++] & 65535), _y(t, e + u, d, x, o), u = wy(u, s);
  for (v = A - 1, h = -1, s = r + 1, d = 2; s <= Bf; ++s, d <<= 1)
    for (; k[s] > 0; --k[s])
      (u & v) !== h && (e += x, b = lz(k, s, r), x = 1 << b, A += x, h = u & v, t[a + h] = new zf(b + r & 255, e - a - h & 65535)), o = new zf(s - r & 255, T[l++] & 65535), _y(t, e + (u >> r), d, x, o), u = wy(u, s);
  return A;
};
var Ib = {};
Ib.lookup = new Uint8Array([
  /* CONTEXT_UTF8, last byte. */
  /* ASCII range. */
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  4,
  4,
  0,
  0,
  4,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  8,
  12,
  16,
  12,
  12,
  20,
  12,
  16,
  24,
  28,
  12,
  12,
  32,
  12,
  36,
  12,
  44,
  44,
  44,
  44,
  44,
  44,
  44,
  44,
  44,
  44,
  32,
  32,
  24,
  40,
  28,
  12,
  12,
  48,
  52,
  52,
  52,
  48,
  52,
  52,
  52,
  48,
  52,
  52,
  52,
  52,
  52,
  48,
  52,
  52,
  52,
  52,
  52,
  48,
  52,
  52,
  52,
  52,
  52,
  24,
  12,
  28,
  12,
  12,
  12,
  56,
  60,
  60,
  60,
  56,
  60,
  60,
  60,
  56,
  60,
  60,
  60,
  60,
  60,
  56,
  60,
  60,
  60,
  60,
  60,
  56,
  60,
  60,
  60,
  60,
  60,
  24,
  12,
  28,
  12,
  0,
  /* UTF8 continuation byte range. */
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  /* UTF8 lead byte range. */
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  /* CONTEXT_UTF8 second last byte. */
  /* ASCII range. */
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  1,
  1,
  1,
  1,
  1,
  1,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  1,
  1,
  1,
  1,
  0,
  /* UTF8 continuation byte range. */
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  /* UTF8 lead byte range. */
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  /* CONTEXT_SIGNED, second last byte. */
  0,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  7,
  /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */
  0,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  56,
  /* CONTEXT_LSB6, last byte. */
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  /* CONTEXT_MSB6, last byte. */
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  6,
  6,
  6,
  6,
  7,
  7,
  7,
  7,
  8,
  8,
  8,
  8,
  9,
  9,
  9,
  9,
  10,
  10,
  10,
  10,
  11,
  11,
  11,
  11,
  12,
  12,
  12,
  12,
  13,
  13,
  13,
  13,
  14,
  14,
  14,
  14,
  15,
  15,
  15,
  15,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  22,
  22,
  22,
  22,
  23,
  23,
  23,
  23,
  24,
  24,
  24,
  24,
  25,
  25,
  25,
  25,
  26,
  26,
  26,
  26,
  27,
  27,
  27,
  27,
  28,
  28,
  28,
  28,
  29,
  29,
  29,
  29,
  30,
  30,
  30,
  30,
  31,
  31,
  31,
  31,
  32,
  32,
  32,
  32,
  33,
  33,
  33,
  33,
  34,
  34,
  34,
  34,
  35,
  35,
  35,
  35,
  36,
  36,
  36,
  36,
  37,
  37,
  37,
  37,
  38,
  38,
  38,
  38,
  39,
  39,
  39,
  39,
  40,
  40,
  40,
  40,
  41,
  41,
  41,
  41,
  42,
  42,
  42,
  42,
  43,
  43,
  43,
  43,
  44,
  44,
  44,
  44,
  45,
  45,
  45,
  45,
  46,
  46,
  46,
  46,
  47,
  47,
  47,
  47,
  48,
  48,
  48,
  48,
  49,
  49,
  49,
  49,
  50,
  50,
  50,
  50,
  51,
  51,
  51,
  51,
  52,
  52,
  52,
  52,
  53,
  53,
  53,
  53,
  54,
  54,
  54,
  54,
  55,
  55,
  55,
  55,
  56,
  56,
  56,
  56,
  57,
  57,
  57,
  57,
  58,
  58,
  58,
  58,
  59,
  59,
  59,
  59,
  60,
  60,
  60,
  60,
  61,
  61,
  61,
  61,
  62,
  62,
  62,
  62,
  63,
  63,
  63,
  63,
  /* CONTEXT_{M,L}SB6, second last byte, */
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0
]);
Ib.lookupOffsets = new Uint16Array([
  /* CONTEXT_LSB6 */
  1024,
  1536,
  /* CONTEXT_MSB6 */
  1280,
  1536,
  /* CONTEXT_UTF8 */
  0,
  256,
  /* CONTEXT_SIGNED */
  768,
  512
]);
var y1 = {};
function nt(t, e) {
  this.offset = t, this.nbits = e;
}
y1.kBlockLengthPrefixCode = [
  new nt(1, 2),
  new nt(5, 2),
  new nt(9, 2),
  new nt(13, 2),
  new nt(17, 3),
  new nt(25, 3),
  new nt(33, 3),
  new nt(41, 3),
  new nt(49, 4),
  new nt(65, 4),
  new nt(81, 4),
  new nt(97, 4),
  new nt(113, 5),
  new nt(145, 5),
  new nt(177, 5),
  new nt(209, 5),
  new nt(241, 6),
  new nt(305, 6),
  new nt(369, 7),
  new nt(497, 8),
  new nt(753, 9),
  new nt(1265, 10),
  new nt(2289, 11),
  new nt(4337, 12),
  new nt(8433, 13),
  new nt(16625, 24)
];
y1.kInsertLengthPrefixCode = [
  new nt(0, 0),
  new nt(1, 0),
  new nt(2, 0),
  new nt(3, 0),
  new nt(4, 0),
  new nt(5, 0),
  new nt(6, 1),
  new nt(8, 1),
  new nt(10, 2),
  new nt(14, 2),
  new nt(18, 3),
  new nt(26, 3),
  new nt(34, 4),
  new nt(50, 4),
  new nt(66, 5),
  new nt(98, 5),
  new nt(130, 6),
  new nt(194, 7),
  new nt(322, 8),
  new nt(578, 9),
  new nt(1090, 10),
  new nt(2114, 12),
  new nt(6210, 14),
  new nt(22594, 24)
];
y1.kCopyLengthPrefixCode = [
  new nt(2, 0),
  new nt(3, 0),
  new nt(4, 0),
  new nt(5, 0),
  new nt(6, 0),
  new nt(7, 0),
  new nt(8, 0),
  new nt(9, 0),
  new nt(10, 1),
  new nt(12, 1),
  new nt(14, 2),
  new nt(18, 2),
  new nt(22, 3),
  new nt(30, 3),
  new nt(38, 4),
  new nt(54, 4),
  new nt(70, 5),
  new nt(102, 5),
  new nt(134, 6),
  new nt(198, 7),
  new nt(326, 8),
  new nt(582, 9),
  new nt(1094, 10),
  new nt(2118, 24)
];
y1.kInsertRangeLut = [
  0,
  0,
  8,
  8,
  0,
  16,
  8,
  16,
  16
];
y1.kCopyRangeLut = [
  0,
  8,
  0,
  8,
  16,
  0,
  16,
  8,
  16
];
var _d = {}, Ay;
function uz() {
  if (Ay) return _d;
  Ay = 1;
  var t = gE(), e = 0, r = 1, n = 2, i = 3, a = 4, o = 5, s = 6, l = 7, u = 8, d = 9, h = 10, v = 11, b = 12, x = 13, A = 14, T = 15, k = 16, E = 17, C = 18, D = 20;
  function _(U, V, z) {
    this.prefix = new Uint8Array(U.length), this.transform = V, this.suffix = new Uint8Array(z.length);
    for (var j = 0; j < U.length; j++)
      this.prefix[j] = U.charCodeAt(j);
    for (var j = 0; j < z.length; j++)
      this.suffix[j] = z.charCodeAt(j);
  }
  var I = [
    new _("", e, ""),
    new _("", e, " "),
    new _(" ", e, " "),
    new _("", b, ""),
    new _("", h, " "),
    new _("", e, " the "),
    new _(" ", e, ""),
    new _("s ", e, " "),
    new _("", e, " of "),
    new _("", h, ""),
    new _("", e, " and "),
    new _("", x, ""),
    new _("", r, ""),
    new _(", ", e, " "),
    new _("", e, ", "),
    new _(" ", h, " "),
    new _("", e, " in "),
    new _("", e, " to "),
    new _("e ", e, " "),
    new _("", e, '"'),
    new _("", e, "."),
    new _("", e, '">'),
    new _("", e, `
`),
    new _("", i, ""),
    new _("", e, "]"),
    new _("", e, " for "),
    new _("", A, ""),
    new _("", n, ""),
    new _("", e, " a "),
    new _("", e, " that "),
    new _(" ", h, ""),
    new _("", e, ". "),
    new _(".", e, ""),
    new _(" ", e, ", "),
    new _("", T, ""),
    new _("", e, " with "),
    new _("", e, "'"),
    new _("", e, " from "),
    new _("", e, " by "),
    new _("", k, ""),
    new _("", E, ""),
    new _(" the ", e, ""),
    new _("", a, ""),
    new _("", e, ". The "),
    new _("", v, ""),
    new _("", e, " on "),
    new _("", e, " as "),
    new _("", e, " is "),
    new _("", l, ""),
    new _("", r, "ing "),
    new _("", e, `
	`),
    new _("", e, ":"),
    new _(" ", e, ". "),
    new _("", e, "ed "),
    new _("", D, ""),
    new _("", C, ""),
    new _("", s, ""),
    new _("", e, "("),
    new _("", h, ", "),
    new _("", u, ""),
    new _("", e, " at "),
    new _("", e, "ly "),
    new _(" the ", e, " of "),
    new _("", o, ""),
    new _("", d, ""),
    new _(" ", h, ", "),
    new _("", h, '"'),
    new _(".", e, "("),
    new _("", v, " "),
    new _("", h, '">'),
    new _("", e, '="'),
    new _(" ", e, "."),
    new _(".com/", e, ""),
    new _(" the ", e, " of the "),
    new _("", h, "'"),
    new _("", e, ". This "),
    new _("", e, ","),
    new _(".", e, " "),
    new _("", h, "("),
    new _("", h, "."),
    new _("", e, " not "),
    new _(" ", e, '="'),
    new _("", e, "er "),
    new _(" ", v, " "),
    new _("", e, "al "),
    new _(" ", v, ""),
    new _("", e, "='"),
    new _("", v, '"'),
    new _("", h, ". "),
    new _(" ", e, "("),
    new _("", e, "ful "),
    new _(" ", h, ". "),
    new _("", e, "ive "),
    new _("", e, "less "),
    new _("", v, "'"),
    new _("", e, "est "),
    new _(" ", h, "."),
    new _("", v, '">'),
    new _(" ", e, "='"),
    new _("", h, ","),
    new _("", e, "ize "),
    new _("", v, "."),
    new _("Â ", e, ""),
    new _(" ", e, ","),
    new _("", h, '="'),
    new _("", v, '="'),
    new _("", e, "ous "),
    new _("", v, ", "),
    new _("", h, "='"),
    new _(" ", h, ","),
    new _(" ", v, '="'),
    new _(" ", v, ", "),
    new _("", v, ","),
    new _("", v, "("),
    new _("", v, ". "),
    new _(" ", v, "."),
    new _("", v, "='"),
    new _(" ", v, ". "),
    new _(" ", h, '="'),
    new _(" ", v, "='"),
    new _(" ", h, "='")
  ];
  _d.kTransforms = I, _d.kNumTransforms = I.length;
  function R(U, V) {
    return U[V] < 192 ? (U[V] >= 97 && U[V] <= 122 && (U[V] ^= 32), 1) : U[V] < 224 ? (U[V + 1] ^= 32, 2) : (U[V + 2] ^= 5, 3);
  }
  return _d.transformDictionaryWord = function(U, V, z, j, S) {
    var B = I[S].prefix, q = I[S].suffix, Y = I[S].transform, Z = Y < b ? 0 : Y - (b - 1), Q = 0, J = V, se;
    Z > j && (Z = j);
    for (var ae = 0; ae < B.length; )
      U[V++] = B[ae++];
    for (z += Z, j -= Z, Y <= d && (j -= Y), Q = 0; Q < j; Q++)
      U[V++] = t.dictionary[z + Q];
    if (se = V - j, Y === h)
      R(U, se);
    else if (Y === v)
      for (; j > 0; ) {
        var te = R(U, se);
        se += te, j -= te;
      }
    for (var ne = 0; ne < q.length; )
      U[V++] = q[ne++];
    return V - J;
  }, _d;
}
var Ey;
function vE() {
  if (Ey) return wd;
  Ey = 1;
  var t = L5.BrotliInput, e = L5.BrotliOutput, r = az, n = gE(), i = N5.HuffmanCode, a = N5.BrotliBuildHuffmanTable, o = Ib, s = y1, l = uz(), u = 8, d = 16, h = 256, v = 704, b = 26, x = 6, A = 2, T = 8, k = 255, E = 1080, C = 18, D = new Uint8Array([
    1,
    2,
    3,
    4,
    0,
    5,
    17,
    6,
    16,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15
  ]), _ = 16, I = new Uint8Array([
    3,
    2,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    2
  ]), R = new Int8Array([
    0,
    0,
    0,
    0,
    -1,
    1,
    -2,
    2,
    -3,
    3,
    -1,
    1,
    -2,
    2,
    -3,
    3
  ]), U = new Uint16Array([
    256,
    402,
    436,
    468,
    500,
    534,
    566,
    598,
    630,
    662,
    694,
    726,
    758,
    790,
    822,
    854,
    886,
    920,
    952,
    984,
    1016,
    1048,
    1080
  ]);
  function V(fe) {
    var ye;
    return fe.readBits(1) === 0 ? 16 : (ye = fe.readBits(3), ye > 0 ? 17 + ye : (ye = fe.readBits(3), ye > 0 ? 8 + ye : 17));
  }
  function z(fe) {
    if (fe.readBits(1)) {
      var ye = fe.readBits(3);
      return ye === 0 ? 1 : fe.readBits(ye) + (1 << ye);
    }
    return 0;
  }
  function j() {
    this.meta_block_length = 0, this.input_end = 0, this.is_uncompressed = 0, this.is_metadata = !1;
  }
  function S(fe) {
    var ye = new j(), be, he, Ge;
    if (ye.input_end = fe.readBits(1), ye.input_end && fe.readBits(1))
      return ye;
    if (be = fe.readBits(2) + 4, be === 7) {
      if (ye.is_metadata = !0, fe.readBits(1) !== 0)
        throw new Error("Invalid reserved bit");
      if (he = fe.readBits(2), he === 0)
        return ye;
      for (Ge = 0; Ge < he; Ge++) {
        var $e = fe.readBits(8);
        if (Ge + 1 === he && he > 1 && $e === 0)
          throw new Error("Invalid size byte");
        ye.meta_block_length |= $e << Ge * 8;
      }
    } else
      for (Ge = 0; Ge < be; ++Ge) {
        var Ve = fe.readBits(4);
        if (Ge + 1 === be && be > 4 && Ve === 0)
          throw new Error("Invalid size nibble");
        ye.meta_block_length |= Ve << Ge * 4;
      }
    return ++ye.meta_block_length, !ye.input_end && !ye.is_metadata && (ye.is_uncompressed = fe.readBits(1)), ye;
  }
  function B(fe, ye, be) {
    var he;
    return be.fillBitWindow(), ye += be.val_ >>> be.bit_pos_ & k, he = fe[ye].bits - T, he > 0 && (be.bit_pos_ += T, ye += fe[ye].value, ye += be.val_ >>> be.bit_pos_ & (1 << he) - 1), be.bit_pos_ += fe[ye].bits, fe[ye].value;
  }
  function q(fe, ye, be, he) {
    for (var Ge = 0, $e = u, Ve = 0, Ze = 0, wt = 32768, et = [], W = 0; W < 32; W++)
      et.push(new i(0, 0));
    for (a(et, 0, 5, fe, C); Ge < ye && wt > 0; ) {
      var ee = 0, le;
      if (he.readMoreInput(), he.fillBitWindow(), ee += he.val_ >>> he.bit_pos_ & 31, he.bit_pos_ += et[ee].bits, le = et[ee].value & 255, le < d)
        Ve = 0, be[Ge++] = le, le !== 0 && ($e = le, wt -= 32768 >> le);
      else {
        var me = le - 14, Ee, ve, Te = 0;
        if (le === d && (Te = $e), Ze !== Te && (Ve = 0, Ze = Te), Ee = Ve, Ve > 0 && (Ve -= 2, Ve <<= me), Ve += he.readBits(me) + 3, ve = Ve - Ee, Ge + ve > ye)
          throw new Error("[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols");
        for (var Pe = 0; Pe < ve; Pe++)
          be[Ge + Pe] = Ze;
        Ge += ve, Ze !== 0 && (wt -= ve << 15 - Ze);
      }
    }
    if (wt !== 0)
      throw new Error("[ReadHuffmanCodeLengths] space = " + wt);
    for (; Ge < ye; Ge++)
      be[Ge] = 0;
  }
  function Y(fe, ye, be, he) {
    var Ge = 0, $e, Ve = new Uint8Array(fe);
    if (he.readMoreInput(), $e = he.readBits(2), $e === 1) {
      for (var Ze, wt = fe - 1, et = 0, W = new Int32Array(4), ee = he.readBits(2) + 1; wt; )
        wt >>= 1, ++et;
      for (Ze = 0; Ze < ee; ++Ze)
        W[Ze] = he.readBits(et) % fe, Ve[W[Ze]] = 2;
      switch (Ve[W[0]] = 1, ee) {
        case 1:
          break;
        case 3:
          if (W[0] === W[1] || W[0] === W[2] || W[1] === W[2])
            throw new Error("[ReadHuffmanCode] invalid symbols");
          break;
        case 2:
          if (W[0] === W[1])
            throw new Error("[ReadHuffmanCode] invalid symbols");
          Ve[W[1]] = 1;
          break;
        case 4:
          if (W[0] === W[1] || W[0] === W[2] || W[0] === W[3] || W[1] === W[2] || W[1] === W[3] || W[2] === W[3])
            throw new Error("[ReadHuffmanCode] invalid symbols");
          he.readBits(1) ? (Ve[W[2]] = 3, Ve[W[3]] = 3) : Ve[W[0]] = 2;
          break;
      }
    } else {
      var Ze, le = new Uint8Array(C), me = 32, Ee = 0, ve = [
        new i(2, 0),
        new i(2, 4),
        new i(2, 3),
        new i(3, 2),
        new i(2, 0),
        new i(2, 4),
        new i(2, 3),
        new i(4, 1),
        new i(2, 0),
        new i(2, 4),
        new i(2, 3),
        new i(3, 2),
        new i(2, 0),
        new i(2, 4),
        new i(2, 3),
        new i(4, 5)
      ];
      for (Ze = $e; Ze < C && me > 0; ++Ze) {
        var Te = D[Ze], Pe = 0, at;
        he.fillBitWindow(), Pe += he.val_ >>> he.bit_pos_ & 15, he.bit_pos_ += ve[Pe].bits, at = ve[Pe].value, le[Te] = at, at !== 0 && (me -= 32 >> at, ++Ee);
      }
      if (!(Ee === 1 || me === 0))
        throw new Error("[ReadHuffmanCode] invalid num_codes or space");
      q(le, fe, Ve, he);
    }
    if (Ge = a(ye, be, T, Ve, fe), Ge === 0)
      throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
    return Ge;
  }
  function Z(fe, ye, be) {
    var he, Ge;
    return he = B(fe, ye, be), Ge = s.kBlockLengthPrefixCode[he].nbits, s.kBlockLengthPrefixCode[he].offset + be.readBits(Ge);
  }
  function Q(fe, ye, be) {
    var he;
    return fe < _ ? (be += I[fe], be &= 3, he = ye[be] + R[fe]) : he = fe - _ + 1, he;
  }
  function J(fe, ye) {
    for (var be = fe[ye], he = ye; he; --he) fe[he] = fe[he - 1];
    fe[0] = be;
  }
  function se(fe, ye) {
    var be = new Uint8Array(256), he;
    for (he = 0; he < 256; ++he)
      be[he] = he;
    for (he = 0; he < ye; ++he) {
      var Ge = fe[he];
      fe[he] = be[Ge], Ge && J(be, Ge);
    }
  }
  function ae(fe, ye) {
    this.alphabet_size = fe, this.num_htrees = ye, this.codes = new Array(ye + ye * U[fe + 31 >>> 5]), this.htrees = new Uint32Array(ye);
  }
  ae.prototype.decode = function(fe) {
    var ye, be, he = 0;
    for (ye = 0; ye < this.num_htrees; ++ye)
      this.htrees[ye] = he, be = Y(this.alphabet_size, this.codes, he, fe), he += be;
  };
  function te(fe, ye) {
    var be = { num_htrees: null, context_map: null }, he, Ge = 0, $e, Ve;
    ye.readMoreInput();
    var Ze = be.num_htrees = z(ye) + 1, wt = be.context_map = new Uint8Array(fe);
    if (Ze <= 1)
      return be;
    for (he = ye.readBits(1), he && (Ge = ye.readBits(4) + 1), $e = [], Ve = 0; Ve < E; Ve++)
      $e[Ve] = new i(0, 0);
    for (Y(Ze + Ge, $e, 0, ye), Ve = 0; Ve < fe; ) {
      var et;
      if (ye.readMoreInput(), et = B($e, 0, ye), et === 0)
        wt[Ve] = 0, ++Ve;
      else if (et <= Ge)
        for (var W = 1 + (1 << et) + ye.readBits(et); --W; ) {
          if (Ve >= fe)
            throw new Error("[DecodeContextMap] i >= context_map_size");
          wt[Ve] = 0, ++Ve;
        }
      else
        wt[Ve] = et - Ge, ++Ve;
    }
    return ye.readBits(1) && se(wt, fe), be;
  }
  function ne(fe, ye, be, he, Ge, $e, Ve) {
    var Ze = be * 2, wt = be, et = B(ye, be * E, Ve), W;
    et === 0 ? W = Ge[Ze + ($e[wt] & 1)] : et === 1 ? W = Ge[Ze + ($e[wt] - 1 & 1)] + 1 : W = et - 2, W >= fe && (W -= fe), he[be] = W, Ge[Ze + ($e[wt] & 1)] = W, ++$e[wt];
  }
  function ce(fe, ye, be, he, Ge, $e) {
    var Ve = Ge + 1, Ze = be & Ge, wt = $e.pos_ & r.IBUF_MASK, et;
    if (ye < 8 || $e.bit_pos_ + (ye << 3) < $e.bit_end_pos_) {
      for (; ye-- > 0; )
        $e.readMoreInput(), he[Ze++] = $e.readBits(8), Ze === Ve && (fe.write(he, Ve), Ze = 0);
      return;
    }
    if ($e.bit_end_pos_ < 32)
      throw new Error("[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32");
    for (; $e.bit_pos_ < 32; )
      he[Ze] = $e.val_ >>> $e.bit_pos_, $e.bit_pos_ += 8, ++Ze, --ye;
    if (et = $e.bit_end_pos_ - $e.bit_pos_ >> 3, wt + et > r.IBUF_MASK) {
      for (var W = r.IBUF_MASK + 1 - wt, ee = 0; ee < W; ee++)
        he[Ze + ee] = $e.buf_[wt + ee];
      et -= W, Ze += W, ye -= W, wt = 0;
    }
    for (var ee = 0; ee < et; ee++)
      he[Ze + ee] = $e.buf_[wt + ee];
    if (Ze += et, ye -= et, Ze >= Ve) {
      fe.write(he, Ve), Ze -= Ve;
      for (var ee = 0; ee < Ze; ee++)
        he[ee] = he[Ve + ee];
    }
    for (; Ze + ye >= Ve; ) {
      if (et = Ve - Ze, $e.input_.read(he, Ze, et) < et)
        throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
      fe.write(he, Ve), ye -= et, Ze = 0;
    }
    if ($e.input_.read(he, Ze, ye) < ye)
      throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
    $e.reset();
  }
  function pe(fe) {
    var ye = fe.bit_pos_ + 7 & -8, be = fe.readBits(ye - fe.bit_pos_);
    return be == 0;
  }
  function Me(fe) {
    var ye = new t(fe), be = new r(ye);
    V(be);
    var he = S(be);
    return he.meta_block_length;
  }
  wd.BrotliDecompressedSize = Me;
  function Ne(fe, ye) {
    var be = new t(fe);
    ye == null && (ye = Me(fe));
    var he = new Uint8Array(ye), Ge = new e(he);
    return it(be, Ge), Ge.pos < Ge.buffer.length && (Ge.buffer = Ge.buffer.subarray(0, Ge.pos)), Ge.buffer;
  }
  wd.BrotliDecompressBuffer = Ne;
  function it(fe, ye) {
    var be, he = 0, Ge = 0, $e = 0, Ve, Ze = 0, wt, et, W, ee, le = [16, 15, 11, 4], me = 0, Ee = 0, ve = 0, Te = [new ae(0, 0), new ae(0, 0), new ae(0, 0)], Pe, at, Ue, rt = 128 + r.READ_SIZE;
    Ue = new r(fe), $e = V(Ue), Ve = (1 << $e) - 16, wt = 1 << $e, et = wt - 1, W = new Uint8Array(wt + rt + n.maxDictionaryWordLength), ee = wt, Pe = [], at = [];
    for (var gt = 0; gt < 3 * E; gt++)
      Pe[gt] = new i(0, 0), at[gt] = new i(0, 0);
    for (; !Ge; ) {
      var _t = 0, Bt, At = [1 << 28, 1 << 28, 1 << 28], Tt = [0], Je = [1, 1, 1], ot = [0, 1, 0, 1, 0, 1], R0 = [0], b0, ir, a0, e0, kr = null, br = null, Br, Mt = null, Rt, tt = 0, yt = null, q0 = 0, L0 = 0, qe = null, mt = 0, lt = 0, Vt = 0, t0, Q0;
      for (be = 0; be < 3; ++be)
        Te[be].codes = null, Te[be].htrees = null;
      Ue.readMoreInput();
      var E0 = S(Ue);
      if (_t = E0.meta_block_length, he + _t > ye.buffer.length) {
        var S0 = new Uint8Array(he + _t);
        S0.set(ye.buffer), ye.buffer = S0;
      }
      if (Ge = E0.input_end, Bt = E0.is_uncompressed, E0.is_metadata) {
        for (pe(Ue); _t > 0; --_t)
          Ue.readMoreInput(), Ue.readBits(8);
        continue;
      }
      if (_t !== 0) {
        if (Bt) {
          Ue.bit_pos_ = Ue.bit_pos_ + 7 & -8, ce(
            ye,
            _t,
            he,
            W,
            et,
            Ue
          ), he += _t;
          continue;
        }
        for (be = 0; be < 3; ++be)
          Je[be] = z(Ue) + 1, Je[be] >= 2 && (Y(Je[be] + 2, Pe, be * E, Ue), Y(b, at, be * E, Ue), At[be] = Z(at, be * E, Ue), R0[be] = 1);
        for (Ue.readMoreInput(), b0 = Ue.readBits(2), ir = _ + (Ue.readBits(4) << b0), a0 = (1 << b0) - 1, e0 = ir + (48 << b0), br = new Uint8Array(Je[0]), be = 0; be < Je[0]; ++be)
          Ue.readMoreInput(), br[be] = Ue.readBits(2) << 1;
        var N0 = te(Je[0] << x, Ue);
        Br = N0.num_htrees, kr = N0.context_map;
        var Gt = te(Je[2] << A, Ue);
        for (Rt = Gt.num_htrees, Mt = Gt.context_map, Te[0] = new ae(h, Br), Te[1] = new ae(v, Je[1]), Te[2] = new ae(e0, Rt), be = 0; be < 3; ++be)
          Te[be].decode(Ue);
        for (yt = 0, qe = 0, t0 = br[Tt[0]], lt = o.lookupOffsets[t0], Vt = o.lookupOffsets[t0 + 1], Q0 = Te[1].htrees[0]; _t > 0; ) {
          var M0, gn, Pi, xr, vn, Y0, h0, Tr, Ut, U0, ar;
          for (Ue.readMoreInput(), At[1] === 0 && (ne(
            Je[1],
            Pe,
            1,
            Tt,
            ot,
            R0,
            Ue
          ), At[1] = Z(at, E, Ue), Q0 = Te[1].htrees[Tt[1]]), --At[1], M0 = B(Te[1].codes, Q0, Ue), gn = M0 >> 6, gn >= 2 ? (gn -= 2, h0 = -1) : h0 = 0, Pi = s.kInsertRangeLut[gn] + (M0 >> 3 & 7), xr = s.kCopyRangeLut[gn] + (M0 & 7), vn = s.kInsertLengthPrefixCode[Pi].offset + Ue.readBits(s.kInsertLengthPrefixCode[Pi].nbits), Y0 = s.kCopyLengthPrefixCode[xr].offset + Ue.readBits(s.kCopyLengthPrefixCode[xr].nbits), Ee = W[he - 1 & et], ve = W[he - 2 & et], U0 = 0; U0 < vn; ++U0)
            Ue.readMoreInput(), At[0] === 0 && (ne(
              Je[0],
              Pe,
              0,
              Tt,
              ot,
              R0,
              Ue
            ), At[0] = Z(at, 0, Ue), tt = Tt[0] << x, yt = tt, t0 = br[Tt[0]], lt = o.lookupOffsets[t0], Vt = o.lookupOffsets[t0 + 1]), Ut = o.lookup[lt + Ee] | o.lookup[Vt + ve], q0 = kr[yt + Ut], --At[0], ve = Ee, Ee = B(Te[0].codes, Te[0].htrees[q0], Ue), W[he & et] = Ee, (he & et) === et && ye.write(W, wt), ++he;
          if (_t -= vn, _t <= 0) break;
          if (h0 < 0) {
            var Ut;
            if (Ue.readMoreInput(), At[2] === 0 && (ne(
              Je[2],
              Pe,
              2,
              Tt,
              ot,
              R0,
              Ue
            ), At[2] = Z(at, 2 * E, Ue), L0 = Tt[2] << A, qe = L0), --At[2], Ut = (Y0 > 4 ? 3 : Y0 - 2) & 255, mt = Mt[qe + Ut], h0 = B(Te[2].codes, Te[2].htrees[mt], Ue), h0 >= ir) {
              var ct, Jr, P0;
              h0 -= ir, Jr = h0 & a0, h0 >>= b0, ct = (h0 >> 1) + 1, P0 = (2 + (h0 & 1) << ct) - 4, h0 = ir + (P0 + Ue.readBits(ct) << b0) + Jr;
            }
          }
          if (Tr = Q(h0, le, me), Tr < 0)
            throw new Error("[BrotliDecompress] invalid distance");
          if (he < Ve && Ze !== Ve ? Ze = he : Ze = Ve, ar = he & et, Tr > Ze)
            if (Y0 >= n.minDictionaryWordLength && Y0 <= n.maxDictionaryWordLength) {
              var P0 = n.offsetsByLength[Y0], Bn = Tr - Ze - 1, bn = n.sizeBitsByLength[Y0], Ln = (1 << bn) - 1, Ii = Bn & Ln, Yn = Bn >> bn;
              if (P0 += Ii * Y0, Yn < l.kNumTransforms) {
                var fi = l.transformDictionaryWord(W, ar, P0, Y0, Yn);
                if (ar += fi, he += fi, _t -= fi, ar >= ee) {
                  ye.write(W, wt);
                  for (var di = 0; di < ar - ee; di++)
                    W[di] = W[ee + di];
                }
              } else
                throw new Error("Invalid backward reference. pos: " + he + " distance: " + Tr + " len: " + Y0 + " bytes left: " + _t);
            } else
              throw new Error("Invalid backward reference. pos: " + he + " distance: " + Tr + " len: " + Y0 + " bytes left: " + _t);
          else {
            if (h0 > 0 && (le[me & 3] = Tr, ++me), Y0 > _t)
              throw new Error("Invalid backward reference. pos: " + he + " distance: " + Tr + " len: " + Y0 + " bytes left: " + _t);
            for (U0 = 0; U0 < Y0; ++U0)
              W[he & et] = W[he - Tr & et], (he & et) === et && ye.write(W, wt), ++he, --_t;
          }
          Ee = W[he - 1 & et], ve = W[he - 2 & et];
        }
        he &= 1073741823;
      }
    }
    ye.write(W, he & et);
  }
  return wd.BrotliDecompress = it, n.init(), wd;
}
var cz = vE().BrotliDecompressBuffer;
const fz = /* @__PURE__ */ On(cz);
function kh(t, e, r, n) {
  Object.defineProperty(t, e, { get: r, set: n, enumerable: !0, configurable: !0 });
}
function $p(t) {
  return t && t.__esModule ? t.default : t;
}
var Th = {};
kh(Th, "logErrors", () => dz);
kh(Th, "registerFormat", () => w1);
kh(Th, "create", () => Qd);
kh(Th, "defaultLanguage", () => M5);
kh(Th, "setDefaultLanguage", () => hz);
let dz = !1, c3 = [];
function w1(t) {
  c3.push(t);
}
function Qd(t, e) {
  for (let r = 0; r < c3.length; r++) {
    let n = c3[r];
    if (n.probe(t)) {
      let i = new n(new Tn(t));
      return e ? i.getFont(e) : i;
    }
  }
  throw new Error("Unknown font format");
}
let M5 = "en";
function hz(t = "en") {
  M5 = t;
}
function In(t, e, r) {
  if (r.get) {
    let n = r.get;
    r.get = function() {
      let i = n.call(this);
      return Object.defineProperty(this, e, {
        value: i
      }), i;
    };
  } else if (typeof r.value == "function") {
    let n = r.value;
    return {
      get() {
        let i = /* @__PURE__ */ new Map();
        function a(...o) {
          let s = o.length > 0 ? o[0] : "value";
          if (i.has(s)) return i.get(s);
          let l = n.apply(this, o);
          return i.set(s, l), l;
        }
        return Object.defineProperty(this, e, {
          value: a
        }), a;
      }
    };
  }
}
let pz = new xe({
  firstCode: F,
  entryCount: F,
  idDelta: Be,
  idRangeOffset: F
}), Mg = new xe({
  startCharCode: ge,
  endCharCode: ge,
  glyphID: ge
}), mz = new xe({
  startUnicodeValue: Kl,
  additionalCount: ze
}), gz = new xe({
  unicodeValue: Kl,
  glyphID: F
}), vz = new ue(mz, ge), bz = new ue(gz, ge), xz = new xe({
  varSelector: Kl,
  defaultUVS: new de(ge, vz, {
    type: "parent"
  }),
  nonDefaultUVS: new de(ge, bz, {
    type: "parent"
  })
}), yz = new qt(F, {
  0: {
    length: F,
    language: F,
    codeMap: new j0(ze, 256)
  },
  2: {
    length: F,
    language: F,
    subHeaderKeys: new ue(F, 256),
    subHeaderCount: (t) => Math.max.apply(Math, t.subHeaderKeys),
    subHeaders: new j0(pz, "subHeaderCount"),
    glyphIndexArray: new j0(F, "subHeaderCount")
  },
  4: {
    length: F,
    language: F,
    segCountX2: F,
    segCount: (t) => t.segCountX2 >> 1,
    searchRange: F,
    entrySelector: F,
    rangeShift: F,
    endCode: new j0(F, "segCount"),
    reservedPad: new J0(F),
    startCode: new j0(F, "segCount"),
    idDelta: new j0(Be, "segCount"),
    idRangeOffset: new j0(F, "segCount"),
    glyphIndexArray: new j0(F, (t) => (t.length - t._currentOffset) / 2)
  },
  6: {
    length: F,
    language: F,
    firstCode: F,
    entryCount: F,
    glyphIndices: new j0(F, "entryCount")
  },
  8: {
    reserved: new J0(F),
    length: ge,
    language: F,
    is32: new j0(ze, 8192),
    nGroups: ge,
    groups: new j0(Mg, "nGroups")
  },
  10: {
    reserved: new J0(F),
    length: ge,
    language: ge,
    firstCode: ge,
    entryCount: ge,
    glyphIndices: new j0(F, "numChars")
  },
  12: {
    reserved: new J0(F),
    length: ge,
    language: ge,
    nGroups: ge,
    groups: new j0(Mg, "nGroups")
  },
  13: {
    reserved: new J0(F),
    length: ge,
    language: ge,
    nGroups: ge,
    groups: new j0(Mg, "nGroups")
  },
  14: {
    length: ge,
    numRecords: ge,
    varSelectors: new j0(xz, "numRecords")
  }
}), wz = new xe({
  platformID: F,
  encodingID: F,
  table: new de(ge, yz, {
    type: "parent",
    lazy: !0
  })
});
var _z = new xe({
  version: F,
  numSubtables: F,
  tables: new ue(wz, "numSubtables")
}), Az = new xe({
  version: Vu,
  revision: Vu,
  checkSumAdjustment: ge,
  magicNumber: ge,
  flags: F,
  unitsPerEm: F,
  created: new ue(Vu, 2),
  modified: new ue(Vu, 2),
  xMin: Be,
  yMin: Be,
  xMax: Be,
  yMax: Be,
  macStyle: new ao(F, [
    "bold",
    "italic",
    "underline",
    "outline",
    "shadow",
    "condensed",
    "extended"
  ]),
  lowestRecPPEM: F,
  fontDirectionHint: Be,
  indexToLocFormat: Be,
  glyphDataFormat: Be
  // 0 for current format
}), Ez = new xe({
  version: Vu,
  ascent: Be,
  descent: Be,
  lineGap: Be,
  advanceWidthMax: F,
  minLeftSideBearing: Be,
  minRightSideBearing: Be,
  xMaxExtent: Be,
  caretSlopeRise: Be,
  caretSlopeRun: Be,
  caretOffset: Be,
  reserved: new J0(Be, 4),
  metricDataFormat: Be,
  numberOfMetrics: F
  // Number of advance widths in 'hmtx' table
});
let Sz = new xe({
  advance: F,
  bearing: Be
});
var Cz = new xe({
  metrics: new j0(Sz, (t) => t.parent.hhea.numberOfMetrics),
  bearings: new j0(Be, (t) => t.parent.maxp.numGlyphs - t.parent.hhea.numberOfMetrics)
}), kz = new xe({
  version: Vu,
  numGlyphs: F,
  maxPoints: F,
  maxContours: F,
  maxComponentPoints: F,
  maxComponentContours: F,
  maxZones: F,
  maxTwilightPoints: F,
  maxStorage: F,
  maxFunctionDefs: F,
  maxInstructionDefs: F,
  maxStackElements: F,
  maxSizeOfInstructions: F,
  maxComponentElements: F,
  maxComponentDepth: F
  // Maximum levels of recursion; 1 for simple components
});
function bE(t, e, r = 0) {
  return t === 1 && Sy[r] ? Sy[r] : Oz[t][e];
}
const Tz = /* @__PURE__ */ new Set([
  "x-mac-roman",
  "x-mac-cyrillic",
  "iso-8859-6",
  "iso-8859-8"
]), Fz = {
  "x-mac-croatian": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊©⁄€‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ",
  "x-mac-gaelic": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØḂ±≤≥ḃĊċḊḋḞḟĠġṀæøṁṖṗɼƒſṠ«»… ÀÃÕŒœ–—“”‘’ṡẛÿŸṪ€‹›Ŷŷṫ·Ỳỳ⁊ÂÊÁËÈÍÎÏÌÓÔ♣ÒÚÛÙıÝýŴŵẄẅẀẁẂẃ",
  "x-mac-greek": "Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦€ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ­",
  "x-mac-icelandic": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",
  "x-mac-inuit": "ᐃᐄᐅᐆᐊᐋᐱᐲᐳᐴᐸᐹᑉᑎᑏᑐᑑᑕᑖᑦᑭᑮᑯᑰᑲᑳᒃᒋᒌᒍᒎᒐᒑ°ᒡᒥᒦ•¶ᒧ®©™ᒨᒪᒫᒻᓂᓃᓄᓅᓇᓈᓐᓯᓰᓱᓲᓴᓵᔅᓕᓖᓗᓘᓚᓛᓪᔨᔩᔪᔫᔭ… ᔮᔾᕕᕖᕗ–—“”‘’ᕘᕙᕚᕝᕆᕇᕈᕉᕋᕌᕐᕿᖀᖁᖂᖃᖄᖅᖏᖐᖑᖒᖓᖔᖕᙱᙲᙳᙴᙵᙶᖖᖠᖡᖢᖣᖤᖥᖦᕼŁł",
  "x-mac-ce": "ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ",
  "x-mac-romanian": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂȘ∞±≤≥¥µ∂∑∏π∫ªºΩăș¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›Țț‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",
  "x-mac-turkish": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙˆ˜¯˘˙˚¸˝˛ˇ"
}, Ug = /* @__PURE__ */ new Map();
function Dz(t) {
  let e = Ug.get(t);
  if (e) return e;
  let r = Fz[t];
  if (r) {
    let n = /* @__PURE__ */ new Map();
    for (let i = 0; i < r.length; i++) n.set(r.charCodeAt(i), 128 + i);
    return Ug.set(t, n), n;
  }
  if (Tz.has(t)) {
    let n = new TextDecoder(t), i = new Uint8Array(128);
    for (let s = 0; s < 128; s++) i[s] = 128 + s;
    let a = /* @__PURE__ */ new Map(), o = n.decode(i);
    for (let s = 0; s < 128; s++) a.set(o.charCodeAt(s), 128 + s);
    return Ug.set(t, a), a;
  }
}
const Oz = [
  // unicode
  [
    "utf-16be",
    "utf-16be",
    "utf-16be",
    "utf-16be",
    "utf-16be",
    "utf-16be",
    "utf-16be"
  ],
  // macintosh
  // Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
  // 0	Roman                 17	Malayalam
  // 1	Japanese	            18	Sinhalese
  // 2	Traditional Chinese	  19	Burmese
  // 3	Korean	              20	Khmer
  // 4	Arabic	              21	Thai
  // 5	Hebrew	              22	Laotian
  // 6	Greek	                23	Georgian
  // 7	Russian	              24	Armenian
  // 8	RSymbol	              25	Simplified Chinese
  // 9	Devanagari	          26	Tibetan
  // 10	Gurmukhi	            27	Mongolian
  // 11	Gujarati	            28	Geez
  // 12	Oriya	                29	Slavic
  // 13	Bengali	              30	Vietnamese
  // 14	Tamil	                31	Sindhi
  // 15	Telugu	              32	(Uninterpreted)
  // 16	Kannada
  [
    "x-mac-roman",
    "shift-jis",
    "big5",
    "euc-kr",
    "iso-8859-6",
    "iso-8859-8",
    "x-mac-greek",
    "x-mac-cyrillic",
    "x-mac-symbol",
    "x-mac-devanagari",
    "x-mac-gurmukhi",
    "x-mac-gujarati",
    "Oriya",
    "Bengali",
    "Tamil",
    "Telugu",
    "Kannada",
    "Malayalam",
    "Sinhalese",
    "Burmese",
    "Khmer",
    "iso-8859-11",
    "Laotian",
    "Georgian",
    "Armenian",
    "gbk",
    "Tibetan",
    "Mongolian",
    "Geez",
    "x-mac-ce",
    "Vietnamese",
    "Sindhi"
  ],
  // ISO (deprecated)
  [
    "ascii",
    null,
    "iso-8859-1"
  ],
  // windows
  // Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
  [
    "symbol",
    "utf-16be",
    "shift-jis",
    "gb18030",
    "big5",
    "euc-kr",
    "johab",
    null,
    null,
    null,
    "utf-16be"
  ]
], Sy = {
  15: "x-mac-icelandic",
  17: "x-mac-turkish",
  18: "x-mac-croatian",
  24: "x-mac-ce",
  25: "x-mac-ce",
  26: "x-mac-ce",
  27: "x-mac-ce",
  28: "x-mac-ce",
  30: "x-mac-icelandic",
  37: "x-mac-romanian",
  38: "x-mac-ce",
  39: "x-mac-ce",
  40: "x-mac-ce",
  143: "x-mac-inuit",
  146: "x-mac-gaelic"
}, Rz = [
  // unicode
  [],
  {
    0: "en",
    30: "fo",
    60: "ks",
    90: "rw",
    1: "fr",
    31: "fa",
    61: "ku",
    91: "rn",
    2: "de",
    32: "ru",
    62: "sd",
    92: "ny",
    3: "it",
    33: "zh",
    63: "bo",
    93: "mg",
    4: "nl",
    34: "nl-BE",
    64: "ne",
    94: "eo",
    5: "sv",
    35: "ga",
    65: "sa",
    128: "cy",
    6: "es",
    36: "sq",
    66: "mr",
    129: "eu",
    7: "da",
    37: "ro",
    67: "bn",
    130: "ca",
    8: "pt",
    38: "cz",
    68: "as",
    131: "la",
    9: "no",
    39: "sk",
    69: "gu",
    132: "qu",
    10: "he",
    40: "si",
    70: "pa",
    133: "gn",
    11: "ja",
    41: "yi",
    71: "or",
    134: "ay",
    12: "ar",
    42: "sr",
    72: "ml",
    135: "tt",
    13: "fi",
    43: "mk",
    73: "kn",
    136: "ug",
    14: "el",
    44: "bg",
    74: "ta",
    137: "dz",
    15: "is",
    45: "uk",
    75: "te",
    138: "jv",
    16: "mt",
    46: "be",
    76: "si",
    139: "su",
    17: "tr",
    47: "uz",
    77: "my",
    140: "gl",
    18: "hr",
    48: "kk",
    78: "km",
    141: "af",
    19: "zh-Hant",
    49: "az-Cyrl",
    79: "lo",
    142: "br",
    20: "ur",
    50: "az-Arab",
    80: "vi",
    143: "iu",
    21: "hi",
    51: "hy",
    81: "id",
    144: "gd",
    22: "th",
    52: "ka",
    82: "tl",
    145: "gv",
    23: "ko",
    53: "mo",
    83: "ms",
    146: "ga",
    24: "lt",
    54: "ky",
    84: "ms-Arab",
    147: "to",
    25: "pl",
    55: "tg",
    85: "am",
    148: "el-polyton",
    26: "hu",
    56: "tk",
    86: "ti",
    149: "kl",
    27: "es",
    57: "mn-CN",
    87: "om",
    150: "az",
    28: "lv",
    58: "mn",
    88: "so",
    151: "nn",
    29: "se",
    59: "ps",
    89: "sw"
  },
  // ISO (deprecated)
  [],
  {
    1078: "af",
    16393: "en-IN",
    1159: "rw",
    1074: "tn",
    1052: "sq",
    6153: "en-IE",
    1089: "sw",
    1115: "si",
    1156: "gsw",
    8201: "en-JM",
    1111: "kok",
    1051: "sk",
    1118: "am",
    17417: "en-MY",
    1042: "ko",
    1060: "sl",
    5121: "ar-DZ",
    5129: "en-NZ",
    1088: "ky",
    11274: "es-AR",
    15361: "ar-BH",
    13321: "en-PH",
    1108: "lo",
    16394: "es-BO",
    3073: "ar",
    18441: "en-SG",
    1062: "lv",
    13322: "es-CL",
    2049: "ar-IQ",
    7177: "en-ZA",
    1063: "lt",
    9226: "es-CO",
    11265: "ar-JO",
    11273: "en-TT",
    2094: "dsb",
    5130: "es-CR",
    13313: "ar-KW",
    2057: "en-GB",
    1134: "lb",
    7178: "es-DO",
    12289: "ar-LB",
    1033: "en",
    1071: "mk",
    12298: "es-EC",
    4097: "ar-LY",
    12297: "en-ZW",
    2110: "ms-BN",
    17418: "es-SV",
    6145: "ary",
    1061: "et",
    1086: "ms",
    4106: "es-GT",
    8193: "ar-OM",
    1080: "fo",
    1100: "ml",
    18442: "es-HN",
    16385: "ar-QA",
    1124: "fil",
    1082: "mt",
    2058: "es-MX",
    1025: "ar-SA",
    1035: "fi",
    1153: "mi",
    19466: "es-NI",
    10241: "ar-SY",
    2060: "fr-BE",
    1146: "arn",
    6154: "es-PA",
    7169: "aeb",
    3084: "fr-CA",
    1102: "mr",
    15370: "es-PY",
    14337: "ar-AE",
    1036: "fr",
    1148: "moh",
    10250: "es-PE",
    9217: "ar-YE",
    5132: "fr-LU",
    1104: "mn",
    20490: "es-PR",
    1067: "hy",
    6156: "fr-MC",
    2128: "mn-CN",
    3082: "es",
    1101: "as",
    4108: "fr-CH",
    1121: "ne",
    1034: "es",
    2092: "az-Cyrl",
    1122: "fy",
    1044: "nb",
    21514: "es-US",
    1068: "az",
    1110: "gl",
    2068: "nn",
    14346: "es-UY",
    1133: "ba",
    1079: "ka",
    1154: "oc",
    8202: "es-VE",
    1069: "eu",
    3079: "de-AT",
    1096: "or",
    2077: "sv-FI",
    1059: "be",
    1031: "de",
    1123: "ps",
    1053: "sv",
    2117: "bn",
    5127: "de-LI",
    1045: "pl",
    1114: "syr",
    1093: "bn-IN",
    4103: "de-LU",
    1046: "pt",
    1064: "tg",
    8218: "bs-Cyrl",
    2055: "de-CH",
    2070: "pt-PT",
    2143: "tzm",
    5146: "bs",
    1032: "el",
    1094: "pa",
    1097: "ta",
    1150: "br",
    1135: "kl",
    1131: "qu-BO",
    1092: "tt",
    1026: "bg",
    1095: "gu",
    2155: "qu-EC",
    1098: "te",
    1027: "ca",
    1128: "ha",
    3179: "qu",
    1054: "th",
    3076: "zh-HK",
    1037: "he",
    1048: "ro",
    1105: "bo",
    5124: "zh-MO",
    1081: "hi",
    1047: "rm",
    1055: "tr",
    2052: "zh",
    1038: "hu",
    1049: "ru",
    1090: "tk",
    4100: "zh-SG",
    1039: "is",
    9275: "smn",
    1152: "ug",
    1028: "zh-TW",
    1136: "ig",
    4155: "smj-NO",
    1058: "uk",
    1155: "co",
    1057: "id",
    5179: "smj",
    1070: "hsb",
    1050: "hr",
    1117: "iu",
    3131: "se-FI",
    1056: "ur",
    4122: "hr-BA",
    2141: "iu-Latn",
    1083: "se",
    2115: "uz-Cyrl",
    1029: "cs",
    2108: "ga",
    2107: "se-SE",
    1091: "uz",
    1030: "da",
    1076: "xh",
    8251: "sms",
    1066: "vi",
    1164: "prs",
    1077: "zu",
    6203: "sma-NO",
    1106: "cy",
    1125: "dv",
    1040: "it",
    7227: "sms",
    1160: "wo",
    2067: "nl-BE",
    2064: "it-CH",
    1103: "sa",
    1157: "sah",
    1043: "nl",
    1041: "ja",
    7194: "sr-Cyrl-BA",
    1144: "ii",
    3081: "en-AU",
    1099: "kn",
    3098: "sr",
    1130: "yo",
    10249: "en-BZ",
    1087: "kk",
    6170: "sr-Latn-BA",
    4105: "en-CA",
    1107: "km",
    2074: "sr-Latn",
    9225: "en-029",
    1158: "quc",
    1132: "nso"
  }
];
let Cy = new xe({
  platformID: F,
  encodingID: F,
  languageID: F,
  nameID: F,
  length: F,
  string: new de(F, new A0("length", (t) => bE(t.platformID, t.encodingID, t.languageID)), {
    type: "parent",
    relativeTo: (t) => t.parent.stringOffset,
    allowNull: !1
  })
}), Pz = new xe({
  length: F,
  tag: new de(F, new A0("length", "utf16be"), {
    type: "parent",
    relativeTo: (t) => t.stringOffset
  })
});
var U5 = new qt(F, {
  0: {
    count: F,
    stringOffset: F,
    records: new ue(Cy, "count")
  },
  1: {
    count: F,
    stringOffset: F,
    records: new ue(Cy, "count"),
    langTagCount: F,
    langTags: new ue(Pz, "langTagCount")
  }
}), Iz = U5;
const f3 = [
  "copyright",
  "fontFamily",
  "fontSubfamily",
  "uniqueSubfamily",
  "fullName",
  "version",
  "postscriptName",
  "trademark",
  "manufacturer",
  "designer",
  "description",
  "vendorURL",
  "designerURL",
  "license",
  "licenseURL",
  null,
  "preferredFamily",
  "preferredSubfamily",
  "compatibleFull",
  "sampleText",
  "postscriptCIDFontName",
  "wwsFamilyName",
  "wwsSubfamilyName"
];
U5.process = function(t) {
  var e = {};
  for (let r of this.records) {
    let n = Rz[r.platformID][r.languageID];
    n == null && this.langTags != null && r.languageID >= 32768 && (n = this.langTags[r.languageID - 32768].tag), n == null && (n = r.platformID + "-" + r.languageID);
    let i = r.nameID >= 256 ? "fontFeatures" : f3[r.nameID] || r.nameID;
    e[i] == null && (e[i] = {});
    let a = e[i];
    r.nameID >= 256 && (a = a[r.nameID] || (a[r.nameID] = {})), (typeof r.string == "string" || typeof a[n] != "string") && (a[n] = r.string);
  }
  this.records = e;
};
U5.preEncode = function() {
  if (Array.isArray(this.records)) return;
  this.version = 0;
  let t = [];
  for (let e in this.records) {
    let r = this.records[e];
    e !== "fontFeatures" && (t.push({
      platformID: 3,
      encodingID: 1,
      languageID: 1033,
      nameID: f3.indexOf(e),
      length: r.en.length * 2,
      string: r.en
    }), e === "postscriptName" && t.push({
      platformID: 1,
      encodingID: 0,
      languageID: 0,
      nameID: f3.indexOf(e),
      length: r.en.length,
      string: r.en
    }));
  }
  this.records = t, this.count = t.length, this.stringOffset = U5.size(this, null, !1);
};
var xE = new qt(F, {
  header: {
    xAvgCharWidth: Be,
    usWeightClass: F,
    usWidthClass: F,
    fsType: new ao(F, [
      null,
      "noEmbedding",
      "viewOnly",
      "editable",
      null,
      null,
      null,
      null,
      "noSubsetting",
      "bitmapOnly"
    ]),
    ySubscriptXSize: Be,
    ySubscriptYSize: Be,
    ySubscriptXOffset: Be,
    ySubscriptYOffset: Be,
    ySuperscriptXSize: Be,
    ySuperscriptYSize: Be,
    ySuperscriptXOffset: Be,
    ySuperscriptYOffset: Be,
    yStrikeoutSize: Be,
    yStrikeoutPosition: Be,
    sFamilyClass: Be,
    panose: new ue(ze, 10),
    ulCharRange: new ue(ge, 4),
    vendorID: new A0(4),
    fsSelection: new ao(F, [
      "italic",
      "underscore",
      "negative",
      "outlined",
      "strikeout",
      "bold",
      "regular",
      "useTypoMetrics",
      "wws",
      "oblique"
    ]),
    usFirstCharIndex: F,
    usLastCharIndex: F
    // The maximum Unicode index in this font
  },
  // The Apple version of this table ends here, but the Microsoft one continues on...
  0: {},
  1: {
    typoAscender: Be,
    typoDescender: Be,
    typoLineGap: Be,
    winAscent: F,
    winDescent: F,
    codePageRange: new ue(ge, 2)
  },
  2: {
    // these should be common with version 1 somehow
    typoAscender: Be,
    typoDescender: Be,
    typoLineGap: Be,
    winAscent: F,
    winDescent: F,
    codePageRange: new ue(ge, 2),
    xHeight: Be,
    capHeight: Be,
    defaultChar: F,
    breakChar: F,
    maxContent: F
  },
  5: {
    typoAscender: Be,
    typoDescender: Be,
    typoLineGap: Be,
    winAscent: F,
    winDescent: F,
    codePageRange: new ue(ge, 2),
    xHeight: Be,
    capHeight: Be,
    defaultChar: F,
    breakChar: F,
    maxContent: F,
    usLowerOpticalPointSize: F,
    usUpperOpticalPointSize: F
  }
});
let zg = xE.versions;
zg[3] = zg[4] = zg[2];
var Bz = xE, Lz = new qt(Er, {
  header: {
    italicAngle: Er,
    underlinePosition: Be,
    underlineThickness: Be,
    isFixedPitch: ge,
    minMemType42: ge,
    maxMemType42: ge,
    minMemType1: ge,
    maxMemType1: ge
    // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
  },
  1: {},
  2: {
    numberOfGlyphs: F,
    glyphNameIndex: new ue(F, "numberOfGlyphs"),
    names: new ue(new A0(ze))
  },
  2.5: {
    numberOfGlyphs: F,
    offsets: new ue(ze, "numberOfGlyphs")
  },
  3: {},
  4: {
    map: new ue(ge, (t) => t.parent.maxp.numGlyphs)
  }
}), Nz = new xe({
  controlValues: new ue(Be)
}), Mz = new xe({
  instructions: new ue(ze)
});
let Bb = new qt("head.indexToLocFormat", {
  0: {
    offsets: new ue(F)
  },
  1: {
    offsets: new ue(ge)
  }
});
Bb.process = function() {
  if (this.version === 0 && !this._processed) {
    for (let t = 0; t < this.offsets.length; t++) this.offsets[t] <<= 1;
    this._processed = !0;
  }
};
Bb.preEncode = function() {
  if (this.version === 0 && this._processed !== !1) {
    for (let t = 0; t < this.offsets.length; t++) this.offsets[t] >>>= 1;
    this._processed = !1;
  }
};
var Uz = Bb, zz = new xe({
  controlValueProgram: new ue(ze)
}), $z = new ue(new Fn());
class jo {
  getCFFVersion(e) {
    for (; e && !e.hdrSize; ) e = e.parent;
    return e ? e.version : -1;
  }
  decode(e, r) {
    let i = this.getCFFVersion(r) >= 2 ? e.readUInt32BE() : e.readUInt16BE();
    if (i === 0) return [];
    let a = e.readUInt8(), o;
    if (a === 1) o = ze;
    else if (a === 2) o = F;
    else if (a === 3) o = Kl;
    else if (a === 4) o = ge;
    else throw new Error(`Bad offset size in CFFIndex: ${a} ${e.pos}`);
    let s = [], l = e.pos + (i + 1) * a - 1, u = o.decode(e);
    for (let d = 0; d < i; d++) {
      let h = o.decode(e);
      if (this.type != null) {
        let v = e.pos;
        e.pos = l + u, r.length = h - u, s.push(this.type.decode(e, r)), e.pos = v;
      } else s.push({
        offset: l + u,
        length: h - u
      });
      u = h;
    }
    return e.pos = l + u, s;
  }
  size(e, r) {
    let n = 2;
    if (e.length === 0) return n;
    let i = this.type || new Fn(), a = 1;
    for (let s = 0; s < e.length; s++) {
      let l = e[s];
      a += i.size(l, r);
    }
    let o;
    if (a <= 255) o = ze;
    else if (a <= 65535) o = F;
    else if (a <= 16777215) o = Kl;
    else if (a <= 4294967295) o = ge;
    else throw new Error("Bad offset in CFFIndex");
    return n += 1 + o.size() * (e.length + 1), n += a - 1, n;
  }
  encode(e, r, n) {
    if (e.writeUInt16BE(r.length), r.length === 0) return;
    let i = this.type || new Fn(), a = [], o = 1;
    for (let l of r) {
      let u = i.size(l, n);
      a.push(u), o += u;
    }
    let s;
    if (o <= 255) s = ze;
    else if (o <= 65535) s = F;
    else if (o <= 16777215) s = Kl;
    else if (o <= 4294967295) s = ge;
    else throw new Error("Bad offset in CFFIndex");
    e.writeUInt8(s.size()), o = 1, s.encode(e, o);
    for (let l of a)
      o += l, s.encode(e, o);
    for (let l of r) i.encode(e, l, n);
  }
  constructor(e) {
    this.type = e;
  }
}
const Ad = 15, ky = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  ".",
  "E",
  "E-",
  null,
  "-"
], Ty = {
  ".": 10,
  E: 11,
  "E-": 12,
  "-": 14
};
class $g {
  static decode(e, r) {
    if (32 <= r && r <= 246) return r - 139;
    if (247 <= r && r <= 250) return (r - 247) * 256 + e.readUInt8() + 108;
    if (251 <= r && r <= 254) return -(r - 251) * 256 - e.readUInt8() - 108;
    if (r === 28) return e.readInt16BE();
    if (r === 29) return e.readInt32BE();
    if (r === 30) {
      let n = "";
      for (; ; ) {
        let i = e.readUInt8(), a = i >> 4;
        if (a === Ad) break;
        n += ky[a];
        let o = i & 15;
        if (o === Ad) break;
        n += ky[o];
      }
      return parseFloat(n);
    }
    return null;
  }
  static size(e) {
    if (e.forceLarge && (e = 32768), (e | 0) !== e) {
      let r = "" + e;
      return 1 + Math.ceil((r.length + 1) / 2);
    } else return -107 <= e && e <= 107 ? 1 : 108 <= e && e <= 1131 || -1131 <= e && e <= -108 ? 2 : -32768 <= e && e <= 32767 ? 3 : 5;
  }
  static encode(e, r) {
    let n = Number(r);
    if (r.forceLarge)
      return e.writeUInt8(29), e.writeInt32BE(n);
    if ((n | 0) !== n) {
      e.writeUInt8(30);
      let a = "" + n;
      for (let o = 0; o < a.length; o += 2) {
        let s = a[o], l = Ty[s] || +s;
        if (o === a.length - 1) var i = Ad;
        else {
          let u = a[o + 1];
          var i = Ty[u] || +u;
        }
        e.writeUInt8(l << 4 | i & 15);
      }
      if (i !== Ad) return e.writeUInt8(Ad << 4);
    } else return -107 <= n && n <= 107 ? e.writeUInt8(n + 139) : 108 <= n && n <= 1131 ? (n -= 108, e.writeUInt8((n >> 8) + 247), e.writeUInt8(n & 255)) : -1131 <= n && n <= -108 ? (n = -n - 108, e.writeUInt8((n >> 8) + 251), e.writeUInt8(n & 255)) : -32768 <= n && n <= 32767 ? (e.writeUInt8(28), e.writeInt16BE(n)) : (e.writeUInt8(29), e.writeInt32BE(n));
  }
}
class Vp {
  decodeOperands(e, r, n, i) {
    if (Array.isArray(e)) return i.map((a, o) => this.decodeOperands(e[o], r, n, [
      a
    ]));
    if (e.decode != null) return e.decode(r, n, i);
    switch (e) {
      case "number":
      case "offset":
      case "sid":
        return i[0];
      case "boolean":
        return !!i[0];
      default:
        return i;
    }
  }
  encodeOperands(e, r, n, i) {
    return Array.isArray(e) ? i.map((a, o) => this.encodeOperands(e[o], r, n, a)[0]) : e.encode != null ? e.encode(r, i, n) : typeof i == "number" ? [
      i
    ] : typeof i == "boolean" ? [
      +i
    ] : Array.isArray(i) ? i : [
      i
    ];
  }
  decode(e, r) {
    let n = e.pos + r.length, i = {}, a = [];
    Object.defineProperties(i, {
      parent: {
        value: r
      },
      _startOffset: {
        value: e.pos
      }
    });
    for (let o in this.fields) {
      let s = this.fields[o];
      i[s[1]] = s[3];
    }
    for (; e.pos < n; ) {
      let o = e.readUInt8();
      if (o < 28) {
        o === 12 && (o = o << 8 | e.readUInt8());
        let s = this.fields[o];
        if (!s) throw new Error(`Unknown operator ${o}`);
        let l = this.decodeOperands(s[2], e, i, a);
        l != null && (l instanceof Sb ? Object.defineProperty(i, s[1], l) : i[s[1]] = l), a = [];
      } else a.push($g.decode(e, o));
    }
    return i;
  }
  size(e, r, n = !0) {
    let i = {
      parent: r,
      val: e,
      pointerSize: 0,
      startOffset: r.startOffset || 0
    }, a = 0;
    for (let o in this.fields) {
      let s = this.fields[o], l = e[s[1]];
      if (l == null || fy(l, s[3])) continue;
      let u = this.encodeOperands(s[2], null, i, l);
      for (let h of u) a += $g.size(h);
      let d = Array.isArray(s[0]) ? s[0] : [
        s[0]
      ];
      a += d.length;
    }
    return n && (a += i.pointerSize), a;
  }
  encode(e, r, n) {
    let i = {
      pointers: [],
      startOffset: e.pos,
      parent: n,
      val: r,
      pointerSize: 0
    };
    i.pointerOffset = e.pos + this.size(r, i, !1);
    for (let o of this.ops) {
      let s = r[o[1]];
      if (s == null || fy(s, o[3])) continue;
      let l = this.encodeOperands(o[2], e, i, s);
      for (let d of l) $g.encode(e, d);
      let u = Array.isArray(o[0]) ? o[0] : [
        o[0]
      ];
      for (let d of u) e.writeUInt8(d);
    }
    let a = 0;
    for (; a < i.pointers.length; ) {
      let o = i.pointers[a++];
      o.type.encode(e, o.val, o.parent);
    }
  }
  constructor(e = []) {
    this.ops = e, this.fields = {};
    for (let r of e) {
      let n = Array.isArray(r[0]) ? r[0][0] << 8 | r[0][1] : r[0];
      this.fields[n] = r;
    }
  }
}
class Xa extends de {
  decode(e, r, n) {
    return this.offsetType = {
      decode: () => n[0]
    }, super.decode(e, r, n);
  }
  encode(e, r, n) {
    if (!e)
      return this.offsetType = {
        size: () => 0
      }, this.size(r, n), [
        new Fy(0)
      ];
    let i = null;
    return this.offsetType = {
      encode: (a, o) => i = o
    }, super.encode(e, r, n), [
      new Fy(i)
    ];
  }
  constructor(e, r = {}) {
    r.type == null && (r.type = "global"), super(null, e, r);
  }
}
class Fy {
  valueOf() {
    return this.val;
  }
  constructor(e) {
    this.val = e, this.forceLarge = !0;
  }
}
class Vz {
  static decode(e, r, n) {
    let i = n.pop();
    for (; n.length > i; ) n.pop();
  }
}
var d3 = new Vp([
  // key       name                    type                                          default
  [
    6,
    "BlueValues",
    "delta",
    null
  ],
  [
    7,
    "OtherBlues",
    "delta",
    null
  ],
  [
    8,
    "FamilyBlues",
    "delta",
    null
  ],
  [
    9,
    "FamilyOtherBlues",
    "delta",
    null
  ],
  [
    [
      12,
      9
    ],
    "BlueScale",
    "number",
    0.039625
  ],
  [
    [
      12,
      10
    ],
    "BlueShift",
    "number",
    7
  ],
  [
    [
      12,
      11
    ],
    "BlueFuzz",
    "number",
    1
  ],
  [
    10,
    "StdHW",
    "number",
    null
  ],
  [
    11,
    "StdVW",
    "number",
    null
  ],
  [
    [
      12,
      12
    ],
    "StemSnapH",
    "delta",
    null
  ],
  [
    [
      12,
      13
    ],
    "StemSnapV",
    "delta",
    null
  ],
  [
    [
      12,
      14
    ],
    "ForceBold",
    "boolean",
    !1
  ],
  [
    [
      12,
      17
    ],
    "LanguageGroup",
    "number",
    0
  ],
  [
    [
      12,
      18
    ],
    "ExpansionFactor",
    "number",
    0.06
  ],
  [
    [
      12,
      19
    ],
    "initialRandomSeed",
    "number",
    0
  ],
  [
    20,
    "defaultWidthX",
    "number",
    0
  ],
  [
    21,
    "nominalWidthX",
    "number",
    0
  ],
  [
    22,
    "vsindex",
    "number",
    0
  ],
  [
    23,
    "blend",
    Vz,
    null
  ],
  [
    19,
    "Subrs",
    new Xa(new jo(), {
      type: "local"
    }),
    null
  ]
]), t5 = [
  ".notdef",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "questiondown",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "AE",
  "ordfeminine",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "ae",
  "dotlessi",
  "lslash",
  "oslash",
  "oe",
  "germandbls",
  "onesuperior",
  "logicalnot",
  "mu",
  "trademark",
  "Eth",
  "onehalf",
  "plusminus",
  "Thorn",
  "onequarter",
  "divide",
  "brokenbar",
  "degree",
  "thorn",
  "threequarters",
  "twosuperior",
  "registered",
  "minus",
  "eth",
  "multiply",
  "threesuperior",
  "copyright",
  "Aacute",
  "Acircumflex",
  "Adieresis",
  "Agrave",
  "Aring",
  "Atilde",
  "Ccedilla",
  "Eacute",
  "Ecircumflex",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Ntilde",
  "Oacute",
  "Ocircumflex",
  "Odieresis",
  "Ograve",
  "Otilde",
  "Scaron",
  "Uacute",
  "Ucircumflex",
  "Udieresis",
  "Ugrave",
  "Yacute",
  "Ydieresis",
  "Zcaron",
  "aacute",
  "acircumflex",
  "adieresis",
  "agrave",
  "aring",
  "atilde",
  "ccedilla",
  "eacute",
  "ecircumflex",
  "edieresis",
  "egrave",
  "iacute",
  "icircumflex",
  "idieresis",
  "igrave",
  "ntilde",
  "oacute",
  "ocircumflex",
  "odieresis",
  "ograve",
  "otilde",
  "scaron",
  "uacute",
  "ucircumflex",
  "udieresis",
  "ugrave",
  "yacute",
  "ydieresis",
  "zcaron",
  "exclamsmall",
  "Hungarumlautsmall",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "Dotaccentsmall",
  "Macronsmall",
  "figuredash",
  "hypheninferior",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall",
  "001.000",
  "001.001",
  "001.002",
  "001.003",
  "Black",
  "Bold",
  "Book",
  "Light",
  "Medium",
  "Regular",
  "Roman",
  "Semibold"
];
let yE = [
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "",
  "questiondown",
  "",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "",
  "ring",
  "cedilla",
  "",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "AE",
  "",
  "ordfeminine",
  "",
  "",
  "",
  "",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "",
  "",
  "",
  "",
  "",
  "ae",
  "",
  "",
  "",
  "dotlessi",
  "",
  "",
  "lslash",
  "oslash",
  "oe",
  "germandbls"
], jz = [
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "space",
  "exclamsmall",
  "Hungarumlautsmall",
  "",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "",
  "",
  "isuperior",
  "",
  "",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "",
  "",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "",
  "",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "",
  "Dotaccentsmall",
  "",
  "",
  "Macronsmall",
  "",
  "",
  "figuredash",
  "hypheninferior",
  "",
  "",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "",
  "",
  "",
  "onequarter",
  "onehalf",
  "threequarters",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "",
  "",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall"
], wE = [
  ".notdef",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "questiondown",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "AE",
  "ordfeminine",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "ae",
  "dotlessi",
  "lslash",
  "oslash",
  "oe",
  "germandbls",
  "onesuperior",
  "logicalnot",
  "mu",
  "trademark",
  "Eth",
  "onehalf",
  "plusminus",
  "Thorn",
  "onequarter",
  "divide",
  "brokenbar",
  "degree",
  "thorn",
  "threequarters",
  "twosuperior",
  "registered",
  "minus",
  "eth",
  "multiply",
  "threesuperior",
  "copyright",
  "Aacute",
  "Acircumflex",
  "Adieresis",
  "Agrave",
  "Aring",
  "Atilde",
  "Ccedilla",
  "Eacute",
  "Ecircumflex",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Ntilde",
  "Oacute",
  "Ocircumflex",
  "Odieresis",
  "Ograve",
  "Otilde",
  "Scaron",
  "Uacute",
  "Ucircumflex",
  "Udieresis",
  "Ugrave",
  "Yacute",
  "Ydieresis",
  "Zcaron",
  "aacute",
  "acircumflex",
  "adieresis",
  "agrave",
  "aring",
  "atilde",
  "ccedilla",
  "eacute",
  "ecircumflex",
  "edieresis",
  "egrave",
  "iacute",
  "icircumflex",
  "idieresis",
  "igrave",
  "ntilde",
  "oacute",
  "ocircumflex",
  "odieresis",
  "ograve",
  "otilde",
  "scaron",
  "uacute",
  "ucircumflex",
  "udieresis",
  "ugrave",
  "yacute",
  "ydieresis",
  "zcaron"
], Wz = [
  ".notdef",
  "space",
  "exclamsmall",
  "Hungarumlautsmall",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "Dotaccentsmall",
  "Macronsmall",
  "figuredash",
  "hypheninferior",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "onequarter",
  "onehalf",
  "threequarters",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall"
], Hz = [
  ".notdef",
  "space",
  "dollaroldstyle",
  "dollarsuperior",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "hyphensuperior",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "centoldstyle",
  "figuredash",
  "hypheninferior",
  "onequarter",
  "onehalf",
  "threequarters",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior"
], _E = new xe({
  reserved: new J0(F),
  reqFeatureIndex: F,
  featureCount: F,
  featureIndexes: new ue(F, "featureCount")
}), qz = new xe({
  tag: new A0(4),
  langSys: new de(F, _E, {
    type: "parent"
  })
}), Yz = new xe({
  defaultLangSys: new de(F, _E),
  count: F,
  langSysRecords: new ue(qz, "count")
}), Gz = new xe({
  tag: new A0(4),
  script: new de(F, Yz, {
    type: "parent"
  })
}), AE = new ue(Gz, F), Zz = new xe({
  version: F,
  nameID: F
}), EE = new xe({
  featureParams: new de(F, Zz),
  lookupCount: F,
  lookupListIndexes: new ue(F, "lookupCount")
}), Xz = new xe({
  tag: new A0(4),
  feature: new de(F, EE, {
    type: "parent"
  })
}), SE = new ue(Xz, F), Kz = new xe({
  markAttachmentType: ze,
  flags: new ao(ze, [
    "rightToLeft",
    "ignoreBaseGlyphs",
    "ignoreLigatures",
    "ignoreMarks",
    "useMarkFilteringSet"
  ])
});
function z5(t) {
  let e = new xe({
    lookupType: F,
    flags: Kz,
    subTableCount: F,
    subTables: new ue(new de(F, t), "subTableCount"),
    markFilteringSet: new B5(F, (r) => r.flags.flags.useMarkFilteringSet)
  });
  return new j0(new de(F, e), F);
}
let Jz = new xe({
  start: F,
  end: F,
  startCoverageIndex: F
}), I0 = new qt(F, {
  1: {
    glyphCount: F,
    glyphs: new ue(F, "glyphCount")
  },
  2: {
    rangeCount: F,
    rangeRecords: new ue(Jz, "rangeCount")
  }
}), Qz = new xe({
  start: F,
  end: F,
  class: F
}), Jl = new qt(F, {
  1: {
    startGlyph: F,
    glyphCount: F,
    classValueArray: new ue(F, "glyphCount")
  },
  2: {
    classRangeCount: F,
    classRangeRecord: new ue(Qz, "classRangeCount")
  }
}), Hl = new xe({
  a: F,
  b: F,
  deltaFormat: F
}), Fh = new xe({
  sequenceIndex: F,
  lookupListIndex: F
}), e$ = new xe({
  glyphCount: F,
  lookupCount: F,
  input: new ue(F, (t) => t.glyphCount - 1),
  lookupRecords: new ue(Fh, "lookupCount")
}), t$ = new ue(new de(F, e$), F), r$ = new xe({
  glyphCount: F,
  lookupCount: F,
  classes: new ue(F, (t) => t.glyphCount - 1),
  lookupRecords: new ue(Fh, "lookupCount")
}), n$ = new ue(new de(F, r$), F), CE = new qt(F, {
  1: {
    coverage: new de(F, I0),
    ruleSetCount: F,
    ruleSets: new ue(new de(F, t$), "ruleSetCount")
  },
  2: {
    coverage: new de(F, I0),
    classDef: new de(F, Jl),
    classSetCnt: F,
    classSet: new ue(new de(F, n$), "classSetCnt")
  },
  3: {
    glyphCount: F,
    lookupCount: F,
    coverages: new ue(new de(F, I0), "glyphCount"),
    lookupRecords: new ue(Fh, "lookupCount")
  }
}), i$ = new xe({
  backtrackGlyphCount: F,
  backtrack: new ue(F, "backtrackGlyphCount"),
  inputGlyphCount: F,
  input: new ue(F, (t) => t.inputGlyphCount - 1),
  lookaheadGlyphCount: F,
  lookahead: new ue(F, "lookaheadGlyphCount"),
  lookupCount: F,
  lookupRecords: new ue(Fh, "lookupCount")
}), Dy = new ue(new de(F, i$), F), kE = new qt(F, {
  1: {
    coverage: new de(F, I0),
    chainCount: F,
    chainRuleSets: new ue(new de(F, Dy), "chainCount")
  },
  2: {
    coverage: new de(F, I0),
    backtrackClassDef: new de(F, Jl),
    inputClassDef: new de(F, Jl),
    lookaheadClassDef: new de(F, Jl),
    chainCount: F,
    chainClassSet: new ue(new de(F, Dy), "chainCount")
  },
  3: {
    backtrackGlyphCount: F,
    backtrackCoverage: new ue(new de(F, I0), "backtrackGlyphCount"),
    inputGlyphCount: F,
    inputCoverage: new ue(new de(F, I0), "inputGlyphCount"),
    lookaheadGlyphCount: F,
    lookaheadCoverage: new ue(new de(F, I0), "lookaheadGlyphCount"),
    lookupCount: F,
    lookupRecords: new ue(Fh, "lookupCount")
  }
}), Bd = new kc(16, "BE", 14), a$ = new xe({
  startCoord: Bd,
  peakCoord: Bd,
  endCoord: Bd
}), o$ = new xe({
  axisCount: F,
  regionCount: F,
  variationRegions: new ue(new ue(a$, "axisCount"), "regionCount")
}), s$ = new xe({
  shortDeltas: new ue(Be, (t) => t.parent.shortDeltaCount),
  regionDeltas: new ue(Zr, (t) => t.parent.regionIndexCount - t.parent.shortDeltaCount),
  deltas: (t) => t.shortDeltas.concat(t.regionDeltas)
}), l$ = new xe({
  itemCount: F,
  shortDeltaCount: F,
  regionIndexCount: F,
  regionIndexes: new ue(F, "regionIndexCount"),
  deltaSets: new ue(s$, "itemCount")
}), jp = new xe({
  format: F,
  variationRegionList: new de(ge, o$),
  variationDataCount: F,
  itemVariationData: new ue(new de(ge, l$), "variationDataCount")
}), u$ = new qt(F, {
  1: {
    axisIndex: F,
    axisIndex: F,
    filterRangeMinValue: Bd,
    filterRangeMaxValue: Bd
  }
}), c$ = new xe({
  conditionCount: F,
  conditionTable: new ue(new de(ge, u$), "conditionCount")
}), f$ = new xe({
  featureIndex: F,
  alternateFeatureTable: new de(ge, EE, {
    type: "parent"
  })
}), d$ = new xe({
  version: Er,
  substitutionCount: F,
  substitutions: new ue(f$, "substitutionCount")
}), h$ = new xe({
  conditionSet: new de(ge, c$, {
    type: "parent"
  }),
  featureTableSubstitution: new de(ge, d$, {
    type: "parent"
  })
}), TE = new xe({
  majorVersion: F,
  minorVersion: F,
  featureVariationRecordCount: ge,
  featureVariationRecords: new ue(h$, "featureVariationRecordCount")
});
class FE {
  decode(e, r, n) {
    return this.predefinedOps[n[0]] ? this.predefinedOps[n[0]] : this.type.decode(e, r, n);
  }
  size(e, r) {
    return this.type.size(e, r);
  }
  encode(e, r, n) {
    let i = this.predefinedOps.indexOf(r);
    return i !== -1 ? i : this.type.encode(e, r, n);
  }
  constructor(e, r) {
    this.predefinedOps = e, this.type = r;
  }
}
class p$ extends O0 {
  decode(e) {
    return ze.decode(e) & 127;
  }
  constructor() {
    super("UInt8");
  }
}
let DE = new xe({
  first: F,
  nLeft: ze
}), m$ = new xe({
  first: F,
  nLeft: F
}), g$ = new qt(new p$(), {
  0: {
    nCodes: ze,
    codes: new ue(ze, "nCodes")
  },
  1: {
    nRanges: ze,
    ranges: new ue(DE, "nRanges")
  }
}), v$ = new FE([
  yE,
  jz
], new Xa(g$, {
  lazy: !0
}));
class Oy extends ue {
  decode(e, r) {
    let n = os(this.length, e, r), i = 0, a = [];
    for (; i < n; ) {
      let o = this.type.decode(e, r);
      o.offset = i, i += o.nLeft + 1, a.push(o);
    }
    return a;
  }
}
let b$ = new qt(ze, {
  0: {
    glyphs: new ue(F, (t) => t.parent.CharStrings.length - 1)
  },
  1: {
    ranges: new Oy(DE, (t) => t.parent.CharStrings.length - 1)
  },
  2: {
    ranges: new Oy(m$, (t) => t.parent.CharStrings.length - 1)
  }
}), x$ = new FE([
  wE,
  Wz,
  Hz
], new Xa(b$, {
  lazy: !0
})), y$ = new xe({
  first: F,
  fd: ze
}), w$ = new xe({
  first: ge,
  fd: F
}), OE = new qt(ze, {
  0: {
    fds: new ue(ze, (t) => t.parent.CharStrings.length)
  },
  3: {
    nRanges: F,
    ranges: new ue(y$, "nRanges"),
    sentinel: F
  },
  4: {
    nRanges: ge,
    ranges: new ue(w$, "nRanges"),
    sentinel: ge
  }
}), Vg = new Xa(d3);
class RE {
  decode(e, r, n) {
    return r.length = n[0], Vg.decode(e, r, [
      n[1]
    ]);
  }
  size(e, r) {
    return [
      d3.size(e, r, !1),
      Vg.size(e, r)[0]
    ];
  }
  encode(e, r, n) {
    return [
      d3.size(r, n, !1),
      Vg.encode(e, r, n)[0]
    ];
  }
}
let PE = new Vp([
  // key       name                   type(s)                                 default
  [
    18,
    "Private",
    new RE(),
    null
  ],
  [
    [
      12,
      38
    ],
    "FontName",
    "sid",
    null
  ],
  [
    [
      12,
      7
    ],
    "FontMatrix",
    "array",
    [
      1e-3,
      0,
      0,
      1e-3,
      0,
      0
    ]
  ],
  [
    [
      12,
      5
    ],
    "PaintType",
    "number",
    0
  ]
]), _$ = new Vp([
  // key       name                   type(s)                                 default
  [
    [
      12,
      30
    ],
    "ROS",
    [
      "sid",
      "sid",
      "number"
    ],
    null
  ],
  [
    0,
    "version",
    "sid",
    null
  ],
  [
    1,
    "Notice",
    "sid",
    null
  ],
  [
    [
      12,
      0
    ],
    "Copyright",
    "sid",
    null
  ],
  [
    2,
    "FullName",
    "sid",
    null
  ],
  [
    3,
    "FamilyName",
    "sid",
    null
  ],
  [
    4,
    "Weight",
    "sid",
    null
  ],
  [
    [
      12,
      1
    ],
    "isFixedPitch",
    "boolean",
    !1
  ],
  [
    [
      12,
      2
    ],
    "ItalicAngle",
    "number",
    0
  ],
  [
    [
      12,
      3
    ],
    "UnderlinePosition",
    "number",
    -100
  ],
  [
    [
      12,
      4
    ],
    "UnderlineThickness",
    "number",
    50
  ],
  [
    [
      12,
      5
    ],
    "PaintType",
    "number",
    0
  ],
  [
    [
      12,
      6
    ],
    "CharstringType",
    "number",
    2
  ],
  [
    [
      12,
      7
    ],
    "FontMatrix",
    "array",
    [
      1e-3,
      0,
      0,
      1e-3,
      0,
      0
    ]
  ],
  [
    13,
    "UniqueID",
    "number",
    null
  ],
  [
    5,
    "FontBBox",
    "array",
    [
      0,
      0,
      0,
      0
    ]
  ],
  [
    [
      12,
      8
    ],
    "StrokeWidth",
    "number",
    0
  ],
  [
    14,
    "XUID",
    "array",
    null
  ],
  [
    15,
    "charset",
    x$,
    wE
  ],
  [
    16,
    "Encoding",
    v$,
    yE
  ],
  [
    17,
    "CharStrings",
    new Xa(new jo()),
    null
  ],
  [
    18,
    "Private",
    new RE(),
    null
  ],
  [
    [
      12,
      20
    ],
    "SyntheticBase",
    "number",
    null
  ],
  [
    [
      12,
      21
    ],
    "PostScript",
    "sid",
    null
  ],
  [
    [
      12,
      22
    ],
    "BaseFontName",
    "sid",
    null
  ],
  [
    [
      12,
      23
    ],
    "BaseFontBlend",
    "delta",
    null
  ],
  // CID font specific
  [
    [
      12,
      31
    ],
    "CIDFontVersion",
    "number",
    0
  ],
  [
    [
      12,
      32
    ],
    "CIDFontRevision",
    "number",
    0
  ],
  [
    [
      12,
      33
    ],
    "CIDFontType",
    "number",
    0
  ],
  [
    [
      12,
      34
    ],
    "CIDCount",
    "number",
    8720
  ],
  [
    [
      12,
      35
    ],
    "UIDBase",
    "number",
    null
  ],
  [
    [
      12,
      37
    ],
    "FDSelect",
    new Xa(OE),
    null
  ],
  [
    [
      12,
      36
    ],
    "FDArray",
    new Xa(new jo(PE)),
    null
  ],
  [
    [
      12,
      38
    ],
    "FontName",
    "sid",
    null
  ]
]), A$ = new xe({
  length: F,
  itemVariationStore: jp
}), E$ = new Vp([
  [
    [
      12,
      7
    ],
    "FontMatrix",
    "array",
    [
      1e-3,
      0,
      0,
      1e-3,
      0,
      0
    ]
  ],
  [
    17,
    "CharStrings",
    new Xa(new jo()),
    null
  ],
  [
    [
      12,
      37
    ],
    "FDSelect",
    new Xa(OE),
    null
  ],
  [
    [
      12,
      36
    ],
    "FDArray",
    new Xa(new jo(PE)),
    null
  ],
  [
    24,
    "vstore",
    new Xa(A$),
    null
  ],
  [
    25,
    "maxstack",
    "number",
    193
  ]
]), S$ = new qt(sU, {
  1: {
    hdrSize: ze,
    offSize: ze,
    nameIndex: new jo(new A0("length")),
    topDictIndex: new jo(_$),
    stringIndex: new jo(new A0("length")),
    globalSubrIndex: new jo()
  },
  2: {
    hdrSize: ze,
    length: F,
    topDict: E$,
    globalSubrIndex: new jo()
  }
});
var IE = S$;
class Lb {
  static decode(e) {
    return new Lb(e);
  }
  decode() {
    this.stream.pos;
    let e = IE.decode(this.stream);
    for (let r in e) {
      let n = e[r];
      this[r] = n;
    }
    if (this.version < 2) {
      if (this.topDictIndex.length !== 1) throw new Error("Only a single font is allowed in CFF");
      this.topDict = this.topDictIndex[0];
    }
    return this.isCIDFont = this.topDict.ROS != null, this;
  }
  string(e) {
    return this.version >= 2 ? null : e < t5.length ? t5[e] : this.stringIndex[e - t5.length];
  }
  get postscriptName() {
    return this.version < 2 ? this.nameIndex[0] : null;
  }
  get fullName() {
    return this.string(this.topDict.FullName);
  }
  get familyName() {
    return this.string(this.topDict.FamilyName);
  }
  getCharString(e) {
    return this.stream.pos = this.topDict.CharStrings[e].offset, this.stream.readBuffer(this.topDict.CharStrings[e].length);
  }
  getGlyphName(e) {
    if (this.version >= 2 || this.isCIDFont) return null;
    let { charset: r } = this.topDict;
    if (Array.isArray(r)) return r[e];
    if (e === 0) return ".notdef";
    switch (e -= 1, r.version) {
      case 0:
        return this.string(r.glyphs[e]);
      case 1:
      case 2:
        for (let n = 0; n < r.ranges.length; n++) {
          let i = r.ranges[n];
          if (i.offset <= e && e <= i.offset + i.nLeft) return this.string(i.first + (e - i.offset));
        }
        break;
    }
    return null;
  }
  fdForGlyph(e) {
    if (!this.topDict.FDSelect) return null;
    switch (this.topDict.FDSelect.version) {
      case 0:
        return this.topDict.FDSelect.fds[e];
      case 3:
      case 4:
        let { ranges: r } = this.topDict.FDSelect, n = 0, i = r.length - 1;
        for (; n <= i; ) {
          let a = n + i >> 1;
          if (e < r[a].first) i = a - 1;
          else if (a < i && e >= r[a + 1].first) n = a + 1;
          else return r[a].fd;
        }
      default:
        throw new Error(`Unknown FDSelect version: ${this.topDict.FDSelect.version}`);
    }
  }
  privateDictForGlyph(e) {
    if (this.topDict.FDSelect) {
      let r = this.fdForGlyph(e);
      return this.topDict.FDArray[r] ? this.topDict.FDArray[r].Private : null;
    }
    return this.version < 2 ? this.topDict.Private : this.topDict.FDArray[0].Private;
  }
  constructor(e) {
    this.stream = e, this.decode();
  }
}
var BE = Lb;
let C$ = new xe({
  glyphIndex: F,
  vertOriginY: Be
});
var k$ = new xe({
  majorVersion: F,
  minorVersion: F,
  defaultVertOriginY: Be,
  numVertOriginYMetrics: F,
  metrics: new ue(C$, "numVertOriginYMetrics")
});
let $f = new xe({
  height: ze,
  width: ze,
  horiBearingX: Zr,
  horiBearingY: Zr,
  horiAdvance: ze,
  vertBearingX: Zr,
  vertBearingY: Zr,
  vertAdvance: ze
}), A2 = new xe({
  height: ze,
  width: ze,
  bearingX: Zr,
  bearingY: Zr,
  advance: ze
}), Ry = new xe({
  glyph: F,
  xOffset: Zr,
  yOffset: Zr
});
class Py {
}
class jg {
}
new qt("version", {
  1: {
    metrics: A2,
    data: Py
  },
  2: {
    metrics: A2,
    data: jg
  },
  // format 3 is deprecated
  // format 4 is not supported by Microsoft
  5: {
    data: jg
  },
  6: {
    metrics: $f,
    data: Py
  },
  7: {
    metrics: $f,
    data: jg
  },
  8: {
    metrics: A2,
    pad: new J0(ze),
    numComponents: F,
    components: new ue(Ry, "numComponents")
  },
  9: {
    metrics: $f,
    pad: new J0(ze),
    numComponents: F,
    components: new ue(Ry, "numComponents")
  },
  17: {
    metrics: A2,
    dataLen: ge,
    data: new Fn("dataLen")
  },
  18: {
    metrics: $f,
    dataLen: ge,
    data: new Fn("dataLen")
  },
  19: {
    dataLen: ge,
    data: new Fn("dataLen")
  }
});
let Iy = new xe({
  ascender: Zr,
  descender: Zr,
  widthMax: ze,
  caretSlopeNumerator: Zr,
  caretSlopeDenominator: Zr,
  caretOffset: Zr,
  minOriginSB: Zr,
  minAdvanceSB: Zr,
  maxBeforeBL: Zr,
  minAfterBL: Zr,
  pad: new J0(Zr, 2)
}), T$ = new xe({
  glyphCode: F,
  offset: F
}), F$ = new qt(F, {
  header: {
    imageFormat: F,
    imageDataOffset: ge
  },
  1: {
    offsetArray: new ue(ge, (t) => t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1)
  },
  2: {
    imageSize: ge,
    bigMetrics: $f
  },
  3: {
    offsetArray: new ue(F, (t) => t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1)
  },
  4: {
    numGlyphs: ge,
    glyphArray: new ue(T$, (t) => t.numGlyphs + 1)
  },
  5: {
    imageSize: ge,
    bigMetrics: $f,
    numGlyphs: ge,
    glyphCodeArray: new ue(F, "numGlyphs")
  }
}), D$ = new xe({
  firstGlyphIndex: F,
  lastGlyphIndex: F,
  subtable: new de(ge, F$)
}), O$ = new xe({
  indexSubTableArray: new de(ge, new ue(D$, 1), {
    type: "parent"
  }),
  indexTablesSize: ge,
  numberOfIndexSubTables: ge,
  colorRef: ge,
  hori: Iy,
  vert: Iy,
  startGlyphIndex: F,
  endGlyphIndex: F,
  ppemX: ze,
  ppemY: ze,
  bitDepth: ze,
  flags: new ao(ze, [
    "horizontal",
    "vertical"
  ])
});
var R$ = new xe({
  version: ge,
  numSizes: ge,
  sizes: new ue(O$, "numSizes")
});
let P$ = new xe({
  ppem: F,
  resolution: F,
  imageOffsets: new ue(new de(ge, "void"), (t) => t.parent.parent.maxp.numGlyphs + 1)
});
var I$ = new xe({
  version: F,
  flags: new ao(F, [
    "renderOutlines"
  ]),
  numImgTables: ge,
  imageTables: new ue(new de(ge, P$), "numImgTables")
});
let B$ = new xe({
  gid: F,
  paletteIndex: F
  // Index value to use in the appropriate palette. This value must
}), L$ = new xe({
  gid: F,
  // and is not rendered for color.
  firstLayerIndex: F,
  // There will be numLayers consecutive entries for this base glyph.
  numLayers: F
});
var N$ = new xe({
  version: F,
  numBaseGlyphRecords: F,
  baseGlyphRecord: new de(ge, new ue(L$, "numBaseGlyphRecords")),
  layerRecords: new de(ge, new ue(B$, "numLayerRecords"), {
    lazy: !0
  }),
  numLayerRecords: F
});
let M$ = new xe({
  blue: ze,
  green: ze,
  red: ze,
  alpha: ze
});
var U$ = new qt(F, {
  header: {
    numPaletteEntries: F,
    numPalettes: F,
    numColorRecords: F,
    colorRecords: new de(ge, new ue(M$, "numColorRecords")),
    colorRecordIndices: new ue(F, "numPalettes")
  },
  0: {},
  1: {
    offsetPaletteTypeArray: new de(ge, new ue(ge, "numPalettes")),
    offsetPaletteLabelArray: new de(ge, new ue(F, "numPalettes")),
    offsetPaletteEntryLabelArray: new de(ge, new ue(F, "numPaletteEntries"))
  }
});
let eh = new qt(F, {
  1: {
    coordinate: Be
    // X or Y value, in design units
  },
  2: {
    coordinate: Be,
    referenceGlyph: F,
    baseCoordPoint: F
    // Index of contour point on the referenceGlyph
  },
  3: {
    coordinate: Be,
    deviceTable: new de(F, Hl)
    // Device table for X or Y value
  }
}), z$ = new xe({
  defaultIndex: F,
  baseCoordCount: F,
  baseCoords: new ue(new de(F, eh), "baseCoordCount")
}), $$ = new xe({
  tag: new A0(4),
  minCoord: new de(F, eh, {
    type: "parent"
  }),
  maxCoord: new de(F, eh, {
    type: "parent"
  })
  // May be NULL
}), LE = new xe({
  minCoord: new de(F, eh),
  maxCoord: new de(F, eh),
  featMinMaxCount: F,
  featMinMaxRecords: new ue($$, "featMinMaxCount")
  // In alphabetical order
}), V$ = new xe({
  tag: new A0(4),
  minMax: new de(F, LE, {
    type: "parent"
  })
}), j$ = new xe({
  baseValues: new de(F, z$),
  defaultMinMax: new de(F, LE),
  baseLangSysCount: F,
  baseLangSysRecords: new ue(V$, "baseLangSysCount")
  // in alphabetical order by BaseLangSysTag
}), W$ = new xe({
  tag: new A0(4),
  script: new de(F, j$, {
    type: "parent"
  })
}), H$ = new ue(W$, F), q$ = new ue(new A0(4), F), By = new xe({
  baseTagList: new de(F, q$),
  baseScriptList: new de(F, H$)
});
var Y$ = new qt(ge, {
  header: {
    horizAxis: new de(F, By),
    vertAxis: new de(F, By)
    // May be NULL
  },
  65536: {},
  65537: {
    itemVariationStore: new de(ge, jp)
  }
});
let G$ = new ue(F, F), Z$ = new xe({
  coverage: new de(F, I0),
  glyphCount: F,
  attachPoints: new ue(new de(F, G$), "glyphCount")
}), X$ = new qt(F, {
  1: {
    coordinate: Be
  },
  2: {
    caretValuePoint: F
  },
  3: {
    coordinate: Be,
    deviceTable: new de(F, Hl)
  }
}), K$ = new ue(new de(F, X$), F), J$ = new xe({
  coverage: new de(F, I0),
  ligGlyphCount: F,
  ligGlyphs: new ue(new de(F, K$), "ligGlyphCount")
}), Ly = new xe({
  markSetTableFormat: F,
  markSetCount: F,
  coverage: new ue(new de(ge, I0), "markSetCount")
});
var Q$ = new qt(ge, {
  header: {
    glyphClassDef: new de(F, Jl),
    attachList: new de(F, Z$),
    ligCaretList: new de(F, J$),
    markAttachClassDef: new de(F, Jl)
  },
  65536: {},
  65538: {
    markGlyphSetsDef: new de(F, Ly)
  },
  65539: {
    markGlyphSetsDef: new de(F, Ly),
    itemVariationStore: new de(ge, jp)
  }
});
let kf = new ao(F, [
  "xPlacement",
  "yPlacement",
  "xAdvance",
  "yAdvance",
  "xPlaDevice",
  "yPlaDevice",
  "xAdvDevice",
  "yAdvDevice"
]), eV = {
  xPlacement: Be,
  yPlacement: Be,
  xAdvance: Be,
  yAdvance: Be,
  xPlaDevice: new de(F, Hl, {
    type: "global",
    relativeTo: (t) => t.rel
  }),
  yPlaDevice: new de(F, Hl, {
    type: "global",
    relativeTo: (t) => t.rel
  }),
  xAdvDevice: new de(F, Hl, {
    type: "global",
    relativeTo: (t) => t.rel
  }),
  yAdvDevice: new de(F, Hl, {
    type: "global",
    relativeTo: (t) => t.rel
  })
};
class s1 {
  buildStruct(e) {
    let r = e;
    for (; !r[this.key] && r.parent; ) r = r.parent;
    if (!r[this.key]) return;
    let n = {};
    n.rel = () => r._startOffset;
    let i = r[this.key];
    for (let a in i) i[a] && (n[a] = eV[a]);
    return new xe(n);
  }
  size(e, r) {
    return this.buildStruct(r).size(e, r);
  }
  decode(e, r) {
    let n = this.buildStruct(r).decode(e, r);
    return delete n.rel, n;
  }
  constructor(e = "valueFormat") {
    this.key = e;
  }
}
let tV = new xe({
  secondGlyph: F,
  value1: new s1("valueFormat1"),
  value2: new s1("valueFormat2")
}), rV = new ue(tV, F), nV = new xe({
  value1: new s1("valueFormat1"),
  value2: new s1("valueFormat2")
}), th = new qt(F, {
  1: {
    xCoordinate: Be,
    yCoordinate: Be
  },
  2: {
    xCoordinate: Be,
    yCoordinate: Be,
    anchorPoint: F
  },
  3: {
    xCoordinate: Be,
    yCoordinate: Be,
    xDeviceTable: new de(F, Hl),
    yDeviceTable: new de(F, Hl)
  }
}), iV = new xe({
  entryAnchor: new de(F, th, {
    type: "parent"
  }),
  exitAnchor: new de(F, th, {
    type: "parent"
  })
}), aV = new xe({
  class: F,
  markAnchor: new de(F, th, {
    type: "parent"
  })
}), Wg = new ue(aV, F), oV = new ue(new de(F, th), (t) => t.parent.classCount), Ny = new ue(oV, F), sV = new ue(new de(F, th), (t) => t.parent.parent.classCount), lV = new ue(sV, F), uV = new ue(new de(F, lV), F), rh = new qt("lookupType", {
  1: new qt(F, {
    1: {
      coverage: new de(F, I0),
      valueFormat: kf,
      value: new s1()
    },
    2: {
      coverage: new de(F, I0),
      valueFormat: kf,
      valueCount: F,
      values: new j0(new s1(), "valueCount")
    }
  }),
  2: new qt(F, {
    1: {
      coverage: new de(F, I0),
      valueFormat1: kf,
      valueFormat2: kf,
      pairSetCount: F,
      pairSets: new j0(new de(F, rV), "pairSetCount")
    },
    2: {
      coverage: new de(F, I0),
      valueFormat1: kf,
      valueFormat2: kf,
      classDef1: new de(F, Jl),
      classDef2: new de(F, Jl),
      class1Count: F,
      class2Count: F,
      classRecords: new j0(new j0(nV, "class2Count"), "class1Count")
    }
  }),
  3: {
    format: F,
    coverage: new de(F, I0),
    entryExitCount: F,
    entryExitRecords: new ue(iV, "entryExitCount")
  },
  4: {
    format: F,
    markCoverage: new de(F, I0),
    baseCoverage: new de(F, I0),
    classCount: F,
    markArray: new de(F, Wg),
    baseArray: new de(F, Ny)
  },
  5: {
    format: F,
    markCoverage: new de(F, I0),
    ligatureCoverage: new de(F, I0),
    classCount: F,
    markArray: new de(F, Wg),
    ligatureArray: new de(F, uV)
  },
  6: {
    format: F,
    mark1Coverage: new de(F, I0),
    mark2Coverage: new de(F, I0),
    classCount: F,
    mark1Array: new de(F, Wg),
    mark2Array: new de(F, Ny)
  },
  7: CE,
  8: kE,
  9: {
    posFormat: F,
    lookupType: F,
    extension: new de(ge, null)
  }
});
rh.versions[9].extension.type = rh;
var cV = new qt(ge, {
  header: {
    scriptList: new de(F, AE),
    featureList: new de(F, SE),
    lookupList: new de(F, new z5(rh))
  },
  65536: {},
  65537: {
    featureVariations: new de(ge, TE)
  }
});
let NE = new ue(F, F), fV = NE, dV = new xe({
  glyph: F,
  compCount: F,
  components: new ue(F, (t) => t.compCount - 1)
}), hV = new ue(new de(F, dV), F), h3 = new qt("lookupType", {
  1: new qt(F, {
    1: {
      coverage: new de(F, I0),
      deltaGlyphID: Be
    },
    2: {
      coverage: new de(F, I0),
      glyphCount: F,
      substitute: new j0(F, "glyphCount")
    }
  }),
  2: {
    substFormat: F,
    coverage: new de(F, I0),
    count: F,
    sequences: new j0(new de(F, NE), "count")
  },
  3: {
    substFormat: F,
    coverage: new de(F, I0),
    count: F,
    alternateSet: new j0(new de(F, fV), "count")
  },
  4: {
    substFormat: F,
    coverage: new de(F, I0),
    count: F,
    ligatureSets: new j0(new de(F, hV), "count")
  },
  5: CE,
  6: kE,
  7: {
    substFormat: F,
    lookupType: F,
    extension: new de(ge, null)
  },
  8: {
    substFormat: F,
    coverage: new de(F, I0),
    backtrackCoverage: new ue(new de(F, I0), "backtrackGlyphCount"),
    lookaheadGlyphCount: F,
    lookaheadCoverage: new ue(new de(F, I0), "lookaheadGlyphCount"),
    glyphCount: F,
    substitutes: new ue(F, "glyphCount")
  }
});
h3.versions[7].extension.type = h3;
var pV = new qt(ge, {
  header: {
    scriptList: new de(F, AE),
    featureList: new de(F, SE),
    lookupList: new de(F, new z5(h3))
  },
  65536: {},
  65537: {
    featureVariations: new de(ge, TE)
  }
});
let kl = new ue(F, F), mV = new xe({
  shrinkageEnableGSUB: new de(F, kl),
  shrinkageDisableGSUB: new de(F, kl),
  shrinkageEnableGPOS: new de(F, kl),
  shrinkageDisableGPOS: new de(F, kl),
  shrinkageJstfMax: new de(F, new z5(rh)),
  extensionEnableGSUB: new de(F, kl),
  extensionDisableGSUB: new de(F, kl),
  extensionEnableGPOS: new de(F, kl),
  extensionDisableGPOS: new de(F, kl),
  extensionJstfMax: new de(F, new z5(rh))
}), ME = new ue(new de(F, mV), F), gV = new xe({
  tag: new A0(4),
  jstfLangSys: new de(F, ME)
}), vV = new xe({
  extenderGlyphs: new de(F, new ue(F, F)),
  defaultLangSys: new de(F, ME),
  langSysCount: F,
  langSysRecords: new ue(gV, "langSysCount")
}), bV = new xe({
  tag: new A0(4),
  script: new de(F, vV, {
    type: "parent"
  })
});
var xV = new xe({
  version: ge,
  scriptCount: F,
  scriptList: new ue(bV, "scriptCount")
});
class yV {
  decode(e, r) {
    switch (this.size(0, r)) {
      case 1:
        return e.readUInt8();
      case 2:
        return e.readUInt16BE();
      case 3:
        return e.readUInt24BE();
      case 4:
        return e.readUInt32BE();
    }
  }
  size(e, r) {
    return os(this._size, null, r);
  }
  constructor(e) {
    this._size = e;
  }
}
let wV = new xe({
  entry: new yV((t) => ((t.parent.entryFormat & 48) >> 4) + 1),
  outerIndex: (t) => t.entry >> (t.parent.entryFormat & 15) + 1,
  innerIndex: (t) => t.entry & (1 << (t.parent.entryFormat & 15) + 1) - 1
}), Hg = new xe({
  entryFormat: F,
  mapCount: F,
  mapData: new ue(wV, "mapCount")
});
var _V = new xe({
  majorVersion: F,
  minorVersion: F,
  itemVariationStore: new de(ge, jp),
  advanceWidthMapping: new de(ge, Hg),
  LSBMapping: new de(ge, Hg),
  RSBMapping: new de(ge, Hg)
});
let AV = new xe({
  format: ge,
  length: ge,
  offset: ge
}), EV = new xe({
  reserved: new J0(F, 2),
  cbSignature: ge,
  signature: new Fn("cbSignature")
});
var SV = new xe({
  ulVersion: ge,
  usNumSigs: F,
  usFlag: F,
  signatures: new ue(AV, "usNumSigs"),
  signatureBlocks: new ue(EV, "usNumSigs")
});
let CV = new xe({
  rangeMaxPPEM: F,
  rangeGaspBehavior: new ao(F, [
    "grayscale",
    "gridfit",
    "symmetricSmoothing",
    "symmetricGridfit"
    // only in version 1, for ClearType
  ])
});
var kV = new xe({
  version: F,
  numRanges: F,
  gaspRanges: new ue(CV, "numRanges")
  // Sorted by ppem
});
let TV = new xe({
  pixelSize: ze,
  maximumWidth: ze,
  widths: new ue(ze, (t) => t.parent.parent.maxp.numGlyphs)
});
var FV = new xe({
  version: F,
  numRecords: Be,
  sizeDeviceRecord: Vu,
  records: new ue(TV, "numRecords")
});
let DV = new xe({
  left: F,
  right: F,
  value: Be
}), My = new xe({
  firstGlyph: F,
  nGlyphs: F,
  offsets: new ue(F, "nGlyphs"),
  max: (t) => t.offsets.length && Math.max.apply(Math, t.offsets)
}), OV = new xe({
  off: (t) => t._startOffset - t.parent.parent._startOffset,
  len: (t) => ((t.parent.leftTable.max - t.off) / t.parent.rowWidth + 1) * (t.parent.rowWidth / 2),
  values: new j0(Be, "len")
}), Uy = new qt("format", {
  0: {
    nPairs: F,
    searchRange: F,
    entrySelector: F,
    rangeShift: F,
    pairs: new ue(DV, "nPairs")
  },
  2: {
    rowWidth: F,
    leftTable: new de(F, My, {
      type: "parent"
    }),
    rightTable: new de(F, My, {
      type: "parent"
    }),
    array: new de(F, OV, {
      type: "parent"
    })
  },
  3: {
    glyphCount: F,
    kernValueCount: ze,
    leftClassCount: ze,
    rightClassCount: ze,
    flags: ze,
    kernValue: new ue(Be, "kernValueCount"),
    leftClass: new ue(ze, "glyphCount"),
    rightClass: new ue(ze, "glyphCount"),
    kernIndex: new ue(ze, (t) => t.leftClassCount * t.rightClassCount)
  }
}), zy = new qt("version", {
  0: {
    subVersion: F,
    length: F,
    format: ze,
    coverage: new ao(ze, [
      "horizontal",
      "minimum",
      "crossStream",
      "override"
      // If set to 1 the value in this table replaces the accumulated value
    ]),
    subtable: Uy,
    padding: new J0(ze, (t) => t.length - t._currentOffset)
  },
  1: {
    length: ge,
    coverage: new ao(ze, [
      null,
      null,
      null,
      null,
      null,
      "variation",
      "crossStream",
      "vertical"
      // Set if table has vertical kerning values
    ]),
    format: ze,
    tupleIndex: F,
    subtable: Uy,
    padding: new J0(ze, (t) => t.length - t._currentOffset)
  }
});
var RV = new qt(F, {
  0: {
    nTables: F,
    tables: new ue(zy, "nTables")
  },
  1: {
    reserved: new J0(F),
    nTables: ge,
    tables: new ue(zy, "nTables")
  }
}), PV = new xe({
  version: F,
  numGlyphs: F,
  yPels: new ue(ze, "numGlyphs")
}), IV = new xe({
  version: F,
  fontNumber: ge,
  pitch: F,
  xHeight: F,
  style: F,
  typeFamily: F,
  capHeight: F,
  symbolSet: F,
  typeface: new A0(16),
  characterComplement: new A0(8),
  fileName: new A0(6),
  strokeWeight: new A0(1),
  widthType: new A0(1),
  serifStyle: ze,
  reserved: new J0(ze)
});
let BV = new xe({
  bCharSet: ze,
  xRatio: ze,
  yStartRatio: ze,
  yEndRatio: ze
  // Ending y-Ratio value
}), LV = new xe({
  yPelHeight: F,
  yMax: Be,
  yMin: Be
  // Minimum value (in pels) for this yPelHeight
}), NV = new xe({
  recs: F,
  startsz: ze,
  endsz: ze,
  entries: new ue(LV, "recs")
  // The VDMX records
});
var MV = new xe({
  version: F,
  numRecs: F,
  numRatios: F,
  ratioRanges: new ue(BV, "numRatios"),
  offsets: new ue(F, "numRatios"),
  groups: new ue(NV, "numRecs")
  // The actual VDMX groupings
}), UV = new xe({
  version: F,
  ascent: Be,
  descent: Be,
  lineGap: Be,
  advanceHeightMax: Be,
  minTopSideBearing: Be,
  minBottomSideBearing: Be,
  yMaxExtent: Be,
  caretSlopeRise: Be,
  caretSlopeRun: Be,
  caretOffset: Be,
  reserved: new J0(Be, 4),
  metricDataFormat: Be,
  numberOfMetrics: F
  // Number of advance heights in the Vertical Metrics table
});
let zV = new xe({
  advance: F,
  bearing: Be
  // The top sidebearing of the glyph
});
var $V = new xe({
  metrics: new j0(zV, (t) => t.parent.vhea.numberOfMetrics),
  bearings: new j0(Be, (t) => t.parent.maxp.numGlyphs - t.parent.vhea.numberOfMetrics)
});
let $y = new kc(16, "BE", 14), VV = new xe({
  fromCoord: $y,
  toCoord: $y
}), jV = new xe({
  pairCount: F,
  correspondence: new ue(VV, "pairCount")
});
var WV = new xe({
  version: Er,
  axisCount: ge,
  segment: new ue(jV, "axisCount")
});
class HV {
  getItem(e) {
    if (this._items[e] == null) {
      let r = this.stream.pos;
      this.stream.pos = this.base + this.type.size(null, this.parent) * e, this._items[e] = this.type.decode(this.stream, this.parent), this.stream.pos = r;
    }
    return this._items[e];
  }
  inspect() {
    return `[UnboundedArray ${this.type.constructor.name}]`;
  }
  constructor(e, r, n) {
    this.type = e, this.stream = r, this.parent = n, this.base = this.stream.pos, this._items = [];
  }
}
class Jo extends ue {
  decode(e, r) {
    return new HV(this.type, e, r);
  }
  constructor(e) {
    super(e, 0);
  }
}
let au = function(t = F) {
  class e {
    decode(s, l) {
      return l = l.parent.parent, this.type.decode(s, l);
    }
    size(s, l) {
      return l = l.parent.parent, this.type.size(s, l);
    }
    encode(s, l, u) {
      return u = u.parent.parent, this.type.encode(s, l, u);
    }
    constructor(s) {
      this.type = s;
    }
  }
  t = new e(t);
  let r = new xe({
    unitSize: F,
    nUnits: F,
    searchRange: F,
    entrySelector: F,
    rangeShift: F
  }), n = new xe({
    lastGlyph: F,
    firstGlyph: F,
    value: t
  }), i = new xe({
    lastGlyph: F,
    firstGlyph: F,
    values: new de(F, new ue(t, (o) => o.lastGlyph - o.firstGlyph + 1), {
      type: "parent"
    })
  }), a = new xe({
    glyph: F,
    value: t
  });
  return new qt(F, {
    0: {
      values: new Jo(t)
      // length == number of glyphs maybe?
    },
    2: {
      binarySearchHeader: r,
      segments: new ue(n, (o) => o.binarySearchHeader.nUnits)
    },
    4: {
      binarySearchHeader: r,
      segments: new ue(i, (o) => o.binarySearchHeader.nUnits)
    },
    6: {
      binarySearchHeader: r,
      segments: new ue(a, (o) => o.binarySearchHeader.nUnits)
    },
    8: {
      firstGlyph: F,
      count: F,
      values: new ue(t, "count")
    }
  });
};
function E2(t = {}, e = F) {
  let r = Object.assign({
    newState: F,
    flags: F
  }, t), n = new xe(r), i = new Jo(new ue(F, (o) => o.nClasses));
  return new xe({
    nClasses: ge,
    classTable: new de(ge, new au(e)),
    stateArray: new de(ge, i),
    entryTable: new de(ge, new Jo(n))
  });
}
function qV(t = {}, e = F) {
  let r = new xe({
    version() {
      return 8;
    },
    firstGlyph: F,
    values: new ue(ze, F)
  }), n = Object.assign({
    newStateOffset: F,
    // convert offset to stateArray index
    newState: (s) => (s.newStateOffset - (s.parent.stateArray.base - s.parent._startOffset)) / s.parent.nClasses,
    flags: F
  }, t), i = new xe(n), a = new Jo(new ue(ze, (s) => s.nClasses));
  return new xe({
    nClasses: F,
    classTable: new de(F, r),
    stateArray: new de(F, a),
    entryTable: new de(F, new Jo(i))
  });
}
let YV = new qt("format", {
  0: {
    deltas: new ue(Be, 32)
  },
  1: {
    deltas: new ue(Be, 32),
    mappingData: new au(F)
  },
  2: {
    standardGlyph: F,
    controlPoints: new ue(F, 32)
  },
  3: {
    standardGlyph: F,
    controlPoints: new ue(F, 32),
    mappingData: new au(F)
  }
});
var GV = new xe({
  version: Er,
  format: F,
  defaultBaseline: F,
  subtable: YV
});
let ZV = new xe({
  setting: F,
  nameIndex: Be,
  name: (t) => t.parent.parent.parent.name.records.fontFeatures[t.nameIndex]
}), XV = new xe({
  feature: F,
  nSettings: F,
  settingTable: new de(ge, new ue(ZV, "nSettings"), {
    type: "parent"
  }),
  featureFlags: new ao(ze, [
    null,
    null,
    null,
    null,
    null,
    null,
    "hasDefault",
    "exclusive"
  ]),
  defaultSetting: ze,
  nameIndex: Be,
  name: (t) => t.parent.parent.name.records.fontFeatures[t.nameIndex]
});
var KV = new xe({
  version: Er,
  featureNameCount: F,
  reserved1: new J0(F),
  reserved2: new J0(ge),
  featureNames: new ue(XV, "featureNameCount")
});
let JV = new xe({
  axisTag: new A0(4),
  minValue: Er,
  defaultValue: Er,
  maxValue: Er,
  flags: F,
  nameID: F,
  name: (t) => t.parent.parent.name.records.fontFeatures[t.nameID]
}), QV = new xe({
  nameID: F,
  name: (t) => t.parent.parent.name.records.fontFeatures[t.nameID],
  flags: F,
  coord: new ue(Er, (t) => t.parent.axisCount),
  postscriptNameID: new B5(F, (t) => t.parent.instanceSize - t._currentOffset > 0)
});
var ej = new xe({
  version: Er,
  offsetToData: F,
  countSizePairs: F,
  axisCount: F,
  axisSize: F,
  instanceCount: F,
  instanceSize: F,
  axis: new ue(JV, "axisCount"),
  instance: new ue(QV, "instanceCount")
});
let tj = new kc(16, "BE", 14);
class rj {
  static decode(e, r) {
    return r.flags ? e.readUInt32BE() : e.readUInt16BE() * 2;
  }
}
let nj = new xe({
  version: F,
  reserved: new J0(F),
  axisCount: F,
  globalCoordCount: F,
  globalCoords: new de(ge, new ue(new ue(tj, "axisCount"), "globalCoordCount")),
  glyphCount: F,
  flags: F,
  offsetToData: ge,
  offsets: new ue(new de(rj, "void", {
    relativeTo: (t) => t.offsetToData,
    allowNull: !1
  }), (t) => t.glyphCount + 1)
});
var ij = nj;
let aj = new xe({
  length: F,
  coverage: F,
  subFeatureFlags: ge,
  stateTable: new qV()
}), oj = new xe({
  justClass: ge,
  beforeGrowLimit: Er,
  beforeShrinkLimit: Er,
  afterGrowLimit: Er,
  afterShrinkLimit: Er,
  growFlags: F,
  shrinkFlags: F
}), sj = new ue(oj, ge), lj = new qt("actionType", {
  0: {
    lowerLimit: Er,
    upperLimit: Er,
    order: F,
    glyphs: new ue(F, F)
  },
  1: {
    addGlyph: F
  },
  2: {
    substThreshold: Er,
    addGlyph: F,
    substGlyph: F
  },
  3: {},
  4: {
    variationAxis: ge,
    minimumLimit: Er,
    noStretchValue: Er,
    maximumLimit: Er
  },
  5: {
    flags: F,
    glyph: F
  }
}), uj = new xe({
  actionClass: F,
  actionType: F,
  actionLength: ge,
  actionData: lj,
  padding: new J0(ze, (t) => t.actionLength - t._currentOffset)
}), cj = new ue(uj, ge), fj = new xe({
  lookupTable: new au(new de(F, cj))
}), Vy = new xe({
  classTable: new de(F, aj, {
    type: "parent"
  }),
  wdcOffset: F,
  postCompensationTable: new de(F, fj, {
    type: "parent"
  }),
  widthDeltaClusters: new au(new de(F, sj, {
    type: "parent",
    relativeTo: (t) => t.wdcOffset
  }))
});
var dj = new xe({
  version: ge,
  format: F,
  horizontal: new de(F, Vy),
  vertical: new de(F, Vy)
});
let hj = {
  action: F
}, pj = {
  markIndex: F,
  currentIndex: F
}, mj = {
  currentInsertIndex: F,
  markedInsertIndex: F
}, gj = new xe({
  items: new Jo(new de(ge, new au()))
}), vj = new qt("type", {
  0: {
    stateTable: new E2()
  },
  1: {
    stateTable: new E2(pj),
    substitutionTable: new de(ge, gj)
  },
  2: {
    stateTable: new E2(hj),
    ligatureActions: new de(ge, new Jo(ge)),
    components: new de(ge, new Jo(F)),
    ligatureList: new de(ge, new Jo(F))
  },
  4: {
    lookupTable: new au()
  },
  5: {
    stateTable: new E2(mj),
    insertionActions: new de(ge, new Jo(F))
  }
}), bj = new xe({
  length: ge,
  coverage: Kl,
  type: ze,
  subFeatureFlags: ge,
  table: vj,
  padding: new J0(ze, (t) => t.length - t._currentOffset)
}), xj = new xe({
  featureType: F,
  featureSetting: F,
  enableFlags: ge,
  disableFlags: ge
}), yj = new xe({
  defaultFlags: ge,
  chainLength: ge,
  nFeatureEntries: ge,
  nSubtables: ge,
  features: new ue(xj, "nFeatureEntries"),
  subtables: new ue(bj, "nSubtables")
});
var wj = new xe({
  version: F,
  unused: new J0(F),
  nChains: ge,
  chains: new ue(yj, "nChains")
});
let _j = new xe({
  left: Be,
  top: Be,
  right: Be,
  bottom: Be
});
var Aj = new xe({
  version: Er,
  format: F,
  lookupTable: new au(_j)
});
let Nt = {};
var $5 = Nt;
Nt.cmap = _z;
Nt.head = Az;
Nt.hhea = Ez;
Nt.hmtx = Cz;
Nt.maxp = kz;
Nt.name = Iz;
Nt["OS/2"] = Bz;
Nt.post = Lz;
Nt.fpgm = Mz;
Nt.loca = Uz;
Nt.prep = zz;
Nt["cvt "] = Nz;
Nt.glyf = $z;
Nt["CFF "] = BE;
Nt.CFF2 = BE;
Nt.VORG = k$;
Nt.EBLC = R$;
Nt.CBLC = Nt.EBLC;
Nt.sbix = I$;
Nt.COLR = N$;
Nt.CPAL = U$;
Nt.BASE = Y$;
Nt.GDEF = Q$;
Nt.GPOS = cV;
Nt.GSUB = pV;
Nt.JSTF = xV;
Nt.HVAR = _V;
Nt.DSIG = SV;
Nt.gasp = kV;
Nt.hdmx = FV;
Nt.kern = RV;
Nt.LTSH = PV;
Nt.PCLT = IV;
Nt.VDMX = MV;
Nt.vhea = UV;
Nt.vmtx = $V;
Nt.avar = WV;
Nt.bsln = GV;
Nt.feat = KV;
Nt.fvar = ej;
Nt.gvar = ij;
Nt.just = dj;
Nt.morx = wj;
Nt.opbd = Aj;
let Ej = new xe({
  tag: new A0(4),
  checkSum: ge,
  offset: new de(ge, "void", {
    type: "global"
  }),
  length: ge
}), Nb = new xe({
  tag: new A0(4),
  numTables: F,
  searchRange: F,
  entrySelector: F,
  rangeShift: F,
  tables: new ue(Ej, "numTables")
});
Nb.process = function() {
  let t = {};
  for (let e of this.tables) t[e.tag] = e;
  this.tables = t;
};
Nb.preEncode = function() {
  if (!Array.isArray(this.tables)) {
    let r = [];
    for (let n in this.tables) {
      let i = this.tables[n];
      i && r.push({
        tag: n,
        checkSum: 0,
        offset: new l3($5[n], i),
        length: $5[n].size(i)
      });
    }
    this.tables = r;
  }
  this.tag = "true", this.numTables = this.tables.length;
  let t = Math.floor(Math.log(this.numTables) / Math.LN2), e = Math.pow(2, t);
  this.searchRange = e * 16, this.entrySelector = Math.log(e) / Math.LN2, this.rangeShift = this.numTables * 16 - this.searchRange;
};
var UE = Nb;
function r5(t, e) {
  let r = 0, n = t.length - 1;
  for (; r <= n; ) {
    let i = r + n >> 1, a = e(t[i]);
    if (a < 0) n = i - 1;
    else if (a > 0) r = i + 1;
    else return i;
  }
  return -1;
}
function Lf(t, e) {
  let r = [];
  for (; t < e; ) r.push(t++);
  return r;
}
const Wp = new TextDecoder("ascii"), jy = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Td = new Uint8Array(256);
for (let t = 0; t < jy.length; t++) Td[jy.charCodeAt(t)] = t;
function Mb(t) {
  let e = t.length * 0.75;
  t[t.length - 1] === "=" && (e--, t[t.length - 2] === "=" && e--);
  let r = new Uint8Array(e), n = 0;
  for (let i = 0, a = t.length; i < a; i += 4) {
    let o = Td[t.charCodeAt(i)], s = Td[t.charCodeAt(i + 1)], l = Td[t.charCodeAt(i + 2)], u = Td[t.charCodeAt(i + 3)];
    r[n++] = o << 2 | s >> 4, r[n++] = (s & 15) << 4 | l >> 2, r[n++] = (l & 3) << 6 | u & 63;
  }
  return r;
}
class Ub {
  findSubtable(e, r) {
    for (let [n, i] of r) for (let a of e.tables)
      if (a.platformID === n && a.encodingID === i) return a.table;
    return null;
  }
  lookup(e, r) {
    if (this.encoding) e = this.encoding.get(e) || e;
    else if (r) {
      let i = this.getVariationSelector(e, r);
      if (i) return i;
    }
    let n = this.cmap;
    switch (n.version) {
      case 0:
        return n.codeMap.get(e) || 0;
      case 4: {
        let i = 0, a = n.segCount - 1;
        for (; i <= a; ) {
          let o = i + a >> 1;
          if (e < n.startCode.get(o)) a = o - 1;
          else if (e > n.endCode.get(o)) i = o + 1;
          else {
            let s = n.idRangeOffset.get(o), l;
            if (s === 0) l = e + n.idDelta.get(o);
            else {
              let u = s / 2 + (e - n.startCode.get(o)) - (n.segCount - o);
              l = n.glyphIndexArray.get(u) || 0, l !== 0 && (l += n.idDelta.get(o));
            }
            return l & 65535;
          }
        }
        return 0;
      }
      case 8:
        throw new Error("TODO: cmap format 8");
      case 6:
      case 10:
        return n.glyphIndices.get(e - n.firstCode) || 0;
      case 12:
      case 13: {
        let i = 0, a = n.nGroups - 1;
        for (; i <= a; ) {
          let o = i + a >> 1, s = n.groups.get(o);
          if (e < s.startCharCode) a = o - 1;
          else if (e > s.endCharCode) i = o + 1;
          else
            return n.version === 12 ? s.glyphID + (e - s.startCharCode) : s.glyphID;
        }
        return 0;
      }
      case 14:
        throw new Error("TODO: cmap format 14");
      default:
        throw new Error(`Unknown cmap format ${n.version}`);
    }
  }
  getVariationSelector(e, r) {
    if (!this.uvs) return 0;
    let n = this.uvs.varSelectors.toArray(), i = r5(n, (o) => r - o.varSelector), a = n[i];
    return i !== -1 && a.defaultUVS && (i = r5(a.defaultUVS, (o) => e < o.startUnicodeValue ? -1 : e > o.startUnicodeValue + o.additionalCount ? 1 : 0)), i !== -1 && a.nonDefaultUVS && (i = r5(a.nonDefaultUVS, (o) => e - o.unicodeValue), i !== -1) ? a.nonDefaultUVS[i].glyphID : 0;
  }
  getCharacterSet() {
    let e = this.cmap;
    switch (e.version) {
      case 0:
        return Lf(0, e.codeMap.length);
      case 4: {
        let r = [], n = e.endCode.toArray();
        for (let i = 0; i < n.length; i++) {
          let a = n[i] + 1, o = e.startCode.get(i);
          r.push(...Lf(o, a));
        }
        return r;
      }
      case 8:
        throw new Error("TODO: cmap format 8");
      case 6:
      case 10:
        return Lf(e.firstCode, e.firstCode + e.glyphIndices.length);
      case 12:
      case 13: {
        let r = [];
        for (let n of e.groups.toArray()) r.push(...Lf(n.startCharCode, n.endCharCode + 1));
        return r;
      }
      case 14:
        throw new Error("TODO: cmap format 14");
      default:
        throw new Error(`Unknown cmap format ${e.version}`);
    }
  }
  codePointsForGlyph(e) {
    let r = this.cmap;
    switch (r.version) {
      case 0: {
        let i = [];
        for (let a = 0; a < 256; a++) r.codeMap.get(a) === e && i.push(a);
        return i;
      }
      case 4: {
        let i = [];
        for (let a = 0; a < r.segCount; a++) {
          let o = r.endCode.get(a), s = r.startCode.get(a), l = r.idRangeOffset.get(a), u = r.idDelta.get(a);
          for (var n = s; n <= o; n++) {
            let d = 0;
            if (l === 0) d = n + u;
            else {
              let h = l / 2 + (n - s) - (r.segCount - a);
              d = r.glyphIndexArray.get(h) || 0, d !== 0 && (d += u);
            }
            d === e && i.push(n);
          }
        }
        return i;
      }
      case 12: {
        let i = [];
        for (let a of r.groups.toArray()) e >= a.glyphID && e <= a.glyphID + (a.endCharCode - a.startCharCode) && i.push(a.startCharCode + (e - a.glyphID));
        return i;
      }
      case 13: {
        let i = [];
        for (let a of r.groups.toArray()) e === a.glyphID && i.push(...Lf(a.startCharCode, a.endCharCode + 1));
        return i;
      }
      default:
        throw new Error(`Unknown cmap format ${r.version}`);
    }
  }
  constructor(e) {
    if (this.encoding = null, this.cmap = this.findSubtable(e, [
      // 32-bit subtables
      [
        3,
        10
      ],
      [
        0,
        6
      ],
      [
        0,
        4
      ],
      // 16-bit subtables
      [
        3,
        1
      ],
      [
        0,
        3
      ],
      [
        0,
        2
      ],
      [
        0,
        1
      ],
      [
        0,
        0
      ]
    ]), !this.cmap) for (let r of e.tables) {
      let n = bE(r.platformID, r.encodingID, r.table.language - 1), i = Dz(n);
      i && (this.cmap = r.table, this.encoding = i);
    }
    if (!this.cmap) throw new Error("Could not find a supported cmap table");
    this.uvs = this.findSubtable(e, [
      [
        0,
        5
      ]
    ]), this.uvs && this.uvs.version !== 14 && (this.uvs = null);
  }
}
Pn([
  In
], Ub.prototype, "getCharacterSet", null);
Pn([
  In
], Ub.prototype, "codePointsForGlyph", null);
class Sj {
  process(e, r) {
    for (let n = 0; n < e.length - 1; n++) {
      let i = e[n].id, a = e[n + 1].id;
      r[n].xAdvance += this.getKerning(i, a);
    }
  }
  getKerning(e, r) {
    let n = 0;
    for (let i of this.kern.tables) {
      if (i.coverage.crossStream) continue;
      switch (i.version) {
        case 0:
          if (!i.coverage.horizontal) continue;
          break;
        case 1:
          if (i.coverage.vertical || i.coverage.variation) continue;
          break;
        default:
          throw new Error(`Unsupported kerning table version ${i.version}`);
      }
      let a = 0, o = i.subtable;
      switch (i.format) {
        case 0:
          let s = r5(o.pairs, function(h) {
            return e - h.left || r - h.right;
          });
          s >= 0 && (a = o.pairs[s].value);
          break;
        case 2:
          let l = 0, u = 0;
          e >= o.leftTable.firstGlyph && e < o.leftTable.firstGlyph + o.leftTable.nGlyphs ? l = o.leftTable.offsets[e - o.leftTable.firstGlyph] : l = o.array.off, r >= o.rightTable.firstGlyph && r < o.rightTable.firstGlyph + o.rightTable.nGlyphs && (u = o.rightTable.offsets[r - o.rightTable.firstGlyph]);
          let d = (l + u - o.array.off) / 2;
          a = o.array.values.get(d);
          break;
        case 3:
          if (e >= o.glyphCount || r >= o.glyphCount) return 0;
          a = o.kernValue[o.kernIndex[o.leftClass[e] * o.rightClassCount + o.rightClass[r]]];
          break;
        default:
          throw new Error(`Unsupported kerning sub-table format ${i.format}`);
      }
      i.coverage.override ? n = a : n += a;
    }
    return n;
  }
  constructor(e) {
    this.kern = e.kern;
  }
}
class Cj {
  positionGlyphs(e, r) {
    let n = 0, i = 0;
    for (let a = 0; a < e.length; a++)
      e[a].isMark ? i = a : (n !== i && this.positionCluster(e, r, n, i), n = i = a);
    return n !== i && this.positionCluster(e, r, n, i), r;
  }
  positionCluster(e, r, n, i) {
    let a = e[n], o = a.cbox.copy();
    a.codePoints.length > 1 && (o.minX += (a.codePoints.length - 1) * o.width / a.codePoints.length);
    let s = -r[n].xAdvance, l = 0, u = this.font.unitsPerEm / 16;
    for (let d = n + 1; d <= i; d++) {
      let h = e[d], v = h.cbox, b = r[d], x = this.getCombiningClass(h.codePoints[0]);
      if (x !== "Not_Reordered") {
        switch (b.xOffset = b.yOffset = 0, x) {
          case "Double_Above":
          case "Double_Below":
            b.xOffset += o.minX - v.width / 2 - v.minX;
            break;
          case "Attached_Below_Left":
          case "Below_Left":
          case "Above_Left":
            b.xOffset += o.minX - v.minX;
            break;
          case "Attached_Above_Right":
          case "Below_Right":
          case "Above_Right":
            b.xOffset += o.maxX - v.width - v.minX;
            break;
          default:
            b.xOffset += o.minX + (o.width - v.width) / 2 - v.minX;
        }
        switch (x) {
          case "Double_Below":
          case "Below_Left":
          case "Below":
          case "Below_Right":
          case "Attached_Below_Left":
          case "Attached_Below":
            (x === "Attached_Below_Left" || x === "Attached_Below") && (o.minY += u), b.yOffset = -o.minY - v.maxY, o.minY += v.height;
            break;
          case "Double_Above":
          case "Above_Left":
          case "Above":
          case "Above_Right":
          case "Attached_Above":
          case "Attached_Above_Right":
            (x === "Attached_Above" || x === "Attached_Above_Right") && (o.maxY += u), b.yOffset = o.maxY - v.minY, o.maxY += v.height;
            break;
        }
        b.xAdvance = b.yAdvance = 0, b.xOffset += s, b.yOffset += l;
      } else
        s -= b.xAdvance, l -= b.yAdvance;
    }
  }
  getCombiningClass(e) {
    let r = QU(e);
    if ((e & -256) === 3584) {
      if (r === "Not_Reordered") switch (e) {
        case 3633:
        case 3636:
        case 3637:
        case 3638:
        case 3639:
        case 3655:
        case 3660:
        case 3645:
        case 3662:
          return "Above_Right";
        case 3761:
        case 3764:
        case 3765:
        case 3766:
        case 3767:
        case 3771:
        case 3788:
        case 3789:
          return "Above";
        case 3772:
          return "Below";
      }
      else if (e === 3642) return "Below_Right";
    }
    switch (r) {
      case "CCC10":
      case "CCC11":
      case "CCC12":
      case "CCC13":
      case "CCC14":
      case "CCC15":
      case "CCC16":
      case "CCC17":
      case "CCC18":
      case "CCC20":
      case "CCC22":
        return "Below";
      case "CCC23":
        return "Attached_Above";
      case "CCC24":
        return "Above_Right";
      case "CCC25":
      case "CCC19":
        return "Above_Left";
      case "CCC26":
        return "Above";
      case "CCC21":
        break;
      case "CCC27":
      case "CCC28":
      case "CCC30":
      case "CCC31":
      case "CCC33":
      case "CCC34":
      case "CCC35":
      case "CCC36":
        return "Above";
      case "CCC29":
      case "CCC32":
        return "Below";
      case "CCC103":
        return "Below_Right";
      case "CCC107":
        return "Above_Right";
      case "CCC118":
        return "Below";
      case "CCC122":
        return "Above";
      case "CCC129":
      case "CCC132":
        return "Below";
      case "CCC130":
        return "Above";
    }
    return r;
  }
  constructor(e) {
    this.font = e;
  }
}
class ou {
  /**
  * The width of the bounding box
  * @type {number}
  */
  get width() {
    return this.maxX - this.minX;
  }
  /**
  * The height of the bounding box
  * @type {number}
  */
  get height() {
    return this.maxY - this.minY;
  }
  addPoint(e, r) {
    Math.abs(e) !== 1 / 0 && (e < this.minX && (this.minX = e), e > this.maxX && (this.maxX = e)), Math.abs(r) !== 1 / 0 && (r < this.minY && (this.minY = r), r > this.maxY && (this.maxY = r));
  }
  copy() {
    return new ou(this.minX, this.minY, this.maxX, this.maxY);
  }
  constructor(e = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0) {
    this.minX = e, this.minY = r, this.maxX = n, this.maxY = i;
  }
}
const l1 = {
  Caucasian_Albanian: "aghb",
  Arabic: "arab",
  Imperial_Aramaic: "armi",
  Armenian: "armn",
  Avestan: "avst",
  Balinese: "bali",
  Bamum: "bamu",
  Bassa_Vah: "bass",
  Batak: "batk",
  Bengali: [
    "bng2",
    "beng"
  ],
  Bopomofo: "bopo",
  Brahmi: "brah",
  Braille: "brai",
  Buginese: "bugi",
  Buhid: "buhd",
  Chakma: "cakm",
  Canadian_Aboriginal: "cans",
  Carian: "cari",
  Cham: "cham",
  Cherokee: "cher",
  Coptic: "copt",
  Cypriot: "cprt",
  Cyrillic: "cyrl",
  Devanagari: [
    "dev2",
    "deva"
  ],
  Deseret: "dsrt",
  Duployan: "dupl",
  Egyptian_Hieroglyphs: "egyp",
  Elbasan: "elba",
  Ethiopic: "ethi",
  Georgian: "geor",
  Glagolitic: "glag",
  Gothic: "goth",
  Grantha: "gran",
  Greek: "grek",
  Gujarati: [
    "gjr2",
    "gujr"
  ],
  Gurmukhi: [
    "gur2",
    "guru"
  ],
  Hangul: "hang",
  Han: "hani",
  Hanunoo: "hano",
  Hebrew: "hebr",
  Hiragana: "hira",
  Pahawh_Hmong: "hmng",
  Katakana_Or_Hiragana: "hrkt",
  Old_Italic: "ital",
  Javanese: "java",
  Kayah_Li: "kali",
  Katakana: "kana",
  Kharoshthi: "khar",
  Khmer: "khmr",
  Khojki: "khoj",
  Kannada: [
    "knd2",
    "knda"
  ],
  Kaithi: "kthi",
  Tai_Tham: "lana",
  Lao: "lao ",
  Latin: "latn",
  Lepcha: "lepc",
  Limbu: "limb",
  Linear_A: "lina",
  Linear_B: "linb",
  Lisu: "lisu",
  Lycian: "lyci",
  Lydian: "lydi",
  Mahajani: "mahj",
  Mandaic: "mand",
  Manichaean: "mani",
  Mende_Kikakui: "mend",
  Meroitic_Cursive: "merc",
  Meroitic_Hieroglyphs: "mero",
  Malayalam: [
    "mlm2",
    "mlym"
  ],
  Modi: "modi",
  Mongolian: "mong",
  Mro: "mroo",
  Meetei_Mayek: "mtei",
  Myanmar: [
    "mym2",
    "mymr"
  ],
  Old_North_Arabian: "narb",
  Nabataean: "nbat",
  Nko: "nko ",
  Ogham: "ogam",
  Ol_Chiki: "olck",
  Old_Turkic: "orkh",
  Oriya: [
    "ory2",
    "orya"
  ],
  Osmanya: "osma",
  Palmyrene: "palm",
  Pau_Cin_Hau: "pauc",
  Old_Permic: "perm",
  Phags_Pa: "phag",
  Inscriptional_Pahlavi: "phli",
  Psalter_Pahlavi: "phlp",
  Phoenician: "phnx",
  Miao: "plrd",
  Inscriptional_Parthian: "prti",
  Rejang: "rjng",
  Runic: "runr",
  Samaritan: "samr",
  Old_South_Arabian: "sarb",
  Saurashtra: "saur",
  Shavian: "shaw",
  Sharada: "shrd",
  Siddham: "sidd",
  Khudawadi: "sind",
  Sinhala: "sinh",
  Sora_Sompeng: "sora",
  Sundanese: "sund",
  Syloti_Nagri: "sylo",
  Syriac: "syrc",
  Tagbanwa: "tagb",
  Takri: "takr",
  Tai_Le: "tale",
  New_Tai_Lue: "talu",
  Tamil: [
    "tml2",
    "taml"
  ],
  Tai_Viet: "tavt",
  Telugu: [
    "tel2",
    "telu"
  ],
  Tifinagh: "tfng",
  Tagalog: "tglg",
  Thaana: "thaa",
  Thai: "thai",
  Tibetan: "tibt",
  Tirhuta: "tirh",
  Ugaritic: "ugar",
  Vai: "vai ",
  Warang_Citi: "wara",
  Old_Persian: "xpeo",
  Cuneiform: "xsux",
  Yi: "yi  ",
  Inherited: "zinh",
  Common: "zyyy",
  Unknown: "zzzz"
}, p3 = {};
for (let t in l1) {
  let e = l1[t];
  if (Array.isArray(e)) for (let r of e) p3[r] = t;
  else p3[e] = t;
}
function kj(t) {
  return p3[t];
}
function Tj(t) {
  let e = t.length, r = 0;
  for (; r < e; ) {
    let n = t.charCodeAt(r++);
    if (55296 <= n && n <= 56319 && r < e) {
      let a = t.charCodeAt(r);
      56320 <= a && a <= 57343 && (r++, n = ((n & 1023) << 10) + (a & 1023) + 65536);
    }
    let i = uE(n);
    if (i !== "Common" && i !== "Inherited" && i !== "Unknown") return l1[i];
  }
  return l1.Unknown;
}
function Fj(t) {
  for (let e = 0; e < t.length; e++) {
    let r = t[e], n = uE(r);
    if (n !== "Common" && n !== "Inherited" && n !== "Unknown") return l1[n];
  }
  return l1.Unknown;
}
const Dj = {
  arab: !0,
  hebr: !0,
  syrc: !0,
  thaa: !0,
  cprt: !0,
  khar: !0,
  phnx: !0,
  "nko ": !0,
  lydi: !0,
  avst: !0,
  armi: !0,
  phli: !0,
  prti: !0,
  sarb: !0,
  orkh: !0,
  samr: !0,
  mand: !0,
  merc: !0,
  mero: !0,
  // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
  mani: !0,
  mend: !0,
  nbat: !0,
  narb: !0,
  palm: !0,
  phlp: !0
  // Psalter Pahlavi
};
function zE(t) {
  return Dj[t] ? "rtl" : "ltr";
}
class Oj {
  /**
  * The total advance width of the run.
  * @type {number}
  */
  get advanceWidth() {
    let e = 0;
    for (let r of this.positions) e += r.xAdvance;
    return e;
  }
  /**
  * The total advance height of the run.
  * @type {number}
  */
  get advanceHeight() {
    let e = 0;
    for (let r of this.positions) e += r.yAdvance;
    return e;
  }
  /**
  * The bounding box containing all glyphs in the run.
  * @type {BBox}
  */
  get bbox() {
    let e = new ou(), r = 0, n = 0;
    for (let i = 0; i < this.glyphs.length; i++) {
      let a = this.glyphs[i], o = this.positions[i], s = a.bbox;
      e.addPoint(s.minX + r + o.xOffset, s.minY + n + o.yOffset), e.addPoint(s.maxX + r + o.xOffset, s.maxY + n + o.yOffset), r += o.xAdvance, n += o.yAdvance;
    }
    return e;
  }
  constructor(e, r, n, i, a) {
    if (this.glyphs = e, this.positions = null, this.script = n, this.language = i || null, this.direction = a || zE(n), this.features = {}, Array.isArray(r)) for (let o of r) this.features[o] = !0;
    else typeof r == "object" && (this.features = r);
  }
}
class Rj {
  constructor(e = 0, r = 0, n = 0, i = 0) {
    this.xAdvance = e, this.yAdvance = r, this.xOffset = n, this.yOffset = i;
  }
}
const Wu = {
  allTypographicFeatures: {
    code: 0,
    exclusive: !1,
    allTypeFeatures: 0
  },
  ligatures: {
    code: 1,
    exclusive: !1,
    requiredLigatures: 0,
    commonLigatures: 2,
    rareLigatures: 4,
    // logos: 6
    rebusPictures: 8,
    diphthongLigatures: 10,
    squaredLigatures: 12,
    abbrevSquaredLigatures: 14,
    symbolLigatures: 16,
    contextualLigatures: 18,
    historicalLigatures: 20
  },
  cursiveConnection: {
    code: 2,
    exclusive: !0,
    unconnected: 0,
    partiallyConnected: 1,
    cursive: 2
  },
  letterCase: {
    code: 3,
    exclusive: !0
  },
  // upperAndLowerCase: 0          # deprecated
  // allCaps: 1                    # deprecated
  // allLowerCase: 2               # deprecated
  // smallCaps: 3                  # deprecated
  // initialCaps: 4                # deprecated
  // initialCapsAndSmallCaps: 5    # deprecated
  verticalSubstitution: {
    code: 4,
    exclusive: !1,
    substituteVerticalForms: 0
  },
  linguisticRearrangement: {
    code: 5,
    exclusive: !1,
    linguisticRearrangement: 0
  },
  numberSpacing: {
    code: 6,
    exclusive: !0,
    monospacedNumbers: 0,
    proportionalNumbers: 1,
    thirdWidthNumbers: 2,
    quarterWidthNumbers: 3
  },
  smartSwash: {
    code: 8,
    exclusive: !1,
    wordInitialSwashes: 0,
    wordFinalSwashes: 2,
    // lineInitialSwashes: 4
    // lineFinalSwashes: 6
    nonFinalSwashes: 8
  },
  diacritics: {
    code: 9,
    exclusive: !0,
    showDiacritics: 0,
    hideDiacritics: 1,
    decomposeDiacritics: 2
  },
  verticalPosition: {
    code: 10,
    exclusive: !0,
    normalPosition: 0,
    superiors: 1,
    inferiors: 2,
    ordinals: 3,
    scientificInferiors: 4
  },
  fractions: {
    code: 11,
    exclusive: !0,
    noFractions: 0,
    verticalFractions: 1,
    diagonalFractions: 2
  },
  overlappingCharacters: {
    code: 13,
    exclusive: !1,
    preventOverlap: 0
  },
  typographicExtras: {
    code: 14,
    exclusive: !1,
    // hyphensToEmDash: 0
    // hyphenToEnDash: 2
    slashedZero: 4
  },
  // formInterrobang: 6
  // smartQuotes: 8
  // periodsToEllipsis: 10
  mathematicalExtras: {
    code: 15,
    exclusive: !1,
    // hyphenToMinus: 0
    // asteristoMultiply: 2
    // slashToDivide: 4
    // inequalityLigatures: 6
    // exponents: 8
    mathematicalGreek: 10
  },
  ornamentSets: {
    code: 16,
    exclusive: !0,
    noOrnaments: 0,
    dingbats: 1,
    piCharacters: 2,
    fleurons: 3,
    decorativeBorders: 4,
    internationalSymbols: 5,
    mathSymbols: 6
  },
  characterAlternatives: {
    code: 17,
    exclusive: !0,
    noAlternates: 0
  },
  // user defined options
  designComplexity: {
    code: 18,
    exclusive: !0,
    designLevel1: 0,
    designLevel2: 1,
    designLevel3: 2,
    designLevel4: 3,
    designLevel5: 4
  },
  styleOptions: {
    code: 19,
    exclusive: !0,
    noStyleOptions: 0,
    displayText: 1,
    engravedText: 2,
    illuminatedCaps: 3,
    titlingCaps: 4,
    tallCaps: 5
  },
  characterShape: {
    code: 20,
    exclusive: !0,
    traditionalCharacters: 0,
    simplifiedCharacters: 1,
    JIS1978Characters: 2,
    JIS1983Characters: 3,
    JIS1990Characters: 4,
    traditionalAltOne: 5,
    traditionalAltTwo: 6,
    traditionalAltThree: 7,
    traditionalAltFour: 8,
    traditionalAltFive: 9,
    expertCharacters: 10,
    JIS2004Characters: 11,
    hojoCharacters: 12,
    NLCCharacters: 13,
    traditionalNamesCharacters: 14
  },
  numberCase: {
    code: 21,
    exclusive: !0,
    lowerCaseNumbers: 0,
    upperCaseNumbers: 1
  },
  textSpacing: {
    code: 22,
    exclusive: !0,
    proportionalText: 0,
    monospacedText: 1,
    halfWidthText: 2,
    thirdWidthText: 3,
    quarterWidthText: 4,
    altProportionalText: 5,
    altHalfWidthText: 6
  },
  transliteration: {
    code: 23,
    exclusive: !0,
    noTransliteration: 0
  },
  // hanjaToHangul: 1
  // hiraganaToKatakana: 2
  // katakanaToHiragana: 3
  // kanaToRomanization: 4
  // romanizationToHiragana: 5
  // romanizationToKatakana: 6
  // hanjaToHangulAltOne: 7
  // hanjaToHangulAltTwo: 8
  // hanjaToHangulAltThree: 9
  annotation: {
    code: 24,
    exclusive: !0,
    noAnnotation: 0,
    boxAnnotation: 1,
    roundedBoxAnnotation: 2,
    circleAnnotation: 3,
    invertedCircleAnnotation: 4,
    parenthesisAnnotation: 5,
    periodAnnotation: 6,
    romanNumeralAnnotation: 7,
    diamondAnnotation: 8,
    invertedBoxAnnotation: 9,
    invertedRoundedBoxAnnotation: 10
  },
  kanaSpacing: {
    code: 25,
    exclusive: !0,
    fullWidthKana: 0,
    proportionalKana: 1
  },
  ideographicSpacing: {
    code: 26,
    exclusive: !0,
    fullWidthIdeographs: 0,
    proportionalIdeographs: 1,
    halfWidthIdeographs: 2
  },
  unicodeDecomposition: {
    code: 27,
    exclusive: !1,
    canonicalComposition: 0,
    compatibilityComposition: 2,
    transcodingComposition: 4
  },
  rubyKana: {
    code: 28,
    exclusive: !1,
    // noRubyKana: 0     # deprecated - use rubyKanaOff instead
    // rubyKana: 1     # deprecated - use rubyKanaOn instead
    rubyKana: 2
  },
  CJKSymbolAlternatives: {
    code: 29,
    exclusive: !0,
    noCJKSymbolAlternatives: 0,
    CJKSymbolAltOne: 1,
    CJKSymbolAltTwo: 2,
    CJKSymbolAltThree: 3,
    CJKSymbolAltFour: 4,
    CJKSymbolAltFive: 5
  },
  ideographicAlternatives: {
    code: 30,
    exclusive: !0,
    noIdeographicAlternatives: 0,
    ideographicAltOne: 1,
    ideographicAltTwo: 2,
    ideographicAltThree: 3,
    ideographicAltFour: 4,
    ideographicAltFive: 5
  },
  CJKVerticalRomanPlacement: {
    code: 31,
    exclusive: !0,
    CJKVerticalRomanCentered: 0,
    CJKVerticalRomanHBaseline: 1
  },
  italicCJKRoman: {
    code: 32,
    exclusive: !1,
    // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
    // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
    CJKItalicRoman: 2
  },
  caseSensitiveLayout: {
    code: 33,
    exclusive: !1,
    caseSensitiveLayout: 0,
    caseSensitiveSpacing: 2
  },
  alternateKana: {
    code: 34,
    exclusive: !1,
    alternateHorizKana: 0,
    alternateVertKana: 2
  },
  stylisticAlternatives: {
    code: 35,
    exclusive: !1,
    noStylisticAlternates: 0,
    stylisticAltOne: 2,
    stylisticAltTwo: 4,
    stylisticAltThree: 6,
    stylisticAltFour: 8,
    stylisticAltFive: 10,
    stylisticAltSix: 12,
    stylisticAltSeven: 14,
    stylisticAltEight: 16,
    stylisticAltNine: 18,
    stylisticAltTen: 20,
    stylisticAltEleven: 22,
    stylisticAltTwelve: 24,
    stylisticAltThirteen: 26,
    stylisticAltFourteen: 28,
    stylisticAltFifteen: 30,
    stylisticAltSixteen: 32,
    stylisticAltSeventeen: 34,
    stylisticAltEighteen: 36,
    stylisticAltNineteen: 38,
    stylisticAltTwenty: 40
  },
  contextualAlternates: {
    code: 36,
    exclusive: !1,
    contextualAlternates: 0,
    swashAlternates: 2,
    contextualSwashAlternates: 4
  },
  lowerCase: {
    code: 37,
    exclusive: !0,
    defaultLowerCase: 0,
    lowerCaseSmallCaps: 1,
    lowerCasePetiteCaps: 2
  },
  upperCase: {
    code: 38,
    exclusive: !0,
    defaultUpperCase: 0,
    upperCaseSmallCaps: 1,
    upperCasePetiteCaps: 2
  },
  languageTag: {
    code: 39,
    exclusive: !0
  },
  CJKRomanSpacing: {
    code: 103,
    exclusive: !0,
    halfWidthCJKRoman: 0,
    proportionalCJKRoman: 1,
    defaultCJKRoman: 2,
    fullWidthCJKRoman: 3
  }
}, Xe = (t, e) => [
  Wu[t].code,
  Wu[t][e]
], V5 = {
  rlig: Xe("ligatures", "requiredLigatures"),
  clig: Xe("ligatures", "contextualLigatures"),
  dlig: Xe("ligatures", "rareLigatures"),
  hlig: Xe("ligatures", "historicalLigatures"),
  liga: Xe("ligatures", "commonLigatures"),
  hist: Xe("ligatures", "historicalLigatures"),
  smcp: Xe("lowerCase", "lowerCaseSmallCaps"),
  pcap: Xe("lowerCase", "lowerCasePetiteCaps"),
  frac: Xe("fractions", "diagonalFractions"),
  dnom: Xe("fractions", "diagonalFractions"),
  numr: Xe("fractions", "diagonalFractions"),
  afrc: Xe("fractions", "verticalFractions"),
  // aalt
  // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
  // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
  // unic, vatu, vhal, vjmo, vpal, vrt2
  // dist -> trak table?
  // kern, vkrn -> kern table
  // lfbd + opbd + rtbd -> opbd table?
  // mark, mkmk -> acnt table?
  // locl -> languageTag + ltag table
  case: Xe("caseSensitiveLayout", "caseSensitiveLayout"),
  ccmp: Xe("unicodeDecomposition", "canonicalComposition"),
  cpct: Xe("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
  valt: Xe("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
  swsh: Xe("contextualAlternates", "swashAlternates"),
  cswh: Xe("contextualAlternates", "contextualSwashAlternates"),
  curs: Xe("cursiveConnection", "cursive"),
  c2pc: Xe("upperCase", "upperCasePetiteCaps"),
  c2sc: Xe("upperCase", "upperCaseSmallCaps"),
  init: Xe("smartSwash", "wordInitialSwashes"),
  fin2: Xe("smartSwash", "wordFinalSwashes"),
  medi: Xe("smartSwash", "nonFinalSwashes"),
  med2: Xe("smartSwash", "nonFinalSwashes"),
  fin3: Xe("smartSwash", "wordFinalSwashes"),
  fina: Xe("smartSwash", "wordFinalSwashes"),
  pkna: Xe("kanaSpacing", "proportionalKana"),
  half: Xe("textSpacing", "halfWidthText"),
  halt: Xe("textSpacing", "altHalfWidthText"),
  hkna: Xe("alternateKana", "alternateHorizKana"),
  vkna: Xe("alternateKana", "alternateVertKana"),
  // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated
  ital: Xe("italicCJKRoman", "CJKItalicRoman"),
  lnum: Xe("numberCase", "upperCaseNumbers"),
  onum: Xe("numberCase", "lowerCaseNumbers"),
  mgrk: Xe("mathematicalExtras", "mathematicalGreek"),
  // nalt: not enough info. what type of annotation?
  // ornm: ditto, which ornament style?
  calt: Xe("contextualAlternates", "contextualAlternates"),
  vrt2: Xe("verticalSubstitution", "substituteVerticalForms"),
  vert: Xe("verticalSubstitution", "substituteVerticalForms"),
  tnum: Xe("numberSpacing", "monospacedNumbers"),
  pnum: Xe("numberSpacing", "proportionalNumbers"),
  sups: Xe("verticalPosition", "superiors"),
  subs: Xe("verticalPosition", "inferiors"),
  ordn: Xe("verticalPosition", "ordinals"),
  pwid: Xe("textSpacing", "proportionalText"),
  hwid: Xe("textSpacing", "halfWidthText"),
  qwid: Xe("textSpacing", "quarterWidthText"),
  twid: Xe("textSpacing", "thirdWidthText"),
  fwid: Xe("textSpacing", "proportionalText"),
  palt: Xe("textSpacing", "altProportionalText"),
  trad: Xe("characterShape", "traditionalCharacters"),
  smpl: Xe("characterShape", "simplifiedCharacters"),
  jp78: Xe("characterShape", "JIS1978Characters"),
  jp83: Xe("characterShape", "JIS1983Characters"),
  jp90: Xe("characterShape", "JIS1990Characters"),
  jp04: Xe("characterShape", "JIS2004Characters"),
  expt: Xe("characterShape", "expertCharacters"),
  hojo: Xe("characterShape", "hojoCharacters"),
  nlck: Xe("characterShape", "NLCCharacters"),
  tnam: Xe("characterShape", "traditionalNamesCharacters"),
  ruby: Xe("rubyKana", "rubyKana"),
  titl: Xe("styleOptions", "titlingCaps"),
  zero: Xe("typographicExtras", "slashedZero"),
  ss01: Xe("stylisticAlternatives", "stylisticAltOne"),
  ss02: Xe("stylisticAlternatives", "stylisticAltTwo"),
  ss03: Xe("stylisticAlternatives", "stylisticAltThree"),
  ss04: Xe("stylisticAlternatives", "stylisticAltFour"),
  ss05: Xe("stylisticAlternatives", "stylisticAltFive"),
  ss06: Xe("stylisticAlternatives", "stylisticAltSix"),
  ss07: Xe("stylisticAlternatives", "stylisticAltSeven"),
  ss08: Xe("stylisticAlternatives", "stylisticAltEight"),
  ss09: Xe("stylisticAlternatives", "stylisticAltNine"),
  ss10: Xe("stylisticAlternatives", "stylisticAltTen"),
  ss11: Xe("stylisticAlternatives", "stylisticAltEleven"),
  ss12: Xe("stylisticAlternatives", "stylisticAltTwelve"),
  ss13: Xe("stylisticAlternatives", "stylisticAltThirteen"),
  ss14: Xe("stylisticAlternatives", "stylisticAltFourteen"),
  ss15: Xe("stylisticAlternatives", "stylisticAltFifteen"),
  ss16: Xe("stylisticAlternatives", "stylisticAltSixteen"),
  ss17: Xe("stylisticAlternatives", "stylisticAltSeventeen"),
  ss18: Xe("stylisticAlternatives", "stylisticAltEighteen"),
  ss19: Xe("stylisticAlternatives", "stylisticAltNineteen"),
  ss20: Xe("stylisticAlternatives", "stylisticAltTwenty")
};
for (let t = 1; t <= 99; t++) V5[`cv${`00${t}`.slice(-2)}`] = [
  Wu.characterAlternatives.code,
  t
];
let Hu = {};
for (let t in V5) {
  let e = V5[t];
  Hu[e[0]] == null && (Hu[e[0]] = {}), Hu[e[0]][e[1]] = t;
}
function Pj(t) {
  let e = {};
  for (let r in t) {
    let n;
    (n = V5[r]) && (e[n[0]] == null && (e[n[0]] = {}), e[n[0]][n[1]] = t[r]);
  }
  return e;
}
function Wy(t) {
  let [e, r] = t;
  if (isNaN(e)) var n = Wu[e] && Wu[e].code;
  else var n = e;
  if (isNaN(r)) var i = Wu[e] && Wu[e][r];
  else var i = r;
  return [
    n,
    i
  ];
}
function Ij(t) {
  let e = {};
  if (Array.isArray(t)) for (let r = 0; r < t.length; r++) {
    let n, i = Wy(t[r]);
    (n = Hu[i[0]] && Hu[i[0]][i[1]]) && (e[n] = !0);
  }
  else if (typeof t == "object") for (let r in t) {
    let n = t[r];
    for (let i in n) {
      let a, o = Wy([
        r,
        i
      ]);
      n[i] && (a = Hu[o[0]] && Hu[o[0]][o[1]]) && (e[a] = !0);
    }
  }
  return Object.keys(e);
}
class Ld {
  lookup(e) {
    switch (this.table.version) {
      case 0:
        return this.table.values.getItem(e);
      case 2:
      case 4: {
        let i = 0, a = this.table.binarySearchHeader.nUnits - 1;
        for (; i <= a; ) {
          var r = i + a >> 1, n = this.table.segments[r];
          if (n.firstGlyph === 65535) return null;
          if (e < n.firstGlyph) a = r - 1;
          else if (e > n.lastGlyph) i = r + 1;
          else
            return this.table.version === 2 ? n.value : n.values[e - n.firstGlyph];
        }
        return null;
      }
      case 6: {
        let i = 0, a = this.table.binarySearchHeader.nUnits - 1;
        for (; i <= a; ) {
          var r = i + a >> 1, n = this.table.segments[r];
          if (n.glyph === 65535) return null;
          if (e < n.glyph) a = r - 1;
          else if (e > n.glyph) i = r + 1;
          else return n.value;
        }
        return null;
      }
      case 8:
        return this.table.values[e - this.table.firstGlyph];
      default:
        throw new Error(`Unknown lookup table format: ${this.table.version}`);
    }
  }
  glyphsForValue(e) {
    let r = [];
    switch (this.table.version) {
      case 2:
      case 4:
        for (let n of this.table.segments) if (this.table.version === 2 && n.value === e) r.push(...Lf(n.firstGlyph, n.lastGlyph + 1));
        else
          for (let i = 0; i < n.values.length; i++) n.values[i] === e && r.push(n.firstGlyph + i);
        break;
      case 6:
        for (let n of this.table.segments) n.value === e && r.push(n.glyph);
        break;
      case 8:
        for (let n = 0; n < this.table.values.length; n++) this.table.values[n] === e && r.push(this.table.firstGlyph + n);
        break;
      default:
        throw new Error(`Unknown lookup table format: ${this.table.version}`);
    }
    return r;
  }
  constructor(e) {
    this.table = e;
  }
}
Pn([
  In
], Ld.prototype, "glyphsForValue", null);
const Bj = 0, Hy = 0, qy = 1, Yy = 2, Lj = 16384;
class Nj {
  process(e, r, n) {
    let i = Bj, a = r ? e.length - 1 : 0, o = r ? -1 : 1;
    for (; o === 1 && a <= e.length || o === -1 && a >= -1; ) {
      let s = null, l = qy, u = !0;
      a === e.length || a === -1 ? l = Hy : (s = e[a], s.id === 65535 ? l = Yy : (l = this.lookupTable.lookup(s.id), l == null && (l = qy)));
      let h = this.stateTable.stateArray.getItem(i)[l], v = this.stateTable.entryTable.getItem(h);
      l !== Hy && l !== Yy && (n(s, v, a), u = !(v.flags & Lj)), i = v.newState, u && (a += o);
    }
    return e;
  }
  /**
  * Performs a depth-first traversal of the glyph strings
  * represented by the state machine.
  */
  traverse(e, r = 0, n = /* @__PURE__ */ new Set()) {
    if (n.has(r)) return;
    n.add(r);
    let { nClasses: i, stateArray: a, entryTable: o } = this.stateTable, s = a.getItem(r);
    for (let l = 4; l < i; l++) {
      let u = s[l], d = o.getItem(u);
      for (let h of this.lookupTable.glyphsForValue(l))
        e.enter && e.enter(h, d), d.newState !== 0 && this.traverse(e, d.newState, n), e.exit && e.exit(h, d);
    }
  }
  constructor(e) {
    this.stateTable = e, this.lookupTable = new Ld(e.classTable);
  }
}
const Mj = 32768, Uj = 8192, zj = 15, Gy = 32768, $j = 32768, Vj = 8192, jj = 2147483648, Wj = 1073741824, Hj = 1073741823, Zy = 4194304, qj = 2048, Yj = 1024, Gj = 992, Zj = 31;
class $E {
  // Processes an array of glyphs and applies the specified features
  // Features should be in the form of {featureType:{featureSetting:boolean}}
  process(e, r = {}) {
    for (let i of this.morx.chains) {
      let a = i.defaultFlags;
      for (let o of i.features) {
        let s;
        (s = r[o.featureType]) && (s[o.featureSetting] ? (a &= o.disableFlags, a |= o.enableFlags) : s[o.featureSetting] === !1 && (a |= ~o.disableFlags, a &= ~o.enableFlags));
      }
      for (let o of i.subtables) o.subFeatureFlags & a && this.processSubtable(o, e);
    }
    let n = e.length - 1;
    for (; n >= 0; )
      e[n].id === 65535 && e.splice(n, 1), n--;
    return e;
  }
  processSubtable(e, r) {
    if (this.subtable = e, this.glyphs = r, this.subtable.type === 4) {
      this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
      return;
    }
    this.ligatureStack = [], this.markedGlyph = null, this.firstGlyph = null, this.lastGlyph = null, this.markedIndex = null;
    let n = this.getStateMachine(e), i = this.getProcessor(), a = !!(this.subtable.coverage & Zy);
    return n.process(this.glyphs, a, i);
  }
  getStateMachine(e) {
    return new Nj(e.table.stateTable);
  }
  getProcessor() {
    switch (this.subtable.type) {
      case 0:
        return this.processIndicRearragement;
      case 1:
        return this.processContextualSubstitution;
      case 2:
        return this.processLigature;
      case 4:
        return this.processNoncontextualSubstitutions;
      case 5:
        return this.processGlyphInsertion;
      default:
        throw new Error(`Invalid morx subtable type: ${this.subtable.type}`);
    }
  }
  processIndicRearragement(e, r, n) {
    r.flags & Mj && (this.firstGlyph = n), r.flags & Uj && (this.lastGlyph = n), Xj(this.glyphs, r.flags & zj, this.firstGlyph, this.lastGlyph);
  }
  processContextualSubstitution(e, r, n) {
    let i = this.subtable.table.substitutionTable.items;
    if (r.markIndex !== 65535) {
      let o = i.getItem(r.markIndex), s = new Ld(o);
      e = this.glyphs[this.markedGlyph];
      var a = s.lookup(e.id);
      a && (this.glyphs[this.markedGlyph] = this.font.getGlyph(a, e.codePoints));
    }
    if (r.currentIndex !== 65535) {
      let o = i.getItem(r.currentIndex), s = new Ld(o);
      e = this.glyphs[n];
      var a = s.lookup(e.id);
      a && (this.glyphs[n] = this.font.getGlyph(a, e.codePoints));
    }
    r.flags & Gy && (this.markedGlyph = n);
  }
  processLigature(e, r, n) {
    if (r.flags & $j && this.ligatureStack.push(n), r.flags & Vj) {
      let i = this.subtable.table.ligatureActions, a = this.subtable.table.components, o = this.subtable.table.ligatureList, s = r.action, l = !1, u = 0, d = [], h = [];
      for (; !l; ) {
        let v = this.ligatureStack.pop();
        d.unshift(...this.glyphs[v].codePoints);
        let b = i.getItem(s++);
        l = !!(b & jj);
        let x = !!(b & Wj), A = (b & Hj) << 2 >> 2;
        A += this.glyphs[v].id;
        let T = a.getItem(A);
        if (u += T, l || x) {
          let k = o.getItem(u);
          this.glyphs[v] = this.font.getGlyph(k, d), h.push(v), u = 0, d = [];
        } else this.glyphs[v] = this.font.getGlyph(65535);
      }
      this.ligatureStack.push(...h);
    }
  }
  processNoncontextualSubstitutions(e, r, n) {
    let i = new Ld(e.table.lookupTable);
    for (n = 0; n < r.length; n++) {
      let a = r[n];
      if (a.id !== 65535) {
        let o = i.lookup(a.id);
        o && (r[n] = this.font.getGlyph(o, a.codePoints));
      }
    }
  }
  _insertGlyphs(e, r, n, i) {
    let a = [];
    for (; n--; ) {
      let o = this.subtable.table.insertionActions.getItem(r++);
      a.push(this.font.getGlyph(o));
    }
    i || e++, this.glyphs.splice(e, 0, ...a);
  }
  processGlyphInsertion(e, r, n) {
    if (r.flags & Gy && (this.markedIndex = n), r.markedInsertIndex !== 65535) {
      let i = (r.flags & Zj) >>> 5, a = !!(r.flags & Yj);
      this._insertGlyphs(this.markedIndex, r.markedInsertIndex, i, a);
    }
    if (r.currentInsertIndex !== 65535) {
      let i = (r.flags & Gj) >>> 5, a = !!(r.flags & qj);
      this._insertGlyphs(n, r.currentInsertIndex, i, a);
    }
  }
  getSupportedFeatures() {
    let e = [];
    for (let r of this.morx.chains) for (let n of r.features) e.push([
      n.featureType,
      n.featureSetting
    ]);
    return e;
  }
  generateInputs(e) {
    return this.inputCache || this.generateInputCache(), this.inputCache[e] || [];
  }
  generateInputCache() {
    this.inputCache = {};
    for (let e of this.morx.chains) {
      let r = e.defaultFlags;
      for (let n of e.subtables) n.subFeatureFlags & r && this.generateInputsForSubtable(n);
    }
  }
  generateInputsForSubtable(e) {
    if (e.type !== 2) return;
    if (!!(e.coverage & Zy)) throw new Error("Reverse subtable, not supported.");
    this.subtable = e, this.ligatureStack = [];
    let n = this.getStateMachine(e), i = this.getProcessor(), a = [], o = [];
    this.glyphs = [], n.traverse({
      enter: (s, l) => {
        let u = this.glyphs;
        o.push({
          glyphs: u.slice(),
          ligatureStack: this.ligatureStack.slice()
        });
        let d = this.font.getGlyph(s);
        a.push(d), u.push(a[a.length - 1]), i(u[u.length - 1], l, u.length - 1);
        let h = 0, v = 0;
        for (let b = 0; b < u.length && h <= 1; b++) u[b].id !== 65535 && (h++, v = u[b].id);
        if (h === 1) {
          let b = a.map((A) => A.id), x = this.inputCache[v];
          x ? x.push(b) : this.inputCache[v] = [
            b
          ];
        }
      },
      exit: () => {
        ({ glyphs: this.glyphs, ligatureStack: this.ligatureStack } = o.pop()), a.pop();
      }
    });
  }
  constructor(e) {
    this.processIndicRearragement = this.processIndicRearragement.bind(this), this.processContextualSubstitution = this.processContextualSubstitution.bind(this), this.processLigature = this.processLigature.bind(this), this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this), this.processGlyphInsertion = this.processGlyphInsertion.bind(this), this.font = e, this.morx = e.morx, this.inputCache = null;
  }
}
Pn([
  In
], $E.prototype, "getStateMachine", null);
function ri(t, e, r, n = !1, i = !1) {
  let a = t.splice(r[0] - (r[1] - 1), r[1]);
  i && a.reverse();
  let o = t.splice(e[0], e[1], ...a);
  return n && o.reverse(), t.splice(r[0] - (e[1] - 1), 0, ...o), t;
}
function Xj(t, e, r, n) {
  switch (e) {
    case 0:
      return t;
    case 1:
      return ri(t, [
        r,
        1
      ], [
        n,
        0
      ]);
    case 2:
      return ri(t, [
        r,
        0
      ], [
        n,
        1
      ]);
    case 3:
      return ri(t, [
        r,
        1
      ], [
        n,
        1
      ]);
    case 4:
      return ri(t, [
        r,
        2
      ], [
        n,
        0
      ]);
    case 5:
      return ri(t, [
        r,
        2
      ], [
        n,
        0
      ], !0, !1);
    case 6:
      return ri(t, [
        r,
        0
      ], [
        n,
        2
      ]);
    case 7:
      return ri(t, [
        r,
        0
      ], [
        n,
        2
      ], !1, !0);
    case 8:
      return ri(t, [
        r,
        1
      ], [
        n,
        2
      ]);
    case 9:
      return ri(t, [
        r,
        1
      ], [
        n,
        2
      ], !1, !0);
    case 10:
      return ri(t, [
        r,
        2
      ], [
        n,
        1
      ]);
    case 11:
      return ri(t, [
        r,
        2
      ], [
        n,
        1
      ], !0, !1);
    case 12:
      return ri(t, [
        r,
        2
      ], [
        n,
        2
      ]);
    case 13:
      return ri(t, [
        r,
        2
      ], [
        n,
        2
      ], !0, !1);
    case 14:
      return ri(t, [
        r,
        2
      ], [
        n,
        2
      ], !1, !0);
    case 15:
      return ri(t, [
        r,
        2
      ], [
        n,
        2
      ], !0, !0);
    default:
      throw new Error(`Unknown verb: ${e}`);
  }
}
class Kj {
  substitute(e) {
    e.direction === "rtl" && e.glyphs.reverse(), this.morxProcessor.process(e.glyphs, Pj(e.features));
  }
  getAvailableFeatures(e, r) {
    return Ij(this.morxProcessor.getSupportedFeatures());
  }
  stringsForGlyph(e) {
    let r = this.morxProcessor.generateInputs(e), n = /* @__PURE__ */ new Set();
    for (let i of r) this._addStrings(i, 0, n, "");
    return n;
  }
  _addStrings(e, r, n, i) {
    let a = this.font._cmapProcessor.codePointsForGlyph(e[r]);
    for (let o of a) {
      let s = i + String.fromCodePoint(o);
      r < e.length - 1 ? this._addStrings(e, r + 1, n, s) : n.add(s);
    }
  }
  constructor(e) {
    this.font = e, this.morxProcessor = new $E(e), this.fallbackPosition = !1;
  }
}
class Jj {
  /**
  * Adds the given features to the last stage.
  * Ignores features that have already been applied.
  */
  _addFeatures(e, r) {
    let n = this.stages.length - 1, i = this.stages[n];
    for (let a of e) this.allFeatures[a] == null && (i.push(a), this.allFeatures[a] = n, r && (this.globalFeatures[a] = !0));
  }
  /**
  * Add features to the last stage
  */
  add(e, r = !0) {
    if (this.stages.length === 0 && this.stages.push([]), typeof e == "string" && (e = [
      e
    ]), Array.isArray(e)) this._addFeatures(e, r);
    else if (typeof e == "object")
      this._addFeatures(e.global || [], !0), this._addFeatures(e.local || [], !1);
    else throw new Error("Unsupported argument to ShapingPlan#add");
  }
  /**
  * Add a new stage
  */
  addStage(e, r) {
    typeof e == "function" ? this.stages.push(e, []) : (this.stages.push([]), this.add(e, r));
  }
  setFeatureOverrides(e) {
    if (Array.isArray(e)) this.add(e);
    else if (typeof e == "object") {
      for (let r in e)
        if (e[r]) this.add(r);
        else if (this.allFeatures[r] != null) {
          let n = this.stages[this.allFeatures[r]];
          n.splice(n.indexOf(r), 1), delete this.allFeatures[r], delete this.globalFeatures[r];
        }
    }
  }
  /**
  * Assigns the global features to the given glyphs
  */
  assignGlobalFeatures(e) {
    for (let r of e) for (let n in this.globalFeatures) r.features[n] = !0;
  }
  /**
  * Executes the planned stages using the given OTProcessor
  */
  process(e, r, n) {
    for (let i of this.stages)
      typeof i == "function" ? n || i(this.font, r, this) : i.length > 0 && e.applyFeatures(i, r, n);
  }
  constructor(e, r, n) {
    this.font = e, this.script = r, this.direction = n, this.stages = [], this.globalFeatures = {}, this.allFeatures = {};
  }
}
const Qj = [
  "rvrn"
], eW = [
  "ccmp",
  "locl",
  "rlig",
  "mark",
  "mkmk"
], tW = [
  "frac",
  "numr",
  "dnom"
], rW = [
  "calt",
  "clig",
  "liga",
  "rclt",
  "curs",
  "kern"
], nW = {
  ltr: [
    "ltra",
    "ltrm"
  ],
  rtl: [
    "rtla",
    "rtlm"
  ]
};
class su {
  static plan(e, r, n) {
    this.planPreprocessing(e), this.planFeatures(e), this.planPostprocessing(e, n), e.assignGlobalFeatures(r), this.assignFeatures(e, r);
  }
  static planPreprocessing(e) {
    e.add({
      global: [
        ...Qj,
        ...nW[e.direction]
      ],
      local: tW
    });
  }
  static planFeatures(e) {
  }
  static planPostprocessing(e, r) {
    e.add([
      ...eW,
      ...rW
    ]), e.setFeatureOverrides(r);
  }
  static assignFeatures(e, r) {
    for (let n = 0; n < r.length; n++) {
      let i = r[n];
      if (i.codePoints[0] === 8260) {
        let a = n, o = n + 1;
        for (; a > 0 && vy(r[a - 1].codePoints[0]); )
          r[a - 1].features.numr = !0, r[a - 1].features.frac = !0, a--;
        for (; o < r.length && vy(r[o].codePoints[0]); )
          r[o].features.dnom = !0, r[o].features.frac = !0, o++;
        i.features.frac = !0, n = o - 1;
      }
    }
  }
}
Fi(su, "zeroMarkWidths", "AFTER_GPOS");
const iW = new Ch(Mb("APABAAAAAAAAOAAAAf0BAv7tmi1MxDAUx7vtvjhAgcDgkEgEAnmXEBIMCYaEcygEiqBQ4FAkCE4ikUgMiiBJSAgSiUQSDMn9L9eSl6bddddug9t7yS/trevre+3r27pcNxZiG+yCfdCVv/9LeQxOwRm4AJegD27ALbgD9+ABPJF+z+BN/h7yDj5k/VOWX6SdmU5+wLWknggxDxaS8u0qiiX4uiz9XamQ3wzDMAzDMAzDMAzDVI/h959V/v7BMAzDMAzDMLlyNTNiMSdewVxbiA44B4/guz1qW58VYlMI0WsJ0W+N6kXw0spvPtdwhtkwnGM6uLaV4Xyzg3v3PM9DPfQ/sOg4xPWjipy31P8LTqbU304c/cLCUmWJLNB2Uz2U1KTeRKNmKHVMfbJC+/0loTZRH/W5cvEvBJPMbREkWt3FD1NcqXZBSpuE2Ad0PBehPtNrPtIEdYP+hiRt/V1jIiE69X4NT/uVZI3PUHE9bm5M7ePGdZWy951v7Nn6j8v1WWKP3mt6ttnsigx6VN7Vc0VomSSGqW2mGNP1muZPl7LfjNUaKNFtDGVf2fvE9O7VlBS5j333c5p/eeoOqcs1R/hIqDWLJ7TTlksirVT1SI7l8k4Yp+g3jafGcrU1RM6l9th80XOpnlN97bDNY4i4s61B0Si/ipa0uHMl6zqEjlFfCZm/TM8KmzQDjmuTAQ==")), Xy = [
  "isol",
  "fina",
  "fin2",
  "fin3",
  "medi",
  "med2",
  "init"
], m3 = {
  Non_Joining: 0,
  Left_Joining: 1,
  Right_Joining: 2,
  Dual_Joining: 3,
  Join_Causing: 3,
  ALAPH: 4,
  "DALATH RISH": 5,
  Transparent: 6
}, K0 = "isol", Tl = "fina", qg = "fin2", aW = "fin3", S2 = "medi", C2 = "med2", k2 = "init", s0 = null, oW = [
  //   Non_Joining,        Left_Joining,       Right_Joining,     Dual_Joining,           ALAPH,            DALATH RISH
  // State 0: prev was U,  not willing to join.
  [
    [
      s0,
      s0,
      0
    ],
    [
      s0,
      K0,
      2
    ],
    [
      s0,
      K0,
      1
    ],
    [
      s0,
      K0,
      2
    ],
    [
      s0,
      K0,
      1
    ],
    [
      s0,
      K0,
      6
    ]
  ],
  // State 1: prev was R or ISOL/ALAPH,  not willing to join.
  [
    [
      s0,
      s0,
      0
    ],
    [
      s0,
      K0,
      2
    ],
    [
      s0,
      K0,
      1
    ],
    [
      s0,
      K0,
      2
    ],
    [
      s0,
      qg,
      5
    ],
    [
      s0,
      K0,
      6
    ]
  ],
  // State 2: prev was D/L in ISOL form,  willing to join.
  [
    [
      s0,
      s0,
      0
    ],
    [
      s0,
      K0,
      2
    ],
    [
      k2,
      Tl,
      1
    ],
    [
      k2,
      Tl,
      3
    ],
    [
      k2,
      Tl,
      4
    ],
    [
      k2,
      Tl,
      6
    ]
  ],
  // State 3: prev was D in FINA form,  willing to join.
  [
    [
      s0,
      s0,
      0
    ],
    [
      s0,
      K0,
      2
    ],
    [
      S2,
      Tl,
      1
    ],
    [
      S2,
      Tl,
      3
    ],
    [
      S2,
      Tl,
      4
    ],
    [
      S2,
      Tl,
      6
    ]
  ],
  // State 4: prev was FINA ALAPH,  not willing to join.
  [
    [
      s0,
      s0,
      0
    ],
    [
      s0,
      K0,
      2
    ],
    [
      C2,
      K0,
      1
    ],
    [
      C2,
      K0,
      2
    ],
    [
      C2,
      qg,
      5
    ],
    [
      C2,
      K0,
      6
    ]
  ],
  // State 5: prev was FIN2/FIN3 ALAPH,  not willing to join.
  [
    [
      s0,
      s0,
      0
    ],
    [
      s0,
      K0,
      2
    ],
    [
      K0,
      K0,
      1
    ],
    [
      K0,
      K0,
      2
    ],
    [
      K0,
      qg,
      5
    ],
    [
      K0,
      K0,
      6
    ]
  ],
  // State 6: prev was DALATH/RISH,  not willing to join.
  [
    [
      s0,
      s0,
      0
    ],
    [
      s0,
      K0,
      2
    ],
    [
      s0,
      K0,
      1
    ],
    [
      s0,
      K0,
      2
    ],
    [
      s0,
      aW,
      5
    ],
    [
      s0,
      K0,
      6
    ]
  ]
];
class Fl extends su {
  static planFeatures(e) {
    e.add([
      "ccmp",
      "locl"
    ]);
    for (let r = 0; r < Xy.length; r++) {
      let n = Xy[r];
      e.addStage(n, !1);
    }
    e.addStage("mset");
  }
  static assignFeatures(e, r) {
    super.assignFeatures(e, r);
    let n = -1, i = 0, a = [];
    for (let s = 0; s < r.length; s++) {
      let l, u;
      var o = r[s];
      let d = sW(o.codePoints[0]);
      if (d === m3.Transparent) {
        a[s] = s0;
        continue;
      }
      [u, l, i] = oW[i][d], u !== s0 && n !== -1 && (a[n] = u), a[s] = l, n = s;
    }
    for (let s = 0; s < r.length; s++) {
      let l;
      var o = r[s];
      (l = a[s]) && (o.features[l] = !0);
    }
  }
}
function sW(t) {
  let e = iW.get(t);
  if (e) return e - 1;
  let r = zp(t);
  return r === "Mn" || r === "Me" || r === "Cf" ? m3.Transparent : m3.Non_Joining;
}
class lW {
  reset(e = {}, r = 0) {
    this.options = e, this.flags = e.flags || {}, this.markAttachmentType = e.markAttachmentType || 0, this.index = r;
  }
  get cur() {
    return this.glyphs[this.index] || null;
  }
  shouldIgnore(e) {
    return this.flags.ignoreMarks && e.isMark || this.flags.ignoreBaseGlyphs && e.isBase || this.flags.ignoreLigatures && e.isLigature || this.markAttachmentType && e.isMark && e.markAttachmentType !== this.markAttachmentType;
  }
  move(e) {
    for (this.index += e; 0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index]); ) this.index += e;
    return 0 > this.index || this.index >= this.glyphs.length ? null : this.glyphs[this.index];
  }
  next() {
    return this.move(1);
  }
  prev() {
    return this.move(-1);
  }
  peek(e = 1) {
    let r = this.index, n = this.increment(e);
    return this.index = r, n;
  }
  peekIndex(e = 1) {
    let r = this.index;
    this.increment(e);
    let n = this.index;
    return this.index = r, n;
  }
  increment(e = 1) {
    let r = e < 0 ? -1 : 1;
    for (e = Math.abs(e); e--; ) this.move(r);
    return this.glyphs[this.index];
  }
  constructor(e, r) {
    this.glyphs = e, this.reset(r);
  }
}
const uW = [
  "DFLT",
  "dflt",
  "latn"
];
class j5 {
  findScript(e) {
    if (this.table.scriptList == null) return null;
    Array.isArray(e) || (e = [
      e
    ]);
    for (let r of e) for (let n of this.table.scriptList)
      if (n.tag === r) return n;
    return null;
  }
  selectScript(e, r, n) {
    let i = !1, a;
    if (!this.script || e !== this.scriptTag) {
      if (a = this.findScript(e), a || (a = this.findScript(uW)), !a) return this.scriptTag;
      this.scriptTag = a.tag, this.script = a.script, this.language = null, this.languageTag = null, i = !0;
    }
    if ((!n || n !== this.direction) && (this.direction = n || zE(e)), r && r.length < 4 && (r += " ".repeat(4 - r.length)), !r || r !== this.languageTag) {
      this.language = null;
      for (let o of this.script.langSysRecords) if (o.tag === r) {
        this.language = o.langSys, this.languageTag = o.tag;
        break;
      }
      this.language || (this.language = this.script.defaultLangSys, this.languageTag = null), i = !0;
    }
    if (i && (this.features = {}, this.language))
      for (let o of this.language.featureIndexes) {
        let s = this.table.featureList[o], l = this.substituteFeatureForVariations(o);
        this.features[s.tag] = l || s.feature;
      }
    return this.scriptTag;
  }
  lookupsForFeatures(e = [], r) {
    let n = [];
    for (let i of e) {
      let a = this.features[i];
      if (a)
        for (let o of a.lookupListIndexes)
          r && r.indexOf(o) !== -1 || n.push({
            feature: i,
            index: o,
            lookup: this.table.lookupList.get(o)
          });
    }
    return n.sort((i, a) => i.index - a.index), n;
  }
  substituteFeatureForVariations(e) {
    if (this.variationsIndex === -1) return null;
    let n = this.table.featureVariations.featureVariationRecords[this.variationsIndex].featureTableSubstitution.substitutions;
    for (let i of n)
      if (i.featureIndex === e) return i.alternateFeatureTable;
    return null;
  }
  findVariationsIndex(e) {
    let r = this.table.featureVariations;
    if (!r) return -1;
    let n = r.featureVariationRecords;
    for (let i = 0; i < n.length; i++) {
      let a = n[i].conditionSet.conditionTable;
      if (this.variationConditionsMatch(a, e)) return i;
    }
    return -1;
  }
  variationConditionsMatch(e, r) {
    return e.every((n) => {
      let i = n.axisIndex < r.length ? r[n.axisIndex] : 0;
      return n.filterRangeMinValue <= i && i <= n.filterRangeMaxValue;
    });
  }
  applyFeatures(e, r, n) {
    let i = this.lookupsForFeatures(e);
    this.applyLookups(i, r, n);
  }
  applyLookups(e, r, n) {
    this.glyphs = r, this.positions = n, this.glyphIterator = new lW(r);
    for (let { feature: i, lookup: a } of e)
      for (this.currentFeature = i, this.glyphIterator.reset(a.flags); this.glyphIterator.index < r.length; ) {
        if (!(i in this.glyphIterator.cur.features)) {
          this.glyphIterator.next();
          continue;
        }
        for (let o of a.subTables)
          if (this.applyLookup(a.lookupType, o)) break;
        this.glyphIterator.next();
      }
  }
  applyLookup(e, r) {
    throw new Error("applyLookup must be implemented by subclasses");
  }
  applyLookupList(e) {
    let r = this.glyphIterator.options, n = this.glyphIterator.index;
    for (let i of e) {
      this.glyphIterator.reset(r, n), this.glyphIterator.increment(i.sequenceIndex);
      let a = this.table.lookupList.get(i.lookupListIndex);
      this.glyphIterator.reset(a.flags, this.glyphIterator.index);
      for (let o of a.subTables)
        if (this.applyLookup(a.lookupType, o)) break;
    }
    return this.glyphIterator.reset(r, n), !0;
  }
  coverageIndex(e, r) {
    switch (r == null && (r = this.glyphIterator.cur.id), e.version) {
      case 1:
        return e.glyphs.indexOf(r);
      case 2:
        for (let n of e.rangeRecords)
          if (n.start <= r && r <= n.end) return n.startCoverageIndex + r - n.start;
        break;
    }
    return -1;
  }
  match(e, r, n, i) {
    let a = this.glyphIterator.index, o = this.glyphIterator.increment(e), s = 0;
    for (; s < r.length && o && n(r[s], o); )
      i && i.push(this.glyphIterator.index), s++, o = this.glyphIterator.next();
    return this.glyphIterator.index = a, s < r.length ? !1 : i || !0;
  }
  sequenceMatches(e, r) {
    return this.match(e, r, (n, i) => n === i.id);
  }
  sequenceMatchIndices(e, r) {
    return this.match(e, r, (n, i) => this.currentFeature in i.features ? n === i.id : !1, []);
  }
  coverageSequenceMatches(e, r) {
    return this.match(e, r, (n, i) => this.coverageIndex(n, i.id) >= 0);
  }
  getClassID(e, r) {
    switch (r.version) {
      case 1:
        let n = e - r.startGlyph;
        if (n >= 0 && n < r.classValueArray.length) return r.classValueArray[n];
        break;
      case 2:
        for (let i of r.classRangeRecord)
          if (i.start <= e && e <= i.end) return i.class;
        break;
    }
    return 0;
  }
  classSequenceMatches(e, r, n) {
    return this.match(e, r, (i, a) => i === this.getClassID(a.id, n));
  }
  applyContext(e) {
    let r, n;
    switch (e.version) {
      case 1:
        if (r = this.coverageIndex(e.coverage), r === -1) return !1;
        n = e.ruleSets[r];
        for (let i of n)
          if (this.sequenceMatches(1, i.input)) return this.applyLookupList(i.lookupRecords);
        break;
      case 2:
        if (this.coverageIndex(e.coverage) === -1 || (r = this.getClassID(this.glyphIterator.cur.id, e.classDef), r === -1)) return !1;
        n = e.classSet[r];
        for (let i of n)
          if (this.classSequenceMatches(1, i.classes, e.classDef)) return this.applyLookupList(i.lookupRecords);
        break;
      case 3:
        if (this.coverageSequenceMatches(0, e.coverages)) return this.applyLookupList(e.lookupRecords);
        break;
    }
    return !1;
  }
  applyChainingContext(e) {
    let r;
    switch (e.version) {
      case 1:
        if (r = this.coverageIndex(e.coverage), r === -1) return !1;
        let n = e.chainRuleSets[r];
        for (let a of n)
          if (this.sequenceMatches(-a.backtrack.length, a.backtrack) && this.sequenceMatches(1, a.input) && this.sequenceMatches(1 + a.input.length, a.lookahead)) return this.applyLookupList(a.lookupRecords);
        break;
      case 2:
        if (this.coverageIndex(e.coverage) === -1) return !1;
        r = this.getClassID(this.glyphIterator.cur.id, e.inputClassDef);
        let i = e.chainClassSet[r];
        if (!i) return !1;
        for (let a of i)
          if (this.classSequenceMatches(-a.backtrack.length, a.backtrack, e.backtrackClassDef) && this.classSequenceMatches(1, a.input, e.inputClassDef) && this.classSequenceMatches(1 + a.input.length, a.lookahead, e.lookaheadClassDef)) return this.applyLookupList(a.lookupRecords);
        break;
      case 3:
        if (this.coverageSequenceMatches(-e.backtrackGlyphCount, e.backtrackCoverage) && this.coverageSequenceMatches(0, e.inputCoverage) && this.coverageSequenceMatches(e.inputGlyphCount, e.lookaheadCoverage)) return this.applyLookupList(e.lookupRecords);
        break;
    }
    return !1;
  }
  constructor(e, r) {
    this.font = e, this.table = r, this.script = null, this.scriptTag = null, this.language = null, this.languageTag = null, this.features = {}, this.lookups = {}, this.variationsIndex = e._variationProcessor ? this.findVariationsIndex(e._variationProcessor.normalizedCoords) : -1, this.selectScript(), this.glyphs = [], this.positions = [], this.ligatureID = 1, this.currentFeature = null;
  }
}
class oo {
  get id() {
    return this._id;
  }
  set id(e) {
    this._id = e, this.substituted = !0;
    let r = this._font.GDEF;
    if (r && r.glyphClassDef) {
      let n = j5.prototype.getClassID(e, r.glyphClassDef);
      this.isBase = n === 1, this.isLigature = n === 2, this.isMark = n === 3, this.markAttachmentType = r.markAttachClassDef ? j5.prototype.getClassID(e, r.markAttachClassDef) : 0;
    } else
      this.isMark = this.codePoints.length > 0 && this.codePoints.every(cE), this.isBase = !this.isMark, this.isLigature = this.codePoints.length > 1, this.markAttachmentType = 0;
  }
  copy() {
    return new oo(this._font, this.id, this.codePoints, this.features);
  }
  constructor(e, r, n = [], i) {
    if (this._font = e, this.codePoints = n, this.id = r, this.features = {}, Array.isArray(i)) for (let a = 0; a < i.length; a++) {
      let o = i[a];
      this.features[o] = !0;
    }
    else typeof i == "object" && Object.assign(this.features, i);
    this.ligatureID = null, this.ligatureComponent = null, this.isLigated = !1, this.cursiveAttachment = null, this.markAttachment = null, this.shaperInfo = null, this.substituted = !1, this.isMultiplied = !1;
  }
}
class VE extends su {
  static planFeatures(e) {
    e.add([
      "ljmo",
      "vjmo",
      "tjmo"
    ], !1);
  }
  static assignFeatures(e, r) {
    let n = 0, i = 0;
    for (; i < r.length; ) {
      let a, s = r[i].codePoints[0], l = Y5(s);
      switch ([a, n] = kW[n][l], a) {
        case Ys:
          e.font.hasGlyphForCodePoint(s) || (i = HE(r, i, e.font));
          break;
        case g3:
          i = TW(r, i, e.font);
          break;
        case v3:
          DW(r, i, e.font);
          break;
        case b3:
          i = OW(r, i, e.font);
          break;
      }
      i++;
    }
  }
}
Fi(VE, "zeroMarkWidths", "NONE");
const u1 = 44032, jE = 55204, cW = jE - u1 + 1, Hp = 4352, qp = 4449, uc = 4519, fW = 19, W5 = 21, nh = 28, dW = Hp + fW - 1, hW = qp + W5 - 1, pW = uc + nh - 1, Ky = 9676, mW = (t) => 4352 <= t && t <= 4447 || 43360 <= t && t <= 43388, gW = (t) => 4448 <= t && t <= 4519 || 55216 <= t && t <= 55238, vW = (t) => 4520 <= t && t <= 4607 || 55243 <= t && t <= 55291, bW = (t) => 12334 <= t && t <= 12335, xW = (t) => u1 <= t && t <= jE, yW = (t) => t - u1 < cW && (t - u1) % nh === 0, wW = (t) => Hp <= t && t <= dW, _W = (t) => qp <= t && t <= hW, AW = (t) => 1 <= t && t <= pW, EW = 0, SW = 1, H5 = 2, zb = 3, q5 = 4, WE = 5, CW = 6;
function Y5(t) {
  return mW(t) ? SW : gW(t) ? H5 : vW(t) ? zb : yW(t) ? q5 : xW(t) ? WE : bW(t) ? CW : EW;
}
const Ai = 0, Ys = 1, g3 = 2, v3 = 4, b3 = 5, kW = [
  //       X                 L                 V                T                  LV                LVT               M
  // State 0: start state
  [
    [
      Ai,
      0
    ],
    [
      Ai,
      1
    ],
    [
      Ai,
      0
    ],
    [
      Ai,
      0
    ],
    [
      Ys,
      2
    ],
    [
      Ys,
      3
    ],
    [
      b3,
      0
    ]
  ],
  // State 1: <L>
  [
    [
      Ai,
      0
    ],
    [
      Ai,
      1
    ],
    [
      g3,
      2
    ],
    [
      Ai,
      0
    ],
    [
      Ys,
      2
    ],
    [
      Ys,
      3
    ],
    [
      b3,
      0
    ]
  ],
  // State 2: <L,V> or <LV>
  [
    [
      Ai,
      0
    ],
    [
      Ai,
      1
    ],
    [
      Ai,
      0
    ],
    [
      g3,
      3
    ],
    [
      Ys,
      2
    ],
    [
      Ys,
      3
    ],
    [
      v3,
      0
    ]
  ],
  // State 3: <L,V,T> or <LVT>
  [
    [
      Ai,
      0
    ],
    [
      Ai,
      1
    ],
    [
      Ai,
      0
    ],
    [
      Ai,
      0
    ],
    [
      Ys,
      2
    ],
    [
      Ys,
      3
    ],
    [
      v3,
      0
    ]
  ]
];
function Nd(t, e, r) {
  return new oo(t, t.glyphForCodePoint(e).id, [
    e
  ], r);
}
function HE(t, e, r) {
  let n = t[e], a = n.codePoints[0] - u1, o = uc + a % nh;
  a = a / nh | 0;
  let s = Hp + a / W5 | 0, l = qp + a % W5;
  if (!r.hasGlyphForCodePoint(s) || !r.hasGlyphForCodePoint(l) || o !== uc && !r.hasGlyphForCodePoint(o)) return e;
  let u = Nd(r, s, n.features);
  u.features.ljmo = !0;
  let d = Nd(r, l, n.features);
  d.features.vjmo = !0;
  let h = [
    u,
    d
  ];
  if (o > uc) {
    let v = Nd(r, o, n.features);
    v.features.tjmo = !0, h.push(v);
  }
  return t.splice(e, 1, ...h), e + h.length - 1;
}
function TW(t, e, r) {
  let n = t[e], i = t[e].codePoints[0], a = Y5(i), o = t[e - 1].codePoints[0], s = Y5(o), l, u, d, h;
  if (s === q5 && a === zb)
    l = o, h = n;
  else {
    a === H5 ? (u = t[e - 1], d = n) : (u = t[e - 2], d = t[e - 1], h = n);
    let b = u.codePoints[0], x = d.codePoints[0];
    wW(b) && _W(x) && (l = u1 + ((b - Hp) * W5 + (x - qp)) * nh);
  }
  let v = h && h.codePoints[0] || uc;
  if (l != null && (v === uc || AW(v))) {
    let b = l + (v - uc);
    if (r.hasGlyphForCodePoint(b)) {
      let x = s === H5 ? 3 : 2;
      return t.splice(e - x + 1, x, Nd(r, b, n.features)), e - x + 1;
    }
  }
  return u && (u.features.ljmo = !0), d && (d.features.vjmo = !0), h && (h.features.tjmo = !0), s === q5 ? (HE(t, e - 1, r), e + 1) : e;
}
function FW(t) {
  switch (Y5(t)) {
    case q5:
    case WE:
      return 1;
    case H5:
      return 2;
    case zb:
      return 3;
  }
}
function DW(t, e, r) {
  let n = t[e], i = t[e].codePoints[0];
  if (r.glyphForCodePoint(i).advanceWidth === 0) return;
  let a = t[e - 1].codePoints[0], o = FW(a);
  return t.splice(e, 1), t.splice(e - o, 0, n);
}
function OW(t, e, r) {
  let n = t[e], i = t[e].codePoints[0];
  if (r.hasGlyphForCodePoint(Ky)) {
    let a = Nd(r, Ky, n.features), o = r.glyphForCodePoint(i).advanceWidth === 0 ? e : e + 1;
    t.splice(o, 0, a), e++;
  }
  return e;
}
var qE = {};
qE = JSON.parse('{"stateTable":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,14,15,16,17],[0,0,0,18,19,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,28,29,30,31,32,33,0,34,0,0,35,36,0,0,37,0],[0,0,0,38,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,39,0,0,0,40,41,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,12,43,0,0,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,0,43,0,0,0,0],[0,0,0,45,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,50,0,0,51,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,52,0,0,0,0,0,0,0,0],[0,0,0,53,54,55,56,57,58,0,59,0,0,60,61,0,0,62,0],[0,0,0,4,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,63,64,0,0,40,41,0,9,0,10,0,0,0,42,0,63,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,0,2,16,0],[0,0,0,18,65,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,0,0],[0,0,0,69,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,73,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,75,0,0,0,76,77,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,25,79,0,0,0,0],[0,0,0,18,19,20,74,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,81,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,86,0,0,87,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,88,0,0,0,0,0,0,0,0],[0,0,0,18,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,89,90,0,0,76,77,0,23,0,24,0,0,0,78,0,89,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,0,0],[0,0,0,94,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,96,0,0,0,97,98,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,35,100,0,0,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,102,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,107,0,0,108,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,109,0,0,0,0,0,0,0,0],[0,0,0,28,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,110,111,0,0,97,98,0,33,0,34,0,0,0,99,0,110,0,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,0,0],[0,0,0,0,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,0,0,115,116,117,118,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,39,0,122,0,123,123,8,9,0,10,0,0,0,42,0,39,0,0],[0,124,64,0,0,0,0,0,0,0,0,0,0,0,0,0,124,0,0],[0,39,0,0,0,121,125,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,126,126,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,47,47,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,128,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,129,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,50,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,134,0,0,0,0,0,0,0,0],[0,0,0,135,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,136,0,0,0,137,138,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,60,140,0,0,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,0,140,0,0,0,0],[0,0,0,142,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,147,0,0,148,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,149,0,0,0,0,0,0,0,0],[0,0,0,53,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,150,151,0,0,137,138,0,58,0,59,0,0,0,139,0,150,0,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,0,0],[0,0,0,155,116,156,157,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,75,3,4,5,159,160,8,161,0,162,0,11,12,163,0,75,16,0],[0,0,0,0,0,40,164,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,0,165,0,0,0,0],[0,124,64,0,0,40,164,0,9,0,10,0,0,0,42,0,124,0,0],[0,0,0,0,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,71,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,167,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,168,0,0,0,0,0,0,0,0],[0,0,0,0,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,0,79,0,0,0,0],[0,0,0,169,170,171,172,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,75,0,176,0,177,177,22,23,0,24,0,0,0,78,0,75,0,0],[0,178,90,0,0,0,0,0,0,0,0,0,0,0,0,0,178,0,0],[0,75,0,0,0,175,179,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,180,180,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,83,83,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,182,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,183,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,86,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,188,0,0,0,0,0,0,0,0],[0,0,0,189,170,190,191,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,76,193,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,0,194,0,0,0,0],[0,178,90,0,0,76,193,0,23,0,24,0,0,0,78,0,178,0,0],[0,0,0,0,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,195,196,197,198,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,96,0,202,0,203,203,32,33,0,34,0,0,0,99,0,96,0,0],[0,204,111,0,0,0,0,0,0,0,0,0,0,0,0,0,204,0,0],[0,96,0,0,0,201,205,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,206,206,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,104,104,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,208,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,209,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,107,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,214,0,0,0,0,0,0,0,0],[0,0,0,215,196,216,217,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,97,219,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,0,220,0,0,0,0],[0,204,111,0,0,97,219,0,33,0,34,0,0,0,99,0,204,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,223,0,0,0,40,224,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,119,225,0,0,0,0],[0,0,0,115,116,117,222,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,115,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,226,64,0,0,40,224,0,9,0,10,0,0,0,42,0,226,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,39,0,0,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,44,44,8,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,227,0,228,229,0,9,0,10,0,0,230,0,0,0,0,0],[0,39,0,122,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,231,231,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,232,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,131,131,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,234,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,235,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,0,0,240,241,242,243,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,136,0,247,0,248,248,57,58,0,59,0,0,0,139,0,136,0,0],[0,249,151,0,0,0,0,0,0,0,0,0,0,0,0,0,249,0,0],[0,136,0,0,0,246,250,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,251,251,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,144,144,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,253,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,254,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,147,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,259,0,0,0,0,0,0,0,0],[0,0,0,260,241,261,262,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,137,264,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,0,265,0,0,0,0],[0,249,151,0,0,137,264,0,58,0,59,0,0,0,139,0,249,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,158,225,0,0,0,0],[0,0,0,155,116,156,222,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,155,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,43,266,266,8,161,0,24,0,0,12,267,0,0,0,0],[0,75,0,176,43,268,268,269,161,0,24,0,0,0,267,0,75,0,0],[0,0,0,0,0,270,0,0,271,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,272,0,0,0,0,0,0,0,0],[0,273,274,0,0,40,41,0,9,0,10,0,0,0,42,0,273,0,0],[0,0,0,40,0,123,123,8,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,121,275,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,276,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,279,0,0,0,76,280,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,173,281,0,0,0,0],[0,0,0,169,170,171,278,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,169,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,282,90,0,0,76,280,0,23,0,24,0,0,0,78,0,282,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,75,0,0,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,80,80,22,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,283,0,284,285,0,23,0,24,0,0,286,0,0,0,0,0],[0,75,0,176,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,0,0,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,287,287,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,288,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,185,185,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,290,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,291,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,192,281,0,0,0,0],[0,0,0,189,170,190,278,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,189,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,76,0,177,177,22,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,175,296,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,299,0,0,0,97,300,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,199,301,0,0,0,0],[0,0,0,195,196,197,298,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,195,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,302,111,0,0,97,300,0,33,0,34,0,0,0,99,0,302,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,96,0,0,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,101,101,32,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,303,0,304,305,0,33,0,34,0,0,306,0,0,0,0,0],[0,96,0,202,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,0,0,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,307,307,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,211,211,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,310,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,311,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,218,301,0,0,0,0],[0,0,0,215,196,216,298,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,215,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,97,0,203,203,32,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,201,316,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,0,225,0,0,0,0],[0,0,0,317,318,319,320,8,9,0,10,0,0,321,322,0,0,16,0],[0,223,0,323,0,123,123,8,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,0,0,121,324,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,325,318,326,327,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,64,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,230,0,0,0,0,0],[0,0,0,227,0,228,121,0,9,0,10,0,0,230,0,0,0,0,0],[0,0,0,227,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,46,0,0],[0,0,0,0,0,329,329,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,330,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,237,237,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,332,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,333,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,337,0,0,0,137,338,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,244,339,0,0,0,0],[0,0,0,240,241,242,336,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,240,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,340,151,0,0,137,338,0,58,0,59,0,0,0,139,0,340,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,136,0,0,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,141,141,57,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,341,0,342,343,0,58,0,59,0,0,344,0,0,0,0,0],[0,136,0,247,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,0,0,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,345,345,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,346,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,256,256,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,348,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,349,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,263,339,0,0,0,0],[0,0,0,260,241,261,336,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,260,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,137,0,248,248,57,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,246,354,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,126,126,8,23,0,0,0,0,0,0,0,0,0,0],[0,355,90,0,0,121,125,0,9,0,10,0,0,0,42,0,355,0,0],[0,0,0,0,0,356,356,269,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,357,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,270,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,363,0,0,0,0,0,0,0,0],[0,0,0,364,116,365,366,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,40,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,0,281,0,0,0,0],[0,0,0,369,370,371,372,22,23,0,24,0,0,373,374,0,0,27,0],[0,279,0,375,0,177,177,22,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,0,0,175,376,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,377,370,378,379,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,90,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,286,0,0,0,0,0],[0,0,0,283,0,284,175,0,23,0,24,0,0,286,0,0,0,0,0],[0,0,0,283,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,82,0,0],[0,0,0,0,0,381,381,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,382,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,293,293,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,384,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,385,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,76,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,0,301,0,0,0,0],[0,0,0,387,388,389,390,32,33,0,34,0,0,391,392,0,0,37,0],[0,299,0,393,0,203,203,32,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,0,0,201,394,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,395,388,396,397,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,111,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,306,0,0,0,0,0],[0,0,0,303,0,304,201,0,33,0,34,0,0,306,0,0,0,0,0],[0,0,0,303,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,0,0],[0,0,0,0,0,399,399,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,400,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,313,313,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,402,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,403,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,97,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,407,0,0,0,40,408,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,321,409,0,0,0,0],[0,0,0,317,318,319,406,8,9,0,10,0,0,321,322,0,0,16,0],[0,0,0,317,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,410,64,0,0,40,408,0,9,0,10,0,0,0,42,0,410,0,0],[0,223,0,0,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,323,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,328,409,0,0,0,0],[0,0,0,325,318,326,406,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,325,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,0,0,0,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,130,0,0],[0,0,0,0,0,411,411,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,412,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,413,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,0,339,0,0,0,0],[0,0,0,414,415,416,417,57,58,0,59,0,0,418,419,0,0,62,0],[0,337,0,420,0,248,248,57,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,0,0,246,421,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,422,415,423,424,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,151,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,344,0,0,0,0,0],[0,0,0,341,0,342,246,0,58,0,59,0,0,344,0,0,0,0,0],[0,0,0,341,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,143,0,0],[0,0,0,0,0,426,426,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,427,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,351,351,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,429,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,430,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,137,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,432,116,433,434,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,0,0,180,180,269,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,359,359,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,437,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,438,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,443,274,0,0,0,0,0,0,0,0,0,0,0,0,0,443,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,367,225,0,0,0,0],[0,0,0,364,116,365,445,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,364,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,448,0,0,0,76,449,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,373,450,0,0,0,0],[0,0,0,369,370,371,447,22,23,0,24,0,0,373,374,0,0,27,0],[0,0,0,369,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,451,90,0,0,76,449,0,23,0,24,0,0,0,78,0,451,0,0],[0,279,0,0,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,375,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,380,450,0,0,0,0],[0,0,0,377,370,378,447,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,377,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,0,0,0,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,184,0,0],[0,0,0,0,0,452,452,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,453,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,454,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,457,0,0,0,97,458,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,391,459,0,0,0,0],[0,0,0,387,388,389,456,32,33,0,34,0,0,391,392,0,0,37,0],[0,0,0,387,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,460,111,0,0,97,458,0,33,0,34,0,0,0,99,0,460,0,0],[0,299,0,0,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,393,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,398,459,0,0,0,0],[0,0,0,395,388,396,456,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,395,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,0,0,0,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,210,0,0],[0,0,0,0,0,461,461,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,462,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,463,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,0,409,0,0,0,0],[0,0,0,464,465,466,467,8,9,0,10,0,0,468,469,0,0,16,0],[0,407,0,470,0,123,123,8,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,0,0,121,471,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,472,465,473,474,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,0,0,0,0,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,236,0,0],[0,0,0,0,0,0,476,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,479,0,0,0,137,480,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,418,481,0,0,0,0],[0,0,0,414,415,416,478,57,58,0,59,0,0,418,419,0,0,62,0],[0,0,0,414,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,482,151,0,0,137,480,0,58,0,59,0,0,0,139,0,482,0,0],[0,337,0,0,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,420,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,425,481,0,0,0,0],[0,0,0,422,415,423,478,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,422,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,0,0,0,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,0,0],[0,0,0,0,0,483,483,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,484,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,485,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,435,225,0,0,0,0],[0,0,0,432,116,433,445,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,432,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,486,486,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,487,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,440,440,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,489,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,490,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,495,0,496,497,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,0,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,0,225,0,0,0,0],[0,0,0,0,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,0,450,0,0,0,0],[0,0,0,499,500,501,502,22,23,0,24,0,0,503,504,0,0,27,0],[0,448,0,505,0,177,177,22,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,0,0,175,506,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,507,500,508,509,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,0,0,0,0,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,292,0,0],[0,0,0,0,0,0,511,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,0,459,0,0,0,0],[0,0,0,512,513,514,515,32,33,0,34,0,0,516,517,0,0,37,0],[0,457,0,518,0,203,203,32,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,0,0,201,519,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,520,513,521,522,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,0,0,0,0,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,312,0,0],[0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,527,0,0,0,40,528,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,468,529,0,0,0,0],[0,0,0,464,465,466,526,8,9,0,10,0,0,468,469,0,0,16,0],[0,0,0,464,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,530,64,0,0,40,528,0,9,0,10,0,0,0,42,0,530,0,0],[0,407,0,0,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,470,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,475,529,0,0,0,0],[0,0,0,472,465,473,526,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,472,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,40,0,0],[0,0,0,0,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,0,481,0,0,0,0],[0,0,0,531,532,533,534,57,58,0,59,0,0,535,536,0,0,62,0],[0,479,0,537,0,248,248,57,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,0,0,246,538,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,539,532,540,541,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,0,0,0,0,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,350,0,0],[0,0,0,0,0,0,543,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,358,0,0],[0,0,0,0,0,544,544,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,545,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,492,492,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,547,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,548,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,274,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,498,0,0,0,0,0],[0,0,0,495,0,496,368,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,495,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,553,0,0,0,76,554,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,503,555,0,0,0,0],[0,0,0,499,500,501,552,22,23,0,24,0,0,503,504,0,0,27,0],[0,0,0,499,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,556,90,0,0,76,554,0,23,0,24,0,0,0,78,0,556,0,0],[0,448,0,0,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,505,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,510,555,0,0,0,0],[0,0,0,507,500,508,552,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,507,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,76,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,559,0,0,0,97,560,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,516,561,0,0,0,0],[0,0,0,512,513,514,558,32,33,0,34,0,0,516,517,0,0,37,0],[0,0,0,512,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,562,111,0,0,97,560,0,33,0,34,0,0,0,99,0,562,0,0],[0,457,0,0,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,518,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,523,561,0,0,0,0],[0,0,0,520,513,521,558,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,520,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,97,0,0],[0,0,0,0,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,0,529,0,0,0,0],[0,0,0,563,66,564,565,8,9,0,10,0,0,566,68,0,0,16,0],[0,527,0,567,0,123,123,8,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,0,0,121,568,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,569,66,570,571,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,575,0,0,0,137,576,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,535,577,0,0,0,0],[0,0,0,531,532,533,574,57,58,0,59,0,0,535,536,0,0,62,0],[0,0,0,531,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,578,151,0,0,137,576,0,58,0,59,0,0,0,139,0,578,0,0],[0,479,0,0,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,537,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,542,577,0,0,0,0],[0,0,0,539,532,540,574,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,539,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,137,0,0],[0,0,0,0,0,0,0,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,439,0,0],[0,0,0,0,0,579,579,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,580,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,581,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,0,555,0,0,0,0],[0,0,0,582,91,583,584,22,23,0,24,0,0,585,93,0,0,27,0],[0,553,0,586,0,177,177,22,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,0,0,175,587,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,588,91,589,590,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,0,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,0,561,0,0,0,0],[0,0,0,592,112,593,594,32,33,0,34,0,0,595,114,0,0,37,0],[0,559,0,596,0,203,203,32,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,0,0,201,597,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,598,112,599,600,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,566,165,0,0,0,0],[0,0,0,563,66,564,67,8,9,0,10,0,0,566,68,0,0,16,0],[0,0,0,563,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,527,0,0,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,567,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,572,165,0,0,0,0],[0,0,0,569,66,570,67,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,569,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,0,577,0,0,0,0],[0,0,0,603,152,604,605,57,58,0,59,0,0,606,154,0,0,62,0],[0,575,0,607,0,248,248,57,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,0,0,246,608,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,609,152,610,611,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,0,0,0,0,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,491,0,0],[0,0,0,0,0,0,613,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,585,194,0,0,0,0],[0,0,0,582,91,583,92,22,23,0,24,0,0,585,93,0,0,27,0],[0,0,0,582,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,553,0,0,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,586,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,591,194,0,0,0,0],[0,0,0,588,91,589,92,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,588,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,595,220,0,0,0,0],[0,0,0,592,112,593,113,32,33,0,34,0,0,595,114,0,0,37,0],[0,0,0,592,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,559,0,0,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,596,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,601,220,0,0,0,0],[0,0,0,598,112,599,113,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,598,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,606,265,0,0,0,0],[0,0,0,603,152,604,153,57,58,0,59,0,0,606,154,0,0,62,0],[0,0,0,603,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,575,0,0,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,607,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,612,265,0,0,0,0],[0,0,0,609,152,610,153,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,609,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,549,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0]],"accepting":[false,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,false,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,false,false,true,false,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,false,false,true,true,false,false,true,true,true,false,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,false,false,false,false,false,false,false,true,true,false,false,true,true,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,false,true,true,false,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,false,true,true,true,true,true,false,true,true,false,true,true,true],"tags":[[],["broken_cluster"],["consonant_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["consonant_syllable"],["broken_cluster"],["symbol_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["broken_cluster"],["broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],[],["broken_cluster"],["symbol_cluster"],[],["symbol_cluster"],["symbol_cluster"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["symbol_cluster"],["symbol_cluster"],["symbol_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],["symbol_cluster"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],[],["broken_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],[],["consonant_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],[],["vowel_syllable"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],[],[],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],["standalone_cluster"],[],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],[],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],[],[],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],[],[],[],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],["consonant_syllable"],["vowel_syllable"],["standalone_cluster"]]}');
var Yp = {};
Yp = JSON.parse('{"categories":["O","IND","S","GB","B","FM","CGJ","VMAbv","VMPst","VAbv","VPst","CMBlw","VPre","VBlw","H","VMBlw","CMAbv","MBlw","CS","R","SUB","MPst","MPre","FAbv","FPst","FBlw","null","SMAbv","SMBlw","VMPre","ZWNJ","ZWJ","WJ","M","VS","N","HN","MAbv"],"decompositions":{"2507":[2503,2494],"2508":[2503,2519],"2888":[2887,2902],"2891":[2887,2878],"2892":[2887,2903],"3018":[3014,3006],"3019":[3015,3006],"3020":[3014,3031],"3144":[3142,3158],"3264":[3263,3285],"3271":[3270,3285],"3272":[3270,3286],"3274":[3270,3266],"3275":[3270,3266,3285],"3402":[3398,3390],"3403":[3399,3390],"3404":[3398,3415],"3546":[3545,3530],"3548":[3545,3535],"3549":[3545,3535,3530],"3550":[3545,3551],"3635":[3661,3634],"3763":[3789,3762],"3955":[3953,3954],"3957":[3953,3956],"3958":[4018,3968],"3959":[4018,3953,3968],"3960":[4019,3968],"3961":[4019,3953,3968],"3969":[3953,3968],"6971":[6970,6965],"6973":[6972,6965],"6976":[6974,6965],"6977":[6975,6965],"6979":[6978,6965],"69934":[69937,69927],"69935":[69938,69927],"70475":[70471,70462],"70476":[70471,70487],"70843":[70841,70842],"70844":[70841,70832],"70846":[70841,70845],"71098":[71096,71087],"71099":[71097,71087]},"stateTable":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[2,2,3,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,17,18,11,19,20,21,22,0,0,0,23,0,0,2,0,0,24,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,26,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,27,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,39,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,49,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,41,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,53,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,51,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,54,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0]],"accepting":[false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true],"tags":[[],["broken_cluster"],["independent_cluster"],["symbol_cluster"],["standard_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["numeral_cluster"],["broken_cluster"],["independent_cluster"],["symbol_cluster"],["symbol_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["virama_terminated_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["broken_cluster"],["broken_cluster"],["numeral_cluster"],["number_joiner_terminated_cluster"],["standard_cluster"],["standard_cluster"],["numeral_cluster"]]}');
const Kt = {
  X: 1,
  C: 2,
  V: 4,
  N: 8,
  H: 16,
  ZWNJ: 32,
  ZWJ: 64,
  M: 128,
  SM: 256,
  VD: 512,
  A: 1024,
  Placeholder: 2048,
  Dotted_Circle: 4096,
  RS: 8192,
  Coeng: 16384,
  Repha: 32768,
  Ra: 65536,
  CM: 131072,
  Symbol: 262144
  // Avagraha, etc that take marks (SM,A,VD).
}, Ct = {
  Start: 1,
  Ra_To_Become_Reph: 2,
  Pre_M: 4,
  Pre_C: 8,
  Base_C: 16,
  After_Main: 32,
  Above_C: 64,
  Before_Sub: 128,
  Below_C: 256,
  After_Sub: 512,
  Before_Post: 1024,
  Post_C: 2048,
  After_Post: 4096,
  Final_C: 8192,
  SMVD: 16384,
  End: 32768
}, RW = Kt.C | Kt.Ra | Kt.CM | Kt.V | Kt.Placeholder | Kt.Dotted_Circle, YE = Kt.ZWJ | Kt.ZWNJ, Md = Kt.H | Kt.Coeng, Jy = {
  Default: {
    hasOldSpec: !1,
    virama: 0,
    basePos: "Last",
    rephPos: Ct.Before_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Devanagari: {
    hasOldSpec: !0,
    virama: 2381,
    basePos: "Last",
    rephPos: Ct.Before_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Bengali: {
    hasOldSpec: !0,
    virama: 2509,
    basePos: "Last",
    rephPos: Ct.After_Sub,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Gurmukhi: {
    hasOldSpec: !0,
    virama: 2637,
    basePos: "Last",
    rephPos: Ct.Before_Sub,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Gujarati: {
    hasOldSpec: !0,
    virama: 2765,
    basePos: "Last",
    rephPos: Ct.Before_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Oriya: {
    hasOldSpec: !0,
    virama: 2893,
    basePos: "Last",
    rephPos: Ct.After_Main,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Tamil: {
    hasOldSpec: !0,
    virama: 3021,
    basePos: "Last",
    rephPos: Ct.After_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Telugu: {
    hasOldSpec: !0,
    virama: 3149,
    basePos: "Last",
    rephPos: Ct.After_Post,
    rephMode: "Explicit",
    blwfMode: "Post_Only"
  },
  Kannada: {
    hasOldSpec: !0,
    virama: 3277,
    basePos: "Last",
    rephPos: Ct.After_Post,
    rephMode: "Implicit",
    blwfMode: "Post_Only"
  },
  Malayalam: {
    hasOldSpec: !0,
    virama: 3405,
    basePos: "Last",
    rephPos: Ct.After_Main,
    rephMode: "Log_Repha",
    blwfMode: "Pre_And_Post"
  },
  // Handled by UniversalShaper
  // Sinhala: {
  //   hasOldSpec: false,
  //   virama: 0x0DCA,
  //   basePos: 'Last_Sinhala',
  //   rephPos: POSITIONS.After_Main,
  //   rephMode: 'Explicit',
  //   blwfMode: 'Pre_And_Post'
  // },
  Khmer: {
    hasOldSpec: !1,
    virama: 6098,
    basePos: "First",
    rephPos: Ct.Ra_To_Become_Reph,
    rephMode: "Vis_Repha",
    blwfMode: "Pre_And_Post"
  }
}, PW = {
  // Khmer
  6078: [
    6081,
    6078
  ],
  6079: [
    6081,
    6079
  ],
  6080: [
    6081,
    6080
  ],
  6084: [
    6081,
    6084
  ],
  6085: [
    6081,
    6085
  ]
}, { decompositions: IW } = /* @__PURE__ */ $p(Yp), GE = new Ch(Mb("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")), BW = new fE(/* @__PURE__ */ $p(qE));
class Pr extends su {
  static planFeatures(e) {
    e.addStage(LW), e.addStage([
      "locl",
      "ccmp"
    ]), e.addStage(MW), e.addStage("nukt"), e.addStage("akhn"), e.addStage("rphf", !1), e.addStage("rkrf"), e.addStage("pref", !1), e.addStage("blwf", !1), e.addStage("abvf", !1), e.addStage("half", !1), e.addStage("pstf", !1), e.addStage("vatu"), e.addStage("cjct"), e.addStage("cfar", !1), e.addStage(UW), e.addStage({
      local: [
        "init"
      ],
      global: [
        "pres",
        "abvs",
        "blws",
        "psts",
        "haln",
        "dist",
        "abvm",
        "blwm",
        "calt",
        "clig"
      ]
    }), e.unicodeScript = kj(e.script), e.indicConfig = Jy[e.unicodeScript] || Jy.Default, e.isOldSpec = e.indicConfig.hasOldSpec && e.script[e.script.length - 1] !== "2";
  }
  static assignFeatures(e, r) {
    for (let n = r.length - 1; n >= 0; n--) {
      let i = r[n].codePoints[0], a = PW[i] || IW[i];
      if (a) {
        let o = a.map((s) => {
          let l = e.font.glyphForCodePoint(s);
          return new oo(e.font, l.id, [
            s
          ], r[n].features);
        });
        r.splice(n, 1, ...o);
      }
    }
  }
}
Fi(Pr, "zeroMarkWidths", "NONE");
function x3(t) {
  return GE.get(t.codePoints[0]) >> 8;
}
function ZE(t) {
  return 1 << (GE.get(t.codePoints[0]) & 255);
}
class n5 {
  constructor(e, r, n, i) {
    this.category = e, this.position = r, this.syllableType = n, this.syllable = i;
  }
}
function LW(t, e) {
  let r = 0, n = 0;
  for (let [i, a, o] of BW.match(e.map(x3))) {
    if (i > n) {
      ++r;
      for (let s = n; s < i; s++) e[s].shaperInfo = new n5(Kt.X, Ct.End, "non_indic_cluster", r);
    }
    ++r;
    for (let s = i; s <= a; s++) e[s].shaperInfo = new n5(1 << x3(e[s]), ZE(e[s]), o[0], r);
    n = a + 1;
  }
  if (n < e.length) {
    ++r;
    for (let i = n; i < e.length; i++) e[i].shaperInfo = new n5(Kt.X, Ct.End, "non_indic_cluster", r);
  }
}
function Nu(t) {
  return t.shaperInfo.category & RW;
}
function $o(t) {
  return t.shaperInfo.category & YE;
}
function js(t) {
  return t.shaperInfo.category & Md;
}
function Gs(t, e) {
  for (let n of t) n.features = {
    [e]: !0
  };
  return t[0]._font._layoutEngine.engine.GSUBProcessor.applyFeatures([
    e
  ], t), t.length === 1;
}
function NW(t, e, r) {
  let n = [
    r,
    e,
    r
  ];
  return Gs(n.slice(0, 2), "blwf") || Gs(n.slice(1, 3), "blwf") ? Ct.Below_C : Gs(n.slice(0, 2), "pstf") || Gs(n.slice(1, 3), "pstf") || Gs(n.slice(0, 2), "pref") || Gs(n.slice(1, 3), "pref") ? Ct.Post_C : Ct.Base_C;
}
function MW(t, e, r) {
  let n = r.indicConfig, i = t._layoutEngine.engine.GSUBProcessor.features, a = t.glyphForCodePoint(9676).id, o = t.glyphForCodePoint(n.virama).id;
  if (o) {
    let s = new oo(t, o, [
      n.virama
    ]);
    for (let l = 0; l < e.length; l++) e[l].shaperInfo.position === Ct.Base_C && (e[l].shaperInfo.position = NW(t, e[l].copy(), s));
  }
  for (let s = 0, l = G5(e, 0); s < e.length; s = l, l = G5(e, s)) {
    let { category: u, syllableType: d } = e[s].shaperInfo;
    if (d === "symbol_cluster" || d === "non_indic_cluster") continue;
    if (d === "broken_cluster" && a) {
      let C = new oo(t, a, [
        9676
      ]);
      C.shaperInfo = new n5(1 << x3(C), ZE(C), e[s].shaperInfo.syllableType, e[s].shaperInfo.syllable);
      let D = s;
      for (; D < l && e[D].shaperInfo.category === Kt.Repha; ) D++;
      e.splice(D++, 0, C), l++;
    }
    let h = l, v = s, b = !1;
    if (n.rephPos !== Ct.Ra_To_Become_Reph && i.rphf && s + 3 <= l && (n.rephMode === "Implicit" && !$o(e[s + 2]) || n.rephMode === "Explicit" && e[s + 2].shaperInfo.category === Kt.ZWJ)) {
      let C = [
        e[s].copy(),
        e[s + 1].copy(),
        e[s + 2].copy()
      ];
      if (Gs(C.slice(0, 2), "rphf") || n.rephMode === "Explicit" && Gs(C, "rphf")) {
        for (v += 2; v < l && $o(e[v]); ) v++;
        h = s, b = !0;
      }
    } else if (n.rephMode === "Log_Repha" && e[s].shaperInfo.category === Kt.Repha) {
      for (v++; v < l && $o(e[v]); ) v++;
      h = s, b = !0;
    }
    switch (n.basePos) {
      case "Last": {
        let C = l, D = !1;
        do {
          let _ = e[--C].shaperInfo;
          if (Nu(e[C])) {
            if (_.position !== Ct.Below_C && (_.position !== Ct.Post_C || D)) {
              h = C;
              break;
            }
            _.position === Ct.Below_C && (D = !0), h = C;
          } else if (s < C && _.category === Kt.ZWJ && e[C - 1].shaperInfo.category === Kt.H) break;
        } while (C > v);
        break;
      }
      case "First":
        h = s;
        for (let C = h + 1; C < l; C++) Nu(e[C]) && (e[C].shaperInfo.position = Ct.Below_C);
    }
    b && h === s && v - h <= 2 && (b = !1);
    for (let C = s; C < h; C++) {
      let D = e[C].shaperInfo;
      D.position = Math.min(Ct.Pre_C, D.position);
    }
    h < l && (e[h].shaperInfo.position = Ct.Base_C);
    for (let C = h + 1; C < l; C++) if (e[C].shaperInfo.category === Kt.M) {
      for (let D = C + 1; D < l; D++) if (Nu(e[D])) {
        e[D].shaperInfo.position = Ct.Final_C;
        break;
      }
      break;
    }
    if (b && (e[s].shaperInfo.position = Ct.Ra_To_Become_Reph), r.isOldSpec) {
      let C = r.unicodeScript !== "Malayalam";
      for (let D = h + 1; D < l; D++) if (e[D].shaperInfo.category === Kt.H) {
        let _;
        for (_ = l - 1; _ > D && !(Nu(e[_]) || C && e[_].shaperInfo.category === Kt.H); _--)
          ;
        if (e[_].shaperInfo.category !== Kt.H && _ > D) {
          let I = e[D];
          e.splice(D, 0, ...e.splice(D + 1, _ - D)), e[_] = I;
        }
        break;
      }
    }
    let x = Ct.Start;
    for (let C = s; C < l; C++) {
      let D = e[C].shaperInfo;
      if (D.category & (YE | Kt.N | Kt.RS | Kt.CM | Md & D.category)) {
        if (D.position = x, D.category === Kt.H && D.position === Ct.Pre_M) {
          for (let _ = C; _ > s; _--) if (e[_ - 1].shaperInfo.position !== Ct.Pre_M) {
            D.position = e[_ - 1].shaperInfo.position;
            break;
          }
        }
      } else D.position !== Ct.SMVD && (x = D.position);
    }
    let A = h;
    for (let C = h + 1; C < l; C++)
      if (Nu(e[C])) {
        for (let D = A + 1; D < C; D++) e[D].shaperInfo.position < Ct.SMVD && (e[D].shaperInfo.position = e[C].shaperInfo.position);
        A = C;
      } else e[C].shaperInfo.category === Kt.M && (A = C);
    let T = e.slice(s, l);
    T.sort((C, D) => C.shaperInfo.position - D.shaperInfo.position), e.splice(s, T.length, ...T);
    for (let C = s; C < l; C++) if (e[C].shaperInfo.position === Ct.Base_C) {
      h = C;
      break;
    }
    for (let C = s; C < l && e[C].shaperInfo.position === Ct.Ra_To_Become_Reph; C++) e[C].features.rphf = !0;
    let k = !r.isOldSpec && n.blwfMode === "Pre_And_Post";
    for (let C = s; C < h; C++)
      e[C].features.half = !0, k && (e[C].features.blwf = !0);
    for (let C = h + 1; C < l; C++)
      e[C].features.abvf = !0, e[C].features.pstf = !0, e[C].features.blwf = !0;
    if (r.isOldSpec && r.unicodeScript === "Devanagari")
      for (let C = s; C + 1 < h; C++) e[C].shaperInfo.category === Kt.Ra && e[C + 1].shaperInfo.category === Kt.H && (C + 1 === h || e[C + 2].shaperInfo.category === Kt.ZWJ) && (e[C].features.blwf = !0, e[C + 1].features.blwf = !0);
    let E = 2;
    if (i.pref && h + E < l)
      for (let C = h + 1; C + E - 1 < l; C++) {
        let D = [
          e[C].copy(),
          e[C + 1].copy()
        ];
        if (Gs(D, "pref")) {
          for (let _ = 0; _ < E; _++) e[C++].features.pref = !0;
          if (i.cfar) for (; C < l; C++) e[C].features.cfar = !0;
          break;
        }
      }
    for (let C = s + 1; C < l; C++) if ($o(e[C])) {
      let D = e[C].shaperInfo.category === Kt.ZWNJ, _ = C;
      do
        _--, D && delete e[_].features.half;
      while (_ > s && !Nu(e[_]));
    }
  }
}
function UW(t, e, r) {
  let n = r.indicConfig, i = t._layoutEngine.engine.GSUBProcessor.features;
  for (let a = 0, o = G5(e, 0); a < e.length; a = o, o = G5(e, a)) {
    let s = !!i.pref, l = a;
    for (; l < o; l++) if (e[l].shaperInfo.position >= Ct.Base_C) {
      if (s && l + 1 < o) {
        for (let u = l + 1; u < o; u++) if (e[u].features.pref) {
          if (!(e[u].substituted && e[u].isLigated && !e[u].isMultiplied)) {
            for (l = u; l < o && js(e[l]); ) l++;
            e[l].shaperInfo.position = Ct.BASE_C, s = !1;
          }
          break;
        }
      }
      if (r.unicodeScript === "Malayalam") for (let u = l + 1; u < o; u++) {
        for (; u < o && $o(e[u]); ) u++;
        if (u === o || !js(e[u])) break;
        for (u++; u < o && $o(e[u]); ) u++;
        u < o && Nu(e[u]) && e[u].shaperInfo.position === Ct.Below_C && (l = u, e[l].shaperInfo.position = Ct.Base_C);
      }
      a < l && e[l].shaperInfo.position > Ct.Base_C && l--;
      break;
    }
    if (l === o && a < l && e[l - 1].shaperInfo.category === Kt.ZWJ && l--, l < o) for (; a < l && e[l].shaperInfo.category & (Kt.N | Md); ) l--;
    if (a + 1 < o && a < l) {
      let u = l === o ? l - 2 : l - 1;
      if (r.unicodeScript !== "Malayalam" && r.unicodeScript !== "Tamil") {
        for (; u > a && !(e[u].shaperInfo.category & (Kt.M | Md)); ) u--;
        js(e[u]) && e[u].shaperInfo.position !== Ct.Pre_M ? u + 1 < o && $o(e[u + 1]) && u++ : u = a;
      }
      if (a < u && e[u].shaperInfo.position !== Ct.Pre_M) {
        for (let d = u; d > a; d--) if (e[d - 1].shaperInfo.position === Ct.Pre_M) {
          let h = d - 1;
          h < l && l <= u && l--;
          let v = e[h];
          e.splice(h, 0, ...e.splice(h + 1, u - h)), e[u] = v, u--;
        }
      }
    }
    if (a + 1 < o && e[a].shaperInfo.position === Ct.Ra_To_Become_Reph && e[a].shaperInfo.category === Kt.Repha !== (e[a].isLigated && !e[a].isMultiplied)) {
      let u, d = n.rephPos, h = !1;
      if (d !== Ct.After_Post) {
        for (u = a + 1; u < l && !js(e[u]); ) u++;
        if (u < l && js(e[u]) && (u + 1 < l && $o(e[u + 1]) && u++, h = !0), !h && d === Ct.After_Main) {
          for (u = l; u + 1 < o && e[u + 1].shaperInfo.position <= Ct.After_Main; ) u++;
          h = u < o;
        }
        if (!h && d === Ct.After_Sub) {
          for (u = l; u + 1 < o && !(e[u + 1].shaperInfo.position & (Ct.Post_C | Ct.After_Post | Ct.SMVD)); ) u++;
          h = u < o;
        }
      }
      if (!h) {
        for (u = a + 1; u < l && !js(e[u]); ) u++;
        u < l && js(e[u]) && (u + 1 < l && $o(e[u + 1]) && u++, h = !0);
      }
      if (!h) {
        for (u = o - 1; u > a && e[u].shaperInfo.position === Ct.SMVD; ) u--;
        if (js(e[u]))
          for (let b = l + 1; b < u; b++) e[b].shaperInfo.category === Kt.M && u--;
      }
      let v = e[a];
      e.splice(a, 0, ...e.splice(a + 1, u - a)), e[u] = v, a < l && l <= u && l--;
    }
    if (s && l + 1 < o) {
      for (let u = l + 1; u < o; u++) if (e[u].features.pref) {
        if (e[u].isLigated && !e[u].isMultiplied) {
          let d = l;
          if (r.unicodeScript !== "Malayalam" && r.unicodeScript !== "Tamil") {
            for (; d > a && !(e[d - 1].shaperInfo.category & (Kt.M | Md)); ) d--;
            if (d > a && e[d - 1].shaperInfo.category === Kt.M) {
              let b = u;
              for (let x = l + 1; x < b; x++) if (e[x].shaperInfo.category === Kt.M) {
                d--;
                break;
              }
            }
          }
          d > a && js(e[d - 1]) && d < o && $o(e[d]) && d++;
          let h = u, v = e[h];
          e.splice(d + 1, 0, ...e.splice(d, h - d)), e[d] = v, d <= l && l < h && l++;
        }
        break;
      }
    }
    e[a].shaperInfo.position === Ct.Pre_M && (!a || !/Cf|Mn/.test(zp(e[a - 1].codePoints[0]))) && (e[a].features.init = !0);
  }
}
function G5(t, e) {
  if (e >= t.length) return e;
  let r = t[e].shaperInfo.syllable;
  for (; ++e < t.length && t[e].shaperInfo.syllable === r; ) ;
  return e;
}
const { categories: zW, decompositions: Qy } = /* @__PURE__ */ $p(Yp), $W = new Ch(Mb("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")), VW = new fE(/* @__PURE__ */ $p(Yp));
class Yt extends su {
  static planFeatures(e) {
    e.addStage(WW), e.addStage([
      "locl",
      "ccmp",
      "nukt",
      "akhn"
    ]), e.addStage(t8), e.addStage([
      "rphf"
    ], !1), e.addStage(HW), e.addStage(t8), e.addStage([
      "pref"
    ]), e.addStage(qW), e.addStage([
      "rkrf",
      "abvf",
      "blwf",
      "half",
      "pstf",
      "vatu",
      "cjct"
    ]), e.addStage(YW), e.addStage([
      "abvs",
      "blws",
      "pres",
      "psts",
      "dist",
      "abvm",
      "blwm"
    ]);
  }
  static assignFeatures(e, r) {
    for (let n = r.length - 1; n >= 0; n--) {
      let i = r[n].codePoints[0];
      if (Qy[i]) {
        let a = Qy[i].map((o) => {
          let s = e.font.glyphForCodePoint(o);
          return new oo(e.font, s.id, [
            o
          ], r[n].features);
        });
        r.splice(n, 1, ...a);
      }
    }
  }
}
Fi(Yt, "zeroMarkWidths", "BEFORE_GPOS");
function e8(t) {
  return $W.get(t.codePoints[0]);
}
class jW {
  constructor(e, r, n) {
    this.category = e, this.syllableType = r, this.syllable = n;
  }
}
function WW(t, e) {
  let r = 0;
  for (let [n, i, a] of VW.match(e.map(e8))) {
    ++r;
    for (let s = n; s <= i; s++) e[s].shaperInfo = new jW(zW[e8(e[s])], a[0], r);
    let o = e[n].shaperInfo.category === "R" ? 1 : Math.min(3, i - n);
    for (let s = n; s < n + o; s++) e[s].features.rphf = !0;
  }
}
function t8(t, e) {
  for (let r of e) r.substituted = !1;
}
function HW(t, e) {
  for (let r of e) r.substituted && r.features.rphf && (r.shaperInfo.category = "R");
}
function qW(t, e) {
  for (let r of e) r.substituted && (r.shaperInfo.category = "VPre");
}
function YW(t, e) {
  let r = t.glyphForCodePoint(9676).id;
  for (let n = 0, i = r8(e, 0); n < e.length; n = i, i = r8(e, n)) {
    let a, o, s = e[n].shaperInfo, l = s.syllableType;
    if (!(l !== "virama_terminated_cluster" && l !== "standard_cluster" && l !== "broken_cluster")) {
      if (l === "broken_cluster" && r) {
        let u = new oo(t, r, [
          9676
        ]);
        for (u.shaperInfo = s, a = n; a < i && e[a].shaperInfo.category === "R"; a++) ;
        e.splice(++a, 0, u), i++;
      }
      if (s.category === "R" && i - n > 1) {
        for (a = n + 1; a < i; a++)
          if (s = e[a].shaperInfo, n8(s) || T2(e[a])) {
            T2(e[a]) && a--, e.splice(n, 0, ...e.splice(n + 1, a - n), e[a]);
            break;
          }
      }
      for (a = n, o = i; a < i; a++)
        s = e[a].shaperInfo, n8(s) || T2(e[a]) ? o = T2(e[a]) ? a + 1 : a : (s.category === "VPre" || s.category === "VMPre") && o < a && e.splice(o, 1, e[a], ...e.splice(o, a - o));
    }
  }
}
function r8(t, e) {
  if (e >= t.length) return e;
  let r = t[e].shaperInfo.syllable;
  for (; ++e < t.length && t[e].shaperInfo.syllable === r; ) ;
  return e;
}
function T2(t) {
  return t.shaperInfo.category === "H" && !t.isLigated;
}
function n8(t) {
  return t.category === "B" || t.category === "GB";
}
const GW = {
  arab: Fl,
  mong: Fl,
  syrc: Fl,
  "nko ": Fl,
  phag: Fl,
  mand: Fl,
  mani: Fl,
  phlp: Fl,
  hang: VE,
  bng2: Pr,
  beng: Pr,
  dev2: Pr,
  deva: Pr,
  gjr2: Pr,
  gujr: Pr,
  guru: Pr,
  gur2: Pr,
  knda: Pr,
  knd2: Pr,
  mlm2: Pr,
  mlym: Pr,
  ory2: Pr,
  orya: Pr,
  taml: Pr,
  tml2: Pr,
  telu: Pr,
  tel2: Pr,
  khmr: Pr,
  bali: Yt,
  batk: Yt,
  brah: Yt,
  bugi: Yt,
  buhd: Yt,
  cakm: Yt,
  cham: Yt,
  dupl: Yt,
  egyp: Yt,
  gran: Yt,
  hano: Yt,
  java: Yt,
  kthi: Yt,
  kali: Yt,
  khar: Yt,
  khoj: Yt,
  sind: Yt,
  lepc: Yt,
  limb: Yt,
  mahj: Yt,
  // mand: UniversalShaper, // Mandaic
  // mani: UniversalShaper, // Manichaean
  mtei: Yt,
  modi: Yt,
  // mong: UniversalShaper, // Mongolian
  // 'nko ': UniversalShaper, // N’Ko
  hmng: Yt,
  // phag: UniversalShaper, // Phags-pa
  // phlp: UniversalShaper, // Psalter Pahlavi
  rjng: Yt,
  saur: Yt,
  shrd: Yt,
  sidd: Yt,
  sinh: Pr,
  sund: Yt,
  sylo: Yt,
  tglg: Yt,
  tagb: Yt,
  tale: Yt,
  lana: Yt,
  tavt: Yt,
  takr: Yt,
  tibt: Yt,
  tfng: Yt,
  tirh: Yt,
  latn: su,
  DFLT: su
};
function ZW(t) {
  Array.isArray(t) || (t = [
    t
  ]);
  for (let e of t) {
    let r = GW[e];
    if (r) return r;
  }
  return su;
}
class XW extends j5 {
  applyLookup(e, r) {
    switch (e) {
      case 1: {
        let i = this.coverageIndex(r.coverage);
        if (i === -1) return !1;
        let a = this.glyphIterator.cur;
        switch (r.version) {
          case 1:
            a.id = a.id + r.deltaGlyphID & 65535;
            break;
          case 2:
            a.id = r.substitute.get(i);
            break;
        }
        return !0;
      }
      case 2: {
        let i = this.coverageIndex(r.coverage);
        if (i !== -1) {
          let a = r.sequences.get(i);
          if (a.length === 0)
            return this.glyphs.splice(this.glyphIterator.index, 1), !0;
          this.glyphIterator.cur.id = a[0], this.glyphIterator.cur.ligatureComponent = 0;
          let o = this.glyphIterator.cur.features, s = this.glyphIterator.cur, l = a.slice(1).map((u, d) => {
            let h = new oo(this.font, u, void 0, o);
            return h.shaperInfo = s.shaperInfo, h.isLigated = s.isLigated, h.ligatureComponent = d + 1, h.substituted = !0, h.isMultiplied = !0, h;
          });
          return this.glyphs.splice(this.glyphIterator.index + 1, 0, ...l), !0;
        }
        return !1;
      }
      case 3: {
        let i = this.coverageIndex(r.coverage);
        if (i !== -1) {
          let a = 0;
          return this.glyphIterator.cur.id = r.alternateSet.get(i)[a], !0;
        }
        return !1;
      }
      case 4: {
        let i = this.coverageIndex(r.coverage);
        if (i === -1) return !1;
        for (let a of r.ligatureSets.get(i)) {
          let o = this.sequenceMatchIndices(1, a.components);
          if (!o) continue;
          let s = this.glyphIterator.cur, l = s.codePoints.slice();
          for (let A of o) l.push(...this.glyphs[A].codePoints);
          let u = new oo(this.font, a.glyph, l, s.features);
          u.shaperInfo = s.shaperInfo, u.isLigated = !0, u.substituted = !0;
          let d = s.isMark;
          for (let A = 0; A < o.length && d; A++) d = this.glyphs[o[A]].isMark;
          u.ligatureID = d ? null : this.ligatureID++;
          let h = s.ligatureID, v = s.codePoints.length, b = v, x = this.glyphIterator.index + 1;
          for (let A of o) {
            if (d) x = A;
            else for (; x < A; ) {
              var n = b - v + Math.min(this.glyphs[x].ligatureComponent || 1, v);
              this.glyphs[x].ligatureID = u.ligatureID, this.glyphs[x].ligatureComponent = n, x++;
            }
            h = this.glyphs[x].ligatureID, v = this.glyphs[x].codePoints.length, b += v, x++;
          }
          if (h && !d) for (let A = x; A < this.glyphs.length && this.glyphs[A].ligatureID === h; A++) {
            var n = b - v + Math.min(this.glyphs[A].ligatureComponent || 1, v);
            this.glyphs[A].ligatureComponent = n;
          }
          for (let A = o.length - 1; A >= 0; A--) this.glyphs.splice(o[A], 1);
          return this.glyphs[this.glyphIterator.index] = u, !0;
        }
        return !1;
      }
      case 5:
        return this.applyContext(r);
      case 6:
        return this.applyChainingContext(r);
      case 7:
        return this.applyLookup(r.lookupType, r.extension);
      default:
        throw new Error(`GSUB lookupType ${e} is not supported`);
    }
  }
}
class KW extends j5 {
  applyPositionValue(e, r) {
    let n = this.positions[this.glyphIterator.peekIndex(e)];
    r.xAdvance != null && (n.xAdvance += r.xAdvance), r.yAdvance != null && (n.yAdvance += r.yAdvance), r.xPlacement != null && (n.xOffset += r.xPlacement), r.yPlacement != null && (n.yOffset += r.yPlacement);
    let i = this.font._variationProcessor, a = this.font.GDEF && this.font.GDEF.itemVariationStore;
    i && a && (r.xPlaDevice && (n.xOffset += i.getDelta(a, r.xPlaDevice.a, r.xPlaDevice.b)), r.yPlaDevice && (n.yOffset += i.getDelta(a, r.yPlaDevice.a, r.yPlaDevice.b)), r.xAdvDevice && (n.xAdvance += i.getDelta(a, r.xAdvDevice.a, r.xAdvDevice.b)), r.yAdvDevice && (n.yAdvance += i.getDelta(a, r.yAdvDevice.a, r.yAdvDevice.b)));
  }
  applyLookup(e, r) {
    switch (e) {
      case 1: {
        let i = this.coverageIndex(r.coverage);
        if (i === -1) return !1;
        switch (r.version) {
          case 1:
            this.applyPositionValue(0, r.value);
            break;
          case 2:
            this.applyPositionValue(0, r.values.get(i));
            break;
        }
        return !0;
      }
      case 2: {
        let i = this.glyphIterator.peek();
        if (!i) return !1;
        let a = this.coverageIndex(r.coverage);
        if (a === -1) return !1;
        switch (r.version) {
          case 1:
            let o = r.pairSets.get(a);
            for (let u of o) if (u.secondGlyph === i.id)
              return this.applyPositionValue(0, u.value1), this.applyPositionValue(1, u.value2), !0;
            return !1;
          case 2:
            let s = this.getClassID(this.glyphIterator.cur.id, r.classDef1), l = this.getClassID(i.id, r.classDef2);
            if (s === -1 || l === -1) return !1;
            var n = r.classRecords.get(s).get(l);
            return this.applyPositionValue(0, n.value1), this.applyPositionValue(1, n.value2), !0;
        }
      }
      case 3: {
        let i = this.glyphIterator.peekIndex(), a = this.glyphs[i];
        if (!a) return !1;
        let o = r.entryExitRecords[this.coverageIndex(r.coverage)];
        if (!o || !o.exitAnchor) return !1;
        let s = r.entryExitRecords[this.coverageIndex(r.coverage, a.id)];
        if (!s || !s.entryAnchor) return !1;
        let l = this.getAnchor(s.entryAnchor), u = this.getAnchor(o.exitAnchor), d = this.positions[this.glyphIterator.index], h = this.positions[i], v;
        switch (this.direction) {
          case "ltr":
            d.xAdvance = u.x + d.xOffset, v = l.x + h.xOffset, h.xAdvance -= v, h.xOffset -= v;
            break;
          case "rtl":
            v = u.x + d.xOffset, d.xAdvance -= v, d.xOffset -= v, h.xAdvance = l.x + h.xOffset;
            break;
        }
        return this.glyphIterator.flags.rightToLeft ? (this.glyphIterator.cur.cursiveAttachment = i, d.yOffset = l.y - u.y) : (a.cursiveAttachment = this.glyphIterator.index, d.yOffset = u.y - l.y), !0;
      }
      case 4: {
        let i = this.coverageIndex(r.markCoverage);
        if (i === -1) return !1;
        let a = this.glyphIterator.index;
        for (; --a >= 0 && (this.glyphs[a].isMark || this.glyphs[a].ligatureComponent > 0); ) ;
        if (a < 0) return !1;
        let o = this.coverageIndex(r.baseCoverage, this.glyphs[a].id);
        if (o === -1) return !1;
        let s = r.markArray[i], l = r.baseArray[o][s.class];
        return this.applyAnchor(s, l, a), !0;
      }
      case 5: {
        let i = this.coverageIndex(r.markCoverage);
        if (i === -1) return !1;
        let a = this.glyphIterator.index;
        for (; --a >= 0 && this.glyphs[a].isMark; ) ;
        if (a < 0) return !1;
        let o = this.coverageIndex(r.ligatureCoverage, this.glyphs[a].id);
        if (o === -1) return !1;
        let s = r.ligatureArray[o], l = this.glyphIterator.cur, u = this.glyphs[a], d = u.ligatureID && u.ligatureID === l.ligatureID && l.ligatureComponent > 0 ? Math.min(l.ligatureComponent, u.codePoints.length) - 1 : u.codePoints.length - 1, h = r.markArray[i], v = s[d][h.class];
        return this.applyAnchor(h, v, a), !0;
      }
      case 6: {
        let i = this.coverageIndex(r.mark1Coverage);
        if (i === -1) return !1;
        let a = this.glyphIterator.peekIndex(-1), o = this.glyphs[a];
        if (!o || !o.isMark) return !1;
        let s = this.glyphIterator.cur, l = !1;
        if (s.ligatureID === o.ligatureID ? s.ligatureID ? s.ligatureComponent === o.ligatureComponent && (l = !0) : l = !0 : (s.ligatureID && !s.ligatureComponent || o.ligatureID && !o.ligatureComponent) && (l = !0), !l) return !1;
        let u = this.coverageIndex(r.mark2Coverage, o.id);
        if (u === -1) return !1;
        let d = r.mark1Array[i], h = r.mark2Array[u][d.class];
        return this.applyAnchor(d, h, a), !0;
      }
      case 7:
        return this.applyContext(r);
      case 8:
        return this.applyChainingContext(r);
      case 9:
        return this.applyLookup(r.lookupType, r.extension);
      default:
        throw new Error(`Unsupported GPOS table: ${e}`);
    }
  }
  applyAnchor(e, r, n) {
    let i = this.getAnchor(r), a = this.getAnchor(e.markAnchor);
    this.positions[n];
    let o = this.positions[this.glyphIterator.index];
    o.xOffset = i.x - a.x, o.yOffset = i.y - a.y, this.glyphIterator.cur.markAttachment = n;
  }
  getAnchor(e) {
    let r = e.xCoordinate, n = e.yCoordinate, i = this.font._variationProcessor, a = this.font.GDEF && this.font.GDEF.itemVariationStore;
    return i && a && (e.xDeviceTable && (r += i.getDelta(a, e.xDeviceTable.a, e.xDeviceTable.b)), e.yDeviceTable && (n += i.getDelta(a, e.yDeviceTable.a, e.yDeviceTable.b))), {
      x: r,
      y: n
    };
  }
  applyFeatures(e, r, n) {
    super.applyFeatures(e, r, n);
    for (var i = 0; i < this.glyphs.length; i++) this.fixCursiveAttachment(i);
    this.fixMarkAttachment();
  }
  fixCursiveAttachment(e) {
    let r = this.glyphs[e];
    if (r.cursiveAttachment != null) {
      let n = r.cursiveAttachment;
      r.cursiveAttachment = null, this.fixCursiveAttachment(n), this.positions[e].yOffset += this.positions[n].yOffset;
    }
  }
  fixMarkAttachment() {
    for (let e = 0; e < this.glyphs.length; e++) {
      let r = this.glyphs[e];
      if (r.markAttachment != null) {
        let n = r.markAttachment;
        if (this.positions[e].xOffset += this.positions[n].xOffset, this.positions[e].yOffset += this.positions[n].yOffset, this.direction === "ltr") for (let i = n; i < e; i++)
          this.positions[e].xOffset -= this.positions[i].xAdvance, this.positions[e].yOffset -= this.positions[i].yAdvance;
        else for (let i = n + 1; i < e + 1; i++)
          this.positions[e].xOffset += this.positions[i].xAdvance, this.positions[e].yOffset += this.positions[i].yAdvance;
      }
    }
  }
}
class JW {
  setup(e) {
    this.glyphInfos = e.glyphs.map((n) => new oo(this.font, n.id, [
      ...n.codePoints
    ]));
    let r = null;
    this.GPOSProcessor && (r = this.GPOSProcessor.selectScript(e.script, e.language, e.direction)), this.GSUBProcessor && (r = this.GSUBProcessor.selectScript(e.script, e.language, e.direction)), this.shaper = ZW(r), this.plan = new Jj(this.font, r, e.direction), this.shaper.plan(this.plan, this.glyphInfos, e.features);
    for (let n in this.plan.allFeatures) e.features[n] = !0;
  }
  substitute(e) {
    this.GSUBProcessor && (this.plan.process(this.GSUBProcessor, this.glyphInfos), e.glyphs = this.glyphInfos.map((r) => this.font.getGlyph(r.id, r.codePoints)));
  }
  position(e) {
    return this.shaper.zeroMarkWidths === "BEFORE_GPOS" && this.zeroMarkAdvances(e.positions), this.GPOSProcessor && this.plan.process(this.GPOSProcessor, this.glyphInfos, e.positions), this.shaper.zeroMarkWidths === "AFTER_GPOS" && this.zeroMarkAdvances(e.positions), e.direction === "rtl" && (e.glyphs.reverse(), e.positions.reverse()), this.GPOSProcessor && this.GPOSProcessor.features;
  }
  zeroMarkAdvances(e) {
    for (let r = 0; r < this.glyphInfos.length; r++) this.glyphInfos[r].isMark && (e[r].xAdvance = 0, e[r].yAdvance = 0);
  }
  cleanup() {
    this.glyphInfos = null, this.plan = null, this.shaper = null;
  }
  getAvailableFeatures(e, r) {
    let n = [];
    return this.GSUBProcessor && (this.GSUBProcessor.selectScript(e, r), n.push(...Object.keys(this.GSUBProcessor.features))), this.GPOSProcessor && (this.GPOSProcessor.selectScript(e, r), n.push(...Object.keys(this.GPOSProcessor.features))), n;
  }
  constructor(e) {
    this.font = e, this.glyphInfos = null, this.plan = null, this.GSUBProcessor = null, this.GPOSProcessor = null, this.fallbackPosition = !0, e.GSUB && (this.GSUBProcessor = new XW(e, e.GSUB)), e.GPOS && (this.GPOSProcessor = new KW(e, e.GPOS));
  }
}
class QW {
  layout(e, r, n, i, a) {
    if (typeof r == "string" && (a = i, i = n, n = r, r = []), typeof e == "string") {
      n == null && (n = Tj(e));
      var o = this.font.glyphsForString(e);
    } else {
      if (n == null) {
        let u = [];
        for (let d of e) u.push(...d.codePoints);
        n = Fj(u);
      }
      var o = e;
    }
    let s = new Oj(o, r, n, i, a);
    return o.length === 0 ? (s.positions = [], s) : (this.engine && this.engine.setup && this.engine.setup(s), this.substitute(s), this.position(s), this.hideDefaultIgnorables(s.glyphs, s.positions), this.engine && this.engine.cleanup && this.engine.cleanup(), s);
  }
  substitute(e) {
    this.engine && this.engine.substitute && this.engine.substitute(e);
  }
  position(e) {
    e.positions = e.glyphs.map((n) => new Rj(n.advanceWidth));
    let r = null;
    this.engine && this.engine.position && (r = this.engine.position(e)), !r && (!this.engine || this.engine.fallbackPosition) && (this.unicodeLayoutEngine || (this.unicodeLayoutEngine = new Cj(this.font)), this.unicodeLayoutEngine.positionGlyphs(e.glyphs, e.positions)), (!r || !r.kern) && e.features.kern !== !1 && this.font.kern && (this.kernProcessor || (this.kernProcessor = new Sj(this.font)), this.kernProcessor.process(e.glyphs, e.positions), e.features.kern = !0);
  }
  hideDefaultIgnorables(e, r) {
    let n = this.font.glyphForCodePoint(32);
    for (let i = 0; i < e.length; i++) this.isDefaultIgnorable(e[i].codePoints[0]) && (e[i] = n, r[i].xAdvance = 0, r[i].yAdvance = 0);
  }
  isDefaultIgnorable(e) {
    let r = e >> 16;
    if (r === 0)
      switch (e >> 8) {
        case 0:
          return e === 173;
        case 3:
          return e === 847;
        case 6:
          return e === 1564;
        case 23:
          return 6068 <= e && e <= 6069;
        case 24:
          return 6155 <= e && e <= 6158;
        case 32:
          return 8203 <= e && e <= 8207 || 8234 <= e && e <= 8238 || 8288 <= e && e <= 8303;
        case 254:
          return 65024 <= e && e <= 65039 || e === 65279;
        case 255:
          return 65520 <= e && e <= 65528;
        default:
          return !1;
      }
    else
      switch (r) {
        case 1:
          return 113824 <= e && e <= 113827 || 119155 <= e && e <= 119162;
        case 14:
          return 917504 <= e && e <= 921599;
        default:
          return !1;
      }
  }
  getAvailableFeatures(e, r) {
    let n = [];
    return this.engine && n.push(...this.engine.getAvailableFeatures(e, r)), this.font.kern && n.indexOf("kern") === -1 && n.push("kern"), n;
  }
  stringsForGlyph(e) {
    let r = /* @__PURE__ */ new Set(), n = this.font._cmapProcessor.codePointsForGlyph(e);
    for (let i of n) r.add(String.fromCodePoint(i));
    if (this.engine && this.engine.stringsForGlyph) for (let i of this.engine.stringsForGlyph(e)) r.add(i);
    return Array.from(r);
  }
  constructor(e) {
    this.font = e, this.unicodeLayoutEngine = null, this.kernProcessor = null, this.font.morx ? this.engine = new Kj(this.font) : (this.font.GSUB || this.font.GPOS) && (this.engine = new JW(this.font));
  }
}
const eH = {
  moveTo: "M",
  lineTo: "L",
  quadraticCurveTo: "Q",
  bezierCurveTo: "C",
  closePath: "Z"
};
class _1 {
  /**
  * Compiles the path to a JavaScript function that can be applied with
  * a graphics context in order to render the path.
  * @return {string}
  */
  toFunction() {
    return (e) => {
      this.commands.forEach((r) => e[r.command].apply(e, r.args));
    };
  }
  /**
  * Converts the path to an SVG path data string
  * @return {string}
  */
  toSVG() {
    return this.commands.map((r) => {
      let n = r.args.map((i) => Math.round(i * 100) / 100);
      return `${eH[r.command]}${n.join(" ")}`;
    }).join("");
  }
  /**
  * Gets the "control box" of a path.
  * This is like the bounding box, but it includes all points including
  * control points of bezier segments and is much faster to compute than
  * the real bounding box.
  * @type {BBox}
  */
  get cbox() {
    if (!this._cbox) {
      let e = new ou();
      for (let r of this.commands) for (let n = 0; n < r.args.length; n += 2) e.addPoint(r.args[n], r.args[n + 1]);
      this._cbox = Object.freeze(e);
    }
    return this._cbox;
  }
  /**
  * Gets the exact bounding box of the path by evaluating curve segments.
  * Slower to compute than the control box, but more accurate.
  * @type {BBox}
  */
  get bbox() {
    if (this._bbox) return this._bbox;
    let e = new ou(), r = 0, n = 0, i = (E) => Math.pow(1 - E, 3) * b[k] + 3 * Math.pow(1 - E, 2) * E * x[k] + 3 * (1 - E) * Math.pow(E, 2) * A[k] + Math.pow(E, 3) * T[k];
    for (let E of this.commands) switch (E.command) {
      case "moveTo":
      case "lineTo":
        let [C, D] = E.args;
        e.addPoint(C, D), r = C, n = D;
        break;
      case "quadraticCurveTo":
      case "bezierCurveTo":
        if (E.command === "quadraticCurveTo")
          var [a, o, h, v] = E.args, s = r + 2 / 3 * (a - r), l = n + 2 / 3 * (o - n), u = h + 2 / 3 * (a - h), d = v + 2 / 3 * (o - v);
        else var [s, l, u, d, h, v] = E.args;
        e.addPoint(h, v);
        for (var b = [
          r,
          n
        ], x = [
          s,
          l
        ], A = [
          u,
          d
        ], T = [
          h,
          v
        ], k = 0; k <= 1; k++) {
          let _ = 6 * b[k] - 12 * x[k] + 6 * A[k], I = -3 * b[k] + 9 * x[k] - 9 * A[k] + 3 * T[k];
          if (E = 3 * x[k] - 3 * b[k], I === 0) {
            if (_ === 0) continue;
            let z = -E / _;
            0 < z && z < 1 && (k === 0 ? e.addPoint(i(z), e.maxY) : k === 1 && e.addPoint(e.maxX, i(z)));
            continue;
          }
          let R = Math.pow(_, 2) - 4 * E * I;
          if (R < 0) continue;
          let U = (-_ + Math.sqrt(R)) / (2 * I);
          0 < U && U < 1 && (k === 0 ? e.addPoint(i(U), e.maxY) : k === 1 && e.addPoint(e.maxX, i(U)));
          let V = (-_ - Math.sqrt(R)) / (2 * I);
          0 < V && V < 1 && (k === 0 ? e.addPoint(i(V), e.maxY) : k === 1 && e.addPoint(e.maxX, i(V)));
        }
        r = h, n = v;
        break;
    }
    return this._bbox = Object.freeze(e);
  }
  /**
  * Applies a mapping function to each point in the path.
  * @param {function} fn
  * @return {Path}
  */
  mapPoints(e) {
    let r = new _1();
    for (let n of this.commands) {
      let i = [];
      for (let a = 0; a < n.args.length; a += 2) {
        let [o, s] = e(n.args[a], n.args[a + 1]);
        i.push(o, s);
      }
      r[n.command](...i);
    }
    return r;
  }
  /**
  * Transforms the path by the given matrix.
  */
  transform(e, r, n, i, a, o) {
    return this.mapPoints((s, l) => {
      const u = e * s + n * l + a, d = r * s + i * l + o;
      return [
        u,
        d
      ];
    });
  }
  /**
  * Translates the path by the given offset.
  */
  translate(e, r) {
    return this.transform(1, 0, 0, 1, e, r);
  }
  /**
  * Rotates the path by the given angle (in radians).
  */
  rotate(e) {
    let r = Math.cos(e), n = Math.sin(e);
    return this.transform(r, n, -n, r, 0, 0);
  }
  /**
  * Scales the path.
  */
  scale(e, r = e) {
    return this.transform(e, 0, 0, r, 0, 0);
  }
  constructor() {
    this.commands = [], this._bbox = null, this._cbox = null;
  }
}
for (let t of [
  "moveTo",
  "lineTo",
  "quadraticCurveTo",
  "bezierCurveTo",
  "closePath"
]) _1.prototype[t] = function(...e) {
  return this._bbox = this._cbox = null, this.commands.push({
    command: t,
    args: e
  }), this;
};
var Ed = [
  ".notdef",
  ".null",
  "nonmarkingreturn",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quotesingle",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "grave",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "Adieresis",
  "Aring",
  "Ccedilla",
  "Eacute",
  "Ntilde",
  "Odieresis",
  "Udieresis",
  "aacute",
  "agrave",
  "acircumflex",
  "adieresis",
  "atilde",
  "aring",
  "ccedilla",
  "eacute",
  "egrave",
  "ecircumflex",
  "edieresis",
  "iacute",
  "igrave",
  "icircumflex",
  "idieresis",
  "ntilde",
  "oacute",
  "ograve",
  "ocircumflex",
  "odieresis",
  "otilde",
  "uacute",
  "ugrave",
  "ucircumflex",
  "udieresis",
  "dagger",
  "degree",
  "cent",
  "sterling",
  "section",
  "bullet",
  "paragraph",
  "germandbls",
  "registered",
  "copyright",
  "trademark",
  "acute",
  "dieresis",
  "notequal",
  "AE",
  "Oslash",
  "infinity",
  "plusminus",
  "lessequal",
  "greaterequal",
  "yen",
  "mu",
  "partialdiff",
  "summation",
  "product",
  "pi",
  "integral",
  "ordfeminine",
  "ordmasculine",
  "Omega",
  "ae",
  "oslash",
  "questiondown",
  "exclamdown",
  "logicalnot",
  "radical",
  "florin",
  "approxequal",
  "Delta",
  "guillemotleft",
  "guillemotright",
  "ellipsis",
  "nonbreakingspace",
  "Agrave",
  "Atilde",
  "Otilde",
  "OE",
  "oe",
  "endash",
  "emdash",
  "quotedblleft",
  "quotedblright",
  "quoteleft",
  "quoteright",
  "divide",
  "lozenge",
  "ydieresis",
  "Ydieresis",
  "fraction",
  "currency",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "daggerdbl",
  "periodcentered",
  "quotesinglbase",
  "quotedblbase",
  "perthousand",
  "Acircumflex",
  "Ecircumflex",
  "Aacute",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Oacute",
  "Ocircumflex",
  "apple",
  "Ograve",
  "Uacute",
  "Ucircumflex",
  "Ugrave",
  "dotlessi",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "Lslash",
  "lslash",
  "Scaron",
  "scaron",
  "Zcaron",
  "zcaron",
  "brokenbar",
  "Eth",
  "eth",
  "Yacute",
  "yacute",
  "Thorn",
  "thorn",
  "minus",
  "multiply",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "onehalf",
  "onequarter",
  "threequarters",
  "franc",
  "Gbreve",
  "gbreve",
  "Idotaccent",
  "Scedilla",
  "scedilla",
  "Cacute",
  "cacute",
  "Ccaron",
  "ccaron",
  "dcroat"
];
class ss {
  _getPath() {
    return new _1();
  }
  _getCBox() {
    return this.path.cbox;
  }
  _getBBox() {
    return this.path.bbox;
  }
  _getTableMetrics(e) {
    if (this.id < e.metrics.length) return e.metrics.get(this.id);
    let r = e.metrics.get(e.metrics.length - 1);
    return {
      advance: r ? r.advance : 0,
      bearing: e.bearings.get(this.id - e.metrics.length) || 0
    };
  }
  _getMetrics(e) {
    if (this._metrics) return this._metrics;
    let { advance: r, bearing: n } = this._getTableMetrics(this._font.hmtx);
    if (this._font.vmtx) var { advance: i, bearing: a } = this._getTableMetrics(this._font.vmtx);
    else {
      let o;
      if ((typeof e > "u" || e === null) && ({ cbox: e } = this), (o = this._font["OS/2"]) && o.version > 0)
        var i = Math.abs(o.typoAscender - o.typoDescender), a = o.typoAscender - e.maxY;
      else {
        let { hhea: s } = this._font;
        var i = Math.abs(s.ascent - s.descent), a = s.ascent - e.maxY;
      }
    }
    return this._font._variationProcessor && this._font.HVAR && (r += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR)), this._metrics = {
      advanceWidth: r,
      advanceHeight: i,
      leftBearing: n,
      topBearing: a
    };
  }
  /**
  * The glyph’s control box.
  * This is often the same as the bounding box, but is faster to compute.
  * Because of the way bezier curves are defined, some of the control points
  * can be outside of the bounding box. Where `bbox` takes this into account,
  * `cbox` does not. Thus, cbox is less accurate, but faster to compute.
  * See [here](http://www.freetype.org/freetype2/docs/glyphs/glyphs-6.html#section-2)
  * for a more detailed description.
  *
  * @type {BBox}
  */
  get cbox() {
    return this._getCBox();
  }
  /**
  * The glyph’s bounding box, i.e. the rectangle that encloses the
  * glyph outline as tightly as possible.
  * @type {BBox}
  */
  get bbox() {
    return this._getBBox();
  }
  /**
  * A vector Path object representing the glyph outline.
  * @type {Path}
  */
  get path() {
    return this._getPath();
  }
  /**
  * Returns a path scaled to the given font size.
  * @param {number} size
  * @return {Path}
  */
  getScaledPath(e) {
    let r = 1 / this._font.unitsPerEm * e;
    return this.path.scale(r);
  }
  /**
  * The glyph's advance width.
  * @type {number}
  */
  get advanceWidth() {
    return this._getMetrics().advanceWidth;
  }
  /**
  * The glyph's advance height.
  * @type {number}
  */
  get advanceHeight() {
    return this._getMetrics().advanceHeight;
  }
  get ligatureCaretPositions() {
  }
  _getName() {
    let { post: e } = this._font;
    if (!e) return null;
    switch (e.version) {
      case 1:
        return Ed[this.id];
      case 2:
        let r = e.glyphNameIndex[this.id];
        return r < Ed.length ? Ed[r] : e.names[r - Ed.length];
      case 2.5:
        return Ed[this.id + e.offsets[this.id]];
      case 4:
        return String.fromCharCode(e.map[this.id]);
    }
  }
  /**
  * The glyph's name
  * @type {string}
  */
  get name() {
    return this._getName();
  }
  /**
  * Renders the glyph to the given graphics context, at the specified font size.
  * @param {CanvasRenderingContext2d} ctx
  * @param {number} size
  */
  render(e, r) {
    e.save();
    let n = 1 / this._font.head.unitsPerEm * r;
    e.scale(n, n), this.path.toFunction()(e), e.fill(), e.restore();
  }
  constructor(e, r, n) {
    this.id = e, this.codePoints = r, this._font = n, this.isMark = this.codePoints.length > 0 && this.codePoints.every(cE), this.isLigature = this.codePoints.length > 1;
  }
}
Pn([
  In
], ss.prototype, "cbox", null);
Pn([
  In
], ss.prototype, "bbox", null);
Pn([
  In
], ss.prototype, "path", null);
Pn([
  In
], ss.prototype, "advanceWidth", null);
Pn([
  In
], ss.prototype, "advanceHeight", null);
Pn([
  In
], ss.prototype, "name", null);
let i8 = new xe({
  numberOfContours: Be,
  xMin: Be,
  yMin: Be,
  xMax: Be,
  yMax: Be
});
const tH = 1, rH = 2, nH = 4, iH = 8, aH = 16, oH = 32, sH = 1, lH = 8, a8 = 32, uH = 64, cH = 128, fH = 256;
class Ga {
  copy() {
    return new Ga(this.onCurve, this.endContour, this.x, this.y);
  }
  constructor(e, r, n = 0, i = 0) {
    this.onCurve = e, this.endContour = r, this.x = n, this.y = i;
  }
}
class dH {
  constructor(e, r, n) {
    this.glyphID = e, this.dx = r, this.dy = n, this.pos = 0, this.scaleX = this.scaleY = 1, this.scale01 = this.scale10 = 0;
  }
}
class Gp extends ss {
  // Parses just the glyph header and returns the bounding box
  _getCBox(e) {
    if (this._font._variationProcessor && !e) return this.path.cbox;
    let r = this._font._getTableStream("glyf");
    r.pos += this._font.loca.offsets[this.id];
    let n = i8.decode(r), i = new ou(n.xMin, n.yMin, n.xMax, n.yMax);
    return Object.freeze(i);
  }
  // Parses a single glyph coordinate
  _parseGlyphCoord(e, r, n, i) {
    if (n) {
      var a = e.readUInt8();
      i || (a = -a), a += r;
    } else if (i) var a = r;
    else var a = r + e.readInt16BE();
    return a;
  }
  // Decodes the glyph data into points for simple glyphs,
  // or components for composite glyphs
  _decode() {
    let e = this._font.loca.offsets[this.id], r = this._font.loca.offsets[this.id + 1];
    if (e === r) return null;
    let n = this._font._getTableStream("glyf");
    n.pos += e;
    let i = n.pos, a = i8.decode(n);
    return a.numberOfContours > 0 ? this._decodeSimple(a, n) : a.numberOfContours < 0 && this._decodeComposite(a, n, i), a;
  }
  _decodeSimple(e, r) {
    e.points = [];
    let n = new ue(F, e.numberOfContours).decode(r);
    e.instructions = new ue(ze, F).decode(r);
    let i = [], a = n[n.length - 1] + 1;
    for (; i.length < a; ) {
      var o = r.readUInt8();
      if (i.push(o), o & iH) {
        let d = r.readUInt8();
        for (let h = 0; h < d; h++) i.push(o);
      }
    }
    for (var s = 0; s < i.length; s++) {
      var o = i[s];
      let h = new Ga(!!(o & tH), n.indexOf(s) >= 0, 0, 0);
      e.points.push(h);
    }
    let l = 0;
    for (var s = 0; s < i.length; s++) {
      var o = i[s];
      e.points[s].x = l = this._parseGlyphCoord(r, l, o & rH, o & aH);
    }
    let u = 0;
    for (var s = 0; s < i.length; s++) {
      var o = i[s];
      e.points[s].y = u = this._parseGlyphCoord(r, u, o & nH, o & oH);
    }
    if (this._font._variationProcessor) {
      let d = e.points.slice();
      d.push(...this._getPhantomPoints(e)), this._font._variationProcessor.transformPoints(this.id, d), e.phantomPoints = d.slice(-4);
    }
  }
  _decodeComposite(e, r, n = 0) {
    e.components = [];
    let i = !1, a = a8;
    for (; a & a8; ) {
      a = r.readUInt16BE();
      let u = r.pos - n, d = r.readUInt16BE();
      if (i || (i = (a & fH) !== 0), a & sH)
        var o = r.readInt16BE(), s = r.readInt16BE();
      else
        var o = r.readInt8(), s = r.readInt8();
      var l = new dH(d, o, s);
      l.pos = u, a & lH ? l.scaleX = l.scaleY = (r.readUInt8() << 24 | r.readUInt8() << 16) / 1073741824 : a & uH ? (l.scaleX = (r.readUInt8() << 24 | r.readUInt8() << 16) / 1073741824, l.scaleY = (r.readUInt8() << 24 | r.readUInt8() << 16) / 1073741824) : a & cH && (l.scaleX = (r.readUInt8() << 24 | r.readUInt8() << 16) / 1073741824, l.scale01 = (r.readUInt8() << 24 | r.readUInt8() << 16) / 1073741824, l.scale10 = (r.readUInt8() << 24 | r.readUInt8() << 16) / 1073741824, l.scaleY = (r.readUInt8() << 24 | r.readUInt8() << 16) / 1073741824), e.components.push(l);
    }
    if (this._font._variationProcessor) {
      let u = [];
      for (let d = 0; d < e.components.length; d++) {
        var l = e.components[d];
        u.push(new Ga(!0, !0, l.dx, l.dy));
      }
      u.push(...this._getPhantomPoints(e)), this._font._variationProcessor.transformPoints(this.id, u), e.phantomPoints = u.splice(-4, 4);
      for (let d = 0; d < u.length; d++) {
        let h = u[d];
        e.components[d].dx = h.x, e.components[d].dy = h.y;
      }
    }
    return i;
  }
  _getPhantomPoints(e) {
    let r = this._getCBox(!0);
    this._metrics == null && (this._metrics = ss.prototype._getMetrics.call(this, r));
    let { advanceWidth: n, advanceHeight: i, leftBearing: a, topBearing: o } = this._metrics;
    return [
      new Ga(!1, !0, e.xMin - a, 0),
      new Ga(!1, !0, e.xMin - a + n, 0),
      new Ga(!1, !0, 0, e.yMax + o),
      new Ga(!1, !0, 0, e.yMax + o + i)
    ];
  }
  // Decodes font data, resolves composite glyphs, and returns an array of contours
  _getContours() {
    let e = this._decode();
    if (!e) return [];
    let r = [];
    if (e.numberOfContours < 0)
      for (let o of e.components) {
        let s = this._font.getGlyph(o.glyphID)._getContours();
        for (let l = 0; l < s.length; l++) {
          let u = s[l];
          for (let d = 0; d < u.length; d++) {
            let h = u[d], v = h.x * o.scaleX + h.y * o.scale01 + o.dx, b = h.y * o.scaleY + h.x * o.scale10 + o.dy;
            r.push(new Ga(h.onCurve, h.endContour, v, b));
          }
        }
      }
    else r = e.points || [];
    e.phantomPoints && !this._font.directory.tables.HVAR && (this._metrics.advanceWidth = e.phantomPoints[1].x - e.phantomPoints[0].x, this._metrics.advanceHeight = e.phantomPoints[3].y - e.phantomPoints[2].y, this._metrics.leftBearing = e.xMin - e.phantomPoints[0].x, this._metrics.topBearing = e.phantomPoints[2].y - e.yMax);
    let n = [], i = [];
    for (let o = 0; o < r.length; o++) {
      var a = r[o];
      i.push(a), a.endContour && (n.push(i), i = []);
    }
    return n;
  }
  _getMetrics() {
    if (this._metrics) return this._metrics;
    let e = this._getCBox(!0);
    return super._getMetrics(e), this._font._variationProcessor && !this._font.HVAR && this.path, this._metrics;
  }
  // Converts contours to a Path object that can be rendered
  _getPath() {
    let e = this._getContours(), r = new _1();
    for (let i = 0; i < e.length; i++) {
      let a = e[i], o = a[0], s = a[a.length - 1], l = 0;
      if (o.onCurve) {
        var n = null;
        l = 1;
      } else {
        s.onCurve ? o = s : o = new Ga(!1, !1, (o.x + s.x) / 2, (o.y + s.y) / 2);
        var n = o;
      }
      r.moveTo(o.x, o.y);
      for (let u = l; u < a.length; u++) {
        let d = a[u], h = u === 0 ? o : a[u - 1];
        if (h.onCurve && d.onCurve) r.lineTo(d.x, d.y);
        else if (h.onCurve && !d.onCurve) var n = d;
        else if (!h.onCurve && !d.onCurve) {
          let b = (h.x + d.x) / 2, x = (h.y + d.y) / 2;
          r.quadraticCurveTo(h.x, h.y, b, x);
          var n = d;
        } else if (!h.onCurve && d.onCurve) {
          r.quadraticCurveTo(n.x, n.y, d.x, d.y);
          var n = null;
        } else throw new Error("Unknown TTF path state");
      }
      n && r.quadraticCurveTo(n.x, n.y, o.x, o.y), r.closePath();
    }
    return r;
  }
  constructor(...e) {
    super(...e), Fi(this, "type", "TTF");
  }
}
class hH extends ss {
  _getName() {
    return this._font.CFF2 ? super._getName() : this._font["CFF "].getGlyphName(this.id);
  }
  bias(e) {
    return e.length < 1240 ? 107 : e.length < 33900 ? 1131 : 32768;
  }
  _getPath() {
    let e = this._font.CFF2 || this._font["CFF "], { stream: r } = e, n = e.topDict.CharStrings[this.id], i = n.offset + n.length;
    r.pos = n.offset;
    let a = new _1(), o = [], s = [], l = null, u = 0, d = 0, h = 0, v, b, x = !1;
    this._usedGsubrs = v = {}, this._usedSubrs = b = {};
    let A = e.globalSubrIndex || [], T = this.bias(A), k = e.privateDictForGlyph(this.id) || {}, E = k.Subrs || [], C = this.bias(E), D = e.topDict.vstore && e.topDict.vstore.itemVariationStore, _ = k.vsindex, I = this._font._variationProcessor;
    function R() {
      l == null && (l = o.shift() + k.nominalWidthX);
    }
    function U() {
      return o.length % 2 !== 0 && R(), u += o.length >> 1, o.length = 0;
    }
    function V(j, S) {
      x && a.closePath(), a.moveTo(j, S), x = !0;
    }
    let z = function() {
      for (; r.pos < i; ) {
        let B = r.readUInt8();
        if (B < 32) {
          let q, Y, Z, Q, J, se, ae, te, ne, ce, pe, Me, Ne, it, fe, ye;
          switch (B) {
            case 1:
            case 3:
            case 18:
            case 23:
              U();
              break;
            case 4:
              o.length > 1 && R(), h += o.shift(), V(d, h);
              break;
            case 5:
              for (; o.length >= 2; )
                d += o.shift(), h += o.shift(), a.lineTo(d, h);
              break;
            case 6:
            case 7:
              for (Z = B === 6; o.length >= 1; )
                Z ? d += o.shift() : h += o.shift(), a.lineTo(d, h), Z = !Z;
              break;
            case 8:
              for (; o.length > 0; )
                Q = d + o.shift(), J = h + o.shift(), se = Q + o.shift(), ae = J + o.shift(), d = se + o.shift(), h = ae + o.shift(), a.bezierCurveTo(Q, J, se, ae, d, h);
              break;
            case 10:
              if (q = o.pop() + C, Y = E[q], Y) {
                b[q] = !0;
                let be = r.pos, he = i;
                r.pos = Y.offset, i = Y.offset + Y.length, z(), r.pos = be, i = he;
              }
              break;
            case 11:
              if (e.version >= 2) break;
              return;
            case 14:
              if (e.version >= 2) break;
              o.length > 0 && R(), x && (a.closePath(), x = !1);
              break;
            case 15:
              if (e.version < 2) throw new Error("vsindex operator not supported in CFF v1");
              _ = o.pop();
              break;
            case 16: {
              if (e.version < 2) throw new Error("blend operator not supported in CFF v1");
              if (!I) throw new Error("blend operator in non-variation font");
              let be = I.getBlendVector(D, _), he = o.pop(), Ge = he * be.length, $e = o.length - Ge, Ve = $e - he;
              for (let Ze = 0; Ze < he; Ze++) {
                let wt = o[Ve + Ze];
                for (let et = 0; et < be.length; et++) wt += be[et] * o[$e++];
                o[Ve + Ze] = wt;
              }
              for (; Ge--; ) o.pop();
              break;
            }
            case 19:
            case 20:
              U(), r.pos += u + 7 >> 3;
              break;
            case 21:
              o.length > 2 && R(), d += o.shift(), h += o.shift(), V(d, h);
              break;
            case 22:
              o.length > 1 && R(), d += o.shift(), V(d, h);
              break;
            case 24:
              for (; o.length >= 8; )
                Q = d + o.shift(), J = h + o.shift(), se = Q + o.shift(), ae = J + o.shift(), d = se + o.shift(), h = ae + o.shift(), a.bezierCurveTo(Q, J, se, ae, d, h);
              d += o.shift(), h += o.shift(), a.lineTo(d, h);
              break;
            case 25:
              for (; o.length >= 8; )
                d += o.shift(), h += o.shift(), a.lineTo(d, h);
              Q = d + o.shift(), J = h + o.shift(), se = Q + o.shift(), ae = J + o.shift(), d = se + o.shift(), h = ae + o.shift(), a.bezierCurveTo(Q, J, se, ae, d, h);
              break;
            case 26:
              for (o.length % 2 && (d += o.shift()); o.length >= 4; )
                Q = d, J = h + o.shift(), se = Q + o.shift(), ae = J + o.shift(), d = se, h = ae + o.shift(), a.bezierCurveTo(Q, J, se, ae, d, h);
              break;
            case 27:
              for (o.length % 2 && (h += o.shift()); o.length >= 4; )
                Q = d + o.shift(), J = h, se = Q + o.shift(), ae = J + o.shift(), d = se + o.shift(), h = ae, a.bezierCurveTo(Q, J, se, ae, d, h);
              break;
            case 28:
              o.push(r.readInt16BE());
              break;
            case 29:
              if (q = o.pop() + T, Y = A[q], Y) {
                v[q] = !0;
                let be = r.pos, he = i;
                r.pos = Y.offset, i = Y.offset + Y.length, z(), r.pos = be, i = he;
              }
              break;
            case 30:
            case 31:
              for (Z = B === 31; o.length >= 4; )
                Z ? (Q = d + o.shift(), J = h, se = Q + o.shift(), ae = J + o.shift(), h = ae + o.shift(), d = se + (o.length === 1 ? o.shift() : 0)) : (Q = d, J = h + o.shift(), se = Q + o.shift(), ae = J + o.shift(), d = se + o.shift(), h = ae + (o.length === 1 ? o.shift() : 0)), a.bezierCurveTo(Q, J, se, ae, d, h), Z = !Z;
              break;
            case 12:
              switch (B = r.readUInt8(), B) {
                case 3:
                  let be = o.pop(), he = o.pop();
                  o.push(be && he ? 1 : 0);
                  break;
                case 4:
                  be = o.pop(), he = o.pop(), o.push(be || he ? 1 : 0);
                  break;
                case 5:
                  be = o.pop(), o.push(be ? 0 : 1);
                  break;
                case 9:
                  be = o.pop(), o.push(Math.abs(be));
                  break;
                case 10:
                  be = o.pop(), he = o.pop(), o.push(be + he);
                  break;
                case 11:
                  be = o.pop(), he = o.pop(), o.push(be - he);
                  break;
                case 12:
                  be = o.pop(), he = o.pop(), o.push(be / he);
                  break;
                case 14:
                  be = o.pop(), o.push(-be);
                  break;
                case 15:
                  be = o.pop(), he = o.pop(), o.push(be === he ? 1 : 0);
                  break;
                case 18:
                  o.pop();
                  break;
                case 20:
                  let Ge = o.pop(), $e = o.pop();
                  s[$e] = Ge;
                  break;
                case 21:
                  $e = o.pop(), o.push(s[$e] || 0);
                  break;
                case 22:
                  let Ve = o.pop(), Ze = o.pop(), wt = o.pop(), et = o.pop();
                  o.push(wt <= et ? Ve : Ze);
                  break;
                case 23:
                  o.push(Math.random());
                  break;
                case 24:
                  be = o.pop(), he = o.pop(), o.push(be * he);
                  break;
                case 26:
                  be = o.pop(), o.push(Math.sqrt(be));
                  break;
                case 27:
                  be = o.pop(), o.push(be, be);
                  break;
                case 28:
                  be = o.pop(), he = o.pop(), o.push(he, be);
                  break;
                case 29:
                  $e = o.pop(), $e < 0 ? $e = 0 : $e > o.length - 1 && ($e = o.length - 1), o.push(o[$e]);
                  break;
                case 30:
                  let W = o.pop(), ee = o.pop();
                  if (ee >= 0) for (; ee > 0; ) {
                    var j = o[W - 1];
                    for (let Ee = W - 2; Ee >= 0; Ee--) o[Ee + 1] = o[Ee];
                    o[0] = j, ee--;
                  }
                  else for (; ee < 0; ) {
                    var j = o[0];
                    for (let ve = 0; ve <= W; ve++) o[ve] = o[ve + 1];
                    o[W - 1] = j, ee++;
                  }
                  break;
                case 34:
                  Q = d + o.shift(), J = h, se = Q + o.shift(), ae = J + o.shift(), te = se + o.shift(), ne = ae, ce = te + o.shift(), pe = ne, Me = ce + o.shift(), Ne = pe, it = Me + o.shift(), fe = Ne, d = it, h = fe, a.bezierCurveTo(Q, J, se, ae, te, ne), a.bezierCurveTo(ce, pe, Me, Ne, it, fe);
                  break;
                case 35:
                  ye = [];
                  for (let Ee = 0; Ee <= 5; Ee++)
                    d += o.shift(), h += o.shift(), ye.push(d, h);
                  a.bezierCurveTo(...ye.slice(0, 6)), a.bezierCurveTo(...ye.slice(6)), o.shift();
                  break;
                case 36:
                  Q = d + o.shift(), J = h + o.shift(), se = Q + o.shift(), ae = J + o.shift(), te = se + o.shift(), ne = ae, ce = te + o.shift(), pe = ne, Me = ce + o.shift(), Ne = pe + o.shift(), it = Me + o.shift(), fe = Ne, d = it, h = fe, a.bezierCurveTo(Q, J, se, ae, te, ne), a.bezierCurveTo(ce, pe, Me, Ne, it, fe);
                  break;
                case 37:
                  let le = d, me = h;
                  ye = [];
                  for (let Ee = 0; Ee <= 4; Ee++)
                    d += o.shift(), h += o.shift(), ye.push(d, h);
                  Math.abs(d - le) > Math.abs(h - me) ? (d += o.shift(), h = me) : (d = le, h += o.shift()), ye.push(d, h), a.bezierCurveTo(...ye.slice(0, 6)), a.bezierCurveTo(...ye.slice(6));
                  break;
                default:
                  throw new Error(`Unknown op: 12 ${B}`);
              }
              break;
            default:
              throw new Error(`Unknown op: ${B}`);
          }
        } else if (B < 247) o.push(B - 139);
        else if (B < 251) {
          var S = r.readUInt8();
          o.push((B - 247) * 256 + S + 108);
        } else if (B < 255) {
          var S = r.readUInt8();
          o.push(-(B - 251) * 256 - S - 108);
        } else o.push(r.readInt32BE() / 65536);
      }
    };
    return z(), x && a.closePath(), a;
  }
  constructor(...e) {
    super(...e), Fi(this, "type", "CFF");
  }
}
let pH = new xe({
  originX: F,
  originY: F,
  type: new A0(4),
  data: new Fn((t) => t.parent.buflen - t._currentOffset)
});
class mH extends Gp {
  /**
  * Returns an object representing a glyph image at the given point size.
  * The object has a data property with a Buffer containing the actual image data,
  * along with the image type, and origin.
  *
  * @param {number} size
  * @return {object}
  */
  getImageForSize(e) {
    for (let o = 0; o < this._font.sbix.imageTables.length; o++) {
      var r = this._font.sbix.imageTables[o];
      if (r.ppem >= e) break;
    }
    let n = r.imageOffsets, i = n[this.id], a = n[this.id + 1];
    return i === a ? null : (this._font.stream.pos = i, pH.decode(this._font.stream, {
      buflen: a - i
    }));
  }
  render(e, r) {
    let n = this.getImageForSize(r);
    if (n != null) {
      let i = r / this._font.unitsPerEm;
      e.image(n.data, {
        height: r,
        x: n.originX,
        y: (this.bbox.minY - n.originY) * i
      });
    }
    this._font.sbix.flags.renderOutlines && super.render(e, r);
  }
  constructor(...e) {
    super(...e), Fi(this, "type", "SBIX");
  }
}
class o8 {
  constructor(e, r) {
    this.glyph = e, this.color = r;
  }
}
class gH extends ss {
  _getBBox() {
    let e = new ou();
    for (let r = 0; r < this.layers.length; r++) {
      let i = this.layers[r].glyph.bbox;
      e.addPoint(i.minX, i.minY), e.addPoint(i.maxX, i.maxY);
    }
    return e;
  }
  /**
  * Returns an array of objects containing the glyph and color for
  * each layer in the composite color glyph.
  * @type {object[]}
  */
  get layers() {
    let e = this._font.CPAL, r = this._font.COLR, n = 0, i = r.baseGlyphRecord.length - 1;
    for (; n <= i; ) {
      let d = n + i >> 1;
      var a = r.baseGlyphRecord[d];
      if (this.id < a.gid) i = d - 1;
      else if (this.id > a.gid) n = d + 1;
      else {
        var o = a;
        break;
      }
    }
    if (o == null) {
      var s = this._font._getBaseGlyph(this.id), l = {
        red: 0,
        green: 0,
        blue: 0,
        alpha: 255
      };
      return [
        new o8(s, l)
      ];
    }
    let u = [];
    for (let d = o.firstLayerIndex; d < o.firstLayerIndex + o.numLayers; d++) {
      var a = r.layerRecords[d], l = e.colorRecords[a.paletteIndex], s = this._font._getBaseGlyph(a.gid);
      u.push(new o8(s, l));
    }
    return u;
  }
  render(e, r) {
    for (let { glyph: n, color: i } of this.layers)
      e.fillColor([
        i.red,
        i.green,
        i.blue
      ], i.alpha / 255 * 100), n.render(e, r);
  }
  constructor(...e) {
    super(...e), Fi(this, "type", "COLR");
  }
}
const vH = 32768, bH = 4095, xH = 32768, s8 = 16384, yH = 8192, l8 = 4095, u8 = 128, c8 = 127, wH = 128, _H = 64, AH = 63;
class EH {
  normalizeCoords(e) {
    let r = [];
    for (var n = 0; n < this.font.fvar.axis.length; n++) {
      let i = this.font.fvar.axis[n];
      e[n] < i.defaultValue ? r.push((e[n] - i.defaultValue + Number.EPSILON) / (i.defaultValue - i.minValue + Number.EPSILON)) : r.push((e[n] - i.defaultValue + Number.EPSILON) / (i.maxValue - i.defaultValue + Number.EPSILON));
    }
    if (this.font.avar) for (var n = 0; n < this.font.avar.segment.length; n++) {
      let a = this.font.avar.segment[n];
      for (let o = 0; o < a.correspondence.length; o++) {
        let s = a.correspondence[o];
        if (o >= 1 && r[n] < s.fromCoord) {
          let l = a.correspondence[o - 1];
          r[n] = ((r[n] - l.fromCoord) * (s.toCoord - l.toCoord) + Number.EPSILON) / (s.fromCoord - l.fromCoord + Number.EPSILON) + l.toCoord;
          break;
        }
      }
    }
    return r;
  }
  transformPoints(e, r) {
    if (!this.font.fvar || !this.font.gvar) return;
    let { gvar: n } = this.font;
    if (e >= n.glyphCount) return;
    let i = n.offsets[e];
    if (i === n.offsets[e + 1]) return;
    let { stream: a } = this.font;
    if (a.pos = i, a.pos >= a.length) return;
    let o = a.readUInt16BE(), s = i + a.readUInt16BE();
    if (o & vH) {
      var l = a.pos;
      a.pos = s;
      var u = this.decodePoints();
      s = a.pos, a.pos = l;
    }
    let d = r.map((T) => T.copy());
    o &= bH;
    for (let T = 0; T < o; T++) {
      let k = a.readUInt16BE(), E = a.readUInt16BE();
      if (E & xH) {
        var h = [];
        for (let U = 0; U < n.axisCount; U++) h.push(a.readInt16BE() / 16384);
      } else {
        if ((E & l8) >= n.globalCoordCount) throw new Error("Invalid gvar table");
        var h = n.globalCoords[E & l8];
      }
      if (E & s8) {
        var v = [];
        for (let U = 0; U < n.axisCount; U++) v.push(a.readInt16BE() / 16384);
        var b = [];
        for (let U = 0; U < n.axisCount; U++) b.push(a.readInt16BE() / 16384);
      }
      let C = this.tupleFactor(E, h, v, b);
      if (C === 0) {
        s += k;
        continue;
      }
      var l = a.pos;
      if (a.pos = s, E & yH) var x = this.decodePoints();
      else var x = u;
      let _ = x.length === 0 ? r.length : x.length, I = this.decodeDeltas(_), R = this.decodeDeltas(_);
      if (x.length === 0) for (let U = 0; U < r.length; U++) {
        var A = r[U];
        A.x += Math.round(I[U] * C), A.y += Math.round(R[U] * C);
      }
      else {
        let U = d.map((z) => z.copy()), V = r.map(() => !1);
        for (let z = 0; z < x.length; z++) {
          let j = x[z];
          if (j < r.length) {
            let S = U[j];
            V[j] = !0, S.x += I[z] * C, S.y += R[z] * C;
          }
        }
        this.interpolateMissingDeltas(U, d, V);
        for (let z = 0; z < r.length; z++) {
          let j = U[z].x - d[z].x, S = U[z].y - d[z].y;
          r[z].x = Math.round(r[z].x + j), r[z].y = Math.round(r[z].y + S);
        }
      }
      s += k, a.pos = l;
    }
  }
  decodePoints() {
    let e = this.font.stream, r = e.readUInt8();
    r & u8 && (r = (r & c8) << 8 | e.readUInt8());
    let n = new Uint16Array(r), i = 0, a = 0;
    for (; i < r; ) {
      let o = e.readUInt8(), s = (o & c8) + 1, l = o & u8 ? e.readUInt16 : e.readUInt8;
      for (let u = 0; u < s && i < r; u++)
        a += l.call(e), n[i++] = a;
    }
    return n;
  }
  decodeDeltas(e) {
    let r = this.font.stream, n = 0, i = new Int16Array(e);
    for (; n < e; ) {
      let a = r.readUInt8(), o = (a & AH) + 1;
      if (a & wH) n += o;
      else {
        let s = a & _H ? r.readInt16BE : r.readInt8;
        for (let l = 0; l < o && n < e; l++) i[n++] = s.call(r);
      }
    }
    return i;
  }
  tupleFactor(e, r, n, i) {
    let a = this.normalizedCoords, { gvar: o } = this.font, s = 1;
    for (let l = 0; l < o.axisCount; l++)
      if (r[l] !== 0) {
        if (a[l] === 0) return 0;
        if (e & s8) {
          if (a[l] < n[l] || a[l] > i[l]) return 0;
          a[l] < r[l] ? s = s * (a[l] - n[l] + Number.EPSILON) / (r[l] - n[l] + Number.EPSILON) : s = s * (i[l] - a[l] + Number.EPSILON) / (i[l] - r[l] + Number.EPSILON);
        } else {
          if (a[l] < Math.min(0, r[l]) || a[l] > Math.max(0, r[l])) return 0;
          s = (s * a[l] + Number.EPSILON) / (r[l] + Number.EPSILON);
        }
      }
    return s;
  }
  // Interpolates points without delta values.
  // Needed for the Ø and Q glyphs in Skia.
  // Algorithm from Freetype.
  interpolateMissingDeltas(e, r, n) {
    if (e.length === 0) return;
    let i = 0;
    for (; i < e.length; ) {
      let a = i, o = i, s = e[o];
      for (; !s.endContour; ) s = e[++o];
      for (; i <= o && !n[i]; ) i++;
      if (i > o) continue;
      let l = i, u = i;
      for (i++; i <= o; )
        n[i] && (this.deltaInterpolate(u + 1, i - 1, u, i, r, e), u = i), i++;
      u === l ? this.deltaShift(a, o, u, r, e) : (this.deltaInterpolate(u + 1, o, u, l, r, e), l > 0 && this.deltaInterpolate(a, l - 1, u, l, r, e)), i = o + 1;
    }
  }
  deltaInterpolate(e, r, n, i, a, o) {
    if (e > r) return;
    let s = [
      "x",
      "y"
    ];
    for (let u = 0; u < s.length; u++) {
      let d = s[u];
      if (a[n][d] > a[i][d]) {
        var l = n;
        n = i, i = l;
      }
      let h = a[n][d], v = a[i][d], b = o[n][d], x = o[i][d];
      if (h !== v || b === x) {
        let A = h === v ? 0 : (x - b) / (v - h);
        for (let T = e; T <= r; T++) {
          let k = a[T][d];
          k <= h ? k += b - h : k >= v ? k += x - v : k = b + (k - h) * A, o[T][d] = k;
        }
      }
    }
  }
  deltaShift(e, r, n, i, a) {
    let o = a[n].x - i[n].x, s = a[n].y - i[n].y;
    if (!(o === 0 && s === 0))
      for (let l = e; l <= r; l++) l !== n && (a[l].x += o, a[l].y += s);
  }
  getAdvanceAdjustment(e, r) {
    let n, i;
    if (r.advanceWidthMapping) {
      let a = e;
      a >= r.advanceWidthMapping.mapCount && (a = r.advanceWidthMapping.mapCount - 1), r.advanceWidthMapping.entryFormat, { outerIndex: n, innerIndex: i } = r.advanceWidthMapping.mapData[a];
    } else
      n = 0, i = e;
    return this.getDelta(r.itemVariationStore, n, i);
  }
  // See pseudo code from `Font Variations Overview'
  // in the OpenType specification.
  getDelta(e, r, n) {
    if (r >= e.itemVariationData.length) return 0;
    let i = e.itemVariationData[r];
    if (n >= i.deltaSets.length) return 0;
    let a = i.deltaSets[n], o = this.getBlendVector(e, r), s = 0;
    for (let l = 0; l < i.regionIndexCount; l++) s += a.deltas[l] * o[l];
    return s;
  }
  getBlendVector(e, r) {
    let n = e.itemVariationData[r];
    if (this.blendVectors.has(n)) return this.blendVectors.get(n);
    let i = this.normalizedCoords, a = [];
    for (let o = 0; o < n.regionIndexCount; o++) {
      let s = 1, l = n.regionIndexes[o], u = e.variationRegionList.variationRegions[l];
      for (let d = 0; d < u.length; d++) {
        let h = u[d], v;
        h.startCoord > h.peakCoord || h.peakCoord > h.endCoord || h.startCoord < 0 && h.endCoord > 0 && h.peakCoord !== 0 || h.peakCoord === 0 ? v = 1 : i[d] < h.startCoord || i[d] > h.endCoord ? v = 0 : i[d] === h.peakCoord ? v = 1 : i[d] < h.peakCoord ? v = (i[d] - h.startCoord + Number.EPSILON) / (h.peakCoord - h.startCoord + Number.EPSILON) : v = (h.endCoord - i[d] + Number.EPSILON) / (h.endCoord - h.peakCoord + Number.EPSILON), s *= v;
      }
      a[o] = s;
    }
    return this.blendVectors.set(n, a), a;
  }
  constructor(e, r) {
    this.font = e, this.normalizedCoords = this.normalizeCoords(r), this.blendVectors = /* @__PURE__ */ new Map();
  }
}
Promise.resolve();
class XE {
  includeGlyph(e) {
    return typeof e == "object" && (e = e.id), this.mapping[e] == null && (this.glyphs.push(e), this.mapping[e] = this.glyphs.length - 1), this.mapping[e];
  }
  constructor(e) {
    this.font = e, this.glyphs = [], this.mapping = {}, this.includeGlyph(0);
  }
}
const SH = 1, CH = 2, kH = 4, TH = 8, FH = 16, DH = 32;
class f8 {
  static size(e) {
    return e >= 0 && e <= 255 ? 1 : 2;
  }
  static encode(e, r) {
    r >= 0 && r <= 255 ? e.writeUInt8(r) : e.writeInt16BE(r);
  }
}
let d8 = new xe({
  numberOfContours: Be,
  xMin: Be,
  yMin: Be,
  xMax: Be,
  yMax: Be,
  endPtsOfContours: new ue(F, "numberOfContours"),
  instructions: new ue(ze, F),
  flags: new ue(ze, 0),
  xPoints: new ue(f8, 0),
  yPoints: new ue(f8, 0)
});
class OH {
  encodeSimple(e, r = []) {
    let n = [], i = [], a = [], o = [], s = 0, l = 0, u = 0, d = 0, h = 0;
    for (let k = 0; k < e.commands.length; k++) {
      let E = e.commands[k];
      for (let C = 0; C < E.args.length; C += 2) {
        let D = E.args[C], _ = E.args[C + 1], I = 0;
        if (E.command === "quadraticCurveTo" && C === 2) {
          let R = e.commands[k + 1];
          if (R && R.command === "quadraticCurveTo") {
            let U = (l + R.args[0]) / 2, V = (u + R.args[1]) / 2;
            if (D === U && _ === V) continue;
          }
        }
        E.command === "quadraticCurveTo" && C === 0 || (I |= SH), I = this._encodePoint(D, l, i, I, CH, FH), I = this._encodePoint(_, u, a, I, kH, DH), I === d && s < 255 ? (o[o.length - 1] |= TH, s++) : (s > 0 && (o.push(s), s = 0), o.push(I), d = I), l = D, u = _, h++;
      }
      E.command === "closePath" && n.push(h - 1);
    }
    e.commands.length > 1 && e.commands[e.commands.length - 1].command !== "closePath" && n.push(h - 1);
    let v = e.bbox, b = {
      numberOfContours: n.length,
      xMin: v.minX,
      yMin: v.minY,
      xMax: v.maxX,
      yMax: v.maxY,
      endPtsOfContours: n,
      instructions: r,
      flags: o,
      xPoints: i,
      yPoints: a
    }, x = d8.size(b), A = 4 - x % 4, T = new I5(x + A);
    return d8.encode(T, b), A !== 0 && T.fill(0, A), T.buffer;
  }
  _encodePoint(e, r, n, i, a, o) {
    let s = e - r;
    return e === r ? i |= o : (-255 <= s && s <= 255 && (i |= a, s < 0 ? s = -s : i |= o), n.push(s)), i;
  }
}
class RH extends XE {
  _addGlyph(e) {
    let r = this.font.getGlyph(e), n = r._decode(), i = this.font.loca.offsets[e], a = this.font.loca.offsets[e + 1], o = this.font._getTableStream("glyf");
    o.pos += i;
    let s = o.readBuffer(a - i);
    if (n && n.numberOfContours < 0) {
      s = new Uint8Array(s);
      let l = new DataView(s.buffer);
      for (let u of n.components)
        e = this.includeGlyph(u.glyphID), l.setUint16(u.pos, e);
    } else n && this.font._variationProcessor && (s = this.glyphEncoder.encodeSimple(r.path, n.instructions));
    return this.glyf.push(s), this.loca.offsets.push(this.offset), this.hmtx.metrics.push({
      advance: r.advanceWidth,
      bearing: r._getMetrics().leftBearing
    }), this.offset += s.length, this.glyf.length - 1;
  }
  encode() {
    this.glyf = [], this.offset = 0, this.loca = {
      offsets: [],
      version: this.font.loca.version
    }, this.hmtx = {
      metrics: [],
      bearings: []
    };
    let e = 0;
    for (; e < this.glyphs.length; ) this._addGlyph(this.glyphs[e++]);
    let r = Bg(this.font.maxp);
    r.numGlyphs = this.glyf.length, this.loca.offsets.push(this.offset);
    let n = Bg(this.font.head);
    n.indexToLocFormat = this.loca.version;
    let i = Bg(this.font.hhea);
    return i.numberOfMetrics = this.hmtx.metrics.length, UE.toBuffer({
      tables: {
        head: n,
        hhea: i,
        loca: this.loca,
        maxp: r,
        "cvt ": this.font["cvt "],
        prep: this.font.prep,
        glyf: this.glyf,
        hmtx: this.hmtx,
        fpgm: this.font.fpgm
      }
    });
  }
  constructor(e) {
    super(e), this.glyphEncoder = new OH();
  }
}
class PH extends XE {
  subsetCharstrings() {
    this.charstrings = [];
    let e = {};
    for (let r of this.glyphs) {
      this.charstrings.push(this.cff.getCharString(r));
      let n = this.font.getGlyph(r);
      n.path;
      for (let i in n._usedGsubrs) e[i] = !0;
    }
    this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, e);
  }
  subsetSubrs(e, r) {
    let n = [];
    for (let i = 0; i < e.length; i++) {
      let a = e[i];
      r[i] ? (this.cff.stream.pos = a.offset, n.push(this.cff.stream.readBuffer(a.length))) : n.push(new Uint8Array([
        11
      ]));
    }
    return n;
  }
  subsetFontdict(e) {
    e.FDArray = [], e.FDSelect = {
      version: 0,
      fds: []
    };
    let r = {}, n = [], i = {};
    for (let a of this.glyphs) {
      let o = this.cff.fdForGlyph(a);
      if (o == null) continue;
      r[o] || (e.FDArray.push(Object.assign({}, this.cff.topDict.FDArray[o])), n.push({}), i[o] = e.FDArray.length - 1), r[o] = !0, e.FDSelect.fds.push(i[o]);
      let s = this.font.getGlyph(a);
      s.path;
      for (let l in s._usedSubrs) n[i[o]][l] = !0;
    }
    for (let a = 0; a < e.FDArray.length; a++) {
      let o = e.FDArray[a];
      delete o.FontName, o.Private && o.Private.Subrs && (o.Private = Object.assign({}, o.Private), o.Private.Subrs = this.subsetSubrs(o.Private.Subrs, n[a]));
    }
  }
  createCIDFontdict(e) {
    let r = {};
    for (let i of this.glyphs) {
      let a = this.font.getGlyph(i);
      a.path;
      for (let o in a._usedSubrs) r[o] = !0;
    }
    let n = Object.assign({}, this.cff.topDict.Private);
    return this.cff.topDict.Private && this.cff.topDict.Private.Subrs && (n.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, r)), e.FDArray = [
      {
        Private: n
      }
    ], e.FDSelect = {
      version: 3,
      nRanges: 1,
      ranges: [
        {
          first: 0,
          fd: 0
        }
      ],
      sentinel: this.charstrings.length
    };
  }
  addString(e) {
    return e ? (this.strings || (this.strings = []), this.strings.push(e), t5.length + this.strings.length - 1) : null;
  }
  encode() {
    this.subsetCharstrings();
    let e = {
      version: this.charstrings.length > 255 ? 2 : 1,
      ranges: [
        {
          first: 1,
          nLeft: this.charstrings.length - 2
        }
      ]
    }, r = Object.assign({}, this.cff.topDict);
    r.Private = null, r.charset = e, r.Encoding = null, r.CharStrings = this.charstrings;
    for (let i of [
      "version",
      "Notice",
      "Copyright",
      "FullName",
      "FamilyName",
      "Weight",
      "PostScript",
      "BaseFontName",
      "FontName"
    ]) r[i] = this.addString(this.cff.string(r[i]));
    r.ROS = [
      this.addString("Adobe"),
      this.addString("Identity"),
      0
    ], r.CIDCount = this.charstrings.length, this.cff.isCIDFont ? this.subsetFontdict(r) : this.createCIDFontdict(r);
    let n = {
      version: 1,
      hdrSize: this.cff.hdrSize,
      offSize: 4,
      header: this.cff.header,
      nameIndex: [
        this.cff.postscriptName
      ],
      topDictIndex: [
        r
      ],
      stringIndex: this.strings,
      globalSubrIndex: this.gsubrs
    };
    return IE.toBuffer(n);
  }
  constructor(e) {
    if (super(e), this.cff = this.font["CFF "], !this.cff) throw new Error("Not a CFF Font");
  }
}
class qn {
  static probe(e) {
    let r = Wp.decode(e.slice(0, 4));
    return r === "true" || r === "OTTO" || r === "\0\0\0";
  }
  setDefaultLanguage(e = null) {
    this.defaultLanguage = e;
  }
  _getTable(e) {
    if (!(e.tag in this._tables)) try {
      this._tables[e.tag] = this._decodeTable(e);
    } catch {
    }
    return this._tables[e.tag];
  }
  _getTableStream(e) {
    let r = this.directory.tables[e];
    return r ? (this.stream.pos = r.offset, this.stream) : null;
  }
  _decodeDirectory() {
    return this.directory = UE.decode(this.stream, {
      _startOffset: 0
    });
  }
  _decodeTable(e) {
    let r = this.stream.pos, n = this._getTableStream(e.tag), i = $5[e.tag].decode(n, this, e.length);
    return this.stream.pos = r, i;
  }
  /**
  * Gets a string from the font's `name` table
  * `lang` is a BCP-47 language code.
  * @return {string}
  */
  getName(e, r = this.defaultLanguage || M5) {
    let n = this.name && this.name.records[e];
    return n && (n[r] || n[this.defaultLanguage] || n[M5] || n.en || n[Object.keys(n)[0]]) || null;
  }
  /**
  * The unique PostScript name for this font, e.g. "Helvetica-Bold"
  * @type {string}
  */
  get postscriptName() {
    return this.getName("postscriptName");
  }
  /**
  * The font's full name, e.g. "Helvetica Bold"
  * @type {string}
  */
  get fullName() {
    return this.getName("fullName");
  }
  /**
  * The font's family name, e.g. "Helvetica"
  * @type {string}
  */
  get familyName() {
    return this.getName("fontFamily");
  }
  /**
  * The font's sub-family, e.g. "Bold".
  * @type {string}
  */
  get subfamilyName() {
    return this.getName("fontSubfamily");
  }
  /**
  * The font's copyright information
  * @type {string}
  */
  get copyright() {
    return this.getName("copyright");
  }
  /**
  * The font's version number
  * @type {string}
  */
  get version() {
    return this.getName("version");
  }
  /**
  * The font’s [ascender](https://en.wikipedia.org/wiki/Ascender_(typography))
  * @type {number}
  */
  get ascent() {
    return this.hhea.ascent;
  }
  /**
  * The font’s [descender](https://en.wikipedia.org/wiki/Descender)
  * @type {number}
  */
  get descent() {
    return this.hhea.descent;
  }
  /**
  * The amount of space that should be included between lines
  * @type {number}
  */
  get lineGap() {
    return this.hhea.lineGap;
  }
  /**
  * The offset from the normal underline position that should be used
  * @type {number}
  */
  get underlinePosition() {
    return this.post.underlinePosition;
  }
  /**
  * The weight of the underline that should be used
  * @type {number}
  */
  get underlineThickness() {
    return this.post.underlineThickness;
  }
  /**
  * If this is an italic font, the angle the cursor should be drawn at to match the font design
  * @type {number}
  */
  get italicAngle() {
    return this.post.italicAngle;
  }
  /**
  * The height of capital letters above the baseline.
  * See [here](https://en.wikipedia.org/wiki/Cap_height) for more details.
  * @type {number}
  */
  get capHeight() {
    let e = this["OS/2"];
    return e ? e.capHeight : this.ascent;
  }
  /**
  * The height of lower case letters in the font.
  * See [here](https://en.wikipedia.org/wiki/X-height) for more details.
  * @type {number}
  */
  get xHeight() {
    let e = this["OS/2"];
    return e ? e.xHeight : 0;
  }
  /**
  * The number of glyphs in the font.
  * @type {number}
  */
  get numGlyphs() {
    return this.maxp.numGlyphs;
  }
  /**
  * The size of the font’s internal coordinate grid
  * @type {number}
  */
  get unitsPerEm() {
    return this.head.unitsPerEm;
  }
  /**
  * The font’s bounding box, i.e. the box that encloses all glyphs in the font.
  * @type {BBox}
  */
  get bbox() {
    return Object.freeze(new ou(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
  }
  get _cmapProcessor() {
    return new Ub(this.cmap);
  }
  /**
  * An array of all of the unicode code points supported by the font.
  * @type {number[]}
  */
  get characterSet() {
    return this._cmapProcessor.getCharacterSet();
  }
  /**
  * Returns whether there is glyph in the font for the given unicode code point.
  *
  * @param {number} codePoint
  * @return {boolean}
  */
  hasGlyphForCodePoint(e) {
    return !!this._cmapProcessor.lookup(e);
  }
  /**
  * Maps a single unicode code point to a Glyph object.
  * Does not perform any advanced substitutions (there is no context to do so).
  *
  * @param {number} codePoint
  * @return {Glyph}
  */
  glyphForCodePoint(e) {
    return this.getGlyph(this._cmapProcessor.lookup(e), [
      e
    ]);
  }
  /**
  * Returns an array of Glyph objects for the given string.
  * This is only a one-to-one mapping from characters to glyphs.
  * For most uses, you should use font.layout (described below), which
  * provides a much more advanced mapping supporting AAT and OpenType shaping.
  *
  * @param {string} string
  * @return {Glyph[]}
  */
  glyphsForString(e) {
    let r = [], n = e.length, i = 0, a = -1, o = -1;
    for (; i <= n; ) {
      let s = 0, l = 0;
      if (i < n) {
        if (s = e.charCodeAt(i++), 55296 <= s && s <= 56319 && i < n) {
          let u = e.charCodeAt(i);
          56320 <= u && u <= 57343 && (i++, s = ((s & 1023) << 10) + (u & 1023) + 65536);
        }
        l = 65024 <= s && s <= 65039 || 917760 <= s && s <= 917999 ? 1 : 0;
      } else i++;
      o === 0 && l === 1 ? r.push(this.getGlyph(this._cmapProcessor.lookup(a, s), [
        a,
        s
      ])) : o === 0 && l === 0 && r.push(this.glyphForCodePoint(a)), a = s, o = l;
    }
    return r;
  }
  get _layoutEngine() {
    return new QW(this);
  }
  /**
  * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
  *
  * @param {string} string
  * @param {string[]} [userFeatures]
  * @param {string} [script]
  * @param {string} [language]
  * @param {string} [direction]
  * @return {GlyphRun}
  */
  layout(e, r, n, i, a) {
    return this._layoutEngine.layout(e, r, n, i, a);
  }
  /**
  * Returns an array of strings that map to the given glyph id.
  * @param {number} gid - glyph id
  */
  stringsForGlyph(e) {
    return this._layoutEngine.stringsForGlyph(e);
  }
  /**
  * An array of all [OpenType feature tags](https://www.microsoft.com/typography/otspec/featuretags.htm)
  * (or mapped AAT tags) supported by the font.
  * The features parameter is an array of OpenType feature tags to be applied in addition to the default set.
  * If this is an AAT font, the OpenType feature tags are mapped to AAT features.
  *
  * @type {string[]}
  */
  get availableFeatures() {
    return this._layoutEngine.getAvailableFeatures();
  }
  getAvailableFeatures(e, r) {
    return this._layoutEngine.getAvailableFeatures(e, r);
  }
  _getBaseGlyph(e, r = []) {
    return this._glyphs[e] || (this.directory.tables.glyf ? this._glyphs[e] = new Gp(e, r, this) : (this.directory.tables["CFF "] || this.directory.tables.CFF2) && (this._glyphs[e] = new hH(e, r, this))), this._glyphs[e] || null;
  }
  /**
  * Returns a glyph object for the given glyph id.
  * You can pass the array of code points this glyph represents for
  * your use later, and it will be stored in the glyph object.
  *
  * @param {number} glyph
  * @param {number[]} characters
  * @return {Glyph}
  */
  getGlyph(e, r = []) {
    return this._glyphs[e] || (this.directory.tables.sbix ? this._glyphs[e] = new mH(e, r, this) : this.directory.tables.COLR && this.directory.tables.CPAL ? this._glyphs[e] = new gH(e, r, this) : this._getBaseGlyph(e, r)), this._glyphs[e] || null;
  }
  /**
  * Returns a Subset for this font.
  * @return {Subset}
  */
  createSubset() {
    return this.directory.tables["CFF "] ? new PH(this) : new RH(this);
  }
  /**
  * Returns an object describing the available variation axes
  * that this font supports. Keys are setting tags, and values
  * contain the axis name, range, and default value.
  *
  * @type {object}
  */
  get variationAxes() {
    let e = {};
    if (!this.fvar) return e;
    for (let r of this.fvar.axis) e[r.axisTag.trim()] = {
      name: r.name.en,
      min: r.minValue,
      default: r.defaultValue,
      max: r.maxValue
    };
    return e;
  }
  /**
  * Returns an object describing the named variation instances
  * that the font designer has specified. Keys are variation names
  * and values are the variation settings for this instance.
  *
  * @type {object}
  */
  get namedVariations() {
    let e = {};
    if (!this.fvar) return e;
    for (let r of this.fvar.instance) {
      let n = {};
      for (let i = 0; i < this.fvar.axis.length; i++) {
        let a = this.fvar.axis[i];
        n[a.axisTag.trim()] = r.coord[i];
      }
      e[r.name.en] = n;
    }
    return e;
  }
  /**
  * Returns a new font with the given variation settings applied.
  * Settings can either be an instance name, or an object containing
  * variation tags as specified by the `variationAxes` property.
  *
  * @param {object} settings
  * @return {TTFFont}
  */
  getVariation(e) {
    if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) throw new Error("Variations require a font with the fvar, gvar and glyf, or CFF2 tables.");
    if (typeof e == "string" && (e = this.namedVariations[e]), typeof e != "object") throw new Error("Variation settings must be either a variation name or settings object.");
    let r = this.fvar.axis.map((a, o) => {
      let s = a.axisTag.trim();
      return s in e ? Math.max(a.minValue, Math.min(a.maxValue, e[s])) : a.defaultValue;
    }), n = new Tn(this.stream.buffer);
    n.pos = this._directoryPos;
    let i = new qn(n, r);
    return i._tables = this._tables, i;
  }
  get _variationProcessor() {
    if (!this.fvar) return null;
    let e = this.variationCoords;
    return !e && !this.CFF2 ? null : (e || (e = this.fvar.axis.map((r) => r.defaultValue)), new EH(this, e));
  }
  // Standardized format plugin API
  getFont(e) {
    return this.getVariation(e);
  }
  constructor(e, r = null) {
    Fi(this, "type", "TTF"), this.defaultLanguage = null, this.stream = e, this.variationCoords = r, this._directoryPos = this.stream.pos, this._tables = {}, this._glyphs = {}, this._decodeDirectory();
    for (let n in this.directory.tables) {
      let i = this.directory.tables[n];
      $5[n] && i.length > 0 && Object.defineProperty(this, n, {
        get: this._getTable.bind(this, i)
      });
    }
  }
}
Pn([
  In
], qn.prototype, "bbox", null);
Pn([
  In
], qn.prototype, "_cmapProcessor", null);
Pn([
  In
], qn.prototype, "characterSet", null);
Pn([
  In
], qn.prototype, "_layoutEngine", null);
Pn([
  In
], qn.prototype, "variationAxes", null);
Pn([
  In
], qn.prototype, "namedVariations", null);
Pn([
  In
], qn.prototype, "_variationProcessor", null);
let IH = new xe({
  tag: new A0(4),
  offset: new de(ge, "void", {
    type: "global"
  }),
  compLength: ge,
  length: ge,
  origChecksum: ge
}), KE = new xe({
  tag: new A0(4),
  flavor: ge,
  length: ge,
  numTables: F,
  reserved: new J0(F),
  totalSfntSize: ge,
  majorVersion: F,
  minorVersion: F,
  metaOffset: ge,
  metaLength: ge,
  metaOrigLength: ge,
  privOffset: ge,
  privLength: ge,
  tables: new ue(IH, "numTables")
});
KE.process = function() {
  let t = {};
  for (let e of this.tables) t[e.tag] = e;
  this.tables = t;
};
var BH = KE;
class LH extends qn {
  static probe(e) {
    return Wp.decode(e.slice(0, 4)) === "wOFF";
  }
  _decodeDirectory() {
    this.directory = BH.decode(this.stream, {
      _startOffset: 0
    });
  }
  _getTableStream(e) {
    let r = this.directory.tables[e];
    if (r)
      if (this.stream.pos = r.offset, r.compLength < r.length) {
        this.stream.pos += 2;
        let n = new Uint8Array(r.length), i = CU(this.stream.readBuffer(r.compLength - 2), n);
        return new Tn(i);
      } else return this.stream;
    return null;
  }
  constructor(...e) {
    super(...e), Fi(this, "type", "WOFF");
  }
}
class NH extends Gp {
  _decode() {
    return this._font._transformedGlyphs[this.id];
  }
  _getCBox() {
    return this.path.bbox;
  }
  constructor(...e) {
    super(...e), Fi(this, "type", "WOFF2");
  }
}
const h8 = {
  decode(t) {
    let e = 0, r = [
      0,
      1,
      2,
      3,
      4
    ];
    for (let n = 0; n < r.length; n++) {
      let i = t.readUInt8();
      if (e & 3758096384) throw new Error("Overflow");
      if (e = e << 7 | i & 127, !(i & 128)) return e;
    }
    throw new Error("Bad base 128 number");
  }
};
let MH = [
  "cmap",
  "head",
  "hhea",
  "hmtx",
  "maxp",
  "name",
  "OS/2",
  "post",
  "cvt ",
  "fpgm",
  "glyf",
  "loca",
  "prep",
  "CFF ",
  "VORG",
  "EBDT",
  "EBLC",
  "gasp",
  "hdmx",
  "kern",
  "LTSH",
  "PCLT",
  "VDMX",
  "vhea",
  "vmtx",
  "BASE",
  "GDEF",
  "GPOS",
  "GSUB",
  "EBSC",
  "JSTF",
  "MATH",
  "CBDT",
  "CBLC",
  "COLR",
  "CPAL",
  "SVG ",
  "sbix",
  "acnt",
  "avar",
  "bdat",
  "bloc",
  "bsln",
  "cvar",
  "fdsc",
  "feat",
  "fmtx",
  "fvar",
  "gvar",
  "hsty",
  "just",
  "lcar",
  "mort",
  "morx",
  "opbd",
  "prop",
  "trak",
  "Zapf",
  "Silf",
  "Glat",
  "Gloc",
  "Feat",
  "Sill"
], UH = new xe({
  flags: ze,
  customTag: new B5(new A0(4), (t) => (t.flags & 63) === 63),
  tag: (t) => t.customTag || MH[t.flags & 63],
  length: h8,
  transformVersion: (t) => t.flags >>> 6 & 3,
  transformed: (t) => t.tag === "glyf" || t.tag === "loca" ? t.transformVersion === 0 : t.transformVersion !== 0,
  transformLength: new B5(h8, (t) => t.transformed)
}), JE = new xe({
  tag: new A0(4),
  flavor: ge,
  length: ge,
  numTables: F,
  reserved: new J0(F),
  totalSfntSize: ge,
  totalCompressedSize: ge,
  majorVersion: F,
  minorVersion: F,
  metaOffset: ge,
  metaLength: ge,
  metaOrigLength: ge,
  privOffset: ge,
  privLength: ge,
  tables: new ue(UH, "numTables")
});
JE.process = function() {
  let t = {};
  for (let e = 0; e < this.tables.length; e++) {
    let r = this.tables[e];
    t[r.tag] = r;
  }
  return this.tables = t;
};
var zH = JE;
class $H extends qn {
  static probe(e) {
    return Wp.decode(e.slice(0, 4)) === "wOF2";
  }
  _decodeDirectory() {
    this.directory = zH.decode(this.stream), this._dataPos = this.stream.pos;
  }
  _decompress() {
    if (!this._decompressed) {
      this.stream.pos = this._dataPos;
      let e = this.stream.readBuffer(this.directory.totalCompressedSize), r = 0;
      for (let i in this.directory.tables) {
        let a = this.directory.tables[i];
        a.offset = r, r += a.transformLength != null ? a.transformLength : a.length;
      }
      let n = fz(e, r);
      if (!n) throw new Error("Error decoding compressed data in WOFF2");
      this.stream = new Tn(n), this._decompressed = !0;
    }
  }
  _decodeTable(e) {
    return this._decompress(), super._decodeTable(e);
  }
  // Override this method to get a glyph and return our
  // custom subclass if there is a glyf table.
  _getBaseGlyph(e, r = []) {
    if (!this._glyphs[e])
      return this.directory.tables.glyf && this.directory.tables.glyf.transformed ? (this._transformedGlyphs || this._transformGlyfTable(), this._glyphs[e] = new NH(e, r, this)) : super._getBaseGlyph(e, r);
  }
  _transformGlyfTable() {
    this._decompress(), this.stream.pos = this.directory.tables.glyf.offset;
    let e = VH.decode(this.stream), r = [];
    for (let i = 0; i < e.numGlyphs; i++) {
      let a = {}, o = e.nContours.readInt16BE();
      if (a.numberOfContours = o, o > 0) {
        let s = [], l = 0;
        for (let u = 0; u < o; u++) {
          let d = Yg(e.nPoints);
          l += d, s.push(l);
        }
        a.points = qH(e.flags, e.glyphs, l);
        for (let u = 0; u < o; u++) a.points[s[u] - 1].endContour = !0;
        var n = Yg(e.glyphs);
      } else if (o < 0 && Gp.prototype._decodeComposite.call({
        _font: this
      }, a, e.composites))
        var n = Yg(e.glyphs);
      r.push(a);
    }
    this._transformedGlyphs = r;
  }
  constructor(...e) {
    super(...e), Fi(this, "type", "WOFF2");
  }
}
class Lu {
  decode(e, r) {
    return new Tn(this._buf.decode(e, r));
  }
  constructor(e) {
    this.length = e, this._buf = new Fn(e);
  }
}
let VH = new xe({
  version: ge,
  numGlyphs: F,
  indexFormat: F,
  nContourStreamSize: ge,
  nPointsStreamSize: ge,
  flagStreamSize: ge,
  glyphStreamSize: ge,
  compositeStreamSize: ge,
  bboxStreamSize: ge,
  instructionStreamSize: ge,
  nContours: new Lu("nContourStreamSize"),
  nPoints: new Lu("nPointsStreamSize"),
  flags: new Lu("flagStreamSize"),
  glyphs: new Lu("glyphStreamSize"),
  composites: new Lu("compositeStreamSize"),
  bboxes: new Lu("bboxStreamSize"),
  instructions: new Lu("instructionStreamSize")
});
const jH = 253, WH = 254, HH = 255, p8 = 253;
function Yg(t) {
  let e = t.readUInt8();
  return e === jH ? t.readUInt16BE() : e === HH ? t.readUInt8() + p8 : e === WH ? t.readUInt8() + p8 * 2 : e;
}
function Oo(t, e) {
  return t & 1 ? e : -e;
}
function qH(t, e, r) {
  let n, i = n = 0, a = [];
  for (let l = 0; l < r; l++) {
    let u = 0, d = 0, h = t.readUInt8(), v = !(h >> 7);
    if (h &= 127, h < 10)
      u = 0, d = Oo(h, ((h & 14) << 7) + e.readUInt8());
    else if (h < 20)
      u = Oo(h, ((h - 10 & 14) << 7) + e.readUInt8()), d = 0;
    else if (h < 84) {
      var o = h - 20, s = e.readUInt8();
      u = Oo(h, 1 + (o & 48) + (s >> 4)), d = Oo(h >> 1, 1 + ((o & 12) << 2) + (s & 15));
    } else if (h < 120) {
      var o = h - 84;
      u = Oo(h, 1 + (o / 12 << 8) + e.readUInt8()), d = Oo(h >> 1, 1 + (o % 12 >> 2 << 8) + e.readUInt8());
    } else if (h < 124) {
      var s = e.readUInt8();
      let x = e.readUInt8();
      u = Oo(h, (s << 4) + (x >> 4)), d = Oo(h >> 1, ((x & 15) << 8) + e.readUInt8());
    } else
      u = Oo(h, e.readUInt16BE()), d = Oo(h >> 1, e.readUInt16BE());
    i += u, n += d, a.push(new Ga(v, !1, i, n));
  }
  return a;
}
let YH = new qt(ge, {
  65536: {
    numFonts: ge,
    offsets: new ue(ge, "numFonts")
  },
  131072: {
    numFonts: ge,
    offsets: new ue(ge, "numFonts"),
    dsigTag: ge,
    dsigLength: ge,
    dsigOffset: ge
  }
});
class GH {
  static probe(e) {
    return Wp.decode(e.slice(0, 4)) === "ttcf";
  }
  getFont(e) {
    for (let r of this.header.offsets) {
      let n = new Tn(this.stream.buffer);
      n.pos = r;
      let i = new qn(n);
      if (i.postscriptName === e || i.postscriptName instanceof Uint8Array && e instanceof Uint8Array && i.postscriptName.every((a, o) => e[o] === a)) return i;
    }
    return null;
  }
  get fonts() {
    let e = [];
    for (let r of this.header.offsets) {
      let n = new Tn(this.stream.buffer);
      n.pos = r, e.push(new qn(n));
    }
    return e;
  }
  constructor(e) {
    if (Fi(this, "type", "TTC"), this.stream = e, e.readString(4) !== "ttcf") throw new Error("Not a TrueType collection");
    this.header = YH.decode(e);
  }
}
let ZH = new A0(ze);
new xe({
  len: ge,
  buf: new Fn("len")
});
let XH = new xe({
  id: F,
  nameOffset: Be,
  attr: ze,
  dataOffset: Kl,
  handle: ge
}), KH = new xe({
  name: new A0(4),
  maxTypeIndex: F,
  refList: new de(F, new ue(XH, (t) => t.maxTypeIndex + 1), {
    type: "parent"
  })
}), JH = new xe({
  length: F,
  types: new ue(KH, (t) => t.length + 1)
}), QH = new xe({
  reserved: new J0(ze, 24),
  typeList: new de(F, JH),
  nameListOffset: new de(F, "void")
}), m8 = new xe({
  dataOffset: ge,
  map: new de(ge, QH),
  dataLength: ge,
  mapLength: ge
});
class eq {
  static probe(e) {
    let r = new Tn(e);
    try {
      var n = m8.decode(r);
    } catch {
      return !1;
    }
    for (let i of n.map.typeList.types)
      if (i.name === "sfnt") return !0;
    return !1;
  }
  getFont(e) {
    if (!this.sfnt) return null;
    for (let r of this.sfnt.refList) {
      let n = this.header.dataOffset + r.dataOffset + 4, i = new Tn(this.stream.buffer.slice(n)), a = new qn(i);
      if (a.postscriptName === e || a.postscriptName instanceof Uint8Array && e instanceof Uint8Array && a.postscriptName.every((o, s) => e[s] === o)) return a;
    }
    return null;
  }
  get fonts() {
    let e = [];
    for (let r of this.sfnt.refList) {
      let n = this.header.dataOffset + r.dataOffset + 4, i = new Tn(this.stream.buffer.slice(n));
      e.push(new qn(i));
    }
    return e;
  }
  constructor(e) {
    Fi(this, "type", "DFont"), this.stream = e, this.header = m8.decode(this.stream);
    for (let r of this.header.map.typeList.types) {
      for (let n of r.refList) n.nameOffset >= 0 ? (this.stream.pos = n.nameOffset + this.header.map.nameListOffset, n.name = ZH.decode(this.stream)) : n.name = null;
      r.name === "sfnt" && (this.sfnt = r);
    }
  }
}
w1(qn);
w1(LH);
w1($H);
w1(GH);
w1(eq);
function tq() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var rq = tq;
const nq = /* @__PURE__ */ On(rq);
var hs = {}, Dh = {};
(function(t) {
  var e = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
  function r(a, o) {
    return Object.prototype.hasOwnProperty.call(a, o);
  }
  t.assign = function(a) {
    for (var o = Array.prototype.slice.call(arguments, 1); o.length; ) {
      var s = o.shift();
      if (s) {
        if (typeof s != "object")
          throw new TypeError(s + "must be non-object");
        for (var l in s)
          r(s, l) && (a[l] = s[l]);
      }
    }
    return a;
  }, t.shrinkBuf = function(a, o) {
    return a.length === o ? a : a.subarray ? a.subarray(0, o) : (a.length = o, a);
  };
  var n = {
    arraySet: function(a, o, s, l, u) {
      if (o.subarray && a.subarray) {
        a.set(o.subarray(s, s + l), u);
        return;
      }
      for (var d = 0; d < l; d++)
        a[u + d] = o[s + d];
    },
    // Join array of chunks to single array.
    flattenChunks: function(a) {
      var o, s, l, u, d, h;
      for (l = 0, o = 0, s = a.length; o < s; o++)
        l += a[o].length;
      for (h = new Uint8Array(l), u = 0, o = 0, s = a.length; o < s; o++)
        d = a[o], h.set(d, u), u += d.length;
      return h;
    }
  }, i = {
    arraySet: function(a, o, s, l, u) {
      for (var d = 0; d < l; d++)
        a[u + d] = o[s + d];
    },
    // Join array of chunks to single array.
    flattenChunks: function(a) {
      return [].concat.apply([], a);
    }
  };
  t.setTyped = function(a) {
    a ? (t.Buf8 = Uint8Array, t.Buf16 = Uint16Array, t.Buf32 = Int32Array, t.assign(t, n)) : (t.Buf8 = Array, t.Buf16 = Array, t.Buf32 = Array, t.assign(t, i));
  }, t.setTyped(e);
})(Dh);
var A1 = {}, iq = Dh, aq = 4, g8 = 0, v8 = 1, oq = 2;
function E1(t) {
  for (var e = t.length; --e >= 0; )
    t[e] = 0;
}
var sq = 0, QE = 1, lq = 2, uq = 3, cq = 258, $b = 29, Oh = 256, ih = Oh + 1 + $b, Xf = 30, Vb = 19, eS = 2 * ih + 1, qu = 15, Gg = 16, fq = 7, jb = 256, tS = 16, rS = 17, nS = 18, y3 = (
  /* extra bits for each length code */
  [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
), i5 = (
  /* extra bits for each distance code */
  [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
), dq = (
  /* extra bits for each bit length code */
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
), iS = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], hq = 512, Zs = new Array((ih + 2) * 2);
E1(Zs);
var Ud = new Array(Xf * 2);
E1(Ud);
var ah = new Array(hq);
E1(ah);
var oh = new Array(cq - uq + 1);
E1(oh);
var Wb = new Array($b);
E1(Wb);
var Z5 = new Array(Xf);
E1(Z5);
function Zg(t, e, r, n, i) {
  this.static_tree = t, this.extra_bits = e, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = t && t.length;
}
var aS, oS, sS;
function Xg(t, e) {
  this.dyn_tree = t, this.max_code = 0, this.stat_desc = e;
}
function lS(t) {
  return t < 256 ? ah[t] : ah[256 + (t >>> 7)];
}
function sh(t, e) {
  t.pending_buf[t.pending++] = e & 255, t.pending_buf[t.pending++] = e >>> 8 & 255;
}
function Ci(t, e, r) {
  t.bi_valid > Gg - r ? (t.bi_buf |= e << t.bi_valid & 65535, sh(t, t.bi_buf), t.bi_buf = e >> Gg - t.bi_valid, t.bi_valid += r - Gg) : (t.bi_buf |= e << t.bi_valid & 65535, t.bi_valid += r);
}
function Wo(t, e, r) {
  Ci(
    t,
    r[e * 2],
    r[e * 2 + 1]
    /*.Len*/
  );
}
function uS(t, e) {
  var r = 0;
  do
    r |= t & 1, t >>>= 1, r <<= 1;
  while (--e > 0);
  return r >>> 1;
}
function pq(t) {
  t.bi_valid === 16 ? (sh(t, t.bi_buf), t.bi_buf = 0, t.bi_valid = 0) : t.bi_valid >= 8 && (t.pending_buf[t.pending++] = t.bi_buf & 255, t.bi_buf >>= 8, t.bi_valid -= 8);
}
function mq(t, e) {
  var r = e.dyn_tree, n = e.max_code, i = e.stat_desc.static_tree, a = e.stat_desc.has_stree, o = e.stat_desc.extra_bits, s = e.stat_desc.extra_base, l = e.stat_desc.max_length, u, d, h, v, b, x, A = 0;
  for (v = 0; v <= qu; v++)
    t.bl_count[v] = 0;
  for (r[t.heap[t.heap_max] * 2 + 1] = 0, u = t.heap_max + 1; u < eS; u++)
    d = t.heap[u], v = r[r[d * 2 + 1] * 2 + 1] + 1, v > l && (v = l, A++), r[d * 2 + 1] = v, !(d > n) && (t.bl_count[v]++, b = 0, d >= s && (b = o[d - s]), x = r[d * 2], t.opt_len += x * (v + b), a && (t.static_len += x * (i[d * 2 + 1] + b)));
  if (A !== 0) {
    do {
      for (v = l - 1; t.bl_count[v] === 0; )
        v--;
      t.bl_count[v]--, t.bl_count[v + 1] += 2, t.bl_count[l]--, A -= 2;
    } while (A > 0);
    for (v = l; v !== 0; v--)
      for (d = t.bl_count[v]; d !== 0; )
        h = t.heap[--u], !(h > n) && (r[h * 2 + 1] !== v && (t.opt_len += (v - r[h * 2 + 1]) * r[h * 2], r[h * 2 + 1] = v), d--);
  }
}
function cS(t, e, r) {
  var n = new Array(qu + 1), i = 0, a, o;
  for (a = 1; a <= qu; a++)
    n[a] = i = i + r[a - 1] << 1;
  for (o = 0; o <= e; o++) {
    var s = t[o * 2 + 1];
    s !== 0 && (t[o * 2] = uS(n[s]++, s));
  }
}
function gq() {
  var t, e, r, n, i, a = new Array(qu + 1);
  for (r = 0, n = 0; n < $b - 1; n++)
    for (Wb[n] = r, t = 0; t < 1 << y3[n]; t++)
      oh[r++] = n;
  for (oh[r - 1] = n, i = 0, n = 0; n < 16; n++)
    for (Z5[n] = i, t = 0; t < 1 << i5[n]; t++)
      ah[i++] = n;
  for (i >>= 7; n < Xf; n++)
    for (Z5[n] = i << 7, t = 0; t < 1 << i5[n] - 7; t++)
      ah[256 + i++] = n;
  for (e = 0; e <= qu; e++)
    a[e] = 0;
  for (t = 0; t <= 143; )
    Zs[t * 2 + 1] = 8, t++, a[8]++;
  for (; t <= 255; )
    Zs[t * 2 + 1] = 9, t++, a[9]++;
  for (; t <= 279; )
    Zs[t * 2 + 1] = 7, t++, a[7]++;
  for (; t <= 287; )
    Zs[t * 2 + 1] = 8, t++, a[8]++;
  for (cS(Zs, ih + 1, a), t = 0; t < Xf; t++)
    Ud[t * 2 + 1] = 5, Ud[t * 2] = uS(t, 5);
  aS = new Zg(Zs, y3, Oh + 1, ih, qu), oS = new Zg(Ud, i5, 0, Xf, qu), sS = new Zg(new Array(0), dq, 0, Vb, fq);
}
function fS(t) {
  var e;
  for (e = 0; e < ih; e++)
    t.dyn_ltree[e * 2] = 0;
  for (e = 0; e < Xf; e++)
    t.dyn_dtree[e * 2] = 0;
  for (e = 0; e < Vb; e++)
    t.bl_tree[e * 2] = 0;
  t.dyn_ltree[jb * 2] = 1, t.opt_len = t.static_len = 0, t.last_lit = t.matches = 0;
}
function dS(t) {
  t.bi_valid > 8 ? sh(t, t.bi_buf) : t.bi_valid > 0 && (t.pending_buf[t.pending++] = t.bi_buf), t.bi_buf = 0, t.bi_valid = 0;
}
function vq(t, e, r, n) {
  dS(t), sh(t, r), sh(t, ~r), iq.arraySet(t.pending_buf, t.window, e, r, t.pending), t.pending += r;
}
function b8(t, e, r, n) {
  var i = e * 2, a = r * 2;
  return t[i] < t[a] || t[i] === t[a] && n[e] <= n[r];
}
function Kg(t, e, r) {
  for (var n = t.heap[r], i = r << 1; i <= t.heap_len && (i < t.heap_len && b8(e, t.heap[i + 1], t.heap[i], t.depth) && i++, !b8(e, n, t.heap[i], t.depth)); )
    t.heap[r] = t.heap[i], r = i, i <<= 1;
  t.heap[r] = n;
}
function x8(t, e, r) {
  var n, i, a = 0, o, s;
  if (t.last_lit !== 0)
    do
      n = t.pending_buf[t.d_buf + a * 2] << 8 | t.pending_buf[t.d_buf + a * 2 + 1], i = t.pending_buf[t.l_buf + a], a++, n === 0 ? Wo(t, i, e) : (o = oh[i], Wo(t, o + Oh + 1, e), s = y3[o], s !== 0 && (i -= Wb[o], Ci(t, i, s)), n--, o = lS(n), Wo(t, o, r), s = i5[o], s !== 0 && (n -= Z5[o], Ci(t, n, s)));
    while (a < t.last_lit);
  Wo(t, jb, e);
}
function w3(t, e) {
  var r = e.dyn_tree, n = e.stat_desc.static_tree, i = e.stat_desc.has_stree, a = e.stat_desc.elems, o, s, l = -1, u;
  for (t.heap_len = 0, t.heap_max = eS, o = 0; o < a; o++)
    r[o * 2] !== 0 ? (t.heap[++t.heap_len] = l = o, t.depth[o] = 0) : r[o * 2 + 1] = 0;
  for (; t.heap_len < 2; )
    u = t.heap[++t.heap_len] = l < 2 ? ++l : 0, r[u * 2] = 1, t.depth[u] = 0, t.opt_len--, i && (t.static_len -= n[u * 2 + 1]);
  for (e.max_code = l, o = t.heap_len >> 1; o >= 1; o--)
    Kg(t, r, o);
  u = a;
  do
    o = t.heap[
      1
      /*SMALLEST*/
    ], t.heap[
      1
      /*SMALLEST*/
    ] = t.heap[t.heap_len--], Kg(
      t,
      r,
      1
      /*SMALLEST*/
    ), s = t.heap[
      1
      /*SMALLEST*/
    ], t.heap[--t.heap_max] = o, t.heap[--t.heap_max] = s, r[u * 2] = r[o * 2] + r[s * 2], t.depth[u] = (t.depth[o] >= t.depth[s] ? t.depth[o] : t.depth[s]) + 1, r[o * 2 + 1] = r[s * 2 + 1] = u, t.heap[
      1
      /*SMALLEST*/
    ] = u++, Kg(
      t,
      r,
      1
      /*SMALLEST*/
    );
  while (t.heap_len >= 2);
  t.heap[--t.heap_max] = t.heap[
    1
    /*SMALLEST*/
  ], mq(t, e), cS(r, l, t.bl_count);
}
function y8(t, e, r) {
  var n, i = -1, a, o = e[0 * 2 + 1], s = 0, l = 7, u = 4;
  for (o === 0 && (l = 138, u = 3), e[(r + 1) * 2 + 1] = 65535, n = 0; n <= r; n++)
    a = o, o = e[(n + 1) * 2 + 1], !(++s < l && a === o) && (s < u ? t.bl_tree[a * 2] += s : a !== 0 ? (a !== i && t.bl_tree[a * 2]++, t.bl_tree[tS * 2]++) : s <= 10 ? t.bl_tree[rS * 2]++ : t.bl_tree[nS * 2]++, s = 0, i = a, o === 0 ? (l = 138, u = 3) : a === o ? (l = 6, u = 3) : (l = 7, u = 4));
}
function w8(t, e, r) {
  var n, i = -1, a, o = e[0 * 2 + 1], s = 0, l = 7, u = 4;
  for (o === 0 && (l = 138, u = 3), n = 0; n <= r; n++)
    if (a = o, o = e[(n + 1) * 2 + 1], !(++s < l && a === o)) {
      if (s < u)
        do
          Wo(t, a, t.bl_tree);
        while (--s !== 0);
      else a !== 0 ? (a !== i && (Wo(t, a, t.bl_tree), s--), Wo(t, tS, t.bl_tree), Ci(t, s - 3, 2)) : s <= 10 ? (Wo(t, rS, t.bl_tree), Ci(t, s - 3, 3)) : (Wo(t, nS, t.bl_tree), Ci(t, s - 11, 7));
      s = 0, i = a, o === 0 ? (l = 138, u = 3) : a === o ? (l = 6, u = 3) : (l = 7, u = 4);
    }
}
function bq(t) {
  var e;
  for (y8(t, t.dyn_ltree, t.l_desc.max_code), y8(t, t.dyn_dtree, t.d_desc.max_code), w3(t, t.bl_desc), e = Vb - 1; e >= 3 && t.bl_tree[iS[e] * 2 + 1] === 0; e--)
    ;
  return t.opt_len += 3 * (e + 1) + 5 + 5 + 4, e;
}
function xq(t, e, r, n) {
  var i;
  for (Ci(t, e - 257, 5), Ci(t, r - 1, 5), Ci(t, n - 4, 4), i = 0; i < n; i++)
    Ci(t, t.bl_tree[iS[i] * 2 + 1], 3);
  w8(t, t.dyn_ltree, e - 1), w8(t, t.dyn_dtree, r - 1);
}
function yq(t) {
  var e = 4093624447, r;
  for (r = 0; r <= 31; r++, e >>>= 1)
    if (e & 1 && t.dyn_ltree[r * 2] !== 0)
      return g8;
  if (t.dyn_ltree[9 * 2] !== 0 || t.dyn_ltree[10 * 2] !== 0 || t.dyn_ltree[13 * 2] !== 0)
    return v8;
  for (r = 32; r < Oh; r++)
    if (t.dyn_ltree[r * 2] !== 0)
      return v8;
  return g8;
}
var _8 = !1;
function wq(t) {
  _8 || (gq(), _8 = !0), t.l_desc = new Xg(t.dyn_ltree, aS), t.d_desc = new Xg(t.dyn_dtree, oS), t.bl_desc = new Xg(t.bl_tree, sS), t.bi_buf = 0, t.bi_valid = 0, fS(t);
}
function hS(t, e, r, n) {
  Ci(t, (sq << 1) + (n ? 1 : 0), 3), vq(t, e, r);
}
function _q(t) {
  Ci(t, QE << 1, 3), Wo(t, jb, Zs), pq(t);
}
function Aq(t, e, r, n) {
  var i, a, o = 0;
  t.level > 0 ? (t.strm.data_type === oq && (t.strm.data_type = yq(t)), w3(t, t.l_desc), w3(t, t.d_desc), o = bq(t), i = t.opt_len + 3 + 7 >>> 3, a = t.static_len + 3 + 7 >>> 3, a <= i && (i = a)) : i = a = r + 5, r + 4 <= i && e !== -1 ? hS(t, e, r, n) : t.strategy === aq || a === i ? (Ci(t, (QE << 1) + (n ? 1 : 0), 3), x8(t, Zs, Ud)) : (Ci(t, (lq << 1) + (n ? 1 : 0), 3), xq(t, t.l_desc.max_code + 1, t.d_desc.max_code + 1, o + 1), x8(t, t.dyn_ltree, t.dyn_dtree)), fS(t), n && dS(t);
}
function Eq(t, e, r) {
  return t.pending_buf[t.d_buf + t.last_lit * 2] = e >>> 8 & 255, t.pending_buf[t.d_buf + t.last_lit * 2 + 1] = e & 255, t.pending_buf[t.l_buf + t.last_lit] = r & 255, t.last_lit++, e === 0 ? t.dyn_ltree[r * 2]++ : (t.matches++, e--, t.dyn_ltree[(oh[r] + Oh + 1) * 2]++, t.dyn_dtree[lS(e) * 2]++), t.last_lit === t.lit_bufsize - 1;
}
A1._tr_init = wq;
A1._tr_stored_block = hS;
A1._tr_flush_block = Aq;
A1._tr_tally = Eq;
A1._tr_align = _q;
function Sq(t, e, r, n) {
  for (var i = t & 65535 | 0, a = t >>> 16 & 65535 | 0, o = 0; r !== 0; ) {
    o = r > 2e3 ? 2e3 : r, r -= o;
    do
      i = i + e[n++] | 0, a = a + i | 0;
    while (--o);
    i %= 65521, a %= 65521;
  }
  return i | a << 16 | 0;
}
var pS = Sq;
function Cq() {
  for (var t, e = [], r = 0; r < 256; r++) {
    t = r;
    for (var n = 0; n < 8; n++)
      t = t & 1 ? 3988292384 ^ t >>> 1 : t >>> 1;
    e[r] = t;
  }
  return e;
}
var kq = Cq();
function Tq(t, e, r, n) {
  var i = kq, a = n + r;
  t ^= -1;
  for (var o = n; o < a; o++)
    t = t >>> 8 ^ i[(t ^ e[o]) & 255];
  return t ^ -1;
}
var mS = Tq, Fq = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, ai = Dh, _a = A1, gS = pS, Pl = mS, Dq = Fq, Dc = 0, Oq = 1, Rq = 3, Ql = 4, A8 = 5, Ho = 0, E8 = 1, Aa = -2, Pq = -3, Jg = -5, Iq = -1, Bq = 1, F2 = 2, Lq = 3, Nq = 4, Mq = 0, Uq = 2, Zp = 8, zq = 9, $q = 15, Vq = 8, jq = 29, Wq = 256, _3 = Wq + 1 + jq, Hq = 30, qq = 19, Yq = 2 * _3 + 1, Gq = 15, u0 = 3, ql = 258, Qa = ql + u0 + 1, Zq = 32, Xp = 42, A3 = 69, a5 = 73, o5 = 91, s5 = 103, Yu = 113, Fd = 666, Xr = 1, Rh = 2, vc = 3, S1 = 4, Xq = 3;
function Yl(t, e) {
  return t.msg = Dq[e], e;
}
function S8(t) {
  return (t << 1) - (t > 4 ? 9 : 0);
}
function jl(t) {
  for (var e = t.length; --e >= 0; )
    t[e] = 0;
}
function Il(t) {
  var e = t.state, r = e.pending;
  r > t.avail_out && (r = t.avail_out), r !== 0 && (ai.arraySet(t.output, e.pending_buf, e.pending_out, r, t.next_out), t.next_out += r, e.pending_out += r, t.total_out += r, t.avail_out -= r, e.pending -= r, e.pending === 0 && (e.pending_out = 0));
}
function Cn(t, e) {
  _a._tr_flush_block(t, t.block_start >= 0 ? t.block_start : -1, t.strstart - t.block_start, e), t.block_start = t.strstart, Il(t.strm);
}
function y0(t, e) {
  t.pending_buf[t.pending++] = e;
}
function Sd(t, e) {
  t.pending_buf[t.pending++] = e >>> 8 & 255, t.pending_buf[t.pending++] = e & 255;
}
function Kq(t, e, r, n) {
  var i = t.avail_in;
  return i > n && (i = n), i === 0 ? 0 : (t.avail_in -= i, ai.arraySet(e, t.input, t.next_in, i, r), t.state.wrap === 1 ? t.adler = gS(t.adler, e, i, r) : t.state.wrap === 2 && (t.adler = Pl(t.adler, e, i, r)), t.next_in += i, t.total_in += i, i);
}
function vS(t, e) {
  var r = t.max_chain_length, n = t.strstart, i, a, o = t.prev_length, s = t.nice_match, l = t.strstart > t.w_size - Qa ? t.strstart - (t.w_size - Qa) : 0, u = t.window, d = t.w_mask, h = t.prev, v = t.strstart + ql, b = u[n + o - 1], x = u[n + o];
  t.prev_length >= t.good_match && (r >>= 2), s > t.lookahead && (s = t.lookahead);
  do
    if (i = e, !(u[i + o] !== x || u[i + o - 1] !== b || u[i] !== u[n] || u[++i] !== u[n + 1])) {
      n += 2, i++;
      do
        ;
      while (u[++n] === u[++i] && u[++n] === u[++i] && u[++n] === u[++i] && u[++n] === u[++i] && u[++n] === u[++i] && u[++n] === u[++i] && u[++n] === u[++i] && u[++n] === u[++i] && n < v);
      if (a = ql - (v - n), n = v - ql, a > o) {
        if (t.match_start = e, o = a, a >= s)
          break;
        b = u[n + o - 1], x = u[n + o];
      }
    }
  while ((e = h[e & d]) > l && --r !== 0);
  return o <= t.lookahead ? o : t.lookahead;
}
function bc(t) {
  var e = t.w_size, r, n, i, a, o;
  do {
    if (a = t.window_size - t.lookahead - t.strstart, t.strstart >= e + (e - Qa)) {
      ai.arraySet(t.window, t.window, e, e, 0), t.match_start -= e, t.strstart -= e, t.block_start -= e, n = t.hash_size, r = n;
      do
        i = t.head[--r], t.head[r] = i >= e ? i - e : 0;
      while (--n);
      n = e, r = n;
      do
        i = t.prev[--r], t.prev[r] = i >= e ? i - e : 0;
      while (--n);
      a += e;
    }
    if (t.strm.avail_in === 0)
      break;
    if (n = Kq(t.strm, t.window, t.strstart + t.lookahead, a), t.lookahead += n, t.lookahead + t.insert >= u0)
      for (o = t.strstart - t.insert, t.ins_h = t.window[o], t.ins_h = (t.ins_h << t.hash_shift ^ t.window[o + 1]) & t.hash_mask; t.insert && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[o + u0 - 1]) & t.hash_mask, t.prev[o & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = o, o++, t.insert--, !(t.lookahead + t.insert < u0)); )
        ;
  } while (t.lookahead < Qa && t.strm.avail_in !== 0);
}
function Jq(t, e) {
  var r = 65535;
  for (r > t.pending_buf_size - 5 && (r = t.pending_buf_size - 5); ; ) {
    if (t.lookahead <= 1) {
      if (bc(t), t.lookahead === 0 && e === Dc)
        return Xr;
      if (t.lookahead === 0)
        break;
    }
    t.strstart += t.lookahead, t.lookahead = 0;
    var n = t.block_start + r;
    if ((t.strstart === 0 || t.strstart >= n) && (t.lookahead = t.strstart - n, t.strstart = n, Cn(t, !1), t.strm.avail_out === 0) || t.strstart - t.block_start >= t.w_size - Qa && (Cn(t, !1), t.strm.avail_out === 0))
      return Xr;
  }
  return t.insert = 0, e === Ql ? (Cn(t, !0), t.strm.avail_out === 0 ? vc : S1) : (t.strstart > t.block_start && (Cn(t, !1), t.strm.avail_out === 0), Xr);
}
function Qg(t, e) {
  for (var r, n; ; ) {
    if (t.lookahead < Qa) {
      if (bc(t), t.lookahead < Qa && e === Dc)
        return Xr;
      if (t.lookahead === 0)
        break;
    }
    if (r = 0, t.lookahead >= u0 && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + u0 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), r !== 0 && t.strstart - r <= t.w_size - Qa && (t.match_length = vS(t, r)), t.match_length >= u0)
      if (n = _a._tr_tally(t, t.strstart - t.match_start, t.match_length - u0), t.lookahead -= t.match_length, t.match_length <= t.max_lazy_match && t.lookahead >= u0) {
        t.match_length--;
        do
          t.strstart++, t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + u0 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart;
        while (--t.match_length !== 0);
        t.strstart++;
      } else
        t.strstart += t.match_length, t.match_length = 0, t.ins_h = t.window[t.strstart], t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 1]) & t.hash_mask;
    else
      n = _a._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++;
    if (n && (Cn(t, !1), t.strm.avail_out === 0))
      return Xr;
  }
  return t.insert = t.strstart < u0 - 1 ? t.strstart : u0 - 1, e === Ql ? (Cn(t, !0), t.strm.avail_out === 0 ? vc : S1) : t.last_lit && (Cn(t, !1), t.strm.avail_out === 0) ? Xr : Rh;
}
function Tf(t, e) {
  for (var r, n, i; ; ) {
    if (t.lookahead < Qa) {
      if (bc(t), t.lookahead < Qa && e === Dc)
        return Xr;
      if (t.lookahead === 0)
        break;
    }
    if (r = 0, t.lookahead >= u0 && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + u0 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), t.prev_length = t.match_length, t.prev_match = t.match_start, t.match_length = u0 - 1, r !== 0 && t.prev_length < t.max_lazy_match && t.strstart - r <= t.w_size - Qa && (t.match_length = vS(t, r), t.match_length <= 5 && (t.strategy === Bq || t.match_length === u0 && t.strstart - t.match_start > 4096) && (t.match_length = u0 - 1)), t.prev_length >= u0 && t.match_length <= t.prev_length) {
      i = t.strstart + t.lookahead - u0, n = _a._tr_tally(t, t.strstart - 1 - t.prev_match, t.prev_length - u0), t.lookahead -= t.prev_length - 1, t.prev_length -= 2;
      do
        ++t.strstart <= i && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + u0 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart);
      while (--t.prev_length !== 0);
      if (t.match_available = 0, t.match_length = u0 - 1, t.strstart++, n && (Cn(t, !1), t.strm.avail_out === 0))
        return Xr;
    } else if (t.match_available) {
      if (n = _a._tr_tally(t, 0, t.window[t.strstart - 1]), n && Cn(t, !1), t.strstart++, t.lookahead--, t.strm.avail_out === 0)
        return Xr;
    } else
      t.match_available = 1, t.strstart++, t.lookahead--;
  }
  return t.match_available && (n = _a._tr_tally(t, 0, t.window[t.strstart - 1]), t.match_available = 0), t.insert = t.strstart < u0 - 1 ? t.strstart : u0 - 1, e === Ql ? (Cn(t, !0), t.strm.avail_out === 0 ? vc : S1) : t.last_lit && (Cn(t, !1), t.strm.avail_out === 0) ? Xr : Rh;
}
function Qq(t, e) {
  for (var r, n, i, a, o = t.window; ; ) {
    if (t.lookahead <= ql) {
      if (bc(t), t.lookahead <= ql && e === Dc)
        return Xr;
      if (t.lookahead === 0)
        break;
    }
    if (t.match_length = 0, t.lookahead >= u0 && t.strstart > 0 && (i = t.strstart - 1, n = o[i], n === o[++i] && n === o[++i] && n === o[++i])) {
      a = t.strstart + ql;
      do
        ;
      while (n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && i < a);
      t.match_length = ql - (a - i), t.match_length > t.lookahead && (t.match_length = t.lookahead);
    }
    if (t.match_length >= u0 ? (r = _a._tr_tally(t, 1, t.match_length - u0), t.lookahead -= t.match_length, t.strstart += t.match_length, t.match_length = 0) : (r = _a._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++), r && (Cn(t, !1), t.strm.avail_out === 0))
      return Xr;
  }
  return t.insert = 0, e === Ql ? (Cn(t, !0), t.strm.avail_out === 0 ? vc : S1) : t.last_lit && (Cn(t, !1), t.strm.avail_out === 0) ? Xr : Rh;
}
function eY(t, e) {
  for (var r; ; ) {
    if (t.lookahead === 0 && (bc(t), t.lookahead === 0)) {
      if (e === Dc)
        return Xr;
      break;
    }
    if (t.match_length = 0, r = _a._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++, r && (Cn(t, !1), t.strm.avail_out === 0))
      return Xr;
  }
  return t.insert = 0, e === Ql ? (Cn(t, !0), t.strm.avail_out === 0 ? vc : S1) : t.last_lit && (Cn(t, !1), t.strm.avail_out === 0) ? Xr : Rh;
}
function Ro(t, e, r, n, i) {
  this.good_length = t, this.max_lazy = e, this.nice_length = r, this.max_chain = n, this.func = i;
}
var Vf;
Vf = [
  /*      good lazy nice chain */
  new Ro(0, 0, 0, 0, Jq),
  /* 0 store only */
  new Ro(4, 4, 8, 4, Qg),
  /* 1 max speed, no lazy matches */
  new Ro(4, 5, 16, 8, Qg),
  /* 2 */
  new Ro(4, 6, 32, 32, Qg),
  /* 3 */
  new Ro(4, 4, 16, 16, Tf),
  /* 4 lazy matches */
  new Ro(8, 16, 32, 32, Tf),
  /* 5 */
  new Ro(8, 16, 128, 128, Tf),
  /* 6 */
  new Ro(8, 32, 128, 256, Tf),
  /* 7 */
  new Ro(32, 128, 258, 1024, Tf),
  /* 8 */
  new Ro(32, 258, 258, 4096, Tf)
  /* 9 max compression */
];
function tY(t) {
  t.window_size = 2 * t.w_size, jl(t.head), t.max_lazy_match = Vf[t.level].max_lazy, t.good_match = Vf[t.level].good_length, t.nice_match = Vf[t.level].nice_length, t.max_chain_length = Vf[t.level].max_chain, t.strstart = 0, t.block_start = 0, t.lookahead = 0, t.insert = 0, t.match_length = t.prev_length = u0 - 1, t.match_available = 0, t.ins_h = 0;
}
function rY() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = Zp, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new ai.Buf16(Yq * 2), this.dyn_dtree = new ai.Buf16((2 * Hq + 1) * 2), this.bl_tree = new ai.Buf16((2 * qq + 1) * 2), jl(this.dyn_ltree), jl(this.dyn_dtree), jl(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new ai.Buf16(Gq + 1), this.heap = new ai.Buf16(2 * _3 + 1), jl(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new ai.Buf16(2 * _3 + 1), jl(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
function bS(t) {
  var e;
  return !t || !t.state ? Yl(t, Aa) : (t.total_in = t.total_out = 0, t.data_type = Uq, e = t.state, e.pending = 0, e.pending_out = 0, e.wrap < 0 && (e.wrap = -e.wrap), e.status = e.wrap ? Xp : Yu, t.adler = e.wrap === 2 ? 0 : 1, e.last_flush = Dc, _a._tr_init(e), Ho);
}
function xS(t) {
  var e = bS(t);
  return e === Ho && tY(t.state), e;
}
function nY(t, e) {
  return !t || !t.state || t.state.wrap !== 2 ? Aa : (t.state.gzhead = e, Ho);
}
function yS(t, e, r, n, i, a) {
  if (!t)
    return Aa;
  var o = 1;
  if (e === Iq && (e = 6), n < 0 ? (o = 0, n = -n) : n > 15 && (o = 2, n -= 16), i < 1 || i > zq || r !== Zp || n < 8 || n > 15 || e < 0 || e > 9 || a < 0 || a > Nq)
    return Yl(t, Aa);
  n === 8 && (n = 9);
  var s = new rY();
  return t.state = s, s.strm = t, s.wrap = o, s.gzhead = null, s.w_bits = n, s.w_size = 1 << s.w_bits, s.w_mask = s.w_size - 1, s.hash_bits = i + 7, s.hash_size = 1 << s.hash_bits, s.hash_mask = s.hash_size - 1, s.hash_shift = ~~((s.hash_bits + u0 - 1) / u0), s.window = new ai.Buf8(s.w_size * 2), s.head = new ai.Buf16(s.hash_size), s.prev = new ai.Buf16(s.w_size), s.lit_bufsize = 1 << i + 6, s.pending_buf_size = s.lit_bufsize * 4, s.pending_buf = new ai.Buf8(s.pending_buf_size), s.d_buf = 1 * s.lit_bufsize, s.l_buf = 3 * s.lit_bufsize, s.level = e, s.strategy = a, s.method = r, xS(t);
}
function iY(t, e) {
  return yS(t, e, Zp, $q, Vq, Mq);
}
function aY(t, e) {
  var r, n, i, a;
  if (!t || !t.state || e > A8 || e < 0)
    return t ? Yl(t, Aa) : Aa;
  if (n = t.state, !t.output || !t.input && t.avail_in !== 0 || n.status === Fd && e !== Ql)
    return Yl(t, t.avail_out === 0 ? Jg : Aa);
  if (n.strm = t, r = n.last_flush, n.last_flush = e, n.status === Xp)
    if (n.wrap === 2)
      t.adler = 0, y0(n, 31), y0(n, 139), y0(n, 8), n.gzhead ? (y0(
        n,
        (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)
      ), y0(n, n.gzhead.time & 255), y0(n, n.gzhead.time >> 8 & 255), y0(n, n.gzhead.time >> 16 & 255), y0(n, n.gzhead.time >> 24 & 255), y0(n, n.level === 9 ? 2 : n.strategy >= F2 || n.level < 2 ? 4 : 0), y0(n, n.gzhead.os & 255), n.gzhead.extra && n.gzhead.extra.length && (y0(n, n.gzhead.extra.length & 255), y0(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (t.adler = Pl(t.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = A3) : (y0(n, 0), y0(n, 0), y0(n, 0), y0(n, 0), y0(n, 0), y0(n, n.level === 9 ? 2 : n.strategy >= F2 || n.level < 2 ? 4 : 0), y0(n, Xq), n.status = Yu);
    else {
      var o = Zp + (n.w_bits - 8 << 4) << 8, s = -1;
      n.strategy >= F2 || n.level < 2 ? s = 0 : n.level < 6 ? s = 1 : n.level === 6 ? s = 2 : s = 3, o |= s << 6, n.strstart !== 0 && (o |= Zq), o += 31 - o % 31, n.status = Yu, Sd(n, o), n.strstart !== 0 && (Sd(n, t.adler >>> 16), Sd(n, t.adler & 65535)), t.adler = 1;
    }
  if (n.status === A3)
    if (n.gzhead.extra) {
      for (i = n.pending; n.gzindex < (n.gzhead.extra.length & 65535) && !(n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (t.adler = Pl(t.adler, n.pending_buf, n.pending - i, i)), Il(t), i = n.pending, n.pending === n.pending_buf_size)); )
        y0(n, n.gzhead.extra[n.gzindex] & 255), n.gzindex++;
      n.gzhead.hcrc && n.pending > i && (t.adler = Pl(t.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = a5);
    } else
      n.status = a5;
  if (n.status === a5)
    if (n.gzhead.name) {
      i = n.pending;
      do {
        if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (t.adler = Pl(t.adler, n.pending_buf, n.pending - i, i)), Il(t), i = n.pending, n.pending === n.pending_buf_size)) {
          a = 1;
          break;
        }
        n.gzindex < n.gzhead.name.length ? a = n.gzhead.name.charCodeAt(n.gzindex++) & 255 : a = 0, y0(n, a);
      } while (a !== 0);
      n.gzhead.hcrc && n.pending > i && (t.adler = Pl(t.adler, n.pending_buf, n.pending - i, i)), a === 0 && (n.gzindex = 0, n.status = o5);
    } else
      n.status = o5;
  if (n.status === o5)
    if (n.gzhead.comment) {
      i = n.pending;
      do {
        if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (t.adler = Pl(t.adler, n.pending_buf, n.pending - i, i)), Il(t), i = n.pending, n.pending === n.pending_buf_size)) {
          a = 1;
          break;
        }
        n.gzindex < n.gzhead.comment.length ? a = n.gzhead.comment.charCodeAt(n.gzindex++) & 255 : a = 0, y0(n, a);
      } while (a !== 0);
      n.gzhead.hcrc && n.pending > i && (t.adler = Pl(t.adler, n.pending_buf, n.pending - i, i)), a === 0 && (n.status = s5);
    } else
      n.status = s5;
  if (n.status === s5 && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && Il(t), n.pending + 2 <= n.pending_buf_size && (y0(n, t.adler & 255), y0(n, t.adler >> 8 & 255), t.adler = 0, n.status = Yu)) : n.status = Yu), n.pending !== 0) {
    if (Il(t), t.avail_out === 0)
      return n.last_flush = -1, Ho;
  } else if (t.avail_in === 0 && S8(e) <= S8(r) && e !== Ql)
    return Yl(t, Jg);
  if (n.status === Fd && t.avail_in !== 0)
    return Yl(t, Jg);
  if (t.avail_in !== 0 || n.lookahead !== 0 || e !== Dc && n.status !== Fd) {
    var l = n.strategy === F2 ? eY(n, e) : n.strategy === Lq ? Qq(n, e) : Vf[n.level].func(n, e);
    if ((l === vc || l === S1) && (n.status = Fd), l === Xr || l === vc)
      return t.avail_out === 0 && (n.last_flush = -1), Ho;
    if (l === Rh && (e === Oq ? _a._tr_align(n) : e !== A8 && (_a._tr_stored_block(n, 0, 0, !1), e === Rq && (jl(n.head), n.lookahead === 0 && (n.strstart = 0, n.block_start = 0, n.insert = 0))), Il(t), t.avail_out === 0))
      return n.last_flush = -1, Ho;
  }
  return e !== Ql ? Ho : n.wrap <= 0 ? E8 : (n.wrap === 2 ? (y0(n, t.adler & 255), y0(n, t.adler >> 8 & 255), y0(n, t.adler >> 16 & 255), y0(n, t.adler >> 24 & 255), y0(n, t.total_in & 255), y0(n, t.total_in >> 8 & 255), y0(n, t.total_in >> 16 & 255), y0(n, t.total_in >> 24 & 255)) : (Sd(n, t.adler >>> 16), Sd(n, t.adler & 65535)), Il(t), n.wrap > 0 && (n.wrap = -n.wrap), n.pending !== 0 ? Ho : E8);
}
function oY(t) {
  var e;
  return !t || !t.state ? Aa : (e = t.state.status, e !== Xp && e !== A3 && e !== a5 && e !== o5 && e !== s5 && e !== Yu && e !== Fd ? Yl(t, Aa) : (t.state = null, e === Yu ? Yl(t, Pq) : Ho));
}
function sY(t, e) {
  var r = e.length, n, i, a, o, s, l, u, d;
  if (!t || !t.state || (n = t.state, o = n.wrap, o === 2 || o === 1 && n.status !== Xp || n.lookahead))
    return Aa;
  for (o === 1 && (t.adler = gS(t.adler, e, r, 0)), n.wrap = 0, r >= n.w_size && (o === 0 && (jl(n.head), n.strstart = 0, n.block_start = 0, n.insert = 0), d = new ai.Buf8(n.w_size), ai.arraySet(d, e, r - n.w_size, n.w_size, 0), e = d, r = n.w_size), s = t.avail_in, l = t.next_in, u = t.input, t.avail_in = r, t.next_in = 0, t.input = e, bc(n); n.lookahead >= u0; ) {
    i = n.strstart, a = n.lookahead - (u0 - 1);
    do
      n.ins_h = (n.ins_h << n.hash_shift ^ n.window[i + u0 - 1]) & n.hash_mask, n.prev[i & n.w_mask] = n.head[n.ins_h], n.head[n.ins_h] = i, i++;
    while (--a);
    n.strstart = i, n.lookahead = u0 - 1, bc(n);
  }
  return n.strstart += n.lookahead, n.block_start = n.strstart, n.insert = n.lookahead, n.lookahead = 0, n.match_length = n.prev_length = u0 - 1, n.match_available = 0, t.next_in = l, t.input = u, t.avail_in = s, n.wrap = o, Ho;
}
hs.deflateInit = iY;
hs.deflateInit2 = yS;
hs.deflateReset = xS;
hs.deflateResetKeep = bS;
hs.deflateSetHeader = nY;
hs.deflate = aY;
hs.deflateEnd = oY;
hs.deflateSetDictionary = sY;
hs.deflateInfo = "pako deflate (from Nodeca project)";
var co = {}, D2 = 30, lY = 12, uY = function(e, r) {
  var n, i, a, o, s, l, u, d, h, v, b, x, A, T, k, E, C, D, _, I, R, U, V, z, j;
  n = e.state, i = e.next_in, z = e.input, a = i + (e.avail_in - 5), o = e.next_out, j = e.output, s = o - (r - e.avail_out), l = o + (e.avail_out - 257), u = n.dmax, d = n.wsize, h = n.whave, v = n.wnext, b = n.window, x = n.hold, A = n.bits, T = n.lencode, k = n.distcode, E = (1 << n.lenbits) - 1, C = (1 << n.distbits) - 1;
  e:
    do {
      A < 15 && (x += z[i++] << A, A += 8, x += z[i++] << A, A += 8), D = T[x & E];
      t:
        for (; ; ) {
          if (_ = D >>> 24, x >>>= _, A -= _, _ = D >>> 16 & 255, _ === 0)
            j[o++] = D & 65535;
          else if (_ & 16) {
            I = D & 65535, _ &= 15, _ && (A < _ && (x += z[i++] << A, A += 8), I += x & (1 << _) - 1, x >>>= _, A -= _), A < 15 && (x += z[i++] << A, A += 8, x += z[i++] << A, A += 8), D = k[x & C];
            r:
              for (; ; ) {
                if (_ = D >>> 24, x >>>= _, A -= _, _ = D >>> 16 & 255, _ & 16) {
                  if (R = D & 65535, _ &= 15, A < _ && (x += z[i++] << A, A += 8, A < _ && (x += z[i++] << A, A += 8)), R += x & (1 << _) - 1, R > u) {
                    e.msg = "invalid distance too far back", n.mode = D2;
                    break e;
                  }
                  if (x >>>= _, A -= _, _ = o - s, R > _) {
                    if (_ = R - _, _ > h && n.sane) {
                      e.msg = "invalid distance too far back", n.mode = D2;
                      break e;
                    }
                    if (U = 0, V = b, v === 0) {
                      if (U += d - _, _ < I) {
                        I -= _;
                        do
                          j[o++] = b[U++];
                        while (--_);
                        U = o - R, V = j;
                      }
                    } else if (v < _) {
                      if (U += d + v - _, _ -= v, _ < I) {
                        I -= _;
                        do
                          j[o++] = b[U++];
                        while (--_);
                        if (U = 0, v < I) {
                          _ = v, I -= _;
                          do
                            j[o++] = b[U++];
                          while (--_);
                          U = o - R, V = j;
                        }
                      }
                    } else if (U += v - _, _ < I) {
                      I -= _;
                      do
                        j[o++] = b[U++];
                      while (--_);
                      U = o - R, V = j;
                    }
                    for (; I > 2; )
                      j[o++] = V[U++], j[o++] = V[U++], j[o++] = V[U++], I -= 3;
                    I && (j[o++] = V[U++], I > 1 && (j[o++] = V[U++]));
                  } else {
                    U = o - R;
                    do
                      j[o++] = j[U++], j[o++] = j[U++], j[o++] = j[U++], I -= 3;
                    while (I > 2);
                    I && (j[o++] = j[U++], I > 1 && (j[o++] = j[U++]));
                  }
                } else if (_ & 64) {
                  e.msg = "invalid distance code", n.mode = D2;
                  break e;
                } else {
                  D = k[(D & 65535) + (x & (1 << _) - 1)];
                  continue r;
                }
                break;
              }
          } else if (_ & 64)
            if (_ & 32) {
              n.mode = lY;
              break e;
            } else {
              e.msg = "invalid literal/length code", n.mode = D2;
              break e;
            }
          else {
            D = T[(D & 65535) + (x & (1 << _) - 1)];
            continue t;
          }
          break;
        }
    } while (i < a && o < l);
  I = A >> 3, i -= I, A -= I << 3, x &= (1 << A) - 1, e.next_in = i, e.next_out = o, e.avail_in = i < a ? 5 + (a - i) : 5 - (i - a), e.avail_out = o < l ? 257 + (l - o) : 257 - (o - l), n.hold = x, n.bits = A;
}, C8 = Dh, Ff = 15, k8 = 852, T8 = 592, F8 = 0, e4 = 1, D8 = 2, cY = [
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
], fY = [
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
], dY = [
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
], hY = [
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
], pY = function(e, r, n, i, a, o, s, l) {
  var u = l.bits, d = 0, h = 0, v = 0, b = 0, x = 0, A = 0, T = 0, k = 0, E = 0, C = 0, D, _, I, R, U, V = null, z = 0, j, S = new C8.Buf16(Ff + 1), B = new C8.Buf16(Ff + 1), q = null, Y = 0, Z, Q, J;
  for (d = 0; d <= Ff; d++)
    S[d] = 0;
  for (h = 0; h < i; h++)
    S[r[n + h]]++;
  for (x = u, b = Ff; b >= 1 && S[b] === 0; b--)
    ;
  if (x > b && (x = b), b === 0)
    return a[o++] = 1 << 24 | 64 << 16 | 0, a[o++] = 1 << 24 | 64 << 16 | 0, l.bits = 1, 0;
  for (v = 1; v < b && S[v] === 0; v++)
    ;
  for (x < v && (x = v), k = 1, d = 1; d <= Ff; d++)
    if (k <<= 1, k -= S[d], k < 0)
      return -1;
  if (k > 0 && (e === F8 || b !== 1))
    return -1;
  for (B[1] = 0, d = 1; d < Ff; d++)
    B[d + 1] = B[d] + S[d];
  for (h = 0; h < i; h++)
    r[n + h] !== 0 && (s[B[r[n + h]]++] = h);
  if (e === F8 ? (V = q = s, j = 19) : e === e4 ? (V = cY, z -= 257, q = fY, Y -= 257, j = 256) : (V = dY, q = hY, j = -1), C = 0, h = 0, d = v, U = o, A = x, T = 0, I = -1, E = 1 << x, R = E - 1, e === e4 && E > k8 || e === D8 && E > T8)
    return 1;
  for (; ; ) {
    Z = d - T, s[h] < j ? (Q = 0, J = s[h]) : s[h] > j ? (Q = q[Y + s[h]], J = V[z + s[h]]) : (Q = 96, J = 0), D = 1 << d - T, _ = 1 << A, v = _;
    do
      _ -= D, a[U + (C >> T) + _] = Z << 24 | Q << 16 | J | 0;
    while (_ !== 0);
    for (D = 1 << d - 1; C & D; )
      D >>= 1;
    if (D !== 0 ? (C &= D - 1, C += D) : C = 0, h++, --S[d] === 0) {
      if (d === b)
        break;
      d = r[n + s[h]];
    }
    if (d > x && (C & R) !== I) {
      for (T === 0 && (T = x), U += v, A = d - T, k = 1 << A; A + T < b && (k -= S[A + T], !(k <= 0)); )
        A++, k <<= 1;
      if (E += 1 << A, e === e4 && E > k8 || e === D8 && E > T8)
        return 1;
      I = C & R, a[I] = x << 24 | A << 16 | U - o | 0;
    }
  }
  return C !== 0 && (a[U + C] = d - T << 24 | 64 << 16 | 0), l.bits = x, 0;
}, Gi = Dh, E3 = pS, Po = mS, mY = uY, zd = pY, gY = 0, wS = 1, _S = 2, O8 = 4, vY = 5, O2 = 6, xc = 0, bY = 1, xY = 2, Ca = -2, AS = -3, ES = -4, yY = -5, R8 = 8, SS = 1, P8 = 2, I8 = 3, B8 = 4, L8 = 5, N8 = 6, M8 = 7, U8 = 8, z8 = 9, $8 = 10, X5 = 11, Ws = 12, t4 = 13, V8 = 14, r4 = 15, j8 = 16, W8 = 17, H8 = 18, q8 = 19, R2 = 20, P2 = 21, Y8 = 22, G8 = 23, Z8 = 24, X8 = 25, K8 = 26, n4 = 27, J8 = 28, Q8 = 29, dr = 30, CS = 31, wY = 32, _Y = 852, AY = 592, EY = 15, SY = EY;
function ew(t) {
  return (t >>> 24 & 255) + (t >>> 8 & 65280) + ((t & 65280) << 8) + ((t & 255) << 24);
}
function CY() {
  this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Gi.Buf16(320), this.work = new Gi.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
function kS(t) {
  var e;
  return !t || !t.state ? Ca : (e = t.state, t.total_in = t.total_out = e.total = 0, t.msg = "", e.wrap && (t.adler = e.wrap & 1), e.mode = SS, e.last = 0, e.havedict = 0, e.dmax = 32768, e.head = null, e.hold = 0, e.bits = 0, e.lencode = e.lendyn = new Gi.Buf32(_Y), e.distcode = e.distdyn = new Gi.Buf32(AY), e.sane = 1, e.back = -1, xc);
}
function TS(t) {
  var e;
  return !t || !t.state ? Ca : (e = t.state, e.wsize = 0, e.whave = 0, e.wnext = 0, kS(t));
}
function FS(t, e) {
  var r, n;
  return !t || !t.state || (n = t.state, e < 0 ? (r = 0, e = -e) : (r = (e >> 4) + 1, e < 48 && (e &= 15)), e && (e < 8 || e > 15)) ? Ca : (n.window !== null && n.wbits !== e && (n.window = null), n.wrap = r, n.wbits = e, TS(t));
}
function DS(t, e) {
  var r, n;
  return t ? (n = new CY(), t.state = n, n.window = null, r = FS(t, e), r !== xc && (t.state = null), r) : Ca;
}
function kY(t) {
  return DS(t, SY);
}
var tw = !0, i4, a4;
function TY(t) {
  if (tw) {
    var e;
    for (i4 = new Gi.Buf32(512), a4 = new Gi.Buf32(32), e = 0; e < 144; )
      t.lens[e++] = 8;
    for (; e < 256; )
      t.lens[e++] = 9;
    for (; e < 280; )
      t.lens[e++] = 7;
    for (; e < 288; )
      t.lens[e++] = 8;
    for (zd(wS, t.lens, 0, 288, i4, 0, t.work, { bits: 9 }), e = 0; e < 32; )
      t.lens[e++] = 5;
    zd(_S, t.lens, 0, 32, a4, 0, t.work, { bits: 5 }), tw = !1;
  }
  t.lencode = i4, t.lenbits = 9, t.distcode = a4, t.distbits = 5;
}
function OS(t, e, r, n) {
  var i, a = t.state;
  return a.window === null && (a.wsize = 1 << a.wbits, a.wnext = 0, a.whave = 0, a.window = new Gi.Buf8(a.wsize)), n >= a.wsize ? (Gi.arraySet(a.window, e, r - a.wsize, a.wsize, 0), a.wnext = 0, a.whave = a.wsize) : (i = a.wsize - a.wnext, i > n && (i = n), Gi.arraySet(a.window, e, r - n, i, a.wnext), n -= i, n ? (Gi.arraySet(a.window, e, r - n, n, 0), a.wnext = n, a.whave = a.wsize) : (a.wnext += i, a.wnext === a.wsize && (a.wnext = 0), a.whave < a.wsize && (a.whave += i))), 0;
}
function FY(t, e) {
  var r, n, i, a, o, s, l, u, d, h, v, b, x, A, T = 0, k, E, C, D, _, I, R, U, V = new Gi.Buf8(4), z, j, S = (
    /* permutation of code lengths */
    [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
  );
  if (!t || !t.state || !t.output || !t.input && t.avail_in !== 0)
    return Ca;
  r = t.state, r.mode === Ws && (r.mode = t4), o = t.next_out, i = t.output, l = t.avail_out, a = t.next_in, n = t.input, s = t.avail_in, u = r.hold, d = r.bits, h = s, v = l, U = xc;
  e:
    for (; ; )
      switch (r.mode) {
        case SS:
          if (r.wrap === 0) {
            r.mode = t4;
            break;
          }
          for (; d < 16; ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          if (r.wrap & 2 && u === 35615) {
            r.check = 0, V[0] = u & 255, V[1] = u >>> 8 & 255, r.check = Po(r.check, V, 2, 0), u = 0, d = 0, r.mode = P8;
            break;
          }
          if (r.flags = 0, r.head && (r.head.done = !1), !(r.wrap & 1) || /* check if zlib header allowed */
          (((u & 255) << 8) + (u >> 8)) % 31) {
            t.msg = "incorrect header check", r.mode = dr;
            break;
          }
          if ((u & 15) !== R8) {
            t.msg = "unknown compression method", r.mode = dr;
            break;
          }
          if (u >>>= 4, d -= 4, R = (u & 15) + 8, r.wbits === 0)
            r.wbits = R;
          else if (R > r.wbits) {
            t.msg = "invalid window size", r.mode = dr;
            break;
          }
          r.dmax = 1 << R, t.adler = r.check = 1, r.mode = u & 512 ? $8 : Ws, u = 0, d = 0;
          break;
        case P8:
          for (; d < 16; ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          if (r.flags = u, (r.flags & 255) !== R8) {
            t.msg = "unknown compression method", r.mode = dr;
            break;
          }
          if (r.flags & 57344) {
            t.msg = "unknown header flags set", r.mode = dr;
            break;
          }
          r.head && (r.head.text = u >> 8 & 1), r.flags & 512 && (V[0] = u & 255, V[1] = u >>> 8 & 255, r.check = Po(r.check, V, 2, 0)), u = 0, d = 0, r.mode = I8;
        case I8:
          for (; d < 32; ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          r.head && (r.head.time = u), r.flags & 512 && (V[0] = u & 255, V[1] = u >>> 8 & 255, V[2] = u >>> 16 & 255, V[3] = u >>> 24 & 255, r.check = Po(r.check, V, 4, 0)), u = 0, d = 0, r.mode = B8;
        case B8:
          for (; d < 16; ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          r.head && (r.head.xflags = u & 255, r.head.os = u >> 8), r.flags & 512 && (V[0] = u & 255, V[1] = u >>> 8 & 255, r.check = Po(r.check, V, 2, 0)), u = 0, d = 0, r.mode = L8;
        case L8:
          if (r.flags & 1024) {
            for (; d < 16; ) {
              if (s === 0)
                break e;
              s--, u += n[a++] << d, d += 8;
            }
            r.length = u, r.head && (r.head.extra_len = u), r.flags & 512 && (V[0] = u & 255, V[1] = u >>> 8 & 255, r.check = Po(r.check, V, 2, 0)), u = 0, d = 0;
          } else r.head && (r.head.extra = null);
          r.mode = N8;
        case N8:
          if (r.flags & 1024 && (b = r.length, b > s && (b = s), b && (r.head && (R = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), Gi.arraySet(
            r.head.extra,
            n,
            a,
            // extra field is limited to 65536 bytes
            // - no need for additional size check
            b,
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            R
          )), r.flags & 512 && (r.check = Po(r.check, n, b, a)), s -= b, a += b, r.length -= b), r.length))
            break e;
          r.length = 0, r.mode = M8;
        case M8:
          if (r.flags & 2048) {
            if (s === 0)
              break e;
            b = 0;
            do
              R = n[a + b++], r.head && R && r.length < 65536 && (r.head.name += String.fromCharCode(R));
            while (R && b < s);
            if (r.flags & 512 && (r.check = Po(r.check, n, b, a)), s -= b, a += b, R)
              break e;
          } else r.head && (r.head.name = null);
          r.length = 0, r.mode = U8;
        case U8:
          if (r.flags & 4096) {
            if (s === 0)
              break e;
            b = 0;
            do
              R = n[a + b++], r.head && R && r.length < 65536 && (r.head.comment += String.fromCharCode(R));
            while (R && b < s);
            if (r.flags & 512 && (r.check = Po(r.check, n, b, a)), s -= b, a += b, R)
              break e;
          } else r.head && (r.head.comment = null);
          r.mode = z8;
        case z8:
          if (r.flags & 512) {
            for (; d < 16; ) {
              if (s === 0)
                break e;
              s--, u += n[a++] << d, d += 8;
            }
            if (u !== (r.check & 65535)) {
              t.msg = "header crc mismatch", r.mode = dr;
              break;
            }
            u = 0, d = 0;
          }
          r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), t.adler = r.check = 0, r.mode = Ws;
          break;
        case $8:
          for (; d < 32; ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          t.adler = r.check = ew(u), u = 0, d = 0, r.mode = X5;
        case X5:
          if (r.havedict === 0)
            return t.next_out = o, t.avail_out = l, t.next_in = a, t.avail_in = s, r.hold = u, r.bits = d, xY;
          t.adler = r.check = 1, r.mode = Ws;
        case Ws:
          if (e === vY || e === O2)
            break e;
        case t4:
          if (r.last) {
            u >>>= d & 7, d -= d & 7, r.mode = n4;
            break;
          }
          for (; d < 3; ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          switch (r.last = u & 1, u >>>= 1, d -= 1, u & 3) {
            case 0:
              r.mode = V8;
              break;
            case 1:
              if (TY(r), r.mode = R2, e === O2) {
                u >>>= 2, d -= 2;
                break e;
              }
              break;
            case 2:
              r.mode = W8;
              break;
            case 3:
              t.msg = "invalid block type", r.mode = dr;
          }
          u >>>= 2, d -= 2;
          break;
        case V8:
          for (u >>>= d & 7, d -= d & 7; d < 32; ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          if ((u & 65535) !== (u >>> 16 ^ 65535)) {
            t.msg = "invalid stored block lengths", r.mode = dr;
            break;
          }
          if (r.length = u & 65535, u = 0, d = 0, r.mode = r4, e === O2)
            break e;
        case r4:
          r.mode = j8;
        case j8:
          if (b = r.length, b) {
            if (b > s && (b = s), b > l && (b = l), b === 0)
              break e;
            Gi.arraySet(i, n, a, b, o), s -= b, a += b, l -= b, o += b, r.length -= b;
            break;
          }
          r.mode = Ws;
          break;
        case W8:
          for (; d < 14; ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          if (r.nlen = (u & 31) + 257, u >>>= 5, d -= 5, r.ndist = (u & 31) + 1, u >>>= 5, d -= 5, r.ncode = (u & 15) + 4, u >>>= 4, d -= 4, r.nlen > 286 || r.ndist > 30) {
            t.msg = "too many length or distance symbols", r.mode = dr;
            break;
          }
          r.have = 0, r.mode = H8;
        case H8:
          for (; r.have < r.ncode; ) {
            for (; d < 3; ) {
              if (s === 0)
                break e;
              s--, u += n[a++] << d, d += 8;
            }
            r.lens[S[r.have++]] = u & 7, u >>>= 3, d -= 3;
          }
          for (; r.have < 19; )
            r.lens[S[r.have++]] = 0;
          if (r.lencode = r.lendyn, r.lenbits = 7, z = { bits: r.lenbits }, U = zd(gY, r.lens, 0, 19, r.lencode, 0, r.work, z), r.lenbits = z.bits, U) {
            t.msg = "invalid code lengths set", r.mode = dr;
            break;
          }
          r.have = 0, r.mode = q8;
        case q8:
          for (; r.have < r.nlen + r.ndist; ) {
            for (; T = r.lencode[u & (1 << r.lenbits) - 1], k = T >>> 24, E = T >>> 16 & 255, C = T & 65535, !(k <= d); ) {
              if (s === 0)
                break e;
              s--, u += n[a++] << d, d += 8;
            }
            if (C < 16)
              u >>>= k, d -= k, r.lens[r.have++] = C;
            else {
              if (C === 16) {
                for (j = k + 2; d < j; ) {
                  if (s === 0)
                    break e;
                  s--, u += n[a++] << d, d += 8;
                }
                if (u >>>= k, d -= k, r.have === 0) {
                  t.msg = "invalid bit length repeat", r.mode = dr;
                  break;
                }
                R = r.lens[r.have - 1], b = 3 + (u & 3), u >>>= 2, d -= 2;
              } else if (C === 17) {
                for (j = k + 3; d < j; ) {
                  if (s === 0)
                    break e;
                  s--, u += n[a++] << d, d += 8;
                }
                u >>>= k, d -= k, R = 0, b = 3 + (u & 7), u >>>= 3, d -= 3;
              } else {
                for (j = k + 7; d < j; ) {
                  if (s === 0)
                    break e;
                  s--, u += n[a++] << d, d += 8;
                }
                u >>>= k, d -= k, R = 0, b = 11 + (u & 127), u >>>= 7, d -= 7;
              }
              if (r.have + b > r.nlen + r.ndist) {
                t.msg = "invalid bit length repeat", r.mode = dr;
                break;
              }
              for (; b--; )
                r.lens[r.have++] = R;
            }
          }
          if (r.mode === dr)
            break;
          if (r.lens[256] === 0) {
            t.msg = "invalid code -- missing end-of-block", r.mode = dr;
            break;
          }
          if (r.lenbits = 9, z = { bits: r.lenbits }, U = zd(wS, r.lens, 0, r.nlen, r.lencode, 0, r.work, z), r.lenbits = z.bits, U) {
            t.msg = "invalid literal/lengths set", r.mode = dr;
            break;
          }
          if (r.distbits = 6, r.distcode = r.distdyn, z = { bits: r.distbits }, U = zd(_S, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, z), r.distbits = z.bits, U) {
            t.msg = "invalid distances set", r.mode = dr;
            break;
          }
          if (r.mode = R2, e === O2)
            break e;
        case R2:
          r.mode = P2;
        case P2:
          if (s >= 6 && l >= 258) {
            t.next_out = o, t.avail_out = l, t.next_in = a, t.avail_in = s, r.hold = u, r.bits = d, mY(t, v), o = t.next_out, i = t.output, l = t.avail_out, a = t.next_in, n = t.input, s = t.avail_in, u = r.hold, d = r.bits, r.mode === Ws && (r.back = -1);
            break;
          }
          for (r.back = 0; T = r.lencode[u & (1 << r.lenbits) - 1], k = T >>> 24, E = T >>> 16 & 255, C = T & 65535, !(k <= d); ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          if (E && !(E & 240)) {
            for (D = k, _ = E, I = C; T = r.lencode[I + ((u & (1 << D + _) - 1) >> D)], k = T >>> 24, E = T >>> 16 & 255, C = T & 65535, !(D + k <= d); ) {
              if (s === 0)
                break e;
              s--, u += n[a++] << d, d += 8;
            }
            u >>>= D, d -= D, r.back += D;
          }
          if (u >>>= k, d -= k, r.back += k, r.length = C, E === 0) {
            r.mode = K8;
            break;
          }
          if (E & 32) {
            r.back = -1, r.mode = Ws;
            break;
          }
          if (E & 64) {
            t.msg = "invalid literal/length code", r.mode = dr;
            break;
          }
          r.extra = E & 15, r.mode = Y8;
        case Y8:
          if (r.extra) {
            for (j = r.extra; d < j; ) {
              if (s === 0)
                break e;
              s--, u += n[a++] << d, d += 8;
            }
            r.length += u & (1 << r.extra) - 1, u >>>= r.extra, d -= r.extra, r.back += r.extra;
          }
          r.was = r.length, r.mode = G8;
        case G8:
          for (; T = r.distcode[u & (1 << r.distbits) - 1], k = T >>> 24, E = T >>> 16 & 255, C = T & 65535, !(k <= d); ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          if (!(E & 240)) {
            for (D = k, _ = E, I = C; T = r.distcode[I + ((u & (1 << D + _) - 1) >> D)], k = T >>> 24, E = T >>> 16 & 255, C = T & 65535, !(D + k <= d); ) {
              if (s === 0)
                break e;
              s--, u += n[a++] << d, d += 8;
            }
            u >>>= D, d -= D, r.back += D;
          }
          if (u >>>= k, d -= k, r.back += k, E & 64) {
            t.msg = "invalid distance code", r.mode = dr;
            break;
          }
          r.offset = C, r.extra = E & 15, r.mode = Z8;
        case Z8:
          if (r.extra) {
            for (j = r.extra; d < j; ) {
              if (s === 0)
                break e;
              s--, u += n[a++] << d, d += 8;
            }
            r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, d -= r.extra, r.back += r.extra;
          }
          if (r.offset > r.dmax) {
            t.msg = "invalid distance too far back", r.mode = dr;
            break;
          }
          r.mode = X8;
        case X8:
          if (l === 0)
            break e;
          if (b = v - l, r.offset > b) {
            if (b = r.offset - b, b > r.whave && r.sane) {
              t.msg = "invalid distance too far back", r.mode = dr;
              break;
            }
            b > r.wnext ? (b -= r.wnext, x = r.wsize - b) : x = r.wnext - b, b > r.length && (b = r.length), A = r.window;
          } else
            A = i, x = o - r.offset, b = r.length;
          b > l && (b = l), l -= b, r.length -= b;
          do
            i[o++] = A[x++];
          while (--b);
          r.length === 0 && (r.mode = P2);
          break;
        case K8:
          if (l === 0)
            break e;
          i[o++] = r.length, l--, r.mode = P2;
          break;
        case n4:
          if (r.wrap) {
            for (; d < 32; ) {
              if (s === 0)
                break e;
              s--, u |= n[a++] << d, d += 8;
            }
            if (v -= l, t.total_out += v, r.total += v, v && (t.adler = r.check = /*UPDATE(state.check, put - _out, _out);*/
            r.flags ? Po(r.check, i, v, o - v) : E3(r.check, i, v, o - v)), v = l, (r.flags ? u : ew(u)) !== r.check) {
              t.msg = "incorrect data check", r.mode = dr;
              break;
            }
            u = 0, d = 0;
          }
          r.mode = J8;
        case J8:
          if (r.wrap && r.flags) {
            for (; d < 32; ) {
              if (s === 0)
                break e;
              s--, u += n[a++] << d, d += 8;
            }
            if (u !== (r.total & 4294967295)) {
              t.msg = "incorrect length check", r.mode = dr;
              break;
            }
            u = 0, d = 0;
          }
          r.mode = Q8;
        case Q8:
          U = bY;
          break e;
        case dr:
          U = AS;
          break e;
        case CS:
          return ES;
        case wY:
        default:
          return Ca;
      }
  return t.next_out = o, t.avail_out = l, t.next_in = a, t.avail_in = s, r.hold = u, r.bits = d, (r.wsize || v !== t.avail_out && r.mode < dr && (r.mode < n4 || e !== O8)) && OS(t, t.output, t.next_out, v - t.avail_out), h -= t.avail_in, v -= t.avail_out, t.total_in += h, t.total_out += v, r.total += v, r.wrap && v && (t.adler = r.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
  r.flags ? Po(r.check, i, v, t.next_out - v) : E3(r.check, i, v, t.next_out - v)), t.data_type = r.bits + (r.last ? 64 : 0) + (r.mode === Ws ? 128 : 0) + (r.mode === R2 || r.mode === r4 ? 256 : 0), (h === 0 && v === 0 || e === O8) && U === xc && (U = yY), U;
}
function DY(t) {
  if (!t || !t.state)
    return Ca;
  var e = t.state;
  return e.window && (e.window = null), t.state = null, xc;
}
function OY(t, e) {
  var r;
  return !t || !t.state || (r = t.state, !(r.wrap & 2)) ? Ca : (r.head = e, e.done = !1, xc);
}
function RY(t, e) {
  var r = e.length, n, i, a;
  return !t || !t.state || (n = t.state, n.wrap !== 0 && n.mode !== X5) ? Ca : n.mode === X5 && (i = 1, i = E3(i, e, r, 0), i !== n.check) ? AS : (a = OS(t, e, r, r), a ? (n.mode = CS, ES) : (n.havedict = 1, xc));
}
co.inflateReset = TS;
co.inflateReset2 = FS;
co.inflateResetKeep = kS;
co.inflateInit = kY;
co.inflateInit2 = DS;
co.inflate = FY;
co.inflateEnd = DY;
co.inflateGetHeader = OY;
co.inflateSetDictionary = RY;
co.inflateInfo = "pako inflate (from Nodeca project)";
var PY = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_ERRNO: -1,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR: -5,
  //Z_VERSION_ERROR: -6,
  /* compression levels */
  Z_NO_COMPRESSION: 0,
  Z_BEST_SPEED: 1,
  Z_BEST_COMPRESSION: 9,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY: 0,
  Z_TEXT: 1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN: 2,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const IY = /* @__PURE__ */ On(PY);
var RS = { exports: {} };
function BY(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var o4 = { exports: {} };
const LY = {}, NY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: LY
}, Symbol.toStringTag, { value: "Module" })), MY = /* @__PURE__ */ kD(NY);
var rw;
function d0() {
  return rw || (rw = 1, function(t, e) {
    (function(r, n) {
      t.exports = n();
    })(Wt, function() {
      var r = r || function(n, i) {
        var a;
        if (typeof window < "u" && window.crypto && (a = window.crypto), typeof self < "u" && self.crypto && (a = self.crypto), typeof globalThis < "u" && globalThis.crypto && (a = globalThis.crypto), !a && typeof window < "u" && window.msCrypto && (a = window.msCrypto), !a && typeof Wt < "u" && Wt.crypto && (a = Wt.crypto), !a && typeof BY == "function")
          try {
            a = MY;
          } catch {
          }
        var o = function() {
          if (a) {
            if (typeof a.getRandomValues == "function")
              try {
                return a.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof a.randomBytes == "function")
              try {
                return a.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, s = Object.create || /* @__PURE__ */ function() {
          function E() {
          }
          return function(C) {
            var D;
            return E.prototype = C, D = new E(), E.prototype = null, D;
          };
        }(), l = {}, u = l.lib = {}, d = u.Base = /* @__PURE__ */ function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(E) {
              var C = s(this);
              return E && C.mixIn(E), (!C.hasOwnProperty("init") || this.init === C.init) && (C.init = function() {
                C.$super.init.apply(this, arguments);
              }), C.init.prototype = C, C.$super = this, C;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var E = this.extend();
              return E.init.apply(E, arguments), E;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(E) {
              for (var C in E)
                E.hasOwnProperty(C) && (this[C] = E[C]);
              E.hasOwnProperty("toString") && (this.toString = E.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), h = u.WordArray = d.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(E, C) {
            E = this.words = E || [], C != i ? this.sigBytes = C : this.sigBytes = E.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(E) {
            return (E || b).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(E) {
            var C = this.words, D = E.words, _ = this.sigBytes, I = E.sigBytes;
            if (this.clamp(), _ % 4)
              for (var R = 0; R < I; R++) {
                var U = D[R >>> 2] >>> 24 - R % 4 * 8 & 255;
                C[_ + R >>> 2] |= U << 24 - (_ + R) % 4 * 8;
              }
            else
              for (var V = 0; V < I; V += 4)
                C[_ + V >>> 2] = D[V >>> 2];
            return this.sigBytes += I, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var E = this.words, C = this.sigBytes;
            E[C >>> 2] &= 4294967295 << 32 - C % 4 * 8, E.length = n.ceil(C / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var E = d.clone.call(this);
            return E.words = this.words.slice(0), E;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(E) {
            for (var C = [], D = 0; D < E; D += 4)
              C.push(o());
            return new h.init(C, E);
          }
        }), v = l.enc = {}, b = v.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(E) {
            for (var C = E.words, D = E.sigBytes, _ = [], I = 0; I < D; I++) {
              var R = C[I >>> 2] >>> 24 - I % 4 * 8 & 255;
              _.push((R >>> 4).toString(16)), _.push((R & 15).toString(16));
            }
            return _.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(E) {
            for (var C = E.length, D = [], _ = 0; _ < C; _ += 2)
              D[_ >>> 3] |= parseInt(E.substr(_, 2), 16) << 24 - _ % 8 * 4;
            return new h.init(D, C / 2);
          }
        }, x = v.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(E) {
            for (var C = E.words, D = E.sigBytes, _ = [], I = 0; I < D; I++) {
              var R = C[I >>> 2] >>> 24 - I % 4 * 8 & 255;
              _.push(String.fromCharCode(R));
            }
            return _.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(E) {
            for (var C = E.length, D = [], _ = 0; _ < C; _++)
              D[_ >>> 2] |= (E.charCodeAt(_) & 255) << 24 - _ % 4 * 8;
            return new h.init(D, C);
          }
        }, A = v.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(E) {
            try {
              return decodeURIComponent(escape(x.stringify(E)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(E) {
            return x.parse(unescape(encodeURIComponent(E)));
          }
        }, T = u.BufferedBlockAlgorithm = d.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new h.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(E) {
            typeof E == "string" && (E = A.parse(E)), this._data.concat(E), this._nDataBytes += E.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(E) {
            var C, D = this._data, _ = D.words, I = D.sigBytes, R = this.blockSize, U = R * 4, V = I / U;
            E ? V = n.ceil(V) : V = n.max((V | 0) - this._minBufferSize, 0);
            var z = V * R, j = n.min(z * 4, I);
            if (z) {
              for (var S = 0; S < z; S += R)
                this._doProcessBlock(_, S);
              C = _.splice(0, z), D.sigBytes -= j;
            }
            return new h.init(C, j);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var E = d.clone.call(this);
            return E._data = this._data.clone(), E;
          },
          _minBufferSize: 0
        });
        u.Hasher = T.extend({
          /**
           * Configuration options.
           */
          cfg: d.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(E) {
            this.cfg = this.cfg.extend(E), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            T.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(E) {
            return this._append(E), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(E) {
            E && this._append(E);
            var C = this._doFinalize();
            return C;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(E) {
            return function(C, D) {
              return new E.init(D).finalize(C);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(E) {
            return function(C, D) {
              return new k.HMAC.init(E, D).finalize(C);
            };
          }
        });
        var k = l.algo = {};
        return l;
      }(Math);
      return r;
    });
  }(o4)), o4.exports;
}
(function(t, e) {
  (function(r, n) {
    t.exports = n(d0());
  })(Wt, function(r) {
    return function(n) {
      var i = r, a = i.lib, o = a.WordArray, s = a.Hasher, l = i.algo, u = [];
      (function() {
        for (var A = 0; A < 64; A++)
          u[A] = n.abs(n.sin(A + 1)) * 4294967296 | 0;
      })();
      var d = l.MD5 = s.extend({
        _doReset: function() {
          this._hash = new o.init([
            1732584193,
            4023233417,
            2562383102,
            271733878
          ]);
        },
        _doProcessBlock: function(A, T) {
          for (var k = 0; k < 16; k++) {
            var E = T + k, C = A[E];
            A[E] = (C << 8 | C >>> 24) & 16711935 | (C << 24 | C >>> 8) & 4278255360;
          }
          var D = this._hash.words, _ = A[T + 0], I = A[T + 1], R = A[T + 2], U = A[T + 3], V = A[T + 4], z = A[T + 5], j = A[T + 6], S = A[T + 7], B = A[T + 8], q = A[T + 9], Y = A[T + 10], Z = A[T + 11], Q = A[T + 12], J = A[T + 13], se = A[T + 14], ae = A[T + 15], te = D[0], ne = D[1], ce = D[2], pe = D[3];
          te = h(te, ne, ce, pe, _, 7, u[0]), pe = h(pe, te, ne, ce, I, 12, u[1]), ce = h(ce, pe, te, ne, R, 17, u[2]), ne = h(ne, ce, pe, te, U, 22, u[3]), te = h(te, ne, ce, pe, V, 7, u[4]), pe = h(pe, te, ne, ce, z, 12, u[5]), ce = h(ce, pe, te, ne, j, 17, u[6]), ne = h(ne, ce, pe, te, S, 22, u[7]), te = h(te, ne, ce, pe, B, 7, u[8]), pe = h(pe, te, ne, ce, q, 12, u[9]), ce = h(ce, pe, te, ne, Y, 17, u[10]), ne = h(ne, ce, pe, te, Z, 22, u[11]), te = h(te, ne, ce, pe, Q, 7, u[12]), pe = h(pe, te, ne, ce, J, 12, u[13]), ce = h(ce, pe, te, ne, se, 17, u[14]), ne = h(ne, ce, pe, te, ae, 22, u[15]), te = v(te, ne, ce, pe, I, 5, u[16]), pe = v(pe, te, ne, ce, j, 9, u[17]), ce = v(ce, pe, te, ne, Z, 14, u[18]), ne = v(ne, ce, pe, te, _, 20, u[19]), te = v(te, ne, ce, pe, z, 5, u[20]), pe = v(pe, te, ne, ce, Y, 9, u[21]), ce = v(ce, pe, te, ne, ae, 14, u[22]), ne = v(ne, ce, pe, te, V, 20, u[23]), te = v(te, ne, ce, pe, q, 5, u[24]), pe = v(pe, te, ne, ce, se, 9, u[25]), ce = v(ce, pe, te, ne, U, 14, u[26]), ne = v(ne, ce, pe, te, B, 20, u[27]), te = v(te, ne, ce, pe, J, 5, u[28]), pe = v(pe, te, ne, ce, R, 9, u[29]), ce = v(ce, pe, te, ne, S, 14, u[30]), ne = v(ne, ce, pe, te, Q, 20, u[31]), te = b(te, ne, ce, pe, z, 4, u[32]), pe = b(pe, te, ne, ce, B, 11, u[33]), ce = b(ce, pe, te, ne, Z, 16, u[34]), ne = b(ne, ce, pe, te, se, 23, u[35]), te = b(te, ne, ce, pe, I, 4, u[36]), pe = b(pe, te, ne, ce, V, 11, u[37]), ce = b(ce, pe, te, ne, S, 16, u[38]), ne = b(ne, ce, pe, te, Y, 23, u[39]), te = b(te, ne, ce, pe, J, 4, u[40]), pe = b(pe, te, ne, ce, _, 11, u[41]), ce = b(ce, pe, te, ne, U, 16, u[42]), ne = b(ne, ce, pe, te, j, 23, u[43]), te = b(te, ne, ce, pe, q, 4, u[44]), pe = b(pe, te, ne, ce, Q, 11, u[45]), ce = b(ce, pe, te, ne, ae, 16, u[46]), ne = b(ne, ce, pe, te, R, 23, u[47]), te = x(te, ne, ce, pe, _, 6, u[48]), pe = x(pe, te, ne, ce, S, 10, u[49]), ce = x(ce, pe, te, ne, se, 15, u[50]), ne = x(ne, ce, pe, te, z, 21, u[51]), te = x(te, ne, ce, pe, Q, 6, u[52]), pe = x(pe, te, ne, ce, U, 10, u[53]), ce = x(ce, pe, te, ne, Y, 15, u[54]), ne = x(ne, ce, pe, te, I, 21, u[55]), te = x(te, ne, ce, pe, B, 6, u[56]), pe = x(pe, te, ne, ce, ae, 10, u[57]), ce = x(ce, pe, te, ne, j, 15, u[58]), ne = x(ne, ce, pe, te, J, 21, u[59]), te = x(te, ne, ce, pe, V, 6, u[60]), pe = x(pe, te, ne, ce, Z, 10, u[61]), ce = x(ce, pe, te, ne, R, 15, u[62]), ne = x(ne, ce, pe, te, q, 21, u[63]), D[0] = D[0] + te | 0, D[1] = D[1] + ne | 0, D[2] = D[2] + ce | 0, D[3] = D[3] + pe | 0;
        },
        _doFinalize: function() {
          var A = this._data, T = A.words, k = this._nDataBytes * 8, E = A.sigBytes * 8;
          T[E >>> 5] |= 128 << 24 - E % 32;
          var C = n.floor(k / 4294967296), D = k;
          T[(E + 64 >>> 9 << 4) + 15] = (C << 8 | C >>> 24) & 16711935 | (C << 24 | C >>> 8) & 4278255360, T[(E + 64 >>> 9 << 4) + 14] = (D << 8 | D >>> 24) & 16711935 | (D << 24 | D >>> 8) & 4278255360, A.sigBytes = (T.length + 1) * 4, this._process();
          for (var _ = this._hash, I = _.words, R = 0; R < 4; R++) {
            var U = I[R];
            I[R] = (U << 8 | U >>> 24) & 16711935 | (U << 24 | U >>> 8) & 4278255360;
          }
          return _;
        },
        clone: function() {
          var A = s.clone.call(this);
          return A._hash = this._hash.clone(), A;
        }
      });
      function h(A, T, k, E, C, D, _) {
        var I = A + (T & k | ~T & E) + C + _;
        return (I << D | I >>> 32 - D) + T;
      }
      function v(A, T, k, E, C, D, _) {
        var I = A + (T & E | k & ~E) + C + _;
        return (I << D | I >>> 32 - D) + T;
      }
      function b(A, T, k, E, C, D, _) {
        var I = A + (T ^ k ^ E) + C + _;
        return (I << D | I >>> 32 - D) + T;
      }
      function x(A, T, k, E, C, D, _) {
        var I = A + (k ^ (T | ~E)) + C + _;
        return (I << D | I >>> 32 - D) + T;
      }
      i.MD5 = s._createHelper(d), i.HmacMD5 = s._createHmacHelper(d);
    }(Math), r.MD5;
  });
})(RS);
var uu = RS.exports;
const UY = /* @__PURE__ */ On(uu);
var PS = {};
(function(t) {
  var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  (function(r) {
    var n = typeof Uint8Array < "u" ? Uint8Array : Array, i = 43, a = 47, o = 48, s = 97, l = 65, u = 45, d = 95;
    function h(x) {
      var A = x.charCodeAt(0);
      if (A === i || A === u)
        return 62;
      if (A === a || A === d)
        return 63;
      if (A < o)
        return -1;
      if (A < o + 10)
        return A - o + 26 + 26;
      if (A < l + 26)
        return A - l;
      if (A < s + 26)
        return A - s + 26;
    }
    function v(x) {
      var A, T, k, E, C, D;
      if (x.length % 4 > 0)
        throw new Error("Invalid string. Length must be a multiple of 4");
      var _ = x.length;
      C = x.charAt(_ - 2) === "=" ? 2 : x.charAt(_ - 1) === "=" ? 1 : 0, D = new n(x.length * 3 / 4 - C), k = C > 0 ? x.length - 4 : x.length;
      var I = 0;
      function R(U) {
        D[I++] = U;
      }
      for (A = 0, T = 0; A < k; A += 4, T += 3)
        E = h(x.charAt(A)) << 18 | h(x.charAt(A + 1)) << 12 | h(x.charAt(A + 2)) << 6 | h(x.charAt(A + 3)), R((E & 16711680) >> 16), R((E & 65280) >> 8), R(E & 255);
      return C === 2 ? (E = h(x.charAt(A)) << 2 | h(x.charAt(A + 1)) >> 4, R(E & 255)) : C === 1 && (E = h(x.charAt(A)) << 10 | h(x.charAt(A + 1)) << 4 | h(x.charAt(A + 2)) >> 2, R(E >> 8 & 255), R(E & 255)), D;
    }
    function b(x) {
      var A, T = x.length % 3, k = "", E, C;
      function D(I) {
        return e.charAt(I);
      }
      function _(I) {
        return D(I >> 18 & 63) + D(I >> 12 & 63) + D(I >> 6 & 63) + D(I & 63);
      }
      for (A = 0, C = x.length - T; A < C; A += 3)
        E = (x[A] << 16) + (x[A + 1] << 8) + x[A + 2], k += _(E);
      switch (T) {
        case 1:
          E = x[x.length - 1], k += D(E >> 2), k += D(E << 4 & 63), k += "==";
          break;
        case 2:
          E = (x[x.length - 2] << 8) + x[x.length - 1], k += D(E >> 10), k += D(E >> 4 & 63), k += D(E << 2 & 63), k += "=";
          break;
      }
      return k;
    }
    r.toByteArray = v, r.fromByteArray = b;
  })(t);
})(PS);
const zY = /* @__PURE__ */ On(PS);
var IS = {};
const $Y = 5, nw = 12, VY = 13, jY = 16, WY = 17, HY = 22, iw = 28, aw = 31, qY = 33, l5 = 34, YY = 35, s4 = 36, S3 = 37, BS = 38, GY = 39, ZY = 40, Dd = 41, XY = 42, L = 0, $ = 1, _0 = 2, LS = 3, K = 4, KY = [
  //OP   , CL    , CP    , QU    , GL    , NS    , EX    , SY    , IS    , PR    , PO    , NU    , AL    , HL    , ID    , IN    , HY    , BA    , BB    , B2    , ZW    , CM    , WJ    , H2    , H3    , JL    , JV    , JT    , RI    , EB    , EM    , ZWJ   , CB
  [
    K,
    K,
    K,
    K,
    K,
    K,
    K,
    K,
    K,
    K,
    K,
    K,
    K,
    K,
    K,
    K,
    K,
    K,
    K,
    K,
    K,
    LS,
    K,
    K,
    K,
    K,
    K,
    K,
    K,
    K,
    K,
    K,
    K
  ],
  [
    L,
    K,
    K,
    $,
    $,
    K,
    K,
    K,
    K,
    $,
    $,
    L,
    L,
    L,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    L
  ],
  [
    L,
    K,
    K,
    $,
    $,
    K,
    K,
    K,
    K,
    $,
    $,
    $,
    $,
    $,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    L
  ],
  [
    K,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    K,
    _0,
    K,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $
  ],
  [
    $,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    K,
    _0,
    K,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $
  ],
  [
    L,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    L
  ],
  [
    L,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    L
  ],
  [
    L,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    L,
    L,
    $,
    L,
    $,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    L
  ],
  [
    L,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    L,
    L,
    $,
    $,
    $,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    L
  ],
  [
    $,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    L,
    L,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    $,
    $,
    $,
    $,
    $,
    L,
    $,
    $,
    $,
    L
  ],
  [
    $,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    L,
    L,
    $,
    $,
    $,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    L
  ],
  [
    $,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    $,
    $,
    $,
    $,
    $,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    L
  ],
  [
    $,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    $,
    $,
    $,
    $,
    $,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    L
  ],
  [
    $,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    $,
    $,
    $,
    $,
    $,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    L
  ],
  [
    L,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    L,
    $,
    L,
    L,
    L,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    L
  ],
  [
    L,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    L
  ],
  [
    L,
    K,
    K,
    $,
    L,
    $,
    K,
    K,
    K,
    L,
    L,
    $,
    L,
    L,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    L
  ],
  [
    L,
    K,
    K,
    $,
    L,
    $,
    K,
    K,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    L
  ],
  [
    $,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    K,
    _0,
    K,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    L
  ],
  [
    L,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    $,
    $,
    L,
    K,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    L
  ],
  [
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L
  ],
  [
    $,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    $,
    $,
    $,
    $,
    $,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    L
  ],
  [
    $,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    K,
    _0,
    K,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $,
    $
  ],
  [
    L,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    L,
    $,
    L,
    L,
    L,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    $,
    $,
    L,
    L,
    L,
    $,
    L
  ],
  [
    L,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    L,
    $,
    L,
    L,
    L,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    $,
    L,
    L,
    L,
    $,
    L
  ],
  [
    L,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    L,
    $,
    L,
    L,
    L,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    $,
    $,
    $,
    $,
    L,
    L,
    L,
    L,
    $,
    L
  ],
  [
    L,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    L,
    $,
    L,
    L,
    L,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    $,
    $,
    L,
    L,
    L,
    $,
    L
  ],
  [
    L,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    L,
    $,
    L,
    L,
    L,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    $,
    L,
    L,
    L,
    $,
    L
  ],
  [
    L,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    $,
    L,
    L,
    $,
    L
  ],
  [
    L,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    L,
    $,
    L,
    L,
    L,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    $,
    L
  ],
  [
    L,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    L,
    $,
    L,
    L,
    L,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    L
  ],
  [
    $,
    K,
    K,
    $,
    $,
    $,
    K,
    K,
    K,
    $,
    $,
    $,
    $,
    $,
    L,
    $,
    $,
    $,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    L
  ],
  [
    L,
    K,
    K,
    $,
    $,
    L,
    K,
    K,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    K,
    _0,
    K,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    L,
    $,
    L
  ]
  // CB
], JY = zY.toByteArray("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"), QY = new Ch(JY), ow = function(t) {
  switch (t) {
    case qY:
      return nw;
    case GY:
    case ZY:
    case XY:
      return nw;
    case YY:
      return $Y;
    default:
      return t;
  }
}, sw = function(t) {
  switch (t) {
    case S3:
    case BS:
      return l5;
    case Dd:
      return HY;
    default:
      return t;
  }
};
class l4 {
  constructor(e, r = !1) {
    this.position = e, this.required = r;
  }
}
class eG {
  nextCodePoint() {
    const e = this.string.charCodeAt(this.pos++), r = this.string.charCodeAt(this.pos);
    return 55296 <= e && e <= 56319 && 56320 <= r && r <= 57343 ? (this.pos++, (e - 55296) * 1024 + (r - 56320) + 65536) : e;
  }
  nextCharClass() {
    return ow(QY.get(this.nextCodePoint()));
  }
  getSimpleBreak() {
    switch (this.nextClass) {
      case Dd:
        return !1;
      case l5:
      case S3:
      case BS:
        return this.curClass = l5, !1;
      case s4:
        return this.curClass = s4, !1;
    }
    return null;
  }
  getPairTableBreak(e) {
    let r = !1;
    switch (KY[this.curClass][this.nextClass]) {
      case L:
        r = !0;
        break;
      case $:
        r = e === Dd;
        break;
      case _0:
        if (r = e === Dd, !r)
          return r = !1, r;
        break;
      case LS:
        if (e !== Dd) return r;
        break;
    }
    return this.LB8a && (r = !1), this.LB21a && (this.curClass === jY || this.curClass === WY) ? (r = !1, this.LB21a = !1) : this.LB21a = this.curClass === VY, this.curClass === iw ? (this.LB30a++, this.LB30a == 2 && this.nextClass === iw && (r = !0, this.LB30a = 0)) : this.LB30a = 0, this.curClass = this.nextClass, r;
  }
  nextBreak() {
    if (this.curClass == null) {
      let e = this.nextCharClass();
      this.curClass = sw(e), this.nextClass = e, this.LB8a = e === aw, this.LB30a = 0;
    }
    for (; this.pos < this.string.length; ) {
      this.lastPos = this.pos;
      const e = this.nextClass;
      if (this.nextClass = this.nextCharClass(), this.curClass === l5 || this.curClass === s4 && this.nextClass !== S3)
        return this.curClass = sw(ow(this.nextClass)), new l4(this.lastPos, !0);
      let r = this.getSimpleBreak();
      if (r === null && (r = this.getPairTableBreak(e)), this.LB8a = this.nextClass === aw, r) return new l4(this.lastPos);
    }
    return this.lastPos < this.string.length ? (this.lastPos = this.string.length, new l4(this.string.length)) : null;
  }
  constructor(e) {
    this.string = e, this.pos = 0, this.lastPos = 0, this.curClass = null, this.nextClass = null, this.LB8a = !1, this.LB21a = !1, this.LB30a = 0;
  }
}
IS = eG;
const tG = new xe({
  identifier: new Fn(1),
  value: new Fn(1)
}), rG = {
  name: () => "DAC",
  length: un,
  tables: new ue(tG, (t) => t.length / 2)
}, NS = (t, e) => t[e], lw = (t, e) => t[e] << 8 | t[e + 1], uw = (t, e) => t[e] | t[e + 1] << 8, u4 = (t, e) => MS(t, e) >>> 0, c4 = (t, e) => US(t, e) >>> 0, cw = (t) => Array.from(
  t,
  (e) => e.toString(16).padStart(2, "0")
).join(""), nG = new TextDecoder("utf-8"), iG = (t) => nG.decode(t), aG = (t) => {
  const e = t.reduce((i, a) => i + a.length, 0), r = new Uint8Array(e);
  let n = 0;
  return t.forEach((i) => {
    r.set(i, n), n += i.length;
  }), r;
}, MS = (t, e) => t[e] << 24 | t[e + 1] << 16 | t[e + 2] << 8 | t[e + 3], US = (t, e) => t[e] | t[e + 1] << 8 | t[e + 2] << 16 | t[e + 3] << 24;
class oG {
  decode(e, r) {
    const n = {};
    let i = e.buffer.slice(
      e.pos,
      e.pos + r.length - 2
    );
    for (; i.length > 0; ) {
      let a = 1;
      const o = [], s = NS(i, 0), l = i.slice(a, a + 16);
      a += 16;
      for (const u of l)
        o.push(i.slice(a, a + u)), a += u;
      i = i.slice(a), n[s] = aG(o);
    }
    return e.pos += r.length - 2, n;
  }
}
const sG = {
  name: () => "DHT",
  length: un,
  tables: new oG()
}, lG = {
  name: () => "DQT",
  length: un,
  tables: new ue(
    new xe({
      identifier: new Fn(1),
      data: new Fn(64)
    }),
    (t) => (t.length - 2) / 65
  )
}, uG = {
  name: () => "DRI",
  length: un,
  restartInterval: un
}, cG = {
  name: () => "EOI",
  afterEOI: new J0(ze, 1 / 0)
}, f4 = {
  ifd: {
    "010e": "imageDescription",
    "010f": "make",
    "011a": "xResolution",
    "011b": "yResolution",
    "011c": "planarConfiguration",
    "012d": "transferFunction",
    "013b": "artist",
    "013e": "whitePoint",
    "013f": "primaryChromaticities",
    "0100": "imageWidth",
    "0101": "imageHeight",
    "0102": "bitsPerSample",
    "0103": "compression",
    "0106": "photometricInterpretation",
    "0110": "model",
    "0111": "stripOffsets",
    "0112": "orientation",
    "0115": "samplesPerPixel",
    "0116": "rowsPerStrip",
    "0117": "stripByteCounts",
    "0128": "resolutionUnit",
    "0131": "software",
    "0132": "dateTime",
    "0201": "jpegInterchangeFormat",
    "0202": "jpegInterchangeFormatLength",
    "0211": "ycbCrCoefficients",
    "0212": "ycbCrSubSampling",
    "0213": "ycbCrPositioning",
    "0214": "referenceBlackWhite",
    "829a": "exposureTime",
    "829d": "fNumber",
    "920a": "focalLength",
    "927c": "makerNote",
    8298: "copyright",
    8769: "exifIFDPointer",
    8822: "exposureProgram",
    8824: "spectralSensitivity",
    8825: "gpsInfoIFDPointer",
    8827: "photographicSensitivity",
    8828: "oecf",
    8830: "sensitivityType",
    8831: "standardOutputSensitivity",
    8832: "recommendedExposureIndex",
    8833: "isoSpeed",
    8834: "isoSpeedLatitudeyyy",
    8835: "isoSpeedLatitudezzz",
    9e3: "exifVersion",
    9003: "dateTimeOriginal",
    9004: "dateTimeDigitized",
    9101: "componentsConfiguration",
    9102: "compressedBitsPerPixel",
    9201: "shutterSpeedValue",
    9202: "apertureValue",
    9203: "brightnessValue",
    9204: "exposureBiasValue",
    9205: "maxApertureValue",
    9206: "subjectDistance",
    9207: "meteringMode",
    9208: "lightSource",
    9209: "flash",
    9214: "subjectArea",
    9286: "userComment",
    9290: "subSecTime",
    9291: "subSecTimeOriginal",
    9292: "subSecTimeDigitized",
    a000: "flashpixVersion",
    a001: "colorSpace",
    a002: "pixelXDimension",
    a003: "pixelYDimension",
    a004: "relatedSoundFile",
    a005: "interoperabilityIFDPointer",
    a20b: "flashEnergy",
    a20c: "spatialFrequencyResponse",
    a20e: "focalPlaneXResolution",
    a20f: "focalPlaneYResolution",
    a40a: "sharpness",
    a40b: "deviceSettingDescription",
    a40c: "subjectDistanceRange",
    a210: "focalPlaneResolutionUnit",
    a214: "subjectLocation",
    a215: "exposureIndex",
    a217: "sensingMethod",
    a300: "fileSource",
    a301: "sceneType",
    a302: "cfaPattern",
    a401: "customRendered",
    a402: "exposureMode",
    a403: "whiteBalance",
    a404: "digitalZoomRatio",
    a405: "focalLengthIn35mmFilm",
    a406: "sceneCaptureType",
    a407: "gainControl",
    a408: "contrast",
    a409: "saturation",
    a420: "imageUniqueID",
    a430: "cameraOwnerName",
    a431: "bodySerialNumber",
    a432: "lensSpecification",
    a433: "lensMake",
    a434: "lensModel",
    a435: "lensSerialNumber",
    a500: "gamma"
  },
  gps: {
    "0000": "gpsVersionID",
    "0001": "gpsLatitudeRef",
    "0002": "gpsLatitude",
    "0003": "gpsLongitudeRef",
    "0004": "gpsLongitude",
    "0005": "gpsAltitudeRef",
    "0006": "gpsAltitude",
    "0007": "gpsTimeStamp",
    "0008": "gpsSatellites",
    "0009": "gpsStatus",
    "000a": "gpsMeasureMode",
    "000b": "gpsDOP",
    "000c": "gpsSpeedRef",
    "000d": "gpsSpeed",
    "000e": "gpsTrackRef",
    "000f": "gpsTrack",
    "0010": "gpsImgDirectionRef",
    "0011": "gpsImgDirection",
    "0012": "gpsMapDatum",
    "0013": "gpsDestLatitudeRef",
    "0014": "gpsDestLatitude",
    "0015": "gpsDestLongitudeRef",
    "0016": "gpsDestLongitude",
    "0017": "gpsDestBearingRef",
    "0018": "gpsDestBearing",
    "0019": "gpsDestDistanceRef",
    "001a": "gpsDestDistance",
    "001b": "gpsProcessingMethod",
    "001c": "gpsAreaInformation",
    "001d": "gpsDateStamp",
    "001e": "gpsDifferential",
    "001f": "gpsHPositioningError"
  }
};
class fG {
  constructor(e) {
    this.bigEndian = e, this.bytes = [0, 1, 1, 2, 4, 8, 1, 1, 2, 4, 8, 4, 8];
  }
  _getTagValue(e, r, n) {
    switch (r) {
      case 2:
        return e.toString("ascii").replace(/\0+$/, "");
      case 129:
        return e.toString("utf8").replace(/\0+$/, "");
      case 7:
        return "0x" + e.toString("hex");
      default:
        return this._getTagValueForNumericalData(e, r, n);
    }
  }
  _getTagValueForNumericalData(e, r, n) {
    const i = [], a = this.bytes[r];
    for (let o = 0; o < n; o += 1)
      i.push(this._getSingleTagValueForNumericalData(e, r, o * a));
    return i.length === 1 ? i[0] : i;
  }
  _getSingleTagValueForNumericalData(e, r, n) {
    const i = (s) => this.bigEndian ? lw(e, s) : uw(e, s), a = (s) => this.bigEndian ? u4(e, s) : c4(e, s), o = (s) => this.bigEndian ? MS(e, s) : US(e, s);
    switch (r) {
      case 1:
        return NS(e, n);
      case 3:
        return i(n);
      case 4:
        return a(n);
      case 5:
        return a(n) / a(n + 4);
      case 9:
        return o(n);
      case 10:
        return o(n) / o(n + 4);
    }
  }
  _decodeIDFEntries(e, r, n, i = !1) {
    let a = 2 + n;
    const o = {}, s = (d) => this.bigEndian ? lw(e, d) : uw(e, d), l = (d) => this.bigEndian ? u4(e, d) : c4(e, d), u = s(n);
    for (let d = 0; d < u; d++) {
      const h = e.slice(a, a + 2), v = s(a + 2), b = l(a + 4), x = this.bytes[v], A = b * x;
      let T = e.slice(a + 8, a + 12);
      if (A > 4) {
        const D = this.bigEndian ? u4(T, 0) : c4(T, 0);
        T = e.slice(D, D + A);
      }
      const k = this._getTagValue(T, v, b), E = this.bigEndian ? cw(h) : cw(h.reverse()), C = r[E];
      o[C] = k, a += 12;
    }
    return o;
  }
  decode(e, r) {
    const n = e.buffer.slice(e.pos - 8), i = r.offsetToFirstIFD;
    if (i > n.length)
      return e.pos += r.parent.length - 16, {};
    const a = this._decodeIDFEntries(n, f4.ifd, i), { exifIFDPointer: o, gpsInfoIFDPointer: s } = a;
    if (o && (a.subExif = this._decodeIDFEntries(
      n,
      f4.ifd,
      o
    )), s) {
      const l = s;
      a.gpsInfo = this._decodeIDFEntries(n, f4.gps, l, !0);
    }
    return e.pos += r.parent.length - 16, a;
  }
}
const dG = (t) => {
  const e = t ? un : tU, r = t ? JA : nU;
  return new xe({
    fortyTwo: e,
    offsetToFirstIFD: r,
    entries: new fG(t)
  });
};
class hG {
  decode(e, r) {
    const i = iG(
      e.buffer.slice(e.pos, e.pos + 2)
    ) === "MM";
    return e.pos += 2, dG(i).decode(e, r).entries;
  }
}
const pG = {
  name: () => "EXIF",
  length: un,
  identifier: new A0(6),
  entries: new hG()
}, mG = {
  name: () => "JFIF",
  length: un,
  identifier: new A0(5),
  version: un,
  units: ze,
  xDensity: un,
  yDensity: un,
  thumbnailWidth: ze,
  thumbnailHeight: ze
};
class gG {
  decode(e) {
    const r = e.buffer.slice(e.pos);
    let n = 0, i = r.indexOf(255);
    for (; i !== -1; ) {
      n = i;
      const a = r[n + 1], o = a >= 208 && a <= 215;
      if (a !== 0 && !o) break;
      i = r.indexOf(255, i + 1);
    }
    return e.pos += n, r.slice(0, n);
  }
}
const vG = new xe({
  scanComponentSelector: ze,
  entropyCodingTable: new Fn(1)
}), bG = {
  name: () => "SOS",
  length: un,
  numberOfImageComponents: ze,
  componentSpecifications: new ue(
    vG,
    (t) => t.numberOfImageComponents
  ),
  startOfSpectral: ze,
  endOfSpectral: ze,
  successiveApproximationBit: new Fn(1),
  data: new gG()
}, xG = new xe({
  id: ze,
  samplingFactors: ze,
  quantizationTableId: ze
}), Hi = {
  name: () => "SOF",
  length: un,
  precision: ze,
  height: un,
  width: un,
  numberOfComponents: ze,
  components: new ue(
    xG,
    (t) => t.numberOfComponents
  )
}, yG = {
  name: () => "SOI"
}, wG = {
  length: un,
  buf: new Fn((t) => t.length - 2)
}, _G = Array(63).fill(0).reduce((t, e, r) => ({ ...t, [r + 65472]: wG }), {}), AG = new qt(un, {
  ..._G,
  65472: Hi,
  65473: Hi,
  65474: Hi,
  65475: Hi,
  65476: sG,
  65477: Hi,
  65478: Hi,
  65479: Hi,
  65481: Hi,
  65482: Hi,
  65483: Hi,
  65484: rG,
  65485: Hi,
  65486: Hi,
  65487: Hi,
  65496: yG,
  65497: cG,
  65498: bG,
  65499: lG,
  65501: uG,
  65504: mG,
  65505: pG
}), EG = new ue(AG), SG = (t) => EG.fromBuffer(t).map(({ version: r, ...n }) => ({ type: r, ...n })), CG = { decode: SG };
var yc = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {}, qo = [], ba = [], kG = typeof Uint8Array < "u" ? Uint8Array : Array, Hb = !1;
function zS() {
  Hb = !0;
  for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", e = 0, r = t.length; e < r; ++e)
    qo[e] = t[e], ba[t.charCodeAt(e)] = e;
  ba[45] = 62, ba[95] = 63;
}
function TG(t) {
  Hb || zS();
  var e, r, n, i, a, o, s = t.length;
  if (s % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  a = t[s - 2] === "=" ? 2 : t[s - 1] === "=" ? 1 : 0, o = new kG(s * 3 / 4 - a), n = a > 0 ? s - 4 : s;
  var l = 0;
  for (e = 0, r = 0; e < n; e += 4, r += 3)
    i = ba[t.charCodeAt(e)] << 18 | ba[t.charCodeAt(e + 1)] << 12 | ba[t.charCodeAt(e + 2)] << 6 | ba[t.charCodeAt(e + 3)], o[l++] = i >> 16 & 255, o[l++] = i >> 8 & 255, o[l++] = i & 255;
  return a === 2 ? (i = ba[t.charCodeAt(e)] << 2 | ba[t.charCodeAt(e + 1)] >> 4, o[l++] = i & 255) : a === 1 && (i = ba[t.charCodeAt(e)] << 10 | ba[t.charCodeAt(e + 1)] << 4 | ba[t.charCodeAt(e + 2)] >> 2, o[l++] = i >> 8 & 255, o[l++] = i & 255), o;
}
function FG(t) {
  return qo[t >> 18 & 63] + qo[t >> 12 & 63] + qo[t >> 6 & 63] + qo[t & 63];
}
function DG(t, e, r) {
  for (var n, i = [], a = e; a < r; a += 3)
    n = (t[a] << 16) + (t[a + 1] << 8) + t[a + 2], i.push(FG(n));
  return i.join("");
}
function fw(t) {
  Hb || zS();
  for (var e, r = t.length, n = r % 3, i = "", a = [], o = 16383, s = 0, l = r - n; s < l; s += o)
    a.push(DG(t, s, s + o > l ? l : s + o));
  return n === 1 ? (e = t[r - 1], i += qo[e >> 2], i += qo[e << 4 & 63], i += "==") : n === 2 && (e = (t[r - 2] << 8) + t[r - 1], i += qo[e >> 10], i += qo[e >> 4 & 63], i += qo[e << 2 & 63], i += "="), a.push(i), a.join("");
}
function Kp(t, e, r, n, i) {
  var a, o, s = i * 8 - n - 1, l = (1 << s) - 1, u = l >> 1, d = -7, h = r ? i - 1 : 0, v = r ? -1 : 1, b = t[e + h];
  for (h += v, a = b & (1 << -d) - 1, b >>= -d, d += s; d > 0; a = a * 256 + t[e + h], h += v, d -= 8)
    ;
  for (o = a & (1 << -d) - 1, a >>= -d, d += n; d > 0; o = o * 256 + t[e + h], h += v, d -= 8)
    ;
  if (a === 0)
    a = 1 - u;
  else {
    if (a === l)
      return o ? NaN : (b ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, n), a = a - u;
  }
  return (b ? -1 : 1) * o * Math.pow(2, a - n);
}
function $S(t, e, r, n, i, a) {
  var o, s, l, u = a * 8 - i - 1, d = (1 << u) - 1, h = d >> 1, v = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, b = n ? 0 : a - 1, x = n ? 1 : -1, A = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, o = d) : (o = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), o + h >= 1 ? e += v / l : e += v * Math.pow(2, 1 - h), e * l >= 2 && (o++, l /= 2), o + h >= d ? (s = 0, o = d) : o + h >= 1 ? (s = (e * l - 1) * Math.pow(2, i), o = o + h) : (s = e * Math.pow(2, h - 1) * Math.pow(2, i), o = 0)); i >= 8; t[r + b] = s & 255, b += x, s /= 256, i -= 8)
    ;
  for (o = o << i | s, u += i; u > 0; t[r + b] = o & 255, b += x, o /= 256, u -= 8)
    ;
  t[r + b - x] |= A * 128;
}
var OG = {}.toString, VS = Array.isArray || function(t) {
  return OG.call(t) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var jS = 50;
Re.TYPED_ARRAY_SUPPORT = yc.TYPED_ARRAY_SUPPORT !== void 0 ? yc.TYPED_ARRAY_SUPPORT : !0;
var RG = K5();
function K5() {
  return Re.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function Js(t, e) {
  if (K5() < e)
    throw new RangeError("Invalid typed array length");
  return Re.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e), t.__proto__ = Re.prototype) : (t === null && (t = new Re(e)), t.length = e), t;
}
function Re(t, e, r) {
  if (!Re.TYPED_ARRAY_SUPPORT && !(this instanceof Re))
    return new Re(t, e, r);
  if (typeof t == "number") {
    if (typeof e == "string")
      throw new Error(
        "If encoding is specified then the first argument must be a string"
      );
    return qb(this, t);
  }
  return WS(this, t, e, r);
}
Re.poolSize = 8192;
Re._augment = function(t) {
  return t.__proto__ = Re.prototype, t;
};
function WS(t, e, r, n) {
  if (typeof e == "number")
    throw new TypeError('"value" argument must not be a number');
  return typeof ArrayBuffer < "u" && e instanceof ArrayBuffer ? BG(t, e, r, n) : typeof e == "string" ? IG(t, e, r) : LG(t, e);
}
Re.from = function(t, e, r) {
  return WS(null, t, e, r);
};
Re.TYPED_ARRAY_SUPPORT && (Re.prototype.__proto__ = Uint8Array.prototype, Re.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && Re[Symbol.species]);
function HS(t) {
  if (typeof t != "number")
    throw new TypeError('"size" argument must be a number');
  if (t < 0)
    throw new RangeError('"size" argument must not be negative');
}
function PG(t, e, r, n) {
  return HS(e), e <= 0 ? Js(t, e) : r !== void 0 ? typeof n == "string" ? Js(t, e).fill(r, n) : Js(t, e).fill(r) : Js(t, e);
}
Re.alloc = function(t, e, r) {
  return PG(null, t, e, r);
};
function qb(t, e) {
  if (HS(e), t = Js(t, e < 0 ? 0 : Yb(e) | 0), !Re.TYPED_ARRAY_SUPPORT)
    for (var r = 0; r < e; ++r)
      t[r] = 0;
  return t;
}
Re.allocUnsafe = function(t) {
  return qb(null, t);
};
Re.allocUnsafeSlow = function(t) {
  return qb(null, t);
};
function IG(t, e, r) {
  if ((typeof r != "string" || r === "") && (r = "utf8"), !Re.isEncoding(r))
    throw new TypeError('"encoding" must be a valid string encoding');
  var n = qS(e, r) | 0;
  t = Js(t, n);
  var i = t.write(e, r);
  return i !== n && (t = t.slice(0, i)), t;
}
function C3(t, e) {
  var r = e.length < 0 ? 0 : Yb(e.length) | 0;
  t = Js(t, r);
  for (var n = 0; n < r; n += 1)
    t[n] = e[n] & 255;
  return t;
}
function BG(t, e, r, n) {
  if (e.byteLength, r < 0 || e.byteLength < r)
    throw new RangeError("'offset' is out of bounds");
  if (e.byteLength < r + (n || 0))
    throw new RangeError("'length' is out of bounds");
  return r === void 0 && n === void 0 ? e = new Uint8Array(e) : n === void 0 ? e = new Uint8Array(e, r) : e = new Uint8Array(e, r, n), Re.TYPED_ARRAY_SUPPORT ? (t = e, t.__proto__ = Re.prototype) : t = C3(t, e), t;
}
function LG(t, e) {
  if (ls(e)) {
    var r = Yb(e.length) | 0;
    return t = Js(t, r), t.length === 0 || e.copy(t, 0, 0, r), t;
  }
  if (e) {
    if (typeof ArrayBuffer < "u" && e.buffer instanceof ArrayBuffer || "length" in e)
      return typeof e.length != "number" || rZ(e.length) ? Js(t, 0) : C3(t, e);
    if (e.type === "Buffer" && VS(e.data))
      return C3(t, e.data);
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function Yb(t) {
  if (t >= K5())
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K5().toString(16) + " bytes");
  return t | 0;
}
function NG(t) {
  return +t != t && (t = 0), Re.alloc(+t);
}
Re.isBuffer = Zu;
function ls(t) {
  return !!(t != null && t._isBuffer);
}
Re.compare = function(e, r) {
  if (!ls(e) || !ls(r))
    throw new TypeError("Arguments must be Buffers");
  if (e === r) return 0;
  for (var n = e.length, i = r.length, a = 0, o = Math.min(n, i); a < o; ++a)
    if (e[a] !== r[a]) {
      n = e[a], i = r[a];
      break;
    }
  return n < i ? -1 : i < n ? 1 : 0;
};
Re.isEncoding = function(e) {
  switch (String(e).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return !0;
    default:
      return !1;
  }
};
Re.concat = function(e, r) {
  if (!VS(e))
    throw new TypeError('"list" argument must be an Array of Buffers');
  if (e.length === 0)
    return Re.alloc(0);
  var n;
  if (r === void 0)
    for (r = 0, n = 0; n < e.length; ++n)
      r += e[n].length;
  var i = Re.allocUnsafe(r), a = 0;
  for (n = 0; n < e.length; ++n) {
    var o = e[n];
    if (!ls(o))
      throw new TypeError('"list" argument must be an Array of Buffers');
    o.copy(i, a), a += o.length;
  }
  return i;
};
function qS(t, e) {
  if (ls(t))
    return t.length;
  if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer))
    return t.byteLength;
  typeof t != "string" && (t = "" + t);
  var r = t.length;
  if (r === 0) return 0;
  for (var n = !1; ; )
    switch (e) {
      case "ascii":
      case "latin1":
      case "binary":
        return r;
      case "utf8":
      case "utf-8":
      case void 0:
        return J5(t).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return r * 2;
      case "hex":
        return r >>> 1;
      case "base64":
        return QS(t).length;
      default:
        if (n) return J5(t).length;
        e = ("" + e).toLowerCase(), n = !0;
    }
}
Re.byteLength = qS;
function MG(t, e, r) {
  var n = !1;
  if ((e === void 0 || e < 0) && (e = 0), e > this.length || ((r === void 0 || r > this.length) && (r = this.length), r <= 0) || (r >>>= 0, e >>>= 0, r <= e))
    return "";
  for (t || (t = "utf8"); ; )
    switch (t) {
      case "hex":
        return GG(this, e, r);
      case "utf8":
      case "utf-8":
        return ZS(this, e, r);
      case "ascii":
        return qG(this, e, r);
      case "latin1":
      case "binary":
        return YG(this, e, r);
      case "base64":
        return WG(this, e, r);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return ZG(this, e, r);
      default:
        if (n) throw new TypeError("Unknown encoding: " + t);
        t = (t + "").toLowerCase(), n = !0;
    }
}
Re.prototype._isBuffer = !0;
function Gu(t, e, r) {
  var n = t[e];
  t[e] = t[r], t[r] = n;
}
Re.prototype.swap16 = function() {
  var e = this.length;
  if (e % 2 !== 0)
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  for (var r = 0; r < e; r += 2)
    Gu(this, r, r + 1);
  return this;
};
Re.prototype.swap32 = function() {
  var e = this.length;
  if (e % 4 !== 0)
    throw new RangeError("Buffer size must be a multiple of 32-bits");
  for (var r = 0; r < e; r += 4)
    Gu(this, r, r + 3), Gu(this, r + 1, r + 2);
  return this;
};
Re.prototype.swap64 = function() {
  var e = this.length;
  if (e % 8 !== 0)
    throw new RangeError("Buffer size must be a multiple of 64-bits");
  for (var r = 0; r < e; r += 8)
    Gu(this, r, r + 7), Gu(this, r + 1, r + 6), Gu(this, r + 2, r + 5), Gu(this, r + 3, r + 4);
  return this;
};
Re.prototype.toString = function() {
  var e = this.length | 0;
  return e === 0 ? "" : arguments.length === 0 ? ZS(this, 0, e) : MG.apply(this, arguments);
};
Re.prototype.equals = function(e) {
  if (!ls(e)) throw new TypeError("Argument must be a Buffer");
  return this === e ? !0 : Re.compare(this, e) === 0;
};
Re.prototype.inspect = function() {
  var e = "", r = jS;
  return this.length > 0 && (e = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (e += " ... ")), "<Buffer " + e + ">";
};
Re.prototype.compare = function(e, r, n, i, a) {
  if (!ls(e))
    throw new TypeError("Argument must be a Buffer");
  if (r === void 0 && (r = 0), n === void 0 && (n = e ? e.length : 0), i === void 0 && (i = 0), a === void 0 && (a = this.length), r < 0 || n > e.length || i < 0 || a > this.length)
    throw new RangeError("out of range index");
  if (i >= a && r >= n)
    return 0;
  if (i >= a)
    return -1;
  if (r >= n)
    return 1;
  if (r >>>= 0, n >>>= 0, i >>>= 0, a >>>= 0, this === e) return 0;
  for (var o = a - i, s = n - r, l = Math.min(o, s), u = this.slice(i, a), d = e.slice(r, n), h = 0; h < l; ++h)
    if (u[h] !== d[h]) {
      o = u[h], s = d[h];
      break;
    }
  return o < s ? -1 : s < o ? 1 : 0;
};
function YS(t, e, r, n, i) {
  if (t.length === 0) return -1;
  if (typeof r == "string" ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
    if (i) return -1;
    r = t.length - 1;
  } else if (r < 0)
    if (i) r = 0;
    else return -1;
  if (typeof e == "string" && (e = Re.from(e, n)), ls(e))
    return e.length === 0 ? -1 : dw(t, e, r, n, i);
  if (typeof e == "number")
    return e = e & 255, Re.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? i ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : dw(t, [e], r, n, i);
  throw new TypeError("val must be string, number or Buffer");
}
function dw(t, e, r, n, i) {
  var a = 1, o = t.length, s = e.length;
  if (n !== void 0 && (n = String(n).toLowerCase(), n === "ucs2" || n === "ucs-2" || n === "utf16le" || n === "utf-16le")) {
    if (t.length < 2 || e.length < 2)
      return -1;
    a = 2, o /= 2, s /= 2, r /= 2;
  }
  function l(b, x) {
    return a === 1 ? b[x] : b.readUInt16BE(x * a);
  }
  var u;
  if (i) {
    var d = -1;
    for (u = r; u < o; u++)
      if (l(t, u) === l(e, d === -1 ? 0 : u - d)) {
        if (d === -1 && (d = u), u - d + 1 === s) return d * a;
      } else
        d !== -1 && (u -= u - d), d = -1;
  } else
    for (r + s > o && (r = o - s), u = r; u >= 0; u--) {
      for (var h = !0, v = 0; v < s; v++)
        if (l(t, u + v) !== l(e, v)) {
          h = !1;
          break;
        }
      if (h) return u;
    }
  return -1;
}
Re.prototype.includes = function(e, r, n) {
  return this.indexOf(e, r, n) !== -1;
};
Re.prototype.indexOf = function(e, r, n) {
  return YS(this, e, r, n, !0);
};
Re.prototype.lastIndexOf = function(e, r, n) {
  return YS(this, e, r, n, !1);
};
function UG(t, e, r, n) {
  r = Number(r) || 0;
  var i = t.length - r;
  n ? (n = Number(n), n > i && (n = i)) : n = i;
  var a = e.length;
  if (a % 2 !== 0) throw new TypeError("Invalid hex string");
  n > a / 2 && (n = a / 2);
  for (var o = 0; o < n; ++o) {
    var s = parseInt(e.substr(o * 2, 2), 16);
    if (isNaN(s)) return o;
    t[r + o] = s;
  }
  return o;
}
function zG(t, e, r, n) {
  return em(J5(e, t.length - r), t, r, n);
}
function GS(t, e, r, n) {
  return em(eZ(e), t, r, n);
}
function $G(t, e, r, n) {
  return GS(t, e, r, n);
}
function VG(t, e, r, n) {
  return em(QS(e), t, r, n);
}
function jG(t, e, r, n) {
  return em(tZ(e, t.length - r), t, r, n);
}
Re.prototype.write = function(e, r, n, i) {
  if (r === void 0)
    i = "utf8", n = this.length, r = 0;
  else if (n === void 0 && typeof r == "string")
    i = r, n = this.length, r = 0;
  else if (isFinite(r))
    r = r | 0, isFinite(n) ? (n = n | 0, i === void 0 && (i = "utf8")) : (i = n, n = void 0);
  else
    throw new Error(
      "Buffer.write(string, encoding, offset[, length]) is no longer supported"
    );
  var a = this.length - r;
  if ((n === void 0 || n > a) && (n = a), e.length > 0 && (n < 0 || r < 0) || r > this.length)
    throw new RangeError("Attempt to write outside buffer bounds");
  i || (i = "utf8");
  for (var o = !1; ; )
    switch (i) {
      case "hex":
        return UG(this, e, r, n);
      case "utf8":
      case "utf-8":
        return zG(this, e, r, n);
      case "ascii":
        return GS(this, e, r, n);
      case "latin1":
      case "binary":
        return $G(this, e, r, n);
      case "base64":
        return VG(this, e, r, n);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return jG(this, e, r, n);
      default:
        if (o) throw new TypeError("Unknown encoding: " + i);
        i = ("" + i).toLowerCase(), o = !0;
    }
};
Re.prototype.toJSON = function() {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function WG(t, e, r) {
  return e === 0 && r === t.length ? fw(t) : fw(t.slice(e, r));
}
function ZS(t, e, r) {
  r = Math.min(t.length, r);
  for (var n = [], i = e; i < r; ) {
    var a = t[i], o = null, s = a > 239 ? 4 : a > 223 ? 3 : a > 191 ? 2 : 1;
    if (i + s <= r) {
      var l, u, d, h;
      switch (s) {
        case 1:
          a < 128 && (o = a);
          break;
        case 2:
          l = t[i + 1], (l & 192) === 128 && (h = (a & 31) << 6 | l & 63, h > 127 && (o = h));
          break;
        case 3:
          l = t[i + 1], u = t[i + 2], (l & 192) === 128 && (u & 192) === 128 && (h = (a & 15) << 12 | (l & 63) << 6 | u & 63, h > 2047 && (h < 55296 || h > 57343) && (o = h));
          break;
        case 4:
          l = t[i + 1], u = t[i + 2], d = t[i + 3], (l & 192) === 128 && (u & 192) === 128 && (d & 192) === 128 && (h = (a & 15) << 18 | (l & 63) << 12 | (u & 63) << 6 | d & 63, h > 65535 && h < 1114112 && (o = h));
      }
    }
    o === null ? (o = 65533, s = 1) : o > 65535 && (o -= 65536, n.push(o >>> 10 & 1023 | 55296), o = 56320 | o & 1023), n.push(o), i += s;
  }
  return HG(n);
}
var hw = 4096;
function HG(t) {
  var e = t.length;
  if (e <= hw)
    return String.fromCharCode.apply(String, t);
  for (var r = "", n = 0; n < e; )
    r += String.fromCharCode.apply(
      String,
      t.slice(n, n += hw)
    );
  return r;
}
function qG(t, e, r) {
  var n = "";
  r = Math.min(t.length, r);
  for (var i = e; i < r; ++i)
    n += String.fromCharCode(t[i] & 127);
  return n;
}
function YG(t, e, r) {
  var n = "";
  r = Math.min(t.length, r);
  for (var i = e; i < r; ++i)
    n += String.fromCharCode(t[i]);
  return n;
}
function GG(t, e, r) {
  var n = t.length;
  (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);
  for (var i = "", a = e; a < r; ++a)
    i += QG(t[a]);
  return i;
}
function ZG(t, e, r) {
  for (var n = t.slice(e, r), i = "", a = 0; a < n.length; a += 2)
    i += String.fromCharCode(n[a] + n[a + 1] * 256);
  return i;
}
Re.prototype.slice = function(e, r) {
  var n = this.length;
  e = ~~e, r = r === void 0 ? n : ~~r, e < 0 ? (e += n, e < 0 && (e = 0)) : e > n && (e = n), r < 0 ? (r += n, r < 0 && (r = 0)) : r > n && (r = n), r < e && (r = e);
  var i;
  if (Re.TYPED_ARRAY_SUPPORT)
    i = this.subarray(e, r), i.__proto__ = Re.prototype;
  else {
    var a = r - e;
    i = new Re(a, void 0);
    for (var o = 0; o < a; ++o)
      i[o] = this[o + e];
  }
  return i;
};
function fn(t, e, r) {
  if (t % 1 !== 0 || t < 0) throw new RangeError("offset is not uint");
  if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
}
Re.prototype.readUIntLE = function(e, r, n) {
  e = e | 0, r = r | 0, n || fn(e, r, this.length);
  for (var i = this[e], a = 1, o = 0; ++o < r && (a *= 256); )
    i += this[e + o] * a;
  return i;
};
Re.prototype.readUIntBE = function(e, r, n) {
  e = e | 0, r = r | 0, n || fn(e, r, this.length);
  for (var i = this[e + --r], a = 1; r > 0 && (a *= 256); )
    i += this[e + --r] * a;
  return i;
};
Re.prototype.readUInt8 = function(e, r) {
  return r || fn(e, 1, this.length), this[e];
};
Re.prototype.readUInt16LE = function(e, r) {
  return r || fn(e, 2, this.length), this[e] | this[e + 1] << 8;
};
Re.prototype.readUInt16BE = function(e, r) {
  return r || fn(e, 2, this.length), this[e] << 8 | this[e + 1];
};
Re.prototype.readUInt32LE = function(e, r) {
  return r || fn(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + this[e + 3] * 16777216;
};
Re.prototype.readUInt32BE = function(e, r) {
  return r || fn(e, 4, this.length), this[e] * 16777216 + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
};
Re.prototype.readIntLE = function(e, r, n) {
  e = e | 0, r = r | 0, n || fn(e, r, this.length);
  for (var i = this[e], a = 1, o = 0; ++o < r && (a *= 256); )
    i += this[e + o] * a;
  return a *= 128, i >= a && (i -= Math.pow(2, 8 * r)), i;
};
Re.prototype.readIntBE = function(e, r, n) {
  e = e | 0, r = r | 0, n || fn(e, r, this.length);
  for (var i = r, a = 1, o = this[e + --i]; i > 0 && (a *= 256); )
    o += this[e + --i] * a;
  return a *= 128, o >= a && (o -= Math.pow(2, 8 * r)), o;
};
Re.prototype.readInt8 = function(e, r) {
  return r || fn(e, 1, this.length), this[e] & 128 ? (255 - this[e] + 1) * -1 : this[e];
};
Re.prototype.readInt16LE = function(e, r) {
  r || fn(e, 2, this.length);
  var n = this[e] | this[e + 1] << 8;
  return n & 32768 ? n | 4294901760 : n;
};
Re.prototype.readInt16BE = function(e, r) {
  r || fn(e, 2, this.length);
  var n = this[e + 1] | this[e] << 8;
  return n & 32768 ? n | 4294901760 : n;
};
Re.prototype.readInt32LE = function(e, r) {
  return r || fn(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
};
Re.prototype.readInt32BE = function(e, r) {
  return r || fn(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
};
Re.prototype.readFloatLE = function(e, r) {
  return r || fn(e, 4, this.length), Kp(this, e, !0, 23, 4);
};
Re.prototype.readFloatBE = function(e, r) {
  return r || fn(e, 4, this.length), Kp(this, e, !1, 23, 4);
};
Re.prototype.readDoubleLE = function(e, r) {
  return r || fn(e, 8, this.length), Kp(this, e, !0, 52, 8);
};
Re.prototype.readDoubleBE = function(e, r) {
  return r || fn(e, 8, this.length), Kp(this, e, !1, 52, 8);
};
function Di(t, e, r, n, i, a) {
  if (!ls(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (e > i || e < a) throw new RangeError('"value" argument is out of bounds');
  if (r + n > t.length) throw new RangeError("Index out of range");
}
Re.prototype.writeUIntLE = function(e, r, n, i) {
  if (e = +e, r = r | 0, n = n | 0, !i) {
    var a = Math.pow(2, 8 * n) - 1;
    Di(this, e, r, n, a, 0);
  }
  var o = 1, s = 0;
  for (this[r] = e & 255; ++s < n && (o *= 256); )
    this[r + s] = e / o & 255;
  return r + n;
};
Re.prototype.writeUIntBE = function(e, r, n, i) {
  if (e = +e, r = r | 0, n = n | 0, !i) {
    var a = Math.pow(2, 8 * n) - 1;
    Di(this, e, r, n, a, 0);
  }
  var o = n - 1, s = 1;
  for (this[r + o] = e & 255; --o >= 0 && (s *= 256); )
    this[r + o] = e / s & 255;
  return r + n;
};
Re.prototype.writeUInt8 = function(e, r, n) {
  return e = +e, r = r | 0, n || Di(this, e, r, 1, 255, 0), Re.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[r] = e & 255, r + 1;
};
function Jp(t, e, r, n) {
  e < 0 && (e = 65535 + e + 1);
  for (var i = 0, a = Math.min(t.length - r, 2); i < a; ++i)
    t[r + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> (n ? i : 1 - i) * 8;
}
Re.prototype.writeUInt16LE = function(e, r, n) {
  return e = +e, r = r | 0, n || Di(this, e, r, 2, 65535, 0), Re.TYPED_ARRAY_SUPPORT ? (this[r] = e & 255, this[r + 1] = e >>> 8) : Jp(this, e, r, !0), r + 2;
};
Re.prototype.writeUInt16BE = function(e, r, n) {
  return e = +e, r = r | 0, n || Di(this, e, r, 2, 65535, 0), Re.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 8, this[r + 1] = e & 255) : Jp(this, e, r, !1), r + 2;
};
function Qp(t, e, r, n) {
  e < 0 && (e = 4294967295 + e + 1);
  for (var i = 0, a = Math.min(t.length - r, 4); i < a; ++i)
    t[r + i] = e >>> (n ? i : 3 - i) * 8 & 255;
}
Re.prototype.writeUInt32LE = function(e, r, n) {
  return e = +e, r = r | 0, n || Di(this, e, r, 4, 4294967295, 0), Re.TYPED_ARRAY_SUPPORT ? (this[r + 3] = e >>> 24, this[r + 2] = e >>> 16, this[r + 1] = e >>> 8, this[r] = e & 255) : Qp(this, e, r, !0), r + 4;
};
Re.prototype.writeUInt32BE = function(e, r, n) {
  return e = +e, r = r | 0, n || Di(this, e, r, 4, 4294967295, 0), Re.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 24, this[r + 1] = e >>> 16, this[r + 2] = e >>> 8, this[r + 3] = e & 255) : Qp(this, e, r, !1), r + 4;
};
Re.prototype.writeIntLE = function(e, r, n, i) {
  if (e = +e, r = r | 0, !i) {
    var a = Math.pow(2, 8 * n - 1);
    Di(this, e, r, n, a - 1, -a);
  }
  var o = 0, s = 1, l = 0;
  for (this[r] = e & 255; ++o < n && (s *= 256); )
    e < 0 && l === 0 && this[r + o - 1] !== 0 && (l = 1), this[r + o] = (e / s >> 0) - l & 255;
  return r + n;
};
Re.prototype.writeIntBE = function(e, r, n, i) {
  if (e = +e, r = r | 0, !i) {
    var a = Math.pow(2, 8 * n - 1);
    Di(this, e, r, n, a - 1, -a);
  }
  var o = n - 1, s = 1, l = 0;
  for (this[r + o] = e & 255; --o >= 0 && (s *= 256); )
    e < 0 && l === 0 && this[r + o + 1] !== 0 && (l = 1), this[r + o] = (e / s >> 0) - l & 255;
  return r + n;
};
Re.prototype.writeInt8 = function(e, r, n) {
  return e = +e, r = r | 0, n || Di(this, e, r, 1, 127, -128), Re.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[r] = e & 255, r + 1;
};
Re.prototype.writeInt16LE = function(e, r, n) {
  return e = +e, r = r | 0, n || Di(this, e, r, 2, 32767, -32768), Re.TYPED_ARRAY_SUPPORT ? (this[r] = e & 255, this[r + 1] = e >>> 8) : Jp(this, e, r, !0), r + 2;
};
Re.prototype.writeInt16BE = function(e, r, n) {
  return e = +e, r = r | 0, n || Di(this, e, r, 2, 32767, -32768), Re.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 8, this[r + 1] = e & 255) : Jp(this, e, r, !1), r + 2;
};
Re.prototype.writeInt32LE = function(e, r, n) {
  return e = +e, r = r | 0, n || Di(this, e, r, 4, 2147483647, -2147483648), Re.TYPED_ARRAY_SUPPORT ? (this[r] = e & 255, this[r + 1] = e >>> 8, this[r + 2] = e >>> 16, this[r + 3] = e >>> 24) : Qp(this, e, r, !0), r + 4;
};
Re.prototype.writeInt32BE = function(e, r, n) {
  return e = +e, r = r | 0, n || Di(this, e, r, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), Re.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 24, this[r + 1] = e >>> 16, this[r + 2] = e >>> 8, this[r + 3] = e & 255) : Qp(this, e, r, !1), r + 4;
};
function XS(t, e, r, n, i, a) {
  if (r + n > t.length) throw new RangeError("Index out of range");
  if (r < 0) throw new RangeError("Index out of range");
}
function KS(t, e, r, n, i) {
  return i || XS(t, e, r, 4), $S(t, e, r, n, 23, 4), r + 4;
}
Re.prototype.writeFloatLE = function(e, r, n) {
  return KS(this, e, r, !0, n);
};
Re.prototype.writeFloatBE = function(e, r, n) {
  return KS(this, e, r, !1, n);
};
function JS(t, e, r, n, i) {
  return i || XS(t, e, r, 8), $S(t, e, r, n, 52, 8), r + 8;
}
Re.prototype.writeDoubleLE = function(e, r, n) {
  return JS(this, e, r, !0, n);
};
Re.prototype.writeDoubleBE = function(e, r, n) {
  return JS(this, e, r, !1, n);
};
Re.prototype.copy = function(e, r, n, i) {
  if (n || (n = 0), !i && i !== 0 && (i = this.length), r >= e.length && (r = e.length), r || (r = 0), i > 0 && i < n && (i = n), i === n || e.length === 0 || this.length === 0) return 0;
  if (r < 0)
    throw new RangeError("targetStart out of bounds");
  if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
  if (i < 0) throw new RangeError("sourceEnd out of bounds");
  i > this.length && (i = this.length), e.length - r < i - n && (i = e.length - r + n);
  var a = i - n, o;
  if (this === e && n < r && r < i)
    for (o = a - 1; o >= 0; --o)
      e[o + r] = this[o + n];
  else if (a < 1e3 || !Re.TYPED_ARRAY_SUPPORT)
    for (o = 0; o < a; ++o)
      e[o + r] = this[o + n];
  else
    Uint8Array.prototype.set.call(
      e,
      this.subarray(n, n + a),
      r
    );
  return a;
};
Re.prototype.fill = function(e, r, n, i) {
  if (typeof e == "string") {
    if (typeof r == "string" ? (i = r, r = 0, n = this.length) : typeof n == "string" && (i = n, n = this.length), e.length === 1) {
      var a = e.charCodeAt(0);
      a < 256 && (e = a);
    }
    if (i !== void 0 && typeof i != "string")
      throw new TypeError("encoding must be a string");
    if (typeof i == "string" && !Re.isEncoding(i))
      throw new TypeError("Unknown encoding: " + i);
  } else typeof e == "number" && (e = e & 255);
  if (r < 0 || this.length < r || this.length < n)
    throw new RangeError("Out of range index");
  if (n <= r)
    return this;
  r = r >>> 0, n = n === void 0 ? this.length : n >>> 0, e || (e = 0);
  var o;
  if (typeof e == "number")
    for (o = r; o < n; ++o)
      this[o] = e;
  else {
    var s = ls(e) ? e : J5(new Re(e, i).toString()), l = s.length;
    for (o = 0; o < n - r; ++o)
      this[o + r] = s[o % l];
  }
  return this;
};
var XG = /[^+\/0-9A-Za-z-_]/g;
function KG(t) {
  if (t = JG(t).replace(XG, ""), t.length < 2) return "";
  for (; t.length % 4 !== 0; )
    t = t + "=";
  return t;
}
function JG(t) {
  return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
}
function QG(t) {
  return t < 16 ? "0" + t.toString(16) : t.toString(16);
}
function J5(t, e) {
  e = e || 1 / 0;
  for (var r, n = t.length, i = null, a = [], o = 0; o < n; ++o) {
    if (r = t.charCodeAt(o), r > 55295 && r < 57344) {
      if (!i) {
        if (r > 56319) {
          (e -= 3) > -1 && a.push(239, 191, 189);
          continue;
        } else if (o + 1 === n) {
          (e -= 3) > -1 && a.push(239, 191, 189);
          continue;
        }
        i = r;
        continue;
      }
      if (r < 56320) {
        (e -= 3) > -1 && a.push(239, 191, 189), i = r;
        continue;
      }
      r = (i - 55296 << 10 | r - 56320) + 65536;
    } else i && (e -= 3) > -1 && a.push(239, 191, 189);
    if (i = null, r < 128) {
      if ((e -= 1) < 0) break;
      a.push(r);
    } else if (r < 2048) {
      if ((e -= 2) < 0) break;
      a.push(
        r >> 6 | 192,
        r & 63 | 128
      );
    } else if (r < 65536) {
      if ((e -= 3) < 0) break;
      a.push(
        r >> 12 | 224,
        r >> 6 & 63 | 128,
        r & 63 | 128
      );
    } else if (r < 1114112) {
      if ((e -= 4) < 0) break;
      a.push(
        r >> 18 | 240,
        r >> 12 & 63 | 128,
        r >> 6 & 63 | 128,
        r & 63 | 128
      );
    } else
      throw new Error("Invalid code point");
  }
  return a;
}
function eZ(t) {
  for (var e = [], r = 0; r < t.length; ++r)
    e.push(t.charCodeAt(r) & 255);
  return e;
}
function tZ(t, e) {
  for (var r, n, i, a = [], o = 0; o < t.length && !((e -= 2) < 0); ++o)
    r = t.charCodeAt(o), n = r >> 8, i = r % 256, a.push(i), a.push(n);
  return a;
}
function QS(t) {
  return TG(KG(t));
}
function em(t, e, r, n) {
  for (var i = 0; i < n && !(i + r >= e.length || i >= t.length); ++i)
    e[i + r] = t[i];
  return i;
}
function rZ(t) {
  return t !== t;
}
function Zu(t) {
  return t != null && (!!t._isBuffer || eC(t) || nZ(t));
}
function eC(t) {
  return !!t.constructor && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
}
function nZ(t) {
  return typeof t.readFloatLE == "function" && typeof t.slice == "function" && eC(t.slice(0, 0));
}
var iZ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Buffer: Re,
  INSPECT_MAX_BYTES: jS,
  SlowBuffer: NG,
  isBuffer: Zu,
  kMaxLength: RG
});
function tC() {
  throw new Error("setTimeout has not been defined");
}
function rC() {
  throw new Error("clearTimeout has not been defined");
}
var Bl = tC, Ll = rC;
typeof yc.setTimeout == "function" && (Bl = setTimeout);
typeof yc.clearTimeout == "function" && (Ll = clearTimeout);
function nC(t) {
  if (Bl === setTimeout)
    return setTimeout(t, 0);
  if ((Bl === tC || !Bl) && setTimeout)
    return Bl = setTimeout, setTimeout(t, 0);
  try {
    return Bl(t, 0);
  } catch {
    try {
      return Bl.call(null, t, 0);
    } catch {
      return Bl.call(this, t, 0);
    }
  }
}
function aZ(t) {
  if (Ll === clearTimeout)
    return clearTimeout(t);
  if ((Ll === rC || !Ll) && clearTimeout)
    return Ll = clearTimeout, clearTimeout(t);
  try {
    return Ll(t);
  } catch {
    try {
      return Ll.call(null, t);
    } catch {
      return Ll.call(this, t);
    }
  }
}
var Qs = [], Kf = !1, Xu, u5 = -1;
function oZ() {
  !Kf || !Xu || (Kf = !1, Xu.length ? Qs = Xu.concat(Qs) : u5 = -1, Qs.length && iC());
}
function iC() {
  if (!Kf) {
    var t = nC(oZ);
    Kf = !0;
    for (var e = Qs.length; e; ) {
      for (Xu = Qs, Qs = []; ++u5 < e; )
        Xu && Xu[u5].run();
      u5 = -1, e = Qs.length;
    }
    Xu = null, Kf = !1, aZ(t);
  }
}
function ia(t) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var r = 1; r < arguments.length; r++)
      e[r - 1] = arguments[r];
  Qs.push(new aC(t, e)), Qs.length === 1 && !Kf && nC(iC);
}
function aC(t, e) {
  this.fun = t, this.array = e;
}
aC.prototype.run = function() {
  this.fun.apply(null, this.array);
};
var sZ = "browser", lZ = "browser", uZ = !0, cZ = {}, fZ = [], dZ = "", hZ = {}, pZ = {}, mZ = {};
function Oc() {
}
var gZ = Oc, vZ = Oc, bZ = Oc, xZ = Oc, yZ = Oc, wZ = Oc, _Z = Oc;
function AZ(t) {
  throw new Error("process.binding is not supported");
}
function EZ() {
  return "/";
}
function SZ(t) {
  throw new Error("process.chdir is not supported");
}
function CZ() {
  return 0;
}
var Nf = yc.performance || {}, kZ = Nf.now || Nf.mozNow || Nf.msNow || Nf.oNow || Nf.webkitNow || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function TZ(t) {
  var e = kZ.call(Nf) * 1e-3, r = Math.floor(e), n = Math.floor(e % 1 * 1e9);
  return t && (r = r - t[0], n = n - t[1], n < 0 && (r--, n += 1e9)), [r, n];
}
var FZ = /* @__PURE__ */ new Date();
function DZ() {
  var t = /* @__PURE__ */ new Date(), e = t - FZ;
  return e / 1e3;
}
var Ka = {
  nextTick: ia,
  title: sZ,
  browser: uZ,
  env: cZ,
  argv: fZ,
  version: dZ,
  versions: hZ,
  on: gZ,
  addListener: vZ,
  once: bZ,
  off: xZ,
  removeListener: yZ,
  removeAllListeners: wZ,
  emit: _Z,
  binding: AZ,
  cwd: EZ,
  chdir: SZ,
  umask: CZ,
  hrtime: TZ,
  platform: lZ,
  release: pZ,
  config: mZ,
  uptime: DZ
};
function OZ(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function tm(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), r;
}
var oC = {}, pw = /* @__PURE__ */ tm(iZ), RZ;
function eu() {
}
eu.prototype = /* @__PURE__ */ Object.create(null);
function f0() {
  f0.init.call(this);
}
f0.EventEmitter = f0;
f0.usingDomains = !1;
f0.prototype.domain = void 0;
f0.prototype._events = void 0;
f0.prototype._maxListeners = void 0;
f0.defaultMaxListeners = 10;
f0.init = function() {
  this.domain = null, f0.usingDomains && RZ.active, (!this._events || this._events === Object.getPrototypeOf(this)._events) && (this._events = new eu(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
f0.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || isNaN(e))
    throw new TypeError('"n" argument must be a positive number');
  return this._maxListeners = e, this;
};
function sC(t) {
  return t._maxListeners === void 0 ? f0.defaultMaxListeners : t._maxListeners;
}
f0.prototype.getMaxListeners = function() {
  return sC(this);
};
function PZ(t, e, r) {
  if (e)
    t.call(r);
  else
    for (var n = t.length, i = Ph(t, n), a = 0; a < n; ++a)
      i[a].call(r);
}
function IZ(t, e, r, n) {
  if (e)
    t.call(r, n);
  else
    for (var i = t.length, a = Ph(t, i), o = 0; o < i; ++o)
      a[o].call(r, n);
}
function BZ(t, e, r, n, i) {
  if (e)
    t.call(r, n, i);
  else
    for (var a = t.length, o = Ph(t, a), s = 0; s < a; ++s)
      o[s].call(r, n, i);
}
function LZ(t, e, r, n, i, a) {
  if (e)
    t.call(r, n, i, a);
  else
    for (var o = t.length, s = Ph(t, o), l = 0; l < o; ++l)
      s[l].call(r, n, i, a);
}
function NZ(t, e, r, n) {
  if (e)
    t.apply(r, n);
  else
    for (var i = t.length, a = Ph(t, i), o = 0; o < i; ++o)
      a[o].apply(r, n);
}
f0.prototype.emit = function(e) {
  var r, n, i, a, o, s, l, u = e === "error";
  if (s = this._events, s)
    u = u && s.error == null;
  else if (!u)
    return !1;
  if (l = this.domain, u) {
    if (r = arguments[1], l)
      r || (r = new Error('Uncaught, unspecified "error" event')), r.domainEmitter = this, r.domain = l, r.domainThrown = !1, l.emit("error", r);
    else {
      if (r instanceof Error)
        throw r;
      var d = new Error('Uncaught, unspecified "error" event. (' + r + ")");
      throw d.context = r, d;
    }
    return !1;
  }
  if (n = s[e], !n)
    return !1;
  var h = typeof n == "function";
  switch (i = arguments.length, i) {
    case 1:
      PZ(n, h, this);
      break;
    case 2:
      IZ(n, h, this, arguments[1]);
      break;
    case 3:
      BZ(n, h, this, arguments[1], arguments[2]);
      break;
    case 4:
      LZ(n, h, this, arguments[1], arguments[2], arguments[3]);
      break;
    default:
      for (a = new Array(i - 1), o = 1; o < i; o++)
        a[o - 1] = arguments[o];
      NZ(n, h, this, a);
  }
  return !0;
};
function lC(t, e, r, n) {
  var i, a, o;
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  if (a = t._events, a ? (a.newListener && (t.emit(
    "newListener",
    e,
    r.listener ? r.listener : r
  ), a = t._events), o = a[e]) : (a = t._events = new eu(), t._eventsCount = 0), !o)
    o = a[e] = r, ++t._eventsCount;
  else if (typeof o == "function" ? o = a[e] = n ? [r, o] : [o, r] : n ? o.unshift(r) : o.push(r), !o.warned && (i = sC(t), i && i > 0 && o.length > i)) {
    o.warned = !0;
    var s = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + e + " listeners added. Use emitter.setMaxListeners() to increase limit");
    s.name = "MaxListenersExceededWarning", s.emitter = t, s.type = e, s.count = o.length, MZ(s);
  }
  return t;
}
function MZ(t) {
  typeof console.warn == "function" ? console.warn(t) : console.log(t);
}
f0.prototype.addListener = function(e, r) {
  return lC(this, e, r, !1);
};
f0.prototype.on = f0.prototype.addListener;
f0.prototype.prependListener = function(e, r) {
  return lC(this, e, r, !0);
};
function uC(t, e, r) {
  var n = !1;
  function i() {
    t.removeListener(e, i), n || (n = !0, r.apply(t, arguments));
  }
  return i.listener = r, i;
}
f0.prototype.once = function(e, r) {
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  return this.on(e, uC(this, e, r)), this;
};
f0.prototype.prependOnceListener = function(e, r) {
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  return this.prependListener(e, uC(this, e, r)), this;
};
f0.prototype.removeListener = function(e, r) {
  var n, i, a, o, s;
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  if (i = this._events, !i)
    return this;
  if (n = i[e], !n)
    return this;
  if (n === r || n.listener && n.listener === r)
    --this._eventsCount === 0 ? this._events = new eu() : (delete i[e], i.removeListener && this.emit("removeListener", e, n.listener || r));
  else if (typeof n != "function") {
    for (a = -1, o = n.length; o-- > 0; )
      if (n[o] === r || n[o].listener && n[o].listener === r) {
        s = n[o].listener, a = o;
        break;
      }
    if (a < 0)
      return this;
    if (n.length === 1) {
      if (n[0] = void 0, --this._eventsCount === 0)
        return this._events = new eu(), this;
      delete i[e];
    } else
      UZ(n, a);
    i.removeListener && this.emit("removeListener", e, s || r);
  }
  return this;
};
f0.prototype.off = function(t, e) {
  return this.removeListener(t, e);
};
f0.prototype.removeAllListeners = function(e) {
  var r, n;
  if (n = this._events, !n)
    return this;
  if (!n.removeListener)
    return arguments.length === 0 ? (this._events = new eu(), this._eventsCount = 0) : n[e] && (--this._eventsCount === 0 ? this._events = new eu() : delete n[e]), this;
  if (arguments.length === 0) {
    for (var i = Object.keys(n), a = 0, o; a < i.length; ++a)
      o = i[a], o !== "removeListener" && this.removeAllListeners(o);
    return this.removeAllListeners("removeListener"), this._events = new eu(), this._eventsCount = 0, this;
  }
  if (r = n[e], typeof r == "function")
    this.removeListener(e, r);
  else if (r)
    do
      this.removeListener(e, r[r.length - 1]);
    while (r[0]);
  return this;
};
f0.prototype.listeners = function(e) {
  var r, n, i = this._events;
  return i ? (r = i[e], r ? typeof r == "function" ? n = [r.listener || r] : n = zZ(r) : n = []) : n = [], n;
};
f0.listenerCount = function(t, e) {
  return typeof t.listenerCount == "function" ? t.listenerCount(e) : cC.call(t, e);
};
f0.prototype.listenerCount = cC;
function cC(t) {
  var e = this._events;
  if (e) {
    var r = e[t];
    if (typeof r == "function")
      return 1;
    if (r)
      return r.length;
  }
  return 0;
}
f0.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};
function UZ(t, e) {
  for (var r = e, n = r + 1, i = t.length; n < i; r += 1, n += 1)
    t[r] = t[n];
  t.pop();
}
function Ph(t, e) {
  for (var r = new Array(e); e--; )
    r[e] = t[e];
  return r;
}
function zZ(t) {
  for (var e = new Array(t.length), r = 0; r < e.length; ++r)
    e[r] = t[r].listener || t[r];
  return e;
}
var k3;
typeof Object.create == "function" ? k3 = function(e, r) {
  e.super_ = r, e.prototype = Object.create(r.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  });
} : k3 = function(e, r) {
  e.super_ = r;
  var n = function() {
  };
  n.prototype = r.prototype, e.prototype = new n(), e.prototype.constructor = e;
};
var ll = k3, fC = Object.getOwnPropertyDescriptors || function(e) {
  for (var r = Object.keys(e), n = {}, i = 0; i < r.length; i++)
    n[r[i]] = Object.getOwnPropertyDescriptor(e, r[i]);
  return n;
}, $Z = /%[sdj%]/g;
function rm(t) {
  if (!Bh(t)) {
    for (var e = [], r = 0; r < arguments.length; r++)
      e.push(eo(arguments[r]));
    return e.join(" ");
  }
  for (var r = 1, n = arguments, i = n.length, a = String(t).replace($Z, function(s) {
    if (s === "%%") return "%";
    if (r >= i) return s;
    switch (s) {
      case "%s":
        return String(n[r++]);
      case "%d":
        return Number(n[r++]);
      case "%j":
        try {
          return JSON.stringify(n[r++]);
        } catch {
          return "[Circular]";
        }
      default:
        return s;
    }
  }), o = n[r]; r < i; o = n[++r])
    Ih(o) || !Rc(o) ? a += " " + o : a += " " + eo(o);
  return a;
}
function nm(t, e) {
  if (Qo(yc.process))
    return function() {
      return nm(t, e).apply(this, arguments);
    };
  if (Ka.noDeprecation === !0)
    return t;
  var r = !1;
  function n() {
    if (!r) {
      if (Ka.throwDeprecation)
        throw new Error(e);
      Ka.traceDeprecation ? console.trace(e) : console.error(e), r = !0;
    }
    return t.apply(this, arguments);
  }
  return n;
}
var I2 = {}, d4;
function Gb(t) {
  if (Qo(d4) && (d4 = Ka.env.NODE_DEBUG || ""), t = t.toUpperCase(), !I2[t])
    if (new RegExp("\\b" + t + "\\b", "i").test(d4)) {
      var e = 0;
      I2[t] = function() {
        var r = rm.apply(null, arguments);
        console.error("%s %d: %s", t, e, r);
      };
    } else
      I2[t] = function() {
      };
  return I2[t];
}
function eo(t, e) {
  var r = {
    seen: [],
    stylize: jZ
  };
  return arguments.length >= 3 && (r.depth = arguments[2]), arguments.length >= 4 && (r.colors = arguments[3]), im(e) ? r.showHidden = e : e && Jb(r, e), Qo(r.showHidden) && (r.showHidden = !1), Qo(r.depth) && (r.depth = 2), Qo(r.colors) && (r.colors = !1), Qo(r.customInspect) && (r.customInspect = !0), r.colors && (r.stylize = VZ), Q5(r, t, r.depth);
}
eo.colors = {
  bold: [1, 22],
  italic: [3, 23],
  underline: [4, 24],
  inverse: [7, 27],
  white: [37, 39],
  grey: [90, 39],
  black: [30, 39],
  blue: [34, 39],
  cyan: [36, 39],
  green: [32, 39],
  magenta: [35, 39],
  red: [31, 39],
  yellow: [33, 39]
};
eo.styles = {
  special: "cyan",
  number: "yellow",
  boolean: "yellow",
  undefined: "grey",
  null: "bold",
  string: "green",
  date: "magenta",
  // "name": intentionally not styling
  regexp: "red"
};
function VZ(t, e) {
  var r = eo.styles[e];
  return r ? "\x1B[" + eo.colors[r][0] + "m" + t + "\x1B[" + eo.colors[r][1] + "m" : t;
}
function jZ(t, e) {
  return t;
}
function WZ(t) {
  var e = {};
  return t.forEach(function(r, n) {
    e[r] = !0;
  }), e;
}
function Q5(t, e, r) {
  if (t.customInspect && e && fc(e.inspect) && // Filter out the util module, it's inspect function is special
  e.inspect !== eo && // Also filter out any prototype objects using the circular check.
  !(e.constructor && e.constructor.prototype === e)) {
    var n = e.inspect(r, t);
    return Bh(n) || (n = Q5(t, n, r)), n;
  }
  var i = HZ(t, e);
  if (i)
    return i;
  var a = Object.keys(e), o = WZ(a);
  if (t.showHidden && (a = Object.getOwnPropertyNames(e)), Jf(e) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0))
    return h4(e);
  if (a.length === 0) {
    if (fc(e)) {
      var s = e.name ? ": " + e.name : "";
      return t.stylize("[Function" + s + "]", "special");
    }
    if (cc(e))
      return t.stylize(RegExp.prototype.toString.call(e), "regexp");
    if (c1(e))
      return t.stylize(Date.prototype.toString.call(e), "date");
    if (Jf(e))
      return h4(e);
  }
  var l = "", u = !1, d = ["{", "}"];
  if (Zb(e) && (u = !0, d = ["[", "]"]), fc(e)) {
    var h = e.name ? ": " + e.name : "";
    l = " [Function" + h + "]";
  }
  if (cc(e) && (l = " " + RegExp.prototype.toString.call(e)), c1(e) && (l = " " + Date.prototype.toUTCString.call(e)), Jf(e) && (l = " " + h4(e)), a.length === 0 && (!u || e.length == 0))
    return d[0] + l + d[1];
  if (r < 0)
    return cc(e) ? t.stylize(RegExp.prototype.toString.call(e), "regexp") : t.stylize("[Object]", "special");
  t.seen.push(e);
  var v;
  return u ? v = qZ(t, e, r, o, a) : v = a.map(function(b) {
    return T3(t, e, r, o, b, u);
  }), t.seen.pop(), YZ(v, l, d);
}
function HZ(t, e) {
  if (Qo(e))
    return t.stylize("undefined", "undefined");
  if (Bh(e)) {
    var r = "'" + JSON.stringify(e).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
    return t.stylize(r, "string");
  }
  if (Xb(e))
    return t.stylize("" + e, "number");
  if (im(e))
    return t.stylize("" + e, "boolean");
  if (Ih(e))
    return t.stylize("null", "null");
}
function h4(t) {
  return "[" + Error.prototype.toString.call(t) + "]";
}
function qZ(t, e, r, n, i) {
  for (var a = [], o = 0, s = e.length; o < s; ++o)
    gC(e, String(o)) ? a.push(T3(
      t,
      e,
      r,
      n,
      String(o),
      !0
    )) : a.push("");
  return i.forEach(function(l) {
    l.match(/^\d+$/) || a.push(T3(
      t,
      e,
      r,
      n,
      l,
      !0
    ));
  }), a;
}
function T3(t, e, r, n, i, a) {
  var o, s, l;
  if (l = Object.getOwnPropertyDescriptor(e, i) || { value: e[i] }, l.get ? l.set ? s = t.stylize("[Getter/Setter]", "special") : s = t.stylize("[Getter]", "special") : l.set && (s = t.stylize("[Setter]", "special")), gC(n, i) || (o = "[" + i + "]"), s || (t.seen.indexOf(l.value) < 0 ? (Ih(r) ? s = Q5(t, l.value, null) : s = Q5(t, l.value, r - 1), s.indexOf(`
`) > -1 && (a ? s = s.split(`
`).map(function(u) {
    return "  " + u;
  }).join(`
`).substr(2) : s = `
` + s.split(`
`).map(function(u) {
    return "   " + u;
  }).join(`
`))) : s = t.stylize("[Circular]", "special")), Qo(o)) {
    if (a && i.match(/^\d+$/))
      return s;
    o = JSON.stringify("" + i), o.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.substr(1, o.length - 2), o = t.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), o = t.stylize(o, "string"));
  }
  return o + ": " + s;
}
function YZ(t, e, r) {
  var n = t.reduce(function(i, a) {
    return a.indexOf(`
`) >= 0, i + a.replace(/\u001b\[\d\d?m/g, "").length + 1;
  }, 0);
  return n > 60 ? r[0] + (e === "" ? "" : e + `
 `) + " " + t.join(`,
  `) + " " + r[1] : r[0] + e + " " + t.join(", ") + " " + r[1];
}
function Zb(t) {
  return Array.isArray(t);
}
function im(t) {
  return typeof t == "boolean";
}
function Ih(t) {
  return t === null;
}
function dC(t) {
  return t == null;
}
function Xb(t) {
  return typeof t == "number";
}
function Bh(t) {
  return typeof t == "string";
}
function hC(t) {
  return typeof t == "symbol";
}
function Qo(t) {
  return t === void 0;
}
function cc(t) {
  return Rc(t) && Kb(t) === "[object RegExp]";
}
function Rc(t) {
  return typeof t == "object" && t !== null;
}
function c1(t) {
  return Rc(t) && Kb(t) === "[object Date]";
}
function Jf(t) {
  return Rc(t) && (Kb(t) === "[object Error]" || t instanceof Error);
}
function fc(t) {
  return typeof t == "function";
}
function ep(t) {
  return t === null || typeof t == "boolean" || typeof t == "number" || typeof t == "string" || typeof t == "symbol" || // ES6 symbol
  typeof t > "u";
}
function pC(t) {
  return Re.isBuffer(t);
}
function Kb(t) {
  return Object.prototype.toString.call(t);
}
function p4(t) {
  return t < 10 ? "0" + t.toString(10) : t.toString(10);
}
var GZ = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
function ZZ() {
  var t = /* @__PURE__ */ new Date(), e = [
    p4(t.getHours()),
    p4(t.getMinutes()),
    p4(t.getSeconds())
  ].join(":");
  return [t.getDate(), GZ[t.getMonth()], e].join(" ");
}
function mC() {
  console.log("%s - %s", ZZ(), rm.apply(null, arguments));
}
function Jb(t, e) {
  if (!e || !Rc(e)) return t;
  for (var r = Object.keys(e), n = r.length; n--; )
    t[r[n]] = e[r[n]];
  return t;
}
function gC(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
var Mu = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
function Qb(t) {
  if (typeof t != "function")
    throw new TypeError('The "original" argument must be of type Function');
  if (Mu && t[Mu]) {
    var e = t[Mu];
    if (typeof e != "function")
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    return Object.defineProperty(e, Mu, {
      value: e,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), e;
  }
  function e() {
    for (var r, n, i = new Promise(function(s, l) {
      r = s, n = l;
    }), a = [], o = 0; o < arguments.length; o++)
      a.push(arguments[o]);
    a.push(function(s, l) {
      s ? n(s) : r(l);
    });
    try {
      t.apply(this, a);
    } catch (s) {
      n(s);
    }
    return i;
  }
  return Object.setPrototypeOf(e, Object.getPrototypeOf(t)), Mu && Object.defineProperty(e, Mu, {
    value: e,
    enumerable: !1,
    writable: !1,
    configurable: !0
  }), Object.defineProperties(
    e,
    fC(t)
  );
}
Qb.custom = Mu;
function XZ(t, e) {
  if (!t) {
    var r = new Error("Promise was rejected with a falsy value");
    r.reason = t, t = r;
  }
  return e(t);
}
function vC(t) {
  if (typeof t != "function")
    throw new TypeError('The "original" argument must be of type Function');
  function e() {
    for (var r = [], n = 0; n < arguments.length; n++)
      r.push(arguments[n]);
    var i = r.pop();
    if (typeof i != "function")
      throw new TypeError("The last argument must be of type Function");
    var a = this, o = function() {
      return i.apply(a, arguments);
    };
    t.apply(this, r).then(
      function(s) {
        Ka.nextTick(o.bind(null, null, s));
      },
      function(s) {
        Ka.nextTick(XZ.bind(null, s, o));
      }
    );
  }
  return Object.setPrototypeOf(e, Object.getPrototypeOf(t)), Object.defineProperties(e, fC(t)), e;
}
var KZ = {
  inherits: ll,
  _extend: Jb,
  log: mC,
  isBuffer: pC,
  isPrimitive: ep,
  isFunction: fc,
  isError: Jf,
  isDate: c1,
  isObject: Rc,
  isRegExp: cc,
  isUndefined: Qo,
  isSymbol: hC,
  isString: Bh,
  isNumber: Xb,
  isNullOrUndefined: dC,
  isNull: Ih,
  isBoolean: im,
  isArray: Zb,
  inspect: eo,
  deprecate: nm,
  format: rm,
  debuglog: Gb,
  promisify: Qb,
  callbackify: vC
}, JZ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _extend: Jb,
  callbackify: vC,
  debuglog: Gb,
  default: KZ,
  deprecate: nm,
  format: rm,
  inherits: ll,
  inspect: eo,
  isArray: Zb,
  isBoolean: im,
  isBuffer: pC,
  isDate: c1,
  isError: Jf,
  isFunction: fc,
  isNull: Ih,
  isNullOrUndefined: dC,
  isNumber: Xb,
  isObject: Rc,
  isPrimitive: ep,
  isRegExp: cc,
  isString: Bh,
  isSymbol: hC,
  isUndefined: Qo,
  log: mC,
  promisify: Qb
});
function Pc() {
  this.head = null, this.tail = null, this.length = 0;
}
Pc.prototype.push = function(t) {
  var e = { data: t, next: null };
  this.length > 0 ? this.tail.next = e : this.head = e, this.tail = e, ++this.length;
};
Pc.prototype.unshift = function(t) {
  var e = { data: t, next: this.head };
  this.length === 0 && (this.tail = e), this.head = e, ++this.length;
};
Pc.prototype.shift = function() {
  if (this.length !== 0) {
    var t = this.head.data;
    return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, t;
  }
};
Pc.prototype.clear = function() {
  this.head = this.tail = null, this.length = 0;
};
Pc.prototype.join = function(t) {
  if (this.length === 0) return "";
  for (var e = this.head, r = "" + e.data; e = e.next; )
    r += t + e.data;
  return r;
};
Pc.prototype.concat = function(t) {
  if (this.length === 0) return Re.alloc(0);
  if (this.length === 1) return this.head.data;
  for (var e = Re.allocUnsafe(t >>> 0), r = this.head, n = 0; r; )
    r.data.copy(e, n), n += r.data.length, r = r.next;
  return e;
};
var QZ = Re.isEncoding || function(t) {
  switch (t && t.toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
    case "raw":
      return !0;
    default:
      return !1;
  }
};
function eX(t) {
  if (t && !QZ(t))
    throw new Error("Unknown encoding: " + t);
}
function Lh(t) {
  switch (this.encoding = (t || "utf8").toLowerCase().replace(/[-_]/, ""), eX(t), this.encoding) {
    case "utf8":
      this.surrogateSize = 3;
      break;
    case "ucs2":
    case "utf16le":
      this.surrogateSize = 2, this.detectIncompleteChar = rX;
      break;
    case "base64":
      this.surrogateSize = 3, this.detectIncompleteChar = nX;
      break;
    default:
      this.write = tX;
      return;
  }
  this.charBuffer = new Re(6), this.charReceived = 0, this.charLength = 0;
}
Lh.prototype.write = function(t) {
  for (var e = ""; this.charLength; ) {
    var r = t.length >= this.charLength - this.charReceived ? this.charLength - this.charReceived : t.length;
    if (t.copy(this.charBuffer, this.charReceived, 0, r), this.charReceived += r, this.charReceived < this.charLength)
      return "";
    t = t.slice(r, t.length), e = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
    var i = e.charCodeAt(e.length - 1);
    if (i >= 55296 && i <= 56319) {
      this.charLength += this.surrogateSize, e = "";
      continue;
    }
    if (this.charReceived = this.charLength = 0, t.length === 0)
      return e;
    break;
  }
  this.detectIncompleteChar(t);
  var n = t.length;
  this.charLength && (t.copy(this.charBuffer, 0, t.length - this.charReceived, n), n -= this.charReceived), e += t.toString(this.encoding, 0, n);
  var n = e.length - 1, i = e.charCodeAt(n);
  if (i >= 55296 && i <= 56319) {
    var a = this.surrogateSize;
    return this.charLength += a, this.charReceived += a, this.charBuffer.copy(this.charBuffer, a, 0, a), t.copy(this.charBuffer, 0, 0, a), e.substring(0, n);
  }
  return e;
};
Lh.prototype.detectIncompleteChar = function(t) {
  for (var e = t.length >= 3 ? 3 : t.length; e > 0; e--) {
    var r = t[t.length - e];
    if (e == 1 && r >> 5 == 6) {
      this.charLength = 2;
      break;
    }
    if (e <= 2 && r >> 4 == 14) {
      this.charLength = 3;
      break;
    }
    if (e <= 3 && r >> 3 == 30) {
      this.charLength = 4;
      break;
    }
  }
  this.charReceived = e;
};
Lh.prototype.end = function(t) {
  var e = "";
  if (t && t.length && (e = this.write(t)), this.charReceived) {
    var r = this.charReceived, n = this.charBuffer, i = this.encoding;
    e += n.slice(0, r).toString(i);
  }
  return e;
};
function tX(t) {
  return t.toString(this.encoding);
}
function rX(t) {
  this.charReceived = t.length % 2, this.charLength = this.charReceived ? 2 : 0;
}
function nX(t) {
  this.charReceived = t.length % 3, this.charLength = this.charReceived ? 3 : 0;
}
vr.ReadableState = bC;
var W0 = Gb("stream");
ll(vr, f0);
function iX(t, e, r) {
  if (typeof t.prependListener == "function")
    return t.prependListener(e, r);
  !t._events || !t._events[e] ? t.on(e, r) : Array.isArray(t._events[e]) ? t._events[e].unshift(r) : t._events[e] = [r, t._events[e]];
}
function aX(t, e) {
  return t.listeners(e).length;
}
function bC(t, e) {
  t = t || {}, this.objectMode = !!t.objectMode, e instanceof ra && (this.objectMode = this.objectMode || !!t.readableObjectMode);
  var r = t.highWaterMark, n = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = r || r === 0 ? r : n, this.highWaterMark = ~~this.highWaterMark, this.buffer = new Pc(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.ranOut = !1, this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (this.decoder = new Lh(t.encoding), this.encoding = t.encoding);
}
function vr(t) {
  if (!(this instanceof vr)) return new vr(t);
  this._readableState = new bC(t, this), this.readable = !0, t && typeof t.read == "function" && (this._read = t.read), f0.call(this);
}
vr.prototype.push = function(t, e) {
  var r = this._readableState;
  return !r.objectMode && typeof t == "string" && (e = e || r.defaultEncoding, e !== r.encoding && (t = Re.from(t, e), e = "")), xC(this, r, t, e, !1);
};
vr.prototype.unshift = function(t) {
  var e = this._readableState;
  return xC(this, e, t, "", !0);
};
vr.prototype.isPaused = function() {
  return this._readableState.flowing === !1;
};
function xC(t, e, r, n, i) {
  var a = lX(e, r);
  if (a)
    t.emit("error", a);
  else if (r === null)
    e.reading = !1, uX(t, e);
  else if (e.objectMode || r && r.length > 0)
    if (e.ended && !i) {
      var o = new Error("stream.push() after EOF");
      t.emit("error", o);
    } else if (e.endEmitted && i) {
      var s = new Error("stream.unshift() after end event");
      t.emit("error", s);
    } else {
      var l;
      e.decoder && !i && !n && (r = e.decoder.write(r), l = !e.objectMode && r.length === 0), i || (e.reading = !1), l || (e.flowing && e.length === 0 && !e.sync ? (t.emit("data", r), t.read(0)) : (e.length += e.objectMode ? 1 : r.length, i ? e.buffer.unshift(r) : e.buffer.push(r), e.needReadable && am(t))), cX(t, e);
    }
  else i || (e.reading = !1);
  return oX(e);
}
function oX(t) {
  return !t.ended && (t.needReadable || t.length < t.highWaterMark || t.length === 0);
}
vr.prototype.setEncoding = function(t) {
  return this._readableState.decoder = new Lh(t), this._readableState.encoding = t, this;
};
var mw = 8388608;
function sX(t) {
  return t >= mw ? t = mw : (t--, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, t |= t >>> 16, t++), t;
}
function gw(t, e) {
  return t <= 0 || e.length === 0 && e.ended ? 0 : e.objectMode ? 1 : t !== t ? e.flowing && e.length ? e.buffer.head.data.length : e.length : (t > e.highWaterMark && (e.highWaterMark = sX(t)), t <= e.length ? t : e.ended ? e.length : (e.needReadable = !0, 0));
}
vr.prototype.read = function(t) {
  W0("read", t), t = parseInt(t, 10);
  var e = this._readableState, r = t;
  if (t !== 0 && (e.emittedReadable = !1), t === 0 && e.needReadable && (e.length >= e.highWaterMark || e.ended))
    return W0("read: emitReadable", e.length, e.ended), e.length === 0 && e.ended ? m4(this) : am(this), null;
  if (t = gw(t, e), t === 0 && e.ended)
    return e.length === 0 && m4(this), null;
  var n = e.needReadable;
  W0("need readable", n), (e.length === 0 || e.length - t < e.highWaterMark) && (n = !0, W0("length less than watermark", n)), e.ended || e.reading ? (n = !1, W0("reading or ended", n)) : n && (W0("do read"), e.reading = !0, e.sync = !0, e.length === 0 && (e.needReadable = !0), this._read(e.highWaterMark), e.sync = !1, e.reading || (t = gw(r, e)));
  var i;
  return t > 0 ? i = yC(t, e) : i = null, i === null ? (e.needReadable = !0, t = 0) : e.length -= t, e.length === 0 && (e.ended || (e.needReadable = !0), r !== t && e.ended && m4(this)), i !== null && this.emit("data", i), i;
};
function lX(t, e) {
  var r = null;
  return !Re.isBuffer(e) && typeof e != "string" && e !== null && e !== void 0 && !t.objectMode && (r = new TypeError("Invalid non-string/buffer chunk")), r;
}
function uX(t, e) {
  if (!e.ended) {
    if (e.decoder) {
      var r = e.decoder.end();
      r && r.length && (e.buffer.push(r), e.length += e.objectMode ? 1 : r.length);
    }
    e.ended = !0, am(t);
  }
}
function am(t) {
  var e = t._readableState;
  e.needReadable = !1, e.emittedReadable || (W0("emitReadable", e.flowing), e.emittedReadable = !0, e.sync ? ia(vw, t) : vw(t));
}
function vw(t) {
  W0("emit readable"), t.emit("readable"), ex(t);
}
function cX(t, e) {
  e.readingMore || (e.readingMore = !0, ia(fX, t, e));
}
function fX(t, e) {
  for (var r = e.length; !e.reading && !e.flowing && !e.ended && e.length < e.highWaterMark && (W0("maybeReadMore read 0"), t.read(0), r !== e.length); )
    r = e.length;
  e.readingMore = !1;
}
vr.prototype._read = function(t) {
  this.emit("error", new Error("not implemented"));
};
vr.prototype.pipe = function(t, e) {
  var r = this, n = this._readableState;
  switch (n.pipesCount) {
    case 0:
      n.pipes = t;
      break;
    case 1:
      n.pipes = [n.pipes, t];
      break;
    default:
      n.pipes.push(t);
      break;
  }
  n.pipesCount += 1, W0("pipe count=%d opts=%j", n.pipesCount, e);
  var i = !e || e.end !== !1, a = i ? s : d;
  n.endEmitted ? ia(a) : r.once("end", a), t.on("unpipe", o);
  function o(k) {
    W0("onunpipe"), k === r && d();
  }
  function s() {
    W0("onend"), t.end();
  }
  var l = dX(r);
  t.on("drain", l);
  var u = !1;
  function d() {
    W0("cleanup"), t.removeListener("close", x), t.removeListener("finish", A), t.removeListener("drain", l), t.removeListener("error", b), t.removeListener("unpipe", o), r.removeListener("end", s), r.removeListener("end", d), r.removeListener("data", v), u = !0, n.awaitDrain && (!t._writableState || t._writableState.needDrain) && l();
  }
  var h = !1;
  r.on("data", v);
  function v(k) {
    W0("ondata"), h = !1;
    var E = t.write(k);
    E === !1 && !h && ((n.pipesCount === 1 && n.pipes === t || n.pipesCount > 1 && wC(n.pipes, t) !== -1) && !u && (W0("false write response, pause", r._readableState.awaitDrain), r._readableState.awaitDrain++, h = !0), r.pause());
  }
  function b(k) {
    W0("onerror", k), T(), t.removeListener("error", b), aX(t, "error") === 0 && t.emit("error", k);
  }
  iX(t, "error", b);
  function x() {
    t.removeListener("finish", A), T();
  }
  t.once("close", x);
  function A() {
    W0("onfinish"), t.removeListener("close", x), T();
  }
  t.once("finish", A);
  function T() {
    W0("unpipe"), r.unpipe(t);
  }
  return t.emit("pipe", r), n.flowing || (W0("pipe resume"), r.resume()), t;
};
function dX(t) {
  return function() {
    var e = t._readableState;
    W0("pipeOnDrain", e.awaitDrain), e.awaitDrain && e.awaitDrain--, e.awaitDrain === 0 && t.listeners("data").length && (e.flowing = !0, ex(t));
  };
}
vr.prototype.unpipe = function(t) {
  var e = this._readableState;
  if (e.pipesCount === 0) return this;
  if (e.pipesCount === 1)
    return t && t !== e.pipes ? this : (t || (t = e.pipes), e.pipes = null, e.pipesCount = 0, e.flowing = !1, t && t.emit("unpipe", this), this);
  if (!t) {
    var r = e.pipes, n = e.pipesCount;
    e.pipes = null, e.pipesCount = 0, e.flowing = !1;
    for (var i = 0; i < n; i++)
      r[i].emit("unpipe", this);
    return this;
  }
  var a = wC(e.pipes, t);
  return a === -1 ? this : (e.pipes.splice(a, 1), e.pipesCount -= 1, e.pipesCount === 1 && (e.pipes = e.pipes[0]), t.emit("unpipe", this), this);
};
vr.prototype.on = function(t, e) {
  var r = f0.prototype.on.call(this, t, e);
  if (t === "data")
    this._readableState.flowing !== !1 && this.resume();
  else if (t === "readable") {
    var n = this._readableState;
    !n.endEmitted && !n.readableListening && (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && am(this) : ia(hX, this));
  }
  return r;
};
vr.prototype.addListener = vr.prototype.on;
function hX(t) {
  W0("readable nexttick read 0"), t.read(0);
}
vr.prototype.resume = function() {
  var t = this._readableState;
  return t.flowing || (W0("resume"), t.flowing = !0, pX(this, t)), this;
};
function pX(t, e) {
  e.resumeScheduled || (e.resumeScheduled = !0, ia(mX, t, e));
}
function mX(t, e) {
  e.reading || (W0("resume read 0"), t.read(0)), e.resumeScheduled = !1, e.awaitDrain = 0, t.emit("resume"), ex(t), e.flowing && !e.reading && t.read(0);
}
vr.prototype.pause = function() {
  return W0("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (W0("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
};
function ex(t) {
  var e = t._readableState;
  for (W0("flow", e.flowing); e.flowing && t.read() !== null; )
    ;
}
vr.prototype.wrap = function(t) {
  var e = this._readableState, r = !1, n = this;
  t.on("end", function() {
    if (W0("wrapped end"), e.decoder && !e.ended) {
      var o = e.decoder.end();
      o && o.length && n.push(o);
    }
    n.push(null);
  }), t.on("data", function(o) {
    if (W0("wrapped data"), e.decoder && (o = e.decoder.write(o)), !(e.objectMode && o == null) && !(!e.objectMode && (!o || !o.length))) {
      var s = n.push(o);
      s || (r = !0, t.pause());
    }
  });
  for (var i in t)
    this[i] === void 0 && typeof t[i] == "function" && (this[i] = /* @__PURE__ */ function(o) {
      return function() {
        return t[o].apply(t, arguments);
      };
    }(i));
  var a = ["error", "close", "destroy", "pause", "resume"];
  return yX(a, function(o) {
    t.on(o, n.emit.bind(n, o));
  }), n._read = function(o) {
    W0("wrapped _read", o), r && (r = !1, t.resume());
  }, n;
};
vr._fromList = yC;
function yC(t, e) {
  if (e.length === 0) return null;
  var r;
  return e.objectMode ? r = e.buffer.shift() : !t || t >= e.length ? (e.decoder ? r = e.buffer.join("") : e.buffer.length === 1 ? r = e.buffer.head.data : r = e.buffer.concat(e.length), e.buffer.clear()) : r = gX(t, e.buffer, e.decoder), r;
}
function gX(t, e, r) {
  var n;
  return t < e.head.data.length ? (n = e.head.data.slice(0, t), e.head.data = e.head.data.slice(t)) : t === e.head.data.length ? n = e.shift() : n = r ? vX(t, e) : bX(t, e), n;
}
function vX(t, e) {
  var r = e.head, n = 1, i = r.data;
  for (t -= i.length; r = r.next; ) {
    var a = r.data, o = t > a.length ? a.length : t;
    if (o === a.length ? i += a : i += a.slice(0, t), t -= o, t === 0) {
      o === a.length ? (++n, r.next ? e.head = r.next : e.head = e.tail = null) : (e.head = r, r.data = a.slice(o));
      break;
    }
    ++n;
  }
  return e.length -= n, i;
}
function bX(t, e) {
  var r = Re.allocUnsafe(t), n = e.head, i = 1;
  for (n.data.copy(r), t -= n.data.length; n = n.next; ) {
    var a = n.data, o = t > a.length ? a.length : t;
    if (a.copy(r, r.length - t, 0, o), t -= o, t === 0) {
      o === a.length ? (++i, n.next ? e.head = n.next : e.head = e.tail = null) : (e.head = n, n.data = a.slice(o));
      break;
    }
    ++i;
  }
  return e.length -= i, r;
}
function m4(t) {
  var e = t._readableState;
  if (e.length > 0) throw new Error('"endReadable()" called on non-empty stream');
  e.endEmitted || (e.ended = !0, ia(xX, e, t));
}
function xX(t, e) {
  !t.endEmitted && t.length === 0 && (t.endEmitted = !0, e.readable = !1, e.emit("end"));
}
function yX(t, e) {
  for (var r = 0, n = t.length; r < n; r++)
    e(t[r], r);
}
function wC(t, e) {
  for (var r = 0, n = t.length; r < n; r++)
    if (t[r] === e) return r;
  return -1;
}
Dn.WritableState = tx;
ll(Dn, f0);
function wX() {
}
function _X(t, e, r) {
  this.chunk = t, this.encoding = e, this.callback = r, this.next = null;
}
function tx(t, e) {
  Object.defineProperty(this, "buffer", {
    get: nm(function() {
      return this.getBuffer();
    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.")
  }), t = t || {}, this.objectMode = !!t.objectMode, e instanceof ra && (this.objectMode = this.objectMode || !!t.writableObjectMode);
  var r = t.highWaterMark, n = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = r || r === 0 ? r : n, this.highWaterMark = ~~this.highWaterMark, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1;
  var i = t.decodeStrings === !1;
  this.decodeStrings = !i, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(a) {
    FX(e, a);
  }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new SC(this);
}
tx.prototype.getBuffer = function() {
  for (var e = this.bufferedRequest, r = []; e; )
    r.push(e), e = e.next;
  return r;
};
function Dn(t) {
  if (!(this instanceof Dn) && !(this instanceof ra)) return new Dn(t);
  this._writableState = new tx(t, this), this.writable = !0, t && (typeof t.write == "function" && (this._write = t.write), typeof t.writev == "function" && (this._writev = t.writev)), f0.call(this);
}
Dn.prototype.pipe = function() {
  this.emit("error", new Error("Cannot pipe, not readable"));
};
function AX(t, e) {
  var r = new Error("write after end");
  t.emit("error", r), ia(e, r);
}
function EX(t, e, r, n) {
  var i = !0, a = !1;
  return r === null ? a = new TypeError("May not write null values to stream") : !Re.isBuffer(r) && typeof r != "string" && r !== void 0 && !e.objectMode && (a = new TypeError("Invalid non-string/buffer chunk")), a && (t.emit("error", a), ia(n, a), i = !1), i;
}
Dn.prototype.write = function(t, e, r) {
  var n = this._writableState, i = !1;
  return typeof e == "function" && (r = e, e = null), Re.isBuffer(t) ? e = "buffer" : e || (e = n.defaultEncoding), typeof r != "function" && (r = wX), n.ended ? AX(this, r) : EX(this, n, t, r) && (n.pendingcb++, i = CX(this, n, t, e, r)), i;
};
Dn.prototype.cork = function() {
  var t = this._writableState;
  t.corked++;
};
Dn.prototype.uncork = function() {
  var t = this._writableState;
  t.corked && (t.corked--, !t.writing && !t.corked && !t.finished && !t.bufferProcessing && t.bufferedRequest && _C(this, t));
};
Dn.prototype.setDefaultEncoding = function(e) {
  if (typeof e == "string" && (e = e.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((e + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + e);
  return this._writableState.defaultEncoding = e, this;
};
function SX(t, e, r) {
  return !t.objectMode && t.decodeStrings !== !1 && typeof e == "string" && (e = Re.from(e, r)), e;
}
function CX(t, e, r, n, i) {
  r = SX(e, r, n), Re.isBuffer(r) && (n = "buffer");
  var a = e.objectMode ? 1 : r.length;
  e.length += a;
  var o = e.length < e.highWaterMark;
  if (o || (e.needDrain = !0), e.writing || e.corked) {
    var s = e.lastBufferedRequest;
    e.lastBufferedRequest = new _X(r, n, i), s ? s.next = e.lastBufferedRequest : e.bufferedRequest = e.lastBufferedRequest, e.bufferedRequestCount += 1;
  } else
    F3(t, e, !1, a, r, n, i);
  return o;
}
function F3(t, e, r, n, i, a, o) {
  e.writelen = n, e.writecb = o, e.writing = !0, e.sync = !0, r ? t._writev(i, e.onwrite) : t._write(i, a, e.onwrite), e.sync = !1;
}
function kX(t, e, r, n, i) {
  --e.pendingcb, r ? ia(i, n) : i(n), t._writableState.errorEmitted = !0, t.emit("error", n);
}
function TX(t) {
  t.writing = !1, t.writecb = null, t.length -= t.writelen, t.writelen = 0;
}
function FX(t, e) {
  var r = t._writableState, n = r.sync, i = r.writecb;
  if (TX(r), e) kX(t, r, n, e, i);
  else {
    var a = AC(r);
    !a && !r.corked && !r.bufferProcessing && r.bufferedRequest && _C(t, r), n ? ia(bw, t, r, a, i) : bw(t, r, a, i);
  }
}
function bw(t, e, r, n) {
  r || DX(t, e), e.pendingcb--, n(), EC(t, e);
}
function DX(t, e) {
  e.length === 0 && e.needDrain && (e.needDrain = !1, t.emit("drain"));
}
function _C(t, e) {
  e.bufferProcessing = !0;
  var r = e.bufferedRequest;
  if (t._writev && r && r.next) {
    var n = e.bufferedRequestCount, i = new Array(n), a = e.corkedRequestsFree;
    a.entry = r;
    for (var o = 0; r; )
      i[o] = r, r = r.next, o += 1;
    F3(t, e, !0, e.length, i, "", a.finish), e.pendingcb++, e.lastBufferedRequest = null, a.next ? (e.corkedRequestsFree = a.next, a.next = null) : e.corkedRequestsFree = new SC(e);
  } else {
    for (; r; ) {
      var s = r.chunk, l = r.encoding, u = r.callback, d = e.objectMode ? 1 : s.length;
      if (F3(t, e, !1, d, s, l, u), r = r.next, e.writing)
        break;
    }
    r === null && (e.lastBufferedRequest = null);
  }
  e.bufferedRequestCount = 0, e.bufferedRequest = r, e.bufferProcessing = !1;
}
Dn.prototype._write = function(t, e, r) {
  r(new Error("not implemented"));
};
Dn.prototype._writev = null;
Dn.prototype.end = function(t, e, r) {
  var n = this._writableState;
  typeof t == "function" ? (r = t, t = null, e = null) : typeof e == "function" && (r = e, e = null), t != null && this.write(t, e), n.corked && (n.corked = 1, this.uncork()), !n.ending && !n.finished && OX(this, n, r);
};
function AC(t) {
  return t.ending && t.length === 0 && t.bufferedRequest === null && !t.finished && !t.writing;
}
function xw(t, e) {
  e.prefinished || (e.prefinished = !0, t.emit("prefinish"));
}
function EC(t, e) {
  var r = AC(e);
  return r && (e.pendingcb === 0 ? (xw(t, e), e.finished = !0, t.emit("finish")) : xw(t, e)), r;
}
function OX(t, e, r) {
  e.ending = !0, EC(t, e), r && (e.finished ? ia(r) : t.once("finish", r)), e.ended = !0, t.writable = !1;
}
function SC(t) {
  var e = this;
  this.next = null, this.entry = null, this.finish = function(r) {
    var n = e.entry;
    for (e.entry = null; n; ) {
      var i = n.callback;
      t.pendingcb--, i(r), n = n.next;
    }
    t.corkedRequestsFree ? t.corkedRequestsFree.next = e : t.corkedRequestsFree = e;
  };
}
ll(ra, vr);
var yw = Object.keys(Dn.prototype);
for (var g4 = 0; g4 < yw.length; g4++) {
  var v4 = yw[g4];
  ra.prototype[v4] || (ra.prototype[v4] = Dn.prototype[v4]);
}
function ra(t) {
  if (!(this instanceof ra)) return new ra(t);
  vr.call(this, t), Dn.call(this, t), t && t.readable === !1 && (this.readable = !1), t && t.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, t && t.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", RX);
}
function RX() {
  this.allowHalfOpen || this._writableState.ended || ia(PX, this);
}
function PX(t) {
  t.end();
}
ll(so, ra);
function IX(t) {
  this.afterTransform = function(e, r) {
    return BX(t, e, r);
  }, this.needTransform = !1, this.transforming = !1, this.writecb = null, this.writechunk = null, this.writeencoding = null;
}
function BX(t, e, r) {
  var n = t._transformState;
  n.transforming = !1;
  var i = n.writecb;
  if (!i) return t.emit("error", new Error("no writecb in Transform class"));
  n.writechunk = null, n.writecb = null, r != null && t.push(r), i(e);
  var a = t._readableState;
  a.reading = !1, (a.needReadable || a.length < a.highWaterMark) && t._read(a.highWaterMark);
}
function so(t) {
  if (!(this instanceof so)) return new so(t);
  ra.call(this, t), this._transformState = new IX(this);
  var e = this;
  this._readableState.needReadable = !0, this._readableState.sync = !1, t && (typeof t.transform == "function" && (this._transform = t.transform), typeof t.flush == "function" && (this._flush = t.flush)), this.once("prefinish", function() {
    typeof this._flush == "function" ? this._flush(function(r) {
      ww(e, r);
    }) : ww(e);
  });
}
so.prototype.push = function(t, e) {
  return this._transformState.needTransform = !1, ra.prototype.push.call(this, t, e);
};
so.prototype._transform = function(t, e, r) {
  throw new Error("Not implemented");
};
so.prototype._write = function(t, e, r) {
  var n = this._transformState;
  if (n.writecb = r, n.writechunk = t, n.writeencoding = e, !n.transforming) {
    var i = this._readableState;
    (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
  }
};
so.prototype._read = function(t) {
  var e = this._transformState;
  e.writechunk !== null && e.writecb && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
};
function ww(t, e) {
  if (e) return t.emit("error", e);
  var r = t._writableState, n = t._transformState;
  if (r.length) throw new Error("Calling transform done when ws.length != 0");
  if (n.transforming) throw new Error("Calling transform done when still transforming");
  return t.push(null);
}
ll(f1, so);
function f1(t) {
  if (!(this instanceof f1)) return new f1(t);
  so.call(this, t);
}
f1.prototype._transform = function(t, e, r) {
  r(null, t);
};
ll(lo, f0);
lo.Readable = vr;
lo.Writable = Dn;
lo.Duplex = ra;
lo.Transform = so;
lo.PassThrough = f1;
lo.Stream = lo;
function lo() {
  f0.call(this);
}
lo.prototype.pipe = function(t, e) {
  var r = this;
  function n(d) {
    t.writable && t.write(d) === !1 && r.pause && r.pause();
  }
  r.on("data", n);
  function i() {
    r.readable && r.resume && r.resume();
  }
  t.on("drain", i), !t._isStdio && (!e || e.end !== !1) && (r.on("end", o), r.on("close", s));
  var a = !1;
  function o() {
    a || (a = !0, t.end());
  }
  function s() {
    a || (a = !0, typeof t.destroy == "function" && t.destroy());
  }
  function l(d) {
    if (u(), f0.listenerCount(this, "error") === 0)
      throw d;
  }
  r.on("error", l), t.on("error", l);
  function u() {
    r.removeListener("data", n), t.removeListener("drain", i), r.removeListener("end", o), r.removeListener("close", s), r.removeListener("error", l), t.removeListener("error", l), r.removeListener("end", u), r.removeListener("close", u), t.removeListener("close", u);
  }
  return r.on("end", u), r.on("close", u), t.on("close", u), t.emit("pipe", r), t;
};
var LX = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Duplex: ra,
  PassThrough: f1,
  Readable: vr,
  Stream: lo,
  Transform: so,
  Writable: Dn,
  default: lo
}), NX = /* @__PURE__ */ tm(LX), CC = {};
function _w(t, e) {
  if (t === e)
    return 0;
  for (var r = t.length, n = e.length, i = 0, a = Math.min(r, n); i < a; ++i)
    if (t[i] !== e[i]) {
      r = t[i], n = e[i];
      break;
    }
  return r < n ? -1 : n < r ? 1 : 0;
}
var MX = Object.prototype.hasOwnProperty, Aw = Object.keys || function(t) {
  var e = [];
  for (var r in t)
    MX.call(t, r) && e.push(r);
  return e;
}, Ew = Array.prototype.slice, b4;
function kC() {
  return typeof b4 < "u" ? b4 : b4 = function() {
    return function() {
    }.name === "foo";
  }();
}
function Sw(t) {
  return Object.prototype.toString.call(t);
}
function Cw(t) {
  return Zu(t) || typeof yc.ArrayBuffer != "function" ? !1 : typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(t) : t ? !!(t instanceof DataView || t.buffer && t.buffer instanceof ArrayBuffer) : !1;
}
function ui(t, e) {
  t || si(t, !0, e, "==", lh);
}
var UX = /\s*function\s+([^\(\s]*)\s*/;
function TC(t) {
  if (fc(t)) {
    if (kC())
      return t.name;
    var e = t.toString(), r = e.match(UX);
    return r && r[1];
  }
}
ui.AssertionError = om;
function om(t) {
  this.name = "AssertionError", this.actual = t.actual, this.expected = t.expected, this.operator = t.operator, t.message ? (this.message = t.message, this.generatedMessage = !1) : (this.message = zX(this), this.generatedMessage = !0);
  var e = t.stackStartFunction || si;
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, e);
  else {
    var r = new Error();
    if (r.stack) {
      var n = r.stack, i = TC(e), a = n.indexOf(`
` + i);
      if (a >= 0) {
        var o = n.indexOf(`
`, a + 1);
        n = n.substring(o + 1);
      }
      this.stack = n;
    }
  }
}
ll(om, Error);
function kw(t, e) {
  return typeof t == "string" ? t.length < e ? t : t.slice(0, e) : t;
}
function Tw(t) {
  if (kC() || !fc(t))
    return eo(t);
  var e = TC(t), r = e ? ": " + e : "";
  return "[Function" + r + "]";
}
function zX(t) {
  return kw(Tw(t.actual), 128) + " " + t.operator + " " + kw(Tw(t.expected), 128);
}
function si(t, e, r, n, i) {
  throw new om({
    message: r,
    actual: t,
    expected: e,
    operator: n,
    stackStartFunction: i
  });
}
ui.fail = si;
function lh(t, e) {
  t || si(t, !0, e, "==", lh);
}
ui.ok = lh;
ui.equal = rx;
function rx(t, e, r) {
  t != e && si(t, e, r, "==", rx);
}
ui.notEqual = nx;
function nx(t, e, r) {
  t == e && si(t, e, r, "!=", nx);
}
ui.deepEqual = ix;
function ix(t, e, r) {
  d1(t, e, !1) || si(t, e, r, "deepEqual", ix);
}
ui.deepStrictEqual = ax;
function ax(t, e, r) {
  d1(t, e, !0) || si(t, e, r, "deepStrictEqual", ax);
}
function d1(t, e, r, n) {
  if (t === e)
    return !0;
  if (Zu(t) && Zu(e))
    return _w(t, e) === 0;
  if (c1(t) && c1(e))
    return t.getTime() === e.getTime();
  if (cc(t) && cc(e))
    return t.source === e.source && t.global === e.global && t.multiline === e.multiline && t.lastIndex === e.lastIndex && t.ignoreCase === e.ignoreCase;
  if ((t === null || typeof t != "object") && (e === null || typeof e != "object"))
    return r ? t === e : t == e;
  if (Cw(t) && Cw(e) && Sw(t) === Sw(e) && !(t instanceof Float32Array || t instanceof Float64Array))
    return _w(
      new Uint8Array(t.buffer),
      new Uint8Array(e.buffer)
    ) === 0;
  if (Zu(t) !== Zu(e))
    return !1;
  n = n || { actual: [], expected: [] };
  var i = n.actual.indexOf(t);
  return i !== -1 && i === n.expected.indexOf(e) ? !0 : (n.actual.push(t), n.expected.push(e), $X(t, e, r, n));
}
function Fw(t) {
  return Object.prototype.toString.call(t) == "[object Arguments]";
}
function $X(t, e, r, n) {
  if (t == null || e === null || e === void 0)
    return !1;
  if (ep(t) || ep(e))
    return t === e;
  if (r && Object.getPrototypeOf(t) !== Object.getPrototypeOf(e))
    return !1;
  var i = Fw(t), a = Fw(e);
  if (i && !a || !i && a)
    return !1;
  if (i)
    return t = Ew.call(t), e = Ew.call(e), d1(t, e, r);
  var o = Aw(t), s = Aw(e), l, u;
  if (o.length !== s.length)
    return !1;
  for (o.sort(), s.sort(), u = o.length - 1; u >= 0; u--)
    if (o[u] !== s[u])
      return !1;
  for (u = o.length - 1; u >= 0; u--)
    if (l = o[u], !d1(t[l], e[l], r, n))
      return !1;
  return !0;
}
ui.notDeepEqual = ox;
function ox(t, e, r) {
  d1(t, e, !1) && si(t, e, r, "notDeepEqual", ox);
}
ui.notDeepStrictEqual = sx;
function sx(t, e, r) {
  d1(t, e, !0) && si(t, e, r, "notDeepStrictEqual", sx);
}
ui.strictEqual = lx;
function lx(t, e, r) {
  t !== e && si(t, e, r, "===", lx);
}
ui.notStrictEqual = ux;
function ux(t, e, r) {
  t === e && si(t, e, r, "!==", ux);
}
function Dw(t, e) {
  if (!t || !e)
    return !1;
  if (Object.prototype.toString.call(e) == "[object RegExp]")
    return e.test(t);
  try {
    if (t instanceof e)
      return !0;
  } catch {
  }
  return Error.isPrototypeOf(e) ? !1 : e.call({}, t) === !0;
}
function VX(t) {
  var e;
  try {
    t();
  } catch (r) {
    e = r;
  }
  return e;
}
function FC(t, e, r, n) {
  var i;
  if (typeof e != "function")
    throw new TypeError('"block" argument must be a function');
  typeof r == "string" && (n = r, r = null), i = VX(e), n = (r && r.name ? " (" + r.name + ")." : ".") + (n ? " " + n : "."), t && !i && si(i, r, "Missing expected exception" + n);
  var a = typeof n == "string", o = !t && Jf(i), s = !t && i && !r;
  if ((o && a && Dw(i, r) || s) && si(i, r, "Got unwanted exception" + n), t && i && r && !Dw(i, r) || !t && i)
    throw i;
}
ui.throws = DC;
function DC(t, e, r) {
  FC(!0, t, e, r);
}
ui.doesNotThrow = OC;
function OC(t, e, r) {
  FC(!1, t, e, r);
}
ui.ifError = RC;
function RC(t) {
  if (t) throw t;
}
var jX = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  AssertionError: om,
  assert: lh,
  deepEqual: ix,
  deepStrictEqual: ax,
  default: ui,
  doesNotThrow: OC,
  equal: rx,
  fail: si,
  ifError: RC,
  notDeepEqual: ox,
  notDeepStrictEqual: sx,
  notEqual: nx,
  notStrictEqual: ux,
  ok: lh,
  strictEqual: lx,
  throws: DC
}), PC = /* @__PURE__ */ tm(jX);
function WX() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var HX = WX, ps = {}, Nh = {};
(function(t) {
  var e = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
  function r(a, o) {
    return Object.prototype.hasOwnProperty.call(a, o);
  }
  t.assign = function(a) {
    for (var o = Array.prototype.slice.call(arguments, 1); o.length; ) {
      var s = o.shift();
      if (s) {
        if (typeof s != "object")
          throw new TypeError(s + "must be non-object");
        for (var l in s)
          r(s, l) && (a[l] = s[l]);
      }
    }
    return a;
  }, t.shrinkBuf = function(a, o) {
    return a.length === o ? a : a.subarray ? a.subarray(0, o) : (a.length = o, a);
  };
  var n = {
    arraySet: function(a, o, s, l, u) {
      if (o.subarray && a.subarray) {
        a.set(o.subarray(s, s + l), u);
        return;
      }
      for (var d = 0; d < l; d++)
        a[u + d] = o[s + d];
    },
    // Join array of chunks to single array.
    flattenChunks: function(a) {
      var o, s, l, u, d, h;
      for (l = 0, o = 0, s = a.length; o < s; o++)
        l += a[o].length;
      for (h = new Uint8Array(l), u = 0, o = 0, s = a.length; o < s; o++)
        d = a[o], h.set(d, u), u += d.length;
      return h;
    }
  }, i = {
    arraySet: function(a, o, s, l, u) {
      for (var d = 0; d < l; d++)
        a[u + d] = o[s + d];
    },
    // Join array of chunks to single array.
    flattenChunks: function(a) {
      return [].concat.apply([], a);
    }
  };
  t.setTyped = function(a) {
    a ? (t.Buf8 = Uint8Array, t.Buf16 = Uint16Array, t.Buf32 = Int32Array, t.assign(t, n)) : (t.Buf8 = Array, t.Buf16 = Array, t.Buf32 = Array, t.assign(t, i));
  }, t.setTyped(e);
})(Nh);
var C1 = {}, qX = Nh, YX = 4, Ow = 0, Rw = 1, GX = 2;
function k1(t) {
  for (var e = t.length; --e >= 0; )
    t[e] = 0;
}
var ZX = 0, IC = 1, XX = 2, KX = 3, JX = 258, cx = 29, Mh = 256, uh = Mh + 1 + cx, Qf = 30, fx = 19, BC = 2 * uh + 1, Ku = 15, x4 = 16, QX = 7, dx = 256, LC = 16, NC = 17, MC = 18, D3 = (
  /* extra bits for each length code */
  [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
), c5 = (
  /* extra bits for each distance code */
  [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
), eK = (
  /* extra bits for each bit length code */
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
), UC = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], tK = 512, Xs = new Array((uh + 2) * 2);
k1(Xs);
var $d = new Array(Qf * 2);
k1($d);
var ch = new Array(tK);
k1(ch);
var fh = new Array(JX - KX + 1);
k1(fh);
var hx = new Array(cx);
k1(hx);
var tp = new Array(Qf);
k1(tp);
function y4(t, e, r, n, i) {
  this.static_tree = t, this.extra_bits = e, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = t && t.length;
}
var zC, $C, VC;
function w4(t, e) {
  this.dyn_tree = t, this.max_code = 0, this.stat_desc = e;
}
function jC(t) {
  return t < 256 ? ch[t] : ch[256 + (t >>> 7)];
}
function dh(t, e) {
  t.pending_buf[t.pending++] = e & 255, t.pending_buf[t.pending++] = e >>> 8 & 255;
}
function ki(t, e, r) {
  t.bi_valid > x4 - r ? (t.bi_buf |= e << t.bi_valid & 65535, dh(t, t.bi_buf), t.bi_buf = e >> x4 - t.bi_valid, t.bi_valid += r - x4) : (t.bi_buf |= e << t.bi_valid & 65535, t.bi_valid += r);
}
function Yo(t, e, r) {
  ki(
    t,
    r[e * 2],
    r[e * 2 + 1]
    /*.Len*/
  );
}
function WC(t, e) {
  var r = 0;
  do
    r |= t & 1, t >>>= 1, r <<= 1;
  while (--e > 0);
  return r >>> 1;
}
function rK(t) {
  t.bi_valid === 16 ? (dh(t, t.bi_buf), t.bi_buf = 0, t.bi_valid = 0) : t.bi_valid >= 8 && (t.pending_buf[t.pending++] = t.bi_buf & 255, t.bi_buf >>= 8, t.bi_valid -= 8);
}
function nK(t, e) {
  var r = e.dyn_tree, n = e.max_code, i = e.stat_desc.static_tree, a = e.stat_desc.has_stree, o = e.stat_desc.extra_bits, s = e.stat_desc.extra_base, l = e.stat_desc.max_length, u, d, h, v, b, x, A = 0;
  for (v = 0; v <= Ku; v++)
    t.bl_count[v] = 0;
  for (r[t.heap[t.heap_max] * 2 + 1] = 0, u = t.heap_max + 1; u < BC; u++)
    d = t.heap[u], v = r[r[d * 2 + 1] * 2 + 1] + 1, v > l && (v = l, A++), r[d * 2 + 1] = v, !(d > n) && (t.bl_count[v]++, b = 0, d >= s && (b = o[d - s]), x = r[d * 2], t.opt_len += x * (v + b), a && (t.static_len += x * (i[d * 2 + 1] + b)));
  if (A !== 0) {
    do {
      for (v = l - 1; t.bl_count[v] === 0; )
        v--;
      t.bl_count[v]--, t.bl_count[v + 1] += 2, t.bl_count[l]--, A -= 2;
    } while (A > 0);
    for (v = l; v !== 0; v--)
      for (d = t.bl_count[v]; d !== 0; )
        h = t.heap[--u], !(h > n) && (r[h * 2 + 1] !== v && (t.opt_len += (v - r[h * 2 + 1]) * r[h * 2], r[h * 2 + 1] = v), d--);
  }
}
function HC(t, e, r) {
  var n = new Array(Ku + 1), i = 0, a, o;
  for (a = 1; a <= Ku; a++)
    n[a] = i = i + r[a - 1] << 1;
  for (o = 0; o <= e; o++) {
    var s = t[o * 2 + 1];
    s !== 0 && (t[o * 2] = WC(n[s]++, s));
  }
}
function iK() {
  var t, e, r, n, i, a = new Array(Ku + 1);
  for (r = 0, n = 0; n < cx - 1; n++)
    for (hx[n] = r, t = 0; t < 1 << D3[n]; t++)
      fh[r++] = n;
  for (fh[r - 1] = n, i = 0, n = 0; n < 16; n++)
    for (tp[n] = i, t = 0; t < 1 << c5[n]; t++)
      ch[i++] = n;
  for (i >>= 7; n < Qf; n++)
    for (tp[n] = i << 7, t = 0; t < 1 << c5[n] - 7; t++)
      ch[256 + i++] = n;
  for (e = 0; e <= Ku; e++)
    a[e] = 0;
  for (t = 0; t <= 143; )
    Xs[t * 2 + 1] = 8, t++, a[8]++;
  for (; t <= 255; )
    Xs[t * 2 + 1] = 9, t++, a[9]++;
  for (; t <= 279; )
    Xs[t * 2 + 1] = 7, t++, a[7]++;
  for (; t <= 287; )
    Xs[t * 2 + 1] = 8, t++, a[8]++;
  for (HC(Xs, uh + 1, a), t = 0; t < Qf; t++)
    $d[t * 2 + 1] = 5, $d[t * 2] = WC(t, 5);
  zC = new y4(Xs, D3, Mh + 1, uh, Ku), $C = new y4($d, c5, 0, Qf, Ku), VC = new y4(new Array(0), eK, 0, fx, QX);
}
function qC(t) {
  var e;
  for (e = 0; e < uh; e++)
    t.dyn_ltree[e * 2] = 0;
  for (e = 0; e < Qf; e++)
    t.dyn_dtree[e * 2] = 0;
  for (e = 0; e < fx; e++)
    t.bl_tree[e * 2] = 0;
  t.dyn_ltree[dx * 2] = 1, t.opt_len = t.static_len = 0, t.last_lit = t.matches = 0;
}
function YC(t) {
  t.bi_valid > 8 ? dh(t, t.bi_buf) : t.bi_valid > 0 && (t.pending_buf[t.pending++] = t.bi_buf), t.bi_buf = 0, t.bi_valid = 0;
}
function aK(t, e, r, n) {
  YC(t), dh(t, r), dh(t, ~r), qX.arraySet(t.pending_buf, t.window, e, r, t.pending), t.pending += r;
}
function Pw(t, e, r, n) {
  var i = e * 2, a = r * 2;
  return t[i] < t[a] || t[i] === t[a] && n[e] <= n[r];
}
function _4(t, e, r) {
  for (var n = t.heap[r], i = r << 1; i <= t.heap_len && (i < t.heap_len && Pw(e, t.heap[i + 1], t.heap[i], t.depth) && i++, !Pw(e, n, t.heap[i], t.depth)); )
    t.heap[r] = t.heap[i], r = i, i <<= 1;
  t.heap[r] = n;
}
function Iw(t, e, r) {
  var n, i, a = 0, o, s;
  if (t.last_lit !== 0)
    do
      n = t.pending_buf[t.d_buf + a * 2] << 8 | t.pending_buf[t.d_buf + a * 2 + 1], i = t.pending_buf[t.l_buf + a], a++, n === 0 ? Yo(t, i, e) : (o = fh[i], Yo(t, o + Mh + 1, e), s = D3[o], s !== 0 && (i -= hx[o], ki(t, i, s)), n--, o = jC(n), Yo(t, o, r), s = c5[o], s !== 0 && (n -= tp[o], ki(t, n, s)));
    while (a < t.last_lit);
  Yo(t, dx, e);
}
function O3(t, e) {
  var r = e.dyn_tree, n = e.stat_desc.static_tree, i = e.stat_desc.has_stree, a = e.stat_desc.elems, o, s, l = -1, u;
  for (t.heap_len = 0, t.heap_max = BC, o = 0; o < a; o++)
    r[o * 2] !== 0 ? (t.heap[++t.heap_len] = l = o, t.depth[o] = 0) : r[o * 2 + 1] = 0;
  for (; t.heap_len < 2; )
    u = t.heap[++t.heap_len] = l < 2 ? ++l : 0, r[u * 2] = 1, t.depth[u] = 0, t.opt_len--, i && (t.static_len -= n[u * 2 + 1]);
  for (e.max_code = l, o = t.heap_len >> 1; o >= 1; o--)
    _4(t, r, o);
  u = a;
  do
    o = t.heap[
      1
      /*SMALLEST*/
    ], t.heap[
      1
      /*SMALLEST*/
    ] = t.heap[t.heap_len--], _4(
      t,
      r,
      1
      /*SMALLEST*/
    ), s = t.heap[
      1
      /*SMALLEST*/
    ], t.heap[--t.heap_max] = o, t.heap[--t.heap_max] = s, r[u * 2] = r[o * 2] + r[s * 2], t.depth[u] = (t.depth[o] >= t.depth[s] ? t.depth[o] : t.depth[s]) + 1, r[o * 2 + 1] = r[s * 2 + 1] = u, t.heap[
      1
      /*SMALLEST*/
    ] = u++, _4(
      t,
      r,
      1
      /*SMALLEST*/
    );
  while (t.heap_len >= 2);
  t.heap[--t.heap_max] = t.heap[
    1
    /*SMALLEST*/
  ], nK(t, e), HC(r, l, t.bl_count);
}
function Bw(t, e, r) {
  var n, i = -1, a, o = e[0 * 2 + 1], s = 0, l = 7, u = 4;
  for (o === 0 && (l = 138, u = 3), e[(r + 1) * 2 + 1] = 65535, n = 0; n <= r; n++)
    a = o, o = e[(n + 1) * 2 + 1], !(++s < l && a === o) && (s < u ? t.bl_tree[a * 2] += s : a !== 0 ? (a !== i && t.bl_tree[a * 2]++, t.bl_tree[LC * 2]++) : s <= 10 ? t.bl_tree[NC * 2]++ : t.bl_tree[MC * 2]++, s = 0, i = a, o === 0 ? (l = 138, u = 3) : a === o ? (l = 6, u = 3) : (l = 7, u = 4));
}
function Lw(t, e, r) {
  var n, i = -1, a, o = e[0 * 2 + 1], s = 0, l = 7, u = 4;
  for (o === 0 && (l = 138, u = 3), n = 0; n <= r; n++)
    if (a = o, o = e[(n + 1) * 2 + 1], !(++s < l && a === o)) {
      if (s < u)
        do
          Yo(t, a, t.bl_tree);
        while (--s !== 0);
      else a !== 0 ? (a !== i && (Yo(t, a, t.bl_tree), s--), Yo(t, LC, t.bl_tree), ki(t, s - 3, 2)) : s <= 10 ? (Yo(t, NC, t.bl_tree), ki(t, s - 3, 3)) : (Yo(t, MC, t.bl_tree), ki(t, s - 11, 7));
      s = 0, i = a, o === 0 ? (l = 138, u = 3) : a === o ? (l = 6, u = 3) : (l = 7, u = 4);
    }
}
function oK(t) {
  var e;
  for (Bw(t, t.dyn_ltree, t.l_desc.max_code), Bw(t, t.dyn_dtree, t.d_desc.max_code), O3(t, t.bl_desc), e = fx - 1; e >= 3 && t.bl_tree[UC[e] * 2 + 1] === 0; e--)
    ;
  return t.opt_len += 3 * (e + 1) + 5 + 5 + 4, e;
}
function sK(t, e, r, n) {
  var i;
  for (ki(t, e - 257, 5), ki(t, r - 1, 5), ki(t, n - 4, 4), i = 0; i < n; i++)
    ki(t, t.bl_tree[UC[i] * 2 + 1], 3);
  Lw(t, t.dyn_ltree, e - 1), Lw(t, t.dyn_dtree, r - 1);
}
function lK(t) {
  var e = 4093624447, r;
  for (r = 0; r <= 31; r++, e >>>= 1)
    if (e & 1 && t.dyn_ltree[r * 2] !== 0)
      return Ow;
  if (t.dyn_ltree[9 * 2] !== 0 || t.dyn_ltree[10 * 2] !== 0 || t.dyn_ltree[13 * 2] !== 0)
    return Rw;
  for (r = 32; r < Mh; r++)
    if (t.dyn_ltree[r * 2] !== 0)
      return Rw;
  return Ow;
}
var Nw = !1;
function uK(t) {
  Nw || (iK(), Nw = !0), t.l_desc = new w4(t.dyn_ltree, zC), t.d_desc = new w4(t.dyn_dtree, $C), t.bl_desc = new w4(t.bl_tree, VC), t.bi_buf = 0, t.bi_valid = 0, qC(t);
}
function GC(t, e, r, n) {
  ki(t, (ZX << 1) + (n ? 1 : 0), 3), aK(t, e, r);
}
function cK(t) {
  ki(t, IC << 1, 3), Yo(t, dx, Xs), rK(t);
}
function fK(t, e, r, n) {
  var i, a, o = 0;
  t.level > 0 ? (t.strm.data_type === GX && (t.strm.data_type = lK(t)), O3(t, t.l_desc), O3(t, t.d_desc), o = oK(t), i = t.opt_len + 3 + 7 >>> 3, a = t.static_len + 3 + 7 >>> 3, a <= i && (i = a)) : i = a = r + 5, r + 4 <= i && e !== -1 ? GC(t, e, r, n) : t.strategy === YX || a === i ? (ki(t, (IC << 1) + (n ? 1 : 0), 3), Iw(t, Xs, $d)) : (ki(t, (XX << 1) + (n ? 1 : 0), 3), sK(t, t.l_desc.max_code + 1, t.d_desc.max_code + 1, o + 1), Iw(t, t.dyn_ltree, t.dyn_dtree)), qC(t), n && YC(t);
}
function dK(t, e, r) {
  return t.pending_buf[t.d_buf + t.last_lit * 2] = e >>> 8 & 255, t.pending_buf[t.d_buf + t.last_lit * 2 + 1] = e & 255, t.pending_buf[t.l_buf + t.last_lit] = r & 255, t.last_lit++, e === 0 ? t.dyn_ltree[r * 2]++ : (t.matches++, e--, t.dyn_ltree[(fh[r] + Mh + 1) * 2]++, t.dyn_dtree[jC(e) * 2]++), t.last_lit === t.lit_bufsize - 1;
}
C1._tr_init = uK;
C1._tr_stored_block = GC;
C1._tr_flush_block = fK;
C1._tr_tally = dK;
C1._tr_align = cK;
function hK(t, e, r, n) {
  for (var i = t & 65535 | 0, a = t >>> 16 & 65535 | 0, o = 0; r !== 0; ) {
    o = r > 2e3 ? 2e3 : r, r -= o;
    do
      i = i + e[n++] | 0, a = a + i | 0;
    while (--o);
    i %= 65521, a %= 65521;
  }
  return i | a << 16 | 0;
}
var ZC = hK;
function pK() {
  for (var t, e = [], r = 0; r < 256; r++) {
    t = r;
    for (var n = 0; n < 8; n++)
      t = t & 1 ? 3988292384 ^ t >>> 1 : t >>> 1;
    e[r] = t;
  }
  return e;
}
var mK = pK();
function gK(t, e, r, n) {
  var i = mK, a = n + r;
  t ^= -1;
  for (var o = n; o < a; o++)
    t = t >>> 8 ^ i[(t ^ e[o]) & 255];
  return t ^ -1;
}
var XC = gK, vK = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, oi = Nh, Ea = C1, KC = ZC, Nl = XC, bK = vK, Ic = 0, xK = 1, yK = 3, tu = 4, Mw = 5, Go = 0, Uw = 1, Sa = -2, wK = -3, A4 = -5, _K = -1, AK = 1, B2 = 2, EK = 3, SK = 4, CK = 0, kK = 2, sm = 8, TK = 9, FK = 15, DK = 8, OK = 29, RK = 256, R3 = RK + 1 + OK, PK = 30, IK = 19, BK = 2 * R3 + 1, LK = 15, c0 = 3, Gl = 258, to = Gl + c0 + 1, NK = 32, lm = 42, P3 = 69, f5 = 73, d5 = 91, h5 = 103, Ju = 113, Od = 666, Kr = 1, Uh = 2, wc = 3, T1 = 4, MK = 3;
function Zl(t, e) {
  return t.msg = bK[e], e;
}
function zw(t) {
  return (t << 1) - (t > 4 ? 9 : 0);
}
function Wl(t) {
  for (var e = t.length; --e >= 0; )
    t[e] = 0;
}
function Ml(t) {
  var e = t.state, r = e.pending;
  r > t.avail_out && (r = t.avail_out), r !== 0 && (oi.arraySet(t.output, e.pending_buf, e.pending_out, r, t.next_out), t.next_out += r, e.pending_out += r, t.total_out += r, t.avail_out -= r, e.pending -= r, e.pending === 0 && (e.pending_out = 0));
}
function kn(t, e) {
  Ea._tr_flush_block(t, t.block_start >= 0 ? t.block_start : -1, t.strstart - t.block_start, e), t.block_start = t.strstart, Ml(t.strm);
}
function w0(t, e) {
  t.pending_buf[t.pending++] = e;
}
function Cd(t, e) {
  t.pending_buf[t.pending++] = e >>> 8 & 255, t.pending_buf[t.pending++] = e & 255;
}
function UK(t, e, r, n) {
  var i = t.avail_in;
  return i > n && (i = n), i === 0 ? 0 : (t.avail_in -= i, oi.arraySet(e, t.input, t.next_in, i, r), t.state.wrap === 1 ? t.adler = KC(t.adler, e, i, r) : t.state.wrap === 2 && (t.adler = Nl(t.adler, e, i, r)), t.next_in += i, t.total_in += i, i);
}
function JC(t, e) {
  var r = t.max_chain_length, n = t.strstart, i, a, o = t.prev_length, s = t.nice_match, l = t.strstart > t.w_size - to ? t.strstart - (t.w_size - to) : 0, u = t.window, d = t.w_mask, h = t.prev, v = t.strstart + Gl, b = u[n + o - 1], x = u[n + o];
  t.prev_length >= t.good_match && (r >>= 2), s > t.lookahead && (s = t.lookahead);
  do
    if (i = e, !(u[i + o] !== x || u[i + o - 1] !== b || u[i] !== u[n] || u[++i] !== u[n + 1])) {
      n += 2, i++;
      do
        ;
      while (u[++n] === u[++i] && u[++n] === u[++i] && u[++n] === u[++i] && u[++n] === u[++i] && u[++n] === u[++i] && u[++n] === u[++i] && u[++n] === u[++i] && u[++n] === u[++i] && n < v);
      if (a = Gl - (v - n), n = v - Gl, a > o) {
        if (t.match_start = e, o = a, a >= s)
          break;
        b = u[n + o - 1], x = u[n + o];
      }
    }
  while ((e = h[e & d]) > l && --r !== 0);
  return o <= t.lookahead ? o : t.lookahead;
}
function _c(t) {
  var e = t.w_size, r, n, i, a, o;
  do {
    if (a = t.window_size - t.lookahead - t.strstart, t.strstart >= e + (e - to)) {
      oi.arraySet(t.window, t.window, e, e, 0), t.match_start -= e, t.strstart -= e, t.block_start -= e, n = t.hash_size, r = n;
      do
        i = t.head[--r], t.head[r] = i >= e ? i - e : 0;
      while (--n);
      n = e, r = n;
      do
        i = t.prev[--r], t.prev[r] = i >= e ? i - e : 0;
      while (--n);
      a += e;
    }
    if (t.strm.avail_in === 0)
      break;
    if (n = UK(t.strm, t.window, t.strstart + t.lookahead, a), t.lookahead += n, t.lookahead + t.insert >= c0)
      for (o = t.strstart - t.insert, t.ins_h = t.window[o], t.ins_h = (t.ins_h << t.hash_shift ^ t.window[o + 1]) & t.hash_mask; t.insert && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[o + c0 - 1]) & t.hash_mask, t.prev[o & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = o, o++, t.insert--, !(t.lookahead + t.insert < c0)); )
        ;
  } while (t.lookahead < to && t.strm.avail_in !== 0);
}
function zK(t, e) {
  var r = 65535;
  for (r > t.pending_buf_size - 5 && (r = t.pending_buf_size - 5); ; ) {
    if (t.lookahead <= 1) {
      if (_c(t), t.lookahead === 0 && e === Ic)
        return Kr;
      if (t.lookahead === 0)
        break;
    }
    t.strstart += t.lookahead, t.lookahead = 0;
    var n = t.block_start + r;
    if ((t.strstart === 0 || t.strstart >= n) && (t.lookahead = t.strstart - n, t.strstart = n, kn(t, !1), t.strm.avail_out === 0) || t.strstart - t.block_start >= t.w_size - to && (kn(t, !1), t.strm.avail_out === 0))
      return Kr;
  }
  return t.insert = 0, e === tu ? (kn(t, !0), t.strm.avail_out === 0 ? wc : T1) : (t.strstart > t.block_start && (kn(t, !1), t.strm.avail_out === 0), Kr);
}
function E4(t, e) {
  for (var r, n; ; ) {
    if (t.lookahead < to) {
      if (_c(t), t.lookahead < to && e === Ic)
        return Kr;
      if (t.lookahead === 0)
        break;
    }
    if (r = 0, t.lookahead >= c0 && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + c0 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), r !== 0 && t.strstart - r <= t.w_size - to && (t.match_length = JC(t, r)), t.match_length >= c0)
      if (n = Ea._tr_tally(t, t.strstart - t.match_start, t.match_length - c0), t.lookahead -= t.match_length, t.match_length <= t.max_lazy_match && t.lookahead >= c0) {
        t.match_length--;
        do
          t.strstart++, t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + c0 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart;
        while (--t.match_length !== 0);
        t.strstart++;
      } else
        t.strstart += t.match_length, t.match_length = 0, t.ins_h = t.window[t.strstart], t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 1]) & t.hash_mask;
    else
      n = Ea._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++;
    if (n && (kn(t, !1), t.strm.avail_out === 0))
      return Kr;
  }
  return t.insert = t.strstart < c0 - 1 ? t.strstart : c0 - 1, e === tu ? (kn(t, !0), t.strm.avail_out === 0 ? wc : T1) : t.last_lit && (kn(t, !1), t.strm.avail_out === 0) ? Kr : Uh;
}
function Df(t, e) {
  for (var r, n, i; ; ) {
    if (t.lookahead < to) {
      if (_c(t), t.lookahead < to && e === Ic)
        return Kr;
      if (t.lookahead === 0)
        break;
    }
    if (r = 0, t.lookahead >= c0 && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + c0 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), t.prev_length = t.match_length, t.prev_match = t.match_start, t.match_length = c0 - 1, r !== 0 && t.prev_length < t.max_lazy_match && t.strstart - r <= t.w_size - to && (t.match_length = JC(t, r), t.match_length <= 5 && (t.strategy === AK || t.match_length === c0 && t.strstart - t.match_start > 4096) && (t.match_length = c0 - 1)), t.prev_length >= c0 && t.match_length <= t.prev_length) {
      i = t.strstart + t.lookahead - c0, n = Ea._tr_tally(t, t.strstart - 1 - t.prev_match, t.prev_length - c0), t.lookahead -= t.prev_length - 1, t.prev_length -= 2;
      do
        ++t.strstart <= i && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + c0 - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart);
      while (--t.prev_length !== 0);
      if (t.match_available = 0, t.match_length = c0 - 1, t.strstart++, n && (kn(t, !1), t.strm.avail_out === 0))
        return Kr;
    } else if (t.match_available) {
      if (n = Ea._tr_tally(t, 0, t.window[t.strstart - 1]), n && kn(t, !1), t.strstart++, t.lookahead--, t.strm.avail_out === 0)
        return Kr;
    } else
      t.match_available = 1, t.strstart++, t.lookahead--;
  }
  return t.match_available && (n = Ea._tr_tally(t, 0, t.window[t.strstart - 1]), t.match_available = 0), t.insert = t.strstart < c0 - 1 ? t.strstart : c0 - 1, e === tu ? (kn(t, !0), t.strm.avail_out === 0 ? wc : T1) : t.last_lit && (kn(t, !1), t.strm.avail_out === 0) ? Kr : Uh;
}
function $K(t, e) {
  for (var r, n, i, a, o = t.window; ; ) {
    if (t.lookahead <= Gl) {
      if (_c(t), t.lookahead <= Gl && e === Ic)
        return Kr;
      if (t.lookahead === 0)
        break;
    }
    if (t.match_length = 0, t.lookahead >= c0 && t.strstart > 0 && (i = t.strstart - 1, n = o[i], n === o[++i] && n === o[++i] && n === o[++i])) {
      a = t.strstart + Gl;
      do
        ;
      while (n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && i < a);
      t.match_length = Gl - (a - i), t.match_length > t.lookahead && (t.match_length = t.lookahead);
    }
    if (t.match_length >= c0 ? (r = Ea._tr_tally(t, 1, t.match_length - c0), t.lookahead -= t.match_length, t.strstart += t.match_length, t.match_length = 0) : (r = Ea._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++), r && (kn(t, !1), t.strm.avail_out === 0))
      return Kr;
  }
  return t.insert = 0, e === tu ? (kn(t, !0), t.strm.avail_out === 0 ? wc : T1) : t.last_lit && (kn(t, !1), t.strm.avail_out === 0) ? Kr : Uh;
}
function VK(t, e) {
  for (var r; ; ) {
    if (t.lookahead === 0 && (_c(t), t.lookahead === 0)) {
      if (e === Ic)
        return Kr;
      break;
    }
    if (t.match_length = 0, r = Ea._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++, r && (kn(t, !1), t.strm.avail_out === 0))
      return Kr;
  }
  return t.insert = 0, e === tu ? (kn(t, !0), t.strm.avail_out === 0 ? wc : T1) : t.last_lit && (kn(t, !1), t.strm.avail_out === 0) ? Kr : Uh;
}
function Io(t, e, r, n, i) {
  this.good_length = t, this.max_lazy = e, this.nice_length = r, this.max_chain = n, this.func = i;
}
var jf;
jf = [
  /*      good lazy nice chain */
  new Io(0, 0, 0, 0, zK),
  /* 0 store only */
  new Io(4, 4, 8, 4, E4),
  /* 1 max speed, no lazy matches */
  new Io(4, 5, 16, 8, E4),
  /* 2 */
  new Io(4, 6, 32, 32, E4),
  /* 3 */
  new Io(4, 4, 16, 16, Df),
  /* 4 lazy matches */
  new Io(8, 16, 32, 32, Df),
  /* 5 */
  new Io(8, 16, 128, 128, Df),
  /* 6 */
  new Io(8, 32, 128, 256, Df),
  /* 7 */
  new Io(32, 128, 258, 1024, Df),
  /* 8 */
  new Io(32, 258, 258, 4096, Df)
  /* 9 max compression */
];
function jK(t) {
  t.window_size = 2 * t.w_size, Wl(t.head), t.max_lazy_match = jf[t.level].max_lazy, t.good_match = jf[t.level].good_length, t.nice_match = jf[t.level].nice_length, t.max_chain_length = jf[t.level].max_chain, t.strstart = 0, t.block_start = 0, t.lookahead = 0, t.insert = 0, t.match_length = t.prev_length = c0 - 1, t.match_available = 0, t.ins_h = 0;
}
function WK() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = sm, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new oi.Buf16(BK * 2), this.dyn_dtree = new oi.Buf16((2 * PK + 1) * 2), this.bl_tree = new oi.Buf16((2 * IK + 1) * 2), Wl(this.dyn_ltree), Wl(this.dyn_dtree), Wl(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new oi.Buf16(LK + 1), this.heap = new oi.Buf16(2 * R3 + 1), Wl(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new oi.Buf16(2 * R3 + 1), Wl(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
function QC(t) {
  var e;
  return !t || !t.state ? Zl(t, Sa) : (t.total_in = t.total_out = 0, t.data_type = kK, e = t.state, e.pending = 0, e.pending_out = 0, e.wrap < 0 && (e.wrap = -e.wrap), e.status = e.wrap ? lm : Ju, t.adler = e.wrap === 2 ? 0 : 1, e.last_flush = Ic, Ea._tr_init(e), Go);
}
function ek(t) {
  var e = QC(t);
  return e === Go && jK(t.state), e;
}
function HK(t, e) {
  return !t || !t.state || t.state.wrap !== 2 ? Sa : (t.state.gzhead = e, Go);
}
function tk(t, e, r, n, i, a) {
  if (!t)
    return Sa;
  var o = 1;
  if (e === _K && (e = 6), n < 0 ? (o = 0, n = -n) : n > 15 && (o = 2, n -= 16), i < 1 || i > TK || r !== sm || n < 8 || n > 15 || e < 0 || e > 9 || a < 0 || a > SK)
    return Zl(t, Sa);
  n === 8 && (n = 9);
  var s = new WK();
  return t.state = s, s.strm = t, s.wrap = o, s.gzhead = null, s.w_bits = n, s.w_size = 1 << s.w_bits, s.w_mask = s.w_size - 1, s.hash_bits = i + 7, s.hash_size = 1 << s.hash_bits, s.hash_mask = s.hash_size - 1, s.hash_shift = ~~((s.hash_bits + c0 - 1) / c0), s.window = new oi.Buf8(s.w_size * 2), s.head = new oi.Buf16(s.hash_size), s.prev = new oi.Buf16(s.w_size), s.lit_bufsize = 1 << i + 6, s.pending_buf_size = s.lit_bufsize * 4, s.pending_buf = new oi.Buf8(s.pending_buf_size), s.d_buf = 1 * s.lit_bufsize, s.l_buf = 3 * s.lit_bufsize, s.level = e, s.strategy = a, s.method = r, ek(t);
}
function qK(t, e) {
  return tk(t, e, sm, FK, DK, CK);
}
function YK(t, e) {
  var r, n, i, a;
  if (!t || !t.state || e > Mw || e < 0)
    return t ? Zl(t, Sa) : Sa;
  if (n = t.state, !t.output || !t.input && t.avail_in !== 0 || n.status === Od && e !== tu)
    return Zl(t, t.avail_out === 0 ? A4 : Sa);
  if (n.strm = t, r = n.last_flush, n.last_flush = e, n.status === lm)
    if (n.wrap === 2)
      t.adler = 0, w0(n, 31), w0(n, 139), w0(n, 8), n.gzhead ? (w0(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), w0(n, n.gzhead.time & 255), w0(n, n.gzhead.time >> 8 & 255), w0(n, n.gzhead.time >> 16 & 255), w0(n, n.gzhead.time >> 24 & 255), w0(n, n.level === 9 ? 2 : n.strategy >= B2 || n.level < 2 ? 4 : 0), w0(n, n.gzhead.os & 255), n.gzhead.extra && n.gzhead.extra.length && (w0(n, n.gzhead.extra.length & 255), w0(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (t.adler = Nl(t.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = P3) : (w0(n, 0), w0(n, 0), w0(n, 0), w0(n, 0), w0(n, 0), w0(n, n.level === 9 ? 2 : n.strategy >= B2 || n.level < 2 ? 4 : 0), w0(n, MK), n.status = Ju);
    else {
      var o = sm + (n.w_bits - 8 << 4) << 8, s = -1;
      n.strategy >= B2 || n.level < 2 ? s = 0 : n.level < 6 ? s = 1 : n.level === 6 ? s = 2 : s = 3, o |= s << 6, n.strstart !== 0 && (o |= NK), o += 31 - o % 31, n.status = Ju, Cd(n, o), n.strstart !== 0 && (Cd(n, t.adler >>> 16), Cd(n, t.adler & 65535)), t.adler = 1;
    }
  if (n.status === P3)
    if (n.gzhead.extra) {
      for (i = n.pending; n.gzindex < (n.gzhead.extra.length & 65535) && !(n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (t.adler = Nl(t.adler, n.pending_buf, n.pending - i, i)), Ml(t), i = n.pending, n.pending === n.pending_buf_size)); )
        w0(n, n.gzhead.extra[n.gzindex] & 255), n.gzindex++;
      n.gzhead.hcrc && n.pending > i && (t.adler = Nl(t.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = f5);
    } else
      n.status = f5;
  if (n.status === f5)
    if (n.gzhead.name) {
      i = n.pending;
      do {
        if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (t.adler = Nl(t.adler, n.pending_buf, n.pending - i, i)), Ml(t), i = n.pending, n.pending === n.pending_buf_size)) {
          a = 1;
          break;
        }
        n.gzindex < n.gzhead.name.length ? a = n.gzhead.name.charCodeAt(n.gzindex++) & 255 : a = 0, w0(n, a);
      } while (a !== 0);
      n.gzhead.hcrc && n.pending > i && (t.adler = Nl(t.adler, n.pending_buf, n.pending - i, i)), a === 0 && (n.gzindex = 0, n.status = d5);
    } else
      n.status = d5;
  if (n.status === d5)
    if (n.gzhead.comment) {
      i = n.pending;
      do {
        if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (t.adler = Nl(t.adler, n.pending_buf, n.pending - i, i)), Ml(t), i = n.pending, n.pending === n.pending_buf_size)) {
          a = 1;
          break;
        }
        n.gzindex < n.gzhead.comment.length ? a = n.gzhead.comment.charCodeAt(n.gzindex++) & 255 : a = 0, w0(n, a);
      } while (a !== 0);
      n.gzhead.hcrc && n.pending > i && (t.adler = Nl(t.adler, n.pending_buf, n.pending - i, i)), a === 0 && (n.status = h5);
    } else
      n.status = h5;
  if (n.status === h5 && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && Ml(t), n.pending + 2 <= n.pending_buf_size && (w0(n, t.adler & 255), w0(n, t.adler >> 8 & 255), t.adler = 0, n.status = Ju)) : n.status = Ju), n.pending !== 0) {
    if (Ml(t), t.avail_out === 0)
      return n.last_flush = -1, Go;
  } else if (t.avail_in === 0 && zw(e) <= zw(r) && e !== tu)
    return Zl(t, A4);
  if (n.status === Od && t.avail_in !== 0)
    return Zl(t, A4);
  if (t.avail_in !== 0 || n.lookahead !== 0 || e !== Ic && n.status !== Od) {
    var l = n.strategy === B2 ? VK(n, e) : n.strategy === EK ? $K(n, e) : jf[n.level].func(n, e);
    if ((l === wc || l === T1) && (n.status = Od), l === Kr || l === wc)
      return t.avail_out === 0 && (n.last_flush = -1), Go;
    if (l === Uh && (e === xK ? Ea._tr_align(n) : e !== Mw && (Ea._tr_stored_block(n, 0, 0, !1), e === yK && (Wl(n.head), n.lookahead === 0 && (n.strstart = 0, n.block_start = 0, n.insert = 0))), Ml(t), t.avail_out === 0))
      return n.last_flush = -1, Go;
  }
  return e !== tu ? Go : n.wrap <= 0 ? Uw : (n.wrap === 2 ? (w0(n, t.adler & 255), w0(n, t.adler >> 8 & 255), w0(n, t.adler >> 16 & 255), w0(n, t.adler >> 24 & 255), w0(n, t.total_in & 255), w0(n, t.total_in >> 8 & 255), w0(n, t.total_in >> 16 & 255), w0(n, t.total_in >> 24 & 255)) : (Cd(n, t.adler >>> 16), Cd(n, t.adler & 65535)), Ml(t), n.wrap > 0 && (n.wrap = -n.wrap), n.pending !== 0 ? Go : Uw);
}
function GK(t) {
  var e;
  return !t || !t.state ? Sa : (e = t.state.status, e !== lm && e !== P3 && e !== f5 && e !== d5 && e !== h5 && e !== Ju && e !== Od ? Zl(t, Sa) : (t.state = null, e === Ju ? Zl(t, wK) : Go));
}
function ZK(t, e) {
  var r = e.length, n, i, a, o, s, l, u, d;
  if (!t || !t.state || (n = t.state, o = n.wrap, o === 2 || o === 1 && n.status !== lm || n.lookahead))
    return Sa;
  for (o === 1 && (t.adler = KC(t.adler, e, r, 0)), n.wrap = 0, r >= n.w_size && (o === 0 && (Wl(n.head), n.strstart = 0, n.block_start = 0, n.insert = 0), d = new oi.Buf8(n.w_size), oi.arraySet(d, e, r - n.w_size, n.w_size, 0), e = d, r = n.w_size), s = t.avail_in, l = t.next_in, u = t.input, t.avail_in = r, t.next_in = 0, t.input = e, _c(n); n.lookahead >= c0; ) {
    i = n.strstart, a = n.lookahead - (c0 - 1);
    do
      n.ins_h = (n.ins_h << n.hash_shift ^ n.window[i + c0 - 1]) & n.hash_mask, n.prev[i & n.w_mask] = n.head[n.ins_h], n.head[n.ins_h] = i, i++;
    while (--a);
    n.strstart = i, n.lookahead = c0 - 1, _c(n);
  }
  return n.strstart += n.lookahead, n.block_start = n.strstart, n.insert = n.lookahead, n.lookahead = 0, n.match_length = n.prev_length = c0 - 1, n.match_available = 0, t.next_in = l, t.input = u, t.avail_in = s, n.wrap = o, Go;
}
ps.deflateInit = qK;
ps.deflateInit2 = tk;
ps.deflateReset = ek;
ps.deflateResetKeep = QC;
ps.deflateSetHeader = HK;
ps.deflate = YK;
ps.deflateEnd = GK;
ps.deflateSetDictionary = ZK;
ps.deflateInfo = "pako deflate (from Nodeca project)";
var fo = {}, L2 = 30, XK = 12, KK = function(e, r) {
  var n, i, a, o, s, l, u, d, h, v, b, x, A, T, k, E, C, D, _, I, R, U, V, z, j;
  n = e.state, i = e.next_in, z = e.input, a = i + (e.avail_in - 5), o = e.next_out, j = e.output, s = o - (r - e.avail_out), l = o + (e.avail_out - 257), u = n.dmax, d = n.wsize, h = n.whave, v = n.wnext, b = n.window, x = n.hold, A = n.bits, T = n.lencode, k = n.distcode, E = (1 << n.lenbits) - 1, C = (1 << n.distbits) - 1;
  e: do {
    A < 15 && (x += z[i++] << A, A += 8, x += z[i++] << A, A += 8), D = T[x & E];
    t: for (; ; ) {
      if (_ = D >>> 24, x >>>= _, A -= _, _ = D >>> 16 & 255, _ === 0)
        j[o++] = D & 65535;
      else if (_ & 16) {
        I = D & 65535, _ &= 15, _ && (A < _ && (x += z[i++] << A, A += 8), I += x & (1 << _) - 1, x >>>= _, A -= _), A < 15 && (x += z[i++] << A, A += 8, x += z[i++] << A, A += 8), D = k[x & C];
        r: for (; ; ) {
          if (_ = D >>> 24, x >>>= _, A -= _, _ = D >>> 16 & 255, _ & 16) {
            if (R = D & 65535, _ &= 15, A < _ && (x += z[i++] << A, A += 8, A < _ && (x += z[i++] << A, A += 8)), R += x & (1 << _) - 1, R > u) {
              e.msg = "invalid distance too far back", n.mode = L2;
              break e;
            }
            if (x >>>= _, A -= _, _ = o - s, R > _) {
              if (_ = R - _, _ > h && n.sane) {
                e.msg = "invalid distance too far back", n.mode = L2;
                break e;
              }
              if (U = 0, V = b, v === 0) {
                if (U += d - _, _ < I) {
                  I -= _;
                  do
                    j[o++] = b[U++];
                  while (--_);
                  U = o - R, V = j;
                }
              } else if (v < _) {
                if (U += d + v - _, _ -= v, _ < I) {
                  I -= _;
                  do
                    j[o++] = b[U++];
                  while (--_);
                  if (U = 0, v < I) {
                    _ = v, I -= _;
                    do
                      j[o++] = b[U++];
                    while (--_);
                    U = o - R, V = j;
                  }
                }
              } else if (U += v - _, _ < I) {
                I -= _;
                do
                  j[o++] = b[U++];
                while (--_);
                U = o - R, V = j;
              }
              for (; I > 2; )
                j[o++] = V[U++], j[o++] = V[U++], j[o++] = V[U++], I -= 3;
              I && (j[o++] = V[U++], I > 1 && (j[o++] = V[U++]));
            } else {
              U = o - R;
              do
                j[o++] = j[U++], j[o++] = j[U++], j[o++] = j[U++], I -= 3;
              while (I > 2);
              I && (j[o++] = j[U++], I > 1 && (j[o++] = j[U++]));
            }
          } else if (_ & 64) {
            e.msg = "invalid distance code", n.mode = L2;
            break e;
          } else {
            D = k[(D & 65535) + (x & (1 << _) - 1)];
            continue r;
          }
          break;
        }
      } else if (_ & 64)
        if (_ & 32) {
          n.mode = XK;
          break e;
        } else {
          e.msg = "invalid literal/length code", n.mode = L2;
          break e;
        }
      else {
        D = T[(D & 65535) + (x & (1 << _) - 1)];
        continue t;
      }
      break;
    }
  } while (i < a && o < l);
  I = A >> 3, i -= I, A -= I << 3, x &= (1 << A) - 1, e.next_in = i, e.next_out = o, e.avail_in = i < a ? 5 + (a - i) : 5 - (i - a), e.avail_out = o < l ? 257 + (l - o) : 257 - (o - l), n.hold = x, n.bits = A;
}, $w = Nh, Of = 15, Vw = 852, jw = 592, Ww = 0, S4 = 1, Hw = 2, JK = [
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
], QK = [
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
], eJ = [
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
], tJ = [
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
], rJ = function(e, r, n, i, a, o, s, l) {
  var u = l.bits, d = 0, h = 0, v = 0, b = 0, x = 0, A = 0, T = 0, k = 0, E = 0, C = 0, D, _, I, R, U, V = null, z = 0, j, S = new $w.Buf16(Of + 1), B = new $w.Buf16(Of + 1), q = null, Y = 0, Z, Q, J;
  for (d = 0; d <= Of; d++)
    S[d] = 0;
  for (h = 0; h < i; h++)
    S[r[n + h]]++;
  for (x = u, b = Of; b >= 1 && S[b] === 0; b--)
    ;
  if (x > b && (x = b), b === 0)
    return a[o++] = 1 << 24 | 64 << 16 | 0, a[o++] = 1 << 24 | 64 << 16 | 0, l.bits = 1, 0;
  for (v = 1; v < b && S[v] === 0; v++)
    ;
  for (x < v && (x = v), k = 1, d = 1; d <= Of; d++)
    if (k <<= 1, k -= S[d], k < 0)
      return -1;
  if (k > 0 && (e === Ww || b !== 1))
    return -1;
  for (B[1] = 0, d = 1; d < Of; d++)
    B[d + 1] = B[d] + S[d];
  for (h = 0; h < i; h++)
    r[n + h] !== 0 && (s[B[r[n + h]]++] = h);
  if (e === Ww ? (V = q = s, j = 19) : e === S4 ? (V = JK, z -= 257, q = QK, Y -= 257, j = 256) : (V = eJ, q = tJ, j = -1), C = 0, h = 0, d = v, U = o, A = x, T = 0, I = -1, E = 1 << x, R = E - 1, e === S4 && E > Vw || e === Hw && E > jw)
    return 1;
  for (; ; ) {
    Z = d - T, s[h] < j ? (Q = 0, J = s[h]) : s[h] > j ? (Q = q[Y + s[h]], J = V[z + s[h]]) : (Q = 96, J = 0), D = 1 << d - T, _ = 1 << A, v = _;
    do
      _ -= D, a[U + (C >> T) + _] = Z << 24 | Q << 16 | J | 0;
    while (_ !== 0);
    for (D = 1 << d - 1; C & D; )
      D >>= 1;
    if (D !== 0 ? (C &= D - 1, C += D) : C = 0, h++, --S[d] === 0) {
      if (d === b)
        break;
      d = r[n + s[h]];
    }
    if (d > x && (C & R) !== I) {
      for (T === 0 && (T = x), U += v, A = d - T, k = 1 << A; A + T < b && (k -= S[A + T], !(k <= 0)); )
        A++, k <<= 1;
      if (E += 1 << A, e === S4 && E > Vw || e === Hw && E > jw)
        return 1;
      I = C & R, a[I] = x << 24 | A << 16 | U - o | 0;
    }
  }
  return C !== 0 && (a[U + C] = d - T << 24 | 64 << 16 | 0), l.bits = x, 0;
}, Zi = Nh, I3 = ZC, Bo = XC, nJ = KK, Vd = rJ, iJ = 0, rk = 1, nk = 2, qw = 4, aJ = 5, N2 = 6, Ac = 0, oJ = 1, sJ = 2, ka = -2, ik = -3, ak = -4, lJ = -5, Yw = 8, ok = 1, Gw = 2, Zw = 3, Xw = 4, Kw = 5, Jw = 6, Qw = 7, e7 = 8, t7 = 9, r7 = 10, rp = 11, Hs = 12, C4 = 13, n7 = 14, k4 = 15, i7 = 16, a7 = 17, o7 = 18, s7 = 19, M2 = 20, U2 = 21, l7 = 22, u7 = 23, c7 = 24, f7 = 25, d7 = 26, T4 = 27, h7 = 28, p7 = 29, hr = 30, sk = 31, uJ = 32, cJ = 852, fJ = 592, dJ = 15, hJ = dJ;
function m7(t) {
  return (t >>> 24 & 255) + (t >>> 8 & 65280) + ((t & 65280) << 8) + ((t & 255) << 24);
}
function pJ() {
  this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Zi.Buf16(320), this.work = new Zi.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
function lk(t) {
  var e;
  return !t || !t.state ? ka : (e = t.state, t.total_in = t.total_out = e.total = 0, t.msg = "", e.wrap && (t.adler = e.wrap & 1), e.mode = ok, e.last = 0, e.havedict = 0, e.dmax = 32768, e.head = null, e.hold = 0, e.bits = 0, e.lencode = e.lendyn = new Zi.Buf32(cJ), e.distcode = e.distdyn = new Zi.Buf32(fJ), e.sane = 1, e.back = -1, Ac);
}
function uk(t) {
  var e;
  return !t || !t.state ? ka : (e = t.state, e.wsize = 0, e.whave = 0, e.wnext = 0, lk(t));
}
function ck(t, e) {
  var r, n;
  return !t || !t.state || (n = t.state, e < 0 ? (r = 0, e = -e) : (r = (e >> 4) + 1, e < 48 && (e &= 15)), e && (e < 8 || e > 15)) ? ka : (n.window !== null && n.wbits !== e && (n.window = null), n.wrap = r, n.wbits = e, uk(t));
}
function fk(t, e) {
  var r, n;
  return t ? (n = new pJ(), t.state = n, n.window = null, r = ck(t, e), r !== Ac && (t.state = null), r) : ka;
}
function mJ(t) {
  return fk(t, hJ);
}
var g7 = !0, F4, D4;
function gJ(t) {
  if (g7) {
    var e;
    for (F4 = new Zi.Buf32(512), D4 = new Zi.Buf32(32), e = 0; e < 144; )
      t.lens[e++] = 8;
    for (; e < 256; )
      t.lens[e++] = 9;
    for (; e < 280; )
      t.lens[e++] = 7;
    for (; e < 288; )
      t.lens[e++] = 8;
    for (Vd(rk, t.lens, 0, 288, F4, 0, t.work, {
      bits: 9
    }), e = 0; e < 32; )
      t.lens[e++] = 5;
    Vd(nk, t.lens, 0, 32, D4, 0, t.work, {
      bits: 5
    }), g7 = !1;
  }
  t.lencode = F4, t.lenbits = 9, t.distcode = D4, t.distbits = 5;
}
function dk(t, e, r, n) {
  var i, a = t.state;
  return a.window === null && (a.wsize = 1 << a.wbits, a.wnext = 0, a.whave = 0, a.window = new Zi.Buf8(a.wsize)), n >= a.wsize ? (Zi.arraySet(a.window, e, r - a.wsize, a.wsize, 0), a.wnext = 0, a.whave = a.wsize) : (i = a.wsize - a.wnext, i > n && (i = n), Zi.arraySet(a.window, e, r - n, i, a.wnext), n -= i, n ? (Zi.arraySet(a.window, e, r - n, n, 0), a.wnext = n, a.whave = a.wsize) : (a.wnext += i, a.wnext === a.wsize && (a.wnext = 0), a.whave < a.wsize && (a.whave += i))), 0;
}
function vJ(t, e) {
  var r, n, i, a, o, s, l, u, d, h, v, b, x, A, T = 0, k, E, C, D, _, I, R, U, V = new Zi.Buf8(4), z, j, S = (
    /* permutation of code lengths */
    [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
  );
  if (!t || !t.state || !t.output || !t.input && t.avail_in !== 0)
    return ka;
  r = t.state, r.mode === Hs && (r.mode = C4), o = t.next_out, i = t.output, l = t.avail_out, a = t.next_in, n = t.input, s = t.avail_in, u = r.hold, d = r.bits, h = s, v = l, U = Ac;
  e:
    for (; ; )
      switch (r.mode) {
        case ok:
          if (r.wrap === 0) {
            r.mode = C4;
            break;
          }
          for (; d < 16; ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          if (r.wrap & 2 && u === 35615) {
            r.check = 0, V[0] = u & 255, V[1] = u >>> 8 & 255, r.check = Bo(r.check, V, 2, 0), u = 0, d = 0, r.mode = Gw;
            break;
          }
          if (r.flags = 0, r.head && (r.head.done = !1), !(r.wrap & 1) || /* check if zlib header allowed */
          (((u & 255) << 8) + (u >> 8)) % 31) {
            t.msg = "incorrect header check", r.mode = hr;
            break;
          }
          if ((u & 15) !== Yw) {
            t.msg = "unknown compression method", r.mode = hr;
            break;
          }
          if (u >>>= 4, d -= 4, R = (u & 15) + 8, r.wbits === 0)
            r.wbits = R;
          else if (R > r.wbits) {
            t.msg = "invalid window size", r.mode = hr;
            break;
          }
          r.dmax = 1 << R, t.adler = r.check = 1, r.mode = u & 512 ? r7 : Hs, u = 0, d = 0;
          break;
        case Gw:
          for (; d < 16; ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          if (r.flags = u, (r.flags & 255) !== Yw) {
            t.msg = "unknown compression method", r.mode = hr;
            break;
          }
          if (r.flags & 57344) {
            t.msg = "unknown header flags set", r.mode = hr;
            break;
          }
          r.head && (r.head.text = u >> 8 & 1), r.flags & 512 && (V[0] = u & 255, V[1] = u >>> 8 & 255, r.check = Bo(r.check, V, 2, 0)), u = 0, d = 0, r.mode = Zw;
        case Zw:
          for (; d < 32; ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          r.head && (r.head.time = u), r.flags & 512 && (V[0] = u & 255, V[1] = u >>> 8 & 255, V[2] = u >>> 16 & 255, V[3] = u >>> 24 & 255, r.check = Bo(r.check, V, 4, 0)), u = 0, d = 0, r.mode = Xw;
        case Xw:
          for (; d < 16; ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          r.head && (r.head.xflags = u & 255, r.head.os = u >> 8), r.flags & 512 && (V[0] = u & 255, V[1] = u >>> 8 & 255, r.check = Bo(r.check, V, 2, 0)), u = 0, d = 0, r.mode = Kw;
        case Kw:
          if (r.flags & 1024) {
            for (; d < 16; ) {
              if (s === 0)
                break e;
              s--, u += n[a++] << d, d += 8;
            }
            r.length = u, r.head && (r.head.extra_len = u), r.flags & 512 && (V[0] = u & 255, V[1] = u >>> 8 & 255, r.check = Bo(r.check, V, 2, 0)), u = 0, d = 0;
          } else r.head && (r.head.extra = null);
          r.mode = Jw;
        case Jw:
          if (r.flags & 1024 && (b = r.length, b > s && (b = s), b && (r.head && (R = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), Zi.arraySet(
            r.head.extra,
            n,
            a,
            // extra field is limited to 65536 bytes
            // - no need for additional size check
            b,
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            R
          )), r.flags & 512 && (r.check = Bo(r.check, n, b, a)), s -= b, a += b, r.length -= b), r.length))
            break e;
          r.length = 0, r.mode = Qw;
        case Qw:
          if (r.flags & 2048) {
            if (s === 0)
              break e;
            b = 0;
            do
              R = n[a + b++], r.head && R && r.length < 65536 && (r.head.name += String.fromCharCode(R));
            while (R && b < s);
            if (r.flags & 512 && (r.check = Bo(r.check, n, b, a)), s -= b, a += b, R)
              break e;
          } else r.head && (r.head.name = null);
          r.length = 0, r.mode = e7;
        case e7:
          if (r.flags & 4096) {
            if (s === 0)
              break e;
            b = 0;
            do
              R = n[a + b++], r.head && R && r.length < 65536 && (r.head.comment += String.fromCharCode(R));
            while (R && b < s);
            if (r.flags & 512 && (r.check = Bo(r.check, n, b, a)), s -= b, a += b, R)
              break e;
          } else r.head && (r.head.comment = null);
          r.mode = t7;
        case t7:
          if (r.flags & 512) {
            for (; d < 16; ) {
              if (s === 0)
                break e;
              s--, u += n[a++] << d, d += 8;
            }
            if (u !== (r.check & 65535)) {
              t.msg = "header crc mismatch", r.mode = hr;
              break;
            }
            u = 0, d = 0;
          }
          r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), t.adler = r.check = 0, r.mode = Hs;
          break;
        case r7:
          for (; d < 32; ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          t.adler = r.check = m7(u), u = 0, d = 0, r.mode = rp;
        case rp:
          if (r.havedict === 0)
            return t.next_out = o, t.avail_out = l, t.next_in = a, t.avail_in = s, r.hold = u, r.bits = d, sJ;
          t.adler = r.check = 1, r.mode = Hs;
        case Hs:
          if (e === aJ || e === N2)
            break e;
        case C4:
          if (r.last) {
            u >>>= d & 7, d -= d & 7, r.mode = T4;
            break;
          }
          for (; d < 3; ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          switch (r.last = u & 1, u >>>= 1, d -= 1, u & 3) {
            case 0:
              r.mode = n7;
              break;
            case 1:
              if (gJ(r), r.mode = M2, e === N2) {
                u >>>= 2, d -= 2;
                break e;
              }
              break;
            case 2:
              r.mode = a7;
              break;
            case 3:
              t.msg = "invalid block type", r.mode = hr;
          }
          u >>>= 2, d -= 2;
          break;
        case n7:
          for (u >>>= d & 7, d -= d & 7; d < 32; ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          if ((u & 65535) !== (u >>> 16 ^ 65535)) {
            t.msg = "invalid stored block lengths", r.mode = hr;
            break;
          }
          if (r.length = u & 65535, u = 0, d = 0, r.mode = k4, e === N2)
            break e;
        case k4:
          r.mode = i7;
        case i7:
          if (b = r.length, b) {
            if (b > s && (b = s), b > l && (b = l), b === 0)
              break e;
            Zi.arraySet(i, n, a, b, o), s -= b, a += b, l -= b, o += b, r.length -= b;
            break;
          }
          r.mode = Hs;
          break;
        case a7:
          for (; d < 14; ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          if (r.nlen = (u & 31) + 257, u >>>= 5, d -= 5, r.ndist = (u & 31) + 1, u >>>= 5, d -= 5, r.ncode = (u & 15) + 4, u >>>= 4, d -= 4, r.nlen > 286 || r.ndist > 30) {
            t.msg = "too many length or distance symbols", r.mode = hr;
            break;
          }
          r.have = 0, r.mode = o7;
        case o7:
          for (; r.have < r.ncode; ) {
            for (; d < 3; ) {
              if (s === 0)
                break e;
              s--, u += n[a++] << d, d += 8;
            }
            r.lens[S[r.have++]] = u & 7, u >>>= 3, d -= 3;
          }
          for (; r.have < 19; )
            r.lens[S[r.have++]] = 0;
          if (r.lencode = r.lendyn, r.lenbits = 7, z = {
            bits: r.lenbits
          }, U = Vd(iJ, r.lens, 0, 19, r.lencode, 0, r.work, z), r.lenbits = z.bits, U) {
            t.msg = "invalid code lengths set", r.mode = hr;
            break;
          }
          r.have = 0, r.mode = s7;
        case s7:
          for (; r.have < r.nlen + r.ndist; ) {
            for (; T = r.lencode[u & (1 << r.lenbits) - 1], k = T >>> 24, E = T >>> 16 & 255, C = T & 65535, !(k <= d); ) {
              if (s === 0)
                break e;
              s--, u += n[a++] << d, d += 8;
            }
            if (C < 16)
              u >>>= k, d -= k, r.lens[r.have++] = C;
            else {
              if (C === 16) {
                for (j = k + 2; d < j; ) {
                  if (s === 0)
                    break e;
                  s--, u += n[a++] << d, d += 8;
                }
                if (u >>>= k, d -= k, r.have === 0) {
                  t.msg = "invalid bit length repeat", r.mode = hr;
                  break;
                }
                R = r.lens[r.have - 1], b = 3 + (u & 3), u >>>= 2, d -= 2;
              } else if (C === 17) {
                for (j = k + 3; d < j; ) {
                  if (s === 0)
                    break e;
                  s--, u += n[a++] << d, d += 8;
                }
                u >>>= k, d -= k, R = 0, b = 3 + (u & 7), u >>>= 3, d -= 3;
              } else {
                for (j = k + 7; d < j; ) {
                  if (s === 0)
                    break e;
                  s--, u += n[a++] << d, d += 8;
                }
                u >>>= k, d -= k, R = 0, b = 11 + (u & 127), u >>>= 7, d -= 7;
              }
              if (r.have + b > r.nlen + r.ndist) {
                t.msg = "invalid bit length repeat", r.mode = hr;
                break;
              }
              for (; b--; )
                r.lens[r.have++] = R;
            }
          }
          if (r.mode === hr)
            break;
          if (r.lens[256] === 0) {
            t.msg = "invalid code -- missing end-of-block", r.mode = hr;
            break;
          }
          if (r.lenbits = 9, z = {
            bits: r.lenbits
          }, U = Vd(rk, r.lens, 0, r.nlen, r.lencode, 0, r.work, z), r.lenbits = z.bits, U) {
            t.msg = "invalid literal/lengths set", r.mode = hr;
            break;
          }
          if (r.distbits = 6, r.distcode = r.distdyn, z = {
            bits: r.distbits
          }, U = Vd(nk, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, z), r.distbits = z.bits, U) {
            t.msg = "invalid distances set", r.mode = hr;
            break;
          }
          if (r.mode = M2, e === N2)
            break e;
        case M2:
          r.mode = U2;
        case U2:
          if (s >= 6 && l >= 258) {
            t.next_out = o, t.avail_out = l, t.next_in = a, t.avail_in = s, r.hold = u, r.bits = d, nJ(t, v), o = t.next_out, i = t.output, l = t.avail_out, a = t.next_in, n = t.input, s = t.avail_in, u = r.hold, d = r.bits, r.mode === Hs && (r.back = -1);
            break;
          }
          for (r.back = 0; T = r.lencode[u & (1 << r.lenbits) - 1], k = T >>> 24, E = T >>> 16 & 255, C = T & 65535, !(k <= d); ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          if (E && !(E & 240)) {
            for (D = k, _ = E, I = C; T = r.lencode[I + ((u & (1 << D + _) - 1) >> D)], k = T >>> 24, E = T >>> 16 & 255, C = T & 65535, !(D + k <= d); ) {
              if (s === 0)
                break e;
              s--, u += n[a++] << d, d += 8;
            }
            u >>>= D, d -= D, r.back += D;
          }
          if (u >>>= k, d -= k, r.back += k, r.length = C, E === 0) {
            r.mode = d7;
            break;
          }
          if (E & 32) {
            r.back = -1, r.mode = Hs;
            break;
          }
          if (E & 64) {
            t.msg = "invalid literal/length code", r.mode = hr;
            break;
          }
          r.extra = E & 15, r.mode = l7;
        case l7:
          if (r.extra) {
            for (j = r.extra; d < j; ) {
              if (s === 0)
                break e;
              s--, u += n[a++] << d, d += 8;
            }
            r.length += u & (1 << r.extra) - 1, u >>>= r.extra, d -= r.extra, r.back += r.extra;
          }
          r.was = r.length, r.mode = u7;
        case u7:
          for (; T = r.distcode[u & (1 << r.distbits) - 1], k = T >>> 24, E = T >>> 16 & 255, C = T & 65535, !(k <= d); ) {
            if (s === 0)
              break e;
            s--, u += n[a++] << d, d += 8;
          }
          if (!(E & 240)) {
            for (D = k, _ = E, I = C; T = r.distcode[I + ((u & (1 << D + _) - 1) >> D)], k = T >>> 24, E = T >>> 16 & 255, C = T & 65535, !(D + k <= d); ) {
              if (s === 0)
                break e;
              s--, u += n[a++] << d, d += 8;
            }
            u >>>= D, d -= D, r.back += D;
          }
          if (u >>>= k, d -= k, r.back += k, E & 64) {
            t.msg = "invalid distance code", r.mode = hr;
            break;
          }
          r.offset = C, r.extra = E & 15, r.mode = c7;
        case c7:
          if (r.extra) {
            for (j = r.extra; d < j; ) {
              if (s === 0)
                break e;
              s--, u += n[a++] << d, d += 8;
            }
            r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, d -= r.extra, r.back += r.extra;
          }
          if (r.offset > r.dmax) {
            t.msg = "invalid distance too far back", r.mode = hr;
            break;
          }
          r.mode = f7;
        case f7:
          if (l === 0)
            break e;
          if (b = v - l, r.offset > b) {
            if (b = r.offset - b, b > r.whave && r.sane) {
              t.msg = "invalid distance too far back", r.mode = hr;
              break;
            }
            b > r.wnext ? (b -= r.wnext, x = r.wsize - b) : x = r.wnext - b, b > r.length && (b = r.length), A = r.window;
          } else
            A = i, x = o - r.offset, b = r.length;
          b > l && (b = l), l -= b, r.length -= b;
          do
            i[o++] = A[x++];
          while (--b);
          r.length === 0 && (r.mode = U2);
          break;
        case d7:
          if (l === 0)
            break e;
          i[o++] = r.length, l--, r.mode = U2;
          break;
        case T4:
          if (r.wrap) {
            for (; d < 32; ) {
              if (s === 0)
                break e;
              s--, u |= n[a++] << d, d += 8;
            }
            if (v -= l, t.total_out += v, r.total += v, v && (t.adler = r.check = /*UPDATE(state.check, put - _out, _out);*/
            r.flags ? Bo(r.check, i, v, o - v) : I3(r.check, i, v, o - v)), v = l, (r.flags ? u : m7(u)) !== r.check) {
              t.msg = "incorrect data check", r.mode = hr;
              break;
            }
            u = 0, d = 0;
          }
          r.mode = h7;
        case h7:
          if (r.wrap && r.flags) {
            for (; d < 32; ) {
              if (s === 0)
                break e;
              s--, u += n[a++] << d, d += 8;
            }
            if (u !== (r.total & 4294967295)) {
              t.msg = "incorrect length check", r.mode = hr;
              break;
            }
            u = 0, d = 0;
          }
          r.mode = p7;
        case p7:
          U = oJ;
          break e;
        case hr:
          U = ik;
          break e;
        case sk:
          return ak;
        case uJ:
        default:
          return ka;
      }
  return t.next_out = o, t.avail_out = l, t.next_in = a, t.avail_in = s, r.hold = u, r.bits = d, (r.wsize || v !== t.avail_out && r.mode < hr && (r.mode < T4 || e !== qw)) && dk(t, t.output, t.next_out, v - t.avail_out), h -= t.avail_in, v -= t.avail_out, t.total_in += h, t.total_out += v, r.total += v, r.wrap && v && (t.adler = r.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
  r.flags ? Bo(r.check, i, v, t.next_out - v) : I3(r.check, i, v, t.next_out - v)), t.data_type = r.bits + (r.last ? 64 : 0) + (r.mode === Hs ? 128 : 0) + (r.mode === M2 || r.mode === k4 ? 256 : 0), (h === 0 && v === 0 || e === qw) && U === Ac && (U = lJ), U;
}
function bJ(t) {
  if (!t || !t.state)
    return ka;
  var e = t.state;
  return e.window && (e.window = null), t.state = null, Ac;
}
function xJ(t, e) {
  var r;
  return !t || !t.state || (r = t.state, !(r.wrap & 2)) ? ka : (r.head = e, e.done = !1, Ac);
}
function yJ(t, e) {
  var r = e.length, n, i, a;
  return !t || !t.state || (n = t.state, n.wrap !== 0 && n.mode !== rp) ? ka : n.mode === rp && (i = 1, i = I3(i, e, r, 0), i !== n.check) ? ik : (a = dk(t, e, r, r), a ? (n.mode = sk, ak) : (n.havedict = 1, Ac));
}
fo.inflateReset = uk;
fo.inflateReset2 = ck;
fo.inflateResetKeep = lk;
fo.inflateInit = mJ;
fo.inflateInit2 = fk;
fo.inflate = vJ;
fo.inflateEnd = bJ;
fo.inflateGetHeader = xJ;
fo.inflateSetDictionary = yJ;
fo.inflateInfo = "pako inflate (from Nodeca project)";
var wJ = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_ERRNO: -1,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR: -5,
  //Z_VERSION_ERROR: -6,
  /* compression levels */
  Z_NO_COMPRESSION: 0,
  Z_BEST_SPEED: 1,
  Z_BEST_COMPRESSION: 9,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY: 0,
  Z_TEXT: 1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN: 2,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
(function(t) {
  var e = PC, r = HX, n = ps, i = fo, a = wJ;
  for (var o in a)
    t[o] = a[o];
  t.NONE = 0, t.DEFLATE = 1, t.INFLATE = 2, t.GZIP = 3, t.GUNZIP = 4, t.DEFLATERAW = 5, t.INFLATERAW = 6, t.UNZIP = 7;
  var s = 31, l = 139;
  function u(d) {
    if (typeof d != "number" || d < t.DEFLATE || d > t.UNZIP)
      throw new TypeError("Bad argument");
    this.dictionary = null, this.err = 0, this.flush = 0, this.init_done = !1, this.level = 0, this.memLevel = 0, this.mode = d, this.strategy = 0, this.windowBits = 0, this.write_in_progress = !1, this.pending_close = !1, this.gzip_id_bytes_read = 0;
  }
  u.prototype.close = function() {
    if (this.write_in_progress) {
      this.pending_close = !0;
      return;
    }
    this.pending_close = !1, e(this.init_done, "close before init"), e(this.mode <= t.UNZIP), this.mode === t.DEFLATE || this.mode === t.GZIP || this.mode === t.DEFLATERAW ? n.deflateEnd(this.strm) : (this.mode === t.INFLATE || this.mode === t.GUNZIP || this.mode === t.INFLATERAW || this.mode === t.UNZIP) && i.inflateEnd(this.strm), this.mode = t.NONE, this.dictionary = null;
  }, u.prototype.write = function(d, h, v, b, x, A, T) {
    return this._write(!0, d, h, v, b, x, A, T);
  }, u.prototype.writeSync = function(d, h, v, b, x, A, T) {
    return this._write(!1, d, h, v, b, x, A, T);
  }, u.prototype._write = function(d, h, v, b, x, A, T, k) {
    if (e.equal(arguments.length, 8), e(this.init_done, "write before init"), e(this.mode !== t.NONE, "already finalized"), e.equal(!1, this.write_in_progress, "write already in progress"), e.equal(!1, this.pending_close, "close is pending"), this.write_in_progress = !0, e.equal(!1, h === void 0, "must provide flush value"), this.write_in_progress = !0, h !== t.Z_NO_FLUSH && h !== t.Z_PARTIAL_FLUSH && h !== t.Z_SYNC_FLUSH && h !== t.Z_FULL_FLUSH && h !== t.Z_FINISH && h !== t.Z_BLOCK)
      throw new Error("Invalid flush value");
    if (v == null && (v = Re.alloc(0), x = 0, b = 0), this.strm.avail_in = x, this.strm.input = v, this.strm.next_in = b, this.strm.avail_out = k, this.strm.output = A, this.strm.next_out = T, this.flush = h, !d)
      return this._process(), this._checkError() ? this._afterSync() : void 0;
    var E = this;
    return Ka.nextTick(function() {
      E._process(), E._after();
    }), this;
  }, u.prototype._afterSync = function() {
    var d = this.strm.avail_out, h = this.strm.avail_in;
    return this.write_in_progress = !1, [h, d];
  }, u.prototype._process = function() {
    var d = null;
    switch (this.mode) {
      case t.DEFLATE:
      case t.GZIP:
      case t.DEFLATERAW:
        this.err = n.deflate(this.strm, this.flush);
        break;
      case t.UNZIP:
        switch (this.strm.avail_in > 0 && (d = this.strm.next_in), this.gzip_id_bytes_read) {
          case 0:
            if (d === null)
              break;
            if (this.strm.input[d] === s) {
              if (this.gzip_id_bytes_read = 1, d++, this.strm.avail_in === 1)
                break;
            } else {
              this.mode = t.INFLATE;
              break;
            }
          case 1:
            if (d === null)
              break;
            this.strm.input[d] === l ? (this.gzip_id_bytes_read = 2, this.mode = t.GUNZIP) : this.mode = t.INFLATE;
            break;
          default:
            throw new Error("invalid number of gzip magic number bytes read");
        }
      case t.INFLATE:
      case t.GUNZIP:
      case t.INFLATERAW:
        for (this.err = i.inflate(
          this.strm,
          this.flush
          // If data was encoded with dictionary
        ), this.err === t.Z_NEED_DICT && this.dictionary && (this.err = i.inflateSetDictionary(this.strm, this.dictionary), this.err === t.Z_OK ? this.err = i.inflate(this.strm, this.flush) : this.err === t.Z_DATA_ERROR && (this.err = t.Z_NEED_DICT)); this.strm.avail_in > 0 && this.mode === t.GUNZIP && this.err === t.Z_STREAM_END && this.strm.next_in[0] !== 0; )
          this.reset(), this.err = i.inflate(this.strm, this.flush);
        break;
      default:
        throw new Error("Unknown mode " + this.mode);
    }
  }, u.prototype._checkError = function() {
    switch (this.err) {
      case t.Z_OK:
      case t.Z_BUF_ERROR:
        if (this.strm.avail_out !== 0 && this.flush === t.Z_FINISH)
          return this._error("unexpected end of file"), !1;
        break;
      case t.Z_STREAM_END:
        break;
      case t.Z_NEED_DICT:
        return this.dictionary == null ? this._error("Missing dictionary") : this._error("Bad dictionary"), !1;
      default:
        return this._error("Zlib error"), !1;
    }
    return !0;
  }, u.prototype._after = function() {
    if (this._checkError()) {
      var d = this.strm.avail_out, h = this.strm.avail_in;
      this.write_in_progress = !1, this.callback(h, d), this.pending_close && this.close();
    }
  }, u.prototype._error = function(d) {
    this.strm.msg && (d = this.strm.msg), this.onerror(
      d,
      this.err
      // no hope of rescue.
    ), this.write_in_progress = !1, this.pending_close && this.close();
  }, u.prototype.init = function(d, h, v, b, x) {
    e(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])"), e(d >= 8 && d <= 15, "invalid windowBits"), e(h >= -1 && h <= 9, "invalid compression level"), e(v >= 1 && v <= 9, "invalid memlevel"), e(b === t.Z_FILTERED || b === t.Z_HUFFMAN_ONLY || b === t.Z_RLE || b === t.Z_FIXED || b === t.Z_DEFAULT_STRATEGY, "invalid strategy"), this._init(h, d, v, b, x), this._setDictionary();
  }, u.prototype.params = function() {
    throw new Error("deflateParams Not supported");
  }, u.prototype.reset = function() {
    this._reset(), this._setDictionary();
  }, u.prototype._init = function(d, h, v, b, x) {
    switch (this.level = d, this.windowBits = h, this.memLevel = v, this.strategy = b, this.flush = t.Z_NO_FLUSH, this.err = t.Z_OK, (this.mode === t.GZIP || this.mode === t.GUNZIP) && (this.windowBits += 16), this.mode === t.UNZIP && (this.windowBits += 32), (this.mode === t.DEFLATERAW || this.mode === t.INFLATERAW) && (this.windowBits = -1 * this.windowBits), this.strm = new r(), this.mode) {
      case t.DEFLATE:
      case t.GZIP:
      case t.DEFLATERAW:
        this.err = n.deflateInit2(this.strm, this.level, t.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
        break;
      case t.INFLATE:
      case t.GUNZIP:
      case t.INFLATERAW:
      case t.UNZIP:
        this.err = i.inflateInit2(this.strm, this.windowBits);
        break;
      default:
        throw new Error("Unknown mode " + this.mode);
    }
    this.err !== t.Z_OK && this._error("Init error"), this.dictionary = x, this.write_in_progress = !1, this.init_done = !0;
  }, u.prototype._setDictionary = function() {
    if (this.dictionary != null) {
      switch (this.err = t.Z_OK, this.mode) {
        case t.DEFLATE:
        case t.DEFLATERAW:
          this.err = n.deflateSetDictionary(this.strm, this.dictionary);
          break;
      }
      this.err !== t.Z_OK && this._error("Failed to set dictionary");
    }
  }, u.prototype._reset = function() {
    switch (this.err = t.Z_OK, this.mode) {
      case t.DEFLATE:
      case t.DEFLATERAW:
      case t.GZIP:
        this.err = n.deflateReset(this.strm);
        break;
      case t.INFLATE:
      case t.INFLATERAW:
      case t.GUNZIP:
        this.err = i.inflateReset(this.strm);
        break;
    }
    this.err !== t.Z_OK && this._error("Failed to reset stream");
  }, t.Zlib = u;
})(CC);
var _J = /* @__PURE__ */ tm(JZ);
(function(t) {
  var e = pw.Buffer, r = NX.Transform, n = CC, i = _J, a = PC.ok, o = pw.kMaxLength, s = "Cannot create final Buffer. It would be larger than 0x" + o.toString(16) + " bytes";
  n.Z_MIN_WINDOWBITS = 8, n.Z_MAX_WINDOWBITS = 15, n.Z_DEFAULT_WINDOWBITS = 15, n.Z_MIN_CHUNK = 64, n.Z_MAX_CHUNK = 1 / 0, n.Z_DEFAULT_CHUNK = 16 * 1024, n.Z_MIN_MEMLEVEL = 1, n.Z_MAX_MEMLEVEL = 9, n.Z_DEFAULT_MEMLEVEL = 8, n.Z_MIN_LEVEL = -1, n.Z_MAX_LEVEL = 9, n.Z_DEFAULT_LEVEL = n.Z_DEFAULT_COMPRESSION;
  for (var l = Object.keys(n), u = 0; u < l.length; u++) {
    var d = l[u];
    d.match(/^Z/) && Object.defineProperty(t, d, {
      enumerable: !0,
      value: n[d],
      writable: !1
    });
  }
  for (var h = {
    Z_OK: n.Z_OK,
    Z_STREAM_END: n.Z_STREAM_END,
    Z_NEED_DICT: n.Z_NEED_DICT,
    Z_ERRNO: n.Z_ERRNO,
    Z_STREAM_ERROR: n.Z_STREAM_ERROR,
    Z_DATA_ERROR: n.Z_DATA_ERROR,
    Z_MEM_ERROR: n.Z_MEM_ERROR,
    Z_BUF_ERROR: n.Z_BUF_ERROR,
    Z_VERSION_ERROR: n.Z_VERSION_ERROR
  }, v = Object.keys(h), b = 0; b < v.length; b++) {
    var x = v[b];
    h[h[x]] = x;
  }
  Object.defineProperty(t, "codes", {
    enumerable: !0,
    value: Object.freeze(h),
    writable: !1
  }), t.Deflate = k, t.Inflate = E, t.Gzip = C, t.Gunzip = D, t.DeflateRaw = _, t.InflateRaw = I, t.Unzip = R, t.createDeflate = function(S) {
    return new k(S);
  }, t.createInflate = function(S) {
    return new E(S);
  }, t.createDeflateRaw = function(S) {
    return new _(S);
  }, t.createInflateRaw = function(S) {
    return new I(S);
  }, t.createGzip = function(S) {
    return new C(S);
  }, t.createGunzip = function(S) {
    return new D(S);
  }, t.createUnzip = function(S) {
    return new R(S);
  }, t.deflate = function(S, B, q) {
    return typeof B == "function" && (q = B, B = {}), A(new k(B), S, q);
  }, t.deflateSync = function(S, B) {
    return T(new k(B), S);
  }, t.gzip = function(S, B, q) {
    return typeof B == "function" && (q = B, B = {}), A(new C(B), S, q);
  }, t.gzipSync = function(S, B) {
    return T(new C(B), S);
  }, t.deflateRaw = function(S, B, q) {
    return typeof B == "function" && (q = B, B = {}), A(new _(B), S, q);
  }, t.deflateRawSync = function(S, B) {
    return T(new _(B), S);
  }, t.unzip = function(S, B, q) {
    return typeof B == "function" && (q = B, B = {}), A(new R(B), S, q);
  }, t.unzipSync = function(S, B) {
    return T(new R(B), S);
  }, t.inflate = function(S, B, q) {
    return typeof B == "function" && (q = B, B = {}), A(new E(B), S, q);
  }, t.inflateSync = function(S, B) {
    return T(new E(B), S);
  }, t.gunzip = function(S, B, q) {
    return typeof B == "function" && (q = B, B = {}), A(new D(B), S, q);
  }, t.gunzipSync = function(S, B) {
    return T(new D(B), S);
  }, t.inflateRaw = function(S, B, q) {
    return typeof B == "function" && (q = B, B = {}), A(new I(B), S, q);
  }, t.inflateRawSync = function(S, B) {
    return T(new I(B), S);
  };
  function A(S, B, q) {
    var Y = [], Z = 0;
    S.on("error", J), S.on("end", se), S.end(B), Q();
    function Q() {
      for (var ae; (ae = S.read()) !== null; )
        Y.push(ae), Z += ae.length;
      S.once("readable", Q);
    }
    function J(ae) {
      S.removeListener("end", se), S.removeListener("readable", Q), q(ae);
    }
    function se() {
      var ae, te = null;
      Z >= o ? te = new RangeError(s) : ae = e.concat(Y, Z), Y = [], S.close(), q(te, ae);
    }
  }
  function T(S, B) {
    if (typeof B == "string" && (B = e.from(B)), !e.isBuffer(B)) throw new TypeError("Not a string or buffer");
    var q = S._finishFlushFlag;
    return S._processChunk(B, q);
  }
  function k(S) {
    if (!(this instanceof k)) return new k(S);
    V.call(this, S, n.DEFLATE);
  }
  function E(S) {
    if (!(this instanceof E)) return new E(S);
    V.call(this, S, n.INFLATE);
  }
  function C(S) {
    if (!(this instanceof C)) return new C(S);
    V.call(this, S, n.GZIP);
  }
  function D(S) {
    if (!(this instanceof D)) return new D(S);
    V.call(this, S, n.GUNZIP);
  }
  function _(S) {
    if (!(this instanceof _)) return new _(S);
    V.call(this, S, n.DEFLATERAW);
  }
  function I(S) {
    if (!(this instanceof I)) return new I(S);
    V.call(this, S, n.INFLATERAW);
  }
  function R(S) {
    if (!(this instanceof R)) return new R(S);
    V.call(this, S, n.UNZIP);
  }
  function U(S) {
    return S === n.Z_NO_FLUSH || S === n.Z_PARTIAL_FLUSH || S === n.Z_SYNC_FLUSH || S === n.Z_FULL_FLUSH || S === n.Z_FINISH || S === n.Z_BLOCK;
  }
  function V(S, B) {
    var q = this;
    if (this._opts = S = S || {}, this._chunkSize = S.chunkSize || t.Z_DEFAULT_CHUNK, r.call(this, S), S.flush && !U(S.flush))
      throw new Error("Invalid flush flag: " + S.flush);
    if (S.finishFlush && !U(S.finishFlush))
      throw new Error("Invalid flush flag: " + S.finishFlush);
    if (this._flushFlag = S.flush || n.Z_NO_FLUSH, this._finishFlushFlag = typeof S.finishFlush < "u" ? S.finishFlush : n.Z_FINISH, S.chunkSize && (S.chunkSize < t.Z_MIN_CHUNK || S.chunkSize > t.Z_MAX_CHUNK))
      throw new Error("Invalid chunk size: " + S.chunkSize);
    if (S.windowBits && (S.windowBits < t.Z_MIN_WINDOWBITS || S.windowBits > t.Z_MAX_WINDOWBITS))
      throw new Error("Invalid windowBits: " + S.windowBits);
    if (S.level && (S.level < t.Z_MIN_LEVEL || S.level > t.Z_MAX_LEVEL))
      throw new Error("Invalid compression level: " + S.level);
    if (S.memLevel && (S.memLevel < t.Z_MIN_MEMLEVEL || S.memLevel > t.Z_MAX_MEMLEVEL))
      throw new Error("Invalid memLevel: " + S.memLevel);
    if (S.strategy && S.strategy != t.Z_FILTERED && S.strategy != t.Z_HUFFMAN_ONLY && S.strategy != t.Z_RLE && S.strategy != t.Z_FIXED && S.strategy != t.Z_DEFAULT_STRATEGY)
      throw new Error("Invalid strategy: " + S.strategy);
    if (S.dictionary && !e.isBuffer(S.dictionary))
      throw new Error("Invalid dictionary: it should be a Buffer instance");
    this._handle = new n.Zlib(B);
    var Y = this;
    this._hadError = !1, this._handle.onerror = function(J, se) {
      z(Y), Y._hadError = !0;
      var ae = new Error(J);
      ae.errno = se, ae.code = t.codes[se], Y.emit("error", ae);
    };
    var Z = t.Z_DEFAULT_COMPRESSION;
    typeof S.level == "number" && (Z = S.level);
    var Q = t.Z_DEFAULT_STRATEGY;
    typeof S.strategy == "number" && (Q = S.strategy), this._handle.init(S.windowBits || t.Z_DEFAULT_WINDOWBITS, Z, S.memLevel || t.Z_DEFAULT_MEMLEVEL, Q, S.dictionary), this._buffer = e.allocUnsafe(this._chunkSize), this._offset = 0, this._level = Z, this._strategy = Q, this.once("end", this.close), Object.defineProperty(this, "_closed", {
      get: function() {
        return !q._handle;
      },
      configurable: !0,
      enumerable: !0
    });
  }
  i.inherits(V, r), V.prototype.params = function(S, B, q) {
    if (S < t.Z_MIN_LEVEL || S > t.Z_MAX_LEVEL)
      throw new RangeError("Invalid compression level: " + S);
    if (B != t.Z_FILTERED && B != t.Z_HUFFMAN_ONLY && B != t.Z_RLE && B != t.Z_FIXED && B != t.Z_DEFAULT_STRATEGY)
      throw new TypeError("Invalid strategy: " + B);
    if (this._level !== S || this._strategy !== B) {
      var Y = this;
      this.flush(n.Z_SYNC_FLUSH, function() {
        a(Y._handle, "zlib binding closed"), Y._handle.params(S, B), Y._hadError || (Y._level = S, Y._strategy = B, q && q());
      });
    } else
      Ka.nextTick(q);
  }, V.prototype.reset = function() {
    return a(this._handle, "zlib binding closed"), this._handle.reset();
  }, V.prototype._flush = function(S) {
    this._transform(e.alloc(0), "", S);
  }, V.prototype.flush = function(S, B) {
    var q = this, Y = this._writableState;
    (typeof S == "function" || S === void 0 && !B) && (B = S, S = n.Z_FULL_FLUSH), Y.ended ? B && Ka.nextTick(B) : Y.ending ? B && this.once("end", B) : Y.needDrain ? B && this.once("drain", function() {
      return q.flush(S, B);
    }) : (this._flushFlag = S, this.write(e.alloc(0), "", B));
  }, V.prototype.close = function(S) {
    z(this, S), Ka.nextTick(j, this);
  };
  function z(S, B) {
    B && Ka.nextTick(B), S._handle && (S._handle.close(), S._handle = null);
  }
  function j(S) {
    S.emit("close");
  }
  V.prototype._transform = function(S, B, q) {
    var Y, Z = this._writableState, Q = Z.ending || Z.ended, J = Q && (!S || Z.length === S.length);
    if (S !== null && !e.isBuffer(S)) return q(new Error("invalid input"));
    if (!this._handle) return q(new Error("zlib binding closed"));
    J ? Y = this._finishFlushFlag : (Y = this._flushFlag, S.length >= Z.length && (this._flushFlag = this._opts.flush || n.Z_NO_FLUSH)), this._processChunk(S, Y, q);
  }, V.prototype._processChunk = function(S, B, q) {
    var Y = S && S.length, Z = this._chunkSize - this._offset, Q = 0, J = this, se = typeof q == "function";
    if (!se) {
      var ae = [], te = 0, ne;
      this.on("error", function(it) {
        ne = it;
      }), a(this._handle, "zlib binding closed");
      do
        var ce = this._handle.writeSync(
          B,
          S,
          // in
          Q,
          // in_off
          Y,
          // in_len
          this._buffer,
          // out
          this._offset,
          //out_off
          Z
        );
      while (!this._hadError && Ne(ce[0], ce[1]));
      if (this._hadError)
        throw ne;
      if (te >= o)
        throw z(this), new RangeError(s);
      var pe = e.concat(ae, te);
      return z(this), pe;
    }
    a(this._handle, "zlib binding closed");
    var Me = this._handle.write(
      B,
      S,
      // in
      Q,
      // in_off
      Y,
      // in_len
      this._buffer,
      // out
      this._offset,
      //out_off
      Z
    );
    Me.buffer = S, Me.callback = Ne;
    function Ne(it, fe) {
      if (this && (this.buffer = null, this.callback = null), !J._hadError) {
        var ye = Z - fe;
        if (a(ye >= 0, "have should not go down"), ye > 0) {
          var be = J._buffer.slice(J._offset, J._offset + ye);
          J._offset += ye, se ? J.push(be) : (ae.push(be), te += be.length);
        }
        if ((fe === 0 || J._offset >= J._chunkSize) && (Z = J._chunkSize, J._offset = 0, J._buffer = e.allocUnsafe(J._chunkSize)), fe === 0) {
          if (Q += Y - it, Y = it, !se) return !0;
          var he = J._handle.write(B, S, Q, Y, J._buffer, J._offset, J._chunkSize);
          he.callback = Ne, he.buffer = S;
          return;
        }
        if (!se) return !1;
        q();
      }
    }
  }, i.inherits(k, V), i.inherits(E, V), i.inherits(C, V), i.inherits(D, V), i.inherits(_, V), i.inherits(I, V), i.inherits(R, V);
})(oC);
var AJ = /* @__PURE__ */ OZ(oC);
let EJ = class {
  static decode(e, r) {
    throw new Error("PNG.decode not available in browser build");
  }
  static load(e) {
    throw new Error("PNG.load not available in browser build");
  }
  constructor(e) {
    let r;
    for (this.data = e, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.text = {}; ; ) {
      const l = this.readUInt32();
      let u = "";
      for (r = 0; r < 4; r++)
        u += String.fromCharCode(this.data[this.pos++]);
      switch (u) {
        case "IHDR":
          this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
          break;
        case "PLTE":
          this.palette = this.read(l);
          break;
        case "IDAT":
          for (r = 0; r < l; r++)
            this.imgData.push(this.data[this.pos++]);
          break;
        case "tRNS":
          switch (this.transparency = {}, this.colorType) {
            case 3:
              this.transparency.indexed = this.read(l);
              var n = 255 - this.transparency.indexed.length;
              if (n > 0)
                for (r = 0; r < n; r++)
                  this.transparency.indexed.push(255);
              break;
            case 0:
              this.transparency.grayscale = this.read(l)[0];
              break;
            case 2:
              this.transparency.rgb = this.read(l);
              break;
          }
          break;
        case "tEXt":
          var i = this.read(l), a = i.indexOf(0), o = String.fromCharCode.apply(String, i.slice(0, a));
          this.text[o] = String.fromCharCode.apply(String, i.slice(a + 1));
          break;
        case "IEND":
          switch (this.colorType) {
            case 0:
            case 3:
            case 4:
              this.colors = 1;
              break;
            case 2:
            case 6:
              this.colors = 3;
              break;
          }
          this.hasAlphaChannel = [4, 6].includes(this.colorType);
          var s = this.colors + (this.hasAlphaChannel ? 1 : 0);
          switch (this.pixelBitlength = this.bits * s, this.colors) {
            case 1:
              this.colorSpace = "DeviceGray";
              break;
            case 3:
              this.colorSpace = "DeviceRGB";
              break;
          }
          this.imgData = Re.from(this.imgData);
          return;
        default:
          this.pos += l;
      }
      if (this.pos += 4, this.pos > this.data.length)
        throw new Error("Incomplete or corrupt PNG file");
    }
  }
  read(e) {
    const r = new Array(e);
    for (let n = 0; n < e; n++)
      r[n] = this.data[this.pos++];
    return r;
  }
  readUInt32() {
    const e = this.data[this.pos++] << 24, r = this.data[this.pos++] << 16, n = this.data[this.pos++] << 8, i = this.data[this.pos++];
    return e | r | n | i;
  }
  readUInt16() {
    const e = this.data[this.pos++] << 8, r = this.data[this.pos++];
    return e | r;
  }
  decodePixels(e) {
    return AJ.inflate(this.imgData, (r, n) => {
      if (r) throw r;
      var i = 0;
      const {
        width: a,
        height: o
      } = this;
      var s = this.pixelBitlength / 8;
      const l = Re.alloc(a * o * s);
      function u(d, h, v, b, x) {
        x === void 0 && (x = !1);
        const A = Math.ceil((a - d) / v), T = Math.ceil((o - h) / b), k = s * A, E = x ? l : Re.alloc(k * T);
        let C = 0, D = 0;
        for (; C < T && i < n.length; ) {
          var _, I, R, U, V;
          switch (n[i++]) {
            case 0:
              for (R = 0; R < k; R++)
                E[D++] = n[i++];
              break;
            case 1:
              for (R = 0; R < k; R++)
                _ = n[i++], U = R < s ? 0 : E[D - s], E[D++] = (_ + U) % 256;
              break;
            case 2:
              for (R = 0; R < k; R++)
                _ = n[i++], I = (R - R % s) / s, V = C && E[(C - 1) * k + I * s + R % s], E[D++] = (V + _) % 256;
              break;
            case 3:
              for (R = 0; R < k; R++)
                _ = n[i++], I = (R - R % s) / s, U = R < s ? 0 : E[D - s], V = C && E[(C - 1) * k + I * s + R % s], E[D++] = (_ + Math.floor((U + V) / 2)) % 256;
              break;
            case 4:
              for (R = 0; R < k; R++) {
                var z, j;
                _ = n[i++], I = (R - R % s) / s, U = R < s ? 0 : E[D - s], C === 0 ? V = j = 0 : (V = E[(C - 1) * k + I * s + R % s], j = I && E[(C - 1) * k + (I - 1) * s + R % s]);
                const S = U + V - j, B = Math.abs(S - U), q = Math.abs(S - V), Y = Math.abs(S - j);
                B <= q && B <= Y ? z = U : q <= Y ? z = V : z = j, E[D++] = (_ + z) % 256;
              }
              break;
            default:
              throw new Error(`Invalid filter algorithm: ${n[i - 1]}`);
          }
          if (!x) {
            let S = ((h + C * b) * a + d) * s, B = C * k;
            for (R = 0; R < A; R++) {
              for (let q = 0; q < s; q++) l[S++] = E[B++];
              S += (v - 1) * s;
            }
          }
          C++;
        }
      }
      return this.interlaceMethod === 1 ? (u(0, 0, 8, 8), u(4, 0, 8, 8), u(0, 4, 4, 8), u(2, 0, 4, 4), u(0, 2, 2, 4), u(1, 0, 2, 2), u(0, 1, 1, 2)) : u(0, 0, 1, 1, !0), e(l);
    });
  }
  decodePalette() {
    const {
      palette: e
    } = this, {
      length: r
    } = e, n = this.transparency.indexed || [], i = Re.alloc(n.length + r);
    let a = 0, o = 0;
    for (let l = 0; l < r; l += 3) {
      var s;
      i[a++] = e[l], i[a++] = e[l + 1], i[a++] = e[l + 2], i[a++] = (s = n[o++]) != null ? s : 255;
    }
    return i;
  }
  copyToImageData(e, r) {
    let n;
    var i;
    let {
      colors: a
    } = this, o = null, s = this.hasAlphaChannel;
    this.palette.length && (o = this._decodedPalette || (this._decodedPalette = this.decodePalette()), a = 4, s = !0);
    const l = e.data || e, {
      length: u
    } = l, d = o || r;
    let h = n = 0;
    if (a === 1)
      for (; h < u; ) {
        i = o ? r[h / 4] * 4 : n;
        const v = d[i++];
        l[h++] = v, l[h++] = v, l[h++] = v, l[h++] = s ? d[i++] : 255, n = i;
      }
    else
      for (; h < u; )
        i = o ? r[h / 4] * 4 : n, l[h++] = d[i++], l[h++] = d[i++], l[h++] = d[i++], l[h++] = s ? d[i++] : 255, n = i;
  }
  decode(e) {
    const r = Re.alloc(this.width * this.height * 4);
    return this.decodePixels((n) => (this.copyToImageData(r, n), e(r)));
  }
};
var hk = { exports: {} }, O4 = { exports: {} }, v7;
function um() {
  return v7 || (v7 = 1, function(t, e) {
    (function(r, n) {
      t.exports = n(d0());
    })(Wt, function(r) {
      return function(n) {
        var i = r, a = i.lib, o = a.Base, s = a.WordArray, l = i.x64 = {};
        l.Word = o.extend({
          /**
           * Initializes a newly created 64-bit word.
           *
           * @param {number} high The high 32 bits.
           * @param {number} low The low 32 bits.
           *
           * @example
           *
           *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
           */
          init: function(u, d) {
            this.high = u, this.low = d;
          }
          /**
           * Bitwise NOTs this word.
           *
           * @return {X64Word} A new x64-Word object after negating.
           *
           * @example
           *
           *     var negated = x64Word.not();
           */
          // not: function () {
          // var high = ~this.high;
          // var low = ~this.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ANDs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to AND with this word.
           *
           * @return {X64Word} A new x64-Word object after ANDing.
           *
           * @example
           *
           *     var anded = x64Word.and(anotherX64Word);
           */
          // and: function (word) {
          // var high = this.high & word.high;
          // var low = this.low & word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to OR with this word.
           *
           * @return {X64Word} A new x64-Word object after ORing.
           *
           * @example
           *
           *     var ored = x64Word.or(anotherX64Word);
           */
          // or: function (word) {
          // var high = this.high | word.high;
          // var low = this.low | word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise XORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to XOR with this word.
           *
           * @return {X64Word} A new x64-Word object after XORing.
           *
           * @example
           *
           *     var xored = x64Word.xor(anotherX64Word);
           */
          // xor: function (word) {
          // var high = this.high ^ word.high;
          // var low = this.low ^ word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the left.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftL(25);
           */
          // shiftL: function (n) {
          // if (n < 32) {
          // var high = (this.high << n) | (this.low >>> (32 - n));
          // var low = this.low << n;
          // } else {
          // var high = this.low << (n - 32);
          // var low = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the right.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftR(7);
           */
          // shiftR: function (n) {
          // if (n < 32) {
          // var low = (this.low >>> n) | (this.high << (32 - n));
          // var high = this.high >>> n;
          // } else {
          // var low = this.high >>> (n - 32);
          // var high = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Rotates this word n bits to the left.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotL(25);
           */
          // rotL: function (n) {
          // return this.shiftL(n).or(this.shiftR(64 - n));
          // },
          /**
           * Rotates this word n bits to the right.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotR(7);
           */
          // rotR: function (n) {
          // return this.shiftR(n).or(this.shiftL(64 - n));
          // },
          /**
           * Adds this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to add with this word.
           *
           * @return {X64Word} A new x64-Word object after adding.
           *
           * @example
           *
           *     var added = x64Word.add(anotherX64Word);
           */
          // add: function (word) {
          // var low = (this.low + word.low) | 0;
          // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
          // var high = (this.high + word.high + carry) | 0;
          // return X64Word.create(high, low);
          // }
        }), l.WordArray = o.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.x64.WordArray.create();
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ]);
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ], 10);
           */
          init: function(u, d) {
            u = this.words = u || [], d != n ? this.sigBytes = d : this.sigBytes = u.length * 8;
          },
          /**
           * Converts this 64-bit word array to a 32-bit word array.
           *
           * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
           *
           * @example
           *
           *     var x32WordArray = x64WordArray.toX32();
           */
          toX32: function() {
            for (var u = this.words, d = u.length, h = [], v = 0; v < d; v++) {
              var b = u[v];
              h.push(b.high), h.push(b.low);
            }
            return s.create(h, this.sigBytes);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {X64WordArray} The clone.
           *
           * @example
           *
           *     var clone = x64WordArray.clone();
           */
          clone: function() {
            for (var u = o.clone.call(this), d = u.words = this.words.slice(0), h = d.length, v = 0; v < h; v++)
              d[v] = d[v].clone();
            return u;
          }
        });
      }(), r;
    });
  }(O4)), O4.exports;
}
var R4 = { exports: {} }, b7;
function SJ() {
  return b7 || (b7 = 1, function(t, e) {
    (function(r, n) {
      t.exports = n(d0());
    })(Wt, function(r) {
      return function() {
        if (typeof ArrayBuffer == "function") {
          var n = r, i = n.lib, a = i.WordArray, o = a.init, s = a.init = function(l) {
            if (l instanceof ArrayBuffer && (l = new Uint8Array(l)), (l instanceof Int8Array || typeof Uint8ClampedArray < "u" && l instanceof Uint8ClampedArray || l instanceof Int16Array || l instanceof Uint16Array || l instanceof Int32Array || l instanceof Uint32Array || l instanceof Float32Array || l instanceof Float64Array) && (l = new Uint8Array(l.buffer, l.byteOffset, l.byteLength)), l instanceof Uint8Array) {
              for (var u = l.byteLength, d = [], h = 0; h < u; h++)
                d[h >>> 2] |= l[h] << 24 - h % 4 * 8;
              o.call(this, d, u);
            } else
              o.apply(this, arguments);
          };
          s.prototype = a;
        }
      }(), r.lib.WordArray;
    });
  }(R4)), R4.exports;
}
var P4 = { exports: {} }, x7;
function CJ() {
  return x7 || (x7 = 1, function(t, e) {
    (function(r, n) {
      t.exports = n(d0());
    })(Wt, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.WordArray, o = n.enc;
        o.Utf16 = o.Utf16BE = {
          /**
           * Converts a word array to a UTF-16 BE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 BE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
           */
          stringify: function(l) {
            for (var u = l.words, d = l.sigBytes, h = [], v = 0; v < d; v += 2) {
              var b = u[v >>> 2] >>> 16 - v % 4 * 8 & 65535;
              h.push(String.fromCharCode(b));
            }
            return h.join("");
          },
          /**
           * Converts a UTF-16 BE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 BE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
           */
          parse: function(l) {
            for (var u = l.length, d = [], h = 0; h < u; h++)
              d[h >>> 1] |= l.charCodeAt(h) << 16 - h % 2 * 16;
            return a.create(d, u * 2);
          }
        }, o.Utf16LE = {
          /**
           * Converts a word array to a UTF-16 LE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 LE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
           */
          stringify: function(l) {
            for (var u = l.words, d = l.sigBytes, h = [], v = 0; v < d; v += 2) {
              var b = s(u[v >>> 2] >>> 16 - v % 4 * 8 & 65535);
              h.push(String.fromCharCode(b));
            }
            return h.join("");
          },
          /**
           * Converts a UTF-16 LE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 LE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
           */
          parse: function(l) {
            for (var u = l.length, d = [], h = 0; h < u; h++)
              d[h >>> 1] |= s(l.charCodeAt(h) << 16 - h % 2 * 16);
            return a.create(d, u * 2);
          }
        };
        function s(l) {
          return l << 8 & 4278255360 | l >>> 8 & 16711935;
        }
      }(), r.enc.Utf16;
    });
  }(P4)), P4.exports;
}
var I4 = { exports: {} }, y7;
function Bc() {
  return y7 || (y7 = 1, function(t, e) {
    (function(r, n) {
      t.exports = n(d0());
    })(Wt, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.WordArray, o = n.enc;
        o.Base64 = {
          /**
           * Converts a word array to a Base64 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Base64 string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
           */
          stringify: function(l) {
            var u = l.words, d = l.sigBytes, h = this._map;
            l.clamp();
            for (var v = [], b = 0; b < d; b += 3)
              for (var x = u[b >>> 2] >>> 24 - b % 4 * 8 & 255, A = u[b + 1 >>> 2] >>> 24 - (b + 1) % 4 * 8 & 255, T = u[b + 2 >>> 2] >>> 24 - (b + 2) % 4 * 8 & 255, k = x << 16 | A << 8 | T, E = 0; E < 4 && b + E * 0.75 < d; E++)
                v.push(h.charAt(k >>> 6 * (3 - E) & 63));
            var C = h.charAt(64);
            if (C)
              for (; v.length % 4; )
                v.push(C);
            return v.join("");
          },
          /**
           * Converts a Base64 string to a word array.
           *
           * @param {string} base64Str The Base64 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
           */
          parse: function(l) {
            var u = l.length, d = this._map, h = this._reverseMap;
            if (!h) {
              h = this._reverseMap = [];
              for (var v = 0; v < d.length; v++)
                h[d.charCodeAt(v)] = v;
            }
            var b = d.charAt(64);
            if (b) {
              var x = l.indexOf(b);
              x !== -1 && (u = x);
            }
            return s(l, u, h);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function s(l, u, d) {
          for (var h = [], v = 0, b = 0; b < u; b++)
            if (b % 4) {
              var x = d[l.charCodeAt(b - 1)] << b % 4 * 2, A = d[l.charCodeAt(b)] >>> 6 - b % 4 * 2, T = x | A;
              h[v >>> 2] |= T << 24 - v % 4 * 8, v++;
            }
          return a.create(h, v);
        }
      }(), r.enc.Base64;
    });
  }(I4)), I4.exports;
}
var B4 = { exports: {} }, w7;
function kJ() {
  return w7 || (w7 = 1, function(t, e) {
    (function(r, n) {
      t.exports = n(d0());
    })(Wt, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.WordArray, o = n.enc;
        o.Base64url = {
          /**
           * Converts a word array to a Base64url string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {string} The Base64url string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
           */
          stringify: function(l, u) {
            u === void 0 && (u = !0);
            var d = l.words, h = l.sigBytes, v = u ? this._safe_map : this._map;
            l.clamp();
            for (var b = [], x = 0; x < h; x += 3)
              for (var A = d[x >>> 2] >>> 24 - x % 4 * 8 & 255, T = d[x + 1 >>> 2] >>> 24 - (x + 1) % 4 * 8 & 255, k = d[x + 2 >>> 2] >>> 24 - (x + 2) % 4 * 8 & 255, E = A << 16 | T << 8 | k, C = 0; C < 4 && x + C * 0.75 < h; C++)
                b.push(v.charAt(E >>> 6 * (3 - C) & 63));
            var D = v.charAt(64);
            if (D)
              for (; b.length % 4; )
                b.push(D);
            return b.join("");
          },
          /**
           * Converts a Base64url string to a word array.
           *
           * @param {string} base64Str The Base64url string.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
           */
          parse: function(l, u) {
            u === void 0 && (u = !0);
            var d = l.length, h = u ? this._safe_map : this._map, v = this._reverseMap;
            if (!v) {
              v = this._reverseMap = [];
              for (var b = 0; b < h.length; b++)
                v[h.charCodeAt(b)] = b;
            }
            var x = h.charAt(64);
            if (x) {
              var A = l.indexOf(x);
              A !== -1 && (d = A);
            }
            return s(l, d, v);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
          _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function s(l, u, d) {
          for (var h = [], v = 0, b = 0; b < u; b++)
            if (b % 4) {
              var x = d[l.charCodeAt(b - 1)] << b % 4 * 2, A = d[l.charCodeAt(b)] >>> 6 - b % 4 * 2, T = x | A;
              h[v >>> 2] |= T << 24 - v % 4 * 8, v++;
            }
          return a.create(h, v);
        }
      }(), r.enc.Base64url;
    });
  }(B4)), B4.exports;
}
var L4 = { exports: {} }, _7;
function pk() {
  return _7 || (_7 = 1, function(t, e) {
    (function(r, n) {
      t.exports = n(d0());
    })(Wt, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.WordArray, o = i.Hasher, s = n.algo, l = [], u = s.SHA1 = o.extend({
          _doReset: function() {
            this._hash = new a.init([
              1732584193,
              4023233417,
              2562383102,
              271733878,
              3285377520
            ]);
          },
          _doProcessBlock: function(d, h) {
            for (var v = this._hash.words, b = v[0], x = v[1], A = v[2], T = v[3], k = v[4], E = 0; E < 80; E++) {
              if (E < 16)
                l[E] = d[h + E] | 0;
              else {
                var C = l[E - 3] ^ l[E - 8] ^ l[E - 14] ^ l[E - 16];
                l[E] = C << 1 | C >>> 31;
              }
              var D = (b << 5 | b >>> 27) + k + l[E];
              E < 20 ? D += (x & A | ~x & T) + 1518500249 : E < 40 ? D += (x ^ A ^ T) + 1859775393 : E < 60 ? D += (x & A | x & T | A & T) - 1894007588 : D += (x ^ A ^ T) - 899497514, k = T, T = A, A = x << 30 | x >>> 2, x = b, b = D;
            }
            v[0] = v[0] + b | 0, v[1] = v[1] + x | 0, v[2] = v[2] + A | 0, v[3] = v[3] + T | 0, v[4] = v[4] + k | 0;
          },
          _doFinalize: function() {
            var d = this._data, h = d.words, v = this._nDataBytes * 8, b = d.sigBytes * 8;
            return h[b >>> 5] |= 128 << 24 - b % 32, h[(b + 64 >>> 9 << 4) + 14] = Math.floor(v / 4294967296), h[(b + 64 >>> 9 << 4) + 15] = v, d.sigBytes = h.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var d = o.clone.call(this);
            return d._hash = this._hash.clone(), d;
          }
        });
        n.SHA1 = o._createHelper(u), n.HmacSHA1 = o._createHmacHelper(u);
      }(), r.SHA1;
    });
  }(L4)), L4.exports;
}
var N4 = { exports: {} }, A7;
function px() {
  return A7 || (A7 = 1, function(t, e) {
    (function(r, n) {
      t.exports = n(d0());
    })(Wt, function(r) {
      return function(n) {
        var i = r, a = i.lib, o = a.WordArray, s = a.Hasher, l = i.algo, u = [], d = [];
        (function() {
          function b(k) {
            for (var E = n.sqrt(k), C = 2; C <= E; C++)
              if (!(k % C))
                return !1;
            return !0;
          }
          function x(k) {
            return (k - (k | 0)) * 4294967296 | 0;
          }
          for (var A = 2, T = 0; T < 64; )
            b(A) && (T < 8 && (u[T] = x(n.pow(A, 1 / 2))), d[T] = x(n.pow(A, 1 / 3)), T++), A++;
        })();
        var h = [], v = l.SHA256 = s.extend({
          _doReset: function() {
            this._hash = new o.init(u.slice(0));
          },
          _doProcessBlock: function(b, x) {
            for (var A = this._hash.words, T = A[0], k = A[1], E = A[2], C = A[3], D = A[4], _ = A[5], I = A[6], R = A[7], U = 0; U < 64; U++) {
              if (U < 16)
                h[U] = b[x + U] | 0;
              else {
                var V = h[U - 15], z = (V << 25 | V >>> 7) ^ (V << 14 | V >>> 18) ^ V >>> 3, j = h[U - 2], S = (j << 15 | j >>> 17) ^ (j << 13 | j >>> 19) ^ j >>> 10;
                h[U] = z + h[U - 7] + S + h[U - 16];
              }
              var B = D & _ ^ ~D & I, q = T & k ^ T & E ^ k & E, Y = (T << 30 | T >>> 2) ^ (T << 19 | T >>> 13) ^ (T << 10 | T >>> 22), Z = (D << 26 | D >>> 6) ^ (D << 21 | D >>> 11) ^ (D << 7 | D >>> 25), Q = R + Z + B + d[U] + h[U], J = Y + q;
              R = I, I = _, _ = D, D = C + Q | 0, C = E, E = k, k = T, T = Q + J | 0;
            }
            A[0] = A[0] + T | 0, A[1] = A[1] + k | 0, A[2] = A[2] + E | 0, A[3] = A[3] + C | 0, A[4] = A[4] + D | 0, A[5] = A[5] + _ | 0, A[6] = A[6] + I | 0, A[7] = A[7] + R | 0;
          },
          _doFinalize: function() {
            var b = this._data, x = b.words, A = this._nDataBytes * 8, T = b.sigBytes * 8;
            return x[T >>> 5] |= 128 << 24 - T % 32, x[(T + 64 >>> 9 << 4) + 14] = n.floor(A / 4294967296), x[(T + 64 >>> 9 << 4) + 15] = A, b.sigBytes = x.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var b = s.clone.call(this);
            return b._hash = this._hash.clone(), b;
          }
        });
        i.SHA256 = s._createHelper(v), i.HmacSHA256 = s._createHmacHelper(v);
      }(Math), r.SHA256;
    });
  }(N4)), N4.exports;
}
var M4 = { exports: {} }, E7;
function TJ() {
  return E7 || (E7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), px());
    })(Wt, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.WordArray, o = n.algo, s = o.SHA256, l = o.SHA224 = s.extend({
          _doReset: function() {
            this._hash = new a.init([
              3238371032,
              914150663,
              812702999,
              4144912697,
              4290775857,
              1750603025,
              1694076839,
              3204075428
            ]);
          },
          _doFinalize: function() {
            var u = s._doFinalize.call(this);
            return u.sigBytes -= 4, u;
          }
        });
        n.SHA224 = s._createHelper(l), n.HmacSHA224 = s._createHmacHelper(l);
      }(), r.SHA224;
    });
  }(M4)), M4.exports;
}
var U4 = { exports: {} }, S7;
function mk() {
  return S7 || (S7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), um());
    })(Wt, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.Hasher, o = n.x64, s = o.Word, l = o.WordArray, u = n.algo;
        function d() {
          return s.create.apply(s, arguments);
        }
        var h = [
          d(1116352408, 3609767458),
          d(1899447441, 602891725),
          d(3049323471, 3964484399),
          d(3921009573, 2173295548),
          d(961987163, 4081628472),
          d(1508970993, 3053834265),
          d(2453635748, 2937671579),
          d(2870763221, 3664609560),
          d(3624381080, 2734883394),
          d(310598401, 1164996542),
          d(607225278, 1323610764),
          d(1426881987, 3590304994),
          d(1925078388, 4068182383),
          d(2162078206, 991336113),
          d(2614888103, 633803317),
          d(3248222580, 3479774868),
          d(3835390401, 2666613458),
          d(4022224774, 944711139),
          d(264347078, 2341262773),
          d(604807628, 2007800933),
          d(770255983, 1495990901),
          d(1249150122, 1856431235),
          d(1555081692, 3175218132),
          d(1996064986, 2198950837),
          d(2554220882, 3999719339),
          d(2821834349, 766784016),
          d(2952996808, 2566594879),
          d(3210313671, 3203337956),
          d(3336571891, 1034457026),
          d(3584528711, 2466948901),
          d(113926993, 3758326383),
          d(338241895, 168717936),
          d(666307205, 1188179964),
          d(773529912, 1546045734),
          d(1294757372, 1522805485),
          d(1396182291, 2643833823),
          d(1695183700, 2343527390),
          d(1986661051, 1014477480),
          d(2177026350, 1206759142),
          d(2456956037, 344077627),
          d(2730485921, 1290863460),
          d(2820302411, 3158454273),
          d(3259730800, 3505952657),
          d(3345764771, 106217008),
          d(3516065817, 3606008344),
          d(3600352804, 1432725776),
          d(4094571909, 1467031594),
          d(275423344, 851169720),
          d(430227734, 3100823752),
          d(506948616, 1363258195),
          d(659060556, 3750685593),
          d(883997877, 3785050280),
          d(958139571, 3318307427),
          d(1322822218, 3812723403),
          d(1537002063, 2003034995),
          d(1747873779, 3602036899),
          d(1955562222, 1575990012),
          d(2024104815, 1125592928),
          d(2227730452, 2716904306),
          d(2361852424, 442776044),
          d(2428436474, 593698344),
          d(2756734187, 3733110249),
          d(3204031479, 2999351573),
          d(3329325298, 3815920427),
          d(3391569614, 3928383900),
          d(3515267271, 566280711),
          d(3940187606, 3454069534),
          d(4118630271, 4000239992),
          d(116418474, 1914138554),
          d(174292421, 2731055270),
          d(289380356, 3203993006),
          d(460393269, 320620315),
          d(685471733, 587496836),
          d(852142971, 1086792851),
          d(1017036298, 365543100),
          d(1126000580, 2618297676),
          d(1288033470, 3409855158),
          d(1501505948, 4234509866),
          d(1607167915, 987167468),
          d(1816402316, 1246189591)
        ], v = [];
        (function() {
          for (var x = 0; x < 80; x++)
            v[x] = d();
        })();
        var b = u.SHA512 = a.extend({
          _doReset: function() {
            this._hash = new l.init([
              new s.init(1779033703, 4089235720),
              new s.init(3144134277, 2227873595),
              new s.init(1013904242, 4271175723),
              new s.init(2773480762, 1595750129),
              new s.init(1359893119, 2917565137),
              new s.init(2600822924, 725511199),
              new s.init(528734635, 4215389547),
              new s.init(1541459225, 327033209)
            ]);
          },
          _doProcessBlock: function(x, A) {
            for (var T = this._hash.words, k = T[0], E = T[1], C = T[2], D = T[3], _ = T[4], I = T[5], R = T[6], U = T[7], V = k.high, z = k.low, j = E.high, S = E.low, B = C.high, q = C.low, Y = D.high, Z = D.low, Q = _.high, J = _.low, se = I.high, ae = I.low, te = R.high, ne = R.low, ce = U.high, pe = U.low, Me = V, Ne = z, it = j, fe = S, ye = B, be = q, he = Y, Ge = Z, $e = Q, Ve = J, Ze = se, wt = ae, et = te, W = ne, ee = ce, le = pe, me = 0; me < 80; me++) {
              var Ee, ve, Te = v[me];
              if (me < 16)
                ve = Te.high = x[A + me * 2] | 0, Ee = Te.low = x[A + me * 2 + 1] | 0;
              else {
                var Pe = v[me - 15], at = Pe.high, Ue = Pe.low, rt = (at >>> 1 | Ue << 31) ^ (at >>> 8 | Ue << 24) ^ at >>> 7, gt = (Ue >>> 1 | at << 31) ^ (Ue >>> 8 | at << 24) ^ (Ue >>> 7 | at << 25), _t = v[me - 2], Bt = _t.high, At = _t.low, Tt = (Bt >>> 19 | At << 13) ^ (Bt << 3 | At >>> 29) ^ Bt >>> 6, Je = (At >>> 19 | Bt << 13) ^ (At << 3 | Bt >>> 29) ^ (At >>> 6 | Bt << 26), ot = v[me - 7], R0 = ot.high, b0 = ot.low, ir = v[me - 16], a0 = ir.high, e0 = ir.low;
                Ee = gt + b0, ve = rt + R0 + (Ee >>> 0 < gt >>> 0 ? 1 : 0), Ee = Ee + Je, ve = ve + Tt + (Ee >>> 0 < Je >>> 0 ? 1 : 0), Ee = Ee + e0, ve = ve + a0 + (Ee >>> 0 < e0 >>> 0 ? 1 : 0), Te.high = ve, Te.low = Ee;
              }
              var kr = $e & Ze ^ ~$e & et, br = Ve & wt ^ ~Ve & W, Br = Me & it ^ Me & ye ^ it & ye, Mt = Ne & fe ^ Ne & be ^ fe & be, Rt = (Me >>> 28 | Ne << 4) ^ (Me << 30 | Ne >>> 2) ^ (Me << 25 | Ne >>> 7), tt = (Ne >>> 28 | Me << 4) ^ (Ne << 30 | Me >>> 2) ^ (Ne << 25 | Me >>> 7), yt = ($e >>> 14 | Ve << 18) ^ ($e >>> 18 | Ve << 14) ^ ($e << 23 | Ve >>> 9), q0 = (Ve >>> 14 | $e << 18) ^ (Ve >>> 18 | $e << 14) ^ (Ve << 23 | $e >>> 9), L0 = h[me], qe = L0.high, mt = L0.low, lt = le + q0, Vt = ee + yt + (lt >>> 0 < le >>> 0 ? 1 : 0), lt = lt + br, Vt = Vt + kr + (lt >>> 0 < br >>> 0 ? 1 : 0), lt = lt + mt, Vt = Vt + qe + (lt >>> 0 < mt >>> 0 ? 1 : 0), lt = lt + Ee, Vt = Vt + ve + (lt >>> 0 < Ee >>> 0 ? 1 : 0), t0 = tt + Mt, Q0 = Rt + Br + (t0 >>> 0 < tt >>> 0 ? 1 : 0);
              ee = et, le = W, et = Ze, W = wt, Ze = $e, wt = Ve, Ve = Ge + lt | 0, $e = he + Vt + (Ve >>> 0 < Ge >>> 0 ? 1 : 0) | 0, he = ye, Ge = be, ye = it, be = fe, it = Me, fe = Ne, Ne = lt + t0 | 0, Me = Vt + Q0 + (Ne >>> 0 < lt >>> 0 ? 1 : 0) | 0;
            }
            z = k.low = z + Ne, k.high = V + Me + (z >>> 0 < Ne >>> 0 ? 1 : 0), S = E.low = S + fe, E.high = j + it + (S >>> 0 < fe >>> 0 ? 1 : 0), q = C.low = q + be, C.high = B + ye + (q >>> 0 < be >>> 0 ? 1 : 0), Z = D.low = Z + Ge, D.high = Y + he + (Z >>> 0 < Ge >>> 0 ? 1 : 0), J = _.low = J + Ve, _.high = Q + $e + (J >>> 0 < Ve >>> 0 ? 1 : 0), ae = I.low = ae + wt, I.high = se + Ze + (ae >>> 0 < wt >>> 0 ? 1 : 0), ne = R.low = ne + W, R.high = te + et + (ne >>> 0 < W >>> 0 ? 1 : 0), pe = U.low = pe + le, U.high = ce + ee + (pe >>> 0 < le >>> 0 ? 1 : 0);
          },
          _doFinalize: function() {
            var x = this._data, A = x.words, T = this._nDataBytes * 8, k = x.sigBytes * 8;
            A[k >>> 5] |= 128 << 24 - k % 32, A[(k + 128 >>> 10 << 5) + 30] = Math.floor(T / 4294967296), A[(k + 128 >>> 10 << 5) + 31] = T, x.sigBytes = A.length * 4, this._process();
            var E = this._hash.toX32();
            return E;
          },
          clone: function() {
            var x = a.clone.call(this);
            return x._hash = this._hash.clone(), x;
          },
          blockSize: 1024 / 32
        });
        n.SHA512 = a._createHelper(b), n.HmacSHA512 = a._createHmacHelper(b);
      }(), r.SHA512;
    });
  }(U4)), U4.exports;
}
var z4 = { exports: {} }, C7;
function FJ() {
  return C7 || (C7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), um(), mk());
    })(Wt, function(r) {
      return function() {
        var n = r, i = n.x64, a = i.Word, o = i.WordArray, s = n.algo, l = s.SHA512, u = s.SHA384 = l.extend({
          _doReset: function() {
            this._hash = new o.init([
              new a.init(3418070365, 3238371032),
              new a.init(1654270250, 914150663),
              new a.init(2438529370, 812702999),
              new a.init(355462360, 4144912697),
              new a.init(1731405415, 4290775857),
              new a.init(2394180231, 1750603025),
              new a.init(3675008525, 1694076839),
              new a.init(1203062813, 3204075428)
            ]);
          },
          _doFinalize: function() {
            var d = l._doFinalize.call(this);
            return d.sigBytes -= 16, d;
          }
        });
        n.SHA384 = l._createHelper(u), n.HmacSHA384 = l._createHmacHelper(u);
      }(), r.SHA384;
    });
  }(z4)), z4.exports;
}
var $4 = { exports: {} }, k7;
function DJ() {
  return k7 || (k7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), um());
    })(Wt, function(r) {
      return function(n) {
        var i = r, a = i.lib, o = a.WordArray, s = a.Hasher, l = i.x64, u = l.Word, d = i.algo, h = [], v = [], b = [];
        (function() {
          for (var T = 1, k = 0, E = 0; E < 24; E++) {
            h[T + 5 * k] = (E + 1) * (E + 2) / 2 % 64;
            var C = k % 5, D = (2 * T + 3 * k) % 5;
            T = C, k = D;
          }
          for (var T = 0; T < 5; T++)
            for (var k = 0; k < 5; k++)
              v[T + 5 * k] = k + (2 * T + 3 * k) % 5 * 5;
          for (var _ = 1, I = 0; I < 24; I++) {
            for (var R = 0, U = 0, V = 0; V < 7; V++) {
              if (_ & 1) {
                var z = (1 << V) - 1;
                z < 32 ? U ^= 1 << z : R ^= 1 << z - 32;
              }
              _ & 128 ? _ = _ << 1 ^ 113 : _ <<= 1;
            }
            b[I] = u.create(R, U);
          }
        })();
        var x = [];
        (function() {
          for (var T = 0; T < 25; T++)
            x[T] = u.create();
        })();
        var A = d.SHA3 = s.extend({
          /**
           * Configuration options.
           *
           * @property {number} outputLength
           *   The desired number of bits in the output hash.
           *   Only values permitted are: 224, 256, 384, 512.
           *   Default: 512
           */
          cfg: s.cfg.extend({
            outputLength: 512
          }),
          _doReset: function() {
            for (var T = this._state = [], k = 0; k < 25; k++)
              T[k] = new u.init();
            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
          },
          _doProcessBlock: function(T, k) {
            for (var E = this._state, C = this.blockSize / 2, D = 0; D < C; D++) {
              var _ = T[k + 2 * D], I = T[k + 2 * D + 1];
              _ = (_ << 8 | _ >>> 24) & 16711935 | (_ << 24 | _ >>> 8) & 4278255360, I = (I << 8 | I >>> 24) & 16711935 | (I << 24 | I >>> 8) & 4278255360;
              var R = E[D];
              R.high ^= I, R.low ^= _;
            }
            for (var U = 0; U < 24; U++) {
              for (var V = 0; V < 5; V++) {
                for (var z = 0, j = 0, S = 0; S < 5; S++) {
                  var R = E[V + 5 * S];
                  z ^= R.high, j ^= R.low;
                }
                var B = x[V];
                B.high = z, B.low = j;
              }
              for (var V = 0; V < 5; V++)
                for (var q = x[(V + 4) % 5], Y = x[(V + 1) % 5], Z = Y.high, Q = Y.low, z = q.high ^ (Z << 1 | Q >>> 31), j = q.low ^ (Q << 1 | Z >>> 31), S = 0; S < 5; S++) {
                  var R = E[V + 5 * S];
                  R.high ^= z, R.low ^= j;
                }
              for (var J = 1; J < 25; J++) {
                var z, j, R = E[J], se = R.high, ae = R.low, te = h[J];
                te < 32 ? (z = se << te | ae >>> 32 - te, j = ae << te | se >>> 32 - te) : (z = ae << te - 32 | se >>> 64 - te, j = se << te - 32 | ae >>> 64 - te);
                var ne = x[v[J]];
                ne.high = z, ne.low = j;
              }
              var ce = x[0], pe = E[0];
              ce.high = pe.high, ce.low = pe.low;
              for (var V = 0; V < 5; V++)
                for (var S = 0; S < 5; S++) {
                  var J = V + 5 * S, R = E[J], Me = x[J], Ne = x[(V + 1) % 5 + 5 * S], it = x[(V + 2) % 5 + 5 * S];
                  R.high = Me.high ^ ~Ne.high & it.high, R.low = Me.low ^ ~Ne.low & it.low;
                }
              var R = E[0], fe = b[U];
              R.high ^= fe.high, R.low ^= fe.low;
            }
          },
          _doFinalize: function() {
            var T = this._data, k = T.words;
            this._nDataBytes * 8;
            var E = T.sigBytes * 8, C = this.blockSize * 32;
            k[E >>> 5] |= 1 << 24 - E % 32, k[(n.ceil((E + 1) / C) * C >>> 5) - 1] |= 128, T.sigBytes = k.length * 4, this._process();
            for (var D = this._state, _ = this.cfg.outputLength / 8, I = _ / 8, R = [], U = 0; U < I; U++) {
              var V = D[U], z = V.high, j = V.low;
              z = (z << 8 | z >>> 24) & 16711935 | (z << 24 | z >>> 8) & 4278255360, j = (j << 8 | j >>> 24) & 16711935 | (j << 24 | j >>> 8) & 4278255360, R.push(j), R.push(z);
            }
            return new o.init(R, _);
          },
          clone: function() {
            for (var T = s.clone.call(this), k = T._state = this._state.slice(0), E = 0; E < 25; E++)
              k[E] = k[E].clone();
            return T;
          }
        });
        i.SHA3 = s._createHelper(A), i.HmacSHA3 = s._createHmacHelper(A);
      }(Math), r.SHA3;
    });
  }($4)), $4.exports;
}
var V4 = { exports: {} }, T7;
function OJ() {
  return T7 || (T7 = 1, function(t, e) {
    (function(r, n) {
      t.exports = n(d0());
    })(Wt, function(r) {
      /** @preserve
      			(c) 2012 by Cédric Mesnil. All rights reserved.
      
      			Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
      
      			    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
      			    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
      
      			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      			*/
      return function(n) {
        var i = r, a = i.lib, o = a.WordArray, s = a.Hasher, l = i.algo, u = o.create([
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          7,
          4,
          13,
          1,
          10,
          6,
          15,
          3,
          12,
          0,
          9,
          5,
          2,
          14,
          11,
          8,
          3,
          10,
          14,
          4,
          9,
          15,
          8,
          1,
          2,
          7,
          0,
          6,
          13,
          11,
          5,
          12,
          1,
          9,
          11,
          10,
          0,
          8,
          12,
          4,
          13,
          3,
          7,
          15,
          14,
          5,
          6,
          2,
          4,
          0,
          5,
          9,
          7,
          12,
          2,
          10,
          14,
          1,
          3,
          8,
          11,
          6,
          15,
          13
        ]), d = o.create([
          5,
          14,
          7,
          0,
          9,
          2,
          11,
          4,
          13,
          6,
          15,
          8,
          1,
          10,
          3,
          12,
          6,
          11,
          3,
          7,
          0,
          13,
          5,
          10,
          14,
          15,
          8,
          12,
          4,
          9,
          1,
          2,
          15,
          5,
          1,
          3,
          7,
          14,
          6,
          9,
          11,
          8,
          12,
          2,
          10,
          0,
          4,
          13,
          8,
          6,
          4,
          1,
          3,
          11,
          15,
          0,
          5,
          12,
          2,
          13,
          9,
          7,
          10,
          14,
          12,
          15,
          10,
          4,
          1,
          5,
          8,
          7,
          6,
          2,
          13,
          14,
          0,
          3,
          9,
          11
        ]), h = o.create([
          11,
          14,
          15,
          12,
          5,
          8,
          7,
          9,
          11,
          13,
          14,
          15,
          6,
          7,
          9,
          8,
          7,
          6,
          8,
          13,
          11,
          9,
          7,
          15,
          7,
          12,
          15,
          9,
          11,
          7,
          13,
          12,
          11,
          13,
          6,
          7,
          14,
          9,
          13,
          15,
          14,
          8,
          13,
          6,
          5,
          12,
          7,
          5,
          11,
          12,
          14,
          15,
          14,
          15,
          9,
          8,
          9,
          14,
          5,
          6,
          8,
          6,
          5,
          12,
          9,
          15,
          5,
          11,
          6,
          8,
          13,
          12,
          5,
          12,
          13,
          14,
          11,
          8,
          5,
          6
        ]), v = o.create([
          8,
          9,
          9,
          11,
          13,
          15,
          15,
          5,
          7,
          7,
          8,
          11,
          14,
          14,
          12,
          6,
          9,
          13,
          15,
          7,
          12,
          8,
          9,
          11,
          7,
          7,
          12,
          7,
          6,
          15,
          13,
          11,
          9,
          7,
          15,
          11,
          8,
          6,
          6,
          14,
          12,
          13,
          5,
          14,
          13,
          13,
          7,
          5,
          15,
          5,
          8,
          11,
          14,
          14,
          6,
          14,
          6,
          9,
          12,
          9,
          12,
          5,
          15,
          8,
          8,
          5,
          12,
          9,
          12,
          5,
          14,
          6,
          8,
          13,
          6,
          5,
          15,
          13,
          11,
          11
        ]), b = o.create([0, 1518500249, 1859775393, 2400959708, 2840853838]), x = o.create([1352829926, 1548603684, 1836072691, 2053994217, 0]), A = l.RIPEMD160 = s.extend({
          _doReset: function() {
            this._hash = o.create([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
          },
          _doProcessBlock: function(I, R) {
            for (var U = 0; U < 16; U++) {
              var V = R + U, z = I[V];
              I[V] = (z << 8 | z >>> 24) & 16711935 | (z << 24 | z >>> 8) & 4278255360;
            }
            var j = this._hash.words, S = b.words, B = x.words, q = u.words, Y = d.words, Z = h.words, Q = v.words, J, se, ae, te, ne, ce, pe, Me, Ne, it;
            ce = J = j[0], pe = se = j[1], Me = ae = j[2], Ne = te = j[3], it = ne = j[4];
            for (var fe, U = 0; U < 80; U += 1)
              fe = J + I[R + q[U]] | 0, U < 16 ? fe += T(se, ae, te) + S[0] : U < 32 ? fe += k(se, ae, te) + S[1] : U < 48 ? fe += E(se, ae, te) + S[2] : U < 64 ? fe += C(se, ae, te) + S[3] : fe += D(se, ae, te) + S[4], fe = fe | 0, fe = _(fe, Z[U]), fe = fe + ne | 0, J = ne, ne = te, te = _(ae, 10), ae = se, se = fe, fe = ce + I[R + Y[U]] | 0, U < 16 ? fe += D(pe, Me, Ne) + B[0] : U < 32 ? fe += C(pe, Me, Ne) + B[1] : U < 48 ? fe += E(pe, Me, Ne) + B[2] : U < 64 ? fe += k(pe, Me, Ne) + B[3] : fe += T(pe, Me, Ne) + B[4], fe = fe | 0, fe = _(fe, Q[U]), fe = fe + it | 0, ce = it, it = Ne, Ne = _(Me, 10), Me = pe, pe = fe;
            fe = j[1] + ae + Ne | 0, j[1] = j[2] + te + it | 0, j[2] = j[3] + ne + ce | 0, j[3] = j[4] + J + pe | 0, j[4] = j[0] + se + Me | 0, j[0] = fe;
          },
          _doFinalize: function() {
            var I = this._data, R = I.words, U = this._nDataBytes * 8, V = I.sigBytes * 8;
            R[V >>> 5] |= 128 << 24 - V % 32, R[(V + 64 >>> 9 << 4) + 14] = (U << 8 | U >>> 24) & 16711935 | (U << 24 | U >>> 8) & 4278255360, I.sigBytes = (R.length + 1) * 4, this._process();
            for (var z = this._hash, j = z.words, S = 0; S < 5; S++) {
              var B = j[S];
              j[S] = (B << 8 | B >>> 24) & 16711935 | (B << 24 | B >>> 8) & 4278255360;
            }
            return z;
          },
          clone: function() {
            var I = s.clone.call(this);
            return I._hash = this._hash.clone(), I;
          }
        });
        function T(I, R, U) {
          return I ^ R ^ U;
        }
        function k(I, R, U) {
          return I & R | ~I & U;
        }
        function E(I, R, U) {
          return (I | ~R) ^ U;
        }
        function C(I, R, U) {
          return I & U | R & ~U;
        }
        function D(I, R, U) {
          return I ^ (R | ~U);
        }
        function _(I, R) {
          return I << R | I >>> 32 - R;
        }
        i.RIPEMD160 = s._createHelper(A), i.HmacRIPEMD160 = s._createHmacHelper(A);
      }(), r.RIPEMD160;
    });
  }(V4)), V4.exports;
}
var j4 = { exports: {} }, F7;
function mx() {
  return F7 || (F7 = 1, function(t, e) {
    (function(r, n) {
      t.exports = n(d0());
    })(Wt, function(r) {
      (function() {
        var n = r, i = n.lib, a = i.Base, o = n.enc, s = o.Utf8, l = n.algo;
        l.HMAC = a.extend({
          /**
           * Initializes a newly created HMAC.
           *
           * @param {Hasher} hasher The hash algorithm to use.
           * @param {WordArray|string} key The secret key.
           *
           * @example
           *
           *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
           */
          init: function(u, d) {
            u = this._hasher = new u.init(), typeof d == "string" && (d = s.parse(d));
            var h = u.blockSize, v = h * 4;
            d.sigBytes > v && (d = u.finalize(d)), d.clamp();
            for (var b = this._oKey = d.clone(), x = this._iKey = d.clone(), A = b.words, T = x.words, k = 0; k < h; k++)
              A[k] ^= 1549556828, T[k] ^= 909522486;
            b.sigBytes = x.sigBytes = v, this.reset();
          },
          /**
           * Resets this HMAC to its initial state.
           *
           * @example
           *
           *     hmacHasher.reset();
           */
          reset: function() {
            var u = this._hasher;
            u.reset(), u.update(this._iKey);
          },
          /**
           * Updates this HMAC with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {HMAC} This HMAC instance.
           *
           * @example
           *
           *     hmacHasher.update('message');
           *     hmacHasher.update(wordArray);
           */
          update: function(u) {
            return this._hasher.update(u), this;
          },
          /**
           * Finalizes the HMAC computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The HMAC.
           *
           * @example
           *
           *     var hmac = hmacHasher.finalize();
           *     var hmac = hmacHasher.finalize('message');
           *     var hmac = hmacHasher.finalize(wordArray);
           */
          finalize: function(u) {
            var d = this._hasher, h = d.finalize(u);
            d.reset();
            var v = d.finalize(this._oKey.clone().concat(h));
            return v;
          }
        });
      })();
    });
  }(j4)), j4.exports;
}
var W4 = { exports: {} }, D7;
function RJ() {
  return D7 || (D7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), px(), mx());
    })(Wt, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.Base, o = i.WordArray, s = n.algo, l = s.SHA256, u = s.HMAC, d = s.PBKDF2 = a.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hasher to use. Default: SHA256
           * @property {number} iterations The number of iterations to perform. Default: 250000
           */
          cfg: a.extend({
            keySize: 128 / 32,
            hasher: l,
            iterations: 25e4
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.PBKDF2.create();
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
           */
          init: function(h) {
            this.cfg = this.cfg.extend(h);
          },
          /**
           * Computes the Password-Based Key Derivation Function 2.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(h, v) {
            for (var b = this.cfg, x = u.create(b.hasher, h), A = o.create(), T = o.create([1]), k = A.words, E = T.words, C = b.keySize, D = b.iterations; k.length < C; ) {
              var _ = x.update(v).finalize(T);
              x.reset();
              for (var I = _.words, R = I.length, U = _, V = 1; V < D; V++) {
                U = x.finalize(U), x.reset();
                for (var z = U.words, j = 0; j < R; j++)
                  I[j] ^= z[j];
              }
              A.concat(_), E[0]++;
            }
            return A.sigBytes = C * 4, A;
          }
        });
        n.PBKDF2 = function(h, v, b) {
          return d.create(b).compute(h, v);
        };
      }(), r.PBKDF2;
    });
  }(W4)), W4.exports;
}
var H4 = { exports: {} }, O7;
function cu() {
  return O7 || (O7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), pk(), mx());
    })(Wt, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.Base, o = i.WordArray, s = n.algo, l = s.MD5, u = s.EvpKDF = a.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hash algorithm to use. Default: MD5
           * @property {number} iterations The number of iterations to perform. Default: 1
           */
          cfg: a.extend({
            keySize: 128 / 32,
            hasher: l,
            iterations: 1
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.EvpKDF.create();
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
           */
          init: function(d) {
            this.cfg = this.cfg.extend(d);
          },
          /**
           * Derives a key from a password.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(d, h) {
            for (var v, b = this.cfg, x = b.hasher.create(), A = o.create(), T = A.words, k = b.keySize, E = b.iterations; T.length < k; ) {
              v && x.update(v), v = x.update(d).finalize(h), x.reset();
              for (var C = 1; C < E; C++)
                v = x.finalize(v), x.reset();
              A.concat(v);
            }
            return A.sigBytes = k * 4, A;
          }
        });
        n.EvpKDF = function(d, h, v) {
          return u.create(v).compute(d, h);
        };
      }(), r.EvpKDF;
    });
  }(H4)), H4.exports;
}
var q4 = { exports: {} }, R7;
function dn() {
  return R7 || (R7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), cu());
    })(Wt, function(r) {
      r.lib.Cipher || function(n) {
        var i = r, a = i.lib, o = a.Base, s = a.WordArray, l = a.BufferedBlockAlgorithm, u = i.enc;
        u.Utf8;
        var d = u.Base64, h = i.algo, v = h.EvpKDF, b = a.Cipher = l.extend({
          /**
           * Configuration options.
           *
           * @property {WordArray} iv The IV to use for this operation.
           */
          cfg: o.extend(),
          /**
           * Creates this cipher in encryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
           */
          createEncryptor: function(z, j) {
            return this.create(this._ENC_XFORM_MODE, z, j);
          },
          /**
           * Creates this cipher in decryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
           */
          createDecryptor: function(z, j) {
            return this.create(this._DEC_XFORM_MODE, z, j);
          },
          /**
           * Initializes a newly created cipher.
           *
           * @param {number} xformMode Either the encryption or decryption transormation mode constant.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
           */
          init: function(z, j, S) {
            this.cfg = this.cfg.extend(S), this._xformMode = z, this._key = j, this.reset();
          },
          /**
           * Resets this cipher to its initial state.
           *
           * @example
           *
           *     cipher.reset();
           */
          reset: function() {
            l.reset.call(this), this._doReset();
          },
          /**
           * Adds data to be encrypted or decrypted.
           *
           * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
           *
           * @return {WordArray} The data after processing.
           *
           * @example
           *
           *     var encrypted = cipher.process('data');
           *     var encrypted = cipher.process(wordArray);
           */
          process: function(z) {
            return this._append(z), this._process();
          },
          /**
           * Finalizes the encryption or decryption process.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
           *
           * @return {WordArray} The data after final processing.
           *
           * @example
           *
           *     var encrypted = cipher.finalize();
           *     var encrypted = cipher.finalize('data');
           *     var encrypted = cipher.finalize(wordArray);
           */
          finalize: function(z) {
            z && this._append(z);
            var j = this._doFinalize();
            return j;
          },
          keySize: 128 / 32,
          ivSize: 128 / 32,
          _ENC_XFORM_MODE: 1,
          _DEC_XFORM_MODE: 2,
          /**
           * Creates shortcut functions to a cipher's object interface.
           *
           * @param {Cipher} cipher The cipher to create a helper for.
           *
           * @return {Object} An object with encrypt and decrypt shortcut functions.
           *
           * @static
           *
           * @example
           *
           *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
           */
          _createHelper: /* @__PURE__ */ function() {
            function z(j) {
              return typeof j == "string" ? V : I;
            }
            return function(j) {
              return {
                encrypt: function(S, B, q) {
                  return z(B).encrypt(j, S, B, q);
                },
                decrypt: function(S, B, q) {
                  return z(B).decrypt(j, S, B, q);
                }
              };
            };
          }()
        });
        a.StreamCipher = b.extend({
          _doFinalize: function() {
            var z = this._process(!0);
            return z;
          },
          blockSize: 1
        });
        var x = i.mode = {}, A = a.BlockCipherMode = o.extend({
          /**
           * Creates this mode for encryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
           */
          createEncryptor: function(z, j) {
            return this.Encryptor.create(z, j);
          },
          /**
           * Creates this mode for decryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
           */
          createDecryptor: function(z, j) {
            return this.Decryptor.create(z, j);
          },
          /**
           * Initializes a newly created mode.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
           */
          init: function(z, j) {
            this._cipher = z, this._iv = j;
          }
        }), T = x.CBC = function() {
          var z = A.extend();
          z.Encryptor = z.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(S, B) {
              var q = this._cipher, Y = q.blockSize;
              j.call(this, S, B, Y), q.encryptBlock(S, B), this._prevBlock = S.slice(B, B + Y);
            }
          }), z.Decryptor = z.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(S, B) {
              var q = this._cipher, Y = q.blockSize, Z = S.slice(B, B + Y);
              q.decryptBlock(S, B), j.call(this, S, B, Y), this._prevBlock = Z;
            }
          });
          function j(S, B, q) {
            var Y, Z = this._iv;
            Z ? (Y = Z, this._iv = n) : Y = this._prevBlock;
            for (var Q = 0; Q < q; Q++)
              S[B + Q] ^= Y[Q];
          }
          return z;
        }(), k = i.pad = {}, E = k.Pkcs7 = {
          /**
           * Pads data using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to pad.
           * @param {number} blockSize The multiple that the data should be padded to.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
           */
          pad: function(z, j) {
            for (var S = j * 4, B = S - z.sigBytes % S, q = B << 24 | B << 16 | B << 8 | B, Y = [], Z = 0; Z < B; Z += 4)
              Y.push(q);
            var Q = s.create(Y, B);
            z.concat(Q);
          },
          /**
           * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to unpad.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.unpad(wordArray);
           */
          unpad: function(z) {
            var j = z.words[z.sigBytes - 1 >>> 2] & 255;
            z.sigBytes -= j;
          }
        };
        a.BlockCipher = b.extend({
          /**
           * Configuration options.
           *
           * @property {Mode} mode The block mode to use. Default: CBC
           * @property {Padding} padding The padding strategy to use. Default: Pkcs7
           */
          cfg: b.cfg.extend({
            mode: T,
            padding: E
          }),
          reset: function() {
            var z;
            b.reset.call(this);
            var j = this.cfg, S = j.iv, B = j.mode;
            this._xformMode == this._ENC_XFORM_MODE ? z = B.createEncryptor : (z = B.createDecryptor, this._minBufferSize = 1), this._mode && this._mode.__creator == z ? this._mode.init(this, S && S.words) : (this._mode = z.call(B, this, S && S.words), this._mode.__creator = z);
          },
          _doProcessBlock: function(z, j) {
            this._mode.processBlock(z, j);
          },
          _doFinalize: function() {
            var z, j = this.cfg.padding;
            return this._xformMode == this._ENC_XFORM_MODE ? (j.pad(this._data, this.blockSize), z = this._process(!0)) : (z = this._process(!0), j.unpad(z)), z;
          },
          blockSize: 128 / 32
        });
        var C = a.CipherParams = o.extend({
          /**
           * Initializes a newly created cipher params object.
           *
           * @param {Object} cipherParams An object with any of the possible cipher parameters.
           *
           * @example
           *
           *     var cipherParams = CryptoJS.lib.CipherParams.create({
           *         ciphertext: ciphertextWordArray,
           *         key: keyWordArray,
           *         iv: ivWordArray,
           *         salt: saltWordArray,
           *         algorithm: CryptoJS.algo.AES,
           *         mode: CryptoJS.mode.CBC,
           *         padding: CryptoJS.pad.PKCS7,
           *         blockSize: 4,
           *         formatter: CryptoJS.format.OpenSSL
           *     });
           */
          init: function(z) {
            this.mixIn(z);
          },
          /**
           * Converts this cipher params object to a string.
           *
           * @param {Format} formatter (Optional) The formatting strategy to use.
           *
           * @return {string} The stringified cipher params.
           *
           * @throws Error If neither the formatter nor the default formatter is set.
           *
           * @example
           *
           *     var string = cipherParams + '';
           *     var string = cipherParams.toString();
           *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
           */
          toString: function(z) {
            return (z || this.formatter).stringify(this);
          }
        }), D = i.format = {}, _ = D.OpenSSL = {
          /**
           * Converts a cipher params object to an OpenSSL-compatible string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The OpenSSL-compatible string.
           *
           * @static
           *
           * @example
           *
           *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
           */
          stringify: function(z) {
            var j, S = z.ciphertext, B = z.salt;
            return B ? j = s.create([1398893684, 1701076831]).concat(B).concat(S) : j = S, j.toString(d);
          },
          /**
           * Converts an OpenSSL-compatible string to a cipher params object.
           *
           * @param {string} openSSLStr The OpenSSL-compatible string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
           */
          parse: function(z) {
            var j, S = d.parse(z), B = S.words;
            return B[0] == 1398893684 && B[1] == 1701076831 && (j = s.create(B.slice(2, 4)), B.splice(0, 4), S.sigBytes -= 16), C.create({ ciphertext: S, salt: j });
          }
        }, I = a.SerializableCipher = o.extend({
          /**
           * Configuration options.
           *
           * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
           */
          cfg: o.extend({
            format: _
          }),
          /**
           * Encrypts a message.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(z, j, S, B) {
            B = this.cfg.extend(B);
            var q = z.createEncryptor(S, B), Y = q.finalize(j), Z = q.cfg;
            return C.create({
              ciphertext: Y,
              key: S,
              iv: Z.iv,
              algorithm: z,
              mode: Z.mode,
              padding: Z.padding,
              blockSize: z.blockSize,
              formatter: B.format
            });
          },
          /**
           * Decrypts serialized ciphertext.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(z, j, S, B) {
            B = this.cfg.extend(B), j = this._parse(j, B.format);
            var q = z.createDecryptor(S, B).finalize(j.ciphertext);
            return q;
          },
          /**
           * Converts serialized ciphertext to CipherParams,
           * else assumed CipherParams already and returns ciphertext unchanged.
           *
           * @param {CipherParams|string} ciphertext The ciphertext.
           * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
           *
           * @return {CipherParams} The unserialized ciphertext.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
           */
          _parse: function(z, j) {
            return typeof z == "string" ? j.parse(z, this) : z;
          }
        }), R = i.kdf = {}, U = R.OpenSSL = {
          /**
           * Derives a key and IV from a password.
           *
           * @param {string} password The password to derive from.
           * @param {number} keySize The size in words of the key to generate.
           * @param {number} ivSize The size in words of the IV to generate.
           * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
           *
           * @return {CipherParams} A cipher params object with the key, IV, and salt.
           *
           * @static
           *
           * @example
           *
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
           */
          execute: function(z, j, S, B, q) {
            if (B || (B = s.random(64 / 8)), q)
              var Y = v.create({ keySize: j + S, hasher: q }).compute(z, B);
            else
              var Y = v.create({ keySize: j + S }).compute(z, B);
            var Z = s.create(Y.words.slice(j), S * 4);
            return Y.sigBytes = j * 4, C.create({ key: Y, iv: Z, salt: B });
          }
        }, V = a.PasswordBasedCipher = I.extend({
          /**
           * Configuration options.
           *
           * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
           */
          cfg: I.cfg.extend({
            kdf: U
          }),
          /**
           * Encrypts a message using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(z, j, S, B) {
            B = this.cfg.extend(B);
            var q = B.kdf.execute(S, z.keySize, z.ivSize, B.salt, B.hasher);
            B.iv = q.iv;
            var Y = I.encrypt.call(this, z, j, q.key, B);
            return Y.mixIn(q), Y;
          },
          /**
           * Decrypts serialized ciphertext using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(z, j, S, B) {
            B = this.cfg.extend(B), j = this._parse(j, B.format);
            var q = B.kdf.execute(S, z.keySize, z.ivSize, j.salt, B.hasher);
            B.iv = q.iv;
            var Y = I.decrypt.call(this, z, j, q.key, B);
            return Y;
          }
        });
      }();
    });
  }(q4)), q4.exports;
}
var Y4 = { exports: {} }, P7;
function PJ() {
  return P7 || (P7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), dn());
    })(Wt, function(r) {
      return r.mode.CFB = function() {
        var n = r.lib.BlockCipherMode.extend();
        n.Encryptor = n.extend({
          processBlock: function(a, o) {
            var s = this._cipher, l = s.blockSize;
            i.call(this, a, o, l, s), this._prevBlock = a.slice(o, o + l);
          }
        }), n.Decryptor = n.extend({
          processBlock: function(a, o) {
            var s = this._cipher, l = s.blockSize, u = a.slice(o, o + l);
            i.call(this, a, o, l, s), this._prevBlock = u;
          }
        });
        function i(a, o, s, l) {
          var u, d = this._iv;
          d ? (u = d.slice(0), this._iv = void 0) : u = this._prevBlock, l.encryptBlock(u, 0);
          for (var h = 0; h < s; h++)
            a[o + h] ^= u[h];
        }
        return n;
      }(), r.mode.CFB;
    });
  }(Y4)), Y4.exports;
}
var G4 = { exports: {} }, I7;
function IJ() {
  return I7 || (I7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), dn());
    })(Wt, function(r) {
      return r.mode.CTR = function() {
        var n = r.lib.BlockCipherMode.extend(), i = n.Encryptor = n.extend({
          processBlock: function(a, o) {
            var s = this._cipher, l = s.blockSize, u = this._iv, d = this._counter;
            u && (d = this._counter = u.slice(0), this._iv = void 0);
            var h = d.slice(0);
            s.encryptBlock(h, 0), d[l - 1] = d[l - 1] + 1 | 0;
            for (var v = 0; v < l; v++)
              a[o + v] ^= h[v];
          }
        });
        return n.Decryptor = i, n;
      }(), r.mode.CTR;
    });
  }(G4)), G4.exports;
}
var Z4 = { exports: {} }, B7;
function BJ() {
  return B7 || (B7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), dn());
    })(Wt, function(r) {
      /** @preserve
       * Counter block mode compatible with  Dr Brian Gladman fileenc.c
       * derived from CryptoJS.mode.CTR
       * Jan Hruby jhruby.web@gmail.com
       */
      return r.mode.CTRGladman = function() {
        var n = r.lib.BlockCipherMode.extend();
        function i(s) {
          if ((s >> 24 & 255) === 255) {
            var l = s >> 16 & 255, u = s >> 8 & 255, d = s & 255;
            l === 255 ? (l = 0, u === 255 ? (u = 0, d === 255 ? d = 0 : ++d) : ++u) : ++l, s = 0, s += l << 16, s += u << 8, s += d;
          } else
            s += 1 << 24;
          return s;
        }
        function a(s) {
          return (s[0] = i(s[0])) === 0 && (s[1] = i(s[1])), s;
        }
        var o = n.Encryptor = n.extend({
          processBlock: function(s, l) {
            var u = this._cipher, d = u.blockSize, h = this._iv, v = this._counter;
            h && (v = this._counter = h.slice(0), this._iv = void 0), a(v);
            var b = v.slice(0);
            u.encryptBlock(b, 0);
            for (var x = 0; x < d; x++)
              s[l + x] ^= b[x];
          }
        });
        return n.Decryptor = o, n;
      }(), r.mode.CTRGladman;
    });
  }(Z4)), Z4.exports;
}
var X4 = { exports: {} }, L7;
function LJ() {
  return L7 || (L7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), dn());
    })(Wt, function(r) {
      return r.mode.OFB = function() {
        var n = r.lib.BlockCipherMode.extend(), i = n.Encryptor = n.extend({
          processBlock: function(a, o) {
            var s = this._cipher, l = s.blockSize, u = this._iv, d = this._keystream;
            u && (d = this._keystream = u.slice(0), this._iv = void 0), s.encryptBlock(d, 0);
            for (var h = 0; h < l; h++)
              a[o + h] ^= d[h];
          }
        });
        return n.Decryptor = i, n;
      }(), r.mode.OFB;
    });
  }(X4)), X4.exports;
}
var K4 = { exports: {} }, N7;
function NJ() {
  return N7 || (N7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), dn());
    })(Wt, function(r) {
      return r.mode.ECB = function() {
        var n = r.lib.BlockCipherMode.extend();
        return n.Encryptor = n.extend({
          processBlock: function(i, a) {
            this._cipher.encryptBlock(i, a);
          }
        }), n.Decryptor = n.extend({
          processBlock: function(i, a) {
            this._cipher.decryptBlock(i, a);
          }
        }), n;
      }(), r.mode.ECB;
    });
  }(K4)), K4.exports;
}
var J4 = { exports: {} }, M7;
function MJ() {
  return M7 || (M7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), dn());
    })(Wt, function(r) {
      return r.pad.AnsiX923 = {
        pad: function(n, i) {
          var a = n.sigBytes, o = i * 4, s = o - a % o, l = a + s - 1;
          n.clamp(), n.words[l >>> 2] |= s << 24 - l % 4 * 8, n.sigBytes += s;
        },
        unpad: function(n) {
          var i = n.words[n.sigBytes - 1 >>> 2] & 255;
          n.sigBytes -= i;
        }
      }, r.pad.Ansix923;
    });
  }(J4)), J4.exports;
}
var Q4 = { exports: {} }, U7;
function UJ() {
  return U7 || (U7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), dn());
    })(Wt, function(r) {
      return r.pad.Iso10126 = {
        pad: function(n, i) {
          var a = i * 4, o = a - n.sigBytes % a;
          n.concat(r.lib.WordArray.random(o - 1)).concat(r.lib.WordArray.create([o << 24], 1));
        },
        unpad: function(n) {
          var i = n.words[n.sigBytes - 1 >>> 2] & 255;
          n.sigBytes -= i;
        }
      }, r.pad.Iso10126;
    });
  }(Q4)), Q4.exports;
}
var ev = { exports: {} }, z7;
function zJ() {
  return z7 || (z7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), dn());
    })(Wt, function(r) {
      return r.pad.Iso97971 = {
        pad: function(n, i) {
          n.concat(r.lib.WordArray.create([2147483648], 1)), r.pad.ZeroPadding.pad(n, i);
        },
        unpad: function(n) {
          r.pad.ZeroPadding.unpad(n), n.sigBytes--;
        }
      }, r.pad.Iso97971;
    });
  }(ev)), ev.exports;
}
var tv = { exports: {} }, $7;
function $J() {
  return $7 || ($7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), dn());
    })(Wt, function(r) {
      return r.pad.ZeroPadding = {
        pad: function(n, i) {
          var a = i * 4;
          n.clamp(), n.sigBytes += a - (n.sigBytes % a || a);
        },
        unpad: function(n) {
          for (var i = n.words, a = n.sigBytes - 1, a = n.sigBytes - 1; a >= 0; a--)
            if (i[a >>> 2] >>> 24 - a % 4 * 8 & 255) {
              n.sigBytes = a + 1;
              break;
            }
        }
      }, r.pad.ZeroPadding;
    });
  }(tv)), tv.exports;
}
var rv = { exports: {} }, V7;
function VJ() {
  return V7 || (V7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), dn());
    })(Wt, function(r) {
      return r.pad.NoPadding = {
        pad: function() {
        },
        unpad: function() {
        }
      }, r.pad.NoPadding;
    });
  }(rv)), rv.exports;
}
var nv = { exports: {} }, j7;
function jJ() {
  return j7 || (j7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), dn());
    })(Wt, function(r) {
      return function(n) {
        var i = r, a = i.lib, o = a.CipherParams, s = i.enc, l = s.Hex, u = i.format;
        u.Hex = {
          /**
           * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The hexadecimally encoded string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
           */
          stringify: function(d) {
            return d.ciphertext.toString(l);
          },
          /**
           * Converts a hexadecimally encoded ciphertext string to a cipher params object.
           *
           * @param {string} input The hexadecimally encoded string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
           */
          parse: function(d) {
            var h = l.parse(d);
            return o.create({ ciphertext: h });
          }
        };
      }(), r.format.Hex;
    });
  }(nv)), nv.exports;
}
var iv = { exports: {} }, W7;
function WJ() {
  return W7 || (W7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), Bc(), uu, cu(), dn());
    })(Wt, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.BlockCipher, o = n.algo, s = [], l = [], u = [], d = [], h = [], v = [], b = [], x = [], A = [], T = [];
        (function() {
          for (var C = [], D = 0; D < 256; D++)
            D < 128 ? C[D] = D << 1 : C[D] = D << 1 ^ 283;
          for (var _ = 0, I = 0, D = 0; D < 256; D++) {
            var R = I ^ I << 1 ^ I << 2 ^ I << 3 ^ I << 4;
            R = R >>> 8 ^ R & 255 ^ 99, s[_] = R, l[R] = _;
            var U = C[_], V = C[U], z = C[V], j = C[R] * 257 ^ R * 16843008;
            u[_] = j << 24 | j >>> 8, d[_] = j << 16 | j >>> 16, h[_] = j << 8 | j >>> 24, v[_] = j;
            var j = z * 16843009 ^ V * 65537 ^ U * 257 ^ _ * 16843008;
            b[R] = j << 24 | j >>> 8, x[R] = j << 16 | j >>> 16, A[R] = j << 8 | j >>> 24, T[R] = j, _ ? (_ = U ^ C[C[C[z ^ U]]], I ^= C[C[I]]) : _ = I = 1;
          }
        })();
        var k = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], E = o.AES = a.extend({
          _doReset: function() {
            var C;
            if (!(this._nRounds && this._keyPriorReset === this._key)) {
              for (var D = this._keyPriorReset = this._key, _ = D.words, I = D.sigBytes / 4, R = this._nRounds = I + 6, U = (R + 1) * 4, V = this._keySchedule = [], z = 0; z < U; z++)
                z < I ? V[z] = _[z] : (C = V[z - 1], z % I ? I > 6 && z % I == 4 && (C = s[C >>> 24] << 24 | s[C >>> 16 & 255] << 16 | s[C >>> 8 & 255] << 8 | s[C & 255]) : (C = C << 8 | C >>> 24, C = s[C >>> 24] << 24 | s[C >>> 16 & 255] << 16 | s[C >>> 8 & 255] << 8 | s[C & 255], C ^= k[z / I | 0] << 24), V[z] = V[z - I] ^ C);
              for (var j = this._invKeySchedule = [], S = 0; S < U; S++) {
                var z = U - S;
                if (S % 4)
                  var C = V[z];
                else
                  var C = V[z - 4];
                S < 4 || z <= 4 ? j[S] = C : j[S] = b[s[C >>> 24]] ^ x[s[C >>> 16 & 255]] ^ A[s[C >>> 8 & 255]] ^ T[s[C & 255]];
              }
            }
          },
          encryptBlock: function(C, D) {
            this._doCryptBlock(C, D, this._keySchedule, u, d, h, v, s);
          },
          decryptBlock: function(C, D) {
            var _ = C[D + 1];
            C[D + 1] = C[D + 3], C[D + 3] = _, this._doCryptBlock(C, D, this._invKeySchedule, b, x, A, T, l);
            var _ = C[D + 1];
            C[D + 1] = C[D + 3], C[D + 3] = _;
          },
          _doCryptBlock: function(C, D, _, I, R, U, V, z) {
            for (var j = this._nRounds, S = C[D] ^ _[0], B = C[D + 1] ^ _[1], q = C[D + 2] ^ _[2], Y = C[D + 3] ^ _[3], Z = 4, Q = 1; Q < j; Q++) {
              var J = I[S >>> 24] ^ R[B >>> 16 & 255] ^ U[q >>> 8 & 255] ^ V[Y & 255] ^ _[Z++], se = I[B >>> 24] ^ R[q >>> 16 & 255] ^ U[Y >>> 8 & 255] ^ V[S & 255] ^ _[Z++], ae = I[q >>> 24] ^ R[Y >>> 16 & 255] ^ U[S >>> 8 & 255] ^ V[B & 255] ^ _[Z++], te = I[Y >>> 24] ^ R[S >>> 16 & 255] ^ U[B >>> 8 & 255] ^ V[q & 255] ^ _[Z++];
              S = J, B = se, q = ae, Y = te;
            }
            var J = (z[S >>> 24] << 24 | z[B >>> 16 & 255] << 16 | z[q >>> 8 & 255] << 8 | z[Y & 255]) ^ _[Z++], se = (z[B >>> 24] << 24 | z[q >>> 16 & 255] << 16 | z[Y >>> 8 & 255] << 8 | z[S & 255]) ^ _[Z++], ae = (z[q >>> 24] << 24 | z[Y >>> 16 & 255] << 16 | z[S >>> 8 & 255] << 8 | z[B & 255]) ^ _[Z++], te = (z[Y >>> 24] << 24 | z[S >>> 16 & 255] << 16 | z[B >>> 8 & 255] << 8 | z[q & 255]) ^ _[Z++];
            C[D] = J, C[D + 1] = se, C[D + 2] = ae, C[D + 3] = te;
          },
          keySize: 256 / 32
        });
        n.AES = a._createHelper(E);
      }(), r.AES;
    });
  }(iv)), iv.exports;
}
var av = { exports: {} }, H7;
function HJ() {
  return H7 || (H7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), Bc(), uu, cu(), dn());
    })(Wt, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.WordArray, o = i.BlockCipher, s = n.algo, l = [
          57,
          49,
          41,
          33,
          25,
          17,
          9,
          1,
          58,
          50,
          42,
          34,
          26,
          18,
          10,
          2,
          59,
          51,
          43,
          35,
          27,
          19,
          11,
          3,
          60,
          52,
          44,
          36,
          63,
          55,
          47,
          39,
          31,
          23,
          15,
          7,
          62,
          54,
          46,
          38,
          30,
          22,
          14,
          6,
          61,
          53,
          45,
          37,
          29,
          21,
          13,
          5,
          28,
          20,
          12,
          4
        ], u = [
          14,
          17,
          11,
          24,
          1,
          5,
          3,
          28,
          15,
          6,
          21,
          10,
          23,
          19,
          12,
          4,
          26,
          8,
          16,
          7,
          27,
          20,
          13,
          2,
          41,
          52,
          31,
          37,
          47,
          55,
          30,
          40,
          51,
          45,
          33,
          48,
          44,
          49,
          39,
          56,
          34,
          53,
          46,
          42,
          50,
          36,
          29,
          32
        ], d = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28], h = [
          {
            0: 8421888,
            268435456: 32768,
            536870912: 8421378,
            805306368: 2,
            1073741824: 512,
            1342177280: 8421890,
            1610612736: 8389122,
            1879048192: 8388608,
            2147483648: 514,
            2415919104: 8389120,
            2684354560: 33280,
            2952790016: 8421376,
            3221225472: 32770,
            3489660928: 8388610,
            3758096384: 0,
            4026531840: 33282,
            134217728: 0,
            402653184: 8421890,
            671088640: 33282,
            939524096: 32768,
            1207959552: 8421888,
            1476395008: 512,
            1744830464: 8421378,
            2013265920: 2,
            2281701376: 8389120,
            2550136832: 33280,
            2818572288: 8421376,
            3087007744: 8389122,
            3355443200: 8388610,
            3623878656: 32770,
            3892314112: 514,
            4160749568: 8388608,
            1: 32768,
            268435457: 2,
            536870913: 8421888,
            805306369: 8388608,
            1073741825: 8421378,
            1342177281: 33280,
            1610612737: 512,
            1879048193: 8389122,
            2147483649: 8421890,
            2415919105: 8421376,
            2684354561: 8388610,
            2952790017: 33282,
            3221225473: 514,
            3489660929: 8389120,
            3758096385: 32770,
            4026531841: 0,
            134217729: 8421890,
            402653185: 8421376,
            671088641: 8388608,
            939524097: 512,
            1207959553: 32768,
            1476395009: 8388610,
            1744830465: 2,
            2013265921: 33282,
            2281701377: 32770,
            2550136833: 8389122,
            2818572289: 514,
            3087007745: 8421888,
            3355443201: 8389120,
            3623878657: 0,
            3892314113: 33280,
            4160749569: 8421378
          },
          {
            0: 1074282512,
            16777216: 16384,
            33554432: 524288,
            50331648: 1074266128,
            67108864: 1073741840,
            83886080: 1074282496,
            100663296: 1073758208,
            117440512: 16,
            134217728: 540672,
            150994944: 1073758224,
            167772160: 1073741824,
            184549376: 540688,
            201326592: 524304,
            218103808: 0,
            234881024: 16400,
            251658240: 1074266112,
            8388608: 1073758208,
            25165824: 540688,
            41943040: 16,
            58720256: 1073758224,
            75497472: 1074282512,
            92274688: 1073741824,
            109051904: 524288,
            125829120: 1074266128,
            142606336: 524304,
            159383552: 0,
            176160768: 16384,
            192937984: 1074266112,
            209715200: 1073741840,
            226492416: 540672,
            243269632: 1074282496,
            260046848: 16400,
            268435456: 0,
            285212672: 1074266128,
            301989888: 1073758224,
            318767104: 1074282496,
            335544320: 1074266112,
            352321536: 16,
            369098752: 540688,
            385875968: 16384,
            402653184: 16400,
            419430400: 524288,
            436207616: 524304,
            452984832: 1073741840,
            469762048: 540672,
            486539264: 1073758208,
            503316480: 1073741824,
            520093696: 1074282512,
            276824064: 540688,
            293601280: 524288,
            310378496: 1074266112,
            327155712: 16384,
            343932928: 1073758208,
            360710144: 1074282512,
            377487360: 16,
            394264576: 1073741824,
            411041792: 1074282496,
            427819008: 1073741840,
            444596224: 1073758224,
            461373440: 524304,
            478150656: 0,
            494927872: 16400,
            511705088: 1074266128,
            528482304: 540672
          },
          {
            0: 260,
            1048576: 0,
            2097152: 67109120,
            3145728: 65796,
            4194304: 65540,
            5242880: 67108868,
            6291456: 67174660,
            7340032: 67174400,
            8388608: 67108864,
            9437184: 67174656,
            10485760: 65792,
            11534336: 67174404,
            12582912: 67109124,
            13631488: 65536,
            14680064: 4,
            15728640: 256,
            524288: 67174656,
            1572864: 67174404,
            2621440: 0,
            3670016: 67109120,
            4718592: 67108868,
            5767168: 65536,
            6815744: 65540,
            7864320: 260,
            8912896: 4,
            9961472: 256,
            11010048: 67174400,
            12058624: 65796,
            13107200: 65792,
            14155776: 67109124,
            15204352: 67174660,
            16252928: 67108864,
            16777216: 67174656,
            17825792: 65540,
            18874368: 65536,
            19922944: 67109120,
            20971520: 256,
            22020096: 67174660,
            23068672: 67108868,
            24117248: 0,
            25165824: 67109124,
            26214400: 67108864,
            27262976: 4,
            28311552: 65792,
            29360128: 67174400,
            30408704: 260,
            31457280: 65796,
            32505856: 67174404,
            17301504: 67108864,
            18350080: 260,
            19398656: 67174656,
            20447232: 0,
            21495808: 65540,
            22544384: 67109120,
            23592960: 256,
            24641536: 67174404,
            25690112: 65536,
            26738688: 67174660,
            27787264: 65796,
            28835840: 67108868,
            29884416: 67109124,
            30932992: 67174400,
            31981568: 4,
            33030144: 65792
          },
          {
            0: 2151682048,
            65536: 2147487808,
            131072: 4198464,
            196608: 2151677952,
            262144: 0,
            327680: 4198400,
            393216: 2147483712,
            458752: 4194368,
            524288: 2147483648,
            589824: 4194304,
            655360: 64,
            720896: 2147487744,
            786432: 2151678016,
            851968: 4160,
            917504: 4096,
            983040: 2151682112,
            32768: 2147487808,
            98304: 64,
            163840: 2151678016,
            229376: 2147487744,
            294912: 4198400,
            360448: 2151682112,
            425984: 0,
            491520: 2151677952,
            557056: 4096,
            622592: 2151682048,
            688128: 4194304,
            753664: 4160,
            819200: 2147483648,
            884736: 4194368,
            950272: 4198464,
            1015808: 2147483712,
            1048576: 4194368,
            1114112: 4198400,
            1179648: 2147483712,
            1245184: 0,
            1310720: 4160,
            1376256: 2151678016,
            1441792: 2151682048,
            1507328: 2147487808,
            1572864: 2151682112,
            1638400: 2147483648,
            1703936: 2151677952,
            1769472: 4198464,
            1835008: 2147487744,
            1900544: 4194304,
            1966080: 64,
            2031616: 4096,
            1081344: 2151677952,
            1146880: 2151682112,
            1212416: 0,
            1277952: 4198400,
            1343488: 4194368,
            1409024: 2147483648,
            1474560: 2147487808,
            1540096: 64,
            1605632: 2147483712,
            1671168: 4096,
            1736704: 2147487744,
            1802240: 2151678016,
            1867776: 4160,
            1933312: 2151682048,
            1998848: 4194304,
            2064384: 4198464
          },
          {
            0: 128,
            4096: 17039360,
            8192: 262144,
            12288: 536870912,
            16384: 537133184,
            20480: 16777344,
            24576: 553648256,
            28672: 262272,
            32768: 16777216,
            36864: 537133056,
            40960: 536871040,
            45056: 553910400,
            49152: 553910272,
            53248: 0,
            57344: 17039488,
            61440: 553648128,
            2048: 17039488,
            6144: 553648256,
            10240: 128,
            14336: 17039360,
            18432: 262144,
            22528: 537133184,
            26624: 553910272,
            30720: 536870912,
            34816: 537133056,
            38912: 0,
            43008: 553910400,
            47104: 16777344,
            51200: 536871040,
            55296: 553648128,
            59392: 16777216,
            63488: 262272,
            65536: 262144,
            69632: 128,
            73728: 536870912,
            77824: 553648256,
            81920: 16777344,
            86016: 553910272,
            90112: 537133184,
            94208: 16777216,
            98304: 553910400,
            102400: 553648128,
            106496: 17039360,
            110592: 537133056,
            114688: 262272,
            118784: 536871040,
            122880: 0,
            126976: 17039488,
            67584: 553648256,
            71680: 16777216,
            75776: 17039360,
            79872: 537133184,
            83968: 536870912,
            88064: 17039488,
            92160: 128,
            96256: 553910272,
            100352: 262272,
            104448: 553910400,
            108544: 0,
            112640: 553648128,
            116736: 16777344,
            120832: 262144,
            124928: 537133056,
            129024: 536871040
          },
          {
            0: 268435464,
            256: 8192,
            512: 270532608,
            768: 270540808,
            1024: 268443648,
            1280: 2097152,
            1536: 2097160,
            1792: 268435456,
            2048: 0,
            2304: 268443656,
            2560: 2105344,
            2816: 8,
            3072: 270532616,
            3328: 2105352,
            3584: 8200,
            3840: 270540800,
            128: 270532608,
            384: 270540808,
            640: 8,
            896: 2097152,
            1152: 2105352,
            1408: 268435464,
            1664: 268443648,
            1920: 8200,
            2176: 2097160,
            2432: 8192,
            2688: 268443656,
            2944: 270532616,
            3200: 0,
            3456: 270540800,
            3712: 2105344,
            3968: 268435456,
            4096: 268443648,
            4352: 270532616,
            4608: 270540808,
            4864: 8200,
            5120: 2097152,
            5376: 268435456,
            5632: 268435464,
            5888: 2105344,
            6144: 2105352,
            6400: 0,
            6656: 8,
            6912: 270532608,
            7168: 8192,
            7424: 268443656,
            7680: 270540800,
            7936: 2097160,
            4224: 8,
            4480: 2105344,
            4736: 2097152,
            4992: 268435464,
            5248: 268443648,
            5504: 8200,
            5760: 270540808,
            6016: 270532608,
            6272: 270540800,
            6528: 270532616,
            6784: 8192,
            7040: 2105352,
            7296: 2097160,
            7552: 0,
            7808: 268435456,
            8064: 268443656
          },
          {
            0: 1048576,
            16: 33555457,
            32: 1024,
            48: 1049601,
            64: 34604033,
            80: 0,
            96: 1,
            112: 34603009,
            128: 33555456,
            144: 1048577,
            160: 33554433,
            176: 34604032,
            192: 34603008,
            208: 1025,
            224: 1049600,
            240: 33554432,
            8: 34603009,
            24: 0,
            40: 33555457,
            56: 34604032,
            72: 1048576,
            88: 33554433,
            104: 33554432,
            120: 1025,
            136: 1049601,
            152: 33555456,
            168: 34603008,
            184: 1048577,
            200: 1024,
            216: 34604033,
            232: 1,
            248: 1049600,
            256: 33554432,
            272: 1048576,
            288: 33555457,
            304: 34603009,
            320: 1048577,
            336: 33555456,
            352: 34604032,
            368: 1049601,
            384: 1025,
            400: 34604033,
            416: 1049600,
            432: 1,
            448: 0,
            464: 34603008,
            480: 33554433,
            496: 1024,
            264: 1049600,
            280: 33555457,
            296: 34603009,
            312: 1,
            328: 33554432,
            344: 1048576,
            360: 1025,
            376: 34604032,
            392: 33554433,
            408: 34603008,
            424: 0,
            440: 34604033,
            456: 1049601,
            472: 1024,
            488: 33555456,
            504: 1048577
          },
          {
            0: 134219808,
            1: 131072,
            2: 134217728,
            3: 32,
            4: 131104,
            5: 134350880,
            6: 134350848,
            7: 2048,
            8: 134348800,
            9: 134219776,
            10: 133120,
            11: 134348832,
            12: 2080,
            13: 0,
            14: 134217760,
            15: 133152,
            2147483648: 2048,
            2147483649: 134350880,
            2147483650: 134219808,
            2147483651: 134217728,
            2147483652: 134348800,
            2147483653: 133120,
            2147483654: 133152,
            2147483655: 32,
            2147483656: 134217760,
            2147483657: 2080,
            2147483658: 131104,
            2147483659: 134350848,
            2147483660: 0,
            2147483661: 134348832,
            2147483662: 134219776,
            2147483663: 131072,
            16: 133152,
            17: 134350848,
            18: 32,
            19: 2048,
            20: 134219776,
            21: 134217760,
            22: 134348832,
            23: 131072,
            24: 0,
            25: 131104,
            26: 134348800,
            27: 134219808,
            28: 134350880,
            29: 133120,
            30: 2080,
            31: 134217728,
            2147483664: 131072,
            2147483665: 2048,
            2147483666: 134348832,
            2147483667: 133152,
            2147483668: 32,
            2147483669: 134348800,
            2147483670: 134217728,
            2147483671: 134219808,
            2147483672: 134350880,
            2147483673: 134217760,
            2147483674: 134219776,
            2147483675: 0,
            2147483676: 133120,
            2147483677: 2080,
            2147483678: 131104,
            2147483679: 134350848
          }
        ], v = [
          4160749569,
          528482304,
          33030144,
          2064384,
          129024,
          8064,
          504,
          2147483679
        ], b = s.DES = o.extend({
          _doReset: function() {
            for (var k = this._key, E = k.words, C = [], D = 0; D < 56; D++) {
              var _ = l[D] - 1;
              C[D] = E[_ >>> 5] >>> 31 - _ % 32 & 1;
            }
            for (var I = this._subKeys = [], R = 0; R < 16; R++) {
              for (var U = I[R] = [], V = d[R], D = 0; D < 24; D++)
                U[D / 6 | 0] |= C[(u[D] - 1 + V) % 28] << 31 - D % 6, U[4 + (D / 6 | 0)] |= C[28 + (u[D + 24] - 1 + V) % 28] << 31 - D % 6;
              U[0] = U[0] << 1 | U[0] >>> 31;
              for (var D = 1; D < 7; D++)
                U[D] = U[D] >>> (D - 1) * 4 + 3;
              U[7] = U[7] << 5 | U[7] >>> 27;
            }
            for (var z = this._invSubKeys = [], D = 0; D < 16; D++)
              z[D] = I[15 - D];
          },
          encryptBlock: function(k, E) {
            this._doCryptBlock(k, E, this._subKeys);
          },
          decryptBlock: function(k, E) {
            this._doCryptBlock(k, E, this._invSubKeys);
          },
          _doCryptBlock: function(k, E, C) {
            this._lBlock = k[E], this._rBlock = k[E + 1], x.call(this, 4, 252645135), x.call(this, 16, 65535), A.call(this, 2, 858993459), A.call(this, 8, 16711935), x.call(this, 1, 1431655765);
            for (var D = 0; D < 16; D++) {
              for (var _ = C[D], I = this._lBlock, R = this._rBlock, U = 0, V = 0; V < 8; V++)
                U |= h[V][((R ^ _[V]) & v[V]) >>> 0];
              this._lBlock = R, this._rBlock = I ^ U;
            }
            var z = this._lBlock;
            this._lBlock = this._rBlock, this._rBlock = z, x.call(this, 1, 1431655765), A.call(this, 8, 16711935), A.call(this, 2, 858993459), x.call(this, 16, 65535), x.call(this, 4, 252645135), k[E] = this._lBlock, k[E + 1] = this._rBlock;
          },
          keySize: 64 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        function x(k, E) {
          var C = (this._lBlock >>> k ^ this._rBlock) & E;
          this._rBlock ^= C, this._lBlock ^= C << k;
        }
        function A(k, E) {
          var C = (this._rBlock >>> k ^ this._lBlock) & E;
          this._lBlock ^= C, this._rBlock ^= C << k;
        }
        n.DES = o._createHelper(b);
        var T = s.TripleDES = o.extend({
          _doReset: function() {
            var k = this._key, E = k.words;
            if (E.length !== 2 && E.length !== 4 && E.length < 6)
              throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
            var C = E.slice(0, 2), D = E.length < 4 ? E.slice(0, 2) : E.slice(2, 4), _ = E.length < 6 ? E.slice(0, 2) : E.slice(4, 6);
            this._des1 = b.createEncryptor(a.create(C)), this._des2 = b.createEncryptor(a.create(D)), this._des3 = b.createEncryptor(a.create(_));
          },
          encryptBlock: function(k, E) {
            this._des1.encryptBlock(k, E), this._des2.decryptBlock(k, E), this._des3.encryptBlock(k, E);
          },
          decryptBlock: function(k, E) {
            this._des3.decryptBlock(k, E), this._des2.encryptBlock(k, E), this._des1.decryptBlock(k, E);
          },
          keySize: 192 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        n.TripleDES = o._createHelper(T);
      }(), r.TripleDES;
    });
  }(av)), av.exports;
}
var ov = { exports: {} }, q7;
function qJ() {
  return q7 || (q7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), Bc(), uu, cu(), dn());
    })(Wt, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.StreamCipher, o = n.algo, s = o.RC4 = a.extend({
          _doReset: function() {
            for (var d = this._key, h = d.words, v = d.sigBytes, b = this._S = [], x = 0; x < 256; x++)
              b[x] = x;
            for (var x = 0, A = 0; x < 256; x++) {
              var T = x % v, k = h[T >>> 2] >>> 24 - T % 4 * 8 & 255;
              A = (A + b[x] + k) % 256;
              var E = b[x];
              b[x] = b[A], b[A] = E;
            }
            this._i = this._j = 0;
          },
          _doProcessBlock: function(d, h) {
            d[h] ^= l.call(this);
          },
          keySize: 256 / 32,
          ivSize: 0
        });
        function l() {
          for (var d = this._S, h = this._i, v = this._j, b = 0, x = 0; x < 4; x++) {
            h = (h + 1) % 256, v = (v + d[h]) % 256;
            var A = d[h];
            d[h] = d[v], d[v] = A, b |= d[(d[h] + d[v]) % 256] << 24 - x * 8;
          }
          return this._i = h, this._j = v, b;
        }
        n.RC4 = a._createHelper(s);
        var u = o.RC4Drop = s.extend({
          /**
           * Configuration options.
           *
           * @property {number} drop The number of keystream words to drop. Default 192
           */
          cfg: s.cfg.extend({
            drop: 192
          }),
          _doReset: function() {
            s._doReset.call(this);
            for (var d = this.cfg.drop; d > 0; d--)
              l.call(this);
          }
        });
        n.RC4Drop = a._createHelper(u);
      }(), r.RC4;
    });
  }(ov)), ov.exports;
}
var sv = { exports: {} }, Y7;
function YJ() {
  return Y7 || (Y7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), Bc(), uu, cu(), dn());
    })(Wt, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.StreamCipher, o = n.algo, s = [], l = [], u = [], d = o.Rabbit = a.extend({
          _doReset: function() {
            for (var v = this._key.words, b = this.cfg.iv, x = 0; x < 4; x++)
              v[x] = (v[x] << 8 | v[x] >>> 24) & 16711935 | (v[x] << 24 | v[x] >>> 8) & 4278255360;
            var A = this._X = [
              v[0],
              v[3] << 16 | v[2] >>> 16,
              v[1],
              v[0] << 16 | v[3] >>> 16,
              v[2],
              v[1] << 16 | v[0] >>> 16,
              v[3],
              v[2] << 16 | v[1] >>> 16
            ], T = this._C = [
              v[2] << 16 | v[2] >>> 16,
              v[0] & 4294901760 | v[1] & 65535,
              v[3] << 16 | v[3] >>> 16,
              v[1] & 4294901760 | v[2] & 65535,
              v[0] << 16 | v[0] >>> 16,
              v[2] & 4294901760 | v[3] & 65535,
              v[1] << 16 | v[1] >>> 16,
              v[3] & 4294901760 | v[0] & 65535
            ];
            this._b = 0;
            for (var x = 0; x < 4; x++)
              h.call(this);
            for (var x = 0; x < 8; x++)
              T[x] ^= A[x + 4 & 7];
            if (b) {
              var k = b.words, E = k[0], C = k[1], D = (E << 8 | E >>> 24) & 16711935 | (E << 24 | E >>> 8) & 4278255360, _ = (C << 8 | C >>> 24) & 16711935 | (C << 24 | C >>> 8) & 4278255360, I = D >>> 16 | _ & 4294901760, R = _ << 16 | D & 65535;
              T[0] ^= D, T[1] ^= I, T[2] ^= _, T[3] ^= R, T[4] ^= D, T[5] ^= I, T[6] ^= _, T[7] ^= R;
              for (var x = 0; x < 4; x++)
                h.call(this);
            }
          },
          _doProcessBlock: function(v, b) {
            var x = this._X;
            h.call(this), s[0] = x[0] ^ x[5] >>> 16 ^ x[3] << 16, s[1] = x[2] ^ x[7] >>> 16 ^ x[5] << 16, s[2] = x[4] ^ x[1] >>> 16 ^ x[7] << 16, s[3] = x[6] ^ x[3] >>> 16 ^ x[1] << 16;
            for (var A = 0; A < 4; A++)
              s[A] = (s[A] << 8 | s[A] >>> 24) & 16711935 | (s[A] << 24 | s[A] >>> 8) & 4278255360, v[b + A] ^= s[A];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function h() {
          for (var v = this._X, b = this._C, x = 0; x < 8; x++)
            l[x] = b[x];
          b[0] = b[0] + 1295307597 + this._b | 0, b[1] = b[1] + 3545052371 + (b[0] >>> 0 < l[0] >>> 0 ? 1 : 0) | 0, b[2] = b[2] + 886263092 + (b[1] >>> 0 < l[1] >>> 0 ? 1 : 0) | 0, b[3] = b[3] + 1295307597 + (b[2] >>> 0 < l[2] >>> 0 ? 1 : 0) | 0, b[4] = b[4] + 3545052371 + (b[3] >>> 0 < l[3] >>> 0 ? 1 : 0) | 0, b[5] = b[5] + 886263092 + (b[4] >>> 0 < l[4] >>> 0 ? 1 : 0) | 0, b[6] = b[6] + 1295307597 + (b[5] >>> 0 < l[5] >>> 0 ? 1 : 0) | 0, b[7] = b[7] + 3545052371 + (b[6] >>> 0 < l[6] >>> 0 ? 1 : 0) | 0, this._b = b[7] >>> 0 < l[7] >>> 0 ? 1 : 0;
          for (var x = 0; x < 8; x++) {
            var A = v[x] + b[x], T = A & 65535, k = A >>> 16, E = ((T * T >>> 17) + T * k >>> 15) + k * k, C = ((A & 4294901760) * A | 0) + ((A & 65535) * A | 0);
            u[x] = E ^ C;
          }
          v[0] = u[0] + (u[7] << 16 | u[7] >>> 16) + (u[6] << 16 | u[6] >>> 16) | 0, v[1] = u[1] + (u[0] << 8 | u[0] >>> 24) + u[7] | 0, v[2] = u[2] + (u[1] << 16 | u[1] >>> 16) + (u[0] << 16 | u[0] >>> 16) | 0, v[3] = u[3] + (u[2] << 8 | u[2] >>> 24) + u[1] | 0, v[4] = u[4] + (u[3] << 16 | u[3] >>> 16) + (u[2] << 16 | u[2] >>> 16) | 0, v[5] = u[5] + (u[4] << 8 | u[4] >>> 24) + u[3] | 0, v[6] = u[6] + (u[5] << 16 | u[5] >>> 16) + (u[4] << 16 | u[4] >>> 16) | 0, v[7] = u[7] + (u[6] << 8 | u[6] >>> 24) + u[5] | 0;
        }
        n.Rabbit = a._createHelper(d);
      }(), r.Rabbit;
    });
  }(sv)), sv.exports;
}
var lv = { exports: {} }, G7;
function GJ() {
  return G7 || (G7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), Bc(), uu, cu(), dn());
    })(Wt, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.StreamCipher, o = n.algo, s = [], l = [], u = [], d = o.RabbitLegacy = a.extend({
          _doReset: function() {
            var v = this._key.words, b = this.cfg.iv, x = this._X = [
              v[0],
              v[3] << 16 | v[2] >>> 16,
              v[1],
              v[0] << 16 | v[3] >>> 16,
              v[2],
              v[1] << 16 | v[0] >>> 16,
              v[3],
              v[2] << 16 | v[1] >>> 16
            ], A = this._C = [
              v[2] << 16 | v[2] >>> 16,
              v[0] & 4294901760 | v[1] & 65535,
              v[3] << 16 | v[3] >>> 16,
              v[1] & 4294901760 | v[2] & 65535,
              v[0] << 16 | v[0] >>> 16,
              v[2] & 4294901760 | v[3] & 65535,
              v[1] << 16 | v[1] >>> 16,
              v[3] & 4294901760 | v[0] & 65535
            ];
            this._b = 0;
            for (var T = 0; T < 4; T++)
              h.call(this);
            for (var T = 0; T < 8; T++)
              A[T] ^= x[T + 4 & 7];
            if (b) {
              var k = b.words, E = k[0], C = k[1], D = (E << 8 | E >>> 24) & 16711935 | (E << 24 | E >>> 8) & 4278255360, _ = (C << 8 | C >>> 24) & 16711935 | (C << 24 | C >>> 8) & 4278255360, I = D >>> 16 | _ & 4294901760, R = _ << 16 | D & 65535;
              A[0] ^= D, A[1] ^= I, A[2] ^= _, A[3] ^= R, A[4] ^= D, A[5] ^= I, A[6] ^= _, A[7] ^= R;
              for (var T = 0; T < 4; T++)
                h.call(this);
            }
          },
          _doProcessBlock: function(v, b) {
            var x = this._X;
            h.call(this), s[0] = x[0] ^ x[5] >>> 16 ^ x[3] << 16, s[1] = x[2] ^ x[7] >>> 16 ^ x[5] << 16, s[2] = x[4] ^ x[1] >>> 16 ^ x[7] << 16, s[3] = x[6] ^ x[3] >>> 16 ^ x[1] << 16;
            for (var A = 0; A < 4; A++)
              s[A] = (s[A] << 8 | s[A] >>> 24) & 16711935 | (s[A] << 24 | s[A] >>> 8) & 4278255360, v[b + A] ^= s[A];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function h() {
          for (var v = this._X, b = this._C, x = 0; x < 8; x++)
            l[x] = b[x];
          b[0] = b[0] + 1295307597 + this._b | 0, b[1] = b[1] + 3545052371 + (b[0] >>> 0 < l[0] >>> 0 ? 1 : 0) | 0, b[2] = b[2] + 886263092 + (b[1] >>> 0 < l[1] >>> 0 ? 1 : 0) | 0, b[3] = b[3] + 1295307597 + (b[2] >>> 0 < l[2] >>> 0 ? 1 : 0) | 0, b[4] = b[4] + 3545052371 + (b[3] >>> 0 < l[3] >>> 0 ? 1 : 0) | 0, b[5] = b[5] + 886263092 + (b[4] >>> 0 < l[4] >>> 0 ? 1 : 0) | 0, b[6] = b[6] + 1295307597 + (b[5] >>> 0 < l[5] >>> 0 ? 1 : 0) | 0, b[7] = b[7] + 3545052371 + (b[6] >>> 0 < l[6] >>> 0 ? 1 : 0) | 0, this._b = b[7] >>> 0 < l[7] >>> 0 ? 1 : 0;
          for (var x = 0; x < 8; x++) {
            var A = v[x] + b[x], T = A & 65535, k = A >>> 16, E = ((T * T >>> 17) + T * k >>> 15) + k * k, C = ((A & 4294901760) * A | 0) + ((A & 65535) * A | 0);
            u[x] = E ^ C;
          }
          v[0] = u[0] + (u[7] << 16 | u[7] >>> 16) + (u[6] << 16 | u[6] >>> 16) | 0, v[1] = u[1] + (u[0] << 8 | u[0] >>> 24) + u[7] | 0, v[2] = u[2] + (u[1] << 16 | u[1] >>> 16) + (u[0] << 16 | u[0] >>> 16) | 0, v[3] = u[3] + (u[2] << 8 | u[2] >>> 24) + u[1] | 0, v[4] = u[4] + (u[3] << 16 | u[3] >>> 16) + (u[2] << 16 | u[2] >>> 16) | 0, v[5] = u[5] + (u[4] << 8 | u[4] >>> 24) + u[3] | 0, v[6] = u[6] + (u[5] << 16 | u[5] >>> 16) + (u[4] << 16 | u[4] >>> 16) | 0, v[7] = u[7] + (u[6] << 8 | u[6] >>> 24) + u[5] | 0;
        }
        n.RabbitLegacy = a._createHelper(d);
      }(), r.RabbitLegacy;
    });
  }(lv)), lv.exports;
}
var uv = { exports: {} }, Z7;
function ZJ() {
  return Z7 || (Z7 = 1, function(t, e) {
    (function(r, n, i) {
      t.exports = n(d0(), Bc(), uu, cu(), dn());
    })(Wt, function(r) {
      return function() {
        var n = r, i = n.lib, a = i.BlockCipher, o = n.algo;
        const s = 16, l = [
          608135816,
          2242054355,
          320440878,
          57701188,
          2752067618,
          698298832,
          137296536,
          3964562569,
          1160258022,
          953160567,
          3193202383,
          887688300,
          3232508343,
          3380367581,
          1065670069,
          3041331479,
          2450970073,
          2306472731
        ], u = [
          [
            3509652390,
            2564797868,
            805139163,
            3491422135,
            3101798381,
            1780907670,
            3128725573,
            4046225305,
            614570311,
            3012652279,
            134345442,
            2240740374,
            1667834072,
            1901547113,
            2757295779,
            4103290238,
            227898511,
            1921955416,
            1904987480,
            2182433518,
            2069144605,
            3260701109,
            2620446009,
            720527379,
            3318853667,
            677414384,
            3393288472,
            3101374703,
            2390351024,
            1614419982,
            1822297739,
            2954791486,
            3608508353,
            3174124327,
            2024746970,
            1432378464,
            3864339955,
            2857741204,
            1464375394,
            1676153920,
            1439316330,
            715854006,
            3033291828,
            289532110,
            2706671279,
            2087905683,
            3018724369,
            1668267050,
            732546397,
            1947742710,
            3462151702,
            2609353502,
            2950085171,
            1814351708,
            2050118529,
            680887927,
            999245976,
            1800124847,
            3300911131,
            1713906067,
            1641548236,
            4213287313,
            1216130144,
            1575780402,
            4018429277,
            3917837745,
            3693486850,
            3949271944,
            596196993,
            3549867205,
            258830323,
            2213823033,
            772490370,
            2760122372,
            1774776394,
            2652871518,
            566650946,
            4142492826,
            1728879713,
            2882767088,
            1783734482,
            3629395816,
            2517608232,
            2874225571,
            1861159788,
            326777828,
            3124490320,
            2130389656,
            2716951837,
            967770486,
            1724537150,
            2185432712,
            2364442137,
            1164943284,
            2105845187,
            998989502,
            3765401048,
            2244026483,
            1075463327,
            1455516326,
            1322494562,
            910128902,
            469688178,
            1117454909,
            936433444,
            3490320968,
            3675253459,
            1240580251,
            122909385,
            2157517691,
            634681816,
            4142456567,
            3825094682,
            3061402683,
            2540495037,
            79693498,
            3249098678,
            1084186820,
            1583128258,
            426386531,
            1761308591,
            1047286709,
            322548459,
            995290223,
            1845252383,
            2603652396,
            3431023940,
            2942221577,
            3202600964,
            3727903485,
            1712269319,
            422464435,
            3234572375,
            1170764815,
            3523960633,
            3117677531,
            1434042557,
            442511882,
            3600875718,
            1076654713,
            1738483198,
            4213154764,
            2393238008,
            3677496056,
            1014306527,
            4251020053,
            793779912,
            2902807211,
            842905082,
            4246964064,
            1395751752,
            1040244610,
            2656851899,
            3396308128,
            445077038,
            3742853595,
            3577915638,
            679411651,
            2892444358,
            2354009459,
            1767581616,
            3150600392,
            3791627101,
            3102740896,
            284835224,
            4246832056,
            1258075500,
            768725851,
            2589189241,
            3069724005,
            3532540348,
            1274779536,
            3789419226,
            2764799539,
            1660621633,
            3471099624,
            4011903706,
            913787905,
            3497959166,
            737222580,
            2514213453,
            2928710040,
            3937242737,
            1804850592,
            3499020752,
            2949064160,
            2386320175,
            2390070455,
            2415321851,
            4061277028,
            2290661394,
            2416832540,
            1336762016,
            1754252060,
            3520065937,
            3014181293,
            791618072,
            3188594551,
            3933548030,
            2332172193,
            3852520463,
            3043980520,
            413987798,
            3465142937,
            3030929376,
            4245938359,
            2093235073,
            3534596313,
            375366246,
            2157278981,
            2479649556,
            555357303,
            3870105701,
            2008414854,
            3344188149,
            4221384143,
            3956125452,
            2067696032,
            3594591187,
            2921233993,
            2428461,
            544322398,
            577241275,
            1471733935,
            610547355,
            4027169054,
            1432588573,
            1507829418,
            2025931657,
            3646575487,
            545086370,
            48609733,
            2200306550,
            1653985193,
            298326376,
            1316178497,
            3007786442,
            2064951626,
            458293330,
            2589141269,
            3591329599,
            3164325604,
            727753846,
            2179363840,
            146436021,
            1461446943,
            4069977195,
            705550613,
            3059967265,
            3887724982,
            4281599278,
            3313849956,
            1404054877,
            2845806497,
            146425753,
            1854211946
          ],
          [
            1266315497,
            3048417604,
            3681880366,
            3289982499,
            290971e4,
            1235738493,
            2632868024,
            2414719590,
            3970600049,
            1771706367,
            1449415276,
            3266420449,
            422970021,
            1963543593,
            2690192192,
            3826793022,
            1062508698,
            1531092325,
            1804592342,
            2583117782,
            2714934279,
            4024971509,
            1294809318,
            4028980673,
            1289560198,
            2221992742,
            1669523910,
            35572830,
            157838143,
            1052438473,
            1016535060,
            1802137761,
            1753167236,
            1386275462,
            3080475397,
            2857371447,
            1040679964,
            2145300060,
            2390574316,
            1461121720,
            2956646967,
            4031777805,
            4028374788,
            33600511,
            2920084762,
            1018524850,
            629373528,
            3691585981,
            3515945977,
            2091462646,
            2486323059,
            586499841,
            988145025,
            935516892,
            3367335476,
            2599673255,
            2839830854,
            265290510,
            3972581182,
            2759138881,
            3795373465,
            1005194799,
            847297441,
            406762289,
            1314163512,
            1332590856,
            1866599683,
            4127851711,
            750260880,
            613907577,
            1450815602,
            3165620655,
            3734664991,
            3650291728,
            3012275730,
            3704569646,
            1427272223,
            778793252,
            1343938022,
            2676280711,
            2052605720,
            1946737175,
            3164576444,
            3914038668,
            3967478842,
            3682934266,
            1661551462,
            3294938066,
            4011595847,
            840292616,
            3712170807,
            616741398,
            312560963,
            711312465,
            1351876610,
            322626781,
            1910503582,
            271666773,
            2175563734,
            1594956187,
            70604529,
            3617834859,
            1007753275,
            1495573769,
            4069517037,
            2549218298,
            2663038764,
            504708206,
            2263041392,
            3941167025,
            2249088522,
            1514023603,
            1998579484,
            1312622330,
            694541497,
            2582060303,
            2151582166,
            1382467621,
            776784248,
            2618340202,
            3323268794,
            2497899128,
            2784771155,
            503983604,
            4076293799,
            907881277,
            423175695,
            432175456,
            1378068232,
            4145222326,
            3954048622,
            3938656102,
            3820766613,
            2793130115,
            2977904593,
            26017576,
            3274890735,
            3194772133,
            1700274565,
            1756076034,
            4006520079,
            3677328699,
            720338349,
            1533947780,
            354530856,
            688349552,
            3973924725,
            1637815568,
            332179504,
            3949051286,
            53804574,
            2852348879,
            3044236432,
            1282449977,
            3583942155,
            3416972820,
            4006381244,
            1617046695,
            2628476075,
            3002303598,
            1686838959,
            431878346,
            2686675385,
            1700445008,
            1080580658,
            1009431731,
            832498133,
            3223435511,
            2605976345,
            2271191193,
            2516031870,
            1648197032,
            4164389018,
            2548247927,
            300782431,
            375919233,
            238389289,
            3353747414,
            2531188641,
            2019080857,
            1475708069,
            455242339,
            2609103871,
            448939670,
            3451063019,
            1395535956,
            2413381860,
            1841049896,
            1491858159,
            885456874,
            4264095073,
            4001119347,
            1565136089,
            3898914787,
            1108368660,
            540939232,
            1173283510,
            2745871338,
            3681308437,
            4207628240,
            3343053890,
            4016749493,
            1699691293,
            1103962373,
            3625875870,
            2256883143,
            3830138730,
            1031889488,
            3479347698,
            1535977030,
            4236805024,
            3251091107,
            2132092099,
            1774941330,
            1199868427,
            1452454533,
            157007616,
            2904115357,
            342012276,
            595725824,
            1480756522,
            206960106,
            497939518,
            591360097,
            863170706,
            2375253569,
            3596610801,
            1814182875,
            2094937945,
            3421402208,
            1082520231,
            3463918190,
            2785509508,
            435703966,
            3908032597,
            1641649973,
            2842273706,
            3305899714,
            1510255612,
            2148256476,
            2655287854,
            3276092548,
            4258621189,
            236887753,
            3681803219,
            274041037,
            1734335097,
            3815195456,
            3317970021,
            1899903192,
            1026095262,
            4050517792,
            356393447,
            2410691914,
            3873677099,
            3682840055
          ],
          [
            3913112168,
            2491498743,
            4132185628,
            2489919796,
            1091903735,
            1979897079,
            3170134830,
            3567386728,
            3557303409,
            857797738,
            1136121015,
            1342202287,
            507115054,
            2535736646,
            337727348,
            3213592640,
            1301675037,
            2528481711,
            1895095763,
            1721773893,
            3216771564,
            62756741,
            2142006736,
            835421444,
            2531993523,
            1442658625,
            3659876326,
            2882144922,
            676362277,
            1392781812,
            170690266,
            3921047035,
            1759253602,
            3611846912,
            1745797284,
            664899054,
            1329594018,
            3901205900,
            3045908486,
            2062866102,
            2865634940,
            3543621612,
            3464012697,
            1080764994,
            553557557,
            3656615353,
            3996768171,
            991055499,
            499776247,
            1265440854,
            648242737,
            3940784050,
            980351604,
            3713745714,
            1749149687,
            3396870395,
            4211799374,
            3640570775,
            1161844396,
            3125318951,
            1431517754,
            545492359,
            4268468663,
            3499529547,
            1437099964,
            2702547544,
            3433638243,
            2581715763,
            2787789398,
            1060185593,
            1593081372,
            2418618748,
            4260947970,
            69676912,
            2159744348,
            86519011,
            2512459080,
            3838209314,
            1220612927,
            3339683548,
            133810670,
            1090789135,
            1078426020,
            1569222167,
            845107691,
            3583754449,
            4072456591,
            1091646820,
            628848692,
            1613405280,
            3757631651,
            526609435,
            236106946,
            48312990,
            2942717905,
            3402727701,
            1797494240,
            859738849,
            992217954,
            4005476642,
            2243076622,
            3870952857,
            3732016268,
            765654824,
            3490871365,
            2511836413,
            1685915746,
            3888969200,
            1414112111,
            2273134842,
            3281911079,
            4080962846,
            172450625,
            2569994100,
            980381355,
            4109958455,
            2819808352,
            2716589560,
            2568741196,
            3681446669,
            3329971472,
            1835478071,
            660984891,
            3704678404,
            4045999559,
            3422617507,
            3040415634,
            1762651403,
            1719377915,
            3470491036,
            2693910283,
            3642056355,
            3138596744,
            1364962596,
            2073328063,
            1983633131,
            926494387,
            3423689081,
            2150032023,
            4096667949,
            1749200295,
            3328846651,
            309677260,
            2016342300,
            1779581495,
            3079819751,
            111262694,
            1274766160,
            443224088,
            298511866,
            1025883608,
            3806446537,
            1145181785,
            168956806,
            3641502830,
            3584813610,
            1689216846,
            3666258015,
            3200248200,
            1692713982,
            2646376535,
            4042768518,
            1618508792,
            1610833997,
            3523052358,
            4130873264,
            2001055236,
            3610705100,
            2202168115,
            4028541809,
            2961195399,
            1006657119,
            2006996926,
            3186142756,
            1430667929,
            3210227297,
            1314452623,
            4074634658,
            4101304120,
            2273951170,
            1399257539,
            3367210612,
            3027628629,
            1190975929,
            2062231137,
            2333990788,
            2221543033,
            2438960610,
            1181637006,
            548689776,
            2362791313,
            3372408396,
            3104550113,
            3145860560,
            296247880,
            1970579870,
            3078560182,
            3769228297,
            1714227617,
            3291629107,
            3898220290,
            166772364,
            1251581989,
            493813264,
            448347421,
            195405023,
            2709975567,
            677966185,
            3703036547,
            1463355134,
            2715995803,
            1338867538,
            1343315457,
            2802222074,
            2684532164,
            233230375,
            2599980071,
            2000651841,
            3277868038,
            1638401717,
            4028070440,
            3237316320,
            6314154,
            819756386,
            300326615,
            590932579,
            1405279636,
            3267499572,
            3150704214,
            2428286686,
            3959192993,
            3461946742,
            1862657033,
            1266418056,
            963775037,
            2089974820,
            2263052895,
            1917689273,
            448879540,
            3550394620,
            3981727096,
            150775221,
            3627908307,
            1303187396,
            508620638,
            2975983352,
            2726630617,
            1817252668,
            1876281319,
            1457606340,
            908771278,
            3720792119,
            3617206836,
            2455994898,
            1729034894,
            1080033504
          ],
          [
            976866871,
            3556439503,
            2881648439,
            1522871579,
            1555064734,
            1336096578,
            3548522304,
            2579274686,
            3574697629,
            3205460757,
            3593280638,
            3338716283,
            3079412587,
            564236357,
            2993598910,
            1781952180,
            1464380207,
            3163844217,
            3332601554,
            1699332808,
            1393555694,
            1183702653,
            3581086237,
            1288719814,
            691649499,
            2847557200,
            2895455976,
            3193889540,
            2717570544,
            1781354906,
            1676643554,
            2592534050,
            3230253752,
            1126444790,
            2770207658,
            2633158820,
            2210423226,
            2615765581,
            2414155088,
            3127139286,
            673620729,
            2805611233,
            1269405062,
            4015350505,
            3341807571,
            4149409754,
            1057255273,
            2012875353,
            2162469141,
            2276492801,
            2601117357,
            993977747,
            3918593370,
            2654263191,
            753973209,
            36408145,
            2530585658,
            25011837,
            3520020182,
            2088578344,
            530523599,
            2918365339,
            1524020338,
            1518925132,
            3760827505,
            3759777254,
            1202760957,
            3985898139,
            3906192525,
            674977740,
            4174734889,
            2031300136,
            2019492241,
            3983892565,
            4153806404,
            3822280332,
            352677332,
            2297720250,
            60907813,
            90501309,
            3286998549,
            1016092578,
            2535922412,
            2839152426,
            457141659,
            509813237,
            4120667899,
            652014361,
            1966332200,
            2975202805,
            55981186,
            2327461051,
            676427537,
            3255491064,
            2882294119,
            3433927263,
            1307055953,
            942726286,
            933058658,
            2468411793,
            3933900994,
            4215176142,
            1361170020,
            2001714738,
            2830558078,
            3274259782,
            1222529897,
            1679025792,
            2729314320,
            3714953764,
            1770335741,
            151462246,
            3013232138,
            1682292957,
            1483529935,
            471910574,
            1539241949,
            458788160,
            3436315007,
            1807016891,
            3718408830,
            978976581,
            1043663428,
            3165965781,
            1927990952,
            4200891579,
            2372276910,
            3208408903,
            3533431907,
            1412390302,
            2931980059,
            4132332400,
            1947078029,
            3881505623,
            4168226417,
            2941484381,
            1077988104,
            1320477388,
            886195818,
            18198404,
            3786409e3,
            2509781533,
            112762804,
            3463356488,
            1866414978,
            891333506,
            18488651,
            661792760,
            1628790961,
            3885187036,
            3141171499,
            876946877,
            2693282273,
            1372485963,
            791857591,
            2686433993,
            3759982718,
            3167212022,
            3472953795,
            2716379847,
            445679433,
            3561995674,
            3504004811,
            3574258232,
            54117162,
            3331405415,
            2381918588,
            3769707343,
            4154350007,
            1140177722,
            4074052095,
            668550556,
            3214352940,
            367459370,
            261225585,
            2610173221,
            4209349473,
            3468074219,
            3265815641,
            314222801,
            3066103646,
            3808782860,
            282218597,
            3406013506,
            3773591054,
            379116347,
            1285071038,
            846784868,
            2669647154,
            3771962079,
            3550491691,
            2305946142,
            453669953,
            1268987020,
            3317592352,
            3279303384,
            3744833421,
            2610507566,
            3859509063,
            266596637,
            3847019092,
            517658769,
            3462560207,
            3443424879,
            370717030,
            4247526661,
            2224018117,
            4143653529,
            4112773975,
            2788324899,
            2477274417,
            1456262402,
            2901442914,
            1517677493,
            1846949527,
            2295493580,
            3734397586,
            2176403920,
            1280348187,
            1908823572,
            3871786941,
            846861322,
            1172426758,
            3287448474,
            3383383037,
            1655181056,
            3139813346,
            901632758,
            1897031941,
            2986607138,
            3066810236,
            3447102507,
            1393639104,
            373351379,
            950779232,
            625454576,
            3124240540,
            4148612726,
            2007998917,
            544563296,
            2244738638,
            2330496472,
            2058025392,
            1291430526,
            424198748,
            50039436,
            29584100,
            3605783033,
            2429876329,
            2791104160,
            1057563949,
            3255363231,
            3075367218,
            3463963227,
            1469046755,
            985887462
          ]
        ];
        var d = {
          pbox: [],
          sbox: []
        };
        function h(T, k) {
          let E = k >> 24 & 255, C = k >> 16 & 255, D = k >> 8 & 255, _ = k & 255, I = T.sbox[0][E] + T.sbox[1][C];
          return I = I ^ T.sbox[2][D], I = I + T.sbox[3][_], I;
        }
        function v(T, k, E) {
          let C = k, D = E, _;
          for (let I = 0; I < s; ++I)
            C = C ^ T.pbox[I], D = h(T, C) ^ D, _ = C, C = D, D = _;
          return _ = C, C = D, D = _, D = D ^ T.pbox[s], C = C ^ T.pbox[s + 1], { left: C, right: D };
        }
        function b(T, k, E) {
          let C = k, D = E, _;
          for (let I = s + 1; I > 1; --I)
            C = C ^ T.pbox[I], D = h(T, C) ^ D, _ = C, C = D, D = _;
          return _ = C, C = D, D = _, D = D ^ T.pbox[1], C = C ^ T.pbox[0], { left: C, right: D };
        }
        function x(T, k, E) {
          for (let R = 0; R < 4; R++) {
            T.sbox[R] = [];
            for (let U = 0; U < 256; U++)
              T.sbox[R][U] = u[R][U];
          }
          let C = 0;
          for (let R = 0; R < s + 2; R++)
            T.pbox[R] = l[R] ^ k[C], C++, C >= E && (C = 0);
          let D = 0, _ = 0, I = 0;
          for (let R = 0; R < s + 2; R += 2)
            I = v(T, D, _), D = I.left, _ = I.right, T.pbox[R] = D, T.pbox[R + 1] = _;
          for (let R = 0; R < 4; R++)
            for (let U = 0; U < 256; U += 2)
              I = v(T, D, _), D = I.left, _ = I.right, T.sbox[R][U] = D, T.sbox[R][U + 1] = _;
          return !0;
        }
        var A = o.Blowfish = a.extend({
          _doReset: function() {
            if (this._keyPriorReset !== this._key) {
              var T = this._keyPriorReset = this._key, k = T.words, E = T.sigBytes / 4;
              x(d, k, E);
            }
          },
          encryptBlock: function(T, k) {
            var E = v(d, T[k], T[k + 1]);
            T[k] = E.left, T[k + 1] = E.right;
          },
          decryptBlock: function(T, k) {
            var E = b(d, T[k], T[k + 1]);
            T[k] = E.left, T[k + 1] = E.right;
          },
          blockSize: 64 / 32,
          keySize: 128 / 32,
          ivSize: 64 / 32
        });
        n.Blowfish = a._createHelper(A);
      }(), r.Blowfish;
    });
  }(uv)), uv.exports;
}
(function(t, e) {
  (function(r, n, i) {
    t.exports = n(d0(), um(), SJ(), CJ(), Bc(), kJ(), uu, pk(), px(), TJ(), mk(), FJ(), DJ(), OJ(), mx(), RJ(), cu(), dn(), PJ(), IJ(), BJ(), LJ(), NJ(), MJ(), UJ(), zJ(), $J(), VJ(), jJ(), WJ(), HJ(), qJ(), YJ(), GJ(), ZJ());
  })(Wt, function(r) {
    return r;
  });
})(hk);
var XJ = hk.exports;
const X7 = /* @__PURE__ */ On(XJ);
var Ec = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {}, Zo = [], xa = [], KJ = typeof Uint8Array < "u" ? Uint8Array : Array, gx = !1;
function gk() {
  gx = !0;
  for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", e = 0, r = t.length; e < r; ++e)
    Zo[e] = t[e], xa[t.charCodeAt(e)] = e;
  xa[45] = 62, xa[95] = 63;
}
function JJ(t) {
  gx || gk();
  var e, r, n, i, a, o, s = t.length;
  if (s % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  a = t[s - 2] === "=" ? 2 : t[s - 1] === "=" ? 1 : 0, o = new KJ(s * 3 / 4 - a), n = a > 0 ? s - 4 : s;
  var l = 0;
  for (e = 0, r = 0; e < n; e += 4, r += 3)
    i = xa[t.charCodeAt(e)] << 18 | xa[t.charCodeAt(e + 1)] << 12 | xa[t.charCodeAt(e + 2)] << 6 | xa[t.charCodeAt(e + 3)], o[l++] = i >> 16 & 255, o[l++] = i >> 8 & 255, o[l++] = i & 255;
  return a === 2 ? (i = xa[t.charCodeAt(e)] << 2 | xa[t.charCodeAt(e + 1)] >> 4, o[l++] = i & 255) : a === 1 && (i = xa[t.charCodeAt(e)] << 10 | xa[t.charCodeAt(e + 1)] << 4 | xa[t.charCodeAt(e + 2)] >> 2, o[l++] = i >> 8 & 255, o[l++] = i & 255), o;
}
function QJ(t) {
  return Zo[t >> 18 & 63] + Zo[t >> 12 & 63] + Zo[t >> 6 & 63] + Zo[t & 63];
}
function eQ(t, e, r) {
  for (var n, i = [], a = e; a < r; a += 3)
    n = (t[a] << 16) + (t[a + 1] << 8) + t[a + 2], i.push(QJ(n));
  return i.join("");
}
function K7(t) {
  gx || gk();
  for (var e, r = t.length, n = r % 3, i = "", a = [], o = 16383, s = 0, l = r - n; s < l; s += o)
    a.push(eQ(t, s, s + o > l ? l : s + o));
  return n === 1 ? (e = t[r - 1], i += Zo[e >> 2], i += Zo[e << 4 & 63], i += "==") : n === 2 && (e = (t[r - 2] << 8) + t[r - 1], i += Zo[e >> 10], i += Zo[e >> 4 & 63], i += Zo[e << 2 & 63], i += "="), a.push(i), a.join("");
}
function cm(t, e, r, n, i) {
  var a, o, s = i * 8 - n - 1, l = (1 << s) - 1, u = l >> 1, d = -7, h = r ? i - 1 : 0, v = r ? -1 : 1, b = t[e + h];
  for (h += v, a = b & (1 << -d) - 1, b >>= -d, d += s; d > 0; a = a * 256 + t[e + h], h += v, d -= 8)
    ;
  for (o = a & (1 << -d) - 1, a >>= -d, d += n; d > 0; o = o * 256 + t[e + h], h += v, d -= 8)
    ;
  if (a === 0)
    a = 1 - u;
  else {
    if (a === l)
      return o ? NaN : (b ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, n), a = a - u;
  }
  return (b ? -1 : 1) * o * Math.pow(2, a - n);
}
function vk(t, e, r, n, i, a) {
  var o, s, l, u = a * 8 - i - 1, d = (1 << u) - 1, h = d >> 1, v = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, b = n ? 0 : a - 1, x = n ? 1 : -1, A = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, o = d) : (o = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), o + h >= 1 ? e += v / l : e += v * Math.pow(2, 1 - h), e * l >= 2 && (o++, l /= 2), o + h >= d ? (s = 0, o = d) : o + h >= 1 ? (s = (e * l - 1) * Math.pow(2, i), o = o + h) : (s = e * Math.pow(2, h - 1) * Math.pow(2, i), o = 0)); i >= 8; t[r + b] = s & 255, b += x, s /= 256, i -= 8)
    ;
  for (o = o << i | s, u += i; u > 0; t[r + b] = o & 255, b += x, o /= 256, u -= 8)
    ;
  t[r + b - x] |= A * 128;
}
var tQ = {}.toString, bk = Array.isArray || function(t) {
  return tQ.call(t) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var xk = 50;
Oe.TYPED_ARRAY_SUPPORT = Ec.TYPED_ARRAY_SUPPORT !== void 0 ? Ec.TYPED_ARRAY_SUPPORT : !0;
var rQ = np();
function np() {
  return Oe.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function el(t, e) {
  if (np() < e)
    throw new RangeError("Invalid typed array length");
  return Oe.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e), t.__proto__ = Oe.prototype) : (t === null && (t = new Oe(e)), t.length = e), t;
}
function Oe(t, e, r) {
  if (!Oe.TYPED_ARRAY_SUPPORT && !(this instanceof Oe))
    return new Oe(t, e, r);
  if (typeof t == "number") {
    if (typeof e == "string")
      throw new Error(
        "If encoding is specified then the first argument must be a string"
      );
    return vx(this, t);
  }
  return yk(this, t, e, r);
}
Oe.poolSize = 8192;
Oe._augment = function(t) {
  return t.__proto__ = Oe.prototype, t;
};
function yk(t, e, r, n) {
  if (typeof e == "number")
    throw new TypeError('"value" argument must not be a number');
  return typeof ArrayBuffer < "u" && e instanceof ArrayBuffer ? aQ(t, e, r, n) : typeof e == "string" ? iQ(t, e, r) : oQ(t, e);
}
Oe.from = function(t, e, r) {
  return yk(null, t, e, r);
};
Oe.TYPED_ARRAY_SUPPORT && (Oe.prototype.__proto__ = Uint8Array.prototype, Oe.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && Oe[Symbol.species]);
function wk(t) {
  if (typeof t != "number")
    throw new TypeError('"size" argument must be a number');
  if (t < 0)
    throw new RangeError('"size" argument must not be negative');
}
function nQ(t, e, r, n) {
  return wk(e), e <= 0 ? el(t, e) : r !== void 0 ? typeof n == "string" ? el(t, e).fill(r, n) : el(t, e).fill(r) : el(t, e);
}
Oe.alloc = function(t, e, r) {
  return nQ(null, t, e, r);
};
function vx(t, e) {
  if (wk(e), t = el(t, e < 0 ? 0 : bx(e) | 0), !Oe.TYPED_ARRAY_SUPPORT)
    for (var r = 0; r < e; ++r)
      t[r] = 0;
  return t;
}
Oe.allocUnsafe = function(t) {
  return vx(null, t);
};
Oe.allocUnsafeSlow = function(t) {
  return vx(null, t);
};
function iQ(t, e, r) {
  if ((typeof r != "string" || r === "") && (r = "utf8"), !Oe.isEncoding(r))
    throw new TypeError('"encoding" must be a valid string encoding');
  var n = _k(e, r) | 0;
  t = el(t, n);
  var i = t.write(e, r);
  return i !== n && (t = t.slice(0, i)), t;
}
function B3(t, e) {
  var r = e.length < 0 ? 0 : bx(e.length) | 0;
  t = el(t, r);
  for (var n = 0; n < r; n += 1)
    t[n] = e[n] & 255;
  return t;
}
function aQ(t, e, r, n) {
  if (e.byteLength, r < 0 || e.byteLength < r)
    throw new RangeError("'offset' is out of bounds");
  if (e.byteLength < r + (n || 0))
    throw new RangeError("'length' is out of bounds");
  return r === void 0 && n === void 0 ? e = new Uint8Array(e) : n === void 0 ? e = new Uint8Array(e, r) : e = new Uint8Array(e, r, n), Oe.TYPED_ARRAY_SUPPORT ? (t = e, t.__proto__ = Oe.prototype) : t = B3(t, e), t;
}
function oQ(t, e) {
  if (us(e)) {
    var r = bx(e.length) | 0;
    return t = el(t, r), t.length === 0 || e.copy(t, 0, 0, r), t;
  }
  if (e) {
    if (typeof ArrayBuffer < "u" && e.buffer instanceof ArrayBuffer || "length" in e)
      return typeof e.length != "number" || CQ(e.length) ? el(t, 0) : B3(t, e);
    if (e.type === "Buffer" && bk(e.data))
      return B3(t, e.data);
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function bx(t) {
  if (t >= np())
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + np().toString(16) + " bytes");
  return t | 0;
}
function sQ(t) {
  return +t != t && (t = 0), Oe.alloc(+t);
}
Oe.isBuffer = ec;
function us(t) {
  return !!(t != null && t._isBuffer);
}
Oe.compare = function(e, r) {
  if (!us(e) || !us(r))
    throw new TypeError("Arguments must be Buffers");
  if (e === r) return 0;
  for (var n = e.length, i = r.length, a = 0, o = Math.min(n, i); a < o; ++a)
    if (e[a] !== r[a]) {
      n = e[a], i = r[a];
      break;
    }
  return n < i ? -1 : i < n ? 1 : 0;
};
Oe.isEncoding = function(e) {
  switch (String(e).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return !0;
    default:
      return !1;
  }
};
Oe.concat = function(e, r) {
  if (!bk(e))
    throw new TypeError('"list" argument must be an Array of Buffers');
  if (e.length === 0)
    return Oe.alloc(0);
  var n;
  if (r === void 0)
    for (r = 0, n = 0; n < e.length; ++n)
      r += e[n].length;
  var i = Oe.allocUnsafe(r), a = 0;
  for (n = 0; n < e.length; ++n) {
    var o = e[n];
    if (!us(o))
      throw new TypeError('"list" argument must be an Array of Buffers');
    o.copy(i, a), a += o.length;
  }
  return i;
};
function _k(t, e) {
  if (us(t))
    return t.length;
  if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer))
    return t.byteLength;
  typeof t != "string" && (t = "" + t);
  var r = t.length;
  if (r === 0) return 0;
  for (var n = !1; ; )
    switch (e) {
      case "ascii":
      case "latin1":
      case "binary":
        return r;
      case "utf8":
      case "utf-8":
      case void 0:
        return ip(t).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return r * 2;
      case "hex":
        return r >>> 1;
      case "base64":
        return Fk(t).length;
      default:
        if (n) return ip(t).length;
        e = ("" + e).toLowerCase(), n = !0;
    }
}
Oe.byteLength = _k;
function lQ(t, e, r) {
  var n = !1;
  if ((e === void 0 || e < 0) && (e = 0), e > this.length || ((r === void 0 || r > this.length) && (r = this.length), r <= 0) || (r >>>= 0, e >>>= 0, r <= e))
    return "";
  for (t || (t = "utf8"); ; )
    switch (t) {
      case "hex":
        return bQ(this, e, r);
      case "utf8":
      case "utf-8":
        return Sk(this, e, r);
      case "ascii":
        return gQ(this, e, r);
      case "latin1":
      case "binary":
        return vQ(this, e, r);
      case "base64":
        return pQ(this, e, r);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return xQ(this, e, r);
      default:
        if (n) throw new TypeError("Unknown encoding: " + t);
        t = (t + "").toLowerCase(), n = !0;
    }
}
Oe.prototype._isBuffer = !0;
function Qu(t, e, r) {
  var n = t[e];
  t[e] = t[r], t[r] = n;
}
Oe.prototype.swap16 = function() {
  var e = this.length;
  if (e % 2 !== 0)
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  for (var r = 0; r < e; r += 2)
    Qu(this, r, r + 1);
  return this;
};
Oe.prototype.swap32 = function() {
  var e = this.length;
  if (e % 4 !== 0)
    throw new RangeError("Buffer size must be a multiple of 32-bits");
  for (var r = 0; r < e; r += 4)
    Qu(this, r, r + 3), Qu(this, r + 1, r + 2);
  return this;
};
Oe.prototype.swap64 = function() {
  var e = this.length;
  if (e % 8 !== 0)
    throw new RangeError("Buffer size must be a multiple of 64-bits");
  for (var r = 0; r < e; r += 8)
    Qu(this, r, r + 7), Qu(this, r + 1, r + 6), Qu(this, r + 2, r + 5), Qu(this, r + 3, r + 4);
  return this;
};
Oe.prototype.toString = function() {
  var e = this.length | 0;
  return e === 0 ? "" : arguments.length === 0 ? Sk(this, 0, e) : lQ.apply(this, arguments);
};
Oe.prototype.equals = function(e) {
  if (!us(e)) throw new TypeError("Argument must be a Buffer");
  return this === e ? !0 : Oe.compare(this, e) === 0;
};
Oe.prototype.inspect = function() {
  var e = "", r = xk;
  return this.length > 0 && (e = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (e += " ... ")), "<Buffer " + e + ">";
};
Oe.prototype.compare = function(e, r, n, i, a) {
  if (!us(e))
    throw new TypeError("Argument must be a Buffer");
  if (r === void 0 && (r = 0), n === void 0 && (n = e ? e.length : 0), i === void 0 && (i = 0), a === void 0 && (a = this.length), r < 0 || n > e.length || i < 0 || a > this.length)
    throw new RangeError("out of range index");
  if (i >= a && r >= n)
    return 0;
  if (i >= a)
    return -1;
  if (r >= n)
    return 1;
  if (r >>>= 0, n >>>= 0, i >>>= 0, a >>>= 0, this === e) return 0;
  for (var o = a - i, s = n - r, l = Math.min(o, s), u = this.slice(i, a), d = e.slice(r, n), h = 0; h < l; ++h)
    if (u[h] !== d[h]) {
      o = u[h], s = d[h];
      break;
    }
  return o < s ? -1 : s < o ? 1 : 0;
};
function Ak(t, e, r, n, i) {
  if (t.length === 0) return -1;
  if (typeof r == "string" ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
    if (i) return -1;
    r = t.length - 1;
  } else if (r < 0)
    if (i) r = 0;
    else return -1;
  if (typeof e == "string" && (e = Oe.from(e, n)), us(e))
    return e.length === 0 ? -1 : J7(t, e, r, n, i);
  if (typeof e == "number")
    return e = e & 255, Oe.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? i ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : J7(t, [e], r, n, i);
  throw new TypeError("val must be string, number or Buffer");
}
function J7(t, e, r, n, i) {
  var a = 1, o = t.length, s = e.length;
  if (n !== void 0 && (n = String(n).toLowerCase(), n === "ucs2" || n === "ucs-2" || n === "utf16le" || n === "utf-16le")) {
    if (t.length < 2 || e.length < 2)
      return -1;
    a = 2, o /= 2, s /= 2, r /= 2;
  }
  function l(b, x) {
    return a === 1 ? b[x] : b.readUInt16BE(x * a);
  }
  var u;
  if (i) {
    var d = -1;
    for (u = r; u < o; u++)
      if (l(t, u) === l(e, d === -1 ? 0 : u - d)) {
        if (d === -1 && (d = u), u - d + 1 === s) return d * a;
      } else
        d !== -1 && (u -= u - d), d = -1;
  } else
    for (r + s > o && (r = o - s), u = r; u >= 0; u--) {
      for (var h = !0, v = 0; v < s; v++)
        if (l(t, u + v) !== l(e, v)) {
          h = !1;
          break;
        }
      if (h) return u;
    }
  return -1;
}
Oe.prototype.includes = function(e, r, n) {
  return this.indexOf(e, r, n) !== -1;
};
Oe.prototype.indexOf = function(e, r, n) {
  return Ak(this, e, r, n, !0);
};
Oe.prototype.lastIndexOf = function(e, r, n) {
  return Ak(this, e, r, n, !1);
};
function uQ(t, e, r, n) {
  r = Number(r) || 0;
  var i = t.length - r;
  n ? (n = Number(n), n > i && (n = i)) : n = i;
  var a = e.length;
  if (a % 2 !== 0) throw new TypeError("Invalid hex string");
  n > a / 2 && (n = a / 2);
  for (var o = 0; o < n; ++o) {
    var s = parseInt(e.substr(o * 2, 2), 16);
    if (isNaN(s)) return o;
    t[r + o] = s;
  }
  return o;
}
function cQ(t, e, r, n) {
  return hm(ip(e, t.length - r), t, r, n);
}
function Ek(t, e, r, n) {
  return hm(EQ(e), t, r, n);
}
function fQ(t, e, r, n) {
  return Ek(t, e, r, n);
}
function dQ(t, e, r, n) {
  return hm(Fk(e), t, r, n);
}
function hQ(t, e, r, n) {
  return hm(SQ(e, t.length - r), t, r, n);
}
Oe.prototype.write = function(e, r, n, i) {
  if (r === void 0)
    i = "utf8", n = this.length, r = 0;
  else if (n === void 0 && typeof r == "string")
    i = r, n = this.length, r = 0;
  else if (isFinite(r))
    r = r | 0, isFinite(n) ? (n = n | 0, i === void 0 && (i = "utf8")) : (i = n, n = void 0);
  else
    throw new Error(
      "Buffer.write(string, encoding, offset[, length]) is no longer supported"
    );
  var a = this.length - r;
  if ((n === void 0 || n > a) && (n = a), e.length > 0 && (n < 0 || r < 0) || r > this.length)
    throw new RangeError("Attempt to write outside buffer bounds");
  i || (i = "utf8");
  for (var o = !1; ; )
    switch (i) {
      case "hex":
        return uQ(this, e, r, n);
      case "utf8":
      case "utf-8":
        return cQ(this, e, r, n);
      case "ascii":
        return Ek(this, e, r, n);
      case "latin1":
      case "binary":
        return fQ(this, e, r, n);
      case "base64":
        return dQ(this, e, r, n);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return hQ(this, e, r, n);
      default:
        if (o) throw new TypeError("Unknown encoding: " + i);
        i = ("" + i).toLowerCase(), o = !0;
    }
};
Oe.prototype.toJSON = function() {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function pQ(t, e, r) {
  return e === 0 && r === t.length ? K7(t) : K7(t.slice(e, r));
}
function Sk(t, e, r) {
  r = Math.min(t.length, r);
  for (var n = [], i = e; i < r; ) {
    var a = t[i], o = null, s = a > 239 ? 4 : a > 223 ? 3 : a > 191 ? 2 : 1;
    if (i + s <= r) {
      var l, u, d, h;
      switch (s) {
        case 1:
          a < 128 && (o = a);
          break;
        case 2:
          l = t[i + 1], (l & 192) === 128 && (h = (a & 31) << 6 | l & 63, h > 127 && (o = h));
          break;
        case 3:
          l = t[i + 1], u = t[i + 2], (l & 192) === 128 && (u & 192) === 128 && (h = (a & 15) << 12 | (l & 63) << 6 | u & 63, h > 2047 && (h < 55296 || h > 57343) && (o = h));
          break;
        case 4:
          l = t[i + 1], u = t[i + 2], d = t[i + 3], (l & 192) === 128 && (u & 192) === 128 && (d & 192) === 128 && (h = (a & 15) << 18 | (l & 63) << 12 | (u & 63) << 6 | d & 63, h > 65535 && h < 1114112 && (o = h));
      }
    }
    o === null ? (o = 65533, s = 1) : o > 65535 && (o -= 65536, n.push(o >>> 10 & 1023 | 55296), o = 56320 | o & 1023), n.push(o), i += s;
  }
  return mQ(n);
}
var Q7 = 4096;
function mQ(t) {
  var e = t.length;
  if (e <= Q7)
    return String.fromCharCode.apply(String, t);
  for (var r = "", n = 0; n < e; )
    r += String.fromCharCode.apply(
      String,
      t.slice(n, n += Q7)
    );
  return r;
}
function gQ(t, e, r) {
  var n = "";
  r = Math.min(t.length, r);
  for (var i = e; i < r; ++i)
    n += String.fromCharCode(t[i] & 127);
  return n;
}
function vQ(t, e, r) {
  var n = "";
  r = Math.min(t.length, r);
  for (var i = e; i < r; ++i)
    n += String.fromCharCode(t[i]);
  return n;
}
function bQ(t, e, r) {
  var n = t.length;
  (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);
  for (var i = "", a = e; a < r; ++a)
    i += AQ(t[a]);
  return i;
}
function xQ(t, e, r) {
  for (var n = t.slice(e, r), i = "", a = 0; a < n.length; a += 2)
    i += String.fromCharCode(n[a] + n[a + 1] * 256);
  return i;
}
Oe.prototype.slice = function(e, r) {
  var n = this.length;
  e = ~~e, r = r === void 0 ? n : ~~r, e < 0 ? (e += n, e < 0 && (e = 0)) : e > n && (e = n), r < 0 ? (r += n, r < 0 && (r = 0)) : r > n && (r = n), r < e && (r = e);
  var i;
  if (Oe.TYPED_ARRAY_SUPPORT)
    i = this.subarray(e, r), i.__proto__ = Oe.prototype;
  else {
    var a = r - e;
    i = new Oe(a, void 0);
    for (var o = 0; o < a; ++o)
      i[o] = this[o + e];
  }
  return i;
};
function hn(t, e, r) {
  if (t % 1 !== 0 || t < 0) throw new RangeError("offset is not uint");
  if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
}
Oe.prototype.readUIntLE = function(e, r, n) {
  e = e | 0, r = r | 0, n || hn(e, r, this.length);
  for (var i = this[e], a = 1, o = 0; ++o < r && (a *= 256); )
    i += this[e + o] * a;
  return i;
};
Oe.prototype.readUIntBE = function(e, r, n) {
  e = e | 0, r = r | 0, n || hn(e, r, this.length);
  for (var i = this[e + --r], a = 1; r > 0 && (a *= 256); )
    i += this[e + --r] * a;
  return i;
};
Oe.prototype.readUInt8 = function(e, r) {
  return r || hn(e, 1, this.length), this[e];
};
Oe.prototype.readUInt16LE = function(e, r) {
  return r || hn(e, 2, this.length), this[e] | this[e + 1] << 8;
};
Oe.prototype.readUInt16BE = function(e, r) {
  return r || hn(e, 2, this.length), this[e] << 8 | this[e + 1];
};
Oe.prototype.readUInt32LE = function(e, r) {
  return r || hn(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + this[e + 3] * 16777216;
};
Oe.prototype.readUInt32BE = function(e, r) {
  return r || hn(e, 4, this.length), this[e] * 16777216 + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
};
Oe.prototype.readIntLE = function(e, r, n) {
  e = e | 0, r = r | 0, n || hn(e, r, this.length);
  for (var i = this[e], a = 1, o = 0; ++o < r && (a *= 256); )
    i += this[e + o] * a;
  return a *= 128, i >= a && (i -= Math.pow(2, 8 * r)), i;
};
Oe.prototype.readIntBE = function(e, r, n) {
  e = e | 0, r = r | 0, n || hn(e, r, this.length);
  for (var i = r, a = 1, o = this[e + --i]; i > 0 && (a *= 256); )
    o += this[e + --i] * a;
  return a *= 128, o >= a && (o -= Math.pow(2, 8 * r)), o;
};
Oe.prototype.readInt8 = function(e, r) {
  return r || hn(e, 1, this.length), this[e] & 128 ? (255 - this[e] + 1) * -1 : this[e];
};
Oe.prototype.readInt16LE = function(e, r) {
  r || hn(e, 2, this.length);
  var n = this[e] | this[e + 1] << 8;
  return n & 32768 ? n | 4294901760 : n;
};
Oe.prototype.readInt16BE = function(e, r) {
  r || hn(e, 2, this.length);
  var n = this[e + 1] | this[e] << 8;
  return n & 32768 ? n | 4294901760 : n;
};
Oe.prototype.readInt32LE = function(e, r) {
  return r || hn(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
};
Oe.prototype.readInt32BE = function(e, r) {
  return r || hn(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
};
Oe.prototype.readFloatLE = function(e, r) {
  return r || hn(e, 4, this.length), cm(this, e, !0, 23, 4);
};
Oe.prototype.readFloatBE = function(e, r) {
  return r || hn(e, 4, this.length), cm(this, e, !1, 23, 4);
};
Oe.prototype.readDoubleLE = function(e, r) {
  return r || hn(e, 8, this.length), cm(this, e, !0, 52, 8);
};
Oe.prototype.readDoubleBE = function(e, r) {
  return r || hn(e, 8, this.length), cm(this, e, !1, 52, 8);
};
function Oi(t, e, r, n, i, a) {
  if (!us(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (e > i || e < a) throw new RangeError('"value" argument is out of bounds');
  if (r + n > t.length) throw new RangeError("Index out of range");
}
Oe.prototype.writeUIntLE = function(e, r, n, i) {
  if (e = +e, r = r | 0, n = n | 0, !i) {
    var a = Math.pow(2, 8 * n) - 1;
    Oi(this, e, r, n, a, 0);
  }
  var o = 1, s = 0;
  for (this[r] = e & 255; ++s < n && (o *= 256); )
    this[r + s] = e / o & 255;
  return r + n;
};
Oe.prototype.writeUIntBE = function(e, r, n, i) {
  if (e = +e, r = r | 0, n = n | 0, !i) {
    var a = Math.pow(2, 8 * n) - 1;
    Oi(this, e, r, n, a, 0);
  }
  var o = n - 1, s = 1;
  for (this[r + o] = e & 255; --o >= 0 && (s *= 256); )
    this[r + o] = e / s & 255;
  return r + n;
};
Oe.prototype.writeUInt8 = function(e, r, n) {
  return e = +e, r = r | 0, n || Oi(this, e, r, 1, 255, 0), Oe.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[r] = e & 255, r + 1;
};
function fm(t, e, r, n) {
  e < 0 && (e = 65535 + e + 1);
  for (var i = 0, a = Math.min(t.length - r, 2); i < a; ++i)
    t[r + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> (n ? i : 1 - i) * 8;
}
Oe.prototype.writeUInt16LE = function(e, r, n) {
  return e = +e, r = r | 0, n || Oi(this, e, r, 2, 65535, 0), Oe.TYPED_ARRAY_SUPPORT ? (this[r] = e & 255, this[r + 1] = e >>> 8) : fm(this, e, r, !0), r + 2;
};
Oe.prototype.writeUInt16BE = function(e, r, n) {
  return e = +e, r = r | 0, n || Oi(this, e, r, 2, 65535, 0), Oe.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 8, this[r + 1] = e & 255) : fm(this, e, r, !1), r + 2;
};
function dm(t, e, r, n) {
  e < 0 && (e = 4294967295 + e + 1);
  for (var i = 0, a = Math.min(t.length - r, 4); i < a; ++i)
    t[r + i] = e >>> (n ? i : 3 - i) * 8 & 255;
}
Oe.prototype.writeUInt32LE = function(e, r, n) {
  return e = +e, r = r | 0, n || Oi(this, e, r, 4, 4294967295, 0), Oe.TYPED_ARRAY_SUPPORT ? (this[r + 3] = e >>> 24, this[r + 2] = e >>> 16, this[r + 1] = e >>> 8, this[r] = e & 255) : dm(this, e, r, !0), r + 4;
};
Oe.prototype.writeUInt32BE = function(e, r, n) {
  return e = +e, r = r | 0, n || Oi(this, e, r, 4, 4294967295, 0), Oe.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 24, this[r + 1] = e >>> 16, this[r + 2] = e >>> 8, this[r + 3] = e & 255) : dm(this, e, r, !1), r + 4;
};
Oe.prototype.writeIntLE = function(e, r, n, i) {
  if (e = +e, r = r | 0, !i) {
    var a = Math.pow(2, 8 * n - 1);
    Oi(this, e, r, n, a - 1, -a);
  }
  var o = 0, s = 1, l = 0;
  for (this[r] = e & 255; ++o < n && (s *= 256); )
    e < 0 && l === 0 && this[r + o - 1] !== 0 && (l = 1), this[r + o] = (e / s >> 0) - l & 255;
  return r + n;
};
Oe.prototype.writeIntBE = function(e, r, n, i) {
  if (e = +e, r = r | 0, !i) {
    var a = Math.pow(2, 8 * n - 1);
    Oi(this, e, r, n, a - 1, -a);
  }
  var o = n - 1, s = 1, l = 0;
  for (this[r + o] = e & 255; --o >= 0 && (s *= 256); )
    e < 0 && l === 0 && this[r + o + 1] !== 0 && (l = 1), this[r + o] = (e / s >> 0) - l & 255;
  return r + n;
};
Oe.prototype.writeInt8 = function(e, r, n) {
  return e = +e, r = r | 0, n || Oi(this, e, r, 1, 127, -128), Oe.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[r] = e & 255, r + 1;
};
Oe.prototype.writeInt16LE = function(e, r, n) {
  return e = +e, r = r | 0, n || Oi(this, e, r, 2, 32767, -32768), Oe.TYPED_ARRAY_SUPPORT ? (this[r] = e & 255, this[r + 1] = e >>> 8) : fm(this, e, r, !0), r + 2;
};
Oe.prototype.writeInt16BE = function(e, r, n) {
  return e = +e, r = r | 0, n || Oi(this, e, r, 2, 32767, -32768), Oe.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 8, this[r + 1] = e & 255) : fm(this, e, r, !1), r + 2;
};
Oe.prototype.writeInt32LE = function(e, r, n) {
  return e = +e, r = r | 0, n || Oi(this, e, r, 4, 2147483647, -2147483648), Oe.TYPED_ARRAY_SUPPORT ? (this[r] = e & 255, this[r + 1] = e >>> 8, this[r + 2] = e >>> 16, this[r + 3] = e >>> 24) : dm(this, e, r, !0), r + 4;
};
Oe.prototype.writeInt32BE = function(e, r, n) {
  return e = +e, r = r | 0, n || Oi(this, e, r, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), Oe.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 24, this[r + 1] = e >>> 16, this[r + 2] = e >>> 8, this[r + 3] = e & 255) : dm(this, e, r, !1), r + 4;
};
function Ck(t, e, r, n, i, a) {
  if (r + n > t.length) throw new RangeError("Index out of range");
  if (r < 0) throw new RangeError("Index out of range");
}
function kk(t, e, r, n, i) {
  return i || Ck(t, e, r, 4), vk(t, e, r, n, 23, 4), r + 4;
}
Oe.prototype.writeFloatLE = function(e, r, n) {
  return kk(this, e, r, !0, n);
};
Oe.prototype.writeFloatBE = function(e, r, n) {
  return kk(this, e, r, !1, n);
};
function Tk(t, e, r, n, i) {
  return i || Ck(t, e, r, 8), vk(t, e, r, n, 52, 8), r + 8;
}
Oe.prototype.writeDoubleLE = function(e, r, n) {
  return Tk(this, e, r, !0, n);
};
Oe.prototype.writeDoubleBE = function(e, r, n) {
  return Tk(this, e, r, !1, n);
};
Oe.prototype.copy = function(e, r, n, i) {
  if (n || (n = 0), !i && i !== 0 && (i = this.length), r >= e.length && (r = e.length), r || (r = 0), i > 0 && i < n && (i = n), i === n || e.length === 0 || this.length === 0) return 0;
  if (r < 0)
    throw new RangeError("targetStart out of bounds");
  if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
  if (i < 0) throw new RangeError("sourceEnd out of bounds");
  i > this.length && (i = this.length), e.length - r < i - n && (i = e.length - r + n);
  var a = i - n, o;
  if (this === e && n < r && r < i)
    for (o = a - 1; o >= 0; --o)
      e[o + r] = this[o + n];
  else if (a < 1e3 || !Oe.TYPED_ARRAY_SUPPORT)
    for (o = 0; o < a; ++o)
      e[o + r] = this[o + n];
  else
    Uint8Array.prototype.set.call(
      e,
      this.subarray(n, n + a),
      r
    );
  return a;
};
Oe.prototype.fill = function(e, r, n, i) {
  if (typeof e == "string") {
    if (typeof r == "string" ? (i = r, r = 0, n = this.length) : typeof n == "string" && (i = n, n = this.length), e.length === 1) {
      var a = e.charCodeAt(0);
      a < 256 && (e = a);
    }
    if (i !== void 0 && typeof i != "string")
      throw new TypeError("encoding must be a string");
    if (typeof i == "string" && !Oe.isEncoding(i))
      throw new TypeError("Unknown encoding: " + i);
  } else typeof e == "number" && (e = e & 255);
  if (r < 0 || this.length < r || this.length < n)
    throw new RangeError("Out of range index");
  if (n <= r)
    return this;
  r = r >>> 0, n = n === void 0 ? this.length : n >>> 0, e || (e = 0);
  var o;
  if (typeof e == "number")
    for (o = r; o < n; ++o)
      this[o] = e;
  else {
    var s = us(e) ? e : ip(new Oe(e, i).toString()), l = s.length;
    for (o = 0; o < n - r; ++o)
      this[o + r] = s[o % l];
  }
  return this;
};
var yQ = /[^+\/0-9A-Za-z-_]/g;
function wQ(t) {
  if (t = _Q(t).replace(yQ, ""), t.length < 2) return "";
  for (; t.length % 4 !== 0; )
    t = t + "=";
  return t;
}
function _Q(t) {
  return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
}
function AQ(t) {
  return t < 16 ? "0" + t.toString(16) : t.toString(16);
}
function ip(t, e) {
  e = e || 1 / 0;
  for (var r, n = t.length, i = null, a = [], o = 0; o < n; ++o) {
    if (r = t.charCodeAt(o), r > 55295 && r < 57344) {
      if (!i) {
        if (r > 56319) {
          (e -= 3) > -1 && a.push(239, 191, 189);
          continue;
        } else if (o + 1 === n) {
          (e -= 3) > -1 && a.push(239, 191, 189);
          continue;
        }
        i = r;
        continue;
      }
      if (r < 56320) {
        (e -= 3) > -1 && a.push(239, 191, 189), i = r;
        continue;
      }
      r = (i - 55296 << 10 | r - 56320) + 65536;
    } else i && (e -= 3) > -1 && a.push(239, 191, 189);
    if (i = null, r < 128) {
      if ((e -= 1) < 0) break;
      a.push(r);
    } else if (r < 2048) {
      if ((e -= 2) < 0) break;
      a.push(
        r >> 6 | 192,
        r & 63 | 128
      );
    } else if (r < 65536) {
      if ((e -= 3) < 0) break;
      a.push(
        r >> 12 | 224,
        r >> 6 & 63 | 128,
        r & 63 | 128
      );
    } else if (r < 1114112) {
      if ((e -= 4) < 0) break;
      a.push(
        r >> 18 | 240,
        r >> 12 & 63 | 128,
        r >> 6 & 63 | 128,
        r & 63 | 128
      );
    } else
      throw new Error("Invalid code point");
  }
  return a;
}
function EQ(t) {
  for (var e = [], r = 0; r < t.length; ++r)
    e.push(t.charCodeAt(r) & 255);
  return e;
}
function SQ(t, e) {
  for (var r, n, i, a = [], o = 0; o < t.length && !((e -= 2) < 0); ++o)
    r = t.charCodeAt(o), n = r >> 8, i = r % 256, a.push(i), a.push(n);
  return a;
}
function Fk(t) {
  return JJ(wQ(t));
}
function hm(t, e, r, n) {
  for (var i = 0; i < n && !(i + r >= e.length || i >= t.length); ++i)
    e[i + r] = t[i];
  return i;
}
function CQ(t) {
  return t !== t;
}
function ec(t) {
  return t != null && (!!t._isBuffer || Dk(t) || kQ(t));
}
function Dk(t) {
  return !!t.constructor && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
}
function kQ(t) {
  return typeof t.readFloatLE == "function" && typeof t.slice == "function" && Dk(t.slice(0, 0));
}
var TQ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Buffer: Oe,
  INSPECT_MAX_BYTES: xk,
  SlowBuffer: sQ,
  isBuffer: ec,
  kMaxLength: rQ
}), ap = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ok(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function F1(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), r;
}
var L3 = { exports: {} }, D1 = {};
function Rk() {
  throw new Error("setTimeout has not been defined");
}
function Pk() {
  throw new Error("clearTimeout has not been defined");
}
var Ul = Rk, zl = Pk;
typeof Ec.setTimeout == "function" && (Ul = setTimeout);
typeof Ec.clearTimeout == "function" && (zl = clearTimeout);
function Ik(t) {
  if (Ul === setTimeout)
    return setTimeout(t, 0);
  if ((Ul === Rk || !Ul) && setTimeout)
    return Ul = setTimeout, setTimeout(t, 0);
  try {
    return Ul(t, 0);
  } catch {
    try {
      return Ul.call(null, t, 0);
    } catch {
      return Ul.call(this, t, 0);
    }
  }
}
function FQ(t) {
  if (zl === clearTimeout)
    return clearTimeout(t);
  if ((zl === Pk || !zl) && clearTimeout)
    return zl = clearTimeout, clearTimeout(t);
  try {
    return zl(t);
  } catch {
    try {
      return zl.call(null, t);
    } catch {
      return zl.call(this, t);
    }
  }
}
var tl = [], e1 = !1, tc, p5 = -1;
function DQ() {
  !e1 || !tc || (e1 = !1, tc.length ? tl = tc.concat(tl) : p5 = -1, tl.length && Bk());
}
function Bk() {
  if (!e1) {
    var t = Ik(DQ);
    e1 = !0;
    for (var e = tl.length; e; ) {
      for (tc = tl, tl = []; ++p5 < e; )
        tc && tc[p5].run();
      p5 = -1, e = tl.length;
    }
    tc = null, e1 = !1, FQ(t);
  }
}
function OQ(t) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var r = 1; r < arguments.length; r++)
      e[r - 1] = arguments[r];
  tl.push(new Lk(t, e)), tl.length === 1 && !e1 && Ik(Bk);
}
function Lk(t, e) {
  this.fun = t, this.array = e;
}
Lk.prototype.run = function() {
  this.fun.apply(null, this.array);
};
var RQ = "browser", PQ = "browser", IQ = !0, BQ = {}, LQ = [], NQ = "", MQ = {}, UQ = {}, zQ = {};
function Lc() {
}
var $Q = Lc, VQ = Lc, jQ = Lc, WQ = Lc, HQ = Lc, qQ = Lc, YQ = Lc;
function GQ(t) {
  throw new Error("process.binding is not supported");
}
function ZQ() {
  return "/";
}
function XQ(t) {
  throw new Error("process.chdir is not supported");
}
function KQ() {
  return 0;
}
var Mf = Ec.performance || {}, JQ = Mf.now || Mf.mozNow || Mf.msNow || Mf.oNow || Mf.webkitNow || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function QQ(t) {
  var e = JQ.call(Mf) * 1e-3, r = Math.floor(e), n = Math.floor(e % 1 * 1e9);
  return t && (r = r - t[0], n = n - t[1], n < 0 && (r--, n += 1e9)), [r, n];
}
var eee = /* @__PURE__ */ new Date();
function tee() {
  var t = /* @__PURE__ */ new Date(), e = t - eee;
  return e / 1e3;
}
var Qt = {
  nextTick: OQ,
  title: RQ,
  browser: IQ,
  env: BQ,
  argv: LQ,
  version: NQ,
  versions: MQ,
  on: $Q,
  addListener: VQ,
  once: jQ,
  off: WQ,
  removeListener: HQ,
  removeAllListeners: qQ,
  emit: YQ,
  binding: GQ,
  cwd: ZQ,
  chdir: XQ,
  umask: KQ,
  hrtime: QQ,
  platform: PQ,
  release: UQ,
  config: zQ,
  uptime: tee
}, ree;
function ru() {
}
ru.prototype = /* @__PURE__ */ Object.create(null);
function B0() {
  B0.init.call(this);
}
B0.EventEmitter = B0;
B0.usingDomains = !1;
B0.prototype.domain = void 0;
B0.prototype._events = void 0;
B0.prototype._maxListeners = void 0;
B0.defaultMaxListeners = 10;
B0.init = function() {
  this.domain = null, B0.usingDomains && ree.active, (!this._events || this._events === Object.getPrototypeOf(this)._events) && (this._events = new ru(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
B0.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || isNaN(e))
    throw new TypeError('"n" argument must be a positive number');
  return this._maxListeners = e, this;
};
function Nk(t) {
  return t._maxListeners === void 0 ? B0.defaultMaxListeners : t._maxListeners;
}
B0.prototype.getMaxListeners = function() {
  return Nk(this);
};
function nee(t, e, r) {
  if (e)
    t.call(r);
  else
    for (var n = t.length, i = zh(t, n), a = 0; a < n; ++a)
      i[a].call(r);
}
function iee(t, e, r, n) {
  if (e)
    t.call(r, n);
  else
    for (var i = t.length, a = zh(t, i), o = 0; o < i; ++o)
      a[o].call(r, n);
}
function aee(t, e, r, n, i) {
  if (e)
    t.call(r, n, i);
  else
    for (var a = t.length, o = zh(t, a), s = 0; s < a; ++s)
      o[s].call(r, n, i);
}
function oee(t, e, r, n, i, a) {
  if (e)
    t.call(r, n, i, a);
  else
    for (var o = t.length, s = zh(t, o), l = 0; l < o; ++l)
      s[l].call(r, n, i, a);
}
function see(t, e, r, n) {
  if (e)
    t.apply(r, n);
  else
    for (var i = t.length, a = zh(t, i), o = 0; o < i; ++o)
      a[o].apply(r, n);
}
B0.prototype.emit = function(e) {
  var r, n, i, a, o, s, l, u = e === "error";
  if (s = this._events, s)
    u = u && s.error == null;
  else if (!u)
    return !1;
  if (l = this.domain, u) {
    if (r = arguments[1], l)
      r || (r = new Error('Uncaught, unspecified "error" event')), r.domainEmitter = this, r.domain = l, r.domainThrown = !1, l.emit("error", r);
    else {
      if (r instanceof Error)
        throw r;
      var d = new Error('Uncaught, unspecified "error" event. (' + r + ")");
      throw d.context = r, d;
    }
    return !1;
  }
  if (n = s[e], !n)
    return !1;
  var h = typeof n == "function";
  switch (i = arguments.length, i) {
    case 1:
      nee(n, h, this);
      break;
    case 2:
      iee(n, h, this, arguments[1]);
      break;
    case 3:
      aee(n, h, this, arguments[1], arguments[2]);
      break;
    case 4:
      oee(n, h, this, arguments[1], arguments[2], arguments[3]);
      break;
    default:
      for (a = new Array(i - 1), o = 1; o < i; o++)
        a[o - 1] = arguments[o];
      see(n, h, this, a);
  }
  return !0;
};
function Mk(t, e, r, n) {
  var i, a, o;
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  if (a = t._events, a ? (a.newListener && (t.emit(
    "newListener",
    e,
    r.listener ? r.listener : r
  ), a = t._events), o = a[e]) : (a = t._events = new ru(), t._eventsCount = 0), !o)
    o = a[e] = r, ++t._eventsCount;
  else if (typeof o == "function" ? o = a[e] = n ? [r, o] : [o, r] : n ? o.unshift(r) : o.push(r), !o.warned && (i = Nk(t), i && i > 0 && o.length > i)) {
    o.warned = !0;
    var s = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + e + " listeners added. Use emitter.setMaxListeners() to increase limit");
    s.name = "MaxListenersExceededWarning", s.emitter = t, s.type = e, s.count = o.length, lee(s);
  }
  return t;
}
function lee(t) {
  typeof console.warn == "function" ? console.warn(t) : console.log(t);
}
B0.prototype.addListener = function(e, r) {
  return Mk(this, e, r, !1);
};
B0.prototype.on = B0.prototype.addListener;
B0.prototype.prependListener = function(e, r) {
  return Mk(this, e, r, !0);
};
function Uk(t, e, r) {
  var n = !1;
  function i() {
    t.removeListener(e, i), n || (n = !0, r.apply(t, arguments));
  }
  return i.listener = r, i;
}
B0.prototype.once = function(e, r) {
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  return this.on(e, Uk(this, e, r)), this;
};
B0.prototype.prependOnceListener = function(e, r) {
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  return this.prependListener(e, Uk(this, e, r)), this;
};
B0.prototype.removeListener = function(e, r) {
  var n, i, a, o, s;
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  if (i = this._events, !i)
    return this;
  if (n = i[e], !n)
    return this;
  if (n === r || n.listener && n.listener === r)
    --this._eventsCount === 0 ? this._events = new ru() : (delete i[e], i.removeListener && this.emit("removeListener", e, n.listener || r));
  else if (typeof n != "function") {
    for (a = -1, o = n.length; o-- > 0; )
      if (n[o] === r || n[o].listener && n[o].listener === r) {
        s = n[o].listener, a = o;
        break;
      }
    if (a < 0)
      return this;
    if (n.length === 1) {
      if (n[0] = void 0, --this._eventsCount === 0)
        return this._events = new ru(), this;
      delete i[e];
    } else
      uee(n, a);
    i.removeListener && this.emit("removeListener", e, s || r);
  }
  return this;
};
B0.prototype.off = function(t, e) {
  return this.removeListener(t, e);
};
B0.prototype.removeAllListeners = function(e) {
  var r, n;
  if (n = this._events, !n)
    return this;
  if (!n.removeListener)
    return arguments.length === 0 ? (this._events = new ru(), this._eventsCount = 0) : n[e] && (--this._eventsCount === 0 ? this._events = new ru() : delete n[e]), this;
  if (arguments.length === 0) {
    for (var i = Object.keys(n), a = 0, o; a < i.length; ++a)
      o = i[a], o !== "removeListener" && this.removeAllListeners(o);
    return this.removeAllListeners("removeListener"), this._events = new ru(), this._eventsCount = 0, this;
  }
  if (r = n[e], typeof r == "function")
    this.removeListener(e, r);
  else if (r)
    do
      this.removeListener(e, r[r.length - 1]);
    while (r[0]);
  return this;
};
B0.prototype.listeners = function(e) {
  var r, n, i = this._events;
  return i ? (r = i[e], r ? typeof r == "function" ? n = [r.listener || r] : n = cee(r) : n = []) : n = [], n;
};
B0.listenerCount = function(t, e) {
  return typeof t.listenerCount == "function" ? t.listenerCount(e) : zk.call(t, e);
};
B0.prototype.listenerCount = zk;
function zk(t) {
  var e = this._events;
  if (e) {
    var r = e[t];
    if (typeof r == "function")
      return 1;
    if (r)
      return r.length;
  }
  return 0;
}
B0.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};
function uee(t, e) {
  for (var r = e, n = r + 1, i = t.length; n < i; r += 1, n += 1)
    t[r] = t[n];
  t.pop();
}
function zh(t, e) {
  for (var r = new Array(e); e--; )
    r[e] = t[e];
  return r;
}
function cee(t) {
  for (var e = new Array(t.length), r = 0; r < e.length; ++r)
    e[r] = t[r].listener || t[r];
  return e;
}
var fee = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  EventEmitter: B0,
  default: B0
}), $k = /* @__PURE__ */ F1(fee), Vk = $k.EventEmitter, hh = /* @__PURE__ */ F1(TQ), ph;
typeof Object.create == "function" ? ph = function(e, r) {
  e.super_ = r, e.prototype = Object.create(r.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  });
} : ph = function(e, r) {
  e.super_ = r;
  var n = function() {
  };
  n.prototype = r.prototype, e.prototype = new n(), e.prototype.constructor = e;
};
var jk = Object.getOwnPropertyDescriptors || function(e) {
  for (var r = Object.keys(e), n = {}, i = 0; i < r.length; i++)
    n[r[i]] = Object.getOwnPropertyDescriptor(e, r[i]);
  return n;
}, dee = /%[sdj%]/g;
function pm(t) {
  if (!Vh(t)) {
    for (var e = [], r = 0; r < arguments.length; r++)
      e.push(ro(arguments[r]));
    return e.join(" ");
  }
  for (var r = 1, n = arguments, i = n.length, a = String(t).replace(dee, function(s) {
    if (s === "%%") return "%";
    if (r >= i) return s;
    switch (s) {
      case "%s":
        return String(n[r++]);
      case "%d":
        return Number(n[r++]);
      case "%j":
        try {
          return JSON.stringify(n[r++]);
        } catch {
          return "[Circular]";
        }
      default:
        return s;
    }
  }), o = n[r]; r < i; o = n[++r])
    $h(o) || !Nc(o) ? a += " " + o : a += " " + ro(o);
  return a;
}
function xx(t, e) {
  if (es(Ec.process))
    return function() {
      return xx(t, e).apply(this, arguments);
    };
  if (Qt.noDeprecation === !0)
    return t;
  var r = !1;
  function n() {
    if (!r) {
      if (Qt.throwDeprecation)
        throw new Error(e);
      Qt.traceDeprecation ? console.trace(e) : console.error(e), r = !0;
    }
    return t.apply(this, arguments);
  }
  return n;
}
var z2 = {}, cv;
function Wk(t) {
  if (es(cv) && (cv = Qt.env.NODE_DEBUG || ""), t = t.toUpperCase(), !z2[t])
    if (new RegExp("\\b" + t + "\\b", "i").test(cv)) {
      var e = 0;
      z2[t] = function() {
        var r = pm.apply(null, arguments);
        console.error("%s %d: %s", t, e, r);
      };
    } else
      z2[t] = function() {
      };
  return z2[t];
}
function ro(t, e) {
  var r = {
    seen: [],
    stylize: pee
  };
  return arguments.length >= 3 && (r.depth = arguments[2]), arguments.length >= 4 && (r.colors = arguments[3]), mm(e) ? r.showHidden = e : e && Ax(r, e), es(r.showHidden) && (r.showHidden = !1), es(r.depth) && (r.depth = 2), es(r.colors) && (r.colors = !1), es(r.customInspect) && (r.customInspect = !0), r.colors && (r.stylize = hee), op(r, t, r.depth);
}
ro.colors = {
  bold: [1, 22],
  italic: [3, 23],
  underline: [4, 24],
  inverse: [7, 27],
  white: [37, 39],
  grey: [90, 39],
  black: [30, 39],
  blue: [34, 39],
  cyan: [36, 39],
  green: [32, 39],
  magenta: [35, 39],
  red: [31, 39],
  yellow: [33, 39]
};
ro.styles = {
  special: "cyan",
  number: "yellow",
  boolean: "yellow",
  undefined: "grey",
  null: "bold",
  string: "green",
  date: "magenta",
  // "name": intentionally not styling
  regexp: "red"
};
function hee(t, e) {
  var r = ro.styles[e];
  return r ? "\x1B[" + ro.colors[r][0] + "m" + t + "\x1B[" + ro.colors[r][1] + "m" : t;
}
function pee(t, e) {
  return t;
}
function mee(t) {
  var e = {};
  return t.forEach(function(r, n) {
    e[r] = !0;
  }), e;
}
function op(t, e, r) {
  if (t.customInspect && e && hc(e.inspect) && // Filter out the util module, it's inspect function is special
  e.inspect !== ro && // Also filter out any prototype objects using the circular check.
  !(e.constructor && e.constructor.prototype === e)) {
    var n = e.inspect(r, t);
    return Vh(n) || (n = op(t, n, r)), n;
  }
  var i = gee(t, e);
  if (i)
    return i;
  var a = Object.keys(e), o = mee(a);
  if (t.showHidden && (a = Object.getOwnPropertyNames(e)), t1(e) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0))
    return fv(e);
  if (a.length === 0) {
    if (hc(e)) {
      var s = e.name ? ": " + e.name : "";
      return t.stylize("[Function" + s + "]", "special");
    }
    if (dc(e))
      return t.stylize(RegExp.prototype.toString.call(e), "regexp");
    if (h1(e))
      return t.stylize(Date.prototype.toString.call(e), "date");
    if (t1(e))
      return fv(e);
  }
  var l = "", u = !1, d = ["{", "}"];
  if (yx(e) && (u = !0, d = ["[", "]"]), hc(e)) {
    var h = e.name ? ": " + e.name : "";
    l = " [Function" + h + "]";
  }
  if (dc(e) && (l = " " + RegExp.prototype.toString.call(e)), h1(e) && (l = " " + Date.prototype.toUTCString.call(e)), t1(e) && (l = " " + fv(e)), a.length === 0 && (!u || e.length == 0))
    return d[0] + l + d[1];
  if (r < 0)
    return dc(e) ? t.stylize(RegExp.prototype.toString.call(e), "regexp") : t.stylize("[Object]", "special");
  t.seen.push(e);
  var v;
  return u ? v = vee(t, e, r, o, a) : v = a.map(function(b) {
    return N3(t, e, r, o, b, u);
  }), t.seen.pop(), bee(v, l, d);
}
function gee(t, e) {
  if (es(e))
    return t.stylize("undefined", "undefined");
  if (Vh(e)) {
    var r = "'" + JSON.stringify(e).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
    return t.stylize(r, "string");
  }
  if (wx(e))
    return t.stylize("" + e, "number");
  if (mm(e))
    return t.stylize("" + e, "boolean");
  if ($h(e))
    return t.stylize("null", "null");
}
function fv(t) {
  return "[" + Error.prototype.toString.call(t) + "]";
}
function vee(t, e, r, n, i) {
  for (var a = [], o = 0, s = e.length; o < s; ++o)
    Zk(e, String(o)) ? a.push(N3(
      t,
      e,
      r,
      n,
      String(o),
      !0
    )) : a.push("");
  return i.forEach(function(l) {
    l.match(/^\d+$/) || a.push(N3(
      t,
      e,
      r,
      n,
      l,
      !0
    ));
  }), a;
}
function N3(t, e, r, n, i, a) {
  var o, s, l;
  if (l = Object.getOwnPropertyDescriptor(e, i) || { value: e[i] }, l.get ? l.set ? s = t.stylize("[Getter/Setter]", "special") : s = t.stylize("[Getter]", "special") : l.set && (s = t.stylize("[Setter]", "special")), Zk(n, i) || (o = "[" + i + "]"), s || (t.seen.indexOf(l.value) < 0 ? ($h(r) ? s = op(t, l.value, null) : s = op(t, l.value, r - 1), s.indexOf(`
`) > -1 && (a ? s = s.split(`
`).map(function(u) {
    return "  " + u;
  }).join(`
`).substr(2) : s = `
` + s.split(`
`).map(function(u) {
    return "   " + u;
  }).join(`
`))) : s = t.stylize("[Circular]", "special")), es(o)) {
    if (a && i.match(/^\d+$/))
      return s;
    o = JSON.stringify("" + i), o.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.substr(1, o.length - 2), o = t.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), o = t.stylize(o, "string"));
  }
  return o + ": " + s;
}
function bee(t, e, r) {
  var n = t.reduce(function(i, a) {
    return a.indexOf(`
`) >= 0, i + a.replace(/\u001b\[\d\d?m/g, "").length + 1;
  }, 0);
  return n > 60 ? r[0] + (e === "" ? "" : e + `
 `) + " " + t.join(`,
  `) + " " + r[1] : r[0] + e + " " + t.join(", ") + " " + r[1];
}
function yx(t) {
  return Array.isArray(t);
}
function mm(t) {
  return typeof t == "boolean";
}
function $h(t) {
  return t === null;
}
function Hk(t) {
  return t == null;
}
function wx(t) {
  return typeof t == "number";
}
function Vh(t) {
  return typeof t == "string";
}
function qk(t) {
  return typeof t == "symbol";
}
function es(t) {
  return t === void 0;
}
function dc(t) {
  return Nc(t) && _x(t) === "[object RegExp]";
}
function Nc(t) {
  return typeof t == "object" && t !== null;
}
function h1(t) {
  return Nc(t) && _x(t) === "[object Date]";
}
function t1(t) {
  return Nc(t) && (_x(t) === "[object Error]" || t instanceof Error);
}
function hc(t) {
  return typeof t == "function";
}
function sp(t) {
  return t === null || typeof t == "boolean" || typeof t == "number" || typeof t == "string" || typeof t == "symbol" || // ES6 symbol
  typeof t > "u";
}
function Yk(t) {
  return Oe.isBuffer(t);
}
function _x(t) {
  return Object.prototype.toString.call(t);
}
function dv(t) {
  return t < 10 ? "0" + t.toString(10) : t.toString(10);
}
var xee = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
function yee() {
  var t = /* @__PURE__ */ new Date(), e = [
    dv(t.getHours()),
    dv(t.getMinutes()),
    dv(t.getSeconds())
  ].join(":");
  return [t.getDate(), xee[t.getMonth()], e].join(" ");
}
function Gk() {
  console.log("%s - %s", yee(), pm.apply(null, arguments));
}
function Ax(t, e) {
  if (!e || !Nc(e)) return t;
  for (var r = Object.keys(e), n = r.length; n--; )
    t[r[n]] = e[r[n]];
  return t;
}
function Zk(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
var Uu = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
function Ex(t) {
  if (typeof t != "function")
    throw new TypeError('The "original" argument must be of type Function');
  if (Uu && t[Uu]) {
    var e = t[Uu];
    if (typeof e != "function")
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    return Object.defineProperty(e, Uu, {
      value: e,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), e;
  }
  function e() {
    for (var r, n, i = new Promise(function(s, l) {
      r = s, n = l;
    }), a = [], o = 0; o < arguments.length; o++)
      a.push(arguments[o]);
    a.push(function(s, l) {
      s ? n(s) : r(l);
    });
    try {
      t.apply(this, a);
    } catch (s) {
      n(s);
    }
    return i;
  }
  return Object.setPrototypeOf(e, Object.getPrototypeOf(t)), Uu && Object.defineProperty(e, Uu, {
    value: e,
    enumerable: !1,
    writable: !1,
    configurable: !0
  }), Object.defineProperties(
    e,
    jk(t)
  );
}
Ex.custom = Uu;
function wee(t, e) {
  if (!t) {
    var r = new Error("Promise was rejected with a falsy value");
    r.reason = t, t = r;
  }
  return e(t);
}
function Xk(t) {
  if (typeof t != "function")
    throw new TypeError('The "original" argument must be of type Function');
  function e() {
    for (var r = [], n = 0; n < arguments.length; n++)
      r.push(arguments[n]);
    var i = r.pop();
    if (typeof i != "function")
      throw new TypeError("The last argument must be of type Function");
    var a = this, o = function() {
      return i.apply(a, arguments);
    };
    t.apply(this, r).then(
      function(s) {
        Qt.nextTick(o.bind(null, null, s));
      },
      function(s) {
        Qt.nextTick(wee.bind(null, s, o));
      }
    );
  }
  return Object.setPrototypeOf(e, Object.getPrototypeOf(t)), Object.defineProperties(e, jk(t)), e;
}
var _ee = {
  inherits: ph,
  _extend: Ax,
  log: Gk,
  isBuffer: Yk,
  isPrimitive: sp,
  isFunction: hc,
  isError: t1,
  isDate: h1,
  isObject: Nc,
  isRegExp: dc,
  isUndefined: es,
  isSymbol: qk,
  isString: Vh,
  isNumber: wx,
  isNullOrUndefined: Hk,
  isNull: $h,
  isBoolean: mm,
  isArray: yx,
  inspect: ro,
  deprecate: xx,
  format: pm,
  debuglog: Wk,
  promisify: Ex,
  callbackify: Xk
}, Aee = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _extend: Ax,
  callbackify: Xk,
  debuglog: Wk,
  default: _ee,
  deprecate: xx,
  format: pm,
  inherits: ph,
  inspect: ro,
  isArray: yx,
  isBoolean: mm,
  isBuffer: Yk,
  isDate: h1,
  isError: t1,
  isFunction: hc,
  isNull: $h,
  isNullOrUndefined: Hk,
  isNumber: wx,
  isObject: Nc,
  isPrimitive: sp,
  isRegExp: dc,
  isString: Vh,
  isSymbol: qk,
  isUndefined: es,
  log: Gk,
  promisify: Ex
}), Sx = /* @__PURE__ */ F1(Aee), hv, e9;
function Eee() {
  if (e9) return hv;
  e9 = 1;
  function t(v, b) {
    var x = Object.keys(v);
    if (Object.getOwnPropertySymbols) {
      var A = Object.getOwnPropertySymbols(v);
      b && (A = A.filter(function(T) {
        return Object.getOwnPropertyDescriptor(v, T).enumerable;
      })), x.push.apply(x, A);
    }
    return x;
  }
  function e(v) {
    for (var b = 1; b < arguments.length; b++) {
      var x = arguments[b] != null ? arguments[b] : {};
      b % 2 ? t(Object(x), !0).forEach(function(A) {
        r(v, A, x[A]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(v, Object.getOwnPropertyDescriptors(x)) : t(Object(x)).forEach(function(A) {
        Object.defineProperty(v, A, Object.getOwnPropertyDescriptor(x, A));
      });
    }
    return v;
  }
  function r(v, b, x) {
    return b in v ? Object.defineProperty(v, b, {
      value: x,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : v[b] = x, v;
  }
  function n(v, b) {
    if (!(v instanceof b))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(v, b) {
    for (var x = 0; x < b.length; x++) {
      var A = b[x];
      A.enumerable = A.enumerable || !1, A.configurable = !0, "value" in A && (A.writable = !0), Object.defineProperty(v, A.key, A);
    }
  }
  function a(v, b, x) {
    return b && i(v.prototype, b), v;
  }
  var o = hh, s = o.Buffer, l = Sx, u = l.inspect, d = u && u.custom || "inspect";
  function h(v, b, x) {
    s.prototype.copy.call(v, b, x);
  }
  return hv = /* @__PURE__ */ function() {
    function v() {
      n(this, v), this.head = null, this.tail = null, this.length = 0;
    }
    return a(v, [{
      key: "push",
      value: function(x) {
        var A = {
          data: x,
          next: null
        };
        this.length > 0 ? this.tail.next = A : this.head = A, this.tail = A, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(x) {
        var A = {
          data: x,
          next: this.head
        };
        this.length === 0 && (this.tail = A), this.head = A, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var x = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, x;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(x) {
        if (this.length === 0) return "";
        for (var A = this.head, T = "" + A.data; A = A.next; )
          T += x + A.data;
        return T;
      }
    }, {
      key: "concat",
      value: function(x) {
        if (this.length === 0) return s.alloc(0);
        for (var A = s.allocUnsafe(x >>> 0), T = this.head, k = 0; T; )
          h(T.data, A, k), k += T.data.length, T = T.next;
        return A;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(x, A) {
        var T;
        return x < this.head.data.length ? (T = this.head.data.slice(0, x), this.head.data = this.head.data.slice(x)) : x === this.head.data.length ? T = this.shift() : T = A ? this._getString(x) : this._getBuffer(x), T;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(x) {
        var A = this.head, T = 1, k = A.data;
        for (x -= k.length; A = A.next; ) {
          var E = A.data, C = x > E.length ? E.length : x;
          if (C === E.length ? k += E : k += E.slice(0, x), x -= C, x === 0) {
            C === E.length ? (++T, A.next ? this.head = A.next : this.head = this.tail = null) : (this.head = A, A.data = E.slice(C));
            break;
          }
          ++T;
        }
        return this.length -= T, k;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(x) {
        var A = s.allocUnsafe(x), T = this.head, k = 1;
        for (T.data.copy(A), x -= T.data.length; T = T.next; ) {
          var E = T.data, C = x > E.length ? E.length : x;
          if (E.copy(A, A.length - x, 0, C), x -= C, x === 0) {
            C === E.length ? (++k, T.next ? this.head = T.next : this.head = this.tail = null) : (this.head = T, T.data = E.slice(C));
            break;
          }
          ++k;
        }
        return this.length -= k, A;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: d,
      value: function(x, A) {
        return u(this, e({}, A, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), v;
  }(), hv;
}
function See(t, e) {
  var r = this, n = this._readableState && this._readableState.destroyed, i = this._writableState && this._writableState.destroyed;
  return n || i ? (e ? e(t) : t && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, Qt.nextTick(M3, this, t)) : Qt.nextTick(M3, this, t)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function(a) {
    !e && a ? r._writableState ? r._writableState.errorEmitted ? Qt.nextTick(m5, r) : (r._writableState.errorEmitted = !0, Qt.nextTick(t9, r, a)) : Qt.nextTick(t9, r, a) : e ? (Qt.nextTick(m5, r), e(a)) : Qt.nextTick(m5, r);
  }), this);
}
function t9(t, e) {
  M3(t, e), m5(t);
}
function m5(t) {
  t._writableState && !t._writableState.emitClose || t._readableState && !t._readableState.emitClose || t.emit("close");
}
function Cee() {
  this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function M3(t, e) {
  t.emit("error", e);
}
function kee(t, e) {
  var r = t._readableState, n = t._writableState;
  r && r.autoDestroy || n && n.autoDestroy ? t.destroy(e) : t.emit("error", e);
}
var Kk = {
  destroy: See,
  undestroy: Cee,
  errorOrDestroy: kee
}, Mc = {};
function Tee(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
var Jk = {};
function Ta(t, e, r) {
  r || (r = Error);
  function n(a, o, s) {
    return typeof e == "string" ? e : e(a, o, s);
  }
  var i = /* @__PURE__ */ function(a) {
    Tee(o, a);
    function o(s, l, u) {
      return a.call(this, n(s, l, u)) || this;
    }
    return o;
  }(r);
  i.prototype.name = r.name, i.prototype.code = t, Jk[t] = i;
}
function r9(t, e) {
  if (Array.isArray(t)) {
    var r = t.length;
    return t = t.map(function(n) {
      return String(n);
    }), r > 2 ? "one of ".concat(e, " ").concat(t.slice(0, r - 1).join(", "), ", or ") + t[r - 1] : r === 2 ? "one of ".concat(e, " ").concat(t[0], " or ").concat(t[1]) : "of ".concat(e, " ").concat(t[0]);
  } else
    return "of ".concat(e, " ").concat(String(t));
}
function Fee(t, e, r) {
  return t.substr(0, e.length) === e;
}
function Dee(t, e, r) {
  return (r === void 0 || r > t.length) && (r = t.length), t.substring(r - e.length, r) === e;
}
function Oee(t, e, r) {
  return typeof r != "number" && (r = 0), r + e.length > t.length ? !1 : t.indexOf(e, r) !== -1;
}
Ta("ERR_INVALID_OPT_VALUE", function(t, e) {
  return 'The value "' + e + '" is invalid for option "' + t + '"';
}, TypeError);
Ta("ERR_INVALID_ARG_TYPE", function(t, e, r) {
  var n;
  typeof e == "string" && Fee(e, "not ") ? (n = "must not be", e = e.replace(/^not /, "")) : n = "must be";
  var i;
  if (Dee(t, " argument"))
    i = "The ".concat(t, " ").concat(n, " ").concat(r9(e, "type"));
  else {
    var a = Oee(t, ".") ? "property" : "argument";
    i = 'The "'.concat(t, '" ').concat(a, " ").concat(n, " ").concat(r9(e, "type"));
  }
  return i += ". Received type ".concat(typeof r), i;
}, TypeError);
Ta("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
Ta("ERR_METHOD_NOT_IMPLEMENTED", function(t) {
  return "The " + t + " method is not implemented";
});
Ta("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
Ta("ERR_STREAM_DESTROYED", function(t) {
  return "Cannot call " + t + " after a stream was destroyed";
});
Ta("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
Ta("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
Ta("ERR_STREAM_WRITE_AFTER_END", "write after end");
Ta("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
Ta("ERR_UNKNOWN_ENCODING", function(t) {
  return "Unknown encoding: " + t;
}, TypeError);
Ta("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
Mc.codes = Jk;
var Ree = Mc.codes.ERR_INVALID_OPT_VALUE;
function Pee(t, e, r) {
  return t.highWaterMark != null ? t.highWaterMark : e ? t[r] : null;
}
function Iee(t, e, r, n) {
  var i = Pee(e, n, r);
  if (i != null) {
    if (!(isFinite(i) && Math.floor(i) === i) || i < 0) {
      var a = n ? r : "highWaterMark";
      throw new Ree(a, i);
    }
    return Math.floor(i);
  }
  return t.objectMode ? 16 : 16 * 1024;
}
var Qk = {
  getHighWaterMark: Iee
}, U3;
typeof Object.create == "function" ? U3 = function(e, r) {
  e.super_ = r, e.prototype = Object.create(r.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  });
} : U3 = function(e, r) {
  e.super_ = r;
  var n = function() {
  };
  n.prototype = r.prototype, e.prototype = new n(), e.prototype.constructor = e;
};
var Bee = U3, Lee = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Bee
}), jh = /* @__PURE__ */ F1(Lee), Nee = Oe.isEncoding || function(t) {
  switch (t && t.toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
    case "raw":
      return !0;
    default:
      return !1;
  }
};
function Mee(t) {
  if (t && !Nee(t))
    throw new Error("Unknown encoding: " + t);
}
function gm(t) {
  switch (this.encoding = (t || "utf8").toLowerCase().replace(/[-_]/, ""), Mee(t), this.encoding) {
    case "utf8":
      this.surrogateSize = 3;
      break;
    case "ucs2":
    case "utf16le":
      this.surrogateSize = 2, this.detectIncompleteChar = zee;
      break;
    case "base64":
      this.surrogateSize = 3, this.detectIncompleteChar = $ee;
      break;
    default:
      this.write = Uee;
      return;
  }
  this.charBuffer = new Oe(6), this.charReceived = 0, this.charLength = 0;
}
gm.prototype.write = function(t) {
  for (var e = ""; this.charLength; ) {
    var r = t.length >= this.charLength - this.charReceived ? this.charLength - this.charReceived : t.length;
    if (t.copy(this.charBuffer, this.charReceived, 0, r), this.charReceived += r, this.charReceived < this.charLength)
      return "";
    t = t.slice(r, t.length), e = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
    var i = e.charCodeAt(e.length - 1);
    if (i >= 55296 && i <= 56319) {
      this.charLength += this.surrogateSize, e = "";
      continue;
    }
    if (this.charReceived = this.charLength = 0, t.length === 0)
      return e;
    break;
  }
  this.detectIncompleteChar(t);
  var n = t.length;
  this.charLength && (t.copy(this.charBuffer, 0, t.length - this.charReceived, n), n -= this.charReceived), e += t.toString(this.encoding, 0, n);
  var n = e.length - 1, i = e.charCodeAt(n);
  if (i >= 55296 && i <= 56319) {
    var a = this.surrogateSize;
    return this.charLength += a, this.charReceived += a, this.charBuffer.copy(this.charBuffer, a, 0, a), t.copy(this.charBuffer, 0, 0, a), e.substring(0, n);
  }
  return e;
};
gm.prototype.detectIncompleteChar = function(t) {
  for (var e = t.length >= 3 ? 3 : t.length; e > 0; e--) {
    var r = t[t.length - e];
    if (e == 1 && r >> 5 == 6) {
      this.charLength = 2;
      break;
    }
    if (e <= 2 && r >> 4 == 14) {
      this.charLength = 3;
      break;
    }
    if (e <= 3 && r >> 3 == 30) {
      this.charLength = 4;
      break;
    }
  }
  this.charReceived = e;
};
gm.prototype.end = function(t) {
  var e = "";
  if (t && t.length && (e = this.write(t)), this.charReceived) {
    var r = this.charReceived, n = this.charBuffer, i = this.encoding;
    e += n.slice(0, r).toString(i);
  }
  return e;
};
function Uee(t) {
  return t.toString(this.encoding);
}
function zee(t) {
  this.charReceived = t.length % 2, this.charLength = this.charReceived ? 2 : 0;
}
function $ee(t) {
  this.charReceived = t.length % 3, this.charLength = this.charReceived ? 3 : 0;
}
var Vee = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  StringDecoder: gm
}), eT = /* @__PURE__ */ F1(Vee), n9 = Mc.codes.ERR_STREAM_PREMATURE_CLOSE;
function jee(t) {
  var e = !1;
  return function() {
    if (!e) {
      e = !0;
      for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++)
        n[i] = arguments[i];
      t.apply(this, n);
    }
  };
}
function Wee() {
}
function Hee(t) {
  return t.setHeader && typeof t.abort == "function";
}
function tT(t, e, r) {
  if (typeof e == "function") return tT(t, null, e);
  e || (e = {}), r = jee(r || Wee);
  var n = e.readable || e.readable !== !1 && t.readable, i = e.writable || e.writable !== !1 && t.writable, a = function() {
    t.writable || s();
  }, o = t._writableState && t._writableState.finished, s = function() {
    i = !1, o = !0, n || r.call(t);
  }, l = t._readableState && t._readableState.endEmitted, u = function() {
    n = !1, l = !0, i || r.call(t);
  }, d = function(x) {
    r.call(t, x);
  }, h = function() {
    var x;
    if (n && !l)
      return (!t._readableState || !t._readableState.ended) && (x = new n9()), r.call(t, x);
    if (i && !o)
      return (!t._writableState || !t._writableState.ended) && (x = new n9()), r.call(t, x);
  }, v = function() {
    t.req.on("finish", s);
  };
  return Hee(t) ? (t.on("complete", s), t.on("abort", h), t.req ? v() : t.on("request", v)) : i && !t._writableState && (t.on("end", a), t.on("close", a)), t.on("end", u), t.on("finish", s), e.error !== !1 && t.on("error", d), t.on("close", h), function() {
    t.removeListener("complete", s), t.removeListener("abort", h), t.removeListener("request", v), t.req && t.req.removeListener("finish", s), t.removeListener("end", a), t.removeListener("close", a), t.removeListener("finish", s), t.removeListener("end", u), t.removeListener("error", d), t.removeListener("close", h);
  };
}
var Cx = tT, pv, i9;
function qee() {
  if (i9) return pv;
  i9 = 1;
  var t;
  function e(k, E, C) {
    return E in k ? Object.defineProperty(k, E, {
      value: C,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : k[E] = C, k;
  }
  var r = Cx, n = Symbol("lastResolve"), i = Symbol("lastReject"), a = Symbol("error"), o = Symbol("ended"), s = Symbol("lastPromise"), l = Symbol("handlePromise"), u = Symbol("stream");
  function d(k, E) {
    return {
      value: k,
      done: E
    };
  }
  function h(k) {
    var E = k[n];
    if (E !== null) {
      var C = k[u].read();
      C !== null && (k[s] = null, k[n] = null, k[i] = null, E(d(C, !1)));
    }
  }
  function v(k) {
    Qt.nextTick(h, k);
  }
  function b(k, E) {
    return function(C, D) {
      k.then(function() {
        if (E[o]) {
          C(d(void 0, !0));
          return;
        }
        E[l](C, D);
      }, D);
    };
  }
  var x = Object.getPrototypeOf(function() {
  }), A = Object.setPrototypeOf((t = {
    get stream() {
      return this[u];
    },
    next: function() {
      var E = this, C = this[a];
      if (C !== null)
        return Promise.reject(C);
      if (this[o])
        return Promise.resolve(d(void 0, !0));
      if (this[u].destroyed)
        return new Promise(function(R, U) {
          Qt.nextTick(function() {
            E[a] ? U(E[a]) : R(d(void 0, !0));
          });
        });
      var D = this[s], _;
      if (D)
        _ = new Promise(b(D, this));
      else {
        var I = this[u].read();
        if (I !== null)
          return Promise.resolve(d(I, !1));
        _ = new Promise(this[l]);
      }
      return this[s] = _, _;
    }
  }, e(t, Symbol.asyncIterator, function() {
    return this;
  }), e(t, "return", function() {
    var E = this;
    return new Promise(function(C, D) {
      E[u].destroy(null, function(_) {
        if (_) {
          D(_);
          return;
        }
        C(d(void 0, !0));
      });
    });
  }), t), x), T = function(E) {
    var C, D = Object.create(A, (C = {}, e(C, u, {
      value: E,
      writable: !0
    }), e(C, n, {
      value: null,
      writable: !0
    }), e(C, i, {
      value: null,
      writable: !0
    }), e(C, a, {
      value: null,
      writable: !0
    }), e(C, o, {
      value: E._readableState.endEmitted,
      writable: !0
    }), e(C, l, {
      value: function(I, R) {
        var U = D[u].read();
        U ? (D[s] = null, D[n] = null, D[i] = null, I(d(U, !1))) : (D[n] = I, D[i] = R);
      },
      writable: !0
    }), C));
    return D[s] = null, r(E, function(_) {
      if (_ && _.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var I = D[i];
        I !== null && (D[s] = null, D[n] = null, D[i] = null, I(_)), D[a] = _;
        return;
      }
      var R = D[n];
      R !== null && (D[s] = null, D[n] = null, D[i] = null, R(d(void 0, !0))), D[o] = !0;
    }), E.on("readable", v.bind(null, D)), D;
  };
  return pv = T, pv;
}
var mv, a9;
function Yee() {
  return a9 || (a9 = 1, mv = function() {
    throw new Error("Readable.from is not available in the browser");
  }), mv;
}
const kx = D1;
kx.Readable = v0;
v0.ReadableState = nT;
$k.EventEmitter;
var rT = function(e, r) {
  return e.listeners(r).length;
}, Wh = Vk, vm = hh.Buffer, Gee = ap.Uint8Array || function() {
};
function Zee(t) {
  return vm.from(t);
}
function Xee(t) {
  return vm.isBuffer(t) || t instanceof Gee;
}
var gv = Sx, Jt;
gv && gv.debuglog ? Jt = gv.debuglog("stream") : Jt = function() {
};
var Kee = Eee(), Tx = Kk, Jee = Qk, Qee = Jee.getHighWaterMark, bm = Mc.codes, ete = bm.ERR_INVALID_ARG_TYPE, tte = bm.ERR_STREAM_PUSH_AFTER_EOF, rte = bm.ERR_METHOD_NOT_IMPLEMENTED, nte = bm.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, r1, vv, bv;
jh(v0, Wh);
var jd = Tx.errorOrDestroy, xv = ["error", "close", "destroy", "pause", "resume"];
function ite(t, e, r) {
  if (typeof t.prependListener == "function") return t.prependListener(e, r);
  !t._events || !t._events[e] ? t.on(e, r) : Array.isArray(t._events[e]) ? t._events[e].unshift(r) : t._events[e] = [r, t._events[e]];
}
function nT(t, e, r) {
  t = t || {}, typeof r != "boolean" && (r = e instanceof kx.Duplex), this.objectMode = !!t.objectMode, r && (this.objectMode = this.objectMode || !!t.readableObjectMode), this.highWaterMark = Qee(this, t, "readableHighWaterMark", r), this.buffer = new Kee(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = t.emitClose !== !1, this.autoDestroy = !!t.autoDestroy, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (r1 || (r1 = eT.StringDecoder), this.decoder = new r1(t.encoding), this.encoding = t.encoding);
}
function v0(t) {
  if (!(this instanceof v0)) return new v0(t);
  var e = this instanceof kx.Duplex;
  this._readableState = new nT(t, this, e), this.readable = !0, t && (typeof t.read == "function" && (this._read = t.read), typeof t.destroy == "function" && (this._destroy = t.destroy)), Wh.call(this);
}
Object.defineProperty(v0.prototype, "destroyed", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._readableState === void 0 ? !1 : this._readableState.destroyed;
  },
  set: function(e) {
    this._readableState && (this._readableState.destroyed = e);
  }
});
v0.prototype.destroy = Tx.destroy;
v0.prototype._undestroy = Tx.undestroy;
v0.prototype._destroy = function(t, e) {
  e(t);
};
v0.prototype.push = function(t, e) {
  var r = this._readableState, n;
  return r.objectMode ? n = !0 : typeof t == "string" && (e = e || r.defaultEncoding, e !== r.encoding && (t = vm.from(t, e), e = ""), n = !0), iT(this, t, e, !1, n);
};
v0.prototype.unshift = function(t) {
  return iT(this, t, null, !0, !1);
};
function iT(t, e, r, n, i) {
  Jt("readableAddChunk", e);
  var a = t._readableState;
  if (e === null)
    a.reading = !1, ste(t, a);
  else {
    var o;
    if (i || (o = ate(a, e)), o)
      jd(t, o);
    else if (a.objectMode || e && e.length > 0)
      if (typeof e != "string" && !a.objectMode && Object.getPrototypeOf(e) !== vm.prototype && (e = Zee(e)), n)
        a.endEmitted ? jd(t, new nte()) : yv(t, a, e, !0);
      else if (a.ended)
        jd(t, new tte());
      else {
        if (a.destroyed)
          return !1;
        a.reading = !1, a.decoder && !r ? (e = a.decoder.write(e), a.objectMode || e.length !== 0 ? yv(t, a, e, !1) : z3(t, a)) : yv(t, a, e, !1);
      }
    else n || (a.reading = !1, z3(t, a));
  }
  return !a.ended && (a.length < a.highWaterMark || a.length === 0);
}
function yv(t, e, r, n) {
  e.flowing && e.length === 0 && !e.sync ? (e.awaitDrain = 0, t.emit("data", r)) : (e.length += e.objectMode ? 1 : r.length, n ? e.buffer.unshift(r) : e.buffer.push(r), e.needReadable && xm(t)), z3(t, e);
}
function ate(t, e) {
  var r;
  return !Xee(e) && typeof e != "string" && e !== void 0 && !t.objectMode && (r = new ete("chunk", ["string", "Buffer", "Uint8Array"], e)), r;
}
v0.prototype.isPaused = function() {
  return this._readableState.flowing === !1;
};
v0.prototype.setEncoding = function(t) {
  r1 || (r1 = eT.StringDecoder);
  var e = new r1(t);
  this._readableState.decoder = e, this._readableState.encoding = this._readableState.decoder.encoding;
  for (var r = this._readableState.buffer.head, n = ""; r !== null; )
    n += e.write(r.data), r = r.next;
  return this._readableState.buffer.clear(), n !== "" && this._readableState.buffer.push(n), this._readableState.length = n.length, this;
};
var o9 = 1073741824;
function ote(t) {
  return t >= o9 ? t = o9 : (t--, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, t |= t >>> 16, t++), t;
}
function s9(t, e) {
  return t <= 0 || e.length === 0 && e.ended ? 0 : e.objectMode ? 1 : t !== t ? e.flowing && e.length ? e.buffer.head.data.length : e.length : (t > e.highWaterMark && (e.highWaterMark = ote(t)), t <= e.length ? t : e.ended ? e.length : (e.needReadable = !0, 0));
}
v0.prototype.read = function(t) {
  Jt("read", t), t = parseInt(t, 10);
  var e = this._readableState, r = t;
  if (t !== 0 && (e.emittedReadable = !1), t === 0 && e.needReadable && ((e.highWaterMark !== 0 ? e.length >= e.highWaterMark : e.length > 0) || e.ended))
    return Jt("read: emitReadable", e.length, e.ended), e.length === 0 && e.ended ? wv(this) : xm(this), null;
  if (t = s9(t, e), t === 0 && e.ended)
    return e.length === 0 && wv(this), null;
  var n = e.needReadable;
  Jt("need readable", n), (e.length === 0 || e.length - t < e.highWaterMark) && (n = !0, Jt("length less than watermark", n)), e.ended || e.reading ? (n = !1, Jt("reading or ended", n)) : n && (Jt("do read"), e.reading = !0, e.sync = !0, e.length === 0 && (e.needReadable = !0), this._read(e.highWaterMark), e.sync = !1, e.reading || (t = s9(r, e)));
  var i;
  return t > 0 ? i = sT(t, e) : i = null, i === null ? (e.needReadable = e.length <= e.highWaterMark, t = 0) : (e.length -= t, e.awaitDrain = 0), e.length === 0 && (e.ended || (e.needReadable = !0), r !== t && e.ended && wv(this)), i !== null && this.emit("data", i), i;
};
function ste(t, e) {
  if (Jt("onEofChunk"), !e.ended) {
    if (e.decoder) {
      var r = e.decoder.end();
      r && r.length && (e.buffer.push(r), e.length += e.objectMode ? 1 : r.length);
    }
    e.ended = !0, e.sync ? xm(t) : (e.needReadable = !1, e.emittedReadable || (e.emittedReadable = !0, aT(t)));
  }
}
function xm(t) {
  var e = t._readableState;
  Jt("emitReadable", e.needReadable, e.emittedReadable), e.needReadable = !1, e.emittedReadable || (Jt("emitReadable", e.flowing), e.emittedReadable = !0, Qt.nextTick(aT, t));
}
function aT(t) {
  var e = t._readableState;
  Jt("emitReadable_", e.destroyed, e.length, e.ended), !e.destroyed && (e.length || e.ended) && (t.emit("readable"), e.emittedReadable = !1), e.needReadable = !e.flowing && !e.ended && e.length <= e.highWaterMark, Fx(t);
}
function z3(t, e) {
  e.readingMore || (e.readingMore = !0, Qt.nextTick(lte, t, e));
}
function lte(t, e) {
  for (; !e.reading && !e.ended && (e.length < e.highWaterMark || e.flowing && e.length === 0); ) {
    var r = e.length;
    if (Jt("maybeReadMore read 0"), t.read(0), r === e.length)
      break;
  }
  e.readingMore = !1;
}
v0.prototype._read = function(t) {
  jd(this, new rte("_read()"));
};
v0.prototype.pipe = function(t, e) {
  var r = this, n = this._readableState;
  switch (n.pipesCount) {
    case 0:
      n.pipes = t;
      break;
    case 1:
      n.pipes = [n.pipes, t];
      break;
    default:
      n.pipes.push(t);
      break;
  }
  n.pipesCount += 1, Jt("pipe count=%d opts=%j", n.pipesCount, e);
  var i = (!e || e.end !== !1) && t !== Qt.stdout && t !== Qt.stderr, a = i ? s : A;
  n.endEmitted ? Qt.nextTick(a) : r.once("end", a), t.on("unpipe", o);
  function o(T, k) {
    Jt("onunpipe"), T === r && k && k.hasUnpiped === !1 && (k.hasUnpiped = !0, d());
  }
  function s() {
    Jt("onend"), t.end();
  }
  var l = ute(r);
  t.on("drain", l);
  var u = !1;
  function d() {
    Jt("cleanup"), t.removeListener("close", b), t.removeListener("finish", x), t.removeListener("drain", l), t.removeListener("error", v), t.removeListener("unpipe", o), r.removeListener("end", s), r.removeListener("end", A), r.removeListener("data", h), u = !0, n.awaitDrain && (!t._writableState || t._writableState.needDrain) && l();
  }
  r.on("data", h);
  function h(T) {
    Jt("ondata");
    var k = t.write(T);
    Jt("dest.write", k), k === !1 && ((n.pipesCount === 1 && n.pipes === t || n.pipesCount > 1 && lT(n.pipes, t) !== -1) && !u && (Jt("false write response, pause", n.awaitDrain), n.awaitDrain++), r.pause());
  }
  function v(T) {
    Jt("onerror", T), A(), t.removeListener("error", v), rT(t, "error") === 0 && jd(t, T);
  }
  ite(t, "error", v);
  function b() {
    t.removeListener("finish", x), A();
  }
  t.once("close", b);
  function x() {
    Jt("onfinish"), t.removeListener("close", b), A();
  }
  t.once("finish", x);
  function A() {
    Jt("unpipe"), r.unpipe(t);
  }
  return t.emit("pipe", r), n.flowing || (Jt("pipe resume"), r.resume()), t;
};
function ute(t) {
  return function() {
    var r = t._readableState;
    Jt("pipeOnDrain", r.awaitDrain), r.awaitDrain && r.awaitDrain--, r.awaitDrain === 0 && rT(t, "data") && (r.flowing = !0, Fx(t));
  };
}
v0.prototype.unpipe = function(t) {
  var e = this._readableState, r = {
    hasUnpiped: !1
  };
  if (e.pipesCount === 0) return this;
  if (e.pipesCount === 1)
    return t && t !== e.pipes ? this : (t || (t = e.pipes), e.pipes = null, e.pipesCount = 0, e.flowing = !1, t && t.emit("unpipe", this, r), this);
  if (!t) {
    var n = e.pipes, i = e.pipesCount;
    e.pipes = null, e.pipesCount = 0, e.flowing = !1;
    for (var a = 0; a < i; a++)
      n[a].emit("unpipe", this, {
        hasUnpiped: !1
      });
    return this;
  }
  var o = lT(e.pipes, t);
  return o === -1 ? this : (e.pipes.splice(o, 1), e.pipesCount -= 1, e.pipesCount === 1 && (e.pipes = e.pipes[0]), t.emit("unpipe", this, r), this);
};
v0.prototype.on = function(t, e) {
  var r = Wh.prototype.on.call(this, t, e), n = this._readableState;
  return t === "data" ? (n.readableListening = this.listenerCount("readable") > 0, n.flowing !== !1 && this.resume()) : t === "readable" && !n.endEmitted && !n.readableListening && (n.readableListening = n.needReadable = !0, n.flowing = !1, n.emittedReadable = !1, Jt("on readable", n.length, n.reading), n.length ? xm(this) : n.reading || Qt.nextTick(cte, this)), r;
};
v0.prototype.addListener = v0.prototype.on;
v0.prototype.removeListener = function(t, e) {
  var r = Wh.prototype.removeListener.call(this, t, e);
  return t === "readable" && Qt.nextTick(oT, this), r;
};
v0.prototype.removeAllListeners = function(t) {
  var e = Wh.prototype.removeAllListeners.apply(this, arguments);
  return (t === "readable" || t === void 0) && Qt.nextTick(oT, this), e;
};
function oT(t) {
  var e = t._readableState;
  e.readableListening = t.listenerCount("readable") > 0, e.resumeScheduled && !e.paused ? e.flowing = !0 : t.listenerCount("data") > 0 && t.resume();
}
function cte(t) {
  Jt("readable nexttick read 0"), t.read(0);
}
v0.prototype.resume = function() {
  var t = this._readableState;
  return t.flowing || (Jt("resume"), t.flowing = !t.readableListening, fte(this, t)), t.paused = !1, this;
};
function fte(t, e) {
  e.resumeScheduled || (e.resumeScheduled = !0, Qt.nextTick(dte, t, e));
}
function dte(t, e) {
  Jt("resume", e.reading), e.reading || t.read(0), e.resumeScheduled = !1, t.emit("resume"), Fx(t), e.flowing && !e.reading && t.read(0);
}
v0.prototype.pause = function() {
  return Jt("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (Jt("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
};
function Fx(t) {
  var e = t._readableState;
  for (Jt("flow", e.flowing); e.flowing && t.read() !== null; )
    ;
}
v0.prototype.wrap = function(t) {
  var e = this, r = this._readableState, n = !1;
  t.on("end", function() {
    if (Jt("wrapped end"), r.decoder && !r.ended) {
      var o = r.decoder.end();
      o && o.length && e.push(o);
    }
    e.push(null);
  }), t.on("data", function(o) {
    if (Jt("wrapped data"), r.decoder && (o = r.decoder.write(o)), !(r.objectMode && o == null) && !(!r.objectMode && (!o || !o.length))) {
      var s = e.push(o);
      s || (n = !0, t.pause());
    }
  });
  for (var i in t)
    this[i] === void 0 && typeof t[i] == "function" && (this[i] = /* @__PURE__ */ function(s) {
      return function() {
        return t[s].apply(t, arguments);
      };
    }(i));
  for (var a = 0; a < xv.length; a++)
    t.on(xv[a], this.emit.bind(this, xv[a]));
  return this._read = function(o) {
    Jt("wrapped _read", o), n && (n = !1, t.resume());
  }, this;
};
typeof Symbol == "function" && (v0.prototype[Symbol.asyncIterator] = function() {
  return vv === void 0 && (vv = qee()), vv(this);
});
Object.defineProperty(v0.prototype, "readableHighWaterMark", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(v0.prototype, "readableBuffer", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(v0.prototype, "readableFlowing", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._readableState.flowing;
  },
  set: function(e) {
    this._readableState && (this._readableState.flowing = e);
  }
});
v0._fromList = sT;
Object.defineProperty(v0.prototype, "readableLength", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._readableState.length;
  }
});
function sT(t, e) {
  if (e.length === 0) return null;
  var r;
  return e.objectMode ? r = e.buffer.shift() : !t || t >= e.length ? (e.decoder ? r = e.buffer.join("") : e.buffer.length === 1 ? r = e.buffer.first() : r = e.buffer.concat(e.length), e.buffer.clear()) : r = e.buffer.consume(t, e.decoder), r;
}
function wv(t) {
  var e = t._readableState;
  Jt("endReadable", e.endEmitted), e.endEmitted || (e.ended = !0, Qt.nextTick(hte, e, t));
}
function hte(t, e) {
  if (Jt("endReadableNT", t.endEmitted, t.length), !t.endEmitted && t.length === 0 && (t.endEmitted = !0, e.readable = !1, e.emit("end"), t.autoDestroy)) {
    var r = e._writableState;
    (!r || r.autoDestroy && r.finished) && e.destroy();
  }
}
typeof Symbol == "function" && (v0.from = function(t, e) {
  return bv === void 0 && (bv = Yee()), bv(v0, t, e);
});
function lT(t, e) {
  for (var r = 0, n = t.length; r < n; r++)
    if (t[r] === e) return r;
  return -1;
}
var pte = mte;
function mte(t, e) {
  if (_v("noDeprecation"))
    return t;
  var r = !1;
  function n() {
    if (!r) {
      if (_v("throwDeprecation"))
        throw new Error(e);
      _v("traceDeprecation") ? console.trace(e) : console.warn(e), r = !0;
    }
    return t.apply(this, arguments);
  }
  return n;
}
function _v(t) {
  try {
    if (!ap.localStorage) return !1;
  } catch {
    return !1;
  }
  var e = ap.localStorage[t];
  return e == null ? !1 : String(e).toLowerCase() === "true";
}
const Dx = D1;
Dx.Writable = Cr;
function uT(t) {
  var e = this;
  this.next = null, this.entry = null, this.finish = function() {
    Vte(e, t);
  };
}
Cr.WritableState = Hh;
var gte = {
  deprecate: pte
}, cT = Vk, ym = hh.Buffer, vte = ap.Uint8Array || function() {
};
function bte(t) {
  return ym.from(t);
}
function xte(t) {
  return ym.isBuffer(t) || t instanceof vte;
}
var Ox = Kk, yte = Qk, wte = yte.getHighWaterMark, fu = Mc.codes, _te = fu.ERR_INVALID_ARG_TYPE, Ate = fu.ERR_METHOD_NOT_IMPLEMENTED, Ete = fu.ERR_MULTIPLE_CALLBACK, Ste = fu.ERR_STREAM_CANNOT_PIPE, Cte = fu.ERR_STREAM_DESTROYED, kte = fu.ERR_STREAM_NULL_VALUES, Tte = fu.ERR_STREAM_WRITE_AFTER_END, Fte = fu.ERR_UNKNOWN_ENCODING, p1 = Ox.errorOrDestroy;
jh(Cr, cT);
function Dte() {
}
function Hh(t, e, r) {
  t = t || {}, typeof r != "boolean" && (r = e instanceof Dx.Duplex), this.objectMode = !!t.objectMode, r && (this.objectMode = this.objectMode || !!t.writableObjectMode), this.highWaterMark = wte(this, t, "writableHighWaterMark", r), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
  var n = t.decodeStrings === !1;
  this.decodeStrings = !n, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(i) {
    Nte(e, i);
  }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = t.emitClose !== !1, this.autoDestroy = !!t.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new uT(this);
}
Hh.prototype.getBuffer = function() {
  for (var e = this.bufferedRequest, r = []; e; )
    r.push(e), e = e.next;
  return r;
};
(function() {
  try {
    Object.defineProperty(Hh.prototype, "buffer", {
      get: gte.deprecate(function() {
        return this.getBuffer();
      }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
    });
  } catch {
  }
})();
var g5;
typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (g5 = Function.prototype[Symbol.hasInstance], Object.defineProperty(Cr, Symbol.hasInstance, {
  value: function(e) {
    return g5.call(this, e) ? !0 : this !== Cr ? !1 : e && e._writableState instanceof Hh;
  }
})) : g5 = function(e) {
  return e instanceof this;
};
function Cr(t) {
  var e = this instanceof Dx.Duplex;
  if (!e && !g5.call(Cr, this)) return new Cr(t);
  this._writableState = new Hh(t, this, e), this.writable = !0, t && (typeof t.write == "function" && (this._write = t.write), typeof t.writev == "function" && (this._writev = t.writev), typeof t.destroy == "function" && (this._destroy = t.destroy), typeof t.final == "function" && (this._final = t.final)), cT.call(this);
}
Cr.prototype.pipe = function() {
  p1(this, new Ste());
};
function Ote(t, e) {
  var r = new Tte();
  p1(t, r), Qt.nextTick(e, r);
}
function Rte(t, e, r, n) {
  var i;
  return r === null ? i = new kte() : typeof r != "string" && !e.objectMode && (i = new _te("chunk", ["string", "Buffer"], r)), i ? (p1(t, i), Qt.nextTick(n, i), !1) : !0;
}
Cr.prototype.write = function(t, e, r) {
  var n = this._writableState, i = !1, a = !n.objectMode && xte(t);
  return a && !ym.isBuffer(t) && (t = bte(t)), typeof e == "function" && (r = e, e = null), a ? e = "buffer" : e || (e = n.defaultEncoding), typeof r != "function" && (r = Dte), n.ending ? Ote(this, r) : (a || Rte(this, n, t, r)) && (n.pendingcb++, i = Ite(this, n, a, t, e, r)), i;
};
Cr.prototype.cork = function() {
  this._writableState.corked++;
};
Cr.prototype.uncork = function() {
  var t = this._writableState;
  t.corked && (t.corked--, !t.writing && !t.corked && !t.bufferProcessing && t.bufferedRequest && fT(this, t));
};
Cr.prototype.setDefaultEncoding = function(e) {
  if (typeof e == "string" && (e = e.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((e + "").toLowerCase()) > -1)) throw new Fte(e);
  return this._writableState.defaultEncoding = e, this;
};
Object.defineProperty(Cr.prototype, "writableBuffer", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function Pte(t, e, r) {
  return !t.objectMode && t.decodeStrings !== !1 && typeof e == "string" && (e = ym.from(e, r)), e;
}
Object.defineProperty(Cr.prototype, "writableHighWaterMark", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState.highWaterMark;
  }
});
function Ite(t, e, r, n, i, a) {
  if (!r) {
    var o = Pte(e, n, i);
    n !== o && (r = !0, i = "buffer", n = o);
  }
  var s = e.objectMode ? 1 : n.length;
  e.length += s;
  var l = e.length < e.highWaterMark;
  if (l || (e.needDrain = !0), e.writing || e.corked) {
    var u = e.lastBufferedRequest;
    e.lastBufferedRequest = {
      chunk: n,
      encoding: i,
      isBuf: r,
      callback: a,
      next: null
    }, u ? u.next = e.lastBufferedRequest : e.bufferedRequest = e.lastBufferedRequest, e.bufferedRequestCount += 1;
  } else
    $3(t, e, !1, s, n, i, a);
  return l;
}
function $3(t, e, r, n, i, a, o) {
  e.writelen = n, e.writecb = o, e.writing = !0, e.sync = !0, e.destroyed ? e.onwrite(new Cte("write")) : r ? t._writev(i, e.onwrite) : t._write(i, a, e.onwrite), e.sync = !1;
}
function Bte(t, e, r, n, i) {
  --e.pendingcb, r ? (Qt.nextTick(i, n), Qt.nextTick(mh, t, e), t._writableState.errorEmitted = !0, p1(t, n)) : (i(n), t._writableState.errorEmitted = !0, p1(t, n), mh(t, e));
}
function Lte(t) {
  t.writing = !1, t.writecb = null, t.length -= t.writelen, t.writelen = 0;
}
function Nte(t, e) {
  var r = t._writableState, n = r.sync, i = r.writecb;
  if (typeof i != "function") throw new Ete();
  if (Lte(r), e) Bte(t, r, n, e, i);
  else {
    var a = dT(r) || t.destroyed;
    !a && !r.corked && !r.bufferProcessing && r.bufferedRequest && fT(t, r), n ? Qt.nextTick(l9, t, r, a, i) : l9(t, r, a, i);
  }
}
function l9(t, e, r, n) {
  r || Mte(t, e), e.pendingcb--, n(), mh(t, e);
}
function Mte(t, e) {
  e.length === 0 && e.needDrain && (e.needDrain = !1, t.emit("drain"));
}
function fT(t, e) {
  e.bufferProcessing = !0;
  var r = e.bufferedRequest;
  if (t._writev && r && r.next) {
    var n = e.bufferedRequestCount, i = new Array(n), a = e.corkedRequestsFree;
    a.entry = r;
    for (var o = 0, s = !0; r; )
      i[o] = r, r.isBuf || (s = !1), r = r.next, o += 1;
    i.allBuffers = s, $3(t, e, !0, e.length, i, "", a.finish), e.pendingcb++, e.lastBufferedRequest = null, a.next ? (e.corkedRequestsFree = a.next, a.next = null) : e.corkedRequestsFree = new uT(e), e.bufferedRequestCount = 0;
  } else {
    for (; r; ) {
      var l = r.chunk, u = r.encoding, d = r.callback, h = e.objectMode ? 1 : l.length;
      if ($3(t, e, !1, h, l, u, d), r = r.next, e.bufferedRequestCount--, e.writing)
        break;
    }
    r === null && (e.lastBufferedRequest = null);
  }
  e.bufferedRequest = r, e.bufferProcessing = !1;
}
Cr.prototype._write = function(t, e, r) {
  r(new Ate("_write()"));
};
Cr.prototype._writev = null;
Cr.prototype.end = function(t, e, r) {
  var n = this._writableState;
  return typeof t == "function" ? (r = t, t = null, e = null) : typeof e == "function" && (r = e, e = null), t != null && this.write(t, e), n.corked && (n.corked = 1, this.uncork()), n.ending || $te(this, n, r), this;
};
Object.defineProperty(Cr.prototype, "writableLength", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState.length;
  }
});
function dT(t) {
  return t.ending && t.length === 0 && t.bufferedRequest === null && !t.finished && !t.writing;
}
function Ute(t, e) {
  t._final(function(r) {
    e.pendingcb--, r && p1(t, r), e.prefinished = !0, t.emit("prefinish"), mh(t, e);
  });
}
function zte(t, e) {
  !e.prefinished && !e.finalCalled && (typeof t._final == "function" && !e.destroyed ? (e.pendingcb++, e.finalCalled = !0, Qt.nextTick(Ute, t, e)) : (e.prefinished = !0, t.emit("prefinish")));
}
function mh(t, e) {
  var r = dT(e);
  if (r && (zte(t, e), e.pendingcb === 0 && (e.finished = !0, t.emit("finish"), e.autoDestroy))) {
    var n = t._readableState;
    (!n || n.autoDestroy && n.endEmitted) && t.destroy();
  }
  return r;
}
function $te(t, e, r) {
  e.ending = !0, mh(t, e), r && (e.finished ? Qt.nextTick(r) : t.once("finish", r)), e.ended = !0, t.writable = !1;
}
function Vte(t, e, r) {
  var n = t.entry;
  for (t.entry = null; n; ) {
    var i = n.callback;
    e.pendingcb--, i(r), n = n.next;
  }
  e.corkedRequestsFree.next = t;
}
Object.defineProperty(Cr.prototype, "destroyed", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState === void 0 ? !1 : this._writableState.destroyed;
  },
  set: function(e) {
    this._writableState && (this._writableState.destroyed = e);
  }
});
Cr.prototype.destroy = Ox.destroy;
Cr.prototype._undestroy = Ox.undestroy;
Cr.prototype._destroy = function(t, e) {
  e(t);
};
var jte = Object.keys || function(t) {
  var e = [];
  for (var r in t)
    e.push(r);
  return e;
};
const m1 = D1;
m1.Duplex = cs;
jh(cs, m1.Readable);
for (var u9 = jte(m1.Writable.prototype), Av = 0; Av < u9.length; Av++) {
  var Ev = u9[Av];
  cs.prototype[Ev] || (cs.prototype[Ev] = m1.Writable.prototype[Ev]);
}
function cs(t) {
  if (!(this instanceof cs)) return new cs(t);
  m1.Readable.call(this, t), m1.Writable.call(this, t), this.allowHalfOpen = !0, t && (t.readable === !1 && (this.readable = !1), t.writable === !1 && (this.writable = !1), t.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", Wte)));
}
Object.defineProperty(cs.prototype, "writableHighWaterMark", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(cs.prototype, "writableBuffer", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(cs.prototype, "writableLength", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._writableState.length;
  }
});
function Wte() {
  this._writableState.ended || Qt.nextTick(Hte, this);
}
function Hte(t) {
  t.end();
}
Object.defineProperty(cs.prototype, "destroyed", {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: !1,
  get: function() {
    return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function(e) {
    this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = e, this._writableState.destroyed = e);
  }
});
const qh = D1;
qh.Transform = al;
var wm = Mc.codes, qte = wm.ERR_METHOD_NOT_IMPLEMENTED, Yte = wm.ERR_MULTIPLE_CALLBACK, Gte = wm.ERR_TRANSFORM_ALREADY_TRANSFORMING, Zte = wm.ERR_TRANSFORM_WITH_LENGTH_0;
jh(al, qh.Duplex);
function Xte(t, e) {
  var r = this._transformState;
  r.transforming = !1;
  var n = r.writecb;
  if (n === null)
    return this.emit("error", new Yte());
  r.writechunk = null, r.writecb = null, e != null && this.push(e), n(t);
  var i = this._readableState;
  i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
}
function al(t) {
  if (!(this instanceof al)) return new al(t);
  qh.Duplex.call(this, t), this._transformState = {
    afterTransform: Xte.bind(this),
    needTransform: !1,
    transforming: !1,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }, this._readableState.needReadable = !0, this._readableState.sync = !1, t && (typeof t.transform == "function" && (this._transform = t.transform), typeof t.flush == "function" && (this._flush = t.flush)), this.on("prefinish", Kte);
}
function Kte() {
  var t = this;
  typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(e, r) {
    c9(t, e, r);
  }) : c9(this, null, null);
}
al.prototype.push = function(t, e) {
  return this._transformState.needTransform = !1, qh.Duplex.prototype.push.call(this, t, e);
};
al.prototype._transform = function(t, e, r) {
  r(new qte("_transform()"));
};
al.prototype._write = function(t, e, r) {
  var n = this._transformState;
  if (n.writecb = r, n.writechunk = t, n.writeencoding = e, !n.transforming) {
    var i = this._readableState;
    (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
  }
};
al.prototype._read = function(t) {
  var e = this._transformState;
  e.writechunk !== null && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
};
al.prototype._destroy = function(t, e) {
  qh.Duplex.prototype._destroy.call(this, t, function(r) {
    e(r);
  });
};
function c9(t, e, r) {
  if (e) return t.emit("error", e);
  if (r != null && t.push(r), t._writableState.length) throw new Zte();
  if (t._transformState.transforming) throw new Gte();
  return t.push(null);
}
const hT = D1;
hT.PassThrough = gh;
jh(gh, hT.Transform);
function gh(t) {
  if (!(this instanceof gh)) return new gh(t);
  Transform.call(this, t);
}
gh.prototype._transform = function(t, e, r) {
  r(null, t);
};
var Sv;
function Jte(t) {
  var e = !1;
  return function() {
    e || (e = !0, t.apply(void 0, arguments));
  };
}
var pT = Mc.codes, Qte = pT.ERR_MISSING_ARGS, e0e = pT.ERR_STREAM_DESTROYED;
function f9(t) {
  if (t) throw t;
}
function t0e(t) {
  return t.setHeader && typeof t.abort == "function";
}
function r0e(t, e, r, n) {
  n = Jte(n);
  var i = !1;
  t.on("close", function() {
    i = !0;
  }), Sv === void 0 && (Sv = Cx), Sv(t, {
    readable: e,
    writable: r
  }, function(o) {
    if (o) return n(o);
    i = !0, n();
  });
  var a = !1;
  return function(o) {
    if (!i && !a) {
      if (a = !0, t0e(t)) return t.abort();
      if (typeof t.destroy == "function") return t.destroy();
      n(o || new e0e("pipe"));
    }
  };
}
function d9(t) {
  t();
}
function n0e(t, e) {
  return t.pipe(e);
}
function i0e(t) {
  return !t.length || typeof t[t.length - 1] != "function" ? f9 : t.pop();
}
function a0e() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  var n = i0e(e);
  if (Array.isArray(e[0]) && (e = e[0]), e.length < 2)
    throw new Qte("streams");
  var i, a = e.map(function(o, s) {
    var l = s < e.length - 1, u = s > 0;
    return r0e(o, l, u, function(d) {
      i || (i = d), d && a.forEach(d9), !l && (a.forEach(d9), n(i));
    });
  });
  return e.reduce(n0e);
}
var o0e = a0e;
(function(t, e) {
  const r = D1;
  e = t.exports = r.Readable, e.Stream = r.Readable, e.Readable = r.Readable, e.Writable = r.Writable, e.Duplex = r.Duplex, e.Transform = r.Transform, e.PassThrough = r.PassThrough, e.finished = Cx, e.pipeline = o0e;
})(L3, L3.exports);
var mT = L3.exports, gT = /* @__PURE__ */ Ok(mT), vT = {}, bT = {};
function h9(t, e) {
  if (t === e)
    return 0;
  for (var r = t.length, n = e.length, i = 0, a = Math.min(r, n); i < a; ++i)
    if (t[i] !== e[i]) {
      r = t[i], n = e[i];
      break;
    }
  return r < n ? -1 : n < r ? 1 : 0;
}
var s0e = Object.prototype.hasOwnProperty, p9 = Object.keys || function(t) {
  var e = [];
  for (var r in t)
    s0e.call(t, r) && e.push(r);
  return e;
}, m9 = Array.prototype.slice, Cv;
function xT() {
  return typeof Cv < "u" ? Cv : Cv = function() {
    return function() {
    }.name === "foo";
  }();
}
function g9(t) {
  return Object.prototype.toString.call(t);
}
function v9(t) {
  return ec(t) || typeof Ec.ArrayBuffer != "function" ? !1 : typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(t) : t ? !!(t instanceof DataView || t.buffer && t.buffer instanceof ArrayBuffer) : !1;
}
function ci(t, e) {
  t || li(t, !0, e, "==", vh);
}
var l0e = /\s*function\s+([^\(\s]*)\s*/;
function yT(t) {
  if (hc(t)) {
    if (xT())
      return t.name;
    var e = t.toString(), r = e.match(l0e);
    return r && r[1];
  }
}
ci.AssertionError = _m;
function _m(t) {
  this.name = "AssertionError", this.actual = t.actual, this.expected = t.expected, this.operator = t.operator, t.message ? (this.message = t.message, this.generatedMessage = !1) : (this.message = u0e(this), this.generatedMessage = !0);
  var e = t.stackStartFunction || li;
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, e);
  else {
    var r = new Error();
    if (r.stack) {
      var n = r.stack, i = yT(e), a = n.indexOf(`
` + i);
      if (a >= 0) {
        var o = n.indexOf(`
`, a + 1);
        n = n.substring(o + 1);
      }
      this.stack = n;
    }
  }
}
ph(_m, Error);
function b9(t, e) {
  return typeof t == "string" ? t.length < e ? t : t.slice(0, e) : t;
}
function x9(t) {
  if (xT() || !hc(t))
    return ro(t);
  var e = yT(t), r = e ? ": " + e : "";
  return "[Function" + r + "]";
}
function u0e(t) {
  return b9(x9(t.actual), 128) + " " + t.operator + " " + b9(x9(t.expected), 128);
}
function li(t, e, r, n, i) {
  throw new _m({
    message: r,
    actual: t,
    expected: e,
    operator: n,
    stackStartFunction: i
  });
}
ci.fail = li;
function vh(t, e) {
  t || li(t, !0, e, "==", vh);
}
ci.ok = vh;
ci.equal = Rx;
function Rx(t, e, r) {
  t != e && li(t, e, r, "==", Rx);
}
ci.notEqual = Px;
function Px(t, e, r) {
  t == e && li(t, e, r, "!=", Px);
}
ci.deepEqual = Ix;
function Ix(t, e, r) {
  g1(t, e, !1) || li(t, e, r, "deepEqual", Ix);
}
ci.deepStrictEqual = Bx;
function Bx(t, e, r) {
  g1(t, e, !0) || li(t, e, r, "deepStrictEqual", Bx);
}
function g1(t, e, r, n) {
  if (t === e)
    return !0;
  if (ec(t) && ec(e))
    return h9(t, e) === 0;
  if (h1(t) && h1(e))
    return t.getTime() === e.getTime();
  if (dc(t) && dc(e))
    return t.source === e.source && t.global === e.global && t.multiline === e.multiline && t.lastIndex === e.lastIndex && t.ignoreCase === e.ignoreCase;
  if ((t === null || typeof t != "object") && (e === null || typeof e != "object"))
    return r ? t === e : t == e;
  if (v9(t) && v9(e) && g9(t) === g9(e) && !(t instanceof Float32Array || t instanceof Float64Array))
    return h9(
      new Uint8Array(t.buffer),
      new Uint8Array(e.buffer)
    ) === 0;
  if (ec(t) !== ec(e))
    return !1;
  n = n || { actual: [], expected: [] };
  var i = n.actual.indexOf(t);
  return i !== -1 && i === n.expected.indexOf(e) ? !0 : (n.actual.push(t), n.expected.push(e), c0e(t, e, r, n));
}
function y9(t) {
  return Object.prototype.toString.call(t) == "[object Arguments]";
}
function c0e(t, e, r, n) {
  if (t == null || e === null || e === void 0)
    return !1;
  if (sp(t) || sp(e))
    return t === e;
  if (r && Object.getPrototypeOf(t) !== Object.getPrototypeOf(e))
    return !1;
  var i = y9(t), a = y9(e);
  if (i && !a || !i && a)
    return !1;
  if (i)
    return t = m9.call(t), e = m9.call(e), g1(t, e, r);
  var o = p9(t), s = p9(e), l, u;
  if (o.length !== s.length)
    return !1;
  for (o.sort(), s.sort(), u = o.length - 1; u >= 0; u--)
    if (o[u] !== s[u])
      return !1;
  for (u = o.length - 1; u >= 0; u--)
    if (l = o[u], !g1(t[l], e[l], r, n))
      return !1;
  return !0;
}
ci.notDeepEqual = Lx;
function Lx(t, e, r) {
  g1(t, e, !1) && li(t, e, r, "notDeepEqual", Lx);
}
ci.notDeepStrictEqual = Nx;
function Nx(t, e, r) {
  g1(t, e, !0) && li(t, e, r, "notDeepStrictEqual", Nx);
}
ci.strictEqual = Mx;
function Mx(t, e, r) {
  t !== e && li(t, e, r, "===", Mx);
}
ci.notStrictEqual = Ux;
function Ux(t, e, r) {
  t === e && li(t, e, r, "!==", Ux);
}
function w9(t, e) {
  if (!t || !e)
    return !1;
  if (Object.prototype.toString.call(e) == "[object RegExp]")
    return e.test(t);
  try {
    if (t instanceof e)
      return !0;
  } catch {
  }
  return Error.isPrototypeOf(e) ? !1 : e.call({}, t) === !0;
}
function f0e(t) {
  var e;
  try {
    t();
  } catch (r) {
    e = r;
  }
  return e;
}
function wT(t, e, r, n) {
  var i;
  if (typeof e != "function")
    throw new TypeError('"block" argument must be a function');
  typeof r == "string" && (n = r, r = null), i = f0e(e), n = (r && r.name ? " (" + r.name + ")." : ".") + (n ? " " + n : "."), t && !i && li(i, r, "Missing expected exception" + n);
  var a = typeof n == "string", o = !t && t1(i), s = !t && i && !r;
  if ((o && a && w9(i, r) || s) && li(i, r, "Got unwanted exception" + n), t && i && r && !w9(i, r) || !t && i)
    throw i;
}
ci.throws = _T;
function _T(t, e, r) {
  wT(!0, t, e, r);
}
ci.doesNotThrow = AT;
function AT(t, e, r) {
  wT(!1, t, e, r);
}
ci.ifError = ET;
function ET(t) {
  if (t) throw t;
}
var d0e = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  AssertionError: _m,
  assert: vh,
  deepEqual: Ix,
  deepStrictEqual: Bx,
  default: ci,
  doesNotThrow: AT,
  equal: Rx,
  fail: li,
  ifError: ET,
  notDeepEqual: Lx,
  notDeepStrictEqual: Nx,
  notEqual: Px,
  notStrictEqual: Ux,
  ok: vh,
  strictEqual: Mx,
  throws: _T
}), ST = /* @__PURE__ */ F1(d0e);
(function(t) {
  var e = ST, r = nq, n = hs, i = co, a = IY;
  for (var o in a)
    t[o] = a[o];
  t.NONE = 0, t.DEFLATE = 1, t.INFLATE = 2, t.GZIP = 3, t.GUNZIP = 4, t.DEFLATERAW = 5, t.INFLATERAW = 6, t.UNZIP = 7;
  var s = 31, l = 139;
  function u(d) {
    if (typeof d != "number" || d < t.DEFLATE || d > t.UNZIP)
      throw new TypeError("Bad argument");
    this.dictionary = null, this.err = 0, this.flush = 0, this.init_done = !1, this.level = 0, this.memLevel = 0, this.mode = d, this.strategy = 0, this.windowBits = 0, this.write_in_progress = !1, this.pending_close = !1, this.gzip_id_bytes_read = 0;
  }
  u.prototype.close = function() {
    if (this.write_in_progress) {
      this.pending_close = !0;
      return;
    }
    this.pending_close = !1, e(this.init_done, "close before init"), e(this.mode <= t.UNZIP), this.mode === t.DEFLATE || this.mode === t.GZIP || this.mode === t.DEFLATERAW ? n.deflateEnd(this.strm) : (this.mode === t.INFLATE || this.mode === t.GUNZIP || this.mode === t.INFLATERAW || this.mode === t.UNZIP) && i.inflateEnd(this.strm), this.mode = t.NONE, this.dictionary = null;
  }, u.prototype.write = function(d, h, v, b, x, A, T) {
    return this._write(!0, d, h, v, b, x, A, T);
  }, u.prototype.writeSync = function(d, h, v, b, x, A, T) {
    return this._write(!1, d, h, v, b, x, A, T);
  }, u.prototype._write = function(d, h, v, b, x, A, T, k) {
    if (e.equal(arguments.length, 8), e(this.init_done, "write before init"), e(this.mode !== t.NONE, "already finalized"), e.equal(!1, this.write_in_progress, "write already in progress"), e.equal(!1, this.pending_close, "close is pending"), this.write_in_progress = !0, e.equal(!1, h === void 0, "must provide flush value"), this.write_in_progress = !0, h !== t.Z_NO_FLUSH && h !== t.Z_PARTIAL_FLUSH && h !== t.Z_SYNC_FLUSH && h !== t.Z_FULL_FLUSH && h !== t.Z_FINISH && h !== t.Z_BLOCK)
      throw new Error("Invalid flush value");
    if (v == null && (v = Oe.alloc(0), x = 0, b = 0), this.strm.avail_in = x, this.strm.input = v, this.strm.next_in = b, this.strm.avail_out = k, this.strm.output = A, this.strm.next_out = T, this.flush = h, !d)
      return this._process(), this._checkError() ? this._afterSync() : void 0;
    var E = this;
    return Qt.nextTick(function() {
      E._process(), E._after();
    }), this;
  }, u.prototype._afterSync = function() {
    var d = this.strm.avail_out, h = this.strm.avail_in;
    return this.write_in_progress = !1, [h, d];
  }, u.prototype._process = function() {
    var d = null;
    switch (this.mode) {
      case t.DEFLATE:
      case t.GZIP:
      case t.DEFLATERAW:
        this.err = n.deflate(this.strm, this.flush);
        break;
      case t.UNZIP:
        switch (this.strm.avail_in > 0 && (d = this.strm.next_in), this.gzip_id_bytes_read) {
          case 0:
            if (d === null)
              break;
            if (this.strm.input[d] === s) {
              if (this.gzip_id_bytes_read = 1, d++, this.strm.avail_in === 1)
                break;
            } else {
              this.mode = t.INFLATE;
              break;
            }
          case 1:
            if (d === null)
              break;
            this.strm.input[d] === l ? (this.gzip_id_bytes_read = 2, this.mode = t.GUNZIP) : this.mode = t.INFLATE;
            break;
          default:
            throw new Error("invalid number of gzip magic number bytes read");
        }
      case t.INFLATE:
      case t.GUNZIP:
      case t.INFLATERAW:
        for (this.err = i.inflate(
          this.strm,
          this.flush
          // If data was encoded with dictionary
        ), this.err === t.Z_NEED_DICT && this.dictionary && (this.err = i.inflateSetDictionary(this.strm, this.dictionary), this.err === t.Z_OK ? this.err = i.inflate(this.strm, this.flush) : this.err === t.Z_DATA_ERROR && (this.err = t.Z_NEED_DICT)); this.strm.avail_in > 0 && this.mode === t.GUNZIP && this.err === t.Z_STREAM_END && this.strm.next_in[0] !== 0; )
          this.reset(), this.err = i.inflate(this.strm, this.flush);
        break;
      default:
        throw new Error("Unknown mode " + this.mode);
    }
  }, u.prototype._checkError = function() {
    switch (this.err) {
      case t.Z_OK:
      case t.Z_BUF_ERROR:
        if (this.strm.avail_out !== 0 && this.flush === t.Z_FINISH)
          return this._error("unexpected end of file"), !1;
        break;
      case t.Z_STREAM_END:
        break;
      case t.Z_NEED_DICT:
        return this.dictionary == null ? this._error("Missing dictionary") : this._error("Bad dictionary"), !1;
      default:
        return this._error("Zlib error"), !1;
    }
    return !0;
  }, u.prototype._after = function() {
    if (this._checkError()) {
      var d = this.strm.avail_out, h = this.strm.avail_in;
      this.write_in_progress = !1, this.callback(h, d), this.pending_close && this.close();
    }
  }, u.prototype._error = function(d) {
    this.strm.msg && (d = this.strm.msg), this.onerror(
      d,
      this.err
      // no hope of rescue.
    ), this.write_in_progress = !1, this.pending_close && this.close();
  }, u.prototype.init = function(d, h, v, b, x) {
    e(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])"), e(d >= 8 && d <= 15, "invalid windowBits"), e(h >= -1 && h <= 9, "invalid compression level"), e(v >= 1 && v <= 9, "invalid memlevel"), e(b === t.Z_FILTERED || b === t.Z_HUFFMAN_ONLY || b === t.Z_RLE || b === t.Z_FIXED || b === t.Z_DEFAULT_STRATEGY, "invalid strategy"), this._init(h, d, v, b, x), this._setDictionary();
  }, u.prototype.params = function() {
    throw new Error("deflateParams Not supported");
  }, u.prototype.reset = function() {
    this._reset(), this._setDictionary();
  }, u.prototype._init = function(d, h, v, b, x) {
    switch (this.level = d, this.windowBits = h, this.memLevel = v, this.strategy = b, this.flush = t.Z_NO_FLUSH, this.err = t.Z_OK, (this.mode === t.GZIP || this.mode === t.GUNZIP) && (this.windowBits += 16), this.mode === t.UNZIP && (this.windowBits += 32), (this.mode === t.DEFLATERAW || this.mode === t.INFLATERAW) && (this.windowBits = -1 * this.windowBits), this.strm = new r(), this.mode) {
      case t.DEFLATE:
      case t.GZIP:
      case t.DEFLATERAW:
        this.err = n.deflateInit2(this.strm, this.level, t.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
        break;
      case t.INFLATE:
      case t.GUNZIP:
      case t.INFLATERAW:
      case t.UNZIP:
        this.err = i.inflateInit2(this.strm, this.windowBits);
        break;
      default:
        throw new Error("Unknown mode " + this.mode);
    }
    this.err !== t.Z_OK && this._error("Init error"), this.dictionary = x, this.write_in_progress = !1, this.init_done = !0;
  }, u.prototype._setDictionary = function() {
    if (this.dictionary != null) {
      switch (this.err = t.Z_OK, this.mode) {
        case t.DEFLATE:
        case t.DEFLATERAW:
          this.err = n.deflateSetDictionary(this.strm, this.dictionary);
          break;
      }
      this.err !== t.Z_OK && this._error("Failed to set dictionary");
    }
  }, u.prototype._reset = function() {
    switch (this.err = t.Z_OK, this.mode) {
      case t.DEFLATE:
      case t.DEFLATERAW:
      case t.GZIP:
        this.err = n.deflateReset(this.strm);
        break;
      case t.INFLATE:
      case t.INFLATERAW:
      case t.GUNZIP:
        this.err = i.inflateReset(this.strm);
        break;
    }
    this.err !== t.Z_OK && this._error("Failed to reset stream");
  }, t.Zlib = u;
})(bT);
(function(t) {
  var e = hh.Buffer, r = mT.Transform, n = bT, i = Sx, a = ST.ok, o = hh.kMaxLength, s = "Cannot create final Buffer. It would be larger than 0x" + o.toString(16) + " bytes";
  n.Z_MIN_WINDOWBITS = 8, n.Z_MAX_WINDOWBITS = 15, n.Z_DEFAULT_WINDOWBITS = 15, n.Z_MIN_CHUNK = 64, n.Z_MAX_CHUNK = 1 / 0, n.Z_DEFAULT_CHUNK = 16 * 1024, n.Z_MIN_MEMLEVEL = 1, n.Z_MAX_MEMLEVEL = 9, n.Z_DEFAULT_MEMLEVEL = 8, n.Z_MIN_LEVEL = -1, n.Z_MAX_LEVEL = 9, n.Z_DEFAULT_LEVEL = n.Z_DEFAULT_COMPRESSION;
  for (var l = Object.keys(n), u = 0; u < l.length; u++) {
    var d = l[u];
    d.match(/^Z/) && Object.defineProperty(t, d, {
      enumerable: !0,
      value: n[d],
      writable: !1
    });
  }
  for (var h = {
    Z_OK: n.Z_OK,
    Z_STREAM_END: n.Z_STREAM_END,
    Z_NEED_DICT: n.Z_NEED_DICT,
    Z_ERRNO: n.Z_ERRNO,
    Z_STREAM_ERROR: n.Z_STREAM_ERROR,
    Z_DATA_ERROR: n.Z_DATA_ERROR,
    Z_MEM_ERROR: n.Z_MEM_ERROR,
    Z_BUF_ERROR: n.Z_BUF_ERROR,
    Z_VERSION_ERROR: n.Z_VERSION_ERROR
  }, v = Object.keys(h), b = 0; b < v.length; b++) {
    var x = v[b];
    h[h[x]] = x;
  }
  Object.defineProperty(t, "codes", {
    enumerable: !0,
    value: Object.freeze(h),
    writable: !1
  }), t.Deflate = k, t.Inflate = E, t.Gzip = C, t.Gunzip = D, t.DeflateRaw = _, t.InflateRaw = I, t.Unzip = R, t.createDeflate = function(S) {
    return new k(S);
  }, t.createInflate = function(S) {
    return new E(S);
  }, t.createDeflateRaw = function(S) {
    return new _(S);
  }, t.createInflateRaw = function(S) {
    return new I(S);
  }, t.createGzip = function(S) {
    return new C(S);
  }, t.createGunzip = function(S) {
    return new D(S);
  }, t.createUnzip = function(S) {
    return new R(S);
  }, t.deflate = function(S, B, q) {
    return typeof B == "function" && (q = B, B = {}), A(new k(B), S, q);
  }, t.deflateSync = function(S, B) {
    return T(new k(B), S);
  }, t.gzip = function(S, B, q) {
    return typeof B == "function" && (q = B, B = {}), A(new C(B), S, q);
  }, t.gzipSync = function(S, B) {
    return T(new C(B), S);
  }, t.deflateRaw = function(S, B, q) {
    return typeof B == "function" && (q = B, B = {}), A(new _(B), S, q);
  }, t.deflateRawSync = function(S, B) {
    return T(new _(B), S);
  }, t.unzip = function(S, B, q) {
    return typeof B == "function" && (q = B, B = {}), A(new R(B), S, q);
  }, t.unzipSync = function(S, B) {
    return T(new R(B), S);
  }, t.inflate = function(S, B, q) {
    return typeof B == "function" && (q = B, B = {}), A(new E(B), S, q);
  }, t.inflateSync = function(S, B) {
    return T(new E(B), S);
  }, t.gunzip = function(S, B, q) {
    return typeof B == "function" && (q = B, B = {}), A(new D(B), S, q);
  }, t.gunzipSync = function(S, B) {
    return T(new D(B), S);
  }, t.inflateRaw = function(S, B, q) {
    return typeof B == "function" && (q = B, B = {}), A(new I(B), S, q);
  }, t.inflateRawSync = function(S, B) {
    return T(new I(B), S);
  };
  function A(S, B, q) {
    var Y = [], Z = 0;
    S.on("error", J), S.on("end", se), S.end(B), Q();
    function Q() {
      for (var ae; (ae = S.read()) !== null; )
        Y.push(ae), Z += ae.length;
      S.once("readable", Q);
    }
    function J(ae) {
      S.removeListener("end", se), S.removeListener("readable", Q), q(ae);
    }
    function se() {
      var ae, te = null;
      Z >= o ? te = new RangeError(s) : ae = e.concat(Y, Z), Y = [], S.close(), q(te, ae);
    }
  }
  function T(S, B) {
    if (typeof B == "string" && (B = e.from(B)), !e.isBuffer(B)) throw new TypeError("Not a string or buffer");
    var q = S._finishFlushFlag;
    return S._processChunk(B, q);
  }
  function k(S) {
    if (!(this instanceof k)) return new k(S);
    V.call(this, S, n.DEFLATE);
  }
  function E(S) {
    if (!(this instanceof E)) return new E(S);
    V.call(this, S, n.INFLATE);
  }
  function C(S) {
    if (!(this instanceof C)) return new C(S);
    V.call(this, S, n.GZIP);
  }
  function D(S) {
    if (!(this instanceof D)) return new D(S);
    V.call(this, S, n.GUNZIP);
  }
  function _(S) {
    if (!(this instanceof _)) return new _(S);
    V.call(this, S, n.DEFLATERAW);
  }
  function I(S) {
    if (!(this instanceof I)) return new I(S);
    V.call(this, S, n.INFLATERAW);
  }
  function R(S) {
    if (!(this instanceof R)) return new R(S);
    V.call(this, S, n.UNZIP);
  }
  function U(S) {
    return S === n.Z_NO_FLUSH || S === n.Z_PARTIAL_FLUSH || S === n.Z_SYNC_FLUSH || S === n.Z_FULL_FLUSH || S === n.Z_FINISH || S === n.Z_BLOCK;
  }
  function V(S, B) {
    var q = this;
    if (this._opts = S = S || {}, this._chunkSize = S.chunkSize || t.Z_DEFAULT_CHUNK, r.call(this, S), S.flush && !U(S.flush))
      throw new Error("Invalid flush flag: " + S.flush);
    if (S.finishFlush && !U(S.finishFlush))
      throw new Error("Invalid flush flag: " + S.finishFlush);
    if (this._flushFlag = S.flush || n.Z_NO_FLUSH, this._finishFlushFlag = typeof S.finishFlush < "u" ? S.finishFlush : n.Z_FINISH, S.chunkSize && (S.chunkSize < t.Z_MIN_CHUNK || S.chunkSize > t.Z_MAX_CHUNK))
      throw new Error("Invalid chunk size: " + S.chunkSize);
    if (S.windowBits && (S.windowBits < t.Z_MIN_WINDOWBITS || S.windowBits > t.Z_MAX_WINDOWBITS))
      throw new Error("Invalid windowBits: " + S.windowBits);
    if (S.level && (S.level < t.Z_MIN_LEVEL || S.level > t.Z_MAX_LEVEL))
      throw new Error("Invalid compression level: " + S.level);
    if (S.memLevel && (S.memLevel < t.Z_MIN_MEMLEVEL || S.memLevel > t.Z_MAX_MEMLEVEL))
      throw new Error("Invalid memLevel: " + S.memLevel);
    if (S.strategy && S.strategy != t.Z_FILTERED && S.strategy != t.Z_HUFFMAN_ONLY && S.strategy != t.Z_RLE && S.strategy != t.Z_FIXED && S.strategy != t.Z_DEFAULT_STRATEGY)
      throw new Error("Invalid strategy: " + S.strategy);
    if (S.dictionary && !e.isBuffer(S.dictionary))
      throw new Error("Invalid dictionary: it should be a Buffer instance");
    this._handle = new n.Zlib(B);
    var Y = this;
    this._hadError = !1, this._handle.onerror = function(J, se) {
      z(Y), Y._hadError = !0;
      var ae = new Error(J);
      ae.errno = se, ae.code = t.codes[se], Y.emit("error", ae);
    };
    var Z = t.Z_DEFAULT_COMPRESSION;
    typeof S.level == "number" && (Z = S.level);
    var Q = t.Z_DEFAULT_STRATEGY;
    typeof S.strategy == "number" && (Q = S.strategy), this._handle.init(S.windowBits || t.Z_DEFAULT_WINDOWBITS, Z, S.memLevel || t.Z_DEFAULT_MEMLEVEL, Q, S.dictionary), this._buffer = e.allocUnsafe(this._chunkSize), this._offset = 0, this._level = Z, this._strategy = Q, this.once("end", this.close), Object.defineProperty(this, "_closed", {
      get: function() {
        return !q._handle;
      },
      configurable: !0,
      enumerable: !0
    });
  }
  i.inherits(V, r), V.prototype.params = function(S, B, q) {
    if (S < t.Z_MIN_LEVEL || S > t.Z_MAX_LEVEL)
      throw new RangeError("Invalid compression level: " + S);
    if (B != t.Z_FILTERED && B != t.Z_HUFFMAN_ONLY && B != t.Z_RLE && B != t.Z_FIXED && B != t.Z_DEFAULT_STRATEGY)
      throw new TypeError("Invalid strategy: " + B);
    if (this._level !== S || this._strategy !== B) {
      var Y = this;
      this.flush(n.Z_SYNC_FLUSH, function() {
        a(Y._handle, "zlib binding closed"), Y._handle.params(S, B), Y._hadError || (Y._level = S, Y._strategy = B, q && q());
      });
    } else
      Qt.nextTick(q);
  }, V.prototype.reset = function() {
    return a(this._handle, "zlib binding closed"), this._handle.reset();
  }, V.prototype._flush = function(S) {
    this._transform(e.alloc(0), "", S);
  }, V.prototype.flush = function(S, B) {
    var q = this, Y = this._writableState;
    (typeof S == "function" || S === void 0 && !B) && (B = S, S = n.Z_FULL_FLUSH), Y.ended ? B && Qt.nextTick(B) : Y.ending ? B && this.once("end", B) : Y.needDrain ? B && this.once("drain", function() {
      return q.flush(S, B);
    }) : (this._flushFlag = S, this.write(e.alloc(0), "", B));
  }, V.prototype.close = function(S) {
    z(this, S), Qt.nextTick(j, this);
  };
  function z(S, B) {
    B && Qt.nextTick(B), S._handle && (S._handle.close(), S._handle = null);
  }
  function j(S) {
    S.emit("close");
  }
  V.prototype._transform = function(S, B, q) {
    var Y, Z = this._writableState, Q = Z.ending || Z.ended, J = Q && (!S || Z.length === S.length);
    if (S !== null && !e.isBuffer(S)) return q(new Error("invalid input"));
    if (!this._handle) return q(new Error("zlib binding closed"));
    J ? Y = this._finishFlushFlag : (Y = this._flushFlag, S.length >= Z.length && (this._flushFlag = this._opts.flush || n.Z_NO_FLUSH)), this._processChunk(S, Y, q);
  }, V.prototype._processChunk = function(S, B, q) {
    var Y = S && S.length, Z = this._chunkSize - this._offset, Q = 0, J = this, se = typeof q == "function";
    if (!se) {
      var ae = [], te = 0, ne;
      this.on("error", function(it) {
        ne = it;
      }), a(this._handle, "zlib binding closed");
      do
        var ce = this._handle.writeSync(
          B,
          S,
          // in
          Q,
          // in_off
          Y,
          // in_len
          this._buffer,
          // out
          this._offset,
          //out_off
          Z
        );
      while (!this._hadError && Ne(ce[0], ce[1]));
      if (this._hadError)
        throw ne;
      if (te >= o)
        throw z(this), new RangeError(s);
      var pe = e.concat(ae, te);
      return z(this), pe;
    }
    a(this._handle, "zlib binding closed");
    var Me = this._handle.write(
      B,
      S,
      // in
      Q,
      // in_off
      Y,
      // in_len
      this._buffer,
      // out
      this._offset,
      //out_off
      Z
    );
    Me.buffer = S, Me.callback = Ne;
    function Ne(it, fe) {
      if (this && (this.buffer = null, this.callback = null), !J._hadError) {
        var ye = Z - fe;
        if (a(ye >= 0, "have should not go down"), ye > 0) {
          var be = J._buffer.slice(J._offset, J._offset + ye);
          J._offset += ye, se ? J.push(be) : (ae.push(be), te += be.length);
        }
        if ((fe === 0 || J._offset >= J._chunkSize) && (Z = J._chunkSize, J._offset = 0, J._buffer = e.allocUnsafe(J._chunkSize)), fe === 0) {
          if (Q += Y - it, Y = it, !se) return !0;
          var he = J._handle.write(B, S, Q, Y, J._buffer, J._offset, J._chunkSize);
          he.callback = Ne, he.buffer = S;
          return;
        }
        if (!se) return !1;
        q();
      }
    }
  }, i.inherits(k, V), i.inherits(E, V), i.inherits(C, V), i.inherits(D, V), i.inherits(_, V), i.inherits(I, V), i.inherits(R, V);
})(vT);
var Rd = /* @__PURE__ */ Ok(vT);
class CT extends gT.Writable {
  constructor(e, r, n) {
    super({
      decodeStrings: !1
    }), this.finalize = this.finalize.bind(this), this.document = e, this.id = r, n == null && (n = {}), this.data = n, this.gen = 0, this.deflate = null, this.compress = this.document.compress && !this.data.Filter, this.uncompressedLength = 0, this.chunks = [];
  }
  initDeflate() {
    return this.data.Filter = "FlateDecode", this.deflate = Rd.createDeflate(), this.deflate.on("data", (e) => (this.chunks.push(e), this.data.Length += e.length)), this.deflate.on("end", this.finalize);
  }
  _write(e, r, n) {
    return e instanceof Uint8Array || (e = Oe.from(e + `
`, "binary")), this.uncompressedLength += e.length, this.data.Length == null && (this.data.Length = 0), this.compress ? (this.deflate || this.initDeflate(), this.deflate.write(e)) : (this.chunks.push(e), this.data.Length += e.length), n();
  }
  end() {
    return super.end(...arguments), this.deflate ? this.deflate.end() : this.finalize();
  }
  finalize() {
    if (this.offset = this.document._offset, this.document._write(`${this.id} ${this.gen} obj`), this.document._write(Qi.convert(this.data)), this.chunks.length) {
      this.document._write("stream");
      for (let e of Array.from(this.chunks))
        this.document._write(e);
      this.chunks.length = 0, this.document._write(`
endstream`);
    }
    return this.document._write("endobj"), this.document._refEnd(this);
  }
  toString() {
    return `${this.id} ${this.gen} R`;
  }
}
class kT {
  constructor(e) {
    e === void 0 && (e = {}), this._items = {}, this.limits = typeof e.limits == "boolean" ? e.limits : !0;
  }
  add(e, r) {
    return this._items[e] = r;
  }
  get(e) {
    return this._items[e];
  }
  toString() {
    const e = Object.keys(this._items).sort((n, i) => this._compareKeys(n, i)), r = ["<<"];
    if (this.limits && e.length > 1) {
      const n = e[0], i = e[e.length - 1];
      r.push(`  /Limits ${Qi.convert([this._dataForKey(n), this._dataForKey(i)])}`);
    }
    r.push(`  /${this._keysName()} [`);
    for (let n of e)
      r.push(`    ${Qi.convert(this._dataForKey(n))} ${Qi.convert(this._items[n])}`);
    return r.push("]"), r.push(">>"), r.join(`
`);
  }
  _compareKeys() {
    throw new Error("Must be implemented by subclasses");
  }
  _keysName() {
    throw new Error("Must be implemented by subclasses");
  }
  _dataForKey() {
    throw new Error("Must be implemented by subclasses");
  }
}
class v5 extends kT {
  _compareKeys(e, r) {
    return e.localeCompare(r);
  }
  _keysName() {
    return "Names";
  }
  _dataForKey(e) {
    return new String(e);
  }
}
const Rf = (t, e) => (Array(e + 1).join("0") + t).slice(-e), h0e = /[\n\r\t\b\f()\\]/g, p0e = {
  "\n": "\\n",
  "\r": "\\r",
  "	": "\\t",
  "\b": "\\b",
  "\f": "\\f",
  "\\": "\\\\",
  "(": "\\(",
  ")": "\\)"
}, m0e = function(t) {
  const e = t.length;
  if (e & 1)
    throw new Error("Buffer length must be even");
  for (let r = 0, n = e - 1; r < n; r += 2) {
    const i = t[r];
    t[r] = t[r + 1], t[r + 1] = i;
  }
  return t;
};
class Qi {
  static convert(e) {
    if (typeof e == "string")
      return `/${e}`;
    if (e instanceof String) {
      let r = e, n = !1;
      for (let i = 0, a = r.length; i < a; i++)
        if (r.charCodeAt(i) > 127) {
          n = !0;
          break;
        }
      return n && (r = m0e(Oe.from(`\uFEFF${r}`, "utf16le")).toString("binary")), r = r.replace(h0e, (i) => p0e[i]), `(${r})`;
    }
    if (Oe.isBuffer(e))
      return `<${e.toString("hex")}>`;
    if (e instanceof CT || e instanceof v5)
      return e.toString();
    if (e instanceof Date)
      return `(D:${Rf(e.getUTCFullYear(), 4)}` + Rf(e.getUTCMonth() + 1, 2) + Rf(e.getUTCDate(), 2) + Rf(e.getUTCHours(), 2) + Rf(e.getUTCMinutes(), 2) + Rf(e.getUTCSeconds(), 2) + "Z)";
    if (Array.isArray(e))
      return `[${Array.from(e).map((n) => Qi.convert(n)).join(" ")}]`;
    if ({}.toString.call(e) === "[object Object]") {
      const r = ["<<"];
      for (let n in e) {
        const i = e[n];
        r.push(`/${n} ${Qi.convert(i)}`);
      }
      return r.push(">>"), r.join(`
`);
    }
    return typeof e == "number" ? Qi.number(e) : `${e}`;
  }
  static number(e) {
    if (e > -1e21 && e < 1e21)
      return Math.round(e * 1e6) / 1e6;
    throw new Error(`unsupported number: ${e}`);
  }
}
const g0e = {
  top: 72,
  left: 72,
  bottom: 72,
  right: 72
}, v0e = {
  "4A0": [4767.87, 6740.79],
  "2A0": [3370.39, 4767.87],
  A0: [2383.94, 3370.39],
  A1: [1683.78, 2383.94],
  A2: [1190.55, 1683.78],
  A3: [841.89, 1190.55],
  A4: [595.28, 841.89],
  A5: [419.53, 595.28],
  A6: [297.64, 419.53],
  A7: [209.76, 297.64],
  A8: [147.4, 209.76],
  A9: [104.88, 147.4],
  A10: [73.7, 104.88],
  B0: [2834.65, 4008.19],
  B1: [2004.09, 2834.65],
  B2: [1417.32, 2004.09],
  B3: [1000.63, 1417.32],
  B4: [708.66, 1000.63],
  B5: [498.9, 708.66],
  B6: [354.33, 498.9],
  B7: [249.45, 354.33],
  B8: [175.75, 249.45],
  B9: [124.72, 175.75],
  B10: [87.87, 124.72],
  C0: [2599.37, 3676.54],
  C1: [1836.85, 2599.37],
  C2: [1298.27, 1836.85],
  C3: [918.43, 1298.27],
  C4: [649.13, 918.43],
  C5: [459.21, 649.13],
  C6: [323.15, 459.21],
  C7: [229.61, 323.15],
  C8: [161.57, 229.61],
  C9: [113.39, 161.57],
  C10: [79.37, 113.39],
  RA0: [2437.8, 3458.27],
  RA1: [1729.13, 2437.8],
  RA2: [1218.9, 1729.13],
  RA3: [864.57, 1218.9],
  RA4: [609.45, 864.57],
  SRA0: [2551.18, 3628.35],
  SRA1: [1814.17, 2551.18],
  SRA2: [1275.59, 1814.17],
  SRA3: [907.09, 1275.59],
  SRA4: [637.8, 907.09],
  EXECUTIVE: [521.86, 756],
  FOLIO: [612, 936],
  LEGAL: [612, 1008],
  LETTER: [612, 792],
  TABLOID: [792, 1224]
};
class b0e {
  constructor(e, r) {
    r === void 0 && (r = {}), this.document = e, this._options = r, this.size = r.size || "letter", this.layout = r.layout || "portrait", this.userUnit = r.userUnit || 1, typeof r.margin == "number" ? this.margins = {
      top: r.margin,
      left: r.margin,
      bottom: r.margin,
      right: r.margin
    } : this.margins = r.margins || g0e;
    const n = Array.isArray(this.size) ? this.size : v0e[this.size.toUpperCase()];
    this.width = n[this.layout === "portrait" ? 0 : 1], this.height = n[this.layout === "portrait" ? 1 : 0], this.content = this.document.ref(), r.font && e.font(r.font, r.fontFamily), r.fontSize && e.fontSize(r.fontSize), this.resources = this.document.ref({
      ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"]
    }), this.dictionary = this.document.ref({
      Type: "Page",
      Parent: this.document._root.data.Pages,
      MediaBox: [0, 0, this.width, this.height],
      Contents: this.content,
      Resources: this.resources,
      UserUnit: this.userUnit
    }), this.markings = [];
  }
  // Lazily create these objects
  get fonts() {
    const e = this.resources.data;
    return e.Font != null ? e.Font : e.Font = {};
  }
  get xobjects() {
    const e = this.resources.data;
    return e.XObject != null ? e.XObject : e.XObject = {};
  }
  get ext_gstates() {
    const e = this.resources.data;
    return e.ExtGState != null ? e.ExtGState : e.ExtGState = {};
  }
  get patterns() {
    const e = this.resources.data;
    return e.Pattern != null ? e.Pattern : e.Pattern = {};
  }
  get colorSpaces() {
    const e = this.resources.data;
    return e.ColorSpace || (e.ColorSpace = {});
  }
  get annotations() {
    const e = this.dictionary.data;
    return e.Annots != null ? e.Annots : e.Annots = [];
  }
  get structParentTreeKey() {
    const e = this.dictionary.data;
    return e.StructParents != null ? e.StructParents : e.StructParents = this.document.createStructParentTreeNextKey();
  }
  maxY() {
    return this.height - this.margins.bottom;
  }
  write(e) {
    return this.content.write(e);
  }
  // Set tab order if document is tagged for accessibility.
  _setTabOrder() {
    !this.dictionary.Tabs && this.document.hasMarkInfoDictionary() && (this.dictionary.data.Tabs = "S");
  }
  end() {
    this._setTabOrder(), this.dictionary.end(), this.resources.data.ColorSpace = this.resources.data.ColorSpace || {};
    for (let e of Object.values(this.document.spotColors))
      this.resources.data.ColorSpace[e.id] = e;
    return this.resources.end(), this.content.end();
  }
}
const x0e = (t) => {
  const e = [];
  for (let r = 0; r < t.sigBytes; r++)
    e.push(t.words[Math.floor(r / 4)] >> 8 * (3 - r % 4) & 255);
  return Oe.from(e);
};
class y0e {
  static generateFileID(e) {
    e === void 0 && (e = {});
    let r = `${e.CreationDate.getTime()}
`;
    for (let n in e)
      e.hasOwnProperty(n) && (r += `${n}: ${e[n].valueOf()}
`);
    return x0e(UY(r));
  }
}
const {
  number: w0e
} = Qi;
let zx = class {
  constructor(e) {
    this.doc = e, this.stops = [], this.embedded = !1, this.transform = [1, 0, 0, 1, 0, 0];
  }
  stop(e, r, n) {
    if (n == null && (n = 1), r = this.doc._normalizeColor(r), this.stops.length === 0)
      if (r.length === 3)
        this._colorSpace = "DeviceRGB";
      else if (r.length === 4)
        this._colorSpace = "DeviceCMYK";
      else if (r.length === 1)
        this._colorSpace = "DeviceGray";
      else
        throw new Error("Unknown color space");
    else if (this._colorSpace === "DeviceRGB" && r.length !== 3 || this._colorSpace === "DeviceCMYK" && r.length !== 4 || this._colorSpace === "DeviceGray" && r.length !== 1)
      throw new Error("All gradient stops must use the same color space");
    return n = Math.max(0, Math.min(1, n)), this.stops.push([e, r, n]), this;
  }
  setTransform(e, r, n, i, a, o) {
    return this.transform = [e, r, n, i, a, o], this;
  }
  embed(e) {
    let r;
    const n = this.stops.length;
    if (n === 0)
      return;
    this.embedded = !0, this.matrix = e;
    const i = this.stops[n - 1];
    i[0] < 1 && this.stops.push([1, i[1], i[2]]);
    const a = [], o = [], s = [];
    for (let d = 0; d < n - 1; d++)
      o.push(0, 1), d + 2 !== n && a.push(this.stops[d + 1][0]), r = this.doc.ref({
        FunctionType: 2,
        Domain: [0, 1],
        C0: this.stops[d + 0][1],
        C1: this.stops[d + 1][1],
        N: 1
      }), s.push(r), r.end();
    n === 1 ? r = s[0] : (r = this.doc.ref({
      FunctionType: 3,
      // stitching function
      Domain: [0, 1],
      Functions: s,
      Bounds: a,
      Encode: o
    }), r.end()), this.id = `Sh${++this.doc._gradCount}`;
    const l = this.shader(r);
    l.end();
    const u = this.doc.ref({
      Type: "Pattern",
      PatternType: 2,
      Shading: l,
      Matrix: this.matrix.map(w0e)
    });
    if (u.end(), this.stops.some((d) => d[2] < 1)) {
      let d = this.opacityGradient();
      d._colorSpace = "DeviceGray";
      for (let A of this.stops)
        d.stop(A[0], [A[2]]);
      d = d.embed(this.matrix);
      const h = [0, 0, this.doc.page.width, this.doc.page.height], v = this.doc.ref({
        Type: "XObject",
        Subtype: "Form",
        FormType: 1,
        BBox: h,
        Group: {
          Type: "Group",
          S: "Transparency",
          CS: "DeviceGray"
        },
        Resources: {
          ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"],
          Pattern: {
            Sh1: d
          }
        }
      });
      v.write("/Pattern cs /Sh1 scn"), v.end(`${h.join(" ")} re f`);
      const b = this.doc.ref({
        Type: "ExtGState",
        SMask: {
          Type: "Mask",
          S: "Luminosity",
          G: v
        }
      });
      b.end();
      const x = this.doc.ref({
        Type: "Pattern",
        PatternType: 1,
        PaintType: 1,
        TilingType: 2,
        BBox: h,
        XStep: h[2],
        YStep: h[3],
        Resources: {
          ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"],
          Pattern: {
            Sh1: u
          },
          ExtGState: {
            Gs1: b
          }
        }
      });
      x.write("/Gs1 gs /Pattern cs /Sh1 scn"), x.end(`${h.join(" ")} re f`), this.doc.page.patterns[this.id] = x;
    } else
      this.doc.page.patterns[this.id] = u;
    return u;
  }
  apply(e) {
    const [r, n, i, a, o, s] = this.doc._ctm, [l, u, d, h, v, b] = this.transform, x = [r * l + i * u, n * l + a * u, r * d + i * h, n * d + a * h, r * v + i * b + o, n * v + a * b + s];
    (!this.embedded || x.join(" ") !== this.matrix.join(" ")) && this.embed(x), this.doc._setColorSpace("Pattern", e);
    const A = e ? "SCN" : "scn";
    return this.doc.addContent(`/${this.id} ${A}`);
  }
}, _0e = class TT extends zx {
  constructor(e, r, n, i, a) {
    super(e), this.x1 = r, this.y1 = n, this.x2 = i, this.y2 = a;
  }
  shader(e) {
    return this.doc.ref({
      ShadingType: 2,
      ColorSpace: this._colorSpace,
      Coords: [this.x1, this.y1, this.x2, this.y2],
      Function: e,
      Extend: [!0, !0]
    });
  }
  opacityGradient() {
    return new TT(this.doc, this.x1, this.y1, this.x2, this.y2);
  }
}, A0e = class FT extends zx {
  constructor(e, r, n, i, a, o, s) {
    super(e), this.doc = e, this.x1 = r, this.y1 = n, this.r1 = i, this.x2 = a, this.y2 = o, this.r2 = s;
  }
  shader(e) {
    return this.doc.ref({
      ShadingType: 3,
      ColorSpace: this._colorSpace,
      Coords: [this.x1, this.y1, this.r1, this.x2, this.y2, this.r2],
      Function: e,
      Extend: [!0, !0]
    });
  }
  opacityGradient() {
    return new FT(this.doc, this.x1, this.y1, this.r1, this.x2, this.y2, this.r2);
  }
};
var E0e = {
  PDFGradient: zx,
  PDFLinearGradient: _0e,
  PDFRadialGradient: A0e
};
const S0e = ["DeviceCMYK", "DeviceRGB"];
let C0e = class {
  constructor(e, r, n, i, a) {
    this.doc = e, this.bBox = r, this.xStep = n, this.yStep = i, this.stream = a;
  }
  createPattern() {
    const e = this.doc.ref();
    e.end();
    const [r, n, i, a, o, s] = this.doc._ctm, [l, u, d, h, v, b] = [1, 0, 0, 1, 0, 0], x = [r * l + i * u, n * l + a * u, r * d + i * h, n * d + a * h, r * v + i * b + o, n * v + a * b + s], A = this.doc.ref({
      Type: "Pattern",
      PatternType: 1,
      // tiling
      PaintType: 2,
      // 1-colored, 2-uncolored
      TilingType: 2,
      // 2-no distortion
      BBox: this.bBox,
      XStep: this.xStep,
      YStep: this.yStep,
      Matrix: x.map((T) => +T.toFixed(5)),
      Resources: e
    });
    return A.end(this.stream), A;
  }
  embedPatternColorSpaces() {
    S0e.forEach((e) => {
      const r = this.getPatternColorSpaceId(e);
      if (this.doc.page.colorSpaces[r]) return;
      const n = this.doc.ref(["Pattern", e]);
      n.end(), this.doc.page.colorSpaces[r] = n;
    });
  }
  getPatternColorSpaceId(e) {
    return `CsP${e}`;
  }
  embed() {
    this.id || (this.doc._patternCount = this.doc._patternCount + 1, this.id = "P" + this.doc._patternCount, this.pattern = this.createPattern()), this.doc.page.patterns[this.id] || (this.doc.page.patterns[this.id] = this.pattern);
  }
  apply(e, r) {
    this.embedPatternColorSpaces(), this.embed();
    const n = this.doc._normalizeColor(r);
    if (!n) throw Error(`invalid pattern color. (value: ${r})`);
    const i = this.getPatternColorSpaceId(this.doc._getColorSpace(n));
    this.doc._setColorSpace(i, e);
    const a = e ? "SCN" : "scn";
    return this.doc.addContent(`${n.join(" ")} /${this.id} ${a}`);
  }
};
var k0e = {
  PDFTilingPattern: C0e
};
class kv {
  constructor(e, r, n, i, a, o) {
    this.id = "CS" + Object.keys(e.spotColors).length, this.name = r, this.values = [n, i, a, o], this.ref = e.ref(["Separation", this.name, "DeviceCMYK", {
      Range: [0, 1, 0, 1, 0, 1, 0, 1],
      C0: [0, 0, 0, 0],
      C1: this.values.map((s) => s / 100),
      FunctionType: 2,
      Domain: [0, 1],
      N: 1
    }]), this.ref.end();
  }
  toString() {
    return `${this.ref.id} 0 R`;
  }
}
const {
  PDFGradient: T0e,
  PDFLinearGradient: F0e,
  PDFRadialGradient: D0e
} = E0e, {
  PDFTilingPattern: _9
} = k0e;
var O0e = {
  initColor() {
    return this.spotColors = {}, this._opacityRegistry = {}, this._opacityCount = 0, this._patternCount = 0, this._gradCount = 0;
  },
  _normalizeColor(t) {
    if (typeof t == "string") {
      if (t.charAt(0) === "#") {
        t.length === 4 && (t = t.replace(/#([0-9A-F])([0-9A-F])([0-9A-F])/i, "#$1$1$2$2$3$3"));
        const e = parseInt(t.slice(1), 16);
        t = [e >> 16, e >> 8 & 255, e & 255];
      } else if (A9[t])
        t = A9[t];
      else if (this.spotColors[t])
        return this.spotColors[t];
    }
    return Array.isArray(t) ? (t.length === 3 ? t = t.map((e) => e / 255) : t.length === 4 && (t = t.map((e) => e / 100)), t) : null;
  },
  _setColor(t, e) {
    return t instanceof T0e ? (t.apply(e), !0) : Array.isArray(t) && t[0] instanceof _9 ? (t[0].apply(e, t[1]), !0) : this._setColorCore(t, e);
  },
  _setColorCore(t, e) {
    if (t = this._normalizeColor(t), !t)
      return !1;
    const r = e ? "SCN" : "scn", n = this._getColorSpace(t);
    return this._setColorSpace(n, e), t instanceof kv ? (this.page.colorSpaces[t.id] = t.ref, this.addContent(`1 ${r}`)) : this.addContent(`${t.join(" ")} ${r}`), !0;
  },
  _setColorSpace(t, e) {
    const r = e ? "CS" : "cs";
    return this.addContent(`/${t} ${r}`);
  },
  _getColorSpace(t) {
    return t instanceof kv ? t.id : t.length === 4 ? "DeviceCMYK" : "DeviceRGB";
  },
  fillColor(t, e) {
    return this._setColor(t, !1) && this.fillOpacity(e), this._fillColor = [t, e], this;
  },
  strokeColor(t, e) {
    return this._setColor(t, !0) && this.strokeOpacity(e), this;
  },
  opacity(t) {
    return this._doOpacity(t, t), this;
  },
  fillOpacity(t) {
    return this._doOpacity(t, null), this;
  },
  strokeOpacity(t) {
    return this._doOpacity(null, t), this;
  },
  _doOpacity(t, e) {
    let r, n;
    if (t == null && e == null)
      return;
    t != null && (t = Math.max(0, Math.min(1, t))), e != null && (e = Math.max(0, Math.min(1, e)));
    const i = `${t}_${e}`;
    return this._opacityRegistry[i] ? [r, n] = this._opacityRegistry[i] : (r = {
      Type: "ExtGState"
    }, t != null && (r.ca = t), e != null && (r.CA = e), r = this.ref(r), r.end(), n = `Gs${++this._opacityCount}`, this._opacityRegistry[i] = [r, n]), this.page.ext_gstates[n] = r, this.addContent(`/${n} gs`);
  },
  linearGradient(t, e, r, n) {
    return new F0e(this, t, e, r, n);
  },
  radialGradient(t, e, r, n, i, a) {
    return new D0e(this, t, e, r, n, i, a);
  },
  pattern(t, e, r, n) {
    return new _9(this, t, e, r, n);
  },
  addSpotColor(t, e, r, n, i) {
    const a = new kv(this, t, e, r, n, i);
    return this.spotColors[t] = a, this;
  }
}, A9 = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  grey: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
};
let bt, xt, n0, g0, Wf, Hf;
bt = xt = n0 = g0 = Wf = Hf = 0;
const DT = {
  M: 2,
  m: 2,
  Z: 0,
  z: 0,
  L: 2,
  l: 2,
  H: 1,
  h: 1,
  V: 1,
  v: 1,
  C: 6,
  c: 6,
  S: 4,
  s: 4,
  Q: 4,
  q: 4,
  T: 2,
  t: 2,
  A: 7,
  a: 7
}, R0e = (t) => t in DT, P0e = (t) => {
  const e = t.codePointAt(0);
  return e === 32 || e === 9 || e === 13 || e === 10;
}, I0e = (t) => {
  const e = t.codePointAt(0);
  return e == null ? !1 : 48 <= e && e <= 57;
}, Tv = (t, e) => {
  let r = e, n = "", i = (
    /** @type {ReadNumberState} */
    "none"
  );
  for (; r < t.length; r += 1) {
    const o = t[r];
    if (o === "+" || o === "-") {
      if (i === "none") {
        i = "sign", n += o;
        continue;
      }
      if (i === "e") {
        i = "exponent_sign", n += o;
        continue;
      }
    }
    if (I0e(o)) {
      if (i === "none" || i === "sign" || i === "whole") {
        i = "whole", n += o;
        continue;
      }
      if (i === "decimal_point" || i === "decimal") {
        i = "decimal", n += o;
        continue;
      }
      if (i === "e" || i === "exponent_sign" || i === "exponent") {
        i = "exponent", n += o;
        continue;
      }
    }
    if (o === "." && (i === "none" || i === "sign" || i === "whole")) {
      i = "decimal_point", n += o;
      continue;
    }
    if ((o === "E" || o === "e") && (i === "whole" || i === "decimal_point" || i === "decimal")) {
      i = "e", n += o;
      continue;
    }
    break;
  }
  const a = Number.parseFloat(n);
  return Number.isNaN(a) ? [e, null] : [r - 1, a];
}, B0e = (t) => {
  const e = [];
  let r = null, n = (
    /** @type {number[]} */
    []
  ), i = 0, a = !1, o = !1;
  for (let s = 0; s < t.length; s += 1) {
    const l = t.charAt(s);
    if (P0e(l))
      continue;
    if (a && l === ",") {
      if (o)
        break;
      o = !0;
      continue;
    }
    if (R0e(l)) {
      if (o)
        return e;
      if (r == null) {
        if (l !== "M" && l !== "m")
          return e;
      } else if (n.length !== 0)
        return e;
      r = l, n = [], i = DT[r], a = !1, i === 0 && e.push({
        command: r,
        args: n
      });
      continue;
    }
    if (r == null)
      return e;
    let u = s, d = null;
    if (r === "A" || r === "a") {
      const h = n.length;
      (h === 0 || h === 1) && l !== "+" && l !== "-" && ([u, d] = Tv(t, s)), (h === 2 || h === 5 || h === 6) && ([u, d] = Tv(t, s)), (h === 3 || h === 4) && (l === "0" && (d = 0), l === "1" && (d = 1));
    } else
      [u, d] = Tv(t, s);
    if (d == null)
      return e;
    n.push(d), a = !0, o = !1, s = u, n.length === i && (e.push({
      command: r,
      args: n
    }), r === "M" && (r = "L"), r === "m" && (r = "l"), n = []);
  }
  return e;
}, L0e = function(t, e) {
  bt = xt = n0 = g0 = Wf = Hf = 0;
  for (let r = 0; r < t.length; r++) {
    const {
      command: n,
      args: i
    } = t[r];
    typeof E9[n] == "function" && E9[n](e, i);
  }
}, E9 = {
  M(t, e) {
    return bt = e[0], xt = e[1], n0 = g0 = null, Wf = bt, Hf = xt, t.moveTo(bt, xt);
  },
  m(t, e) {
    return bt += e[0], xt += e[1], n0 = g0 = null, Wf = bt, Hf = xt, t.moveTo(bt, xt);
  },
  C(t, e) {
    return bt = e[4], xt = e[5], n0 = e[2], g0 = e[3], t.bezierCurveTo(...e);
  },
  c(t, e) {
    return t.bezierCurveTo(e[0] + bt, e[1] + xt, e[2] + bt, e[3] + xt, e[4] + bt, e[5] + xt), n0 = bt + e[2], g0 = xt + e[3], bt += e[4], xt += e[5];
  },
  S(t, e) {
    return n0 === null && (n0 = bt, g0 = xt), t.bezierCurveTo(bt - (n0 - bt), xt - (g0 - xt), e[0], e[1], e[2], e[3]), n0 = e[0], g0 = e[1], bt = e[2], xt = e[3];
  },
  s(t, e) {
    return n0 === null && (n0 = bt, g0 = xt), t.bezierCurveTo(bt - (n0 - bt), xt - (g0 - xt), bt + e[0], xt + e[1], bt + e[2], xt + e[3]), n0 = bt + e[0], g0 = xt + e[1], bt += e[2], xt += e[3];
  },
  Q(t, e) {
    return n0 = e[0], g0 = e[1], bt = e[2], xt = e[3], t.quadraticCurveTo(e[0], e[1], bt, xt);
  },
  q(t, e) {
    return t.quadraticCurveTo(e[0] + bt, e[1] + xt, e[2] + bt, e[3] + xt), n0 = bt + e[0], g0 = xt + e[1], bt += e[2], xt += e[3];
  },
  T(t, e) {
    return n0 === null ? (n0 = bt, g0 = xt) : (n0 = bt - (n0 - bt), g0 = xt - (g0 - xt)), t.quadraticCurveTo(n0, g0, e[0], e[1]), n0 = bt - (n0 - bt), g0 = xt - (g0 - xt), bt = e[0], xt = e[1];
  },
  t(t, e) {
    return n0 === null ? (n0 = bt, g0 = xt) : (n0 = bt - (n0 - bt), g0 = xt - (g0 - xt)), t.quadraticCurveTo(n0, g0, bt + e[0], xt + e[1]), bt += e[0], xt += e[1];
  },
  A(t, e) {
    return S9(t, bt, xt, e), bt = e[5], xt = e[6];
  },
  a(t, e) {
    return e[5] += bt, e[6] += xt, S9(t, bt, xt, e), bt = e[5], xt = e[6];
  },
  L(t, e) {
    return bt = e[0], xt = e[1], n0 = g0 = null, t.lineTo(bt, xt);
  },
  l(t, e) {
    return bt += e[0], xt += e[1], n0 = g0 = null, t.lineTo(bt, xt);
  },
  H(t, e) {
    return bt = e[0], n0 = g0 = null, t.lineTo(bt, xt);
  },
  h(t, e) {
    return bt += e[0], n0 = g0 = null, t.lineTo(bt, xt);
  },
  V(t, e) {
    return xt = e[0], n0 = g0 = null, t.lineTo(bt, xt);
  },
  v(t, e) {
    return xt += e[0], n0 = g0 = null, t.lineTo(bt, xt);
  },
  Z(t) {
    return t.closePath(), bt = Wf, xt = Hf;
  },
  z(t) {
    return t.closePath(), bt = Wf, xt = Hf;
  }
}, S9 = function(t, e, r, n) {
  const [i, a, o, s, l, u, d] = n, h = N0e(u, d, i, a, s, l, o, e, r);
  for (let v of h) {
    const b = M0e(...v);
    t.bezierCurveTo(...b);
  }
}, N0e = function(t, e, r, n, i, a, o, s, l) {
  const u = o * (Math.PI / 180), d = Math.sin(u), h = Math.cos(u);
  r = Math.abs(r), n = Math.abs(n), n0 = h * (s - t) * 0.5 + d * (l - e) * 0.5, g0 = h * (l - e) * 0.5 - d * (s - t) * 0.5;
  let v = n0 * n0 / (r * r) + g0 * g0 / (n * n);
  v > 1 && (v = Math.sqrt(v), r *= v, n *= v);
  const b = h / r, x = d / r, A = -d / n, T = h / n, k = b * s + x * l, E = A * s + T * l, C = b * t + x * e, D = A * t + T * e;
  let I = 1 / ((C - k) * (C - k) + (D - E) * (D - E)) - 0.25;
  I < 0 && (I = 0);
  let R = Math.sqrt(I);
  a === i && (R = -R);
  const U = 0.5 * (k + C) - R * (D - E), V = 0.5 * (E + D) + R * (C - k), z = Math.atan2(E - V, k - U);
  let S = Math.atan2(D - V, C - U) - z;
  S < 0 && a === 1 ? S += 2 * Math.PI : S > 0 && a === 0 && (S -= 2 * Math.PI);
  const B = Math.ceil(Math.abs(S / (Math.PI * 0.5 + 1e-3))), q = [];
  for (let Y = 0; Y < B; Y++) {
    const Z = z + Y * S / B, Q = z + (Y + 1) * S / B;
    q[Y] = [U, V, Z, Q, r, n, d, h];
  }
  return q;
}, M0e = function(t, e, r, n, i, a, o, s) {
  const l = s * i, u = -o * a, d = o * i, h = s * a, v = 0.5 * (n - r), b = 8 / 3 * Math.sin(v * 0.5) * Math.sin(v * 0.5) / Math.sin(v), x = t + Math.cos(r) - b * Math.sin(r), A = e + Math.sin(r) + b * Math.cos(r), T = t + Math.cos(n), k = e + Math.sin(n), E = T + b * Math.sin(n), C = k - b * Math.cos(n);
  return [l * x + u * A, d * x + h * A, l * E + u * C, d * E + h * C, l * T + u * k, d * T + h * k];
};
class U0e {
  static apply(e, r) {
    const n = B0e(r);
    L0e(n, e);
  }
}
const {
  number: mr
} = Qi, $2 = 4 * ((Math.sqrt(2) - 1) / 3);
var z0e = {
  initVector() {
    return this._ctm = [1, 0, 0, 1, 0, 0], this._ctmStack = [];
  },
  save() {
    return this._ctmStack.push(this._ctm.slice()), this.addContent("q");
  },
  restore() {
    return this._ctm = this._ctmStack.pop() || [1, 0, 0, 1, 0, 0], this.addContent("Q");
  },
  closePath() {
    return this.addContent("h");
  },
  lineWidth(t) {
    return this.addContent(`${mr(t)} w`);
  },
  _CAP_STYLES: {
    BUTT: 0,
    ROUND: 1,
    SQUARE: 2
  },
  lineCap(t) {
    return typeof t == "string" && (t = this._CAP_STYLES[t.toUpperCase()]), this.addContent(`${t} J`);
  },
  _JOIN_STYLES: {
    MITER: 0,
    ROUND: 1,
    BEVEL: 2
  },
  lineJoin(t) {
    return typeof t == "string" && (t = this._JOIN_STYLES[t.toUpperCase()]), this.addContent(`${t} j`);
  },
  miterLimit(t) {
    return this.addContent(`${mr(t)} M`);
  },
  dash(t, e) {
    e === void 0 && (e = {});
    const r = t;
    if (Array.isArray(t) || (t = [t, e.space || t]), !t.every((i) => Number.isFinite(i) && i > 0))
      throw new Error(`dash(${JSON.stringify(r)}, ${JSON.stringify(e)}) invalid, lengths must be numeric and greater than zero`);
    return t = t.map(mr).join(" "), this.addContent(`[${t}] ${mr(e.phase || 0)} d`);
  },
  undash() {
    return this.addContent("[] 0 d");
  },
  moveTo(t, e) {
    return this.addContent(`${mr(t)} ${mr(e)} m`);
  },
  lineTo(t, e) {
    return this.addContent(`${mr(t)} ${mr(e)} l`);
  },
  bezierCurveTo(t, e, r, n, i, a) {
    return this.addContent(`${mr(t)} ${mr(e)} ${mr(r)} ${mr(n)} ${mr(i)} ${mr(a)} c`);
  },
  quadraticCurveTo(t, e, r, n) {
    return this.addContent(`${mr(t)} ${mr(e)} ${mr(r)} ${mr(n)} v`);
  },
  rect(t, e, r, n) {
    return this.addContent(`${mr(t)} ${mr(e)} ${mr(r)} ${mr(n)} re`);
  },
  roundedRect(t, e, r, n, i) {
    i == null && (i = 0), i = Math.min(i, 0.5 * r, 0.5 * n);
    const a = i * (1 - $2);
    return this.moveTo(t + i, e), this.lineTo(t + r - i, e), this.bezierCurveTo(t + r - a, e, t + r, e + a, t + r, e + i), this.lineTo(t + r, e + n - i), this.bezierCurveTo(t + r, e + n - a, t + r - a, e + n, t + r - i, e + n), this.lineTo(t + i, e + n), this.bezierCurveTo(t + a, e + n, t, e + n - a, t, e + n - i), this.lineTo(t, e + i), this.bezierCurveTo(t, e + a, t + a, e, t + i, e), this.closePath();
  },
  ellipse(t, e, r, n) {
    n == null && (n = r), t -= r, e -= n;
    const i = r * $2, a = n * $2, o = t + r * 2, s = e + n * 2, l = t + r, u = e + n;
    return this.moveTo(t, u), this.bezierCurveTo(t, u - a, l - i, e, l, e), this.bezierCurveTo(l + i, e, o, u - a, o, u), this.bezierCurveTo(o, u + a, l + i, s, l, s), this.bezierCurveTo(l - i, s, t, u + a, t, u), this.closePath();
  },
  circle(t, e, r) {
    return this.ellipse(t, e, r);
  },
  arc(t, e, r, n, i, a) {
    a == null && (a = !1);
    const o = 2 * Math.PI, s = 0.5 * Math.PI;
    let l = i - n;
    Math.abs(l) > o ? l = o : l !== 0 && a !== l < 0 && (l = (a ? -1 : 1) * o + l);
    const u = Math.ceil(Math.abs(l) / s), d = l / u, h = d / s * $2 * r;
    let v = n, b = -Math.sin(v) * h, x = Math.cos(v) * h, A = t + Math.cos(v) * r, T = e + Math.sin(v) * r;
    this.moveTo(A, T);
    for (let k = 0; k < u; k++) {
      const E = A + b, C = T + x;
      v += d, A = t + Math.cos(v) * r, T = e + Math.sin(v) * r, b = -Math.sin(v) * h, x = Math.cos(v) * h;
      const D = A - b, _ = T - x;
      this.bezierCurveTo(E, C, D, _, A, T);
    }
    return this;
  },
  polygon() {
    for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
      e[r] = arguments[r];
    this.moveTo(...e.shift() || []);
    for (let n of e)
      this.lineTo(...n || []);
    return this.closePath();
  },
  path(t) {
    return U0e.apply(this, t), this;
  },
  _windingRule(t) {
    return /even-?odd/.test(t) ? "*" : "";
  },
  fill(t, e) {
    return /(even-?odd)|(non-?zero)/.test(t) && (e = t, t = null), t && this.fillColor(t), this.addContent(`f${this._windingRule(e)}`);
  },
  stroke(t) {
    return t && this.strokeColor(t), this.addContent("S");
  },
  fillAndStroke(t, e, r) {
    e == null && (e = t);
    const n = /(even-?odd)|(non-?zero)/;
    return n.test(t) && (r = t, t = null), n.test(e) && (r = e, e = t), t && (this.fillColor(t), this.strokeColor(e)), this.addContent(`B${this._windingRule(r)}`);
  },
  clip(t) {
    return this.addContent(`W${this._windingRule(t)} n`);
  },
  transform(t, e, r, n, i, a) {
    if (t === 1 && e === 0 && r === 0 && n === 1 && i === 0 && a === 0)
      return this;
    const o = this._ctm, [s, l, u, d, h, v] = o;
    o[0] = s * t + u * e, o[1] = l * t + d * e, o[2] = s * r + u * n, o[3] = l * r + d * n, o[4] = s * i + u * a + h, o[5] = l * i + d * a + v;
    const b = [t, e, r, n, i, a].map((x) => mr(x)).join(" ");
    return this.addContent(`${b} cm`);
  },
  translate(t, e) {
    return this.transform(1, 0, 0, 1, t, e);
  },
  rotate(t, e) {
    e === void 0 && (e = {});
    let r;
    const n = t * Math.PI / 180, i = Math.cos(n), a = Math.sin(n);
    let o = r = 0;
    if (e.origin != null) {
      [o, r] = e.origin;
      const s = o * i - r * a, l = o * a + r * i;
      o -= s, r -= l;
    }
    return this.transform(i, a, -a, i, o, r);
  },
  scale(t, e, r) {
    r === void 0 && (r = {});
    let n;
    e == null && (e = t), typeof e == "object" && (r = e, e = t);
    let i = n = 0;
    return r.origin != null && ([i, n] = r.origin, i -= t * i, n -= e * n), this.transform(t, 0, 0, e, i, n);
  }
}, lp = {};
const $0e = (t, e, r) => {
  let n = [], i = e + 1;
  for (let a = t; a < i; a++)
    n.push(a);
  return n;
}, C9 = {
  402: 131,
  8211: 150,
  8212: 151,
  8216: 145,
  8217: 146,
  8218: 130,
  8220: 147,
  8221: 148,
  8222: 132,
  8224: 134,
  8225: 135,
  8226: 149,
  8230: 133,
  8364: 128,
  8240: 137,
  8249: 139,
  8250: 155,
  710: 136,
  8482: 153,
  338: 140,
  339: 156,
  732: 152,
  352: 138,
  353: 154,
  376: 159,
  381: 142,
  382: 158
}, k9 = `.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef
.notdef       .notdef        .notdef        .notdef

space         exclam         quotedbl       numbersign
dollar        percent        ampersand      quotesingle
parenleft     parenright     asterisk       plus
comma         hyphen         period         slash
zero          one            two            three
four          five           six            seven
eight         nine           colon          semicolon
less          equal          greater        question

at            A              B              C
D             E              F              G
H             I              J              K
L             M              N              O
P             Q              R              S
T             U              V              W
X             Y              Z              bracketleft
backslash     bracketright   asciicircum    underscore

grave         a              b              c
d             e              f              g
h             i              j              k
l             m              n              o
p             q              r              s
t             u              v              w
x             y              z              braceleft
bar           braceright     asciitilde     .notdef

Euro          .notdef        quotesinglbase florin
quotedblbase  ellipsis       dagger         daggerdbl
circumflex    perthousand    Scaron         guilsinglleft
OE            .notdef        Zcaron         .notdef
.notdef       quoteleft      quoteright     quotedblleft
quotedblright bullet         endash         emdash
tilde         trademark      scaron         guilsinglright
oe            .notdef        zcaron         ydieresis

space         exclamdown     cent           sterling
currency      yen            brokenbar      section
dieresis      copyright      ordfeminine    guillemotleft
logicalnot    hyphen         registered     macron
degree        plusminus      twosuperior    threesuperior
acute         mu             paragraph      periodcentered
cedilla       onesuperior    ordmasculine   guillemotright
onequarter    onehalf        threequarters  questiondown

Agrave        Aacute         Acircumflex    Atilde
Adieresis     Aring          AE             Ccedilla
Egrave        Eacute         Ecircumflex    Edieresis
Igrave        Iacute         Icircumflex    Idieresis
Eth           Ntilde         Ograve         Oacute
Ocircumflex   Otilde         Odieresis      multiply
Oslash        Ugrave         Uacute         Ucircumflex
Udieresis     Yacute         Thorn          germandbls

agrave        aacute         acircumflex    atilde
adieresis     aring          ae             ccedilla
egrave        eacute         ecircumflex    edieresis
igrave        iacute         icircumflex    idieresis
eth           ntilde         ograve         oacute
ocircumflex   otilde         odieresis      divide
oslash        ugrave         uacute         ucircumflex
udieresis     yacute         thorn          ydieresis`.split(/\s+/);
function V0e(t) {
  const e = {
    attributes: {},
    glyphWidths: {},
    kernPairs: {}
  };
  let r = "";
  for (let l of t.split(`
`)) {
    var n, i;
    if (n = l.match(/^Start(\w+)/)) {
      r = n[1];
      continue;
    } else if (n = l.match(/^End(\w+)/)) {
      r = "";
      continue;
    }
    switch (r) {
      case "FontMetrics":
        n = l.match(/(^\w+)\s+(.*)/);
        var a = n[1], o = n[2];
        (i = e.attributes[a]) ? (Array.isArray(i) || (i = e.attributes[a] = [i]), i.push(o)) : e.attributes[a] = o;
        break;
      case "CharMetrics":
        if (!/^CH?\s/.test(l))
          continue;
        var s = l.match(/\bN\s+(\.?\w+)\s*;/)[1];
        e.glyphWidths[s] = +l.match(/\bWX\s+(\d+)\s*;/)[1];
        break;
      case "KernPairs":
        n = l.match(/^KPX\s+(\.?\w+)\s+(\.?\w+)\s+(-?\d+)/), n && (e.kernPairs[n[1] + n[2]] = parseInt(n[3]));
        break;
    }
  }
  return e;
}
class $x {
  static open(e) {
    throw new Error("AFMFont.open not available on browser build");
  }
  static fromJson(e) {
    return new $x(e);
  }
  constructor(e) {
    typeof e == "string" ? (this.contents = e, this.parse()) : (this.attributes = e.attributes, this.glyphWidths = e.glyphWidths, this.kernPairs = e.kernPairs), this.charWidths = $0e(0, 255).map((r) => this.glyphWidths[k9[r]]), this.bbox = Array.from(this.attributes.FontBBox.split(/\s+/)).map((r) => +r), this.ascender = +(this.attributes.Ascender || 0), this.descender = +(this.attributes.Descender || 0), this.xHeight = +(this.attributes.XHeight || 0), this.capHeight = +(this.attributes.CapHeight || 0), this.lineGap = this.bbox[3] - this.bbox[1] - (this.ascender - this.descender);
  }
  parse() {
    const e = V0e(this.contents);
    this.attributes = e.attributes, this.glyphWidths = e.glyphWidths, this.kernPairs = e.kernPairs;
  }
  encodeText(e) {
    const r = [];
    for (let n = 0, i = e.length, a = 0 <= i; a ? n < i : n > i; a ? n++ : n--) {
      let o = e.charCodeAt(n);
      o = C9[o] || o, r.push(o.toString(16));
    }
    return r;
  }
  glyphsForString(e) {
    const r = [];
    for (let n = 0, i = e.length, a = 0 <= i; a ? n < i : n > i; a ? n++ : n--) {
      const o = e.charCodeAt(n);
      r.push(this.characterToGlyph(o));
    }
    return r;
  }
  characterToGlyph(e) {
    return k9[C9[e] || e] || ".notdef";
  }
  widthOfGlyph(e) {
    return this.glyphWidths[e] || 0;
  }
  getKernPair(e, r) {
    return this.kernPairs[e + r] || 0;
  }
  advancesForGlyphs(e) {
    const r = [];
    for (let n = 0; n < e.length; n++) {
      const i = e[n], a = e[n + 1];
      r.push(this.widthOfGlyph(i) + this.getKernPair(i, a));
    }
    return r;
  }
}
var j0e = [
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:43:52 1997",
      "UniqueID 43052",
      "VMusage 37169 48194"
    ],
    FontName: "Helvetica-Bold",
    FullName: "Helvetica Bold",
    FamilyName: "Helvetica",
    Weight: "Bold",
    ItalicAngle: "0",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-170 -228 1003 962 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "718",
    XHeight: "532",
    Ascender: "718",
    Descender: "-207",
    StdHW: "118",
    StdVW: "140"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:45:12 1997",
      "UniqueID 43053",
      "VMusage 14482 68586"
    ],
    FontName: "Helvetica-BoldOblique",
    FullName: "Helvetica Bold Oblique",
    FamilyName: "Helvetica",
    Weight: "Bold",
    ItalicAngle: "-12",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-174 -228 1114 962",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "718",
    XHeight: "532",
    Ascender: "718",
    Descender: "-207",
    StdHW: "118",
    StdVW: "140"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:44:31 1997",
      "UniqueID 43055",
      "VMusage 14960 69346"
    ],
    FontName: "Helvetica-Oblique",
    FullName: "Helvetica Oblique",
    FamilyName: "Helvetica",
    Weight: "Medium",
    ItalicAngle: "-12",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-170 -225 1116 931 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "718",
    XHeight: "523",
    Ascender: "718",
    Descender: "-207",
    StdHW: "76",
    StdVW: "88"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:38:23 1997",
      "UniqueID 43054",
      "VMusage 37069 48094"
    ],
    FontName: "Helvetica",
    FullName: "Helvetica",
    FamilyName: "Helvetica",
    Weight: "Medium",
    ItalicAngle: "0",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-166 -225 1000 931 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "718",
    XHeight: "523",
    Ascender: "718",
    Descender: "-207",
    StdHW: "76",
    StdVW: "88"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:52:56 1997",
      "UniqueID 43065",
      "VMusage 41636 52661"
    ],
    FontName: "Times-Bold",
    FullName: "Times Bold",
    FamilyName: "Times",
    Weight: "Bold",
    ItalicAngle: "0",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-168 -218 1000 935 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "676",
    XHeight: "461",
    Ascender: "683",
    Descender: "-217",
    StdHW: "44",
    StdVW: "139"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 13:04:06 1997",
      "UniqueID 43066",
      "VMusage 45874 56899"
    ],
    FontName: "Times-BoldItalic",
    FullName: "Times Bold Italic",
    FamilyName: "Times",
    Weight: "Bold",
    ItalicAngle: "-15",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-200 -218 996 921",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "669",
    XHeight: "462",
    Ascender: "683",
    Descender: "-217",
    StdHW: "42",
    StdVW: "121"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:56:55 1997",
      "UniqueID 43067",
      "VMusage 47727 58752"
    ],
    FontName: "Times-Italic",
    FullName: "Times Italic",
    FamilyName: "Times",
    Weight: "Medium",
    ItalicAngle: "-15.5",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-169 -217 1010 883 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "653",
    XHeight: "441",
    Ascender: "683",
    Descender: "-217",
    StdHW: "32",
    StdVW: "76"
  },
  {
    Comment: [
      "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 12:49:17 1997",
      "UniqueID 43068",
      "VMusage 43909 54934"
    ],
    FontName: "Times-Roman",
    FullName: "Times Roman",
    FamilyName: "Times",
    Weight: "Roman",
    ItalicAngle: "0",
    IsFixedPitch: "false",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-168 -218 1000 898 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "002.000",
    Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "662",
    XHeight: "450",
    Ascender: "683",
    Descender: "-217",
    StdHW: "28",
    StdVW: "84"
  },
  {
    Comment: [
      "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Mon Jun 23 16:28:00 1997",
      "UniqueID 43048",
      "VMusage 41139 52164"
    ],
    FontName: "Courier-Bold",
    FullName: "Courier Bold",
    FamilyName: "Courier",
    Weight: "Bold",
    ItalicAngle: "0",
    IsFixedPitch: "true",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-113 -250 749 801 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "003.000",
    Notice: "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "562",
    XHeight: "439",
    Ascender: "629",
    Descender: "-157",
    StdHW: "84",
    StdVW: "106"
  },
  {
    Comment: [
      "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Mon Jun 23 16:28:46 1997",
      "UniqueID 43049",
      "VMusage 17529 79244"
    ],
    FontName: "Courier-BoldOblique",
    FullName: "Courier Bold Oblique",
    FamilyName: "Courier",
    Weight: "Bold",
    ItalicAngle: "-12",
    IsFixedPitch: "true",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-57 -250 869 801",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "003.000",
    Notice: "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "562",
    XHeight: "439",
    Ascender: "629",
    Descender: "-157",
    StdHW: "84",
    StdVW: "106"
  },
  {
    Comment: [
      "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 17:37:52 1997",
      "UniqueID 43051",
      "VMusage 16248 75829"
    ],
    FontName: "Courier-Oblique",
    FullName: "Courier Oblique",
    FamilyName: "Courier",
    Weight: "Medium",
    ItalicAngle: "-12",
    IsFixedPitch: "true",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-27 -250 849 805 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "003.000",
    Notice: "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "562",
    XHeight: "426",
    Ascender: "629",
    Descender: "-157",
    StdHW: "51",
    StdVW: "51"
  },
  {
    Comment: [
      "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
      "Creation Date: Thu May  1 17:27:09 1997",
      "UniqueID 43050",
      "VMusage 39754 50779"
    ],
    FontName: "Courier",
    FullName: "Courier",
    FamilyName: "Courier",
    Weight: "Medium",
    ItalicAngle: "0",
    IsFixedPitch: "true",
    CharacterSet: "ExtendedRoman",
    FontBBox: "-23 -250 715 805 ",
    UnderlinePosition: "-100",
    UnderlineThickness: "50",
    Version: "003.000",
    Notice: "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
    EncodingScheme: "AdobeStandardEncoding",
    CapHeight: "562",
    XHeight: "426",
    Ascender: "629",
    Descender: "-157",
    StdHW: "51",
    StdVW: "51"
  }
], W0e = {
  space: [
    278,
    278,
    278,
    278,
    250,
    250,
    250,
    250,
    600,
    600,
    600,
    600
  ],
  exclam: [
    333,
    333,
    278,
    278,
    333,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  quotedbl: [
    474,
    474,
    355,
    355,
    555,
    555,
    420,
    408,
    600,
    600,
    600,
    600
  ],
  numbersign: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  dollar: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  percent: [
    889,
    889,
    889,
    889,
    1e3,
    833,
    833,
    833,
    600,
    600,
    600,
    600
  ],
  ampersand: [
    722,
    722,
    667,
    667,
    833,
    778,
    778,
    778,
    600,
    600,
    600,
    600
  ],
  quoteright: [
    278,
    278,
    222,
    222,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  parenleft: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  parenright: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  asterisk: [
    389,
    389,
    389,
    389,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  plus: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  comma: [
    278,
    278,
    278,
    278,
    250,
    250,
    250,
    250,
    600,
    600,
    600,
    600
  ],
  hyphen: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  period: [
    278,
    278,
    278,
    278,
    250,
    250,
    250,
    250,
    600,
    600,
    600,
    600
  ],
  slash: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  zero: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  one: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  two: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  three: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  four: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  five: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  six: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  seven: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  eight: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  nine: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  colon: [
    333,
    333,
    278,
    278,
    333,
    333,
    333,
    278,
    600,
    600,
    600,
    600
  ],
  semicolon: [
    333,
    333,
    278,
    278,
    333,
    333,
    333,
    278,
    600,
    600,
    600,
    600
  ],
  less: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  equal: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  greater: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  question: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  at: [
    975,
    975,
    1015,
    1015,
    930,
    832,
    920,
    921,
    600,
    600,
    600,
    600
  ],
  A: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  B: [
    722,
    722,
    667,
    667,
    667,
    667,
    611,
    667,
    600,
    600,
    600,
    600
  ],
  C: [
    722,
    722,
    722,
    722,
    722,
    667,
    667,
    667,
    600,
    600,
    600,
    600
  ],
  D: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  E: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  F: [
    611,
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    600,
    600,
    600,
    600
  ],
  G: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  H: [
    722,
    722,
    722,
    722,
    778,
    778,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  I: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  J: [
    556,
    556,
    500,
    500,
    500,
    500,
    444,
    389,
    600,
    600,
    600,
    600
  ],
  K: [
    722,
    722,
    667,
    667,
    778,
    667,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  L: [
    611,
    611,
    556,
    556,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  M: [
    833,
    833,
    833,
    833,
    944,
    889,
    833,
    889,
    600,
    600,
    600,
    600
  ],
  N: [
    722,
    722,
    722,
    722,
    722,
    722,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  O: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  P: [
    667,
    667,
    667,
    667,
    611,
    611,
    611,
    556,
    600,
    600,
    600,
    600
  ],
  Q: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  R: [
    722,
    722,
    722,
    722,
    722,
    667,
    611,
    667,
    600,
    600,
    600,
    600
  ],
  S: [
    667,
    667,
    667,
    667,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  T: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  U: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  V: [
    667,
    667,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  W: [
    944,
    944,
    944,
    944,
    1e3,
    889,
    833,
    944,
    600,
    600,
    600,
    600
  ],
  X: [
    667,
    667,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  Y: [
    667,
    667,
    667,
    667,
    722,
    611,
    556,
    722,
    600,
    600,
    600,
    600
  ],
  Z: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  bracketleft: [
    333,
    333,
    278,
    278,
    333,
    333,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  backslash: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  bracketright: [
    333,
    333,
    278,
    278,
    333,
    333,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  asciicircum: [
    584,
    584,
    469,
    469,
    581,
    570,
    422,
    469,
    600,
    600,
    600,
    600
  ],
  underscore: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  quoteleft: [
    278,
    278,
    222,
    222,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  a: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  b: [
    611,
    611,
    556,
    556,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  c: [
    556,
    556,
    500,
    500,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  d: [
    611,
    611,
    556,
    556,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  e: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  f: [
    333,
    333,
    278,
    278,
    333,
    333,
    278,
    333,
    600,
    600,
    600,
    600
  ],
  g: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  h: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  i: [
    278,
    278,
    222,
    222,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  j: [
    278,
    278,
    222,
    222,
    333,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  k: [
    556,
    556,
    500,
    500,
    556,
    500,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  l: [
    278,
    278,
    222,
    222,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  m: [
    889,
    889,
    833,
    833,
    833,
    778,
    722,
    778,
    600,
    600,
    600,
    600
  ],
  n: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  o: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  p: [
    611,
    611,
    556,
    556,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  q: [
    611,
    611,
    556,
    556,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  r: [
    389,
    389,
    333,
    333,
    444,
    389,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  s: [
    556,
    556,
    500,
    500,
    389,
    389,
    389,
    389,
    600,
    600,
    600,
    600
  ],
  t: [
    333,
    333,
    278,
    278,
    333,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  u: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  v: [
    556,
    556,
    500,
    500,
    500,
    444,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  w: [
    778,
    778,
    722,
    722,
    722,
    667,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  x: [
    556,
    556,
    500,
    500,
    500,
    500,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  y: [
    556,
    556,
    500,
    500,
    500,
    444,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  z: [
    500,
    500,
    500,
    500,
    444,
    389,
    389,
    444,
    600,
    600,
    600,
    600
  ],
  braceleft: [
    389,
    389,
    334,
    334,
    394,
    348,
    400,
    480,
    600,
    600,
    600,
    600
  ],
  bar: [
    280,
    280,
    260,
    260,
    220,
    220,
    275,
    200,
    600,
    600,
    600,
    600
  ],
  braceright: [
    389,
    389,
    334,
    334,
    394,
    348,
    400,
    480,
    600,
    600,
    600,
    600
  ],
  asciitilde: [
    584,
    584,
    584,
    584,
    520,
    570,
    541,
    541,
    600,
    600,
    600,
    600
  ],
  exclamdown: [
    333,
    333,
    333,
    333,
    333,
    389,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  cent: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  sterling: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  fraction: [
    167,
    167,
    167,
    167,
    167,
    167,
    167,
    167,
    600,
    600,
    600,
    600
  ],
  yen: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  florin: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  section: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  currency: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  quotesingle: [
    238,
    238,
    191,
    191,
    278,
    278,
    214,
    180,
    600,
    600,
    600,
    600
  ],
  quotedblleft: [
    500,
    500,
    333,
    333,
    500,
    500,
    556,
    444,
    600,
    600,
    600,
    600
  ],
  guillemotleft: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  guilsinglleft: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  guilsinglright: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  fi: [
    611,
    611,
    500,
    500,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  fl: [
    611,
    611,
    500,
    500,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  endash: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  dagger: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  daggerdbl: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  periodcentered: [
    278,
    278,
    278,
    278,
    250,
    250,
    250,
    250,
    600,
    600,
    600,
    600
  ],
  paragraph: [
    556,
    556,
    537,
    537,
    540,
    500,
    523,
    453,
    600,
    600,
    600,
    600
  ],
  bullet: [
    350,
    350,
    350,
    350,
    350,
    350,
    350,
    350,
    600,
    600,
    600,
    600
  ],
  quotesinglbase: [
    278,
    278,
    222,
    222,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  quotedblbase: [
    500,
    500,
    333,
    333,
    500,
    500,
    556,
    444,
    600,
    600,
    600,
    600
  ],
  quotedblright: [
    500,
    500,
    333,
    333,
    500,
    500,
    556,
    444,
    600,
    600,
    600,
    600
  ],
  guillemotright: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  ellipsis: [
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    889,
    1e3,
    600,
    600,
    600,
    600
  ],
  perthousand: [
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    600,
    600,
    600,
    600
  ],
  questiondown: [
    611,
    611,
    611,
    611,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  grave: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  acute: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  circumflex: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  tilde: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  macron: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  breve: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  dotaccent: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  dieresis: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  ring: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  cedilla: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  hungarumlaut: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  ogonek: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  caron: [
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  emdash: [
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    889,
    1e3,
    600,
    600,
    600,
    600
  ],
  AE: [
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    944,
    889,
    889,
    600,
    600,
    600,
    600
  ],
  ordfeminine: [
    370,
    370,
    370,
    370,
    300,
    266,
    276,
    276,
    600,
    600,
    600,
    600
  ],
  Lslash: [
    611,
    611,
    556,
    556,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  Oslash: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  OE: [
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    944,
    944,
    889,
    600,
    600,
    600,
    600
  ],
  ordmasculine: [
    365,
    365,
    365,
    365,
    330,
    300,
    310,
    310,
    600,
    600,
    600,
    600
  ],
  ae: [
    889,
    889,
    889,
    889,
    722,
    722,
    667,
    667,
    600,
    600,
    600,
    600
  ],
  dotlessi: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  lslash: [
    278,
    278,
    222,
    222,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  oslash: [
    611,
    611,
    611,
    611,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  oe: [
    944,
    944,
    944,
    944,
    722,
    722,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  germandbls: [
    611,
    611,
    611,
    611,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Idieresis: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  eacute: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  abreve: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  uhungarumlaut: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  ecaron: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  Ydieresis: [
    667,
    667,
    667,
    667,
    722,
    611,
    556,
    722,
    600,
    600,
    600,
    600
  ],
  divide: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  Yacute: [
    667,
    667,
    667,
    667,
    722,
    611,
    556,
    722,
    600,
    600,
    600,
    600
  ],
  Acircumflex: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  aacute: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  Ucircumflex: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  yacute: [
    556,
    556,
    500,
    500,
    500,
    444,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  scommaaccent: [
    556,
    556,
    500,
    500,
    389,
    389,
    389,
    389,
    600,
    600,
    600,
    600
  ],
  ecircumflex: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  Uring: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Udieresis: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  aogonek: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  Uacute: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  uogonek: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Edieresis: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  Dcroat: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  commaaccent: [
    250,
    250,
    250,
    250,
    250,
    250,
    250,
    250,
    600,
    600,
    600,
    600
  ],
  copyright: [
    737,
    737,
    737,
    737,
    747,
    747,
    760,
    760,
    600,
    600,
    600,
    600
  ],
  Emacron: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  ccaron: [
    556,
    556,
    500,
    500,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  aring: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  Ncommaaccent: [
    722,
    722,
    722,
    722,
    722,
    722,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  lacute: [
    278,
    278,
    222,
    222,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  agrave: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  Tcommaaccent: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  Cacute: [
    722,
    722,
    722,
    722,
    722,
    667,
    667,
    667,
    600,
    600,
    600,
    600
  ],
  atilde: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  Edotaccent: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  scaron: [
    556,
    556,
    500,
    500,
    389,
    389,
    389,
    389,
    600,
    600,
    600,
    600
  ],
  scedilla: [
    556,
    556,
    500,
    500,
    389,
    389,
    389,
    389,
    600,
    600,
    600,
    600
  ],
  iacute: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  lozenge: [
    494,
    494,
    471,
    471,
    494,
    494,
    471,
    471,
    600,
    600,
    600,
    600
  ],
  Rcaron: [
    722,
    722,
    722,
    722,
    722,
    667,
    611,
    667,
    600,
    600,
    600,
    600
  ],
  Gcommaaccent: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  ucircumflex: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  acircumflex: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  Amacron: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  rcaron: [
    389,
    389,
    333,
    333,
    444,
    389,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  ccedilla: [
    556,
    556,
    500,
    500,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  Zdotaccent: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  Thorn: [
    667,
    667,
    667,
    667,
    611,
    611,
    611,
    556,
    600,
    600,
    600,
    600
  ],
  Omacron: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Racute: [
    722,
    722,
    722,
    722,
    722,
    667,
    611,
    667,
    600,
    600,
    600,
    600
  ],
  Sacute: [
    667,
    667,
    667,
    667,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  dcaron: [
    743,
    743,
    643,
    643,
    672,
    608,
    544,
    588,
    600,
    600,
    600,
    600
  ],
  Umacron: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  uring: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  threesuperior: [
    333,
    333,
    333,
    333,
    300,
    300,
    300,
    300,
    600,
    600,
    600,
    600
  ],
  Ograve: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Agrave: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  Abreve: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  multiply: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  uacute: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Tcaron: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  partialdiff: [
    494,
    494,
    476,
    476,
    494,
    494,
    476,
    476,
    600,
    600,
    600,
    600
  ],
  ydieresis: [
    556,
    556,
    500,
    500,
    500,
    444,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  Nacute: [
    722,
    722,
    722,
    722,
    722,
    722,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  icircumflex: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  Ecircumflex: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  adieresis: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  edieresis: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  cacute: [
    556,
    556,
    500,
    500,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  nacute: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  umacron: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Ncaron: [
    722,
    722,
    722,
    722,
    722,
    722,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  Iacute: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  plusminus: [
    584,
    584,
    584,
    584,
    570,
    570,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  brokenbar: [
    280,
    280,
    260,
    260,
    220,
    220,
    275,
    200,
    600,
    600,
    600,
    600
  ],
  registered: [
    737,
    737,
    737,
    737,
    747,
    747,
    760,
    760,
    600,
    600,
    600,
    600
  ],
  Gbreve: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Idotaccent: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  summation: [
    600,
    600,
    600,
    600,
    600,
    600,
    600,
    600,
    600,
    600,
    600,
    600
  ],
  Egrave: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  racute: [
    389,
    389,
    333,
    333,
    444,
    389,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  omacron: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Zacute: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  Zcaron: [
    611,
    611,
    611,
    611,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  greaterequal: [
    549,
    549,
    549,
    549,
    549,
    549,
    549,
    549,
    600,
    600,
    600,
    600
  ],
  Eth: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Ccedilla: [
    722,
    722,
    722,
    722,
    722,
    667,
    667,
    667,
    600,
    600,
    600,
    600
  ],
  lcommaaccent: [
    278,
    278,
    222,
    222,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  tcaron: [
    389,
    389,
    317,
    317,
    416,
    366,
    300,
    326,
    600,
    600,
    600,
    600
  ],
  eogonek: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  Uogonek: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Aacute: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  Adieresis: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  egrave: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  zacute: [
    500,
    500,
    500,
    500,
    444,
    389,
    389,
    444,
    600,
    600,
    600,
    600
  ],
  iogonek: [
    278,
    278,
    222,
    222,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  Oacute: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  oacute: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  amacron: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    444,
    600,
    600,
    600,
    600
  ],
  sacute: [
    556,
    556,
    500,
    500,
    389,
    389,
    389,
    389,
    600,
    600,
    600,
    600
  ],
  idieresis: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  Ocircumflex: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Ugrave: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Delta: [
    612,
    612,
    612,
    612,
    612,
    612,
    612,
    612,
    600,
    600,
    600,
    600
  ],
  thorn: [
    611,
    611,
    556,
    556,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  twosuperior: [
    333,
    333,
    333,
    333,
    300,
    300,
    300,
    300,
    600,
    600,
    600,
    600
  ],
  Odieresis: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  mu: [
    611,
    611,
    556,
    556,
    556,
    576,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  igrave: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  ohungarumlaut: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Eogonek: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  dcroat: [
    611,
    611,
    556,
    556,
    556,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  threequarters: [
    834,
    834,
    834,
    834,
    750,
    750,
    750,
    750,
    600,
    600,
    600,
    600
  ],
  Scedilla: [
    667,
    667,
    667,
    667,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  lcaron: [
    400,
    400,
    299,
    299,
    394,
    382,
    300,
    344,
    600,
    600,
    600,
    600
  ],
  Kcommaaccent: [
    722,
    722,
    667,
    667,
    778,
    667,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  Lacute: [
    611,
    611,
    556,
    556,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  trademark: [
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    1e3,
    980,
    980,
    600,
    600,
    600,
    600
  ],
  edotaccent: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  Igrave: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  Imacron: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  Lcaron: [
    611,
    611,
    556,
    556,
    667,
    611,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  onehalf: [
    834,
    834,
    834,
    834,
    750,
    750,
    750,
    750,
    600,
    600,
    600,
    600
  ],
  lessequal: [
    549,
    549,
    549,
    549,
    549,
    549,
    549,
    549,
    600,
    600,
    600,
    600
  ],
  ocircumflex: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  ntilde: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Uhungarumlaut: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  Eacute: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  emacron: [
    556,
    556,
    556,
    556,
    444,
    444,
    444,
    444,
    600,
    600,
    600,
    600
  ],
  gbreve: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  onequarter: [
    834,
    834,
    834,
    834,
    750,
    750,
    750,
    750,
    600,
    600,
    600,
    600
  ],
  Scaron: [
    667,
    667,
    667,
    667,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  Scommaaccent: [
    667,
    667,
    667,
    667,
    556,
    556,
    500,
    556,
    600,
    600,
    600,
    600
  ],
  Ohungarumlaut: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  degree: [
    400,
    400,
    400,
    400,
    400,
    400,
    400,
    400,
    600,
    600,
    600,
    600
  ],
  ograve: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Ccaron: [
    722,
    722,
    722,
    722,
    722,
    667,
    667,
    667,
    600,
    600,
    600,
    600
  ],
  ugrave: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  radical: [
    549,
    549,
    453,
    453,
    549,
    549,
    453,
    453,
    600,
    600,
    600,
    600
  ],
  Dcaron: [
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  rcommaaccent: [
    389,
    389,
    333,
    333,
    444,
    389,
    389,
    333,
    600,
    600,
    600,
    600
  ],
  Ntilde: [
    722,
    722,
    722,
    722,
    722,
    722,
    667,
    722,
    600,
    600,
    600,
    600
  ],
  otilde: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  Rcommaaccent: [
    722,
    722,
    722,
    722,
    722,
    667,
    611,
    667,
    600,
    600,
    600,
    600
  ],
  Lcommaaccent: [
    611,
    611,
    556,
    556,
    667,
    611,
    556,
    611,
    600,
    600,
    600,
    600
  ],
  Atilde: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  Aogonek: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  Aring: [
    722,
    722,
    667,
    667,
    722,
    667,
    611,
    722,
    600,
    600,
    600,
    600
  ],
  Otilde: [
    778,
    778,
    778,
    778,
    778,
    722,
    722,
    722,
    600,
    600,
    600,
    600
  ],
  zdotaccent: [
    500,
    500,
    500,
    500,
    444,
    389,
    389,
    444,
    600,
    600,
    600,
    600
  ],
  Ecaron: [
    667,
    667,
    667,
    667,
    667,
    667,
    611,
    611,
    600,
    600,
    600,
    600
  ],
  Iogonek: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  kcommaaccent: [
    556,
    556,
    500,
    500,
    556,
    500,
    444,
    500,
    600,
    600,
    600,
    600
  ],
  minus: [
    584,
    584,
    584,
    584,
    570,
    606,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  Icircumflex: [
    278,
    278,
    278,
    278,
    389,
    389,
    333,
    333,
    600,
    600,
    600,
    600
  ],
  ncaron: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  tcommaaccent: [
    333,
    333,
    278,
    278,
    333,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  logicalnot: [
    584,
    584,
    584,
    584,
    570,
    606,
    675,
    564,
    600,
    600,
    600,
    600
  ],
  odieresis: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  udieresis: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  notequal: [
    549,
    549,
    549,
    549,
    549,
    549,
    549,
    549,
    600,
    600,
    600,
    600
  ],
  gcommaaccent: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  eth: [
    611,
    611,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  zcaron: [
    500,
    500,
    500,
    500,
    444,
    389,
    389,
    444,
    600,
    600,
    600,
    600
  ],
  ncommaaccent: [
    611,
    611,
    556,
    556,
    556,
    556,
    500,
    500,
    600,
    600,
    600,
    600
  ],
  onesuperior: [
    333,
    333,
    333,
    333,
    300,
    300,
    300,
    300,
    600,
    600,
    600,
    600
  ],
  imacron: [
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    278,
    600,
    600,
    600,
    600
  ],
  Euro: [
    556,
    556,
    556,
    556,
    500,
    500,
    500,
    500,
    600,
    600,
    600,
    600
  ]
}, H0e = {
  AC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  ACacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  ACcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  ACcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  ATcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  ATcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Au: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Auacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Audieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Augrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Auhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Auogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Auring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Av: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Aw: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Ay: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Ayacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Aydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AacuteC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AacuteCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AacuteCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AacuteCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AacuteG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AacuteGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AacuteGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AacuteO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AacuteQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AacuteT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AacuteTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AacuteTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AacuteU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AacuteV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AacuteW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AacuteY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AacuteYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AacuteYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Aacuteu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacuteuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aacutev: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Aacutew: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Aacutey: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Aacuteyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Aacuteydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AbreveC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AbreveCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AbreveCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AbreveCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AbreveG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AbreveGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AbreveGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AbreveO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AbreveQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AbreveT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AbreveTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AbreveTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AbreveU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AbreveV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AbreveW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AbreveY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AbreveYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AbreveYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Abreveu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abreveuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Abrevev: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Abrevew: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Abrevey: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Abreveyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Abreveydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AcircumflexC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AcircumflexCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AcircumflexCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AcircumflexCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AcircumflexG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AcircumflexGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AcircumflexGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AcircumflexO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AcircumflexQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AcircumflexT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AcircumflexTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AcircumflexTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AcircumflexU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AcircumflexV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AcircumflexW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AcircumflexY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AcircumflexYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AcircumflexYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Acircumflexu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Acircumflexv: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Acircumflexw: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Acircumflexy: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Acircumflexyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Acircumflexydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AdieresisC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AdieresisCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AdieresisCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AdieresisCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AdieresisG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AdieresisGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AdieresisGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AdieresisO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AdieresisQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AdieresisT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AdieresisTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AdieresisTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AdieresisU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AdieresisV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AdieresisW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AdieresisY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AdieresisYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AdieresisYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Adieresisu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Adieresisv: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Adieresisw: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Adieresisy: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Adieresisyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Adieresisydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AgraveC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AgraveCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AgraveCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AgraveCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AgraveG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AgraveGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AgraveGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AgraveO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AgraveQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AgraveT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AgraveTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AgraveTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AgraveU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AgraveV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AgraveW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AgraveY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AgraveYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AgraveYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Agraveu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agraveuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Agravev: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Agravew: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Agravey: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Agraveyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Agraveydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AmacronC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AmacronCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AmacronCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AmacronCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AmacronG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AmacronGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AmacronGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AmacronO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AmacronQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AmacronT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AmacronTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AmacronTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AmacronU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AmacronV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AmacronW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AmacronY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AmacronYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AmacronYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Amacronu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Amacronv: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Amacronw: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Amacrony: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Amacronyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Amacronydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AogonekC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AogonekCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AogonekCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AogonekCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AogonekG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AogonekGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AogonekGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AogonekO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AogonekQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AogonekT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AogonekTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AogonekTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AogonekU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AogonekV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AogonekW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AogonekY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AogonekYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AogonekYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Aogoneku: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aogonekv: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Aogonekw: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -52
  ],
  Aogoneky: [
    -30,
    -30,
    -40,
    -40,
    -34,
    -34,
    -55,
    -52
  ],
  Aogonekyacute: [
    -30,
    -30,
    -40,
    -40,
    -34,
    -34,
    -55,
    -52
  ],
  Aogonekydieresis: [
    -30,
    -30,
    -40,
    -40,
    -34,
    -34,
    -55,
    -52
  ],
  AringC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AringCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AringCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AringCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AringG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AringGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AringGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AringO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AringQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AringT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AringTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AringTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AringU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AringV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AringW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AringY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AringYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AringYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Aringu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Aringv: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Aringw: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Aringy: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Aringyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Aringydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  AtildeC: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AtildeCacute: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AtildeCcaron: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AtildeCcedilla: [
    -40,
    -40,
    -30,
    -30,
    -55,
    -65,
    -30,
    -40
  ],
  AtildeG: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AtildeGbreve: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AtildeGcommaaccent: [
    -50,
    -50,
    -30,
    -30,
    -55,
    -60,
    -35,
    -40
  ],
  AtildeO: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOacute: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOcircumflex: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOdieresis: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOgrave: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOhungarumlaut: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOmacron: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOslash: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeOtilde: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -50,
    -40,
    -55
  ],
  AtildeQ: [
    -40,
    -40,
    -30,
    -30,
    -45,
    -55,
    -40,
    -55
  ],
  AtildeT: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AtildeTcaron: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AtildeTcommaaccent: [
    -90,
    -90,
    -120,
    -120,
    -95,
    -55,
    -37,
    -111
  ],
  AtildeU: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUacute: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUcircumflex: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUdieresis: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUgrave: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUhungarumlaut: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUmacron: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUogonek: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeUring: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -55
  ],
  AtildeV: [
    -80,
    -80,
    -70,
    -70,
    -145,
    -95,
    -105,
    -135
  ],
  AtildeW: [
    -60,
    -60,
    -50,
    -50,
    -130,
    -100,
    -95,
    -90
  ],
  AtildeY: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AtildeYacute: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  AtildeYdieresis: [
    -110,
    -110,
    -100,
    -100,
    -100,
    -70,
    -55,
    -105
  ],
  Atildeu: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeuacute: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeudieresis: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeugrave: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeumacron: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeuogonek: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildeuring: [
    -30,
    -30,
    -30,
    -30,
    -50,
    -30,
    -20
  ],
  Atildev: [
    -40,
    -40,
    -40,
    -40,
    -100,
    -74,
    -55,
    -74
  ],
  Atildew: [
    -30,
    -30,
    -40,
    -40,
    -90,
    -74,
    -55,
    -92
  ],
  Atildey: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Atildeyacute: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  Atildeydieresis: [
    -30,
    -30,
    -40,
    -40,
    -74,
    -74,
    -55,
    -92
  ],
  BA: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAacute: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAbreve: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAcircumflex: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAdieresis: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAgrave: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAmacron: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAogonek: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAring: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BAtilde: [
    -30,
    -30,
    0,
    0,
    -30,
    -25,
    -25,
    -35
  ],
  BU: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUacute: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUcircumflex: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUdieresis: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUgrave: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUhungarumlaut: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUmacron: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUogonek: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  BUring: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  DA: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAacute: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAbreve: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAcircumflex: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAdieresis: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAgrave: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAmacron: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAogonek: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAring: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DAtilde: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DV: [
    -40,
    -40,
    -70,
    -70,
    -40,
    -50,
    -40,
    -40
  ],
  DW: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -30
  ],
  DY: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  DYacute: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  DYdieresis: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  Dcomma: [
    -30,
    -30,
    -70,
    -70
  ],
  Dperiod: [
    -30,
    -30,
    -70,
    -70,
    -20
  ],
  DcaronA: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAacute: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAbreve: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAcircumflex: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAdieresis: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAgrave: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAmacron: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAogonek: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAring: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronAtilde: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcaronV: [
    -40,
    -40,
    -70,
    -70,
    -40,
    -50,
    -40,
    -40
  ],
  DcaronW: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -30
  ],
  DcaronY: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  DcaronYacute: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  DcaronYdieresis: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  Dcaroncomma: [
    -30,
    -30,
    -70,
    -70
  ],
  Dcaronperiod: [
    -30,
    -30,
    -70,
    -70,
    -20
  ],
  DcroatA: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAacute: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAbreve: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAcircumflex: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAdieresis: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAgrave: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAmacron: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAogonek: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAring: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatAtilde: [
    -40,
    -40,
    -40,
    -40,
    -35,
    -25,
    -35,
    -40
  ],
  DcroatV: [
    -40,
    -40,
    -70,
    -70,
    -40,
    -50,
    -40,
    -40
  ],
  DcroatW: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -30
  ],
  DcroatY: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  DcroatYacute: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  DcroatYdieresis: [
    -70,
    -70,
    -90,
    -90,
    -40,
    -50,
    -40,
    -55
  ],
  Dcroatcomma: [
    -30,
    -30,
    -70,
    -70
  ],
  Dcroatperiod: [
    -30,
    -30,
    -70,
    -70,
    -20
  ],
  FA: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAacute: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAbreve: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAcircumflex: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAdieresis: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAgrave: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAmacron: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAogonek: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAring: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  FAtilde: [
    -80,
    -80,
    -80,
    -80,
    -90,
    -100,
    -115,
    -74
  ],
  Fa: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Faacute: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Fabreve: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Facircumflex: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Fadieresis: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Fagrave: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Famacron: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Faogonek: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Faring: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Fatilde: [
    -20,
    -20,
    -50,
    -50,
    -25,
    -95,
    -75,
    -15
  ],
  Fcomma: [
    -100,
    -100,
    -150,
    -150,
    -92,
    -129,
    -135,
    -80
  ],
  Fperiod: [
    -100,
    -100,
    -150,
    -150,
    -110,
    -129,
    -135,
    -80
  ],
  JA: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAacute: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAbreve: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAcircumflex: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAdieresis: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAgrave: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAmacron: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAogonek: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAring: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  JAtilde: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -25,
    -40,
    -60
  ],
  Jcomma: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    -25
  ],
  Jperiod: [
    -20,
    -20,
    -30,
    -30,
    -20,
    -10,
    -25
  ],
  Ju: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Juacute: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jucircumflex: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Judieresis: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jugrave: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Juhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jumacron: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Juogonek: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Juring: [
    -20,
    -20,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  KO: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOacute: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOcircumflex: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOdieresis: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOgrave: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOhungarumlaut: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOmacron: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOslash: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KOtilde: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  Ke: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Keacute: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kecaron: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kecircumflex: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kedieresis: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kedotaccent: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kegrave: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kemacron: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Keogonek: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Ko: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Koacute: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kocircumflex: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kodieresis: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kograve: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kohungarumlaut: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Komacron: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Koslash: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kotilde: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Ku: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kuacute: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kudieresis: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kugrave: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kumacron: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kuogonek: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kuring: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Ky: [
    -40,
    -40,
    -50,
    -50,
    -45,
    -20,
    -40,
    -25
  ],
  Kyacute: [
    -40,
    -40,
    -50,
    -50,
    -45,
    -20,
    -40,
    -25
  ],
  Kydieresis: [
    -40,
    -40,
    -50,
    -50,
    -45,
    -20,
    -40,
    -25
  ],
  KcommaaccentO: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOacute: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOcircumflex: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOdieresis: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOgrave: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOhungarumlaut: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOmacron: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOslash: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  KcommaaccentOtilde: [
    -30,
    -30,
    -50,
    -50,
    -30,
    -30,
    -50,
    -30
  ],
  Kcommaaccente: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccenteacute: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccentecaron: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccentecircumflex: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccentedieresis: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccentedotaccent: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccentegrave: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccentemacron: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccenteogonek: [
    -15,
    -15,
    -40,
    -40,
    -25,
    -25,
    -35,
    -25
  ],
  Kcommaaccento: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentoacute: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentocircumflex: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentodieresis: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentograve: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentohungarumlaut: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentomacron: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentoslash: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentotilde: [
    -35,
    -35,
    -40,
    -40,
    -25,
    -25,
    -40,
    -35
  ],
  Kcommaaccentu: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentuacute: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentucircumflex: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentudieresis: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentugrave: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentuhungarumlaut: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentumacron: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccentuogonek: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccenturing: [
    -30,
    -30,
    -30,
    -30,
    -15,
    -20,
    -40,
    -15
  ],
  Kcommaaccenty: [
    -40,
    -40,
    -50,
    -50,
    -45,
    -20,
    -40,
    -25
  ],
  Kcommaaccentyacute: [
    -40,
    -40,
    -50,
    -50,
    -45,
    -20,
    -40,
    -25
  ],
  Kcommaaccentydieresis: [
    -40,
    -40,
    -50,
    -50,
    -45,
    -20,
    -40,
    -25
  ],
  LT: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LTcaron: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LTcommaaccent: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LV: [
    -110,
    -110,
    -110,
    -110,
    -92,
    -37,
    -55,
    -100
  ],
  LW: [
    -80,
    -80,
    -70,
    -70,
    -92,
    -37,
    -55,
    -74
  ],
  LY: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LYacute: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LYdieresis: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  Lquotedblright: [
    -140,
    -140,
    -140,
    -140,
    -20
  ],
  Lquoteright: [
    -140,
    -140,
    -160,
    -160,
    -110,
    -55,
    -37,
    -92
  ],
  Ly: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lyacute: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lydieresis: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  LacuteT: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LacuteTcaron: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LacuteTcommaaccent: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LacuteV: [
    -110,
    -110,
    -110,
    -110,
    -92,
    -37,
    -55,
    -100
  ],
  LacuteW: [
    -80,
    -80,
    -70,
    -70,
    -92,
    -37,
    -55,
    -74
  ],
  LacuteY: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LacuteYacute: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LacuteYdieresis: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  Lacutequotedblright: [
    -140,
    -140,
    -140,
    -140,
    -20
  ],
  Lacutequoteright: [
    -140,
    -140,
    -160,
    -160,
    -110,
    -55,
    -37,
    -92
  ],
  Lacutey: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lacuteyacute: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lacuteydieresis: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  LcommaaccentT: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LcommaaccentTcaron: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LcommaaccentTcommaaccent: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LcommaaccentV: [
    -110,
    -110,
    -110,
    -110,
    -92,
    -37,
    -55,
    -100
  ],
  LcommaaccentW: [
    -80,
    -80,
    -70,
    -70,
    -92,
    -37,
    -55,
    -74
  ],
  LcommaaccentY: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LcommaaccentYacute: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LcommaaccentYdieresis: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  Lcommaaccentquotedblright: [
    -140,
    -140,
    -140,
    -140,
    -20
  ],
  Lcommaaccentquoteright: [
    -140,
    -140,
    -160,
    -160,
    -110,
    -55,
    -37,
    -92
  ],
  Lcommaaccenty: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lcommaaccentyacute: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lcommaaccentydieresis: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  LslashT: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LslashTcaron: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LslashTcommaaccent: [
    -90,
    -90,
    -110,
    -110,
    -92,
    -18,
    -20,
    -92
  ],
  LslashV: [
    -110,
    -110,
    -110,
    -110,
    -92,
    -37,
    -55,
    -100
  ],
  LslashW: [
    -80,
    -80,
    -70,
    -70,
    -92,
    -37,
    -55,
    -74
  ],
  LslashY: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LslashYacute: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  LslashYdieresis: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -37,
    -20,
    -100
  ],
  Lslashquotedblright: [
    -140,
    -140,
    -140,
    -140,
    -20
  ],
  Lslashquoteright: [
    -140,
    -140,
    -160,
    -160,
    -110,
    -55,
    -37,
    -92
  ],
  Lslashy: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lslashyacute: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  Lslashydieresis: [
    -30,
    -30,
    -30,
    -30,
    -55,
    -37,
    -30,
    -55
  ],
  OA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Ocomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Operiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OacuteA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OacuteT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OacuteTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OacuteTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OacuteV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OacuteW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OacuteX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OacuteY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OacuteYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OacuteYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Oacutecomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Oacuteperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OcircumflexA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OcircumflexT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OcircumflexTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OcircumflexTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OcircumflexV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OcircumflexW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OcircumflexX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OcircumflexY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OcircumflexYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OcircumflexYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Ocircumflexcomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Ocircumflexperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OdieresisA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OdieresisT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OdieresisTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OdieresisTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OdieresisV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OdieresisW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OdieresisX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OdieresisY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OdieresisYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OdieresisYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Odieresiscomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Odieresisperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OgraveA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OgraveT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OgraveTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OgraveTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OgraveV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OgraveW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OgraveX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OgraveY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OgraveYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OgraveYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Ogravecomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Ograveperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OhungarumlautA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OhungarumlautT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OhungarumlautTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OhungarumlautTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OhungarumlautV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OhungarumlautW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OhungarumlautX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OhungarumlautY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OhungarumlautYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OhungarumlautYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Ohungarumlautcomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Ohungarumlautperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OmacronA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OmacronT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OmacronTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OmacronTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OmacronV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OmacronW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OmacronX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OmacronY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OmacronYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OmacronYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Omacroncomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Omacronperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OslashA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OslashT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OslashTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OslashTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OslashV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OslashW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OslashX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OslashY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OslashYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OslashYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Oslashcomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Oslashperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  OtildeA: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAacute: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAbreve: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAcircumflex: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAdieresis: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAgrave: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAmacron: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAogonek: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAring: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeAtilde: [
    -50,
    -50,
    -20,
    -20,
    -40,
    -40,
    -55,
    -35
  ],
  OtildeT: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OtildeTcaron: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OtildeTcommaaccent: [
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  OtildeV: [
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50,
    -50
  ],
  OtildeW: [
    -50,
    -50,
    -30,
    -30,
    -50,
    -50,
    -50,
    -35
  ],
  OtildeX: [
    -50,
    -50,
    -60,
    -60,
    -40,
    -40,
    -40,
    -40
  ],
  OtildeY: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OtildeYacute: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  OtildeYdieresis: [
    -70,
    -70,
    -70,
    -70,
    -50,
    -50,
    -50,
    -50
  ],
  Otildecomma: [
    -40,
    -40,
    -40,
    -40
  ],
  Otildeperiod: [
    -40,
    -40,
    -40,
    -40
  ],
  PA: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAacute: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAbreve: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAcircumflex: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAdieresis: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAgrave: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAmacron: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAogonek: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAring: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  PAtilde: [
    -100,
    -100,
    -120,
    -120,
    -74,
    -85,
    -90,
    -92
  ],
  Pa: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Paacute: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Pabreve: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Pacircumflex: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Padieresis: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Pagrave: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Pamacron: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Paogonek: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Paring: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Patilde: [
    -30,
    -30,
    -40,
    -40,
    -10,
    -40,
    -80,
    -15
  ],
  Pcomma: [
    -120,
    -120,
    -180,
    -180,
    -92,
    -129,
    -135,
    -111
  ],
  Pe: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Peacute: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Pecaron: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Pecircumflex: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Pedieresis: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Pedotaccent: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Pegrave: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Pemacron: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Peogonek: [
    -30,
    -30,
    -50,
    -50,
    -20,
    -50,
    -80
  ],
  Po: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Poacute: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Pocircumflex: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Podieresis: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Pograve: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Pohungarumlaut: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Pomacron: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Poslash: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Potilde: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -55,
    -80
  ],
  Pperiod: [
    -120,
    -120,
    -180,
    -180,
    -110,
    -129,
    -135,
    -111
  ],
  QU: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUacute: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUcircumflex: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUdieresis: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUgrave: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUhungarumlaut: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUmacron: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUogonek: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  QUring: [
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10,
    -10
  ],
  Qcomma: [
    20,
    20
  ],
  Qperiod: [
    20,
    20,
    0,
    0,
    -20
  ],
  RO: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROacute: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROcircumflex: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROdieresis: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROgrave: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROmacron: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROslash: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  ROtilde: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RT: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RTcaron: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RTcommaaccent: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RU: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUacute: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUcircumflex: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUdieresis: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUgrave: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUhungarumlaut: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUmacron: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUogonek: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RUring: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RV: [
    -50,
    -50,
    -50,
    -50,
    -55,
    -18,
    -18,
    -80
  ],
  RW: [
    -40,
    -40,
    -30,
    -30,
    -35,
    -18,
    -18,
    -55
  ],
  RY: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RYacute: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RYdieresis: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RacuteO: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOacute: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOcircumflex: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOdieresis: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOgrave: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOmacron: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOslash: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteOtilde: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteT: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RacuteTcaron: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RacuteTcommaaccent: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RacuteU: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUacute: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUcircumflex: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUdieresis: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUgrave: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUhungarumlaut: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUmacron: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUogonek: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteUring: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RacuteV: [
    -50,
    -50,
    -50,
    -50,
    -55,
    -18,
    -18,
    -80
  ],
  RacuteW: [
    -40,
    -40,
    -30,
    -30,
    -35,
    -18,
    -18,
    -55
  ],
  RacuteY: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RacuteYacute: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RacuteYdieresis: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RcaronO: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOacute: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOcircumflex: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOdieresis: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOgrave: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOmacron: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOslash: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronOtilde: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronT: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RcaronTcaron: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RcaronTcommaaccent: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RcaronU: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUacute: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUcircumflex: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUdieresis: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUgrave: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUhungarumlaut: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUmacron: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUogonek: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronUring: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcaronV: [
    -50,
    -50,
    -50,
    -50,
    -55,
    -18,
    -18,
    -80
  ],
  RcaronW: [
    -40,
    -40,
    -30,
    -30,
    -35,
    -18,
    -18,
    -55
  ],
  RcaronY: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RcaronYacute: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RcaronYdieresis: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RcommaaccentO: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOacute: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOcircumflex: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOdieresis: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOgrave: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOmacron: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOslash: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentOtilde: [
    -20,
    -20,
    -20,
    -20,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentT: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RcommaaccentTcaron: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RcommaaccentTcommaaccent: [
    -20,
    -20,
    -30,
    -30,
    -40,
    -30,
    0,
    -60
  ],
  RcommaaccentU: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUacute: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUcircumflex: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUdieresis: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUgrave: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUhungarumlaut: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUmacron: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUogonek: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentUring: [
    -20,
    -20,
    -40,
    -40,
    -30,
    -40,
    -40,
    -40
  ],
  RcommaaccentV: [
    -50,
    -50,
    -50,
    -50,
    -55,
    -18,
    -18,
    -80
  ],
  RcommaaccentW: [
    -40,
    -40,
    -30,
    -30,
    -35,
    -18,
    -18,
    -55
  ],
  RcommaaccentY: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RcommaaccentYacute: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  RcommaaccentYdieresis: [
    -50,
    -50,
    -50,
    -50,
    -35,
    -18,
    -18,
    -65
  ],
  TA: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAacute: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAbreve: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAcircumflex: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAdieresis: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAgrave: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAmacron: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAogonek: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAring: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TAtilde: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TO: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOacute: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOcircumflex: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOdieresis: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOgrave: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOhungarumlaut: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOmacron: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOslash: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TOtilde: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  Ta: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Taacute: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tabreve: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -80
  ],
  Tacircumflex: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -80
  ],
  Tadieresis: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -40
  ],
  Tagrave: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -40
  ],
  Tamacron: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -40
  ],
  Taogonek: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Taring: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tatilde: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -40
  ],
  Tcolon: [
    -40,
    -40,
    -20,
    -20,
    -74,
    -74,
    -55,
    -50
  ],
  Tcomma: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -92,
    -74,
    -74
  ],
  Te: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Teacute: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tecaron: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tecircumflex: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -52,
    -70
  ],
  Tedieresis: [
    -60,
    -60,
    -120,
    -120,
    -52,
    -52,
    -52,
    -30
  ],
  Tedotaccent: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tegrave: [
    -60,
    -60,
    -60,
    -60,
    -52,
    -52,
    -52,
    -70
  ],
  Temacron: [
    -60,
    -60,
    -60,
    -60,
    -52,
    -52,
    -52,
    -30
  ],
  Teogonek: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Thyphen: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -92,
    -74,
    -92
  ],
  To: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Toacute: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tocircumflex: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Todieresis: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tograve: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tohungarumlaut: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tomacron: [
    -80,
    -80,
    -60,
    -60,
    -92,
    -95,
    -92,
    -80
  ],
  Toslash: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Totilde: [
    -80,
    -80,
    -60,
    -60,
    -92,
    -95,
    -92,
    -80
  ],
  Tperiod: [
    -80,
    -80,
    -120,
    -120,
    -90,
    -92,
    -74,
    -74
  ],
  Tr: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tracute: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Trcommaaccent: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tsemicolon: [
    -40,
    -40,
    -20,
    -20,
    -74,
    -74,
    -65,
    -55
  ],
  Tu: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tuacute: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tucircumflex: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tudieresis: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tugrave: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tuhungarumlaut: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tumacron: [
    -90,
    -90,
    -60,
    -60,
    -92,
    -37,
    -55,
    -45
  ],
  Tuogonek: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Turing: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tw: [
    -60,
    -60,
    -120,
    -120,
    -74,
    -37,
    -74,
    -80
  ],
  Ty: [
    -60,
    -60,
    -120,
    -120,
    -34,
    -37,
    -74,
    -80
  ],
  Tyacute: [
    -60,
    -60,
    -120,
    -120,
    -34,
    -37,
    -74,
    -80
  ],
  Tydieresis: [
    -60,
    -60,
    -60,
    -60,
    -34,
    -37,
    -34,
    -80
  ],
  TcaronA: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAacute: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAbreve: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAcircumflex: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAdieresis: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAgrave: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAmacron: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAogonek: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAring: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronAtilde: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcaronO: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOacute: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOcircumflex: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOdieresis: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOgrave: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOhungarumlaut: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOmacron: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOslash: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcaronOtilde: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  Tcarona: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcaronaacute: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcaronabreve: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -80
  ],
  Tcaronacircumflex: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -80
  ],
  Tcaronadieresis: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -40
  ],
  Tcaronagrave: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -40
  ],
  Tcaronamacron: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -40
  ],
  Tcaronaogonek: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcaronaring: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcaronatilde: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -40
  ],
  Tcaroncolon: [
    -40,
    -40,
    -20,
    -20,
    -74,
    -74,
    -55,
    -50
  ],
  Tcaroncomma: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -92,
    -74,
    -74
  ],
  Tcarone: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcaroneacute: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcaronecaron: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcaronecircumflex: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -52,
    -30
  ],
  Tcaronedieresis: [
    -60,
    -60,
    -120,
    -120,
    -52,
    -52,
    -52,
    -30
  ],
  Tcaronedotaccent: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcaronegrave: [
    -60,
    -60,
    -60,
    -60,
    -52,
    -52,
    -52,
    -70
  ],
  Tcaronemacron: [
    -60,
    -60,
    -60,
    -60,
    -52,
    -52,
    -52,
    -30
  ],
  Tcaroneogonek: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcaronhyphen: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -92,
    -74,
    -92
  ],
  Tcarono: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronoacute: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronocircumflex: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronodieresis: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronograve: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronohungarumlaut: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronomacron: [
    -80,
    -80,
    -60,
    -60,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronoslash: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronotilde: [
    -80,
    -80,
    -60,
    -60,
    -92,
    -95,
    -92,
    -80
  ],
  Tcaronperiod: [
    -80,
    -80,
    -120,
    -120,
    -90,
    -92,
    -74,
    -74
  ],
  Tcaronr: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcaronracute: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcaronrcommaaccent: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcaronsemicolon: [
    -40,
    -40,
    -20,
    -20,
    -74,
    -74,
    -65,
    -55
  ],
  Tcaronu: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronuacute: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronucircumflex: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronudieresis: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronugrave: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronuhungarumlaut: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronumacron: [
    -90,
    -90,
    -60,
    -60,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronuogonek: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronuring: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcaronw: [
    -60,
    -60,
    -120,
    -120,
    -74,
    -37,
    -74,
    -80
  ],
  Tcarony: [
    -60,
    -60,
    -120,
    -120,
    -34,
    -37,
    -74,
    -80
  ],
  Tcaronyacute: [
    -60,
    -60,
    -120,
    -120,
    -34,
    -37,
    -74,
    -80
  ],
  Tcaronydieresis: [
    -60,
    -60,
    -60,
    -60,
    -34,
    -37,
    -34,
    -80
  ],
  TcommaaccentA: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAacute: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAbreve: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAcircumflex: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAdieresis: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAgrave: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAmacron: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAogonek: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAring: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentAtilde: [
    -90,
    -90,
    -120,
    -120,
    -90,
    -55,
    -50,
    -93
  ],
  TcommaaccentO: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOacute: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOcircumflex: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOdieresis: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOgrave: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOhungarumlaut: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOmacron: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOslash: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  TcommaaccentOtilde: [
    -40,
    -40,
    -40,
    -40,
    -18,
    -18,
    -18,
    -18
  ],
  Tcommaaccenta: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcommaaccentaacute: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcommaaccentabreve: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -80
  ],
  Tcommaaccentacircumflex: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -80
  ],
  Tcommaaccentadieresis: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -40
  ],
  Tcommaaccentagrave: [
    -80,
    -80,
    -120,
    -120,
    -52,
    -92,
    -92,
    -40
  ],
  Tcommaaccentamacron: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -40
  ],
  Tcommaaccentaogonek: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcommaaccentaring: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -92,
    -92,
    -80
  ],
  Tcommaaccentatilde: [
    -80,
    -80,
    -60,
    -60,
    -52,
    -92,
    -92,
    -40
  ],
  Tcommaaccentcolon: [
    -40,
    -40,
    -20,
    -20,
    -74,
    -74,
    -55,
    -50
  ],
  Tcommaaccentcomma: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -92,
    -74,
    -74
  ],
  Tcommaaccente: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcommaaccenteacute: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcommaaccentecaron: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcommaaccentecircumflex: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -52,
    -30
  ],
  Tcommaaccentedieresis: [
    -60,
    -60,
    -120,
    -120,
    -52,
    -52,
    -52,
    -30
  ],
  Tcommaaccentedotaccent: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcommaaccentegrave: [
    -60,
    -60,
    -60,
    -60,
    -52,
    -52,
    -52,
    -30
  ],
  Tcommaaccentemacron: [
    -60,
    -60,
    -60,
    -60,
    -52,
    -52,
    -52,
    -70
  ],
  Tcommaaccenteogonek: [
    -60,
    -60,
    -120,
    -120,
    -92,
    -92,
    -92,
    -70
  ],
  Tcommaaccenthyphen: [
    -120,
    -120,
    -140,
    -140,
    -92,
    -92,
    -74,
    -92
  ],
  Tcommaaccento: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentoacute: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentocircumflex: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentodieresis: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentograve: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentohungarumlaut: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentomacron: [
    -80,
    -80,
    -60,
    -60,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentoslash: [
    -80,
    -80,
    -120,
    -120,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentotilde: [
    -80,
    -80,
    -60,
    -60,
    -92,
    -95,
    -92,
    -80
  ],
  Tcommaaccentperiod: [
    -80,
    -80,
    -120,
    -120,
    -90,
    -92,
    -74,
    -74
  ],
  Tcommaaccentr: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcommaaccentracute: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcommaaccentrcommaaccent: [
    -80,
    -80,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcommaaccentsemicolon: [
    -40,
    -40,
    -20,
    -20,
    -74,
    -74,
    -65,
    -55
  ],
  Tcommaaccentu: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentuacute: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentucircumflex: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentudieresis: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentugrave: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentuhungarumlaut: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentumacron: [
    -90,
    -90,
    -60,
    -60,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentuogonek: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccenturing: [
    -90,
    -90,
    -120,
    -120,
    -92,
    -37,
    -55,
    -45
  ],
  Tcommaaccentw: [
    -60,
    -60,
    -120,
    -120,
    -74,
    -37,
    -74,
    -80
  ],
  Tcommaaccenty: [
    -60,
    -60,
    -120,
    -120,
    -34,
    -37,
    -74,
    -80
  ],
  Tcommaaccentyacute: [
    -60,
    -60,
    -120,
    -120,
    -34,
    -37,
    -74,
    -80
  ],
  Tcommaaccentydieresis: [
    -60,
    -60,
    -60,
    -60,
    -34,
    -37,
    -34,
    -80
  ],
  UA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Ucomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Uperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UacuteA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UacuteAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Uacutecomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Uacuteperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UcircumflexA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UcircumflexAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Ucircumflexcomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Ucircumflexperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UdieresisA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UdieresisAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Udieresiscomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Udieresisperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UgraveA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UgraveAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Ugravecomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Ugraveperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UhungarumlautA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UhungarumlautAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Uhungarumlautcomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Uhungarumlautperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UmacronA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UmacronAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Umacroncomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Umacronperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UogonekA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UogonekAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Uogonekcomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Uogonekperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  UringA: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAacute: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAbreve: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAdieresis: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAgrave: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAmacron: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAogonek: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAring: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  UringAtilde: [
    -50,
    -50,
    -40,
    -40,
    -60,
    -45,
    -40,
    -40
  ],
  Uringcomma: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  Uringperiod: [
    -30,
    -30,
    -40,
    -40,
    -50,
    0,
    -25
  ],
  VA: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAacute: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAbreve: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAcircumflex: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAdieresis: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAgrave: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAmacron: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAogonek: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAring: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VAtilde: [
    -80,
    -80,
    -80,
    -80,
    -135,
    -85,
    -60,
    -135
  ],
  VG: [
    -50,
    -50,
    -40,
    -40,
    -30,
    -10,
    0,
    -15
  ],
  VGbreve: [
    -50,
    -50,
    -40,
    -40,
    -30,
    -10,
    0,
    -15
  ],
  VGcommaaccent: [
    -50,
    -50,
    -40,
    -40,
    -30,
    -10,
    0,
    -15
  ],
  VO: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOacute: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOcircumflex: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOdieresis: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOgrave: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOhungarumlaut: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOmacron: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOslash: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  VOtilde: [
    -50,
    -50,
    -40,
    -40,
    -45,
    -30,
    -30,
    -40
  ],
  Va: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -111
  ],
  Vaacute: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -111
  ],
  Vabreve: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -111
  ],
  Vacircumflex: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -71
  ],
  Vadieresis: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -71
  ],
  Vagrave: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -71
  ],
  Vamacron: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -71
  ],
  Vaogonek: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -111
  ],
  Varing: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -111
  ],
  Vatilde: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -111,
    -111,
    -71
  ],
  Vcolon: [
    -40,
    -40,
    -40,
    -40,
    -92,
    -74,
    -65,
    -74
  ],
  Vcomma: [
    -120,
    -120,
    -125,
    -125,
    -129,
    -129,
    -129,
    -129
  ],
  Ve: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -111,
    -111,
    -111
  ],
  Veacute: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -111,
    -111,
    -111
  ],
  Vecaron: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -111,
    -111,
    -71
  ],
  Vecircumflex: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -111,
    -111,
    -71
  ],
  Vedieresis: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -71,
    -71,
    -71
  ],
  Vedotaccent: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -111,
    -111,
    -111
  ],
  Vegrave: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -71,
    -71,
    -71
  ],
  Vemacron: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -71,
    -71,
    -71
  ],
  Veogonek: [
    -50,
    -50,
    -80,
    -80,
    -100,
    -111,
    -111,
    -111
  ],
  Vhyphen: [
    -80,
    -80,
    -80,
    -80,
    -74,
    -70,
    -55,
    -100
  ],
  Vo: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -129
  ],
  Voacute: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -129
  ],
  Vocircumflex: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -129
  ],
  Vodieresis: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -89
  ],
  Vograve: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -89
  ],
  Vohungarumlaut: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -129
  ],
  Vomacron: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -89
  ],
  Voslash: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -129
  ],
  Votilde: [
    -90,
    -90,
    -80,
    -80,
    -100,
    -111,
    -111,
    -89
  ],
  Vperiod: [
    -120,
    -120,
    -125,
    -125,
    -145,
    -129,
    -129,
    -129
  ],
  Vsemicolon: [
    -40,
    -40,
    -40,
    -40,
    -92,
    -74,
    -74,
    -74
  ],
  Vu: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vuacute: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vucircumflex: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vudieresis: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vugrave: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vuhungarumlaut: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vumacron: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vuogonek: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  Vuring: [
    -60,
    -60,
    -70,
    -70,
    -92,
    -55,
    -74,
    -75
  ],
  WA: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAacute: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAbreve: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAcircumflex: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAdieresis: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAgrave: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAmacron: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAogonek: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAring: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WAtilde: [
    -60,
    -60,
    -50,
    -50,
    -120,
    -74,
    -60,
    -120
  ],
  WO: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOacute: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOcircumflex: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOdieresis: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOgrave: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOmacron: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOslash: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  WOtilde: [
    -20,
    -20,
    -20,
    -20,
    -10,
    -15,
    -25,
    -10
  ],
  Wa: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Waacute: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Wabreve: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Wacircumflex: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Wadieresis: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Wagrave: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Wamacron: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Waogonek: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Waring: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Watilde: [
    -40,
    -40,
    -40,
    -40,
    -65,
    -85,
    -92,
    -80
  ],
  Wcolon: [
    -10,
    -10,
    0,
    0,
    -55,
    -55,
    -65,
    -37
  ],
  Wcomma: [
    -80,
    -80,
    -80,
    -80,
    -92,
    -74,
    -92,
    -92
  ],
  We: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -90,
    -92,
    -80
  ],
  Weacute: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -90,
    -92,
    -80
  ],
  Wecaron: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -90,
    -92,
    -80
  ],
  Wecircumflex: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -90,
    -92,
    -80
  ],
  Wedieresis: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -50,
    -52,
    -40
  ],
  Wedotaccent: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -90,
    -92,
    -80
  ],
  Wegrave: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -50,
    -52,
    -40
  ],
  Wemacron: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -50,
    -52,
    -40
  ],
  Weogonek: [
    -35,
    -35,
    -30,
    -30,
    -65,
    -90,
    -92,
    -80
  ],
  Whyphen: [
    -40,
    -40,
    -40,
    -40,
    -37,
    -50,
    -37,
    -65
  ],
  Wo: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Woacute: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Wocircumflex: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Wodieresis: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Wograve: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Wohungarumlaut: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Womacron: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Woslash: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Wotilde: [
    -60,
    -60,
    -30,
    -30,
    -75,
    -80,
    -92,
    -80
  ],
  Wperiod: [
    -80,
    -80,
    -80,
    -80,
    -92,
    -74,
    -92,
    -92
  ],
  Wsemicolon: [
    -10,
    -10,
    0,
    0,
    -55,
    -55,
    -65,
    -37
  ],
  Wu: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wuacute: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wucircumflex: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wudieresis: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wugrave: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wuhungarumlaut: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wumacron: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wuogonek: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wuring: [
    -45,
    -45,
    -30,
    -30,
    -50,
    -55,
    -55,
    -50
  ],
  Wy: [
    -20,
    -20,
    -20,
    -20,
    -60,
    -55,
    -70,
    -73
  ],
  Wyacute: [
    -20,
    -20,
    -20,
    -20,
    -60,
    -55,
    -70,
    -73
  ],
  Wydieresis: [
    -20,
    -20,
    -20,
    -20,
    -60,
    -55,
    -70,
    -73
  ],
  YA: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAacute: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAbreve: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAcircumflex: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAdieresis: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAgrave: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAmacron: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAogonek: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAring: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YAtilde: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YO: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOacute: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOcircumflex: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOdieresis: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOgrave: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOhungarumlaut: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOmacron: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOslash: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YOtilde: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  Ya: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yaacute: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yabreve: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -100
  ],
  Yacircumflex: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yadieresis: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Yagrave: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Yamacron: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -60
  ],
  Yaogonek: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yaring: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yatilde: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Ycolon: [
    -50,
    -50,
    -60,
    -60,
    -92,
    -92,
    -65,
    -92
  ],
  Ycomma: [
    -100,
    -100,
    -140,
    -140,
    -92,
    -92,
    -92,
    -129
  ],
  Ye: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yeacute: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yecaron: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yecircumflex: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -71,
    -92,
    -100
  ],
  Yedieresis: [
    -80,
    -80,
    -140,
    -140,
    -71,
    -71,
    -52,
    -60
  ],
  Yedotaccent: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yegrave: [
    -80,
    -80,
    -140,
    -140,
    -71,
    -71,
    -52,
    -60
  ],
  Yemacron: [
    -80,
    -80,
    -70,
    -70,
    -71,
    -71,
    -52,
    -60
  ],
  Yeogonek: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yo: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yoacute: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yocircumflex: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yodieresis: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yograve: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yohungarumlaut: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yomacron: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yoslash: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yotilde: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yperiod: [
    -100,
    -100,
    -140,
    -140,
    -92,
    -74,
    -92,
    -129
  ],
  Ysemicolon: [
    -50,
    -50,
    -60,
    -60,
    -92,
    -92,
    -65,
    -92
  ],
  Yu: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yuacute: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yucircumflex: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yudieresis: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Yugrave: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Yuhungarumlaut: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yumacron: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Yuogonek: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yuring: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  YacuteA: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAacute: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAbreve: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAcircumflex: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAdieresis: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAgrave: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAmacron: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAogonek: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAring: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteAtilde: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YacuteO: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOacute: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOcircumflex: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOdieresis: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOgrave: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOhungarumlaut: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOmacron: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOslash: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YacuteOtilde: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  Yacutea: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yacuteaacute: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yacuteabreve: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -100
  ],
  Yacuteacircumflex: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yacuteadieresis: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Yacuteagrave: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Yacuteamacron: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -60
  ],
  Yacuteaogonek: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yacutearing: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Yacuteatilde: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -60
  ],
  Yacutecolon: [
    -50,
    -50,
    -60,
    -60,
    -92,
    -92,
    -65,
    -92
  ],
  Yacutecomma: [
    -100,
    -100,
    -140,
    -140,
    -92,
    -92,
    -92,
    -129
  ],
  Yacutee: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yacuteeacute: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yacuteecaron: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yacuteecircumflex: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -71,
    -92,
    -100
  ],
  Yacuteedieresis: [
    -80,
    -80,
    -140,
    -140,
    -71,
    -71,
    -52,
    -60
  ],
  Yacuteedotaccent: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yacuteegrave: [
    -80,
    -80,
    -140,
    -140,
    -71,
    -71,
    -52,
    -60
  ],
  Yacuteemacron: [
    -80,
    -80,
    -70,
    -70,
    -71,
    -71,
    -52,
    -60
  ],
  Yacuteeogonek: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Yacuteo: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yacuteoacute: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yacuteocircumflex: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yacuteodieresis: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yacuteograve: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yacuteohungarumlaut: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yacuteomacron: [
    -100,
    -100,
    -70,
    -70,
    -111,
    -111,
    -92,
    -70
  ],
  Yacuteoslash: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Yacuteotilde: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Yacuteperiod: [
    -100,
    -100,
    -140,
    -140,
    -92,
    -74,
    -92,
    -129
  ],
  Yacutesemicolon: [
    -50,
    -50,
    -60,
    -60,
    -92,
    -92,
    -65,
    -92
  ],
  Yacuteu: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yacuteuacute: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yacuteucircumflex: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yacuteudieresis: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Yacuteugrave: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Yacuteuhungarumlaut: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yacuteumacron: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Yacuteuogonek: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Yacuteuring: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  YdieresisA: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAacute: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAbreve: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAcircumflex: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAdieresis: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAgrave: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAmacron: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAogonek: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAring: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisAtilde: [
    -110,
    -110,
    -110,
    -110,
    -110,
    -74,
    -50,
    -120
  ],
  YdieresisO: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOacute: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOcircumflex: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOdieresis: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOgrave: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOhungarumlaut: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOmacron: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOslash: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  YdieresisOtilde: [
    -70,
    -70,
    -85,
    -85,
    -35,
    -25,
    -15,
    -30
  ],
  Ydieresisa: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresisaacute: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresisabreve: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresisacircumflex: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresisadieresis: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Ydieresisagrave: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -60
  ],
  Ydieresisamacron: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -60
  ],
  Ydieresisaogonek: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresisaring: [
    -90,
    -90,
    -140,
    -140,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresisatilde: [
    -90,
    -90,
    -70,
    -70,
    -85,
    -92,
    -92,
    -100
  ],
  Ydieresiscolon: [
    -50,
    -50,
    -60,
    -60,
    -92,
    -92,
    -65,
    -92
  ],
  Ydieresiscomma: [
    -100,
    -100,
    -140,
    -140,
    -92,
    -92,
    -92,
    -129
  ],
  Ydieresise: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Ydieresiseacute: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Ydieresisecaron: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Ydieresisecircumflex: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -71,
    -92,
    -100
  ],
  Ydieresisedieresis: [
    -80,
    -80,
    -140,
    -140,
    -71,
    -71,
    -52,
    -60
  ],
  Ydieresisedotaccent: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Ydieresisegrave: [
    -80,
    -80,
    -140,
    -140,
    -71,
    -71,
    -52,
    -60
  ],
  Ydieresisemacron: [
    -80,
    -80,
    -70,
    -70,
    -71,
    -71,
    -52,
    -60
  ],
  Ydieresiseogonek: [
    -80,
    -80,
    -140,
    -140,
    -111,
    -111,
    -92,
    -100
  ],
  Ydieresiso: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Ydieresisoacute: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Ydieresisocircumflex: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Ydieresisodieresis: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Ydieresisograve: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Ydieresisohungarumlaut: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Ydieresisomacron: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Ydieresisoslash: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -110
  ],
  Ydieresisotilde: [
    -100,
    -100,
    -140,
    -140,
    -111,
    -111,
    -92,
    -70
  ],
  Ydieresisperiod: [
    -100,
    -100,
    -140,
    -140,
    -92,
    -74,
    -92,
    -129
  ],
  Ydieresissemicolon: [
    -50,
    -50,
    -60,
    -60,
    -92,
    -92,
    -65,
    -92
  ],
  Ydieresisu: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Ydieresisuacute: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Ydieresisucircumflex: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Ydieresisudieresis: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Ydieresisugrave: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Ydieresisuhungarumlaut: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Ydieresisumacron: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -71
  ],
  Ydieresisuogonek: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  Ydieresisuring: [
    -100,
    -100,
    -110,
    -110,
    -92,
    -92,
    -92,
    -111
  ],
  ag: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  agbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  agcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  av: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  aw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  ay: [
    -20,
    -20,
    -30,
    -30
  ],
  ayacute: [
    -20,
    -20,
    -30,
    -30
  ],
  aydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  aacuteg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aacutegbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aacutegcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aacutev: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  aacutew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  aacutey: [
    -20,
    -20,
    -30,
    -30
  ],
  aacuteyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  aacuteydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  abreveg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  abrevegbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  abrevegcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  abrevev: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  abrevew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  abrevey: [
    -20,
    -20,
    -30,
    -30
  ],
  abreveyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  abreveydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  acircumflexg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  acircumflexgbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  acircumflexgcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  acircumflexv: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  acircumflexw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  acircumflexy: [
    -20,
    -20,
    -30,
    -30
  ],
  acircumflexyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  acircumflexydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  adieresisg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  adieresisgbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  adieresisgcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  adieresisv: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  adieresisw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  adieresisy: [
    -20,
    -20,
    -30,
    -30
  ],
  adieresisyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  adieresisydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  agraveg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  agravegbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  agravegcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  agravev: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  agravew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  agravey: [
    -20,
    -20,
    -30,
    -30
  ],
  agraveyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  agraveydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  amacrong: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  amacrongbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  amacrongcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  amacronv: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  amacronw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  amacrony: [
    -20,
    -20,
    -30,
    -30
  ],
  amacronyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  amacronydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  aogonekg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aogonekgbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aogonekgcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aogonekv: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  aogonekw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  aogoneky: [
    -20,
    -20,
    -30,
    -30
  ],
  aogonekyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  aogonekydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  aringg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aringgbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aringgcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  aringv: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  aringw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  aringy: [
    -20,
    -20,
    -30,
    -30
  ],
  aringyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  aringydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  atildeg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  atildegbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  atildegcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  atildev: [
    -15,
    -15,
    -20,
    -20,
    -25,
    0,
    0,
    -20
  ],
  atildew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    0,
    -15
  ],
  atildey: [
    -20,
    -20,
    -30,
    -30
  ],
  atildeyacute: [
    -20,
    -20,
    -30,
    -30
  ],
  atildeydieresis: [
    -20,
    -20,
    -30,
    -30
  ],
  bl: [
    -10,
    -10,
    -20,
    -20
  ],
  blacute: [
    -10,
    -10,
    -20,
    -20
  ],
  blcommaaccent: [
    -10,
    -10,
    -20,
    -20
  ],
  blslash: [
    -10,
    -10,
    -20,
    -20
  ],
  bu: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  buacute: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  bucircumflex: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  budieresis: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  bugrave: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  buhungarumlaut: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  bumacron: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  buogonek: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  buring: [
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20,
    -20
  ],
  bv: [
    -20,
    -20,
    -20,
    -20,
    -15,
    0,
    0,
    -15
  ],
  by: [
    -20,
    -20,
    -20,
    -20
  ],
  byacute: [
    -20,
    -20,
    -20,
    -20
  ],
  bydieresis: [
    -20,
    -20,
    -20,
    -20
  ],
  ch: [
    -10,
    -10,
    0,
    0,
    0,
    -10,
    -15
  ],
  ck: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  ckcommaaccent: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  cl: [
    -20,
    -20
  ],
  clacute: [
    -20,
    -20
  ],
  clcommaaccent: [
    -20,
    -20
  ],
  clslash: [
    -20,
    -20
  ],
  cy: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  cyacute: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  cydieresis: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  cacuteh: [
    -10,
    -10,
    0,
    0,
    0,
    -10,
    -15
  ],
  cacutek: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  cacutekcommaaccent: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  cacutel: [
    -20,
    -20
  ],
  cacutelacute: [
    -20,
    -20
  ],
  cacutelcommaaccent: [
    -20,
    -20
  ],
  cacutelslash: [
    -20,
    -20
  ],
  cacutey: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  cacuteyacute: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  cacuteydieresis: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  ccaronh: [
    -10,
    -10,
    0,
    0,
    0,
    -10,
    -15
  ],
  ccaronk: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  ccaronkcommaaccent: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  ccaronl: [
    -20,
    -20
  ],
  ccaronlacute: [
    -20,
    -20
  ],
  ccaronlcommaaccent: [
    -20,
    -20
  ],
  ccaronlslash: [
    -20,
    -20
  ],
  ccarony: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  ccaronyacute: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  ccaronydieresis: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  ccedillah: [
    -10,
    -10,
    0,
    0,
    0,
    -10,
    -15
  ],
  ccedillak: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  ccedillakcommaaccent: [
    -20,
    -20,
    -20,
    -20,
    0,
    -10,
    -20
  ],
  ccedillal: [
    -20,
    -20
  ],
  ccedillalacute: [
    -20,
    -20
  ],
  ccedillalcommaaccent: [
    -20,
    -20
  ],
  ccedillalslash: [
    -20,
    -20
  ],
  ccedillay: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  ccedillayacute: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  ccedillaydieresis: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    0,
    -15
  ],
  colonspace: [
    -40,
    -40,
    -50,
    -50
  ],
  commaquotedblright: [
    -120,
    -120,
    -100,
    -100,
    -45,
    -95,
    -140,
    -70
  ],
  commaquoteright: [
    -120,
    -120,
    -100,
    -100,
    -55,
    -95,
    -140,
    -70
  ],
  commaspace: [
    -40,
    -40
  ],
  dd: [
    -10,
    -10
  ],
  ddcroat: [
    -10,
    -10
  ],
  dv: [
    -15,
    -15
  ],
  dw: [
    -15,
    -15,
    0,
    0,
    -15
  ],
  dy: [
    -15,
    -15
  ],
  dyacute: [
    -15,
    -15
  ],
  dydieresis: [
    -15,
    -15
  ],
  dcroatd: [
    -10,
    -10
  ],
  dcroatdcroat: [
    -10,
    -10
  ],
  dcroatv: [
    -15,
    -15
  ],
  dcroatw: [
    -15,
    -15,
    0,
    0,
    -15
  ],
  dcroaty: [
    -15,
    -15
  ],
  dcroatyacute: [
    -15,
    -15
  ],
  dcroatydieresis: [
    -15,
    -15
  ],
  ecomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  eperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  ev: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  ew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  ex: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  ey: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eacutecomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  eacuteperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  eacutev: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  eacutew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  eacutex: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  eacutey: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eacuteyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eacuteydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  ecaroncomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  ecaronperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  ecaronv: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  ecaronw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  ecaronx: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  ecarony: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  ecaronyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  ecaronydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  ecircumflexcomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  ecircumflexperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  ecircumflexv: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  ecircumflexw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  ecircumflexx: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  ecircumflexy: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  ecircumflexyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  ecircumflexydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  edieresiscomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  edieresisperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  edieresisv: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  edieresisw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  edieresisx: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  edieresisy: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  edieresisyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  edieresisydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  edotaccentcomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  edotaccentperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  edotaccentv: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  edotaccentw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  edotaccentx: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  edotaccenty: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  edotaccentyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  edotaccentydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  egravecomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  egraveperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  egravev: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  egravew: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  egravex: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  egravey: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  egraveyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  egraveydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  emacroncomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  emacronperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  emacronv: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  emacronw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  emacronx: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  emacrony: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  emacronyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  emacronydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eogonekcomma: [
    10,
    10,
    -15,
    -15,
    0,
    0,
    -10
  ],
  eogonekperiod: [
    20,
    20,
    -15,
    -15,
    0,
    0,
    -15
  ],
  eogonekv: [
    -15,
    -15,
    -30,
    -30,
    -15,
    0,
    -15,
    -25
  ],
  eogonekw: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -15,
    -25
  ],
  eogonekx: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    -20,
    -15
  ],
  eogoneky: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eogonekyacute: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  eogonekydieresis: [
    -15,
    -15,
    -20,
    -20,
    0,
    0,
    -30,
    -15
  ],
  fcomma: [
    -10,
    -10,
    -30,
    -30,
    -15,
    -10,
    -10
  ],
  fe: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10
  ],
  feacute: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10
  ],
  fecaron: [
    -10,
    -10,
    -30,
    -30
  ],
  fecircumflex: [
    -10,
    -10,
    -30,
    -30
  ],
  fedieresis: [
    -10,
    -10,
    -30,
    -30
  ],
  fedotaccent: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10
  ],
  fegrave: [
    -10,
    -10,
    -30,
    -30
  ],
  femacron: [
    -10,
    -10,
    -30,
    -30
  ],
  feogonek: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10
  ],
  fo: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  foacute: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  focircumflex: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  fodieresis: [
    -20,
    -20,
    -30,
    -30,
    -25
  ],
  fograve: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  fohungarumlaut: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  fomacron: [
    -20,
    -20,
    -30,
    -30,
    -25
  ],
  foslash: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  fotilde: [
    -20,
    -20,
    -30,
    -30,
    -25,
    -10
  ],
  fperiod: [
    -10,
    -10,
    -30,
    -30,
    -15,
    -10,
    -15
  ],
  fquotedblright: [
    30,
    30,
    60,
    60,
    50
  ],
  fquoteright: [
    30,
    30,
    50,
    50,
    55,
    55,
    92,
    55
  ],
  ge: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  geacute: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gecaron: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gecircumflex: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gedieresis: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gedotaccent: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gegrave: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gemacron: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  geogonek: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  ggbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  ggcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbrevee: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveeacute: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveecaron: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveecircumflex: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveedieresis: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveedotaccent: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveegrave: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveemacron: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveeogonek: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbreveg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbrevegbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  gbrevegcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccente: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccenteacute: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentecaron: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentecircumflex: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentedieresis: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentedotaccent: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentegrave: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentemacron: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccenteogonek: [
    10,
    10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentg: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentgbreve: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentgcommaaccent: [
    -10,
    -10,
    0,
    0,
    0,
    0,
    -10
  ],
  hy: [
    -20,
    -20,
    -30,
    -30,
    -15,
    0,
    0,
    -5
  ],
  hyacute: [
    -20,
    -20,
    -30,
    -30,
    -15,
    0,
    0,
    -5
  ],
  hydieresis: [
    -20,
    -20,
    -30,
    -30,
    -15,
    0,
    0,
    -5
  ],
  ko: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  koacute: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kocircumflex: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kodieresis: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kograve: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kohungarumlaut: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  komacron: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  koslash: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kotilde: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccento: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentoacute: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentocircumflex: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentodieresis: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentograve: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentohungarumlaut: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentomacron: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentoslash: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  kcommaaccentotilde: [
    -15,
    -15,
    -20,
    -20,
    -15,
    -10,
    -10,
    -10
  ],
  lw: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ly: [
    -15,
    -15
  ],
  lyacute: [
    -15,
    -15
  ],
  lydieresis: [
    -15,
    -15
  ],
  lacutew: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  lacutey: [
    -15,
    -15
  ],
  lacuteyacute: [
    -15,
    -15
  ],
  lacuteydieresis: [
    -15,
    -15
  ],
  lcommaaccentw: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  lcommaaccenty: [
    -15,
    -15
  ],
  lcommaaccentyacute: [
    -15,
    -15
  ],
  lcommaaccentydieresis: [
    -15,
    -15
  ],
  lslashw: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  lslashy: [
    -15,
    -15
  ],
  lslashyacute: [
    -15,
    -15
  ],
  lslashydieresis: [
    -15,
    -15
  ],
  mu: [
    -20,
    -20,
    -10,
    -10
  ],
  muacute: [
    -20,
    -20,
    -10,
    -10
  ],
  mucircumflex: [
    -20,
    -20,
    -10,
    -10
  ],
  mudieresis: [
    -20,
    -20,
    -10,
    -10
  ],
  mugrave: [
    -20,
    -20,
    -10,
    -10
  ],
  muhungarumlaut: [
    -20,
    -20,
    -10,
    -10
  ],
  mumacron: [
    -20,
    -20,
    -10,
    -10
  ],
  muogonek: [
    -20,
    -20,
    -10,
    -10
  ],
  muring: [
    -20,
    -20,
    -10,
    -10
  ],
  my: [
    -30,
    -30,
    -15,
    -15
  ],
  myacute: [
    -30,
    -30,
    -15,
    -15
  ],
  mydieresis: [
    -30,
    -30,
    -15,
    -15
  ],
  nu: [
    -10,
    -10,
    -10,
    -10
  ],
  nuacute: [
    -10,
    -10,
    -10,
    -10
  ],
  nucircumflex: [
    -10,
    -10,
    -10,
    -10
  ],
  nudieresis: [
    -10,
    -10,
    -10,
    -10
  ],
  nugrave: [
    -10,
    -10,
    -10,
    -10
  ],
  nuhungarumlaut: [
    -10,
    -10,
    -10,
    -10
  ],
  numacron: [
    -10,
    -10,
    -10,
    -10
  ],
  nuogonek: [
    -10,
    -10,
    -10,
    -10
  ],
  nuring: [
    -10,
    -10,
    -10,
    -10
  ],
  nv: [
    -40,
    -40,
    -20,
    -20,
    -40,
    -40,
    -40,
    -40
  ],
  ny: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  nyacute: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  nydieresis: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  nacuteu: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteuacute: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteucircumflex: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteudieresis: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteugrave: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteuhungarumlaut: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteumacron: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteuogonek: [
    -10,
    -10,
    -10,
    -10
  ],
  nacuteuring: [
    -10,
    -10,
    -10,
    -10
  ],
  nacutev: [
    -40,
    -40,
    -20,
    -20,
    -40,
    -40,
    -40,
    -40
  ],
  nacutey: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  nacuteyacute: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  nacuteydieresis: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ncaronu: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronuacute: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronucircumflex: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronudieresis: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronugrave: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronuhungarumlaut: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronumacron: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronuogonek: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronuring: [
    -10,
    -10,
    -10,
    -10
  ],
  ncaronv: [
    -40,
    -40,
    -20,
    -20,
    -40,
    -40,
    -40,
    -40
  ],
  ncarony: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ncaronyacute: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ncaronydieresis: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ncommaaccentu: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentuacute: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentucircumflex: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentudieresis: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentugrave: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentuhungarumlaut: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentumacron: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentuogonek: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccenturing: [
    -10,
    -10,
    -10,
    -10
  ],
  ncommaaccentv: [
    -40,
    -40,
    -20,
    -20,
    -40,
    -40,
    -40,
    -40
  ],
  ncommaaccenty: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ncommaaccentyacute: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ncommaaccentydieresis: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ntildeu: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeuacute: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeucircumflex: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeudieresis: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeugrave: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeuhungarumlaut: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeumacron: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeuogonek: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildeuring: [
    -10,
    -10,
    -10,
    -10
  ],
  ntildev: [
    -40,
    -40,
    -20,
    -20,
    -40,
    -40,
    -40,
    -40
  ],
  ntildey: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ntildeyacute: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ntildeydieresis: [
    -20,
    -20,
    -15,
    -15,
    0,
    0,
    0,
    -15
  ],
  ov: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  ow: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  ox: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  oy: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  oyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  oydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  oacutev: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  oacutew: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  oacutex: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  oacutey: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  oacuteyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  oacuteydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ocircumflexv: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  ocircumflexw: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  ocircumflexx: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  ocircumflexy: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ocircumflexyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ocircumflexydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  odieresisv: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  odieresisw: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  odieresisx: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  odieresisy: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  odieresisyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  odieresisydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ogravev: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  ogravew: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  ogravex: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  ogravey: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ograveyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ograveydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ohungarumlautv: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  ohungarumlautw: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  ohungarumlautx: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  ohungarumlauty: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ohungarumlautyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  ohungarumlautydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  omacronv: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  omacronw: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  omacronx: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  omacrony: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  omacronyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  omacronydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  oslashv: [
    -20,
    -20,
    -70,
    -70,
    -10,
    -15,
    -10,
    -15
  ],
  oslashw: [
    -15,
    -15,
    -70,
    -70,
    -10,
    -25,
    0,
    -25
  ],
  oslashx: [
    -30,
    -30,
    -85,
    -85,
    0,
    -10
  ],
  oslashy: [
    -20,
    -20,
    -70,
    -70,
    0,
    -10,
    0,
    -10
  ],
  oslashyacute: [
    -20,
    -20,
    -70,
    -70,
    0,
    -10,
    0,
    -10
  ],
  oslashydieresis: [
    -20,
    -20,
    -70,
    -70,
    0,
    -10,
    0,
    -10
  ],
  otildev: [
    -20,
    -20,
    -15,
    -15,
    -10,
    -15,
    -10,
    -15
  ],
  otildew: [
    -15,
    -15,
    -15,
    -15,
    -10,
    -25,
    0,
    -25
  ],
  otildex: [
    -30,
    -30,
    -30,
    -30,
    0,
    -10
  ],
  otildey: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  otildeyacute: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  otildeydieresis: [
    -20,
    -20,
    -30,
    -30,
    0,
    -10,
    0,
    -10
  ],
  py: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  pyacute: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  pydieresis: [
    -15,
    -15,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  periodquotedblright: [
    -120,
    -120,
    -100,
    -100,
    -55,
    -95,
    -140,
    -70
  ],
  periodquoteright: [
    -120,
    -120,
    -100,
    -100,
    -55,
    -95,
    -140,
    -70
  ],
  periodspace: [
    -40,
    -40,
    -60,
    -60
  ],
  quotedblrightspace: [
    -80,
    -80,
    -40,
    -40
  ],
  quoteleftquoteleft: [
    -46,
    -46,
    -57,
    -57,
    -63,
    -74,
    -111,
    -74
  ],
  quoterightd: [
    -80,
    -80,
    -50,
    -50,
    -20,
    -15,
    -25,
    -50
  ],
  quoterightdcroat: [
    -80,
    -80,
    -50,
    -50,
    -20,
    -15,
    -25,
    -50
  ],
  quoterightl: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  quoterightlacute: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  quoterightlcommaaccent: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  quoterightlslash: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  quoterightquoteright: [
    -46,
    -46,
    -57,
    -57,
    -63,
    -74,
    -111,
    -74
  ],
  quoterightr: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -15,
    -25,
    -50
  ],
  quoterightracute: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -15,
    -25,
    -50
  ],
  quoterightrcaron: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -15,
    -25,
    -50
  ],
  quoterightrcommaaccent: [
    -40,
    -40,
    -50,
    -50,
    -20,
    -15,
    -25,
    -50
  ],
  quoterights: [
    -60,
    -60,
    -50,
    -50,
    -37,
    -74,
    -40,
    -55
  ],
  quoterightsacute: [
    -60,
    -60,
    -50,
    -50,
    -37,
    -74,
    -40,
    -55
  ],
  quoterightscaron: [
    -60,
    -60,
    -50,
    -50,
    -37,
    -74,
    -40,
    -55
  ],
  quoterightscedilla: [
    -60,
    -60,
    -50,
    -50,
    -37,
    -74,
    -40,
    -55
  ],
  quoterightscommaaccent: [
    -60,
    -60,
    -50,
    -50,
    -37,
    -74,
    -40,
    -55
  ],
  quoterightspace: [
    -80,
    -80,
    -70,
    -70,
    -74,
    -74,
    -111,
    -74
  ],
  quoterightv: [
    -20,
    -20,
    0,
    0,
    -20,
    -15,
    -10,
    -50
  ],
  rc: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rccaron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rccedilla: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcomma: [
    -60,
    -60,
    -50,
    -50,
    -92,
    -65,
    -111,
    -40
  ],
  rd: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  rdcroat: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  rg: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rgbreve: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rgcommaaccent: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rhyphen: [
    -20,
    -20,
    0,
    0,
    -37,
    0,
    -20,
    -20
  ],
  ro: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  roacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rocircumflex: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rodieresis: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rograve: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rohungarumlaut: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  romacron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  roslash: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rotilde: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rperiod: [
    -60,
    -60,
    -50,
    -50,
    -100,
    -65,
    -111,
    -55
  ],
  rq: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rs: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rsacute: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rscaron: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rscedilla: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rscommaaccent: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rt: [
    20,
    20,
    40,
    40
  ],
  rtcommaaccent: [
    20,
    20,
    40,
    40
  ],
  rv: [
    10,
    10,
    30,
    30,
    -10
  ],
  ry: [
    10,
    10,
    30,
    30
  ],
  ryacute: [
    10,
    10,
    30,
    30
  ],
  rydieresis: [
    10,
    10,
    30,
    30
  ],
  racutec: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  racutecacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteccaron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteccedilla: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  racutecomma: [
    -60,
    -60,
    -50,
    -50,
    -92,
    -65,
    -111,
    -40
  ],
  racuted: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  racutedcroat: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  racuteg: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  racutegbreve: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  racutegcommaaccent: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  racutehyphen: [
    -20,
    -20,
    0,
    0,
    -37,
    0,
    -20,
    -20
  ],
  racuteo: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteoacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteocircumflex: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteodieresis: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteograve: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteohungarumlaut: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteomacron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteoslash: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteotilde: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  racuteperiod: [
    -60,
    -60,
    -50,
    -50,
    -100,
    -65,
    -111,
    -55
  ],
  racuteq: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  racutes: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  racutesacute: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  racutescaron: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  racutescedilla: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  racutescommaaccent: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  racutet: [
    20,
    20,
    40,
    40
  ],
  racutetcommaaccent: [
    20,
    20,
    40,
    40
  ],
  racutev: [
    10,
    10,
    30,
    30,
    -10
  ],
  racutey: [
    10,
    10,
    30,
    30
  ],
  racuteyacute: [
    10,
    10,
    30,
    30
  ],
  racuteydieresis: [
    10,
    10,
    30,
    30
  ],
  rcaronc: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaroncacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronccaron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronccedilla: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaroncomma: [
    -60,
    -60,
    -50,
    -50,
    -92,
    -65,
    -111,
    -40
  ],
  rcarond: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  rcarondcroat: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  rcarong: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rcarongbreve: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rcarongcommaaccent: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rcaronhyphen: [
    -20,
    -20,
    0,
    0,
    -37,
    0,
    -20,
    -20
  ],
  rcarono: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronoacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronocircumflex: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronodieresis: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronograve: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronohungarumlaut: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronomacron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronoslash: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronotilde: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcaronperiod: [
    -60,
    -60,
    -50,
    -50,
    -100,
    -65,
    -111,
    -55
  ],
  rcaronq: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcarons: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcaronsacute: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcaronscaron: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcaronscedilla: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcaronscommaaccent: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcaront: [
    20,
    20,
    40,
    40
  ],
  rcarontcommaaccent: [
    20,
    20,
    40,
    40
  ],
  rcaronv: [
    10,
    10,
    30,
    30,
    -10
  ],
  rcarony: [
    10,
    10,
    30,
    30
  ],
  rcaronyacute: [
    10,
    10,
    30,
    30
  ],
  rcaronydieresis: [
    10,
    10,
    30,
    30
  ],
  rcommaaccentc: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentcacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentccaron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentccedilla: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentcomma: [
    -60,
    -60,
    -50,
    -50,
    -92,
    -65,
    -111,
    -40
  ],
  rcommaaccentd: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  rcommaaccentdcroat: [
    -20,
    -20,
    0,
    0,
    0,
    0,
    -37
  ],
  rcommaaccentg: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rcommaaccentgbreve: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rcommaaccentgcommaaccent: [
    -15,
    -15,
    0,
    0,
    -10,
    0,
    -37,
    -18
  ],
  rcommaaccenthyphen: [
    -20,
    -20,
    0,
    0,
    -37,
    0,
    -20,
    -20
  ],
  rcommaaccento: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentoacute: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentocircumflex: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentodieresis: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentograve: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentohungarumlaut: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentomacron: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentoslash: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentotilde: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -45
  ],
  rcommaaccentperiod: [
    -60,
    -60,
    -50,
    -50,
    -100,
    -65,
    -111,
    -55
  ],
  rcommaaccentq: [
    -20,
    -20,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccents: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcommaaccentsacute: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcommaaccentscaron: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcommaaccentscedilla: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcommaaccentscommaaccent: [
    -15,
    -15,
    0,
    0,
    0,
    0,
    -10
  ],
  rcommaaccentt: [
    20,
    20,
    40,
    40
  ],
  rcommaaccenttcommaaccent: [
    20,
    20,
    40,
    40
  ],
  rcommaaccentv: [
    10,
    10,
    30,
    30,
    -10
  ],
  rcommaaccenty: [
    10,
    10,
    30,
    30
  ],
  rcommaaccentyacute: [
    10,
    10,
    30,
    30
  ],
  rcommaaccentydieresis: [
    10,
    10,
    30,
    30
  ],
  sw: [
    -15,
    -15,
    -30,
    -30
  ],
  sacutew: [
    -15,
    -15,
    -30,
    -30
  ],
  scaronw: [
    -15,
    -15,
    -30,
    -30
  ],
  scedillaw: [
    -15,
    -15,
    -30,
    -30
  ],
  scommaaccentw: [
    -15,
    -15,
    -30,
    -30
  ],
  semicolonspace: [
    -40,
    -40,
    -50,
    -50
  ],
  spaceT: [
    -100,
    -100,
    -50,
    -50,
    -30,
    0,
    -18,
    -18
  ],
  spaceTcaron: [
    -100,
    -100,
    -50,
    -50,
    -30,
    0,
    -18,
    -18
  ],
  spaceTcommaaccent: [
    -100,
    -100,
    -50,
    -50,
    -30,
    0,
    -18,
    -18
  ],
  spaceV: [
    -80,
    -80,
    -50,
    -50,
    -45,
    -70,
    -35,
    -50
  ],
  spaceW: [
    -80,
    -80,
    -40,
    -40,
    -30,
    -70,
    -40,
    -30
  ],
  spaceY: [
    -120,
    -120,
    -90,
    -90,
    -55,
    -70,
    -75,
    -90
  ],
  spaceYacute: [
    -120,
    -120,
    -90,
    -90,
    -55,
    -70,
    -75,
    -90
  ],
  spaceYdieresis: [
    -120,
    -120,
    -90,
    -90,
    -55,
    -70,
    -75,
    -90
  ],
  spacequotedblleft: [
    -80,
    -80,
    -30,
    -30
  ],
  spacequoteleft: [
    -60,
    -60,
    -60,
    -60
  ],
  va: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vaacute: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vabreve: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vacircumflex: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vadieresis: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vagrave: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vamacron: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vaogonek: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  varing: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vatilde: [
    -20,
    -20,
    -25,
    -25,
    -10,
    0,
    0,
    -25
  ],
  vcomma: [
    -80,
    -80,
    -80,
    -80,
    -55,
    -37,
    -74,
    -65
  ],
  vo: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  voacute: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  vocircumflex: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  vodieresis: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  vograve: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  vohungarumlaut: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  vomacron: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  voslash: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  votilde: [
    -30,
    -30,
    -25,
    -25,
    -10,
    -15,
    0,
    -20
  ],
  vperiod: [
    -80,
    -80,
    -80,
    -80,
    -70,
    -37,
    -74,
    -65
  ],
  wcomma: [
    -40,
    -40,
    -60,
    -60,
    -55,
    -37,
    -74,
    -65
  ],
  wo: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  woacute: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  wocircumflex: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  wodieresis: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  wograve: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  wohungarumlaut: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  womacron: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  woslash: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  wotilde: [
    -20,
    -20,
    -10,
    -10,
    -10,
    -15,
    0,
    -10
  ],
  wperiod: [
    -40,
    -40,
    -60,
    -60,
    -70,
    -37,
    -74,
    -65
  ],
  xe: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xeacute: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xecaron: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xecircumflex: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xedieresis: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xedotaccent: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xegrave: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xemacron: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  xeogonek: [
    -10,
    -10,
    -30,
    -30,
    0,
    -10,
    0,
    -15
  ],
  ya: [
    -30,
    -30,
    -20,
    -20
  ],
  yaacute: [
    -30,
    -30,
    -20,
    -20
  ],
  yabreve: [
    -30,
    -30,
    -20,
    -20
  ],
  yacircumflex: [
    -30,
    -30,
    -20,
    -20
  ],
  yadieresis: [
    -30,
    -30,
    -20,
    -20
  ],
  yagrave: [
    -30,
    -30,
    -20,
    -20
  ],
  yamacron: [
    -30,
    -30,
    -20,
    -20
  ],
  yaogonek: [
    -30,
    -30,
    -20,
    -20
  ],
  yaring: [
    -30,
    -30,
    -20,
    -20
  ],
  yatilde: [
    -30,
    -30,
    -20,
    -20
  ],
  ycomma: [
    -80,
    -80,
    -100,
    -100,
    -55,
    -37,
    -55,
    -65
  ],
  ye: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yeacute: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yecaron: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yecircumflex: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yedieresis: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yedotaccent: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yegrave: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yemacron: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yeogonek: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yo: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yoacute: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yocircumflex: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yodieresis: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yograve: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yohungarumlaut: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yomacron: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yoslash: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yotilde: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yperiod: [
    -80,
    -80,
    -100,
    -100,
    -70,
    -37,
    -55,
    -65
  ],
  yacutea: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteaacute: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteabreve: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteacircumflex: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteadieresis: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteagrave: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteamacron: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteaogonek: [
    -30,
    -30,
    -20,
    -20
  ],
  yacutearing: [
    -30,
    -30,
    -20,
    -20
  ],
  yacuteatilde: [
    -30,
    -30,
    -20,
    -20
  ],
  yacutecomma: [
    -80,
    -80,
    -100,
    -100,
    -55,
    -37,
    -55,
    -65
  ],
  yacutee: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteeacute: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteecaron: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteecircumflex: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteedieresis: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteedotaccent: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteegrave: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteemacron: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteeogonek: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  yacuteo: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteoacute: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteocircumflex: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteodieresis: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteograve: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteohungarumlaut: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteomacron: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteoslash: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteotilde: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  yacuteperiod: [
    -80,
    -80,
    -100,
    -100,
    -70,
    -37,
    -55,
    -65
  ],
  ydieresisa: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisaacute: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisabreve: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisacircumflex: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisadieresis: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisagrave: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisamacron: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisaogonek: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisaring: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresisatilde: [
    -30,
    -30,
    -20,
    -20
  ],
  ydieresiscomma: [
    -80,
    -80,
    -100,
    -100,
    -55,
    -37,
    -55,
    -65
  ],
  ydieresise: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresiseacute: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresisecaron: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresisecircumflex: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresisedieresis: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresisedotaccent: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresisegrave: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresisemacron: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresiseogonek: [
    -10,
    -10,
    -20,
    -20,
    -10
  ],
  ydieresiso: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisoacute: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisocircumflex: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisodieresis: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisograve: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisohungarumlaut: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisomacron: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisoslash: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisotilde: [
    -25,
    -25,
    -20,
    -20,
    -25
  ],
  ydieresisperiod: [
    -80,
    -80,
    -100,
    -100,
    -70,
    -37,
    -55,
    -65
  ],
  ze: [
    10,
    10,
    -15,
    -15
  ],
  zeacute: [
    10,
    10,
    -15,
    -15
  ],
  zecaron: [
    10,
    10,
    -15,
    -15
  ],
  zecircumflex: [
    10,
    10,
    -15,
    -15
  ],
  zedieresis: [
    10,
    10,
    -15,
    -15
  ],
  zedotaccent: [
    10,
    10,
    -15,
    -15
  ],
  zegrave: [
    10,
    10,
    -15,
    -15
  ],
  zemacron: [
    10,
    10,
    -15,
    -15
  ],
  zeogonek: [
    10,
    10,
    -15,
    -15
  ],
  zacutee: [
    10,
    10,
    -15,
    -15
  ],
  zacuteeacute: [
    10,
    10,
    -15,
    -15
  ],
  zacuteecaron: [
    10,
    10,
    -15,
    -15
  ],
  zacuteecircumflex: [
    10,
    10,
    -15,
    -15
  ],
  zacuteedieresis: [
    10,
    10,
    -15,
    -15
  ],
  zacuteedotaccent: [
    10,
    10,
    -15,
    -15
  ],
  zacuteegrave: [
    10,
    10,
    -15,
    -15
  ],
  zacuteemacron: [
    10,
    10,
    -15,
    -15
  ],
  zacuteeogonek: [
    10,
    10,
    -15,
    -15
  ],
  zcarone: [
    10,
    10,
    -15,
    -15
  ],
  zcaroneacute: [
    10,
    10,
    -15,
    -15
  ],
  zcaronecaron: [
    10,
    10,
    -15,
    -15
  ],
  zcaronecircumflex: [
    10,
    10,
    -15,
    -15
  ],
  zcaronedieresis: [
    10,
    10,
    -15,
    -15
  ],
  zcaronedotaccent: [
    10,
    10,
    -15,
    -15
  ],
  zcaronegrave: [
    10,
    10,
    -15,
    -15
  ],
  zcaronemacron: [
    10,
    10,
    -15,
    -15
  ],
  zcaroneogonek: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccente: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccenteacute: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccentecaron: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccentecircumflex: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccentedieresis: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccentedotaccent: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccentegrave: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccentemacron: [
    10,
    10,
    -15,
    -15
  ],
  zdotaccenteogonek: [
    10,
    10,
    -15,
    -15
  ],
  Bcomma: [
    0,
    0,
    -20,
    -20
  ],
  Bperiod: [
    0,
    0,
    -20,
    -20
  ],
  Ccomma: [
    0,
    0,
    -30,
    -30
  ],
  Cperiod: [
    0,
    0,
    -30,
    -30
  ],
  Cacutecomma: [
    0,
    0,
    -30,
    -30
  ],
  Cacuteperiod: [
    0,
    0,
    -30,
    -30
  ],
  Ccaroncomma: [
    0,
    0,
    -30,
    -30
  ],
  Ccaronperiod: [
    0,
    0,
    -30,
    -30
  ],
  Ccedillacomma: [
    0,
    0,
    -30,
    -30
  ],
  Ccedillaperiod: [
    0,
    0,
    -30,
    -30
  ],
  Fe: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Feacute: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Fecaron: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Fecircumflex: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Fedieresis: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Fedotaccent: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Fegrave: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Femacron: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Feogonek: [
    0,
    0,
    -30,
    -30,
    -25,
    -100,
    -75
  ],
  Fo: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Foacute: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Focircumflex: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Fodieresis: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Fograve: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Fohungarumlaut: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Fomacron: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Foslash: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Fotilde: [
    0,
    0,
    -30,
    -30,
    -25,
    -70,
    -105,
    -15
  ],
  Fr: [
    0,
    0,
    -45,
    -45,
    0,
    -50,
    -55
  ],
  Fracute: [
    0,
    0,
    -45,
    -45,
    0,
    -50,
    -55
  ],
  Frcaron: [
    0,
    0,
    -45,
    -45,
    0,
    -50,
    -55
  ],
  Frcommaaccent: [
    0,
    0,
    -45,
    -45,
    0,
    -50,
    -55
  ],
  Ja: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jaacute: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jabreve: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jacircumflex: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jadieresis: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jagrave: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jamacron: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jaogonek: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jaring: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  Jatilde: [
    0,
    0,
    -20,
    -20,
    -15,
    -40,
    -35
  ],
  LcaronT: [
    0,
    0,
    -110,
    -110
  ],
  LcaronTcaron: [
    0,
    0,
    -110,
    -110
  ],
  LcaronTcommaaccent: [
    0,
    0,
    -110,
    -110
  ],
  LcaronV: [
    0,
    0,
    -110,
    -110
  ],
  LcaronW: [
    0,
    0,
    -70,
    -70
  ],
  LcaronY: [
    0,
    0,
    -140,
    -140
  ],
  LcaronYacute: [
    0,
    0,
    -140,
    -140
  ],
  LcaronYdieresis: [
    0,
    0,
    -140,
    -140
  ],
  Lcaronquotedblright: [
    0,
    0,
    -140,
    -140
  ],
  Lcaronquoteright: [
    0,
    0,
    -160,
    -160,
    0,
    0,
    0,
    -92
  ],
  Lcarony: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -55
  ],
  Lcaronyacute: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -55
  ],
  Lcaronydieresis: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -55
  ],
  Scomma: [
    0,
    0,
    -20,
    -20
  ],
  Speriod: [
    0,
    0,
    -20,
    -20
  ],
  Sacutecomma: [
    0,
    0,
    -20,
    -20
  ],
  Sacuteperiod: [
    0,
    0,
    -20,
    -20
  ],
  Scaroncomma: [
    0,
    0,
    -20,
    -20
  ],
  Scaronperiod: [
    0,
    0,
    -20,
    -20
  ],
  Scedillacomma: [
    0,
    0,
    -20,
    -20
  ],
  Scedillaperiod: [
    0,
    0,
    -20,
    -20
  ],
  Scommaaccentcomma: [
    0,
    0,
    -20,
    -20
  ],
  Scommaaccentperiod: [
    0,
    0,
    -20,
    -20
  ],
  Trcaron: [
    0,
    0,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcaronrcaron: [
    0,
    0,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Tcommaaccentrcaron: [
    0,
    0,
    -120,
    -120,
    -74,
    -37,
    -55,
    -35
  ],
  Yhyphen: [
    0,
    0,
    -140,
    -140,
    -92,
    -92,
    -74,
    -111
  ],
  Yi: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Yiacute: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Yiogonek: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Yacutehyphen: [
    0,
    0,
    -140,
    -140,
    -92,
    -92,
    -74,
    -111
  ],
  Yacutei: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Yacuteiacute: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Yacuteiogonek: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Ydieresishyphen: [
    0,
    0,
    -140,
    -140,
    -92,
    -92,
    -74,
    -111
  ],
  Ydieresisi: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Ydieresisiacute: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  Ydieresisiogonek: [
    0,
    0,
    -20,
    -20,
    -37,
    -55,
    -74,
    -55
  ],
  bb: [
    0,
    0,
    -10,
    -10,
    -10,
    -10
  ],
  bcomma: [
    0,
    0,
    -40,
    -40
  ],
  bperiod: [
    0,
    0,
    -40,
    -40,
    -40,
    -40,
    -40,
    -40
  ],
  ccomma: [
    0,
    0,
    -15,
    -15
  ],
  cacutecomma: [
    0,
    0,
    -15,
    -15
  ],
  ccaroncomma: [
    0,
    0,
    -15,
    -15
  ],
  ccedillacomma: [
    0,
    0,
    -15,
    -15
  ],
  fa: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  faacute: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  fabreve: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  facircumflex: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  fadieresis: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  fagrave: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  famacron: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  faogonek: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  faring: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  fatilde: [
    0,
    0,
    -30,
    -30,
    0,
    0,
    0,
    -10
  ],
  fdotlessi: [
    0,
    0,
    -28,
    -28,
    -35,
    -30,
    -60,
    -50
  ],
  gr: [
    0,
    0,
    -10,
    -10
  ],
  gracute: [
    0,
    0,
    -10,
    -10
  ],
  grcaron: [
    0,
    0,
    -10,
    -10
  ],
  grcommaaccent: [
    0,
    0,
    -10,
    -10
  ],
  gbrever: [
    0,
    0,
    -10,
    -10
  ],
  gbreveracute: [
    0,
    0,
    -10,
    -10
  ],
  gbrevercaron: [
    0,
    0,
    -10,
    -10
  ],
  gbrevercommaaccent: [
    0,
    0,
    -10,
    -10
  ],
  gcommaaccentr: [
    0,
    0,
    -10,
    -10
  ],
  gcommaaccentracute: [
    0,
    0,
    -10,
    -10
  ],
  gcommaaccentrcaron: [
    0,
    0,
    -10,
    -10
  ],
  gcommaaccentrcommaaccent: [
    0,
    0,
    -10,
    -10
  ],
  ke: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  keacute: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kecaron: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kecircumflex: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kedieresis: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kedotaccent: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kegrave: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kemacron: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  keogonek: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccente: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccenteacute: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccentecaron: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccentecircumflex: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccentedieresis: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccentedotaccent: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccentegrave: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccentemacron: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  kcommaaccenteogonek: [
    0,
    0,
    -20,
    -20,
    -10,
    -30,
    -10,
    -10
  ],
  ocomma: [
    0,
    0,
    -40,
    -40
  ],
  operiod: [
    0,
    0,
    -40,
    -40
  ],
  oacutecomma: [
    0,
    0,
    -40,
    -40
  ],
  oacuteperiod: [
    0,
    0,
    -40,
    -40
  ],
  ocircumflexcomma: [
    0,
    0,
    -40,
    -40
  ],
  ocircumflexperiod: [
    0,
    0,
    -40,
    -40
  ],
  odieresiscomma: [
    0,
    0,
    -40,
    -40
  ],
  odieresisperiod: [
    0,
    0,
    -40,
    -40
  ],
  ogravecomma: [
    0,
    0,
    -40,
    -40
  ],
  ograveperiod: [
    0,
    0,
    -40,
    -40
  ],
  ohungarumlautcomma: [
    0,
    0,
    -40,
    -40
  ],
  ohungarumlautperiod: [
    0,
    0,
    -40,
    -40
  ],
  omacroncomma: [
    0,
    0,
    -40,
    -40
  ],
  omacronperiod: [
    0,
    0,
    -40,
    -40
  ],
  oslasha: [
    0,
    0,
    -55,
    -55
  ],
  oslashaacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashabreve: [
    0,
    0,
    -55,
    -55
  ],
  oslashacircumflex: [
    0,
    0,
    -55,
    -55
  ],
  oslashadieresis: [
    0,
    0,
    -55,
    -55
  ],
  oslashagrave: [
    0,
    0,
    -55,
    -55
  ],
  oslashamacron: [
    0,
    0,
    -55,
    -55
  ],
  oslashaogonek: [
    0,
    0,
    -55,
    -55
  ],
  oslasharing: [
    0,
    0,
    -55,
    -55
  ],
  oslashatilde: [
    0,
    0,
    -55,
    -55
  ],
  oslashb: [
    0,
    0,
    -55,
    -55
  ],
  oslashc: [
    0,
    0,
    -55,
    -55
  ],
  oslashcacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashccaron: [
    0,
    0,
    -55,
    -55
  ],
  oslashccedilla: [
    0,
    0,
    -55,
    -55
  ],
  oslashcomma: [
    0,
    0,
    -95,
    -95
  ],
  oslashd: [
    0,
    0,
    -55,
    -55
  ],
  oslashdcroat: [
    0,
    0,
    -55,
    -55
  ],
  oslashe: [
    0,
    0,
    -55,
    -55
  ],
  oslasheacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashecaron: [
    0,
    0,
    -55,
    -55
  ],
  oslashecircumflex: [
    0,
    0,
    -55,
    -55
  ],
  oslashedieresis: [
    0,
    0,
    -55,
    -55
  ],
  oslashedotaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslashegrave: [
    0,
    0,
    -55,
    -55
  ],
  oslashemacron: [
    0,
    0,
    -55,
    -55
  ],
  oslasheogonek: [
    0,
    0,
    -55,
    -55
  ],
  oslashf: [
    0,
    0,
    -55,
    -55
  ],
  oslashg: [
    0,
    0,
    -55,
    -55,
    0,
    0,
    -10
  ],
  oslashgbreve: [
    0,
    0,
    -55,
    -55,
    0,
    0,
    -10
  ],
  oslashgcommaaccent: [
    0,
    0,
    -55,
    -55,
    0,
    0,
    -10
  ],
  oslashh: [
    0,
    0,
    -55,
    -55
  ],
  oslashi: [
    0,
    0,
    -55,
    -55
  ],
  oslashiacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashicircumflex: [
    0,
    0,
    -55,
    -55
  ],
  oslashidieresis: [
    0,
    0,
    -55,
    -55
  ],
  oslashigrave: [
    0,
    0,
    -55,
    -55
  ],
  oslashimacron: [
    0,
    0,
    -55,
    -55
  ],
  oslashiogonek: [
    0,
    0,
    -55,
    -55
  ],
  oslashj: [
    0,
    0,
    -55,
    -55
  ],
  oslashk: [
    0,
    0,
    -55,
    -55
  ],
  oslashkcommaaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslashl: [
    0,
    0,
    -55,
    -55
  ],
  oslashlacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashlcommaaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslashlslash: [
    0,
    0,
    -55,
    -55
  ],
  oslashm: [
    0,
    0,
    -55,
    -55
  ],
  oslashn: [
    0,
    0,
    -55,
    -55
  ],
  oslashnacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashncaron: [
    0,
    0,
    -55,
    -55
  ],
  oslashncommaaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslashntilde: [
    0,
    0,
    -55,
    -55
  ],
  oslasho: [
    0,
    0,
    -55,
    -55
  ],
  oslashoacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashocircumflex: [
    0,
    0,
    -55,
    -55
  ],
  oslashodieresis: [
    0,
    0,
    -55,
    -55
  ],
  oslashograve: [
    0,
    0,
    -55,
    -55
  ],
  oslashohungarumlaut: [
    0,
    0,
    -55,
    -55
  ],
  oslashomacron: [
    0,
    0,
    -55,
    -55
  ],
  oslashoslash: [
    0,
    0,
    -55,
    -55
  ],
  oslashotilde: [
    0,
    0,
    -55,
    -55
  ],
  oslashp: [
    0,
    0,
    -55,
    -55
  ],
  oslashperiod: [
    0,
    0,
    -95,
    -95
  ],
  oslashq: [
    0,
    0,
    -55,
    -55
  ],
  oslashr: [
    0,
    0,
    -55,
    -55
  ],
  oslashracute: [
    0,
    0,
    -55,
    -55
  ],
  oslashrcaron: [
    0,
    0,
    -55,
    -55
  ],
  oslashrcommaaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslashs: [
    0,
    0,
    -55,
    -55
  ],
  oslashsacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashscaron: [
    0,
    0,
    -55,
    -55
  ],
  oslashscedilla: [
    0,
    0,
    -55,
    -55
  ],
  oslashscommaaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslasht: [
    0,
    0,
    -55,
    -55
  ],
  oslashtcommaaccent: [
    0,
    0,
    -55,
    -55
  ],
  oslashu: [
    0,
    0,
    -55,
    -55
  ],
  oslashuacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashucircumflex: [
    0,
    0,
    -55,
    -55
  ],
  oslashudieresis: [
    0,
    0,
    -55,
    -55
  ],
  oslashugrave: [
    0,
    0,
    -55,
    -55
  ],
  oslashuhungarumlaut: [
    0,
    0,
    -55,
    -55
  ],
  oslashumacron: [
    0,
    0,
    -55,
    -55
  ],
  oslashuogonek: [
    0,
    0,
    -55,
    -55
  ],
  oslashuring: [
    0,
    0,
    -55,
    -55
  ],
  oslashz: [
    0,
    0,
    -55,
    -55
  ],
  oslashzacute: [
    0,
    0,
    -55,
    -55
  ],
  oslashzcaron: [
    0,
    0,
    -55,
    -55
  ],
  oslashzdotaccent: [
    0,
    0,
    -55,
    -55
  ],
  otildecomma: [
    0,
    0,
    -40,
    -40
  ],
  otildeperiod: [
    0,
    0,
    -40,
    -40
  ],
  pcomma: [
    0,
    0,
    -35,
    -35
  ],
  pperiod: [
    0,
    0,
    -35,
    -35
  ],
  ra: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  raacute: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rabreve: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racircumflex: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  radieresis: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  ragrave: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  ramacron: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  raogonek: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  raring: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  ratilde: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcolon: [
    0,
    0,
    30,
    30
  ],
  ri: [
    0,
    0,
    15,
    15
  ],
  riacute: [
    0,
    0,
    15,
    15
  ],
  ricircumflex: [
    0,
    0,
    15,
    15
  ],
  ridieresis: [
    0,
    0,
    15,
    15
  ],
  rigrave: [
    0,
    0,
    15,
    15
  ],
  rimacron: [
    0,
    0,
    15,
    15
  ],
  riogonek: [
    0,
    0,
    15,
    15
  ],
  rk: [
    0,
    0,
    15,
    15
  ],
  rkcommaaccent: [
    0,
    0,
    15,
    15
  ],
  rl: [
    0,
    0,
    15,
    15
  ],
  rlacute: [
    0,
    0,
    15,
    15
  ],
  rlcommaaccent: [
    0,
    0,
    15,
    15
  ],
  rlslash: [
    0,
    0,
    15,
    15
  ],
  rm: [
    0,
    0,
    25,
    25
  ],
  rn: [
    0,
    0,
    25,
    25,
    -15
  ],
  rnacute: [
    0,
    0,
    25,
    25,
    -15
  ],
  rncaron: [
    0,
    0,
    25,
    25,
    -15
  ],
  rncommaaccent: [
    0,
    0,
    25,
    25,
    -15
  ],
  rntilde: [
    0,
    0,
    25,
    25,
    -15
  ],
  rp: [
    0,
    0,
    30,
    30,
    -10
  ],
  rsemicolon: [
    0,
    0,
    30,
    30
  ],
  ru: [
    0,
    0,
    15,
    15
  ],
  ruacute: [
    0,
    0,
    15,
    15
  ],
  rucircumflex: [
    0,
    0,
    15,
    15
  ],
  rudieresis: [
    0,
    0,
    15,
    15
  ],
  rugrave: [
    0,
    0,
    15,
    15
  ],
  ruhungarumlaut: [
    0,
    0,
    15,
    15
  ],
  rumacron: [
    0,
    0,
    15,
    15
  ],
  ruogonek: [
    0,
    0,
    15,
    15
  ],
  ruring: [
    0,
    0,
    15,
    15
  ],
  racutea: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteaacute: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteabreve: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteacircumflex: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteadieresis: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteagrave: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteamacron: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteaogonek: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racutearing: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racuteatilde: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  racutecolon: [
    0,
    0,
    30,
    30
  ],
  racutei: [
    0,
    0,
    15,
    15
  ],
  racuteiacute: [
    0,
    0,
    15,
    15
  ],
  racuteicircumflex: [
    0,
    0,
    15,
    15
  ],
  racuteidieresis: [
    0,
    0,
    15,
    15
  ],
  racuteigrave: [
    0,
    0,
    15,
    15
  ],
  racuteimacron: [
    0,
    0,
    15,
    15
  ],
  racuteiogonek: [
    0,
    0,
    15,
    15
  ],
  racutek: [
    0,
    0,
    15,
    15
  ],
  racutekcommaaccent: [
    0,
    0,
    15,
    15
  ],
  racutel: [
    0,
    0,
    15,
    15
  ],
  racutelacute: [
    0,
    0,
    15,
    15
  ],
  racutelcommaaccent: [
    0,
    0,
    15,
    15
  ],
  racutelslash: [
    0,
    0,
    15,
    15
  ],
  racutem: [
    0,
    0,
    25,
    25
  ],
  racuten: [
    0,
    0,
    25,
    25,
    -15
  ],
  racutenacute: [
    0,
    0,
    25,
    25,
    -15
  ],
  racutencaron: [
    0,
    0,
    25,
    25,
    -15
  ],
  racutencommaaccent: [
    0,
    0,
    25,
    25,
    -15
  ],
  racutentilde: [
    0,
    0,
    25,
    25,
    -15
  ],
  racutep: [
    0,
    0,
    30,
    30,
    -10
  ],
  racutesemicolon: [
    0,
    0,
    30,
    30
  ],
  racuteu: [
    0,
    0,
    15,
    15
  ],
  racuteuacute: [
    0,
    0,
    15,
    15
  ],
  racuteucircumflex: [
    0,
    0,
    15,
    15
  ],
  racuteudieresis: [
    0,
    0,
    15,
    15
  ],
  racuteugrave: [
    0,
    0,
    15,
    15
  ],
  racuteuhungarumlaut: [
    0,
    0,
    15,
    15
  ],
  racuteumacron: [
    0,
    0,
    15,
    15
  ],
  racuteuogonek: [
    0,
    0,
    15,
    15
  ],
  racuteuring: [
    0,
    0,
    15,
    15
  ],
  rcarona: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronaacute: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronabreve: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronacircumflex: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronadieresis: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronagrave: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronamacron: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronaogonek: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronaring: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaronatilde: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcaroncolon: [
    0,
    0,
    30,
    30
  ],
  rcaroni: [
    0,
    0,
    15,
    15
  ],
  rcaroniacute: [
    0,
    0,
    15,
    15
  ],
  rcaronicircumflex: [
    0,
    0,
    15,
    15
  ],
  rcaronidieresis: [
    0,
    0,
    15,
    15
  ],
  rcaronigrave: [
    0,
    0,
    15,
    15
  ],
  rcaronimacron: [
    0,
    0,
    15,
    15
  ],
  rcaroniogonek: [
    0,
    0,
    15,
    15
  ],
  rcaronk: [
    0,
    0,
    15,
    15
  ],
  rcaronkcommaaccent: [
    0,
    0,
    15,
    15
  ],
  rcaronl: [
    0,
    0,
    15,
    15
  ],
  rcaronlacute: [
    0,
    0,
    15,
    15
  ],
  rcaronlcommaaccent: [
    0,
    0,
    15,
    15
  ],
  rcaronlslash: [
    0,
    0,
    15,
    15
  ],
  rcaronm: [
    0,
    0,
    25,
    25
  ],
  rcaronn: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcaronnacute: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcaronncaron: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcaronncommaaccent: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcaronntilde: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcaronp: [
    0,
    0,
    30,
    30,
    -10
  ],
  rcaronsemicolon: [
    0,
    0,
    30,
    30
  ],
  rcaronu: [
    0,
    0,
    15,
    15
  ],
  rcaronuacute: [
    0,
    0,
    15,
    15
  ],
  rcaronucircumflex: [
    0,
    0,
    15,
    15
  ],
  rcaronudieresis: [
    0,
    0,
    15,
    15
  ],
  rcaronugrave: [
    0,
    0,
    15,
    15
  ],
  rcaronuhungarumlaut: [
    0,
    0,
    15,
    15
  ],
  rcaronumacron: [
    0,
    0,
    15,
    15
  ],
  rcaronuogonek: [
    0,
    0,
    15,
    15
  ],
  rcaronuring: [
    0,
    0,
    15,
    15
  ],
  rcommaaccenta: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentaacute: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentabreve: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentacircumflex: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentadieresis: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentagrave: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentamacron: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentaogonek: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentaring: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentatilde: [
    0,
    0,
    -10,
    -10,
    0,
    0,
    -15
  ],
  rcommaaccentcolon: [
    0,
    0,
    30,
    30
  ],
  rcommaaccenti: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentiacute: [
    0,
    0,
    15,
    15
  ],
  rcommaaccenticircumflex: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentidieresis: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentigrave: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentimacron: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentiogonek: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentk: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentkcommaaccent: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentl: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentlacute: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentlcommaaccent: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentlslash: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentm: [
    0,
    0,
    25,
    25
  ],
  rcommaaccentn: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcommaaccentnacute: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcommaaccentncaron: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcommaaccentncommaaccent: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcommaaccentntilde: [
    0,
    0,
    25,
    25,
    -15
  ],
  rcommaaccentp: [
    0,
    0,
    30,
    30,
    -10
  ],
  rcommaaccentsemicolon: [
    0,
    0,
    30,
    30
  ],
  rcommaaccentu: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentuacute: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentucircumflex: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentudieresis: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentugrave: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentuhungarumlaut: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentumacron: [
    0,
    0,
    15,
    15
  ],
  rcommaaccentuogonek: [
    0,
    0,
    15,
    15
  ],
  rcommaaccenturing: [
    0,
    0,
    15,
    15
  ],
  scomma: [
    0,
    0,
    -15,
    -15
  ],
  speriod: [
    0,
    0,
    -15,
    -15
  ],
  sacutecomma: [
    0,
    0,
    -15,
    -15
  ],
  sacuteperiod: [
    0,
    0,
    -15,
    -15
  ],
  scaroncomma: [
    0,
    0,
    -15,
    -15
  ],
  scaronperiod: [
    0,
    0,
    -15,
    -15
  ],
  scedillacomma: [
    0,
    0,
    -15,
    -15
  ],
  scedillaperiod: [
    0,
    0,
    -15,
    -15
  ],
  scommaaccentcomma: [
    0,
    0,
    -15,
    -15
  ],
  scommaaccentperiod: [
    0,
    0,
    -15,
    -15
  ],
  ve: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  veacute: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  vecaron: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  vecircumflex: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  vedieresis: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  vedotaccent: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  vegrave: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  vemacron: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  veogonek: [
    0,
    0,
    -25,
    -25,
    -10,
    -15,
    0,
    -15
  ],
  wa: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  waacute: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  wabreve: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  wacircumflex: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  wadieresis: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  wagrave: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  wamacron: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  waogonek: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  waring: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  watilde: [
    0,
    0,
    -15,
    -15,
    0,
    -10,
    0,
    -10
  ],
  we: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  weacute: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  wecaron: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  wecircumflex: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  wedieresis: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  wedotaccent: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  wegrave: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  wemacron: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  weogonek: [
    0,
    0,
    -10,
    -10,
    0,
    -10
  ],
  zo: [
    0,
    0,
    -15,
    -15
  ],
  zoacute: [
    0,
    0,
    -15,
    -15
  ],
  zocircumflex: [
    0,
    0,
    -15,
    -15
  ],
  zodieresis: [
    0,
    0,
    -15,
    -15
  ],
  zograve: [
    0,
    0,
    -15,
    -15
  ],
  zohungarumlaut: [
    0,
    0,
    -15,
    -15
  ],
  zomacron: [
    0,
    0,
    -15,
    -15
  ],
  zoslash: [
    0,
    0,
    -15,
    -15
  ],
  zotilde: [
    0,
    0,
    -15,
    -15
  ],
  zacuteo: [
    0,
    0,
    -15,
    -15
  ],
  zacuteoacute: [
    0,
    0,
    -15,
    -15
  ],
  zacuteocircumflex: [
    0,
    0,
    -15,
    -15
  ],
  zacuteodieresis: [
    0,
    0,
    -15,
    -15
  ],
  zacuteograve: [
    0,
    0,
    -15,
    -15
  ],
  zacuteohungarumlaut: [
    0,
    0,
    -15,
    -15
  ],
  zacuteomacron: [
    0,
    0,
    -15,
    -15
  ],
  zacuteoslash: [
    0,
    0,
    -15,
    -15
  ],
  zacuteotilde: [
    0,
    0,
    -15,
    -15
  ],
  zcarono: [
    0,
    0,
    -15,
    -15
  ],
  zcaronoacute: [
    0,
    0,
    -15,
    -15
  ],
  zcaronocircumflex: [
    0,
    0,
    -15,
    -15
  ],
  zcaronodieresis: [
    0,
    0,
    -15,
    -15
  ],
  zcaronograve: [
    0,
    0,
    -15,
    -15
  ],
  zcaronohungarumlaut: [
    0,
    0,
    -15,
    -15
  ],
  zcaronomacron: [
    0,
    0,
    -15,
    -15
  ],
  zcaronoslash: [
    0,
    0,
    -15,
    -15
  ],
  zcaronotilde: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccento: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentoacute: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentocircumflex: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentodieresis: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentograve: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentohungarumlaut: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentomacron: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentoslash: [
    0,
    0,
    -15,
    -15
  ],
  zdotaccentotilde: [
    0,
    0,
    -15,
    -15
  ],
  Ap: [
    0,
    0,
    0,
    0,
    -25
  ],
  Aquoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Aacutep: [
    0,
    0,
    0,
    0,
    -25
  ],
  Aacutequoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Abrevep: [
    0,
    0,
    0,
    0,
    -25
  ],
  Abrevequoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Acircumflexp: [
    0,
    0,
    0,
    0,
    -25
  ],
  Acircumflexquoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Adieresisp: [
    0,
    0,
    0,
    0,
    -25
  ],
  Adieresisquoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Agravep: [
    0,
    0,
    0,
    0,
    -25
  ],
  Agravequoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Amacronp: [
    0,
    0,
    0,
    0,
    -25
  ],
  Amacronquoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Aogonekp: [
    0,
    0,
    0,
    0,
    -25
  ],
  Aogonekquoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Aringp: [
    0,
    0,
    0,
    0,
    -25
  ],
  Aringquoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Atildep: [
    0,
    0,
    0,
    0,
    -25
  ],
  Atildequoteright: [
    0,
    0,
    0,
    0,
    -74,
    -74,
    -37,
    -111
  ],
  Je: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jeacute: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jecaron: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jecircumflex: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jedieresis: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jedotaccent: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jegrave: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jemacron: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jeogonek: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jo: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Joacute: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jocircumflex: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jodieresis: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jograve: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Johungarumlaut: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jomacron: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Joslash: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  Jotilde: [
    0,
    0,
    0,
    0,
    -15,
    -40,
    -25
  ],
  NA: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAacute: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAbreve: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAcircumflex: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAdieresis: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAgrave: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAmacron: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAogonek: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAring: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NAtilde: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteA: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAacute: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAbreve: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAcircumflex: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAdieresis: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAgrave: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAmacron: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAogonek: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAring: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NacuteAtilde: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronA: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAacute: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAbreve: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAcircumflex: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAdieresis: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAgrave: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAmacron: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAogonek: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAring: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcaronAtilde: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentA: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAacute: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAbreve: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAcircumflex: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAdieresis: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAgrave: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAmacron: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAogonek: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAring: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NcommaaccentAtilde: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeA: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAacute: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAbreve: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAcircumflex: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAdieresis: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAgrave: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAmacron: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAogonek: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAring: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  NtildeAtilde: [
    0,
    0,
    0,
    0,
    -20,
    -30,
    -27,
    -35
  ],
  Ti: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tiacute: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tiogonek: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tcaroni: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tcaroniacute: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tcaroniogonek: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tcommaaccenti: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tcommaaccentiacute: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Tcommaaccentiogonek: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -35
  ],
  Vi: [
    0,
    0,
    0,
    0,
    -37,
    -55,
    -74,
    -60
  ],
  Viacute: [
    0,
    0,
    0,
    0,
    -37,
    -55,
    -74,
    -60
  ],
  Vicircumflex: [
    0,
    0,
    0,
    0,
    -37,
    0,
    -34,
    -20
  ],
  Vidieresis: [
    0,
    0,
    0,
    0,
    -37,
    0,
    -34,
    -20
  ],
  Vigrave: [
    0,
    0,
    0,
    0,
    -37,
    0,
    -34,
    -20
  ],
  Vimacron: [
    0,
    0,
    0,
    0,
    -37,
    0,
    -34,
    -20
  ],
  Viogonek: [
    0,
    0,
    0,
    0,
    -37,
    -55,
    -74,
    -60
  ],
  Wi: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -40
  ],
  Wiacute: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -40
  ],
  Wiogonek: [
    0,
    0,
    0,
    0,
    -18,
    -37,
    -55,
    -40
  ],
  fi: [
    0,
    0,
    0,
    0,
    -25,
    0,
    -20,
    -20
  ],
  gperiod: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -15
  ],
  gbreveperiod: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -15
  ],
  gcommaaccentperiod: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -15
  ],
  iv: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  iacutev: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  icircumflexv: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  idieresisv: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  igravev: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  imacronv: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  iogonekv: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -25
  ],
  ky: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -10,
    -15
  ],
  kyacute: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -10,
    -15
  ],
  kydieresis: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -10,
    -15
  ],
  kcommaaccenty: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -10,
    -15
  ],
  kcommaaccentyacute: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -10,
    -15
  ],
  kcommaaccentydieresis: [
    0,
    0,
    0,
    0,
    -15,
    0,
    -10,
    -15
  ],
  quotedblleftA: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAacute: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAbreve: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAcircumflex: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAdieresis: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAgrave: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAmacron: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAogonek: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAring: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quotedblleftAtilde: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftA: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAacute: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAbreve: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAcircumflex: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAdieresis: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAgrave: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAmacron: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAogonek: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAring: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  quoteleftAtilde: [
    0,
    0,
    0,
    0,
    -10,
    0,
    0,
    -80
  ],
  re: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  reacute: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  recaron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  recircumflex: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  redieresis: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  redotaccent: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  regrave: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  remacron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  reogonek: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racutee: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteeacute: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteecaron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteecircumflex: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteedieresis: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteedotaccent: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteegrave: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteemacron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  racuteeogonek: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcarone: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaroneacute: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronecaron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronecircumflex: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronedieresis: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronedotaccent: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronegrave: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaronemacron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcaroneogonek: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccente: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccenteacute: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentecaron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentecircumflex: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentedieresis: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentedotaccent: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentegrave: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccentemacron: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  rcommaaccenteogonek: [
    0,
    0,
    0,
    0,
    -18,
    0,
    -37
  ],
  spaceA: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAacute: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAbreve: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAcircumflex: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAdieresis: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAgrave: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAmacron: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAogonek: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAring: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  spaceAtilde: [
    0,
    0,
    0,
    0,
    -55,
    -37,
    -18,
    -55
  ],
  Fi: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  Fiacute: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  Ficircumflex: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  Fidieresis: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  Figrave: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  Fimacron: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  Fiogonek: [
    0,
    0,
    0,
    0,
    0,
    -40,
    -45
  ],
  eb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  eacuteb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ecaronb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ecircumflexb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  edieresisb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  edotaccentb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  egraveb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  emacronb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  eogonekb: [
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ff: [
    0,
    0,
    0,
    0,
    0,
    -18,
    -18,
    -25
  ],
  quoterightt: [
    0,
    0,
    0,
    0,
    0,
    -37,
    -30,
    -18
  ],
  quoterighttcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    -37,
    -30,
    -18
  ],
  Yicircumflex: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yidieresis: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yigrave: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yimacron: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yacuteicircumflex: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yacuteidieresis: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yacuteigrave: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Yacuteimacron: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Ydieresisicircumflex: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Ydieresisidieresis: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Ydieresisigrave: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  Ydieresisimacron: [
    0,
    0,
    0,
    0,
    0,
    0,
    -34
  ],
  eg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  egbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  egcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  eacuteg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  eacutegbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  eacutegcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  ecarong: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  ecarongbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  ecarongcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  ecircumflexg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  ecircumflexgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  ecircumflexgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  edieresisg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  edieresisgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  edieresisgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  edotaccentg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  edotaccentgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  edotaccentgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  egraveg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  egravegbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  egravegcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  emacrong: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  emacrongbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  emacrongcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  eogonekg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  eogonekgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  eogonekgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -40,
    -15
  ],
  fiogonek: [
    0,
    0,
    0,
    0,
    0,
    0,
    -20
  ],
  gcomma: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  gbrevecomma: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  gcommaaccentcomma: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  og: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ogbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ogcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  oacuteg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  oacutegbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  oacutegcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ocircumflexg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ocircumflexgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ocircumflexgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  odieresisg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  odieresisgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  odieresisgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ograveg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ogravegbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ogravegcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ohungarumlautg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ohungarumlautgbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  ohungarumlautgcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  omacrong: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  omacrongbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  omacrongcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  otildeg: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  otildegbreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  otildegcommaaccent: [
    0,
    0,
    0,
    0,
    0,
    0,
    -10
  ],
  fiacute: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -20
  ],
  ga: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gaacute: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gabreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gacircumflex: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gadieresis: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gagrave: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gamacron: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gaogonek: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  garing: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gatilde: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbrevea: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveaacute: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveabreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveacircumflex: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveadieresis: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveagrave: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveamacron: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveaogonek: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbrevearing: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gbreveatilde: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccenta: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentaacute: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentabreve: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentacircumflex: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentadieresis: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentagrave: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentamacron: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentaogonek: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentaring: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ],
  gcommaaccentatilde: [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -5
  ]
}, q0e = {
  attributes: j0e,
  glyphWidths: W0e,
  kernPairs: H0e
};
const Y0e = (t) => [t.FontName, {
  attributes: t,
  glyphWidths: {},
  kernPairs: {}
}], G0e = (t) => {
  const {
    attributes: e,
    glyphWidths: r,
    kernPairs: n
  } = t, i = e.map(Y0e);
  return Object.keys(r).forEach((a) => {
    r[a].forEach((o, s) => {
      o && (i[s][1].glyphWidths[a] = o);
    });
  }), Object.keys(n).forEach((a) => {
    n[a].forEach((o, s) => {
      o && (i[s][1].kernPairs[a] = o);
    });
  }), Object.fromEntries(i);
}, T9 = G0e(q0e), Z0e = (t) => class extends t {
  constructor(r, n, i) {
    super(), this.document = r, this.name = n, this.id = i, this.font = $x.fromJson(T9[this.name]), this.ascender = this.font.ascender, this.descender = this.font.descender, this.bbox = this.font.bbox, this.lineGap = this.font.lineGap;
  }
  embed() {
    return this.dictionary.data = {
      Type: "Font",
      BaseFont: this.name,
      Subtype: "Type1",
      Encoding: "WinAnsiEncoding"
    }, this.dictionary.end();
  }
  encode(r) {
    const n = this.font.encodeText(r), i = this.font.glyphsForString(`${r}`), a = this.font.advancesForGlyphs(i), o = [];
    for (let s = 0; s < i.length; s++) {
      const l = i[s];
      o.push({
        xAdvance: a[s],
        yAdvance: 0,
        xOffset: 0,
        yOffset: 0,
        advanceWidth: this.font.widthOfGlyph(l)
      });
    }
    return [n, o];
  }
  encodeGlyphs(r) {
    const n = [];
    for (let i of Array.from(r))
      n.push(`00${i.id.toString(16)}`.slice(-2));
    return n;
  }
  widthOfString(r, n) {
    const i = this.font.glyphsForString(`${r}`), a = this.font.advancesForGlyphs(i);
    let o = 0;
    for (let l of Array.from(a))
      o += l;
    const s = n / 1e3;
    return o * s;
  }
  static isStandardFont(r) {
    return r in T9;
  }
}, Fv = function() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return Array.from(e).map((i) => `0000${i.toString(16)}`.slice(-4)).join("");
}, X0e = (t) => class extends t {
  constructor(r, n, i) {
    super(), this.document = r, this.font = n, this.id = i, this.subset = this.font.createSubset(), this.unicode = [[0]], this.widths = [this.font.getGlyph(0).advanceWidth], this.name = this.font.postscriptName, this.scale = 1e3 / this.font.unitsPerEm, this.ascender = this.font.ascent * this.scale, this.descender = this.font.descent * this.scale, this.xHeight = this.font.xHeight * this.scale, this.capHeight = this.font.capHeight * this.scale, this.lineGap = this.font.lineGap * this.scale, this.bbox = this.font.bbox, this.layoutCache = /* @__PURE__ */ Object.create(null);
  }
  layoutRun(r, n) {
    const i = this.font.layout(r, n, void 0, void 0, "ltr");
    for (let a = 0; a < i.positions.length; a++) {
      const o = i.positions[a];
      for (let s in o)
        o[s] *= this.scale;
      o.advanceWidth = i.glyphs[a].advanceWidth * this.scale;
    }
    return i;
  }
  layoutCached(r) {
    let n;
    if (n = this.layoutCache[r])
      return n;
    const i = this.layoutRun(r);
    return this.layoutCache[r] = i, i;
  }
  layout(r, n, i) {
    if (i == null && (i = !1), n)
      return this.layoutRun(r, n);
    const a = i ? null : [], o = i ? null : [];
    let s = 0, l = 0, u = 0;
    for (; u <= r.length; ) {
      let d;
      if (u === r.length && l < u || (d = r.charAt(u), [" ", "	"].includes(d))) {
        const h = this.layoutCached(r.slice(l, ++u));
        i || (a.push(...Array.from(h.glyphs || [])), o.push(...Array.from(h.positions || []))), s += h.advanceWidth, l = u;
      } else
        u++;
    }
    return {
      glyphs: a,
      positions: o,
      advanceWidth: s
    };
  }
  encode(r, n) {
    const {
      glyphs: i,
      positions: a
    } = this.layout(r, n), o = [];
    for (let s = 0; s < i.length; s++) {
      const l = i[s], u = this.subset.includeGlyph(l.id);
      o.push(`0000${u.toString(16)}`.slice(-4)), this.widths[u] == null && (this.widths[u] = l.advanceWidth * this.scale), this.unicode[u] == null && (this.unicode[u] = l.codePoints);
    }
    return [o, a];
  }
  encodeGlyphs(r) {
    const n = [];
    for (let i = 0; i < r.length; i++) {
      const a = r[i], o = this.subset.includeGlyph(a.id);
      n.push(`0000${o.toString(16)}`.slice(-4)), this.widths[o] == null && (this.widths[o] = a.advanceWidth * this.scale), this.unicode[o] == null && (this.unicode[o] = a.codePoints);
    }
    return n;
  }
  widthOfString(r, n, i) {
    const a = this.layout(r, i, !0).advanceWidth, o = n / 1e3;
    return a * o;
  }
  embed() {
    const r = this.subset.cff != null, n = this.document.ref();
    r && (n.data.Subtype = "CIDFontType0C"), n.end(this.subset.encode());
    const i = ((this.font["OS/2"] != null ? this.font["OS/2"].sFamilyClass : void 0) || 0) >> 8;
    let a = 0;
    this.font.post.isFixedPitch && (a |= 1), 1 <= i && i <= 7 && (a |= 2), a |= 4, i === 10 && (a |= 8), this.font.head.macStyle.italic && (a |= 64);
    const s = [0, 1, 2, 3, 4, 5].map(() => String.fromCharCode(Math.random() * 26 + 65)).join("") + "+" + this.font.postscriptName, {
      bbox: l
    } = this.font, u = this.document.ref({
      Type: "FontDescriptor",
      FontName: s,
      Flags: a,
      FontBBox: [l.minX * this.scale, l.minY * this.scale, l.maxX * this.scale, l.maxY * this.scale],
      ItalicAngle: this.font.italicAngle,
      Ascent: this.ascender,
      Descent: this.descender,
      CapHeight: (this.font.capHeight || this.font.ascent) * this.scale,
      XHeight: (this.font.xHeight || 0) * this.scale,
      StemV: 0
    });
    r ? u.data.FontFile3 = n : u.data.FontFile2 = n, u.end();
    const d = {
      Type: "Font",
      Subtype: "CIDFontType0",
      BaseFont: s,
      CIDSystemInfo: {
        Registry: new String("Adobe"),
        Ordering: new String("Identity"),
        Supplement: 0
      },
      FontDescriptor: u,
      W: [0, this.widths]
    };
    r || (d.Subtype = "CIDFontType2", d.CIDToGIDMap = "Identity");
    const h = this.document.ref(d);
    return h.end(), this.dictionary.data = {
      Type: "Font",
      Subtype: "Type0",
      BaseFont: s,
      Encoding: "Identity-H",
      DescendantFonts: [h],
      ToUnicode: this.toUnicodeCmap()
    }, this.dictionary.end();
  }
  // Maps the glyph ids encoded in the PDF back to unicode strings
  // Because of ligature substitutions and the like, there may be one or more
  // unicode characters represented by each glyph.
  toUnicodeCmap() {
    const r = this.document.ref();
    let n = [], i = `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo <<
  /Registry (Adobe)
  /Ordering (UCS)
  /Supplement 0
>> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000><ffff>
endcodespacerange`;
    for (let [a, o] of this.unicode.entries()) {
      const s = [];
      n.length >= 100 && (i += `
` + n.length + ` beginbfchar
` + n.join(`
`) + `
endbfchar`, n = []);
      for (let l of o)
        l > 65535 && (l -= 65536, s.push(Fv(l >>> 10 & 1023 | 55296)), l = 56320 | l & 1023), s.push(Fv(l));
      n.push("<" + Fv(a) + "><" + s.join(" ") + ">");
    }
    return n.length && (i += `
` + n.length + ` beginbfchar
` + n.join(`
`) + `
endbfchar
`), i += `endcmap
CMapName currentdict /CMap defineresource pop
end
end`, r.end(i), r;
  }
};
class Am {
  static open(e, r, n, i) {
    let a;
    if (typeof r == "string") {
      if (F9.isStandardFont(r))
        return new F9(e, r, i);
      throw new Error(`Can't open ${r} in browser build`);
    } else r instanceof Uint8Array ? a = Qd(r, n) : r instanceof ArrayBuffer ? a = Qd(new Uint8Array(r), n) : typeof r == "object" && (a = r);
    if (a == null)
      throw new Error("Not a supported font format or standard PDF font.");
    return new K0e(e, a, i);
  }
  encode() {
    throw new Error("Must be implemented by subclasses");
  }
  widthOfString() {
    throw new Error("Must be implemented by subclasses");
  }
  ref() {
    return this.dictionary != null ? this.dictionary : this.dictionary = this.document.ref();
  }
  finalize() {
    if (!(this.embedded || this.dictionary == null))
      return this.embed(), this.embedded = !0;
  }
  embed() {
    throw new Error("Must be implemented by subclasses");
  }
  lineHeight(e, r) {
    r == null && (r = !1);
    const n = r ? this.lineGap : 0;
    return (this.ascender + n - this.descender) / 1e3 * e;
  }
}
const F9 = Z0e(Am), K0e = X0e(Am);
var J0e = {
  initFonts() {
    return this._fontFamilies = {}, this._fontCount = 0, this._fontSize = 12, this._font = null, this._registeredFonts = {}, this.font("Helvetica");
  },
  font(t, e, r) {
    let n, i;
    if (typeof e == "number" && (r = e, e = null), typeof t == "string" && this._registeredFonts[t] ? (n = t, {
      src: t,
      family: e
    } = this._registeredFonts[t]) : (n = e || t, typeof n != "string" && (n = null)), r != null && this.fontSize(r), i = this._fontFamilies[n])
      return this._font = i, this;
    const a = `F${++this._fontCount}`;
    return this._font = Am.open(this, t, e, a), (i = this._fontFamilies[this._font.name]) ? (this._font = i, this) : (n && (this._fontFamilies[n] = this._font), this._font.name && (this._fontFamilies[this._font.name] = this._font), this);
  },
  fontSize(t) {
    return this._fontSize = t, this;
  },
  currentLineHeight(t) {
    return t == null && (t = !1), this._font.lineHeight(this._fontSize, t);
  },
  registerFont(t, e, r) {
    return this._registeredFonts[t] = {
      src: e,
      family: r
    }, this;
  }
};
function V2(t) {
  return Math.fround(t);
}
const D9 = "­", Dv = "-";
class V3 extends B0 {
  constructor(e, r) {
    super(), this.document = e, this.horizontalScaling = r.horizontalScaling || 100, this.indent = (r.indent || 0) * this.horizontalScaling / 100, this.characterSpacing = (r.characterSpacing || 0) * this.horizontalScaling / 100, this.wordSpacing = (r.wordSpacing === 0) * this.horizontalScaling / 100, this.columns = r.columns || 1, this.columnGap = (r.columnGap != null ? r.columnGap : 18) * this.horizontalScaling / 100, this.lineWidth = (r.width * this.horizontalScaling / 100 - this.columnGap * (this.columns - 1)) / this.columns, this.spaceLeft = this.lineWidth, this.startX = this.document.x, this.startY = this.document.y, this.column = 1, this.ellipsis = r.ellipsis, this.continuedX = 0, this.features = r.features, r.height != null ? (this.height = r.height, this.maxY = V2(this.startY + r.height)) : this.maxY = V2(this.document.page.maxY()), this.on("firstLine", (n) => {
      const i = this.continuedX || this.indent;
      if (this.document.x += i, this.lineWidth -= i, !n.indentAllLines)
        return this.once("line", () => {
          if (this.document.x -= i, this.lineWidth += i, n.continued && !this.continuedX && (this.continuedX = this.indent), !n.continued)
            return this.continuedX = 0;
        });
    }), this.on("lastLine", (n) => {
      const {
        align: i
      } = n;
      return i === "justify" && (n.align = "left"), this.lastLine = !0, this.once("line", () => (this.document.y += n.paragraphGap || 0, n.align = i, this.lastLine = !1));
    });
  }
  wordWidth(e) {
    return this.document.widthOfString(e, this) + this.characterSpacing + this.wordSpacing;
  }
  canFit(e, r) {
    return e[e.length - 1] != D9 ? r <= this.spaceLeft : r + this.wordWidth(Dv) <= this.spaceLeft;
  }
  eachWord(e, r) {
    let n;
    const i = new IS(e);
    let a = null;
    const o = /* @__PURE__ */ Object.create(null);
    for (; n = i.nextBreak(); ) {
      var s;
      let d = e.slice(a?.position || 0, n.position), h = o[d] != null ? o[d] : o[d] = this.wordWidth(d);
      if (h > this.lineWidth + this.continuedX) {
        let v = a;
        const b = {};
        for (; d.length; ) {
          var l, u;
          h > this.spaceLeft ? (l = Math.ceil(this.spaceLeft / (h / d.length)), h = this.wordWidth(d.slice(0, l)), u = h <= this.spaceLeft && l < d.length) : l = d.length;
          let x = h > this.spaceLeft && l > 0;
          for (; x || u; )
            x ? (h = this.wordWidth(d.slice(0, --l)), x = h > this.spaceLeft && l > 0) : (h = this.wordWidth(d.slice(0, ++l)), x = h > this.spaceLeft && l > 0, u = h <= this.spaceLeft && l < d.length);
          if (l === 0 && this.spaceLeft === this.lineWidth && (l = 1), b.required = n.required || l < d.length, s = r(d.slice(0, l), h, b, v), v = {
            required: !1
          }, d = d.slice(l), h = this.wordWidth(d), s === !1)
            break;
        }
      } else
        s = r(d, h, n, a);
      if (s === !1)
        break;
      a = n;
    }
  }
  wrap(e, r) {
    this.horizontalScaling = r.horizontalScaling || 100, r.indent != null && (this.indent = r.indent * this.horizontalScaling / 100), r.characterSpacing != null && (this.characterSpacing = r.characterSpacing * this.horizontalScaling / 100), r.wordSpacing != null && (this.wordSpacing = r.wordSpacing * this.horizontalScaling / 100), r.ellipsis != null && (this.ellipsis = r.ellipsis);
    const n = this.document.y + this.document.currentLineHeight(!0);
    (this.document.y > this.maxY || n > this.maxY) && this.nextSection();
    let i = "", a = 0, o = 0, s = 0, {
      y: l
    } = this.document;
    const u = () => (r.textWidth = a + this.wordSpacing * (o - 1), r.wordCount = o, r.lineWidth = this.lineWidth, {
      y: l
    } = this.document, this.emit("line", i, r, this), s++);
    return this.emit("sectionStart", r, this), this.eachWord(e, (d, h, v, b) => {
      if ((b == null || b.required) && (this.emit("firstLine", r, this), this.spaceLeft = this.lineWidth), this.canFit(d, h) && (i += d, a += h, o++), v.required || !this.canFit(d, h)) {
        const x = this.document.currentLineHeight(!0);
        if (this.height != null && this.ellipsis && V2(this.document.y + x * 2) > this.maxY && this.column >= this.columns) {
          for (this.ellipsis === !0 && (this.ellipsis = "…"), i = i.replace(/\s+$/, ""), a = this.wordWidth(i + this.ellipsis); i && a > this.lineWidth; )
            i = i.slice(0, -1).replace(/\s+$/, ""), a = this.wordWidth(i + this.ellipsis);
          a <= this.lineWidth && (i = i + this.ellipsis), a = this.wordWidth(i);
        }
        return v.required && (h > this.spaceLeft && (u(), i = d, a = h, o = 1), this.emit("lastLine", r, this)), i[i.length - 1] == D9 && (i = i.slice(0, -1) + Dv, this.spaceLeft -= this.wordWidth(Dv)), u(), V2(this.document.y + x) > this.maxY && !this.nextSection() ? (o = 0, i = "", !1) : v.required ? (this.spaceLeft = this.lineWidth, i = "", a = 0, o = 0) : (this.spaceLeft = this.lineWidth - h, i = d, a = h, o = 1);
      } else
        return this.spaceLeft -= h;
    }), o > 0 && (this.emit("lastLine", r, this), u()), this.emit("sectionEnd", r, this), r.continued === !0 ? (s > 1 && (this.continuedX = 0), this.continuedX += r.textWidth || 0, this.document.y = l) : this.document.x = this.startX;
  }
  nextSection(e) {
    if (this.emit("sectionEnd", e, this), ++this.column > this.columns) {
      if (this.height != null)
        return !1;
      this.document.continueOnNewPage(), this.column = 1, this.startY = this.document.page.margins.top, this.maxY = this.document.page.maxY(), this.document.x = this.startX, this.document._fillColor && this.document.fillColor(...this.document._fillColor), this.emit("pageBreak", e, this);
    } else
      this.document.x += this.lineWidth + this.columnGap, this.document.y = this.startY, this.emit("columnBreak", e, this);
    return this.emit("sectionStart", e, this), !0;
  }
}
const {
  number: qs
} = Qi;
var Q0e = {
  initText() {
    return this._line = this._line.bind(this), this.x = 0, this.y = 0, this._lineGap = 0;
  },
  lineGap(t) {
    return this._lineGap = t, this;
  },
  moveDown(t) {
    return t == null && (t = 1), this.y += this.currentLineHeight(!0) * t + this._lineGap, this;
  },
  moveUp(t) {
    return t == null && (t = 1), this.y -= this.currentLineHeight(!0) * t + this._lineGap, this;
  },
  _text(t, e, r, n, i) {
    n = this._initOptions(e, r, n), t = t == null ? "" : `${t}`, n.wordSpacing && (t = t.replace(/\s{2,}/g, " "));
    const a = () => {
      n.structParent && n.structParent.add(this.struct(n.structType || "P", [this.markStructureContent(n.structType || "P")]));
    };
    if (n.rotation !== 0 && (this.save(), this.rotate(-n.rotation, {
      origin: [this.x, this.y]
    })), n.width) {
      let o = this._wrapper;
      o || (o = new V3(this, n), o.on("line", i), o.on("firstLine", a)), this._wrapper = n.continued ? o : null, this._textOptions = n.continued ? n : null, o.wrap(t, n);
    } else
      for (let o of t.split(`
`))
        a(), i(o, n);
    return n.rotation !== 0 && this.restore(), this;
  },
  text(t, e, r, n) {
    return this._text(t, e, r, n, this._line);
  },
  widthOfString(t, e) {
    e === void 0 && (e = {});
    const r = e.horizontalScaling || 100;
    return (this._font.widthOfString(t, this._fontSize, e.features) + (e.characterSpacing || 0) * (t.length - 1)) * r / 100;
  },
  /**
   * Compute the bounding box of a string
   * based on what will actually be rendered by `doc.text()`
   *
   * @param string - The string
   * @param x - X position of text (defaults to this.x)
   * @param y - Y position of text (defaults to this.y)
   * @param options - Any text options (The same you would apply to `doc.text()`)
   * @returns {{x: number, y: number, width: number, height: number}}
   */
  boundsOfString(t, e, r, n) {
  },
  heightOfString(t, e) {
    const {
      x: r,
      y: n
    } = this;
    e = this._initOptions(e), e.height = 1 / 0;
    const i = e.lineGap || this._lineGap || 0;
    this._text(t, this.x, this.y, e, () => this.y += this.currentLineHeight(!0) + i);
    const a = this.y - n;
    return this.x = r, this.y = n, a;
  },
  list(t, e, r, n, i) {
    n = this._initOptions(e, r, n);
    const a = n.listType || "bullet", o = Math.round(this._font.ascender / 1e3 * this._fontSize), s = o / 2, l = n.bulletRadius || o / 3, u = n.textIndent || (a === "bullet" ? l * 5 : o * 2), d = n.bulletIndent || (a === "bullet" ? l * 8 : o * 2);
    let h = 1;
    const v = [], b = [], x = [];
    var A = function(E) {
      let C = 1;
      for (let D = 0; D < E.length; D++) {
        const _ = E[D];
        Array.isArray(_) ? (h++, A(_), h--) : (v.push(_), b.push(h), a !== "bullet" && x.push(C++));
      }
    };
    A(t);
    const T = function(E) {
      switch (a) {
        case "numbered":
          return `${E}.`;
        case "lettered":
          var C = String.fromCharCode((E - 1) % 26 + 65), D = Math.floor((E - 1) / 26 + 1), _ = Array(D + 1).join(C);
          return `${_}.`;
      }
    }, k = function(E, C) {
      i = new V3(this, n), i.on("line", this._line), h = 1, i.once("firstLine", () => {
        let D, _, I, R;
        n.structParent && (n.structTypes ? [_, I, R] = n.structTypes : [_, I, R] = ["LI", "Lbl", "LBody"]), _ ? (D = this.struct(_), n.structParent.add(D)) : n.structParent && (D = n.structParent);
        let U;
        if ((U = b[C++]) !== h) {
          const z = d * (U - h);
          this.x += z, i.lineWidth -= z, h = U;
        }
        switch (D && (I || R) && D.add(this.struct(I || R, [this.markStructureContent(I || R)])), a) {
          case "bullet":
            this.circle(this.x - u + l, this.y + s, l), this.fill();
            break;
          case "numbered":
          case "lettered":
            var V = T(x[C - 1]);
            this._fragment(V, this.x - u, this.y, n);
            break;
        }
        D && I && R && D.add(this.struct(R, [this.markStructureContent(R)])), D && D !== n.structParent && D.end();
      }), i.on("sectionStart", () => {
        const D = u + d * (h - 1);
        return this.x += D, i.lineWidth -= D;
      }), i.on("sectionEnd", () => {
        const D = u + d * (h - 1);
        return this.x -= D, i.lineWidth += D;
      }), i.wrap(E, n);
    };
    for (let E = 0; E < v.length; E++)
      k.call(this, v[E], E);
    return this;
  },
  _initOptions(t, e, r) {
    var n;
    t === void 0 && (t = {}), r === void 0 && (r = {}), typeof t == "object" && (r = t, t = null);
    const i = Object.assign({}, r);
    if (this._textOptions)
      for (let a in this._textOptions) {
        const o = this._textOptions[a];
        a !== "continued" && i[a] === void 0 && (i[a] = o);
      }
    return t != null && (this.x = t), e != null && (this.y = e), i.lineBreak !== !1 && (i.width == null && (i.width = this.page.width - this.x - this.page.margins.right), i.width = Math.max(i.width, 0)), i.columns || (i.columns = 0), i.columnGap == null && (i.columnGap = 18), i.rotation = Number((n = r.rotation) !== null && n !== void 0 ? n : 0) % 360, i.rotation < 0 && (i.rotation += 360), i;
  },
  _line(t, e, r) {
    e === void 0 && (e = {}), this._fragment(t, this.x, this.y, e);
    const n = e.lineGap || this._lineGap || 0;
    return r ? this.y += this.currentLineHeight(!0) + n : this.x += this.widthOfString(t, e);
  },
  _fragment(t, e, r, n) {
    let i, a, o, s, l, u;
    if (t = `${t}`.replace(/\n/g, ""), t.length === 0)
      return;
    const d = n.align || "left";
    let h = n.wordSpacing || 0;
    const v = n.characterSpacing || 0, b = n.horizontalScaling || 100;
    if (n.width)
      switch (d) {
        case "right":
          l = this.widthOfString(t.replace(/\s+$/, ""), n), e += n.lineWidth - l;
          break;
        case "center":
          e += n.lineWidth / 2 - n.textWidth / 2;
          break;
        case "justify":
          u = t.trim().split(/\s+/), l = this.widthOfString(t.replace(/\s+/g, ""), n);
          var x = this.widthOfString(" ") + v;
          h = Math.max(0, (n.lineWidth - l) / Math.max(1, u.length - 1) - x);
          break;
      }
    if (typeof n.baseline == "number")
      i = -n.baseline;
    else {
      switch (n.baseline) {
        case "svg-middle":
          i = 0.5 * this._font.xHeight;
          break;
        case "middle":
        case "svg-central":
          i = 0.5 * (this._font.descender + this._font.ascender);
          break;
        case "bottom":
        case "ideographic":
          i = this._font.descender;
          break;
        case "alphabetic":
          i = 0;
          break;
        case "mathematical":
          i = 0.5 * this._font.ascender;
          break;
        case "hanging":
          i = 0.8 * this._font.ascender;
          break;
        case "top":
          i = this._font.ascender;
          break;
        default:
          i = this._font.ascender;
      }
      i = i / 1e3 * this._fontSize;
    }
    const A = n.textWidth + h * (n.wordCount - 1) + v * (t.length - 1);
    if (n.link != null && this.link(e, r, A, this.currentLineHeight(), n.link), n.goTo != null && this.goTo(e, r, A, this.currentLineHeight(), n.goTo), n.destination != null && this.addNamedDestination(n.destination, "XYZ", e, r, null), n.underline) {
      this.save(), n.stroke || this.strokeColor(...this._fillColor || []);
      const R = this._fontSize < 10 ? 0.5 : Math.floor(this._fontSize / 10);
      this.lineWidth(R);
      let U = r + this.currentLineHeight() - R;
      this.moveTo(e, U), this.lineTo(e + A, U), this.stroke(), this.restore();
    }
    if (n.strike) {
      this.save(), n.stroke || this.strokeColor(...this._fillColor || []);
      const R = this._fontSize < 10 ? 0.5 : Math.floor(this._fontSize / 10);
      this.lineWidth(R);
      let U = r + this.currentLineHeight() / 2;
      this.moveTo(e, U), this.lineTo(e + A, U), this.stroke(), this.restore();
    }
    if (this.save(), n.oblique) {
      let R;
      typeof n.oblique == "number" ? R = -Math.tan(n.oblique * Math.PI / 180) : R = -0.25, this.transform(1, 0, 0, 1, e, r), this.transform(1, 0, R, 1, -R * i, 0), this.transform(1, 0, 0, 1, -e, -r);
    }
    this.transform(1, 0, 0, -1, 0, this.page.height), r = this.page.height - r - i, this.page.fonts[this._font.id] == null && (this.page.fonts[this._font.id] = this._font.ref()), this.addContent("BT"), this.addContent(`1 0 0 1 ${qs(e)} ${qs(r)} Tm`), this.addContent(`/${this._font.id} ${qs(this._fontSize)} Tf`);
    const T = n.fill && n.stroke ? 2 : n.stroke ? 1 : 0;
    if (T && this.addContent(`${T} Tr`), v && this.addContent(`${qs(v)} Tc`), b !== 100 && this.addContent(`${b} Tz`), h) {
      u = t.trim().split(/\s+/), h += this.widthOfString(" ") + v, h *= 1e3 / this._fontSize, a = [], s = [];
      for (let R of u) {
        const [U, V] = this._font.encode(R, n.features);
        a = a.concat(U), s = s.concat(V);
        const z = {}, j = s[s.length - 1];
        for (let S in j) {
          const B = j[S];
          z[S] = B;
        }
        z.xAdvance += h, s[s.length - 1] = z;
      }
    } else
      [a, s] = this._font.encode(t, n.features);
    const k = this._fontSize / 1e3, E = [];
    let C = 0, D = !1;
    const _ = (R) => {
      if (C < R) {
        const U = a.slice(C, R).join(""), V = s[R - 1].xAdvance - s[R - 1].advanceWidth;
        E.push(`<${U}> ${qs(-V)}`);
      }
      return C = R;
    }, I = (R) => {
      if (_(R), E.length > 0)
        return this.addContent(`[${E.join(" ")}] TJ`), E.length = 0;
    };
    for (o = 0; o < s.length; o++) {
      const R = s[o];
      R.xOffset || R.yOffset ? (I(o), this.addContent(`1 0 0 1 ${qs(e + R.xOffset * k)} ${qs(r + R.yOffset * k)} Tm`), I(o + 1), D = !0) : (D && (this.addContent(`1 0 0 1 ${qs(e)} ${qs(r)} Tm`), D = !1), R.xAdvance - R.advanceWidth !== 0 && _(o + 1)), e += R.xAdvance * k;
    }
    return I(o), this.addContent("ET"), this.restore();
  }
};
const ere = {
  1: "DeviceGray",
  3: "DeviceRGB",
  4: "DeviceCMYK"
};
class tre {
  constructor(e, r) {
    if (this.data = e, this.label = r, this.orientation = 1, this.data.readUInt16BE(0) !== 65496)
      throw "SOI not found in JPEG";
    const n = CG.decode(this.data);
    for (let i = 0; i < n.length; i += 1) {
      const a = n[i];
      a.name === "EXIF" && a.entries.orientation && (this.orientation = a.entries.orientation), a.name === "SOF" && (this.bits ||= a.precision, this.width ||= a.width, this.height ||= a.height, this.colorSpace ||= ere[a.numberOfComponents]);
    }
    this.obj = null;
  }
  embed(e) {
    if (!this.obj)
      return this.obj = e.ref({
        Type: "XObject",
        Subtype: "Image",
        BitsPerComponent: this.bits,
        Width: this.width,
        Height: this.height,
        ColorSpace: this.colorSpace,
        Filter: "DCTDecode"
      }), this.colorSpace === "DeviceCMYK" && (this.obj.data.Decode = [1, 0, 1, 0, 1, 0, 1, 0]), this.obj.end(this.data), this.data = null;
  }
}
class rre {
  constructor(e, r) {
    this.label = r, this.image = new EJ(e), this.width = this.image.width, this.height = this.image.height, this.imgData = this.image.imgData, this.obj = null;
  }
  embed(e) {
    let r = !1;
    if (this.document = e, this.obj)
      return;
    const n = this.image.hasAlphaChannel, i = this.image.interlaceMethod === 1;
    if (this.obj = this.document.ref({
      Type: "XObject",
      Subtype: "Image",
      BitsPerComponent: n ? 8 : this.image.bits,
      Width: this.width,
      Height: this.height,
      Filter: "FlateDecode"
    }), !n) {
      const a = this.document.ref({
        Predictor: i ? 1 : 15,
        Colors: this.image.colors,
        BitsPerComponent: this.image.bits,
        Columns: this.width
      });
      this.obj.data.DecodeParms = a, a.end();
    }
    if (this.image.palette.length === 0)
      this.obj.data.ColorSpace = this.image.colorSpace;
    else {
      const a = this.document.ref();
      a.end(Oe.from(this.image.palette)), this.obj.data.ColorSpace = ["Indexed", "DeviceRGB", this.image.palette.length / 3 - 1, a];
    }
    if (this.image.transparency.grayscale != null) {
      const a = this.image.transparency.grayscale;
      this.obj.data.Mask = [a, a];
    } else if (this.image.transparency.rgb) {
      const {
        rgb: a
      } = this.image.transparency, o = [];
      for (let s of a)
        o.push(s, s);
      this.obj.data.Mask = o;
    } else {
      if (this.image.transparency.indexed)
        return r = !0, this.loadIndexedAlphaChannel();
      if (n)
        return r = !0, this.splitAlphaChannel();
    }
    if (i && !r)
      return this.decodeData();
    this.finalize();
  }
  finalize() {
    if (this.alphaChannel) {
      const e = this.document.ref({
        Type: "XObject",
        Subtype: "Image",
        Height: this.height,
        Width: this.width,
        BitsPerComponent: 8,
        Filter: "FlateDecode",
        ColorSpace: "DeviceGray",
        Decode: [0, 1]
      });
      e.end(this.alphaChannel), this.obj.data.SMask = e;
    }
    return this.obj.end(this.imgData), this.image = null, this.imgData = null;
  }
  splitAlphaChannel() {
    return this.image.decodePixels((e) => {
      let r, n;
      const i = this.image.colors, a = this.width * this.height, o = Oe.alloc(a * i), s = Oe.alloc(a);
      let l = n = r = 0;
      const u = e.length, d = this.image.bits === 16 ? 1 : 0;
      for (; l < u; ) {
        for (let h = 0; h < i; h++)
          o[n++] = e[l++], l += d;
        s[r++] = e[l++], l += d;
      }
      return this.imgData = Rd.deflateSync(o), this.alphaChannel = Rd.deflateSync(s), this.finalize();
    });
  }
  loadIndexedAlphaChannel() {
    const e = this.image.transparency.indexed;
    return this.image.decodePixels((r) => {
      const n = Oe.alloc(this.width * this.height);
      let i = 0;
      for (let a = 0, o = r.length; a < o; a++)
        n[i++] = e[r[a]];
      return this.alphaChannel = Rd.deflateSync(n), this.finalize();
    });
  }
  decodeData() {
    this.image.decodePixels((e) => {
      this.imgData = Rd.deflateSync(e), this.finalize();
    });
  }
}
class nre {
  static open(e, r) {
    let n;
    if (Oe.isBuffer(e))
      n = e;
    else if (e instanceof ArrayBuffer)
      n = Oe.from(new Uint8Array(e));
    else {
      let i;
      if (i = /^data:.+?;base64,(.*)$/.exec(e))
        n = Oe.from(i[1], "base64");
      else if (n = lp.readFileSync(e), !n)
        return;
    }
    if (n[0] === 255 && n[1] === 216)
      return new tre(n, r);
    if (n[0] === 137 && n.toString("ascii", 1, 4) === "PNG")
      return new rre(n, r);
    throw new Error("Unknown image format.");
  }
}
var ire = {
  initImages() {
    return this._imageRegistry = {}, this._imageCount = 0;
  },
  image(t, e, r, n) {
    n === void 0 && (n = {});
    let i, a, o, s, l, u, d, h, v, b;
    typeof e == "object" && (n = e, e = null);
    const x = n.ignoreOrientation || n.ignoreOrientation !== !1 && this.options.ignoreOrientation;
    e = (u = e ?? n.x) != null ? u : this.x, r = (d = r ?? n.y) != null ? d : this.y, typeof t == "string" && (s = this._imageRegistry[t]), s || (t.width && t.height ? s = t : s = this.openImage(t)), s.obj || s.embed(this), this.page.xobjects[s.label] == null && (this.page.xobjects[s.label] = s.obj);
    let {
      width: A,
      height: T
    } = s;
    !x && s.orientation > 4 && ([A, T] = [T, A]);
    let k = n.width || A, E = n.height || T;
    if (n.width && !n.height) {
      const C = k / A;
      k = A * C, E = T * C;
    } else if (n.height && !n.width) {
      const C = E / T;
      k = A * C, E = T * C;
    } else n.scale ? (k = A * n.scale, E = T * n.scale) : n.fit ? ([o, i] = n.fit, a = o / i, l = A / T, l > a ? (k = o, E = o / l) : (E = i, k = i * l)) : n.cover && ([o, i] = n.cover, a = o / i, l = A / T, l > a ? (E = i, k = i * l) : (k = o, E = o / l));
    if ((n.fit || n.cover) && (n.align === "center" ? e = e + o / 2 - k / 2 : n.align === "right" && (e = e + o - k), n.valign === "center" ? r = r + i / 2 - E / 2 : n.valign === "bottom" && (r = r + i - E)), x)
      E = -E, r -= E, h = 0;
    else
      switch (s.orientation) {
        default:
        case 1:
          E = -E, r -= E, h = 0;
          break;
        case 2:
          k = -k, E = -E, e -= k, r -= E, h = 0;
          break;
        case 3:
          v = e, b = r, E = -E, e -= k, h = 180;
          break;
        case 4:
          break;
        case 5:
          v = e, b = r, [k, E] = [E, k], r -= E, h = 90;
          break;
        case 6:
          v = e, b = r, [k, E] = [E, k], E = -E, h = 90;
          break;
        case 7:
          v = e, b = r, [k, E] = [E, k], E = -E, k = -k, e -= k, h = 90;
          break;
        case 8:
          v = e, b = r, [k, E] = [E, k], E = -E, e -= k, r -= E, h = -90;
          break;
      }
    return n.link != null && this.link(e, r, k, E, n.link), n.goTo != null && this.goTo(e, r, k, E, n.goTo), n.destination != null && this.addNamedDestination(n.destination, "XYZ", e, r, null), this.y === r && (this.y += E), this.save(), h && this.rotate(h, {
      origin: [v, b]
    }), this.transform(k, 0, 0, E, e, r), this.addContent(`/${s.label} Do`), this.restore(), this;
  },
  openImage(t) {
    let e;
    return typeof t == "string" && (e = this._imageRegistry[t]), e || (e = nre.open(t, `I${++this._imageCount}`), typeof t == "string" && (this._imageRegistry[t] = e)), e;
  }
}, are = {
  annotate(t, e, r, n, i) {
    i.Type = "Annot", i.Rect = this._convertRect(t, e, r, n), i.Border = [0, 0, 0], i.Subtype === "Link" && typeof i.F > "u" && (i.F = 4), i.Subtype !== "Link" && i.C == null && (i.C = this._normalizeColor(i.color || [0, 0, 0])), delete i.color, typeof i.Dest == "string" && (i.Dest = new String(i.Dest));
    for (let o in i) {
      const s = i[o];
      i[o[0].toUpperCase() + o.slice(1)] = s;
    }
    const a = this.ref(i);
    return this.page.annotations.push(a), a.end(), this;
  },
  note(t, e, r, n, i, a) {
    return a === void 0 && (a = {}), a.Subtype = "Text", a.Contents = new String(i), a.Name == null && (a.Name = "Comment"), a.color == null && (a.color = [243, 223, 92]), this.annotate(t, e, r, n, a);
  },
  goTo(t, e, r, n, i, a) {
    return a === void 0 && (a = {}), a.Subtype = "Link", a.A = this.ref({
      S: "GoTo",
      D: new String(i)
    }), a.A.end(), this.annotate(t, e, r, n, a);
  },
  link(t, e, r, n, i, a) {
    if (a === void 0 && (a = {}), a.Subtype = "Link", typeof i == "number") {
      const o = this._root.data.Pages.data;
      if (i >= 0 && i < o.Kids.length)
        a.A = this.ref({
          S: "GoTo",
          D: [o.Kids[i], "XYZ", null, null, null]
        }), a.A.end();
      else
        throw new Error(`The document has no page ${i}`);
    } else
      a.A = this.ref({
        S: "URI",
        URI: new String(i)
      }), a.A.end();
    return this.annotate(t, e, r, n, a);
  },
  _markup(t, e, r, n, i) {
    i === void 0 && (i = {});
    const [a, o, s, l] = this._convertRect(t, e, r, n);
    return i.QuadPoints = [a, l, s, l, a, o, s, o], i.Contents = new String(), this.annotate(t, e, r, n, i);
  },
  highlight(t, e, r, n, i) {
    return i === void 0 && (i = {}), i.Subtype = "Highlight", i.color == null && (i.color = [241, 238, 148]), this._markup(t, e, r, n, i);
  },
  underline(t, e, r, n, i) {
    return i === void 0 && (i = {}), i.Subtype = "Underline", this._markup(t, e, r, n, i);
  },
  strike(t, e, r, n, i) {
    return i === void 0 && (i = {}), i.Subtype = "StrikeOut", this._markup(t, e, r, n, i);
  },
  lineAnnotation(t, e, r, n, i) {
    return i === void 0 && (i = {}), i.Subtype = "Line", i.Contents = new String(), i.L = [t, this.page.height - e, r, this.page.height - n], this.annotate(t, e, r, n, i);
  },
  rectAnnotation(t, e, r, n, i) {
    return i === void 0 && (i = {}), i.Subtype = "Square", i.Contents = new String(), this.annotate(t, e, r, n, i);
  },
  ellipseAnnotation(t, e, r, n, i) {
    return i === void 0 && (i = {}), i.Subtype = "Circle", i.Contents = new String(), this.annotate(t, e, r, n, i);
  },
  textAnnotation(t, e, r, n, i, a) {
    return a === void 0 && (a = {}), a.Subtype = "FreeText", a.Contents = new String(i), a.DA = new String(), this.annotate(t, e, r, n, a);
  },
  fileAnnotation(t, e, r, n, i, a) {
    i === void 0 && (i = {}), a === void 0 && (a = {});
    const o = this.file(i.src, Object.assign({
      hidden: !0
    }, i));
    return a.Subtype = "FileAttachment", a.FS = o, a.Contents ? a.Contents = new String(a.Contents) : o.data.Desc && (a.Contents = o.data.Desc), this.annotate(t, e, r, n, a);
  },
  _convertRect(t, e, r, n) {
    let i = e;
    e += n;
    let a = t + r;
    const [o, s, l, u, d, h] = this._ctm;
    return t = o * t + l * e + d, e = s * t + u * e + h, a = o * a + l * i + d, i = s * a + u * i + h, [t, e, a, i];
  }
};
class Vx {
  constructor(e, r, n, i, a) {
    a === void 0 && (a = {
      expanded: !1
    }), this.document = e, this.options = a, this.outlineData = {}, i !== null && (this.outlineData.Dest = [i.dictionary, "Fit"]), r !== null && (this.outlineData.Parent = r), n !== null && (this.outlineData.Title = new String(n)), this.dictionary = this.document.ref(this.outlineData), this.children = [];
  }
  addItem(e, r) {
    r === void 0 && (r = {
      expanded: !1
    });
    const n = new Vx(this.document, this.dictionary, e, this.document.page, r);
    return this.children.push(n), n;
  }
  endOutline() {
    if (this.children.length > 0) {
      this.options.expanded && (this.outlineData.Count = this.children.length);
      const e = this.children[0], r = this.children[this.children.length - 1];
      this.outlineData.First = e.dictionary, this.outlineData.Last = r.dictionary;
      for (let n = 0, i = this.children.length; n < i; n++) {
        const a = this.children[n];
        n > 0 && (a.outlineData.Prev = this.children[n - 1].dictionary), n < this.children.length - 1 && (a.outlineData.Next = this.children[n + 1].dictionary), a.endOutline();
      }
    }
    return this.dictionary.end();
  }
}
var ore = {
  initOutline() {
    return this.outline = new Vx(this, null, null, null);
  },
  endOutline() {
    if (this.outline.endOutline(), this.outline.children.length > 0)
      return this._root.data.Outlines = this.outline.dictionary, this._root.data.PageMode = "UseOutlines";
  }
};
class b5 {
  constructor(e, r) {
    this.refs = [{
      pageRef: e,
      mcid: r
    }];
  }
  push(e) {
    e.refs.forEach((r) => this.refs.push(r));
  }
}
class $l {
  constructor(e, r, n, i) {
    n === void 0 && (n = {}), i === void 0 && (i = null), this.document = e, this._attached = !1, this._ended = !1, this._flushed = !1, this.dictionary = e.ref({
      // Type: "StructElem",
      S: r
    });
    const a = this.dictionary.data;
    (Array.isArray(n) || this._isValidChild(n)) && (i = n, n = {}), typeof n.title < "u" && (a.T = new String(n.title)), typeof n.lang < "u" && (a.Lang = new String(n.lang)), typeof n.alt < "u" && (a.Alt = new String(n.alt)), typeof n.expanded < "u" && (a.E = new String(n.expanded)), typeof n.actual < "u" && (a.ActualText = new String(n.actual)), this._children = [], i && (Array.isArray(i) || (i = [i]), i.forEach((o) => this.add(o)), this.end());
  }
  add(e) {
    if (this._ended)
      throw new Error("Cannot add child to already-ended structure element");
    if (!this._isValidChild(e))
      throw new Error("Invalid structure element child");
    return e instanceof $l && (e.setParent(this.dictionary), this._attached && e.setAttached()), e instanceof b5 && this._addContentToParentTree(e), typeof e == "function" && this._attached && (e = this._contentForClosure(e)), this._children.push(e), this;
  }
  _addContentToParentTree(e) {
    e.refs.forEach((r) => {
      let {
        pageRef: n,
        mcid: i
      } = r;
      const a = this.document.getStructParentTree().get(n.data.StructParents);
      a[i] = this.dictionary;
    });
  }
  setParent(e) {
    if (this.dictionary.data.P)
      throw new Error("Structure element added to more than one parent");
    this.dictionary.data.P = e, this._flush();
  }
  setAttached() {
    this._attached || (this._children.forEach((e, r) => {
      e instanceof $l && e.setAttached(), typeof e == "function" && (this._children[r] = this._contentForClosure(e));
    }), this._attached = !0, this._flush());
  }
  end() {
    this._ended || (this._children.filter((e) => e instanceof $l).forEach((e) => e.end()), this._ended = !0, this._flush());
  }
  _isValidChild(e) {
    return e instanceof $l || e instanceof b5 || typeof e == "function";
  }
  _contentForClosure(e) {
    const r = this.document.markStructureContent(this.dictionary.data.S);
    return e(), this.document.endMarkedContent(), this._addContentToParentTree(r), r;
  }
  _isFlushable() {
    return !this.dictionary.data.P || !this._ended ? !1 : this._children.every((e) => typeof e == "function" ? !1 : e instanceof $l ? e._isFlushable() : !0);
  }
  _flush() {
    this._flushed || !this._isFlushable() || (this.dictionary.data.K = [], this._children.forEach((e) => this._flushChild(e)), this.dictionary.end(), this._children = [], this.dictionary.data.K = null, this._flushed = !0);
  }
  _flushChild(e) {
    e instanceof $l && this.dictionary.data.K.push(e.dictionary), e instanceof b5 && e.refs.forEach((r) => {
      let {
        pageRef: n,
        mcid: i
      } = r;
      this.dictionary.data.Pg || (this.dictionary.data.Pg = n), this.dictionary.data.Pg === n ? this.dictionary.data.K.push(i) : this.dictionary.data.K.push({
        Type: "MCR",
        Pg: n,
        MCID: i
      });
    });
  }
}
class sre extends kT {
  _compareKeys(e, r) {
    return parseInt(e) - parseInt(r);
  }
  _keysName() {
    return "Nums";
  }
  _dataForKey(e) {
    return parseInt(e);
  }
}
var lre = {
  initMarkings(t) {
    this.structChildren = [], t.tagged && (this.getMarkInfoDictionary().data.Marked = !0, this.getStructTreeRoot());
  },
  markContent(t, e) {
    if (e === void 0 && (e = null), t === "Artifact" || e && e.mcid) {
      let n = 0;
      for (this.page.markings.forEach((i) => {
        (n || i.structContent || i.tag === "Artifact") && n++;
      }); n--; )
        this.endMarkedContent();
    }
    if (!e)
      return this.page.markings.push({
        tag: t
      }), this.addContent(`/${t} BMC`), this;
    this.page.markings.push({
      tag: t,
      options: e
    });
    const r = {};
    return typeof e.mcid < "u" && (r.MCID = e.mcid), t === "Artifact" && (typeof e.type == "string" && (r.Type = e.type), Array.isArray(e.bbox) && (r.BBox = [e.bbox[0], this.page.height - e.bbox[3], e.bbox[2], this.page.height - e.bbox[1]]), Array.isArray(e.attached) && e.attached.every((n) => typeof n == "string") && (r.Attached = e.attached)), t === "Span" && (e.lang && (r.Lang = new String(e.lang)), e.alt && (r.Alt = new String(e.alt)), e.expanded && (r.E = new String(e.expanded)), e.actual && (r.ActualText = new String(e.actual))), this.addContent(`/${t} ${Qi.convert(r)} BDC`), this;
  },
  markStructureContent(t, e) {
    e === void 0 && (e = {});
    const r = this.getStructParentTree().get(this.page.structParentTreeKey), n = r.length;
    r.push(null), this.markContent(t, {
      ...e,
      mcid: n
    });
    const i = new b5(this.page.dictionary, n);
    return this.page.markings.slice(-1)[0].structContent = i, i;
  },
  endMarkedContent() {
    return this.page.markings.pop(), this.addContent("EMC"), this;
  },
  struct(t, e, r) {
    return e === void 0 && (e = {}), r === void 0 && (r = null), new $l(this, t, e, r);
  },
  addStructure(t) {
    const e = this.getStructTreeRoot();
    return t.setParent(e), t.setAttached(), this.structChildren.push(t), e.data.K || (e.data.K = []), e.data.K.push(t.dictionary), this;
  },
  initPageMarkings(t) {
    t.forEach((e) => {
      if (e.structContent) {
        const r = e.structContent, n = this.markStructureContent(e.tag, e.options);
        r.push(n), this.page.markings.slice(-1)[0].structContent = r;
      } else
        this.markContent(e.tag, e.options);
    });
  },
  endPageMarkings(t) {
    const e = t.markings;
    return e.forEach(() => t.write("EMC")), t.markings = [], e;
  },
  getMarkInfoDictionary() {
    return this._root.data.MarkInfo || (this._root.data.MarkInfo = this.ref({})), this._root.data.MarkInfo;
  },
  hasMarkInfoDictionary() {
    return !!this._root.data.MarkInfo;
  },
  getStructTreeRoot() {
    return this._root.data.StructTreeRoot || (this._root.data.StructTreeRoot = this.ref({
      Type: "StructTreeRoot",
      ParentTree: new sre(),
      ParentTreeNextKey: 0
    })), this._root.data.StructTreeRoot;
  },
  getStructParentTree() {
    return this.getStructTreeRoot().data.ParentTree;
  },
  createStructParentTreeNextKey() {
    this.getMarkInfoDictionary();
    const t = this.getStructTreeRoot(), e = t.data.ParentTreeNextKey++;
    return t.data.ParentTree.add(e, []), e;
  },
  endMarkings() {
    const t = this._root.data.StructTreeRoot;
    t && (t.end(), this.structChildren.forEach((e) => e.end())), this._root.data.MarkInfo && this._root.data.MarkInfo.end();
  }
};
const O9 = {
  readOnly: 1,
  required: 2,
  noExport: 4,
  multiline: 4096,
  password: 8192,
  toggleToOffButton: 16384,
  radioButton: 32768,
  pushButton: 65536,
  combo: 131072,
  edit: 262144,
  sort: 524288,
  multiSelect: 2097152,
  noSpell: 4194304
}, R9 = {
  left: 0,
  center: 1,
  right: 2
}, P9 = {
  value: "V",
  defaultValue: "DV"
}, I9 = {
  zip: "0",
  zipPlus4: "1",
  zip4: "1",
  phone: "2",
  ssn: "3"
}, B9 = {
  number: {
    nDec: 0,
    sepComma: !1,
    negStyle: "MinusBlack",
    currency: "",
    currencyPrepend: !0
  },
  percent: {
    nDec: 0,
    sepComma: !1
  }
};
var ure = {
  /**
   * Must call if adding AcroForms to a document. Must also call font() before
   * this method to set the default font.
   */
  initForm() {
    if (!this._font)
      throw new Error("Must set a font before calling initForm method");
    this._acroform = {
      fonts: {},
      defaultFont: this._font.name
    }, this._acroform.fonts[this._font.id] = this._font.ref();
    let t = {
      Fields: [],
      NeedAppearances: !0,
      DA: new String(`/${this._font.id} 0 Tf 0 g`),
      DR: {
        Font: {}
      }
    };
    t.DR.Font[this._font.id] = this._font.ref();
    const e = this.ref(t);
    return this._root.data.AcroForm = e, this;
  },
  /**
   * Called automatically by document.js
   */
  endAcroForm() {
    if (this._root.data.AcroForm) {
      if (!Object.keys(this._acroform.fonts).length && !this._acroform.defaultFont)
        throw new Error("No fonts specified for PDF form");
      let t = this._root.data.AcroForm.data.DR.Font;
      Object.keys(this._acroform.fonts).forEach((e) => {
        t[e] = this._acroform.fonts[e];
      }), this._root.data.AcroForm.data.Fields.forEach((e) => {
        this._endChild(e);
      }), this._root.data.AcroForm.end();
    }
    return this;
  },
  _endChild(t) {
    return Array.isArray(t.data.Kids) && (t.data.Kids.forEach((e) => {
      this._endChild(e);
    }), t.end()), this;
  },
  /**
   * Creates and adds a form field to the document. Form fields are intermediate
   * nodes in a PDF form that are used to specify form name heirarchy and form
   * value defaults.
   * @param {string} name - field name (T attribute in field dictionary)
   * @param {object} options  - other attributes to include in field dictionary
   */
  formField(t, e) {
    e === void 0 && (e = {});
    let r = this._fieldDict(t, null, e), n = this.ref(r);
    return this._addToParent(n), n;
  },
  /**
   * Creates and adds a Form Annotation to the document. Form annotations are
   * called Widget annotations internally within a PDF file.
   * @param {string} name - form field name (T attribute of widget annotation
   * dictionary)
   * @param {number} x
   * @param {number} y
   * @param {number} w
   * @param {number} h
   * @param {object} options
   */
  formAnnotation(t, e, r, n, i, a, o) {
    o === void 0 && (o = {});
    let s = this._fieldDict(t, e, o);
    s.Subtype = "Widget", s.F === void 0 && (s.F = 4), this.annotate(r, n, i, a, s);
    let l = this.page.annotations[this.page.annotations.length - 1];
    return this._addToParent(l);
  },
  formText(t, e, r, n, i, a) {
    return a === void 0 && (a = {}), this.formAnnotation(t, "text", e, r, n, i, a);
  },
  formPushButton(t, e, r, n, i, a) {
    return a === void 0 && (a = {}), this.formAnnotation(t, "pushButton", e, r, n, i, a);
  },
  formCombo(t, e, r, n, i, a) {
    return a === void 0 && (a = {}), this.formAnnotation(t, "combo", e, r, n, i, a);
  },
  formList(t, e, r, n, i, a) {
    return a === void 0 && (a = {}), this.formAnnotation(t, "list", e, r, n, i, a);
  },
  formRadioButton(t, e, r, n, i, a) {
    return a === void 0 && (a = {}), this.formAnnotation(t, "radioButton", e, r, n, i, a);
  },
  formCheckbox(t, e, r, n, i, a) {
    return a === void 0 && (a = {}), this.formAnnotation(t, "checkbox", e, r, n, i, a);
  },
  _addToParent(t) {
    let e = t.data.Parent;
    return e ? (e.data.Kids || (e.data.Kids = []), e.data.Kids.push(t)) : this._root.data.AcroForm.data.Fields.push(t), this;
  },
  _fieldDict(t, e, r) {
    if (r === void 0 && (r = {}), !this._acroform)
      throw new Error("Call document.initForm() method before adding form elements to document");
    let n = Object.assign({}, r);
    return e !== null && (n = this._resolveType(e, r)), n = this._resolveFlags(n), n = this._resolveJustify(n), n = this._resolveFont(n), n = this._resolveStrings(n), n = this._resolveColors(n), n = this._resolveFormat(n), n.T = new String(t), n.parent && (n.Parent = n.parent, delete n.parent), n;
  },
  _resolveType(t, e) {
    if (t === "text")
      e.FT = "Tx";
    else if (t === "pushButton")
      e.FT = "Btn", e.pushButton = !0;
    else if (t === "radioButton")
      e.FT = "Btn", e.radioButton = !0;
    else if (t === "checkbox")
      e.FT = "Btn";
    else if (t === "combo")
      e.FT = "Ch", e.combo = !0;
    else if (t === "list")
      e.FT = "Ch";
    else
      throw new Error(`Invalid form annotation type '${t}'`);
    return e;
  },
  _resolveFormat(t) {
    const e = t.format;
    if (e && e.type) {
      let r, n, i = "";
      if (I9[e.type] !== void 0)
        r = "AFSpecial_Keystroke", n = "AFSpecial_Format", i = I9[e.type];
      else {
        let a = e.type.charAt(0).toUpperCase() + e.type.slice(1);
        if (r = `AF${a}_Keystroke`, n = `AF${a}_Format`, e.type === "date")
          r += "Ex", i = String(e.param);
        else if (e.type === "time")
          i = String(e.param);
        else if (e.type === "number") {
          let o = Object.assign({}, B9.number, e);
          i = String([String(o.nDec), o.sepComma ? "0" : "1", '"' + o.negStyle + '"', "null", '"' + o.currency + '"', String(o.currencyPrepend)].join(","));
        } else if (e.type === "percent") {
          let o = Object.assign({}, B9.percent, e);
          i = String([String(o.nDec), o.sepComma ? "0" : "1"].join(","));
        }
      }
      t.AA = t.AA ? t.AA : {}, t.AA.K = {
        S: "JavaScript",
        JS: new String(`${r}(${i});`)
      }, t.AA.F = {
        S: "JavaScript",
        JS: new String(`${n}(${i});`)
      };
    }
    return delete t.format, t;
  },
  _resolveColors(t) {
    let e = this._normalizeColor(t.backgroundColor);
    return e && (t.MK || (t.MK = {}), t.MK.BG = e), e = this._normalizeColor(t.borderColor), e && (t.MK || (t.MK = {}), t.MK.BC = e), delete t.backgroundColor, delete t.borderColor, t;
  },
  _resolveFlags(t) {
    let e = 0;
    return Object.keys(t).forEach((r) => {
      O9[r] && (t[r] && (e |= O9[r]), delete t[r]);
    }), e !== 0 && (t.Ff = t.Ff ? t.Ff : 0, t.Ff |= e), t;
  },
  _resolveJustify(t) {
    let e = 0;
    return t.align !== void 0 && (typeof R9[t.align] == "number" && (e = R9[t.align]), delete t.align), e !== 0 && (t.Q = e), t;
  },
  _resolveFont(t) {
    if (this._acroform.fonts[this._font.id] == null && (this._acroform.fonts[this._font.id] = this._font.ref()), this._acroform.defaultFont !== this._font.name) {
      t.DR = {
        Font: {}
      };
      const e = t.fontSize || 0;
      t.DR.Font[this._font.id] = this._font.ref(), t.DA = new String(`/${this._font.id} ${e} Tf 0 g`);
    }
    return t;
  },
  _resolveStrings(t) {
    let e = [];
    function r(n) {
      if (Array.isArray(n))
        for (let i = 0; i < n.length; i++)
          typeof n[i] == "string" ? e.push(new String(n[i])) : e.push(n[i]);
    }
    return r(t.Opt), t.select && (r(t.select), delete t.select), e.length && (t.Opt = e), Object.keys(P9).forEach((n) => {
      t[n] !== void 0 && (t[P9[n]] = t[n], delete t[n]);
    }), ["V", "DV"].forEach((n) => {
      typeof t[n] == "string" && (t[n] = new String(t[n]));
    }), t.MK && t.MK.CA && (t.MK.CA = new String(t.MK.CA)), t.label && (t.MK = t.MK ? t.MK : {}, t.MK.CA = new String(t.label), delete t.label), t;
  }
}, cre = {
  /**
   * Embed contents of `src` in PDF
   * @param {Buffer | ArrayBuffer | string} src input Buffer, ArrayBuffer, base64 encoded string or path to file
   * @param {object} options
   *  * options.name: filename to be shown in PDF, will use `src` if none set
   *  * options.type: filetype to be shown in PDF
   *  * options.description: description to be shown in PDF
   *  * options.hidden: if true, do not add attachment to EmbeddedFiles dictionary. Useful for file attachment annotations
   *  * options.creationDate: override creation date
   *  * options.modifiedDate: override modified date
   *  * options.relationship: Relationship between the PDF document and its attached file. Can be 'Alternative', 'Data', 'Source', 'Supplement' or 'Unspecified'.
   * @returns filespec reference
   */
  file(t, e) {
    e === void 0 && (e = {}), e.name = e.name || t, e.relationship = e.relationship || "Unspecified";
    const r = {
      Type: "EmbeddedFile",
      Params: {}
    };
    let n;
    if (!t)
      throw new Error("No src specified");
    if (Oe.isBuffer(t))
      n = t;
    else if (t instanceof ArrayBuffer)
      n = Oe.from(new Uint8Array(t));
    else {
      let u;
      if (u = /^data:(.*?);base64,(.*)$/.exec(t))
        u[1] && (r.Subtype = u[1].replace("/", "#2F")), n = Oe.from(u[2], "base64");
      else {
        if (n = lp.readFileSync(t), !n)
          throw new Error(`Could not read contents of file at filepath ${t}`);
        const {
          birthtime: d,
          ctime: h
        } = lp.statSync(t);
        r.Params.CreationDate = d, r.Params.ModDate = h;
      }
    }
    e.creationDate instanceof Date && (r.Params.CreationDate = e.creationDate), e.modifiedDate instanceof Date && (r.Params.ModDate = e.modifiedDate), e.type && (r.Subtype = e.type.replace("/", "#2F"));
    const i = X7.MD5(X7.lib.WordArray.create(new Uint8Array(n)));
    r.Params.CheckSum = new String(i), r.Params.Size = n.byteLength;
    let a;
    this._fileRegistry || (this._fileRegistry = {});
    let o = this._fileRegistry[e.name];
    o && fre(r, o) ? a = o.ref : (a = this.ref(r), a.end(n), this._fileRegistry[e.name] = {
      ...r,
      ref: a
    });
    const s = {
      Type: "Filespec",
      AFRelationship: e.relationship,
      F: new String(e.name),
      EF: {
        F: a
      },
      UF: new String(e.name)
    };
    e.description && (s.Desc = new String(e.description));
    const l = this.ref(s);
    return l.end(), e.hidden || this.addNamedEmbeddedFile(e.name, l), this._root.data.AF ? this._root.data.AF.push(l) : this._root.data.AF = [l], l;
  }
};
function fre(t, e) {
  return t.Subtype === e.Subtype && t.Params.CheckSum.toString() === e.Params.CheckSum.toString() && t.Params.Size === e.Params.Size && t.Params.CreationDate.getTime() === e.Params.CreationDate.getTime() && (t.Params.ModDate === void 0 && e.Params.ModDate === void 0 || t.Params.ModDate.getTime() === e.Params.ModDate.getTime());
}
var dre = "/home/runner/work/react-pdf/react-pdf/packages/pdfkit/src/mixins", hre = {
  initPDFA(t) {
    t.charAt(t.length - 3) === "-" ? (this.subset_conformance = t.charAt(t.length - 1).toUpperCase(), this.subset = parseInt(t.charAt(t.length - 2))) : (this.subset_conformance = "B", this.subset = parseInt(t.charAt(t.length - 1)));
  },
  endSubset() {
    this._addPdfaMetadata(), this._addColorOutputIntent();
  },
  _addColorOutputIntent() {
    const t = lp.readFileSync(`${dre}/data/sRGB_IEC61966_2_1.icc`), e = this.ref({
      Length: t.length,
      N: 3
    });
    e.write(t), e.end();
    const r = this.ref({
      Type: "OutputIntent",
      S: "GTS_PDFA1",
      Info: new String("sRGB IEC61966-2.1"),
      OutputConditionIdentifier: new String("sRGB IEC61966-2.1"),
      DestOutputProfile: e
    });
    r.end(), this._root.data.OutputIntents = [r];
  },
  _getPdfaid() {
    return `
        <rdf:Description xmlns:pdfaid="http://www.aiim.org/pdfa/ns/id/" rdf:about="">
            <pdfaid:part>${this.subset}</pdfaid:part>
            <pdfaid:conformance>${this.subset_conformance}</pdfaid:conformance>
        </rdf:Description>
        `;
  },
  _addPdfaMetadata() {
    this.appendXML(this._getPdfaid());
  }
}, pre = {
  initPDFUA() {
    this.subset = 1;
  },
  endSubset() {
    this._addPdfuaMetadata();
  },
  _addPdfuaMetadata() {
    this.appendXML(this._getPdfuaid());
  },
  _getPdfuaid() {
    return `
        <rdf:Description xmlns:pdfuaid="http://www.aiim.org/pdfua/ns/id/" rdf:about="">
            <pdfuaid:part>${this.subset}</pdfuaid:part>
        </rdf:Description>
        `;
  }
}, mre = {
  _importSubset(t) {
    Object.assign(this, t);
  },
  initSubset(t) {
    switch (t.subset) {
      case "PDF/A-1":
      case "PDF/A-1a":
      case "PDF/A-1b":
      case "PDF/A-2":
      case "PDF/A-2a":
      case "PDF/A-2b":
      case "PDF/A-3":
      case "PDF/A-3a":
      case "PDF/A-3b":
        this._importSubset(hre), this.initPDFA(t.subset);
        break;
      case "PDF/UA":
        this._importSubset(pre), this.initPDFUA();
        break;
    }
  }
};
class gre {
  constructor() {
    this._metadata = `
        <?xpacket begin="\uFEFF" id="W5M0MpCehiHzreSzNTczkc9d"?>
            <x:xmpmeta xmlns:x="adobe:ns:meta/">
                <rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
        `;
  }
  _closeTags() {
    this._metadata = this._metadata.concat(`
                </rdf:RDF>
            </x:xmpmeta>
        <?xpacket end="w"?>
        `);
  }
  append(e, r) {
    r === void 0 && (r = !0), this._metadata = this._metadata.concat(e), r && (this._metadata = this._metadata.concat(`
`));
  }
  getXML() {
    return this._metadata;
  }
  getLength() {
    return this._metadata.length;
  }
  end() {
    this._closeTags(), this._metadata = this._metadata.trim();
  }
}
var vre = {
  initMetadata() {
    this.metadata = new gre();
  },
  appendXML(t, e) {
    e === void 0 && (e = !0), this.metadata.append(t, e);
  },
  _addInfo() {
    this.appendXML(`
        <rdf:Description rdf:about="" xmlns:xmp="http://ns.adobe.com/xap/1.0/">
            <xmp:CreateDate>${this.info.CreationDate.toISOString().split(".")[0] + "Z"}</xmp:CreateDate>
            <xmp:CreatorTool>${this.info.Creator}</xmp:CreatorTool>
        </rdf:Description>
        `), (this.info.Title || this.info.Author || this.info.Subject) && (this.appendXML(`
            <rdf:Description rdf:about="" xmlns:dc="http://purl.org/dc/elements/1.1/">
            `), this.info.Title && this.appendXML(`
                <dc:title>
                    <rdf:Alt>
                        <rdf:li xml:lang="x-default">${this.info.Title}</rdf:li>
                    </rdf:Alt>
                </dc:title>
                `), this.info.Author && this.appendXML(`
                <dc:creator>
                    <rdf:Seq>
                        <rdf:li>${this.info.Author}</rdf:li>
                    </rdf:Seq>
                </dc:creator>
                `), this.info.Subject && this.appendXML(`
                <dc:description>
                    <rdf:Alt>
                        <rdf:li xml:lang="x-default">${this.info.Subject}</rdf:li>
                    </rdf:Alt>
                </dc:description>
                `), this.appendXML(`
            </rdf:Description>
            `)), this.appendXML(`
        <rdf:Description rdf:about="" xmlns:pdf="http://ns.adobe.com/pdf/1.3/">
            <pdf:Producer>${this.info.Creator}</pdf:Producer>`, !1), this.info.Keywords && this.appendXML(`
            <pdf:Keywords>${this.info.Keywords}</pdf:Keywords>`, !1), this.appendXML(`
        </rdf:Description>
        `);
  },
  endMetadata() {
    this._addInfo(), this.metadata.end(), this.version != 1.3 && (this.metadataRef = this.ref({
      length: this.metadata.getLength(),
      Type: "Metadata",
      Subtype: "XML"
    }), this.metadataRef.compress = !1, this.metadataRef.write(Oe.from(this.metadata.getXML(), "utf-8")), this.metadataRef.end(), this._root.data.Metadata = this.metadataRef);
  }
};
class OT extends gT.Readable {
  constructor(e) {
    switch (e === void 0 && (e = {}), super(e), this.options = e, e.pdfVersion) {
      case "1.4":
        this.version = 1.4;
        break;
      case "1.5":
        this.version = 1.5;
        break;
      case "1.6":
        this.version = 1.6;
        break;
      case "1.7":
      case "1.7ext3":
        this.version = 1.7;
        break;
      default:
        this.version = 1.3;
        break;
    }
    this.compress = this.options.compress != null ? this.options.compress : !0, this._pageBuffer = [], this._pageBufferStart = 0, this._offsets = [], this._waiting = 0, this._ended = !1, this._offset = 0;
    const r = this.ref({
      Type: "Pages",
      Count: 0,
      Kids: []
    }), n = this.ref({
      Dests: new v5()
    });
    if (this._root = this.ref({
      Type: "Catalog",
      Pages: r,
      Names: n
    }), this.options.lang && (this._root.data.Lang = new String(this.options.lang)), this.page = null, this.initMetadata(), this.initColor(), this.initVector(), this.initFonts(e.font), this.initText(), this.initImages(), this.initOutline(), this.initMarkings(e), this.initSubset(e), this.info = {
      Producer: "PDFKit",
      Creator: "PDFKit",
      CreationDate: /* @__PURE__ */ new Date()
    }, this.options.info)
      for (let i in this.options.info) {
        const a = this.options.info[i];
        this.info[i] = a;
      }
    this.options.displayTitle && (this._root.data.ViewerPreferences = this.ref({
      DisplayDocTitle: !0
    })), this._id = y0e.generateFileID(this.info), this._write(`%PDF-${this.version}`), this._write("%ÿÿÿÿ"), this.options.autoFirstPage !== !1 && this.addPage();
  }
  addPage(e) {
    e == null && ({
      options: e
    } = this), this.options.bufferPages || this.flushPages(), this.page = new b0e(this, e), this._pageBuffer.push(this.page);
    const r = this._root.data.Pages.data;
    return r.Kids.push(this.page.dictionary), r.Count++, this.x = this.page.margins.left, this.y = this.page.margins.top, this._ctm = [1, 0, 0, 1, 0, 0], this.transform(1, 0, 0, -1, 0, this.page.height), this.emit("pageAdded"), this;
  }
  continueOnNewPage(e) {
    const r = this.endPageMarkings(this.page);
    return this.addPage(e ?? this.page._options), this.initPageMarkings(r), this;
  }
  bufferedPageRange() {
    return {
      start: this._pageBufferStart,
      count: this._pageBuffer.length
    };
  }
  switchToPage(e) {
    let r;
    if (!(r = this._pageBuffer[e - this._pageBufferStart]))
      throw new Error(`switchToPage(${e}) out of bounds, current buffer covers pages ${this._pageBufferStart} to ${this._pageBufferStart + this._pageBuffer.length - 1}`);
    return this.page = r;
  }
  flushPages() {
    const e = this._pageBuffer;
    this._pageBuffer = [], this._pageBufferStart += e.length;
    for (let r of e)
      this.endPageMarkings(r), r.end();
  }
  addNamedDestination(e) {
    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
      n[i - 1] = arguments[i];
    n.length === 0 && (n = ["XYZ", null, null, null]), n[0] === "XYZ" && n[2] !== null && (n[2] = this.page.height - n[2]), n.unshift(this.page.dictionary), this._root.data.Names.data.Dests.add(e, n);
  }
  addNamedEmbeddedFile(e, r) {
    this._root.data.Names.data.EmbeddedFiles || (this._root.data.Names.data.EmbeddedFiles = new v5({
      limits: !1
    })), this._root.data.Names.data.EmbeddedFiles.add(e, r);
  }
  addNamedJavaScript(e, r) {
    this._root.data.Names.data.JavaScript || (this._root.data.Names.data.JavaScript = new v5());
    let n = {
      JS: new String(r),
      S: "JavaScript"
    };
    this._root.data.Names.data.JavaScript.add(e, n);
  }
  ref(e) {
    const r = new CT(this, this._offsets.length + 1, e);
    return this._offsets.push(null), this._waiting++, r;
  }
  _read() {
  }
  // do nothing, but this method is required by node
  _write(e) {
    return Oe.isBuffer(e) || (e = Oe.from(e + `
`, "binary")), this.push(e), this._offset += e.length;
  }
  addContent(e) {
    return this.page.write(e), this;
  }
  _refEnd(e) {
    if (this._offsets[e.id - 1] = e.offset, --this._waiting === 0 && this._ended)
      return this._finalize(), this._ended = !1;
  }
  end() {
    this.flushPages(), this._info = this.ref();
    for (let e in this.info) {
      let r = this.info[e];
      typeof r == "string" && (r = new String(r));
      let n = this.ref(r);
      n.end(), this._info.data[e] = n;
    }
    this._info.end();
    for (let e in this._fontFamilies)
      this._fontFamilies[e].finalize();
    return this.endOutline(), this.endMarkings(), this.subset && this.endSubset(), this.endMetadata(), this._root.end(), this._root.data.Pages.end(), this._root.data.Names.end(), this.endAcroForm(), this._root.data.ViewerPreferences && this._root.data.ViewerPreferences.end(), this._security && this._security.end(), this._waiting === 0 ? this._finalize() : this._ended = !0;
  }
  _finalize() {
    const e = this._offset;
    this._write("xref"), this._write(`0 ${this._offsets.length + 1}`), this._write("0000000000 65535 f ");
    for (let n of this._offsets)
      n = `0000000000${n}`.slice(-10), this._write(n + " 00000 n ");
    const r = {
      Size: this._offsets.length + 1,
      Root: this._root,
      Info: this._info,
      ID: [this._id, this._id]
    };
    return this._security && (r.Encrypt = this._security.dictionary), this._write("trailer"), this._write(Qi.convert(r)), this._write("startxref"), this._write(`${e}`), this._write("%%EOF"), this.push(null);
  }
  toString() {
    return "[object PDFDocument]";
  }
}
const Fa = (t) => {
  Object.assign(OT.prototype, t);
};
Fa(vre);
Fa(O0e);
Fa(z0e);
Fa(J0e);
Fa(Q0e);
Fa(ire);
Fa(are);
Fa(ore);
Fa(lre);
Fa(ure);
Fa(cre);
Fa(mre);
OT.LineWrapper = V3;
const bre = [
  "Courier",
  "Courier-Bold",
  "Courier-Oblique",
  "Courier-BoldOblique",
  "Helvetica",
  "Helvetica-Bold",
  "Helvetica-Oblique",
  "Helvetica-BoldOblique",
  "Times-Roman",
  "Times-Bold",
  "Times-Italic",
  "Times-BoldItalic"
];
class xre {
  name;
  src;
  fullName;
  familyName;
  subfamilyName;
  postscriptName;
  copyright;
  version;
  underlinePosition;
  underlineThickness;
  italicAngle;
  bbox;
  "OS/2";
  hhea;
  numGlyphs;
  characterSet;
  availableFeatures;
  type;
  constructor(e) {
    this.name = e, this.fullName = e, this.familyName = e, this.subfamilyName = e, this.type = "STANDARD", this.postscriptName = e, this.availableFeatures = [], this.copyright = "", this.version = 1, this.underlinePosition = -100, this.underlineThickness = 50, this.italicAngle = 0, this.bbox = {}, this["OS/2"] = {}, this.hhea = {}, this.numGlyphs = 0, this.characterSet = [], this.src = Am.open(null, e);
  }
  encode(e) {
    return this.src.encode(e);
  }
  layout(e) {
    const [r, n] = this.encode(e), i = r.map((o, s) => {
      const l = this.getGlyph(parseInt(o, 16));
      return l.advanceWidth = n[s].advanceWidth, l;
    }), a = n.reduce((o, s) => o + s.advanceWidth, 0);
    return {
      positions: n,
      stringIndices: n.map((o, s) => s),
      glyphs: i,
      script: "latin",
      language: "dflt",
      direction: "ltr",
      features: {},
      advanceWidth: a,
      advanceHeight: 0,
      bbox: void 0
    };
  }
  glyphForCodePoint(e) {
    const r = this.getGlyph(e);
    return r.advanceWidth = 400, r;
  }
  getGlyph(e) {
    return {
      id: e,
      codePoints: [e],
      isLigature: !1,
      name: this.src.font.characterToGlyph(e),
      _font: this.src,
      // @ts-expect-error assign proper value
      advanceWidth: void 0
    };
  }
  hasGlyphForCodePoint(e) {
    return this.src.font.characterToGlyph(e) !== ".notdef";
  }
  // Based on empirical observation
  get ascent() {
    return 900;
  }
  // Based on empirical observation
  get capHeight() {
    switch (this.name) {
      case "Times-Roman":
      case "Times-Bold":
      case "Times-Italic":
      case "Times-BoldItalic":
        return 650;
      case "Courier":
      case "Courier-Bold":
      case "Courier-Oblique":
      case "Courier-BoldOblique":
        return 550;
      default:
        return 690;
    }
  }
  // Based on empirical observation
  get xHeight() {
    switch (this.name) {
      case "Times-Roman":
      case "Times-Bold":
      case "Times-Italic":
      case "Times-BoldItalic":
        return 440;
      case "Courier":
      case "Courier-Bold":
      case "Courier-Oblique":
      case "Courier-BoldOblique":
        return 390;
      default:
        return 490;
    }
  }
  // Based on empirical observation
  get descent() {
    switch (this.name) {
      case "Times-Roman":
      case "Times-Bold":
      case "Times-Italic":
      case "Times-BoldItalic":
        return -220;
      case "Courier":
      case "Courier-Bold":
      case "Courier-Oblique":
      case "Courier-BoldOblique":
        return -230;
      default:
        return -200;
    }
  }
  get lineGap() {
    return 0;
  }
  get unitsPerEm() {
    return 1e3;
  }
  stringsForGlyph() {
    throw new Error("Method not implemented.");
  }
  glyphsForString() {
    throw new Error("Method not implemented.");
  }
  widthOfGlyph() {
    throw new Error("Method not implemented.");
  }
  getAvailableFeatures() {
    throw new Error("Method not implemented.");
  }
  createSubset() {
    throw new Error("Method not implemented.");
  }
  getVariation() {
    throw new Error("Method not implemented.");
  }
  getFont() {
    throw new Error("Method not implemented.");
  }
  getName() {
    throw new Error("Method not implemented.");
  }
  setDefaultLanguage() {
    throw new Error("Method not implemented.");
  }
}
const yre = async (t, e) => {
  const n = await (await fetch(t, e)).arrayBuffer();
  return new Uint8Array(n);
}, wre = (t) => {
  const e = t.split(",")[0], r = e.substring(0, 5) === "data:", n = e.split(";")[1] === "base64";
  return r && n;
};
class _re {
  src;
  fontFamily;
  fontStyle;
  fontWeight;
  data;
  options;
  loadResultPromise;
  constructor(e, r, n, i, a) {
    this.src = e, this.fontFamily = r, this.fontStyle = n || "normal", this.fontWeight = i || 400, this.data = null, this.options = a || {}, this.loadResultPromise = null;
  }
  async _load() {
    const { postscriptName: e } = this.options;
    let r = null;
    if (bre.includes(this.src))
      r = new xre(this.src);
    else if (wre(this.src)) {
      const n = this.src.split(",")[1], i = new Uint8Array(atob(n).split("").map((a) => a.charCodeAt(0)));
      r = Qd(i, e);
    } else {
      const { headers: n, body: i, method: a = "GET" } = this.options, o = await yre(this.src, { method: a, body: i, headers: n });
      r = Qd(o, e);
    }
    if (r && "fonts" in r)
      throw new Error("Font collection is not supported");
    this.data = r;
  }
  async load() {
    return this.loadResultPromise === null && (this.loadResultPromise = this._load()), this.loadResultPromise;
  }
}
const Are = {
  thin: 100,
  hairline: 100,
  ultralight: 200,
  extralight: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  demibold: 600,
  bold: 700,
  ultrabold: 800,
  extrabold: 800,
  heavy: 900,
  black: 900
}, L9 = (t) => typeof t == "string" ? Are[t] : t, N9 = (t, e) => t.fontWeight - e.fontWeight;
class jx {
  family;
  sources;
  static create(e) {
    return new jx(e);
  }
  constructor(e) {
    this.family = e, this.sources = [];
  }
  register({ src: e, fontWeight: r, fontStyle: n, ...i }) {
    const a = r ? L9(r) : void 0;
    this.sources.push(new _re(e, this.family, n, a, i));
  }
  resolve(e) {
    const { fontWeight: r = 400, fontStyle: n = "normal" } = e, i = this.sources.filter((d) => d.fontStyle === n), a = i.find((d) => d.fontWeight === r);
    if (a)
      return a;
    let o = null;
    const s = L9(r);
    if (s >= 400 && s <= 500) {
      const d = i.filter((b) => b.fontWeight <= s), h = i.filter((b) => b.fontWeight > 500);
      o = i.filter((b) => b.fontWeight >= s && b.fontWeight < 500)[0] || d[d.length - 1] || h[0];
    }
    const l = i.filter((d) => d.fontWeight < s).sort(N9), u = i.filter((d) => d.fontWeight > s).sort(N9);
    if (s < 400 && (o = l[l.length - 1] || u[0]), s > 500 && (o = u[0] || l[l.length - 1]), !o)
      throw new Error(`Could not resolve font for ${this.family}, fontWeight ${r}, fontStyle ${n}`);
    return o;
  }
}
class Ere {
  fontFamilies = {};
  emojiSource = null;
  constructor() {
    this.register({
      family: "Helvetica",
      fonts: [
        { src: "Helvetica", fontStyle: "normal", fontWeight: 400 },
        { src: "Helvetica-Bold", fontStyle: "normal", fontWeight: 700 },
        { src: "Helvetica-Oblique", fontStyle: "italic", fontWeight: 400 },
        { src: "Helvetica-BoldOblique", fontStyle: "italic", fontWeight: 700 }
      ]
    }), this.register({
      family: "Courier",
      fonts: [
        { src: "Courier", fontStyle: "normal", fontWeight: 400 },
        { src: "Courier-Bold", fontStyle: "normal", fontWeight: 700 },
        { src: "Courier-Oblique", fontStyle: "italic", fontWeight: 400 },
        { src: "Courier-BoldOblique", fontStyle: "italic", fontWeight: 700 }
      ]
    }), this.register({
      family: "Times-Roman",
      fonts: [
        { src: "Times-Roman", fontStyle: "normal", fontWeight: 400 },
        { src: "Times-Bold", fontStyle: "normal", fontWeight: 700 },
        { src: "Times-Italic", fontStyle: "italic", fontWeight: 400 },
        { src: "Times-BoldItalic", fontStyle: "italic", fontWeight: 700 }
      ]
    }), this.register({
      family: "Helvetica-Bold",
      src: "Helvetica-Bold"
    }), this.register({
      family: "Helvetica-Oblique",
      src: "Helvetica-Oblique"
    }), this.register({
      family: "Helvetica-BoldOblique",
      src: "Helvetica-BoldOblique"
    }), this.register({
      family: "Courier-Bold",
      src: "Courier-Bold"
    }), this.register({
      family: "Courier-Oblique",
      src: "Courier-Oblique"
    }), this.register({
      family: "Courier-BoldOblique",
      src: "Courier-BoldOblique"
    }), this.register({
      family: "Times-Bold",
      src: "Times-Bold"
    }), this.register({
      family: "Times-Italic",
      src: "Times-Italic"
    }), this.register({
      family: "Times-BoldItalic",
      src: "Times-BoldItalic"
    }), this.load({
      fontFamily: "Helvetica",
      fontStyle: "normal",
      fontWeight: 400
    }), this.load({
      fontFamily: "Helvetica",
      fontStyle: "normal",
      fontWeight: 700
    }), this.load({
      fontFamily: "Helvetica",
      fontStyle: "italic",
      fontWeight: 400
    }), this.load({
      fontFamily: "Helvetica",
      fontStyle: "italic",
      fontWeight: 700
    });
  }
  hyphenationCallback = null;
  register = (e) => {
    const { family: r } = e;
    if (this.fontFamilies[r] || (this.fontFamilies[r] = jx.create(r)), "fonts" in e)
      for (let n = 0; n < e.fonts.length; n += 1) {
        const { src: i, fontStyle: a, fontWeight: o, ...s } = e.fonts[n];
        this.fontFamilies[r].register({
          src: i,
          fontStyle: a,
          fontWeight: o,
          ...s
        });
      }
    else {
      const { src: n, fontStyle: i, fontWeight: a, ...o } = e;
      this.fontFamilies[r].register({
        src: n,
        fontStyle: i,
        fontWeight: a,
        ...o
      });
    }
  };
  registerEmojiSource = (e) => {
    this.emojiSource = e;
  };
  registerHyphenationCallback = (e) => {
    this.hyphenationCallback = e;
  };
  getFont = (e) => {
    const { fontFamily: r } = e;
    if (!this.fontFamilies[r])
      throw new Error(`Font family not registered: ${r}. Please register it calling Font.register() method.`);
    return this.fontFamilies[r].resolve(e);
  };
  load = async (e) => {
    const r = this.getFont(e);
    r && await r.load();
  };
  reset = () => {
    const e = Object.keys(this.fontFamilies);
    for (let r = 0; r < e.length; r += 1) {
      const n = e[r];
      for (let i = 0; i < this.fontFamilies[n].sources.length; i++) {
        const a = this.fontFamilies[n].sources[i];
        a.data = null;
      }
    }
  };
  clear = () => {
    this.fontFamilies = {};
  };
  getRegisteredFonts = () => this.fontFamilies;
  getEmojiSource = () => this.emojiSource;
  getHyphenationCallback = () => this.hyphenationCallback;
  getRegisteredFontFamilies = () => Object.keys(this.fontFamilies);
}
const M9 = (t) => t == null, Sre = (t) => /((-)?\d+\.?\d*)%/g.exec(`${t}`), Cre = (t) => {
  const e = Sre(t);
  if (e) {
    const r = parseFloat(e[1]);
    return { percent: r / 100, value: r };
  }
  return null;
}, kre = (t) => t && t.charAt(0).toUpperCase() + t.slice(1), Tre = (t, e) => {
  const r = [];
  for (let n = 0; n < e.length; n += 1) {
    const i = e[n];
    t.includes(i) || r.push(i);
  }
  return r;
};
var Fre = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
}, RT = { exports: {} }, Dre = function(e) {
  return !e || typeof e == "string" ? !1 : e instanceof Array || Array.isArray(e) || e.length >= 0 && (e.splice instanceof Function || Object.getOwnPropertyDescriptor(e, e.length - 1) && e.constructor.name !== "String");
}, Ore = Dre, Rre = Array.prototype.concat, Pre = Array.prototype.slice, U9 = RT.exports = function(e) {
  for (var r = [], n = 0, i = e.length; n < i; n++) {
    var a = e[n];
    Ore(a) ? r = Rre.call(r, Pre.call(a)) : r.push(a);
  }
  return r;
};
U9.wrap = function(t) {
  return function() {
    return t(U9(arguments));
  };
};
var Ire = RT.exports, Wd = Fre, Yh = Ire, PT = Object.hasOwnProperty, IT = /* @__PURE__ */ Object.create(null);
for (var Ov in Wd)
  PT.call(Wd, Ov) && (IT[Wd[Ov]] = Ov);
var Xi = {
  to: {},
  get: {}
};
Xi.get = function(t) {
  var e = t.substring(0, 3).toLowerCase(), r, n;
  switch (e) {
    case "hsl":
      r = Xi.get.hsl(t), n = "hsl";
      break;
    case "hwb":
      r = Xi.get.hwb(t), n = "hwb";
      break;
    default:
      r = Xi.get.rgb(t), n = "rgb";
      break;
  }
  return r ? { model: n, value: r } : null;
};
Xi.get.rgb = function(t) {
  if (!t)
    return null;
  var e = /^#([a-f0-9]{3,4})$/i, r = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i, n = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, i = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, a = /^(\w+)$/, o = [0, 0, 0, 1], s, l, u;
  if (s = t.match(r)) {
    for (u = s[2], s = s[1], l = 0; l < 3; l++) {
      var d = l * 2;
      o[l] = parseInt(s.slice(d, d + 2), 16);
    }
    u && (o[3] = parseInt(u, 16) / 255);
  } else if (s = t.match(e)) {
    for (s = s[1], u = s[3], l = 0; l < 3; l++)
      o[l] = parseInt(s[l] + s[l], 16);
    u && (o[3] = parseInt(u + u, 16) / 255);
  } else if (s = t.match(n)) {
    for (l = 0; l < 3; l++)
      o[l] = parseInt(s[l + 1], 0);
    s[4] && (s[5] ? o[3] = parseFloat(s[4]) * 0.01 : o[3] = parseFloat(s[4]));
  } else if (s = t.match(i)) {
    for (l = 0; l < 3; l++)
      o[l] = Math.round(parseFloat(s[l + 1]) * 2.55);
    s[4] && (s[5] ? o[3] = parseFloat(s[4]) * 0.01 : o[3] = parseFloat(s[4]));
  } else return (s = t.match(a)) ? s[1] === "transparent" ? [0, 0, 0, 0] : PT.call(Wd, s[1]) ? (o = Wd[s[1]], o[3] = 1, o) : null : null;
  for (l = 0; l < 3; l++)
    o[l] = nu(o[l], 0, 255);
  return o[3] = nu(o[3], 0, 1), o;
};
Xi.get.hsl = function(t) {
  if (!t)
    return null;
  var e = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, r = t.match(e);
  if (r) {
    var n = parseFloat(r[4]), i = (parseFloat(r[1]) % 360 + 360) % 360, a = nu(parseFloat(r[2]), 0, 100), o = nu(parseFloat(r[3]), 0, 100), s = nu(isNaN(n) ? 1 : n, 0, 1);
    return [i, a, o, s];
  }
  return null;
};
Xi.get.hwb = function(t) {
  if (!t)
    return null;
  var e = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, r = t.match(e);
  if (r) {
    var n = parseFloat(r[4]), i = (parseFloat(r[1]) % 360 + 360) % 360, a = nu(parseFloat(r[2]), 0, 100), o = nu(parseFloat(r[3]), 0, 100), s = nu(isNaN(n) ? 1 : n, 0, 1);
    return [i, a, o, s];
  }
  return null;
};
Xi.to.hex = function() {
  var t = Yh(arguments);
  return "#" + j2(t[0]) + j2(t[1]) + j2(t[2]) + (t[3] < 1 ? j2(Math.round(t[3] * 255)) : "");
};
Xi.to.rgb = function() {
  var t = Yh(arguments);
  return t.length < 4 || t[3] === 1 ? "rgb(" + Math.round(t[0]) + ", " + Math.round(t[1]) + ", " + Math.round(t[2]) + ")" : "rgba(" + Math.round(t[0]) + ", " + Math.round(t[1]) + ", " + Math.round(t[2]) + ", " + t[3] + ")";
};
Xi.to.rgb.percent = function() {
  var t = Yh(arguments), e = Math.round(t[0] / 255 * 100), r = Math.round(t[1] / 255 * 100), n = Math.round(t[2] / 255 * 100);
  return t.length < 4 || t[3] === 1 ? "rgb(" + e + "%, " + r + "%, " + n + "%)" : "rgba(" + e + "%, " + r + "%, " + n + "%, " + t[3] + ")";
};
Xi.to.hsl = function() {
  var t = Yh(arguments);
  return t.length < 4 || t[3] === 1 ? "hsl(" + t[0] + ", " + t[1] + "%, " + t[2] + "%)" : "hsla(" + t[0] + ", " + t[1] + "%, " + t[2] + "%, " + t[3] + ")";
};
Xi.to.hwb = function() {
  var t = Yh(arguments), e = "";
  return t.length >= 4 && t[3] !== 1 && (e = ", " + t[3]), "hwb(" + t[0] + ", " + t[1] + "%, " + t[2] + "%" + e + ")";
};
Xi.to.keyword = function(t) {
  return IT[t.slice(0, 3)];
};
function nu(t, e, r) {
  return Math.min(Math.max(e, t), r);
}
function j2(t) {
  var e = Math.round(t).toString(16).toUpperCase();
  return e.length < 2 ? "0" + e : e;
}
function Wx() {
  var t = function(e) {
    var r = {
      R: "13k,1a,2,3,3,2+1j,ch+16,a+1,5+2,2+n,5,a,4,6+16,4+3,h+1b,4mo,179q,2+9,2+11,2i9+7y,2+68,4,3+4,5+13,4+3,2+4k,3+29,8+cf,1t+7z,w+17,3+3m,1t+3z,16o1+5r,8+30,8+mc,29+1r,29+4v,75+73",
      EN: "1c+9,3d+1,6,187+9,513,4+5,7+9,sf+j,175h+9,qw+q,161f+1d,4xt+a,25i+9",
      ES: "17,2,6dp+1,f+1,av,16vr,mx+1,4o,2",
      ET: "z+2,3h+3,b+1,ym,3e+1,2o,p4+1,8,6u,7c,g6,1wc,1n9+4,30+1b,2n,6d,qhx+1,h0m,a+1,49+2,63+1,4+1,6bb+3,12jj",
      AN: "16o+5,2j+9,2+1,35,ed,1ff2+9,87+u",
      CS: "18,2+1,b,2u,12k,55v,l,17v0,2,3,53,2+1,b",
      B: "a,3,f+2,2v,690",
      S: "9,2,k",
      WS: "c,k,4f4,1vk+a,u,1j,335",
      ON: "x+1,4+4,h+5,r+5,r+3,z,5+3,2+1,2+1,5,2+2,3+4,o,w,ci+1,8+d,3+d,6+8,2+g,39+1,9,6+1,2,33,b8,3+1,3c+1,7+1,5r,b,7h+3,sa+5,2,3i+6,jg+3,ur+9,2v,ij+1,9g+9,7+a,8m,4+1,49+x,14u,2+2,c+2,e+2,e+2,e+1,i+n,e+e,2+p,u+2,e+2,36+1,2+3,2+1,b,2+2,6+5,2,2,2,h+1,5+4,6+3,3+f,16+2,5+3l,3+81,1y+p,2+40,q+a,m+13,2r+ch,2+9e,75+hf,3+v,2+2w,6e+5,f+6,75+2a,1a+p,2+2g,d+5x,r+b,6+3,4+o,g,6+1,6+2,2k+1,4,2j,5h+z,1m+1,1e+f,t+2,1f+e,d+3,4o+3,2s+1,w,535+1r,h3l+1i,93+2,2s,b+1,3l+x,2v,4g+3,21+3,kz+1,g5v+1,5a,j+9,n+v,2,3,2+8,2+1,3+2,2,3,46+1,4+4,h+5,r+5,r+a,3h+2,4+6,b+4,78,1r+24,4+c,4,1hb,ey+6,103+j,16j+c,1ux+7,5+g,fsh,jdq+1t,4,57+2e,p1,1m,1m,1m,1m,4kt+1,7j+17,5+2r,d+e,3+e,2+e,2+10,m+4,w,1n+5,1q,4z+5,4b+rb,9+c,4+c,4+37,d+2g,8+b,l+b,5+1j,9+9,7+13,9+t,3+1,27+3c,2+29,2+3q,d+d,3+4,4+2,6+6,a+o,8+6,a+2,e+6,16+42,2+1i",
      BN: "0+8,6+d,2s+5,2+p,e,4m9,1kt+2,2b+5,5+5,17q9+v,7k,6p+8,6+1,119d+3,440+7,96s+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+75,6p+2rz,1ben+1,1ekf+1,1ekf+1",
      NSM: "lc+33,7o+6,7c+18,2,2+1,2+1,2,21+a,1d+k,h,2u+6,3+5,3+1,2+3,10,v+q,2k+a,1n+8,a,p+3,2+8,2+2,2+4,18+2,3c+e,2+v,1k,2,5+7,5,4+6,b+1,u,1n,5+3,9,l+1,r,3+1,1m,5+1,5+1,3+2,4,v+1,4,c+1,1m,5+4,2+1,5,l+1,n+5,2,1n,3,2+3,9,8+1,c+1,v,1q,d,1f,4,1m+2,6+2,2+3,8+1,c+1,u,1n,g+1,l+1,t+1,1m+1,5+3,9,l+1,u,21,8+2,2,2j,3+6,d+7,2r,3+8,c+5,23+1,s,2,2,1k+d,2+4,2+1,6+a,2+z,a,2v+3,2+5,2+1,3+1,q+1,5+2,h+3,e,3+1,7,g,jk+2,qb+2,u+2,u+1,v+1,1t+1,2+6,9,3+a,a,1a+2,3c+1,z,3b+2,5+1,a,7+2,64+1,3,1n,2+6,2,2,3+7,7+9,3,1d+g,1s+3,1d,2+4,2,6,15+8,d+1,x+3,3+1,2+2,1l,2+1,4,2+2,1n+7,3+1,49+2,2+c,2+6,5,7,4+1,5j+1l,2+4,k1+w,2db+2,3y,2p+v,ff+3,30+1,n9x+3,2+9,x+1,29+1,7l,4,5,q+1,6,48+1,r+h,e,13+7,q+a,1b+2,1d,3+3,3+1,14,1w+5,3+1,3+1,d,9,1c,1g,2+2,3+1,6+1,2,17+1,9,6n,3,5,fn5,ki+f,h+f,r2,6b,46+4,1af+2,2+1,6+3,15+2,5,4m+1,fy+3,as+1,4a+a,4x,1j+e,1l+2,1e+3,3+1,1y+2,11+4,2+7,1r,d+1,1h+8,b+3,3,2o+2,3,2+1,7,4h,4+7,m+1,1m+1,4,12+6,4+4,5g+7,3+2,2,o,2d+5,2,5+1,2+1,6n+3,7+1,2+1,s+1,2e+7,3,2+1,2z,2,3+5,2,2u+2,3+3,2+4,78+8,2+1,75+1,2,5,41+3,3+1,5,x+5,3+1,15+5,3+3,9,a+5,3+2,1b+c,2+1,bb+6,2+5,2d+l,3+6,2+1,2+1,3f+5,4,2+1,2+6,2,21+1,4,2,9o+1,f0c+4,1o+6,t5,1s+3,2a,f5l+1,43t+2,i+7,3+6,v+3,45+2,1j0+1i,5+1d,9,f,n+4,2+e,11t+6,2+g,3+6,2+1,2+4,7a+6,c6+3,15t+6,32+6,gzhy+6n",
      AL: "16w,3,2,e+1b,z+2,2+2s,g+1,8+1,b+m,2+t,s+2i,c+e,4h+f,1d+1e,1bwe+dp,3+3z,x+c,2+1,35+3y,2rm+z,5+7,b+5,dt+l,c+u,17nl+27,1t+27,4x+6n,3+d",
      LRO: "6ct",
      RLO: "6cu",
      LRE: "6cq",
      RLE: "6cr",
      PDF: "6cs",
      LRI: "6ee",
      RLI: "6ef",
      FSI: "6eg",
      PDI: "6eh"
    }, n = {}, i = {};
    n.L = 1, i[1] = "L", Object.keys(r).forEach(function(W, ee) {
      n[W] = 1 << ee + 1, i[n[W]] = W;
    }), Object.freeze(n);
    var a = n.LRI | n.RLI | n.FSI, o = n.L | n.R | n.AL, s = n.B | n.S | n.WS | n.ON | n.FSI | n.LRI | n.RLI | n.PDI, l = n.BN | n.RLE | n.LRE | n.RLO | n.LRO | n.PDF, u = n.S | n.WS | n.B | a | n.PDI | l, d = null;
    function h() {
      if (!d) {
        d = /* @__PURE__ */ new Map();
        var W = function(le) {
          if (r.hasOwnProperty(le)) {
            var me = 0;
            r[le].split(",").forEach(function(Ee) {
              var ve = Ee.split("+"), Te = ve[0], Pe = ve[1];
              Te = parseInt(Te, 36), Pe = Pe ? parseInt(Pe, 36) : 0, d.set(me += Te, n[le]);
              for (var at = 0; at < Pe; at++)
                d.set(++me, n[le]);
            });
          }
        };
        for (var ee in r) W(ee);
      }
    }
    function v(W) {
      return h(), d.get(W.codePointAt(0)) || n.L;
    }
    function b(W) {
      return i[v(W)];
    }
    var x = {
      pairs: "14>1,1e>2,u>2,2wt>1,1>1,1ge>1,1wp>1,1j>1,f>1,hm>1,1>1,u>1,u6>1,1>1,+5,28>1,w>1,1>1,+3,b8>1,1>1,+3,1>3,-1>-1,3>1,1>1,+2,1s>1,1>1,x>1,th>1,1>1,+2,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,4q>1,1e>2,u>2,2>1,+1",
      canonical: "6f1>-6dx,6dy>-6dx,6ec>-6ed,6ee>-6ed,6ww>2jj,-2ji>2jj,14r4>-1e7l,1e7m>-1e7l,1e7m>-1e5c,1e5d>-1e5b,1e5c>-14qx,14qy>-14qx,14vn>-1ecg,1ech>-1ecg,1edu>-1ecg,1eci>-1ecg,1eda>-1ecg,1eci>-1ecg,1eci>-168q,168r>-168q,168s>-14ye,14yf>-14ye"
    };
    function A(W, ee) {
      var le = 36, me = 0, Ee = /* @__PURE__ */ new Map(), ve = ee && /* @__PURE__ */ new Map(), Te;
      return W.split(",").forEach(function Pe(at) {
        if (at.indexOf("+") !== -1)
          for (var Ue = +at; Ue--; )
            Pe(Te);
        else {
          Te = at;
          var rt = at.split(">"), gt = rt[0], _t = rt[1];
          gt = String.fromCodePoint(me += parseInt(gt, le)), _t = String.fromCodePoint(me += parseInt(_t, le)), Ee.set(gt, _t), ee && ve.set(_t, gt);
        }
      }), { map: Ee, reverseMap: ve };
    }
    var T, k, E;
    function C() {
      if (!T) {
        var W = A(x.pairs, !0), ee = W.map, le = W.reverseMap;
        T = ee, k = le, E = A(x.canonical, !1).map;
      }
    }
    function D(W) {
      return C(), T.get(W) || null;
    }
    function _(W) {
      return C(), k.get(W) || null;
    }
    function I(W) {
      return C(), E.get(W) || null;
    }
    var R = n.L, U = n.R, V = n.EN, z = n.ES, j = n.ET, S = n.AN, B = n.CS, q = n.B, Y = n.S, Z = n.ON, Q = n.BN, J = n.NSM, se = n.AL, ae = n.LRO, te = n.RLO, ne = n.LRE, ce = n.RLE, pe = n.PDF, Me = n.LRI, Ne = n.RLI, it = n.FSI, fe = n.PDI;
    function ye(W, ee) {
      for (var le = 125, me = new Uint32Array(W.length), Ee = 0; Ee < W.length; Ee++)
        me[Ee] = v(W[Ee]);
      var ve = /* @__PURE__ */ new Map();
      function Te(o0, Wr) {
        var sr = me[o0];
        me[o0] = Wr, ve.set(sr, ve.get(sr) - 1), sr & s && ve.set(s, ve.get(s) - 1), ve.set(Wr, (ve.get(Wr) || 0) + 1), Wr & s && ve.set(s, (ve.get(s) || 0) + 1);
      }
      for (var Pe = new Uint8Array(W.length), at = /* @__PURE__ */ new Map(), Ue = [], rt = null, gt = 0; gt < W.length; gt++)
        rt || Ue.push(rt = {
          start: gt,
          end: W.length - 1,
          // 3.3.1 P2-P3: Determine the paragraph level
          level: ee === "rtl" ? 1 : ee === "ltr" ? 0 : Dr(gt, !1)
        }), me[gt] & q && (rt.end = gt, rt = null);
      for (var _t = ce | ne | te | ae | a | fe | pe | q, Bt = function(o0) {
        return o0 + (o0 & 1 ? 1 : 2);
      }, At = function(o0) {
        return o0 + (o0 & 1 ? 2 : 1);
      }, Tt = 0; Tt < Ue.length; Tt++) {
        rt = Ue[Tt];
        var Je = [{
          _level: rt.level,
          _override: 0,
          //0=neutral, 1=L, 2=R
          _isolate: 0
          //bool
        }], ot = void 0, R0 = 0, b0 = 0, ir = 0;
        ve.clear();
        for (var a0 = rt.start; a0 <= rt.end; a0++) {
          var e0 = me[a0];
          if (ot = Je[Je.length - 1], ve.set(e0, (ve.get(e0) || 0) + 1), e0 & s && ve.set(s, (ve.get(s) || 0) + 1), e0 & _t)
            if (e0 & (ce | ne)) {
              Pe[a0] = ot._level;
              var kr = (e0 === ce ? At : Bt)(ot._level);
              kr <= le && !R0 && !b0 ? Je.push({
                _level: kr,
                _override: 0,
                _isolate: 0
              }) : R0 || b0++;
            } else if (e0 & (te | ae)) {
              Pe[a0] = ot._level;
              var br = (e0 === te ? At : Bt)(ot._level);
              br <= le && !R0 && !b0 ? Je.push({
                _level: br,
                _override: e0 & te ? U : R,
                _isolate: 0
              }) : R0 || b0++;
            } else if (e0 & a) {
              e0 & it && (e0 = Dr(a0 + 1, !0) === 1 ? Ne : Me), Pe[a0] = ot._level, ot._override && Te(a0, ot._override);
              var Br = (e0 === Ne ? At : Bt)(ot._level);
              Br <= le && R0 === 0 && b0 === 0 ? (ir++, Je.push({
                _level: Br,
                _override: 0,
                _isolate: 1,
                _isolInitIndex: a0
              })) : R0++;
            } else if (e0 & fe) {
              if (R0 > 0)
                R0--;
              else if (ir > 0) {
                for (b0 = 0; !Je[Je.length - 1]._isolate; )
                  Je.pop();
                var Mt = Je[Je.length - 1]._isolInitIndex;
                Mt != null && (at.set(Mt, a0), at.set(a0, Mt)), Je.pop(), ir--;
              }
              ot = Je[Je.length - 1], Pe[a0] = ot._level, ot._override && Te(a0, ot._override);
            } else e0 & pe ? (R0 === 0 && (b0 > 0 ? b0-- : !ot._isolate && Je.length > 1 && (Je.pop(), ot = Je[Je.length - 1])), Pe[a0] = ot._level) : e0 & q && (Pe[a0] = rt.level);
          else
            Pe[a0] = ot._level, ot._override && e0 !== Q && Te(a0, ot._override);
        }
        for (var Rt = [], tt = null, yt = rt.start; yt <= rt.end; yt++) {
          var q0 = me[yt];
          if (!(q0 & l)) {
            var L0 = Pe[yt], qe = q0 & a, mt = q0 === fe;
            tt && L0 === tt._level ? (tt._end = yt, tt._endsWithIsolInit = qe) : Rt.push(tt = {
              _start: yt,
              _end: yt,
              _level: L0,
              _startsWithPDI: mt,
              _endsWithIsolInit: qe
            });
          }
        }
        for (var lt = [], Vt = 0; Vt < Rt.length; Vt++) {
          var t0 = Rt[Vt];
          if (!t0._startsWithPDI || t0._startsWithPDI && !at.has(t0._start)) {
            for (var Q0 = [tt = t0], E0 = void 0; tt && tt._endsWithIsolInit && (E0 = at.get(tt._end)) != null; )
              for (var S0 = Vt + 1; S0 < Rt.length; S0++)
                if (Rt[S0]._start === E0) {
                  Q0.push(tt = Rt[S0]);
                  break;
                }
            for (var N0 = [], Gt = 0; Gt < Q0.length; Gt++)
              for (var M0 = Q0[Gt], gn = M0._start; gn <= M0._end; gn++)
                N0.push(gn);
            for (var Pi = Pe[N0[0]], xr = rt.level, vn = N0[0] - 1; vn >= 0; vn--)
              if (!(me[vn] & l)) {
                xr = Pe[vn];
                break;
              }
            var Y0 = N0[N0.length - 1], h0 = Pe[Y0], Tr = rt.level;
            if (!(me[Y0] & a)) {
              for (var Ut = Y0 + 1; Ut <= rt.end; Ut++)
                if (!(me[Ut] & l)) {
                  Tr = Pe[Ut];
                  break;
                }
            }
            lt.push({
              _seqIndices: N0,
              _sosType: Math.max(xr, Pi) % 2 ? U : R,
              _eosType: Math.max(Tr, h0) % 2 ? U : R
            });
          }
        }
        for (var U0 = 0; U0 < lt.length; U0++) {
          var ar = lt[U0], ct = ar._seqIndices, Jr = ar._sosType, P0 = ar._eosType, Bn = Pe[ct[0]] & 1 ? U : R;
          if (ve.get(J))
            for (var bn = 0; bn < ct.length; bn++) {
              var Ln = ct[bn];
              if (me[Ln] & J) {
                for (var Ii = Jr, Yn = bn - 1; Yn >= 0; Yn--)
                  if (!(me[ct[Yn]] & l)) {
                    Ii = me[ct[Yn]];
                    break;
                  }
                Te(Ln, Ii & (a | fe) ? Z : Ii);
              }
            }
          if (ve.get(V))
            for (var fi = 0; fi < ct.length; fi++) {
              var di = ct[fi];
              if (me[di] & V)
                for (var ho = fi - 1; ho >= -1; ho--) {
                  var aa = ho === -1 ? Jr : me[ct[ho]];
                  if (aa & o) {
                    aa === se && Te(di, S);
                    break;
                  }
                }
            }
          if (ve.get(se))
            for (var Qr = 0; Qr < ct.length; Qr++) {
              var hi = ct[Qr];
              me[hi] & se && Te(hi, U);
            }
          if (ve.get(z) || ve.get(B))
            for (var Bi = 1; Bi < ct.length - 1; Bi++) {
              var Da = ct[Bi];
              if (me[Da] & (z | B)) {
                for (var en = 0, po = 0, Nn = Bi - 1; Nn >= 0 && (en = me[ct[Nn]], !!(en & l)); Nn--)
                  ;
                for (var ms = Bi + 1; ms < ct.length && (po = me[ct[ms]], !!(po & l)); ms++)
                  ;
                en === po && (me[Da] === z ? en === V : en & (V | S)) && Te(Da, en);
              }
            }
          if (ve.get(V))
            for (var Mn = 0; Mn < ct.length; Mn++) {
              var Uc = ct[Mn];
              if (me[Uc] & V) {
                for (var oa = Mn - 1; oa >= 0 && me[ct[oa]] & (j | l); oa--)
                  Te(ct[oa], V);
                for (Mn++; Mn < ct.length && me[ct[Mn]] & (j | l | V); Mn++)
                  me[ct[Mn]] !== V && Te(ct[Mn], V);
              }
            }
          if (ve.get(j) || ve.get(z) || ve.get(B))
            for (var Oa = 0; Oa < ct.length; Oa++) {
              var mo = ct[Oa];
              if (me[mo] & (j | z | B)) {
                Te(mo, Z);
                for (var pi = Oa - 1; pi >= 0 && me[ct[pi]] & l; pi--)
                  Te(ct[pi], Z);
                for (var sa = Oa + 1; sa < ct.length && me[ct[sa]] & l; sa++)
                  Te(ct[sa], Z);
              }
            }
          if (ve.get(V))
            for (var Ra = 0, go = Jr; Ra < ct.length; Ra++) {
              var gs = ct[Ra], vs = me[gs];
              vs & V ? go === R && Te(gs, R) : vs & o && (go = vs);
            }
          if (ve.get(s)) {
            var Pa = U | V | S, mi = Pa | R, gi = [];
            {
              for (var Gn = [], vi = 0; vi < ct.length; vi++)
                if (me[ct[vi]] & s) {
                  var Ia = W[ct[vi]], la = void 0;
                  if (D(Ia) !== null)
                    if (Gn.length < 63)
                      Gn.push({ char: Ia, seqIndex: vi });
                    else
                      break;
                  else if ((la = _(Ia)) !== null)
                    for (var or = Gn.length - 1; or >= 0; or--) {
                      var ua = Gn[or].char;
                      if (ua === la || ua === _(I(Ia)) || D(I(ua)) === Ia) {
                        gi.push([Gn[or].seqIndex, vi]), Gn.length = or;
                        break;
                      }
                    }
                }
              gi.sort(function(o0, Wr) {
                return o0[0] - Wr[0];
              });
            }
            for (var xn = 0; xn < gi.length; xn++) {
              for (var Ba = gi[xn], Li = Ba[0], bi = Ba[1], vo = !1, yr = 0, bs = Li + 1; bs < bi; bs++) {
                var xs = ct[bs];
                if (me[xs] & mi) {
                  vo = !0;
                  var G0 = me[xs] & Pa ? U : R;
                  if (G0 === Bn) {
                    yr = G0;
                    break;
                  }
                }
              }
              if (vo && !yr) {
                yr = Jr;
                for (var ca = Li - 1; ca >= 0; ca--) {
                  var ul = ct[ca];
                  if (me[ul] & mi) {
                    var La = me[ul] & Pa ? U : R;
                    La !== Bn ? yr = La : yr = Bn;
                    break;
                  }
                }
              }
              if (yr) {
                if (me[ct[Li]] = me[ct[bi]] = yr, yr !== Bn) {
                  for (var wr = Li + 1; wr < ct.length; wr++)
                    if (!(me[ct[wr]] & l)) {
                      v(W[ct[wr]]) & J && (me[ct[wr]] = yr);
                      break;
                    }
                }
                if (yr !== Bn) {
                  for (var Zn = bi + 1; Zn < ct.length; Zn++)
                    if (!(me[ct[Zn]] & l)) {
                      v(W[ct[Zn]]) & J && (me[ct[Zn]] = yr);
                      break;
                    }
                }
              }
            }
            for (var Lr = 0; Lr < ct.length; Lr++)
              if (me[ct[Lr]] & s) {
                for (var Fr = Lr, yn = Lr, Nr = Jr, pr = Lr - 1; pr >= 0; pr--)
                  if (me[ct[pr]] & l)
                    Fr = pr;
                  else {
                    Nr = me[ct[pr]] & Pa ? U : R;
                    break;
                  }
                for (var fa = P0, Un = Lr + 1; Un < ct.length; Un++)
                  if (me[ct[Un]] & (s | l))
                    yn = Un;
                  else {
                    fa = me[ct[Un]] & Pa ? U : R;
                    break;
                  }
                for (var _r = Fr; _r <= yn; _r++)
                  me[ct[_r]] = Nr === fa ? Nr : Bn;
                Lr = yn;
              }
          }
        }
        for (var z0 = rt.start; z0 <= rt.end; z0++) {
          var Na = Pe[z0], tn = me[z0];
          if (Na & 1 ? tn & (R | V | S) && Pe[z0]++ : tn & U ? Pe[z0]++ : tn & (S | V) && (Pe[z0] += 2), tn & l && (Pe[z0] = z0 === 0 ? rt.level : Pe[z0 - 1]), z0 === rt.end || v(W[z0]) & (Y | q))
            for (var zn = z0; zn >= 0 && v(W[zn]) & u; zn--)
              Pe[zn] = rt.level;
        }
      }
      return {
        levels: Pe,
        paragraphs: Ue
      };
      function Dr(o0, Wr) {
        for (var sr = o0; sr < W.length; sr++) {
          var rn = me[sr];
          if (rn & (U | se))
            return 1;
          if (rn & (q | R) || Wr && rn === fe)
            return 0;
          if (rn & a) {
            var Ma = Ni(sr);
            sr = Ma === -1 ? W.length : Ma;
          }
        }
        return 0;
      }
      function Ni(o0) {
        for (var Wr = 1, sr = o0 + 1; sr < W.length; sr++) {
          var rn = me[sr];
          if (rn & q)
            break;
          if (rn & fe) {
            if (--Wr === 0)
              return sr;
          } else rn & a && Wr++;
        }
        return -1;
      }
    }
    var be = "14>1,j>2,t>2,u>2,1a>g,2v3>1,1>1,1ge>1,1wd>1,b>1,1j>1,f>1,ai>3,-2>3,+1,8>1k0,-1jq>1y7,-1y6>1hf,-1he>1h6,-1h5>1ha,-1h8>1qi,-1pu>1,6>3u,-3s>7,6>1,1>1,f>1,1>1,+2,3>1,1>1,+13,4>1,1>1,6>1eo,-1ee>1,3>1mg,-1me>1mk,-1mj>1mi,-1mg>1mi,-1md>1,1>1,+2,1>10k,-103>1,1>1,4>1,5>1,1>1,+10,3>1,1>8,-7>8,+1,-6>7,+1,a>1,1>1,u>1,u6>1,1>1,+5,26>1,1>1,2>1,2>2,8>1,7>1,4>1,1>1,+5,b8>1,1>1,+3,1>3,-2>1,2>1,1>1,+2,c>1,3>1,1>1,+2,h>1,3>1,a>1,1>1,2>1,3>1,1>1,d>1,f>1,3>1,1a>1,1>1,6>1,7>1,13>1,k>1,1>1,+19,4>1,1>1,+2,2>1,1>1,+18,m>1,a>1,1>1,lk>1,1>1,4>1,2>1,f>1,3>1,1>1,+3,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,6>1,4j>1,j>2,t>2,u>2,2>1,+1", he;
    function Ge() {
      if (!he) {
        var W = A(be, !0), ee = W.map, le = W.reverseMap;
        le.forEach(function(me, Ee) {
          ee.set(Ee, me);
        }), he = ee;
      }
    }
    function $e(W) {
      return Ge(), he.get(W) || null;
    }
    function Ve(W, ee, le, me) {
      var Ee = W.length;
      le = Math.max(0, le == null ? 0 : +le), me = Math.min(Ee - 1, me == null ? Ee - 1 : +me);
      for (var ve = /* @__PURE__ */ new Map(), Te = le; Te <= me; Te++)
        if (ee[Te] & 1) {
          var Pe = $e(W[Te]);
          Pe !== null && ve.set(Te, Pe);
        }
      return ve;
    }
    function Ze(W, ee, le, me) {
      var Ee = W.length;
      le = Math.max(0, le == null ? 0 : +le), me = Math.min(Ee - 1, me == null ? Ee - 1 : +me);
      var ve = [];
      return ee.paragraphs.forEach(function(Te) {
        var Pe = Math.max(le, Te.start), at = Math.min(me, Te.end);
        if (Pe < at) {
          for (var Ue = ee.levels.slice(Pe, at + 1), rt = at; rt >= Pe && v(W[rt]) & u; rt--)
            Ue[rt] = Te.level;
          for (var gt = Te.level, _t = 1 / 0, Bt = 0; Bt < Ue.length; Bt++) {
            var At = Ue[Bt];
            At > gt && (gt = At), At < _t && (_t = At | 1);
          }
          for (var Tt = gt; Tt >= _t; Tt--)
            for (var Je = 0; Je < Ue.length; Je++)
              if (Ue[Je] >= Tt) {
                for (var ot = Je; Je + 1 < Ue.length && Ue[Je + 1] >= Tt; )
                  Je++;
                Je > ot && ve.push([ot + Pe, Je + Pe]);
              }
        }
      }), ve;
    }
    function wt(W, ee, le, me) {
      var Ee = et(W, ee, le, me), ve = [].concat(W);
      return Ee.forEach(function(Te, Pe) {
        ve[Pe] = (ee.levels[Te] & 1 ? $e(W[Te]) : null) || W[Te];
      }), ve.join("");
    }
    function et(W, ee, le, me) {
      for (var Ee = Ze(W, ee, le, me), ve = [], Te = 0; Te < W.length; Te++)
        ve[Te] = Te;
      return Ee.forEach(function(Pe) {
        for (var at = Pe[0], Ue = Pe[1], rt = ve.slice(at, Ue + 1), gt = rt.length; gt--; )
          ve[Ue - gt] = rt[gt];
      }), ve;
    }
    return e.closingToOpeningBracket = _, e.getBidiCharType = v, e.getBidiCharTypeName = b, e.getCanonicalBracket = I, e.getEmbeddingLevels = ye, e.getMirroredCharacter = $e, e.getMirroredCharactersMap = Ve, e.getReorderSegments = Ze, e.getReorderedIndices = et, e.getReorderedString = wt, e.openingToClosingBracket = D, Object.defineProperty(e, "__esModule", { value: !0 }), e;
  }({});
  return t;
}
var BT = { exports: {} };
(function(t) {
  (function(e, r) {
    t.exports ? t.exports = r() : e.createHyphenator = r();
  })(Wt, function() {
    function e(S) {
      var B = "", q = "", Y = 0, Z = S();
      return function(Q) {
        for (; Y < Q.length; ) {
          B = Q.charAt(Y++), q = Q.charAt(Y);
          var J = Z(B, q);
          if (J !== void 0)
            return J;
        }
      };
    }
    var r = RegExp.prototype.test.bind(
      /\s|(?![\'])[\!-\@\[-\`\{-\~\u2013-\u203C]/
    );
    function n() {
      var S = !1;
      return function(B, q) {
        return S ? q[0] === ">" && (B(), S = !1) : q[0] === "<" && (!r(q[1]) || q[1] === "/") && (S = !0), S;
      };
    }
    function i(S) {
      var B = !1;
      return function(q, Y) {
        return B ? !r(Y[0]) && r(Y[1]) && (q(), B = !1) : !r(Y[0]) && Y[1] === S && (B = !0), B;
      };
    }
    function a(S, B) {
      return function() {
        var q = "", Y = "";
        function Z() {
          q += Y, Y = "";
        }
        function Q(J) {
          return q = "", Y = "", J;
        }
        return function(J, se) {
          Y += J;
          var ae = S.reduce(function(te, ne) {
            return te || ne(Z, [J, se]);
          }, !1);
          if (!ae && (r(J) && !r(se) && Z(), !r(J) && r(se))) {
            if (Y.length >= B)
              return Q([q, Y]);
            Z();
          }
          if (se === "")
            return (Y.length < B || ae) && Z(), Q([q, Y]);
        };
      };
    }
    function o(S) {
      var B = 0;
      function q() {
        return S[B++];
      }
      return q;
    }
    function s(S) {
      var B = 0, q = S;
      function Y() {
        if (q = S.slice(B++), !(q.length < 3))
          return q;
      }
      function Z() {
        return B === 2;
      }
      return [Y, Z];
    }
    function l(S, B, q, Y, Z) {
      for (var Q = new Array(S.length + 1), J = ("." + S.toLocaleLowerCase() + ".").split(""), se, ae, te, ne, ce, pe, Me = -1, Ne, it, fe, ye, be = Q.length; be--; ) Q[be] = 0;
      for (Ne = s(J), it = Ne[0], fe = Ne[1]; se = it(); )
        for (Me++, fe() && Me--, te = q, ye = o(se); (ae = ye()) && (ne = te[ae]) !== void 0; ) {
          switch (te = {}, ce = -1, Object.prototype.toString.call(ne)) {
            case "[object Array]":
              te = ne[0], ce = ne[1];
              break;
            case "[object Object]":
              te = ne;
              break;
            case "[object Number]":
              ce = ne;
              break;
          }
          if (!(ce < 0)) {
            B[ce].splice || (B[ce] = B[ce].slice("")), pe = B[ce];
            for (var he = 0; he < pe.length; he++)
              Q[Me + he] = Math.max(
                pe[he],
                Q[Me + he]
              );
          }
        }
      Q[0] = Q[1] = Q[Q.length - 1] = Q[Q.length - 2] = 0;
      for (var Ge = "", be = 0; be < Q.length; be++)
        Ge += (Q[be] % 2 === 1 ? Z : "") + S.charAt(be);
      return Ge;
    }
    function u(S, B, q, Y, Z, Q, J, se, ae) {
      function te() {
        Me(ne);
      }
      var ne = "", ce, pe = e(
        a(
          (J ? [n()] : []).concat(
            i(Q)
          ),
          se
        )
      ), Me = function() {
      };
      function Ne() {
        for (var it = /* @__PURE__ */ new Date(); (!ae || /* @__PURE__ */ new Date() - it < 10) && (ce = pe(S)); ) {
          if (ce[1]) {
            var fe = ce[1].length ? "~" + ce[1] : "";
            Y[fe] === void 0 && (Y[fe] = l(
              ce[1],
              B,
              q,
              Z,
              Q
            )), ce[1] = Y[fe];
          }
          ne += ce[0] + ce[1];
        }
        ce ? setTimeout(Ne) : te();
      }
      return ae ? (setTimeout(Ne), new Promise(function(it) {
        Me = it;
      })) : (Ne(), ne);
    }
    var d = !1, h = !1, v = [], b = !0, x = "­", A = 5, T = "async", k = "debug", E = "exceptions", C = "html", D = "hyphenChar", _ = "minWordLength", I = typeof Wt == "object" ? Wt : typeof window == "object" ? window : typeof self == "object" ? self : {};
    function R(S, B) {
      S = S || {};
      for (var q in B)
        S[q] = B[q];
      return S;
    }
    function U(S) {
      return S instanceof Array;
    }
    function V(S, B, q, Y) {
      return B in S && (!Y || Y(S[B])) ? S[B] : q;
    }
    function z(S, B) {
      return S.reduce(function(q, Y) {
        return q["~" + Y.replace(/\-/g, "")] = Y.replace(
          /\-/g,
          B
        ), q;
      }, {});
    }
    function j(S, B) {
      B = B || {};
      var q = V(
        B,
        T,
        d
      ), Y = {}, Z = V(B, k, h), Q = {}, J = V(
        B,
        D,
        x
      ), se = S[0].split(","), ae = JSON.parse(S[1]), te = V(
        B,
        _,
        A
      ) >> 0, ne = V(B, C, b), ce = V(
        B,
        E,
        v,
        U
      ), pe = J + te;
      if (Q[pe] = {}, S[2] && (Q[pe] = z(
        S[2],
        J
      )), ce && ce.length && (Q[pe] = R(
        Q[pe],
        z(ce, J)
      )), Y[pe] = R({}, Q[pe]), q && !("Promise" in I))
        throw new Error(
          "Failed to create hyphenator: Could not find global Promise object, needed for hyphenator to work in async mode"
        );
      return function(Me, Ne) {
        Ne = Ne || {};
        var it = V(Ne, k, Z), fe = V(
          Ne,
          D,
          J
        ), ye = V(Ne, _, te) >> 0, be = V(
          Ne,
          E,
          v,
          U
        ), he = fe + ye;
        return !Q[he] && S[2] && (Q[he] = z(
          S[2],
          fe
        ), Y[he] = R(Y[he], Q[he])), be && be.length && (Q[he] = R(
          Q[he],
          z(be, fe)
        ), Y[he] = R(Y[he], Q[he])), u(
          Me,
          se,
          ae,
          Y[he],
          it,
          fe,
          ne,
          ye,
          q
        );
      };
    }
    return j;
  });
})(BT);
var Bre = BT.exports;
const Lre = /* @__PURE__ */ On(Bre);
var LT = { exports: {} };
(function(t) {
  (function(e, r) {
    t.exports ? t.exports = r() : e.hyphenationPatternsEnUs = r();
  })(Wt, function() {
    return [
      "0004,004,001,003,005,0005,00005,000005,0002,002,0000005,0003,00003,00505,00034,0001,00055,00004,4,05,0055,04,42,03,02,2,404,3,044,01,0505,55,5,045,041,0033,000004,22,00504,5504,0042,1,21,41,402,405,4004,43,23,000054,303,3005,022,5004,000003,252,45,25,2004,000505,054,403,401,3002,0025,144,432,00054,34,12,234,0022,014,0304,012,143,503,0403,101,052,414,212,011,043,00002,0041,0024,05005,03003,00102,0404,04303,01004,0034,025,0044,00404,00025,0103,042,0205,412,104,54,344,433,5005,253,055,0402,3004,0043,204,505,454,0000004,00303,04004,552,201,4005,0255,52,444,14,44,02004,033,05004,00045,00013,0021,0405,00044,0054,50055,000303,00001,304,0204,11,301,232,122,00305,504,000043,0104,00052,000045,50004,0023,00033,00032,00202,5003,202,0401,0000505,214,102,032,000161,004101,00501,00301,0036,0052,00023,006101,006,00401,000521,0014,0063,00012,000501,000006,000604,000601,005001,005005,0010305,00006,003012,003005,0003011,0061,013,000021,000022,000105,00211,00062,00051,000112,006013,000011,0200306,1021,0050001,003003,2102,305,000015,01030005,000035,001011,00021,16330001,0234,030006,5020001,000001,00016,0031,021,21431,002305,0350014,0000012,000063,00101,106,105,00435,00063,0300061,00041,100306,003602,023,0503,0010011,10003,1005,30011,00031,0001001,0000061,0030003,30305,001201,0301,5000101,500101,00015,000401,000065,000016,0000402,0500002,000205,030201,500301,00014,5001,000002,00030011,01034,0300006,030213,00400304,050001,05003,000311,0634,00061,0006,00000604,00050013,00213,0030001,100003,000033,30002,00003632,0003004,050003,0000021,006303,0000006,00005005,30451,03001,00231,00056,00011,6,001001,00500001,03005,503005,0000010001,1002,003001,001065,300001,32011,32,0000003,0213001,0500053,021005,10001,0000011,0001041,0020016,100032,50011,0606,5002,3001,03002,0015001,0102,00003001,000000033,0000001,300101,300015,0101003,00000101,0100501,0101,0010033,00000362,000014,0005001,031",
      '{".":{"a":{"c":{"h":0},"d":{"d":{"e":{"r":1}}},"f":{"t":2},"l":{"t":3},"m":{"a":{"t":4}},"n":{"c":4,"g":0,"i":{"m":5},"t":[{"e":3,"i":{"s":6}},0]},"r":{"s":4,"t":{"i":{"e":1},"y":1}},"s":{"c":3,"p":2,"s":2,"t":{"e":{"r":7}}},"t":{"o":{"m":6}},"u":{"d":2},"v":{"i":1},"w":{"n":0}},"b":{"a":{"g":1,"n":{"a":4},"s":{"e":0}},"e":{"r":[{"a":4},0],"s":{"m":3,"t":{"o":4}}},"r":{"i":8},"u":{"t":{"t":{"i":0}}}},"c":{"a":{"m":{"p":{"e":0}},"n":{"c":5},"p":{"a":{"b":6}},"r":{"o":{"l":5}},"t":1},"e":{"l":{"a":1}},"h":[{"i":{"l":{"l":{"i":7}}}},1],"i":[{"t":{"r":5}},9],"o":{"e":3,"r":[{"n":{"e":{"r":5}}},1],"n":{"g":{"r":5}}}},"d":{"e":{"m":{"o":{"i":1}},"o":3,"r":{"a":3,"i":[{"v":{"a":4}},3]},"s":{"c":0}},"i":{"c":{"t":{"i":{"o":10}}}},"o":{"t":1},"u":{"c":1,"m":{"b":6}},"r":{"i":{"v":67}}},"e":{"a":{"r":{"t":{"h":7}},"s":{"i":11}},"b":1,"e":{"r":0},"g":9,"l":{"d":4,"e":{"m":3}},"n":{"a":{"m":12},"g":3,"s":3},"q":{"u":{"i":{"t":13}}},"r":{"r":{"i":1}},"s":3,"u":[{"l":{"e":{"r":1}}},3],"y":{"e":5},"t":{"h":{"y":{"l":162}}},"v":[{"e":{"r":{"s":{"i":{"b":158}}}}},9]},"f":{"e":{"s":11},"o":{"r":{"m":{"e":{"r":5}}}}},"g":{"a":[{"s":{"o":{"m":163}}},9],"e":[{"n":{"t":14},"o":{"g":4,"m":{"e":1},"t":164}},9],"i":{"a":4,"b":1},"o":{"r":1}},"h":{"a":{"n":{"d":{"i":6},"k":5}},"e":[{"r":{"o":{"i":6,"e":3}},"s":11,"t":11,"m":{"o":165},"p":{"a":166}},9],"i":{"b":3,"e":{"r":3}},"o":{"n":{"e":{"y":5},"o":11},"v":5}},"i":{"d":{"l":1,"o":{"l":12}},"m":{"m":3,"p":{"i":{"n":4}}},"n":[{"c":{"i":3},"e":8,"k":9,"s":3,"u":{"t":167}},2],"r":{"r":4},"s":{"i":1}},"j":{"u":{"r":3}},"l":{"a":{"c":{"y":1},"m":1,"t":{"e":{"r":5},"h":6}},"e":[{"g":{"e":5},"n":0,"p":5,"v":15,"i":{"c":{"e":{"s":170}}}},9],"i":{"g":[{"a":5},1],"n":9,"o":3,"t":1}},"m":{"a":{"g":{"a":16},"l":{"o":5},"n":{"a":5},"r":{"t":{"i":5}}},"e":[{"r":{"c":11},"t":{"e":{"r":4},"a":{"l":{"a":0}}},"g":{"a":{"l":171}}},9],"i":{"s":[{"t":{"i":6},"e":{"r":{"s":173}}},15],"m":{"i":{"c":172}}},"o":{"n":{"e":11},"r":{"o":3}},"u":{"t":{"a":[{"b":6},4]}}},"n":{"i":{"c":1},"e":{"o":{"f":174}},"o":{"e":{"t":{"h":15}},"n":{"e":{"m":175}}}},"o":{"d":[{"d":5},9],"f":{"t":{"e":4}},"r":{"a":{"t":{"o":4}},"c":3,"d":2,"t":3},"s":[{"t":{"l":1}},3],"t":{"h":11},"u":{"t":11}},"p":{"e":{"d":{"a":{"l":5}},"t":{"e":4,"i":{"t":4}}},"i":{"e":1,"o":{"n":5},"t":9},"r":{"e":{"m":11,"a":{"m":15}}},"o":{"l":{"y":{"s":137}},"s":{"t":{"a":{"m":137}}}}},"r":{"a":{"c":1,"n":{"t":0},"t":{"i":{"o":{"n":{"a":7}}}},"v":{"e":{"n":{"o":176}}}},"e":{"e":[{"c":173},8],"m":{"i":{"t":4}},"s":[{"t":{"a":{"t":4}}},8]},"i":{"g":1,"t":{"u":5}},"o":{"q":1,"s":{"t":5},"w":{"d":5}},"u":{"d":1}},"s":{"c":{"i":{"e":11}},"e":{"l":{"f":6,"l":6},"n":9,"r":{"i":{"e":4}},"m":{"i":[{"c":0,"d":177,"p":36,"r":36,"s":178,"v":36},6]}},"h":9,"i":[{"n":{"g":17}},9],"t":[{"a":{"b":{"l":5}}},1],"y":9,"p":{"h":{"i":{"n":179}},"i":{"n":{"o":137}}}},"t":{"a":[{"p":{"e":{"s":{"t":{"r":180}}}}},1],"e":[{"n":{"a":{"n":5}},"l":{"e":{"g":{"r":3}}}},1],"h":9,"i":[{"l":0,"m":{"o":16},"n":{"g":17,"k":5}},9],"o":{"n":{"a":0},"p":[{"i":5,"o":{"g":170}},1],"u":{"s":5},"q":9},"r":{"i":{"b":{"u":{"t":6}}}}},"u":{"n":{"a":[{"t":{"t":144}},2],"c":{"e":3},"d":{"e":{"r":7}},"e":[{"r":{"r":181}},2],"k":4,"o":4,"u":3},"p":3,"r":{"e":11},"s":{"a":4}},"v":{"e":{"n":{"d":{"e":0}},"r":{"a":4}},"i":{"c":{"a":{"r":151}}}},"w":{"i":{"l":{"i":5}},"e":{"b":{"l":131}}},"y":{"e":1},"k":{"i":{"l":{"n":{"i":168}}},"o":{"r":{"t":{"e":169}}}}},"a":{"b":{".":18,"a":{"l":19,"n":19},"e":[{"r":{"d":4}},8],"i":{"a":5,"t":{"a":{"b":13}}},"l":{"a":{"t":4}},"o":{"l":{"i":{"z":20,"c":19}}},"r":[{"o":{"g":4}},18],"u":{"l":3}},"c":{"a":{"r":[{"d":4,"o":4},21],"b":{"l":24}},"e":{"o":{"u":19},"r":2},"h":{"e":{"t":19}},"i":[{"e":23,"n":2,"o":23},22],"r":{"o":{"b":4}},"t":{"i":{"f":5}},"u":{"l":3,"m":1}},"d":[{"d":{"i":{"n":1}},"e":{"r":{".":4}},"i":[{"a":23,"c":{"a":3},"e":{"r":0},"o":23,"t":23,"u":19},25],"l":{"e":1},"o":{"w":3},"r":{"a":{"n":4}},"s":{"u":1},"u":[{"c":23,"m":4},18]},24],"e":{"r":[{"i":{"e":17}},1]},"f":[{"f":[{"i":{"s":{"h":170}}},0]},24],"g":{"a":{"b":21,"n":0},"e":{"l":{"l":4},"o":0,"u":18},"i":2,"l":26,"n":2,"o":[{"g":27,"n":{"i":3}},24],"u":{"e":{"r":19},"l":4},"y":21},"h":{"a":23,"e":23,"l":1,"o":23},"i":[{"a":19,"c":{".":23},"l":{"y":4},"n":[{"i":{"n":5},"o":5},28],"t":{"e":{"n":5}}},9],"j":29,"k":{"e":{"n":2}},"l":{"a":{"b":4,"d":3,"r":21},"d":{"i":18},"e":[{"n":{"d":3,"t":{"i":21}},"o":30},25],"i":[{"a":{".":1},"e":0},2],"l":{"e":{"v":4},"i":{"c":18}},"m":18,"o":{"g":{".":19}},"y":{".":21,"s":[{"t":31},18],"t":32,"z":27}},"m":{"a":[{"b":4,"g":3,"r":{"a":5},"s":{"c":4},"t":{"i":{"s":21},"o":33}},18],"e":{"r":{"a":4},"n":{"t":{"a":{"b":182}}}},"i":{"c":3,"f":4,"l":{"y":4},"n":[{"o":0},2]},"o":[{"n":19,"r":{"i":6}},24],"p":{"e":{"n":5}}},"n":[{"a":{"g":{"e":3},"l":{"y":[{"s":183},27]},"r":[{"c":3,"i":17},23],"t":{"i":23}},"d":[{"e":{"s":17},"i":{"s":3},"l":2,"o":{"w":1}},18],"e":{"e":19,"n":23,"s":{"t":{".":4}},"u":23},"g":[{"i":{"e":5},"l":2},25],"i":{"c":34,"e":{"s":23},"f":35,"m":{"e":1,"i":19},"n":{"e":19},"o":3,"p":23,"s":{"h":3},"t":3,"u":23},"k":{"l":{"i":1}},"n":{"i":{"z":32}},"o":[{"t":[{"h":7},4],"a":{"c":148}},0],"s":{"a":9,"c":{"o":1},"n":1,"p":[{"o":11},9],"t":1,"u":{"r":1},"g":{"r":5},"v":11},"t":{"a":{"l":36},"i":{"e":1,"d":137,"n":184,"r":{"e":137}},"o":18,"r":9,"w":1},"u":{"a":3,"l":3,"r":19}},24],"o":18,"p":{"a":{"r":17,"t":4},"e":{"r":{"o":4},"a":{"b":{"l":{"e":132}}}},"h":{"e":{"r":23},"i":18},"i":{"l":{"l":{"a":[{"r":4},21]}},"n":3,"t":{"a":3,"u":23}},"l":24,"o":{"c":6,"l":{"a":4},"r":{"i":6},"s":{"t":12}},"s":{"e":{"s":5}},"u":23},"q":{"u":{"e":6}},"r":[{"a":{"c":{"t":3},"d":{"e":19,"i":{"s":4}},"l":3,"m":{"e":{"t":{"e":19}}},"n":{"g":17},"p":11,"t":[{"i":{"o":19,"v":4}},1],"u":19,"v":38,"w":17},"b":{"a":{"l":36}},"c":{"h":{"a":{"n":1},"e":{"t":185}}},"d":{"i":{"n":{"e":4}},"r":1},"e":{"a":{"s":4},"e":23,"n":{"t":3},"s":{"s":19}},"f":{"i":1,"l":1},"i":[{"a":{"l":4,"n":3},"e":{"t":23},"m":1,"n":{"a":{"t":4}},"o":3,"z":9},2],"m":{"i":9},"o":{"d":20,"n":{"i":19},"o":23},"p":9,"q":3,"r":{"e":17,"a":{"n":{"g":{"e":9}}}},"s":{"a":1,"h":9}},37],"s":{".":18,"a":{"b":1,"n":{"t":3}},"h":{"i":17},"i":{"a":{".":19},"b":23,"c":23,"t":39},"k":{"i":11},"l":1,"o":{"c":21},"p":{"h":4},"s":{"h":1},"t":{"e":{"n":3},"r":2},"u":{"r":{"a":6}},"y":{"m":{"p":{"t":{"o":{"t":4}}}}}},"t":{"a":[{"b":{"l":3},"c":4,"l":{"o":3},"p":4},24],"e":{"c":[{"h":4},5],"g":{"o":3},"n":{".":3},"r":{"a":3,"n":[{"a":19},6]},"s":{"t":3},"v":4},"h":[{"e":{"m":5,"n":19,"r":{"o":{"s":186}}},"o":[{"m":5},1]},18],"i":{".":18,"a":19,"b":20,"c":2,"f":3,"o":{"n":{"a":{"r":7}}},"t":{"u":3}},"o":{"g":21,"m":[{"i":{"z":4}},24],"p":21,"s":21},"r":[{"o":{"p":4}},29],"s":{"k":1},"t":{"a":{"g":1},"e":[{"s":{".":170}},4],"h":1},"u":[{"a":4,"e":4,"l":3,"r":{"a":3}},24],"y":24},"u":{"b":1,"g":{"h":[{"t":{"l":17}},12],"u":3},"l":[{"i":{"f":13}},40],"n":{"d":5},"r":3,"s":{"i":{"b":4}},"t":{"e":{"n":5},"h":2}},"v":{"a":[{"g":3,"n":19},24],"e":{"n":{"o":0},"r":{"a":3,"n":4,"y":4}},"i":[{"e":{"r":0},"g":3,"o":{"u":3}},2],"o":{"c":4,"r":29}},"w":{"a":{"y":27},"i":3,"l":{"y":1},"s":0},"x":{"i":{"c":1,"d":1}},"y":{"a":{"l":4},"e":0,"s":0},"z":{"i":{"e":{"r":0}},"z":{"i":5}}},"b":{"a":{".":32,"d":{"g":{"e":{"r":5}}},"g":{"e":1},"l":{"a":15},"n":{"d":{"a":{"g":5}},"e":0,"i":11},"r":{"b":{"i":7},"i":{"a":17},"o":{"n":{"i":{"e":187}}}},"s":{"s":{"i":0}},"t":[{"h":{"y":2}},41],"z":1,"c":{"k":{"e":{"r":{".":84}}}}},"b":[{"e":[{"r":23},24],"i":{"n":{"a":0},"t":0}},42],"d":43,"e":{".":18,"a":{"k":17,"t":12},"d":[{"a":3,"e":3,"i":3},44],"g":{"i":3,"u":4},"l":[{"i":2,"o":3},41],"m":45,"n":{"i":{"g":4},"u":4},"s":[{"p":3,"t":{"r":4}},46],"t":[{"i":{"z":5},"r":4,"w":3},27],"w":3,"y":{"o":4},"v":{"i":{"e":9}}},"f":25,"h":47,"i":{"b":9,"d":[{"i":{"f":167}},1],"e":[{"n":4,"r":1},27],"f":48,"l":[{"i":{"z":3},"l":{"a":{"b":8}}},41],"n":{"a":{"r":49},"d":0,"e":{"t":4}},"o":{"g":{"r":3},"u":4,"m":5,"r":{"b":2,"h":15}},"t":[{"i":{"o":50,"v":{"e":188}},"r":3,"u":{"a":51},"z":19},9]},"j":29,"k":1,"l":[{"a":{"t":{"h":7},"n":{"d":189}},"e":{".":21,"n":17,"s":{"p":32}},"i":{"s":23,"n":{"d":189}},"o":[{"n":{"d":190}},21],"u":{"n":{"t":17}}},52],"m":43,"n":[{"e":{"g":5}},47],"o":{"d":[{"i":11},27],"e":1,"l":{"i":{"c":11}},"m":{"b":{"i":0}},"n":{"a":[{"t":5},0]},"o":27,"r":{".":32,"a":43,"d":5,"e":32,"i":32,"n":{"o":191}},"s":53,"t":{"a":19,"h":6,"o":1,"u":{"l":192}},"u":{"n":{"d":54}}},"p":18,"r":{"i":{"t":18},"o":{"t":{"h":54}},"u":{"s":{"q":17}}},"s":[{"o":{"r":17}},55],"t":[{"l":1,"o":21,"r":23},25],"u":{"f":{"f":{"e":{"r":0}}},"g":{"a":1},"l":{"i":3},"m":{"i":17},"n":[{"t":{"i":17}},1],"r":{"e":3},"s":{"i":{"e":[{"r":193,"s":193},5]},"s":{"e":17,"i":{"n":{"g":17}}},"t":32},"t":{"a":18,"i":{"o":27},"o":19,"e":{"d":{".":8}},"t":{"e":{"d":0}}}},"v":29,"w":56,"y":{".":32,"s":0}},"c":{"a":[{"b":{"i":{"n":11},"l":2},"c":{"h":17},"d":{"e":{"n":4,"m":194}},"g":46,"h":57,"l":{"a":{"t":3},"l":{"a":0,"i":{"n":6}},"o":18},"n":{"d":5,"e":0,"i":{"c":0,"s":5,"z":11},"t":{"y":0},"y":17},"p":{"e":{"r":4}},"r":{"o":{"m":5}},"s":{"t":{"e":{"r":6},"i":{"g":5}},"y":18},"t":{"h":1,"i":{"v":18},"a":{"s":195}},"v":{"a":{"l":5}}},41],"c":[{"h":{"a":6},"i":{"a":0},"o":{"m":{"p":{"a":10}},"n":17,"u":{"t":12}}},23],"e":{".":25,"d":{".":18,"e":{"n":18}},"i":27,"l":{".":32,"l":27},"n":[{"c":27,"e":58,"i":18,"t":27},41],"p":27,"r":{"a":{"m":4}},"s":{"a":18,"s":{"i":[{"b":59},27]},"t":5},"t":[{"a":60},0],"w":0},"h":[{".":18,"a":{"b":61,"n":{"i":{"c":32,"s":20}}},"e":[{"a":{"p":54},"d":18,"l":{"o":5},"m":{"i":27},"n":{"e":4},"r":{".":3,"s":3}},8],"i":{"n":[{"e":{".":32,"s":{"s":4}},"i":32},62],"o":32,"t":27,"z":8,"e":{"v":{"o":6}}},"o":63,"t":{"i":1},"s":{".":18,"h":{"u":11}}},25],"i":[{"a":[{"b":64,"r":5},27],"c":4,"e":{"r":18},"f":{"i":{"c":{".":32}}},"i":18,"l":{"a":1,"i":27},"m":25,"n":[{"a":[{"t":27},21],"e":{"m":11},"g":[{".":19},29],"o":32,"q":8},25],"o":{"n":17},"p":{"e":18,"h":3,"i":{"c":18}},"s":{"t":{"a":18,"i":18}},"t":[{"i":{"z":11}},42],"z":32,"g":{"a":{"r":152}}},41],"k":[{"i":3},2],"l":[{"a":{"r":[{"a":{"t":{"i":{"o":19}}},"e":32},18]},"e":{"m":0,"a":{"r":0}},"i":{"c":18,"m":17},"y":0},65],"n":19,"o":[{"a":{"g":4},"e":8,"g":[{"r":1},25],"i":[{"n":{"c":3}},0],"l":{"i":5,"o":[{"r":11},32]},"m":{"e":{"r":5}},"n":{"a":0,"e":21,"g":11,"t":5},"p":{"a":3,"i":{"c":11},"l":1,"h":{"o":{"n":196}}},"r":{"b":18,"o":{"n":12}},"s":{"e":0},"v":[{"e":17},15],"w":{"a":5},"z":{"e":5,"i":4},"u":{"s":{"t":{"i":84}}}},41],"q":29,"r":{"a":{"s":{"t":6},"t":{".":32,"i":{"c":32}}},"e":{"a":{"t":11},"d":32,"t":{"a":47},"v":0},"i":[{"f":5,"n":21,"s":17,"t":{"i":[{"e":11},32]}},8],"o":{"p":{"l":0,"o":6},"s":{"e":17},"c":{"o":{"d":197}},"e":{"c":{"o":148}}},"u":{"d":0}},"s":66,"t":[{"a":{"b":0,"n":{"g":4,"t":19}},"e":[{"r":23},24],"i":{"c":{"u":21},"m":{"i":12}},"u":{"r":0},"w":21,"r":{"o":{"m":{"e":{"c":198}}}}},42],"u":{"d":5,"f":21,"i":[{"t":{"y":4}},21],"l":{"i":32,"t":{"i":{"s":0},"u":27}},"m":{"a":9,"e":23,"i":1},"n":27,"p":{"i":3,"y":4},"r":{"a":{"b":67,"n":{"c":{"e":199}}},"i":{"a":4}},"s":[{"s":{"i":17}},41],"t":[{"i":{"e":1,"v":56},"r":18},68]},"y":41,"z":{"e":0}},"d":{"a":[{".":32,"b":70,"c":{"h":17},"f":18,"g":25,"m":71,"n":{"g":11},"r":{"d":6,"k":6,"y":18},"t":[{"i":{"v":18},"o":18,"a":{"b":137}},27],"v":[{"e":5},53],"y":32,"l":{"o":{"n":{"e":48}}}},69],"b":29,"c":19,"d":[{"a":{"b":20},"i":{"b":94}},72],"e":{".":25,"a":{"f":6,"l":{"s":{".":1}}},"b":{"i":{"t":5},"o":{"n":1}},"c":{"a":{"n":36},"i":{"l":1},"o":{"m":4},"l":{"a":{"r":200},"i":{"n":{"a":64}}}},"d":42,"e":{".":18},"i":{"f":4},"l":{"i":{"e":17,"q":16},"o":4},"m":[{".":32,"i":{"c":[{".":5},27],"l":4},"o":{"n":{"s":1},"r":7,"s":9}},21],"n":[{"a":{"r":1},"o":3,"t":{"i":{"f":7}},"u":3},41],"p":[{"a":3,"i":17,"u":9},2],"q":23,"r":{"h":21,"m":32,"n":{"i":{"z":6}},"s":5},"s":[{".":24,"c":2,"o":64,"t":{"i":11,"r":3},"u":1,"i":{"c":11}},8],"t":[{"o":9,"i":{"c":9}},2],"v":[{"i":{"l":11}},2],"y":18,"f":{"i":{"n":{"i":{"t":{"i":201}}}}}},"f":43,"g":{"a":21,"e":{"t":73},"i":2,"y":24},"h":74,"i":{".":32,"a":[{"b":5},75],"c":{"a":{"m":1,"i":{"d":15}},"e":21,"t":27},"d":27,"e":{"n":76},"f":[{"f":{"r":{"a":5}}},29],"g":{"e":3},"l":{"a":{"t":{"o":1}}},"n":[{"a":41,"e":{".":27},"i":[{"z":4},32]},29],"o":[{"g":5},41],"p":{"l":1},"r":[{"e":[{"n":9,"r":9},2],"t":{"i":6}},8],"s":[{"i":32,"t":77},15],"t":{"i":24},"v":78,"m":{"e":{"t":{"h":{"y":141}}}}},"j":29,"k":79,"l":{"a":56,"e":{".":27,"d":27,"s":{".":27,"s":18},"a":{"d":42}},"o":48,"u":56,"y":25,"i":{"e":202}},"m":29,"n":80,"o":[{".":27,"d":{"e":4},"e":32,"f":57,"g":21,"l":{"a":1,"i":17,"o":{"r":4}},"m":{"i":{"z":5}},"n":{"a":{"t":3},"i":17},"o":{"d":11},"p":{"p":0},"r":21,"s":27,"u":{"t":56},"v":1,"x":27,"w":{"o":{"r":{"d":203}}}},41],"p":29,"r":[{"a":{"g":{"o":{"n":6}},"i":18},"e":[{"a":{"r":6},"n":[{"a":{"l":204}},32]},0],"i":{"b":0,"l":17,"f":{"t":{"a":189}},"p":{"l":{"e":{"g":205}}}},"o":{"p":0,"w":18,"m":{"e":{"d":206}}},"u":{"p":{"l":{"i":32}}},"y":18},41],"s":[{"p":1,"w":21,"y":21},81],"t":{"h":24,"a":{"b":23}},"u":[{"a":[{"l":{".":9}},82],"c":[{"a":29,"e":{"r":5},"t":{".":18,"s":18}},9],"e":{"l":4},"g":1,"l":{"e":23},"m":{"b":{"e":0}},"n":1,"p":[{"e":1},18],"o":{"p":{"o":{"l":207}}}},41],"v":29,"w":29,"y":[{"n":32,"s":{"e":1,"p":5}},24]},"e":{"a":{"b":72,"c":{"t":23},"d":[{"i":{"e":5}},15],"g":{"e":[{"r":4},1]},"l":[{"e":{"r":5},"o":{"u":11}},1],"m":{"e":{"r":11}},"n":{"d":19,"i":{"e":{"s":111}}},"r":{"a":11,"c":0,"e":{"s":5},"i":{"c":0,"l":0},"k":5,"t":[{"e":12},8]},"s":{"p":4,"s":23,"t":12},"t":[{"e":{"n":5},"h":{"i":12},"i":{"f":19},"u":83},9],"v":[{"e":{"n":11},"i":5,"o":5},9]},"b":[{"e":{"l":{".":21,"s":21},"n":21},"i":{"t":21},"r":23},42],"c":{"a":{"d":21,"n":{"c":6}},"c":{"a":6},"e":[{"s":{"s":{"a":4}}},29],"i":[{"b":21,"f":{"i":{"c":{"a":{"t":4}},"e":4},"y":4},"m":3,"t":[{"e":19},0]},9],"l":{"a":{"m":21},"u":{"s":21}},"o":{"l":24,"m":{"m":21,"p":{"e":21}},"n":{"c":21},"r":[{"a":3,"o":5},24]},"r":[{"e":{"m":21}},29],"t":{"a":{"n":1},"e":1},"u":[{"l":[{"a":3},21]},29],"h":{"a":{"s":23}}},"d":{"a":37,"d":61,"e":{"r":34,"s":0},"i":[{"a":23,"b":3,"c":{"a":3},"m":3,"t":2,"z":5},18],"o":[{"l":21,"n":84},18],"r":{"i":21},"u":{"l":[{"o":4,"i":{"n":{"g":2}}},21]},"g":{"l":15}},"e":{"c":9,"d":{"i":11},"f":9,"l":{"i":11,"y":1},"m":9,"n":{"a":1},"p":85,"s":[{"t":17},86],"t":{"y":1},"x":19},"f":[{"e":{"r":{"e":83}},"f":41,"i":{"c":[{"i":32},21],"l":17,"n":{"e":23,"i":{"t":{"e":20}}},"t":27},"o":{"r":{"e":{"s":6}}},"u":{"s":{"e":{".":21}}}},29],"g":{"a":{"l":18},"e":{"r":17},"i":{"b":4,"c":1,"n":{"g":4},"t":87},"n":4,"o":{".":21,"s":21},"u":{"l":2,"r":19},"y":32},"h":[{"e":{"r":17}},72],"i":[{"c":19,"d":4,"g":[{"l":4},8],"m":{"b":23},"n":{"f":23,"g":29,"s":{"t":19}},"r":{"d":0},"t":{"e":11,"h":3,"y":19}},9],"j":[{"u":{"d":[{"i":4},21]}},29],"k":{"i":{"n":0},"l":{"a":1}},"l":{"a":[{".":21,"c":21,"n":{"d":17},"t":{"i":{"v":4}},"w":21,"x":{"a":36}},29],"e":{"a":23,"b":{"r":{"a":4}},"c":32,"d":21,"g":{"a":3},"n":19,"r":34,"s":29},"f":9,"i":[{"b":{"e":23},"c":{".":33,"a":3},"e":{"r":23},"g":{"i":{"b":4}},"m":19,"n":{"g":83},"o":23,"s":[{"h":4},24],"v":88,"t":{"i":{"s":208}}},9],"l":{"a":[{"b":1},18],"o":17},"o":{"c":19,"g":4,"p":{".":3},"a":29},"s":{"h":9},"t":{"a":1},"u":{"d":19,"g":4}},"m":{"a":{"c":21,"g":21,"n":[{"a":4},19]},"b":4,"e":[{"l":24,"t":21},29],"i":{"c":{"a":3},"e":0,"g":{"r":{"a":4}},"n":[{"e":4,"i":35},89],"s":[{"h":4,"s":19},21],"z":3},"n":{"i":{"z":32}},"o":{"g":0,"n":{"i":{"o":7}}},"p":{"i":3},"u":{"l":[{"a":4},21],"n":11},"y":23},"n":{"a":{"m":{"o":4},"n":{"t":21}},"c":{"h":{"e":{"r":17}}},"d":{"i":{"c":3,"x":2}},"e":{"a":19,"e":19,"m":3,"r":{"o":4},"s":{"i":4,"t":4},"t":{"r":3},"w":23},"i":{"c":{"s":4},"e":19,"l":19,"o":23,"s":{"h":3},"t":3,"u":19,"z":32},"n":18,"o":[{"g":0,"s":21,"v":3},18],"s":{"w":1},"t":{"a":{"g":{"e":5}},"h":{"e":{"s":18}}},"u":{"a":3,"f":4},"y":{".":23},"z":61},"o":{"f":19,"g":[{"r":{"a":{"p":3}}},9],"i":90,"l":23,"p":{"a":{"r":11}},"r":[{"e":3,"o":{"l":4}},29],"s":0,"t":[{"o":1},21],"u":{"t":19},"w":19},"p":{"a":[{"i":23,"n":{"c":4}},24],"e":{"l":19,"n":{"t":23},"t":{"i":{"t":{"i":{"o":4}}}}},"h":{"e":17},"l":{"i":21},"o":29,"r":{"e":{"c":[{"a":4},21],"d":21,"h":3},"o":[{"b":21},23]},"s":{"h":1},"t":{"i":{"b":13}},"u":{"t":[{"a":4},21]},"i":{"n":{"e":{"p":{"h":209}}}}},"q":[{"u":{"i":{"l":12,"s":91}}},29],"r":{"a":[{"b":0,"n":{"d":18},"r":3,"t":{"i":{".":18}}},2],"b":[{"l":1},25],"c":{"h":[{"e":1},3]},"e":{".":25,"a":{"l":23},"c":{"o":5},"i":{"n":11},"l":{".":4},"m":{"o":3},"n":{"a":4,"c":{"e":4},"e":18,"t":3},"q":0,"s":{"s":4,"t":3},"t":17},"h":2,"i":[{"a":[{"n":{".":210}},92],"c":{"k":32},"e":{"n":23,"r":0},"n":{"e":3},"o":29,"t":18,"u":1,"v":[{"a":21},0]},2],"m":93,"n":{"i":{"s":1,"t":18,"z":32},"o":3},"o":[{"b":4,"c":19,"r":0,"u":2},25],"s":[{"e":{"t":3}},2],"t":{"e":{"r":11},"l":18,"w":3},"u":[{"t":0},18],"w":{"a":{"u":32}}},"s":{"a":[{"g":{"e":{".":21,"s":21}}},72],"c":[{"a":[{"n":4},24],"r":23,"u":4},9],"e":[{"c":[{"r":4},24],"n":{"c":4},"r":{"t":{".":21,"s":21},"v":{"a":21}}},74],"h":[{"a":23,"e":{"n":5}},18],"i":[{"c":24,"d":[{"e":{"n":4}},24],"g":{"n":{"a":4}},"m":94,"n":95,"s":{"t":{"e":17}},"u":0},29],"k":{"i":{"n":19}},"m":{"i":1},"o":{"l":[{"u":3},24],"n":[{"a":4},24]},"p":[{"e":{"r":3},"i":{"r":{"a":4}},"r":{"e":1},"a":{"c":{"i":211}}},29],"s":[{"i":{"b":96}},25],"t":{"a":{"n":36},"i":{"g":3,"m":4},"o":[{"n":23},44],"r":[{"o":19,"u":{"c":10}},25]},"u":{"r":[{"r":4},24]},"w":1},"t":{"a":{"b":0},"e":{"n":{"d":17},"o":23},"h":{"o":{"d":54},"y":{"l":{"e":{"n":{"e":162}}}}},"i":{"c":2,"d":{"e":19},"n":[{"o":0},17],"r":19,"t":{"i":{"o":19,"v":4}}},"n":18,"o":{"n":{"a":4}},"r":{"a":23,"e":23,"i":{"c":3,"f":4},"o":{"g":3,"s":4}},"u":{"a":3},"y":{"m":4},"z":4},"u":[{"n":19,"p":23,"r":{"o":3},"s":0,"t":{"e":17,"i":{"l":6},"r":4},"c":{"l":{"i":{"d":212}}}},18],"v":{"a":{"p":97,"s":[{"t":4},24]},"e":{"a":19,"l":{"l":3,"o":12},"n":{"g":19,"i":17},"r":[{"b":19},2]},"i":[{"d":3,"l":0,"n":21,"v":0},29],"o":{"c":19},"u":19},"w":{"a":[{"g":21},29],"e":{"e":19},"h":23,"i":{"l":6,"n":{"g":3},"t":23}},"x":{"p":41},"y":{"c":32,"e":{".":32},"s":0}},"f":{"a":[{"b":{"l":3,"r":11},"c":{"e":1},"g":18,"i":{"n":17},"l":{"l":{"e":6}},"m":{"a":26,"i":{"s":5}},"r":[{"t":{"h":5}},32],"t":{"a":3,"h":{"e":3},"o":18},"u":{"l":{"t":7}}},41],"b":56,"d":18,"e":{".":18,"a":{"s":17,"t":{"h":54}},"b":[{"r":{"u":{"a":15}}},1],"c":{"a":18,"t":32},"d":25,"l":{"i":3},"m":{"o":1},"n":{"d":[{"e":6},8]},"r":[{"r":32,"m":{"i":{"o":213}}},15],"v":0},"f":[{"e":{"s":21},"i":{"e":21,"n":{".":19},"s":94},"l":{"y":21},"y":24},43],"h":18,"i":[{"a":3,"c":{".":48,"a":{"l":47,"n":23,"t":{"e":18}},"e":{"n":23,"r":3},"i":[{"a":32,"e":32},0],"s":18,"u":3,"h":27},"d":{"e":{"l":4}},"g":{"h":{"t":7}},"l":{"i":5,"l":{"i":{"n":6}},"y":18},"n":[{"a":32,"d":97,"e":9,"g":98,"n":0},25],"s":{"t":{"i":0}},"t":{"t":{"e":{"d":{".":5}}}}},41],"l":[{"e":{"s":{"s":19}},"i":{"n":17},"o":{"r":{"e":11},"w":{"e":{"r":{".":84}}}},"y":100,"a":{"g":{"e":{"l":214}}},"u":{"o":{"r":27}}},99],"m":18,"n":18,"o":[{"n":[{"d":{"e":0},"t":0},32],"r":[{"a":{"t":4,"y":5},"e":{"t":6},"i":0,"t":{"a":6}},9],"s":5},41],"p":56,"r":{"a":{"t":0},"e":{"a":19,"s":{"c":6}},"i":[{"l":17},8],"o":{"l":6}},"s":48,"t":[{"o":21,"y":24},25],"u":[{"e":{"l":4},"g":18,"m":{"i":{"n":1}},"n":{"e":4},"r":{"i":3},"s":{"i":17,"s":0},"t":{"a":18}},27],"y":41},"g":{"a":[{"f":0,"l":{".":32,"i":27,"o":3},"m":[{"e":{"t":4},"o":19},25],"n":{"i":{"s":5,"z":[{"a":6},3]},"o":18},"r":{"n":67},"s":{"s":17},"t":{"h":12,"i":{"v":18}},"z":18},41],"b":23,"d":1,"e":{".":25,"d":25,"e":{"z":17},"l":{"i":{"n":0,"s":4,"z":4},"y":18},"n":[{"a":{"t":1},"i":{"z":4},"o":18,"y":18,"c":{"y":{".":8}}},41],"o":[{"m":3,"d":215},41],"r":{"y":21},"s":{"i":32},"t":{"h":6,"o":18,"y":1,"i":{"c":{".":8}}},"v":1},"g":[{"e":[{"r":23},24],"l":{"u":6},"o":0},101],"h":{"i":{"n":3},"o":{"u":{"t":4}},"t":{"o":1,"w":{"e":15}}},"i":{".":32,"a":[{"r":5},102],"c":[{"i":{"a":32},"o":21},29],"e":{"n":6,"s":{".":32}},"l":0,"m":{"e":{"n":23}},"n":{".":68,"g":{"e":5},"s":103},"o":32,"r":[{"l":0},27],"s":{"l":23},"u":1,"v":32,"z":27},"l":[{"a":[{"d":{"i":6},"s":32},0],"e":[{"a":{"d":29}},41],"i":{"b":0,"g":23,"s":{"h":43}},"o":[{"r":11,"b":{"i":{"n":106}}},27]},9],"m":[{"y":21},29],"n":{"a":[{".":21,"c":69},1],"e":{"t":{"t":17,"i":{"s":{"m":137}}}},"i":[{"n":24,"o":21},29],"o":[{"n":21,"m":{"o":5},"r":{".":216,"e":{"s":{"p":24}}}},29]},"o":[{".":27,"b":5,"e":32,"g":104,"i":{"s":3},"n":[{"a":105,"d":{"o":7},"i":[{"z":{"a":217}},3]},8],"o":32,"r":{"i":{"z":4},"o":{"u":5}},"s":{".":32},"v":15},41],"p":23,"r":[{"a":{"d":{"a":18},"i":21,"n":84,"p":{"h":{".":32,"e":{"r":[{".":7},19]},"i":{"c":32},"y":18}},"y":18},"e":{"n":0,"s":{"s":{".":18}}},"i":{"t":18,"e":{"v":213}},"o":21,"u":{"f":17}},41],"s":[{"t":{"e":19}},9],"t":{"h":11},"u":{"a":[{"r":{"d":27}},1],"e":25,"i":{"t":106},"n":27,"s":27,"t":[{"a":{"n":29}},26]},"w":23,"y":[{"n":107,"r":{"a":4}},41]},"h":{"a":{"b":{"l":73},"c":{"h":17},"e":{"m":0,"t":0},"g":{"u":19},"l":{"a":[{"m":12},3]},"m":1,"n":{"c":{"i":0,"y":0},"d":{".":32},"g":[{"e":{"r":6},"o":6},0],"i":{"z":108},"k":0,"t":{"e":0}},"p":{"l":11,"t":5,"a":{"r":{"r":218}}},"r":{"a":{"n":3,"s":4},"d":[{"e":12},8],"l":{"e":0},"p":{"e":{"n":6}},"t":{"e":{"r":5}}},"s":{"s":5},"u":{"n":17},"z":[{"a":11},32],"i":{"r":{"s":137}},"t":{"c":{"h":213}}},"b":29,"e":{"a":{"d":41,"r":27},"c":{"a":{"n":1,"t":19}},"d":[{"o":13},21],"l":{"i":93,"l":{"i":{"s":0},"y":0},"o":19},"m":{"p":0},"n":[{"a":[{"t":5},17]},9],"o":{"r":5},"p":5,"r":{"a":[{"p":12},21],"b":{"a":0},"e":{"a":6},"n":23,"o":{"u":19},"y":23},"s":[{"p":64},29],"t":[{"e":{"d":0}},1],"u":0,"x":{"a":168}},"f":29,"h":29,"i":{"a":{"n":4},"c":{"o":1},"g":{"h":6},"l":109,"m":{"e":{"r":36}},"n":{"a":21},"o":{"n":{"e":17}},"p":[{"e":{"l":{"a":219}}},1],"r":{"l":0,"o":3,"p":0,"r":0},"s":{"e":{"l":11},"s":0},"t":{"h":{"e":{"r":6}},"e":{"s":{"i":{"d":12}}}},"v":9},"k":18,"l":[{"a":{"n":17},"o":[{"r":{"i":11}},24]},80],"m":[{"e":{"t":17}},43],"n":[{"a":{"u":{"z":12}}},42],"o":{"d":{"i":{"z":19},"s":19},"g":[{"e":17},1],"l":{"a":{"r":5},"e":110},"m":{"a":1,"e":12},"n":{"a":0,"y":4},"o":{"d":27,"n":17},"r":{"a":{"t":5},"i":{"s":4,"c":{".":187}},"t":{"e":12},"u":4},"s":{"e":[{"n":4},0],"p":15},"u":{"s":[{"e":54},41]},"v":{"e":{"l":5}}},"p":56,"r":[{"e":{"e":6},"o":{"n":{"i":{"z":5}},"p":{"o":11}}},26],"s":[{"h":21},101],"t":{"a":{"r":21},"e":{"n":2,"s":4,"o":{"u":216}},"y":21},"u":{"g":1,"m":{"i":{"n":1}},"n":{"k":{"e":5},"t":0},"s":{"t":14},"t":1},"w":[{"a":{"r":{"t":21}}},29],"y":{"p":{"e":3,"h":3,"o":{"t":{"h":{"a":137}}}},"s":9}},"i":{"a":[{"l":24,"m":[{"e":{"t":{"e":5}}},0],"n":[{"c":18,"i":11,"t":46},24],"p":{"e":4},"s":{"s":17},"t":{"i":{"v":21},"r":{"i":{"c":1}},"u":21}},42],"b":{"e":[{"r":{"a":3,"t":4}},0],"i":{"a":4,"n":3,"t":{".":4,"e":4}},"l":[{"i":3},29],"o":19,"r":[{"i":94},29],"u":{"n":19}},"c":{"a":{"m":18,"p":32,"r":[{".":21,"a":21},18],"s":6,"y":21},"c":{"u":17},"e":{"o":18},"h":18,"i":[{"d":19,"n":{"a":4},"p":[{"a":3},24]},25],"l":{"y":21},"o":{"c":94},"r":[{"a":32,"y":21},43],"t":{"e":1,"u":[{"a":111},84]},"u":{"l":{"a":3},"m":1,"o":4,"r":23}},"d":[{"a":{"i":21,"n":{"c":4}},"d":4,"e":{"a":{"l":11},"s":0},"i":[{"a":{"n":4,"r":0},"e":19,"o":[{"u":5,"s":1},3],"t":2,"u":4},24],"l":{"e":23},"o":{"m":21,"w":3},"r":21,"u":[{"o":4},24]},25],"e":[{"d":{"e":0},"g":{"a":113},"l":{"d":12},"n":{"a":67,"e":0,"n":19,"t":{"i":23}},"r":{".":29},"s":{"c":23,"t":29},"t":23},112],"f":{".":18,"e":{"r":{"o":4}},"f":{"e":{"n":5},"r":1},"i":{"c":{".":18},"e":23},"l":23,"t":18,"a":{"c":{"e":{"t":137}}}},"g":[{"a":{"b":5},"e":{"r":{"a":3}},"h":{"t":{"i":12}},"i":[{"b":23,"l":3,"n":3,"t":3},18],"l":28,"o":[{"r":3,"t":4},24],"r":{"e":19},"u":{"i":5,"r":2},"n":{"i":{"t":[{"e":{"r":213}},0]}}},25],"h":23,"i":114,"j":[{"k":21},23],"k":18,"l":{"a":[{"b":93,"d":{"e":21},"m":94,"r":{"a":5}},29],"e":{"g":23,"r":2,"v":17},"f":4,"i":[{"a":3,"b":9,"o":3,"s":{"t":1},"t":25,"z":9},2],"l":{"a":{"b":5}},"n":18,"o":{"q":3},"t":{"y":1},"u":{"r":4},"v":3},"m":{"a":{"g":[{"e":3},21],"r":{"y":5}},"e":{"n":{"t":{"a":{"r":10}}},"t":18},"i":[{"d":{"a":4},"l":{"e":5},"n":{"i":19},"t":18},2],"n":{"i":1},"o":{"n":23},"u":[{"l":{"a":3}},24],"p":{"e":{"d":{"a":201}}}},"n":{".":25,"a":{"u":83,"v":18},"c":{"e":{"l":36,"r":3}},"d":[{"l":{"i":{"n":{"g":4}}}},18],"e":[{"e":23,"r":{"a":{"r":17}},"s":{"s":19}},25],"g":{"a":18,"e":[{"n":4},18],"i":18,"l":{"i":{"n":{"g":4}}},"o":18,"u":18},"i":[{".":19,"a":21,"o":3,"s":2,"t":{"e":{".":19,"l":{"y":{".":19}}},"i":{"o":32},"y":3}},25],"k":18,"l":18,"n":25,"o":[{"c":90,"s":0,"t":21},42],"s":[{"e":3,"u":{"r":{"a":7}}},25],"t":{".":25,"h":112},"u":[{"s":19},2],"y":18,"f":{"r":{"a":{"s":220}}}},"o":[{".":18,"g":{"e":17,"r":9},"l":29,"m":1,"n":{"a":{"t":11},"e":{"r":{"y":0}},"i":11},"p":{"h":4},"r":{"i":11},"s":21,"t":{"h":4,"i":19,"o":1},"u":{"r":21}},25],"p":[{"e":0,"h":{"r":{"a":{"s":115}}},"i":[{"c":1},3],"r":{"e":96},"u":{"l":3}},25],"q":{"u":{"a":23,"e":{"f":4},"i":{"d":3,"t":116}}},"r":[{"a":[{"b":0,"c":21},29],"d":{"e":5},"e":{"d":{"e":0},"f":21,"l":117,"s":21},"g":{"i":4},"i":[{"d":{"e":5},"s":1,"t":{"u":11},"z":118},2],"m":{"i":{"n":1}},"o":{"g":0,"n":{".":32}},"u":{"l":4},"r":{"e":{"v":{"o":{"c":221}}}}},18],"s":{".":25,"a":{"g":4,"r":3,"s":6},"c":[{"h":3},119],"e":[{"r":3},18],"f":27,"h":{"a":{"n":4},"o":{"n":3,"p":5}},"i":{"b":3,"d":0,"s":19,"t":{"i":{"v":4}}},"k":26,"l":{"a":{"n":36}},"m":{"s":18},"o":[{"m":{"e":{"r":5}}},24],"p":[{"i":9,"y":1},2],"s":[{"a":{"l":1},"e":{"n":36,"s":1}},62],"t":{"a":{".":1},"e":2,"i":2,"l":{"y":0},"r":{"a":{"l":18}}},"u":[{"s":4},24]},"t":{"a":{".":18,"b":{"i":0},"g":21,"m":120,"n":23,"t":23},"e":[{"r":{"a":3,"i":19},"s":[{"i":{"m":{"a":29}}},1]},25],"h":[{"i":{"l":148}},25],"i":[{"a":18,"c":[{"a":3,"k":31},22],"g":3,"l":{"l":4},"m":24,"o":25,"s":[{"m":21},18],"n":{"e":{"r":{"a":{"r":158}}}}},29],"o":{"m":121,"n":18},"r":{"a":{"m":21},"y":4},"t":18,"u":{"a":{"t":3},"d":19,"l":3},"z":{".":18}},"u":29,"v":[{"e":{"l":{"l":3},"n":{".":3},"r":{".":83,"s":{".":21}}},"i":{"l":{".":4},"o":4,"t":2},"o":{"r":{"e":19,"o":35},"t":83}},25],"w":56,"x":{"o":1},"y":18,"z":{"a":{"r":18},"i":0,"o":{"n":{"t":32}}}},"j":{"a":[{"c":{"q":0},"p":[{"a":{"n":{"e":{"s":220}}}},1],"n":{"u":{"a":12}}},32],"e":[{"r":{"s":5,"e":{"m":222}},"s":{"t":{"i":{"e":18},"y":18}},"w":11},41],"o":{"p":1},"u":{"d":{"g":32}}},"k":{"a":{".":27,"b":23,"g":19,"i":{"s":17},"l":0},"b":29,"e":{"d":24,"e":41,"g":1,"l":{"i":[{"n":{"g":223}},4]},"n":{"d":73},"r":29,"s":[{"t":{".":23}},0],"t":{"y":1}},"f":23,"h":1,"i":[{".":32,"c":122,"l":{"l":21,"o":6},"m":21,"n":{".":21,"d":{"e":0},"e":{"s":{"s":19},"t":{"i":{"c":224}}},"g":0},"p":1,"s":[{"h":19},0]},29],"k":1,"l":[{"e":{"y":18},"y":18},29],"m":29,"n":{"e":{"s":19},"o":69},"o":{"r":4,"s":{"h":17},"u":23,"v":{"i":{"a":{"n":41}}}},"r":{"o":{"n":5}},"s":[{"c":21,"l":1,"y":21,"h":{"a":23}},101],"t":19,"w":29},"l":{"a":{"b":{"i":{"c":11},"o":21},"c":{"i":[{"e":225},17]},"d":{"e":21,"y":3},"g":{"n":0},"m":{"o":11},"n":{"d":[{"l":0},27],"e":{"t":5},"t":{"e":0}},"r":{"g":0,"i":11,"c":{"e":{"n":176}}},"s":{"e":0},"t":{"a":{"n":4},"e":{"l":{"i":18}},"i":{"v":18}},"v":[{"a":95},18],"i":{"n":{"e":{"s":{"s":226}}}}},"b":[{"i":{"n":17}},42],"c":[{"e":0,"i":23,"h":{"a":{"i":23},"i":{"l":{"d":227}}}},101],"d":[{"e":[{"r":{"e":1,"i":1}},24],"i":[{"s":4},0],"r":[{"i":21},23]},25],"e":{"a":[{"d":{"e":{"r":{".":183}}},"s":{"a":228}},9],"b":{"i":1},"f":{"t":6},"g":{".":32,"g":32,"e":{"n":{"d":{"r":{"e":230}}}}},"m":{"a":{"t":[{"i":{"c":5}},1]}},"n":{".":18,"c":27,"e":{".":32},"t":41,"o":{"i":{"d":78}}},"p":{"h":3,"r":1},"r":{"a":{"b":6},"e":0,"g":27,"i":68,"o":21},"s":[{"c":{"o":4},"q":32,"s":[{".":32},27]},8],"v":{"a":23,"e":{"r":{".":0,"a":0,"s":0}}},"y":[{"e":18},27],"c":{"t":{"a":{"b":229}}}},"f":[{"r":19},25],"g":[{"a":[{"r":12},19],"e":{"s":21},"o":11},80],"h":48,"i":{"a":{"g":1,"m":9,"r":{"i":{"z":6}},"s":1,"t":{"o":1}},"b":{"i":4},"c":{"i":{"o":32},"o":{"r":1},"s":18,"t":{".":18},"u":21,"y":23},"d":{"a":23,"e":{"r":5},"i":27},"f":{"e":{"r":11},"f":21,"l":1},"g":{"a":{"t":{"e":32}},"h":27,"r":{"a":1}},"k":27,"l":123,"m":{"b":{"l":0},"i":11,"o":1,"p":90},"n":{"a":21,"e":[{"a":11},124],"i":11,"k":{"e":{"r":6}}},"o":{"g":4},"q":125,"s":{"p":0},"t":[{".":24,"i":{"c":{"a":32,"s":108}},"h":{"o":{"g":204}}},29],"v":{"e":{"r":11}},"z":29},"j":18,"k":{"a":[{"l":23,"t":0},11]},"l":[{"a":{"w":21},"e":[{"a":19,"c":23,"g":23,"l":23,"n":73,"t":73},24],"i":[{"n":[{"a":19},126],"s":{"h":231}},9],"o":[{"q":{"u":{"i":10}},"u":{"t":4},"w":19},1],"f":{"l":2}},29],"m":[{"e":{"t":19},"i":{"n":{"g":3}},"o":{"d":21,"n":[{"e":{"l":{"l":232}}},17]}},25],"n":81,"o":{".":27,"b":{"a":{"l":5},"o":{"t":{"o":233}}},"c":{"i":1},"f":18,"g":{"i":{"c":27},"o":19,"u":27,"e":{"s":{".":9}}},"m":{"e":{"r":11}},"n":{"g":32,"i":[{"z":127},0]},"o":{"d":6},"p":{"e":{".":32},"i":11,"m":23},"r":{"a":[{"t":{"o":1}},17],"i":{"e":4},"o":{"u":5}},"s":{".":32,"e":{"t":5},"o":{"p":{"h":{"i":{"z":32},"y":32}}},"t":0},"t":{"a":1},"u":{"n":{"d":6},"t":25},"v":18,"a":{"d":{"e":{"d":{".":17},"r":{".":183}}}}},"p":[{"a":{"b":5},"h":{"a":23,"i":19},"i":{"n":{"g":4},"t":23},"l":21,"r":19},25],"r":43,"s":[{"c":21,"e":24,"i":{"e":21}},81],"t":[{"a":{"g":4,"n":{"e":7}},"e":[{"n":17,"r":{"a":36},"a":23},29],"h":{"i":[{"l":{"y":148}},11]},"i":{"e":{"s":{".":19}},"s":17},"r":29,"u":[{"r":{"a":12}},8]},18],"u":{"a":4,"b":{"r":3},"c":{"h":17,"i":3},"e":{"n":3,"p":15},"f":0,"i":{"d":4},"m":{"a":1,"i":32,"n":{".":19,"i":{"a":32}},"b":{"i":{"a":{".":235}}}},"o":[{"r":11},3],"p":18,"s":{"s":17,"t":{"e":11}},"t":41,"n":{"k":{"e":{"r":234}}}},"v":{"e":{"n":19,"t":128}},"w":42,"y":[{"a":18,"b":18,"m":{"e":4},"n":{"o":3},"s":[{"e":19,"t":{"y":{"r":4}}},58],"g":{"a":{"m":{"i":236}}}},41]},"m":{"a":[{"b":25,"c":{"a":9,"h":{"i":{"n":{"e":4}}},"l":1},"g":{"i":{"n":5},"n":32},"h":25,"i":{"d":6},"l":{"d":18,"i":{"g":3,"n":4},"l":{"i":0},"t":{"y":0},"a":{"p":222}},"n":{"i":{"a":32,"s":5,"z":11},".":24,"u":{"s":{"c":237}}},"p":[{"h":{"r":{"o":244}}},18],"r":{"i":{"n":{"e":{".":4}},"z":4},"l":{"y":0},"v":11,"g":{"i":{"n":238}}},"s":{"c":{"e":4},"e":0,"t":15},"t":{"e":32,"h":12,"i":{"s":3,"z":{"a":18}}}},41],"b":[{"a":{"t":129},"i":{"l":19,"n":{"g":83},"v":0}},43],"c":56,"e":{".":18,"d":[{".":18,"i":{"a":32,"e":3,"c":[{"i":{"n":152}},84],"o":{"c":239}},"y":108},25],"g":[{"r":{"a":{"n":240}}},9],"l":{"o":{"n":5},"t":0},"m":[{"o":130},9],"n":[{"a":[{"c":5},0],"d":{"e":0},"e":18,"i":0,"s":[{"u":7},17],"t":[{"e":0},27],".":24},41],"o":{"n":4},"r":{"s":{"a":19}},"s":[{"t":{"i":27}},25],"t":{"a":[{"l":11},1],"e":2,"h":{"i":4},"r":[{"i":{"c":32,"e":4},"y":3},21]},"v":1},"f":43,"h":25,"i":{".":32,"a":3,"d":{"a":[{"b":241},0],"g":0},"g":0,"l":{"i":{"a":27,"e":108,"t":{"a":27}},"l":[{"a":{"g":208},"i":{"l":{"i":59}}},21]},"n":{"a":0,"d":27,"e":{"e":19},"g":{"l":[{"i":5,"y":19},21]},"t":0,"u":[{"t":{"e":{"r":242,"s":{"t":242}}}},21],"i":{"s":{".":174}}},"o":{"t":17},"s":[{"e":{"r":{".":0}},"l":5,"t":{"i":0,"r":{"y":19}}},24],"t":{"h":18},"z":24},"k":18,"l":43,"m":[{"a":{"r":{"y":5},"b":243}},29],"n":[{"a":1,"i":{"n":21},"o":1},43],"o":[{"c":{"r":[{"a":{"t":[{"i":{"z":32}},245]}},18]},"d":131,"g":{"o":1},"i":{"s":[{"e":5},84]},"k":18,"l":{"e":{"s":{"t":4},"c":246}},"m":{"e":3},"n":{"e":{"t":5,"y":{"l":247}},"g":{"e":5},"i":{"a":12,"s":{"m":0,"t":0},"z":3},"o":{"l":36,"c":{"h":12},"e":{"n":171},"s":249},"y":{".":3}},"r":[{"a":{".":18},"o":{"n":{"i":{"s":248}}}},9],"s":[{"e":{"y":4},"p":3},8],"t":{"h":[{"e":{"t":250}},12]},"u":{"f":19,"s":[{"i":{"n":98}},27]},"v":9,"e":{"l":{"a":{"s":167}}}},41],"p":[{"a":{"r":{"a":[{"b":5},7],"i":6}},"e":{"t":23},"h":{"a":{"s":36}},"i":[{"a":0,"e":{"s":4},"n":34,"r":19,"s":4},24],"o":{"r":{"i":11},"s":{"i":{"t":{"e":6}}},"u":{"s":21},"v":6},"t":{"r":1},"y":24},43],"r":47,"s":[{"h":[{"a":{"c":{"k":251}}},21],"i":19},101],"t":18,"u":[{"l":{"a":{"r":49},"t":[{"i":[{"u":252},54]},32]},"m":27,"n":8,"p":18,"u":1,"d":{"r":{"o":9}}},41],"w":18},"n":{"a":[{"b":[{"u":21},81],"c":{".":18,"a":1,"t":19},"g":{"e":{"r":{".":5}}},"k":0,"l":{"i":[{"a":4},1],"t":18},"m":{"i":{"t":4}},"n":[{"c":{"i":36},"i":{"t":0},"k":17},24],"r":{"c":[{"h":{"s":{".":73}}},11],"e":18,"i":11,"l":0,"m":19},"s":[{"c":0,"t":{"i":5}},21],"t":[{"a":{"l":3},"o":{"m":{"i":{"z":6}}}},24],"u":[{"s":{"e":11},"t":27},24],"v":{"e":0}},41],"b":80,"c":{"a":{"r":6},"e":{"s":{".":21}},"h":{"a":23,"e":{"o":19,"s":{"t":253}},"i":{"l":19,"s":23}},"i":{"n":2,"t":1},"o":{"u":{"r":{"a":7}}},"r":29,"u":29},"d":{"a":{"i":21,"n":19},"e":[{"s":{"t":{".":4}}},29],"i":{"b":0,"f":79,"t":29,"z":23,"e":{"c":{"k":29}}},"u":{"c":19,"r":0},"w":{"e":9},"t":{"h":{"r":3}}},"e":{".":25,"a":{"r":23},"b":[{"u":11,"a":{"c":{"k":3}}},9],"c":[{"k":32},9],"d":25,"g":{"a":{"t":[{"i":{"v":5}},1]},"e":32},"l":{"a":1,"i":{"z":5}},"m":{"i":4,"o":1},"n":[{"e":18},41],"o":27,"p":{"o":1},"q":9,"r":[{"a":{"b":6,"r":21},"e":24,"i":132,"r":0},29],"s":[{".":25,"p":18,"t":25,"w":18,"k":{"i":119}},41],"t":{"i":{"c":27}},"v":[{"e":19},1],"w":1},"f":[{"i":{"n":{"i":{"t":{"e":{"s":226}}}}}},23],"g":{"a":{"b":21},"e":{"l":23,"n":{"e":[{"s":5},133]},"r":{"e":19,"i":23}},"h":{"a":4,"o":2},"i":{"b":23,"n":2,"t":19},"l":{"a":21},"o":{"v":17},"s":{"h":4,"p":{"r":2}},"u":[{"m":21},29],"y":24},"h":[{"a":[{"b":12},0],"e":0},80],"i":{"a":[{"n":[{".":114},3],"p":1},68],"b":{"a":3,"l":1},"d":[{"i":4},1],"e":{"r":1},"f":{"i":[{"c":{"a":{"t":4}}},9]},"g":{"r":19},"k":0,"m":[{"i":{"z":3}},29],"n":[{"e":{".":32},"g":0},29],"o":1,"s":{".":32,"t":{"a":0}},"t":[{"h":21,"i":{"o":27},"o":{"r":23},"r":3},24]},"j":29,"k":[{"e":{"r":{"o":19},"t":23},"i":{"n":3},"l":29,"r":{"u":{"p":3}}},44],"l":[{"e":{"s":{"s":19}}},43],"m":[{"e":[{"t":17},0]},19],"n":[{"e":0,"i":{"a":{"l":11},"v":0}},101],"o":{"b":{"l":[{"e":3},0]},"c":{"l":19,"e":{"r":{"o":{"s":254}}}},"d":66,"e":27,"g":[{"e":17},18],"i":{"s":{"i":6}},"l":{"i":134,"o":{"g":{"i":{"s":32}}}},"m":{"i":{"c":27,"z":108,"s":{"t":82}},"o":1,"y":3,"a":{"l":214},"e":{"n":{"o":194}}},"n":[{"a":{"g":0},"i":[{"z":19,"s":{"o":255}},5],"e":{"q":15}},1],"p":[{"o":{"l":{"i":135,"y":{".":256}}}},18],"r":{"a":{"b":5,"r":{"y":1}}},"s":{"c":18,"e":0,"t":5},"t":{"a":4},"u":[{"n":27},41],"v":{"e":{"l":136,"m":{"b":2}}},"w":{"l":12}},"p":[{"i":0,"r":{"e":{"c":17}}},72],"q":29,"r":[{"u":0},29],"s":[{"a":{"b":4,"t":{"i":36}},"c":[{"e":{"i":{"v":4}}},1],"e":[{"s":83},24],"i":{"d":137,"g":17},"l":24,"m":[{"o":{"o":1}},3],"o":{"c":21},"p":{"e":1,"i":19},"t":{"a":{"b":{"l":6}}}},81],"t":[{"a":{"b":0},"e":{"r":{"s":12}},"i":[{"b":19,"e":{"r":0},"f":8,"n":{"e":23,"g":83},"p":0},9],"r":{"o":{"l":{"l":{"i":7}}},"e":{"p":137}},"s":1,"u":{"m":{"e":11}}},29],"u":{"a":2,"d":1,"e":{"n":4},"f":{"f":{"e":0}},"i":{"n":23,"t":50},"m":[{"e":2,"i":19},21],"n":138,"o":23,"t":{"r":3}},"v":74,"w":72,"y":{"m":0,"p":0},"z":[{"a":23},18]},"o":{"a":[{"d":11,"l":{"e":{"s":108}},"r":{"d":12},"s":{"e":0,"t":{"e":6}},"t":{"i":5}},18],"b":{"a":{"b":35,"r":19},"e":{"l":0},"i":[{"n":[{"g":4},24]},29],"r":23,"u":{"l":3},"l":{"i":{"g":189}}},"c":{"e":29,"h":[{"e":{"t":23},"a":{"s":23}},0],"i":{"f":12,"l":21},"l":{"a":{"m":21}},"o":{"d":21},"r":{"a":{"c":3,"t":{"i":{"z":4}}},"e":12,"i":{"t":32}},"t":{"o":{"r":{"a":7}}},"u":{"l":{"a":3},"r":{"e":19}}},"d":{"d":{"e":{"d":4}},"i":{"c":3,"o":11,"t":{"i":{"c":137}}},"o":[{"r":12},139],"u":{"c":{"t":{".":4,"s":4}}},"e":{"l":{"l":{"i":12}}}},"e":{"l":21,"n":{"g":19},"r":[{"s":{"t":257}},23],"t":{"a":1},"v":23},"f":{"i":[{"t":{"e":4,"t":17}},24]},"g":{"a":{"r":121,"t":{"i":{"v":4},"o":21}},"e":[{"n":{"e":19},"o":19,"r":21},29],"i":{"e":23,"s":140,"t":3},"l":[{"y":79},21],"n":{"i":{"z":27}},"r":{"o":21},"u":{"i":5},"y":[{"n":25},41]},"h":[{"a":{"b":6}},74],"i":[{"c":{"e":{"s":11}},"d":{"e":{"r":3}},"f":{"f":17},"g":0,"l":{"e":{"t":4}},"n":{"g":23,"t":{"e":{"r":6}}},"s":{"m":19,"o":{"n":4},"t":{"e":{"n":6}}},"t":{"e":{"r":3}}},9],"j":19,"k":[{"e":{"n":23,"s":{"t":15}},"i":{"e":4}},25],"l":{"a":[{"n":21,"s":{"s":36}},29],"d":[{"e":15},9],"e":{"r":3,"s":{"c":23,"t":{"e":{"r":88}}},"t":23},"f":{"i":1},"i":[{"a":23,"c":{"e":23},"d":{".":4},"f":73,"l":19,"n":{"g":3},"o":19,"s":{".":19,"h":3},"t":{"e":19,"i":{"o":19}},"v":19,"g":{"o":{"p":{"o":258}}}},9],"l":{"i":{"e":17}},"o":{"g":{"i":{"z":4}},"r":0,"n":{"o":{"m":259}}},"p":{"l":4},"t":9,"u":{"b":3,"m":{"e":3},"n":3,"s":19},"v":9,"y":24},"m":{"a":{"h":4,"l":5,"t":{"i":{"z":4}}},"b":{"e":9,"l":1},"e":[{"n":{"a":3},"r":{"s":{"e":4}},"t":[{"r":{"y":4}},21],"c":{"h":{"a":260}}},24],"i":{"a":23,"c":{".":3,"a":3},"d":19,"n":[{"i":19},2]},"m":{"e":{"n":{"d":32}}},"o":{"g":{"e":0},"n":21},"p":{"i":3,"r":{"o":7}}},"n":[{"a":[{"c":1,"n":23},2],"c":[{"i":{"l":27}},2],"d":[{"o":4},25],"e":{"n":23,"s":{"t":4}},"g":{"u":1},"i":{"c":2,"o":23,"s":2,"u":19},"k":{"e":{"y":3}},"o":{"d":{"i":1},"m":{"y":3,"i":{"c":137}},"r":{"m":{"a":23}},"t":{"o":{"n":261}},"u":23},"s":[{"p":{"i":[{"r":{"a":10}},36]},"u":17},3],"t":{"e":{"n":36},"i":[{"f":7},93]},"u":{"m":4},"v":{"a":6}},24],"o":[{"d":{"e":5,"i":5},"k":1,"p":{"i":11},"r":{"d":23},"s":{"t":6}},9],"p":{"a":24,"e":{"d":5,"r":[{"a":[{"g":18},27]},2]},"h":[{"a":{"n":19},"e":{"r":19}},25],"i":{"n":{"g":3},"t":23,"s":{"m":{".":2}}},"o":{"n":19,"s":{"i":21}},"r":29,"u":2,"y":5},"q":29,"r":{"a":[{".":19,"g":83,"l":{"i":{"z":4}},"n":{"g":{"e":4}}},29],"e":{"a":[{"l":19},5],"i":3,"s":{"h":5,"t":{".":4}},"w":17},"g":{"u":1},"i":{"a":56,"c":{"a":3},"l":19,"n":2,"o":29,"t":{"y":3},"u":23},"m":{"i":9},"n":{"e":8},"o":{"f":19,"u":{"g":3}},"p":{"e":4},"r":{"h":27},"s":{"e":[{"n":5},1],"t":17},"t":{"h":{"i":3,"y":3,"o":{"n":{"i":{"t":262}}},"r":{"i":137}},"y":1,"i":{"v":{"e":{"l":{"y":4}}}}},"u":{"m":19},"y":29},"s":{"a":{"l":3},"c":[{"e":1,"o":{"p":[{"i":18},23]},"r":19},9],"i":{"e":95,"t":{"i":{"v":4},"o":3,"y":3},"u":0},"l":1,"o":24,"p":{"a":1,"o":1,"h":{"e":{"r":83}}},"t":{"a":[{"t":{"i":19}},9],"i":{"l":4,"t":4}}},"t":{"a":{"n":21},"e":{"l":{"e":{"g":36}},"r":{".":3,"s":4},"s":[{"t":{"e":{"r":263},"o":{"r":264}}},21]},"h":[{"e":{"s":{"i":5},"o":{"s":265}},"i":14},18],"i":{"c":{".":3,"a":4,"e":23},"f":23,"s":23},"o":{"s":5}},"u":[{"b":{"l":3,"a":{"d":{"o":116}}},"c":{"h":{"i":6}},"e":{"t":4},"l":1,"n":{"c":{"e":{"r":6}},"d":8},"v":4},9],"v":{"e":{"n":1,"r":{"n":{"e":17},"s":12,"t":1}},"i":{"s":23,"t":{"i":36},"a":{"n":{".":266}}},"o":{"l":60}},"w":{"d":{"e":{"r":3}},"e":{"l":3,"s":{"t":4}},"i":2,"n":{"i":5},"o":21},"y":{"a":2},"x":{"i":{"d":{"i":{"c":267}}}}},"p":{"a":[{"c":{"a":1,"e":1,"t":0},"d":21,"g":{"a":{"n":32,"t":23}},"i":[{"n":17},21],"l":[{"m":{"a":{"t":268}}},21],"n":{"a":0,"e":{"l":11},"t":{"y":0},"y":3},"p":[{"u":1},2],"r":{"a":{"b":{"l":6},"g":{"e":5,"r":{"a":269}},"l":{"e":228},"m":[{"e":12},36]},"d":{"i":5},"e":[{"l":5},27],"i":[{"s":0},28]},"t":{"e":[{"r":4},9],"h":{"i":{"c":32},"y":4},"r":{"i":{"c":1}}},"v":0,"y":27},41],"b":43,"d":1,"e":{".":18,"a":[{"r":{"l":17}},138],"c":9,"d":[{"e":27,"i":[{"a":36,"c":0},27]},37],"e":[{"d":0,"v":208},21],"k":0,"l":{"a":1,"i":{"e":17}},"n":{"a":{"n":1},"c":21,"t":{"h":0}},"o":{"n":4},"r":{"a":{".":21,"b":{"l":6},"g":21},"i":[{"s":{"t":6}},21],"m":{"a":{"l":0},"e":7},"n":21,"o":11,"t":{"i":11},"u":4,"v":15},"t":[{"e":{"n":4},"i":{"z":4}},9]},"f":18,"g":18,"h":{".":18,"a":{"r":{"i":6}},"e":{"n":{"o":11},"r":1,"s":{".":1}},"i":{"c":2,"e":32,"n":{"g":4},"s":{"t":{"i":32}},"z":27,"l":{"a":{"n":{"t":168},"t":{"e":{"l":270}}}}},"l":9,"o":{"b":27,"n":{"e":27,"i":32},"r":0},"s":18,"t":3,"u":32,"y":41},"i":{"a":[{"n":17},3],"c":{"i":{"e":1},"y":1,"a":{"d":271}},"d":[{"a":19,"e":3,"i":32},21],"e":{"c":27,"n":3},"g":{"r":{"a":{"p":1}}},"l":{"o":3},"n":[{".":21,"d":17,"o":21},9],"o":[{"n":17},141],"t":{"h":[{"a":4},23],"u":9}},"k":142,"l":[{"a":{"n":27,"s":{"t":6}},"i":{"a":11,"e":{"r":5},"g":18,"n":[{"a":{"r":5}},0],"c":{"a":{"b":208}}},"o":{"i":17},"u":{"m":[{"b":17},0]}},143],"m":43,"n":48,"o":{"c":1,"d":{".":32},"e":{"m":4,"t":144},"g":145,"i":{"n":[{"t":32,"c":{"a":12}},84]},"l":{"y":{"t":6,"e":137,"p":{"h":{"o":{"n":{"o":272}}}}},"e":{".":41}},"n":{"i":1},"p":1,"r":[{"y":1},124],"s":[{"s":15},41],"t":[{"a":1},21],"u":{"n":32}},"p":[{"a":{"r":{"a":5}},"e":[{"d":21,"l":19,"n":23,"r":23,"t":23},24],"o":{"s":{"i":{"t":{"e":5}}}}},43],"r":[{"a":{"y":{"e":17}},"e":{"c":{"i":32,"o":5},"e":{"m":11},"f":{"a":{"c":6}},"l":{"a":0},"r":11,"s":{"e":23,"s":27,"p":{"l":{"i":84}}},"t":{"e":{"n":5}},"v":11,"m":{"a":{"c":273}},"n":{"e":{"u":15}}},"i":{"e":53,"n":{"t":146},"s":[{"o":12},0]},"o":{"c":{"a":23,"e":{"s":{"s":8}},"i":{"t":{"y":{".":274}}}},"f":{"i":{"t":6}},"l":11,"s":{"e":12},"t":15,"g":{"e":208}}},9],"s":[{"e":[{"u":{"d":[{"o":{"d":276,"f":276}},275]}},24],"h":1,"i":{"b":21}},81],"t":[{"a":{"b":134},"e":24,"h":24,"i":{"m":11},"u":{"r":0},"w":21,"o":{"m":{"a":{"t":277}}},"r":{"o":{"l":278}}},42],"u":{"b":[{"e":{"s":{"c":181}}},11],"e":0,"f":0,"l":{"c":11},"m":1,"n":9,"r":{"r":0},"s":32,"t":[{"e":[{"r":11},32],"r":3,"t":{"e":{"d":0},"i":{"n":0}}},9]},"w":23},"q":{"u":[{"a":{"v":5,"i":{"n":{"t":{"e":279}}},"s":{"i":[{"r":281,"s":281},280]}},"e":{".":25,"r":27,"t":27},"i":{"n":{"t":{"e":{"s":{"s":282}}}},"v":{"a":{"r":14}}}},9]},"r":{"a":{"b":[{"i":3,"o":{"l":{"i":{"c":29},"o":{"i":236}}}},25],"c":{"h":{"e":17,"u":3},"l":19},"f":{"f":{"i":5},"t":0},"i":24,"l":{"o":1},"m":{"e":{"t":[{"r":{"i":{"z":283}}},11],"n":24},"i":24,"o":{"u":3}},"n":{"e":{"o":6},"g":{"e":0},"i":21,"o":4,"h":{"a":{"s":167}}},"p":{"e":{"r":11},"h":{"y":27}},"r":{"c":5,"e":[{"f":5},17],"i":{"l":18}},"s":24,"t":{"i":{"o":{"n":115}}},"u":{"t":0},"v":{"a":{"i":4},"e":{"l":11}},"z":{"i":{"e":4}},"d":{"i":{"g":127,"o":{"g":249}}},"o":{"r":2}},"b":[{"a":{"b":21,"g":21},"i":[{"f":0,"n":[{"e":19,"g":{".":4,"e":284}},24]},8],"o":1},29],"c":[{"e":[{"n":17},24],"h":{"a":23,"e":{"r":0}},"i":{"b":90,"t":1},"u":{"m":12}},29],"d":{"a":{"l":21},"i":[{"a":0,"e":{"r":0},"n":[{"g":3},17]},9]},"e":{".":25,"a":{"l":2,"n":3,"r":{"r":4},"v":32,"w":1},"b":{"r":{"a":{"t":19}}},"c":{"o":{"l":{"l":5},"m":{"p":{"e":5}}},"r":{"e":1},"i":{"p":{"r":285}},"t":{"a":{"n":{"g":286}}}},"d":[{"e":2,"i":{"s":3,"t":5}},37],"f":{"a":{"c":1},"e":[{"r":{".":4}},9],"i":3,"y":1},"g":{"i":{"s":11}},"i":{"t":4},"l":{"i":2,"u":4},"n":{"t":{"a":90,"e":0}},"o":2,"p":{"i":{"n":4},"o":{"s":{"i":1}},"u":2},"r":[{"i":21,"o":17,"u":4},147],"s":{".":21,"p":{"i":1},"s":{"i":{"b":6}},"t":[{"a":{"l":4},"r":3},8]},"t":{"e":{"r":1},"i":{"z":96},"r":{"i":[{"b":{"u":85}},3]}},"u":[{"t":{"i":4}},8],"v":[{"a":{"l":1},"e":{"l":11,"r":{".":30,"s":4,"t":4}},"i":{"l":4},"o":{"l":{"u":5}}},8],"w":{"h":1}},"f":[{"u":0,"y":21},29],"g":[{"e":{"r":3,"t":23},"i":{"c":23,"n":[{"g":3},0],"s":19,"t":19},"l":29,"o":{"n":0},"u":23},9],"h":[{".":18,"a":{"l":18}},1],"i":{"a":[{"b":0,"g":1,"l":{".":23}},3],"b":[{"a":11},21],"c":{"a":{"s":5},"e":21,"i":[{"d":32,"e":1},18],"o":21},"d":{"e":{"r":5}},"e":{"n":{"c":3,"t":3},"r":2,"t":4},"g":{"a":{"n":5},"i":32},"l":{"i":{"z":11}},"m":{"a":{"n":32},"i":5,"o":27,"p":{"e":0}},"n":{"a":[{".":32},24],"d":0,"e":0,"g":0},"o":2,"p":{"h":[{"e":6},32],"l":[{"i":{"c":5}},9]},"q":21,"s":[{".":21,"c":0,"h":23,"p":0},24],"t":{"a":{"b":116},"e":{"d":{".":19},"r":{".":5,"s":5}},"i":{"c":11},"u":[{"r":5},9]},"v":{"e":{"l":5,"t":11},"i":11,"o":{"l":287}}},"j":23,"k":{"e":{"t":23},"l":{"e":1,"i":{"n":1}},".":288,"h":{"o":2},"r":{"a":{"u":29}},"s":{".":288}},"l":[{"e":[{"d":24,"q":{"u":30}},0],"i":{"g":21,"s":[{"h":4},21]},"o":73},29],"m":[{"a":{"c":5},"e":[{"n":23,"r":{"s":4}},24],"i":{"n":{"g":[{".":21},3]},"o":21,"t":23},"y":21},29],"n":{"a":{"r":21},"e":{"l":23,"r":21,"t":19,"y":23},"i":{"c":19,"s":92,"t":23,"v":23},"o":[{"u":21},0],"u":23},"o":{"b":{"l":11,"o":{"t":289}},"c":[{"r":3},24],"e":[{"l":{"a":{"s":167}},"p":{"i":{"d":{"e":290}}}},1],"f":{"e":2,"i":{"l":4}},"k":[{"e":{"r":4}},8],"l":{"e":{".":32}},"m":{"e":{"t":{"e":5},"s":{"h":3}},"i":0,"p":0},"n":{"a":{"l":0},"e":0,"i":{"s":134},"t":{"a":0}},"o":{"m":41,"t":32},"p":{"e":{"l":3},"i":{"c":11}},"r":{"i":11,"o":4},"s":{"p":{"e":{"r":5}},"s":0},"t":{"h":{"e":1},"y":1,"r":{"o":{"n":2}}},"v":{"a":1,"e":{"l":5}},"x":5},"p":[{"e":{"a":21,"n":{"t":19},"r":{".":4},"t":23},"h":95,"i":{"n":{"g":3}},"o":23,"a":{"u":{"l":{"i":291}}}},29],"r":[{"e":{"c":0,"f":0,"o":21,"s":{"t":0}},"i":{"o":0,"v":0},"o":{"n":17,"s":17},"y":{"s":17}},72],"s":[{"a":[{"t":{"i":5}},29],"c":1,"e":[{"c":[{"r":0},23],"r":{".":4,"a":{"d":{"i":238}}},"s":3,"v":148},24],"h":[{"a":19},29],"i":[{"b":90},29],"o":{"n":12},"p":29,"w":19},44],"t":{"a":{"c":{"h":36},"g":21},"e":{"b":23,"n":{"d":17},"o":5},"i":[{"b":4,"d":0,"e":{"r":21},"g":23,"l":{"i":12,"l":17,"y":21},"s":{"t":21},"v":21},29],"r":{"i":23,"o":{"p":{"h":115}},"e":{"u":29}},"s":{"h":1},"h":{"o":{"u":29}}},"u":{"a":3,"e":{"l":93,"n":3},"g":{"l":1},"i":{"n":3},"m":{"p":{"l":11}},"n":[{"k":6,"t":{"y":0}},9],"s":{"c":19},"t":{"i":{"n":6}}},"v":{"e":[{"l":{"i":17},"n":23,"r":{".":4},"s":{"t":19},"y":23,"i":{"l":29}},1],"i":{"c":23,"v":0},"o":23},"w":29,"y":{"c":1,"n":{"g":{"e":32}},"t":3},"z":{"s":{"c":2}}},"s":{"a":[{"b":42,"c":{"k":32,"r":{"i":11},"t":23},"i":32,"l":{"a":{"r":36},"m":0,"o":4,"t":0,"e":{"s":{"c":54,"w":7}}},"n":{"c":27,"d":{"e":0}},"p":[{"a":{"r":{"i":{"l":292}}}},29],"t":{"a":4,"i":{"o":76},"u":11},"u":0,"v":{"o":{"r":4}},"w":32},9],"b":56,"c":{"a":{"n":{"t":149},"p":[{"e":{"r":267}},0],"v":6,"t":{"o":{"l":208}}},"e":{"d":21,"i":18,"s":21},"h":[{"o":21,"i":{"t":{"z":21}},"r":{"o":{"d":{"i":{"n":{"g":293}}}}}},8],"i":{"e":68,"n":{"d":150},"u":{"t":{"t":294}}},"l":{"e":6,"i":21},"o":{"f":17,"p":{"y":18},"u":{"r":{"a":7}}},"u":29,"r":{"a":{"p":{"e":{"r":{".":36}}}}},"y":{"t":{"h":247}}},"d":56,"e":{".":18,"a":[{"s":17,"w":5},1],"c":{"o":151,"t":27},"d":[{"e":95,"l":19},125],"g":[{"r":11},9],"i":32,"l":{"e":2,"f":32,"v":32},"m":{"e":[{"s":{"t":295}},18],"o":{"l":1},"a":{"p":{"h":287}},"i":{"t":{"i":{"c":296}}}},"n":{"a":{"t":5},"c":18,"d":0,"e":{"d":19},"g":5,"i":{"n":19},"t":{"d":18,"l":18}},"p":{"a":152,"t":{"e":{"m":{"b":11}}}},"r":{".":43,"l":21,"o":0,"v":{"o":18}},"s":[{"h":4,"t":5},72],"u":{"m":113},"v":[{"e":{"n":11}},32],"w":{"i":0},"x":32},"f":47,"g":48,"h":[{".":25,"e":{"r":2,"v":32},"i":{"n":2,"o":3,"p":27,"v":6},"o":[{"l":{"d":4},"n":12,"r":[{"t":7},17],"e":{"s":{"t":137}}},0],"w":18},24],"i":{"b":2,"c":{"c":19},"d":{"e":{".":27,"s":[{"t":6,"w":6},32],"d":{".":8}},"i":[{"z":4},32]},"g":{"n":{"a":18}},"l":{"e":0,"y":18},"n":[{"a":24,"e":{".":32},"g":23},42],"o":[{"n":[{"a":6},32]},41],"r":[{"a":5,"e":{"s":{"i":{"d":4}}}},9],"s":41,"t":{"i":{"o":27}},"u":32,"v":41,"z":32},"k":[{"e":[{"t":23},18],"i":{"n":{"e":4,"g":4}},"y":{"s":{"c":15}}},9],"l":[{"a":{"t":23},"e":24,"i":{"t":{"h":7}},"o":{"v":{"a":{"k":{"i":{"a":297}}}}}},74],"m":[{"a":[{"l":{"l":54},"n":12},23],"e":{"l":17,"n":19},"i":{"t":{"h":32}},"o":{"l":{"d":49}}},42],"n":72,"o":[{"c":{"e":1},"f":{"t":12},"l":{"a":{"b":1},"d":153,"i":{"c":3},"v":32,"u":{"t":{"e":9}}},"m":27,"n":{".":68,"a":17,"g":0},"p":[{"h":{"i":{"c":32,"z":19},"y":19}},21],"r":{"c":5,"d":5},"v":[{"i":4},18],"g":{"a":{"m":{"y":298}}}},41],"p":{"a":[{"i":32,"n":0,"c":{"e":299,"i":{"n":69}}},25],"e":{"n":{"d":17},"o":57,"r":25,"c":{"i":{"o":11}}},"h":{"e":[{"r":[{"o":213},27]},24],"o":6},"i":{"l":17,"n":{"g":4},"o":18,"c":{"i":{"l":208}}},"l":{"y":21},"o":{"n":21,"r":[{"t":{"s":{"c":300,"w":300}}},17],"t":18,"k":{"e":{"s":{"w":10}}}}},"q":{"u":{"a":{"l":{"l":36}},"i":{"t":{"o":88}}}},"r":29,"s":[{"a":[{"s":12,"c":{"h":{"u":301}}},29],"c":94,"e":{"l":23,"n":{"g":19},"s":{".":21},"t":19},"i":[{"e":[{"r":0},21],"l":{"y":4},"a":{"n":{".":210}},"g":{"n":{"a":{"b":302}}}},29],"l":[{"i":1},21],"n":21,"p":{"e":{"n":{"d":115}}},"t":9,"u":{"r":{"a":6}},"w":4,"h":{"a":{"t":3}}},25],"t":{".":25,"a":{"g":24,"l":24,"m":{"i":17,"p":69},"n":{"d":32,"t":{"s":{"h":{"i":303}}}},"p":90,"t":{".":32,"i":15},"r":{"t":{"l":{"i":12}}}},"e":{"d":21,"r":{"n":{"i":7},"o":19},"w":[{"a":6},8]},"h":{"e":23},"i":[{".":21,"a":19,"c":[{"k":32},29],"e":21,"f":23,"n":{"g":3},"r":32},9],"l":{"e":29},"o":{"c":{"k":32},"m":{"a":12},"n":{"e":32},"p":21,"r":{"e":27,"a":{"b":304}}},"r":[{"a":{"d":21,"t":{"u":32,"a":{"g":305}},"y":21},"i":{"d":21,"b":{"u":{"t":7}}},"y":18},1],"w":61,"y":[{"l":{"i":{"s":137}}},24],"b":4,"s":{"c":{"r":4}},"u":{"p":{"i":{"d":306}}}},"u":[{"a":{"l":2},"b":111,"g":151,"i":{"s":4,"t":12},"l":21,"m":[{"i":11},9],"n":9,"r":9,"p":{"e":{"r":{"e":307}}}},41],"v":18,"w":[{"o":18,"i":{"m":{"m":177}}},9],"y":[{"c":18,"l":27,"n":{"o":5,"c":41},"r":{"i":{"n":4}},"t":{"h":{"i":308}}},21]},"t":{"a":[{".":27,"b":[{"l":{"e":{"s":4}},"o":{"l":{"i":{"z":32,"s":{"m":309}}}}},25],"c":{"i":18},"d":{"o":4},"f":46,"i":{"l":{"o":5}},"l":[{"a":4,"e":{"n":5},"i":11,"k":[{"a":204},18],"l":{"i":{"s":0}},"o":{"g":4}},9],"m":{"o":4,"i":{"n":82}},"n":{"d":{"e":0},"t":{"a":54}},"p":{"e":{"r":4},"l":4,"a":{"t":{"h":310}}},"r":{"a":0,"c":18,"e":18,"i":{"z":3},"r":{"h":311}},"s":{"e":0,"y":4},"t":{"i":{"c":18},"u":{"r":1}},"u":{"n":17},"v":0,"w":25,"x":{"i":{"s":0}},"g":{"o":{"n":{".":3}}}},41],"b":42,"c":[{"h":[{"e":{"t":5},"c":15,"i":{"e":{"r":237}}},21],"r":29},18],"d":43,"e":{".":18,"a":{"d":{"i":17},"t":18,"c":{"h":{"e":{"r":{".":36}}}}},"c":{"e":17,"t":32},"d":[{"i":4},42],"e":41,"g":[{"e":{"r":4},"i":4},0],"l":{".":27,"i":17,"s":32,"e":{"g":84,"r":{"o":249}}},"m":{"a":[{"t":11},154]},"n":{"a":{"n":27},"c":27,"d":27,"e":{"s":18},"t":[{"a":{"g":0}},41]},"o":41,"p":[{"e":4},1],"r":{"c":11,"d":155,"i":[{"e":{"s":5},"s":11,"z":{"a":6},"c":{".":8}},41],"n":{"i":{"t":32}},"v":5,"g":{"e":{"i":312}}},"s":{".":18,"s":[{".":23,"e":{"s":313}},18]},"t":{"h":{"e":6}},"u":27,"x":27,"y":18},"f":42,"g":43,"h":{".":25,"a":{"n":17,"l":{"a":{"m":228}}},"e":[{"a":[{"s":3,"t":5},18],"i":{"s":11},"t":27},9],"i":{"c":{".":4,"a":4},"l":18,"n":{"k":32}},"l":18,"o":{"d":{"e":4,"i":{"c":32},"o":{"n":11}},"o":18,"r":{"i":{"t":6,"z":5}},"g":{"e":{"n":{"i":314}}},"k":{"e":{"r":175}}},"s":25,"y":{"l":{"a":{"n":228}},"s":{"c":11}}},"i":{"a":[{"b":1,"t":{"o":1},"n":{".":70}},41],"b":156,"c":{"k":18,"o":21,"u":157},"d":{"i":32},"e":{"n":27},"f":[{"y":4},8],"g":[{"u":32},25],"l":{"l":{"i":{"n":6}}},"m":[{"p":18,"u":{"l":5}},41],"n":[{"a":24,"e":{".":27},"i":27,"o":{"m":285}},42],"o":[{"c":4,"n":{"e":{"e":6}}},41],"q":32,"s":{"a":3,"e":27,"m":0,"o":4,"p":0,"t":{"i":{"c":{"a":32}}}},"t":{"l":3},"u":1,"v":[{"a":0},41],"z":[{"a":3,"e":{"n":3}},41]},"l":[{"a":[{"n":17},19],"e":{".":27,"d":27,"s":{".":27},"t":{".":19}},"o":19,"i":{"e":{"r":315}}},25],"m":[{"e":0},43],"n":81,"o":[{"b":3,"c":{"r":{"a":{"t":4}}},"d":{"o":18},"f":25,"g":{"r":9},"i":{"c":4},"m":{"a":9,"b":0,"y":3},"n":{"a":{"l":{"i":0},"t":3},"o":18,"y":18},"r":{"a":9,"i":{"e":3,"z":5}},"s":8,"u":{"r":32,"t":18},"w":{"a":{"r":3}},"l":{"o":{"g":{"y":84}}},"t":{"i":{"c":11}}},41],"p":43,"r":{"a":[{"b":11,"c":{"h":5,"i":[{"t":17},36],"t":{"e":17}},"s":17,"v":{"e":{"n":5,"s":158,"r":{"s":[{"a":{"b":317}},15]}}},"i":{"t":{"o":{"r":316}}}},41],"e":{"f":5,"m":[{"i":6},0],"a":{"c":{"h":{"e":318}}}},"i":{"a":[{"l":{".":1}},32],"c":{"e":{"s":5},"i":{"a":32},"s":18},"m":25,"v":0},"o":{"m":{"i":5},"n":{"i":6,"y":18},"p":{"h":{"e":5},"i":{"s":175},"o":{"l":{"e":{"s":320},"i":{"s":320,"t":321}}}},"s":{"p":11},"v":11,"l":{"e":{"u":{"m":319}}},"f":{"i":{"c":{".":17},"t":11}}},"u":{"i":5,"s":17}},"s":[{"c":[{"h":{"i":{"e":12}}},21],"h":0,"w":21},101],"t":[{"e":{"s":21},"o":19,"u":0,"r":{"i":{"b":{"u":{"t":322}}}}},66],"u":[{"a":[{"r":3},2],"b":{"i":1},"d":8,"e":18,"f":46,"i":76,"m":27,"n":{"i":{"s":1}},"p":{".":48},"r":{"e":27,"i":[{"s":11},32],"o":5,"y":4,"n":{"a":{"r":12}}},"s":27},41],"v":18,"w":[{"a":43,"i":{"s":17},"o":18,"h":29},1],"y":[{"a":18,"l":25,"p":{"e":12,"h":4,"a":{"l":64}}},41],"z":[{"e":1},18]},"u":{"a":{"b":18,"c":0,"n":{"a":4,"i":0},"r":{"a":{"n":{"t":5}},"d":8,"i":11,"t":11},"t":29,"v":0,"d":{"r":{"a":{"t":{"i":3,"u":15}}}}},"b":{"e":[{"l":21,"r":[{"o":21},23]},1],"i":[{"n":{"g":33}},72],"l":{"e":{".":23}}},"c":{"a":23,"i":{"b":0,"t":1},"l":{"e":12},"r":23,"u":23,"y":21},"d":{"d":4,"e":{"r":3,"s":{"t":4},"v":17},"i":{"c":29,"e":{"d":3,"s":3},"s":4,"t":19},"o":{"n":[{"y":232},21]},"s":{"i":1},"u":21},"e":{"n":{"e":21,"s":17,"t":{"e":0}},"r":{"i":{"l":0}},"a":{"m":15}},"f":{"a":27,"l":23},"g":{"h":{"e":{"n":11}},"i":{"n":4}},"i":[{"l":{"i":{"z":5}},"n":[{"g":29},1],"r":{"m":0},"t":{"a":17},"v":[{"e":{"r":{".":0}}},11]},156],"j":19,"k":18,"l":{"a":[{"b":5,"t":{"i":19}},29],"c":{"h":[{"e":32},17]},"d":{"e":{"r":3}},"e":[{"n":29},1],"g":{"i":1},"i":[{"a":19,"n":{"g":3},"s":{"h":4}},9],"l":{"a":{"r":1},"i":{"b":96,"s":1}},"m":61,"o":72,"s":[{"e":{"s":5}},18],"t":{"i":2,"r":{"a":54},"u":18},"u":[{"l":4},23],"v":4},"m":{"a":{"b":4},"b":{"i":1,"l":{"y":1}},"i":[{"n":{"g":83}},29],"o":{"r":{"o":6}},"p":9},"n":{"a":{"t":17},"e":[{"r":1},24],"i":[{"m":1,"n":24,"s":{"h":4},"v":11},29],"s":[{"w":1},93],"t":{"a":{"b":11},"e":{"r":{".":1},"s":1}},"u":0,"y":4,"z":4},"o":{"r":{"s":21},"s":19,"u":29},"p":{"e":[{"r":{"s":6}},29],"i":{"a":19,"n":{"g":3}},"l":23,"p":[{"o":{"r":{"t":10}}},3],"t":{"i":{"b":5},"u":17}},"r":{"a":[{".":18,"g":21,"s":21,"l":{".":216}},29],"b":{"e":1},"c":0,"d":2,"e":{"a":{"t":5}},"f":{"e":{"r":1},"r":1},"i":{"f":[{"i":{"c":0}},23],"n":2,"o":23,"t":29,"z":3,"a":{"l":{".":0}}},"l":[{"i":{"n":{"g":{".":5}}}},9],"n":{"o":1},"o":{"s":17},"p":{"e":1,"i":1},"s":{"e":{"r":5}},"t":{"e":{"s":4},"h":{"e":3},"i":[{"e":1},17]},"u":23},"s":[{"a":{"d":19,"n":19,"p":1},"c":[{"i":3},8],"e":{"a":5,"r":{".":9}},"i":{"a":19,"c":23},"l":{"i":{"n":1}},"p":2,"s":{"l":4},"t":{"e":{"r":{"e":4}},"r":2},"u":[{"r":17},24]},25],"t":{"a":{"b":0,"t":23},"e":{".":18,"l":18,"n":[{"i":17},18]},"i":[{"l":{"i":{"z":5}},"n":{"e":23,"g":3},"o":{"n":{"a":7}},"s":21,"z":31},101],"l":34,"o":{"f":4,"g":5,"m":{"a":{"t":{"i":{"c":5}}}},"n":19,"u":21},"s":0},"u":[{"m":1},23],"v":74,"x":{"u":11},"z":{"e":1}},"v":{"a":[{".":32,"b":159,"c":{"i":{"l":5},"u":11},"g":[{"e":1,"u":{"e":{"r":170}}},0],"l":{"i":{"e":4},"o":5,"u":15},"m":{"o":4},"n":{"i":{"z":4}},"p":{"i":4},"r":{"i":{"e":{"d":5}}},"t":[{"i":{"v":29}},27],"u":{"d":{"e":{"v":54}}}},41],"e":{".":18,"d":18,"g":11,"l":{".":23,"l":{"i":11},"o":1,"y":21},"n":{"o":{"m":11},"u":{"e":19}},"r":{"d":21,"e":{".":32,"l":[{"y":{".":41}},21],"n":[{"c":5},23],"s":21,"i":{"g":324}},"i":{"e":11},"m":{"i":{"n":36}},"s":{"e":27},"t":{"h":11}},"s":[{".":18,"t":{"e":0,"i":{"t":{"e":15}}}},99],"t":{"e":[{"r":11},1],"y":1}},"i":{"a":{"l":{"i":4},"n":32},"d":{"e":{".":32,"d":32,"n":47,"s":32},"i":32},"f":23,"g":{"n":4},"k":0,"l":[{"i":{"t":32,"z":127}},25],"n":[{"a":26,"c":24,"d":5,"g":18},29],"o":{"l":11,"r":73,"u":2},"p":1,"r":{"o":4},"s":{"i":{"t":11},"o":3,"u":3},"t":{"i":18,"r":11,"y":18},"v":[{"i":{"p":{"a":{"r":325}}}},27]},"o":{".":32,"i":[{"r":{"d":{"u":323}},"c":{"e":{"p":213}}},0],"k":27,"l":{"a":1,"e":19,"t":32,"v":27},"m":{"i":5},"r":{"a":{"b":5},"i":17,"y":1},"t":{"a":1,"e":{"e":18}}},"v":26,"y":21},"w":{"a":{"b":{"l":19},"c":25,"g":{"e":{"r":4},"o":5},"i":{"t":6},"l":{".":19},"m":0,"r":{"t":0},"s":{"t":[{"e":{"w":{"a":326}}},0]},"t":{"e":2},"v":{"e":{"r":4,"g":327}}},"b":29,"e":{"a":{"r":{"i":{"e":5}},"t":{"h":54}},"d":{"n":0},"e":{"t":12,"v":5,"k":{"n":137}},"l":{"l":0},"r":29,"s":{"t":12},"v":23},"h":{"i":0},"i":[{"l":[{"l":{"i":{"n":6}}},8],"n":{"d":{"e":0},"g":0},"r":0,"s":{"e":27},"t":{"h":12},"z":5,"d":{"e":{"s":{"p":6}}}},9],"k":21,"l":{"e":{"s":1},"i":{"n":3}},"n":{"o":21},"o":[{"m":15,"v":{"e":{"n":4}},"k":{"e":{"n":85}}},160],"p":19,"r":{"a":[{"p":{"a":{"r":{"o":12}}}},0],"i":[{"t":{"a":36,"e":{"r":{".":183}}}},0]},"s":{"h":23,"l":1,"p":{"e":1},"t":60},"t":18,"y":1,"c":23},"x":{"a":[{"c":{"e":5},"g":{"o":21},"m":11,"p":21,"s":5},29],"c":161,"e":[{"c":{"u":{"t":{"o":1}}},"d":24,"r":{"i":0,"o":4}},29],"h":[{"i":[{"l":6},8],"u":0},29],"i":[{"a":4,"c":4,"d":{"i":4},"m":{"e":21,"i":{"z":4}}},23],"o":[{"b":21},23],"p":[{"a":{"n":{"d":17}},"e":{"c":{"t":{"o":10}},"d":11}},23],"t":[{"i":23},74],"u":[{"a":3},29],"x":1,"q":[{"u":{"i":{"s":54}}},29]},"y":{"a":{"c":19,"r":110,"t":19},"b":29,"c":[{"e":[{"r":4},24],"h":[{"e":[{"d":264},0]},23],"o":{"m":17,"t":17}},29],"d":29,"e":{"e":19,"r":[{"f":21},29],"s":[{"t":{"e":{"r":{"y":328}}}},0],"t":1},"g":{"i":19},"h":47,"i":29,"l":{"a":23,"l":{"a":{"b":{"l":6}}},"o":23,"u":19},"m":{"b":{"o":{"l":7}},"e":[{"t":{"r":{"y":20}}},0],"p":{"a":12}},"n":{"c":{"h":{"r":3}},"d":4,"g":4,"i":{"c":4},"x":32},"o":[{"d":4,"g":33,"m":0,"n":{"e":{"t":4},"s":21},"s":21},72],"p":{"e":{"d":21,"r":6},"i":3,"o":[{"c":21},23],"t":{"a":9},"u":19},"r":{"a":{"m":5},"i":{"a":4},"o":23,"r":1},"s":{"c":1,"e":161,"i":{"c":{"a":3},"o":3,"s":27},"o":21,"s":0,"t":[{"a":3,"r":{"o":29}},2],"u":{"r":17}},"t":{"h":{"i":{"n":23}},"i":{"c":3}},"w":29},"z":{"a":[{"b":79,"r":8},2],"b":18,"e":[{"n":1,"p":1,"r":[{"o":3},29],"t":0},25],"i":[{"l":21,"s":21,"a":{"n":{".":23}}},42],"l":32,"m":18,"o":[{"m":1,"o":{"l":4},"p":{"h":{"r":329}}},41],"t":{"e":0},"z":[{"y":21,"w":231},101]}}',
      [
        "as-so-ciate",
        "as-so-ciates",
        "dec-li-na-tion",
        "oblig-a-tory",
        "phil-an-thropic",
        "present",
        "presents",
        "project",
        "projects",
        "reci-procity",
        "re-cog-ni-zance",
        "ref-or-ma-tion",
        "ret-ri-bu-tion",
        "ta-ble"
      ]
    ];
  });
})(LT);
var Nre = LT.exports;
const Mre = /* @__PURE__ */ On(Nre);
Wx();
Wx();
Wx();
var z9;
(function(t) {
  t[t.GROW = 0] = "GROW", t[t.SHRINK = 1] = "SHRINK";
})(z9 || (z9 = {}));
Lre(Mre);
let En = /* @__PURE__ */ function(t) {
  return t[t.Auto = 0] = "Auto", t[t.FlexStart = 1] = "FlexStart", t[t.Center = 2] = "Center", t[t.FlexEnd = 3] = "FlexEnd", t[t.Stretch = 4] = "Stretch", t[t.Baseline = 5] = "Baseline", t[t.SpaceBetween = 6] = "SpaceBetween", t[t.SpaceAround = 7] = "SpaceAround", t[t.SpaceEvenly = 8] = "SpaceEvenly", t;
}({}), $9 = /* @__PURE__ */ function(t) {
  return t[t.BorderBox = 0] = "BorderBox", t[t.ContentBox = 1] = "ContentBox", t;
}({}), V9 = /* @__PURE__ */ function(t) {
  return t[t.Width = 0] = "Width", t[t.Height = 1] = "Height", t;
}({}), Rv = /* @__PURE__ */ function(t) {
  return t[t.Inherit = 0] = "Inherit", t[t.LTR = 1] = "LTR", t[t.RTL = 2] = "RTL", t;
}({}), Pv = /* @__PURE__ */ function(t) {
  return t[t.Flex = 0] = "Flex", t[t.None = 1] = "None", t[t.Contents = 2] = "Contents", t;
}({}), nr = /* @__PURE__ */ function(t) {
  return t[t.Left = 0] = "Left", t[t.Top = 1] = "Top", t[t.Right = 2] = "Right", t[t.Bottom = 3] = "Bottom", t[t.Start = 4] = "Start", t[t.End = 5] = "End", t[t.Horizontal = 6] = "Horizontal", t[t.Vertical = 7] = "Vertical", t[t.All = 8] = "All", t;
}({}), Pf = /* @__PURE__ */ function(t) {
  return t[t.None = 0] = "None", t[t.StretchFlexBasis = 1] = "StretchFlexBasis", t[t.AbsolutePositionWithoutInsetsExcludesPadding = 2] = "AbsolutePositionWithoutInsetsExcludesPadding", t[t.AbsolutePercentAgainstInnerSize = 4] = "AbsolutePercentAgainstInnerSize", t[t.All = 2147483647] = "All", t[t.Classic = 2147483646] = "Classic", t;
}({}), Ure = /* @__PURE__ */ function(t) {
  return t[t.WebFlexBasis = 0] = "WebFlexBasis", t;
}({}), rc = /* @__PURE__ */ function(t) {
  return t[t.Column = 0] = "Column", t[t.ColumnReverse = 1] = "ColumnReverse", t[t.Row = 2] = "Row", t[t.RowReverse = 3] = "RowReverse", t;
}({}), Hd = /* @__PURE__ */ function(t) {
  return t[t.Column = 0] = "Column", t[t.Row = 1] = "Row", t[t.All = 2] = "All", t;
}({}), Za = /* @__PURE__ */ function(t) {
  return t[t.FlexStart = 0] = "FlexStart", t[t.Center = 1] = "Center", t[t.FlexEnd = 2] = "FlexEnd", t[t.SpaceBetween = 3] = "SpaceBetween", t[t.SpaceAround = 4] = "SpaceAround", t[t.SpaceEvenly = 5] = "SpaceEvenly", t;
}({}), If = /* @__PURE__ */ function(t) {
  return t[t.Error = 0] = "Error", t[t.Warn = 1] = "Warn", t[t.Info = 2] = "Info", t[t.Debug = 3] = "Debug", t[t.Verbose = 4] = "Verbose", t[t.Fatal = 5] = "Fatal", t;
}({}), Iv = /* @__PURE__ */ function(t) {
  return t[t.Undefined = 0] = "Undefined", t[t.Exactly = 1] = "Exactly", t[t.AtMost = 2] = "AtMost", t;
}({}), j9 = /* @__PURE__ */ function(t) {
  return t[t.Default = 0] = "Default", t[t.Text = 1] = "Text", t;
}({}), qd = /* @__PURE__ */ function(t) {
  return t[t.Visible = 0] = "Visible", t[t.Hidden = 1] = "Hidden", t[t.Scroll = 2] = "Scroll", t;
}({}), n1 = /* @__PURE__ */ function(t) {
  return t[t.Static = 0] = "Static", t[t.Relative = 1] = "Relative", t[t.Absolute = 2] = "Absolute", t;
}({}), W2 = /* @__PURE__ */ function(t) {
  return t[t.Undefined = 0] = "Undefined", t[t.Point = 1] = "Point", t[t.Percent = 2] = "Percent", t[t.Auto = 3] = "Auto", t;
}({}), Yd = /* @__PURE__ */ function(t) {
  return t[t.NoWrap = 0] = "NoWrap", t[t.Wrap = 1] = "Wrap", t[t.WrapReverse = 2] = "WrapReverse", t;
}({});
En.Auto, En.FlexStart, En.Center, En.FlexEnd, En.Stretch, En.Baseline, En.SpaceBetween, En.SpaceAround, En.SpaceEvenly, $9.BorderBox, $9.ContentBox, V9.Width, V9.Height, Rv.Inherit, Rv.LTR, Rv.RTL, Pv.Flex, Pv.None, Pv.Contents, nr.Left, nr.Top, nr.Right, nr.Bottom, nr.Start, nr.End, nr.Horizontal, nr.Vertical, nr.All, Pf.None, Pf.StretchFlexBasis, Pf.AbsolutePositionWithoutInsetsExcludesPadding, Pf.AbsolutePercentAgainstInnerSize, Pf.All, Pf.Classic, Ure.WebFlexBasis, rc.Column, rc.ColumnReverse, rc.Row, rc.RowReverse, Hd.Column, Hd.Row, Hd.All, Za.FlexStart, Za.Center, Za.FlexEnd, Za.SpaceBetween, Za.SpaceAround, Za.SpaceEvenly, If.Error, If.Warn, If.Info, If.Debug, If.Verbose, If.Fatal, Iv.Undefined, Iv.Exactly, Iv.AtMost, j9.Default, j9.Text, qd.Visible, qd.Hidden, qd.Scroll, n1.Static, n1.Relative, n1.Absolute, W2.Undefined, W2.Point, W2.Percent, W2.Auto, Yd.NoWrap, Yd.Wrap, Yd.WrapReverse;
var W9 = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {}, Xo = [], ya = [], zre = typeof Uint8Array < "u" ? Uint8Array : Array, Hx = !1;
function NT() {
  Hx = !0;
  for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", e = 0, r = t.length; e < r; ++e)
    Xo[e] = t[e], ya[t.charCodeAt(e)] = e;
  ya[45] = 62, ya[95] = 63;
}
function $re(t) {
  Hx || NT();
  var e, r, n, i, a, o, s = t.length;
  if (s % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  a = t[s - 2] === "=" ? 2 : t[s - 1] === "=" ? 1 : 0, o = new zre(s * 3 / 4 - a), n = a > 0 ? s - 4 : s;
  var l = 0;
  for (e = 0, r = 0; e < n; e += 4, r += 3)
    i = ya[t.charCodeAt(e)] << 18 | ya[t.charCodeAt(e + 1)] << 12 | ya[t.charCodeAt(e + 2)] << 6 | ya[t.charCodeAt(e + 3)], o[l++] = i >> 16 & 255, o[l++] = i >> 8 & 255, o[l++] = i & 255;
  return a === 2 ? (i = ya[t.charCodeAt(e)] << 2 | ya[t.charCodeAt(e + 1)] >> 4, o[l++] = i & 255) : a === 1 && (i = ya[t.charCodeAt(e)] << 10 | ya[t.charCodeAt(e + 1)] << 4 | ya[t.charCodeAt(e + 2)] >> 2, o[l++] = i >> 8 & 255, o[l++] = i & 255), o;
}
function Vre(t) {
  return Xo[t >> 18 & 63] + Xo[t >> 12 & 63] + Xo[t >> 6 & 63] + Xo[t & 63];
}
function jre(t, e, r) {
  for (var n, i = [], a = e; a < r; a += 3)
    n = (t[a] << 16) + (t[a + 1] << 8) + t[a + 2], i.push(Vre(n));
  return i.join("");
}
function H9(t) {
  Hx || NT();
  for (var e, r = t.length, n = r % 3, i = "", a = [], o = 16383, s = 0, l = r - n; s < l; s += o)
    a.push(jre(t, s, s + o > l ? l : s + o));
  return n === 1 ? (e = t[r - 1], i += Xo[e >> 2], i += Xo[e << 4 & 63], i += "==") : n === 2 && (e = (t[r - 2] << 8) + t[r - 1], i += Xo[e >> 10], i += Xo[e >> 4 & 63], i += Xo[e << 2 & 63], i += "="), a.push(i), a.join("");
}
function Em(t, e, r, n, i) {
  var a, o, s = i * 8 - n - 1, l = (1 << s) - 1, u = l >> 1, d = -7, h = r ? i - 1 : 0, v = r ? -1 : 1, b = t[e + h];
  for (h += v, a = b & (1 << -d) - 1, b >>= -d, d += s; d > 0; a = a * 256 + t[e + h], h += v, d -= 8)
    ;
  for (o = a & (1 << -d) - 1, a >>= -d, d += n; d > 0; o = o * 256 + t[e + h], h += v, d -= 8)
    ;
  if (a === 0)
    a = 1 - u;
  else {
    if (a === l)
      return o ? NaN : (b ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, n), a = a - u;
  }
  return (b ? -1 : 1) * o * Math.pow(2, a - n);
}
function MT(t, e, r, n, i, a) {
  var o, s, l, u = a * 8 - i - 1, d = (1 << u) - 1, h = d >> 1, v = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, b = n ? 0 : a - 1, x = n ? 1 : -1, A = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, o = d) : (o = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), o + h >= 1 ? e += v / l : e += v * Math.pow(2, 1 - h), e * l >= 2 && (o++, l /= 2), o + h >= d ? (s = 0, o = d) : o + h >= 1 ? (s = (e * l - 1) * Math.pow(2, i), o = o + h) : (s = e * Math.pow(2, h - 1) * Math.pow(2, i), o = 0)); i >= 8; t[r + b] = s & 255, b += x, s /= 256, i -= 8)
    ;
  for (o = o << i | s, u += i; u > 0; t[r + b] = o & 255, b += x, o /= 256, u -= 8)
    ;
  t[r + b - x] |= A * 128;
}
var Wre = {}.toString, UT = Array.isArray || function(t) {
  return Wre.call(t) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var Hre = 50;
Le.TYPED_ARRAY_SUPPORT = W9.TYPED_ARRAY_SUPPORT !== void 0 ? W9.TYPED_ARRAY_SUPPORT : !0;
up();
function up() {
  return Le.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function rl(t, e) {
  if (up() < e)
    throw new RangeError("Invalid typed array length");
  return Le.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e), t.__proto__ = Le.prototype) : (t === null && (t = new Le(e)), t.length = e), t;
}
function Le(t, e, r) {
  if (!Le.TYPED_ARRAY_SUPPORT && !(this instanceof Le))
    return new Le(t, e, r);
  if (typeof t == "number") {
    if (typeof e == "string")
      throw new Error(
        "If encoding is specified then the first argument must be a string"
      );
    return qx(this, t);
  }
  return zT(this, t, e, r);
}
Le.poolSize = 8192;
Le._augment = function(t) {
  return t.__proto__ = Le.prototype, t;
};
function zT(t, e, r, n) {
  if (typeof e == "number")
    throw new TypeError('"value" argument must not be a number');
  return typeof ArrayBuffer < "u" && e instanceof ArrayBuffer ? Gre(t, e, r, n) : typeof e == "string" ? Yre(t, e, r) : Zre(t, e);
}
Le.from = function(t, e, r) {
  return zT(null, t, e, r);
};
Le.TYPED_ARRAY_SUPPORT && (Le.prototype.__proto__ = Uint8Array.prototype, Le.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && Le[Symbol.species]);
function $T(t) {
  if (typeof t != "number")
    throw new TypeError('"size" argument must be a number');
  if (t < 0)
    throw new RangeError('"size" argument must not be negative');
}
function qre(t, e, r, n) {
  return $T(e), e <= 0 ? rl(t, e) : r !== void 0 ? typeof n == "string" ? rl(t, e).fill(r, n) : rl(t, e).fill(r) : rl(t, e);
}
Le.alloc = function(t, e, r) {
  return qre(null, t, e, r);
};
function qx(t, e) {
  if ($T(e), t = rl(t, e < 0 ? 0 : Yx(e) | 0), !Le.TYPED_ARRAY_SUPPORT)
    for (var r = 0; r < e; ++r)
      t[r] = 0;
  return t;
}
Le.allocUnsafe = function(t) {
  return qx(null, t);
};
Le.allocUnsafeSlow = function(t) {
  return qx(null, t);
};
function Yre(t, e, r) {
  if ((typeof r != "string" || r === "") && (r = "utf8"), !Le.isEncoding(r))
    throw new TypeError('"encoding" must be a valid string encoding');
  var n = VT(e, r) | 0;
  t = rl(t, n);
  var i = t.write(e, r);
  return i !== n && (t = t.slice(0, i)), t;
}
function j3(t, e) {
  var r = e.length < 0 ? 0 : Yx(e.length) | 0;
  t = rl(t, r);
  for (var n = 0; n < r; n += 1)
    t[n] = e[n] & 255;
  return t;
}
function Gre(t, e, r, n) {
  if (e.byteLength, r < 0 || e.byteLength < r)
    throw new RangeError("'offset' is out of bounds");
  if (e.byteLength < r + (n || 0))
    throw new RangeError("'length' is out of bounds");
  return r === void 0 && n === void 0 ? e = new Uint8Array(e) : n === void 0 ? e = new Uint8Array(e, r) : e = new Uint8Array(e, r, n), Le.TYPED_ARRAY_SUPPORT ? (t = e, t.__proto__ = Le.prototype) : t = j3(t, e), t;
}
function Zre(t, e) {
  if (fs(e)) {
    var r = Yx(e.length) | 0;
    return t = rl(t, r), t.length === 0 || e.copy(t, 0, 0, r), t;
  }
  if (e) {
    if (typeof ArrayBuffer < "u" && e.buffer instanceof ArrayBuffer || "length" in e)
      return typeof e.length != "number" || pne(e.length) ? rl(t, 0) : j3(t, e);
    if (e.type === "Buffer" && UT(e.data))
      return j3(t, e.data);
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function Yx(t) {
  if (t >= up())
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + up().toString(16) + " bytes");
  return t | 0;
}
Le.isBuffer = mne;
function fs(t) {
  return !!(t != null && t._isBuffer);
}
Le.compare = function(e, r) {
  if (!fs(e) || !fs(r))
    throw new TypeError("Arguments must be Buffers");
  if (e === r) return 0;
  for (var n = e.length, i = r.length, a = 0, o = Math.min(n, i); a < o; ++a)
    if (e[a] !== r[a]) {
      n = e[a], i = r[a];
      break;
    }
  return n < i ? -1 : i < n ? 1 : 0;
};
Le.isEncoding = function(e) {
  switch (String(e).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return !0;
    default:
      return !1;
  }
};
Le.concat = function(e, r) {
  if (!UT(e))
    throw new TypeError('"list" argument must be an Array of Buffers');
  if (e.length === 0)
    return Le.alloc(0);
  var n;
  if (r === void 0)
    for (r = 0, n = 0; n < e.length; ++n)
      r += e[n].length;
  var i = Le.allocUnsafe(r), a = 0;
  for (n = 0; n < e.length; ++n) {
    var o = e[n];
    if (!fs(o))
      throw new TypeError('"list" argument must be an Array of Buffers');
    o.copy(i, a), a += o.length;
  }
  return i;
};
function VT(t, e) {
  if (fs(t))
    return t.length;
  if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer))
    return t.byteLength;
  typeof t != "string" && (t = "" + t);
  var r = t.length;
  if (r === 0) return 0;
  for (var n = !1; ; )
    switch (e) {
      case "ascii":
      case "latin1":
      case "binary":
        return r;
      case "utf8":
      case "utf-8":
      case void 0:
        return cp(t).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return r * 2;
      case "hex":
        return r >>> 1;
      case "base64":
        return ZT(t).length;
      default:
        if (n) return cp(t).length;
        e = ("" + e).toLowerCase(), n = !0;
    }
}
Le.byteLength = VT;
function Xre(t, e, r) {
  var n = !1;
  if ((e === void 0 || e < 0) && (e = 0), e > this.length || ((r === void 0 || r > this.length) && (r = this.length), r <= 0) || (r >>>= 0, e >>>= 0, r <= e))
    return "";
  for (t || (t = "utf8"); ; )
    switch (t) {
      case "hex":
        return one(this, e, r);
      case "utf8":
      case "utf-8":
        return HT(this, e, r);
      case "ascii":
        return ine(this, e, r);
      case "latin1":
      case "binary":
        return ane(this, e, r);
      case "base64":
        return rne(this, e, r);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return sne(this, e, r);
      default:
        if (n) throw new TypeError("Unknown encoding: " + t);
        t = (t + "").toLowerCase(), n = !0;
    }
}
Le.prototype._isBuffer = !0;
function nc(t, e, r) {
  var n = t[e];
  t[e] = t[r], t[r] = n;
}
Le.prototype.swap16 = function() {
  var e = this.length;
  if (e % 2 !== 0)
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  for (var r = 0; r < e; r += 2)
    nc(this, r, r + 1);
  return this;
};
Le.prototype.swap32 = function() {
  var e = this.length;
  if (e % 4 !== 0)
    throw new RangeError("Buffer size must be a multiple of 32-bits");
  for (var r = 0; r < e; r += 4)
    nc(this, r, r + 3), nc(this, r + 1, r + 2);
  return this;
};
Le.prototype.swap64 = function() {
  var e = this.length;
  if (e % 8 !== 0)
    throw new RangeError("Buffer size must be a multiple of 64-bits");
  for (var r = 0; r < e; r += 8)
    nc(this, r, r + 7), nc(this, r + 1, r + 6), nc(this, r + 2, r + 5), nc(this, r + 3, r + 4);
  return this;
};
Le.prototype.toString = function() {
  var e = this.length | 0;
  return e === 0 ? "" : arguments.length === 0 ? HT(this, 0, e) : Xre.apply(this, arguments);
};
Le.prototype.equals = function(e) {
  if (!fs(e)) throw new TypeError("Argument must be a Buffer");
  return this === e ? !0 : Le.compare(this, e) === 0;
};
Le.prototype.inspect = function() {
  var e = "", r = Hre;
  return this.length > 0 && (e = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (e += " ... ")), "<Buffer " + e + ">";
};
Le.prototype.compare = function(e, r, n, i, a) {
  if (!fs(e))
    throw new TypeError("Argument must be a Buffer");
  if (r === void 0 && (r = 0), n === void 0 && (n = e ? e.length : 0), i === void 0 && (i = 0), a === void 0 && (a = this.length), r < 0 || n > e.length || i < 0 || a > this.length)
    throw new RangeError("out of range index");
  if (i >= a && r >= n)
    return 0;
  if (i >= a)
    return -1;
  if (r >= n)
    return 1;
  if (r >>>= 0, n >>>= 0, i >>>= 0, a >>>= 0, this === e) return 0;
  for (var o = a - i, s = n - r, l = Math.min(o, s), u = this.slice(i, a), d = e.slice(r, n), h = 0; h < l; ++h)
    if (u[h] !== d[h]) {
      o = u[h], s = d[h];
      break;
    }
  return o < s ? -1 : s < o ? 1 : 0;
};
function jT(t, e, r, n, i) {
  if (t.length === 0) return -1;
  if (typeof r == "string" ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
    if (i) return -1;
    r = t.length - 1;
  } else if (r < 0)
    if (i) r = 0;
    else return -1;
  if (typeof e == "string" && (e = Le.from(e, n)), fs(e))
    return e.length === 0 ? -1 : q9(t, e, r, n, i);
  if (typeof e == "number")
    return e = e & 255, Le.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? i ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : q9(t, [e], r, n, i);
  throw new TypeError("val must be string, number or Buffer");
}
function q9(t, e, r, n, i) {
  var a = 1, o = t.length, s = e.length;
  if (n !== void 0 && (n = String(n).toLowerCase(), n === "ucs2" || n === "ucs-2" || n === "utf16le" || n === "utf-16le")) {
    if (t.length < 2 || e.length < 2)
      return -1;
    a = 2, o /= 2, s /= 2, r /= 2;
  }
  function l(b, x) {
    return a === 1 ? b[x] : b.readUInt16BE(x * a);
  }
  var u;
  if (i) {
    var d = -1;
    for (u = r; u < o; u++)
      if (l(t, u) === l(e, d === -1 ? 0 : u - d)) {
        if (d === -1 && (d = u), u - d + 1 === s) return d * a;
      } else
        d !== -1 && (u -= u - d), d = -1;
  } else
    for (r + s > o && (r = o - s), u = r; u >= 0; u--) {
      for (var h = !0, v = 0; v < s; v++)
        if (l(t, u + v) !== l(e, v)) {
          h = !1;
          break;
        }
      if (h) return u;
    }
  return -1;
}
Le.prototype.includes = function(e, r, n) {
  return this.indexOf(e, r, n) !== -1;
};
Le.prototype.indexOf = function(e, r, n) {
  return jT(this, e, r, n, !0);
};
Le.prototype.lastIndexOf = function(e, r, n) {
  return jT(this, e, r, n, !1);
};
function Kre(t, e, r, n) {
  r = Number(r) || 0;
  var i = t.length - r;
  n ? (n = Number(n), n > i && (n = i)) : n = i;
  var a = e.length;
  if (a % 2 !== 0) throw new TypeError("Invalid hex string");
  n > a / 2 && (n = a / 2);
  for (var o = 0; o < n; ++o) {
    var s = parseInt(e.substr(o * 2, 2), 16);
    if (isNaN(s)) return o;
    t[r + o] = s;
  }
  return o;
}
function Jre(t, e, r, n) {
  return km(cp(e, t.length - r), t, r, n);
}
function WT(t, e, r, n) {
  return km(dne(e), t, r, n);
}
function Qre(t, e, r, n) {
  return WT(t, e, r, n);
}
function ene(t, e, r, n) {
  return km(ZT(e), t, r, n);
}
function tne(t, e, r, n) {
  return km(hne(e, t.length - r), t, r, n);
}
Le.prototype.write = function(e, r, n, i) {
  if (r === void 0)
    i = "utf8", n = this.length, r = 0;
  else if (n === void 0 && typeof r == "string")
    i = r, n = this.length, r = 0;
  else if (isFinite(r))
    r = r | 0, isFinite(n) ? (n = n | 0, i === void 0 && (i = "utf8")) : (i = n, n = void 0);
  else
    throw new Error(
      "Buffer.write(string, encoding, offset[, length]) is no longer supported"
    );
  var a = this.length - r;
  if ((n === void 0 || n > a) && (n = a), e.length > 0 && (n < 0 || r < 0) || r > this.length)
    throw new RangeError("Attempt to write outside buffer bounds");
  i || (i = "utf8");
  for (var o = !1; ; )
    switch (i) {
      case "hex":
        return Kre(this, e, r, n);
      case "utf8":
      case "utf-8":
        return Jre(this, e, r, n);
      case "ascii":
        return WT(this, e, r, n);
      case "latin1":
      case "binary":
        return Qre(this, e, r, n);
      case "base64":
        return ene(this, e, r, n);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return tne(this, e, r, n);
      default:
        if (o) throw new TypeError("Unknown encoding: " + i);
        i = ("" + i).toLowerCase(), o = !0;
    }
};
Le.prototype.toJSON = function() {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function rne(t, e, r) {
  return e === 0 && r === t.length ? H9(t) : H9(t.slice(e, r));
}
function HT(t, e, r) {
  r = Math.min(t.length, r);
  for (var n = [], i = e; i < r; ) {
    var a = t[i], o = null, s = a > 239 ? 4 : a > 223 ? 3 : a > 191 ? 2 : 1;
    if (i + s <= r) {
      var l, u, d, h;
      switch (s) {
        case 1:
          a < 128 && (o = a);
          break;
        case 2:
          l = t[i + 1], (l & 192) === 128 && (h = (a & 31) << 6 | l & 63, h > 127 && (o = h));
          break;
        case 3:
          l = t[i + 1], u = t[i + 2], (l & 192) === 128 && (u & 192) === 128 && (h = (a & 15) << 12 | (l & 63) << 6 | u & 63, h > 2047 && (h < 55296 || h > 57343) && (o = h));
          break;
        case 4:
          l = t[i + 1], u = t[i + 2], d = t[i + 3], (l & 192) === 128 && (u & 192) === 128 && (d & 192) === 128 && (h = (a & 15) << 18 | (l & 63) << 12 | (u & 63) << 6 | d & 63, h > 65535 && h < 1114112 && (o = h));
      }
    }
    o === null ? (o = 65533, s = 1) : o > 65535 && (o -= 65536, n.push(o >>> 10 & 1023 | 55296), o = 56320 | o & 1023), n.push(o), i += s;
  }
  return nne(n);
}
var Y9 = 4096;
function nne(t) {
  var e = t.length;
  if (e <= Y9)
    return String.fromCharCode.apply(String, t);
  for (var r = "", n = 0; n < e; )
    r += String.fromCharCode.apply(
      String,
      t.slice(n, n += Y9)
    );
  return r;
}
function ine(t, e, r) {
  var n = "";
  r = Math.min(t.length, r);
  for (var i = e; i < r; ++i)
    n += String.fromCharCode(t[i] & 127);
  return n;
}
function ane(t, e, r) {
  var n = "";
  r = Math.min(t.length, r);
  for (var i = e; i < r; ++i)
    n += String.fromCharCode(t[i]);
  return n;
}
function one(t, e, r) {
  var n = t.length;
  (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);
  for (var i = "", a = e; a < r; ++a)
    i += fne(t[a]);
  return i;
}
function sne(t, e, r) {
  for (var n = t.slice(e, r), i = "", a = 0; a < n.length; a += 2)
    i += String.fromCharCode(n[a] + n[a + 1] * 256);
  return i;
}
Le.prototype.slice = function(e, r) {
  var n = this.length;
  e = ~~e, r = r === void 0 ? n : ~~r, e < 0 ? (e += n, e < 0 && (e = 0)) : e > n && (e = n), r < 0 ? (r += n, r < 0 && (r = 0)) : r > n && (r = n), r < e && (r = e);
  var i;
  if (Le.TYPED_ARRAY_SUPPORT)
    i = this.subarray(e, r), i.__proto__ = Le.prototype;
  else {
    var a = r - e;
    i = new Le(a, void 0);
    for (var o = 0; o < a; ++o)
      i[o] = this[o + e];
  }
  return i;
};
function pn(t, e, r) {
  if (t % 1 !== 0 || t < 0) throw new RangeError("offset is not uint");
  if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
}
Le.prototype.readUIntLE = function(e, r, n) {
  e = e | 0, r = r | 0, n || pn(e, r, this.length);
  for (var i = this[e], a = 1, o = 0; ++o < r && (a *= 256); )
    i += this[e + o] * a;
  return i;
};
Le.prototype.readUIntBE = function(e, r, n) {
  e = e | 0, r = r | 0, n || pn(e, r, this.length);
  for (var i = this[e + --r], a = 1; r > 0 && (a *= 256); )
    i += this[e + --r] * a;
  return i;
};
Le.prototype.readUInt8 = function(e, r) {
  return r || pn(e, 1, this.length), this[e];
};
Le.prototype.readUInt16LE = function(e, r) {
  return r || pn(e, 2, this.length), this[e] | this[e + 1] << 8;
};
Le.prototype.readUInt16BE = function(e, r) {
  return r || pn(e, 2, this.length), this[e] << 8 | this[e + 1];
};
Le.prototype.readUInt32LE = function(e, r) {
  return r || pn(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + this[e + 3] * 16777216;
};
Le.prototype.readUInt32BE = function(e, r) {
  return r || pn(e, 4, this.length), this[e] * 16777216 + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
};
Le.prototype.readIntLE = function(e, r, n) {
  e = e | 0, r = r | 0, n || pn(e, r, this.length);
  for (var i = this[e], a = 1, o = 0; ++o < r && (a *= 256); )
    i += this[e + o] * a;
  return a *= 128, i >= a && (i -= Math.pow(2, 8 * r)), i;
};
Le.prototype.readIntBE = function(e, r, n) {
  e = e | 0, r = r | 0, n || pn(e, r, this.length);
  for (var i = r, a = 1, o = this[e + --i]; i > 0 && (a *= 256); )
    o += this[e + --i] * a;
  return a *= 128, o >= a && (o -= Math.pow(2, 8 * r)), o;
};
Le.prototype.readInt8 = function(e, r) {
  return r || pn(e, 1, this.length), this[e] & 128 ? (255 - this[e] + 1) * -1 : this[e];
};
Le.prototype.readInt16LE = function(e, r) {
  r || pn(e, 2, this.length);
  var n = this[e] | this[e + 1] << 8;
  return n & 32768 ? n | 4294901760 : n;
};
Le.prototype.readInt16BE = function(e, r) {
  r || pn(e, 2, this.length);
  var n = this[e + 1] | this[e] << 8;
  return n & 32768 ? n | 4294901760 : n;
};
Le.prototype.readInt32LE = function(e, r) {
  return r || pn(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
};
Le.prototype.readInt32BE = function(e, r) {
  return r || pn(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
};
Le.prototype.readFloatLE = function(e, r) {
  return r || pn(e, 4, this.length), Em(this, e, !0, 23, 4);
};
Le.prototype.readFloatBE = function(e, r) {
  return r || pn(e, 4, this.length), Em(this, e, !1, 23, 4);
};
Le.prototype.readDoubleLE = function(e, r) {
  return r || pn(e, 8, this.length), Em(this, e, !0, 52, 8);
};
Le.prototype.readDoubleBE = function(e, r) {
  return r || pn(e, 8, this.length), Em(this, e, !1, 52, 8);
};
function Ri(t, e, r, n, i, a) {
  if (!fs(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (e > i || e < a) throw new RangeError('"value" argument is out of bounds');
  if (r + n > t.length) throw new RangeError("Index out of range");
}
Le.prototype.writeUIntLE = function(e, r, n, i) {
  if (e = +e, r = r | 0, n = n | 0, !i) {
    var a = Math.pow(2, 8 * n) - 1;
    Ri(this, e, r, n, a, 0);
  }
  var o = 1, s = 0;
  for (this[r] = e & 255; ++s < n && (o *= 256); )
    this[r + s] = e / o & 255;
  return r + n;
};
Le.prototype.writeUIntBE = function(e, r, n, i) {
  if (e = +e, r = r | 0, n = n | 0, !i) {
    var a = Math.pow(2, 8 * n) - 1;
    Ri(this, e, r, n, a, 0);
  }
  var o = n - 1, s = 1;
  for (this[r + o] = e & 255; --o >= 0 && (s *= 256); )
    this[r + o] = e / s & 255;
  return r + n;
};
Le.prototype.writeUInt8 = function(e, r, n) {
  return e = +e, r = r | 0, n || Ri(this, e, r, 1, 255, 0), Le.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[r] = e & 255, r + 1;
};
function Sm(t, e, r, n) {
  e < 0 && (e = 65535 + e + 1);
  for (var i = 0, a = Math.min(t.length - r, 2); i < a; ++i)
    t[r + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> (n ? i : 1 - i) * 8;
}
Le.prototype.writeUInt16LE = function(e, r, n) {
  return e = +e, r = r | 0, n || Ri(this, e, r, 2, 65535, 0), Le.TYPED_ARRAY_SUPPORT ? (this[r] = e & 255, this[r + 1] = e >>> 8) : Sm(this, e, r, !0), r + 2;
};
Le.prototype.writeUInt16BE = function(e, r, n) {
  return e = +e, r = r | 0, n || Ri(this, e, r, 2, 65535, 0), Le.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 8, this[r + 1] = e & 255) : Sm(this, e, r, !1), r + 2;
};
function Cm(t, e, r, n) {
  e < 0 && (e = 4294967295 + e + 1);
  for (var i = 0, a = Math.min(t.length - r, 4); i < a; ++i)
    t[r + i] = e >>> (n ? i : 3 - i) * 8 & 255;
}
Le.prototype.writeUInt32LE = function(e, r, n) {
  return e = +e, r = r | 0, n || Ri(this, e, r, 4, 4294967295, 0), Le.TYPED_ARRAY_SUPPORT ? (this[r + 3] = e >>> 24, this[r + 2] = e >>> 16, this[r + 1] = e >>> 8, this[r] = e & 255) : Cm(this, e, r, !0), r + 4;
};
Le.prototype.writeUInt32BE = function(e, r, n) {
  return e = +e, r = r | 0, n || Ri(this, e, r, 4, 4294967295, 0), Le.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 24, this[r + 1] = e >>> 16, this[r + 2] = e >>> 8, this[r + 3] = e & 255) : Cm(this, e, r, !1), r + 4;
};
Le.prototype.writeIntLE = function(e, r, n, i) {
  if (e = +e, r = r | 0, !i) {
    var a = Math.pow(2, 8 * n - 1);
    Ri(this, e, r, n, a - 1, -a);
  }
  var o = 0, s = 1, l = 0;
  for (this[r] = e & 255; ++o < n && (s *= 256); )
    e < 0 && l === 0 && this[r + o - 1] !== 0 && (l = 1), this[r + o] = (e / s >> 0) - l & 255;
  return r + n;
};
Le.prototype.writeIntBE = function(e, r, n, i) {
  if (e = +e, r = r | 0, !i) {
    var a = Math.pow(2, 8 * n - 1);
    Ri(this, e, r, n, a - 1, -a);
  }
  var o = n - 1, s = 1, l = 0;
  for (this[r + o] = e & 255; --o >= 0 && (s *= 256); )
    e < 0 && l === 0 && this[r + o + 1] !== 0 && (l = 1), this[r + o] = (e / s >> 0) - l & 255;
  return r + n;
};
Le.prototype.writeInt8 = function(e, r, n) {
  return e = +e, r = r | 0, n || Ri(this, e, r, 1, 127, -128), Le.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[r] = e & 255, r + 1;
};
Le.prototype.writeInt16LE = function(e, r, n) {
  return e = +e, r = r | 0, n || Ri(this, e, r, 2, 32767, -32768), Le.TYPED_ARRAY_SUPPORT ? (this[r] = e & 255, this[r + 1] = e >>> 8) : Sm(this, e, r, !0), r + 2;
};
Le.prototype.writeInt16BE = function(e, r, n) {
  return e = +e, r = r | 0, n || Ri(this, e, r, 2, 32767, -32768), Le.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 8, this[r + 1] = e & 255) : Sm(this, e, r, !1), r + 2;
};
Le.prototype.writeInt32LE = function(e, r, n) {
  return e = +e, r = r | 0, n || Ri(this, e, r, 4, 2147483647, -2147483648), Le.TYPED_ARRAY_SUPPORT ? (this[r] = e & 255, this[r + 1] = e >>> 8, this[r + 2] = e >>> 16, this[r + 3] = e >>> 24) : Cm(this, e, r, !0), r + 4;
};
Le.prototype.writeInt32BE = function(e, r, n) {
  return e = +e, r = r | 0, n || Ri(this, e, r, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), Le.TYPED_ARRAY_SUPPORT ? (this[r] = e >>> 24, this[r + 1] = e >>> 16, this[r + 2] = e >>> 8, this[r + 3] = e & 255) : Cm(this, e, r, !1), r + 4;
};
function qT(t, e, r, n, i, a) {
  if (r + n > t.length) throw new RangeError("Index out of range");
  if (r < 0) throw new RangeError("Index out of range");
}
function YT(t, e, r, n, i) {
  return i || qT(t, e, r, 4), MT(t, e, r, n, 23, 4), r + 4;
}
Le.prototype.writeFloatLE = function(e, r, n) {
  return YT(this, e, r, !0, n);
};
Le.prototype.writeFloatBE = function(e, r, n) {
  return YT(this, e, r, !1, n);
};
function GT(t, e, r, n, i) {
  return i || qT(t, e, r, 8), MT(t, e, r, n, 52, 8), r + 8;
}
Le.prototype.writeDoubleLE = function(e, r, n) {
  return GT(this, e, r, !0, n);
};
Le.prototype.writeDoubleBE = function(e, r, n) {
  return GT(this, e, r, !1, n);
};
Le.prototype.copy = function(e, r, n, i) {
  if (n || (n = 0), !i && i !== 0 && (i = this.length), r >= e.length && (r = e.length), r || (r = 0), i > 0 && i < n && (i = n), i === n || e.length === 0 || this.length === 0) return 0;
  if (r < 0)
    throw new RangeError("targetStart out of bounds");
  if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
  if (i < 0) throw new RangeError("sourceEnd out of bounds");
  i > this.length && (i = this.length), e.length - r < i - n && (i = e.length - r + n);
  var a = i - n, o;
  if (this === e && n < r && r < i)
    for (o = a - 1; o >= 0; --o)
      e[o + r] = this[o + n];
  else if (a < 1e3 || !Le.TYPED_ARRAY_SUPPORT)
    for (o = 0; o < a; ++o)
      e[o + r] = this[o + n];
  else
    Uint8Array.prototype.set.call(
      e,
      this.subarray(n, n + a),
      r
    );
  return a;
};
Le.prototype.fill = function(e, r, n, i) {
  if (typeof e == "string") {
    if (typeof r == "string" ? (i = r, r = 0, n = this.length) : typeof n == "string" && (i = n, n = this.length), e.length === 1) {
      var a = e.charCodeAt(0);
      a < 256 && (e = a);
    }
    if (i !== void 0 && typeof i != "string")
      throw new TypeError("encoding must be a string");
    if (typeof i == "string" && !Le.isEncoding(i))
      throw new TypeError("Unknown encoding: " + i);
  } else typeof e == "number" && (e = e & 255);
  if (r < 0 || this.length < r || this.length < n)
    throw new RangeError("Out of range index");
  if (n <= r)
    return this;
  r = r >>> 0, n = n === void 0 ? this.length : n >>> 0, e || (e = 0);
  var o;
  if (typeof e == "number")
    for (o = r; o < n; ++o)
      this[o] = e;
  else {
    var s = fs(e) ? e : cp(new Le(e, i).toString()), l = s.length;
    for (o = 0; o < n - r; ++o)
      this[o + r] = s[o % l];
  }
  return this;
};
var lne = /[^+\/0-9A-Za-z-_]/g;
function une(t) {
  if (t = cne(t).replace(lne, ""), t.length < 2) return "";
  for (; t.length % 4 !== 0; )
    t = t + "=";
  return t;
}
function cne(t) {
  return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
}
function fne(t) {
  return t < 16 ? "0" + t.toString(16) : t.toString(16);
}
function cp(t, e) {
  e = e || 1 / 0;
  for (var r, n = t.length, i = null, a = [], o = 0; o < n; ++o) {
    if (r = t.charCodeAt(o), r > 55295 && r < 57344) {
      if (!i) {
        if (r > 56319) {
          (e -= 3) > -1 && a.push(239, 191, 189);
          continue;
        } else if (o + 1 === n) {
          (e -= 3) > -1 && a.push(239, 191, 189);
          continue;
        }
        i = r;
        continue;
      }
      if (r < 56320) {
        (e -= 3) > -1 && a.push(239, 191, 189), i = r;
        continue;
      }
      r = (i - 55296 << 10 | r - 56320) + 65536;
    } else i && (e -= 3) > -1 && a.push(239, 191, 189);
    if (i = null, r < 128) {
      if ((e -= 1) < 0) break;
      a.push(r);
    } else if (r < 2048) {
      if ((e -= 2) < 0) break;
      a.push(
        r >> 6 | 192,
        r & 63 | 128
      );
    } else if (r < 65536) {
      if ((e -= 3) < 0) break;
      a.push(
        r >> 12 | 224,
        r >> 6 & 63 | 128,
        r & 63 | 128
      );
    } else if (r < 1114112) {
      if ((e -= 4) < 0) break;
      a.push(
        r >> 18 | 240,
        r >> 12 & 63 | 128,
        r >> 6 & 63 | 128,
        r & 63 | 128
      );
    } else
      throw new Error("Invalid code point");
  }
  return a;
}
function dne(t) {
  for (var e = [], r = 0; r < t.length; ++r)
    e.push(t.charCodeAt(r) & 255);
  return e;
}
function hne(t, e) {
  for (var r, n, i, a = [], o = 0; o < t.length && !((e -= 2) < 0); ++o)
    r = t.charCodeAt(o), n = r >> 8, i = r % 256, a.push(i), a.push(n);
  return a;
}
function ZT(t) {
  return $re(une(t));
}
function km(t, e, r, n) {
  for (var i = 0; i < n && !(i + r >= e.length || i >= t.length); ++i)
    e[i + r] = t[i];
  return i;
}
function pne(t) {
  return t !== t;
}
function mne(t) {
  return t != null && (!!t._isBuffer || XT(t) || gne(t));
}
function XT(t) {
  return !!t.constructor && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
}
function gne(t) {
  return typeof t.readFloatLE == "function" && typeof t.slice == "function" && XT(t.slice(0, 0));
}
Le.isBuffer;
const vne = [
  "x",
  "y",
  "clipPath",
  "clipRule",
  "opacity",
  "fill",
  "fillOpacity",
  "fillRule",
  "stroke",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeOpacity",
  "strokeWidth",
  "textAnchor",
  "dominantBaseline",
  "color",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "opacity",
  "textDecoration",
  "lineHeight",
  "textAlign",
  "visibility",
  "wordSpacing"
];
Tre(["x"], vne);
qd.Hidden, qd.Scroll;
Yd.Wrap, Yd.WrapReverse;
const mn = (t, e) => (r) => (n) => {
  const { yogaNode: i } = n;
  if (!M9(r) && i) {
    const a = !M9(e), o = `set${kre(t)}`, s = `${o}Auto`, l = `${o}Percent`, u = Cre(r);
    if (u && !i[l])
      throw new Error(`You can't pass percentage values to ${t} property`);
    u ? a ? i[l]?.(e, u.value) : i[l]?.(u.value) : r === "auto" ? a ? i[s]?.(e) : i[s]?.() : a ? i[o]?.(e, r) : i[o]?.(r);
  }
  return n;
};
En.FlexStart, En.Center, En.FlexEnd, En.Stretch, En.Baseline, En.SpaceBetween, En.SpaceAround, En.SpaceEvenly;
n1.Absolute, n1.Relative, n1.Static;
rc.Row, rc.RowReverse, rc.ColumnReverse;
Za.Center, Za.FlexEnd, Za.SpaceBetween, Za.SpaceAround, Za.SpaceEvenly;
mn("margin", nr.Top);
mn("margin", nr.Right);
mn("margin", nr.Bottom);
mn("margin", nr.Left);
mn("padding", nr.Top);
mn("padding", nr.Right);
mn("padding", nr.Bottom);
mn("padding", nr.Left);
mn("border", nr.Top);
mn("border", nr.Right);
mn("border", nr.Bottom);
mn("border", nr.Left);
mn("position", nr.Top);
mn("position", nr.Right);
mn("position", nr.Bottom);
mn("position", nr.Left);
mn("gap", Hd.Row);
mn("gap", Hd.Column);
var KT = { exports: {} }, JT = {};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function(t) {
  function e(Z, Q) {
    var J = Z.length;
    Z.push(Q);
    e: for (; 0 < J; ) {
      var se = J - 1 >>> 1, ae = Z[se];
      if (0 < i(ae, Q))
        Z[se] = Q, Z[J] = ae, J = se;
      else break e;
    }
  }
  function r(Z) {
    return Z.length === 0 ? null : Z[0];
  }
  function n(Z) {
    if (Z.length === 0) return null;
    var Q = Z[0], J = Z.pop();
    if (J !== Q) {
      Z[0] = J;
      e: for (var se = 0, ae = Z.length, te = ae >>> 1; se < te; ) {
        var ne = 2 * (se + 1) - 1, ce = Z[ne], pe = ne + 1, Me = Z[pe];
        if (0 > i(ce, J))
          pe < ae && 0 > i(Me, ce) ? (Z[se] = Me, Z[pe] = J, se = pe) : (Z[se] = ce, Z[ne] = J, se = ne);
        else if (pe < ae && 0 > i(Me, J))
          Z[se] = Me, Z[pe] = J, se = pe;
        else break e;
      }
    }
    return Q;
  }
  function i(Z, Q) {
    var J = Z.sortIndex - Q.sortIndex;
    return J !== 0 ? J : Z.id - Q.id;
  }
  if (t.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
    var a = performance;
    t.unstable_now = function() {
      return a.now();
    };
  } else {
    var o = Date, s = o.now();
    t.unstable_now = function() {
      return o.now() - s;
    };
  }
  var l = [], u = [], d = 1, h = null, v = 3, b = !1, x = !1, A = !1, T = typeof setTimeout == "function" ? setTimeout : null, k = typeof clearTimeout == "function" ? clearTimeout : null, E = typeof setImmediate < "u" ? setImmediate : null;
  function C(Z) {
    for (var Q = r(u); Q !== null; ) {
      if (Q.callback === null) n(u);
      else if (Q.startTime <= Z)
        n(u), Q.sortIndex = Q.expirationTime, e(l, Q);
      else break;
      Q = r(u);
    }
  }
  function D(Z) {
    if (A = !1, C(Z), !x)
      if (r(l) !== null)
        x = !0, q();
      else {
        var Q = r(u);
        Q !== null && Y(D, Q.startTime - Z);
      }
  }
  var _ = !1, I = -1, R = 5, U = -1;
  function V() {
    return !(t.unstable_now() - U < R);
  }
  function z() {
    if (_) {
      var Z = t.unstable_now();
      U = Z;
      var Q = !0;
      try {
        e: {
          x = !1, A && (A = !1, k(I), I = -1), b = !0;
          var J = v;
          try {
            t: {
              for (C(Z), h = r(l); h !== null && !(h.expirationTime > Z && V()); ) {
                var se = h.callback;
                if (typeof se == "function") {
                  h.callback = null, v = h.priorityLevel;
                  var ae = se(
                    h.expirationTime <= Z
                  );
                  if (Z = t.unstable_now(), typeof ae == "function") {
                    h.callback = ae, C(Z), Q = !0;
                    break t;
                  }
                  h === r(l) && n(l), C(Z);
                } else n(l);
                h = r(l);
              }
              if (h !== null) Q = !0;
              else {
                var te = r(u);
                te !== null && Y(
                  D,
                  te.startTime - Z
                ), Q = !1;
              }
            }
            break e;
          } finally {
            h = null, v = J, b = !1;
          }
          Q = void 0;
        }
      } finally {
        Q ? j() : _ = !1;
      }
    }
  }
  var j;
  if (typeof E == "function")
    j = function() {
      E(z);
    };
  else if (typeof MessageChannel < "u") {
    var S = new MessageChannel(), B = S.port2;
    S.port1.onmessage = z, j = function() {
      B.postMessage(null);
    };
  } else
    j = function() {
      T(z, 0);
    };
  function q() {
    _ || (_ = !0, j());
  }
  function Y(Z, Q) {
    I = T(function() {
      Z(t.unstable_now());
    }, Q);
  }
  t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function(Z) {
    Z.callback = null;
  }, t.unstable_continueExecution = function() {
    x || b || (x = !0, q());
  }, t.unstable_forceFrameRate = function(Z) {
    0 > Z || 125 < Z ? console.error(
      "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
    ) : R = 0 < Z ? Math.floor(1e3 / Z) : 5;
  }, t.unstable_getCurrentPriorityLevel = function() {
    return v;
  }, t.unstable_getFirstCallbackNode = function() {
    return r(l);
  }, t.unstable_next = function(Z) {
    switch (v) {
      case 1:
      case 2:
      case 3:
        var Q = 3;
        break;
      default:
        Q = v;
    }
    var J = v;
    v = Q;
    try {
      return Z();
    } finally {
      v = J;
    }
  }, t.unstable_pauseExecution = function() {
  }, t.unstable_requestPaint = function() {
  }, t.unstable_runWithPriority = function(Z, Q) {
    switch (Z) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        Z = 3;
    }
    var J = v;
    v = Z;
    try {
      return Q();
    } finally {
      v = J;
    }
  }, t.unstable_scheduleCallback = function(Z, Q, J) {
    var se = t.unstable_now();
    switch (typeof J == "object" && J !== null ? (J = J.delay, J = typeof J == "number" && 0 < J ? se + J : se) : J = se, Z) {
      case 1:
        var ae = -1;
        break;
      case 2:
        ae = 250;
        break;
      case 5:
        ae = 1073741823;
        break;
      case 4:
        ae = 1e4;
        break;
      default:
        ae = 5e3;
    }
    return ae = J + ae, Z = {
      id: d++,
      callback: Q,
      priorityLevel: Z,
      startTime: J,
      expirationTime: ae,
      sortIndex: -1
    }, J > se ? (Z.sortIndex = J, e(u, Z), r(l) === null && Z === r(u) && (A ? (k(I), I = -1) : A = !0, Y(D, J - se))) : (Z.sortIndex = ae, e(l, Z), x || b || (x = !0, q())), Z;
  }, t.unstable_shouldYield = V, t.unstable_wrapCallback = function(Z) {
    var Q = v;
    return function() {
      var J = v;
      v = Q;
      try {
        return Z.apply(this, arguments);
      } finally {
        v = J;
      }
    };
  };
})(JT);
KT.exports = JT;
var QT = KT.exports;
const bne = /* @__PURE__ */ On(QT), eF = /* @__PURE__ */ CD({
  __proto__: null,
  default: bne
}, [QT]);
function xne(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function yne(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, i.get ? i : { enumerable: !0, get: function() {
      return t[n];
    } });
  }), r;
}
var G9, tF = { exports: {} }, Z9 = { exports: {} }, wne = yne(eF), H2;
/**
 * @license React
 * react-reconciler.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
tF.exports = (G9 || (G9 = 1, (H2 = Z9).exports = function(t) {
  function e(c, f, g, w) {
    return new Xc(c, f, g, w);
  }
  function r(c) {
    var f = "https://react.dev/errors/" + c;
    if (1 < arguments.length) {
      f += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var g = 2; g < arguments.length; g++) f += "&args[]=" + encodeURIComponent(arguments[g]);
    }
    return "Minified React error #" + c + "; visit " + f + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function n(c) {
    return c === null || typeof c != "object" ? null : typeof (c = X1 && c[X1] || c["@@iterator"]) == "function" ? c : null;
  }
  function i(c) {
    if (c == null) return null;
    if (typeof c == "function") return c.$$typeof === K1 ? null : c.displayName || c.name || null;
    if (typeof c == "string") return c;
    switch (c) {
      case Ha:
        return "Fragment";
      case Ao:
        return "Portal";
      case Qc:
        return "Profiler";
      case wn:
        return "StrictMode";
      case tf:
        return "Suspense";
      case rf:
        return "SuspenseList";
    }
    if (typeof c == "object") switch (c.$$typeof) {
      case jn:
        return (c.displayName || "Context") + ".Provider";
      case Z1:
        return (c._context.displayName || "Context") + ".Consumer";
      case ef:
        var f = c.render;
        return (c = c.displayName) || (c = (c = f.displayName || f.name || "") !== "" ? "ForwardRef(" + c + ")" : "ForwardRef"), c;
      case gl:
        return (f = c.displayName || null) !== null ? f : i(c.type) || "Memo";
      case Eo:
        f = c._payload, c = c._init;
        try {
          return i(c(f));
        } catch {
        }
    }
    return null;
  }
  function a(c) {
    if (Cs === void 0) try {
      throw Error();
    } catch (g) {
      var f = g.stack.trim().match(/\n( *(at )?)/);
      Cs = f && f[1] || "", _o = -1 < g.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < g.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return `
` + Cs + c + _o;
  }
  function o(c, f) {
    if (!c || J1) return "";
    J1 = !0;
    var g = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var w = { DetermineComponentFrameRoot: function() {
        try {
          if (f) {
            var Qe = function() {
              throw Error();
            };
            if (Object.defineProperty(Qe.prototype, "props", { set: function() {
              throw Error();
            } }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(Qe, []);
              } catch (pt) {
                var We = pt;
              }
              Reflect.construct(c, [], Qe);
            } else {
              try {
                Qe.call();
              } catch (pt) {
                We = pt;
              }
              c.call(Qe.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (pt) {
              We = pt;
            }
            (Qe = c()) && typeof Qe.catch == "function" && Qe.catch(function() {
            });
          }
        } catch (pt) {
          if (pt && We && typeof pt.stack == "string") return [pt.stack, We.stack];
        }
        return [null, null];
      } };
      w.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var O = Object.getOwnPropertyDescriptor(w.DetermineComponentFrameRoot, "name");
      O && O.configurable && Object.defineProperty(w.DetermineComponentFrameRoot, "name", { value: "DetermineComponentFrameRoot" });
      var N = w.DetermineComponentFrameRoot(), G = N[0], ie = N[1];
      if (G && ie) {
        var oe = G.split(`
`), De = ie.split(`
`);
        for (O = w = 0; w < oe.length && !oe[w].includes("DetermineComponentFrameRoot"); ) w++;
        for (; O < De.length && !De[O].includes("DetermineComponentFrameRoot"); ) O++;
        if (w === oe.length || O === De.length) for (w = oe.length - 1, O = De.length - 1; 1 <= w && 0 <= O && oe[w] !== De[O]; ) O--;
        for (; 1 <= w && 0 <= O; w--, O--) if (oe[w] !== De[O]) {
          if (w !== 1 || O !== 1) do
            if (w--, 0 > --O || oe[w] !== De[O]) {
              var Ke = `
` + oe[w].replace(" at new ", " at ");
              return c.displayName && Ke.includes("<anonymous>") && (Ke = Ke.replace("<anonymous>", c.displayName)), Ke;
            }
          while (1 <= w && 0 <= O);
          break;
        }
      }
    } finally {
      J1 = !1, Error.prepareStackTrace = g;
    }
    return (g = c ? c.displayName || c.name : "") ? a(g) : "";
  }
  function s(c) {
    switch (c.tag) {
      case 26:
      case 27:
      case 5:
        return a(c.type);
      case 16:
        return a("Lazy");
      case 13:
        return a("Suspense");
      case 19:
        return a("SuspenseList");
      case 0:
      case 15:
        return o(c.type, !1);
      case 11:
        return o(c.type.render, !1);
      case 1:
        return o(c.type, !0);
      default:
        return "";
    }
  }
  function l(c) {
    try {
      var f = "";
      do
        f += s(c), c = c.return;
      while (c);
      return f;
    } catch (g) {
      return `
Error generating stack: ` + g.message + `
` + g.stack;
    }
  }
  function u(c) {
    return { current: c };
  }
  function d(c) {
    0 > sf || (c.current = Rm[sf], Rm[sf] = null, sf--);
  }
  function h(c, f) {
    sf++, Rm[sf] = c.current, c.current = f;
  }
  function v(c) {
    var f = 42 & c;
    if (f !== 0) return f;
    switch (c & -c) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return 4194176 & c;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return 62914560 & c;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return c;
    }
  }
  function b(c, f) {
    var g = c.pendingLanes;
    if (g === 0) return 0;
    var w = 0, O = c.suspendedLanes;
    c = c.pingedLanes;
    var N = 134217727 & g;
    return N !== 0 ? (g = N & ~O) != 0 ? w = v(g) : (c &= N) != 0 && (w = v(c)) : (g &= ~O) != 0 ? w = v(g) : c !== 0 && (w = v(c)), w === 0 ? 0 : f !== 0 && f !== w && !(f & O) && ((O = w & -w) >= (c = f & -f) || O === 32 && 4194176 & c) ? f : w;
  }
  function x(c, f) {
    switch (c) {
      case 1:
      case 2:
      case 4:
      case 8:
        return f + 250;
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return f + 5e3;
      default:
        return -1;
    }
  }
  function A() {
    var c = Pm;
    return !(4194176 & (Pm <<= 1)) && (Pm = 128), c;
  }
  function T() {
    var c = Im;
    return !(62914560 & (Im <<= 1)) && (Im = 4194304), c;
  }
  function k(c) {
    for (var f = [], g = 0; 31 > g; g++) f.push(c);
    return f;
  }
  function E(c, f) {
    c.pendingLanes |= f, f !== 268435456 && (c.suspendedLanes = 0, c.pingedLanes = 0, c.warmLanes = 0);
  }
  function C(c, f, g) {
    c.pendingLanes |= f, c.suspendedLanes &= ~f;
    var w = 31 - bl(f);
    c.entangledLanes |= f, c.entanglements[w] = 1073741824 | c.entanglements[w] | 4194218 & g;
  }
  function D(c, f) {
    var g = c.entangledLanes |= f;
    for (c = c.entanglements; g; ) {
      var w = 31 - bl(g), O = 1 << w;
      O & f | c[w] & f && (c[w] |= f), g &= ~O;
    }
  }
  function _(c) {
    return 2 < (c &= -c) ? 8 < c ? 134217727 & c ? 32 : 268435456 : 8 : 2;
  }
  function I(c) {
    typeof uF == "function" && cF(c);
  }
  function R(c, f) {
    if (typeof c == "object" && c !== null) {
      var g = Kx.get(c);
      return g !== void 0 ? g : (f = { value: c, source: f, stack: l(f) }, Kx.set(c, f), f);
    }
    return { value: c, source: f, stack: l(f) };
  }
  function U(c) {
    for (; c === Jx; ) Jx = a2[--o2], a2[o2] = null, a2[--o2], a2[o2] = null;
    for (; c === Qx; ) Qx = uf[--cf], uf[cf] = null, uf[--cf], uf[cf] = null, uf[--cf], uf[cf] = null;
  }
  function V(c, f) {
    h(s2, f), h(od, c), h(Is, null), c = Tm(f), d(Is), h(Is, c);
  }
  function z() {
    d(Is), d(od), d(s2);
  }
  function j(c) {
    c.memoizedState !== null && h(l2, c);
    var f = Is.current, g = t2(f, c.type);
    f !== g && (h(od, c), h(Is, g));
  }
  function S(c) {
    od.current === c && (d(Is), d(od)), l2.current === c && (d(l2), p._currentValue2 = m);
  }
  function B() {
    for (var c = ff, f = Nm = ff = 0; f < c; ) {
      var g = pa[f];
      pa[f++] = null;
      var w = pa[f];
      pa[f++] = null;
      var O = pa[f];
      pa[f++] = null;
      var N = pa[f];
      if (pa[f++] = null, w !== null && O !== null) {
        var G = w.pending;
        G === null ? O.next = O : (O.next = G.next, G.next = O), w.pending = O;
      }
      N !== 0 && Q(g, O, N);
    }
  }
  function q(c, f, g, w) {
    pa[ff++] = c, pa[ff++] = f, pa[ff++] = g, pa[ff++] = w, Nm |= w, c.lanes |= w, (c = c.alternate) !== null && (c.lanes |= w);
  }
  function Y(c, f, g, w) {
    return q(c, f, g, w), J(c);
  }
  function Z(c, f) {
    return q(c, null, null, f), J(c);
  }
  function Q(c, f, g) {
    c.lanes |= g;
    var w = c.alternate;
    w !== null && (w.lanes |= g);
    for (var O = !1, N = c.return; N !== null; ) N.childLanes |= g, (w = N.alternate) !== null && (w.childLanes |= g), N.tag === 22 && ((c = N.stateNode) === null || 1 & c._visibility || (O = !0)), c = N, N = N.return;
    O && f !== null && c.tag === 3 && (N = c.stateNode, O = 31 - bl(g), (c = (N = N.hiddenUpdates)[O]) === null ? N[O] = [f] : c.push(f), f.lane = 536870912 | g);
  }
  function J(c) {
    if (50 < gd) throw gd = 0, ng = null, Error(r(185));
    for (var f = c.return; f !== null; ) f = (c = f).return;
    return c.tag === 3 ? c.stateNode : null;
  }
  function se(c) {
    c !== df && c.next === null && (df === null ? u2 = df = c : df = df.next = c), c2 = !0, Mm || (Mm = !0, Bm(Gx, te));
  }
  function ae(c, f) {
    if (!Um && c2) {
      Um = !0;
      do
        for (var g = !1, w = u2; w !== null; ) {
          if (c !== 0) {
            var O = w.pendingLanes;
            if (O === 0) var N = 0;
            else {
              var G = w.suspendedLanes, ie = w.pingedLanes;
              N = (1 << 31 - bl(42 | c) + 1) - 1, N = 201326677 & (N &= O & ~(G & ~ie)) ? 201326677 & N | 1 : N ? 2 | N : 0;
            }
            N !== 0 && (g = !0, pe(w, N));
          } else N = T0, 3 & (N = b(w, w === tr ? N : 0)) && (g = !0, pe(w, N));
          w = w.next;
        }
      while (g);
      Um = !1;
    }
  }
  function te() {
    c2 = Mm = !1;
    var c = 0;
    hf !== 0 && (n2() && (c = hf), hf = 0);
    for (var f = Ps(), g = null, w = u2; w !== null; ) {
      var O = w.next, N = ne(w, f);
      N === 0 ? (w.next = null, g === null ? u2 = O : g.next = O, O === null && (df = g)) : (g = w, (c !== 0 || 3 & N) && (c2 = !0)), w = O;
    }
    ae(c);
  }
  function ne(c, f) {
    for (var g = c.suspendedLanes, w = c.pingedLanes, O = c.expirationTimes, N = -62914561 & c.pendingLanes; 0 < N; ) {
      var G = 31 - bl(N), ie = 1 << G, oe = O[G];
      oe === -1 ? ie & g && !(ie & w) || (O[G] = x(ie, f)) : oe <= f && (c.expiredLanes |= ie), N &= ~ie;
    }
    if (g = T0, g = b(c, c === (f = tr) ? g : 0), w = c.callbackNode, g === 0 || c === f && Ar === 2 || c.cancelPendingCommit !== null) return w !== null && w !== null && Lm(w), c.callbackNode = null, c.callbackPriority = 0;
    if (3 & g) return w !== null && w !== null && Lm(w), c.callbackPriority = 2, c.callbackNode = null, 2;
    if ((f = g & -g) === c.callbackPriority) return f;
    switch (w !== null && Lm(w), _(g)) {
      case 2:
        g = Gx;
        break;
      case 8:
        g = sF;
        break;
      case 32:
      default:
        g = Zx;
        break;
      case 268435456:
        g = lF;
    }
    return w = ce.bind(null, c), g = Bm(g, w), c.callbackPriority = f, c.callbackNode = g, f;
  }
  function ce(c, f) {
    var g = c.callbackNode;
    if (St() && c.callbackNode !== g) return null;
    var w = T0;
    return (w = b(c, c === tr ? w : 0)) === 0 ? null : (z1(c, w, f), ne(c, Ps()), c.callbackNode === g ? ce.bind(null, c) : null);
  }
  function pe(c, f) {
    if (St()) return null;
    z1(c, f, !0);
  }
  function Me() {
    return hf === 0 && (hf = A()), hf;
  }
  function Ne() {
    if (--zm == 0 && sd !== null) {
      Du !== null && (Du.status = "fulfilled");
      var c = sd;
      sd = null, Fu = 0, Du = null;
      for (var f = 0; f < c.length; f++) (0, c[f])();
    }
  }
  function it(c) {
    c.updateQueue = { baseState: c.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, lanes: 0, hiddenCallbacks: null }, callbacks: null };
  }
  function fe(c, f) {
    c = c.updateQueue, f.updateQueue === c && (f.updateQueue = { baseState: c.baseState, firstBaseUpdate: c.firstBaseUpdate, lastBaseUpdate: c.lastBaseUpdate, shared: c.shared, callbacks: null });
  }
  function ye(c) {
    return { lane: c, tag: 0, payload: null, callback: null, next: null };
  }
  function be(c, f, g) {
    var w = c.updateQueue;
    if (w === null) return null;
    if (w = w.shared, (2 & Or) != 0) {
      var O = w.pending;
      return O === null ? f.next = f : (f.next = O.next, O.next = f), w.pending = f, f = J(c), Q(c, null, g), f;
    }
    return q(c, w, f, g), J(c);
  }
  function he(c, f, g) {
    if ((f = f.updateQueue) !== null && (f = f.shared, (4194176 & g) != 0)) {
      var w = f.lanes;
      g |= w &= c.pendingLanes, f.lanes = g, D(c, g);
    }
  }
  function Ge(c, f) {
    var g = c.updateQueue, w = c.alternate;
    if (w !== null && g === (w = w.updateQueue)) {
      var O = null, N = null;
      if ((g = g.firstBaseUpdate) !== null) {
        do {
          var G = { lane: g.lane, tag: g.tag, payload: g.payload, callback: null, next: null };
          N === null ? O = N = G : N = N.next = G, g = g.next;
        } while (g !== null);
        N === null ? O = N = f : N = N.next = f;
      } else O = N = f;
      return g = { baseState: w.baseState, firstBaseUpdate: O, lastBaseUpdate: N, shared: w.shared, callbacks: w.callbacks }, void (c.updateQueue = g);
    }
    (c = g.lastBaseUpdate) === null ? g.firstBaseUpdate = f : c.next = f, g.lastBaseUpdate = f;
  }
  function $e() {
    if ($m && Du !== null) throw Du;
  }
  function Ve(c, f, g, w) {
    $m = !1;
    var O = c.updateQueue;
    xl = !1;
    var N = O.firstBaseUpdate, G = O.lastBaseUpdate, ie = O.shared.pending;
    if (ie !== null) {
      O.shared.pending = null;
      var oe = ie, De = oe.next;
      oe.next = null, G === null ? N = De : G.next = De, G = oe;
      var Ke = c.alternate;
      Ke !== null && (ie = (Ke = Ke.updateQueue).lastBaseUpdate) !== G && (ie === null ? Ke.firstBaseUpdate = De : ie.next = De, Ke.lastBaseUpdate = oe);
    }
    if (N !== null) {
      var Qe = O.baseState;
      for (G = 0, Ke = De = oe = null, ie = N; ; ) {
        var We = -536870913 & ie.lane, pt = We !== ie.lane;
        if (pt ? (T0 & We) === We : (w & We) === We) {
          We !== 0 && We === Fu && ($m = !0), Ke !== null && (Ke = Ke.next = { lane: 0, tag: ie.tag, payload: ie.payload, callback: null, next: null });
          e: {
            var cr = c, _e = ie;
            We = f;
            var Ae = g;
            switch (_e.tag) {
              case 1:
                if (typeof (cr = _e.payload) == "function") {
                  Qe = cr.call(Ae, Qe, We);
                  break e;
                }
                Qe = cr;
                break e;
              case 3:
                cr.flags = -65537 & cr.flags | 128;
              case 0:
                if ((We = typeof (cr = _e.payload) == "function" ? cr.call(Ae, Qe, We) : cr) == null) break e;
                Qe = Vn({}, Qe, We);
                break e;
              case 2:
                xl = !0;
            }
          }
          (We = ie.callback) !== null && (c.flags |= 64, pt && (c.flags |= 8192), (pt = O.callbacks) === null ? O.callbacks = [We] : pt.push(We));
        } else pt = { lane: We, tag: ie.tag, payload: ie.payload, callback: ie.callback, next: null }, Ke === null ? (De = Ke = pt, oe = Qe) : Ke = Ke.next = pt, G |= We;
        if ((ie = ie.next) === null) {
          if ((ie = O.shared.pending) === null) break;
          ie = (pt = ie).next, pt.next = null, O.lastBaseUpdate = pt, O.shared.pending = null;
        }
      }
      Ke === null && (oe = Qe), O.baseState = oe, O.firstBaseUpdate = De, O.lastBaseUpdate = Ke, N === null && (O.shared.lanes = 0), zs |= G, c.lanes = G, c.memoizedState = Qe;
    }
  }
  function Ze(c, f) {
    if (typeof c != "function") throw Error(r(191, c));
    c.call(f);
  }
  function wt(c, f) {
    var g = c.callbacks;
    if (g !== null) for (c.callbacks = null, c = 0; c < g.length; c++) Ze(g[c], f);
  }
  function et(c, f) {
    if (Wi(c, f)) return !0;
    if (typeof c != "object" || c === null || typeof f != "object" || f === null) return !1;
    var g = Object.keys(c), w = Object.keys(f);
    if (g.length !== w.length) return !1;
    for (w = 0; w < g.length; w++) {
      var O = g[w];
      if (!dF.call(f, O) || !Wi(c[O], f[O])) return !1;
    }
    return !0;
  }
  function W(c) {
    return (c = c.status) === "fulfilled" || c === "rejected";
  }
  function ee() {
  }
  function le(c, f, g) {
    switch ((g = c[g]) === void 0 ? c.push(f) : g !== f && (f.then(ee, ee), f = g), f.status) {
      case "fulfilled":
        return f.value;
      case "rejected":
        throw (c = f.reason) === ld ? Error(r(483)) : c;
      default:
        if (typeof f.status == "string") f.then(ee, ee);
        else {
          if ((c = tr) !== null && 100 < c.shellSuspendCounter) throw Error(r(482));
          (c = f).status = "pending", c.then(function(w) {
            if (f.status === "pending") {
              var O = f;
              O.status = "fulfilled", O.value = w;
            }
          }, function(w) {
            if (f.status === "pending") {
              var O = f;
              O.status = "rejected", O.reason = w;
            }
          });
        }
        switch (f.status) {
          case "fulfilled":
            return f.value;
          case "rejected":
            throw (c = f.reason) === ld ? Error(r(483)) : c;
        }
        throw ud = f, ld;
    }
  }
  function me() {
    if (ud === null) throw Error(r(459));
    var c = ud;
    return ud = null, c;
  }
  function Ee(c) {
    var f = cd;
    return cd += 1, pf === null && (pf = []), le(pf, c, f);
  }
  function ve(c, f, g, w) {
    c = w.props.ref, g.ref = c !== void 0 ? c : null;
  }
  function Te(c, f) {
    throw f.$$typeof === ks ? Error(r(525)) : (c = Object.prototype.toString.call(f), Error(r(31, c === "[object Object]" ? "object with keys {" + Object.keys(f).join(", ") + "}" : c)));
  }
  function Pe(c) {
    return (0, c._init)(c._payload);
  }
  function at(c) {
    function f(_e, Ae) {
      if (c) {
        var ke = _e.deletions;
        ke === null ? (_e.deletions = [Ae], _e.flags |= 16) : ke.push(Ae);
      }
    }
    function g(_e, Ae) {
      if (!c) return null;
      for (; Ae !== null; ) f(_e, Ae), Ae = Ae.sibling;
      return null;
    }
    function w(_e) {
      for (var Ae = /* @__PURE__ */ new Map(); _e !== null; ) _e.key !== null ? Ae.set(_e.key, _e) : Ae.set(_e.index, _e), _e = _e.sibling;
      return Ae;
    }
    function O(_e, Ae) {
      return (_e = Vi(_e, Ae)).index = 0, _e.sibling = null, _e;
    }
    function N(_e, Ae, ke) {
      return _e.index = ke, c ? (ke = _e.alternate) !== null ? (ke = ke.index) < Ae ? (_e.flags |= 33554434, Ae) : ke : (_e.flags |= 33554434, Ae) : (_e.flags |= 1048576, Ae);
    }
    function G(_e) {
      return c && _e.alternate === null && (_e.flags |= 33554434), _e;
    }
    function ie(_e, Ae, ke, He) {
      return Ae === null || Ae.tag !== 6 ? ((Ae = Su(ke, _e.mode, He)).return = _e, Ae) : ((Ae = O(Ae, ke)).return = _e, Ae);
    }
    function oe(_e, Ae, ke, He) {
      var It = ke.type;
      return It === Ha ? Ke(_e, Ae, ke.props.children, He, ke.key) : Ae !== null && (Ae.elementType === It || typeof It == "object" && It !== null && It.$$typeof === Eo && Pe(It) === Ae.type) ? (ve(_e, 0, He = O(Ae, ke.props), ke), He.return = _e, He) : (ve(_e, 0, He = Au(ke.type, ke.key, ke.props, null, _e.mode, He), ke), He.return = _e, He);
    }
    function De(_e, Ae, ke, He) {
      return Ae === null || Ae.tag !== 4 || Ae.stateNode.containerInfo !== ke.containerInfo || Ae.stateNode.implementation !== ke.implementation ? ((Ae = ha(ke, _e.mode, He)).return = _e, Ae) : ((Ae = O(Ae, ke.children || [])).return = _e, Ae);
    }
    function Ke(_e, Ae, ke, He, It) {
      return Ae === null || Ae.tag !== 7 ? ((Ae = ft(ke, _e.mode, He, It)).return = _e, Ae) : ((Ae = O(Ae, ke)).return = _e, Ae);
    }
    function Qe(_e, Ae, ke) {
      if (typeof Ae == "string" && Ae !== "" || typeof Ae == "number" || typeof Ae == "bigint") return (Ae = Su("" + Ae, _e.mode, ke)).return = _e, Ae;
      if (typeof Ae == "object" && Ae !== null) {
        switch (Ae.$$typeof) {
          case _i:
            return ve(_e, 0, ke = Au(Ae.type, Ae.key, Ae.props, null, _e.mode, ke), Ae), ke.return = _e, ke;
          case Ao:
            return (Ae = ha(Ae, _e.mode, ke)).return = _e, Ae;
          case Eo:
            return Qe(_e, Ae = (0, Ae._init)(Ae._payload), ke);
        }
        if (nf(Ae) || n(Ae)) return (Ae = ft(Ae, _e.mode, ke, null)).return = _e, Ae;
        if (typeof Ae.then == "function") return Qe(_e, Ee(Ae), ke);
        if (Ae.$$typeof === jn) return Qe(_e, Wr(_e, Ae), ke);
        Te(_e, Ae);
      }
      return null;
    }
    function We(_e, Ae, ke, He) {
      var It = Ae !== null ? Ae.key : null;
      if (typeof ke == "string" && ke !== "" || typeof ke == "number" || typeof ke == "bigint") return It !== null ? null : ie(_e, Ae, "" + ke, He);
      if (typeof ke == "object" && ke !== null) {
        switch (ke.$$typeof) {
          case _i:
            return ke.key === It ? oe(_e, Ae, ke, He) : null;
          case Ao:
            return ke.key === It ? De(_e, Ae, ke, He) : null;
          case Eo:
            return We(_e, Ae, ke = (It = ke._init)(ke._payload), He);
        }
        if (nf(ke) || n(ke)) return It !== null ? null : Ke(_e, Ae, ke, He, null);
        if (typeof ke.then == "function") return We(_e, Ae, Ee(ke), He);
        if (ke.$$typeof === jn) return We(_e, Ae, Wr(_e, ke), He);
        Te(_e, ke);
      }
      return null;
    }
    function pt(_e, Ae, ke, He, It) {
      if (typeof He == "string" && He !== "" || typeof He == "number" || typeof He == "bigint") return ie(Ae, _e = _e.get(ke) || null, "" + He, It);
      if (typeof He == "object" && He !== null) {
        switch (He.$$typeof) {
          case _i:
            return oe(Ae, _e = _e.get(He.key === null ? ke : He.key) || null, He, It);
          case Ao:
            return De(Ae, _e = _e.get(He.key === null ? ke : He.key) || null, He, It);
          case Eo:
            return pt(_e, Ae, ke, He = (0, He._init)(He._payload), It);
        }
        if (nf(He) || n(He)) return Ke(Ae, _e = _e.get(ke) || null, He, It, null);
        if (typeof He.then == "function") return pt(_e, Ae, ke, Ee(He), It);
        if (He.$$typeof === jn) return pt(_e, Ae, ke, Wr(Ae, He), It);
        Te(Ae, He);
      }
      return null;
    }
    function cr(_e, Ae, ke, He) {
      if (typeof ke == "object" && ke !== null && ke.type === Ha && ke.key === null && (ke = ke.props.children), typeof ke == "object" && ke !== null) {
        switch (ke.$$typeof) {
          case _i:
            e: {
              for (var It = ke.key, X0 = Ae; X0 !== null; ) {
                if (X0.key === It) {
                  if ((It = ke.type) === Ha) {
                    if (X0.tag === 7) {
                      g(_e, X0.sibling), (Ae = O(X0, ke.props.children)).return = _e, _e = Ae;
                      break e;
                    }
                  } else if (X0.elementType === It || typeof It == "object" && It !== null && It.$$typeof === Eo && Pe(It) === X0.type) {
                    g(_e, X0.sibling), ve(_e, 0, Ae = O(X0, ke.props), ke), Ae.return = _e, _e = Ae;
                    break e;
                  }
                  g(_e, X0);
                  break;
                }
                f(_e, X0), X0 = X0.sibling;
              }
              ke.type === Ha ? ((Ae = ft(ke.props.children, _e.mode, He, ke.key)).return = _e, _e = Ae) : (ve(_e, 0, He = Au(ke.type, ke.key, ke.props, null, _e.mode, He), ke), He.return = _e, _e = He);
            }
            return G(_e);
          case Ao:
            e: {
              for (X0 = ke.key; Ae !== null; ) {
                if (Ae.key === X0) {
                  if (Ae.tag === 4 && Ae.stateNode.containerInfo === ke.containerInfo && Ae.stateNode.implementation === ke.implementation) {
                    g(_e, Ae.sibling), (Ae = O(Ae, ke.children || [])).return = _e, _e = Ae;
                    break e;
                  }
                  g(_e, Ae);
                  break;
                }
                f(_e, Ae), Ae = Ae.sibling;
              }
              (Ae = ha(ke, _e.mode, He)).return = _e, _e = Ae;
            }
            return G(_e);
          case Eo:
            return cr(_e, Ae, ke = (X0 = ke._init)(ke._payload), He);
        }
        if (nf(ke)) return function(zt, i0, $0, _n) {
          for (var Gr = null, fr = null, Ot = i0, Xt = i0 = 0, Rr = null; Ot !== null && Xt < $0.length; Xt++) {
            Ot.index > Xt ? (Rr = Ot, Ot = null) : Rr = Ot.sibling;
            var m0 = We(zt, Ot, $0[Xt], _n);
            if (m0 === null) {
              Ot === null && (Ot = Rr);
              break;
            }
            c && Ot && m0.alternate === null && f(zt, Ot), i0 = N(m0, i0, Xt), fr === null ? Gr = m0 : fr.sibling = m0, fr = m0, Ot = Rr;
          }
          if (Xt === $0.length) return g(zt, Ot), Gr;
          if (Ot === null) {
            for (; Xt < $0.length; Xt++) (Ot = Qe(zt, $0[Xt], _n)) !== null && (i0 = N(Ot, i0, Xt), fr === null ? Gr = Ot : fr.sibling = Ot, fr = Ot);
            return Gr;
          }
          for (Ot = w(Ot); Xt < $0.length; Xt++) (Rr = pt(Ot, zt, Xt, $0[Xt], _n)) !== null && (c && Rr.alternate !== null && Ot.delete(Rr.key === null ? Xt : Rr.key), i0 = N(Rr, i0, Xt), fr === null ? Gr = Rr : fr.sibling = Rr, fr = Rr);
          return c && Ot.forEach(function(El) {
            return f(zt, El);
          }), Gr;
        }(_e, Ae, ke, He);
        if (n(ke)) {
          if (typeof (X0 = n(ke)) != "function") throw Error(r(150));
          return function(zt, i0, $0, _n) {
            if ($0 == null) throw Error(r(151));
            for (var Gr = null, fr = null, Ot = i0, Xt = i0 = 0, Rr = null, m0 = $0.next(); Ot !== null && !m0.done; Xt++, m0 = $0.next()) {
              Ot.index > Xt ? (Rr = Ot, Ot = null) : Rr = Ot.sibling;
              var El = We(zt, Ot, m0.value, _n);
              if (El === null) {
                Ot === null && (Ot = Rr);
                break;
              }
              c && Ot && El.alternate === null && f(zt, Ot), i0 = N(El, i0, Xt), fr === null ? Gr = El : fr.sibling = El, fr = El, Ot = Rr;
            }
            if (m0.done) return g(zt, Ot), Gr;
            if (Ot === null) {
              for (; !m0.done; Xt++, m0 = $0.next()) (m0 = Qe(zt, m0.value, _n)) !== null && (i0 = N(m0, i0, Xt), fr === null ? Gr = m0 : fr.sibling = m0, fr = m0);
              return Gr;
            }
            for (Ot = w(Ot); !m0.done; Xt++, m0 = $0.next()) (m0 = pt(Ot, zt, Xt, m0.value, _n)) !== null && (c && m0.alternate !== null && Ot.delete(m0.key === null ? Xt : m0.key), i0 = N(m0, i0, Xt), fr === null ? Gr = m0 : fr.sibling = m0, fr = m0);
            return c && Ot.forEach(function(wF) {
              return f(zt, wF);
            }), Gr;
          }(_e, Ae, ke = X0.call(ke), He);
        }
        if (typeof ke.then == "function") return cr(_e, Ae, Ee(ke), He);
        if (ke.$$typeof === jn) return cr(_e, Ae, Wr(_e, ke), He);
        Te(_e, ke);
      }
      return typeof ke == "string" && ke !== "" || typeof ke == "number" || typeof ke == "bigint" ? (ke = "" + ke, Ae !== null && Ae.tag === 6 ? (g(_e, Ae.sibling), (Ae = O(Ae, ke)).return = _e, _e = Ae) : (g(_e, Ae), (Ae = Su(ke, _e.mode, He)).return = _e, _e = Ae), G(_e)) : g(_e, Ae);
    }
    return function(_e, Ae, ke, He) {
      try {
        cd = 0;
        var It = cr(_e, Ae, ke, He);
        return pf = null, It;
      } catch (zt) {
        if (zt === ld) throw zt;
        var X0 = e(29, zt, null, _e.mode);
        return X0.lanes = He, X0.return = _e, X0;
      }
    };
  }
  function Ue(c, f) {
    h(f2, c = Us), h(gf, f), Us = c | f.baseLanes;
  }
  function rt() {
    h(f2, Us), h(gf, gf.current);
  }
  function gt() {
    Us = f2.current, d(gf), d(f2);
  }
  function _t(c) {
    var f = c.alternate;
    h(qr, 1 & qr.current), h(Ls, c), Ns === null && (f === null || gf.current !== null || f.memoizedState !== null) && (Ns = c);
  }
  function Bt(c) {
    if (c.tag === 22) {
      if (h(qr, qr.current), h(Ls, c), Ns === null) {
        var f = c.alternate;
        f !== null && f.memoizedState !== null && (Ns = c);
      }
    } else At();
  }
  function At() {
    h(qr, qr.current), h(Ls, Ls.current);
  }
  function Tt(c) {
    d(Ls), Ns === c && (Ns = null), d(qr);
  }
  function Je(c) {
    for (var f = c; f !== null; ) {
      if (f.tag === 13) {
        var g = f.memoizedState;
        if (g !== null && ((g = g.dehydrated) === null || Fe(g) || dt(g))) return f;
      } else if (f.tag === 19 && f.memoizedProps.revealOrder !== void 0) {
        if (128 & f.flags) return f;
      } else if (f.child !== null) {
        f.child.return = f, f = f.child;
        continue;
      }
      if (f === c) break;
      for (; f.sibling === null; ) {
        if (f.return === null || f.return === c) return null;
        f = f.return;
      }
      f.sibling.return = f.return, f = f.sibling;
    }
    return null;
  }
  function ot() {
    throw Error(r(321));
  }
  function R0(c, f) {
    if (f === null) return !1;
    for (var g = 0; g < f.length && g < c.length; g++) if (!Wi(c[g], f[g])) return !1;
    return !0;
  }
  function b0(c, f, g, w, O, N) {
    return yl = N, Zt = f, f.memoizedState = null, f.updateQueue = null, f.lanes = 0, $t.H = c === null || c.memoizedState === null ? Ru : wl, Ou = !1, N = g(w, O), Ou = !1, vf && (N = a0(f, g, w, O)), ir(c), N;
  }
  function ir(c) {
    $t.H = ko;
    var f = er !== null && er.next !== null;
    if (yl = 0, Ur = er = Zt = null, d2 = !1, fd = 0, bf = null, f) throw Error(r(300));
    c === null || sn || (c = c.dependencies) !== null && Dr(c) && (sn = !0);
  }
  function a0(c, f, g, w) {
    Zt = c;
    var O = 0;
    do {
      if (vf && (bf = null), fd = 0, vf = !1, 25 <= O) throw Error(r(301));
      if (O += 1, Ur = er = null, c.updateQueue != null) {
        var N = c.updateQueue;
        N.lastEffect = null, N.events = null, N.stores = null, N.memoCache != null && (N.memoCache.index = 0);
      }
      $t.H = Pu, N = f(g, w);
    } while (vf);
    return N;
  }
  function e0() {
    var c = $t.H, f = c.useState()[0];
    return f = typeof f.then == "function" ? tt(f) : f, c = c.useState()[0], (er !== null ? er.memoizedState : null) !== c && (Zt.flags |= 1024), f;
  }
  function kr() {
    var c = jm !== 0;
    return jm = 0, c;
  }
  function br(c, f, g) {
    f.updateQueue = c.updateQueue, f.flags &= -2053, c.lanes &= ~g;
  }
  function Br(c) {
    if (d2) {
      for (c = c.memoizedState; c !== null; ) {
        var f = c.queue;
        f !== null && (f.pending = null), c = c.next;
      }
      d2 = !1;
    }
    yl = 0, Ur = er = Zt = null, vf = !1, fd = jm = 0, bf = null;
  }
  function Mt() {
    var c = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return Ur === null ? Zt.memoizedState = Ur = c : Ur = Ur.next = c, Ur;
  }
  function Rt() {
    if (er === null) {
      var c = Zt.alternate;
      c = c !== null ? c.memoizedState : null;
    } else c = er.next;
    var f = Ur === null ? Zt.memoizedState : Ur.next;
    if (f !== null) Ur = f, er = c;
    else {
      if (c === null)
        throw Zt.alternate === null ? Error(r(467)) : Error(r(310));
      c = { memoizedState: (er = c).memoizedState, baseState: er.baseState, baseQueue: er.baseQueue, queue: er.queue, next: null }, Ur === null ? Zt.memoizedState = Ur = c : Ur = Ur.next = c;
    }
    return Ur;
  }
  function tt(c) {
    var f = fd;
    return fd += 1, bf === null && (bf = []), c = le(bf, c, f), f = Zt, (Ur === null ? f.memoizedState : Ur.next) === null && (f = f.alternate, $t.H = f === null || f.memoizedState === null ? Ru : wl), c;
  }
  function yt(c) {
    if (c !== null && typeof c == "object") {
      if (typeof c.then == "function") return tt(c);
      if (c.$$typeof === jn) return o0(c);
    }
    throw Error(r(438, String(c)));
  }
  function q0(c) {
    var f = null, g = Zt.updateQueue;
    if (g !== null && (f = g.memoCache), f == null) {
      var w = Zt.alternate;
      w !== null && (w = w.updateQueue) !== null && (w = w.memoCache) != null && (f = { data: w.data.map(function(O) {
        return O.slice();
      }), index: 0 });
    }
    if (f == null && (f = { data: [], index: 0 }), g === null && (g = Wm(), Zt.updateQueue = g), g.memoCache = f, (g = f.data[f.index]) === void 0) for (g = f.data[f.index] = Array(c), w = 0; w < c; w++) g[w] = e2;
    return f.index++, g;
  }
  function L0(c, f) {
    return typeof f == "function" ? f(c) : f;
  }
  function qe(c) {
    return mt(Rt(), er, c);
  }
  function mt(c, f, g) {
    var w = c.queue;
    if (w === null) throw Error(r(311));
    w.lastRenderedReducer = g;
    var O = c.baseQueue, N = w.pending;
    if (N !== null) {
      if (O !== null) {
        var G = O.next;
        O.next = N.next, N.next = G;
      }
      f.baseQueue = O = N, w.pending = null;
    }
    if (N = c.baseState, O === null) c.memoizedState = N;
    else {
      var ie = G = null, oe = null, De = f = O.next, Ke = !1;
      do {
        var Qe = -536870913 & De.lane;
        if (Qe !== De.lane ? (T0 & Qe) === Qe : (yl & Qe) === Qe) {
          var We = De.revertLane;
          if (We === 0) oe !== null && (oe = oe.next = { lane: 0, revertLane: 0, action: De.action, hasEagerState: De.hasEagerState, eagerState: De.eagerState, next: null }), Qe === Fu && (Ke = !0);
          else {
            if ((yl & We) === We) {
              De = De.next, We === Fu && (Ke = !0);
              continue;
            }
            Qe = { lane: 0, revertLane: De.revertLane, action: De.action, hasEagerState: De.hasEagerState, eagerState: De.eagerState, next: null }, oe === null ? (ie = oe = Qe, G = N) : oe = oe.next = Qe, Zt.lanes |= We, zs |= We;
          }
          Qe = De.action, Ou && g(N, Qe), N = De.hasEagerState ? De.eagerState : g(N, Qe);
        } else We = { lane: Qe, revertLane: De.revertLane, action: De.action, hasEagerState: De.hasEagerState, eagerState: De.eagerState, next: null }, oe === null ? (ie = oe = We, G = N) : oe = oe.next = We, Zt.lanes |= Qe, zs |= Qe;
        De = De.next;
      } while (De !== null && De !== f);
      if (oe === null ? G = N : oe.next = ie, !Wi(N, c.memoizedState) && (sn = !0, Ke && (g = Du) !== null)) throw g;
      c.memoizedState = N, c.baseState = G, c.baseQueue = oe, w.lastRenderedState = N;
    }
    return O === null && (w.lanes = 0), [c.memoizedState, w.dispatch];
  }
  function lt(c) {
    var f = Rt(), g = f.queue;
    if (g === null) throw Error(r(311));
    g.lastRenderedReducer = c;
    var w = g.dispatch, O = g.pending, N = f.memoizedState;
    if (O !== null) {
      g.pending = null;
      var G = O = O.next;
      do
        N = c(N, G.action), G = G.next;
      while (G !== O);
      Wi(N, f.memoizedState) || (sn = !0), f.memoizedState = N, f.baseQueue === null && (f.baseState = N), g.lastRenderedState = N;
    }
    return [N, w];
  }
  function Vt(c, f, g) {
    var w = Zt, O = Rt();
    g = f();
    var N = !Wi((er || O).memoizedState, g);
    if (N && (O.memoizedState = g, sn = !0), O = O.queue, Yn(E0.bind(null, w, O, c), [c]), O.getSnapshot !== f || N || Ur !== null && 1 & Ur.memoizedState.tag) {
      if (w.flags |= 2048, P0(9, Q0.bind(null, w, O, g, f), { destroy: void 0 }, null), tr === null) throw Error(r(349));
      60 & yl || t0(w, f, g);
    }
    return g;
  }
  function t0(c, f, g) {
    c.flags |= 16384, c = { getSnapshot: f, value: g }, (f = Zt.updateQueue) === null ? (f = Wm(), Zt.updateQueue = f, f.stores = [c]) : (g = f.stores) === null ? f.stores = [c] : g.push(c);
  }
  function Q0(c, f, g, w) {
    f.value = g, f.getSnapshot = w, S0(f) && N0(c);
  }
  function E0(c, f, g) {
    return g(function() {
      S0(f) && N0(c);
    });
  }
  function S0(c) {
    var f = c.getSnapshot;
    c = c.value;
    try {
      var g = f();
      return !Wi(c, g);
    } catch {
      return !0;
    }
  }
  function N0(c) {
    var f = Z(c, 2);
    f !== null && Kn(f, 0, 2);
  }
  function Gt(c) {
    var f = Mt();
    if (typeof c == "function") {
      var g = c;
      if (c = g(), Ou) {
        I(!0);
        try {
          g();
        } finally {
          I(!1);
        }
      }
    }
    return f.memoizedState = f.baseState = c, f.queue = { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: L0, lastRenderedState: c }, f;
  }
  function M0(c, f, g, w) {
    return c.baseState = g, mt(c, er, typeof w == "function" ? w : L0);
  }
  function gn(c, f, g, w, O) {
    if (sa(c)) throw Error(r(485));
    if ((c = f.action) !== null) {
      var N = { payload: O, action: c, next: null, isTransition: !0, status: "pending", value: null, reason: null, listeners: [], then: function(G) {
        N.listeners.push(G);
      } };
      $t.T !== null ? g(!0) : N.isTransition = !1, w(N), (g = f.pending) === null ? (N.next = f.pending = N, Pi(f, N)) : (N.next = g.next, f.pending = g.next = N);
    }
  }
  function Pi(c, f) {
    var g = f.action, w = f.payload, O = c.state;
    if (f.isTransition) {
      var N = $t.T, G = {};
      $t.T = G;
      try {
        var ie = g(O, w), oe = $t.S;
        oe !== null && oe(G, ie), xr(c, f, ie);
      } catch (De) {
        Y0(c, f, De);
      } finally {
        $t.T = N;
      }
    } else try {
      xr(c, f, N = g(O, w));
    } catch (De) {
      Y0(c, f, De);
    }
  }
  function xr(c, f, g) {
    g !== null && typeof g == "object" && typeof g.then == "function" ? g.then(function(w) {
      vn(c, f, w);
    }, function(w) {
      return Y0(c, f, w);
    }) : vn(c, f, g);
  }
  function vn(c, f, g) {
    f.status = "fulfilled", f.value = g, h0(f), c.state = g, (f = c.pending) !== null && ((g = f.next) === f ? c.pending = null : (g = g.next, f.next = g, Pi(c, g)));
  }
  function Y0(c, f, g) {
    var w = c.pending;
    if (c.pending = null, w !== null) {
      w = w.next;
      do
        f.status = "rejected", f.reason = g, h0(f), f = f.next;
      while (f !== w);
    }
    c.action = null;
  }
  function h0(c) {
    c = c.listeners;
    for (var f = 0; f < c.length; f++) (0, c[f])();
  }
  function Tr(c, f) {
    return f;
  }
  function Ut(c, f) {
    var g, w, O;
    (g = Mt()).memoizedState = g.baseState = f, w = { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: Tr, lastRenderedState: f }, g.queue = w, g = Oa.bind(null, Zt, w), w.dispatch = g, w = Gt(!1);
    var N = pi.bind(null, Zt, !1, w.queue);
    return O = { state: f, dispatch: null, action: c, pending: null }, (w = Mt()).queue = O, g = gn.bind(null, Zt, O, N, g), O.dispatch = g, w.memoizedState = c, [f, g, !1];
  }
  function U0(c) {
    return ar(Rt(), er, c);
  }
  function ar(c, f, g) {
    f = mt(c, f, Tr)[0], c = qe(L0)[0], f = typeof f == "object" && f !== null && typeof f.then == "function" ? tt(f) : f;
    var w = Rt(), O = w.queue, N = O.dispatch;
    return g !== w.memoizedState && (Zt.flags |= 2048, P0(9, ct.bind(null, O, g), { destroy: void 0 }, null)), [f, N, c];
  }
  function ct(c, f) {
    c.action = f;
  }
  function Jr(c) {
    var f = Rt(), g = er;
    if (g !== null) return ar(f, g, c);
    Rt(), f = f.memoizedState;
    var w = (g = Rt()).queue.dispatch;
    return g.memoizedState = c, [f, w, !1];
  }
  function P0(c, f, g, w) {
    return c = { tag: c, create: f, inst: g, deps: w, next: null }, (f = Zt.updateQueue) === null && (f = Wm(), Zt.updateQueue = f), (g = f.lastEffect) === null ? f.lastEffect = c.next = c : (w = g.next, g.next = c, c.next = w, f.lastEffect = c), c;
  }
  function Bn() {
    return Rt().memoizedState;
  }
  function bn(c, f, g, w) {
    var O = Mt();
    Zt.flags |= c, O.memoizedState = P0(1 | f, g, { destroy: void 0 }, w === void 0 ? null : w);
  }
  function Ln(c, f, g, w) {
    var O = Rt();
    w = w === void 0 ? null : w;
    var N = O.memoizedState.inst;
    er !== null && w !== null && R0(w, er.memoizedState.deps) ? O.memoizedState = P0(f, g, N, w) : (Zt.flags |= c, O.memoizedState = P0(1 | f, g, N, w));
  }
  function Ii(c, f) {
    bn(8390656, 8, c, f);
  }
  function Yn(c, f) {
    Ln(2048, 8, c, f);
  }
  function fi(c, f) {
    return Ln(4, 2, c, f);
  }
  function di(c, f) {
    return Ln(4, 4, c, f);
  }
  function ho(c, f) {
    if (typeof f == "function") {
      c = c();
      var g = f(c);
      return function() {
        typeof g == "function" ? g() : f(null);
      };
    }
    if (f != null) return c = c(), f.current = c, function() {
      f.current = null;
    };
  }
  function aa(c, f, g) {
    g = g != null ? g.concat([c]) : null, Ln(4, 4, ho.bind(null, f, c), g);
  }
  function Qr() {
  }
  function hi(c, f) {
    var g = Rt();
    f = f === void 0 ? null : f;
    var w = g.memoizedState;
    return f !== null && R0(f, w[1]) ? w[0] : (g.memoizedState = [c, f], c);
  }
  function Bi(c, f) {
    var g = Rt();
    f = f === void 0 ? null : f;
    var w = g.memoizedState;
    if (f !== null && R0(f, w[1])) return w[0];
    if (w = c(), Ou) {
      I(!0);
      try {
        c();
      } finally {
        I(!1);
      }
    }
    return g.memoizedState = [w, f], w;
  }
  function Da(c, f, g) {
    return g === void 0 || 1073741824 & yl ? c.memoizedState = f : (c.memoizedState = g, c = U1(), Zt.lanes |= c, zs |= c, g);
  }
  function en(c, f, g, w) {
    return Wi(g, f) ? g : gf.current !== null ? (c = Da(c, g, w), Wi(c, f) || (sn = !0), c) : 42 & yl ? (c = U1(), Zt.lanes |= c, zs |= c, f) : (sn = !0, c.memoizedState = g);
  }
  function po(c, f, g, w, O) {
    var N = ku();
    So(N !== 0 && 8 > N ? N : 8);
    var G, ie, oe, De = $t.T, Ke = {};
    $t.T = Ke, pi(c, !1, f, g);
    try {
      var Qe = O(), We = $t.S;
      We !== null && We(Ke, Qe), Qe !== null && typeof Qe == "object" && typeof Qe.then == "function" ? mo(c, f, (G = w, ie = [], oe = { status: "pending", value: null, reason: null, then: function(pt) {
        ie.push(pt);
      } }, Qe.then(function() {
        oe.status = "fulfilled", oe.value = G;
        for (var pt = 0; pt < ie.length; pt++) (0, ie[pt])(G);
      }, function(pt) {
        for (oe.status = "rejected", oe.reason = pt, pt = 0; pt < ie.length; pt++) (0, ie[pt])(void 0);
      }), oe), $i()) : mo(c, f, w, $i());
    } catch (pt) {
      mo(c, f, { then: function() {
      }, status: "rejected", reason: pt }, $i());
    } finally {
      So(N), $t.T = De;
    }
  }
  function Nn() {
    return o0(p);
  }
  function ms() {
    return Rt().memoizedState;
  }
  function Mn() {
    return Rt().memoizedState;
  }
  function Uc(c) {
    for (var f = c.return; f !== null; ) {
      switch (f.tag) {
        case 24:
        case 3:
          var g = $i(), w = be(f, c = ye(g), g);
          return w !== null && (Kn(w, 0, g), he(w, f, g)), f = { cache: rn() }, void (c.payload = f);
      }
      f = f.return;
    }
  }
  function oa(c, f, g) {
    var w = $i();
    g = { lane: w, revertLane: 0, action: g, hasEagerState: !1, eagerState: null, next: null }, sa(c) ? Ra(f, g) : (g = Y(c, f, g, w)) !== null && (Kn(g, 0, w), go(g, f, w));
  }
  function Oa(c, f, g) {
    mo(c, f, g, $i());
  }
  function mo(c, f, g, w) {
    var O = { lane: w, revertLane: 0, action: g, hasEagerState: !1, eagerState: null, next: null };
    if (sa(c)) Ra(f, O);
    else {
      var N = c.alternate;
      if (c.lanes === 0 && (N === null || N.lanes === 0) && (N = f.lastRenderedReducer) !== null) try {
        var G = f.lastRenderedState, ie = N(G, g);
        if (O.hasEagerState = !0, O.eagerState = ie, Wi(ie, G)) return q(c, f, O, 0), tr === null && B(), !1;
      } catch {
      }
      if ((g = Y(c, f, O, w)) !== null) return Kn(g, 0, w), go(g, f, w), !0;
    }
    return !1;
  }
  function pi(c, f, g, w) {
    if (w = { lane: 2, revertLane: Me(), action: w, hasEagerState: !1, eagerState: null, next: null }, sa(c)) {
      if (f) throw Error(r(479));
    } else (f = Y(c, g, w, 2)) !== null && Kn(f, 0, 2);
  }
  function sa(c) {
    var f = c.alternate;
    return c === Zt || f !== null && f === Zt;
  }
  function Ra(c, f) {
    vf = d2 = !0;
    var g = c.pending;
    g === null ? f.next = f : (f.next = g.next, g.next = f), c.pending = f;
  }
  function go(c, f, g) {
    if (4194176 & g) {
      var w = f.lanes;
      g |= w &= c.pendingLanes, f.lanes = g, D(c, g);
    }
  }
  function gs(c, f, g, w) {
    g = (g = g(w, f = c.memoizedState)) == null ? f : Vn({}, f, g), c.memoizedState = g, c.lanes === 0 && (c.updateQueue.baseState = g);
  }
  function vs(c, f, g, w, O, N, G) {
    return typeof (c = c.stateNode).shouldComponentUpdate == "function" ? c.shouldComponentUpdate(w, N, G) : !(f.prototype && f.prototype.isPureReactComponent && et(g, w) && et(O, N));
  }
  function Pa(c, f, g, w) {
    c = f.state, typeof f.componentWillReceiveProps == "function" && f.componentWillReceiveProps(g, w), typeof f.UNSAFE_componentWillReceiveProps == "function" && f.UNSAFE_componentWillReceiveProps(g, w), f.state !== c && Hm.enqueueReplaceState(f, f.state, null);
  }
  function mi(c, f) {
    var g = f;
    if ("ref" in f) for (var w in g = {}, f) w !== "ref" && (g[w] = f[w]);
    if (c = c.defaultProps) for (var O in g === f && (g = Vn({}, g)), c) g[O] === void 0 && (g[O] = c[O]);
    return g;
  }
  function gi(c, f) {
    try {
      (0, c.onUncaughtError)(f.value, { componentStack: f.stack });
    } catch (g) {
      setTimeout(function() {
        throw g;
      });
    }
  }
  function Gn(c, f, g) {
    try {
      (0, c.onCaughtError)(g.value, { componentStack: g.stack, errorBoundary: f.tag === 1 ? f.stateNode : null });
    } catch (w) {
      setTimeout(function() {
        throw w;
      });
    }
  }
  function vi(c, f, g) {
    return (g = ye(g)).tag = 3, g.payload = { element: null }, g.callback = function() {
      gi(c, f);
    }, g;
  }
  function Ia(c) {
    return (c = ye(c)).tag = 3, c;
  }
  function la(c, f, g, w) {
    var O = g.type.getDerivedStateFromError;
    if (typeof O == "function") {
      var N = w.value;
      c.payload = function() {
        return O(N);
      }, c.callback = function() {
        Gn(f, g, w);
      };
    }
    var G = g.stateNode;
    G !== null && typeof G.componentDidCatch == "function" && (c.callback = function() {
      Gn(f, g, w), typeof O != "function" && (Al === null ? Al = /* @__PURE__ */ new Set([this]) : Al.add(this));
      var ie = w.stack;
      this.componentDidCatch(w.value, { componentStack: ie !== null ? ie : "" });
    });
  }
  function or(c, f, g, w) {
    f.child = c === null ? hF(f, null, g, w) : mf(f, c.child, g, w);
  }
  function ua(c, f, g, w, O) {
    g = g.render;
    var N = f.ref;
    if ("ref" in w) {
      var G = {};
      for (var ie in w) ie !== "ref" && (G[ie] = w[ie]);
    } else G = w;
    return Ni(f), w = b0(c, f, g, G, N, O), ie = kr(), c === null || sn ? (f.flags |= 1, or(c, f, w, O), f.child) : (br(c, f, O), Nr(c, f, O));
  }
  function xn(c, f, g, w, O) {
    if (c === null) {
      var N = g.type;
      return typeof N != "function" || Ss(N) || N.defaultProps !== void 0 || g.compare !== null ? ((c = Au(g.type, null, w, f, f.mode, O)).ref = f.ref, c.return = f, f.child = c) : (f.tag = 15, f.type = N, Ba(c, f, N, w, O));
    }
    if (N = c.child, !pr(c, O)) {
      var G = N.memoizedProps;
      if ((g = (g = g.compare) !== null ? g : et)(G, w) && c.ref === f.ref) return Nr(c, f, O);
    }
    return f.flags |= 1, (c = Vi(N, w)).ref = f.ref, c.return = f, f.child = c;
  }
  function Ba(c, f, g, w, O) {
    if (c !== null) {
      var N = c.memoizedProps;
      if (et(N, w) && c.ref === f.ref) {
        if (sn = !1, f.pendingProps = w = N, !pr(c, O)) return f.lanes = c.lanes, Nr(c, f, O);
        131072 & c.flags && (sn = !0);
      }
    }
    return yr(c, f, g, w, O);
  }
  function Li(c, f, g) {
    var w = f.pendingProps, O = w.children, N = (2 & f.stateNode._pendingVisibility) != 0, G = c !== null ? c.memoizedState : null;
    if (vo(c, f), w.mode === "hidden" || N) {
      if (128 & f.flags) {
        if (w = G !== null ? G.baseLanes | g : g, c !== null) {
          for (O = f.child = c.child, N = 0; O !== null; ) N = N | O.lanes | O.childLanes, O = O.sibling;
          f.childLanes = N & ~w;
        } else f.childLanes = 0, f.child = null;
        return bi(c, f, w, g);
      }
      if (!(536870912 & g)) return f.lanes = f.childLanes = 536870912, bi(c, f, G !== null ? G.baseLanes | g : g, g);
      f.memoizedState = { baseLanes: 0, cachePool: null }, c !== null && cl(0, G !== null ? G.cachePool : null), G !== null ? Ue(f, G) : rt(), Bt(f);
    } else G !== null ? (cl(0, G.cachePool), Ue(f, G), At(), f.memoizedState = null) : (c !== null && cl(0, null), rt(), At());
    return or(c, f, O, g), f.child;
  }
  function bi(c, f, g, w) {
    var O = zc();
    return O = O === null ? null : { parent: Yr._currentValue2, pool: O }, f.memoizedState = { baseLanes: g, cachePool: O }, c !== null && cl(0, null), rt(), Bt(f), c !== null && zn(c, f, w, !0), null;
  }
  function vo(c, f) {
    var g = f.ref;
    if (g === null) c !== null && c.ref !== null && (f.flags |= 2097664);
    else {
      if (typeof g != "function" && typeof g != "object") throw Error(r(284));
      c !== null && c.ref === g || (f.flags |= 2097664);
    }
  }
  function yr(c, f, g, w, O) {
    return Ni(f), g = b0(c, f, g, w, void 0, O), w = kr(), c === null || sn ? (f.flags |= 1, or(c, f, g, O), f.child) : (br(c, f, O), Nr(c, f, O));
  }
  function bs(c, f, g, w, O, N) {
    return Ni(f), f.updateQueue = null, g = a0(f, w, g, O), ir(c), w = kr(), c === null || sn ? (f.flags |= 1, or(c, f, g, N), f.child) : (br(c, f, N), Nr(c, f, N));
  }
  function xs(c, f, g, w, O) {
    if (Ni(f), f.stateNode === null) {
      var N = lf, G = g.contextType;
      typeof G == "object" && G !== null && (N = o0(G)), N = new g(w, N), f.memoizedState = N.state !== null && N.state !== void 0 ? N.state : null, N.updater = Hm, f.stateNode = N, N._reactInternals = f, (N = f.stateNode).props = w, N.state = f.memoizedState, N.refs = {}, it(f), G = g.contextType, N.context = typeof G == "object" && G !== null ? o0(G) : lf, N.state = f.memoizedState, typeof (G = g.getDerivedStateFromProps) == "function" && (gs(f, g, G, w), N.state = f.memoizedState), typeof g.getDerivedStateFromProps == "function" || typeof N.getSnapshotBeforeUpdate == "function" || typeof N.UNSAFE_componentWillMount != "function" && typeof N.componentWillMount != "function" || (G = N.state, typeof N.componentWillMount == "function" && N.componentWillMount(), typeof N.UNSAFE_componentWillMount == "function" && N.UNSAFE_componentWillMount(), G !== N.state && Hm.enqueueReplaceState(N, N.state, null), Ve(f, w, N, O), $e(), N.state = f.memoizedState), typeof N.componentDidMount == "function" && (f.flags |= 4194308), w = !0;
    } else if (c === null) {
      N = f.stateNode;
      var ie = f.memoizedProps, oe = mi(g, ie);
      N.props = oe;
      var De = N.context, Ke = g.contextType;
      G = lf, typeof Ke == "object" && Ke !== null && (G = o0(Ke));
      var Qe = g.getDerivedStateFromProps;
      Ke = typeof Qe == "function" || typeof N.getSnapshotBeforeUpdate == "function", ie = f.pendingProps !== ie, Ke || typeof N.UNSAFE_componentWillReceiveProps != "function" && typeof N.componentWillReceiveProps != "function" || (ie || De !== G) && Pa(f, N, w, G), xl = !1;
      var We = f.memoizedState;
      N.state = We, Ve(f, w, N, O), $e(), De = f.memoizedState, ie || We !== De || xl ? (typeof Qe == "function" && (gs(f, g, Qe, w), De = f.memoizedState), (oe = xl || vs(f, g, oe, w, We, De, G)) ? (Ke || typeof N.UNSAFE_componentWillMount != "function" && typeof N.componentWillMount != "function" || (typeof N.componentWillMount == "function" && N.componentWillMount(), typeof N.UNSAFE_componentWillMount == "function" && N.UNSAFE_componentWillMount()), typeof N.componentDidMount == "function" && (f.flags |= 4194308)) : (typeof N.componentDidMount == "function" && (f.flags |= 4194308), f.memoizedProps = w, f.memoizedState = De), N.props = w, N.state = De, N.context = G, w = oe) : (typeof N.componentDidMount == "function" && (f.flags |= 4194308), w = !1);
    } else {
      N = f.stateNode, fe(c, f), Ke = mi(g, G = f.memoizedProps), N.props = Ke, Qe = f.pendingProps, We = N.context, De = g.contextType, oe = lf, typeof De == "object" && De !== null && (oe = o0(De)), (De = typeof (ie = g.getDerivedStateFromProps) == "function" || typeof N.getSnapshotBeforeUpdate == "function") || typeof N.UNSAFE_componentWillReceiveProps != "function" && typeof N.componentWillReceiveProps != "function" || (G !== Qe || We !== oe) && Pa(f, N, w, oe), xl = !1, We = f.memoizedState, N.state = We, Ve(f, w, N, O), $e();
      var pt = f.memoizedState;
      G !== Qe || We !== pt || xl || c !== null && c.dependencies !== null && Dr(c.dependencies) ? (typeof ie == "function" && (gs(f, g, ie, w), pt = f.memoizedState), (Ke = xl || vs(f, g, Ke, w, We, pt, oe) || c !== null && c.dependencies !== null && Dr(c.dependencies)) ? (De || typeof N.UNSAFE_componentWillUpdate != "function" && typeof N.componentWillUpdate != "function" || (typeof N.componentWillUpdate == "function" && N.componentWillUpdate(w, pt, oe), typeof N.UNSAFE_componentWillUpdate == "function" && N.UNSAFE_componentWillUpdate(w, pt, oe)), typeof N.componentDidUpdate == "function" && (f.flags |= 4), typeof N.getSnapshotBeforeUpdate == "function" && (f.flags |= 1024)) : (typeof N.componentDidUpdate != "function" || G === c.memoizedProps && We === c.memoizedState || (f.flags |= 4), typeof N.getSnapshotBeforeUpdate != "function" || G === c.memoizedProps && We === c.memoizedState || (f.flags |= 1024), f.memoizedProps = w, f.memoizedState = pt), N.props = w, N.state = pt, N.context = oe, w = Ke) : (typeof N.componentDidUpdate != "function" || G === c.memoizedProps && We === c.memoizedState || (f.flags |= 4), typeof N.getSnapshotBeforeUpdate != "function" || G === c.memoizedProps && We === c.memoizedState || (f.flags |= 1024), w = !1);
    }
    return N = w, vo(c, f), w = (128 & f.flags) != 0, N || w ? (N = f.stateNode, g = w && typeof g.getDerivedStateFromError != "function" ? null : N.render(), f.flags |= 1, c !== null && w ? (f.child = mf(f, c.child, null, O), f.child = mf(f, null, g, O)) : or(c, f, g, O), f.memoizedState = N.state, c = f.child) : c = Nr(c, f, O), c;
  }
  function G0(c) {
    return { baseLanes: c, cachePool: $c() };
  }
  function ca(c, f, g) {
    return c = c !== null ? c.childLanes & ~g : 0, f && (c |= ma), c;
  }
  function ul(c, f, g) {
    var w, O, N, G, ie = f.pendingProps, oe = !1, De = (128 & f.flags) != 0;
    if ((w = De) || (w = (c === null || c.memoizedState !== null) && (2 & qr.current) != 0), w && (oe = !0, f.flags &= -129), w = (32 & f.flags) != 0, f.flags &= -33, c === null) return O = ie.children, ie = ie.fallback, oe ? (At(), O = wr({ mode: "hidden", children: O }, oe = f.mode), ie = ft(ie, oe, g, null), O.return = f, ie.return = f, O.sibling = ie, f.child = O, (oe = f.child).memoizedState = G0(g), oe.childLanes = ca(c, w, g), f.memoizedState = qm, ie) : (_t(f), La(f, O));
    if ((N = c.memoizedState) !== null && (O = N.dehydrated) !== null) {
      if (De) 256 & f.flags ? (_t(f), f.flags &= -257, f = Zn(c, f, g)) : f.memoizedState !== null ? (At(), f.child = c.child, f.flags |= 128, f = null) : (At(), oe = ie.fallback, O = f.mode, ie = wr({ mode: "visible", children: ie.children }, O), (oe = ft(oe, O, g, null)).flags |= 2, ie.return = f, oe.return = f, ie.sibling = oe, f.child = ie, mf(f, c.child, null, g), (ie = f.child).memoizedState = G0(g), ie.childLanes = ca(c, w, g), f.memoizedState = qm, f = oe);
      else if (_t(f), dt(O)) w = Ft(O).digest, (ie = Error(r(419))).stack = "", ie.digest = w, G = { value: ie, source: null, stack: null }, Bs === null ? Bs = [G] : Bs.push(G), f = Zn(c, f, g);
      else if (sn || zn(c, f, g, !1), w = (g & c.childLanes) != 0, sn || w) {
        if ((w = tr) !== null) {
          if (42 & (ie = g & -g)) ie = 1;
          else switch (ie) {
            case 2:
              ie = 1;
              break;
            case 8:
              ie = 4;
              break;
            case 32:
              ie = 16;
              break;
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              ie = 64;
              break;
            case 268435456:
              ie = 134217728;
              break;
            default:
              ie = 0;
          }
          if ((ie = ie & (w.suspendedLanes | g) ? 0 : ie) !== 0 && ie !== N.retryLane) throw N.retryLane = ie, Z(c, ie), Kn(w, 0, ie), t6;
        }
        Fe(O) || Gc(), f = Zn(c, f, g);
      } else Fe(O) ? (f.flags |= 128, f.child = c.child, f = ja.bind(null, c), k0(O, f), f = null) : (c = N.treeContext, (f = La(f, ie.children)).flags |= 4096);
      return f;
    }
    return oe ? (At(), oe = ie.fallback, O = f.mode, De = (N = c.child).sibling, (ie = Vi(N, { mode: "hidden", children: ie.children })).subtreeFlags = 31457280 & N.subtreeFlags, De !== null ? oe = Vi(De, oe) : (oe = ft(oe, O, g, null)).flags |= 2, oe.return = f, ie.return = f, ie.sibling = oe, f.child = ie, ie = oe, oe = f.child, (O = c.child.memoizedState) === null ? O = G0(g) : ((N = O.cachePool) !== null ? (De = Yr._currentValue2, N = N.parent !== De ? { parent: De, pool: De } : N) : N = $c(), O = { baseLanes: O.baseLanes | g, cachePool: N }), oe.memoizedState = O, oe.childLanes = ca(c, w, g), f.memoizedState = qm, ie) : (_t(f), c = (g = c.child).sibling, (g = Vi(g, { mode: "visible", children: ie.children })).return = f, g.sibling = null, c !== null && ((w = f.deletions) === null ? (f.deletions = [c], f.flags |= 16) : w.push(c)), f.child = g, f.memoizedState = null, g);
  }
  function La(c, f) {
    return (f = wr({ mode: "visible", children: f }, c.mode)).return = c, c.child = f;
  }
  function wr(c, f) {
    return Eu(c, f, 0, null);
  }
  function Zn(c, f, g) {
    return mf(f, c.child, null, g), (c = La(f, f.pendingProps.children)).flags |= 2, f.memoizedState = null, c;
  }
  function Lr(c, f, g) {
    c.lanes |= f;
    var w = c.alternate;
    w !== null && (w.lanes |= f), Na(c.return, f, g);
  }
  function Fr(c, f, g, w, O) {
    var N = c.memoizedState;
    N === null ? c.memoizedState = { isBackwards: f, rendering: null, renderingStartTime: 0, last: w, tail: g, tailMode: O } : (N.isBackwards = f, N.rendering = null, N.renderingStartTime = 0, N.last = w, N.tail = g, N.tailMode = O);
  }
  function yn(c, f, g) {
    var w = f.pendingProps, O = w.revealOrder, N = w.tail;
    if (or(c, f, w.children, g), (2 & (w = qr.current)) != 0) w = 1 & w | 2, f.flags |= 128;
    else {
      if (c !== null && 128 & c.flags) e: for (c = f.child; c !== null; ) {
        if (c.tag === 13) c.memoizedState !== null && Lr(c, g, f);
        else if (c.tag === 19) Lr(c, g, f);
        else if (c.child !== null) {
          c.child.return = c, c = c.child;
          continue;
        }
        if (c === f) break e;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === f) break e;
          c = c.return;
        }
        c.sibling.return = c.return, c = c.sibling;
      }
      w &= 1;
    }
    switch (h(qr, w), O) {
      case "forwards":
        for (g = f.child, O = null; g !== null; ) (c = g.alternate) !== null && Je(c) === null && (O = g), g = g.sibling;
        (g = O) === null ? (O = f.child, f.child = null) : (O = g.sibling, g.sibling = null), Fr(f, !1, O, g, N);
        break;
      case "backwards":
        for (g = null, O = f.child, f.child = null; O !== null; ) {
          if ((c = O.alternate) !== null && Je(c) === null) {
            f.child = O;
            break;
          }
          c = O.sibling, O.sibling = g, g = O, O = c;
        }
        Fr(f, !0, g, null, N);
        break;
      case "together":
        Fr(f, !1, null, null, void 0);
        break;
      default:
        f.memoizedState = null;
    }
    return f.child;
  }
  function Nr(c, f, g) {
    if (c !== null && (f.dependencies = c.dependencies), zs |= f.lanes, (g & f.childLanes) == 0 && (c === null || (zn(c, f, g, !1), (g & f.childLanes) == 0)))
      return null;
    if (c !== null && f.child !== c.child) throw Error(r(153));
    if (f.child !== null) {
      for (g = Vi(c = f.child, c.pendingProps), f.child = g, g.return = f; c.sibling !== null; ) c = c.sibling, (g = g.sibling = Vi(c, c.pendingProps)).return = f;
      g.sibling = null;
    }
    return f.child;
  }
  function pr(c, f) {
    return (c.lanes & f) != 0 || !((c = c.dependencies) === null || !Dr(c));
  }
  function fa(c, f, g) {
    if (c !== null) if (c.memoizedProps !== f.pendingProps) sn = !0;
    else {
      if (!pr(c, g) && !(128 & f.flags)) return sn = !1, function(ie, oe, De) {
        switch (oe.tag) {
          case 3:
            V(oe, oe.stateNode.containerInfo), _r(0, Yr, ie.memoizedState.cache);
            break;
          case 27:
          case 5:
            j(oe);
            break;
          case 4:
            V(oe, oe.stateNode.containerInfo);
            break;
          case 10:
            _r(0, oe.type, oe.memoizedProps.value);
            break;
          case 13:
            var Ke = oe.memoizedState;
            if (Ke !== null) return Ke.dehydrated !== null ? (_t(oe), oe.flags |= 128, null) : De & oe.child.childLanes ? ul(ie, oe, De) : (_t(oe), (ie = Nr(ie, oe, De)) !== null ? ie.sibling : null);
            _t(oe);
            break;
          case 19:
            var Qe = (128 & ie.flags) != 0;
            if ((Ke = (De & oe.childLanes) != 0) || (zn(ie, oe, De, !1), Ke = (De & oe.childLanes) != 0), Qe) {
              if (Ke) return yn(ie, oe, De);
              oe.flags |= 128;
            }
            if ((Qe = oe.memoizedState) !== null && (Qe.rendering = null, Qe.tail = null, Qe.lastEffect = null), h(qr, qr.current), Ke) break;
            return null;
          case 22:
          case 23:
            return oe.lanes = 0, Li(ie, oe, De);
          case 24:
            _r(0, Yr, ie.memoizedState.cache);
        }
        return Nr(ie, oe, De);
      }(c, f, g);
      sn = (131072 & c.flags) != 0;
    }
    else sn = !1;
    switch (f.lanes = 0, f.tag) {
      case 16:
        e: {
          c = f.pendingProps;
          var w = f.elementType, O = w._init;
          if (w = O(w._payload), f.type = w, typeof w != "function") {
            if (w != null) {
              if ((O = w.$$typeof) === ef) {
                f.tag = 11, f = ua(null, f, w, c, g);
                break e;
              }
              if (O === gl) {
                f.tag = 14, f = xn(null, f, w, c, g);
                break e;
              }
            }
            throw f = i(w) || w, Error(r(306, f, ""));
          }
          Ss(w) ? (c = mi(w, c), f.tag = 1, f = xs(null, f, w, c, g)) : (f.tag = 0, f = yr(null, f, w, c, g));
        }
        return f;
      case 0:
        return yr(c, f, f.type, f.pendingProps, g);
      case 1:
        return xs(c, f, w = f.type, O = mi(w, f.pendingProps), g);
      case 3:
        if (V(f, f.stateNode.containerInfo), c === null) throw Error(r(387));
        var N = f.pendingProps;
        w = (O = f.memoizedState).element, fe(c, f), Ve(f, N, null, g);
        var G = f.memoizedState;
        return N = G.cache, _r(0, Yr, N), N !== O.cache && tn(f, [Yr], g, !0), $e(), (N = G.element) !== w ? (or(c, f, N, g), f = f.child) : f = Nr(c, f, g), f;
      case 26:
      case 27:
      case 5:
        return j(f), O = f.type, N = f.pendingProps, G = c !== null ? c.memoizedProps : null, w = N.children, r2(O, N) ? w = null : G !== null && r2(O, G) && (f.flags |= 32), f.memoizedState !== null && (O = b0(c, f, e0, null, null, g), p._currentValue2 = O), vo(c, f), or(c, f, w, g), f.child;
      case 6:
        return null;
      case 13:
        return ul(c, f, g);
      case 4:
        return V(f, f.stateNode.containerInfo), w = f.pendingProps, c === null ? f.child = mf(f, null, w, g) : or(c, f, w, g), f.child;
      case 11:
        return ua(c, f, f.type, f.pendingProps, g);
      case 7:
        return or(c, f, f.pendingProps, g), f.child;
      case 8:
      case 12:
        return or(c, f, f.pendingProps.children, g), f.child;
      case 10:
        return w = f.pendingProps, _r(0, f.type, w.value), or(c, f, w.children, g), f.child;
      case 9:
        return O = f.type._context, w = f.pendingProps.children, Ni(f), w = w(O = o0(O)), f.flags |= 1, or(c, f, w, g), f.child;
      case 14:
        return xn(c, f, f.type, f.pendingProps, g);
      case 15:
        return Ba(c, f, f.type, f.pendingProps, g);
      case 19:
        return yn(c, f, g);
      case 22:
        return Li(c, f, g);
      case 24:
        return Ni(f), w = o0(Yr), c === null ? ((O = zc()) === null && (O = tr, N = rn(), O.pooledCache = N, N.refCount++, N !== null && (O.pooledCacheLanes |= g), O = N), f.memoizedState = { parent: w, cache: O }, it(f), _r(0, Yr, O)) : (c.lanes & g && (fe(c, f), Ve(f, null, null, g), $e()), O = c.memoizedState, N = f.memoizedState, O.parent !== w ? (O = { parent: w, cache: w }, f.memoizedState = O, f.lanes === 0 && (f.memoizedState = f.updateQueue.baseState = O), _r(0, Yr, w)) : (w = N.cache, _r(0, Yr, w), w !== O.cache && tn(f, [Yr], g, !0))), or(c, f, f.pendingProps.children, g), f.child;
      case 29:
        throw f.pendingProps;
    }
    throw Error(r(156, f.tag));
  }
  function Un() {
    Gm = xf = h2 = null;
  }
  function _r(c, f, g) {
    h(Ym, f._currentValue2), f._currentValue2 = g;
  }
  function z0(c) {
    var f = Ym.current;
    c._currentValue2 = f, d(Ym);
  }
  function Na(c, f, g) {
    for (; c !== null; ) {
      var w = c.alternate;
      if ((c.childLanes & f) !== f ? (c.childLanes |= f, w !== null && (w.childLanes |= f)) : w !== null && (w.childLanes & f) !== f && (w.childLanes |= f), c === g) break;
      c = c.return;
    }
  }
  function tn(c, f, g, w) {
    var O = c.child;
    for (O !== null && (O.return = c); O !== null; ) {
      var N = O.dependencies;
      if (N !== null) {
        var G = O.child;
        N = N.firstContext;
        e: for (; N !== null; ) {
          var ie = N;
          N = O;
          for (var oe = 0; oe < f.length; oe++) if (ie.context === f[oe]) {
            N.lanes |= g, (ie = N.alternate) !== null && (ie.lanes |= g), Na(N.return, g, c), w || (G = null);
            break e;
          }
          N = ie.next;
        }
      } else if (O.tag === 18) {
        if ((G = O.return) === null) throw Error(r(341));
        G.lanes |= g, (N = G.alternate) !== null && (N.lanes |= g), Na(G, g, c), G = null;
      } else G = O.child;
      if (G !== null) G.return = O;
      else for (G = O; G !== null; ) {
        if (G === c) {
          G = null;
          break;
        }
        if ((O = G.sibling) !== null) {
          O.return = G.return, G = O;
          break;
        }
        G = G.return;
      }
      O = G;
    }
  }
  function zn(c, f, g, w) {
    c = null;
    for (var O = f, N = !1; O !== null; ) {
      if (!N) {
        if (524288 & O.flags) N = !0;
        else if (262144 & O.flags) break;
      }
      if (O.tag === 10) {
        var G = O.alternate;
        if (G === null) throw Error(r(387));
        if ((G = G.memoizedProps) !== null) {
          var ie = O.type;
          Wi(O.pendingProps.value, G.value) || (c !== null ? c.push(ie) : c = [ie]);
        }
      } else if (O === l2.current) {
        if ((G = O.alternate) === null) throw Error(r(387));
        G.memoizedState.memoizedState !== O.memoizedState.memoizedState && (c !== null ? c.push(p) : c = [p]);
      }
      O = O.return;
    }
    c !== null && tn(f, c, g, w), f.flags |= 262144;
  }
  function Dr(c) {
    for (c = c.firstContext; c !== null; ) {
      var f = c.context;
      if (!Wi(f._currentValue2, c.memoizedValue)) return !0;
      c = c.next;
    }
    return !1;
  }
  function Ni(c) {
    h2 = c, Gm = xf = null, (c = c.dependencies) !== null && (c.firstContext = null);
  }
  function o0(c) {
    return sr(h2, c);
  }
  function Wr(c, f) {
    return h2 === null && Ni(c), sr(c, f);
  }
  function sr(c, f) {
    var g = f._currentValue2;
    if (Gm !== f) if (f = { context: f, memoizedValue: g, next: null }, xf === null) {
      if (c === null) throw Error(r(308));
      xf = f, c.dependencies = { lanes: 0, firstContext: f }, c.flags |= 524288;
    } else xf = xf.next = f;
    return g;
  }
  function rn() {
    return { controller: new mF(), data: /* @__PURE__ */ new Map(), refCount: 0 };
  }
  function Ma(c) {
    c.refCount--, c.refCount === 0 && gF(vF, function() {
      c.controller.abort();
    });
  }
  function zc() {
    var c = yf.current;
    return c !== null ? c : tr.pooledCache;
  }
  function cl(c, f) {
    h(yf, f === null ? yf.current : f.pool);
  }
  function $c() {
    var c = zc();
    return c === null ? null : { parent: Yr._currentValue2, pool: c };
  }
  function du(c) {
    c.flags |= 4;
  }
  function fl(c, f) {
    f !== null && (c.flags |= 4), 16384 & c.flags && (f = c.tag !== 22 ? T() : 536870912, c.lanes |= f);
  }
  function ys(c, f) {
    switch (c.tailMode) {
      case "hidden":
        f = c.tail;
        for (var g = null; f !== null; ) f.alternate !== null && (g = f), f = f.sibling;
        g === null ? c.tail = null : g.sibling = null;
        break;
      case "collapsed":
        g = c.tail;
        for (var w = null; g !== null; ) g.alternate !== null && (w = g), g = g.sibling;
        w === null ? f || c.tail === null ? c.tail = null : c.tail.sibling = null : w.sibling = null;
    }
  }
  function nn(c) {
    var f = c.alternate !== null && c.alternate.child === c.child, g = 0, w = 0;
    if (f) for (var O = c.child; O !== null; ) g |= O.lanes | O.childLanes, w |= 31457280 & O.subtreeFlags, w |= 31457280 & O.flags, O.return = c, O = O.sibling;
    else for (O = c.child; O !== null; ) g |= O.lanes | O.childLanes, w |= O.subtreeFlags, w |= O.flags, O.return = c, O = O.sibling;
    return c.subtreeFlags |= w, c.childLanes = g, f;
  }
  function Gh(c, f, g) {
    var w = f.pendingProps;
    switch (U(f), f.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
      case 1:
        return nn(f), null;
      case 3:
        return g = f.stateNode, w = null, c !== null && (w = c.memoizedState.cache), f.memoizedState.cache !== w && (f.flags |= 2048), z0(Yr), z(), g.pendingContext && (g.context = g.pendingContext, g.pendingContext = null), c !== null && c.child !== null || c === null || c.memoizedState.isDehydrated && !(256 & f.flags) || (f.flags |= 1024, Bs !== null && (Yc(Bs), Bs = null)), nn(f), null;
      case 26:
        var O;
      case 27:
      case 5:
        if (S(f), g = f.type, c !== null && f.stateNode != null) (function(G, ie, oe, De) {
          G.memoizedProps !== De && du(ie);
        })(c, f, 0, w);
        else {
          if (!w) {
            if (f.stateNode === null) throw Error(r(166));
            return nn(f), null;
          }
          c = Is.current, function(G, ie, oe, De) {
            for (oe = ie.child; oe !== null; ) {
              if (oe.tag === 5 || oe.tag === 6) Q1(G, oe.stateNode);
              else if (oe.tag !== 4 && !Tu && oe.child !== null) {
                oe.child.return = oe, oe = oe.child;
                continue;
              }
              if (oe === ie) break;
              for (; oe.sibling === null; ) {
                if (oe.return === null || oe.return === ie) return;
                oe = oe.return;
              }
              oe.sibling.return = oe.return, oe = oe.sibling;
            }
          }(O = Dm(g, w, s2.current, c, f), f, !1), f.stateNode = O, ed(O, g, w, c) && du(f);
        }
        return nn(f), function(G, ie, oe) {
          if (i2(ie, oe)) {
            if (G.flags |= 16777216, !id(ie, oe)) {
              if (!H1()) throw ud = Vm, e6;
              G.flags |= 8192;
            }
          } else G.flags &= -16777217;
        }(f, f.type, f.pendingProps), null;
      case 6:
        if (c && f.stateNode != null) (g = c.memoizedProps) !== w && du(f);
        else {
          if (typeof w != "string" && f.stateNode === null) throw Error(r(166));
          c = s2.current, g = Is.current, f.stateNode = qa(w, c, g, f);
        }
        return nn(f), null;
      case 13:
        if (w = f.memoizedState, c === null || c.memoizedState !== null && c.memoizedState.dehydrated !== null) {
          if (O = !1, w !== null && w.dehydrated !== null) {
            if (c === null)
              throw Error(r(O ? 344 : 318));
            !(128 & f.flags) && (f.memoizedState = null), f.flags |= 4, nn(f), O = !1;
          } else Bs !== null && (Yc(Bs), Bs = null), O = !0;
          if (!O) return 256 & f.flags ? (Tt(f), f) : (Tt(f), null);
        }
        if (Tt(f), (128 & f.flags) != 0) return f.lanes = g, f;
        if (g = w !== null, c = c !== null && c.memoizedState !== null, g) {
          O = null, (w = f.child).alternate !== null && w.alternate.memoizedState !== null && w.alternate.memoizedState.cachePool !== null && (O = w.alternate.memoizedState.cachePool.pool);
          var N = null;
          w.memoizedState !== null && w.memoizedState.cachePool !== null && (N = w.memoizedState.cachePool.pool), N !== O && (w.flags |= 2048);
        }
        return g !== c && g && (f.child.flags |= 8192), fl(f, f.updateQueue), nn(f), null;
      case 4:
        return z(), c === null && nd(f.stateNode.containerInfo), nn(f), null;
      case 10:
        return z0(f.type), nn(f), null;
      case 19:
        if (d(qr), (O = f.memoizedState) === null) return nn(f), null;
        if (w = (128 & f.flags) != 0, (N = O.rendering) === null) if (w) ys(O, !1);
        else {
          if (zr !== 0 || c !== null && 128 & c.flags) for (c = f.child; c !== null; ) {
            if ((N = Je(c)) !== null) {
              for (f.flags |= 128, ys(O, !1), c = N.updateQueue, f.updateQueue = c, fl(f, c), f.subtreeFlags = 0, c = g, g = f.child; g !== null; ) Kc(g, c), g = g.sibling;
              return h(qr, 1 & qr.current | 2), f.child;
            }
            c = c.sibling;
          }
          O.tail !== null && Ps() > eg && (f.flags |= 128, w = !0, ys(O, !1), f.lanes = 4194304);
        }
        else {
          if (!w) if ((c = Je(N)) !== null) {
            if (f.flags |= 128, w = !0, c = c.updateQueue, f.updateQueue = c, fl(f, c), ys(O, !0), O.tail === null && O.tailMode === "hidden" && !N.alternate) return nn(f), null;
          } else 2 * Ps() - O.renderingStartTime > eg && g !== 536870912 && (f.flags |= 128, w = !0, ys(O, !1), f.lanes = 4194304);
          O.isBackwards ? (N.sibling = f.child, f.child = N) : ((c = O.last) !== null ? c.sibling = N : f.child = N, O.last = N);
        }
        return O.tail !== null ? (f = O.tail, O.rendering = f, O.tail = f.sibling, O.renderingStartTime = Ps(), f.sibling = null, c = qr.current, h(qr, w ? 1 & c | 2 : 1 & c), f) : (nn(f), null);
      case 22:
      case 23:
        return Tt(f), gt(), w = f.memoizedState !== null, c !== null ? c.memoizedState !== null !== w && (f.flags |= 8192) : w && (f.flags |= 8192), w ? 536870912 & g && !(128 & f.flags) && (nn(f), 6 & f.subtreeFlags && (f.flags |= 8192)) : nn(f), (g = f.updateQueue) !== null && fl(f, g.retryQueue), g = null, c !== null && c.memoizedState !== null && c.memoizedState.cachePool !== null && (g = c.memoizedState.cachePool.pool), w = null, f.memoizedState !== null && f.memoizedState.cachePool !== null && (w = f.memoizedState.cachePool.pool), w !== g && (f.flags |= 2048), c !== null && d(yf), null;
      case 24:
        return g = null, c !== null && (g = c.memoizedState.cache), f.memoizedState.cache !== g && (f.flags |= 2048), z0(Yr), nn(f), null;
      case 25:
        return null;
    }
    throw Error(r(156, f.tag));
  }
  function Zh(c, f) {
    switch (U(f), f.tag) {
      case 1:
        return 65536 & (c = f.flags) ? (f.flags = -65537 & c | 128, f) : null;
      case 3:
        return z0(Yr), z(), 65536 & (c = f.flags) && !(128 & c) ? (f.flags = -65537 & c | 128, f) : null;
      case 26:
      case 27:
      case 5:
        return S(f), null;
      case 13:
        if (Tt(f), (c = f.memoizedState) !== null && c.dehydrated !== null && f.alternate === null) throw Error(r(340));
        return 65536 & (c = f.flags) ? (f.flags = -65537 & c | 128, f) : null;
      case 19:
        return d(qr), null;
      case 4:
        return z(), null;
      case 10:
        return z0(f.type), null;
      case 22:
      case 23:
        return Tt(f), gt(), c !== null && d(yf), 65536 & (c = f.flags) ? (f.flags = -65537 & c | 128, f) : null;
      case 24:
        return z0(Yr), null;
      default:
        return null;
    }
  }
  function O1(c, f) {
    switch (U(f), f.tag) {
      case 3:
        z0(Yr), z();
        break;
      case 26:
      case 27:
      case 5:
        S(f);
        break;
      case 4:
        z();
        break;
      case 13:
        Tt(f);
        break;
      case 19:
        d(qr);
        break;
      case 10:
        z0(f.type);
        break;
      case 22:
      case 23:
        Tt(f), gt(), c !== null && d(yf);
        break;
      case 24:
        z0(Yr);
    }
  }
  function dl(c, f) {
    try {
      var g = f.updateQueue, w = g !== null ? g.lastEffect : null;
      if (w !== null) {
        var O = w.next;
        g = O;
        do {
          if ((g.tag & c) === c) {
            w = void 0;
            var N = g.create, G = g.inst;
            w = N(), G.destroy = w;
          }
          g = g.next;
        } while (g !== O);
      }
    } catch (ie) {
      ht(f, f.return, ie);
    }
  }
  function Ua(c, f, g) {
    try {
      var w = f.updateQueue, O = w !== null ? w.lastEffect : null;
      if (O !== null) {
        var N = O.next;
        w = N;
        do {
          if ((w.tag & c) === c) {
            var G = w.inst, ie = G.destroy;
            if (ie !== void 0) {
              G.destroy = void 0, O = f;
              var oe = g;
              try {
                ie();
              } catch (De) {
                ht(O, oe, De);
              }
            }
          }
          w = w.next;
        } while (w !== N);
      }
    } catch (De) {
      ht(f, f.return, De);
    }
  }
  function R1(c) {
    var f = c.updateQueue;
    if (f !== null) {
      var g = c.stateNode;
      try {
        wt(f, g);
      } catch (w) {
        ht(c, c.return, w);
      }
    }
  }
  function hu(c, f, g) {
    g.props = mi(c.type, c.memoizedProps), g.state = c.memoizedState;
    try {
      g.componentWillUnmount();
    } catch (w) {
      ht(c, f, w);
    }
  }
  function hl(c, f) {
    try {
      var g = c.ref;
      if (g !== null) {
        var w = c.stateNode;
        switch (c.tag) {
          case 26:
          case 27:
          case 5:
            var O = Ts(w);
            break;
          default:
            O = w;
        }
        typeof g == "function" ? c.refCleanup = g(O) : g.current = O;
      }
    } catch (N) {
      ht(c, f, N);
    }
  }
  function Mi(c, f) {
    var g = c.ref, w = c.refCleanup;
    if (g !== null) if (typeof w == "function") try {
      w();
    } catch (O) {
      ht(c, f, O);
    } finally {
      c.refCleanup = null, (c = c.alternate) != null && (c.refCleanup = null);
    }
    else if (typeof g == "function") try {
      g(null);
    } catch (O) {
      ht(c, f, O);
    }
    else g.current = null;
  }
  function Xh(c) {
    var f = c.type, g = c.memoizedProps, w = c.stateNode;
    try {
      re(w, f, g, c);
    } catch (O) {
      ht(c, c.return, O);
    }
  }
  function Ui(c) {
    return c.tag === 5 || c.tag === 3 || c.tag === 4;
  }
  function Xn(c) {
    e: for (; ; ) {
      for (; c.sibling === null; ) {
        if (c.return === null || Ui(c.return)) return null;
        c = c.return;
      }
      for (c.sibling.return = c.return, c = c.sibling; c.tag !== 5 && c.tag !== 6 && c.tag !== 18; ) {
        if (2 & c.flags || c.child === null || c.tag === 4) continue e;
        c.child.return = c, c = c.child;
      }
      if (!(2 & c.flags)) return c.stateNode;
    }
  }
  function Vc(c, f, g) {
    var w = c.tag;
    if (w === 5 || w === 6) c = c.stateNode, f ? je(g, c, f) : M(g, c);
    else if (w !== 4 && !Tu && (c = c.child) !== null) for (Vc(c, f, g), c = c.sibling; c !== null; ) Vc(c, f, g), c = c.sibling;
  }
  function jc(c, f, g) {
    var w = c.tag;
    if (w === 5 || w === 6) c = c.stateNode, f ? Ie(g, c, f) : P(g, c);
    else if (w !== 4 && !Tu && (c = c.child) !== null) for (jc(c, f, g), c = c.sibling; c !== null; ) jc(c, f, g), c = c.sibling;
  }
  function P1(c, f, g) {
    var w = g.flags;
    switch (g.tag) {
      case 0:
      case 11:
      case 15:
        ws(c, g), 4 & w && dl(5, g);
        break;
      case 1:
        if (ws(c, g), 4 & w) if (c = g.stateNode, f === null) try {
          c.componentDidMount();
        } catch (ie) {
          ht(g, g.return, ie);
        }
        else {
          var O = mi(g.type, f.memoizedProps);
          f = f.memoizedState;
          try {
            c.componentDidUpdate(O, f, c.__reactInternalSnapshotBeforeUpdate);
          } catch (ie) {
            ht(g, g.return, ie);
          }
        }
        64 & w && R1(g), 512 & w && hl(g, g.return);
        break;
      case 3:
        if (ws(c, g), 64 & w && (w = g.updateQueue) !== null) {
          if (c = null, g.child !== null) switch (g.child.tag) {
            case 27:
            case 5:
              c = Ts(g.child.stateNode);
              break;
            case 1:
              c = g.child.stateNode;
          }
          try {
            wt(w, c);
          } catch (ie) {
            ht(g, g.return, ie);
          }
        }
        break;
      case 26:
      case 27:
      case 5:
        ws(c, g), f === null && 4 & w && Xh(g), 512 & w && hl(g, g.return);
        break;
      case 12:
      case 13:
      default:
        ws(c, g);
        break;
      case 22:
        if (!(O = g.memoizedState !== null || Ms)) {
          f = f !== null && f.memoizedState !== null || ei;
          var N = Ms, G = ei;
          Ms = O, (ei = f) && !G ? _s(c, g, (8772 & g.subtreeFlags) != 0) : ws(c, g), Ms = N, ei = G;
        }
        512 & w && (g.memoizedProps.mode === "manual" ? hl(g, g.return) : Mi(g, g.return));
    }
  }
  function I1(c) {
    var f = c.alternate;
    f !== null && (c.alternate = null, I1(f)), c.child = null, c.deletions = null, c.sibling = null, c.tag === 5 && (f = c.stateNode) !== null && af(f), c.stateNode = null, c.return = null, c.dependencies = null, c.memoizedProps = null, c.memoizedState = null, c.pendingProps = null, c.stateNode = null, c.updateQueue = null;
  }
  function za(c, f, g) {
    for (g = g.child; g !== null; ) B1(c, f, g), g = g.sibling;
  }
  function B1(c, f, g) {
    switch (g.tag) {
      case 26:
      case 27:
        var w, O;
      case 5:
        ei || Mi(g, f);
      case 6:
        if (w = ti, O = To, ti = null, za(c, f, g), To = O, (ti = w) !== null) if (To) try {
          ur(ti, g.stateNode);
        } catch (N) {
          ht(g, f, N);
        }
        else try {
          vt(ti, g.stateNode);
        } catch (N) {
          ht(g, f, N);
        }
        break;
      case 18:
        ti !== null && (To ? p0(ti, g.stateNode) : Pt(ti, g.stateNode));
        break;
      case 4:
        w = ti, O = To, ti = g.stateNode.containerInfo, To = !0, za(c, f, g), ti = w, To = O;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        ei || Ua(2, g, f), ei || Ua(4, g, f), za(c, f, g);
        break;
      case 1:
        ei || (Mi(g, f), typeof (w = g.stateNode).componentWillUnmount == "function" && hu(g, f, w)), za(c, f, g);
        break;
      case 21:
        za(c, f, g);
        break;
      case 22:
        Mi(g, f), ei = (w = ei) || g.memoizedState !== null, za(c, f, g), ei = w;
        break;
      default:
        za(c, f, g);
    }
  }
  function pu(c, f) {
    var g = function(w) {
      switch (w.tag) {
        case 13:
        case 19:
          var O = w.stateNode;
          return O === null && (O = w.stateNode = new n6()), O;
        case 22:
          return (O = (w = w.stateNode)._retryCache) === null && (O = w._retryCache = new n6()), O;
        default:
          throw Error(r(435, w.tag));
      }
    }(c);
    f.forEach(function(w) {
      var O = _u.bind(null, c, w);
      g.has(w) || (g.add(w), w.then(O, O));
    });
  }
  function zi(c, f) {
    var g = f.deletions;
    if (g !== null) for (var w = 0; w < g.length; w++) {
      var O = g[w], N = c, G = f, ie = G;
      e: for (; ie !== null; ) {
        switch (ie.tag) {
          case 27:
          case 5:
            ti = ie.stateNode, To = !1;
            break e;
          case 3:
          case 4:
            ti = ie.stateNode.containerInfo, To = !0;
            break e;
        }
        ie = ie.return;
      }
      if (ti === null) throw Error(r(160));
      B1(N, G, O), ti = null, To = !1, (N = O.alternate) !== null && (N.return = null), O.return = null;
    }
    if (13878 & f.subtreeFlags) for (f = f.child; f !== null; ) L1(f, c), f = f.sibling;
  }
  function L1(c, f) {
    var g = c.alternate, w = c.flags;
    switch (c.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        zi(f, c), xi(c), 4 & w && (Ua(3, c, c.return), dl(3, c), Ua(5, c, c.return));
        break;
      case 1:
        zi(f, c), xi(c), 512 & w && g !== null && Mi(g, g.return), 64 & w && Ms && (c = c.updateQueue) !== null && (w = c.callbacks) !== null && (g = c.shared.hiddenCallbacks, c.shared.hiddenCallbacks = g === null ? w : g.concat(w));
        break;
      case 26:
        var O;
      case 27:
        var N;
      case 5:
        if (zi(f, c), xi(c), 512 & w && g !== null && Mi(g, g.return), 32 & c.flags) {
          f = c.stateNode;
          try {
            C0(f);
          } catch (Ke) {
            ht(c, c.return, Ke);
          }
        }
        4 & w && c.stateNode != null && function(Ke, Qe, We) {
          try {
            Se(Ke.stateNode, Ke.type, We, Qe, Ke);
          } catch (pt) {
            ht(Ke, Ke.return, pt);
          }
        }(c, f = c.memoizedProps, g !== null ? g.memoizedProps : f), 1024 & w && (Zm = !0);
        break;
      case 6:
        if (zi(f, c), xi(c), 4 & w && ji) {
          if (c.stateNode === null) throw Error(r(162));
          w = c.memoizedProps, g = g !== null ? g.memoizedProps : w, f = c.stateNode;
          try {
            H(f, g, w);
          } catch (Ke) {
            ht(c, c.return, Ke);
          }
        }
        break;
      case 3:
        zi(f, c), xi(c), Zm && (Zm = !1, N1(c));
        break;
      case 4:
      case 12:
        zi(f, c), xi(c);
        break;
      case 13:
        zi(f, c), xi(c), 8192 & c.child.flags && c.memoizedState !== null != (g !== null && g.memoizedState !== null) && (Qm = Ps()), 4 & w && (w = c.updateQueue) !== null && (c.updateQueue = null, pu(c, w));
        break;
      case 22:
        512 & w && g !== null && Mi(g, g.return), O = c.memoizedState !== null;
        var G = g !== null && g.memoizedState !== null, ie = Ms, oe = ei;
        if (Ms = ie || O, ei = oe || G, zi(f, c), ei = oe, Ms = ie, xi(c), (f = c.stateNode)._current = c, f._visibility &= -3, f._visibility |= 2 & f._pendingVisibility, 8192 & w && (f._visibility = O ? -2 & f._visibility : 1 | f._visibility, O && (f = Ms || ei, g === null || G || f || bo(c)), c.memoizedProps === null || c.memoizedProps.mode !== "manual")) {
          e: if (g = null, ji) for (f = c; ; ) {
            if (f.tag === 5 || Hr || Tu) {
              if (g === null) {
                G = g = f;
                try {
                  N = G.stateNode, O ? Jn(N) : Qn(G.stateNode, G.memoizedProps);
                } catch (Ke) {
                  ht(G, G.return, Ke);
                }
              }
            } else if (f.tag === 6) {
              if (g === null) {
                G = f;
                try {
                  var De = G.stateNode;
                  O ? Rs(De) : Ce(De, G.memoizedProps);
                } catch (Ke) {
                  ht(G, G.return, Ke);
                }
              }
            } else if ((f.tag !== 22 && f.tag !== 23 || f.memoizedState === null || f === c) && f.child !== null) {
              f.child.return = f, f = f.child;
              continue;
            }
            if (f === c) break e;
            for (; f.sibling === null; ) {
              if (f.return === null || f.return === c) break e;
              g === f && (g = null), f = f.return;
            }
            g === f && (g = null), f.sibling.return = f.return, f = f.sibling;
          }
        }
        4 & w && (w = c.updateQueue) !== null && (g = w.retryQueue) !== null && (w.retryQueue = null, pu(c, g));
        break;
      case 19:
        zi(f, c), xi(c), 4 & w && (w = c.updateQueue) !== null && (c.updateQueue = null, pu(c, w));
        break;
      case 21:
        break;
      default:
        zi(f, c), xi(c);
    }
  }
  function xi(c) {
    var f = c.flags;
    if (2 & f) {
      try {
        if (ji && (!Tu || c.tag !== 27)) {
          e: {
            for (var g = c.return; g !== null; ) {
              if (Ui(g)) {
                var w = g;
                break e;
              }
              g = g.return;
            }
            throw Error(r(160));
          }
          switch (w.tag) {
            case 27:
            case 5:
              var O = w.stateNode;
              32 & w.flags && (C0(O), w.flags &= -33), jc(c, Xn(c), O);
              break;
            case 3:
            case 4:
              var N = w.stateNode.containerInfo;
              Vc(c, Xn(c), N);
              break;
            default:
              throw Error(r(161));
          }
        }
      } catch (G) {
        ht(c, c.return, G);
      }
      c.flags &= -3;
    }
    4096 & f && (c.flags &= -4097);
  }
  function N1(c) {
    if (1024 & c.subtreeFlags) for (c = c.child; c !== null; ) {
      var f = c;
      N1(f), f.tag === 5 && 1024 & f.flags && y(f.stateNode), c = c.sibling;
    }
  }
  function ws(c, f) {
    if (8772 & f.subtreeFlags) for (f = f.child; f !== null; ) P1(c, f.alternate, f), f = f.sibling;
  }
  function bo(c) {
    for (c = c.child; c !== null; ) {
      var f = c;
      switch (f.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Ua(4, f, f.return), bo(f);
          break;
        case 1:
          Mi(f, f.return);
          var g = f.stateNode;
          typeof g.componentWillUnmount == "function" && hu(f, f.return, g), bo(f);
          break;
        case 26:
        case 27:
        case 5:
          Mi(f, f.return), bo(f);
          break;
        case 22:
          Mi(f, f.return), f.memoizedState === null && bo(f);
          break;
        default:
          bo(f);
      }
      c = c.sibling;
    }
  }
  function _s(c, f, g) {
    for (g = g && (8772 & f.subtreeFlags) != 0, f = f.child; f !== null; ) {
      var w = f.alternate, O = c, N = f, G = N.flags;
      switch (N.tag) {
        case 0:
        case 11:
        case 15:
          _s(O, N, g), dl(4, N);
          break;
        case 1:
          if (_s(O, N, g), typeof (O = (w = N).stateNode).componentDidMount == "function") try {
            O.componentDidMount();
          } catch (De) {
            ht(w, w.return, De);
          }
          if ((O = (w = N).updateQueue) !== null) {
            var ie = w.stateNode;
            try {
              var oe = O.shared.hiddenCallbacks;
              if (oe !== null) for (O.shared.hiddenCallbacks = null, O = 0; O < oe.length; O++) Ze(oe[O], ie);
            } catch (De) {
              ht(w, w.return, De);
            }
          }
          g && 64 & G && R1(N), hl(N, N.return);
          break;
        case 26:
        case 27:
        case 5:
          _s(O, N, g), g && w === null && 4 & G && Xh(N), hl(N, N.return);
          break;
        case 12:
        case 13:
        default:
          _s(O, N, g);
          break;
        case 22:
          N.memoizedState === null && _s(O, N, g), hl(N, N.return);
      }
      f = f.sibling;
    }
  }
  function Wc(c, f) {
    var g = null;
    c !== null && c.memoizedState !== null && c.memoizedState.cachePool !== null && (g = c.memoizedState.cachePool.pool), c = null, f.memoizedState !== null && f.memoizedState.cachePool !== null && (c = f.memoizedState.cachePool.pool), c !== g && (c != null && c.refCount++, g != null && Ma(g));
  }
  function mu(c, f) {
    c = null, f.alternate !== null && (c = f.alternate.memoizedState.cache), (f = f.memoizedState.cache) !== c && (f.refCount++, c != null && Ma(c));
  }
  function $a(c, f, g, w) {
    if (10256 & f.subtreeFlags) for (f = f.child; f !== null; ) da(c, f, g, w), f = f.sibling;
  }
  function da(c, f, g, w) {
    var O = f.flags;
    switch (f.tag) {
      case 0:
      case 11:
      case 15:
        $a(c, f, g, w), 2048 & O && dl(9, f);
        break;
      case 3:
        $a(c, f, g, w), 2048 & O && (c = null, f.alternate !== null && (c = f.alternate.memoizedState.cache), (f = f.memoizedState.cache) !== c && (f.refCount++, c != null && Ma(c)));
        break;
      case 12:
        if (2048 & O) {
          $a(c, f, g, w), c = f.stateNode;
          try {
            var N = f.memoizedProps, G = N.id, ie = N.onPostCommit;
            typeof ie == "function" && ie(G, f.alternate === null ? "mount" : "update", c.passiveEffectDuration, -0);
          } catch (oe) {
            ht(f, f.return, oe);
          }
        } else $a(c, f, g, w);
        break;
      case 23:
        break;
      case 22:
        N = f.stateNode, f.memoizedState !== null ? 4 & N._visibility ? $a(c, f, g, w) : yo(c, f) : 4 & N._visibility ? $a(c, f, g, w) : (N._visibility |= 4, xo(c, f, g, w, (10256 & f.subtreeFlags) != 0)), 2048 & O && Wc(f.alternate, f);
        break;
      case 24:
        $a(c, f, g, w), 2048 & O && mu(f.alternate, f);
        break;
      default:
        $a(c, f, g, w);
    }
  }
  function xo(c, f, g, w, O) {
    for (O = O && (10256 & f.subtreeFlags) != 0, f = f.child; f !== null; ) {
      var N = c, G = f, ie = g, oe = w, De = G.flags;
      switch (G.tag) {
        case 0:
        case 11:
        case 15:
          xo(N, G, ie, oe, O), dl(8, G);
          break;
        case 23:
          break;
        case 22:
          var Ke = G.stateNode;
          G.memoizedState !== null ? 4 & Ke._visibility ? xo(N, G, ie, oe, O) : yo(N, G) : (Ke._visibility |= 4, xo(N, G, ie, oe, O)), O && 2048 & De && Wc(G.alternate, G);
          break;
        case 24:
          xo(N, G, ie, oe, O), O && 2048 & De && mu(G.alternate, G);
          break;
        default:
          xo(N, G, ie, oe, O);
      }
      f = f.sibling;
    }
  }
  function yo(c, f) {
    if (10256 & f.subtreeFlags) for (f = f.child; f !== null; ) {
      var g = c, w = f, O = w.flags;
      switch (w.tag) {
        case 22:
          yo(g, w), 2048 & O && Wc(w.alternate, w);
          break;
        case 24:
          yo(g, w), 2048 & O && mu(w.alternate, w);
          break;
        default:
          yo(g, w);
      }
      f = f.sibling;
    }
  }
  function pl(c) {
    if (c.subtreeFlags & wf) for (c = c.child; c !== null; ) Hc(c), c = c.sibling;
  }
  function Hc(c) {
    switch (c.tag) {
      case 26:
        pl(c), c.flags & wf && (c.memoizedState !== null ? Co(bF, c.memoizedState, c.memoizedProps) : ad(c.type, c.memoizedProps));
        break;
      case 5:
        pl(c), c.flags & wf && ad(c.type, c.memoizedProps);
        break;
      case 3:
      case 4:
        var f;
        pl(c);
        break;
      case 22:
        c.memoizedState === null && ((f = c.alternate) !== null && f.memoizedState !== null ? (f = wf, wf = 16777216, pl(c), wf = f) : pl(c));
        break;
      default:
        pl(c);
    }
  }
  function Kh(c) {
    var f = c.alternate;
    if (f !== null && (c = f.child) !== null) {
      f.child = null;
      do
        f = c.sibling, c.sibling = null, c = f;
      while (c !== null);
    }
  }
  function gu(c) {
    var f = c.deletions;
    if (16 & c.flags) {
      if (f !== null) for (var g = 0; g < f.length; g++) {
        var w = f[g];
        ln = w, ml(w, c);
      }
      Kh(c);
    }
    if (10256 & c.subtreeFlags) for (c = c.child; c !== null; ) M1(c), c = c.sibling;
  }
  function M1(c) {
    switch (c.tag) {
      case 0:
      case 11:
      case 15:
        gu(c), 2048 & c.flags && Ua(9, c, c.return);
        break;
      case 3:
      case 12:
      default:
        gu(c);
        break;
      case 22:
        var f = c.stateNode;
        c.memoizedState !== null && 4 & f._visibility && (c.return === null || c.return.tag !== 13) ? (f._visibility &= -5, qc(c)) : gu(c);
    }
  }
  function qc(c) {
    var f = c.deletions;
    if (16 & c.flags) {
      if (f !== null) for (var g = 0; g < f.length; g++) {
        var w = f[g];
        ln = w, ml(w, c);
      }
      Kh(c);
    }
    for (c = c.child; c !== null; ) {
      switch ((f = c).tag) {
        case 0:
        case 11:
        case 15:
          Ua(8, f, f.return), qc(f);
          break;
        case 22:
          4 & (g = f.stateNode)._visibility && (g._visibility &= -5, qc(f));
          break;
        default:
          qc(f);
      }
      c = c.sibling;
    }
  }
  function ml(c, f) {
    for (; ln !== null; ) {
      var g = ln;
      switch (g.tag) {
        case 0:
        case 11:
        case 15:
          Ua(8, g, f);
          break;
        case 23:
        case 22:
          if (g.memoizedState !== null && g.memoizedState.cachePool !== null) {
            var w = g.memoizedState.cachePool.pool;
            w != null && w.refCount++;
          }
          break;
        case 24:
          Ma(g.memoizedState.cache);
      }
      if ((w = g.child) !== null) w.return = g, ln = w;
      else e: for (g = c; ln !== null; ) {
        var O = (w = ln).sibling, N = w.return;
        if (I1(w), w === g) {
          ln = null;
          break e;
        }
        if (O !== null) {
          O.return = N, ln = O;
          break e;
        }
        ln = N;
      }
    }
  }
  function $i() {
    return 2 & Or && T0 !== 0 ? T0 & -T0 : $t.T !== null ? Fu !== 0 ? Fu : Me() : Os();
  }
  function U1() {
    ma === 0 && (ma = !(536870912 & T0) || fF ? A() : 536870912);
    var c = Ls.current;
    return c !== null && (c.flags |= 32), ma;
  }
  function Kn(c, f, g) {
    (c === tr && Ar === 2 || c.cancelPendingCommit !== null) && (As(c, 0), Va(c, T0, ma)), E(c, g), 2 & Or && c === tr || (c === tr && (!(2 & Or) && (_l |= g), zr === 4 && Va(c, T0, ma)), se(c));
  }
  function z1(c, f, g) {
    if (6 & Or) throw Error(r(327));
    var w = (g = !g && (60 & f) == 0 && (f & c.expiredLanes) == 0) ? function(oe, De) {
      var Ke = Or;
      Or |= 2;
      var Qe = Jh(), We = vu();
      tr === oe && T0 === De || (m2 = null, eg = Ps() + 500, As(oe, De));
      e: for (; ; ) try {
        if (Ar !== 0 && r0 !== null) {
          De = r0;
          var pt = Ya;
          t: switch (Ar) {
            case 1:
            case 6:
              Ar = 0, Ya = null, Es(oe, De, pt);
              break;
            case 2:
              if (W(pt)) {
                Ar = 0, Ya = null, wo(De);
                break;
              }
              De = function() {
                Ar === 2 && tr === oe && (Ar = 7), se(oe);
              }, pt.then(De, De);
              break e;
            case 3:
              Ar = 7;
              break e;
            case 4:
              Ar = 5;
              break e;
            case 7:
              W(pt) ? (Ar = 0, Ya = null, wo(De)) : (Ar = 0, Ya = null, Es(oe, De, pt));
              break;
            case 5:
              var cr = null;
              switch (r0.tag) {
                case 26:
                  cr = r0.memoizedState;
                case 5:
                case 27:
                  var _e = r0, Ae = _e.type, ke = _e.pendingProps;
                  if (cr ? x0(cr) : id(Ae, ke)) {
                    Ar = 0, Ya = null;
                    var He = _e.sibling;
                    if (He !== null) r0 = He;
                    else {
                      var It = _e.return;
                      It !== null ? (r0 = It, bu(It)) : r0 = null;
                    }
                    break t;
                  }
              }
              Ar = 0, Ya = null, Es(oe, De, pt);
              break;
            case 8:
              j1(), zr = 6;
              break e;
            default:
              throw Error(r(462));
          }
        }
        yi();
        break;
      } catch (X0) {
        W1(oe, X0);
      }
      return Un(), $t.H = Qe, $t.A = We, Or = Ke, r0 !== null ? 0 : (tr = null, T0 = 0, B(), zr);
    }(c, f) : lr(c, f);
    if (w !== 0) for (var O = g; ; ) {
      if (w === 6) Va(c, f, 0);
      else {
        if (g = c.current.alternate, O && !V1(g)) {
          w = lr(c, f), O = !1;
          continue;
        }
        if (w === 2) {
          if (O = f, c.errorRecoveryDisabledLanes & O) var N = 0;
          else N = (N = -536870913 & c.pendingLanes) != 0 ? N : 536870912 & N ? 536870912 : 0;
          if (N !== 0) {
            f = N;
            e: {
              var G = c;
              w = pd;
              var ie = rd;
              if (ie && (As(G, N).flags |= 256), (N = lr(G, N)) !== 2) {
                if (Xm && !ie) {
                  G.errorRecoveryDisabledLanes |= O, _l |= O, w = 4;
                  break e;
                }
                O = Fo, Fo = w, O !== null && Yc(O);
              }
              w = N;
            }
            if (O = !1, w !== 2) continue;
          }
        }
        if (w === 1) {
          As(c, 0), Va(c, f, 0);
          break;
        }
        e: {
          switch (O = c, w) {
            case 0:
            case 1:
              throw Error(r(345));
            case 4:
              if ((4194176 & f) === f) {
                Va(O, f, ma);
                break e;
              }
              break;
            case 2:
              Fo = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(r(329));
          }
          if (O.finishedWork = g, O.finishedLanes = f, (62914560 & f) === f && 10 < (w = Qm + 300 - Ps())) {
            if (Va(O, f, ma), b(O, 0) !== 0) break e;
            O.timeoutHandle = td($1.bind(null, O, g, Fo, m2, Jm, f, ma, _l, hd, p2, 2, -0, 0), w);
          } else $1(O, g, Fo, m2, Jm, f, ma, _l, hd, p2, 0, -0, 0);
        }
      }
      break;
    }
    se(c);
  }
  function Yc(c) {
    Fo === null ? Fo = c : Fo.push.apply(Fo, c);
  }
  function $1(c, f, g, w, O, N, G, ie, oe, De, Ke, Qe, We) {
    if ((8192 & (De = f.subtreeFlags) || (16785408 & De) == 16785408) && (of(), Hc(f), (f = Om()) !== null)) return c.cancelPendingCommit = f(yu.bind(null, c, g, w, O, G, ie, oe, 1, Qe, We)), void Va(c, N, G);
    yu(c, g, w, O, G);
  }
  function V1(c) {
    for (var f = c; ; ) {
      var g = f.tag;
      if ((g === 0 || g === 11 || g === 15) && 16384 & f.flags && (g = f.updateQueue) !== null && (g = g.stores) !== null) for (var w = 0; w < g.length; w++) {
        var O = g[w], N = O.getSnapshot;
        O = O.value;
        try {
          if (!Wi(N(), O)) return !1;
        } catch {
          return !1;
        }
      }
      if (g = f.child, 16384 & f.subtreeFlags && g !== null) g.return = f, f = g;
      else {
        if (f === c) break;
        for (; f.sibling === null; ) {
          if (f.return === null || f.return === c) return !0;
          f = f.return;
        }
        f.sibling.return = f.return, f = f.sibling;
      }
    }
    return !0;
  }
  function Va(c, f, g) {
    f &= ~Km, f &= ~_l, c.suspendedLanes |= f, c.pingedLanes &= ~f;
    for (var w = c.expirationTimes, O = f; 0 < O; ) {
      var N = 31 - bl(O), G = 1 << N;
      w[N] = -1, O &= ~G;
    }
    g !== 0 && C(c, g, f);
  }
  function j1() {
    if (r0 !== null) {
      if (Ar === 0) var c = r0.return;
      else c = r0, Un(), Br(c), pf = null, cd = 0, c = r0;
      for (; c !== null; ) O1(c.alternate, c), c = c.return;
      r0 = null;
    }
  }
  function As(c, f) {
    c.finishedWork = null, c.finishedLanes = 0;
    var g = c.timeoutHandle;
    g !== vl && (c.timeoutHandle = vl, Ds(g)), (g = c.cancelPendingCommit) !== null && (c.cancelPendingCommit = null, g()), j1(), tr = c, r0 = g = Vi(c.current, null), T0 = f, Ar = 0, Ya = null, Xm = p2 = !1, hd = ma = Km = _l = zs = zr = 0, Fo = pd = null, Jm = !1, 8 & f && (f |= 32 & f);
    var w = c.entangledLanes;
    if (w !== 0) for (c = c.entanglements, w &= f; 0 < w; ) {
      var O = 31 - bl(w), N = 1 << O;
      f |= c[O], w &= ~N;
    }
    return Us = f, B(), g;
  }
  function W1(c, f) {
    Zt = null, $t.H = ko, f === ld ? (f = me(), Ar = H1() && !(134217727 & zs) && !(134217727 & _l) ? 2 : 3) : f === e6 ? (f = me(), Ar = 4) : Ar = f === t6 ? 8 : f !== null && typeof f == "object" && typeof f.then == "function" ? 6 : 1, Ya = f, r0 === null && (zr = 1, gi(c, R(f, c.current)));
  }
  function H1() {
    var c = Ls.current;
    return c === null || ((4194176 & T0) === T0 ? Ns === null : ((62914560 & T0) === T0 || (536870912 & T0) != 0) && c === Ns);
  }
  function Jh() {
    var c = $t.H;
    return $t.H = ko, c === null ? ko : c;
  }
  function vu() {
    var c = $t.A;
    return $t.A = xF, c;
  }
  function Gc() {
    zr = 4, !(134217727 & zs) && !(134217727 & _l) || tr === null || Va(tr, T0, ma);
  }
  function lr(c, f) {
    var g = Or;
    Or |= 2;
    var w = Jh(), O = vu();
    tr === c && T0 === f || (m2 = null, As(c, f)), f = !1;
    e: for (; ; ) try {
      if (Ar !== 0 && r0 !== null) {
        var N = r0, G = Ya;
        switch (Ar) {
          case 8:
            j1(), zr = 6;
            break e;
          case 3:
          case 2:
            f || Ls.current !== null || (f = !0);
          default:
            Ar = 0, Ya = null, Es(c, N, G);
        }
      }
      q1();
      break;
    } catch (ie) {
      W1(c, ie);
    }
    if (f && c.shellSuspendCounter++, Un(), Or = g, $t.H = w, $t.A = O, r0 !== null) throw Error(r(261));
    return tr = null, T0 = 0, B(), zr;
  }
  function q1() {
    for (; r0 !== null; ) wi(r0);
  }
  function yi() {
    for (; r0 !== null && !aF(); ) wi(r0);
  }
  function wi(c) {
    var f = fa(c.alternate, c, Us);
    c.memoizedProps = c.pendingProps, f === null ? bu(c) : r0 = f;
  }
  function wo(c) {
    var f = c, g = f.alternate;
    switch (f.tag) {
      case 15:
      case 0:
        f = bs(g, f, f.pendingProps, f.type, void 0, T0);
        break;
      case 11:
        f = bs(g, f, f.pendingProps, f.type.render, f.ref, T0);
        break;
      case 5:
        Br(f);
      default:
        O1(g, f), f = fa(g, f = r0 = Kc(f, Us), Us);
    }
    c.memoizedProps = c.pendingProps, f === null ? bu(c) : r0 = f;
  }
  function Es(c, f, g) {
    Un(), Br(f), pf = null, cd = 0;
    var w = f.return;
    try {
      if (function(O, N, G, ie, oe) {
        if (G.flags |= 32768, ie !== null && typeof ie == "object" && typeof ie.then == "function") {
          if ((N = G.alternate) !== null && zn(N, G, oe, !0), (G = Ls.current) !== null) {
            switch (G.tag) {
              case 13:
                return Ns === null ? Gc() : G.alternate === null && zr === 0 && (zr = 3), G.flags &= -257, G.flags |= 65536, G.lanes = oe, ie === Vm ? G.flags |= 16384 : ((N = G.updateQueue) === null ? G.updateQueue = /* @__PURE__ */ new Set([ie]) : N.add(ie), an(O, ie, oe)), !1;
              case 22:
                return G.flags |= 65536, ie === Vm ? G.flags |= 16384 : ((N = G.updateQueue) === null ? (N = { transitions: null, markerInstances: null, retryQueue: /* @__PURE__ */ new Set([ie]) }, G.updateQueue = N) : (G = N.retryQueue) === null ? N.retryQueue = /* @__PURE__ */ new Set([ie]) : G.add(ie), an(O, ie, oe)), !1;
            }
            throw Error(r(435, G.tag));
          }
          return an(O, ie, oe), Gc(), !1;
        }
        var De = Error(r(520), { cause: ie });
        if (De = R(De, G), pd === null ? pd = [De] : pd.push(De), zr !== 4 && (zr = 2), N === null) return !0;
        ie = R(ie, G), G = N;
        do {
          switch (G.tag) {
            case 3:
              return G.flags |= 65536, O = oe & -oe, G.lanes |= O, Ge(G, O = vi(G.stateNode, ie, O)), !1;
            case 1:
              if (N = G.type, De = G.stateNode, (128 & G.flags) == 0 && (typeof N.getDerivedStateFromError == "function" || De !== null && typeof De.componentDidCatch == "function" && (Al === null || !Al.has(De)))) return G.flags |= 65536, oe &= -oe, G.lanes |= oe, la(oe = Ia(oe), O, G, ie), Ge(G, oe), !1;
          }
          G = G.return;
        } while (G !== null);
        return !1;
      }(c, w, f, g, T0)) return zr = 1, gi(c, R(g, c.current)), void (r0 = null);
    } catch (O) {
      if (w !== null) throw r0 = w, O;
      return zr = 1, gi(c, R(g, c.current)), void (r0 = null);
    }
    32768 & f.flags ? xu(f, !0) : bu(f);
  }
  function bu(c) {
    var f = c;
    do {
      if (32768 & f.flags) return void xu(f, p2);
      c = f.return;
      var g = Gh(f.alternate, f, Us);
      if (g !== null) return void (r0 = g);
      if ((f = f.sibling) !== null) return void (r0 = f);
      r0 = f = c;
    } while (f !== null);
    zr === 0 && (zr = 5);
  }
  function xu(c, f) {
    do {
      var g = Zh(c.alternate, c);
      if (g !== null) return g.flags &= 32767, void (r0 = g);
      if ((g = c.return) !== null && (g.flags |= 32768, g.subtreeFlags = 0, g.deletions = null), !f && (c = c.sibling) !== null) return void (r0 = c);
      r0 = c = g;
    } while (c !== null);
    zr = 6, r0 = null;
  }
  function yu(c, f, g, w, O, N, G, ie, oe, De) {
    var Ke = $t.T, Qe = ku();
    try {
      So(2), $t.T = null, function(We, pt, cr, _e, Ae, ke) {
        do
          St();
        while (Iu !== null);
        if (6 & Or) throw Error(r(327));
        var He = We.finishedWork;
        if (_e = We.finishedLanes, He === null) return null;
        if (We.finishedWork = null, We.finishedLanes = 0, He === We.current) throw Error(r(177));
        We.callbackNode = null, We.callbackPriority = 0, We.cancelPendingCommit = null;
        var It = He.lanes | He.childLanes;
        if (function(zt, i0, $0, _n) {
          var Gr = zt.pendingLanes;
          zt.pendingLanes = $0, zt.suspendedLanes = 0, zt.pingedLanes = 0, zt.warmLanes = 0, zt.expiredLanes &= $0, zt.entangledLanes &= $0, zt.errorRecoveryDisabledLanes &= $0, zt.shellSuspendCounter = 0, i0 = zt.entanglements;
          var fr = zt.expirationTimes, Ot = zt.hiddenUpdates;
          for ($0 = Gr & ~$0; 0 < $0; ) {
            var Xt = 31 - bl($0);
            Gr = 1 << Xt, i0[Xt] = 0, fr[Xt] = -1;
            var Rr = Ot[Xt];
            if (Rr !== null) for (Ot[Xt] = null, Xt = 0; Xt < Rr.length; Xt++) {
              var m0 = Rr[Xt];
              m0 !== null && (m0.lane &= -536870913);
            }
            $0 &= ~Gr;
          }
          _n !== 0 && C(zt, _n, 0);
        }(We, _e, It |= Nm, ke), We === tr && (r0 = tr = null, T0 = 0), !(10256 & He.subtreeFlags) && !(10256 & He.flags) || g2 || (g2 = !0, tg = It, rg = cr, Bm(Zx, function() {
          return St(), null;
        })), cr = (15990 & He.flags) != 0, (15990 & He.subtreeFlags) != 0 || cr) {
          cr = $t.T, $t.T = null, ke = ku(), So(2);
          var X0 = Or;
          Or |= 4, function(zt, i0) {
            for (Fs(zt.containerInfo), ln = i0; ln !== null; ) if (i0 = (zt = ln).child, (1028 & zt.subtreeFlags) != 0 && i0 !== null) i0.return = zt, ln = i0;
            else for (; ln !== null; ) {
              var $0 = (zt = ln).alternate;
              switch (i0 = zt.flags, zt.tag) {
                case 0:
                case 11:
                case 15:
                case 5:
                case 26:
                case 27:
                case 6:
                case 4:
                case 17:
                  break;
                case 1:
                  if (1024 & i0 && $0 !== null) {
                    i0 = void 0;
                    var _n = zt, Gr = $0.memoizedProps;
                    $0 = $0.memoizedState;
                    var fr = _n.stateNode;
                    try {
                      var Ot = mi(_n.type, Gr, (_n.elementType, _n.type));
                      i0 = fr.getSnapshotBeforeUpdate(Ot, $0), fr.__reactInternalSnapshotBeforeUpdate = i0;
                    } catch (Xt) {
                      ht(_n, _n.return, Xt);
                    }
                  }
                  break;
                case 3:
                  1024 & i0 && ji && we(zt.stateNode.containerInfo);
                  break;
                default:
                  if (1024 & i0) throw Error(r(163));
              }
              if ((i0 = zt.sibling) !== null) {
                i0.return = zt.return, ln = i0;
                break;
              }
              ln = zt.return;
            }
            Ot = i6, i6 = !1;
          }(We, He), L1(He, We), Fm(We.containerInfo), We.current = He, P1(We, He.alternate, He), oF(), Or = X0, So(ke), $t.T = cr;
        } else We.current = He;
        if (g2 ? (g2 = !1, Iu = We, md = _e) : Zc(We, It), (It = We.pendingLanes) === 0 && (Al = null), He.stateNode, se(We), pt !== null) for (Ae = We.onRecoverableError, He = 0; He < pt.length; He++) Ae((It = pt[He]).value, { componentStack: It.stack });
        3 & md && St(), It = We.pendingLanes, 4194218 & _e && 42 & It ? We === ng ? gd++ : (gd = 0, ng = We) : gd = 0, ae(0);
      }(c, f, g, w, Qe, O);
    } finally {
      $t.T = Ke, So(Qe);
    }
  }
  function Zc(c, f) {
    (c.pooledCacheLanes &= f) == 0 && (f = c.pooledCache) != null && (c.pooledCache = null, Ma(f));
  }
  function St() {
    if (Iu !== null) {
      var c = Iu, f = tg;
      tg = 0;
      var g = _(md), w = 32 > g ? 32 : g;
      g = $t.T;
      var O = ku();
      try {
        if (So(w), $t.T = null, Iu === null) var N = !1;
        else {
          w = rg, rg = null;
          var G = Iu, ie = md;
          if (Iu = null, md = 0, (6 & Or) != 0) throw Error(r(331));
          var oe = Or;
          Or |= 4, M1(G.current), da(G, G.current, ie, w), Or = oe, ae(0), Xx && Xx.onPostCommitFiberRoot, N = !0;
        }
        return N;
      } finally {
        So(O), $t.T = g, Zc(c, f);
      }
    }
    return !1;
  }
  function $n(c, f, g) {
    f = R(g, f), (c = be(c, f = vi(c.stateNode, f, 2), 2)) !== null && (E(c, 2), se(c));
  }
  function ht(c, f, g) {
    if (c.tag === 3) $n(c, c, g);
    else for (; f !== null; ) {
      if (f.tag === 3) {
        $n(f, c, g);
        break;
      }
      if (f.tag === 1) {
        var w = f.stateNode;
        if (typeof f.type.getDerivedStateFromError == "function" || typeof w.componentDidCatch == "function" && (Al === null || !Al.has(w))) {
          c = R(g, c), (w = be(f, g = Ia(2), 2)) !== null && (la(g, w, f, c), E(w, 2), se(w));
          break;
        }
      }
      f = f.return;
    }
  }
  function an(c, f, g) {
    var w = c.pingCache;
    if (w === null) {
      w = c.pingCache = new yF();
      var O = /* @__PURE__ */ new Set();
      w.set(f, O);
    } else (O = w.get(f)) === void 0 && (O = /* @__PURE__ */ new Set(), w.set(f, O));
    O.has(g) || (Xm = !0, O.add(g), c = Mr.bind(null, c, f, g), f.then(c, c));
  }
  function Mr(c, f, g) {
    var w = c.pingCache;
    w !== null && w.delete(f), c.pingedLanes |= c.suspendedLanes & g, c.warmLanes &= ~g, tr === c && (T0 & g) === g && (zr === 4 || zr === 3 && (62914560 & T0) === T0 && 300 > Ps() - Qm ? !(2 & Or) && As(c, 0) : Km |= g, hd === T0 && (hd = 0)), se(c);
  }
  function wu(c, f) {
    f === 0 && (f = T()), (c = Z(c, f)) !== null && (E(c, f), se(c));
  }
  function ja(c) {
    var f = c.memoizedState, g = 0;
    f !== null && (g = f.retryLane), wu(c, g);
  }
  function _u(c, f) {
    var g = 0;
    switch (c.tag) {
      case 13:
        var w = c.stateNode, O = c.memoizedState;
        O !== null && (g = O.retryLane);
        break;
      case 19:
        w = c.stateNode;
        break;
      case 22:
        w = c.stateNode._retryCache;
        break;
      default:
        throw Error(r(314));
    }
    w !== null && w.delete(f), wu(c, g);
  }
  function Xc(c, f, g, w) {
    this.tag = c, this.key = g, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = f, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = w, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Ss(c) {
    return !(!(c = c.prototype) || !c.isReactComponent);
  }
  function Vi(c, f) {
    var g = c.alternate;
    return g === null ? ((g = e(c.tag, f, c.key, c.mode)).elementType = c.elementType, g.type = c.type, g.stateNode = c.stateNode, g.alternate = c, c.alternate = g) : (g.pendingProps = f, g.type = c.type, g.flags = 0, g.subtreeFlags = 0, g.deletions = null), g.flags = 31457280 & c.flags, g.childLanes = c.childLanes, g.lanes = c.lanes, g.child = c.child, g.memoizedProps = c.memoizedProps, g.memoizedState = c.memoizedState, g.updateQueue = c.updateQueue, f = c.dependencies, g.dependencies = f === null ? null : { lanes: f.lanes, firstContext: f.firstContext }, g.sibling = c.sibling, g.index = c.index, g.ref = c.ref, g.refCleanup = c.refCleanup, g;
  }
  function Kc(c, f) {
    c.flags &= 31457282;
    var g = c.alternate;
    return g === null ? (c.childLanes = 0, c.lanes = f, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null) : (c.childLanes = g.childLanes, c.lanes = g.lanes, c.child = g.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = g.memoizedProps, c.memoizedState = g.memoizedState, c.updateQueue = g.updateQueue, c.type = g.type, f = g.dependencies, c.dependencies = f === null ? null : { lanes: f.lanes, firstContext: f.firstContext }), c;
  }
  function Au(c, f, g, w, O, N) {
    var G = 0;
    if (w = c, typeof c == "function") Ss(c) && (G = 1);
    else if (typeof c == "string") G = 5;
    else e: switch (c) {
      case Ha:
        return ft(g.children, O, N, f);
      case wn:
        G = 8, O |= 24;
        break;
      case Qc:
        return (c = e(12, g, f, 2 | O)).elementType = Qc, c.lanes = N, c;
      case tf:
        return (c = e(13, g, f, O)).elementType = tf, c.lanes = N, c;
      case rf:
        return (c = e(19, g, f, O)).elementType = rf, c.lanes = N, c;
      case Qh:
        return Eu(g, O, N, f);
      default:
        if (typeof c == "object" && c !== null) switch (c.$$typeof) {
          case G1:
          case jn:
            G = 10;
            break e;
          case Z1:
            G = 9;
            break e;
          case ef:
            G = 11;
            break e;
          case gl:
            G = 14;
            break e;
          case Eo:
            G = 16, w = null;
            break e;
        }
        G = 29, g = Error(r(130, c === null ? "null" : typeof c, "")), w = null;
    }
    return (f = e(G, g, f, O)).elementType = c, f.type = w, f.lanes = N, f;
  }
  function ft(c, f, g, w) {
    return (c = e(7, c, w, f)).lanes = g, c;
  }
  function Eu(c, f, g, w) {
    (c = e(22, c, w, f)).elementType = Qh, c.lanes = g;
    var O = { _visibility: 1, _pendingVisibility: 1, _pendingMarkers: null, _retryCache: null, _transitions: null, _current: null, detach: function() {
      var N = O._current;
      if (N === null) throw Error(r(456));
      if (!(2 & O._pendingVisibility)) {
        var G = Z(N, 2);
        G !== null && (O._pendingVisibility |= 2, Kn(G, 0, 2));
      }
    }, attach: function() {
      var N = O._current;
      if (N === null) throw Error(r(456));
      if (2 & O._pendingVisibility) {
        var G = Z(N, 2);
        G !== null && (O._pendingVisibility &= -3, Kn(G, 0, 2));
      }
    } };
    return c.stateNode = O, c;
  }
  function Su(c, f, g) {
    return (c = e(6, c, null, f)).lanes = g, c;
  }
  function ha(c, f, g) {
    return (f = e(4, c.children !== null ? c.children : [], c.key, f)).lanes = g, f.stateNode = { containerInfo: c.containerInfo, pendingChildren: null, implementation: c.implementation }, f;
  }
  function Jc(c, f, g, w, O, N, G, ie) {
    this.tag = 1, this.containerInfo = c, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = vl, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = k(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = k(0), this.hiddenUpdates = k(null), this.identifierPrefix = w, this.onUncaughtError = O, this.onCaughtError = N, this.onRecoverableError = G, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = ie, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function Cu(c, f, g, w, O, N) {
    O = function(G) {
      return G ? G = lf : lf;
    }(O), w.context === null ? w.context = O : w.pendingContext = O, (w = ye(f)).payload = { element: g }, (N = N === void 0 ? null : N) !== null && (w.callback = N), (g = be(c, w, f)) !== null && (Kn(g, 0, f), he(g, c, f));
  }
  var Cs, _o, Wa = {}, Y1 = Ye, on = wne, Vn = Object.assign, ks = Symbol.for("react.element"), _i = Symbol.for("react.transitional.element"), Ao = Symbol.for("react.portal"), Ha = Symbol.for("react.fragment"), wn = Symbol.for("react.strict_mode"), Qc = Symbol.for("react.profiler"), G1 = Symbol.for("react.provider"), Z1 = Symbol.for("react.consumer"), jn = Symbol.for("react.context"), ef = Symbol.for("react.forward_ref"), tf = Symbol.for("react.suspense"), rf = Symbol.for("react.suspense_list"), gl = Symbol.for("react.memo"), Eo = Symbol.for("react.lazy"), Qh = Symbol.for("react.offscreen"), e2 = Symbol.for("react.memo_cache_sentinel"), X1 = Symbol.iterator, K1 = Symbol.for("react.client.reference"), $t = Y1.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, J1 = !1, nf = Array.isArray, Ts = t.getPublicInstance, Tm = t.getRootHostContext, t2 = t.getChildHostContext, Fs = t.prepareForCommit, Fm = t.resetAfterCommit, Dm = t.createInstance, Q1 = t.appendInitialChild, ed = t.finalizeInitialChildren, r2 = t.shouldSetTextContent, qa = t.createTextInstance, td = null, Ds = null, vl = t.noTimeout, ji = !0, rd = null, nd = null, So = t.setCurrentUpdatePriority, ku = t.getCurrentUpdatePriority, Os = t.resolveUpdatePriority, n2 = t.shouldAttemptEagerTransition, af = null;
  t.requestPostPaintCallback;
  var i2 = t.maySuspendCommit, id = null, of = null, ad = null, Om = null, m = null, p = null, y = null, P = t.appendChild, M = t.appendChildToContainer, H = t.commitTextUpdate, re = null, Se = t.commitUpdate, Ie = t.insertBefore, je = null, vt = t.removeChild, ur = t.removeChildFromContainer, C0 = t.resetTextContent, Jn = null, Rs = null, Qn = null, Ce = null, we = t.clearContainer, Fe = null, dt = null, Ft = null, k0 = null, Pt = null, p0 = null, Hr = null, x0 = null, Co = null, Tu = null, Rm = [], sf = -1, lf = {}, bl = Math.clz32 ? Math.clz32 : function(c) {
    return (c >>>= 0) == 0 ? 32 : 31 - (nF(c) / iF | 0) | 0;
  }, nF = Math.log, iF = Math.LN2, Pm = 128, Im = 4194304, Bm = on.unstable_scheduleCallback, Lm = on.unstable_cancelCallback, aF = on.unstable_shouldYield, oF = on.unstable_requestPaint, Ps = on.unstable_now, Gx = on.unstable_ImmediatePriority, sF = on.unstable_UserBlockingPriority, Zx = on.unstable_NormalPriority, lF = on.unstable_IdlePriority, uF = on.log, cF = on.unstable_setDisableYieldValue, Xx = null, Wi = typeof Object.is == "function" ? Object.is : function(c, f) {
    return c === f && (c !== 0 || 1 / c == 1 / f) || c != c && f != f;
  }, Kx = /* @__PURE__ */ new WeakMap(), a2 = [], o2 = 0, Jx = null, uf = [], cf = 0, Qx = null, Is = u(null), od = u(null), s2 = u(null), l2 = u(null), fF = !1, Bs = null;
  Error(r(519));
  var pa = [], ff = 0, Nm = 0, u2 = null, df = null, Mm = !1, c2 = !1, Um = !1, hf = 0, sd = null, zm = 0, Fu = 0, Du = null, xl = !1, $m = !1, dF = Object.prototype.hasOwnProperty, ld = Error(r(460)), e6 = Error(r(474)), Vm = { then: function() {
  } }, ud = null, pf = null, cd = 0, mf = at(!0), hF = at(!1), gf = u(null), f2 = u(0), Ls = u(null), Ns = null, qr = u(0), yl = 0, Zt = null, er = null, Ur = null, d2 = !1, vf = !1, Ou = !1, jm = 0, fd = 0, bf = null, pF = 0, Wm = function() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }, ko = { readContext: o0, use: yt, useCallback: ot, useContext: ot, useEffect: ot, useImperativeHandle: ot, useLayoutEffect: ot, useInsertionEffect: ot, useMemo: ot, useReducer: ot, useRef: ot, useState: ot, useDebugValue: ot, useDeferredValue: ot, useTransition: ot, useSyncExternalStore: ot, useId: ot };
  ko.useCacheRefresh = ot, ko.useMemoCache = ot, ko.useHostTransitionStatus = ot, ko.useFormState = ot, ko.useActionState = ot, ko.useOptimistic = ot;
  var Ru = { readContext: o0, use: yt, useCallback: function(c, f) {
    return Mt().memoizedState = [c, f === void 0 ? null : f], c;
  }, useContext: o0, useEffect: Ii, useImperativeHandle: function(c, f, g) {
    g = g != null ? g.concat([c]) : null, bn(4194308, 4, ho.bind(null, f, c), g);
  }, useLayoutEffect: function(c, f) {
    return bn(4194308, 4, c, f);
  }, useInsertionEffect: function(c, f) {
    bn(4, 2, c, f);
  }, useMemo: function(c, f) {
    var g = Mt();
    f = f === void 0 ? null : f;
    var w = c();
    if (Ou) {
      I(!0);
      try {
        c();
      } finally {
        I(!1);
      }
    }
    return g.memoizedState = [w, f], w;
  }, useReducer: function(c, f, g) {
    var w = Mt();
    if (g !== void 0) {
      var O = g(f);
      if (Ou) {
        I(!0);
        try {
          g(f);
        } finally {
          I(!1);
        }
      }
    } else O = f;
    return w.memoizedState = w.baseState = O, c = { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: c, lastRenderedState: O }, w.queue = c, c = c.dispatch = oa.bind(null, Zt, c), [w.memoizedState, c];
  }, useRef: function(c) {
    return c = { current: c }, Mt().memoizedState = c;
  }, useState: function(c) {
    var f = (c = Gt(c)).queue, g = Oa.bind(null, Zt, f);
    return f.dispatch = g, [c.memoizedState, g];
  }, useDebugValue: Qr, useDeferredValue: function(c, f) {
    return Da(Mt(), c, f);
  }, useTransition: function() {
    var c = Gt(!1);
    return c = po.bind(null, Zt, c.queue, !0, !1), Mt().memoizedState = c, [!1, c];
  }, useSyncExternalStore: function(c, f, g) {
    var w = Zt, O = Mt();
    if (g = f(), tr === null) throw Error(r(349));
    60 & T0 || t0(w, f, g), O.memoizedState = g;
    var N = { value: g, getSnapshot: f };
    return O.queue = N, Ii(E0.bind(null, w, N, c), [c]), w.flags |= 2048, P0(9, Q0.bind(null, w, N, g, f), { destroy: void 0 }, null), g;
  }, useId: function() {
    var c = Mt(), f = tr.identifierPrefix;
    return f = ":" + f + "r" + (pF++).toString(32) + ":", c.memoizedState = f;
  }, useCacheRefresh: function() {
    return Mt().memoizedState = Uc.bind(null, Zt);
  } };
  Ru.useMemoCache = q0, Ru.useHostTransitionStatus = Nn, Ru.useFormState = Ut, Ru.useActionState = Ut, Ru.useOptimistic = function(c) {
    var f = Mt();
    f.memoizedState = f.baseState = c;
    var g = { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: null, lastRenderedState: null };
    return f.queue = g, f = pi.bind(null, Zt, !0, g), g.dispatch = f, [c, f];
  };
  var wl = { readContext: o0, use: yt, useCallback: hi, useContext: o0, useEffect: Yn, useImperativeHandle: aa, useInsertionEffect: fi, useLayoutEffect: di, useMemo: Bi, useReducer: qe, useRef: Bn, useState: function() {
    return qe(L0);
  }, useDebugValue: Qr, useDeferredValue: function(c, f) {
    return en(Rt(), er.memoizedState, c, f);
  }, useTransition: function() {
    var c = qe(L0)[0], f = Rt().memoizedState;
    return [typeof c == "boolean" ? c : tt(c), f];
  }, useSyncExternalStore: Vt, useId: ms };
  wl.useCacheRefresh = Mn, wl.useMemoCache = q0, wl.useHostTransitionStatus = Nn, wl.useFormState = U0, wl.useActionState = U0, wl.useOptimistic = function(c, f) {
    return M0(Rt(), 0, c, f);
  };
  var Pu = { readContext: o0, use: yt, useCallback: hi, useContext: o0, useEffect: Yn, useImperativeHandle: aa, useInsertionEffect: fi, useLayoutEffect: di, useMemo: Bi, useReducer: lt, useRef: Bn, useState: function() {
    return lt(L0);
  }, useDebugValue: Qr, useDeferredValue: function(c, f) {
    var g = Rt();
    return er === null ? Da(g, c, f) : en(g, er.memoizedState, c, f);
  }, useTransition: function() {
    var c = lt(L0)[0], f = Rt().memoizedState;
    return [typeof c == "boolean" ? c : tt(c), f];
  }, useSyncExternalStore: Vt, useId: ms };
  Pu.useCacheRefresh = Mn, Pu.useMemoCache = q0, Pu.useHostTransitionStatus = Nn, Pu.useFormState = Jr, Pu.useActionState = Jr, Pu.useOptimistic = function(c, f) {
    var g = Rt();
    return er !== null ? M0(g, 0, c, f) : (g.baseState = c, [c, g.queue.dispatch]);
  };
  var Hm = { isMounted: function(c) {
    return !!(c = c._reactInternals) && function(f) {
      var g = f, w = f;
      if (f.alternate) for (; g.return; ) g = g.return;
      else {
        f = g;
        do
          4098 & (g = f).flags && (w = g.return), f = g.return;
        while (f);
      }
      return g.tag === 3 ? w : null;
    }(c) === c;
  }, enqueueSetState: function(c, f, g) {
    c = c._reactInternals;
    var w = $i(), O = ye(w);
    O.payload = f, g != null && (O.callback = g), (f = be(c, O, w)) !== null && (Kn(f, 0, w), he(f, c, w));
  }, enqueueReplaceState: function(c, f, g) {
    c = c._reactInternals;
    var w = $i(), O = ye(w);
    O.tag = 1, O.payload = f, g != null && (O.callback = g), (f = be(c, O, w)) !== null && (Kn(f, 0, w), he(f, c, w));
  }, enqueueForceUpdate: function(c, f) {
    c = c._reactInternals;
    var g = $i(), w = ye(g);
    w.tag = 2, f != null && (w.callback = f), (f = be(c, w, g)) !== null && (Kn(f, 0, g), he(f, c, g));
  } };
  typeof reportError == "function" && reportError;
  var t6 = Error(r(461)), sn = !1, qm = { dehydrated: null, treeContext: null, retryLane: 0 }, Ym = u(null), h2 = null, xf = null, Gm = null, mF = typeof AbortController < "u" ? AbortController : function() {
    var c = [], f = this.signal = { aborted: !1, addEventListener: function(g, w) {
      c.push(w);
    } };
    this.abort = function() {
      f.aborted = !0, c.forEach(function(g) {
        return g();
      });
    };
  }, gF = on.unstable_scheduleCallback, vF = on.unstable_NormalPriority, Yr = { $$typeof: jn, Consumer: null, Provider: null, _currentValue: null, _currentValue2: null, _threadCount: 0 }, r6 = $t.S;
  $t.S = function(c, f) {
    typeof f == "object" && f !== null && typeof f.then == "function" && function(g, w) {
      if (sd === null) {
        var O = sd = [];
        zm = 0, Fu = Me(), Du = { status: "pending", value: void 0, then: function(N) {
          O.push(N);
        } };
      }
      zm++, w.then(Ne, Ne);
    }(0, f), r6 !== null && r6(c, f);
  };
  var yf = u(null), Ms = !1, ei = !1, Zm = !1, n6 = typeof WeakSet == "function" ? WeakSet : Set, ln = null, i6 = !1, ti = null, To = !1, bF = null, wf = 8192, xF = { getCacheForType: function(c) {
    var f = o0(Yr), g = f.data.get(c);
    return g === void 0 && (g = c(), f.data.set(c, g)), g;
  } };
  if (typeof Symbol == "function" && Symbol.for) {
    var dd = Symbol.for;
    dd("selector.component"), dd("selector.has_pseudo_class"), dd("selector.role"), dd("selector.test_id"), dd("selector.text");
  }
  var yF = typeof WeakMap == "function" ? WeakMap : Map, Or = 0, tr = null, r0 = null, T0 = 0, Ar = 0, Ya = null, p2 = !1, Xm = !1, Us = 0, zr = 0, zs = 0, _l = 0, Km = 0, ma = 0, hd = 0, pd = null, Fo = null, Jm = !1, Qm = 0, eg = 1 / 0, m2 = null, Al = null, g2 = !1, Iu = null, md = 0, tg = 0, rg = null, gd = 0, ng = null;
  return Wa.createContainer = function(c, f, g, w, O, N, G, ie, oe, De) {
    return function(Ke, Qe, We, pt, cr, _e, Ae, ke, He, It, X0, zt) {
      return Ke = new Jc(Ke, Qe, We, Ae, ke, He, It, null), Qe = 1, _e === !0 && (Qe |= 24), _e = e(3, null, null, Qe), Ke.current = _e, _e.stateNode = Ke, (Qe = rn()).refCount++, Ke.pooledCache = Qe, Qe.refCount++, _e.memoizedState = { element: pt, isDehydrated: We, cache: Qe }, it(_e), Ke;
    }(c, f, !1, null, 0, w, N, G, ie, oe);
  }, Wa.flushSyncWork = function() {
    return (6 & Or) != 0 || (ae(0), !1);
  }, Wa.updateContainer = function(c, f, g, w) {
    var O = f.current, N = $i();
    return Cu(O, N, c, f, g, w), N;
  }, Wa.updateContainerSync = function(c, f, g, w) {
    return f.tag === 0 && St(), Cu(f.current, 2, c, f, g, w), 2;
  }, Wa;
}, H2.exports.default = H2.exports, Object.defineProperty(H2.exports, "__esModule", { value: !0 })), Z9.exports);
var X9;
xne(tF.exports);
var Dl = {};
/**
 * @license React
 * react-reconciler-constants.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
X9 || (X9 = 1, Dl.ConcurrentRoot = 1, Dl.ContinuousEventPriority = 8, Dl.DefaultEventPriority = 32, Dl.DiscreteEventPriority = 2, Dl.IdleEventPriority = 268435456, Dl.LegacyRoot = 0, Dl.NoEventPriority = 0);
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var K9 = Object.getOwnPropertySymbols, _ne = Object.prototype.hasOwnProperty, Ane = Object.prototype.propertyIsEnumerable;
function Ene(t) {
  if (t == null)
    throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(t);
}
function Sne() {
  try {
    if (!Object.assign)
      return !1;
    var t = new String("abc");
    if (t[5] = "de", Object.getOwnPropertyNames(t)[0] === "5")
      return !1;
    for (var e = {}, r = 0; r < 10; r++)
      e["_" + String.fromCharCode(r)] = r;
    var n = Object.getOwnPropertyNames(e).map(function(a) {
      return e[a];
    });
    if (n.join("") !== "0123456789")
      return !1;
    var i = {};
    return "abcdefghijklmnopqrst".split("").forEach(function(a) {
      i[a] = a;
    }), Object.keys(Object.assign({}, i)).join("") === "abcdefghijklmnopqrst";
  } catch {
    return !1;
  }
}
var Cne = Sne() ? Object.assign : function(t, e) {
  for (var r, n = Ene(t), i, a = 1; a < arguments.length; a++) {
    r = Object(arguments[a]);
    for (var o in r)
      _ne.call(r, o) && (n[o] = r[o]);
    if (K9) {
      i = K9(r);
      for (var s = 0; s < i.length; s++)
        Ane.call(r, i[s]) && (n[i[s]] = r[i[s]]);
    }
  }
  return n;
};
const kne = /* @__PURE__ */ On(Cne);
function Tne(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Fne(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, i.get ? i : { enumerable: !0, get: function() {
      return t[n];
    } });
  }), r;
}
var q2, rF = { exports: {} }, Dne = Fne(eF);
/** @license React v0.23.0
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(q2 = rF).exports = function t(e) {
  var r = kne, n = Ye, i = Dne;
  function a(m) {
    for (var p = "https://reactjs.org/docs/error-decoder.html?invariant=" + m, y = 1; y < arguments.length; y++) p += "&args[]=" + encodeURIComponent(arguments[y]);
    return "Minified React error #" + m + "; visit " + p + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var o = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  o.hasOwnProperty("ReactCurrentDispatcher") || (o.ReactCurrentDispatcher = { current: null }), o.hasOwnProperty("ReactCurrentBatchConfig") || (o.ReactCurrentBatchConfig = { suspense: null });
  var s = typeof Symbol == "function" && Symbol.for, l = s ? Symbol.for("react.element") : 60103, u = s ? Symbol.for("react.portal") : 60106, d = s ? Symbol.for("react.fragment") : 60107, h = s ? Symbol.for("react.strict_mode") : 60108, v = s ? Symbol.for("react.profiler") : 60114, b = s ? Symbol.for("react.provider") : 60109, x = s ? Symbol.for("react.context") : 60110, A = s ? Symbol.for("react.concurrent_mode") : 60111, T = s ? Symbol.for("react.forward_ref") : 60112, k = s ? Symbol.for("react.suspense") : 60113, E = s ? Symbol.for("react.suspense_list") : 60120, C = s ? Symbol.for("react.memo") : 60115, D = s ? Symbol.for("react.lazy") : 60116, _ = typeof Symbol == "function" && Symbol.iterator;
  function I(m) {
    return m === null || typeof m != "object" ? null : typeof (m = _ && m[_] || m["@@iterator"]) == "function" ? m : null;
  }
  function R(m) {
    if (m == null) return null;
    if (typeof m == "function") return m.displayName || m.name || null;
    if (typeof m == "string") return m;
    switch (m) {
      case d:
        return "Fragment";
      case u:
        return "Portal";
      case v:
        return "Profiler";
      case h:
        return "StrictMode";
      case k:
        return "Suspense";
      case E:
        return "SuspenseList";
    }
    if (typeof m == "object") switch (m.$$typeof) {
      case x:
        return "Context.Consumer";
      case b:
        return "Context.Provider";
      case T:
        var p = m.render;
        return p = p.displayName || p.name || "", m.displayName || (p !== "" ? "ForwardRef(" + p + ")" : "ForwardRef");
      case C:
        return R(m.type);
      case D:
        if (m = m._status === 1 ? m._result : null) return R(m);
    }
    return null;
  }
  function U(m) {
    var p = m, y = m;
    if (m.alternate) for (; p.return; ) p = p.return;
    else {
      m = p;
      do
        1026 & (p = m).effectTag && (y = p.return), m = p.return;
      while (m);
    }
    return p.tag === 3 ? y : null;
  }
  function V(m) {
    if (U(m) !== m) throw Error(a(188));
  }
  function z(m) {
    var p = m.alternate;
    if (!p) {
      if ((p = U(m)) === null) throw Error(a(188));
      return p !== m ? null : m;
    }
    for (var y = m, P = p; ; ) {
      var M = y.return;
      if (M === null) break;
      var H = M.alternate;
      if (H === null) {
        if ((P = M.return) !== null) {
          y = P;
          continue;
        }
        break;
      }
      if (M.child === H.child) {
        for (H = M.child; H; ) {
          if (H === y) return V(M), m;
          if (H === P) return V(M), p;
          H = H.sibling;
        }
        throw Error(a(188));
      }
      if (y.return !== P.return) y = M, P = H;
      else {
        for (var re = !1, Se = M.child; Se; ) {
          if (Se === y) {
            re = !0, y = M, P = H;
            break;
          }
          if (Se === P) {
            re = !0, P = M, y = H;
            break;
          }
          Se = Se.sibling;
        }
        if (!re) {
          for (Se = H.child; Se; ) {
            if (Se === y) {
              re = !0, y = H, P = M;
              break;
            }
            if (Se === P) {
              re = !0, P = H, y = M;
              break;
            }
            Se = Se.sibling;
          }
          if (!re) throw Error(a(189));
        }
      }
      if (y.alternate !== P) throw Error(a(190));
    }
    if (y.tag !== 3) throw Error(a(188));
    return y.stateNode.current === y ? m : p;
  }
  function j(m) {
    if (!(m = z(m))) return null;
    for (var p = m; ; ) {
      if (p.tag === 5 || p.tag === 6) return p;
      if (p.child) p.child.return = p, p = p.child;
      else {
        if (p === m) break;
        for (; !p.sibling; ) {
          if (!p.return || p.return === m) return null;
          p = p.return;
        }
        p.sibling.return = p.return, p = p.sibling;
      }
    }
    return null;
  }
  var S = e.getPublicInstance, B = e.getRootHostContext, q = e.getChildHostContext, Y = e.prepareForCommit, Z = e.resetAfterCommit, Q = e.createInstance, J = e.appendInitialChild, se = e.finalizeInitialChildren, ae = e.prepareUpdate, te = e.shouldSetTextContent, ne = e.createTextInstance, ce = null, pe = null, Me = e.noTimeout, Ne = !0, it = null, fe = e.appendChild, ye = e.appendChildToContainer, be = e.commitTextUpdate, he = null, Ge = e.commitUpdate, $e = e.insertBefore, Ve = null, Ze = e.removeChild, wt = e.removeChildFromContainer, et = e.resetTextContent, W = null, ee = null, le = null, me = null, Ee = null, ve = null, Te = /^(.*)[\\\/]/;
  function Pe(m) {
    var p = "";
    do {
      e: switch (m.tag) {
        case 3:
        case 4:
        case 6:
        case 7:
        case 10:
        case 9:
          var y = "";
          break e;
        default:
          var P = m._debugOwner, M = m._debugSource, H = R(m.type);
          y = null, P && (y = R(P.type)), P = H, H = "", M ? H = " (at " + M.fileName.replace(Te, "") + ":" + M.lineNumber + ")" : y && (H = " (created by " + y + ")"), y = `
    in ` + (P || "Unknown") + H;
      }
      p += y, m = m.return;
    } while (m);
    return p;
  }
  var at = [], Ue = -1;
  function rt(m) {
    0 > Ue || (m.current = at[Ue], at[Ue] = null, Ue--);
  }
  function gt(m, p) {
    Ue++, at[Ue] = m.current, m.current = p;
  }
  var _t = {}, Bt = { current: _t }, At = { current: !1 }, Tt = _t;
  function Je(m, p) {
    var y = m.type.contextTypes;
    if (!y) return _t;
    var P = m.stateNode;
    if (P && P.__reactInternalMemoizedUnmaskedChildContext === p) return P.__reactInternalMemoizedMaskedChildContext;
    var M, H = {};
    for (M in y) H[M] = p[M];
    return P && ((m = m.stateNode).__reactInternalMemoizedUnmaskedChildContext = p, m.__reactInternalMemoizedMaskedChildContext = H), H;
  }
  function ot(m) {
    return (m = m.childContextTypes) != null;
  }
  function R0(m) {
    rt(At), rt(Bt);
  }
  function b0(m) {
    rt(At), rt(Bt);
  }
  function ir(m, p, y) {
    if (Bt.current !== _t) throw Error(a(168));
    gt(Bt, p), gt(At, y);
  }
  function a0(m, p, y) {
    var P = m.stateNode;
    if (m = p.childContextTypes, typeof P.getChildContext != "function") return y;
    for (var M in P = P.getChildContext()) if (!(M in m)) throw Error(a(108, R(p) || "Unknown", M));
    return r({}, y, {}, P);
  }
  function e0(m) {
    var p = m.stateNode;
    return p = p && p.__reactInternalMemoizedMergedChildContext || _t, Tt = Bt.current, gt(Bt, p), gt(At, At.current), !0;
  }
  function kr(m, p, y) {
    var P = m.stateNode;
    if (!P) throw Error(a(169));
    y ? (p = a0(m, p, Tt), P.__reactInternalMemoizedMergedChildContext = p, rt(At), rt(Bt), gt(Bt, p)) : rt(At), gt(At, y);
  }
  var br = i.unstable_runWithPriority, Br = i.unstable_scheduleCallback, Mt = i.unstable_cancelCallback, Rt = i.unstable_shouldYield, tt = i.unstable_requestPaint, yt = i.unstable_now, q0 = i.unstable_getCurrentPriorityLevel, L0 = i.unstable_ImmediatePriority, qe = i.unstable_UserBlockingPriority, mt = i.unstable_NormalPriority, lt = i.unstable_LowPriority, Vt = i.unstable_IdlePriority, t0 = {}, Q0 = tt !== void 0 ? tt : function() {
  }, E0 = null, S0 = null, N0 = !1, Gt = yt(), M0 = 1e4 > Gt ? yt : function() {
    return yt() - Gt;
  };
  function gn() {
    switch (q0()) {
      case L0:
        return 99;
      case qe:
        return 98;
      case mt:
        return 97;
      case lt:
        return 96;
      case Vt:
        return 95;
      default:
        throw Error(a(332));
    }
  }
  function Pi(m) {
    switch (m) {
      case 99:
        return L0;
      case 98:
        return qe;
      case 97:
        return mt;
      case 96:
        return lt;
      case 95:
        return Vt;
      default:
        throw Error(a(332));
    }
  }
  function xr(m, p) {
    return m = Pi(m), br(m, p);
  }
  function vn(m, p, y) {
    return m = Pi(m), Br(m, p, y);
  }
  function Y0(m) {
    return E0 === null ? (E0 = [m], S0 = Br(L0, Tr)) : E0.push(m), t0;
  }
  function h0() {
    if (S0 !== null) {
      var m = S0;
      S0 = null, Mt(m);
    }
    Tr();
  }
  function Tr() {
    if (!N0 && E0 !== null) {
      N0 = !0;
      var m = 0;
      try {
        var p = E0;
        xr(99, function() {
          for (; m < p.length; m++) {
            var y = p[m];
            do
              y = y(!0);
            while (y !== null);
          }
        }), E0 = null;
      } catch (y) {
        throw E0 !== null && (E0 = E0.slice(m + 1)), Br(L0, h0), y;
      } finally {
        N0 = !1;
      }
    }
  }
  var Ut = 3;
  function U0(m, p, y) {
    return 1073741821 - (1 + ((1073741821 - m + p / 10) / (y /= 10) | 0)) * y;
  }
  var ar = typeof Object.is == "function" ? Object.is : function(m, p) {
    return m === p && (m !== 0 || 1 / m == 1 / p) || m != m && p != p;
  }, ct = Object.prototype.hasOwnProperty;
  function Jr(m, p) {
    if (ar(m, p)) return !0;
    if (typeof m != "object" || m === null || typeof p != "object" || p === null) return !1;
    var y = Object.keys(m), P = Object.keys(p);
    if (y.length !== P.length) return !1;
    for (P = 0; P < y.length; P++) if (!ct.call(p, y[P]) || !ar(m[y[P]], p[y[P]])) return !1;
    return !0;
  }
  function P0(m, p) {
    if (m && m.defaultProps) for (var y in p = r({}, p), m = m.defaultProps) p[y] === void 0 && (p[y] = m[y]);
    return p;
  }
  var Bn = { current: null }, bn = null, Ln = null, Ii = null;
  function Yn() {
    Ii = Ln = bn = null;
  }
  function fi(m, p) {
    var y = m.type._context;
    gt(Bn, y._currentValue2), y._currentValue2 = p;
  }
  function di(m) {
    var p = Bn.current;
    rt(Bn), (m = m.type._context)._currentValue2 = p;
  }
  function ho(m, p) {
    for (; m !== null; ) {
      var y = m.alternate;
      if (m.childExpirationTime < p) m.childExpirationTime = p, y !== null && y.childExpirationTime < p && (y.childExpirationTime = p);
      else {
        if (!(y !== null && y.childExpirationTime < p)) break;
        y.childExpirationTime = p;
      }
      m = m.return;
    }
  }
  function aa(m, p) {
    bn = m, Ii = Ln = null, (m = m.dependencies) !== null && m.firstContext !== null && (m.expirationTime >= p && (Ui = !0), m.firstContext = null);
  }
  function Qr(m, p) {
    if (Ii !== m && p !== !1 && p !== 0) if (typeof p == "number" && p !== 1073741823 || (Ii = m, p = 1073741823), p = { context: m, observedBits: p, next: null }, Ln === null) {
      if (bn === null) throw Error(a(308));
      Ln = p, bn.dependencies = { expirationTime: 0, firstContext: p, responders: null };
    } else Ln = Ln.next = p;
    return m._currentValue2;
  }
  var hi = !1;
  function Bi(m) {
    return { baseState: m, firstUpdate: null, lastUpdate: null, firstCapturedUpdate: null, lastCapturedUpdate: null, firstEffect: null, lastEffect: null, firstCapturedEffect: null, lastCapturedEffect: null };
  }
  function Da(m) {
    return { baseState: m.baseState, firstUpdate: m.firstUpdate, lastUpdate: m.lastUpdate, firstCapturedUpdate: null, lastCapturedUpdate: null, firstEffect: null, lastEffect: null, firstCapturedEffect: null, lastCapturedEffect: null };
  }
  function en(m, p) {
    return { expirationTime: m, suspenseConfig: p, tag: 0, payload: null, callback: null, next: null, nextEffect: null };
  }
  function po(m, p) {
    m.lastUpdate === null ? m.firstUpdate = m.lastUpdate = p : (m.lastUpdate.next = p, m.lastUpdate = p);
  }
  function Nn(m, p) {
    var y = m.alternate;
    if (y === null) {
      var P = m.updateQueue, M = null;
      P === null && (P = m.updateQueue = Bi(m.memoizedState));
    } else P = m.updateQueue, M = y.updateQueue, P === null ? M === null ? (P = m.updateQueue = Bi(m.memoizedState), M = y.updateQueue = Bi(y.memoizedState)) : P = m.updateQueue = Da(M) : M === null && (M = y.updateQueue = Da(P));
    M === null || P === M ? po(P, p) : P.lastUpdate === null || M.lastUpdate === null ? (po(P, p), po(M, p)) : (po(P, p), M.lastUpdate = p);
  }
  function ms(m, p) {
    var y = m.updateQueue;
    (y = y === null ? m.updateQueue = Bi(m.memoizedState) : Mn(m, y)).lastCapturedUpdate === null ? y.firstCapturedUpdate = y.lastCapturedUpdate = p : (y.lastCapturedUpdate.next = p, y.lastCapturedUpdate = p);
  }
  function Mn(m, p) {
    var y = m.alternate;
    return y !== null && p === y.updateQueue && (p = m.updateQueue = Da(p)), p;
  }
  function Uc(m, p, y, P, M, H) {
    switch (y.tag) {
      case 1:
        return typeof (m = y.payload) == "function" ? m.call(H, P, M) : m;
      case 3:
        m.effectTag = -4097 & m.effectTag | 64;
      case 0:
        if ((M = typeof (m = y.payload) == "function" ? m.call(H, P, M) : m) == null) break;
        return r({}, P, M);
      case 2:
        hi = !0;
    }
    return P;
  }
  function oa(m, p, y, P, M) {
    hi = !1;
    for (var H = (p = Mn(m, p)).baseState, re = null, Se = 0, Ie = p.firstUpdate, je = H; Ie !== null; ) {
      var vt = Ie.expirationTime;
      vt < M ? (re === null && (re = Ie, H = je), Se < vt && (Se = vt)) : (rf(vt, Ie.suspenseConfig), je = Uc(m, 0, Ie, je, y, P), Ie.callback !== null && (m.effectTag |= 32, Ie.nextEffect = null, p.lastEffect === null ? p.firstEffect = p.lastEffect = Ie : (p.lastEffect.nextEffect = Ie, p.lastEffect = Ie))), Ie = Ie.next;
    }
    for (vt = null, Ie = p.firstCapturedUpdate; Ie !== null; ) {
      var ur = Ie.expirationTime;
      ur < M ? (vt === null && (vt = Ie, re === null && (H = je)), Se < ur && (Se = ur)) : (je = Uc(m, 0, Ie, je, y, P), Ie.callback !== null && (m.effectTag |= 32, Ie.nextEffect = null, p.lastCapturedEffect === null ? p.firstCapturedEffect = p.lastCapturedEffect = Ie : (p.lastCapturedEffect.nextEffect = Ie, p.lastCapturedEffect = Ie))), Ie = Ie.next;
    }
    re === null && (p.lastUpdate = null), vt === null ? p.lastCapturedUpdate = null : m.effectTag |= 32, re === null && vt === null && (H = je), p.baseState = H, p.firstUpdate = re, p.firstCapturedUpdate = vt, gl(Se), m.expirationTime = Se, m.memoizedState = je;
  }
  function Oa(m, p, y) {
    p.firstCapturedUpdate !== null && (p.lastUpdate !== null && (p.lastUpdate.next = p.firstCapturedUpdate, p.lastUpdate = p.lastCapturedUpdate), p.firstCapturedUpdate = p.lastCapturedUpdate = null), mo(p.firstEffect, y), p.firstEffect = p.lastEffect = null, mo(p.firstCapturedEffect, y), p.firstCapturedEffect = p.lastCapturedEffect = null;
  }
  function mo(m, p) {
    for (; m !== null; ) {
      var y = m.callback;
      if (y !== null) {
        m.callback = null;
        var P = p;
        if (typeof y != "function") throw Error(a(191, y));
        y.call(P);
      }
      m = m.nextEffect;
    }
  }
  var pi = o.ReactCurrentBatchConfig, sa = new n.Component().refs;
  function Ra(m, p, y, P) {
    y = (y = y(P, p = m.memoizedState)) == null ? p : r({}, p, y), m.memoizedState = y, (P = m.updateQueue) !== null && m.expirationTime === 0 && (P.baseState = y);
  }
  var go = { isMounted: function(m) {
    return !!(m = m._reactInternalFiber) && U(m) === m;
  }, enqueueSetState: function(m, p, y) {
    m = m._reactInternalFiber;
    var P = Vn(), M = pi.suspense;
    (M = en(P = ks(P, m, M), M)).payload = p, y != null && (M.callback = y), Nn(m, M), _i(m, P);
  }, enqueueReplaceState: function(m, p, y) {
    m = m._reactInternalFiber;
    var P = Vn(), M = pi.suspense;
    (M = en(P = ks(P, m, M), M)).tag = 1, M.payload = p, y != null && (M.callback = y), Nn(m, M), _i(m, P);
  }, enqueueForceUpdate: function(m, p) {
    m = m._reactInternalFiber;
    var y = Vn(), P = pi.suspense;
    (P = en(y = ks(y, m, P), P)).tag = 2, p != null && (P.callback = p), Nn(m, P), _i(m, y);
  } };
  function gs(m, p, y, P, M, H, re) {
    return typeof (m = m.stateNode).shouldComponentUpdate == "function" ? m.shouldComponentUpdate(P, H, re) : !(p.prototype && p.prototype.isPureReactComponent && Jr(y, P) && Jr(M, H));
  }
  function vs(m, p, y) {
    var P = !1, M = _t, H = p.contextType;
    return typeof H == "object" && H !== null ? H = Qr(H) : (M = ot(p) ? Tt : Bt.current, H = (P = (P = p.contextTypes) != null) ? Je(m, M) : _t), p = new p(y, H), m.memoizedState = p.state !== null && p.state !== void 0 ? p.state : null, p.updater = go, m.stateNode = p, p._reactInternalFiber = m, P && ((m = m.stateNode).__reactInternalMemoizedUnmaskedChildContext = M, m.__reactInternalMemoizedMaskedChildContext = H), p;
  }
  function Pa(m, p, y, P) {
    m = p.state, typeof p.componentWillReceiveProps == "function" && p.componentWillReceiveProps(y, P), typeof p.UNSAFE_componentWillReceiveProps == "function" && p.UNSAFE_componentWillReceiveProps(y, P), p.state !== m && go.enqueueReplaceState(p, p.state, null);
  }
  function mi(m, p, y, P) {
    var M = m.stateNode;
    M.props = y, M.state = m.memoizedState, M.refs = sa;
    var H = p.contextType;
    typeof H == "object" && H !== null ? M.context = Qr(H) : (H = ot(p) ? Tt : Bt.current, M.context = Je(m, H)), (H = m.updateQueue) !== null && (oa(m, H, y, M, P), M.state = m.memoizedState), typeof (H = p.getDerivedStateFromProps) == "function" && (Ra(m, p, H, y), M.state = m.memoizedState), typeof p.getDerivedStateFromProps == "function" || typeof M.getSnapshotBeforeUpdate == "function" || typeof M.UNSAFE_componentWillMount != "function" && typeof M.componentWillMount != "function" || (p = M.state, typeof M.componentWillMount == "function" && M.componentWillMount(), typeof M.UNSAFE_componentWillMount == "function" && M.UNSAFE_componentWillMount(), p !== M.state && go.enqueueReplaceState(M, M.state, null), (H = m.updateQueue) !== null && (oa(m, H, y, M, P), M.state = m.memoizedState)), typeof M.componentDidMount == "function" && (m.effectTag |= 4);
  }
  var gi = Array.isArray;
  function Gn(m, p, y) {
    if ((m = y.ref) !== null && typeof m != "function" && typeof m != "object") {
      if (y._owner) {
        if (y = y._owner) {
          if (y.tag !== 1) throw Error(a(309));
          var P = y.stateNode;
        }
        if (!P) throw Error(a(147, m));
        var M = "" + m;
        return p !== null && p.ref !== null && typeof p.ref == "function" && p.ref._stringRef === M ? p.ref : (p = function(H) {
          var re = P.refs;
          re === sa && (re = P.refs = {}), H === null ? delete re[M] : re[M] = H;
        }, p._stringRef = M, p);
      }
      if (typeof m != "string") throw Error(a(284));
      if (!y._owner) throw Error(a(290, m));
    }
    return m;
  }
  function vi(m, p) {
    if (m.type !== "textarea") throw Error(a(31, Object.prototype.toString.call(p) === "[object Object]" ? "object with keys {" + Object.keys(p).join(", ") + "}" : p, ""));
  }
  function Ia(m) {
    function p(Ce, we) {
      if (m) {
        var Fe = Ce.lastEffect;
        Fe !== null ? (Fe.nextEffect = we, Ce.lastEffect = we) : Ce.firstEffect = Ce.lastEffect = we, we.nextEffect = null, we.effectTag = 8;
      }
    }
    function y(Ce, we) {
      if (!m) return null;
      for (; we !== null; ) p(Ce, we), we = we.sibling;
      return null;
    }
    function P(Ce, we) {
      for (Ce = /* @__PURE__ */ new Map(); we !== null; ) we.key !== null ? Ce.set(we.key, we) : Ce.set(we.index, we), we = we.sibling;
      return Ce;
    }
    function M(Ce, we, Fe) {
      return (Ce = Ds(Ce, we)).index = 0, Ce.sibling = null, Ce;
    }
    function H(Ce, we, Fe) {
      return Ce.index = Fe, m ? (Fe = Ce.alternate) !== null ? (Fe = Fe.index) < we ? (Ce.effectTag = 2, we) : Fe : (Ce.effectTag = 2, we) : we;
    }
    function re(Ce) {
      return m && Ce.alternate === null && (Ce.effectTag = 2), Ce;
    }
    function Se(Ce, we, Fe, dt) {
      return we === null || we.tag !== 6 ? ((we = rd(Fe, Ce.mode, dt)).return = Ce, we) : ((we = M(we, Fe)).return = Ce, we);
    }
    function Ie(Ce, we, Fe, dt) {
      return we !== null && we.elementType === Fe.type ? ((dt = M(we, Fe.props)).ref = Gn(Ce, we, Fe), dt.return = Ce, dt) : ((dt = vl(Fe.type, Fe.key, Fe.props, null, Ce.mode, dt)).ref = Gn(Ce, we, Fe), dt.return = Ce, dt);
    }
    function je(Ce, we, Fe, dt) {
      return we === null || we.tag !== 4 || we.stateNode.containerInfo !== Fe.containerInfo || we.stateNode.implementation !== Fe.implementation ? ((we = nd(Fe, Ce.mode, dt)).return = Ce, we) : ((we = M(we, Fe.children || [])).return = Ce, we);
    }
    function vt(Ce, we, Fe, dt, Ft) {
      return we === null || we.tag !== 7 ? ((we = ji(Fe, Ce.mode, dt, Ft)).return = Ce, we) : ((we = M(we, Fe)).return = Ce, we);
    }
    function ur(Ce, we, Fe) {
      if (typeof we == "string" || typeof we == "number") return (we = rd("" + we, Ce.mode, Fe)).return = Ce, we;
      if (typeof we == "object" && we !== null) {
        switch (we.$$typeof) {
          case l:
            return (Fe = vl(we.type, we.key, we.props, null, Ce.mode, Fe)).ref = Gn(Ce, null, we), Fe.return = Ce, Fe;
          case u:
            return (we = nd(we, Ce.mode, Fe)).return = Ce, we;
        }
        if (gi(we) || I(we)) return (we = ji(we, Ce.mode, Fe, null)).return = Ce, we;
        vi(Ce, we);
      }
      return null;
    }
    function C0(Ce, we, Fe, dt) {
      var Ft = we !== null ? we.key : null;
      if (typeof Fe == "string" || typeof Fe == "number") return Ft !== null ? null : Se(Ce, we, "" + Fe, dt);
      if (typeof Fe == "object" && Fe !== null) {
        switch (Fe.$$typeof) {
          case l:
            return Fe.key === Ft ? Fe.type === d ? vt(Ce, we, Fe.props.children, dt, Ft) : Ie(Ce, we, Fe, dt) : null;
          case u:
            return Fe.key === Ft ? je(Ce, we, Fe, dt) : null;
        }
        if (gi(Fe) || I(Fe)) return Ft !== null ? null : vt(Ce, we, Fe, dt, null);
        vi(Ce, Fe);
      }
      return null;
    }
    function Jn(Ce, we, Fe, dt, Ft) {
      if (typeof dt == "string" || typeof dt == "number") return Se(we, Ce = Ce.get(Fe) || null, "" + dt, Ft);
      if (typeof dt == "object" && dt !== null) {
        switch (dt.$$typeof) {
          case l:
            return Ce = Ce.get(dt.key === null ? Fe : dt.key) || null, dt.type === d ? vt(we, Ce, dt.props.children, Ft, dt.key) : Ie(we, Ce, dt, Ft);
          case u:
            return je(we, Ce = Ce.get(dt.key === null ? Fe : dt.key) || null, dt, Ft);
        }
        if (gi(dt) || I(dt)) return vt(we, Ce = Ce.get(Fe) || null, dt, Ft, null);
        vi(we, dt);
      }
      return null;
    }
    function Rs(Ce, we, Fe, dt) {
      for (var Ft = null, k0 = null, Pt = we, p0 = we = 0, Hr = null; Pt !== null && p0 < Fe.length; p0++) {
        Pt.index > p0 ? (Hr = Pt, Pt = null) : Hr = Pt.sibling;
        var x0 = C0(Ce, Pt, Fe[p0], dt);
        if (x0 === null) {
          Pt === null && (Pt = Hr);
          break;
        }
        m && Pt && x0.alternate === null && p(Ce, Pt), we = H(x0, we, p0), k0 === null ? Ft = x0 : k0.sibling = x0, k0 = x0, Pt = Hr;
      }
      if (p0 === Fe.length) return y(Ce, Pt), Ft;
      if (Pt === null) {
        for (; p0 < Fe.length; p0++) (Pt = ur(Ce, Fe[p0], dt)) !== null && (we = H(Pt, we, p0), k0 === null ? Ft = Pt : k0.sibling = Pt, k0 = Pt);
        return Ft;
      }
      for (Pt = P(Ce, Pt); p0 < Fe.length; p0++) (Hr = Jn(Pt, Ce, p0, Fe[p0], dt)) !== null && (m && Hr.alternate !== null && Pt.delete(Hr.key === null ? p0 : Hr.key), we = H(Hr, we, p0), k0 === null ? Ft = Hr : k0.sibling = Hr, k0 = Hr);
      return m && Pt.forEach(function(Co) {
        return p(Ce, Co);
      }), Ft;
    }
    function Qn(Ce, we, Fe, dt) {
      var Ft = I(Fe);
      if (typeof Ft != "function") throw Error(a(150));
      if ((Fe = Ft.call(Fe)) == null) throw Error(a(151));
      for (var k0 = Ft = null, Pt = we, p0 = we = 0, Hr = null, x0 = Fe.next(); Pt !== null && !x0.done; p0++, x0 = Fe.next()) {
        Pt.index > p0 ? (Hr = Pt, Pt = null) : Hr = Pt.sibling;
        var Co = C0(Ce, Pt, x0.value, dt);
        if (Co === null) {
          Pt === null && (Pt = Hr);
          break;
        }
        m && Pt && Co.alternate === null && p(Ce, Pt), we = H(Co, we, p0), k0 === null ? Ft = Co : k0.sibling = Co, k0 = Co, Pt = Hr;
      }
      if (x0.done) return y(Ce, Pt), Ft;
      if (Pt === null) {
        for (; !x0.done; p0++, x0 = Fe.next()) (x0 = ur(Ce, x0.value, dt)) !== null && (we = H(x0, we, p0), k0 === null ? Ft = x0 : k0.sibling = x0, k0 = x0);
        return Ft;
      }
      for (Pt = P(Ce, Pt); !x0.done; p0++, x0 = Fe.next()) (x0 = Jn(Pt, Ce, p0, x0.value, dt)) !== null && (m && x0.alternate !== null && Pt.delete(x0.key === null ? p0 : x0.key), we = H(x0, we, p0), k0 === null ? Ft = x0 : k0.sibling = x0, k0 = x0);
      return m && Pt.forEach(function(Tu) {
        return p(Ce, Tu);
      }), Ft;
    }
    return function(Ce, we, Fe, dt) {
      var Ft = typeof Fe == "object" && Fe !== null && Fe.type === d && Fe.key === null;
      Ft && (Fe = Fe.props.children);
      var k0 = typeof Fe == "object" && Fe !== null;
      if (k0) switch (Fe.$$typeof) {
        case l:
          e: {
            for (k0 = Fe.key, Ft = we; Ft !== null; ) {
              if (Ft.key === k0) {
                if (Ft.tag === 7 ? Fe.type === d : Ft.elementType === Fe.type) {
                  y(Ce, Ft.sibling), (we = M(Ft, Fe.type === d ? Fe.props.children : Fe.props)).ref = Gn(Ce, Ft, Fe), we.return = Ce, Ce = we;
                  break e;
                }
                y(Ce, Ft);
                break;
              }
              p(Ce, Ft), Ft = Ft.sibling;
            }
            Fe.type === d ? ((we = ji(Fe.props.children, Ce.mode, dt, Fe.key)).return = Ce, Ce = we) : ((dt = vl(Fe.type, Fe.key, Fe.props, null, Ce.mode, dt)).ref = Gn(Ce, we, Fe), dt.return = Ce, Ce = dt);
          }
          return re(Ce);
        case u:
          e: {
            for (Ft = Fe.key; we !== null; ) {
              if (we.key === Ft) {
                if (we.tag === 4 && we.stateNode.containerInfo === Fe.containerInfo && we.stateNode.implementation === Fe.implementation) {
                  y(Ce, we.sibling), (we = M(we, Fe.children || [])).return = Ce, Ce = we;
                  break e;
                }
                y(Ce, we);
                break;
              }
              p(Ce, we), we = we.sibling;
            }
            (we = nd(Fe, Ce.mode, dt)).return = Ce, Ce = we;
          }
          return re(Ce);
      }
      if (typeof Fe == "string" || typeof Fe == "number") return Fe = "" + Fe, we !== null && we.tag === 6 ? (y(Ce, we.sibling), (we = M(we, Fe)).return = Ce, Ce = we) : (y(Ce, we), (we = rd(Fe, Ce.mode, dt)).return = Ce, Ce = we), re(Ce);
      if (gi(Fe)) return Rs(Ce, we, Fe, dt);
      if (I(Fe)) return Qn(Ce, we, Fe, dt);
      if (k0 && vi(Ce, Fe), Fe === void 0 && !Ft) switch (Ce.tag) {
        case 1:
        case 0:
          throw Ce = Ce.type, Error(a(152, Ce.displayName || Ce.name || "Component"));
      }
      return y(Ce, we);
    };
  }
  var la = Ia(!0), or = Ia(!1), ua = {}, xn = { current: ua }, Ba = { current: ua }, Li = { current: ua };
  function bi(m) {
    if (m === ua) throw Error(a(174));
    return m;
  }
  function vo(m, p) {
    gt(Li, p), gt(Ba, m), gt(xn, ua), p = B(p), rt(xn), gt(xn, p);
  }
  function yr(m) {
    rt(xn), rt(Ba), rt(Li);
  }
  function bs(m) {
    var p = bi(Li.current), y = bi(xn.current);
    y !== (p = q(y, m.type, p)) && (gt(Ba, m), gt(xn, p));
  }
  function xs(m) {
    Ba.current === m && (rt(xn), rt(Ba));
  }
  var G0 = { current: 0 };
  function ca(m) {
    for (var p = m; p !== null; ) {
      if (p.tag === 13) {
        var y = p.memoizedState;
        if (y !== null && ((y = y.dehydrated) === null || Ee(y) || ve(y))) return p;
      } else if (p.tag === 19 && p.memoizedProps.revealOrder !== void 0) {
        if (64 & p.effectTag) return p;
      } else if (p.child !== null) {
        p.child.return = p, p = p.child;
        continue;
      }
      if (p === m) break;
      for (; p.sibling === null; ) {
        if (p.return === null || p.return === m) return null;
        p = p.return;
      }
      p.sibling.return = p.return, p = p.sibling;
    }
    return null;
  }
  function ul(m, p) {
    return { responder: m, props: p };
  }
  var La = o.ReactCurrentDispatcher, wr = o.ReactCurrentBatchConfig, Zn = 0, Lr = null, Fr = null, yn = null, Nr = null, pr = null, fa = null, Un = 0, _r = null, z0 = 0, Na = !1, tn = null, zn = 0;
  function Dr() {
    throw Error(a(321));
  }
  function Ni(m, p) {
    if (p === null) return !1;
    for (var y = 0; y < p.length && y < m.length; y++) if (!ar(m[y], p[y])) return !1;
    return !0;
  }
  function o0(m, p, y, P, M, H) {
    if (Zn = H, Lr = p, yn = m !== null ? m.memoizedState : null, La.current = yn === null ? hl : Mi, p = y(P, M), Na) {
      do
        Na = !1, zn += 1, yn = m !== null ? m.memoizedState : null, fa = Nr, _r = pr = Fr = null, La.current = Mi, p = y(P, M);
      while (Na);
      tn = null, zn = 0;
    }
    if (La.current = hu, (m = Lr).memoizedState = Nr, m.expirationTime = Un, m.updateQueue = _r, m.effectTag |= z0, m = Fr !== null && Fr.next !== null, Zn = 0, fa = pr = Nr = yn = Fr = Lr = null, Un = 0, _r = null, z0 = 0, m) throw Error(a(300));
    return p;
  }
  function Wr() {
    La.current = hu, Zn = 0, fa = pr = Nr = yn = Fr = Lr = null, Un = 0, _r = null, z0 = 0, Na = !1, tn = null, zn = 0;
  }
  function sr() {
    var m = { memoizedState: null, baseState: null, queue: null, baseUpdate: null, next: null };
    return pr === null ? Nr = pr = m : pr = pr.next = m, pr;
  }
  function rn() {
    if (fa !== null) fa = (pr = fa).next, yn = (Fr = yn) !== null ? Fr.next : null;
    else {
      if (yn === null) throw Error(a(310));
      var m = { memoizedState: (Fr = yn).memoizedState, baseState: Fr.baseState, queue: Fr.queue, baseUpdate: Fr.baseUpdate, next: null };
      pr = pr === null ? Nr = m : pr.next = m, yn = Fr.next;
    }
    return pr;
  }
  function Ma(m, p) {
    return typeof p == "function" ? p(m) : p;
  }
  function zc(m) {
    var p = rn(), y = p.queue;
    if (y === null) throw Error(a(311));
    if (y.lastRenderedReducer = m, 0 < zn) {
      var P = y.dispatch;
      if (tn !== null) {
        var M = tn.get(y);
        if (M !== void 0) {
          tn.delete(y);
          var H = p.memoizedState;
          do
            H = m(H, M.action), M = M.next;
          while (M !== null);
          return ar(H, p.memoizedState) || (Ui = !0), p.memoizedState = H, p.baseUpdate === y.last && (p.baseState = H), y.lastRenderedState = H, [H, P];
        }
      }
      return [p.memoizedState, P];
    }
    P = y.last;
    var re = p.baseUpdate;
    if (H = p.baseState, re !== null ? (P !== null && (P.next = null), P = re.next) : P = P !== null ? P.next : null, P !== null) {
      var Se = M = null, Ie = P, je = !1;
      do {
        var vt = Ie.expirationTime;
        vt < Zn ? (je || (je = !0, Se = re, M = H), vt > Un && gl(Un = vt)) : (rf(vt, Ie.suspenseConfig), H = Ie.eagerReducer === m ? Ie.eagerState : m(H, Ie.action)), re = Ie, Ie = Ie.next;
      } while (Ie !== null && Ie !== P);
      je || (Se = re, M = H), ar(H, p.memoizedState) || (Ui = !0), p.memoizedState = H, p.baseUpdate = Se, p.baseState = M, y.lastRenderedState = H;
    }
    return [p.memoizedState, y.dispatch];
  }
  function cl(m) {
    var p = sr();
    return typeof m == "function" && (m = m()), p.memoizedState = p.baseState = m, m = (m = p.queue = { last: null, dispatch: null, lastRenderedReducer: Ma, lastRenderedState: m }).dispatch = R1.bind(null, Lr, m), [p.memoizedState, m];
  }
  function $c(m) {
    return zc(Ma);
  }
  function du(m, p, y, P) {
    return m = { tag: m, create: p, destroy: y, deps: P, next: null }, _r === null ? (_r = { lastEffect: null }).lastEffect = m.next = m : (p = _r.lastEffect) === null ? _r.lastEffect = m.next = m : (y = p.next, p.next = m, m.next = y, _r.lastEffect = m), m;
  }
  function fl(m, p, y, P) {
    var M = sr();
    z0 |= m, M.memoizedState = du(p, y, void 0, P === void 0 ? null : P);
  }
  function ys(m, p, y, P) {
    var M = rn();
    P = P === void 0 ? null : P;
    var H = void 0;
    if (Fr !== null) {
      var re = Fr.memoizedState;
      if (H = re.destroy, P !== null && Ni(P, re.deps)) return void du(0, y, H, P);
    }
    z0 |= m, M.memoizedState = du(p, y, H, P);
  }
  function nn(m, p) {
    return fl(516, 192, m, p);
  }
  function Gh(m, p) {
    return ys(516, 192, m, p);
  }
  function Zh(m, p) {
    return typeof p == "function" ? (m = m(), p(m), function() {
      p(null);
    }) : p != null ? (m = m(), p.current = m, function() {
      p.current = null;
    }) : void 0;
  }
  function O1() {
  }
  function dl(m, p) {
    return sr().memoizedState = [m, p === void 0 ? null : p], m;
  }
  function Ua(m, p) {
    var y = rn();
    p = p === void 0 ? null : p;
    var P = y.memoizedState;
    return P !== null && p !== null && Ni(p, P[1]) ? P[0] : (y.memoizedState = [m, p], m);
  }
  function R1(m, p, y) {
    if (!(25 > zn)) throw Error(a(301));
    var P = m.alternate;
    if (m === Lr || P !== null && P === Lr) if (Na = !0, m = { expirationTime: Zn, suspenseConfig: null, action: y, eagerReducer: null, eagerState: null, next: null }, tn === null && (tn = /* @__PURE__ */ new Map()), (y = tn.get(p)) === void 0) tn.set(p, m);
    else {
      for (p = y; p.next !== null; ) p = p.next;
      p.next = m;
    }
    else {
      var M = Vn(), H = pi.suspense;
      H = { expirationTime: M = ks(M, m, H), suspenseConfig: H, action: y, eagerReducer: null, eagerState: null, next: null };
      var re = p.last;
      if (re === null) H.next = H;
      else {
        var Se = re.next;
        Se !== null && (H.next = Se), re.next = H;
      }
      if (p.last = H, m.expirationTime === 0 && (P === null || P.expirationTime === 0) && (P = p.lastRenderedReducer) !== null) try {
        var Ie = p.lastRenderedState, je = P(Ie, y);
        if (H.eagerReducer = P, H.eagerState = je, ar(je, Ie)) return;
      } catch {
      }
      _i(m, M);
    }
  }
  var hu = { readContext: Qr, useCallback: Dr, useContext: Dr, useEffect: Dr, useImperativeHandle: Dr, useLayoutEffect: Dr, useMemo: Dr, useReducer: Dr, useRef: Dr, useState: Dr, useDebugValue: Dr, useResponder: Dr, useDeferredValue: Dr, useTransition: Dr }, hl = { readContext: Qr, useCallback: dl, useContext: Qr, useEffect: nn, useImperativeHandle: function(m, p, y) {
    return y = y != null ? y.concat([m]) : null, fl(4, 36, Zh.bind(null, p, m), y);
  }, useLayoutEffect: function(m, p) {
    return fl(4, 36, m, p);
  }, useMemo: function(m, p) {
    var y = sr();
    return p = p === void 0 ? null : p, m = m(), y.memoizedState = [m, p], m;
  }, useReducer: function(m, p, y) {
    var P = sr();
    return p = y !== void 0 ? y(p) : p, P.memoizedState = P.baseState = p, m = (m = P.queue = { last: null, dispatch: null, lastRenderedReducer: m, lastRenderedState: p }).dispatch = R1.bind(null, Lr, m), [P.memoizedState, m];
  }, useRef: function(m) {
    return m = { current: m }, sr().memoizedState = m;
  }, useState: cl, useDebugValue: O1, useResponder: ul, useDeferredValue: function(m, p) {
    var y = cl(m), P = y[0], M = y[1];
    return nn(function() {
      i.unstable_next(function() {
        var H = wr.suspense;
        wr.suspense = p === void 0 ? null : p;
        try {
          M(m);
        } finally {
          wr.suspense = H;
        }
      });
    }, [m, p]), P;
  }, useTransition: function(m) {
    var p = cl(!1), y = p[0], P = p[1];
    return [dl(function(M) {
      P(!0), i.unstable_next(function() {
        var H = wr.suspense;
        wr.suspense = m === void 0 ? null : m;
        try {
          P(!1), M();
        } finally {
          wr.suspense = H;
        }
      });
    }, [m, y]), y];
  } }, Mi = { readContext: Qr, useCallback: Ua, useContext: Qr, useEffect: Gh, useImperativeHandle: function(m, p, y) {
    return y = y != null ? y.concat([m]) : null, ys(4, 36, Zh.bind(null, p, m), y);
  }, useLayoutEffect: function(m, p) {
    return ys(4, 36, m, p);
  }, useMemo: function(m, p) {
    var y = rn();
    p = p === void 0 ? null : p;
    var P = y.memoizedState;
    return P !== null && p !== null && Ni(p, P[1]) ? P[0] : (m = m(), y.memoizedState = [m, p], m);
  }, useReducer: zc, useRef: function() {
    return rn().memoizedState;
  }, useState: $c, useDebugValue: O1, useResponder: ul, useDeferredValue: function(m, p) {
    var y = $c(), P = y[0], M = y[1];
    return Gh(function() {
      i.unstable_next(function() {
        var H = wr.suspense;
        wr.suspense = p === void 0 ? null : p;
        try {
          M(m);
        } finally {
          wr.suspense = H;
        }
      });
    }, [m, p]), P;
  }, useTransition: function(m) {
    var p = $c(), y = p[0], P = p[1];
    return [Ua(function(M) {
      P(!0), i.unstable_next(function() {
        var H = wr.suspense;
        wr.suspense = m === void 0 ? null : m;
        try {
          P(!1), M();
        } finally {
          wr.suspense = H;
        }
      });
    }, [m, y]), y];
  } }, Xh = o.ReactCurrentOwner, Ui = !1;
  function Xn(m, p, y, P) {
    p.child = m === null ? or(p, null, y, P) : la(p, m.child, y, P);
  }
  function Vc(m, p, y, P, M) {
    y = y.render;
    var H = p.ref;
    return aa(p, M), P = o0(m, p, y, P, H, M), m === null || Ui ? (p.effectTag |= 1, Xn(m, p, P, M), p.child) : (p.updateQueue = m.updateQueue, p.effectTag &= -517, m.expirationTime <= M && (m.expirationTime = 0), da(m, p, M));
  }
  function jc(m, p, y, P, M, H) {
    if (m === null) {
      var re = y.type;
      return typeof re != "function" || td(re) || re.defaultProps !== void 0 || y.compare !== null || y.defaultProps !== void 0 ? ((m = vl(y.type, null, P, null, p.mode, H)).ref = p.ref, m.return = p, p.child = m) : (p.tag = 15, p.type = re, P1(m, p, re, P, M, H));
    }
    return re = m.child, M < H && (M = re.memoizedProps, (y = (y = y.compare) !== null ? y : Jr)(M, P) && m.ref === p.ref) ? da(m, p, H) : (p.effectTag |= 1, (m = Ds(re, P)).ref = p.ref, m.return = p, p.child = m);
  }
  function P1(m, p, y, P, M, H) {
    return m !== null && Jr(m.memoizedProps, P) && m.ref === p.ref && (Ui = !1, M < H) ? da(m, p, H) : za(m, p, y, P, H);
  }
  function I1(m, p) {
    var y = p.ref;
    (m === null && y !== null || m !== null && m.ref !== y) && (p.effectTag |= 128);
  }
  function za(m, p, y, P, M) {
    var H = ot(y) ? Tt : Bt.current;
    return H = Je(p, H), aa(p, M), y = o0(m, p, y, P, H, M), m === null || Ui ? (p.effectTag |= 1, Xn(m, p, y, M), p.child) : (p.updateQueue = m.updateQueue, p.effectTag &= -517, m.expirationTime <= M && (m.expirationTime = 0), da(m, p, M));
  }
  function B1(m, p, y, P, M) {
    if (ot(y)) {
      var H = !0;
      e0(p);
    } else H = !1;
    if (aa(p, M), p.stateNode === null) m !== null && (m.alternate = null, p.alternate = null, p.effectTag |= 2), vs(p, y, P), mi(p, y, P, M), P = !0;
    else if (m === null) {
      var re = p.stateNode, Se = p.memoizedProps;
      re.props = Se;
      var Ie = re.context, je = y.contextType;
      je = typeof je == "object" && je !== null ? Qr(je) : Je(p, je = ot(y) ? Tt : Bt.current);
      var vt = y.getDerivedStateFromProps, ur = typeof vt == "function" || typeof re.getSnapshotBeforeUpdate == "function";
      ur || typeof re.UNSAFE_componentWillReceiveProps != "function" && typeof re.componentWillReceiveProps != "function" || (Se !== P || Ie !== je) && Pa(p, re, P, je), hi = !1;
      var C0 = p.memoizedState;
      Ie = re.state = C0;
      var Jn = p.updateQueue;
      Jn !== null && (oa(p, Jn, P, re, M), Ie = p.memoizedState), Se !== P || C0 !== Ie || At.current || hi ? (typeof vt == "function" && (Ra(p, y, vt, P), Ie = p.memoizedState), (Se = hi || gs(p, y, Se, P, C0, Ie, je)) ? (ur || typeof re.UNSAFE_componentWillMount != "function" && typeof re.componentWillMount != "function" || (typeof re.componentWillMount == "function" && re.componentWillMount(), typeof re.UNSAFE_componentWillMount == "function" && re.UNSAFE_componentWillMount()), typeof re.componentDidMount == "function" && (p.effectTag |= 4)) : (typeof re.componentDidMount == "function" && (p.effectTag |= 4), p.memoizedProps = P, p.memoizedState = Ie), re.props = P, re.state = Ie, re.context = je, P = Se) : (typeof re.componentDidMount == "function" && (p.effectTag |= 4), P = !1);
    } else re = p.stateNode, Se = p.memoizedProps, re.props = p.type === p.elementType ? Se : P0(p.type, Se), Ie = re.context, je = typeof (je = y.contextType) == "object" && je !== null ? Qr(je) : Je(p, je = ot(y) ? Tt : Bt.current), (ur = typeof (vt = y.getDerivedStateFromProps) == "function" || typeof re.getSnapshotBeforeUpdate == "function") || typeof re.UNSAFE_componentWillReceiveProps != "function" && typeof re.componentWillReceiveProps != "function" || (Se !== P || Ie !== je) && Pa(p, re, P, je), hi = !1, Ie = p.memoizedState, C0 = re.state = Ie, (Jn = p.updateQueue) !== null && (oa(p, Jn, P, re, M), C0 = p.memoizedState), Se !== P || Ie !== C0 || At.current || hi ? (typeof vt == "function" && (Ra(p, y, vt, P), C0 = p.memoizedState), (vt = hi || gs(p, y, Se, P, Ie, C0, je)) ? (ur || typeof re.UNSAFE_componentWillUpdate != "function" && typeof re.componentWillUpdate != "function" || (typeof re.componentWillUpdate == "function" && re.componentWillUpdate(P, C0, je), typeof re.UNSAFE_componentWillUpdate == "function" && re.UNSAFE_componentWillUpdate(P, C0, je)), typeof re.componentDidUpdate == "function" && (p.effectTag |= 4), typeof re.getSnapshotBeforeUpdate == "function" && (p.effectTag |= 256)) : (typeof re.componentDidUpdate != "function" || Se === m.memoizedProps && Ie === m.memoizedState || (p.effectTag |= 4), typeof re.getSnapshotBeforeUpdate != "function" || Se === m.memoizedProps && Ie === m.memoizedState || (p.effectTag |= 256), p.memoizedProps = P, p.memoizedState = C0), re.props = P, re.state = C0, re.context = je, P = vt) : (typeof re.componentDidUpdate != "function" || Se === m.memoizedProps && Ie === m.memoizedState || (p.effectTag |= 4), typeof re.getSnapshotBeforeUpdate != "function" || Se === m.memoizedProps && Ie === m.memoizedState || (p.effectTag |= 256), P = !1);
    return pu(m, p, y, P, H, M);
  }
  function pu(m, p, y, P, M, H) {
    I1(m, p);
    var re = (64 & p.effectTag) != 0;
    if (!P && !re) return M && kr(p, y, !1), da(m, p, H);
    P = p.stateNode, Xh.current = p;
    var Se = re && typeof y.getDerivedStateFromError != "function" ? null : P.render();
    return p.effectTag |= 1, m !== null && re ? (p.child = la(p, m.child, null, H), p.child = la(p, null, Se, H)) : Xn(m, p, Se, H), p.memoizedState = P.state, M && kr(p, y, !0), p.child;
  }
  function zi(m) {
    var p = m.stateNode;
    p.pendingContext ? ir(0, p.pendingContext, p.pendingContext !== p.context) : p.context && ir(0, p.context, !1), vo(m, p.containerInfo);
  }
  var L1, xi, N1, ws, bo = { dehydrated: null, retryTime: 0 };
  function _s(m, p, y) {
    var P, M = p.mode, H = p.pendingProps, re = G0.current, Se = !1;
    if ((P = (64 & p.effectTag) != 0) || (P = (2 & re) != 0 && (m === null || m.memoizedState !== null)), P ? (Se = !0, p.effectTag &= -65) : m !== null && m.memoizedState === null || H.fallback === void 0 || H.unstable_avoidThisFallback === !0 || (re |= 1), gt(G0, 1 & re), m === null) {
      if (H.fallback, Se) {
        if (Se = H.fallback, (H = ji(null, M, 0, null)).return = p, (2 & p.mode) == 0) for (m = p.memoizedState !== null ? p.child.child : p.child, H.child = m; m !== null; ) m.return = H, m = m.sibling;
        return (y = ji(Se, M, y, null)).return = p, H.sibling = y, p.memoizedState = bo, p.child = H, y;
      }
      return M = H.children, p.memoizedState = null, p.child = or(p, null, M, y);
    }
    if (m.memoizedState !== null) {
      if (M = (m = m.child).sibling, Se) {
        if (H = H.fallback, (y = Ds(m, m.pendingProps)).return = p, (2 & p.mode) == 0 && (Se = p.memoizedState !== null ? p.child.child : p.child) !== m.child) for (y.child = Se; Se !== null; ) Se.return = y, Se = Se.sibling;
        return (M = Ds(M, H, M.expirationTime)).return = p, y.sibling = M, y.childExpirationTime = 0, p.memoizedState = bo, p.child = y, M;
      }
      return y = la(p, m.child, H.children, y), p.memoizedState = null, p.child = y;
    }
    if (m = m.child, Se) {
      if (Se = H.fallback, (H = ji(null, M, 0, null)).return = p, H.child = m, m !== null && (m.return = H), (2 & p.mode) == 0) for (m = p.memoizedState !== null ? p.child.child : p.child, H.child = m; m !== null; ) m.return = H, m = m.sibling;
      return (y = ji(Se, M, y, null)).return = p, H.sibling = y, y.effectTag |= 2, H.childExpirationTime = 0, p.memoizedState = bo, p.child = H, y;
    }
    return p.memoizedState = null, p.child = la(p, m, H.children, y);
  }
  function Wc(m, p) {
    m.expirationTime < p && (m.expirationTime = p);
    var y = m.alternate;
    y !== null && y.expirationTime < p && (y.expirationTime = p), ho(m.return, p);
  }
  function mu(m, p, y, P, M, H) {
    var re = m.memoizedState;
    re === null ? m.memoizedState = { isBackwards: p, rendering: null, last: P, tail: y, tailExpiration: 0, tailMode: M, lastEffect: H } : (re.isBackwards = p, re.rendering = null, re.last = P, re.tail = y, re.tailExpiration = 0, re.tailMode = M, re.lastEffect = H);
  }
  function $a(m, p, y) {
    var P = p.pendingProps, M = P.revealOrder, H = P.tail;
    if (Xn(m, p, P.children, y), (2 & (P = G0.current)) != 0) P = 1 & P | 2, p.effectTag |= 64;
    else {
      if (m !== null && 64 & m.effectTag) e: for (m = p.child; m !== null; ) {
        if (m.tag === 13) m.memoizedState !== null && Wc(m, y);
        else if (m.tag === 19) Wc(m, y);
        else if (m.child !== null) {
          m.child.return = m, m = m.child;
          continue;
        }
        if (m === p) break e;
        for (; m.sibling === null; ) {
          if (m.return === null || m.return === p) break e;
          m = m.return;
        }
        m.sibling.return = m.return, m = m.sibling;
      }
      P &= 1;
    }
    if (gt(G0, P), (2 & p.mode) == 0) p.memoizedState = null;
    else switch (M) {
      case "forwards":
        for (y = p.child, M = null; y !== null; ) (m = y.alternate) !== null && ca(m) === null && (M = y), y = y.sibling;
        (y = M) === null ? (M = p.child, p.child = null) : (M = y.sibling, y.sibling = null), mu(p, !1, M, y, H, p.lastEffect);
        break;
      case "backwards":
        for (y = null, M = p.child, p.child = null; M !== null; ) {
          if ((m = M.alternate) !== null && ca(m) === null) {
            p.child = M;
            break;
          }
          m = M.sibling, M.sibling = y, y = M, M = m;
        }
        mu(p, !0, y, null, H, p.lastEffect);
        break;
      case "together":
        mu(p, !1, null, null, void 0, p.lastEffect);
        break;
      default:
        p.memoizedState = null;
    }
    return p.child;
  }
  function da(m, p, y) {
    m !== null && (p.dependencies = m.dependencies);
    var P = p.expirationTime;
    if (P !== 0 && gl(P), p.childExpirationTime < y) return null;
    if (m !== null && p.child !== m.child) throw Error(a(153));
    if (p.child !== null) {
      for (y = Ds(m = p.child, m.pendingProps, m.expirationTime), p.child = y, y.return = p; m.sibling !== null; ) m = m.sibling, (y = y.sibling = Ds(m, m.pendingProps, m.expirationTime)).return = p;
      y.sibling = null;
    }
    return p.child;
  }
  function xo(m) {
    m.effectTag |= 4;
  }
  function yo(m, p) {
    switch (m.tailMode) {
      case "hidden":
        p = m.tail;
        for (var y = null; p !== null; ) p.alternate !== null && (y = p), p = p.sibling;
        y === null ? m.tail = null : y.sibling = null;
        break;
      case "collapsed":
        y = m.tail;
        for (var P = null; y !== null; ) y.alternate !== null && (P = y), y = y.sibling;
        P === null ? p || m.tail === null ? m.tail = null : m.tail.sibling = null : P.sibling = null;
    }
  }
  function pl(m) {
    switch (m.tag) {
      case 1:
        ot(m.type) && R0();
        var p = m.effectTag;
        return 4096 & p ? (m.effectTag = -4097 & p | 64, m) : null;
      case 3:
        if (yr(), b0(), (64 & (p = m.effectTag)) != 0) throw Error(a(285));
        return m.effectTag = -4097 & p | 64, m;
      case 5:
        return xs(m), null;
      case 13:
        return rt(G0), 4096 & (p = m.effectTag) ? (m.effectTag = -4097 & p | 64, m) : null;
      case 19:
        return rt(G0), null;
      case 4:
        return yr(), null;
      case 10:
        return di(m), null;
      default:
        return null;
    }
  }
  function Hc(m, p) {
    return { value: m, source: p, stack: Pe(p) };
  }
  L1 = function(m, p) {
    for (var y = p.child; y !== null; ) {
      if (y.tag === 5 || y.tag === 6) J(m, y.stateNode);
      else if (y.tag !== 4 && y.child !== null) {
        y.child.return = y, y = y.child;
        continue;
      }
      if (y === p) break;
      for (; y.sibling === null; ) {
        if (y.return === null || y.return === p) return;
        y = y.return;
      }
      y.sibling.return = y.return, y = y.sibling;
    }
  }, xi = function() {
  }, N1 = function(m, p, y, P, M) {
    if ((m = m.memoizedProps) !== P) {
      var H = p.stateNode, re = bi(xn.current);
      y = ae(H, y, m, P, M, re), (p.updateQueue = y) && xo(p);
    }
  }, ws = function(m, p, y, P) {
    y !== P && xo(p);
  };
  var Kh = typeof WeakSet == "function" ? WeakSet : Set;
  function gu(m, p) {
    var y = p.source, P = p.stack;
    P === null && y !== null && (P = Pe(y)), y !== null && R(y.type), p = p.value, m !== null && m.tag === 1 && R(m.type);
    try {
      console.error(p);
    } catch (M) {
      setTimeout(function() {
        throw M;
      });
    }
  }
  function M1(m) {
    var p = m.ref;
    if (p !== null) if (typeof p == "function") try {
      p(null);
    } catch (y) {
      Fs(m, y);
    }
    else p.current = null;
  }
  function qc(m, p) {
    switch (p.tag) {
      case 0:
      case 11:
      case 15:
        ml(2, 0, p);
        break;
      case 1:
        if (256 & p.effectTag && m !== null) {
          var y = m.memoizedProps, P = m.memoizedState;
          p = (m = p.stateNode).getSnapshotBeforeUpdate(p.elementType === p.type ? y : P0(p.type, y), P), m.__reactInternalSnapshotBeforeUpdate = p;
        }
        break;
      case 3:
      case 5:
      case 6:
      case 4:
      case 17:
        break;
      default:
        throw Error(a(163));
    }
  }
  function ml(m, p, y) {
    if ((y = (y = y.updateQueue) !== null ? y.lastEffect : null) !== null) {
      var P = y = y.next;
      do {
        if (P.tag & m) {
          var M = P.destroy;
          P.destroy = void 0, M !== void 0 && M();
        }
        P.tag & p && (M = P.create, P.destroy = M()), P = P.next;
      } while (P !== y);
    }
  }
  function $i(m, p, y) {
    switch (typeof ed == "function" && ed(p), p.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if ((m = p.updateQueue) !== null && (m = m.lastEffect) !== null) {
          var P = m.next;
          xr(97 < y ? 97 : y, function() {
            var M = P;
            do {
              var H = M.destroy;
              if (H !== void 0) {
                var re = p;
                try {
                  H();
                } catch (Se) {
                  Fs(re, Se);
                }
              }
              M = M.next;
            } while (M !== P);
          });
        }
        break;
      case 1:
        M1(p), typeof (y = p.stateNode).componentWillUnmount == "function" && function(M, H) {
          try {
            H.props = M.memoizedProps, H.state = M.memoizedState, H.componentWillUnmount();
          } catch (re) {
            Fs(M, re);
          }
        }(p, y);
        break;
      case 5:
        M1(p);
        break;
      case 4:
        $1(m, p, y);
    }
  }
  function U1(m, p, y) {
    for (var P = p; ; ) if ($i(m, P, y), P.child === null || P.tag === 4) {
      if (P === p) break;
      for (; P.sibling === null; ) {
        if (P.return === null || P.return === p) return;
        P = P.return;
      }
      P.sibling.return = P.return, P = P.sibling;
    } else P.child.return = P, P = P.child;
  }
  function Kn(m) {
    var p = m.alternate;
    m.return = null, m.child = null, m.memoizedState = null, m.updateQueue = null, m.dependencies = null, m.alternate = null, m.firstEffect = null, m.lastEffect = null, m.pendingProps = null, m.memoizedProps = null, p !== null && Kn(p);
  }
  function z1(m) {
    return m.tag === 5 || m.tag === 3 || m.tag === 4;
  }
  function Yc(m) {
    e: {
      for (var p = m.return; p !== null; ) {
        if (z1(p)) {
          var y = p;
          break e;
        }
        p = p.return;
      }
      throw Error(a(160));
    }
    switch (p = y.stateNode, y.tag) {
      case 5:
        var P = !1;
        break;
      case 3:
      case 4:
        p = p.containerInfo, P = !0;
        break;
      default:
        throw Error(a(161));
    }
    16 & y.effectTag && (et(p), y.effectTag &= -17);
    e: t: for (y = m; ; ) {
      for (; y.sibling === null; ) {
        if (y.return === null || z1(y.return)) {
          y = null;
          break e;
        }
        y = y.return;
      }
      for (y.sibling.return = y.return, y = y.sibling; y.tag !== 5 && y.tag !== 6 && y.tag !== 18; ) {
        if (2 & y.effectTag || y.child === null || y.tag === 4) continue t;
        y.child.return = y, y = y.child;
      }
      if (!(2 & y.effectTag)) {
        y = y.stateNode;
        break e;
      }
    }
    for (var M = m; ; ) {
      var H = M.tag === 5 || M.tag === 6;
      if (H) H = H ? M.stateNode : M.stateNode.instance, y ? P ? Ve(p, H, y) : $e(p, H, y) : P ? ye(p, H) : fe(p, H);
      else if (M.tag !== 4 && M.child !== null) {
        M.child.return = M, M = M.child;
        continue;
      }
      if (M === m) break;
      for (; M.sibling === null; ) {
        if (M.return === null || M.return === m) return;
        M = M.return;
      }
      M.sibling.return = M.return, M = M.sibling;
    }
  }
  function $1(m, p, y) {
    for (var P, M, H = p, re = !1; ; ) {
      if (!re) {
        re = H.return;
        e: for (; ; ) {
          if (re === null) throw Error(a(160));
          switch (P = re.stateNode, re.tag) {
            case 5:
              M = !1;
              break e;
            case 3:
            case 4:
              P = P.containerInfo, M = !0;
              break e;
          }
          re = re.return;
        }
        re = !0;
      }
      if (H.tag === 5 || H.tag === 6) U1(m, H, y), M ? wt(P, H.stateNode) : Ze(P, H.stateNode);
      else if (H.tag === 4) {
        if (H.child !== null) {
          P = H.stateNode.containerInfo, M = !0, H.child.return = H, H = H.child;
          continue;
        }
      } else if ($i(m, H, y), H.child !== null) {
        H.child.return = H, H = H.child;
        continue;
      }
      if (H === p) break;
      for (; H.sibling === null; ) {
        if (H.return === null || H.return === p) return;
        (H = H.return).tag === 4 && (re = !1);
      }
      H.sibling.return = H.return, H = H.sibling;
    }
  }
  function V1(m, p) {
    switch (p.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        ml(4, 8, p);
        break;
      case 1:
      case 3:
      case 12:
      case 17:
      case 20:
      case 21:
        break;
      case 5:
        var y = p.stateNode;
        if (y != null) {
          var P = p.memoizedProps;
          m = m !== null ? m.memoizedProps : P;
          var M = p.type, H = p.updateQueue;
          p.updateQueue = null, H !== null && Ge(y, H, M, m, P, p);
        }
        break;
      case 6:
        if (p.stateNode === null) throw Error(a(162));
        y = p.memoizedProps, be(p.stateNode, m !== null ? m.memoizedProps : y, y);
        break;
      case 13:
        (function(re) {
          var Se = re;
          if (re.memoizedState === null) var Ie = !1;
          else Ie = !0, Se = re.child, Kc = M0();
          if (Se !== null) {
            e: if (re = Se, Ne) for (Se = re; ; ) {
              if (Se.tag === 5) {
                var je = Se.stateNode;
                Ie ? W(je) : le(Se.stateNode, Se.memoizedProps);
              } else if (Se.tag === 6) je = Se.stateNode, Ie ? ee(je) : me(je, Se.memoizedProps);
              else {
                if (Se.tag === 13 && Se.memoizedState !== null && Se.memoizedState.dehydrated === null) {
                  (je = Se.child.sibling).return = Se, Se = je;
                  continue;
                }
                if (Se.child !== null) {
                  Se.child.return = Se, Se = Se.child;
                  continue;
                }
              }
              if (Se === re) break e;
              for (; Se.sibling === null; ) {
                if (Se.return === null || Se.return === re) break e;
                Se = Se.return;
              }
              Se.sibling.return = Se.return, Se = Se.sibling;
            }
          }
        })(p), Va(p);
        break;
      case 19:
        Va(p);
        break;
      default:
        throw Error(a(163));
    }
  }
  function Va(m) {
    var p = m.updateQueue;
    if (p !== null) {
      m.updateQueue = null;
      var y = m.stateNode;
      y === null && (y = m.stateNode = new Kh()), p.forEach(function(P) {
        var M = Dm.bind(null, m, P);
        y.has(P) || (y.add(P), P.then(M, M));
      });
    }
  }
  var j1 = typeof WeakMap == "function" ? WeakMap : Map;
  function As(m, p, y) {
    (y = en(y, null)).tag = 3, y.payload = { element: null };
    var P = p.value;
    return y.callback = function() {
      Eu || (Eu = !0, Su = P), gu(m, p);
    }, y;
  }
  function W1(m, p, y) {
    (y = en(y, null)).tag = 3;
    var P = m.type.getDerivedStateFromError;
    if (typeof P == "function") {
      var M = p.value;
      y.payload = function() {
        return gu(m, p), P(M);
      };
    }
    var H = m.stateNode;
    return H !== null && typeof H.componentDidCatch == "function" && (y.callback = function() {
      typeof P != "function" && (ha === null ? ha = /* @__PURE__ */ new Set([this]) : ha.add(this), gu(m, p));
      var re = p.stack;
      this.componentDidCatch(p.value, { componentStack: re !== null ? re : "" });
    }), y;
  }
  var H1, Jh = Math.ceil, vu = o.ReactCurrentDispatcher, Gc = o.ReactCurrentOwner, lr = 0, q1 = 8, yi = 16, wi = 32, wo = 0, Es = 1, bu = 2, xu = 3, yu = 4, Zc = 5, St = lr, $n = null, ht = null, an = 0, Mr = wo, wu = null, ja = 1073741823, _u = 1073741823, Xc = null, Ss = 0, Vi = !1, Kc = 0, Au = 500, ft = null, Eu = !1, Su = null, ha = null, Jc = !1, Cu = null, Cs = 90, _o = null, Wa = 0, Y1 = null, on = 0;
  function Vn() {
    return (St & (yi | wi)) !== lr ? 1073741821 - (M0() / 10 | 0) : on !== 0 ? on : on = 1073741821 - (M0() / 10 | 0);
  }
  function ks(m, p, y) {
    if (!(2 & (p = p.mode))) return 1073741823;
    var P = gn();
    if (!(4 & p)) return P === 99 ? 1073741823 : 1073741822;
    if ((St & yi) !== lr) return an;
    if (y !== null) m = U0(m, 0 | y.timeoutMs || 5e3, 250);
    else switch (P) {
      case 99:
        m = 1073741823;
        break;
      case 98:
        m = U0(m, 150, 100);
        break;
      case 97:
      case 96:
        m = U0(m, 5e3, 250);
        break;
      case 95:
        m = 2;
        break;
      default:
        throw Error(a(326));
    }
    return $n !== null && m === an && --m, m;
  }
  function _i(m, p) {
    if (50 < Wa) throw Wa = 0, Y1 = null, Error(a(185));
    if ((m = Ao(m, p)) !== null) {
      var y = gn();
      p === 1073741823 ? (St & q1) !== lr && (St & (yi | wi)) === lr ? G1(m) : (wn(m), St === lr && h0()) : wn(m), (4 & St) === lr || y !== 98 && y !== 99 || (_o === null ? _o = /* @__PURE__ */ new Map([[m, p]]) : ((y = _o.get(m)) === void 0 || y > p) && _o.set(m, p));
    }
  }
  function Ao(m, p) {
    m.expirationTime < p && (m.expirationTime = p);
    var y = m.alternate;
    y !== null && y.expirationTime < p && (y.expirationTime = p);
    var P = m.return, M = null;
    if (P === null && m.tag === 3) M = m.stateNode;
    else for (; P !== null; ) {
      if (y = P.alternate, P.childExpirationTime < p && (P.childExpirationTime = p), y !== null && y.childExpirationTime < p && (y.childExpirationTime = p), P.return === null && P.tag === 3) {
        M = P.stateNode;
        break;
      }
      P = P.return;
    }
    return M !== null && ($n === M && (gl(p), Mr === yu && Os(M, an)), n2(M, p)), M;
  }
  function Ha(m) {
    var p = m.lastExpiredTime;
    return p !== 0 ? p : ku(m, p = m.firstPendingTime) ? (p = m.lastPingedTime) > (m = m.nextKnownPendingLevel) ? p : m : p;
  }
  function wn(m) {
    if (m.lastExpiredTime !== 0) m.callbackExpirationTime = 1073741823, m.callbackPriority = 99, m.callbackNode = Y0(G1.bind(null, m));
    else {
      var p = Ha(m), y = m.callbackNode;
      if (p === 0) y !== null && (m.callbackNode = null, m.callbackExpirationTime = 0, m.callbackPriority = 90);
      else {
        var P = Vn();
        if (P = p === 1073741823 ? 99 : p === 1 || p === 2 ? 95 : 0 >= (P = 10 * (1073741821 - p) - 10 * (1073741821 - P)) ? 99 : 250 >= P ? 98 : 5250 >= P ? 97 : 95, y !== null) {
          var M = m.callbackPriority;
          if (m.callbackExpirationTime === p && M >= P) return;
          y !== t0 && Mt(y);
        }
        m.callbackExpirationTime = p, m.callbackPriority = P, p = p === 1073741823 ? Y0(G1.bind(null, m)) : vn(P, Qc.bind(null, m), { timeout: 10 * (1073741821 - p) - M0() }), m.callbackNode = p;
      }
    }
  }
  function Qc(m, p) {
    if (on = 0, p) return af(m, p = Vn()), wn(m), null;
    var y = Ha(m);
    if (y !== 0) {
      if (p = m.callbackNode, (St & (yi | wi)) !== lr) throw Error(a(327));
      if (Ts(), m === $n && y === an || jn(m, y), ht !== null) {
        var P = St;
        St |= yi;
        for (var M = tf(); ; ) try {
          Qh();
          break;
        } catch (Se) {
          ef(m, Se);
        }
        if (Yn(), St = P, vu.current = M, Mr === Es) throw p = wu, jn(m, y), Os(m, y), wn(m), p;
        if (ht === null) switch (M = m.finishedWork = m.current.alternate, m.finishedExpirationTime = y, P = Mr, $n = null, P) {
          case wo:
          case Es:
            throw Error(a(345));
          case bu:
            af(m, 2 < y ? 2 : y);
            break;
          case xu:
            if (Os(m, y), y === (P = m.lastSuspendedTime) && (m.nextKnownPendingLevel = K1(M)), ja === 1073741823 && 10 < (M = Kc + Au - M0())) {
              if (Vi) {
                var H = m.lastPingedTime;
                if (H === 0 || H >= y) {
                  m.lastPingedTime = y, jn(m, y);
                  break;
                }
              }
              if ((H = Ha(m)) !== 0 && H !== y) break;
              if (P !== 0 && P !== y) {
                m.lastPingedTime = P;
                break;
              }
              m.timeoutHandle = ce($t.bind(null, m), M);
              break;
            }
            $t(m);
            break;
          case yu:
            if (Os(m, y), y === (P = m.lastSuspendedTime) && (m.nextKnownPendingLevel = K1(M)), Vi && ((M = m.lastPingedTime) === 0 || M >= y)) {
              m.lastPingedTime = y, jn(m, y);
              break;
            }
            if ((M = Ha(m)) !== 0 && M !== y) break;
            if (P !== 0 && P !== y) {
              m.lastPingedTime = P;
              break;
            }
            if (_u !== 1073741823 ? P = 10 * (1073741821 - _u) - M0() : ja === 1073741823 ? P = 0 : (P = 10 * (1073741821 - ja) - 5e3, 0 > (P = (M = M0()) - P) && (P = 0), (y = 10 * (1073741821 - y) - M) < (P = (120 > P ? 120 : 480 > P ? 480 : 1080 > P ? 1080 : 1920 > P ? 1920 : 3e3 > P ? 3e3 : 4320 > P ? 4320 : 1960 * Jh(P / 1960)) - P) && (P = y)), 10 < P) {
              m.timeoutHandle = ce($t.bind(null, m), P);
              break;
            }
            $t(m);
            break;
          case Zc:
            if (ja !== 1073741823 && Xc !== null) {
              H = ja;
              var re = Xc;
              if (0 >= (P = 0 | re.busyMinDurationMs) ? P = 0 : (M = 0 | re.busyDelayMs, P = (H = M0() - (10 * (1073741821 - H) - (0 | re.timeoutMs || 5e3))) <= M ? 0 : M + P - H), 10 < P) {
                Os(m, y), m.timeoutHandle = ce($t.bind(null, m), P);
                break;
              }
            }
            $t(m);
            break;
          default:
            throw Error(a(329));
        }
        if (wn(m), m.callbackNode === p) return Qc.bind(null, m);
      }
    }
    return null;
  }
  function G1(m) {
    var p = m.lastExpiredTime;
    if (p = p !== 0 ? p : 1073741823, m.finishedExpirationTime === p) $t(m);
    else {
      if ((St & (yi | wi)) !== lr) throw Error(a(327));
      if (Ts(), m === $n && p === an || jn(m, p), ht !== null) {
        var y = St;
        St |= yi;
        for (var P = tf(); ; ) try {
          Eo();
          break;
        } catch (M) {
          ef(m, M);
        }
        if (Yn(), St = y, vu.current = P, Mr === Es) throw y = wu, jn(m, p), Os(m, p), wn(m), y;
        if (ht !== null) throw Error(a(261));
        m.finishedWork = m.current.alternate, m.finishedExpirationTime = p, $n = null, $t(m), wn(m);
      }
    }
    return null;
  }
  function Z1(m, p) {
    if ((St & (yi | wi)) !== lr) throw Error(a(187));
    var y = St;
    St |= 1;
    try {
      return xr(99, m.bind(null, p));
    } finally {
      St = y, h0();
    }
  }
  function jn(m, p) {
    m.finishedWork = null, m.finishedExpirationTime = 0;
    var y = m.timeoutHandle;
    if (y !== Me && (m.timeoutHandle = Me, pe(y)), ht !== null) for (y = ht.return; y !== null; ) {
      var P = y;
      switch (P.tag) {
        case 1:
          var M = P.type.childContextTypes;
          M != null && R0();
          break;
        case 3:
          yr(), b0();
          break;
        case 5:
          xs(P);
          break;
        case 4:
          yr();
          break;
        case 13:
        case 19:
          rt(G0);
          break;
        case 10:
          di(P);
      }
      y = y.return;
    }
    $n = m, ht = Ds(m.current, null), an = p, Mr = wo, wu = null, _u = ja = 1073741823, Xc = null, Ss = 0, Vi = !1;
  }
  function ef(m, p) {
    for (; ; ) {
      try {
        if (Yn(), Wr(), ht === null || ht.return === null) return Mr = Es, wu = p, null;
        e: {
          var y = m, P = ht.return, M = ht, H = p;
          if (p = an, M.effectTag |= 2048, M.firstEffect = M.lastEffect = null, H !== null && typeof H == "object" && typeof H.then == "function") {
            var re = H, Se = (1 & G0.current) != 0, Ie = P;
            do {
              var je;
              if (je = Ie.tag === 13) {
                var vt = Ie.memoizedState;
                if (vt !== null) je = vt.dehydrated !== null;
                else {
                  var ur = Ie.memoizedProps;
                  je = ur.fallback !== void 0 && (ur.unstable_avoidThisFallback !== !0 || !Se);
                }
              }
              if (je) {
                var C0 = Ie.updateQueue;
                if (C0 === null) {
                  var Jn = /* @__PURE__ */ new Set();
                  Jn.add(re), Ie.updateQueue = Jn;
                } else C0.add(re);
                if (!(2 & Ie.mode)) {
                  if (Ie.effectTag |= 64, M.effectTag &= -2981, M.tag === 1) if (M.alternate === null) M.tag = 17;
                  else {
                    var Rs = en(1073741823, null);
                    Rs.tag = 2, Nn(M, Rs);
                  }
                  M.expirationTime = 1073741823;
                  break e;
                }
                H = void 0, M = p;
                var Qn = y.pingCache;
                if (Qn === null ? (Qn = y.pingCache = new j1(), H = /* @__PURE__ */ new Set(), Qn.set(re, H)) : (H = Qn.get(re)) === void 0 && (H = /* @__PURE__ */ new Set(), Qn.set(re, H)), !H.has(M)) {
                  H.add(M);
                  var Ce = Fm.bind(null, y, re, M);
                  re.then(Ce, Ce);
                }
                Ie.effectTag |= 4096, Ie.expirationTime = p;
                break e;
              }
              Ie = Ie.return;
            } while (Ie !== null);
            H = Error((R(M.type) || "A React component") + ` suspended while rendering, but no fallback UI was specified.

Add a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.` + Pe(M));
          }
          Mr !== Zc && (Mr = bu), H = Hc(H, M), Ie = P;
          do {
            switch (Ie.tag) {
              case 3:
                re = H, Ie.effectTag |= 4096, Ie.expirationTime = p, ms(Ie, As(Ie, re, p));
                break e;
              case 1:
                re = H;
                var we = Ie.type, Fe = Ie.stateNode;
                if (!(64 & Ie.effectTag) && (typeof we.getDerivedStateFromError == "function" || Fe !== null && typeof Fe.componentDidCatch == "function" && (ha === null || !ha.has(Fe)))) {
                  Ie.effectTag |= 4096, Ie.expirationTime = p, ms(Ie, W1(Ie, re, p));
                  break e;
                }
            }
            Ie = Ie.return;
          } while (Ie !== null);
        }
        ht = X1(ht);
      } catch (dt) {
        p = dt;
        continue;
      }
      break;
    }
  }
  function tf() {
    var m = vu.current;
    return vu.current = hu, m === null ? hu : m;
  }
  function rf(m, p) {
    m < ja && 2 < m && (ja = m), p !== null && m < _u && 2 < m && (_u = m, Xc = p);
  }
  function gl(m) {
    m > Ss && (Ss = m);
  }
  function Eo() {
    for (; ht !== null; ) ht = e2(ht);
  }
  function Qh() {
    for (; ht !== null && !Rt(); ) ht = e2(ht);
  }
  function e2(m) {
    var p = H1(m.alternate, m, an);
    return m.memoizedProps = m.pendingProps, p === null && (p = X1(m)), Gc.current = null, p;
  }
  function X1(m) {
    ht = m;
    do {
      var p = ht.alternate;
      if (m = ht.return, (2048 & ht.effectTag) == 0) {
        e: {
          var y = p, P = an, M = (p = ht).pendingProps;
          switch (p.tag) {
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
            case 20:
            case 21:
              break;
            case 1:
            case 17:
              ot(p.type) && R0();
              break;
            case 3:
              yr(), b0(), (M = p.stateNode).pendingContext && (M.context = M.pendingContext, M.pendingContext = null), y === null || y.child, xi(p);
              break;
            case 5:
              xs(p);
              var H = bi(Li.current);
              if (P = p.type, y !== null && p.stateNode != null) N1(y, p, P, M, H), y.ref !== p.ref && (p.effectTag |= 128);
              else if (M) {
                y = bi(xn.current);
                var re = Q(P, M, H, y, p);
                L1(re, p, !1, !1), p.stateNode = re, se(re, P, M, H, y) && xo(p), p.ref !== null && (p.effectTag |= 128);
              } else if (p.stateNode === null) throw Error(a(166));
              break;
            case 6:
              if (y && p.stateNode != null) ws(y, p, y.memoizedProps, M);
              else {
                if (typeof M != "string" && p.stateNode === null) throw Error(a(166));
                y = bi(Li.current), H = bi(xn.current), p.stateNode = ne(M, y, H, p);
              }
              break;
            case 13:
              if (rt(G0), M = p.memoizedState, (64 & p.effectTag) != 0) {
                p.expirationTime = P;
                break e;
              }
              M = M !== null, H = !1, y === null ? p.memoizedProps.fallback : (H = (P = y.memoizedState) !== null, M || P === null || (P = y.child.sibling) !== null && ((re = p.firstEffect) !== null ? (p.firstEffect = P, P.nextEffect = re) : (p.firstEffect = p.lastEffect = P, P.nextEffect = null), P.effectTag = 8)), M && !H && 2 & p.mode && (y === null && p.memoizedProps.unstable_avoidThisFallback !== !0 || 1 & G0.current ? Mr === wo && (Mr = xu) : (Mr !== wo && Mr !== xu || (Mr = yu), Ss !== 0 && $n !== null && (Os($n, an), n2($n, Ss)))), (M || H) && (p.effectTag |= 4);
              break;
            case 4:
              yr(), xi(p);
              break;
            case 10:
              di(p);
              break;
            case 19:
              if (rt(G0), (M = p.memoizedState) === null) break;
              if (H = (64 & p.effectTag) != 0, (re = M.rendering) === null) {
                if (H) yo(M, !1);
                else if (Mr !== wo || y !== null && 64 & y.effectTag) for (y = p.child; y !== null; ) {
                  if ((re = ca(y)) !== null) {
                    for (p.effectTag |= 64, yo(M, !1), (y = re.updateQueue) !== null && (p.updateQueue = y, p.effectTag |= 4), M.lastEffect === null && (p.firstEffect = null), p.lastEffect = M.lastEffect, y = P, M = p.child; M !== null; ) P = y, (H = M).effectTag &= 2, H.nextEffect = null, H.firstEffect = null, H.lastEffect = null, (re = H.alternate) === null ? (H.childExpirationTime = 0, H.expirationTime = P, H.child = null, H.memoizedProps = null, H.memoizedState = null, H.updateQueue = null, H.dependencies = null) : (H.childExpirationTime = re.childExpirationTime, H.expirationTime = re.expirationTime, H.child = re.child, H.memoizedProps = re.memoizedProps, H.memoizedState = re.memoizedState, H.updateQueue = re.updateQueue, P = re.dependencies, H.dependencies = P === null ? null : { expirationTime: P.expirationTime, firstContext: P.firstContext, responders: P.responders }), M = M.sibling;
                    gt(G0, 1 & G0.current | 2), p = p.child;
                    break e;
                  }
                  y = y.sibling;
                }
              } else {
                if (!H) if ((y = ca(re)) !== null) {
                  if (p.effectTag |= 64, H = !0, (y = y.updateQueue) !== null && (p.updateQueue = y, p.effectTag |= 4), yo(M, !0), M.tail === null && M.tailMode === "hidden") {
                    (p = p.lastEffect = M.lastEffect) !== null && (p.nextEffect = null);
                    break;
                  }
                } else M0() > M.tailExpiration && 1 < P && (p.effectTag |= 64, H = !0, yo(M, !1), p.expirationTime = p.childExpirationTime = P - 1);
                M.isBackwards ? (re.sibling = p.child, p.child = re) : ((y = M.last) !== null ? y.sibling = re : p.child = re, M.last = re);
              }
              if (M.tail !== null) {
                M.tailExpiration === 0 && (M.tailExpiration = M0() + 500), y = M.tail, M.rendering = y, M.tail = y.sibling, M.lastEffect = p.lastEffect, y.sibling = null, M = G0.current, gt(G0, M = H ? 1 & M | 2 : 1 & M), p = y;
                break e;
              }
              break;
            default:
              throw Error(a(156, p.tag));
          }
          p = null;
        }
        if (y = ht, an === 1 || y.childExpirationTime !== 1) {
          for (M = 0, H = y.child; H !== null; ) (P = H.expirationTime) > M && (M = P), (re = H.childExpirationTime) > M && (M = re), H = H.sibling;
          y.childExpirationTime = M;
        }
        if (p !== null) return p;
        m !== null && !(2048 & m.effectTag) && (m.firstEffect === null && (m.firstEffect = ht.firstEffect), ht.lastEffect !== null && (m.lastEffect !== null && (m.lastEffect.nextEffect = ht.firstEffect), m.lastEffect = ht.lastEffect), 1 < ht.effectTag && (m.lastEffect !== null ? m.lastEffect.nextEffect = ht : m.firstEffect = ht, m.lastEffect = ht));
      } else {
        if ((p = pl(ht)) !== null) return p.effectTag &= 2047, p;
        m !== null && (m.firstEffect = m.lastEffect = null, m.effectTag |= 2048);
      }
      if ((p = ht.sibling) !== null) return p;
      ht = m;
    } while (ht !== null);
    return Mr === wo && (Mr = Zc), null;
  }
  function K1(m) {
    var p = m.expirationTime;
    return p > (m = m.childExpirationTime) ? p : m;
  }
  function $t(m) {
    var p = gn();
    return xr(99, J1.bind(null, m, p)), null;
  }
  function J1(m, p) {
    if (Ts(), (St & (yi | wi)) !== lr) throw Error(a(327));
    var y = m.finishedWork, P = m.finishedExpirationTime;
    if (y === null) return null;
    if (m.finishedWork = null, m.finishedExpirationTime = 0, y === m.current) throw Error(a(177));
    m.callbackNode = null, m.callbackExpirationTime = 0, m.callbackPriority = 90, m.nextKnownPendingLevel = 0;
    var M = K1(y);
    if (m.firstPendingTime = M, P <= m.lastSuspendedTime ? m.firstSuspendedTime = m.lastSuspendedTime = m.nextKnownPendingLevel = 0 : P <= m.firstSuspendedTime && (m.firstSuspendedTime = P - 1), P <= m.lastPingedTime && (m.lastPingedTime = 0), P <= m.lastExpiredTime && (m.lastExpiredTime = 0), m === $n && (ht = $n = null, an = 0), 1 < y.effectTag ? y.lastEffect !== null ? (y.lastEffect.nextEffect = y, M = y.firstEffect) : M = y : M = y.firstEffect, M !== null) {
      var H = St;
      St |= wi, Gc.current = null, Y(m.containerInfo), ft = M;
      do
        try {
          nf();
        } catch (p0) {
          if (ft === null) throw Error(a(330));
          Fs(ft, p0), ft = ft.nextEffect;
        }
      while (ft !== null);
      ft = M;
      do
        try {
          for (var re = m, Se = p; ft !== null; ) {
            var Ie = ft.effectTag;
            if (16 & Ie && Ne && et(ft.stateNode), 128 & Ie) {
              var je = ft.alternate;
              if (je !== null) {
                var vt = je.ref;
                vt !== null && (typeof vt == "function" ? vt(null) : vt.current = null);
              }
            }
            switch (1038 & Ie) {
              case 2:
                Yc(ft), ft.effectTag &= -3;
                break;
              case 6:
                Yc(ft), ft.effectTag &= -3, V1(ft.alternate, ft);
                break;
              case 1024:
                ft.effectTag &= -1025;
                break;
              case 1028:
                ft.effectTag &= -1025, V1(ft.alternate, ft);
                break;
              case 4:
                V1(ft.alternate, ft);
                break;
              case 8:
                var ur = re, C0 = ft, Jn = Se;
                Ne ? $1(ur, C0, Jn) : U1(ur, C0, Jn), Kn(C0);
            }
            ft = ft.nextEffect;
          }
        } catch (p0) {
          if (ft === null) throw Error(a(330));
          Fs(ft, p0), ft = ft.nextEffect;
        }
      while (ft !== null);
      Z(m.containerInfo), m.current = y, ft = M;
      do
        try {
          for (Ie = P; ft !== null; ) {
            var Rs = ft.effectTag;
            if (36 & Rs) {
              var Qn = ft.alternate;
              switch (vt = Ie, (je = ft).tag) {
                case 0:
                case 11:
                case 15:
                  ml(16, 32, je);
                  break;
                case 1:
                  var Ce = je.stateNode;
                  if (4 & je.effectTag) if (Qn === null) Ce.componentDidMount();
                  else {
                    var we = je.elementType === je.type ? Qn.memoizedProps : P0(je.type, Qn.memoizedProps);
                    Ce.componentDidUpdate(we, Qn.memoizedState, Ce.__reactInternalSnapshotBeforeUpdate);
                  }
                  var Fe = je.updateQueue;
                  Fe !== null && Oa(0, Fe, Ce);
                  break;
                case 3:
                  var dt = je.updateQueue;
                  if (dt !== null) {
                    if (re = null, je.child !== null) switch (je.child.tag) {
                      case 5:
                        re = S(je.child.stateNode);
                        break;
                      case 1:
                        re = je.child.stateNode;
                    }
                    Oa(0, dt, re);
                  }
                  break;
                case 5:
                  var Ft = je.stateNode;
                  Qn === null && 4 & je.effectTag && he(Ft, je.type, je.memoizedProps, je);
                  break;
                case 6:
                case 4:
                case 12:
                case 19:
                case 17:
                case 20:
                case 21:
                  break;
                case 13:
                  it && je.memoizedState;
                  break;
                default:
                  throw Error(a(163));
              }
            }
            if (128 & Rs) {
              je = void 0;
              var k0 = ft.ref;
              if (k0 !== null) {
                var Pt = ft.stateNode;
                je = ft.tag === 5 ? S(Pt) : Pt, typeof k0 == "function" ? k0(je) : k0.current = je;
              }
            }
            ft = ft.nextEffect;
          }
        } catch (p0) {
          if (ft === null) throw Error(a(330));
          Fs(ft, p0), ft = ft.nextEffect;
        }
      while (ft !== null);
      ft = null, Q0(), St = H;
    } else m.current = y;
    if (Jc) Jc = !1, Cu = m, Cs = p;
    else for (ft = M; ft !== null; ) p = ft.nextEffect, ft.nextEffect = null, ft = p;
    if ((p = m.firstPendingTime) === 0 && (ha = null), p === 1073741823 ? m === Y1 ? Wa++ : (Wa = 0, Y1 = m) : Wa = 0, typeof Q1 == "function" && Q1(y.stateNode, P), wn(m), Eu) throw Eu = !1, m = Su, Su = null, m;
    return (St & q1) !== lr || h0(), null;
  }
  function nf() {
    for (; ft !== null; ) {
      var m = ft.effectTag;
      256 & m && qc(ft.alternate, ft), !(512 & m) || Jc || (Jc = !0, vn(97, function() {
        return Ts(), null;
      })), ft = ft.nextEffect;
    }
  }
  function Ts() {
    if (Cs !== 90) {
      var m = 97 < Cs ? 97 : Cs;
      return Cs = 90, xr(m, Tm);
    }
  }
  function Tm() {
    if (Cu === null) return !1;
    var m = Cu;
    if (Cu = null, (St & (yi | wi)) !== lr) throw Error(a(331));
    var p = St;
    for (St |= wi, m = m.current.firstEffect; m !== null; ) {
      try {
        var y = m;
        if (512 & y.effectTag) switch (y.tag) {
          case 0:
          case 11:
          case 15:
            ml(128, 0, y), ml(0, 64, y);
        }
      } catch (P) {
        if (m === null) throw Error(a(330));
        Fs(m, P);
      }
      y = m.nextEffect, m.nextEffect = null, m = y;
    }
    return St = p, h0(), !0;
  }
  function t2(m, p, y) {
    Nn(m, p = As(m, p = Hc(y, p), 1073741823)), (m = Ao(m, 1073741823)) !== null && wn(m);
  }
  function Fs(m, p) {
    if (m.tag === 3) t2(m, m, p);
    else for (var y = m.return; y !== null; ) {
      if (y.tag === 3) {
        t2(y, m, p);
        break;
      }
      if (y.tag === 1) {
        var P = y.stateNode;
        if (typeof y.type.getDerivedStateFromError == "function" || typeof P.componentDidCatch == "function" && (ha === null || !ha.has(P))) {
          Nn(y, m = W1(y, m = Hc(p, m), 1073741823)), (y = Ao(y, 1073741823)) !== null && wn(y);
          break;
        }
      }
      y = y.return;
    }
  }
  function Fm(m, p, y) {
    var P = m.pingCache;
    P !== null && P.delete(p), $n === m && an === y ? Mr === yu || Mr === xu && ja === 1073741823 && M0() - Kc < Au ? jn(m, an) : Vi = !0 : ku(m, y) && ((p = m.lastPingedTime) !== 0 && p < y || (m.lastPingedTime = y, m.finishedExpirationTime === y && (m.finishedExpirationTime = 0, m.finishedWork = null), wn(m)));
  }
  function Dm(m, p) {
    var y = m.stateNode;
    y !== null && y.delete(p), (p = 0) == 0 && (p = ks(p = Vn(), m, null)), (m = Ao(m, p)) !== null && wn(m);
  }
  H1 = function(m, p, y) {
    var P = p.expirationTime;
    if (m !== null) {
      var M = p.pendingProps;
      if (m.memoizedProps !== M || At.current) Ui = !0;
      else {
        if (P < y) {
          switch (Ui = !1, p.tag) {
            case 3:
              zi(p);
              break;
            case 5:
              if (bs(p), 4 & p.mode && y !== 1 && null(p.type, M)) return p.expirationTime = p.childExpirationTime = 1, null;
              break;
            case 1:
              ot(p.type) && e0(p);
              break;
            case 4:
              vo(p, p.stateNode.containerInfo);
              break;
            case 10:
              fi(p, p.memoizedProps.value);
              break;
            case 13:
              if (p.memoizedState !== null) return (P = p.child.childExpirationTime) !== 0 && P >= y ? _s(m, p, y) : (gt(G0, 1 & G0.current), (p = da(m, p, y)) !== null ? p.sibling : null);
              gt(G0, 1 & G0.current);
              break;
            case 19:
              if (P = p.childExpirationTime >= y, (64 & m.effectTag) != 0) {
                if (P) return $a(m, p, y);
                p.effectTag |= 64;
              }
              if ((M = p.memoizedState) !== null && (M.rendering = null, M.tail = null), gt(G0, G0.current), !P) return null;
          }
          return da(m, p, y);
        }
        Ui = !1;
      }
    } else Ui = !1;
    switch (p.expirationTime = 0, p.tag) {
      case 2:
        if (P = p.type, m !== null && (m.alternate = null, p.alternate = null, p.effectTag |= 2), m = p.pendingProps, M = Je(p, Bt.current), aa(p, y), M = o0(null, p, P, m, M, y), p.effectTag |= 1, typeof M == "object" && M !== null && typeof M.render == "function" && M.$$typeof === void 0) {
          if (p.tag = 1, Wr(), ot(P)) {
            var H = !0;
            e0(p);
          } else H = !1;
          p.memoizedState = M.state !== null && M.state !== void 0 ? M.state : null;
          var re = P.getDerivedStateFromProps;
          typeof re == "function" && Ra(p, P, re, m), M.updater = go, p.stateNode = M, M._reactInternalFiber = p, mi(p, P, m, y), p = pu(null, p, P, !0, H, y);
        } else p.tag = 0, Xn(null, p, M, y), p = p.child;
        return p;
      case 16:
        if (M = p.elementType, m !== null && (m.alternate = null, p.alternate = null, p.effectTag |= 2), m = p.pendingProps, function(vt) {
          if (vt._status === -1) {
            vt._status = 0;
            var ur = vt._ctor;
            ur = ur(), vt._result = ur, ur.then(function(C0) {
              vt._status === 0 && (C0 = C0.default, vt._status = 1, vt._result = C0);
            }, function(C0) {
              vt._status === 0 && (vt._status = 2, vt._result = C0);
            });
          }
        }(M), M._status !== 1) throw M._result;
        switch (M = M._result, p.type = M, H = p.tag = function(vt) {
          if (typeof vt == "function") return td(vt) ? 1 : 0;
          if (vt != null) {
            if ((vt = vt.$$typeof) === T) return 11;
            if (vt === C) return 14;
          }
          return 2;
        }(M), m = P0(M, m), H) {
          case 0:
            p = za(null, p, M, m, y);
            break;
          case 1:
            p = B1(null, p, M, m, y);
            break;
          case 11:
            p = Vc(null, p, M, m, y);
            break;
          case 14:
            p = jc(null, p, M, P0(M.type, m), P, y);
            break;
          default:
            throw Error(a(306, M, ""));
        }
        return p;
      case 0:
        return P = p.type, M = p.pendingProps, za(m, p, P, M = p.elementType === P ? M : P0(P, M), y);
      case 1:
        return P = p.type, M = p.pendingProps, B1(m, p, P, M = p.elementType === P ? M : P0(P, M), y);
      case 3:
        if (zi(p), (P = p.updateQueue) === null) throw Error(a(282));
        if (M = (M = p.memoizedState) !== null ? M.element : null, oa(p, P, p.pendingProps, null, y), (P = p.memoizedState.element) === M) p = da(m, p, y);
        else {
          if ((M = p.stateNode.hydrate) && (M = !1), M) for (y = or(p, null, P, y), p.child = y; y; ) y.effectTag = -3 & y.effectTag | 1024, y = y.sibling;
          else Xn(m, p, P, y);
          p = p.child;
        }
        return p;
      case 5:
        return bs(p), P = p.type, M = p.pendingProps, H = m !== null ? m.memoizedProps : null, re = M.children, te(P, M) ? re = null : H !== null && te(P, H) && (p.effectTag |= 16), I1(m, p), 4 & p.mode && y !== 1 && null(P, M) ? (p.expirationTime = p.childExpirationTime = 1, p = null) : (Xn(m, p, re, y), p = p.child), p;
      case 6:
        return null;
      case 13:
        return _s(m, p, y);
      case 4:
        return vo(p, p.stateNode.containerInfo), P = p.pendingProps, m === null ? p.child = la(p, null, P, y) : Xn(m, p, P, y), p.child;
      case 11:
        return P = p.type, M = p.pendingProps, Vc(m, p, P, M = p.elementType === P ? M : P0(P, M), y);
      case 7:
        return Xn(m, p, p.pendingProps, y), p.child;
      case 8:
      case 12:
        return Xn(m, p, p.pendingProps.children, y), p.child;
      case 10:
        e: {
          if (P = p.type._context, M = p.pendingProps, re = p.memoizedProps, fi(p, H = M.value), re !== null) {
            var Se = re.value;
            if ((H = ar(Se, H) ? 0 : 0 | (typeof P._calculateChangedBits == "function" ? P._calculateChangedBits(Se, H) : 1073741823)) == 0) {
              if (re.children === M.children && !At.current) {
                p = da(m, p, y);
                break e;
              }
            } else for ((Se = p.child) !== null && (Se.return = p); Se !== null; ) {
              var Ie = Se.dependencies;
              if (Ie !== null) {
                re = Se.child;
                for (var je = Ie.firstContext; je !== null; ) {
                  if (je.context === P && je.observedBits & H) {
                    Se.tag === 1 && ((je = en(y, null)).tag = 2, Nn(Se, je)), Se.expirationTime < y && (Se.expirationTime = y), (je = Se.alternate) !== null && je.expirationTime < y && (je.expirationTime = y), ho(Se.return, y), Ie.expirationTime < y && (Ie.expirationTime = y);
                    break;
                  }
                  je = je.next;
                }
              } else re = Se.tag === 10 && Se.type === p.type ? null : Se.child;
              if (re !== null) re.return = Se;
              else for (re = Se; re !== null; ) {
                if (re === p) {
                  re = null;
                  break;
                }
                if ((Se = re.sibling) !== null) {
                  Se.return = re.return, re = Se;
                  break;
                }
                re = re.return;
              }
              Se = re;
            }
          }
          Xn(m, p, M.children, y), p = p.child;
        }
        return p;
      case 9:
        return M = p.type, P = (H = p.pendingProps).children, aa(p, y), P = P(M = Qr(M, H.unstable_observedBits)), p.effectTag |= 1, Xn(m, p, P, y), p.child;
      case 14:
        return H = P0(M = p.type, p.pendingProps), jc(m, p, M, H = P0(M.type, H), P, y);
      case 15:
        return P1(m, p, p.type, p.pendingProps, P, y);
      case 17:
        return P = p.type, M = p.pendingProps, M = p.elementType === P ? M : P0(P, M), m !== null && (m.alternate = null, p.alternate = null, p.effectTag |= 2), p.tag = 1, ot(P) ? (m = !0, e0(p)) : m = !1, aa(p, y), vs(p, P, M), mi(p, P, M, y), pu(null, p, P, !0, m, y);
      case 19:
        return $a(m, p, y);
    }
    throw Error(a(156, p.tag));
  };
  var Q1 = null, ed = null;
  function r2(m, p, y, P) {
    this.tag = m, this.key = y, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = p, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = P, this.effectTag = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childExpirationTime = this.expirationTime = 0, this.alternate = null;
  }
  function qa(m, p, y, P) {
    return new r2(m, p, y, P);
  }
  function td(m) {
    return !(!(m = m.prototype) || !m.isReactComponent);
  }
  function Ds(m, p) {
    var y = m.alternate;
    return y === null ? ((y = qa(m.tag, p, m.key, m.mode)).elementType = m.elementType, y.type = m.type, y.stateNode = m.stateNode, y.alternate = m, m.alternate = y) : (y.pendingProps = p, y.effectTag = 0, y.nextEffect = null, y.firstEffect = null, y.lastEffect = null), y.childExpirationTime = m.childExpirationTime, y.expirationTime = m.expirationTime, y.child = m.child, y.memoizedProps = m.memoizedProps, y.memoizedState = m.memoizedState, y.updateQueue = m.updateQueue, p = m.dependencies, y.dependencies = p === null ? null : { expirationTime: p.expirationTime, firstContext: p.firstContext, responders: p.responders }, y.sibling = m.sibling, y.index = m.index, y.ref = m.ref, y;
  }
  function vl(m, p, y, P, M, H) {
    var re = 2;
    if (P = m, typeof m == "function") td(m) && (re = 1);
    else if (typeof m == "string") re = 5;
    else e: switch (m) {
      case d:
        return ji(y.children, M, H, p);
      case A:
        re = 8, M |= 7;
        break;
      case h:
        re = 8, M |= 1;
        break;
      case v:
        return (m = qa(12, y, p, 8 | M)).elementType = v, m.type = v, m.expirationTime = H, m;
      case k:
        return (m = qa(13, y, p, M)).type = k, m.elementType = k, m.expirationTime = H, m;
      case E:
        return (m = qa(19, y, p, M)).elementType = E, m.expirationTime = H, m;
      default:
        if (typeof m == "object" && m !== null) switch (m.$$typeof) {
          case b:
            re = 10;
            break e;
          case x:
            re = 9;
            break e;
          case T:
            re = 11;
            break e;
          case C:
            re = 14;
            break e;
          case D:
            re = 16, P = null;
            break e;
        }
        throw Error(a(130, m == null ? m : typeof m, ""));
    }
    return (p = qa(re, y, p, M)).elementType = m, p.type = P, p.expirationTime = H, p;
  }
  function ji(m, p, y, P) {
    return (m = qa(7, m, P, p)).expirationTime = y, m;
  }
  function rd(m, p, y) {
    return (m = qa(6, m, null, p)).expirationTime = y, m;
  }
  function nd(m, p, y) {
    return (p = qa(4, m.children !== null ? m.children : [], m.key, p)).expirationTime = y, p.stateNode = { containerInfo: m.containerInfo, pendingChildren: null, implementation: m.implementation }, p;
  }
  function So(m, p, y) {
    this.tag = p, this.current = null, this.containerInfo = m, this.pingCache = this.pendingChildren = null, this.finishedExpirationTime = 0, this.finishedWork = null, this.timeoutHandle = Me, this.pendingContext = this.context = null, this.hydrate = y, this.callbackNode = null, this.callbackPriority = 90, this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
  }
  function ku(m, p) {
    var y = m.firstSuspendedTime;
    return m = m.lastSuspendedTime, y !== 0 && y >= p && m <= p;
  }
  function Os(m, p) {
    var y = m.firstSuspendedTime, P = m.lastSuspendedTime;
    y < p && (m.firstSuspendedTime = p), (P > p || y === 0) && (m.lastSuspendedTime = p), p <= m.lastPingedTime && (m.lastPingedTime = 0), p <= m.lastExpiredTime && (m.lastExpiredTime = 0);
  }
  function n2(m, p) {
    p > m.firstPendingTime && (m.firstPendingTime = p);
    var y = m.firstSuspendedTime;
    y !== 0 && (p >= y ? m.firstSuspendedTime = m.lastSuspendedTime = m.nextKnownPendingLevel = 0 : p >= m.lastSuspendedTime && (m.lastSuspendedTime = p + 1), p > m.nextKnownPendingLevel && (m.nextKnownPendingLevel = p));
  }
  function af(m, p) {
    var y = m.lastExpiredTime;
    (y === 0 || y > p) && (m.lastExpiredTime = p);
  }
  function i2(m) {
    var p = m._reactInternalFiber;
    if (p === void 0)
      throw typeof m.render == "function" ? Error(a(188)) : Error(a(268, Object.keys(m)));
    return (m = j(p)) === null ? null : m.stateNode;
  }
  function id(m, p) {
    (m = m.memoizedState) !== null && m.dehydrated !== null && m.retryTime < p && (m.retryTime = p);
  }
  function of(m, p) {
    id(m, p), (m = m.alternate) && id(m, p);
  }
  var ad = { createContainer: function(m, p, y) {
    return m = new So(m, p, y), p = qa(3, null, null, p === 2 ? 7 : p === 1 ? 3 : 0), m.current = p, p.stateNode = m;
  }, updateContainer: function(m, p, y, P) {
    var M = p.current, H = Vn(), re = pi.suspense;
    H = ks(H, M, re);
    e: if (y) {
      t: {
        if (U(y = y._reactInternalFiber) !== y || y.tag !== 1) throw Error(a(170));
        var Se = y;
        do {
          switch (Se.tag) {
            case 3:
              Se = Se.stateNode.context;
              break t;
            case 1:
              if (ot(Se.type)) {
                Se = Se.stateNode.__reactInternalMemoizedMergedChildContext;
                break t;
              }
          }
          Se = Se.return;
        } while (Se !== null);
        throw Error(a(171));
      }
      if (y.tag === 1) {
        var Ie = y.type;
        if (ot(Ie)) {
          y = a0(y, Ie, Se);
          break e;
        }
      }
      y = Se;
    } else y = _t;
    return p.context === null ? p.context = y : p.pendingContext = y, (p = en(H, re)).payload = { element: m }, (P = P === void 0 ? null : P) !== null && (p.callback = P), Nn(M, p), _i(M, H), H;
  }, batchedEventUpdates: function(m, p) {
    var y = St;
    St |= 2;
    try {
      return m(p);
    } finally {
      (St = y) === lr && h0();
    }
  }, batchedUpdates: function(m, p) {
    var y = St;
    St |= 1;
    try {
      return m(p);
    } finally {
      (St = y) === lr && h0();
    }
  }, unbatchedUpdates: function(m, p) {
    var y = St;
    St &= -2, St |= q1;
    try {
      return m(p);
    } finally {
      (St = y) === lr && h0();
    }
  }, deferredUpdates: function(m) {
    return xr(97, m);
  }, syncUpdates: function(m, p, y, P) {
    return xr(99, m.bind(null, p, y, P));
  }, discreteUpdates: function(m, p, y, P) {
    var M = St;
    St |= 4;
    try {
      return xr(98, m.bind(null, p, y, P));
    } finally {
      (St = M) === lr && h0();
    }
  }, flushDiscreteUpdates: function() {
    (St & (1 | yi | wi)) === lr && (function() {
      if (_o !== null) {
        var m = _o;
        _o = null, m.forEach(function(p, y) {
          af(y, p), wn(y);
        }), h0();
      }
    }(), Ts());
  }, flushControlled: function(m) {
    var p = St;
    St |= 1;
    try {
      xr(99, m);
    } finally {
      (St = p) === lr && h0();
    }
  }, flushSync: Z1, flushPassiveEffects: Ts, IsThisRendererActing: { current: !1 }, getPublicRootInstance: function(m) {
    return (m = m.current).child ? m.child.tag === 5 ? S(m.child.stateNode) : m.child.stateNode : null;
  }, attemptSynchronousHydration: function(m) {
    switch (m.tag) {
      case 3:
        var p = m.stateNode;
        p.hydrate && function(y, P) {
          af(y, P), wn(y), (St & (yi | wi)) === lr && h0();
        }(p, p.firstPendingTime);
        break;
      case 13:
        Z1(function() {
          return _i(m, 1073741823);
        }), p = U0(Vn(), 150, 100), of(m, p);
    }
  }, attemptUserBlockingHydration: function(m) {
    if (m.tag === 13) {
      var p = U0(Vn(), 150, 100);
      _i(m, p), of(m, p);
    }
  }, attemptContinuousHydration: function(m) {
    if (m.tag === 13) {
      Vn();
      var p = Ut++;
      _i(m, p), of(m, p);
    }
  }, attemptHydrationAtCurrentPriority: function(m) {
    if (m.tag === 13) {
      var p = Vn();
      _i(m, p = ks(p, m, null)), of(m, p);
    }
  }, findHostInstance: i2, findHostInstanceWithWarning: function(m) {
    return i2(m);
  }, findHostInstanceWithNoPortals: function(m) {
    return (m = function(p) {
      if (!(p = z(p))) return null;
      for (var y = p; ; ) {
        if (y.tag === 5 || y.tag === 6) return y;
        if (y.child && y.tag !== 4) y.child.return = y, y = y.child;
        else {
          if (y === p) break;
          for (; !y.sibling; ) {
            if (!y.return || y.return === p) return null;
            y = y.return;
          }
          y.sibling.return = y.return, y = y.sibling;
        }
      }
      return null;
    }(m)) === null ? null : m.tag === 20 ? m.stateNode.instance : m.stateNode;
  }, shouldSuspend: function() {
    return !1;
  }, injectIntoDevTools: function(m) {
    var p = m.findFiberByHostInstance;
    return function(y) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1;
      var P = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (P.isDisabled || !P.supportsFiber) return !0;
      try {
        var M = P.inject(y);
        Q1 = function(H) {
          try {
            P.onCommitFiberRoot(M, H, void 0, (64 & H.current.effectTag) == 64);
          } catch {
          }
        }, ed = function(H) {
          try {
            P.onCommitFiberUnmount(M, H);
          } catch {
          }
        };
      } catch {
      }
      return !0;
    }(r({}, m, { overrideHookState: null, overrideProps: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: o.ReactCurrentDispatcher, findHostInstanceByFiber: function(y) {
      return (y = j(y)) === null ? null : y.stateNode;
    }, findFiberByHostInstance: function(y) {
      return p ? p(y) : null;
    }, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null }));
  } };
  q2.exports = ad.default || ad;
  var Om = q2.exports;
  return q2.exports = t, Om;
};
Tne(rF.exports);
Ye.version.startsWith("19");
const One = new Ere(), Rne = One, Pne = {
  create: (t) => t
}, Ine = (t) => {
  t.register({
    family: "Inter",
    src: "https://fonts.gstatic.com/s/inter/v18/UcCO3FwrK3iLTeHuS_nVMrMxCp50yjIw2boKoduKmMEVuLyfMZg.ttf"
  }), t.register({
    family: "Inter-SemiBold",
    src: "https://fonts.gstatic.com/s/inter/v18/UcCO3FwrK3iLTeHuS_nVMrMxCp50yjIw2boKoduKmMEVuGKYMZg.ttf"
  });
}, Pie = ({
  size: t = "A4",
  style: e,
  title: r,
  ...n
}) => {
  Ye.useEffect(() => {
    Ine(Rne);
  }, []);
  const i = {
    paddingLeft: "2.5cm",
    paddingRight: "2.5cm",
    paddingTop: "1.15cm",
    paddingBottom: "1.30cm"
  }, a = (Array.isArray(e) ? [i, ...e] : [i, e]).filter(
    (o) => o !== void 0
  );
  return /* @__PURE__ */ X.jsx(MM, { author: "https://api.forms.saas.dev.au.rptau.net", title: r, creationDate: /* @__PURE__ */ new Date(), children: /* @__PURE__ */ X.jsx(NM, { size: t, style: a, ...n }) });
}, Ol = Pne.create({
  page: {
    flexDirection: "column",
    fontFamily: "Inter",
    color: "#222B33"
  },
  title: {
    fontSize: "20px",
    fontFamily: "Inter-SemiBold"
  },
  bold: {
    fontFamily: "Inter-SemiBold"
  },
  table: {
    fontSize: "10px"
  },
  tableHeader: {
    flexDirection: "column",
    color: "#607890"
  },
  tableBody: {
    flexDirection: "column"
  },
  tableRow: {
    flexDirection: "row",
    gap: "12px",
    paddingHorizontal: "6px",
    paddingVertical: "10px",
    borderBottomWidth: "1px",
    borderBottomColor: "#E5E9ED",
    borderBottomStyle: "solid"
  },
  tableEmptyMessage: {
    padding: "16px",
    width: "100%",
    alignSelf: "center"
  }
});
function Iie({
  headers: t,
  rows: e,
  emptyMessage: r = "There's no data to display."
}) {
  const n = 100 / t.filter((i) => i.width).length;
  return /* @__PURE__ */ X.jsxs(Bu, { style: Ol.table, children: [
    /* @__PURE__ */ X.jsx(Bu, { minPresenceAhead: 1, fixed: !0, style: Ol.tableHeader, children: /* @__PURE__ */ X.jsx(Bu, { style: [Ol.tableRow, Ol.bold], children: t.map((i) => /* @__PURE__ */ X.jsx(Bu, { style: { width: i.width ?? `${n}%` }, children: /* @__PURE__ */ X.jsx(kg, { children: i.title }) }, i.title)) }) }),
    /* @__PURE__ */ X.jsxs(Bu, { wrap: !0, style: Ol.tableBody, children: [
      e?.map((i, a) => /* @__PURE__ */ X.jsx(Bu, { wrap: !1, style: Ol.tableRow, children: t.map((o) => /* @__PURE__ */ X.jsx(
        Bu,
        {
          style: { width: o.width ?? `${n}%` },
          children: /* @__PURE__ */ X.jsx(kg, { children: o.renderText?.(i) ?? i?.[o.key] })
        },
        `row-${a}-${o.title}`
      )) }, a)),
      !e?.length && /* @__PURE__ */ X.jsx(kg, { style: [Ol.tableEmptyMessage, Ol.bold], children: r })
    ] })
  ] });
}
const Bne = "c12gqses", Bie = ({
  children: t,
  className: e,
  ...r
}) => /* @__PURE__ */ X.jsx(gD, {
  className: st(Bne, r_, e),
  ...r,
  children: /* @__PURE__ */ X.jsx(jr, {
    children: t
  })
}), Lne = "b1ws8oh0", Nne = "b8dhmrs", Lie = ({
  className: t,
  isReversed: e,
  children: r,
  ...n
}) => /* @__PURE__ */ X.jsx(vD, {
  className: st(Lne, e && "reversed", t),
  ...n,
  children: /* @__PURE__ */ X.jsx(Y3, {
    className: Nne,
    children: r
  })
});
export {
  Lie as Badge,
  Hne as BrandLogo,
  Cie as ButtonDropdown,
  d_ as CanvasSignature,
  pie as Card,
  mie as CardAction,
  hie as CardBodyAdditionalContent,
  die as CardBodyContent,
  cie as CardBodySectionWrapper,
  fie as CardBodyTitle,
  uie as CardBodyWrapper,
  lie as CardHeader,
  NA as Checkbox,
  sie as DialogConfirmation,
  iie as DialogExitAgreement,
  BR as DialogSignature,
  oie as DialogSubmitAgreement,
  vp as DialogWrapper,
  kie as Drawer,
  mM as Dropdown,
  bM as DropdownContainer,
  hM as DropdownContentItems,
  xM as DropdownModal,
  yM as DropdownModalContent,
  wM as DropdownTrigger,
  QR as FileInformation,
  gie as FormIcon,
  tP as FormSectionViewDivider,
  wie as InputArray,
  xie as InputFieldGroup,
  bie as InputFile,
  QD as LoadingSkeleton,
  Iie as PDFTable,
  nie as PageWrapper,
  Pie as PdfDocument,
  Ol as PdfStyle,
  Bie as PersistentNotification,
  BD as ReapitMark,
  vie as RenderHTML,
  _ie as Select,
  yie as SelectAsync,
  Sie as Table,
  oM as TableCellCustom,
  Eie as TableCellSplit,
  HN as TableHeader,
  FM as TableRow,
  ON as TableToolbar,
  Aie as Tabs,
  iM as Tooltip,
  HD as calculateScaledSize,
  Xne as elBgTransparent,
  VD as elBorderBottomLight,
  tie as elColorWhite,
  ic as elCursorPointer,
  Gne as elHFit,
  zv as elHasNoBorder,
  jD as elJustifySelfCenter,
  f_ as elJustifySelfEnd,
  Zne as elJustifySelfStart,
  Uv as elMb4,
  zD as elMt4,
  Jne as elOverflowAuto,
  Kne as elOverflowHidden,
  Qne as elOverflowXAuto,
  eie as elOverflowYAuto,
  Yne as elP0Important,
  UD as elPy4,
  qne as elPy9,
  WD as elTileHasError,
  rie as elUnorderedList,
  $D as elWFit,
  Ine as initializePdfFonts,
  aie as useDialogSubmitAgreement,
  vM as useDropdown,
  Ab as useDropdownContext,
  HR as useDynamicSvgImport
};
